const Fal0 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal0",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 192C0 103.6 71.6 32 160 32s160 71.6 160 160v128c0 88.4-71.6 160-160 160S0 408.4 0 320V192zM160 64C89.3 64 32 121.3 32 192v128c0 70.7 57.3 128 128 128s128-57.3 128-128V192c0-70.7-57.3-128-128-128z"
        }
    ]
};

const Fal00 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal00",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32C64.5 32 0 96.5 0 176v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM32 176c0-61.9 50.1-112 112-112s112 50.1 112 112v160c0 61.9-50.1 112-112 112S32 397.9 32 336V176zM496 32c-79.5 0-144 64.5-144 144v160c0 79.5 64.5 144 144 144s144-64.5 144-144V176c0-79.5-64.5-144-144-144zM384 176c0-61.9 50.1-112 112-112s112 50.1 112 112v160c0 61.9-50.1 112-112 112s-112-50.1-112-112V176z"
        }
    ]
};

const Fal1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal1",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 48c0-5.9-3.2-11.3-8.5-14.1s-11.5-2.5-16.4.8l-96 64c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4L112 77.9V448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96V48z"
        }
    ]
};

const Fal2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal2",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M148 64c-28.8 0-56.9 11.5-77.2 31.8l-27.5 27.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l27.5-27.6C74.6 46.8 110.9 32 148 32c76.5 0 140 61.9 140 138.8 0 38.4-15.9 75-43.9 101.3L56.5 448H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-6.6 0-12.5-4-14.9-10.1S.2 456.8 5 452.3l217.2-203.6c21.5-20.2 33.8-48.4 33.8-77.9C256 112 207.2 64 148 64z"
        }
    ]
};

const Fal3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal3",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h272c6.6 0 12.5 4 14.9 10.2s.8 13.1-4 17.6L120.9 224H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H89.4c-36.4 0-69.6-20.5-85.9-53.1l-1.9-3.8c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l1.9 3.8C43 434.3 65.2 448 89.4 448H192c53 0 96-43 96-96s-43-96-96-96H80c-6.6 0-12.5-4-14.9-10.2s-.8-13.1 4-17.6L247.1 64H16C7.2 64 0 56.8 0 48z"
        }
    ]
};

const Fal360Degrees = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal360Degrees",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M608 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16h111.3L35.4 214.2c-3.8 4.8-4.4 11.4-1.7 16.9s8.3 9 14.4 9H80c44.2 0 80 35.8 80 80v16c0 44.2-35.8 80-80 80h-5.5c-12.7 0-24.9-5.1-33.9-14.1l-13.3-13.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L18 424.6c15 15 35.4 23.4 56.6 23.4H80c61.9 0 112-50.1 112-112v-16c0-61.6-49.8-111.6-111.3-112l91.9-118.2c3.8-4.8 4.4-11.4 1.7-16.9s-8.3-9-14.4-9H16zm432 80c0-26.5 21.5-48 48-48s48 21.5 48 48v224c0 26.5-21.5 48-48 48s-48-21.5-48-48V144zm128 224V144c0-44.2-35.8-80-80-80s-80 35.8-80 80v224c0 44.2 35.8 80 80 80s80-35.8 80-80zM256 176c0-44.2 35.8-80 80-80 8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112v192c0 44.2 35.8 80 80 80s80-35.8 80-80v-96c0-44.2-35.8-80-80-80-18 0-34.6 6-48 16v-32zm48 48c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48s-48-21.5-48-48v-96c0-26.5 21.5-48 48-48z"
        }
    ]
};

const Fal4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal4",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M174.3 55.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-144 288c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6H288V464c0 8.8 7.2 16 16 16s16-7.2 16-16V352h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v176H41.9L174.3 55.2z"
        }
    ]
};

const Fal5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal5",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48.5 44.1C50.3 37 56.7 32 64 32h208c8.8 0 16 7.2 16 16s-7.2 16-16 16H76.5l-40 160H192c70.7 0 128 57.3 128 128s-57.3 128-128 128H84.5c-33.3 0-63.8-18.8-78.7-48.6l-4.1-8.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l4.1 8.2c9.5 19 28.9 31 50.1 31H192c53 0 96-43 96-96s-43-96-96-96H16c-4.9 0-9.6-2.3-12.6-6.2S-.7 241 .5 236.2l48-192z"
        }
    ]
};

const Fal6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal6",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 320c0-70.7-57.3-128-128-128-69.7 0-126.3 55.7-128 124.9v3.1c0 70.7 57.3 128 128 128s128-57.3 128-128zM126.8 163.5c10.7-2.3 21.8-3.5 33.2-3.5 88.4 0 160 71.6 160 160s-71.6 160-160 160S0 408.4 0 320c0-2 0-3.9.1-5.9 1.4-37.9 15.9-74.2 41.1-102.6L196 37.4c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6l-93.1 104.8z"
        }
    ]
};

const Fal7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal7",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h288c5.8 0 11.1 3.1 14 8.2s2.7 11.3-.3 16.2l-256 416c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22L275.4 64H16C7.2 64 0 56.8 0 48z"
        }
    ]
};

const Fal8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal8",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 152c0-66.3-53.7-120-120-120h-48C69.7 32 16 85.7 16 152c0 41.4 20.9 77.9 52.8 99.4C28.1 270.6 0 312 0 360c0 66.3 53.7 120 120 120h80c66.3 0 120-53.7 120-120 0-48-28.1-89.4-68.8-108.6 31.9-21.5 52.8-58 52.8-99.4zM184.1 272H200c48.6 0 88 39.4 88 88s-39.4 88-88 88h-80c-48.6 0-88-39.4-88-88s39.4-88 88-88h64.1zm0-32h-48.2C87.4 240 48 200.6 48 152s39.4-88 88-88h48c48.6 0 88 39.4 88 88s-39.4 88-87.9 88z"
        }
    ]
};

const Fal9 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "Fal9",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 192c0 70.7 57.3 128 128 128 69.7 0 126.3-55.7 128-124.9V192c0-70.7-57.3-128-128-128S32 121.3 32 192zm161.2 156.5c-10.7 2.3-21.8 3.5-33.2 3.5C71.6 352 0 280.4 0 192S71.6 32 160 32s160 71.6 160 160c0 2 0 3.9-.1 5.9-1.4 37.9-15.9 74.2-41.1 102.6L124 474.6c-5.9 6.6-16 7.2-22.6 1.3s-7.2-16-1.3-22.6l93.2-104.8z"
        }
    ]
};

const FalA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalA",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M206.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8l-176 416c-3.4 8.1.4 17.5 8.5 21s17.5-.4 21-8.5L67.2 384h249.6l36.5 86.2c3.4 8.1 12.8 11.9 21 8.5s11.9-12.8 8.5-21l-176-416zM303.2 352H80.8L192 89.1 303.2 352z"
        }
    ]
};

const FalAbacus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAbacus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v96h-96v-32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V64h64zm-96 64h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H288v-32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V64h128v64zm-160 0h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32h-96v-32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V64h96v64zm-128 0h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H32V96c0-17.7 14.3-32 32-32h64v64zM32 416V224h96v64h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H64c-17.7 0-32-14.3-32-32zm128-32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-64h96v64h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64h-96v-64zm128-64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-64h128v128h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H288v-64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-32zm160 64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V224h96v192c0 17.7-14.3 32-32 32h-64v-64zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalAccentGrave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAccentGrave",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 65.3C64 46.9 78.9 32 97.3 32c16.1 0 30 11.6 32.8 27.5l22.5 126.2c.6 3.3-1.9 6.3-5.3 6.3-1.7 0-3.4-.8-4.4-2.3L70.4 86.9C66.2 81 64 74 64 66.8v-1.5zm-32 0v1.5c0 13.8 4.3 27.3 12.2 38.5l72.6 102.9c7 9.9 18.4 15.8 30.5 15.8 23.3 0 40.9-21 36.8-43.9L161.6 53.8C156.1 22.7 129 0 97.3 0 61.2 0 32 29.2 32 65.3z"
        }
    ]
};

const FalAcorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAcorn",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-3.9 3.9c-15.3 15.3-25.7 34.6-30.3 55.4H96c-53 0-96 43-96 96v16c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-16c0-53-43-96-96-96H243.6c3.8-12.3 10.6-23.6 19.8-32.8l3.9-3.9zM352 96c35.3 0 64 28.7 64 64v16H32v-16c0-35.3 28.7-64 64-64h256zM48.4 240c4.1 78.1 39 189.3 165.5 236.4 6.5 2.4 13.7 2.4 20.2 0C360.6 429.3 395.5 318.1 399.6 240h-32c-4 70.6-35.5 165.2-143.5 206C116 405.2 84.4 310.6 80.5 240h-32z"
        }
    ]
};

const FalAddressBook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAddressBook",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H96zM32 64C32 28.7 60.7 0 96 0h288c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zm240 128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm32 128c-26.5 0-48 21.5-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48h-64zM512 80v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16 112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm16 144v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalAddressCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAddressCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM112 368c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16s16-7.2 16-16zm240-208c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H352zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H352zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H352z"
        }
    ]
};

const FalAirConditioner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAirConditioner",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 64h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 160v144c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-29.6 16.1-55.5 40-69.3 7.6-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6 0 26.5 21.5 48 48 48s48-21.5 48-48V288h32zm64 112V288h32v112c0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.7-9.6-33.3-24-41.6-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8c23.9 13.8 40 39.7 40 69.3 0 44.2-35.8 80-80 80s-80-35.8-80-80z"
        }
    ]
};

const FalAirplay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAirplay",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 64H96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h37.5l-18.7 18.7c-4 4-7.4 8.5-10.2 13.3H96c-53 0-96-43-96-96V128c0-53 43-96 96-96h384c53 0 96 43 96 96v192c0 53-43 96-96 96h-8.6c-2.8-4.8-6.2-9.2-10.2-13.3L442.5 384H480c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM162.2 435.7c-1.4 1.3-2.2 3.2-2.2 5.2 0 3.9 3.2 7.1 7.1 7.1h241.8c3.9 0 7.1-3.2 7.1-7.1 0-2-.8-3.8-2.2-5.2L293.6 322.2c-1.4-1.3-3.5-2.2-5.6-2.2s-4.2.8-5.6 2.2L162.2 435.7zm-22-23.3 120.2-113.5c7.4-7 17.4-10.9 27.6-10.9s20.1 3.9 27.6 10.9l120.1 113.5c7.8 7.4 12.3 17.7 12.3 28.5 0 21.6-17.5 39.1-39.1 39.1H167.1c-21.6 0-39.1-17.5-39.1-39.1 0-10.8 4.4-21.1 12.3-28.5z"
        }
    ]
};

const FalAlarmClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlarmClock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5 4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1 6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zm264.9 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6.8c10.7-9.9 25.1-16 40.9-16C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288c0-123.7-100.3-224-224-224S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm16 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 5 2.4 9.8 6.4 12.8l64 48c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4L272 296V176z"
        }
    ]
};

const FalAlarmExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlarmExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5 4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1 6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zm264.9 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6.8c10.7-9.9 25.1-16 40.9-16C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288c0-123.7-100.3-224-224-224S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 64c-8.8 0-16 7.2-16 16v144c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalAlarmPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlarmPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5 4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1 6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zm264.9 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6.8c10.7-9.9 25.1-16 40.9-16C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288c0-123.7-100.3-224-224-224S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 80c-8.8 0-16 7.2-16 16v80h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-80c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalAlarmSnooze = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlarmSnooze",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M92.2 0C41.3 0 0 41.3 0 92.2c0 18.2 5.3 35.2 14.4 49.5 4.7 7.5 14.6 9.6 22.1 4.9s9.6-14.6 4.9-22.1c-5.9-9.3-9.4-20.4-9.4-32.3C32 58.9 58.9 32 92.2 32c15.8 0 30.2 6.1 40.9 16.1 6.5 6 16.6 5.6 22.6-.8s5.6-16.6-.8-22.6C138.4 9.3 116.4 0 92.2 0zm264.9 24.6c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6.8c10.7-9.9 25.1-16 40.9-16C453 32 480 58.9 480 92.2c0 11.9-3.4 23-9.4 32.3-4.7 7.5-2.6 17.3 4.9 22.1s17.3 2.6 22.1-4.9c9.1-14.3 14.4-31.3 14.4-49.5C512 41.3 470.7 0 419.8 0c-24.2 0-46.3 9.3-62.7 24.6zM59.3 507.3l50-50C148.6 491.4 199.9 512 256 512s107.4-20.6 146.7-54.7l50 50c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-50-50C459.4 395.4 480 344.1 480 288c0-123.7-100.3-224-224-224S32 164.3 32 288c0 56.1 20.6 107.4 54.7 146.7l-50 50c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zM256 96a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm-64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h94.7L179.5 358c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-94.7l107.2-134c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H192z"
        }
    ]
};

const FalAlbumCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlbumCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h211.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7s-10.7.2-16 .7V96c0-17.7-14.3-32-32-32zM224 96c69.3 0 128.3 44 150.5 105.6-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1.7 10.9 2.4 21.5 5 31.7-12 2.9-24.5 4.4-37.4 4.4-88.4 0-160-71.6-160-160S135.6 96 224 96zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm320 136a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalAlbumCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlbumCircleUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h211.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v96.7c-5.3-.5-10.6-.7-16-.7s-10.7.2-16 .7V96c0-17.7-14.3-32-32-32zM224 96c69.3 0 128.3 44 150.5 105.6-10.2 3.5-20 8-29.3 13.2C328.1 164.3 280.3 128 224 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c11.2 0 22-1.4 32.4-4.1.7 10.9 2.4 21.5 5 31.7-12 2.9-24.5 4.4-37.4 4.4-88.4 0-160-71.6-160-160S135.6 96 224 96zm0 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm268 230.6c-7.8-9.1-19.4-14.6-31.8-14.6h-56.4c-12.4 0-23.9 5.5-31.8 14.6 17.3 11 37.9 17.4 60 17.4s42.7-6.4 60-17.4zm24.3-20.8c17.2-19.7 27.7-45.6 27.7-73.8 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 28.2 10.5 54.1 27.7 73.8 13.8-16.1 34.2-25.8 56.1-25.8h56.4c21.8 0 42.2 9.6 56.1 25.8zM288 368a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"
        }
    ]
};

const FalAlbumCollectionCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlbumCollectionCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM16 80c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272c2.7 28.8 26.9 50.9 55.8 50.9h310.3c-12.9-9.1-24.5-19.9-34.6-32H84.5c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272c-1.3-14.1 9.8-26.2 23.9-26.2h392.4c14.1 0 25.2 12.1 23.9 26.2l-.6 7c6.7-.8 13.6-1.2 20.5-1.2 3.9 0 7.8.1 11.7.4l.3-3.3c3-32.8-22.8-61.1-55.8-61.1H59.8zM256 192c-88.4 0-160 57.3-160 128s71.6 128 160 128c27.6 0 53.6-5.6 76.2-15.4-3.9-9.9-6.9-20.2-9-30.8-18.8 8.8-41.5 14.2-67.2 14.2-77.7 0-128-49.3-128-96s50.3-96 128-96c43.3 0 78 15.3 100.3 36.9 6.5-8.5 13.8-16.4 21.8-23.6C348.8 209.6 305 192 256 192zm0 152c13.3 0 24-9 24-20s-10.7-20-24-20-24 9-24 20 10.7 20 24 20zm128 24a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-128-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FalAlbumCollectionCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlbumCollectionCircleUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM16 80c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272c2.7 28.8 26.9 50.9 55.8 50.9h310.3c-12.9-9.1-24.5-19.9-34.6-32H84.5c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272c-1.3-14.1 9.8-26.2 23.9-26.2h392.4c14.1 0 25.2 12.1 23.9 26.2l-.6 7c6.7-.8 13.6-1.2 20.5-1.2 3.9 0 7.8.1 11.7.4l.3-3.3c3-32.8-22.8-61.1-55.8-61.1H59.8zM256 192c-88.4 0-160 57.3-160 128s71.6 128 160 128c27.6 0 53.6-5.6 76.2-15.4-3.9-9.9-6.9-20.2-9-30.8-18.8 8.8-41.5 14.2-67.2 14.2-77.7 0-128-49.3-128-96s50.3-96 128-96c43.3 0 78 15.3 100.3 36.9 6.5-8.5 13.8-16.4 21.8-23.6C348.8 209.6 305 192 256 192zm0 152c13.3 0 24-9 24-20s-10.7-20-24-20-24 9-24 20 10.7 20 24 20zm300 118.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6h56.4c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8h-56.4c-21.8 0-42.2 9.6-56.1 25.8-17.2-19.7-27.7-45.6-27.7-73.8 0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
        }
    ]
};

const FalAlbumCollection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlbumCollection",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM16 80c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm43.8 48C26.9 128 1.1 156.3 4 189.1l24.7 272c2.7 28.8 26.9 50.9 55.8 50.9h343c29 0 53.1-22.1 55.8-50.9l24.7-272c3-32.8-22.8-61.1-55.8-61.1H59.8zm-23.9 58.2c-1.3-14.1 9.8-26.2 23.9-26.2h392.4c14.1 0 25.2 12.1 23.9 26.2l-24.7 272c-1.1 12.4-11.5 21.8-23.9 21.8h-343c-12.4 0-22.8-9.5-23.9-21.8l-24.7-272zM256 416c-77.7 0-128-49.3-128-96s50.3-96 128-96 128 49.3 128 96-50.3 96-128 96zm0 32c88.4 0 160-57.3 160-128s-71.6-128-160-128S96 249.3 96 320s71.6 128 160 128zm0-104c13.3 0 24-9 24-20s-10.7-20-24-20-24 9-24 20 10.7 20 24 20z"
        }
    ]
};

const FalAlbum = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlbum",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm0-136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalAlicorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlicorn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M335.5 148.1c-.5 1.9-1.3 3.6-2.5 5.2-1.4 1.9-3.1 3.4-5 4.5s-4.1 1.8-6.4 2.1c-3.2.3-6.6-.3-9.6-2L169.9 76.6c7 52.2 32.2 91.2 57.8 118.4 15.1 16 30.1 27.8 41.4 35.5 5.6 3.9 10.3 6.7 13.5 8.6 1.6.9 2.8 1.6 3.6 2l.9.5.2.1c7.9 4 11.1 13.6 7.1 21.5s-13.6 11.1-21.5 7.2L280 256l-7.2 14.3-.1-.1-.4-.2c-.3-.2-.7-.4-1.3-.7-1.1-.6-2.6-1.4-4.5-2.5-3.8-2.2-9.2-5.5-15.5-9.9-12.7-8.7-29.6-22-46.6-40-34-36-68.4-91.7-68.4-168.9 0-5.7 3-11 8-13.8s11-2.9 16-.1l146.4 83.7C318.7 50.8 377.4 0 448 0h96c8.8 0 16 7.2 16 16 0 7-4.5 13-10.8 15.1 7.3 9.5 12.5 20.6 15 32.9h66.5c5.1 0 9.3 4.2 9.3 9.3 0 4-2.6 7.6-6.4 8.8l-65.2 21.7 4.7 49.4c2.3 23.9-9.2 47.1-29.6 59.9-29.1 18.2-67.4 10-86.5-18.6l-1.7-2.5H448v40c0 .7-.1 1.5-.1 2.2.1 1.9.1 3.9.1 5.8 0 30.9-12.4 58.4-32 78.4V472c0 22.1-17.9 40-40 40h-32c-22.1 0-40-17.9-40-40V347.6l-88.1-19.8c-.5 14.3-3.6 28.3-9.2 41.4l-8.1 19c-2.2 5-2.5 10.6-1.1 15.9l15.9 57.2c7.1 25.5-12.1 50.7-38.5 50.7h-33.3c-18 0-33.7-12-38.5-29.3l-13.5-48.6c-8.3-29.8-6.2-61.5 6-90l8.1-19c.2-.4.3-.8.3-1.3 0-.4-.1-.8-.2-1.2l-33.4-80.1c-4.2-10.1-6.4-20.8-6.4-31.7-18.6 6.6-32 24.4-32 45.3v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-41.3 31.3-75.2 71.4-79.5 9-19.8 25.6-35.4 46-43.1 3.4 10.4 7.4 20.4 11.8 29.8-19.4 7-33.2 25.6-33.2 47.5 0 6.7 1.3 13.3 3.9 19.5l33.4 80.1c1.8 4.3 2.7 8.9 2.7 13.5 0 4.8-1 9.5-2.8 13.9l-8.1 19c-9.3 21.7-10.9 46-4.6 68.8l13.5 48.6c1 3.5 4.1 5.9 7.7 5.9h33.2c5.3 0 9.1-5 7.7-10.1l-15.9-57.2c-3.4-12.3-2.5-25.3 2.5-37l8.1-19c4.4-10.4 6.7-21.5 6.7-32.8 0-4.6-.4-9.2-1.1-13.7-.9-5.3.9-10.6 4.8-14.3s9.3-5.2 14.5-4L318.4 318c1.4.3 2.8.6 4.3.8 7.7 1.3 13.3 8 13.3 15.8V472c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V311.6c0-4.6 1.9-8.9 5.3-11.9C405.6 285.1 416 264 416 240c0-2.3-.1-4.5-.3-6.7-.1-1.5 0-3.1.3-4.5V176c0-8.8 7.2-16 16-16h32c5.4 0 10.3 2.7 13.3 7.1l6.4 9.6c9.4 14.2 28.5 18.3 42.9 9.2 10.1-6.3 15.8-17.8 14.7-29.7l-7.7-80.8c-2.3-24.6-23-43.4-47.8-43.4H448c-61.8 0-111.9 50-112 111.7 0 1.5-.1 2.9-.5 4.4zM464 96a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalAlien8bit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlien8bit",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32H96v-16c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32v144c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32v-64h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v16h-64v-32h32c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32h-32c-17.7 0-32 14.3-32 32v32h-64V96c0-17.7-14.3-32-32-32h-32c0-17.7-14.3-32-32-32h-32zm352 160v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h32v144h-48c-8.8 0-16 7.2-16 16v48H96v-48c0-8.8-7.2-16-16-16H32V144h32v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h80c8.8 0 16-7.2 16-16V96h32v48c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V96h32v80c0 8.8 7.2 16 16 16h80zM128 96V64h32v32h-32zm320 0h-32V64h32v32zM160 448v-64h32v16c0 8.8 7.2 16 16 16h32v32h-80zm224-48v-16h32v64h-80v-32h32c8.8 0 16-7.2 16-16zM224 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64z"
        }
    ]
};

const FalAlien = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlien",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32C118 32 32 118 32 224c0 56.2 31.2 110.7 72.2 157.4 40.4 46.1 86.7 80.4 108.6 95.4 2.8 1.9 6.6 3.2 11.2 3.2s8.4-1.3 11.2-3.2c21.9-15 68.1-49.3 108.6-95.4 41-46.7 72.2-101.2 72.2-157.4 0-106-86-192-192-192zM0 224C0 100.3 100.3 0 224 0s224 100.3 224 224c0 135.3-148.8 247.7-194.7 279.2-8.6 5.9-18.9 8.8-29.3 8.8s-20.7-2.9-29.3-8.8C148.8 471.7 0 359.3 0 224zm350 16h-14c-29.8 0-54.9 20.4-62 48h14c29.8 0 54.9-20.4 62-48zm-14-32h32c8.8 0 16 7.2 16 16 0 53-43 96-96 96h-32c-8.8 0-16-7.2-16-16 0-53 43-96 96-96zm-224 32H98c7.1 27.6 32.2 48 62 48h14c-7.1-27.6-32.2-48-62-48zm96 64c0 8.8-7.2 16-16 16h-32c-53 0-96-43-96-96 0-8.8 7.2-16 16-16h32c53 0 96 43 96 96z"
        }
    ]
};

const FalAlignCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlignCenter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm80 144c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalAlignJustify = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlignJustify",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 192c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalAlignLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlignLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 320c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalAlignRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlignRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h256zm0 128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h416zm16 144c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h256c8.8 0 16 7.2 16 16zm-16 112c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h416z"
        }
    ]
};

const FalAlignSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlignSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM528 336c8.8 0 16-7.2 16-16s-7.2-16-16-16h-43.9l40.5 32h3.4zm0-128c8.8 0 16-7.2 16-16s-7.2-16-16-16H322l40.5 32H528zm-372.1 0-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h43.9zM528 48H159.8l40.5 32H528c8.8 0 16-7.2 16-16s-7.2-16-16-16zM318 336l-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h206zm121.6 96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h368.2l-40.5-32z"
        }
    ]
};

const FalAlt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAlt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M462 107.7c6.1-7.4 15.2-11.7 24.8-11.7H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H486.7c-19.2 0-37.4 8.6-49.5 23.5L178 404.3c-6.1 7.4-15.2 11.7-24.8 11.7H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h137.3c19.2 0 37.4-8.6 49.5-23.5L462 107.7zM432 416c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"
        }
    ]
};

const FalAmpGuitar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAmpGuitar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M139.6 51.9C168.3 27.2 210.1 0 256 0s87.7 27.2 116.4 51.9c4.8 4.1 9.3 8.2 13.4 12.1H448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h62.2c4.2-4 8.7-8.1 13.4-12.1zm36 12.1h160.8C312.1 46 284 32 256 32s-56.1 14-80.4 32zM480 288H32v160c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V288zm0-32V128c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v128h448zM80 336a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm0 96a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm48-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-32a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48-32a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 152a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalAmpersand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAmpersand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.2 64h33.9c34.7 0 62.9 28.2 62.9 62.9 0 20.5-10 39.8-26.8 51.5L181.6 223l-51.1-51.1C118.7 160 112 144 112 127.2c0-34.9 28.3-63.2 63.2-63.2zm29.4 181.9 59-41.3c25.4-17.8 40.5-46.8 40.5-77.8-.1-52.3-42.6-94.8-95-94.8h-33.9C122.6 32 80 74.6 80 127.2c0 25.2 10 49.5 27.9 67.3l47.1 47.1L72.9 299C47.3 317 32 346.3 32 377.7v6.3c0 53 43 96 96 96h80c35.3 0 68.4-16.6 89.6-44.8l21.8-29.1 69.2 69.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72.5-72.5 74-98.6c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2l-71.2 95-111.3-111.5zM178 264.5l118.6 118.7L272 416c-15.1 20.1-38.8 32-64 32h-80c-35.3 0-64-28.7-64-64v-6.3c0-20.9 10.2-40.5 27.3-52.4l86.6-60.7z"
        }
    ]
};

const FalAnchorCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnchorCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 80a48 48 0 1 1-96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80 0 38.7 27.5 71 64.1 78.4-.1.5-.1 1-.1 1.6v32h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v256h-32c-79.5 0-144-64.5-144-144v-25.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h96c17.2 0 33.8-2.5 49.5-7-9.8-7.9-18.8-16.9-26.7-26.7-7.4 1.2-15 1.8-22.8 1.8h-32V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm208 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FalAnchorCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnchorCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 80a48 48 0 1 1-96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80 0 38.7 27.5 71 64.1 78.4-.1.5-.1 1-.1 1.6v32h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v256h-32c-79.5 0-144-64.5-144-144v-25.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h96c17.2 0 33.8-2.5 49.5-7-9.8-7.9-18.8-16.9-26.7-26.7-7.4 1.2-15 1.8-22.8 1.8h-32V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalAnchorCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnchorCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 80a48 48 0 1 1-96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80 0 38.7 27.5 71 64.1 78.4-.1.5-.1 1-.1 1.6v32h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v256h-32c-79.5 0-144-64.5-144-144v-25.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h96c17.2 0 33.8-2.5 49.5-7-9.8-7.9-18.8-16.9-26.7-26.7-7.4 1.2-15 1.8-22.8 1.8h-32V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm96 368a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"
        }
    ]
};

const FalAnchorLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnchorLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 80a48 48 0 1 1-96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80 0 38.7 27.5 71 64.1 78.4-.1.5-.1 1-.1 1.6v32h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v256h-32c-79.5 0-144-64.5-144-144v-25.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h96c18.3 0 36-2.8 52.6-8-3-7.4-4.6-15.5-4.6-24v-8.2c-15 5.3-31.2 8.2-48 8.2h-32V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80zm240 224c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80h160v128H448V352z"
        }
    ]
};

const FalAnchor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnchor",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 80a48 48 0 1 1-96 0 48 48 0 1 1 96 0zM288 0c-44.2 0-80 35.8-80 80 0 38.7 27.5 71 64.1 78.4-.1.5-.1 1-.1 1.6v32h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v256h-32c-79.5 0-144-64.5-144-144v-25.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L64 310.6V336c0 97.2 78.8 176 176 176h96c97.2 0 176-78.8 176-176v-25.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7V336c0 79.5-64.5 144-144 144h-32V224h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-32c0-.5 0-1.1-.1-1.6C340.5 151 368 118.7 368 80c0-44.2-35.8-80-80-80z"
        }
    ]
};

const FalAngel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAngel",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64.2c0 .1-.1.3-.2.6-.3.6-.9 1.8-2.3 3.5s-3.4 3.6-6.2 5.6c6.7 8.3 12.2 17.6 16.3 27.7C407 91 416 78 416 64c0-35.3-57.3-64-128-64S160 28.7 160 64c0 14 9 27 24.3 37.5 4.1-10 9.6-19.3 16.3-27.7-2.7-2-4.8-4-6.2-5.6-1.4-1.7-2-2.8-2.3-3.5-.1-.3-.2-.5-.2-.6v-.4c0-.1.1-.3.2-.6.3-.6.9-1.8 2.3-3.5 2.9-3.5 8.4-7.9 17.3-12.4C229.6 38.4 256.5 32 288 32s58.4 6.4 76.2 15.4c8.9 4.5 14.4 8.9 17.3 12.4 1.4 1.7 2 2.8 2.3 3.5.1.3.2.5.2.6v.4zM288 96a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM45.3 480C38 480 32 474 32 466.7c0-2.1.5-4.1 1.4-5.9l39.8-79.7c4.4-8.9 6.8-18.7 6.8-28.6v-.9c0-9.9-2.3-19.7-6.8-28.6l-18.3-36.8c-4.5-9-6.9-19.1-6.9-29.3 0-35.8 29-64.9 64.2-64.9 17 0 33.3 6.8 45.4 18.8l67 67c-12 9.3-22.1 21.4-29.1 35.5L112 480H45.3zm208.5-218.2-73.6-73.6c-18-18-42.5-28.2-68-28.2-53.1 0-96.2 43.8-96.2 96.9 0 15.1 3.5 30.1 10.2 43.6l18.4 36.7c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 5-1.2 9.9-3.4 14.3L4.8 446.4C1.6 452.7 0 459.7 0 466.7c0 25 20.3 45.3 45.3 45.3h485.4c25 0 45.3-20.3 45.3-45.3 0-7-1.6-14-4.8-20.3l-39.8-79.7c-2.2-4.4-3.4-9.3-3.4-14.3v-.9c0-5 1.2-9.9 3.4-14.3l18.4-36.7C556.5 287 560 272 560 256.9c0-53.1-43.1-96.9-96.2-96.9-25.5 0-50 10.1-68 28.2l-73.6 73.6c-10.8-3.8-22.4-5.8-34.2-5.8s-23.4 2-34.2 5.8zm97.7 15.9 67-67c12-12 28.4-18.8 45.4-18.8 35.1 0 64.2 29.1 64.2 64.9 0 10.2-2.4 20.3-6.9 29.3l-18.4 36.7c-4.4 8.9-6.8 18.7-6.8 28.6v.9c0 9.9 2.3 19.7 6.8 28.6l39.8 79.7c.9 1.8 1.4 3.9 1.4 5.9 0 7.3-6 13.3-13.3 13.3H464l-83.4-166.6c-7.1-14.1-17.1-26.2-29.1-35.5zm.5 49.8L428.2 480H147.8L224 327.6c12.1-24.2 36.9-39.6 64-39.6s51.9 15.3 64 39.6z"
        }
    ]
};

const FalAngle90 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAngle90",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v416c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V48zm160.8 75c-29.9-13.2-62.2-21.9-96-25.3-9.1-.9-16.8 6.4-16.8 15.6 0 8.5 6.7 15.5 15.1 16.4 29.3 3.2 57.3 10.7 83.3 22 7.6 3.3 16.6.8 21-6.3 4.9-8 2-18.5-6.6-22.3zm104.7 124.4c5.1 7.1 14.8 9.3 22.2 4.7 7.6-4.7 10-14.8 4.7-22.1-20.6-28.8-45.8-54-74.6-74.6-7.3-5.2-17.4-2.9-22.1 4.7-4.6 7.4-2.3 17.1 4.7 22.2 24.9 18 46.9 40 64.9 64.9zm30.8 54.1c11.3 26 18.8 54 22 83.3.9 8.5 7.9 15.1 16.4 15.1 9.2 0 16.5-7.7 15.6-16.8-3.4-33.9-12.2-66.1-25.3-96-3.8-8.6-14.3-11.6-22.3-6.6-7.1 4.4-9.6 13.4-6.3 21z"
        }
    ]
};

const FalAngleDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAngleDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M212.7 331.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4 75.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l160 160z"
        }
    ]
};

const FalAngleLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAngleLeft",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M52.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 256l148.7 148.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-160-160z"
        }
    ]
};

const FalAngleRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAngleRight",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256 84.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l160 160z"
        }
    ]
};

const FalAngleUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAngleUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M212.7 148.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160z"
        }
    ]
};

const FalAngle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAngle",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M238.3 55.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-208 416c-2.5 5-2.2 10.8.7 15.6s8.1 7.6 13.6 7.6H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H41.9L238.3 55.2zM295 238.9c-16.3-20.5-35-39.1-55.6-55.2-7.7-6.1-19-3.2-23.4 5.6-3.5 7.1-1.4 15.6 4.8 20.5 17.8 14.1 34 30.2 48.2 47.9 5.3 6.6 14.7 8.4 21.9 3.9 7.8-4.9 9.9-15.4 4.1-22.7zm14.5 84.9c9.9 22.2 17.3 45.7 21.7 70.3 1.4 8 8.2 14 16.3 14 9.6 0 17.2-8.4 15.5-17.9-4.9-28.4-13.4-55.5-25-81-3.9-8.6-14.5-11.4-22.5-6.4-7 4.4-9.4 13.5-6 21z"
        }
    ]
};

const FalAnglesDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnglesDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 459.3c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 425.4l148.7-148.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-160 160zm160-352-160 160c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 233.4 372.7 84.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalAnglesLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnglesLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256l148.7-148.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160zm352-160-160 160c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l148.7-148.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FalAnglesRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnglesRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M459.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 276.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm-352 160 160-160c6.2-6.2 6.2-16.4 0-22.6l-160-160c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 84.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"
        }
    ]
};

const FalAnglesUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnglesUpDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M234 19.5c-5.8-4.7-14.1-4.7-20 0l-160 128c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l150-120 150 120c6.9 5.5 17 4.4 22.5-2.5s4.4-17-2.5-22.5l-160-128zm160 345c6.9-5.5 8-15.6 2.5-22.5s-15.6-8-22.5-2.5l-150 120-150-120c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5l160 128c5.8 4.7 14.1 4.7 20 0l160-128z"
        }
    ]
};

const FalAnglesUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnglesUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 52.7c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 86.6l148.7 148.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-160-160zm160 352-160-160c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 278.6l148.7 148.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"
        }
    ]
};

const FalAnkh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAnkh",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128c0 48.2 25.8 88.6 55 118.7 14.4 14.8 28.8 26.4 39.7 34.2l1.3.9 1.3-.9c10.9-7.8 25.3-19.3 39.7-34.2 29.2-30.1 55-70.5 55-118.7 0-53-43-96-96-96s-96 43-96 96zm52.1 160C79.1 255.9 32 200.8 32 128 32 57.3 89.3 0 160 0s128 57.3 128 128c0 72.8-47.1 127.9-84.1 160H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h100.1z"
        }
    ]
};

const FalApartment = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalApartment",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128H64c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h160v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v64h160c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-64c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v32c0 17.7-14.3 32-32 32zm192 288c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64v-64zm-96 96H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64V64c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v96h64c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224zm288-88c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48zm-32-8v-32h-32v32h32zm-344-32H88c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-8-64H96v32h32v-32zm384-24c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48zm-32-8v-32h-32v32h32zm-344-32H88c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-8-64H96v32h32v-32zm208 72c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48zm-32-8v-32h-32v32h32zm8-96h-48c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-8-64h-32v32h32V96z"
        }
    ]
};

const FalAperture = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAperture",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480c-6.1 0-12.1-.2-18.1-.7L316 344l13.8-23.9.1-.1 18.5-32 67 116.1 3.3 5.8C377.9 453.1 320.1 480 256 480zm73.9-288h140.8c6 20.3 9.3 41.8 9.3 64 0 47.3-14.6 91.1-39.7 127.3L362.2 248l-13.7-23.7c0-.1-.1-.2-.1-.3l-18.5-32zm-55.2-32h-37.2l67-116.1 3.4-5.8C374.6 53.9 429.7 99.5 458.4 160H274.7zM256 32c6.1 0 12.1.2 18.1.7L196 168l-13.9 24-18.5 32-67-116.1-3.3-5.8C134.1 58.9 191.9 32 256 32zM32 256c0-47.3 14.6-91.1 39.7-127.3L149.8 264l32.3 56H41.3c-6-20.3-9.3-41.8-9.3-64zm172.1 217.9C137.4 458.1 82.3 412.5 53.6 352h220.9l-67 116.1-3.4 5.8zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm46.1-207.9c-5.7 9.8-16.3 15.9-27.7 15.9h-36.9c-11.4 0-22-6.1-27.7-16l-18.5-32c-5.7-9.9-5.7-22.1 0-32l18.5-32c5.7-9.9 16.2-15.9 27.5-16h37.3c11.3.1 21.7 6.1 27.4 15.8l18.7 32.4c5.6 9.8 5.6 21.9 0 31.7 0 0 0 .1-.1.1l-18.5 32s0 .1-.1.1z"
        }
    ]
};

const FalApostrophe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalApostrophe",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M78.7 320.1c-8.8.7-15.3 8.5-14.6 17.3s8.5 15.3 17.3 14.6l8-.7c58-4.8 102.7-53.4 102.7-111.6V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h64c11.7 0 22.6-3.1 32-8.6v24.2c0 41.6-31.9 76.3-73.4 79.7l-8 .7zM160 160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64z"
        }
    ]
};

const FalAppleCore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAppleCore",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M196.6 96c32.8 0 59.4-26.6 59.4-59.4V32h-4.6C218.6 32 192 58.6 192 91.4V96h4.6zm-18.3 32c-10.1 0-18.3-8.2-18.3-18.3V91.4C160 40.9 200.9 0 251.4 0h18.3C279.8 0 288 8.2 288 18.3v18.3c0 50.5-40.9 91.4-91.4 91.4h-18.3zM128 480c13.2 0 32-2.7 45.3-5 12.3-2.2 25-2.2 37.3 0 13.3 2.3 32.1 5 45.3 5 19.7 0 41.8-8.8 62.6-27.3C280 415 256 362.3 256 304c0-55.6 21.8-106.1 57.3-143.4-3-.4-6.1-.6-9.3-.6-21 0-48.7 8.4-71.1 17.1-26.2 10.2-55.6 10.2-81.9 0-22.3-8.7-50-17.1-71-17.1-3.2 0-6.3.2-9.3.6C106.2 197.9 128 248.4 128 304c0 58.3-24 111-62.6 148.7C86.2 471.2 108.3 480 128 480zm-98.1-17.6c-6.2-6.8-4.4-17.3 2.7-23.1C71.3 407 96 358.4 96 304c0-55.4-25.6-104.7-65.5-137-8-6.5-9.3-18.7-.7-24.3C43.9 133.4 60.7 128 80 128c27.3 0 59.7 10.3 82.7 19.3 18.8 7.3 39.9 7.3 58.7 0 22.9-8.9 55.4-19.3 82.7-19.3 19.3 0 36.1 5.4 50.3 14.7 8.6 5.6 7.3 17.9-.7 24.3-40 32.3-65.5 81.7-65.5 137 0 54.4 24.7 103 63.4 135.3 7 5.9 8.8 16.3 2.7 23.1-28.5 31.3-63.4 49.6-98.3 49.6-16.2 0-37.4-3.2-50.8-5.5-8.7-1.5-17.6-1.5-26.3 0-13.5 2.4-34.6 5.5-50.8 5.5-34.9 0-69.8-18.3-98.1-49.6z"
        }
    ]
};

const FalAppleWhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAppleWhole",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M228.6 96H224v-4.6c0-32.8 26.6-59.4 59.4-59.4h4.6v4.6c0 32.8-26.6 59.4-59.4 59.4zm-18.3 32h18.3c50.5 0 91.4-40.9 91.4-91.4V18.3C320 8.2 311.8 0 301.7 0h-18.3C232.9 0 192 40.9 192 91.4v18.3c0 10.1 8.2 18.3 18.3 18.3zM32 288c0-33.8 8-67.7 22.8-92 14.2-23.5 33-36 57.2-36 21 0 48.7 8.4 71.1 17.1 26.2 10.2 55.6 10.2 81.9 0 22.3-8.7 50-17.1 71-17.1 24.3 0 43 12.5 57.2 36 14.8 24.3 22.8 58.2 22.8 92 0 57.5-18 106.6-43.6 140.8-26 34.7-57.4 51.2-84.4 51.2-13.2 0-32-2.7-45.3-5-12.3-2.2-25-2.2-37.3 0-13.3 2.3-32.1 5-45.3 5-27 0-58.4-16.5-84.4-51.2C50 394.6 32 345.5 32 288zm128 224c16.2 0 37.4-3.2 50.8-5.5 8.7-1.5 17.6-1.5 26.3 0 13.5 2.4 34.6 5.5 50.8 5.5 80 0 160-96 160-224 0-76.3-35.7-160-112-160-27.3 0-59.7 10.3-82.7 19.3-18.8 7.3-39.9 7.3-58.7 0-22.8-9-55.2-19.3-82.5-19.3C35.7 128 0 211.7 0 288c0 128 80 224 160 224z"
        }
    ]
};

const FalArchway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArchway",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V352c0-53-43-96-96-96s-96 43-96 96v112c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V64H16C7.2 64 0 56.8 0 48zm64 16v64h384V64H64zm0 96v288h64v-96c0-70.7 57.3-128 128-128s128 57.3 128 128v96h64V160H64z"
        }
    ]
};

const FalArrowDown19 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDown19",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 48v144h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V70.2l-26.9 9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13zM171.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v377.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zM428 288a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4h.1c0 21.2-7.6 41.8-21.5 57.9l-62.4 72.5c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.9-1.7-22.6l25.5-29.5H428c-46.4 0-84-37.6-84-84z"
        }
    ]
};

const FalArrowDown91 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDown91",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M428 64a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4h.1c0 21.2-7.6 41.8-21.5 57.9l-62.4 72.5c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.9-1.7-22.6l25.5-29.5H428c-46.4 0-84-37.6-84-84zm-76.7 263.3-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v377.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM448 304v144h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V326.2l-26.9 9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13z"
        }
    ]
};

const FalArrowDownAZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownAZ",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m267.3 379.3-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v377.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm163-338.5 63.9 127.7.3.6 15.8 31.7c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2L470.1 192H361.9l-11.6 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l15.8-31.7.3-.6 64-127.8c2.7-5.4 8.2-8.8 14.3-8.8s11.6 3.4 14.3 8.8zm-14.3 43L377.9 160h76.2L416 83.8zM352 288h128c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L385.3 448H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9l107.2-134H352c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalArrowDownArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v377.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm352-342.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 86.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96z"
        }
    ]
};

const FalArrowDownBigSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownBigSmall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m171.3 475.3 96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v377.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM352 432v-64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zm-32 0c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v64zm32-352c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80zm-32 0v128c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalArrowDownFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M116 362.6c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3L240 453.9V176c0-8.8 7.2-16 16-16s16 7.2 16 16v277.9l100-112.5c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6l-128 144c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4l-128-144zM256 32C132.3 32 32 132.3 32 256c0 8.8-7.2 16-16 16s-16-7.2-16-16C0 114.6 114.6 0 256 0s256 114.6 256 256c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-123.7-100.3-224-224-224z"
        }
    ]
};

const FalArrowDownFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 425.4V176c0-8.8 7.2-16 16-16s16 7.2 16 16v249.4l100.7-100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128zM32 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm384 0a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm72-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalArrowDownFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 425.4V144c0-8.8 7.2-16 16-16s16 7.2 16 16v281.4l100.7-100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128zM16 64C7.2 64 0 56.8 0 48s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H16z"
        }
    ]
};

const FalArrowDownLeftAndArrowUpRightToCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownLeftAndArrowUpRightToCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 169.4V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v144c0 8.8 7.2 16 16 16h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H342.6L507.3 27.3zM4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 342.6V448c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h105.4L4.7 484.7z"
        }
    ]
};

const FalArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 416c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16v185.4l260.7-260.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 384H272c8.8 0 16 7.2 16 16s-7.2 16-16 16H48z"
        }
    ]
};

const FalArrowDownLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownLong",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M180.7 507.3c6.2 6.2 16.4 6.2 22.6 0l144-144c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 457.4V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v441.4L59.3 340.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l144 144z"
        }
    ]
};

const FalArrowDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 416c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v185.4L59.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h224z"
        }
    ]
};

const FalArrowDownShortWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownShortWide",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m235.3 379.3-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v377.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 48h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalArrowDownSmallBig = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownSmallBig",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m171.3 475.3 96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v377.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM352 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V80zm-32 0v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48zm32 352V304c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16zm-32 0c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v128z"
        }
    ]
};

const FalArrowDownSquareTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownSquareTriangle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m267.3 379.3-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v377.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96zm64 147.5L341.3 448h149.4L416 323.5zM320 176V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48zm-12.4 266 84.2-140.3c5.1-8.5 14.3-13.7 24.2-13.7s19.1 5.2 24.2 13.7L524.4 442c2.3 3.9 3.6 8.4 3.6 12.9 0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1 0-4.5 1.2-9 3.6-12.9z"
        }
    ]
};

const FalArrowDownToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480c123.7 0 224-100.3 224-224 0-8.8 7.2-16 16-16s16 7.2 16 16c0 141.4-114.6 256-256 256S0 397.4 0 256c0-8.8 7.2-16 16-16s16 7.2 16 16c0 123.7 100.3 224 224 224zm140-277.4-128 144c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4l-128-144c-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3L240 293.9V16c0-8.8 7.2-16 16-16s16 7.2 16 16v277.9l100-112.5c5.9-6.6 16-7.2 22.6-1.3s7.2 16 1.3 22.6z"
        }
    ]
};

const FalArrowDownToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownToBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m363.3 219.3-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 297.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16v281.4l100.7-100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM32 336v96c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80v-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalArrowDownToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m363.3 219.3-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L208 297.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16v249.4l100.7-100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-312 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalArrowDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H16zm187.3-100.7c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 329.4V48c0-8.8 7.2-16 16-16s16 7.2 16 16v281.4l100.7-100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128z"
        }
    ]
};

const FalArrowDownToSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownToSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m267.8 330.9 96-104c6-6.5 5.6-16.6-.9-22.6s-16.6-5.6-22.6.9L272 279.1V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v263.1l-68.2-73.9c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6l96 104c3 3.3 7.3 5.1 11.8 5.1s8.7-1.9 11.8-5.1zM64 32C28.7 32 0 60.7 0 96v352c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c17.7 0 32 14.3 32 32v352c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"
        }
    ]
};

const FalArrowDownTriangleSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownTriangleSquare",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m267.3 379.3-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v377.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 432c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96zm64-364.5L341.3 192h149.4L416 67.5zM307.6 186l84.2-140.3C396.9 37.2 406.1 32 416 32s19.1 5.2 24.2 13.7L524.4 186c2.3 3.9 3.6 8.4 3.6 12.9 0 13.8-11.2 25.1-25.1 25.1H329.1c-13.8 0-25.1-11.2-25.1-25.1 0-4.5 1.2-9 3.6-12.9zM320 432v-96c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FalArrowDownUpAcrossLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownUpAcrossLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M148.7 507.3c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4V272h384c8.8 0 16-7.2 16-16s-7.2-16-16-16H432V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L400 54.6V240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h128v185.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96zM144 192h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v144zm288 128h-32v144c0 8.8 7.2 16 16 16s16-7.2 16-16V320z"
        }
    ]
};

const FalArrowDownUpLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownUpLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m139.3 507.3 96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L144 457.4V272h272c0-11.1 1.6-21.9 4.6-32H336V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 54.6V240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v185.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM144 200V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v152h32zm192 112h-32v152c0 8.8 7.2 16 16 16s16-7.2 16-16V312zm192-88c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80h160v128H448V352z"
        }
    ]
};

const FalArrowDownWideShort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownWideShort",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m235.3 379.3-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v377.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 464c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H304zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H304z"
        }
    ]
};

const FalArrowDownZA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDownZA",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m267.3 379.3-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v377.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM352 32h128c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L385.3 192H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9L446.7 64H352c-8.8 0-16-7.2-16-16s7.2-16 16-16zm64 256c6.1 0 11.6 3.4 14.3 8.8l63.9 127.7.3.6 15.8 31.7c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2L470.1 448H361.9l-11.6 23.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l15.8-31.7.3-.6 63.9-127.7c2.7-5.4 8.2-8.8 14.3-8.8zm-38.1 128h76.2L416 339.8 377.9 416z"
        }
    ]
};

const FalArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M180.7 475.3c6.2 6.2 16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v377.4L27.3 276.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176z"
        }
    ]
};

const FalArrowLeftFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowLeftFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256c0-123.7-100.3-224-224-224-8.8 0-16-7.2-16-16s7.2-16 16-16c141.4 0 256 114.6 256 256S397.4 512 256 512c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224zM149.4 116c6.6-5.9 16.7-5.3 22.6 1.3s5.3 16.7-1.3 22.6L58.1 240H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H58.1l112.5 100c6.6 5.9 7.2 16 1.3 22.6s-16 7.2-22.6 1.3L5.4 268C2 264.9 0 260.6 0 256s2-8.9 5.4-12l144-128z"
        }
    ]
};

const FalArrowLeftFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowLeftFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H54.6l100.7-100.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128zM416 432c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v352z"
        }
    ]
};

const FalArrowLeftLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowLeftLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16S0 71.2 0 80zm132.7 164.7c-6.2 6.2-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L182.6 272H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H182.6l116.7-116.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144z"
        }
    ]
};

const FalArrowLeftLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowLeftLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H54.6l116.7-116.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144z"
        }
    ]
};

const FalArrowLeftToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowLeftToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.6 0 0 114.6 0 256s114.6 256 256 256c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zm277.4-140-144 128c-3.4 3-5.4 7.4-5.4 12s2 8.9 5.4 12l144 128c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6L218.1 272H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H218.1l112.5-100c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3z"
        }
    ]
};

const FalArrowLeftToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowLeftToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 432c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16S0 71.2 0 80v352zm100.7-187.3c-6.2 6.2-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L150.6 272H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H150.6l100.7-100.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128z"
        }
    ]
};

const FalArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H54.6L203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z"
        }
    ]
};

const FalArrowPointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowPointer",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 426V55.2C0 42.4 10.4 32 23.2 32c5.7 0 11.2 2.1 15.4 5.9l274 243.6c4.7 4.2 7.4 10.2 7.4 16.5 0 12.2-9.9 22.1-22.1 22.1H161.5l61.1 137.5c3.6 8.1 0 17.5-8.1 21.1s-17.5 0-21.1-8.1l-61-137.2-93.8 107.1c-4.2 4.8-10.2 7.5-16.6 7.5-12.2 0-22-9.9-22-22zM32 72v328l86.4-100.8c6.1-7.1 15-11.2 24.3-11.2H272L32 72z"
        }
    ]
};

const FalArrowProgress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowProgress",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M281.6 3.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L288 48H112C50.1 48 0 98.1 0 160s50.1 112 112 112h288c44.2 0 80 35.8 80 80 0 39.5-28.7 72.3-66.3 78.8-7.5-27-32.3-46.8-61.7-46.8-35.3 0-64 28.7-64 64s28.7 64 64 64c30.1 0 55.4-20.8 62.2-48.9 55.2-7 97.8-54.1 97.8-111.1 0-61.9-50.1-112-112-112H112c-44.2 0-80-35.8-80-80s35.8-80 80-80h176l-25.6 19.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48zM351.9 480a32 32 0 1 1 .1-64 32 32 0 1 1-.1 64zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM126 432c-7.1-27.6-32.2-48-62-48-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h66l-25.6 19.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l64-48c4-3 6.4-7.8 6.4-12.8s-2.4-9.8-6.4-12.8l-64-48c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4L192 432h-66zm-94 16a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FalArrowRightArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightArrowLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M443.3 139.3c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l68.7 68.7H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h377.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96zm-342.6 352c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 400H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H54.6l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96z"
        }
    ]
};

const FalArrowRightFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C114.6 0 0 114.6 0 256s114.6 256 256 256c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zm330.6-140c-6.6-5.9-16.7-5.3-22.6 1.3s-5.3 16.7 1.3 22.6L453.9 240H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h277.9L341.4 372c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128z"
        }
    ]
};

const FalArrowRightFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightFromBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h281.4L356.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80C35.8 32 0 67.8 0 112v288c0 44.2 35.8 80 80 80h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h96z"
        }
    ]
};

const FalArrowRightFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h281.4L292.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V80z"
        }
    ]
};

const FalArrowRightLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 80v352c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM507.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L457.4 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h441.4L340.7 123.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l144 144z"
        }
    ]
};

const FalArrowRightLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-144-144c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h441.4L340.7 388.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l144-144z"
        }
    ]
};

const FalArrowRightToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256c0-123.7-100.3-224-224-224-8.8 0-16-7.2-16-16s7.2-16 16-16c141.4 0 256 114.6 256 256S397.4 512 256 512c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224zM202.6 116l144 128c3.4 3 5.4 7.4 5.4 12s-2 8.9-5.4 12l-144 128c-6.6 5.9-16.7 5.3-22.6-1.3s-5.3-16.7 1.3-22.6L293.9 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h277.9L181.4 140c-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3z"
        }
    ]
};

const FalArrowRightToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightToBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h281.4L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM336 448c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c44.2 0 80-35.8 80-80V112c0-44.2-35.8-80-80-80h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-96z"
        }
    ]
};

const FalArrowRightToCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightToCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v160c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-26.5-21.5-48-48-48h-16v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-32V48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v448c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm32 48v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32V96h32zm96 160c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v32h-32v-32zm-32 128v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32v-32h32zM384 192c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v32h-32v-32zm-32 128v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32v-32h32zM155.3 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l68.7 68.7H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h185.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"
        }
    ]
};

const FalArrowRightToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRightToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v352c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h281.4L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h377.4L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z"
        }
    ]
};

const FalArrowRotateLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRotateLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 192c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v92.6C103.2 75.5 174.5 32 256 32c123.7 0 224 100.3 224 224S379.7 480 256 480c-79.9 0-150-41.8-189.7-104.8C59.8 364.8 67.7 352 80 352c6 0 11.4 3.2 14.7 8.2C128.9 413 188.4 448 256 448c106 0 192-86 192-192S362 64 256 64c-71.1 0-133.1 38.6-166.3 96H176c8.8 0 16 7.2 16 16s-7.2 16-16 16H48z"
        }
    ]
};

const FalArrowRotateRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowRotateRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 192c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v92.6C408.8 75.5 337.5 32 256 32 132.3 32 32 132.3 32 256s100.3 224 224 224c79.9 0 150-41.8 189.7-104.8 6.6-10.4-1.4-23.2-13.7-23.2-6 0-11.4 3.2-14.7 8.2C383.1 413 323.6 448 256 448c-106 0-192-86-192-192S150 64 256 64c71.1 0 133.1 38.6 166.3 96H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h128z"
        }
    ]
};

const FalArrowTrendDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowTrendDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 400c0 8.8 7.2 16 16 16h176c8.8 0 16-7.2 16-16V224c0-8.8-7.2-16-16-16s-16 7.2-16 16v137.4L331.3 148.7c-6.2-6.2-16.4-6.2-22.6 0L192 265.4 27.3 100.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0L320 182.6 521.4 384H384c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalArrowTrendUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowTrendUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 112c0-8.8 7.2-16 16-16h176c8.8 0 16 7.2 16 16v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V150.6L331.3 363.3c-6.2 6.2-16.4 6.2-22.6 0L192 246.6 27.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l176-176c6.2-6.2 16.4-6.2 22.6 0L320 329.4 521.4 128H384c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalArrowTurnDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowTurnDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 48c0-8.8 7.2-16 16-16s16 7.2 16 16v176c0 44.2-35.8 80-80 80H54.6l100.7 100.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 272H432c26.5 0 48-21.5 48-48V48z"
        }
    ]
};

const FalArrowTurnDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowTurnDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v176c0 44.2 35.8 80 80 80h377.4L356.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 272H80c-26.5 0-48-21.5-48-48V48z"
        }
    ]
};

const FalArrowTurnDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowTurnDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 24.8 0 16S7.2 0 16 0h112c44.2 0 80 35.8 80 80v377.4l100.7-100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 457.4V80c0-26.5-21.5-48-48-48H16z"
        }
    ]
};

const FalArrowTurnUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowTurnUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16h112c44.2 0 80-35.8 80-80V54.6l100.7 100.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6V432c0 26.5-21.5 48-48 48H16z"
        }
    ]
};

const FalArrowUp19 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUp19",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 48c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V48zM171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM428 392a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84h1.3l-25.4 29.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l62.4-72.5c13.8-16.2 21.4-36.8 21.4-58h-.1c.1-1.3.1-2.7.1-4 0-46.4-37.6-84-84-84s-84 37.6-84 84z"
        }
    ]
};

const FalArrowUp91 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUp91",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M428 168a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84h1.3l-25.4 29.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l62.4-72.5c13.8-16.2 21.4-36.8 21.4-58h-.1c.1-1.3.1-2.7.1-4 0-46.4-37.6-84-84-84s-84 37.6-84 84zM171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM448 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V448h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V304z"
        }
    ]
};

const FalArrowUpAZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpAZ",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h94.7L339.5 454c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-94.7l107.2-134c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1H352zm64-256c-6.1 0-11.6 3.4-14.3 8.8l-63.9 127.8-.3.6-15.8 31.7c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l11.5-23.2h108.2l11.6 23.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-15.8-31.7-.3-.6-64-127.8c-2.7-5.4-8.2-8.8-14.3-8.8zm-38.1 128L416 83.8l38.1 76.2h-76.2z"
        }
    ]
};

const FalArrowUpArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zm352 342.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v377.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96z"
        }
    ]
};

const FalArrowUpBigSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpBigSmall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M148.7 36.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 86.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM352 432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v64zm-32 0v-64c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48zm32-352v128c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V80z"
        }
    ]
};

const FalArrowUpFromArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpFromArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480C132.3 480 32 379.7 32 256c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 141.4 114.6 256 256 256s256-114.6 256-256c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7-100.3 224-224 224zM116 149.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3L240 58.1V336c0 8.8 7.2 16 16 16s16-7.2 16-16V58.1l100 112.5c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L268 5.4C264.9 2 260.6 0 256 0s-8.9 2-12 5.4l-128 144z"
        }
    ]
};

const FalArrowUpFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpFromBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l100.7 100.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-96z"
        }
    ]
};

const FalArrowUpFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 86.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l100.7 100.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm384 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-264-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalArrowUpFromGroundWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpFromGroundWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 352c8.8 0 16-7.2 16-16V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 54.6V336c0 8.8 7.2 16 16 16zM64 192c-35.3 0-64 28.7-64 64v169c5.3-3.1 11.2-5.4 17.5-6.9 4.8-1.1 9.7-2.8 14.5-4.8V256c0-17.7 14.3-32 32-32h128v-32H64zm512 233V256c0-35.3-28.7-64-64-64H384v32h128c17.7 0 32 14.3 32 32v157.3c4.8 2.1 9.7 3.7 14.5 4.8 6.3 1.5 12.1 3.8 17.5 6.9zm-384 55c-20.9 0-41.7-9.9-58.2-21.2-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"
        }
    ]
};

const FalArrowUpFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 86.6V368c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l100.7 100.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalArrowUpFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpFromSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-104 104c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6V320c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-104-104zM64 32C28.7 32 0 60.7 0 96v352c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c17.7 0 32 14.3 32 32v352c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"
        }
    ]
};

const FalArrowUpFromWaterPump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpFromWaterPump",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 32c-8.8 0-16 7.2-16 16v208h160V48c0-8.8-7.2-16-16-16H112zm176 16v208h144V54.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 54.6V256h48c35.3 0 64 28.7 64 64v105c-5.3-3.1-11.2-5.4-17.5-6.9-4.8-1.1-9.7-2.8-14.5-4.8V320c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v93.3c-4.8 2.1-9.7 3.7-14.5 4.8-6.3 1.5-12.2 3.8-17.5 6.9V320c0-35.3 28.7-64 64-64V48c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48zm-96 432c20.9 0 41.6-9.9 58.2-21.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z"
        }
    ]
};

const FalArrowUpLeftFromCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpLeftFromCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0H16C7.2 0 0 7.2 0 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l268.7 268.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 32H176c8.8 0 16-7.2 16-16s-7.2-16-16-16zm112 64c-8.8 0-16 7.2-16 16s7.2 16 16 16c106 0 192 86 192 192s-86 192-192 192S96 394 96 288c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7 100.3 224 224 224s224-100.3 224-224S411.7 64 288 64z"
        }
    ]
};

const FalArrowUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 96c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V150.6l260.7 260.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 128H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H48z"
        }
    ]
};

const FalArrowUpLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpLong",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-144 144c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l116.7 116.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-144-144z"
        }
    ]
};

const FalArrowUpRightAndArrowDownLeftFromCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpRightAndArrowDownLeftFromCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M292.7 196.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6V160c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h105.4L292.7 196.7zm-73.4 118.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L32 457.4V352c0-8.8-7.2-16-16-16s-16 7.2-16 16v144c0 8.8 7.2 16 16 16h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H54.6l164.7-164.7z"
        }
    ]
};

const FalArrowUpRightDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpRightDots",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h121.4L4.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H144zm384 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-128 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm128-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM256 336a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 112a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-144-48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm336-144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16-176a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FalArrowUpRightFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpRightFromSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h121.4L212.7 276.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H336zM64 32C28.7 32 0 60.7 0 96v352c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v144c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"
        }
    ]
};

const FalArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 96c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V150.6L59.3 411.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 128H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224z"
        }
    ]
};

const FalArrowUpShortWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpShortWide",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M139.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM304 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"
        }
    ]
};

const FalArrowUpSmallBig = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpSmallBig",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M148.7 36.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L176 86.6V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zM352 80v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-64c-26.5 0-48-21.5-48-48V80zm32 352c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v128zm-32 0V304c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FalArrowUpSquareTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpSquareTriangle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 176V80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm64 147.5L490.7 448H341.3L416 323.5zM320 176c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v96zm-12.4 266c-2.3 3.9-3.6 8.4-3.6 12.9 0 13.8 11.2 25.1 25.1 25.1h173.8c13.8 0 25.1-11.2 25.1-25.1 0-4.5-1.2-9-3.6-12.9l-84.2-140.3c-5.1-8.5-14.3-13.7-24.2-13.7s-19.1 5.2-24.2 13.7L307.6 442z"
        }
    ]
};

const FalArrowUpToArc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpToArc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c123.7 0 224 100.3 224 224 0 8.8 7.2 16 16 16s16-7.2 16-16C512 114.6 397.4 0 256 0S0 114.6 0 256c0 8.8 7.2 16 16 16s16-7.2 16-16C32 132.3 132.3 32 256 32zm140 277.4-128-144c-3-3.4-7.4-5.4-12-5.4s-8.9 2-12 5.4l-128 144c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3L240 218.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V218.1l100 112.5c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6z"
        }
    ]
};

const FalArrowUpToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m363.3 292.7-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 214.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V214.6l100.7 100.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM32 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm384 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM152 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalArrowUpToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 182.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V182.6l100.7 100.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128z"
        }
    ]
};

const FalArrowUpTriangleSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpTriangleSquare",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 432v-96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm64-364.5L490.7 192H341.3L416 67.5zM307.6 186c-2.3 3.9-3.6 8.4-3.6 12.9 0 13.8 11.2 25.1 25.1 25.1h173.8c13.8 0 25.1-11.2 25.1-25.1 0-4.5-1.2-9-3.6-12.9L440.2 45.7C435.1 37.2 425.9 32 416 32s-19.1 5.2-24.2 13.7L307.6 186zM320 432c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v96z"
        }
    ]
};

const FalArrowUpWideShort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpWideShort",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M139.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM304 464h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16z"
        }
    ]
};

const FalArrowUpZA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUpZA",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM352 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h94.7L339.5 198c-3.8 4.8-4.6 11.4-1.9 16.9s8.3 9.1 14.4 9.1h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-94.7L492.5 58c3.8-4.8 4.6-11.4 1.9-16.9S486.1 32 480 32H352zm64 256c-6.1 0-11.6 3.4-14.3 8.8l-63.9 127.8-.3.6-15.8 31.7c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l11.5-23.2h108.2l11.6 23.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-15.8-31.7-.3-.6-64-127.8c-2.7-5.4-8.2-8.8-14.3-8.8zm-38.1 128 38.1-76.2 38.1 76.2h-76.2z"
        }
    ]
};

const FalArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l148.7 148.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-176-176z"
        }
    ]
};

const FalArrowsCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsCross",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h105.4L4.7 452.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 86.6V192c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16H288zM27.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l168.4 168.4 22.6-22.6L27.3 36.7zm225 270.2L393.4 448H288c-8.8 0-16 7.2-16 16s7.2 16 16 16h144c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16s-16 7.2-16 16v105.4L274.9 284.3l-22.6 22.6z"
        }
    ]
};

const FalArrowsDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsDownToLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16zm11.3-164.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L464 345.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v297.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112zm-320-22.6c-6.2-6.2-16.4-6.2-22.6 0L144 345.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v297.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalArrowsDownToPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsDownToPeople",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8 7.2-16 16-16s16 7.2 16 16v129.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7V16zm292.7 92.7c6.2-6.2 16.4-6.2 22.6 0l36.7 36.7V16c0-8.8 7.2-16 16-16s16 7.2 16 16v129.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zM336 192a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm24 208h48V289.5c-3.8-1-7.7-1.5-11.8-1.5h-24.4c-4 0-8 .5-11.8 1.5V400zm122.4-15.6L376 315.5V400c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-84.5l-42.4 68.9c-.2.3-.3.5-.5.8 1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 411.5V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-68.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 366.4 104 352 131.8 352h24.5c14.6 0 28.7 4 40.8 11.2l42.5-69.1c14.6-23.7 40.4-38.1 68.2-38.1h24.5c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2h24.5c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 411.5V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-68.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9-.2-.3-.4-.5-.5-.8zM144 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-24 145.5V480h48v-94.5c-3.8-1-7.7-1.5-11.8-1.5h-24.4c-4 0-8 .5-11.8 1.5zM512 288a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm24 192h48v-94.5c-3.8-1-7.7-1.5-11.8-1.5h-24.4c-4 0-8 .5-11.8 1.5V480z"
        }
    ]
};

const FalArrowsFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 4.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM8 256a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm384 0a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-120 24a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm96 280c4.2 0 8.3-1.7 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 457.4V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v121.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c3 3 7.1 4.7 11.3 4.7z"
        }
    ]
};

const FalArrowsFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 4.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L208 54.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM0 256c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm224 256c4.2 0 8.3-1.7 11.3-4.7l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 457.4V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v121.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c3 3 7.1 4.7 11.3 4.7z"
        }
    ]
};

const FalArrowsLeftRightToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsLeftRightToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm203.3 84.7c6.2 6.2 6.2 16.4 0 22.6L150.6 240h338.7l-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l68.8-68.7H150.7l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM640 80v352c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalArrowsLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M503.3 271.3c6.1-6.1 6.3-15.9.4-22.2l-96-104c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6l71.3 77.2H50.6l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L50.6 276h402.7l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"
        }
    ]
};

const FalArrowsMaximize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsMaximize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L256 233.4 86.6 64H176c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6L233.4 256 64 425.4V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H86.6L256 278.6 425.4 448H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4L278.6 256 448 86.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16H336z"
        }
    ]
};

const FalArrowsMinimize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsMinimize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M36.7 36.7c6.2-6.2 16.4-6.2 22.6 0L192 169.4V64c0-8.8 7.2-16 16-16s16 7.2 16 16v144c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h105.4L36.7 59.3c-6.2-6.2-6.2-16.4 0-22.6zm416 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 192H448c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16s16 7.2 16 16v105.4L452.7 36.7zM48 304c0-8.8 7.2-16 16-16h144c8.8 0 16 7.2 16 16v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.6L59.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L169.4 320H64c-8.8 0-16-7.2-16-16zm240 0c0-8.8 7.2-16 16-16h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H342.6l132.7 132.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 342.6V448c0 8.8-7.2 16-16 16s-16-7.2-16-16V304z"
        }
    ]
};

const FalArrowsRepeat1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsRepeat1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 255.2c-.4 8.8 6.4 16.3 15.2 16.8s16.3-6.4 16.8-15.2l.4-8C36.2 172.2 99.5 112 176.2 112h214.4l-57.4 52.2c-6.5 5.9-7 16.1-1.1 22.6s16.1 7 22.6 1.1l88-80c3.3-3 5.2-7.3 5.2-11.8s-1.9-8.8-5.2-11.8l-88-80c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6l57.4 52H176.2C82.4 80 5.1 153.5.4 247.2l-.4 8zm512 1.6c.4-8.8-6.4-16.3-15.2-16.8s-16.3 6.4-16.8 15.2l-.4 8C475.8 339.8 412.5 400 335.8 400H121.4l57.4-52.2c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80c-3.3 3-5.2 7.3-5.2 11.8s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6l-57.4-52h214.4c93.8 0 171.1-73.5 175.8-167.2l.4-8zM288 208c0-6.1-3.4-11.6-8.8-14.3s-11.9-2.1-16.8 1.5l-32 24c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l6.4-4.8v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalArrowsRepeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsRepeat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M15.2 272c-8.8-.5-15.6-8-15.2-16.8l.4-8C5.1 153.5 82.4 80 176.2 80h214.4l-57.4-52.2c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1l88 80c3.3 3 5.2 7.3 5.2 11.8s-1.9 8.8-5.2 11.8l-88 80c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6l57.4-52H176.2c-76.7 0-140 60.2-143.8 136.8l-.4 8c-.4 8.8-8 15.6-16.8 15.2zm481.6-32c8.8.4 15.6 8 15.2 16.8l-.4 8c-4.7 93.7-82 167.2-175.8 167.2H121.4l57.4 52.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1s5.5 16.7-1.1 22.6l-57.4 52h214.4c76.7 0 140-60.2 143.8-136.8l.4-8c.4-8.8 8-15.6 16.8-15.2z"
        }
    ]
};

const FalArrowsRetweet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsRetweet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M116.7 68.7c6.2-6.2 16.4-6.2 22.6 0l88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L144 118.6V336c0 26.5 21.5 48 48 48h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-44.2 0-80-35.8-80-80V118.6l-60.7 60.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l88-88zM528 393.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-6.2 6.2-16.4 6.2-22.6 0l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l60.7 60.7V176c0-26.5-21.5-48-48-48H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h144c44.2 0 80 35.8 80 80v217.4z"
        }
    ]
};

const FalArrowsRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsRotate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M69.4 210.6C89.8 126.5 165.6 64 256 64c71.1 0 133.1 38.6 166.3 96H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v60.6C408.8 75.5 337.5 32 256 32 149.6 32 60.5 106.2 37.7 205.6 35.5 215.2 43.1 224 53 224c7.9 0 14.6-5.7 16.5-13.4zm373.2 90.9C422.2 385.5 346.4 448 256 448c-71.1 0-133.1-38.6-166.3-96h54.5c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-60.2C103.4 436.6 174.7 480 256 480c106.4 0 195.5-74.2 218.3-173.6 2.2-9.6-5.4-18.4-15.3-18.4-7.9 0-14.6 5.7-16.5 13.4z"
        }
    ]
};

const FalArrowsSpin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsSpin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M257.1 79.5c-11.3 0-22.4 1.1-33.1 3.1V50.2c10.8-1.7 21.9-2.6 33.1-2.6 53.8 0 102.8 20.4 139.7 53.9l27.1-27.1c15.1-15.1 41-4.4 41 17v86.1c0 8.8-7.2 16-16 16h-86.1c-21.4 0-32.1-25.9-17-41l28.3-28.3C343 96.5 302 79.6 257.1 79.6zm-132.9 60.7c-26.8 30.9-43.1 71.2-43.1 115.3 0 11.1 1 21.9 3 32.5H51.7c-1.7-10.6-2.5-21.4-2.5-32.5 0-53 19.8-101.3 52.4-138L74.3 90.3c-15.1-15.1-4.4-41 17-41h86.1c8.8 0 16 7.2 16 16v86.1c0 21.4-25.9 32.1-41 17l-28.2-28.2zm308.9 115.3c0-10.8-1-21.3-2.8-31.5h32.4c1.6 10.3 2.4 20.8 2.4 31.5 0 53.8-20.4 102.8-53.9 139.7l28.7 28.7c15.1 15.1 4.4 41-17 41h-86c-8.8 0-16-7.2-16-16v-86.1c0-21.4 25.8-32.1 41-17l26.7 26.7c27.7-31.1 44.6-72.1 44.6-117zM288 428.8v32.4c-10.1 1.5-20.4 2.3-30.9 2.3-53 0-101.3-19.8-138-52.4l-28.8 28.8c-15.1 15.1-41 4.4-41-17v-86.1c0-8.8 7.2-16 16-16h86.1c21.4 0 32.1 25.9 17 41l-26.6 26.6c30.9 26.8 71.2 43.1 115.3 43.1 10.5 0 20.8-.9 30.9-2.7zm115.6 4.1-50.7-50.7v50.7h50.7zM161.4 132.1V81.4h-50.7l50.7 50.7zm-80 271.5 50.7-50.7H81.4v50.7zm300.8-242.2h50.7v-50.8l-50.7 50.7z"
        }
    ]
};

const FalArrowsSplitUpAndLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsSplitUpAndLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 123.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 54.6V400c0 44.2 35.8 80 80 80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-61.9 0-112-50.1-112-112v-16c0-44.2-35.8-80-80-80H54.6l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 272H224c31.3 0 59.7 12.9 80 33.6v-251l-68.7 68.7z"
        }
    ]
};

const FalArrowsToCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsToCircle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M27.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L137.4 160H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.4L27.3 4.7zM320 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM464 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-57.4L635.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 137.4V80c0-8.8-7.2-16-16-16zM176 448c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L160 374.6V432c0 8.8 7.2 16 16 16zm288 0c8.8 0 16-7.2 16-16v-57.4l132.7 132.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L502.6 352H560c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16z"
        }
    ]
};

const FalArrowsToDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsToDot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v121.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 137.4V16zm16 240a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm59.3 171.3c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7V496c0 8.8 7.2 16 16 16s16-7.2 16-16V374.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0zM84.7 164.7c-6.2 6.2-6.2 16.4 0 22.6l52.7 52.7H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h121.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0zm342.6 0c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L374.6 272H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H374.6l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalArrowsToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 192c-4.2 0-8.3-1.7-11.3-4.7l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7V16c0-8.8 7.2-16 16-16s16 7.2 16 16v121.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-3 3-7.1 4.7-11.3 4.7zM56 256a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm384 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-120 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-72-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-120 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm107.3 44.7 80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 374.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V374.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7z"
        }
    ]
};

const FalArrowsToEye = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsToEye",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M43.3 20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l84.7 84.7H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.4L43.3 20.7zm553.4 0L512 105.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-57.4l84.7-84.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM320 368c-77.3 0-132.6-65-156.7-112 24.1-47 79.4-112 156.7-112s132.6 65 156.7 112c-24.1 47-79.4 112-156.7 112zm0-256c-97.3 0-161.4 81.6-186.5 131.9-3.8 7.6-3.8 16.5 0 24.2C158.6 318.4 222.7 400 320 400s161.4-81.6 186.5-131.9c3.8-7.6 3.8-16.5 0-24.2C481.4 193.6 417.3 112 320 112zm276.7 379.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L534.6 384H592c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-57.4l84.7 84.7zm-576-22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l84.7-84.7V464c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4l-84.7 84.7zM272 256a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FalArrowsToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 192c-4.2 0-8.3-1.7-11.3-4.7l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7V16c0-8.8 7.2-16 16-16s16 7.2 16 16v121.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-3 3-7.1 4.7-11.3 4.7zM0 256c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm235.3 68.7 80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 374.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V374.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7z"
        }
    ]
};

const FalArrowsTurnRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsTurnRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M292 5.5c5.8-6.7 15.9-7.3 22.6-1.5l128 112c3.5 3 5.5 7.4 5.5 12s-2 9-5.5 12l-128 112c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l96-84H112c-44.2 0-80 35.8-80 80v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V224c0-61.9 50.1-112 112-112h277.4l-96-84c-6.6-5.8-7.3-15.9-1.5-22.6zm-96 256c5.8-6.6 15.9-7.3 22.6-1.5l128 112c3.5 3 5.5 7.4 5.5 12s-2 9-5.5 12l-128 112c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l96-84H80c-26.5 0-48 21.5-48 48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V448c0-44.2 35.8-80 80-80h213.4l-96-84c-6.7-5.8-7.3-15.9-1.5-22.6z"
        }
    ]
};

const FalArrowsTurnToDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsTurnToDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M260.7 36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L230.6 112H432c44.2 0 80 35.8 80 80v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c0-26.5-21.5-48-48-48H230.6l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6l80-80zm-9.4 256 80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7H80c-26.5 0-48 21.5-48 48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c0-44.2 35.8-80 80-80h201.4l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM448 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM32 128a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm96 0a64 64 0 1 1-128 0 64 64 0 1 1 128 0z"
        }
    ]
};

const FalArrowsUpDownLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsUpDownLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6V240H54.6l44.7-44.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-72 72c-6.2 6.2-6.2 16.4 0 22.6l72 72c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272H240v185.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l72 72c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 457.4V272h185.4l-44.7 44.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6l-72-72c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l44.7 44.7H272V54.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-72-72z"
        }
    ]
};

const FalArrowsUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsUpDown",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 4.7c-6.1-6.1-15.9-6.3-22.2-.4l-104 96c-6.5 6-6.9 16.1-.9 22.6s16.1 6.9 22.6.9L144 52.5v404.9l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4V54.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z"
        }
    ]
};

const FalArrowsUpToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalArrowsUpToLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 32 0 39.2 0 48s7.2 16 16 16zM4.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l84.7-84.7V464c0 8.8 7.2 16 16 16s16-7.2 16-16V166.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112zm320 22.6c6.2 6.2 16.4 6.2 22.6 0l84.7-84.7V464c0 8.8 7.2 16 16 16s16-7.2 16-16V166.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6z"
        }
    ]
};

const FalAsterisk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAsterisk",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c8.8 0 16 7.2 16 16v178.9l151.4-96.4c7.5-4.7 17.3-2.5 22.1 4.9s2.5 17.3-4.9 22.1L221.8 256l154.8 98.5c7.5 4.7 9.7 14.6 4.9 22.1s-14.6 9.7-22.1 4.9L208 285.1V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V285.1L24.6 381.5c-7.5 4.7-17.3 2.5-22.1-4.9S0 359.3 7.4 354.5L162.2 256 7.4 157.5c-7.5-4.7-9.7-14.6-4.9-22.1s14.6-9.7 22.1-4.9L176 226.9V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalAt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256v24c0 48.6-39.4 88-88 88-33.4 0-62.5-18.7-77.4-46.1-20.4 28-53.4 46.1-90.6 46.1-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6V176c0-8.8 7.2-16 16-16s16 7.2 16 16v104c0 30.9 25.1 56 56 56s56-25.1 56-56v-24c0-123.7-100.3-224-224-224zm80 224a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FalAtomSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAtomSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M175.1 438.1c-50.8 16.9-82.3 10.1-96.7-4.4s-21.3-46-4.4-96.7c5.4-16.2 12.9-33.3 22.5-50.9 16.8 23.8 36.7 47.4 59.4 70.1s46.3 42.6 70.1 59.4c-17.6 9.6-34.7 17.2-50.9 22.5zM55.7 55.7C16.5 94.9 27.6 173.9 76.8 256c-49.2 82.1-60.3 161.1-21.1 200.3s118.2 28.1 200.3-21.1c82.1 49.2 161.1 60.3 200.3 21.1s28.1-118.2-21.1-200.3c49.2-82.1 60.3-161.1 21.1-200.3S338.1 27.6 256 76.8C173.9 27.6 94.9 16.5 55.7 55.7zm122.8 277.8c-25.3-25.3-46.6-51.6-63.8-77.5 17.2-25.9 38.6-52.3 63.8-77.5s51.6-46.6 77.5-63.8c25.9 17.2 52.3 38.6 77.5 63.8s46.6 51.6 63.8 77.5c-17.2 25.9-38.6 52.3-63.8 77.5s-51.6 46.6-77.5 63.8c-25.9-17.2-52.3-38.6-77.5-63.8zm-22.7-177.7c-22.7 22.7-42.6 46.3-59.4 70.1-9.6-17.6-17.2-34.7-22.5-50.9-16.9-50.8-10-82.3 4.4-96.7s46-21.3 96.7-4.4c16.2 5.4 33.3 12.9 50.9 22.5-23.8 16.8-47.4 36.7-70.1 59.4zm200.3 0c-22.7-22.7-46.3-42.6-70.1-59.4 17.6-9.6 34.7-17.2 50.9-22.5 50.8-16.9 82.3-10 96.7 4.4s21.3 46 4.4 96.7c-5.4 16.2-12.9 33.3-22.5 50.9-16.8-23.8-36.7-47.4-59.4-70.1zm0 200.3c22.7-22.7 42.6-46.3 59.4-70.1 9.6 17.6 17.2 34.7 22.5 50.9 16.9 50.8 10.1 82.3-4.4 96.7s-46 21.3-96.7 4.4c-16.2-5.4-33.3-12.9-50.9-22.5 23.8-16.8 47.4-36.7 70.1-59.4zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalAtom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAtom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M322 421.3c-.3.7-.6 1.3-.9 1.9C301.4 464.7 278 480 256 480s-45.4-15.3-65.1-56.7c-.3-.6-.6-1.3-.9-1.9 21.1-5 43.3-12.6 66-22.6 22.7 9.9 44.9 17.5 66 22.6zm-104.9-41.5c-13.4 4.8-26.4 8.6-38.7 11.4-4-12.6-7.4-26.3-10.1-40.9 8.4 5.7 17.1 11.2 26 16.6 7.6 4.6 15.2 8.9 22.8 13zm116.4 11.4c-12.3-2.8-25.3-6.5-38.7-11.4 7.6-4.1 15.2-8.4 22.8-13 8.9-5.4 17.6-10.9 26-16.6-2.8 14.6-6.2 28.3-10.1 40.9zm-32.3-51.8c-15.3 9.2-30.4 17.2-45.2 24.2-14.8-7-29.9-15.1-45.2-24.2-17.5-10.5-33.7-21.5-48.5-32.8-1.5-16.2-2.3-33.1-2.3-50.6s.8-34.4 2.3-50.6c14.8-11.3 31.1-22.3 48.5-32.8 15.3-9.2 30.4-17.2 45.2-24.2 14.8 7 29.9 15.1 45.2 24.2 17.5 10.5 33.7 21.5 48.5 32.8 1.5 16.2 2.3 33.1 2.3 50.6s-.8 34.4-2.3 50.6c-14.8 11.3-31.1 22.3-48.5 32.8zm64.3 56.7c6.6-22.1 11.5-46.6 14.6-72.7 16.7-13.5 31.7-27.5 44.7-41.8l.8 1.2c25 37.7 26.8 66.1 16 85.6-10.4 18.7-33.6 31-76.1 27.7zm18.1-118.2c.3-7.2.4-14.5.4-21.9s-.1-14.7-.4-21.9c7.7 7.3 14.8 14.6 21.3 21.9-6.5 7.3-13.6 14.7-21.3 21.9zm86 106.1c20.7-37.1 9.4-82.8-23.6-128 33-45.2 44.3-90.9 23.6-128-20.2-36.3-62.5-49.3-115.2-43.2C332.4 32.7 298.8 0 256 0s-76.4 32.7-98.4 84.8c-52.7-6.1-95 6.8-115.2 43.2C21.7 165.1 33 210.8 66 256c-33 45.2-44.3 90.9-23.6 128 20.2 36.3 62.5 49.3 115.2 43.2 22 52.1 55.7 84.8 98.4 84.8s76.4-32.7 98.4-84.8c52.7 6.1 95-6.8 115.2-43.2zm-28-240.4c10.8 19.5 9.1 47.9-16 85.6l-.8 1.2c-13-14.2-28-28.2-44.7-41.8-3.1-26.1-8-50.6-14.6-72.7 42.6-3.3 65.7 8.9 76.1 27.7zM321.1 88.7c.3.6.6 1.3.9 1.9-21.1 5-43.3 12.6-66 22.6-22.7-9.9-44.9-17.5-66-22.6.3-.7.6-1.3.9-1.9C210.6 47.3 234 32 256 32s45.4 15.3 65.1 56.7zm12.5 32.1c4 12.6 7.4 26.3 10.1 40.9-8.4-5.7-17.1-11.2-26-16.5-7.6-4.6-15.2-8.9-22.8-13 13.4-4.8 26.4-8.6 38.7-11.3zm-155.1 0c12.3 2.8 25.3 6.5 38.7 11.3-7.6 4.1-15.2 8.4-22.8 13-8.9 5.4-17.6 10.9-26 16.5 2.8-14.6 6.2-28.3 10.1-40.9zm-32-4.9c-6.6 22.1-11.5 46.6-14.6 72.7-16.7 13.5-31.7 27.5-44.7 41.8l-.8-1.2c-25-37.7-26.8-66.1-16-85.6 10.4-18.7 33.6-31 76.1-27.7zM86.3 282.8l.8-1.2c13 14.2 28 28.2 44.7 41.8 3.1 26.1 8 50.6 14.6 72.7-42.6 3.3-65.7-8.9-76.1-27.7-10.8-19.5-9.1-47.9 16-85.6zm42.1-48.8c-.3 7.2-.4 14.5-.4 21.9s.1 14.7.4 21.9c-7.7-7.3-14.8-14.6-21.3-21.9 6.5-7.3 13.6-14.7 21.3-21.9zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalAudioDescriptionSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAudioDescriptionSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm434 444.6H96c-17.7 0-32-14.3-32-32V135.4l-32-25.2V416c0 35.3 28.7 64 64 64h404.4l-40.5-32zM544 32H139.6l40.5 32H544c17.7 0 32 14.3 32 32v280.6l32 25.3V96c0-35.3-28.7-64-64-64zm-32 224c0-53-43-96-96-96h-64c-8.8 0-16 7.2-16 16v11.1l32 25.3V192h48c35.3 0 64 28.7 64 64 0 13.4-4.1 25.8-11.1 36l25.2 19.9c11.3-15.7 17.9-35 17.9-55.9zm-382.3 72.8c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l19.5-39.1h92.2l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2 5.1-2.6 8.3-7.5 8.8-12.8L237 272h-43.1l12.2-24.4-25.7-20.3-50.7 101.5z"
        }
    ]
};

const FalAudioDescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAudioDescription",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm192 64c6.1 0 11.6 3.4 14.3 8.8l80 160c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2L238.1 304h-92.2l-19.6 39.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l80-160c2.7-5.4 8.3-8.8 14.3-8.8zm30.1 112L192 211.8 161.9 272h60.2zm81.9-96c0-8.8 7.2-16 16-16h64c53 0 96 43 96 96s-43 96-96 96h-64c-8.8 0-16-7.2-16-16V176zm32 16v128h48c35.3 0 64-28.7 64-64s-28.7-64-64-64h-48z"
        }
    ]
};

const FalAustralSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAustralSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M238.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8L132.2 224H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h102.6l-27 64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h62L33.3 457.8c-3.4 8.1.4 17.5 8.5 21s17.5-.4 21-8.5l50-118.2h222.4l50 118.2c3.4 8.1 12.8 11.9 21 8.5s11.9-12.8 8.5-21L370 352h62c8.8 0 16-7.2 16-16s-7.2-16-16-16h-75.5l-27.1-64H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H315.8L238.7 41.8zM281.1 224H166.9L224 89.1 281.1 224zm-127.7 32h141.2l27.1 64H126.3l27.1-64z"
        }
    ]
};

const FalAvocado = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAvocado",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 144c0 34.8-15.9 66-40.9 86.6-22.3 18.4-42.7 44.7-49.1 77.6-9.4 47.7-31 93.8-57.5 120.3-68.7 68.7-180.2 68.7-248.9 0s-68.7-180.2 0-248.9c26.5-26.5 72.5-48.1 120.3-57.5 32.9-6.4 59.3-26.8 77.6-49.1C302 47.9 333.2 32 368 32c61.9 0 112 50.1 112 112zm-58.7 170.3c4.6-23.5 19.6-43.9 38.1-59.1C491.5 228.9 512 188.8 512 144 512 64.5 447.5 0 368 0c-44.8 0-84.9 20.5-111.3 52.6-15.2 18.5-35.6 33.5-59.1 38.1-51.9 10.2-104.5 34-136.7 66.3-81.2 81.2-81.2 212.9 0 294.2s212.9 81.2 294.2 0c32.3-32.3 56.1-84.9 66.3-136.7zm-245.2-74.2c38.2-38.2 88.1-40.4 112.1-16.4s21.8 73.9-16.4 112.1-88.1 40.4-112.1 16.4-21.8-73.9 16.4-112.1zm134.8-39c-41.4-41.4-112.1-28.8-157.4 16.4s-57.8 116-16.4 157.4 112.1 28.8 157.4-16.4 57.8-116 16.4-157.4z"
        }
    ]
};

const FalAwardSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAwardSimple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3.8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5.8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2.5c-18.3.4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2.5c3.3.1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9l-9.2 16.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2.5c6.4.2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2.5c-9.4.2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1-176 0 88 88 0 1 1 176 0zM88 390c9.7 4.3 20.3 6.6 31.3 6.8l-16.6 72 83-35.6c4-1.7 8.6-1.7 12.6 0l83 35.6-16.6-72c10.9-.2 21.5-2.5 31.3-6.8l23.6 102.4c1.4 5.9-.7 12-5.3 15.9s-11 4.8-16.6 2.4L192 465.4 86.3 510.7c-5.5 2.4-11.9 1.4-16.6-2.4s-6.7-10-5.3-15.9L88 390z"
        }
    ]
};

const FalAward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAward",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M166.5 7.2c15.7-9.5 35.3-9.5 51 0l16.4 10c2.8 1.7 6 2.6 9.3 2.5l19.2-.5c18.3-.4 35.4 9.4 44.2 25.5l9.2 16.8c1.6 2.9 3.9 5.2 6.8 6.8l16.8 9.2c16.1 8.8 25.9 25.8 25.5 44.2l-.5 19.2c-.1 3.3.8 6.5 2.5 9.3l10 16.4c9.5 15.7 9.5 35.3 0 51l-10 16.4c-1.7 2.8-2.6 6-2.5 9.3l.5 19.2c.4 18.3-9.4 35.4-25.5 44.2l-16.8 9.2c-2.9 1.6-5.2 3.9-6.8 6.8l-9.2 16.8c-8.8 16.1-25.8 25.9-44.2 25.5l-19.2-.5c-3.3-.1-6.5.8-9.3 2.5l-16.4 10c-15.7 9.5-35.3 9.5-51 0l-16.4-10c-2.8-1.7-6-2.6-9.3-2.5l-19.2.5c-18.3.4-35.4-9.4-44.2-25.5l-9.2-16.8c-1.6-2.9-3.9-5.2-6.8-6.8l-16.8-9.2c-16.1-8.8-25.9-25.8-25.5-44.2l.5-19.2c.1-3.3-.8-6.5-2.5-9.3l-10-16.4c-9.5-15.7-9.5-35.3 0-51l10-16.4 13.7 8.3-13.7-8.3c1.7-2.8 2.6-6 2.5-9.3l-.5-19.2c-.4-18.3 9.4-35.4 25.5-44.2l16.8-9.2c2.9-1.6 5.2-3.9 6.8-6.8l9.2-16.8c8.8-16.1 25.8-25.9 44.2-25.5l19.2.5c3.3.1 6.5-.8 9.3-2.5l16.4-10zm34.4 27.3c-5.4-3.3-12.3-3.3-17.7 0l-16.4 10c-8 4.9-17.3 7.4-26.7 7.1l-19.2-.5c-6.4-.2-12.3 3.3-15.3 8.9l-9.2 16.9c-4.5 8.2-11.3 15-19.5 19.5L60 105.6c-5.6 3.1-9 9-8.9 15.3l.5 19.2c.2 9.4-2.3 18.6-7.1 26.7l-10 16.4c-3.3 5.4-3.3 12.3 0 17.7l10 16.4c4.9 8 7.4 17.3 7.1 26.7l-.5 19.2c-.2 6.4 3.3 12.3 8.9 15.3l16.8 9.2c8.2 4.5 15 11.3 19.5 19.5l9.2 16.8c3.1 5.6 9 9 15.3 8.9l19.2-.5c9.4-.2 18.6 2.3 26.7 7.1l16.4 10c5.4 3.3 12.3 3.3 17.7 0l16.4-10c8-4.9 17.3-7.4 26.7-7.1l19.2.5c6.4.2 12.3-3.3 15.3-8.9l9.2-16.8c4.5-8.2 11.3-15 19.5-19.5l16.8-9.2c5.6-3.1 9-9 8.9-15.3l-.5-19.2c-.2-9.4 2.3-18.6 7.1-26.7l10-16.4c3.3-5.4 3.3-12.3 0-17.7l-10-16.4c-4.9-8-7.4-17.3-7.1-26.7l.5-19.2c.2-6.4-3.3-12.3-8.9-15.3l-16.8-9.2c-8.2-4.5-15-11.3-19.5-19.5L278.4 60c-3.1-5.6-9-9-15.3-8.9l-19.2.5c-9.4.2-18.6-2.3-26.7-7.1l-16.4-10zM192 136a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm88 56a88 88 0 1 1-176 0 88 88 0 1 1 176 0zM1.3 441.8l41.2-97.9c1.5 1.8 3.6 4.8 6.9 10.8 4 7.4 9.1 14 15 19.6L41.8 428l38.1-5.7c6.2-.9 12.3 1.8 15.7 7.1l21.3 32.6 26-61.8c1.8.9 4.1 2.2 6.9 3.9 7 4.3 14.5 7.4 22.2 9.3l-37.3 88.7c-2.3 5.5-7.4 9.2-13.3 9.7s-11.6-2.2-14.8-7.2l-32.2-49.1-56.1 8.3c-5.7.8-11.4-1.5-15-6s-4.3-10.7-2.1-16zm248 60.4L212 413.5c7.7-2 15.2-5.1 22.2-9.3 2.8-1.7 5.1-3 6.9-3.9l26 61.8 21.3-32.6c3.4-5.2 9.6-8 15.7-7.1l38.1 5.7-22.6-53.7c5.9-5.6 11-12.2 15-19.6 3.3-6 5.4-9 6.9-10.8l41.2 97.9c2.2 5.3 1.4 11.4-2.1 16s-9.3 6.9-15 6l-56.1-8.3-32.2 49.2c-3.2 5-8.9 7.7-14.8 7.2s-11-4.3-13.3-9.7z"
        }
    ]
};

const FalAxeBattle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAxeBattle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M73.6 52.1C47.4 93.7 32 144.4 32 192c0 48.6 16.1 100.9 43.5 142.9 7.2-15 16.3-28.9 26.1-41 22.1-27.2 56.1-54.2 106.4-65v32.9c-38.6 9.9-64.4 31.2-81.6 52.3-13.6 16.8-25 36.8-30.9 57.8-1.5 5.8-6.1 10.4-11.9 11.7s-12-.7-15.8-5.3C25.5 327.7 0 257.4 0 192 0 126.4 25.6 56.5 67.7 5.7 71.8.9 78.4-1.1 84.5.7 90.6 2.5 95 7.7 95.8 14c2.9 20.2 12.8 40.3 24.9 56.4 15.9 21.3 42.5 43.5 87.2 52.9v32.6c-56.2-10.1-91.3-37.7-112.8-66.3C87 78.7 79.4 66 73.6 52.1zM304 261.8v-32.9c50.3 10.8 84.4 37.8 106.5 65 9.9 12.1 18.9 26 26.1 41 20.8-32.1 35.2-70.2 40.8-108.2l-12.1-12.1c-12.5-12.5-12.5-32.8 0-45.3l12.1-12.1c-5.4-36.8-19.2-73.7-39-105.2-5.7 14-13.4 26.7-21.5 37.6-21.5 28.6-56.7 56.2-112.9 66.3v-32.6c44.8-9.4 71.3-31.7 87.3-52.9 12.1-16.1 22-36.2 24.9-56.4.8-6.3 5.3-11.5 11.3-13.3 6.1-1.8 12.7.2 16.8 5.1C481.5 50.7 505.8 110.4 511 169l-.4.4L488 192l22.6 22.6.4.4c-5.2 58.5-29.4 118.6-66.7 163.2-3.9 4.6-10 6.6-15.8 5.3s-10.5-5.9-11.9-11.7c-5.9-21-17.3-41-30.9-57.8-17.2-21.1-43-42.4-81.7-52.3zM272 48v448c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalAxe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalAxe",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M502.6 182.6 352 32l-96 96 150.6 150.6c6 6 9.4 14.1 9.4 22.6V384c106 0 192-86 192-192h-82.7c-8.5 0-16.6-3.4-22.6-9.4zM473.3 108l52 52H608c17.7 0 32 14.3 32 32 0 123.7-100.3 224-224 224-17.7 0-32-14.3-32-32v-82.7L233.4 150.6c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0L404 38.7l29.4-29.3c12.5-12.5 32.8-12.5 45.3 0l24 24c12.5 12.5 12.5 32.8 0 45.3L473.3 108zm-22.7-22.6L480 56l-24-24-29.4 29.4 24 24zM262.7 225.3 32 456l24 24 230.7-230.7 22.6 22.6L78.6 502.6c-12.5 12.5-32.8 12.5-45.3 0l-24-24c-12.5-12.5-12.5-32.8 0-45.3l230.8-230.7 22.6 22.6z"
        }
    ]
};

const FalB = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalB",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h144c70.7 0 128-57.3 128-128 0-52.8-32-98.2-77.7-117.7C270 213.9 288 181 288 144c0-61.9-50.1-112-112-112H48zm144 224c53 0 96 43 96 96s-43 96-96 96H48c-8.8 0-16-7.2-16-16V256h160zm-16-32H32V80c0-8.8 7.2-16 16-16h128c44.2 0 80 35.8 80 80s-35.8 80-80 80z"
        }
    ]
};

const FalBabyCarriage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBabyCarriage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M.7 224c-.2-2.9-.4-5.7-.5-8.6-.2-2.5-.2-4.9-.2-7.4v-16h.1C2.7 117.9 41.3 52.9 99 14.1c13.3-8.9 30.8-4.3 39.9 8.8L256 192h160v-48c0-26.5 21.5-48 48-48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16 7.2-16 16v72h-.2c-.1 2.7-.3 5.3-.5 8-1.8 22.2-7.5 44-16.8 64.5-11.5 25.4-28.2 48.3-49.2 67.5-20.9 19.2-45.6 34.2-72.6 44.5S253 416 224 416s-57.9-5.2-84.8-15.5-51.6-25.3-72.6-44.5c-20.9-19.1-37.7-42-49.1-67.5C8.2 268 2.5 246.2.7 224zm216.4-32L113.7 42.8c-47.4 33.4-79 87.6-81.5 149.2h184.9zM32.8 224c1.8 17.6 6.4 34.9 13.8 51.4 9.6 21.4 23.8 40.8 41.6 57.1s39 29.3 62.3 38.2 48.3 13.4 73.5 13.4 50.2-4.6 73.5-13.4 44.5-21.8 62.3-38.2 32-35.7 41.6-57.1c7.4-16.4 12.1-33.7 13.8-51.4H32.8zM80 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm304 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FalBaby = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBaby",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM46.1 146.8c20.5-23.1 55.9-25.2 79.1-4.7l24.2 21.5c20.5 18.3 47.1 28.4 74.6 28.4s54.1-10.1 74.6-28.4l24.2-21.5c23.1-20.5 58.5-18.5 79.1 4.7s18.5 58.5-4.7 79.1L373 247.3c-16.1 14.3-33.9 26-53 35.1v32.3l49.9 56.1c16.9 19 18.9 47.1 4.7 68.3l-32 48c-17.2 25.7-51.9 32.7-77.7 15.5s-32.7-51.9-15.5-77.7l8-12-18.5-20.9h-29.8l-18.6 20.9 8 12c17.2 25.7 10.2 60.5-15.5 77.7s-60.5 10.2-77.7-15.5l-32-48c-14.1-21.2-12.2-49.2 4.7-68.3l50-56.1v-32.3c-19.1-9-37-20.8-53-35.1l-24.2-21.4c-23.1-20.5-25.2-55.9-4.7-79.1zM160 304v17.4l38.9 38.9c1-.2 2-.3 3-.3H246c1 0 2 .1 3 .3l39-38.9V304H160zm128-32c0-6.5 3.9-12.3 9.9-14.7 19.6-8.1 37.8-19.5 53.9-33.8L376 202c9.9-8.8 10.8-24 2-33.9s-24-10.8-33.9-2l-24.2 21.5C293.5 211 259.3 224 224 224s-69.5-13-95.9-36.5L103.9 166c-9.9-8.8-25.1-7.9-33.9 2s-7.9 25.1 2 33.9l24.2 21.5c16.1 14.3 34.4 25.7 53.9 33.8 6 2.5 9.8 8.3 9.9 14.7h128zm18.7 75.9-34 34 16.8 19c4.8 5.4 5.4 13.4 1.4 19.5L276 442.7c-7.4 11-4.4 25.9 6.7 33.3s25.9 4.4 33.3-6.7l32-48c6.1-9.1 5.2-21.1-2-29.3l-39.2-44.1zm-131.4 34-34-34-39.2 44.1c-7.2 8.2-8.1 20.2-2 29.3l32 48c7.4 11 22.3 14 33.3 6.7s14-22.3 6.7-33.3l-14.9-22.3c-4-6.1-3.5-14.1 1.4-19.5l16.8-19z"
        }
    ]
};

const FalBackpack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBackpack",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32h64c8.8 0 16 7.2 16 16v16h-96V48c0-8.8 7.2-16 16-16zm-48 16v16h-16C57.3 64 0 121.3 0 192v256c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V192c0-70.7-57.3-128-128-128h-16V48c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48zm16 48h160c53 0 96 43 96 96v256c0 17.7-14.3 32-32 32h-16V320c0-35.3-28.7-64-64-64H144c-35.3 0-64 28.7-64 64v160H64c-17.7 0-32-14.3-32-32V192c0-53 43-96 96-96h32zm-48 384v-96h224v96H112zm32-320c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm192 192H112v-32c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32v32z"
        }
    ]
};

const FalBackwardFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBackwardFast",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64c8.8 0 16 7.2 16 16v135.8L210.6 70.2c5-4 11.2-6.2 17.6-6.2 15.4 0 27.8 12.4 27.8 27.8v150.1L466.6 70.2c5-4 11.2-6.2 17.6-6.2 15.4 0 27.8 12.4 27.8 27.8v328.4c0 15.4-12.4 27.8-27.8 27.8-6.4 0-12.6-2.2-17.6-6.2L256 270.1v150.1c0 15.4-12.4 27.8-27.8 27.8-6.4 0-12.6-2.2-17.6-6.2L32 296.2V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm17.3 192L224 411.4V100.6L33.3 256zM480 100.6 289.3 256 480 411.4V100.6z"
        }
    ]
};

const FalBackwardStep = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBackwardStep",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v352c0 8.8 7.2 16 16 16s16-7.2 16-16V296.2l178.6 145.6c5 4 11.2 6.2 17.6 6.2 15.4 0 27.8-12.4 27.8-27.8V91.8c0-15.4-12.4-27.8-27.8-27.8-6.4 0-12.6 2.2-17.6 6.2L64 215.8V80zm192 20.6v310.8L65.3 256 256 100.6z"
        }
    ]
};

const FalBackward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBackward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M37.6 256 256 414.1V97.9L37.6 256zM258 64c16.6 0 30 13.5 30 30v103.4L464.3 69.7C469.5 66 475.6 64 482 64c16.6 0 30 13.5 30 30v324c0 16.6-13.4 30-30 30-6.3 0-12.5-2-17.6-5.7L288 314.6V418c0 16.6-13.5 30-30 30-6.3 0-12.5-2-17.6-5.7L9.9 275.4C3.7 270.9 0 263.7 0 256s3.7-14.9 9.9-19.4L240.3 69.7C245.5 66 251.6 64 258 64zm30 211.1 192 139V97.9l-192 139v38.2z"
        }
    ]
};

const FalBacon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBacon",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M566.6 105.4c8 8 11.2 19.7 8.3 30.7s-11.3 19.6-22.2 22.7c-51.9 14.8-85.6 34.7-111.1 57.2-27.5 24.3-48.4 54.6-69 84.7l-.5.7c-44.3 64.5-96.6 140.6-229.8 207.2-12.3 6.2-27.2 3.7-36.9-6l-96-96c-7.3-7.3-10.6-17.6-9-27.8s8.1-18.9 17.3-23.5C107 310.7 169.8 247 225.6 165.9c21.8-31.8 44.9-64.9 77.7-93.9 33.4-29.5 75.8-53.6 135.9-70.8 11.2-3.2 23.2-.1 31.4 8.1l96 96zM68.1 420.1l4.8-2.4c122.1-61.1 168.8-129 211.7-191.4l2.3-3.3c21.9-31.9 43.9-63.5 75.1-90.9 29.9-26.4 67.7-48.5 121.2-64.9L448 32c-56 16-94 38-123.5 64S274 152 252 184c-58.8 85.6-125.8 152.9-220 200l36.1 36.1zm23.8 23.8L128 480c125.8-62.9 174.5-133.7 217.8-196.8 22.3-32.5 45-65 74.7-91.2C450 166 488 144 544 128l-35.1-35.1-8.5 2.4c-54 15.4-89.8 36.3-117.3 60.6-27.8 24.5-47.8 52.9-69.9 85.1l-2.2 3.3c-43.3 63.1-93 135.4-219 199.6z"
        }
    ]
};

const FalBacteria = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBacteria",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M310.4 1.3c8.1 3.5 11.8 12.9 8.3 21.1L314 33.1c15.7 7.9 28.7 20.7 36.9 36.9l10.7-4.7c8.1-3.5 17.5.2 21.1 8.3s-.2 17.5-8.3 21.1l-14.7 6.4c1.7 20.2-4 39.8-15.3 55.6l6 3.7c7.5 4.7 9.8 14.5 5.2 22s-14.5 9.8-22 5.2l-13.3-8.2c-7.6 4.7-16.2 8.3-25.4 10.5-6.8 1.6-13.2 3.4-19.1 5.4l3.8 17.3c1.9 8.6-3.5 17.2-12.1 19.1s-17.2-3.5-19.1-12.1l-2.4-10.8c-19.4 11.6-31.2 25.3-38.8 37.2l7.6 3.6c8 3.8 11.4 13.3 7.6 21.3s-13.3 11.4-21.3 7.6l-7.4-3.5c-1 3.3-1.7 6.7-2.3 10.1-1.5 14.1-6.5 27.1-14 38.1l10.2 10.8c6.1 6.4 5.8 16.6-.6 22.6s-16.6 5.8-22.6-.6l-9.6-10.2c-15.3 10.2-34 15.6-53.7 13.9l-6.4 14.7c-3.5 8.1-12.9 11.8-21.1 8.3s-11.8-13-8.3-21.1l4.7-10.7c-16-8.1-28.9-21.1-36.9-36.9l-10.7 4.7c-8.1 3.5-17.5-.2-21.1-8.3s.2-17.5 8.3-21.1l14.7-6.3c-.4-4.8-.4-9.6.1-14.6 1.1-12.1 3.8-24.2 7-35.9.2-.9.5-1.7.7-2.6l-15.2-7.6c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l11.6 5.8c4.8-11.7 11-24.2 18.8-37.2 1.9-3.2 3.9-6.4 6.1-9.6l-5.1-3.8c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2l5 3.7c10.9-13.1 23.5-25.8 38.1-37.8l-10.5-16.7c-4.6-7.5-2.3-17.4 5.2-22s17.4-2.3 22 5.2l9 14.7c14.5-9.4 30.6-18 48.3-25.5l-3.6-8.5c-3.5-8.1.3-17.5 8.4-21s17.5.3 21 8.4l4.3 10.1c9-2.8 18.3-5.4 28.1-7.6 8.7-2 17.4-2.6 25.8-1.9l6.4-14.7c3.5-8.1 12.9-11.8 21.1-8.3zM192 144a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-64 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm31.7 81.6c.1-.5.1-.9.2-1.4 2.8-18.2 10.3-34.8 18.2-48 16-26.7 46.7-59.1 109.6-73.6 28-6.5 45.4-34.4 39-62.4s-34.4-45.4-62.4-39c-93.1 21.5-146.4 73-175.4 121.4-14.1 23.7-22.2 45.9-26.7 62.4-2.9 10.6-5.1 20.8-6 30.3-2.6 28.6 18.5 53.8 47.1 56.4 28.3 2.6 53.3-18 56.4-46.1zm161.6 208 4.7-10.7c-15.6-7.9-28.7-20.7-36.9-36.9l-10.7 4.7c-8.1 3.5-17.5-.2-21.1-8.3s.2-17.5 8.3-21.1l14.7-6.4c-1.7-20.2 4-39.8 15.3-55.6l-6-3.7c-7.5-4.6-9.8-14.5-5.2-22s14.5-9.8 22-5.2l13.3 8.2c7.6-4.7 16.2-8.3 25.4-10.5 6.8-1.6 13.2-3.4 19.1-5.4l-3.8-17.3c-1.9-8.6 3.5-17.2 12.1-19.1s17.2 3.5 19.1 12.1l2.4 10.7c19.4-11.6 31.2-25.3 38.8-37.2l-7.6-3.6c-8-3.8-11.4-13.3-7.6-21.3s13.3-11.4 21.3-7.6l7.4 3.5c1-3.3 1.7-6.7 2.3-10.1 1.5-14.1 6.5-27.1 14-38.1L452.4 178c-6.1-6.4-5.8-16.6.6-22.6s16.6-5.8 22.6.6l9.6 10.2c15.3-10.2 34-15.6 53.7-13.9l6.4-14.7c3.5-8.1 12.9-11.8 21.1-8.3s11.8 12.9 8.3 21.1l-4.7 10.7c16 8.1 28.9 21.1 36.9 36.9l10.7-4.7c8.1-3.5 17.5.2 21.1 8.3s-.2 17.5-8.3 21.1l-14.7 6.4c.4 4.8.4 9.6-.1 14.6-1.1 12.1-3.8 24.2-7 35.9-.2.9-.5 1.7-.7 2.6l15.2 7.6c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-11.6-5.8c-4.8 11.7-11 24.2-18.8 37.2-1.9 3.2-3.9 6.4-6.1 9.6l5.1 3.8c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-5-3.7c-10.9 13.1-23.5 25.8-38.1 37.8l10.3 16.8c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2l-9-14.7c-14.5 9.4-30.6 18-48.3 25.5l3.6 8.5c3.5 8.1-.3 17.5-8.4 21s-17.5-.3-21-8.4l-4.1-10.3c-9 2.8-18.3 5.4-28.1 7.6-8.7 2-17.4 2.6-25.8 1.9l-6.4 14.6c-3.5 8.1-12.9 11.8-21.1 8.3s-11.8-13-8.3-21.1zM416 408a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm64.3-177.6c0 .5-.1.9-.2 1.4-2.8 18.2-10.3 34.8-18.2 48-16 26.7-46.7 59.1-109.6 73.6-28 6.5-45.4 34.4-39 62.4s34.4 45.4 62.4 39c93.1-21.5 146.4-73 175.4-121.4 14.2-23.6 22.2-45.8 26.7-62.3 2.9-10.6 5.1-20.8 6-30.3 2.6-28.6-18.5-53.8-47.1-56.4-28.3-2.6-53.3 18-56.4 46.1z"
        }
    ]
};

const FalBacterium = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBacterium",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M415.4 20.4c2.4-8.5-2.5-17.4-11-19.8s-17.4 2.5-19.8 11l-6 20.9c-11.7-1.1-23.8-.4-35.8 2.4-13.7 3.2-26.9 6.8-39.5 10.8l-8.6-20c-3.5-8.1-12.9-11.9-21-8.4s-11.9 12.9-8.4 21l7.8 18.2c-27.3 10.9-51.7 23.8-73.5 38l-10.3-15.4c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l10.8 16.2c-24.5 19-45 39.8-62.1 61.1L98 163.5c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5L92.4 200c-3.7 5.5-7.1 10.9-10.4 16.4-10.4 17.4-19.8 36-27.5 55.4L38 265.2c-8.2-3.3-17.5.7-20.8 8.9s.7 17.5 8.9 20.8l17.8 7.1c-5.5 18.4-9.4 37.2-11.4 55.9-.9 9.7-.5 19.3 1 28.5l-21.9 6.2C3.1 395-1.8 403.9.6 412.4s11.3 13.4 19.8 11l22.8-6.5c10.9 22.5 29.2 40.9 51.9 51.9l-6.5 22.8c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11l6.3-21.9c2.7.4 5.4.8 8.2 1 26.6 2.4 51.9-4.7 72.5-18.5l14.3 14.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-13.1-13.1c13.6-16.4 22.7-36.8 25.2-59.4 1.1-7.5 3.2-15 5.9-22.2l20.5 8.8c8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21l-18.8-8.1c10.8-17.2 28.2-37.7 58.4-54.3l2.7 9.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8l-3.9-13.8c9.1-3.3 19-6.2 29.7-8.7 17.6-4.1 33.3-12.1 46.4-22.9l13.1 13.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L461 206.4c15.4-23 22.3-51.7 17.5-80.7l21.9-6.3c8.5-2.4 13.4-11.3 11-19.8s-11.3-13.4-19.8-11l-22.8 6.5c-12.3-25.4-33.6-44.8-59-55.1l5.6-19.7zm-74.9 216c-.3.1-.6.1-.9.2-1.7.5-3.2 1.2-4.6 2.2-47.2 21.1-73.2 51-88.4 76.4-10.1 16.9-19.5 37.7-22.9 60.1-.1.5-.1.9-.2 1.4-4.7 43.3-43.2 74.9-86.8 71-43.9-4-76.3-42.8-72.4-86.7 4.7-43.9 21.7-89.1 45.1-128.2C149.4 166.1 222.8 95.4 350 66c43.1-9.9 86 16.9 95.9 60s-16.9 86-60 95.9c-16.9 3.9-32 8.8-45.5 14.4zM264 208a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 112a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"
        }
    ]
};

const FalBadgeCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBadgeCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8 25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8 7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4c19.1 27.5 51 45.6 87.1 45.6s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9c27.5-19.1 45.6-51 45.6-87.1s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm107.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalBadgeDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBadgeDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8 25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8 7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4c19.1 27.5 51 45.6 87.1 45.6s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9c27.5-19.1 45.6-51 45.6-87.1s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm16.9 140.4c0-8.8-7.2-16-16-16s-16 7.2-16 16v20.8c-9.5 1.5-19.2 4.6-27.7 9.7-14.1 8.3-25.7 22.7-25.6 43.4.1 19.6 11.4 32.1 24.4 39.9 11.5 6.9 26.1 11.3 38.4 15l1.7.5c13.8 4.2 24.8 7.7 32.7 12.6 6.9 4.3 9.3 8.4 9.4 14.3.1 8.1-3.4 13.2-9.5 17-6.8 4.3-16.9 6.5-27.3 6.2-13.4-.4-25.8-4.7-40.9-9.8-2.5-.9-5.2-1.8-7.9-2.7-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2.2.7 4.6 1.5 6.9 2.4 10.6 3.7 22.7 7.8 35.4 10.1v21.3c0 8.8 7.2 16 16 16s16-7.2 16-16V351c10-1.5 20-4.6 28.7-10.1 14.3-8.9 24.9-23.9 24.6-44.6-.3-19.8-11.3-32.7-24.4-41-12-7.6-27.4-12.2-40-16l-.4-.1c-13.9-4.2-25-7.6-32.8-12.3-6.9-4.2-8.9-7.8-8.9-12.7 0-6.8 3.2-11.8 9.9-15.7 7.3-4.3 17.5-6.5 27.1-6.4 11.4.2 23.7 2.7 36.1 6 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.7-2.3-18.3-4.5-28.1-5.8v-21z"
        }
    ]
};

const FalBadgePercent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBadgePercent",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.6 71.4C203 47.9 227.7 32 256 32s53 15.9 65.4 39.4c3.6 6.8 11.5 10.1 18.8 7.8 25.4-7.8 54.1-1.6 74.1 18.4s26.2 48.7 18.4 74.1c-2.3 7.3 1 15.2 7.8 18.8C464.1 203 480 227.7 480 256s-15.9 53-39.4 65.4c-6.8 3.6-10.1 11.5-7.8 18.8 7.8 25.4 1.6 54.1-18.4 74.1s-48.7 26.2-74.1 18.4c-7.3-2.3-15.2 1-18.8 7.8C309 464.1 284.3 480 256 480s-53-15.9-65.4-39.4c-3.6-6.8-11.5-10.1-18.8-7.8-25.4 7.8-54.1 1.6-74.1-18.4s-26.2-48.7-18.4-74.1c2.3-7.3-1-15.2-7.8-18.8C47.9 309 32 284.3 32 256s15.9-53 39.4-65.4c6.8-3.6 10.1-11.5 7.8-18.8-7.8-25.4-1.6-54.1 18.4-74.1s48.7-26.2 74.1-18.4c7.3 2.3 15.2-1 18.8-7.8zM256 0c-36.1 0-68 18.1-87.1 45.6-33-6-68.3 3.8-93.9 29.4s-35.3 60.9-29.4 93.9C18.1 188 0 219.9 0 256s18.1 68 45.6 87.1c-6 33 3.8 68.3 29.4 93.9s60.9 35.3 93.9 29.4c19.1 27.5 51 45.6 87.1 45.6s68-18.1 87.1-45.6c33 6 68.3-3.8 93.9-29.4s35.3-60.9 29.4-93.9c27.5-19.1 45.6-51 45.6-87.1s-18.1-68-45.6-87.1c6-33-3.8-68.3-29.4-93.9s-60.9-35.3-93.9-29.4C324 18.1 292.1 0 256 0zm91.3 164.7c-6.2-6.2-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6zM192 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 128a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalBadgeSheriff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBadgeSheriff",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-35.3 0-64 28.7-64 64 0 14.7 5 28.3 13.4 39.1l-18.9 32.4-35.2.1A62.99 62.99 0 0 0 96 112.5C65.4 94.9 26.3 105.4 8.6 136S1.4 205.8 32 223.4c12.3 7.1 25.9 9.6 39 8.2L84.9 256 71 280.4c-13.1-1.4-26.7 1.1-39 8.2C1.4 306.2-9.1 345.4 8.6 376s56.8 41.1 87.4 23.4l-8-13.9 8 13.9c10-5.8 17.8-13.8 23.3-23.1l35.2.1 18.9 32.4C165 419.7 160 433.3 160 448c0 35.3 28.7 64 64 64s64-28.7 64-64c0-14.7-5-28.3-13.4-39.1l18.9-32.4 35.2-.1c5.4 9.3 13.3 17.4 23.3 23.1 30.6 17.7 69.8 7.2 87.4-23.4s7.2-69.8-23.4-87.4c-12.3-7.1-25.9-9.6-39-8.2L363.1 256l13.9-24.4c13.1 1.4 26.7-1.1 39-8.2 30.6-17.7 41.1-56.8 23.4-87.4s-56.8-41.1-87.4-23.4c-10 5.8-17.8 13.8-23.3 23.1l-35.2-.1-18.9-32.4C283 92.3 288 78.7 288 64c0-35.3-28.7-64-64-64zm-32 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 9.9-4.4 18.7-11.5 24.6-6 5-7.5 13.6-3.6 20.3l24.9 42.8c5.7 9.8 16.2 15.8 27.5 15.9l45.4.2c6.8 0 12.8-4.2 15.1-10.6 2.5-6.9 7.3-12.9 14.1-16.9 15.3-8.8 34.9-3.6 43.7 11.7s3.6 34.9-11.7 43.7c-8.2 4.8-17.7 5.4-26.1 2.7-7.2-2.4-15.1.6-18.9 7.2l-19.7 34.5c-5.6 9.8-5.6 21.9 0 31.8l19.8 34.5c3.8 6.6 11.7 9.6 18.9 7.2 8.4-2.8 17.8-2.1 26.1 2.7 15.3 8.8 20.5 28.4 11.7 43.7s-28.4 20.6-43.7 11.7c-6.8-3.9-11.6-10-14.1-16.9-2.3-6.4-8.3-10.6-15.1-10.6l-45.4.2c-11.3 0-21.8 6.1-27.5 15.9L241 403.1c-3.9 6.7-2.4 15.3 3.6 20.3 7 5.9 11.5 14.7 11.5 24.6 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-9.9 4.4-18.7 11.5-24.6 6-5 7.5-13.6 3.6-20.3l-24.9-42.8c-5.7-9.8-16.2-15.8-27.5-15.9l-45.4-.2c-6.8 0-12.8 4.2-15.1 10.6-2.5 6.9-7.3 12.9-14.1 16.9-15.3 8.8-34.9 3.6-43.7-11.7s-3.6-34.9 11.7-43.7c8.2-4.7 17.7-5.4 26.1-2.7 7.2 2.4 15.1-.6 18.9-7.2l19.7-34.5c5.6-9.8 5.6-21.9 0-31.8L93 205.6c-3.8-6.6-11.7-9.6-18.9-7.2-8.4 2.8-17.8 2.1-26.1-2.7-15.3-8.8-20.5-28.4-11.7-43.7s28.4-20.5 43.7-11.7c6.8 3.9 11.6 10 14.1 16.9 2.3 6.4 8.3 10.6 15.1 10.6l45.4-.2c11.3 0 21.8-6.1 27.5-15.9l-13.8-8.1 13.8 8.1 24.9-42.8c3.9-6.7 2.4-15.3-3.6-20.3-7-5.9-11.4-14.7-11.4-24.6zm64 192a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"
        }
    ]
};

const FalBadge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBadge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c-28.3 0-53 15.9-65.4 39.4-3.6 6.8-11.5 10.1-18.8 7.8-25.4-7.8-54.1-1.6-74.1 18.4s-26.2 48.7-18.4 74.1c2.3 7.3-1 15.2-7.8 18.8C47.9 203 32 227.7 32 256s15.9 53 39.4 65.4c6.8 3.6 10.1 11.5 7.8 18.8-7.8 25.4-1.6 54.1 18.4 74.1s48.7 26.2 74.1 18.4c7.3-2.3 15.2 1 18.8 7.8C203 464.1 227.7 480 256 480s53-15.9 65.4-39.4c3.6-6.8 11.5-10.1 18.8-7.8 25.4 7.8 54.1 1.6 74.1-18.4s26.2-48.7 18.4-74.1c-2.3-7.3 1-15.2 7.8-18.8C464.1 309 480 284.3 480 256s-15.9-53-39.4-65.4c-6.8-3.6-10.1-11.5-7.8-18.8 7.8-25.4 1.6-54.1-18.4-74.1s-48.7-26.2-74.1-18.4c-7.3 2.3-15.2-1-18.8-7.8C309 47.9 284.3 32 256 32zm-87.1 13.6C188 18.1 219.9 0 256 0s68 18.1 87.1 45.6c33-6 68.3 3.8 93.9 29.4s35.3 60.9 29.4 93.9c27.5 19.1 45.6 51 45.6 87.1s-18.1 68-45.6 87.1c6 33-3.8 68.3-29.4 93.9s-60.9 35.3-93.9 29.4C324 493.9 292.1 512 256 512s-68-18.1-87.1-45.6c-33 6-68.3-3.8-93.9-29.4s-35.3-60.9-29.4-93.9C18.1 324 0 292.1 0 256s18.1-68 45.6-87.1c-6-33 3.8-68.3 29.4-93.9s60.9-35.3 93.9-29.4z"
        }
    ]
};

const FalBadgerHoney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBadgerHoney",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M459.8 96c-21 0-41.8 4.9-60.6 14.3-23.3 11.6-48.9 17.7-74.9 17.7H128c-5.3 0-10.5.4-15.6 1.3 4.7 53.1 49.3 94.7 103.6 94.7h2c17.1 0 34-4.2 49.2-12.1l85.6-44.8C391.7 146.7 435 136 479 136h104.9c-.7-.4-1.5-.7-2.2-1l-61.1-26.7c-18.4-8.1-38.3-12.3-58.4-12.3h-2.4zM32 224c0 43.2 28.5 79.8 67.8 91.8 8.3 2.6 13.1 11.3 10.7 19.7l-11.3 39.4c-1.7 5.9-1.6 12.1.1 18l13.1 43.7c2 6.8 8.3 11.4 15.3 11.4H149c10.7 0 18.4-10.3 15.3-20.6l-8.3-27.7c-3.2-10.8-2.6-22.4 1.9-32.7l16-37.3c2.5-5.9 8.3-9.7 14.7-9.7h118.1c7.8 0 14.5 5.7 15.8 13.4l16.9 101.3c1.3 7.7 8 13.4 15.8 13.4h23.1c9.9 0 17.4-8.9 15.8-18.6l-19.9-118.8c-1-5.8 1.3-11.6 5.9-15.2 42.5-33.4 112.3-71.5 187.8-78.4 11.5-1.1 21.7-5.3 28.7-12.4 7.2-7.2 11.3-17.1 11.3-27.3v-2.2c0-2.4-.2-4.8-.6-7.2h-95.7c.3 1.3.4 2.6.4 4 0 11-9 20-20 20s-20-9-20-20c0-1.3.1-2.6.4-3.9-36.5 1-72.3 10.3-104.8 27.3L282 240.2c-19.8 10.3-41.7 15.8-64 15.8h-2c-68.3 0-124.9-50.4-134.5-116C52 156.4 32 187.9 32 224zm43.7 116.9C58.9 333.3 44 322.3 32 308.7V320c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96C0 153.3 57.3 96 128 96h196.2c21 0 41.8-4.9 60.6-14.3 23.3-11.6 49-17.7 75-17.7h2.4c24.5 0 48.8 5.1 71.2 14.9l61.1 26.7c27.6 12.1 45.5 39.4 45.5 69.6v2.2c0 18.7-7.4 36.7-20.7 49.9-12.1 12.1-27.6 18.7-43.3 21.1V272c0 8.8-7.2 16-16 16s-16-7.2-16-16v-19.1c-53.3 10.6-102.6 36.9-136.6 62.1l18.2 109.1c4.9 29.3-17.7 55.9-47.3 55.9h-23.2c-23.5 0-43.5-17-47.3-40.1L293.1 352h-94l-11.8 27.6c-1.5 3.4-1.7 7.3-.6 10.9l8.3 27.7c9.2 30.8-13.8 61.8-46 61.8h-21.2c-21.2 0-39.9-13.9-46-34.2l-13.1-43.7a63.9 63.9 0 0 1-.2-36l7.2-25.2z"
        }
    ]
};

const FalBadminton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBadminton",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 28.2 6.4 56 19.7 80.7 7.8 14.4 7.2 32.8-4.4 44.4l-12 12-4.7-4.7c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3l-4.7-4.7 11.9-11.9c11.6-11.6 30-12.2 44.4-4.3 72.5 39.4 169.9 17.5 234.7-47.4 43.6-43.6 67-99.8 66.9-154 0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 376l32 32-72 72-32-32 72-72zm352.9 88-8.2 27.4c-2.5 8.5 2.3 17.4 10.7 19.9s17.4-2.3 19.9-10.7l11-36.6h-33.4zm39.1 32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h-32v32zm37.7-32 11 36.6c2.5 8.5 11.5 13.3 19.9 10.7s13.3-11.5 10.7-19.9l-8.2-27.4h-33.4zM496 400c0-8.8 7.2-16 16-16s16 7.2 16 16v16h-32v-16zm64 0c0-26.5-21.5-48-48-48s-48 21.5-48 48v48h96v-48z"
        }
    ]
};

const FalBagSeedling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBagSeedling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M89 96h334l12.6 50.3c8.2 33 12.4 66.9 12.4 100.9v17.7c0 34-4.2 67.9-12.4 100.9L423 416H89l-12.6-50.3c-8.2-33-12.4-66.8-12.4-100.9v-17.6c0-34 4.2-67.9 12.4-100.9L89 96zm341.9-32H81.1L64.8 39.5c-.5-.8-.8-1.7-.8-2.7 0-2.7 2.2-4.8 4.8-4.8h374.4c2.7 0 4.8 2.2 4.8 4.8 0 1-.3 1.9-.8 2.7L430.9 64zM81.1 448h349.8l16.3 24.5c.5.8.8 1.7.8 2.7 0 2.7-2.2 4.8-4.8 4.8H68.8c-2.7 0-4.8-2.2-4.8-4.8 0-1 .3-1.9.8-2.7L81.1 448zM38.2 57.3l20 30-12.8 51.2C36.5 174 32 210.5 32 247.2v17.7c0 36.6 4.5 73.1 13.4 108.7l12.8 51.2-20 30c-4 6.1-6.2 13.2-6.2 20.4 0 20.3 16.5 36.8 36.8 36.8h374.4c20.3 0 36.8-16.5 36.8-36.8 0-7.3-2.2-14.4-6.2-20.4l-20-30 12.8-51.2c8.9-35.5 13.4-72 13.4-108.7v-17.7c0-36.6-4.5-73.1-13.4-108.7l-12.8-51.2 20-30c4-6.1 6.2-13.2 6.2-20.4C480 16.5 463.5 0 443.2 0H68.8C48.5 0 32 16.5 32 36.8c0 7.3 2.2 14.4 6.2 20.4zM272 319c63.1-7.9 112-61.7 112-127v-1.6c0-16.8-13.6-30.4-30.4-30.4h-8.9c-37.2 0-68.9 17.9-88.7 44.5-19.8-26.6-51.5-44.5-88.7-44.5h-8.9c-16.8 0-30.4 13.6-30.4 30.4v1.6c0 65.3 48.9 119.1 112 127v33c0 8.8 7.2 16 16 16s16-7.2 16-16v-33zm-32-32.3c-45.4-7.6-80-47.1-80-94.7h7.3c33.6 0 61 20.5 72.7 48.4v46.2zm32 0v-46.3c11.7-27.9 39.1-48.4 72.7-48.4h7.3c0 47.6-34.6 87.1-80 94.7z"
        }
    ]
};

const FalBagShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBagShopping",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96v32h128V96c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 64H48c-8.8 0-16 7.2-16 16v240c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V176c0-8.8-7.2-16-16-16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80H160v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80zm0-32V96c0-53 43-96 96-96s96 43 96 96v32h80c26.5 0 48 21.5 48 48v240c0 53-43 96-96 96H96c-53 0-96-43-96-96V176c0-26.5 21.5-48 48-48h80z"
        }
    ]
};

const FalBagel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBagel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M608 208c0-97.2-78.8-176-176-176-49.3 0-93.9 20.3-125.8 52.9-10.5-4.7-21.3-8.7-32.5-11.8C311.8 28.4 368.6 0 432 0c114.9 0 208 93.1 208 208s-93.1 208-208 208c-3.9 0-7.7-.1-11.5-.3 5.4-10.2 10-20.7 13.9-31.7 96.1-1.3 173.6-79.6 173.6-176zM364.6 84.4l17.6-.5c6.2-.2 12.1-2.1 17.2-5.6l14.5-10c10.9-7.5 25.3-7.5 36.2 0l14.5 10c5.1 3.5 11 5.4 17.2 5.6l17.6.5c13.2.4 24.8 8.8 29.3 21.3l5.9 16.6c2.1 5.8 5.8 10.9 10.6 14.6l14 10.7c10.5 8.1 14.9 21.7 11.2 34.4l-5 16.9c-1.7 5.9-1.7 12.2 0 18.1l5 16.9c3.7 12.7-.7 26.3-11.2 34.4l-14 10.7c-4.9 3.8-8.6 8.8-10.6 14.6l-5.9 16.6c-4.4 12.5-16.1 20.9-29.3 21.3l-17.6.5c-6.2.2-12.1 2.1-17.2 5.6l-14.5 10c-2.1 1.5-4.4 2.6-6.7 3.5 2.6-13.2 4.2-26.9 4.5-40.8 9.8-6.4 21.3-9.9 33-10.3l17.6-.5 5.9-16.6c4.1-11.6 11.5-21.8 21.3-29.3l14-10.7-5-16.9c-3.5-11.8-3.5-24.4 0-36.2l5-16.9-14-10.7c-9.8-7.5-17.1-17.7-21.3-29.3l-5.9-16.6-17.6-.5c-12.3-.3-24.3-4.2-34.4-11.2L432 94.8l-14.5 10c-10.2 7-22.1 10.8-34.4 11.2l-17.6.5-1.8 4.9c-8.4-7.2-17.3-13.8-26.6-19.7 5.3-10.2 15.8-16.9 27.5-17.2zM384 304a176 176 0 1 0-352 0 176 176 0 1 0 352 0zM0 304a208 208 0 1 1 416 0 208 208 0 1 1-416 0zm208-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm48 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM128 192a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM112 384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm128 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48-16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM80 256a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalBagsShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBagsShopping",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96c0-35.3 28.7-64 64-64s64 28.7 64 64v64H160V96zm-32 64H64c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h96v-32H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32h32c0-35.3-28.7-64-64-64h-64V96c0-53-43-96-96-96s-96 43-96 96v64zm384 128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h256zm-320 32v128c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64zm128 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 35.3-28.7 64-64 64s-64-28.7-64-64v-16z"
        }
    ]
};

const FalBaguette = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBaguette",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M591.9 74.8c-29.4-44.1-89-56-133.1-26.6L379.6 101l47.8 47.8c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352.4 119l-88 58.7 51 51c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-55.5-55.5-88 58.7 54.2 54.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L122 272.6l-47.3 31.5c-44.1 29.4-56 89-26.6 133.1s89 56 133.1 26.6l384-256c44.1-29.4 56-89 26.6-133.1zM618.5 57c39.2 58.8 23.3 138.3-35.5 177.5l-384 256C140.2 529.7 60.7 513.8 21.5 455S-1.8 316.7 57 277.5l384-256C499.8-17.7 579.3-1.8 618.5 57z"
        }
    ]
};

const FalBahai = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBahai",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M287.7 0c7.2 0 13.6 4.9 15.5 11.9l32.2 120.7 102.4-71.8c5.9-4.2 13.9-3.8 19.5.8s7.3 12.5 4.2 19l-53 113.1 124.6 10.7c7.2.6 13.1 6 14.4 13.2s-2.4 14.2-9 17.3L425 287.7l88.5 88.2c5.1 5.1 6.2 13 2.6 19.3s-11 9.3-18 7.5l-120.8-32.5 11 124.4c.6 7.2-3.7 14-10.5 16.4s-14.4.1-18.6-5.9l-71.5-102.4-71.6 102.5c-4.2 5.9-11.8 8.3-18.6 5.9s-11.1-9.2-10.5-16.4l11-124.4-120.7 32.3c-7 1.9-14.4-1.2-18-7.5s-2.6-14.2 2.6-19.3l88.5-88.2L37 235c-6.6-3.1-10.3-10.1-9-17.3s7.2-12.5 14.4-13.2L167 193.8 114 80.7c-3.1-6.6-1.4-14.4 4.2-19s13.5-5 19.5-.8L240 132.6l32.2-120.7c1.9-7 8.2-11.9 15.5-11.9zm0 78L265 162.9c-1.3 5-5.1 9.1-10 10.9s-10.4 1.1-14.7-1.9l-72-50.5 37.3 79.6c2.2 4.7 2 10.3-.6 14.8s-7.3 7.5-12.5 7.9l-87.6 7.5 79.7 37c4.7 2.2 8.1 6.6 9 11.7s-.8 10.4-4.5 14.1l-62.2 62 84.9-22.8c5-1.4 10.4-.2 14.4 3.2s6.1 8.5 5.7 13.7l-7.8 87.5 50.4-72.1c3-4.3 7.9-6.8 13.1-6.8s10.1 2.6 13.1 6.8l50.4 72.1-7.8-87.5c-.5-5.2 1.6-10.3 5.7-13.7s9.4-4.6 14.4-3.2l84.9 22.8-62.2-62c-3.7-3.7-5.4-9-4.5-14.1s4.3-9.5 9-11.7l79.7-37-87.6-7.5c-5.2-.4-9.9-3.4-12.5-7.9s-2.9-10-.6-14.8l37.4-79.6-72 50.5c-4.3 3-9.8 3.7-14.7 1.9s-8.6-5.9-10-10.9L287.7 78z"
        }
    ]
};

const FalBahtSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBahtSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c-8.8 0-16 7.2-16 16v48H37.6C16.8 64 0 80.8 0 101.6v304.7c0 23 18.7 41.7 41.7 41.7H128v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h56c57.4 0 104-46.6 104-104 0-44.7-28.2-82.8-67.8-97.5 21.9-19.1 35.8-47.2 35.8-78.5 0-57.4-46.6-104-104-104h-24V16c0-8.8-7.2-16-16-16zm-16 96v144H32V101.6c0-3.1 2.5-5.6 5.6-5.6H128zm32 144V96h24c39.8 0 72 32.2 72 72s-32.2 72-72 72h-24zm-32 32v144H41.7c-5.4 0-9.7-4.4-9.7-9.7V272h96zm32 144V272h56c39.8 0 72 32.2 72 72s-32.2 72-72 72h-56z"
        }
    ]
};

const FalBallPile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBallPile",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 96a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-35.4 91.7c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3c17.7 17.4 28.6 41.6 28.6 68.3s-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256s10.9-50.9 28.6-68.3zM384 352c-9.9 0-19.5-1.5-28.6-4.3 17.7 17.4 28.6 41.6 28.6 68.3 0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3c17.7 17.4 28.6 41.6 28.6 68.3 0 53-43 96-96 96S0 469 0 416s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96 9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96c0 26.7-10.9 50.9-28.6 68.3 9-2.8 18.6-4.3 28.6-4.3 53 0 96 43 96 96 0 26.7-10.9 50.9-28.6 68.3 9-2.8 18.6-4.3 28.6-4.3 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3-9 2.8-18.6 4.3-28.6 4.3zm-128-96a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-96 160a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm224-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-96 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256-64a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FalBalloon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBalloon",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m205.6 405.8-13.6 9.5-13.6-9.5-.2-.2-1.1-.8c-1-.7-2.6-1.9-4.6-3.4-4-3-9.9-7.6-17-13.5-14.2-11.8-33.1-28.8-51.8-49.4C65 295.9 32 243.6 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 51.6-33 103.9-71.7 146.5-18.8 20.6-37.6 37.6-51.8 49.4-7.1 5.9-12.9 10.5-17 13.5-2 1.5-3.6 2.7-4.6 3.4l-1.1.8-.2.2zM192 439.6l3.4 6.8 16.8 33.6h-40.4l16.8-33.7 3.4-6.8zM0 192c0 128 160 240 160 240l-30.6 61.3c-.9 1.8-1.4 3.8-1.4 5.8 0 7.1 5.8 12.9 12.9 12.9h102.2c7.1 0 12.9-5.8 12.9-12.9 0-2-.5-4-1.4-5.8L224 432s160-112 160-240C384 86 298 0 192 0S0 86 0 192zm112-16c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalBalloons = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBalloons",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M172.8 342.4 160 352l-12.8-9.6-.1-.1-.8-.6c-.8-.6-2-1.6-3.6-2.8-3.1-2.6-7.8-6.4-13.3-11.4-11.2-10-26.1-24.5-40.9-42C58 249.1 32 204.5 32 160 32 89.3 89.3 32 160 32s128 57.3 128 128c0 44.5-26 89.1-56.5 125.4-14.8 17.6-29.7 32-40.9 42-5.6 5-10.2 8.8-13.3 11.4-1.6 1.3-2.8 2.2-3.6 2.8l-.8.6-.1.1zm-9.4 39.9 16.8 33.7h-40.4l16.8-33.7 3.4-6.8 3.4 6.8zM192 368s128-96 128-208C320 71.6 248.4 0 160 0S0 71.6 0 160c0 112 128 208 128 208l-30.6 61.3c-.9 1.8-1.4 3.8-1.4 5.8 0 7.1 5.8 12.9 12.9 12.9h102.2c7.1 0 12.9-5.8 12.9-12.9 0-2-.5-4-1.4-5.8L192 368zm139.2-84.9C362.3 367.8 448 432 448 432l-30.6 61.3c-.9 1.8-1.4 3.8-1.4 5.8 0 7.1 5.8 12.9 12.9 12.9h102.2c7.1 0 12.9-5.8 12.9-12.9 0-2-.5-4-1.4-5.8L512 432s128-96 128-208c0-88.4-71.6-160-160-160-46.1 0-87.7 19.5-116.9 50.8 3.2 14.6 4.9 29.7 4.9 45.2v2c21.8-39.4 63.8-66 112-66 70.7 0 128 57.3 128 128 0 44.5-26 89.1-56.5 125.4-14.8 17.6-29.7 32-40.9 42-5.6 5-10.2 8.8-13.3 11.4-1.6 1.3-2.8 2.2-3.6 2.8l-.8.6-.1.1L480 416l-12.8-9.6-.1-.1-.8-.6c-.8-.6-2-1.6-3.6-2.8-3.1-2.6-7.8-6.4-13.3-11.4-11.2-10-26.1-24.5-40.9-42-27.3-32.5-50.9-71.5-55.6-111.2-6.1 16-13.6 31-21.7 44.7zM480 439.6l3.4 6.8 16.8 33.6h-40.4l16.8-33.7 3.4-6.8zM112 160c0-26.5 21.5-48 48-48 8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16s16-7.2 16-16zm320 64c0-26.5 21.5-48 48-48 8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalBallotCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBallotCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h320zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 128c0 8.8 7.2 16 16 16h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm32 128c0 8.8 7.2 16 16 16h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm-32 128c0 8.8 7.2 16 16 16h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM88 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H88zM72 376v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H88c-8.8 0-16 7.2-16 16zm91.3-132.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L104 257.4l-12.7-12.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48z"
        }
    ]
};

const FalBallot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBallot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h320zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 128c0 8.8 7.2 16 16 16h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM88 104c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H88zM72 248v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H88c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H88z"
        }
    ]
};

const FalBanBug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBanBug",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm79.5-167.1c.3-2.9.5-5.9.5-8.9v-5.9l46 5.8c8.8 1.1 16.8-5.1 17.9-13.9s-5.1-16.8-13.9-17.9l-50-6.2v-21.4l51.9-13c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-44.1 11V208c0-7.4-1-14.7-2.9-21.5l43.8-29.2c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-40.8 27.2C303.7 139.7 281.2 128 256 128c-28.6 0-53.7 15-67.8 37.6l-78.9-78.9C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224 0 56.1-20.6 107.4-54.7 146.7l-89.8-89.8zM304 281.4l-92.2-92.2C219.1 172 236.2 160 256 160c26.5 0 48 21.5 48 48v73.4zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-246.1-50 6.2c-8.8 1.1-15 9.1-13.9 17.9s9.1 15 17.9 13.9l46-5.8v5.9c0 7.4 1 14.7 2.9 21.5l-43.8 29.2c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l40.8-27.2c14.6 18.2 37.1 29.9 62.3 29.9 17 0 32.8-5.3 45.8-14.4l-23.2-23.2c-6.7 3.6-14.4 5.6-22.5 5.6-26.5 0-48-21.5-48-48v-28.2l-32-32v22z"
        }
    ]
};

const FalBanParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBanParking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480C132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7l316 316C363.4 459.4 312.1 480 256 480zm76-170.6c30.9-16 52-48.2 52-85.4 0-53-43-96-96-96h-88c-13.3 0-24 10.7-24 24v1.4l-66.7-66.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224 0 56.1-20.6 107.4-54.7 146.7L332 309.4zM307.6 285 208 185.4V160h80c35.3 0 64 28.7 64 64 0 28.5-18.7 52.7-44.4 61zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-254.1V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h30.1L176 257.9z"
        }
    ]
};

const FalBanSmoking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBanSmoking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M86.7 109.3 201.4 224l32 32 32 32 32 32 105.3 105.3C363.4 459.4 312.1 480 256 480 132.3 480 32 379.7 32 256c0-56.1 20.6-107.4 54.7-146.7zM278.6 256H384v32h-73.4l-32-32zm64 64H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H246.6L109.3 86.7C148.6 52.6 199.9 32 256 32c123.7 0 224 100.3 224 224 0 56.1-20.6 107.4-54.7 146.7L342.6 320zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm16-416c-8.8 0-16 7.2-16 16 0 26.5 21.5 48 48 48h32c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48h-32c-8.8 0-16-7.2-16-16s-7.2-16-16-16zm-51.9 192H128v-32h60.1l-32-32H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h140.1l-32-32z"
        }
    ]
};

const FalBan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBan",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m402.7 425.3-316-316C52.6 148.6 32 199.9 32 256c0 123.7 100.3 224 224 224 56.1 0 107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256c0-123.7-100.3-224-224-224-56.1 0-107.4 20.6-146.7 54.7l316 316zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FalBanana = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBanana",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 144c0 41.2-8.7 80.4-24.3 115.9-8-7.6-17-14.2-26.5-19.5 12.1-29.7 18.8-62.3 18.8-96.4 0-31.4-5.6-61.3-15.9-89-9.5-25.5 8.6-55 38-55 9.8 0 19.5 3.6 27 10.4C411.4 63.1 448 139.3 448 224c0 11-.6 21.8-1.8 32.5-11.4 1-22.6 3.6-33.3 7.5 2.1-13.1 3.1-26.4 3.1-40.1 0-75.3-32.5-143-84.3-189.9-1.5-1.4-3.5-2.1-5.6-2.1-3.3 0-5.5 1.4-7 3.6-1.7 2.6-2 5.6-1.1 8.2 11.7 31.3 18 65.1 18 100.3zm-82.1 152.2c-9.7-5.3-20.7-8.2-32-8.2-11.6 0-22.9 3-32.9 8.7l-37 21.1c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l37-21.1c14.9-8.5 31.7-13 48.8-13 26.1 0 51.1 10.4 69.6 28.8l48 48 77.8-35.9c12.7-5.9 26.5-8.9 40.5-8.9 34.4 0 66.1 18.2 83.4 47.9l32.7 56c4.5 7.6 1.9 17.4-5.8 21.9s-17.4 1.9-21.9-5.8l-32.7-56c-11.6-19.8-32.8-32.1-55.8-32.1-9.3 0-18.6 2-27.1 5.9l-1.4.7C387.8 435 282.9 512 160 512H48c-26.5 0-48-21.5-48-48v-16c0-26.5 21.5-48 48-48 84.4 0 159.2-40.8 205.9-103.8zm130.6 51.1-41.7 19.3c-6.1 2.8-13.3 1.5-18-3.2L278.4 317C225.8 386.8 142.2 432 48 432c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h112c96.7 0 180.9-53.6 224.4-132.7z"
        }
    ]
};

const FalBandage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBandage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 128v256h80c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-80zm-32 0H192v256h256V128zM160 384V128H80c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h80zm0-288h400c44.2 0 80 35.8 80 80v160c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h80zm112 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-72 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalBangladeshiTakaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBangladeshiTakaSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M50 32.1C41.2 31 33.2 37.2 32.1 46S37.2 62.8 46 63.9l7.9 1c24 3 42 23.4 42 47.6V192H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v176c0 44.2 35.8 80 80 80h32c97.2 0 176-78.8 176-176v-32c0-44.2-35.8-80-80-80h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c26.5 0 48 21.5 48 48v32c0 79.5-64.5 144-144 144h-32c-26.5 0-48-21.5-48-48V224h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-79.5c0-40.3-30-74.4-70.1-79.4l-7.9-1z"
        }
    ]
};

const FalBanjo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBanjo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M445.7 33c.6-.6 1.5-1 2.3-1s1.7.3 2.3 1L479 61.7c.6.6 1 1.5 1 2.3s-.3 1.7-1 2.3l-39 39-42.9 9.5 9.5-42.8 39-39zm-69.3 27.5-15 67.5-62.4 62.4c-25.2-20.8-56.6-34.4-90.9-37.7V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v8.8c-34.4 3.2-65.8 16.9-90.9 37.7l-6.2-6.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l6.2 6.2c-21 25.1-34.6 56.5-37.8 90.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.8c3.2 34.4 16.9 65.8 37.7 90.9l-6.2 6.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l6.2-6.2c25.2 20.8 56.6 34.4 90.9 37.7v8.8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.8c34.4-3.2 65.8-16.9 90.9-37.7l6.2 6.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-6.2-6.2c20.8-25.2 34.4-56.6 37.7-90.9h8.8c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8.8c-3.2-34.4-16.9-65.8-37.7-90.9l62.5-62.5 67.5-15c3-.7 5.7-2.2 7.8-4.3L501.7 89c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L473 10.3C466.3 3.7 457.4 0 448 0s-18.3 3.7-25 10.3l-42.3 42.4c-2.2 2.2-3.6 4.9-4.3 7.8zM192 184a136 136 0 1 1 0 272 136 136 0 1 1 0-272zm-67.3 132.7c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalBarcodeRead = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBarcodeRead",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V48C0 21.5 21.5 0 48 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48zm96 96c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm48 16c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm224 0c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm-144-16c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm208-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c26.5 0 48 21.5 48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zM48 480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-26.5 0-48-21.5-48-48v-96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8 7.2 16 16 16zm496-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 26.5-21.5 48-48 48h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FalBarcodeScan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBarcodeScan",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 48v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm0 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320H64v144zm96 0V320h-32v144c0 8.8 7.2 16 16 16s16-7.2 16-16zM128 48v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32v144zm0-416v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32v144zm0-416v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32v144zm0-416v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32v144zm0-416v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96 416c0 8.8 7.2 16 16 16s16-7.2 16-16V320h-32v144zm0-416v144h32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16zM0 256c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalBarcode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBarcode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16s16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm64 0c0-8.8 7.2-16 16-16s16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm80-16c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16s16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm80-16c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16s16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48zm112-16c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalBarsFilter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBarsFilter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zm64 160c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm224 160c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalBarsProgress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBarsProgress",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H320V96h144zM48 96h240v96H48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm0-32C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H48zm416 256c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H192v-96h272zm-416 0h112v96H48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H48z"
        }
    ]
};

const FalBarsSort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBarsSort",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zm0 160c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm192 160c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalBarsStaggered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBarsStaggered",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zm64 160c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm384 160c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h416c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalBars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBars",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zm0 160c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm448 160c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h416c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalBaseballBatBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBaseballBatBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 0c-14.5 0-28.4 5.8-38.6 16L226.1 167.2c-9.7 9.7-18.4 20.3-26 31.7l-74.9 112.4c-6.4 9.6-13.8 18.6-22 26.8L32 409.4l-4.7-4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.7 4.7 11.3 11.3 48 48L80 502.6l4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-4.7-4.7 71.2-71.2c8.2-8.2 17.2-15.6 26.8-22L313 311.9c11.4-7.6 22-16.3 31.7-26L496 134.6c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6L454.6 16C444.4 5.8 430.5 0 416 0zM80 457.4 54.6 432l71.2-71.2 2.1-2.1 25.5 25.3-2.1 2.1L80 457.4zm98.1-93.9-29.6-29.6 3.3-4.8 74.9-112.4c6.4-9.6 13.8-18.6 22-26.8L400 38.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6L473.4 80c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16L322.1 263.2c-8.2 8.2-17.2 15.6-26.8 22l-112.4 74.9-4.8 3.3zM384 432a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FalBaseball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBaseball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256.6 480c-.4-5.3-.6-10.6-.6-16 0-5.8.2-11.6.7-17.3.7-8.8 8.5-15.4 17.3-14.6s15.4 8.5 14.6 17.3c-.4 4.8-.6 9.7-.6 14.7 0 4.6.2 9.1.5 13.7 97.7-14.2 174.9-91.5 189.1-189.1-4.5-.3-9.1-.5-13.7-.5-4.9 0-9.8.2-14.7.6-8.8.7-16.5-5.8-17.3-14.6s5.8-16.5 14.6-17.3c5.7-.5 11.5-.7 17.3-.7 5.4 0 10.7.2 16 .6v-.6C480 132.3 379.7 32 256 32h-.6c.4 5.3.6 10.6.6 16 0 5.8-.2 11.6-.7 17.3-.7 8.8-8.5 15.4-17.3 14.6s-15.4-8.5-14.6-17.3c.4-4.8.6-9.7.6-14.7 0-4.6-.2-9.1-.5-13.7-97.7 14.4-174.9 91.6-189.2 189.3 4.5.3 9.1.5 13.7.5 4.9 0 9.8-.2 14.7-.6 8.8-.7 16.5 5.8 17.3 14.6s-5.8 16.5-14.6 17.3c-5.7.5-11.5.7-17.3.7-5.4 0-10.7-.2-16-.6v.6c0 123.7 100.3 224 224 224h.6zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm121.3-48c38.3-17.6 69.2-48.5 86.7-86.7 3.7-8 13.2-11.6 21.2-7.9s11.6 13.2 7.9 21.2c-20.8 45.2-57.2 81.7-102.5 102.5-8 3.7-17.5.2-21.2-7.9s-.2-17.5 7.9-21.2zm269.4 96c-38.3 17.6-69.2 48.5-86.7 86.7-3.7 8-13.2 11.6-21.2 7.9s-11.6-13.2-7.9-21.2c20.8-45.2 57.2-81.7 102.5-102.5 8-3.7 17.5-.2 21.2 7.9s.2 17.5-7.9 21.2z"
        }
    ]
};

const FalBasketShoppingSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBasketShoppingSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M322.2 24.1c-4.5-7.6-1.9-17.4 5.8-21.9S345.4.3 349.9 8l107.3 184H560c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24l-59.9 239.5C469 492 443.4 512 414 512H162c-29.4 0-55-20-62.1-48.5L40 224H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h102.8L226.2 7.9c4.5-7.6 14.2-10.2 21.9-5.8s10.2 14.2 5.8 21.9l-98 168h264.2l-98-167.9zM503 224H73l57.9 231.8c3.6 14.2 16.4 24.2 31 24.2H414c14.7 0 27.5-10 31-24.2L503 224zm-359 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm264-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalBasketShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBasketShopping",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M327.9 2.2c-7.6 4.5-10.2 14.2-5.8 21.9l98 167.9H155.9l98-167.9c4.5-7.6 1.9-17.4-5.8-21.9S230.7.3 226.2 8L118.8 192H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h24l59.9 239.5C107 492 132.6 512 162 512h252c29.4 0 55-20 62.1-48.5L536 224h24c8.8 0 16-7.2 16-16s-7.2-16-16-16H457.2L349.8 7.9c-4.5-7.6-14.2-10.2-21.9-5.8zM73 224h430l-57.9 231.8C441.5 470 428.7 480 414 480H162c-14.7 0-27.5-10-31-24.2L73 224zm151 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm64-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm96 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalBasketballHoop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBasketballHoop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M35.1 201.9C51.5 170.8 135.3 32 320 32s268.5 138.8 284.9 169.9c2.1 4 3.1 8.4 3.1 13v116.3c0 12.6-7.4 24.1-19 29.2l-79.2 35.2-5 37.2 97.2-43.1c23.1-10.3 38-33.2 38-58.5V214.9c0-8.9-1.8-18.6-6.8-28C615.3 153.1 523.3 0 320 0S24.7 153.1 6.8 187c-5 9.3-6.8 19-6.8 27.9v116.3c0 25.3 14.9 48.2 38 58.5l97.2 43.2-5-37.2L51 360.4c-11.6-5.1-19-16.6-19-29.2V214.9c0-4.6.9-9 3.1-13zM192 176c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v32h32v-32c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48v32h32v-32zm-48 64h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h18l30.1 226.1c.8 6.2 5.2 11.4 11.3 13.2s12.6-.1 16.7-4.8l48.3-55.7 56.3 56.5c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l56.3-56.5 48.3 55.7c4.1 4.8 10.6 6.7 16.7 4.8s10.4-7 11.3-13.2L494 272h18c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm34.3 32h54.4l1.4 1.7-48.6 53.1-7.2-54.8zm100.7 0h82l2.1 2.2-43 49.6-43-49.6 1.9-2.2zm128.3 0h54.4l-7.3 54.7-48.6-53.1 1.4-1.7zM320 473.3l-46.6-46.8 46.6-53.8 46.6 53.8-46.6 46.8zm-69.3-69.5-48.1-48.3 52.6-57.5 43.6 50.3-48.1 55.5zm-21 24.2-26.5 30.6-8.8-66.1 35.3 35.5zm159.6-24.2-48.1-55.5 43.6-50.3 52.6 57.5-48.1 48.3zm21 24.2 35.3-35.5-8.8 66.1-26.5-30.6z"
        }
    ]
};

const FalBasketball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBasketball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M290.7 477.3c-1.8-9.5-2.7-19.3-2.7-29.3 0-38.4 13.5-73.7 36.1-101.3l78.6 78.6c-31 26.9-69.5 45.4-112 52zm-32 2.7H256c-56.1 0-107.4-20.6-146.7-54.7L256 278.6l45.4 45.4c-28.3 33.5-45.4 76.7-45.4 124 0 10.9.9 21.6 2.7 32zM324 301.4 278.6 256l146.7-146.7C459.4 148.6 480 199.9 480 256v2.7c-10.4-1.7-21.1-2.7-32-2.7-47.3 0-90.5 17.1-124 45.4zm22.7 22.7C374.3 301.5 409.6 288 448 288c10 0 19.8.9 29.3 2.7-6.6 42.5-25.1 81-52 112l-78.6-78.6zM256 233.4 210.6 188c28.3-33.5 45.4-76.7 45.4-124 0-10.9-.9-21.6-2.7-32h2.7c56.1 0 107.4 20.6 146.7 54.7L256 233.4zm-68.1-68.1-78.6-78.6c31-26.9 69.5-45.4 112-52C223.1 44.2 224 54 224 64c0 38.4-13.5 73.7-36.1 101.3zm-22.6 22.6C137.7 210.5 102.4 224 64 224c-10 0-19.8-.9-29.3-2.7 6.6-42.5 25.1-81 52-112l78.6 78.6zM32 253.3c10.4 1.7 21.1 2.7 32 2.7 47.3 0 90.5-17.1 124-45.4l45.4 45.4L86.7 402.7C52.6 363.4 32 312.1 32 256v-2.7zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"
        }
    ]
};

const FalBat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M366.3 187.7c8.9 4.5 19.3 4.6 28.3.4l71.8-34.2c3.1-1.5 6.8-.7 9 1.9 44.3 51.7 68.6 117.4 68.6 185.4v7L507.6 330c-22.4-11.2-49.7-3.3-62.6 18.2l-19.3 32.2-22.1-22.1c-20.5-20.5-54.3-18.3-72 4.7L288 419.5l-43.5-56.6c-17.7-23-51.5-25.2-72-4.7l-22.1 22.1-19.3-32.2c-12.9-21.5-40.2-29.5-62.6-18.2L32 348.2v-7c0-68 24.3-133.7 68.6-185.4 2.2-2.6 5.9-3.4 9-1.9l71.8 34.2c9 4.3 19.4 4.1 28.3-.4s15.1-12.9 16.9-22.6L240.3 92l15.3 10.2a58.462 58.462 0 0 0 64.8 0L335.7 92l13.7 73.1c1.8 9.8 8.1 18.1 16.9 22.6zM358.2 77l-9.9-14.9 9.9 14.9zm16.6 49.7-12.6-67.2c-1.3-6.7-7.1-11.5-13.9-11.5-2.8 0-5.5.8-7.8 2.4l-37.8 25.2c-4.3 2.9-9.4 4.4-14.7 4.4s-10.3-1.5-14.7-4.4l-37.7-25.2c-2.3-1.5-5-2.4-7.8-2.4-6.8 0-12.6 4.8-13.9 11.5l-12.6 67.2-6.1 32.5-29.9-14.2-41.9-20c-16.2-7.7-35.5-3.6-47.1 10C27.1 192.4 0 265.6 0 341.2v37.6c0 9.7 10.2 16 18.9 11.7l63.8-31.9c7.5-3.7 16.6-1.1 20.9 6.1l29.8 49.7c5.4 8.9 17.7 10.4 25 3.1l36.6-36.6c6.8-6.8 18.1-6.1 24 1.6l56.2 73.1c6.4 8.3 19 8.3 25.4 0l56.2-73.1c5.9-7.7 17.2-8.4 24-1.6l36.6 36.6c7.4 7.4 19.7 5.8 25-3.1l29.8-49.7c4.3-7.2 13.4-9.8 20.9-6.1l63.8 31.9c8.7 4.3 18.9-2 18.9-11.7v-37.6c0-75.6-27.1-148.8-76.3-206.2-11.6-13.6-30.9-17.7-47.1-10l-41.7 20-29.9 14.2-6.1-32.5z"
        }
    ]
};

const FalBath = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBath",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.3 32C77.1 32 64 45.1 64 61.3V256h432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V61.3C32 27.4 59.4 0 93.3 0c16.2 0 31.8 6.5 43.3 17.9L161.7 43c11.1-7 24.2-11 38.3-11 20.2 0 38.5 8.3 51.6 21.8l1.1-1.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-104 104c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.1-1.1C136.3 142.5 128 124.2 128 104c0-14.1 4-27.2 11-38.3l-25.1-25.1C108.5 35.1 101 32 93.3 32zM32 320h32v48c0 26.2 12.6 49.4 32 64 13.4 10 30 16 48 16h224c18 0 34.6-6 48-16 19.4-14.6 32-37.8 32-64v-48h32v48c0 30.5-12.2 58.2-32 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-26.8c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-49.6c-19.8-20.2-32-47.9-32-78.4v-48zM200 64c-22.1 0-40 17.9-40 40 0 11.4 4.8 21.7 12.4 29L229 76.4c-7.3-7.6-17.6-12.4-29-12.4z"
        }
    ]
};

const FalBatteryBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBatteryBolt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 384h66.4c1 12.1 6.2 23.4 14.4 32H80c-44.2 0-80-35.8-80-80V176c0-44.2 35.8-80 80-80h196l-33.8 32H80c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48zm156 32 33.8-32H432c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-66.4c-1-12.1-6.2-23.4-14.4-32H432c44.2 0 80 35.8 80 80v160c0 44.2-35.8 80-80 80H236zm324-224c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm-368.3 72H240c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9 85.2-80.6H272c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9-85.2 80.6zm121.9-152c14.7 0 24.4 15.2 18.2 28.5L297 216h49.4c11.9 0 21.6 9.7 21.6 21.6 0 5.9-2.4 11.6-6.7 15.7L212.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5-14.7 0-24.4-15.2-18.2-28.5L215 296h-49.4c-11.9 0-21.6-9.7-21.6-21.6 0-5.9 2.4-11.6 6.7-15.7l149.1-141.2c3.7-3.5 8.7-5.5 13.8-5.5z"
        }
    ]
};

const FalBatteryEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBatteryEmpty",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 128c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H80zM0 176c0-44.2 35.8-80 80-80h352c44.2 0 80 35.8 80 80v160c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V176zm560 16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalBatteryExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBatteryExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 96H80c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h136.6c-5.4-9.4-8.6-20.3-8.6-32H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h128V96zm224 320c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80h-96v32h96c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-96c0 11.7-3.1 22.6-8.6 32H432zm144-208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zM272 96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm24 280a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalBatteryFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBatteryFull",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 128c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h352zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zm496 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm-464-16h288c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm-48 16v96c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalBatteryHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBatteryHalf",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 128c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h352zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zm496 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm-464-16h128c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48H112z"
        }
    ]
};

const FalBatteryLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBatteryLow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 128c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h352zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zm496 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm-448 0v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0v96c0 26.5 21.5 48 48 48s48-21.5 48-48v-96c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
        }
    ]
};

const FalBatteryQuarter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBatteryQuarter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 128c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h352zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zm496 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm-464-16h32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm-48 16v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalBatterySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBatterySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM378.8 384H112c-26.5 0-48-21.5-48-48V176c0-12 4.4-22.9 11.7-31.4l-25.2-19.8C39 138.7 32 156.5 32 176v160c0 44.2 35.8 80 80 80h307.4l-40.5-32zM464 96H220.6l40.5 32H464c26.5 0 48 21.5 48 48v150l30.7 24.3c.8-4.6 1.3-9.4 1.3-14.3V176c0-44.2-35.8-80-80-80zm128 96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalBatteryThreeQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBatteryThreeQuarters",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 128c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h352zM80 96c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H80zm496 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm-464-16h192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm-48 16v96c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalBedBunk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBedBunk",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.3h512V496c0 8.8 7.2 16 16 16s16-7.2 16-16V112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32v128H32V16zm192 272v127.7H32V192h512v64H256c-17.7 0-32 14.3-32 32zm320-176v48H256V32h208c44.2 0 80 35.8 80 80zM256 288h288v127.7H256V288zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FalBedEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBedEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v416c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h576v48c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-61.9-50.1-112-112-112H32V48zm576 272H32v-96h496c44.2 0 80 35.8 80 80v16zM32 352h576v32H32v-32z"
        }
    ]
};

const FalBedFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBedFront",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96v40.6c9.4-5.4 20.3-8.6 32-8.6h112c19.1 0 36.3 8.4 48 21.7 11.7-13.3 28.9-21.7 48-21.7h112c11.7 0 22.6 3.1 32 8.6V96c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm416 96v48c19.4 14.6 32 37.8 32 64v160c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-26.2 12.6-49.4 32-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v96zm-32 33.6V192c0-17.7-14.3-32-32-32H304c-17.7 0-32 14.3-32 32v32h160c5.5 0 10.8.6 16 1.6zM240 224v-32c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v33.6c5.2-1 10.5-1.6 16-1.6h160zm240 80c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48v80h448v-80z"
        }
    ]
};

const FalBedPulse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBedPulse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M478.3 8.8 505.9 64H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H496c-6.1 0-11.6-3.4-14.3-8.8L465.6 55l-50.7 126.9c-2.3 5.9-7.9 9.8-14.2 10s-12.2-3.2-15-8.8L342.1 96H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h144c6.1 0 11.6 3.4 14.3 8.8l32.1 64.2 50.7-126.9c2.3-5.9 7.9-9.8 14.2-10s12.2 3.2 15 8.8zM304 160h34.3l16 32H304c-8.8 0-16 7.2-16 16v144h320v-80c0-44.2-35.8-80-80-80h-82.7l12.8-32H528c61.9 0 112 50.1 112 112v224c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v272h224V208c0-26.5 21.5-48 48-48zm304 256v-32H32v32h576zM192 240a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FalBed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v416c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h576v48c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-61.9-50.1-112-112-112H304c-26.5 0-48 21.5-48 48v144H32V48zm576 336H32v-32h576v32zm0-144v80H288V176c0-8.8 7.2-16 16-16h224c44.2 0 80 35.8 80 80zM96 208a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FalBee = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBee",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M219.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l31.5 31.5C215.6 73 208 91.6 208 112c0 3 .2 6 .5 8.9C185.7 105 157 96 128 96 63 96 0 140.9 0 208c0 61.9 53.6 104.9 112.9 111.2-.6-5.1-.9-10.2-.9-15.2 0-5.7.3-11.4.8-17-46.1-6.1-80.8-39.4-80.8-79 0-43.8 42.5-80 96-80 40.8 0 75.2 21.1 89.3 50.5C173.5 203.3 144 250.2 144 304c0 83.8 103.6 179.7 129.9 202.8 3.9 3.4 8.9 5.2 14.1 5.2s10.2-1.8 14.1-5.2C328.4 483.7 432 387.8 432 304c0-53.8-29.5-100.7-73.3-125.5 14-29.5 48.5-50.5 89.3-50.5 53.5 0 96 36.2 96 80 0 39.6-34.7 72.9-80.8 79 .5 5.6.8 11.3.8 17 0 5-.3 10.1-.9 15.2C522.4 312.9 576 269.9 576 208c0-67.1-63-112-128-112-29 0-57.7 9-80.5 24.9.3-2.9.5-5.9.5-8.9 0-20.4-7.6-39-20.2-53.2l31.5-31.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-34.8 34.8C311.6 34.7 300.1 32 288 32s-23.6 2.7-33.9 7.5L219.3 4.7zM288 64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM177.1 288c1.6-11.3 4.9-22.1 9.6-32h202.5c4.7 9.9 8 20.7 9.6 32H177.1zm32.5-64c20.2-19.8 47.9-32 78.4-32s58.2 12.2 78.4 32H209.6zm188.7 96c-2 10.2-5.7 20.9-10.9 32H188.5c-5.2-11.1-8.9-21.8-10.9-32h220.8zm-29 64c-5.4 8.1-11.3 16.3-17.6 24.5-2 2.6-4 5.1-6 7.5H230.3l-6-7.5c-6.4-8.1-12.3-16.3-17.6-24.5h162.6zm-52.1 64c-11.4 11.8-21.7 21.6-29.2 28.5-7.6-6.9-17.9-16.6-29.2-28.5h58.5z"
        }
    ]
};

const FalBeerMugEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBeerMugEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 64H64v352c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V64zm32 306.5V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32v32h64c35.3 0 64 28.7 64 64v102.1c0 31.8-18.8 60.6-47.9 73.3l-80.1 35zm0-242.5v207.5l67.2-29.4c17.5-7.6 28.8-24.9 28.8-44V160c0-17.7-14.3-32-32-32h-64zm-240 0c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 0c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalBeerMug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBeerMug",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0c-26.3 0-50.2 10.6-67.6 27.8 0 0-.1.1-.2.1-.2.1-.4.2-.8.2-.7.1-1.3-.1-1.6-.3C125.7 20.3 111.3 16 96 16c-44.2 0-80 35.8-80 80s35.8 80 80 80c15.3 0 29.7-4.3 41.9-11.8.3-.2.8-.4 1.6-.3.3 0 .6.1.8.2.1 0 .1.1.2.1 17.3 17.2 41.2 27.8 67.5 27.8s50.2-10.6 67.6-27.8h.2c.2-.1.4-.2.8-.2.7-.1 1.3.1 1.6.3 12.2 7.5 26.6 11.8 41.9 11.8 44.2 0 80-35.8 80-80s-35.8-80-80-80c-15.3 0-29.7 4.3-41.9 11.8-.3.2-.8.4-1.6.3-.3 0-.6-.1-.8-.2-.1 0-.1-.1-.2-.1C258.2 10.6 234.3 0 208 0zm-45 50.5C174.5 39.1 190.4 32 208 32s33.5 7.1 45 18.5c11.3 11.2 29 12.4 41.8 4.5 7.3-4.5 15.9-7.1 25.1-7.1 26.5 0 48 21.5 48 48s-21.5 48-48 48c-9.2 0-17.8-2.6-25.1-7.1-12.8-7.9-30.5-6.7-41.8 4.5-11.6 11.5-27.5 18.5-45 18.5s-33.5-7.1-45-18.5c-11.3-11.2-29-12.4-41.8-4.5-7.3 4.5-15.9 7.1-25.1 7.1-26.5 0-48-21.5-48-48s21.5-48 48-48c9.2 0 17.8 2.6 25.1 7.1 12.8 7.9 30.5 6.7 41.8-4.5zM32 187.9V448c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64v-13.5l80.1-35c29.1-12.7 47.9-41.5 47.9-73.3V272c0-44.2-35.8-80-80-80h-48v-4.1c-9.7 6.7-20.4 12-32 15.4V448c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V203.4c-11.6-3.4-22.3-8.7-32-15.4zM208 224c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zm224 0c26.5 0 48 21.5 48 48v54.1c0 19.1-11.3 36.3-28.8 44L384 399.5V224h48zm-272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V240z"
        }
    ]
};

const FalBellConcierge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBellConcierge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48.6C123.8 152.8 32 249.7 32 368v16h32v-16c0-106 86-192 192-192s192 86 192 192v16h32v-16c0-118.3-91.8-215.2-208-223.4V96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zM16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalBellExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBellExclamation",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16v16.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3 0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48c-70.7 0-128 57.3-128 128v29.1c0 52.2-20.7 102.3-57.7 139.2l-2.7 2.7c-2.3 2.3-3.6 5.4-3.6 8.7 0 6.8 5.5 12.3 12.3 12.3h359.4c6.8 0 12.3-5.5 12.3-12.3 0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2v-29c0-70.7-57.3-128-128-128zm-30.2 394.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4c-8.8 24.9-32.5 42.7-60.4 42.7s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM200 304a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm40-176v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalBellOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBellOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M606.3 8.8c4 7.9.7 17.5-7.2 21.5l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2zM304 16c0-8.8 7.2-16 16-16s16 7.2 16 16v16.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3 0 24.5-19.8 44.3-44.3 44.3H140.3C115.8 416 96 396.2 96 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8c30.9-30.9 48.3-72.8 48.3-116.6v-29c0-83 63.1-151.2 144-159.2V16zm16 48c-70.7 0-128 57.3-128 128v29.1c0 52.2-20.7 102.3-57.7 139.2l-2.8 2.8c-2.3 2.3-3.6 5.4-3.6 8.7 0 6.8 5.5 12.3 12.3 12.3h359.5c6.8 0 12.3-5.5 12.3-12.3 0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zm-30.2 394.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4c-8.8 24.9-32.5 42.7-60.4 42.7s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM0 176c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm544-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM40.8 30.3c-7.9-4-11.1-13.6-7.2-21.5S47.2-2.3 55.1 1.6l64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32z"
        }
    ]
};

const FalBellPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBellPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16v16.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3 0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48c-70.7 0-128 57.3-128 128v29.1c0 52.2-20.7 102.3-57.7 139.2l-2.7 2.7c-2.3 2.3-3.6 5.4-3.6 8.7 0 6.8 5.5 12.3 12.3 12.3h359.4c6.8 0 12.3-5.5 12.3-12.3 0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2v-29c0-70.7-57.3-128-128-128zm-30.2 394.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4c-8.8 24.9-32.5 42.7-60.4 42.7s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8zM224 160c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalBellSchoolSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBellSchoolSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 208C480 93.1 386.9 0 272 0c-45.8 0-88.1 14.8-122.5 39.9l26.3 20.7C203.4 42.5 236.5 32 272 32c97.2 0 176 78.8 176 176 0 20.8-3.6 40.8-10.3 59.4l26.3 20.7c10.3-24.7 16-51.7 16-80.1zm-384 0c0-14.9 1.8-29.3 5.3-43.1l-27.1-21.4C67.6 163.8 64 185.5 64 208c0 59 24.6 112.2 64 150.1V448c0 35.3 28.7 64 64 64h288c15.9 0 30.4-5.8 41.6-15.3L495.4 476c-4.6 2.5-9.8 4-15.4 4h-72.6c5.4-9.4 8.6-20.3 8.6-32v-34.7L384 388v60c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32v-64.7C192.3 404 230.8 416 272 416c39.8 0 77-11.2 108.6-30.6L353.5 364c-24.4 12.8-52.1 20-81.5 20-97.2 0-176-78.8-176-176zm176-80c-3.4 0-6.8.2-10.1.6l89.6 70.7c-4.3-40.1-38.2-71.3-79.5-71.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalBellSchool = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBellSchool",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 384a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm0 32c-41.2 0-79.7-12-112-32.7V448c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-64.7C287.7 404 249.2 416 208 416zm64 96H128c-35.3 0-64-28.7-64-64v-89.9C24.6 320.2 0 267 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208c0 59-24.6 112.2-64 150.1V448c0 11.7-3.1 22.6-8.6 32H416c17.7 0 32-14.3 32-32v-2.7c-18.6-6.6-32-24.4-32-45.3 0-26.5 21.5-48 48-48s48 21.5 48 48c0 20.9-13.4 38.7-32 45.3v2.7c0 35.3-28.7 64-64 64H272zm-16-304a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm336 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalBellSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBellSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M378.8 384H140.3c-6.8 0-12.3-5.5-12.3-12.3 0-3.3 1.3-6.4 3.6-8.7l2.8-2.8c33.4-33.4 53.5-77.5 57.1-124.2L160 211.2v9.9c0 43.7-17.4 85.6-48.3 116.6l-2.8 2.8c-8.3 8.3-13 19.6-13 31.3 0 24.5 19.8 44.3 44.3 44.3h279.2l-40.5-32zM304 32.8c-39.5 3.9-74.8 22.2-100.6 49.6l25.2 19.9C251.9 78.7 284.2 64 320 64c70.7 0 128 57.3 128 128v29.1c0 21.4 3.5 42.5 10.2 62.4l75.1 59.3c-.7-.8-1.5-1.7-2.3-2.5l-2.8-2.8c-30.8-30.8-48.2-72.7-48.2-116.4V192c0-83-63.1-151.2-144-159.2V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16.8zm-14.2 425.9c-2.9-8.3-12.1-12.7-20.4-9.8s-12.7 12.1-9.8 20.4c8.8 24.8 32.5 42.7 60.4 42.7s51.6-17.8 60.4-42.7c2.9-8.3-1.4-17.5-9.8-20.4s-17.5 1.4-20.4 9.8c-4.4 12.4-16.3 21.3-30.2 21.3s-25.8-8.9-30.2-21.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalBell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBell",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16v16.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3 0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48c-70.7 0-128 57.3-128 128v29.1c0 52.2-20.7 102.3-57.7 139.2l-2.7 2.7c-2.3 2.3-3.6 5.4-3.6 8.7 0 6.8 5.5 12.3 12.3 12.3h359.4c6.8 0 12.3-5.5 12.3-12.3 0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2v-29c0-70.7-57.3-128-128-128zm-30.2 394.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4c-8.8 24.9-32.5 42.7-60.4 42.7s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z"
        }
    ]
};

const FalBells = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBells",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M282.6 40.1C214 15.1 138 50.4 112.8 119l-14.6 40C84 197.8 57.6 231 23 253.7l-8.1 5.3C4.7 265.7-.8 277.5.6 289.5s9.4 22.2 20.8 26.3l230.5 83.9 1.1-3.9c2.6-9.1 4.4-18.4 5.4-27.7l-226-82.3 8.2-5.4c40.3-26.5 71.1-65.2 87.7-110.4l14.7-40c18.7-51 74.5-77.7 125.7-60.9 8.4-8.6 17.7-16.3 27.9-23-4.5-2.2-9.1-4.2-13.9-6zm8.3 183.6C270.8 169 299 108.5 353.7 88.5s115.4 8.3 135.5 63l18.8 51.1c16.3 44.6 46.4 82.8 85.9 109.2l13.7 9.2-297.5 108.3 4.6-15.8c13.1-45.6 11.3-94.1-5-138.7l-18.8-51.2zm51.9-165.3c-71.4 26-108 104.8-81.9 176.2l18.8 51.2c14 38.2 15.5 79.8 4.3 118.9l-4.6 15.8c-3.3 11.6.1 24 9 32.2s21.5 10.8 32.8 6.7l297.4-108.3c11.3-4.1 19.4-14.2 20.8-26.2s-4-23.7-14-30.4l-13.7-9.2c-33.8-22.7-59.6-55.4-73.6-93.6l-18.8-51.2c-26.1-71.3-105.2-108-176.5-82.1zm92 379.2c-6.7 5.8-7.4 15.9-1.6 22.6 17.3 19.9 45.8 27.8 71.8 17.6s41.5-35.5 40.5-61.8c-.3-8.8-7.7-15.7-16.6-15.4s-15.7 7.7-15.4 16.6c.5 13.2-7.3 25.8-20.3 30.9s-27.2 1.2-35.9-8.8c-5.8-6.7-15.9-7.4-22.6-1.6zm-254.9-30.9c-8.7 10-23 13.9-35.9 8.8s-20.7-17.7-20.3-30.9c.3-8.8-6.6-16.2-15.4-16.6s-16.2 6.6-16.6 15.4c-.9 26.3 14.6 51.6 40.5 61.8s54.5 2.3 71.8-17.6c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6z"
        }
    ]
};

const FalBenchTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBenchTree",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.2 106.1c-1.9 11.9 3.1 23.9 12.9 30.9 12.1 8.8 19.9 23 19.9 39 0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48 0-16 7.8-30.2 19.9-38.9 9.8-7.1 14.7-19 12.9-30.9-.5-3.3-.8-6.7-.8-10.1 0-35.3 28.7-64 64-64s64 28.7 64 64c0 3.5-.3 6.8-.8 10.1zm31.6 5c.8-4.9 1.2-10 1.2-15.1 0-53-43-96-96-96s-96 43-96 96c0 5.1.4 10.2 1.2 15.1-20.1 14.6-33.2 38.2-33.2 64.9 0 44.2 35.8 80 80 80h32v240c0 8.8 7.2 16 16 16s16-7.2 16-16V256h32c44.2 0 80-35.8 80-80 0-26.7-13.1-50.3-33.2-64.9zM64 224h256v64H64v-64zm0 96v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h256v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32zm224 0v48H96v-48h192z"
        }
    ]
};

const FalBezierCurve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBezierCurve",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h64zm83.4 64H514c7.1 27.6 32.2 48 62 48 35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H400V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v16H126c-7.1-27.6-32.2-48-62-48-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h78.6C139.5 167.2 96 238.5 96 320H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-16c0-77.5 45.9-144.3 112-174.6.7 25.9 21.9 46.6 48 46.6h64c26 0 47.2-20.7 48-46.6 66.1 30.3 112 97.1 112 174.6h-16c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-16c0-81.5-43.5-152.8-108.6-192zM544 352h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h48zm-416 0h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h48zM32 112a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm512 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FalBicycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBicycle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h38.3l50.5 96H223.5l-33.7-56.2c-2.9-4.8-8.1-7.8-13.7-7.8H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h54.9l30.1 50.2-26.5 53.1c-13.3-4.7-27.6-7.2-42.5-7.2C57.3 224 0 281.3 0 352s57.3 128 128 128c65.3 0 119.1-48.9 127-112h65c5.9 0 11.2-3.2 14-8.3l83.4-152.9 21.2 40.3c-33 23.1-54.6 61.5-54.6 104.9 0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-15.8 0-31 2.9-45 8.1L368.4 44.8c-4.1-7.9-12.3-12.8-21.2-12.8H304zm149.8 243.7 44.1 83.8c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6l-44.1-83.8c9.4-3.1 19.5-4.8 29.9-4.8 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-31.1 14.8-58.8 37.8-76.3zM156 260.2l-40 80.1c-6.4 12.8 2.9 27.8 17.2 27.8h89.5c-7.6 45.4-47.1 80-94.7 80-53 0-96-43-96-96s43-96 96-96c9.8 0 19.2 1.5 28 4.2zm-2.1 75.8 62.7-125.3L291.7 336H153.9zm88.8-144H389l-69.7 127.8L242.7 192z"
        }
    ]
};

const FalBillboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBillboard",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H240V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H80c-26.5 0-48 21.5-48 48v272H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h288v104c0 8.8 7.2 16 16 16s16-7.2 16-16V384h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V80c0-26.5-21.5-48-48-48H432V16zM320 352H64V80c0-8.8 7.2-16 16-16h128v64h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V64h160v64h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V64h128c8.8 0 16 7.2 16 16v272H320z"
        }
    ]
};

const FalBinBottlesRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBinBottlesRecycle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 16c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm-32 176c0-28.1-12.1-53.4-31.4-71-17.1-15.5-39.7-25-64.6-25H128c-53 0-96 43-96 96h32c0-35.3 28.7-64 64-64h128c35.3 0 64 28.7 64 64h32zm223.1 0c-1.2-9.7-4.6-18.7-9.6-26.5 6.4-9.5 10.1-21 10.1-33.3 0-23.2-13.4-44.3-34.4-54.2L528 71.8c-11-5.1-23-7.8-35.1-7.8h-90.6c-12.1 0-24.1 2.7-35.1 7.8L354.1 78c-7.2 3.4-13.5 8-18.6 13.6 8.4 6.7 16 14.4 22.5 22.9 2.6-3.2 5.9-5.8 9.7-7.6l13.2-6.2c6.7-3.2 14.1-4.8 21.5-4.8H493c7.4 0 14.8 1.6 21.5 4.8l13.1 6.2c9.8 4.6 16 14.4 16 25.2 0 5.8-1.7 11.1-4.7 15.5-7.1 10.6-7.2 24.4-.4 35.1 1.8 2.8 3.2 5.9 4 9.2H575zm21.2 32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h17.9l21.8 185.3c4.7 40.3 38.9 70.7 79.5 70.7h369.7c40.6 0 74.7-30.4 79.5-70.7L606.1 256H624c8.8 0 16-7.2 16-16s-7.2-16-16-16h-27.7zM87.5 437.6 66.1 256h507.8l-21.4 181.6c-2.8 24.2-23.3 42.4-47.7 42.4H135.1c-24.3 0-44.8-18.2-47.7-42.4zM319.9 320c4.6 0 9 2.3 11.5 6.2l8.5 12.9c4.8 7.3 14.5 9.4 21.8 4.8 7.6-4.8 9.8-14.9 4.9-22.4l-8.5-12.9c-8.5-12.9-22.8-20.6-38.2-20.6-15.3 0-29.6 7.7-38.1 20.4l-7.6 11.4c-5 7.5-2.8 17.7 4.8 22.4 7.3 4.6 17 2.5 21.8-4.7l7.6-11.4c2.6-3.8 6.9-6.1 11.5-6.1zm-59.4 48.4c-7.3-4.6-17-2.5-21.8 4.7l-7.9 11.9c-4.4 6.7-6.8 14.5-6.8 22.5 0 22.4 18.2 40.6 40.6 40.6h25.2c8.8 0 16-7.2 16-16s-7.2-16-16-16h-25.2c-4.7 0-8.6-3.8-8.6-8.6 0-1.7.5-3.3 1.4-4.7l7.9-11.9c5-7.5 2.8-17.7-4.8-22.4zm77.2 63.6c0 8.8 7.2 16 16 16h20.9c22.4 0 40.6-18.2 40.6-40.6 0-7.9-2.3-15.7-6.7-22.4l-6.6-10.1c-4.8-7.3-14.5-9.4-21.8-4.8-7.6 4.8-9.8 14.9-4.9 22.4l6.6 10.1c.9 1.4 1.4 3.1 1.4 4.7 0 4.8-3.9 8.6-8.6 8.6h-20.9c-8.8 0-16 7.2-16 16zM160 0c-17.7 0-32 14.3-32 32-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16V32h64v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16c0-17.7-14.3-32-32-32h-64z"
        }
    ]
};

const FalBinBottles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBinBottles",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 16c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm-32 176h-32c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64H32c0-53 43-96 96-96h128c24.9 0 47.6 9.5 64.6 25 19.3 17.6 31.4 42.9 31.4 71zm223.1 0h-32.5c-.9-3.3-2.2-6.4-4-9.2-6.9-10.7-6.8-24.5.4-35.1 3-4.4 4.7-9.7 4.7-15.5 0-10.8-6.2-20.6-16-25.2l-13.1-6.2c-6.7-3.2-14.1-4.8-21.5-4.8h-90.8c-7.4 0-14.8 1.6-21.5 4.8l-13.2 6.2c-3.8 1.8-7.1 4.4-9.7 7.6-6.5-8.5-14.1-16.2-22.5-22.9 5.2-5.6 11.5-10.3 18.6-13.6l13.2-6.2c11-5.1 23-7.8 35.1-7.8h90.6C505 64 517 66.7 528 71.8l13.2 6.2c21 9.9 34.4 31 34.4 54.2 0 12.3-3.7 23.8-10.1 33.3 5 7.8 8.4 16.9 9.6 26.5zm2.6 32H624c8.8 0 16 7.2 16 16s-7.2 16-16 16h-17.9l-21.8 185.3c-4.7 40.3-38.9 70.7-79.5 70.7H135.1c-40.6 0-74.7-30.4-79.5-70.7L33.9 256H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h561.7zM66.1 256l21.4 181.6c2.8 24.2 23.3 42.4 47.7 42.4h369.7c24.3 0 44.8-18.2 47.7-42.4L573.9 256H66.1zM160 0h64c17.7 0 32 14.3 32 32 8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V32h-64v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FalBinRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBinRecycle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M536 64c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h496zM0 88c0 20.3 15.1 37 34.6 39.6v.4l24.5 293.3c2.8 33.2 30.5 58.7 63.8 58.7h330.2c33.3 0 61-25.5 63.8-58.7L541.3 128v-.4C560.9 125 576 108.3 576 88V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v16zm91 330.7L66.8 128h442.4L485 418.7c-1.4 16.6-15.2 29.3-31.9 29.3H122.9c-16.6 0-30.5-12.8-31.9-29.3zM288 192c5 0 9.7 2.4 12.6 6.4l31 42.1c5 6.7 14.3 8.5 21.4 4.1 7.9-4.9 9.9-15.6 4.4-23.1l-31-42.1c-9-12.2-23.2-19.4-38.4-19.4s-29.4 7.2-38.4 19.4l-31 42.1c-5.5 7.5-3.5 18.1 4.4 23.1 7.1 4.4 16.4 2.7 21.4-4.1l31-42.1c3-4 7.6-6.4 12.6-6.4zm-86.1 77.1c-7.1-4.4-16.4-2.7-21.4 4.1L153 310.5c-5.8 7.9-9 17.5-9 27.4 0 25.5 20.6 46.1 46.1 46.1H256c8.8 0 16-7.2 16-16s-7.2-16-16-16h-65.9c-7.8 0-14.1-6.3-14.1-14.1 0-3 1-5.9 2.8-8.4l27.6-37.4c5.5-7.5 3.5-18.1-4.4-23.1zM304 368c0 8.8 7.2 16 16 16h65.9c25.5 0 46.1-20.6 46.1-46.1 0-9.8-3.1-19.4-9-27.4l-27.6-37.4c-5-6.7-14.3-8.5-21.4-4.1-7.9 4.9-9.9 15.6-4.4 23.1l27.6 37.4c1.8 2.4 2.7 5.4 2.7 8.4 0 7.8-6.3 14.1-14.1 14.1H320c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalBinaryCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBinaryCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 16c0-5.1-2.5-10-6.6-13S303.9-.8 299 .8l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V16zM96 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V304zM0 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80C35.8 0 0 35.8 0 80zm80-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm192 256c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h32c24 0 45.6-10.6 60.2-27.3-7.4-8.3-14-17.3-19.7-27C336 471.1 321.1 480 304 480h-32c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h32c7.6 0 14.9 1.8 21.3 5 2.6-10.5 6.2-20.7 10.7-30.3-9.8-4.3-20.6-6.6-32-6.6h-32zm224-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalBinaryLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBinaryLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M313.4 3c-4.2-3-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V16c0-5.1-2.5-10-6.6-13zm-224 288c-4.2-3-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V304c0-5.1-2.5-10-6.6-13zM80 0C35.8 0 0 35.8 0 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80zM32 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zm160 288v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80v-64c0-44.2-35.8-80-80-80h-32c-44.2 0-80 35.8-80 80zm80-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zm256-96c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80h160v128H448V352z"
        }
    ]
};

const FalBinarySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBinarySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 16c0-5.1-2.5-10-6.6-13S431.9-.8 427 .8l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192h-48c-6.3 0-11.8 3.7-14.4 9l29.1 23H496c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V16zM320 144V80c0-44.2-35.8-80-80-80h-32c-27.2 0-51.2 13.5-65.6 34.2l25.2 19.9C176.1 40.8 191 32 208 32h32c26.5 0 48 21.5 48 48v64c0 1.7-.1 3.4-.3 5l27.6 21.8c3-8.4 4.6-17.4 4.6-26.8zm0 224v64c0 44.2 35.8 80 80 80h32c27.2 0 51.2-13.5 65.6-34.2l-25.2-19.9C463.9 471.2 449 480 432 480h-32c-26.5 0-48-21.5-48-48v-64c0-1.7.1-3.4.3-5l-27.6-21.8c-3 8.4-4.6 17.4-4.6 26.8zm-96-64c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V304zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBinary",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 16c0-5.1-2.5-10-6.6-13S303.9-.8 299 .8l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V192h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V16zM96 304c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V304zM0 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80C35.8 0 0 35.8 0 80zm80-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm192 256c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80v-64c0-44.2-35.8-80-80-80h-32zm-48 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-64z"
        }
    ]
};

const FalBinoculars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBinoculars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zM192 432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-75.1c0-28.8 7.8-57.1 22.7-81.9 16-26.6 26.2-56.3 30.1-87.1l5.7-45.9c1-8 7.8-14 15.9-14H192v304zm32 0V288h64v144c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48v-75.1c0-34.6-9.4-68.6-27.2-98.3-13.7-22.8-22.5-48.2-25.8-74.6l-5.7-46c-3-24-23.4-42-47.6-42H312c-13.3 0-24 10.7-24 24v8h-64v-8c0-13.3-10.7-24-24-24h-93.6c-24.2 0-44.6 18-47.6 42L53 184c-3.3 26.4-12.1 51.8-25.8 74.6C9.4 288.3 0 322.3 0 356.9V432c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48zm0-176v-96h64v96h-64zm96 16V128h85.6c8.1 0 14.9 6 15.9 14l5.7 45.9c3.9 30.8 14.1 60.5 30.1 87.1 14.8 24.7 22.7 53 22.7 81.9V432c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16V272z"
        }
    ]
};

const FalBiohazard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBiohazard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M147.2 6.4c3-4 7.8-6.4 12.8-6.4h.9c4.6 0 8.9 1.9 11.9 5.3s4.5 7.9 4 12.4c-3.5 30.8 4.4 62.5 22.7 86.3 18 23.3 47 40 88.5 40s70.4-16.6 88.5-40c18.4-23.7 26.2-55.5 22.7-86.3-.5-4.5.9-9.1 4-12.4S410.6 0 415.1 0h.9c5 0 9.8 2.4 12.8 6.4C450.9 35.8 464 72.4 464 112c0 18.6-2.9 36.5-8.2 53.3 15.5 3.9 30.6 10 45.1 18.3 34.3 19.8 59.4 49.4 73.9 83.3 2 4.6 1.7 9.9-.9 14.3l-.5.8c-2.3 3.9-6.1 6.7-10.6 7.7s-9.1-.1-12.8-2.8c-24.9-18.4-56.3-27.5-86.1-23.4-29.2 4-58.1 20.7-78.8 56.6s-20.8 69.3-9.6 96.6c11.4 27.8 35 50.4 63.3 62.8 4.2 1.8 7.4 5.3 8.8 9.7s.9 9.1-1.3 13l-.5.8c-2.5 4.4-6.9 7.3-11.9 7.9-36.5 4.4-74.8-2.5-109.1-22.3-13.8-8-26.1-17.5-36.9-28.3-10.7 10.8-23.1 20.4-36.9 28.3-34.3 19.8-72.5 26.8-109.1 22.3-5-.6-9.4-3.5-11.9-7.9l-.5-.8c-2.3-3.9-2.8-8.7-1.3-13s4.6-7.8 8.8-9.7c28.4-12.4 51.9-35 63.3-62.8 11.2-27.3 11.1-60.7-9.6-96.6s-49.6-52.7-78.8-56.6c-29.8-4-61.1 5.1-86.1 23.4-3.7 2.7-8.3 3.7-12.8 2.8S4.7 286 2.4 282l-.5-.8c-2.5-4.4-2.8-9.6-.9-14.3 14.4-33.8 39.6-63.5 73.9-83.3 14.5-8.3 29.6-14.4 45.1-18.3-5.3-16.8-8.2-34.7-8.2-53.3 0-39.6 13.1-76.2 35.2-105.6zm2.2 66.5c-3.5 12.4-5.4 25.5-5.4 39.1 0 21 4.5 40.9 12.5 58.8 2.1 4.6 1.8 9.9-.6 14.3s-6.9 7.4-11.9 8.1c-18.1 2.4-36.1 8.3-52.9 18.1-11.7 6.8-22.1 15-31.1 24.2 18.2-4.9 37.4-6.4 56.3-3.8 39.4 5.3 76.8 28.2 102.3 72.3s26.6 87.9 11.5 124.7c-7.3 17.7-18.1 33.5-31.5 46.9 12.5-3.2 24.8-8.1 36.5-14.9 16-9.2 29.5-21 40.4-34.6 3-3.8 7.6-6 12.5-6s9.4 2.2 12.5 6c10.9 13.5 24.4 25.4 40.4 34.6 11.7 6.8 24 11.7 36.5 14.9-13.3-13.3-24.2-29.2-31.5-46.9-15.1-36.8-14-80.6 11.5-124.7s62.9-67 102.3-72.3c19-2.6 38.1-1.1 56.3 3.8-9-9.2-19.4-17.4-31.2-24.2-16.8-9.7-34.8-15.6-52.9-18.1-5-.7-9.4-3.7-11.9-8.1s-2.7-9.7-.6-14.3c8-17.9 12.5-37.9 12.5-58.9 0-13.6-1.9-26.7-5.4-39.1-4.9 18.2-13.1 35.5-24.9 50.7C377.5 155.1 339 176 288 176s-89.5-20.9-113.8-52.4c-11.7-15.1-20-32.5-24.9-50.7zm5.1 358.6c-40.1-33.6-67.4-82.1-73.3-136.9 9-1.8 18.1-2.2 26.7-1.1 1.8.2 3.7.6 5.5 1 5.6 43.9 27.3 82.7 59 110.3l-.1.3c-3.9 9.6-10.1 18.6-17.9 26.4zM288 96c-15.9 0-31.3 2.1-45.9 6.1-7.6-4.6-13.7-10.4-18.5-16.6-2.2-2.9-4.2-6-6.1-9.2 22-8 45.8-12.3 70.5-12.3s48.5 4.3 70.5 12.2c-1.8 3.2-3.8 6.3-6.1 9.2-4.8 6.2-10.9 12-18.5 16.6-14.6-3.9-30-6.1-45.9-6.1zm174.6 198.5c1.8-.4 3.7-.7 5.5-1 8.6-1.2 17.7-.8 26.7 1.1-5.9 54.9-33.2 103.3-73.3 136.9-7.8-7.8-13.9-16.8-17.9-26.4l-.1-.3c31.7-27.6 53.5-66.4 59.1-110.3zM288 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalBird = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBird",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 192h160c35.3 0 64-28.7 64-64v-24c0-39.8 32.2-72 72-72s72 32.2 72 72v96c0 101.6-82.4 184-184 184S32 301.6 32 200v-8zm-32-3.6V200c0 106.2 76.7 194.6 177.8 212.6l48.1 90.9c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6L215.8 416h.2c19.3 0 37.9-2.5 55.7-7.3l50.2 94.7c4.1 7.8 13.8 10.8 21.6 6.7s10.8-13.8 6.7-21.6l-47.9-90.4C378.6 364.8 432 288.6 432 200v-14.9l72.2-43.3c4.8-2.9 7.8-8.1 7.8-13.7s-2.9-10.8-7.8-13.7l-79-47.6C410.2 27.8 372.3 0 328 0c-57.4 0-104 46.6-104 104v24c0 17.7-14.3 32-32 32H28.4C12.7 160 0 172.7 0 188.4zM464.9 128 432 147.7v-39.4l32.9 19.7zM328 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalBitcoinSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBitcoinSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48.3c53.7 4.1 96 49 96 103.7 0 31.3-13.9 59.4-35.8 78.5 39.6 14.7 67.8 52.8 67.8 97.5 0 57.4-46.6 104-104 104h-24v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H96v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H41.7C18.7 448 0 429.3 0 406.3V101.6C0 80.8 16.8 64 37.6 64H64V16zm112 400h40c39.8 0 72-32.2 72-72s-32.2-72-72-72H32v134.3c0 5.4 4.4 9.7 9.7 9.7H176zm0-320H37.6c-3.1 0-5.6 2.5-5.6 5.6V240h152c39.8 0 72-32.2 72-72s-32.2-72-72-72h-8z"
        }
    ]
};

const FalBlanketFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlanketFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v41c9.4-6.9 20.9-9.8 32-8.8V96c0-53-43-96-96-96H96C43 0 0 43 0 96v256c0 53 43 96 96 96h218.4c-5.9-10.1-10.9-20.9-14.9-32H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h205.8c4.4-10.9 9.7-21.6 15.5-32H96c-24.6 0-47 9.2-64 24.4V96zm256 254.1c0-4.6.3-9.3.8-14.1H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h192.8c-.5-5.9-.8-11.9-.8-17.9zm221.4-96.6c9.6-.1 18.7-4.5 24.7-12.1 3.9-4.9 7.8-9.6 11.6-14 16.4 17.8 30.9 39.4 41.8 60.5C601 314 608 339.4 608 352.2c0 70.2-57 127.8-128 127.8-71.8 0-128-57.5-128-127.8 0-17.9 9.4-46.2 27.6-75.8 15.9-25.8 37.9-53.1 64-78.1 14.3 13.7 27.9 28.3 40.8 43.7 6.2 7.4 15.3 11.6 25 11.5zm-21.8-56.4c-10.9-11.6-22.2-22.8-34-33.4-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 87.9 70.3 160 160 160 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-1.8 1.6-3.5 3.3-5.2 5-7.7 7.7-14.8 16.4-21.2 24.5-7-8.4-14.1-16.5-21.5-24.4zM445.1 256c-4.8 0-9.4 2.2-12.5 5.9-14.9 18.4-26.9 33.8-35.1 47.9C389 324.3 384 338.3 384 354c0 28.7 10.7 52.6 28.8 69.2 18 16.5 42.3 24.8 68.2 24.8 21.3 0 40.3-6 57.9-17.7l.3-.2c37.3-26.1 46.3-77.2 25-116.5v-.1c-1.9-3.9-4.5-9-8.3-14.1-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5-12.4 8.2-25.3 12.2-40 12.2-19.1 0-35.3-6.1-46.6-16.4-11.1-10.2-18.4-25.3-18.4-45.6 0-8.3 2.5-16.8 9.1-28.1 4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.4 1.8 2.4.5.6.1.2L507 351l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"
        }
    ]
};

const FalBlanket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlanket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 128v184.4C49 297.2 71.4 288 96 288h296c8.6 0 16.7 1.9 24 5.4V128c0-35.3-28.7-64-64-64H96c-35.3 0-64 28.7-64 64zM0 384V128c0-53 43-96 96-96h256c53 0 96 43 96 96v216c0 30.9-25.1 56-56 56H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h296c13.3 0 24-10.7 24-24s-10.7-24-24-24H96c-35.3 0-64 28.7-64 64s28.7 64 64 64h336c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-53 0-96-43-96-96z"
        }
    ]
};

const FalBlenderPhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlenderPhone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M226.8 32H535l-16 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h143l-16 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h119l-32 128H253.4L226.8 32zm260.3 323.4 79-315.6C571.1 19.6 555.8 0 535 0H226.8c-18.7 0-33.4 16-31.9 34.7l26.6 319.5c-35.3 8.3-61.5 40-61.5 77.9v32c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V432c0-36.1-24-66.7-56.9-76.6zM240 384h224c26.5 0 48 21.5 48 48v32c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16v-32c0-26.5 21.5-48 48-48zm136 48a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM120.1 116.7 95 114.2c-15.5-1.5-29.9 8.4-34 23.5-9.6 35.5-9.6 73 0 108.6 4.1 15.1 18.5 25 34 23.5l25.1-2.5 21.8 53.5L96.3 350c-85.7-88.5-85.7-227.5 0-316l45.6 29.2-21.8 53.5zm45-76.6L108.4 3.8C99-2.2 86-.9 78.1 6.8-26 109.1-26 274.9 78.1 377.2c7.9 7.8 20.9 9.1 30.3 3.1l56.7-36.4c9.6-6.1 13.4-17.9 9.2-28.3l-26.9-66.1c-3.9-9.7-13.9-15.6-24.5-14.6l-31.1 3c-8.2-30-8.2-61.8 0-91.8l31 3c10.6 1 20.5-4.9 24.5-14.6l26.9-66.1c4.2-10.4.4-22.2-9.2-28.3z"
        }
    ]
};

const FalBlender = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlender",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 72C0 32.2 32.2 0 72 0h399c20.8 0 36.1 19.6 31 39.8l-78.9 315.6C456 365.3 480 395.9 480 432v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48v-32c0-37.8 26.2-69.5 61.5-77.9L148 240H72c-39.8 0-72-32.2-72-72V72zm128 360v32c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16v-32c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm295-208H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h127l16-64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h151l16-64H162.8l26.7 320H391l32-128zM72 32c-22.1 0-40 17.9-40 40v96c0 22.1 17.9 40 40 40h73.3L130.7 32H72zm216 376a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalBlindsOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlindsOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32v32c0 17.7 14.3 32 32 32h96v162.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V96h320c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm0 32h448v32H32V32zm96 272a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v-32H16zm176 32h304c8.8 0 16-7.2 16-16s-7.2-16-16-16H192v32zM0 496c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16-176c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c-7-9.3-12-20.2-14.4-32H16zm480 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H222.4c-2.4 11.8-7.4 22.7-14.4 32h288z"
        }
    ]
};

const FalBlindsRaised = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlindsRaised",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32v32c0 17.7 14.3 32 32 32h96v322.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V96h320c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm0 32h448v32H32V32zm96 432a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM35.9 160l9.8-32H12.3L.9 165c-.6 2-.9 4.1-.9 6.1C0 182.7 9.3 192 20.9 192H96v-32H35.9zm0 96 9.8-32H12.3L.9 261c-.6 2-.9 4.1-.9 6.1C0 278.7 9.3 288 20.9 288H96v-32H35.9zm156.1 0v32h299.1c11.5 0 20.9-9.3 20.9-20.9 0-2.1-.3-4.1-.9-6.1l-11.4-37h-33.5l9.8 32H192zm0-96v32h299.1c11.5 0 20.9-9.3 20.9-20.9 0-2.1-.3-4.1-.9-6.1l-11.4-37h-33.5l9.8 32H192z"
        }
    ]
};

const FalBlinds = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlinds",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32C0 14.3 14.3 0 32 0h448c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H160v162.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V96H32C14.3 96 0 81.7 0 64V32zm480 0H32v32h448V32zM96 192v32H20.9C9.3 224 0 214.7 0 203.1c0-2.1.3-4.1.9-6.1l21.2-69h33.5l-19.7 64H96zm96 32v-32h284.1l-19.7-64h33.5l21.2 69c.6 2 .9 4.1.9 6.1 0 11.5-9.3 20.9-20.9 20.9H192zM65.6 288c-1 5.2-1.6 10.5-1.6 16s.6 10.8 1.6 16H20.9C9.3 320 0 310.7 0 299.1c0-2.1.3-4.1.9-6.1l11.4-37h33.5L36 288h29.6zm156.8 32c1-5.2 1.6-10.5 1.6-16s-.6-10.8-1.6-16h253.7l-9.8-32h33.5l11.4 37c.6 2 .9 4.1.9 6.1 0 11.5-9.3 20.9-20.9 20.9H222.4zM144 384h332.1l-9.8-32h33.5l11.4 37c.6 2 .9 4.1.9 6.1 0 11.5-9.3 20.9-20.9 20.9H20.9C9.3 416 0 406.7 0 395.1c0-2.1.3-4.1.9-6.1l11.4-37h33.5L36 384h108zm322.2 64h33.5l11.4 37c.6 2 .9 4.1.9 6.1 0 11.5-9.3 20.9-20.9 20.9H20.9C9.3 512 0 502.7 0 491.1c0-2.1.3-4.1.9-6.1l11.4-37h33.5L36 480h440.1l-9.8-32zM144 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalBlockBrickFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlockBrickFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 64v64h176V64H168zm-32 0H96c-17.7 0-32 14.3-32 32v32h72V64zm-72 96v80h176v-80H64zm0 192h72v-80H64v80zm0 32v32c0 17.7 14.3 32 32 32h144v-64H64zm104-32h120c.1 10.9 1.1 21.6 3 32h-19v64h42.4c6.6 11.4 14.4 22.2 23.2 32H96c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v48.6c-1.7-1.5-3.3-3.1-5-4.6-7.7-7-17.2-10.9-27-11.8V96c0-17.7-14.3-32-32-32h-40v96H272v80h54.9c-.6.9-1.1 1.8-1.7 2.7-5.8 9.5-11.3 19.3-16.2 29.3H168v80zm341.4-98.5c-9.6.1-18.8-4.1-25-11.5-12.9-15.5-26.5-30-40.8-43.7-26.1 25-48 52.3-64 78.1-18.3 29.6-27.6 57.9-27.6 75.8 0 70.3 56.2 127.8 128 127.8 71 0 128-57.6 128-127.8 0-12.8-7-38.2-20.6-64.3-10.9-21.1-25.4-42.6-41.8-60.5-3.8 4.4-7.7 9.1-11.6 14-6 7.5-15.1 12-24.7 12.1zm-21.8-56.4c7.4 7.9 14.5 16 21.5 24.4 6.4-8.1 13.6-16.8 21.2-24.5 1.7-1.7 3.5-3.4 5.2-5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C640 440 568.7 512 480 512c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8 11.8 10.6 23.1 21.7 34 33.4zM445.1 256c4.8 0 9.4 2.2 12.4 6 2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1v.1c21.3 39.3 12.3 90.4-25 116.5l-.3.2C521.3 442 502.3 448 481 448c-25.9 0-50.2-8.4-68.2-24.8-18.1-16.6-28.8-40.5-28.8-69.2 0-15.7 5-29.7 13.4-44.2 8.2-14.1 20.2-29.5 35.1-47.9 3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L507 351l-12.6 9.9-.1-.2-.5-.6-1.8-2.4-6.6-8.4-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2-6.6 11.3-9.1 19.8-9.1 28.1 0 20.3 7.3 35.4 18.4 45.6 11.2 10.2 27.4 16.3 46.5 16.3 14.7 0 27.6-4 40-12.2 20.1-14.2 27.8-41.8 18.9-66.5z"
        }
    ]
};

const FalBlockBrick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlockBrick",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 64v64h176V64H136zm-32 0H64c-17.7 0-32 14.3-32 32v32h72V64zm-72 96v80h176v-80H32zm0 192h72v-80H32v80zm0 32v32c0 17.7 14.3 32 32 32h144v-64H32zm104-32h176v-80H136v80zm208 0h72v-80h-72v80zm72 32H240v64h144c17.7 0 32-14.3 32-32v-32zm0-224H240v80h176v-80zm0-32V96c0-17.7-14.3-32-32-32h-40v64h72zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalBlockQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlockQuestion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM88 368a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm248 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM136.7 177.8c6.5-24.6 28.7-41.8 54.2-41.8H248c35.5 0 64 29 64 64.3 0 24-13.4 46.2-34.9 57.2L240 276.3V296c0 8.8-7.2 16-16 16s-16-7.2-16-16v-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7 0-17.8-14.4-32.3-32-32.3h-57.1c-10.9 0-20.5 7.4-23.2 17.9l-.2.7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM200 360a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalBlockQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlockQuote",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 80C7.2 80 0 87.2 0 96s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm128 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm-16 176c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM0 432c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16s-16 7.2-16 16v192z"
        }
    ]
};

const FalBlock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlock",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 88a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 392a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalBlog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlog",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240 107.5 240 240 0 8.8 7.2 16 16 16s16-7.2 16-16c0-150.2-121.8-272-272-272zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c79.5 0 144 64.5 144 144 0 8.8 7.2 16 16 16s16-7.2 16-16c0-97.2-78.8-176-176-176zm-176-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v248c0 79.5 64.5 144 144 144s144-64.5 144-144-64.5-144-144-144h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c61.9 0 112 50.1 112 112s-50.1 112-112 112S32 429.9 32 368V120z"
        }
    ]
};

const FalBlueberries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBlueberries",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M382.7 312.3C439.3 292.9 480 239.2 480 176c0-79.5-64.5-144-144-144-63.2 0-116.9 40.7-136.3 97.3-7.8-.9-15.7-1.3-23.7-1.3-3.2 0-6.3.1-9.4.2C187.4 54.2 255.4 0 336 0c97.2 0 176 78.8 176 176 0 80.6-54.2 148.6-128.2 169.4.1-3.1.2-6.3.2-9.4 0-8-.5-15.9-1.3-23.7zM320 336a144 144 0 1 0-288 0 144 144 0 1 0 288 0zM0 336a176 176 0 1 1 352 0 176 176 0 1 1-352 0zm176-96v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zM368 80v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalBluetooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBluetooth",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M185.4 1.4c5.7-2.6 12.5-1.5 17.2 2.6l144 128c3.6 3.2 5.5 7.7 5.4 12.5s-2.4 9.2-6.2 12.1L218.1 256l127.8 99.4c3.8 2.9 6 7.4 6.2 12.1s-1.8 9.3-5.4 12.5l-144 128c-4.7 4.2-11.4 5.2-17.2 2.6s-9.4-8.3-9.4-14.6V288.7L57.8 380.6c-7 5.4-17 4.2-22.5-2.8s-4.2-17 2.8-22.5L165.9 256 38.2 156.6c-7-5.4-8.2-15.5-2.8-22.5s15.5-8.2 22.5-2.8l118.1 92V16c0-6.3 3.7-12 9.4-14.6zM208 288.7v171.7l103-91.6-103-80.1zm0-65.4 103-80.1-103-91.6v171.7z"
        }
    ]
};

const FalBold = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBold",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h216c66.3 0 120 53.7 120 120 0 38.8-18.4 73.3-46.9 95.2C351.1 264 384 308.1 384 360c0 66.3-53.7 120-120 120H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V64H16C7.2 64 0 56.8 0 48zm64 400h200c48.6 0 88-39.4 88-88s-39.4-88-88-88H64v176zm0-208h168c48.6 0 88-39.4 88-88s-39.4-88-88-88H64v176z"
        }
    ]
};

const FalBoltAuto = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoltAuto",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M291.4 0c-6.1 0-12 2.2-16.5 6.3L8.7 242.9C3.2 247.8 0 254.8 0 262.2 0 276.4 11.6 288 25.8 288h111.5L69.2 478.7c-5.8 16.2 6.2 33.3 23.4 33.3 6.1 0 11.9-2.2 16.5-6.2l265.8-234.5c5.8-5.1 9.1-12.5 9.1-20.3 0-14.9-12.1-27-27-27H246.7l68.1-190.7C320.6 17.1 308.6 0 291.4 0zM42.1 256 275.3 48.7l-66.4 186c-1.8 4.9-1 10.3 2 14.6s7.9 6.8 13.1 6.8h119.8L108.6 463.6l66.5-186.2c1.8-4.9 1-10.3-2-14.6s-7.9-6.8-13.1-6.8H42.1zM464 288c-6.1 0-11.6 3.4-14.3 8.8l-96 192c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l19.5-39.1h124.2l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-96-192c-2.7-5.4-8.2-8.8-14.3-8.8zm0 51.8 46.1 92.2h-92.2l46.1-92.2z"
        }
    ]
};

const FalBoltLightning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoltLightning",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 30.9C32 13.8 45.9 0 62.9 0h163.3C242.7 0 256 13.3 256 29.8c0 3.2-.5 6.4-1.5 9.4L214.2 160h141.6c15.6 0 28.2 12.6 28.2 28.2 0 5.7-1.7 11.2-4.9 15.9l-203.2 297c-4.6 6.8-12.3 10.8-20.5 10.8-16.2 0-28-15.2-24.1-30.9l48.2-193H30.9C13.9 288 0 274.1 0 257.1c0-1.5.1-2.9.3-4.4L32 30.9zM64 32c0 1.1-.1 2.2-.3 3.3L32.2 256H200c4.9 0 9.6 2.3 12.6 6.2s4.1 8.9 2.9 13.7l-43.6 174.3L348.6 192H192c-5.1 0-10-2.5-13-6.6s-3.8-9.5-2.2-14.4l46.3-139H64z"
        }
    ]
};

const FalBoltSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoltSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M351.4 362.3 236.6 463.6 290 313.9 263.5 293l-66.3 185.7c-5.8 16.2 6.2 33.3 23.5 33.3 6.1 0 11.9-2.2 16.5-6.2l139.7-123.4-25.5-20.2zM216.7 256h-46.6l21.9-19.5-25.5-20.1-29.8 26.5c-5.5 4.9-8.7 11.9-8.7 19.3 0 14.3 11.6 25.8 25.8 25.8h103.4l-40.5-32zm72.5-105.9L403.3 48.7 350 198.1l26.5 20.9 66.3-185.7C448.6 17.1 436.6 0 419.4 0c-6.1 0-12 2.2-16.5 6.3L263.7 130l25.5 20.1zM485 224H382.8l40.5 32h48.5l-22.9 20.2 25.5 20.2 28.4-25.1c5.8-5.1 9.1-12.5 9.1-20.3 0-14.9-12.1-27-27-27zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBolt",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M306.8 6.3c4.6-4.1 10.5-6.3 16.6-6.3 17.2 0 29.2 17.1 23.4 33.3L278.7 224H389c14.9 0 27 12.1 27 27 0 7.8-3.3 15.1-9.1 20.3L141.1 505.8c-4.5 4-10.4 6.2-16.5 6.2-17.2 0-29.2-17.1-23.5-33.3L169.3 288H57.8C43.6 288 32 276.4 32 262.2c0-7.4 3.2-14.4 8.7-19.3L306.8 6.3zm.5 42.4L74.1 256H192c5.2 0 10.1 2.5 13.1 6.8s3.7 9.7 2 14.6l-66.5 186.2L375.8 256H256c-5.2 0-10.1-2.5-13.1-6.8s-3.7-9.7-2-14.6l66.4-186z"
        }
    ]
};

const FalBomb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBomb",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM301.1 130.9a31.99 31.99 0 0 1-33.5 7.5C249.1 131.7 229 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176c0-21-3.7-41.1-10.4-59.7a31.99 31.99 0 0 1 7.5-33.5l2.9-2.8-80-80-2.9 2.9zm-22.6-22.6 2.9-2.9c12.5-12.5 32.8-12.5 45.3 0l28.7 28.7 17.4-17.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L378 156.7l28.7 28.7c12.5 12.5 12.5 32.8 0 45.3l-2.9 2.9c7.9 22 12.2 45.7 12.2 70.5 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c24.7 0 48.5 4.3 70.5 12.3zM200 192c-57.4 0-104 46.6-104 104v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-75.1 60.9-136 136-136h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8z"
        }
    ]
};

const FalBoneBreak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoneBreak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM164.7 68.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm310.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zM270.7 244.3c-2.3-8.5-11.1-13.6-19.6-11.3l-73.4 19.7c-4 1.1-8.1-1.1-9.9-4.9-17.7-38.1-60.6-59.1-102.6-47.8C18.3 212.6-9.6 260.8 3 307.8 9.7 332.6 26.3 352 47.4 363c4.9 2.6 6.7 9.1 3.7 13.8-12.8 20.1-17.4 45.3-10.8 70.1 12.6 46.9 60.8 74.8 107.8 62.2 41.9-11.2 68.6-50.9 64.9-92.7-.4-4.1 2.1-8.1 6.1-9.1l73.4-19.7c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-73.4 19.7c-20.6 5.5-31.3 24.9-29.7 42.9 2.4 26.6-14.7 51.8-41.3 59-29.9 8-60.6-9.7-68.6-39.6-4.2-15.8-1.3-31.8 6.9-44.6 13.1-20.5 5.7-48.1-15.9-59.3-13.5-7-24-19.4-28.2-35.2-8-29.9 9.7-60.6 39.6-68.6 26.6-7.1 54 6.2 65.3 30.4 7.6 16.3 26.6 27.8 47.2 22.3l73.4-19.7c8.5-2.3 13.6-11.1 11.3-19.6zM388.9 233c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l73.4 19.7c20.6 5.5 39.6-5.9 47.2-22.3 11.2-24.2 38.6-37.5 65.3-30.4 29.9 8 47.6 38.7 39.6 68.6-4.2 15.8-14.7 28.2-28.2 35.2-21.6 11.2-28.9 38.8-15.9 59.3 8.2 12.8 11.1 28.8 6.9 44.6-8 29.9-38.7 47.6-68.6 39.6-26.6-7.1-43.7-32.4-41.3-59 1.6-18-9.1-37.4-29.7-42.9l-73.4-19.7c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l73.4 19.7c4 1.1 6.5 5 6.1 9.1-3.7 41.8 23 81.5 64.9 92.7 46.9 12.6 95.2-15.3 107.8-62.2 6.6-24.8 2-50-10.8-70.1-3-4.7-1.2-11.2 3.7-13.8 21.1-11 37.7-30.5 44.4-55.3 12.6-46.9-15.3-95.2-62.2-107.8-41.9-11.2-84.9 9.8-102.6 47.8-1.7 3.8-5.9 5.9-9.9 4.9L388.9 233z"
        }
    ]
};

const FalBone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M143.2 174.3C138.6 148 115.6 128 88 128c-30.9 0-56 25.1-56 56 0 16.3 7 31 18.2 41.3 17.9 16.4 17.9 45 0 61.4C39 297 32 311.7 32 328c0 30.9 25.1 56 56 56 27.6 0 50.6-20 55.2-46.3C146.3 320 161.7 304 183 304h210c21.3 0 36.7 16 39.8 33.7C437.4 364 460.4 384 488 384c30.9 0 56-25.1 56-56 0-16.3-7-31-18.2-41.3-17.9-16.4-17.9-45 0-61.4C537 215 544 200.3 544 184c0-30.9-25.1-56-56-56-27.6 0-50.6 20-55.2 46.3C429.7 192 414.3 208 393 208H183c-21.3 0-36.7-16-39.8-33.7zm31.5-5.5c.7 4.1 4.1 7.3 8.3 7.3h210c4.1 0 7.6-3.2 8.3-7.3C408.5 127.4 444.6 96 488 96c48.6 0 88 39.4 88 88 0 25.7-11 48.8-28.5 64.9-4.1 3.7-4.1 10.5 0 14.2C565 279.2 576 302.3 576 328c0 48.6-39.4 88-88 88-43.4 0-79.5-31.4-86.7-72.7-.7-4.1-4.1-7.3-8.3-7.3H183c-4.1 0-7.6 3.2-8.3 7.3-7.2 41.3-43.3 72.7-86.7 72.7-48.6 0-88-39.4-88-88 0-25.7 11-48.8 28.5-64.9 4.1-3.7 4.1-10.5 0-14.2C11 232.8 0 209.7 0 184c0-48.6 39.4-88 88-88 43.4 0 79.5 31.4 86.7 72.7z"
        }
    ]
};

const FalBong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 208.5c0 17.4-9.3 32.4-22.5 40.9C79 266.4 58 291 45.3 320h293.4c-12.7-29-33.7-53.6-60.2-70.6-13.2-8.5-22.5-23.5-22.5-40.9V32H128v176.5zM35.2 352c-2.1 10.3-3.2 21-3.2 32 0 32.9 9.9 63.4 26.9 88.8 2.4 3.5 8 7.2 17.2 7.2h231.8c9.2 0 14.9-3.7 17.2-7.2 17-25.4 26.9-55.9 26.9-88.8 0-11-1.1-21.7-3.2-32H35.2zM96 208.5V32H80c-8.8 0-16-7.2-16-16S71.2 0 80 0h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v176.5c0 5.7 3.1 10.9 7.9 14 13.4 8.6 25.7 18.9 36.5 30.5l45-45-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l32 32 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L400 230.6l-47.7 47.7C372.3 308.6 384 345 384 384c0 39.4-11.9 76.1-32.2 106.5-9.6 14.4-26.5 21.5-43.8 21.5H76.1c-17.3 0-34.2-7.1-43.8-21.5C11.9 460.1 0 423.4 0 384c0-67.8 35.1-127.3 88.1-161.5 4.8-3.1 7.9-8.3 7.9-14z"
        }
    ]
};

const FalBookArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-66.7c18.6-6.6 32-24.4 32-45.3v-96h-32v96c0 8.8-7.2 16-16 16H64c-11.7 0-22.6 3.1-32 8.6V64c0-17.7 14.3-32 32-32h336c8.8 0 16 7.2 16 16v96h32V48c0-26.5-21.5-48-48-48H64zm320 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h320zm155.3-315.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l68.7 68.7H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h313.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"
        }
    ]
};

const FalBookArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h112v-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h112v-32H64c-11.7 0-22.6 3.1-32 8.6V64c0-17.7 14.3-32 32-32h336c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16h-96v32h80v64h-80v32h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-66.7c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zm68.7 228.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l68.7-68.7V496c0 8.8 7.2 16 16 16s16-7.2 16-16V182.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96z"
        }
    ]
};

const FalBookAtlas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookAtlas",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm64 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64zm-32-23.4c9.4-5.4 20.3-8.6 32-8.6h336c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64c-17.7 0-32 14.3-32 32v328.6zM176.5 224h-31c4.8 26.1 21.1 48.2 43.5 60.8-6.6-16.9-11-37.8-12.5-60.8zm0-32c1.4-22.9 5.9-43.8 12.5-60.8-22.4 12.6-38.7 34.7-43.5 60.8h31zM112 208a120 120 0 1 1 240 0 120 120 0 1 1-240 0zm206.5 16h-31c-1.4 22.9-5.9 43.8-12.5 60.8 22.4-12.6 38.7-34.7 43.5-60.8zM275 131.2c6.6 16.9 11 37.8 12.5 60.8h31c-4.8-26.1-21.1-48.2-43.5-60.8zM255.4 224h-46.8c1.6 22.6 6.5 41.8 12.8 55.3 4.7 10.1 8.6 14.2 10.6 15.8 2-1.6 5.9-5.7 10.6-15.8 6.3-13.5 11.2-32.7 12.8-55.3zm-46.9-32h46.9c-1.6-22.6-6.5-41.8-12.8-55.3-4.7-10.1-8.6-14.2-10.6-15.8-2 1.6-5.9 5.7-10.6 15.8-6.3 13.5-11.2 32.7-12.8 55.3z"
        }
    ]
};

const FalBookBible = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookBible",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm64 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64zm-32-23.4c9.4-5.4 20.3-8.6 32-8.6h336c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64c-17.7 0-32 14.3-32 32v328.6zM224 72h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32v80c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-80h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32v-32c0-17.7 14.3-32 32-32zm0 32v48c0 8.8-7.2 16-16 16h-48v32h48c8.8 0 16 7.2 16 16v96h32v-96c0-8.8 7.2-16 16-16h48v-32h-48c-8.8 0-16-7.2-16-16v-48h-32z"
        }
    ]
};

const FalBookBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookBlank",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm64 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64zm-32-23.4c9.4-5.4 20.3-8.6 32-8.6h32V32H64c-17.7 0-32 14.3-32 32v328.6zM128 32v352h272c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H128z"
        }
    ]
};

const FalBookBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookBookmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm320-32H192v174.7l54-43.2c5.8-4.7 14.1-4.7 20 0l54 43.2V32zm-160 0H64c-17.7 0-32 14.3-32 32v328.6c9.4-5.4 20.3-8.6 32-8.6h336c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-48v208c0 6.2-3.5 11.8-9.1 14.4s-12.1 1.9-16.9-1.9l-70-56-70 56c-4.8 3.8-11.4 4.6-16.9 1.9s-9.1-8.3-9.1-14.4V32zM64 416c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64z"
        }
    ]
};

const FalBookCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookCircleArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h262.6c-2.9-10.3-4.9-21-5.9-32H64c-11.7 0-22.6 3.1-32 8.6V64c0-17.7 14.3-32 32-32h336c8.8 0 16 7.2 16 16v163.2c10.1-5.2 20.8-9.4 32-12.6V48c0-26.5-21.5-48-48-48H64zm432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-3.3-211.3c-6.2 6.2-6.2 16.4 0 22.6l28.7 28.7H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalBookCircleArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookCircleArrowUp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h262.6c-2.9-10.3-4.9-21-5.9-32H64c-11.7 0-22.6 3.1-32 8.6V64c0-17.7 14.3-32 32-32h336c8.8 0 16 7.2 16 16v163.2c10.1-5.2 20.8-9.4 32-12.6V48c0-26.5-21.5-48-48-48H64zm320 368a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-211.3 3.3c6.2 6.2 16.4 6.2 22.6 0l28.7-28.7V432c0 8.8 7.2 16 16 16s16-7.2 16-16v-89.4l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0l-56 56c-6.2 6.2-6.2 16.4 0 22.6z"
        }
    ]
};

const FalBookCopy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookCopy",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64c0-17.7 14.3-32 32-32h272c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H256c-11.7 0-22.6 3.1-32 8.6V64zm-32 0v288c0 35.3 28.7 64 64 64h304c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-66.7c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H256c-35.3 0-64 28.7-64 64zm64 320c-17.7 0-32-14.3-32-32s14.3-32 32-32h256v64H256zm96 96v-32h-32v32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h120.4c-8.3-9.2-14.8-20.1-19-32H64c-11.7 0-22.6 3.1-32 8.6V160c0-17.7 14.3-32 32-32h96V96H64c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h304c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16z"
        }
    ]
};

const FalBookFont = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookFont",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm64 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64zm-32-23.4c9.4-5.4 20.3-8.6 32-8.6h336c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64c-17.7 0-32 14.3-32 32v328.6zm222.3-287.8 63.9 127.7.3.6 31.8 63.7c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2L294.1 256H185.9l-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l31.8-63.7.3-.6 63.9-127.7c2.7-5.4 8.3-8.8 14.3-8.8s11.6 3.4 14.3 8.8zM278.1 224 240 147.8 201.9 224h76.2z"
        }
    ]
};

const FalBookHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm64 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64zm-32-23.4c9.4-5.4 20.3-8.6 32-8.6h336c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64c-17.7 0-32 14.3-32 32v328.6zm128-219.3c0 7.8 3.1 15.2 8.6 20.7l71.4 71.4 71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7 0-16.2-13.1-29.3-29.3-29.3-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0L210 152.6c-5.5-5.5-12.9-8.6-20.7-8.6-16.2 0-29.3 13.1-29.3 29.3zm29.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3 0-33.8 27.4-61.3 61.3-61.3z"
        }
    ]
};

const FalBookJournalWhills = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookJournalWhills",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-66.7c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zm320 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h320zM64 384c-11.7 0-22.6 3.1-32 8.6V64c0-17.7 14.3-32 32-32h336c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64zM190.5 86.3c-3.6-4.2-9.7-5.4-14.6-2.8C130.8 106.8 100 153.8 100 208c0 77.3 62.7 140 140 140s140-62.7 140-140c0-54.2-30.8-101.2-75.9-124.5-4.9-2.5-11-1.4-14.6 2.8s-3.9 10.3-.7 14.8C295.9 111 300 123 300 136c0 17.8-7.7 33.7-20 44.7-4.9 4.4-5.4 11.9-1 16.9 8.1 9.2 13 21.2 13 34.4 0 23.2-15.2 42.9-36.3 49.6l-.9-23.4 2.2 2.2c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-9-9H272c4.4 0 8-3.6 8-8s-3.6-8-8-8h-12.7l9-9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-4.2 4.2L248 87.7c-.2-4.3-3.7-7.7-8-7.7s-7.8 3.4-8 7.7l-4.8 120.2-4.2-4.2c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l9 9H208c-4.4 0-8 3.6-8 8s3.6 8 8 8h12.7l-9 9c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l2.2-2.2-.9 23.4c-21-6.7-36.3-26.3-36.3-49.6 0-13.2 4.9-25.2 13-34.4 4.4-4.9 3.9-12.5-1-16.9-12.3-11-20-27-20-44.7 0-13 4.1-25 11.1-34.8 3.2-4.5 2.9-10.6-.7-14.8zm133.1 41.2c11 11.4 19.7 25.1 25.3 40.3l-18.5 18.5c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l12.2-12.2c1.4 7.3 2.2 14.8 2.2 22.5v.7l-25.7 25.7c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l11.3-11.3c-11.9 51.4-58 89.7-113 89.7s-101.1-38.3-113-89.7l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L124 208.7v-.7c0-7.7.8-15.2 2.2-22.5l12.2 12.2c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-18.5-18.5c5.6-15.2 14.3-28.8 25.3-40.3-.3 2.8-.4 5.6-.4 8.4 0 20.9 7.6 40 20.2 54.7-7.8 11.9-12.3 26.1-12.3 41.3 0 42 34 76 76 76s76-34 76-76c0-15.2-4.5-29.4-12.2-41.3C316.4 176 324 156.9 324 136c0-2.8-.1-5.7-.4-8.4z"
        }
    ]
};

const FalBookMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm64 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64zm-32-23.4c9.4-5.4 20.3-8.6 32-8.6h336c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64c-17.7 0-32 14.3-32 32v328.6zM224 96h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32v-32c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7h-48v32h48c8.8 0 16 7.2 16 16v48h32v-48c0-8.8 7.2-16 16-16h48v-32h-48c-8.8 0-16-7.2-16-16v-48h-32z"
        }
    ]
};

const FalBookOpenCover = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookOpenCover",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 373.8V33.5L336 62.1v353.3l208-41.6zm-240 41.6V62.1L96 33.5v340.3l208 41.6zM539.6 1.8C558.9-.8 576 14.1 576 33.5v340.3c0 15.3-10.8 28.4-25.7 31.4l-217.7 43.5c-8.3 1.7-16.8 1.7-25.1 0L89.7 405.1c-15-3-25.7-16.1-25.7-31.4V33.5C64 14.1 81.1-.8 100.4 1.8L320 32 539.6 1.8zM0 65.5c0-17.9 14.6-32 32-32v385.1l281.7 56.3c4.1.8 8.4.8 12.6 0L608 418.6V33.5c17.4 0 32 14.1 32 32v353.1c0 15.3-10.8 28.4-25.7 31.4l-281.7 56.3c-8.3 1.7-16.8 1.7-25.1 0L25.7 449.9C10.8 447 0 433.8 0 418.6V65.5z"
        }
    ]
};

const FalBookOpenReader = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookOpenReader",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 48s-56.8-42.6-224-47.5c-17.6-.6-32 13.8-32 31.5v208c0 17.7 14.4 31.9 32 32.7 114.9 4.7 186.9 33.7 208.8 43.8 4.8 2.2 9.9 3.5 15.1 3.5s10.4-1.3 15.1-3.5c21.9-10.1 93.9-39.1 208.8-43.8 17.7-.7 32-15 32-32.7V224c0-17.7-14.4-32.1-32-31.5C312.8 197.4 256 240 256 240zm-18.9 25.8 2.9 2.2v205.3c-34-13.8-104.4-36.4-206.7-40.6-.5 0-.9-.2-1.2-.5-.1-.1-.1-.1-.1-.2V224.5c80.5 2.4 133.2 13.9 164.9 24.1 15.9 5.1 26.7 9.9 33 13.2 3.2 1.6 5.3 2.9 6.4 3.6.4.3.7.5.9.6zM272 268l2.9-2.2c.1-.1.4-.3.9-.6 1.1-.7 3.2-1.9 6.4-3.6 6.3-3.3 17-8.1 33-13.2 31.8-10.2 84.5-21.6 164.9-24.1v207.8l-.1.1c-.3.3-.7.5-1.2.5-102.4 4.2-172.8 26.8-206.8 40.6V268z"
        }
    ]
};

const FalBookOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M156 32c44.6 0 89.7 8.6 132 22.6 42.3-14 87.4-22.6 132-22.6 55.4 0 107.2 14.6 128.9 21.6C565.7 59 576 74.5 576 91.1v311.4c0 26.9-25.1 44.8-49 40.6-18.5-3.2-51.3-7.2-99-7.2-58.9 0-97.8 24.3-111.2 34.1-7.5 5.5-17.2 9.6-28.2 9.9h-1.2c-10.2 0-19.6-3.4-27-8.4C245.5 461.5 202 436 148 436c-45.2 0-80.1 4.4-100 7.7-24 4-48-14.1-48-40.2V91.1C0 74.5 10.3 59 27.1 53.6 48.8 46.6 100.6 32 156 32zm148 408c20.3-13.5 63.1-36 124-36 49.5 0 84.1 4.2 104.4 7.6 2.5.4 5.7-.3 8.2-2.3 2.2-1.8 3.4-4 3.4-6.8V91.1c0-3.5-2.1-6.1-4.9-7C518.6 77.5 470.5 64 420 64c-38.6 0-78.1 7.1-116 19v357zM272 83c-37.9-12-77.4-19-116-19-50.5 0-98.6 13.5-119.1 20-2.8.9-4.9 3.6-4.9 7v312.5c0 2.7 1.1 4.9 3.1 6.5 2.2 1.8 5.1 2.5 7.6 2.1 21.3-3.6 58-8.2 105.3-8.2 56.8 0 102.8 23.7 124 36.9V83z"
        }
    ]
};

const FalBookQuran = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookQuran",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 0c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-66.7C13.4 406.7 0 388.9 0 368V48C0 21.5 21.5 0 48 0h336zM64 416v64h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm320-32c11.7 0 22.6 3.1 32 8.6V64c0-17.7-14.3-32-32-32H48c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h336zm-85.9-217.8c2.2-5.3 9.6-5.3 11.8 0l8.9 21.4 23.1 1.9c5.7.5 8 7.5 3.7 11.2L328 215.8l5.4 22.6c1.3 5.5-4.7 9.9-9.6 6.9L304 233.2l-19.8 12.1c-4.9 3-10.9-1.4-9.6-6.9l5.4-22.6-17.6-15.1c-4.3-3.7-2-10.8 3.7-11.2l23.1-1.9 8.9-21.4zM126.4 208c0 62.7 50.9 113.6 113.6 113.6 11.7 0 23-1.8 33.6-5-53.3-5.9-98.3-51.6-98.3-108.6s45-102.6 98.3-108.6c-10.6-3.3-21.9-5-33.6-5-62.7 0-113.6 50.9-113.6 113.6zM240 65.6c28.5 0 55 8.4 77.3 22.8 10.5 6.8 11.8 18.8 8.4 27.2s-12.8 16-25 13.6c-48.6-9.9-96.6 28.8-96.6 78.8s48 88.7 96.6 78.8c12.3-2.5 21.6 5.2 25 13.6s2.1 20.4-8.4 27.2C295 342 268.5 350.4 240 350.4c-78.6 0-142.4-63.8-142.4-142.4S161.4 65.6 240 65.6z"
        }
    ]
};

const FalBookSection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookSection",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm64 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64zm-32-23.4c9.4-5.4 20.3-8.6 32-8.6h336c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64c-17.7 0-32 14.3-32 32v328.6zm192.7-138.5c-20.7-5.5-63.7-17-55.7-58.8 2-10.5 7.5-19.2 15.6-25.8-11.5-8.8-19.4-21.7-15.6-41.7 5.7-29.8 37.9-45 82-38.7 7.8 1.1 16.8 3.3 28.3 6.9 7.9 2.5 12.3 10.9 9.9 18.8-2.5 7.9-11 12.3-18.8 9.9-9.9-3.1-17.5-4.9-23.6-5.8-26.1-3.8-46 2.3-48.4 14.7-1.7 8.7-.2 15.1 34 24.1l6.8 1.8c28.2 7.3 70.9 18.3 62.8 60.6-2 10.5-7.5 19.2-15.6 25.9 11.8 8.9 19.4 21.7 15.6 41.6-4.8 25.3-28.9 40.2-63.1 40.2-6 0-12.3-.5-18.9-1.4-12.1-1.7-24.9-5.8-36.1-9.5l-5.4-1.8c-7.9-2.5-12.2-11-9.7-18.8 2.5-7.9 11-12.3 18.9-9.7l5.5 1.8c10.1 3.3 21.5 7 31 8.3 26.3 3.7 46.1-2.3 48.4-14.7 2.3-11.9-5.4-16.8-40.9-26l-7-1.8zm-2.7-68.2c-8.1 1.1-21.6 4.5-23.6 15.1-1.7 8.7-.2 15.1 34 24.1 0 0 13.2 3.5 16.6 4.4 8.2-1.1 21.6-4.5 23.6-15 2.3-11.9-5.4-16.8-40.9-26 0 0-8.8-2.3-9.7-2.6z"
        }
    ]
};

const FalBookSkull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookSkull",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm64 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64zm-32-23.4c9.4-5.4 20.3-8.6 32-8.6h336c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64c-17.7 0-32 14.3-32 32v328.6zM240 96c-38.9 0-64 24.6-64 48 0 14.1 8.4 28 24.2 37.5 4.8 2.9 7.8 8.1 7.8 13.7V208h64v-12.8c0-5.6 2.9-10.8 7.8-13.7C295.6 172 304 158.1 304 144c0-23.4-25.1-48-64-48zm-96 48c0-47.3 46.5-80 96-80s96 32.7 96 80c0 24.6-13 45.6-32 59.7V216c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-12.3c-19-14.1-32-35.1-32-59.7zm56 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM129.2 249.8c3.4-8.2 12.8-12 20.9-8.6l89.9 37.5 89.8-37.4c8.2-3.4 17.5.5 20.9 8.6s-.5 17.5-8.6 20.9L281.6 296l60.6 25.2c8.2 3.4 12 12.8 8.6 20.9s-12.8 12-20.9 8.6L240 313.3l-89.8 37.4c-8.2 3.4-17.5-.5-20.9-8.6s.5-17.5 8.6-20.9l60.5-25.2-60.6-25.2c-8.2-3.4-12-12.8-8.6-20.9z"
        }
    ]
};

const FalBookSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookSparkles",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-66.7c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zm320 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h320zM64 384c-11.7 0-22.6 3.1-32 8.6V64c0-17.7 14.3-32 32-32h336c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H64zm201.9-213.1-16.5 38.6-38.6 16.5c-19.4 8.3-19.4 35.8 0 44.1l38.6 16.5 16.5 38.6c8.3 19.4 35.8 19.4 44.1 0l16.5-38.6 38.6-16.5c19.4-8.3 19.4-35.8 0-44.1l-38.6-16.5-16.5-38.6c-8.3-19.4-35.8-19.4-44.1 0zm22.1 29.7 11.7 27.3c1.6 3.8 4.6 6.8 8.4 8.4l27.3 11.7-27.3 11.7c-3.8 1.6-6.8 4.6-8.4 8.4L288 295.4l-11.7-27.3c-1.6-3.8-4.6-6.8-8.4-8.4L240.6 248l27.3-11.7c3.8-1.6 6.8-4.6 8.4-8.4l11.7-27.3zm-135-78.8 7-14 7 14c1.5 3.1 4.1 5.6 7.2 7.2l14 7-14 7c-3.1 1.5-5.6 4.1-7.2 7.2l-7 14-7-14c-1.5-3.1-4.1-5.6-7.2-7.2l-14-7 14-7c3.1-1.5 5.6-4.1 7.2-7.2zm28.5-42.7c-8.8-17.7-34.1-17.7-42.9 0l-11.8 23.6-23.6 11.8c-17.7 8.8-17.7 34.1 0 42.9l23.6 11.8 11.8 23.6c8.8 17.7 34.1 17.7 42.9 0l11.8-23.6 23.6-11.8c17.7-8.8 17.7-34.1 0-42.9l-23.6-11.8-11.8-23.5z"
        }
    ]
};

const FalBookTanakh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookTanakh",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 0c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-66.7C13.4 406.7 0 388.9 0 368V48C0 21.5 21.5 0 48 0h336zM64 416v64h320c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zm320-32c11.7 0 22.6 3.1 32 8.6V64c0-17.7-14.3-32-32-32H48c-8.8 0-16 7.2-16 16v320c0 8.8 7.2 16 16 16h336zM146.7 232l-13.9 24h27.7l-13.9-24zm-13.9-24-27.7-48c-6.2-10.7 1.5-24 13.9-24h55.4l27.7-48c6.2-10.7 21.6-10.7 27.7 0l27.7 48H313c12.3 0 20 13.3 13.9 24l-27.7 48 27.7 48c6.2 10.7-1.5 24-13.9 24h-55.4l-27.7 48c-6.2 10.7-21.6 10.7-27.7 0l-27.7-48H119c-12.3 0-20-13.3-13.9-24l27.7-48zm27.7 0 27.7 48h55.4l27.7-48-27.7-48h-55.3l-27.7 48zm0-48h-27.6l13.9 24 13.9-24zm41.6-24h27.7L216 112l-13.9 24zm69.3 24 13.9 24 13.9-24h-27.8zm13.9 72-13.9 24h27.7l-13.9-24zm-55.4 48h-27.8l13.9 24 13.9-24z"
        }
    ]
};

const FalBookUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64C0 28.7 28.7 0 64 0h336c26.5 0 48 21.5 48 48v320c0 20.9-13.4 38.7-32 45.3V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V64zm64 352c-17.7 0-32 14.3-32 32s14.3 32 32 32h320v-64H64zm-32-23.4c9.4-5.4 20.3-8.6 32-8.6h336c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H64c-17.7 0-32 14.3-32 32v328.6zM240 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-32 192c-26.5 0-48 21.5-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48h-64z"
        }
    ]
};

const FalBook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBook",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-66.7c18.6-6.6 32-24.4 32-45.3V48c0-26.5-21.5-48-48-48H64zm320 416v64H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h320zM64 384c-11.7 0-22.6 3.1-32 8.6V64c0-17.7 14.3-32 32-32h32v352H64zm64 0V32h272c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16H128zm48-240c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalBookmarkSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookmarkSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 48c0-26.5-21.5-48-48-48H176c-18.9 0-35.2 10.9-43.1 26.8L160 48.1V48c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v252.8l32 25.2V48zM160 471.4V211.2L128 186v303.9c0 12.2 9.9 22.1 22.1 22.1 4.4 0 8.6-1.3 12.3-3.7L320 403.2l157.6 105.1c3.6 2.4 7.9 3.7 12.3 3.7 12.2 0 22.1-9.9 22.1-22.1v-.7l-32-25.3v7.6L328.9 370.7c-5.4-3.6-12.4-3.6-17.7 0L160 471.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBookmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v441.9c0 12.2-9.9 22.1-22.1 22.1-4.4 0-8.6-1.3-12.3-3.7L192 403.2 34.4 508.3c-3.6 2.4-7.9 3.7-12.3 3.7C9.9 512 0 502.1 0 489.9V48zm48-16c-8.8 0-16 7.2-16 16v423.4l151.1-100.7c5.4-3.6 12.4-3.6 17.8 0L352 471.4V48c0-8.8-7.2-16-16-16H48z"
        }
    ]
};

const FalBooksMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBooksMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 464c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-48h96v48zm-16 48c12.3 0 23.5-4.6 32-12.2 8.5 7.6 19.7 12.2 32 12.2h64c26.5 0 48-21.5 48-48V193.8l51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2c-6.6-25.6-32-40.7-56.7-33.9l-59.6 16.5c-3.5 1-6.8 2.3-9.9 4C335.9 8.8 321 0 304 0h-64c-12.3 0-23.5 4.6-32 12.2C199.5 4.6 188.3 0 176 0h-64C85.5 0 64 21.5 64 48v80h128v48h32v-48h96v256h-96v-48h-32v48H64v80c0 26.5 21.5 48 48 48h64zM352 64.8v-1.3c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2-13.8-53.2c-.3-1.3-.5-2.6-.6-3.8zm-32-.6V96h-96V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v16.2zM240 480c-8.8 0-16-7.2-16-16v-48h96v48c0 8.8-7.2 16-16 16h-64zM192 48v48H96V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16zm269.7 80.7 59.8 230.5-87.3 24.2-59.8-230.6 87.3-24.2zm67.9 261.5 13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2zM80 160c-17.7 0-32 14.3-32 32v16H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h16v16c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-16h16c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-16v-16c0-17.7-14.3-32-32-32H80zm0 32h32v32c0 8.8 7.2 16 16 16h32v32h-32c-8.8 0-16 7.2-16 16v32H80v-32c0-8.8-7.2-16-16-16H32v-32h32c4.2 0 8.3-1.7 11.3-4.7S80 228.2 80 224v-32z"
        }
    ]
};

const FalBooks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBooks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 416v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-48h96zm-16 96c12.3 0 23.5-4.6 32-12.2 8.5 7.6 19.7 12.2 32 12.2h64c26.5 0 48-21.5 48-48V193.8l51.4 198.1 4 15.5 18 69.2c6.6 25.5 32 40.6 56.7 33.8l59.6-16.5c24.7-6.8 39.3-33 32.7-58.5l-13.9-53.7-4-15.5-63.9-246-4-15.5-18-69.2c-6.6-25.6-32-40.7-56.7-33.9l-59.6 16.5c-3.5 1-6.8 2.3-9.9 4C271.9 8.8 257 0 240 0h-64c-12.3 0-23.5 4.6-32 12.2C135.5 4.6 124.3 0 112 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h64zM288 64.8v-1.3c.3-7.2 5.1-13 10.8-14.6l59.6-16.5c6.6-1.8 14.8 2 17.2 11l14.1 54.2-87.3 24.2-13.8-53.2c-.3-1.3-.5-2.6-.6-3.8zm-32-.6V96h-96V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v16.2zM176 480c-8.8 0-16-7.2-16-16v-48h96v48c0 8.8-7.2 16-16 16h-64zm-48-352v256H32V128h96zm0-80v48H32V48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16zm128 336h-96V128h96v256zm141.7-255.3 59.8 230.5-87.3 24.2-59.8-230.6 87.3-24.2zm67.9 261.5 13.8 53.2c2.4 9.4-3.2 17.7-10.3 19.6l-59.6 16.5c-6.6 1.8-14.8-2-17.2-11l-14.1-54.2 87.3-24.2z"
        }
    ]
};

const FalBoombox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoombox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32h352c26.5 0 48 21.5 48 48v80H96V80c0-26.5 21.5-48 48-48zM64 80v80c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64V80c0-44.2-35.8-80-80-80H144C99.8 0 64 35.8 64 80zm16 112h496c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h16zm16 144a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm192 0a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm176-80a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM208 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32z"
        }
    ]
};

const FalBootHeeled = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBootHeeled",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M37 0C16.5 0 0 16.5 0 37c0 3.5.5 7 1.5 10.3C6.5 65.1 32 158.5 32 232c0 15.4-3.7 37.3-9 60-5.1 22.4-11.4 44.3-16 59.5-4.4 14.5-7 29.8-7 45.4V496c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-46.5l118.9 52.8c14.3 6.4 29.8 9.7 45.5 9.7H496c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-34.3c0-24.2-13.7-46.4-35.4-57.2l-144.4-72.3C273.1 302.7 256 275 256 244.7V40c0-22.1-17.9-40-40-40H37zm59 32v208c0 8.8 7.2 16 16 16s16-7.2 16-16V32h88c4.4 0 8 3.6 8 8v204.7c0 42.4 24 81.2 61.9 100.2L430.3 417c10.8 5.4 17.7 16.5 17.7 28.6V480H292.4c-11.2 0-22.3-2.3-32.5-6.9l-125.4-55.7c-2-.9-4.3-1.4-6.5-1.4H32v-19.1c0-12.1 2-24.2 5.6-36.1 4.7-15.5 11.3-38.2 16.6-61.6 5.3-23 9.8-47.9 9.8-67.2 0-78.5-26.8-175.8-31.8-193.5-.2-.6-.2-1.1-.2-1.6 0-2.7 2.2-5 5-5h59zm0 448H32v-32h64v32z"
        }
    ]
};

const FalBoot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32h320v64H32V32zM0 32v96h352c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zm240 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v32h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h90.8c3.4 3 7.4 5.3 12 6.7l91.6 27.5c27.1 8.1 45.6 33 45.6 61.3V384H32V160H0v297.4c0 14.5 5.8 28.4 16 38.6s24.1 16 38.6 16h14.9c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h11c17 0 33.3-6.7 45.3-18.7l7.6-7.6c3.1-3.1 8.2-3.1 11.3 0l7.6 7.6c12 12 28.3 18.7 45.3 18.7h14.9c14.5 0 28.4-5.8 38.6-16s16-24.1 16-38.6v-106c0-42.4-27.8-79.8-68.4-92L352 232v-56c0-8.8-7.2-16-16-16h-96zm240.3 256v41.4c0 6.1-2.4 11.9-6.7 16.2s-10.1 6.7-16.2 6.7h-14.9c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6c-15.5-15.5-40.6-15.5-56.1 0l22.4 22.4-22.4-22.4-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5h-11c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6c-15.5-15.5-40.6-15.5-56.1 0l-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5h-11c-8.6 0-16.8-3.4-22.9-9.5l-7.6-7.6-21.5 21.8 21.8-21.8c-15.5-15.5-40.6-15.5-56.1 0l-7.6 7.6c-6.1 6.1-14.3 9.5-22.9 9.5H54.6c-6.1 0-11.9-2.4-16.2-6.7s-6.7-10.1-6.7-16.2V416h448.6z"
        }
    ]
};

const FalBoothCurtain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoothCurtain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 32v464c0 8.8 7.2 16 16 16s16-7.2 16-16V32h32V0H32C14.3 0 0 14.3 0 32zm288 0v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64zm-32 416c19.1 0 36.3-8.4 48-21.7 11.7 13.3 28.9 21.7 48 21.7s36.3-8.4 48-21.7c11.7 13.3 28.9 21.7 48 21.7 11.7 0 22.6-3.1 32-8.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v352c0 35.3 28.7 64 64 64 19.1 0 36.3-8.4 48-21.7 11.7 13.3 28.9 21.7 48 21.7zM480 48v336c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64v16zm-96-16v352c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64zM192 384c0 17.7-14.3 32-32 32s-32-14.3-32-32V32h64v352z"
        }
    ]
};

const FalBorderAll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderAll",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v144H240V64h144zm32 208v144c0 17.7-14.3 32-32 32H240V272h176zm-208-32H32V96c0-17.7 14.3-32 32-32h144v176zM32 272h176v176H64c-17.7 0-32-14.3-32-32V272zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalBorderBottomRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderBottomRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v352c0 17.7-14.3 32-32 32H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c35.3 0 64-28.7 64-64V64zM320 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-192 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"
        }
    ]
};

const FalBorderBottom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderBottom",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 464c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h416c8.8 0 16 7.2 16 16zm-56-112a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-336 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm144 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm240-192a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM8 160a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm240 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm144 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-336 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm144 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM440 64a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM8 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm240 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm48 192a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm48-192a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-240 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm48 192a24 24 0 1 1-48 0 24 24 0 1 1 48 0z"
        }
    ]
};

const FalBorderCenterH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderCenterH",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96-384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-96 336a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192 336a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-384a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM224 328a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 328a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm384-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 136a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalBorderCenterV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderCenterV",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v416zM56 448a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm384 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM56 352a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm384 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-48-192a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-336 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm336 96a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-336 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM392 64a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM8 64a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm288 192a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm48-192a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-48 384a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM152 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-48 384a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm48-192a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalBorderInner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderInner",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 480c-8.8 0-16-7.2-16-16V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h192V48c0-8.8 7.2-16 16-16s16 7.2 16 16v192h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H240v192c0 8.8-7.2 16-16 16zM32 424a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-168a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM32 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm360-72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM8 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm288 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24 360a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalBorderLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 480c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v416c0 8.8-7.2 16-16 16zm112-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-336a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-96 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-336a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 144a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-192 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192 48a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-192 48a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
        }
    ]
};

const FalBorderNone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderNone",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 424a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm96-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-240a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-432a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-96 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-336a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 144a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-384a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 40a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm384 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm384-240a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"
        }
    ]
};

const FalBorderOuter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderOuter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-72 72a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm72 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
        }
    ]
};

const FalBorderRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 32c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zM320 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 432a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm96-144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0 336a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM32 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 432a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm0-240a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm192-48a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM32 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 240a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm192-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalBorderTopLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderTopLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 448c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-17.7 14.3-32 32-32h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H64C28.7 32 0 60.7 0 96v352zm128-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm192 0a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-96 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm192-48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 48a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0-144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalBorderTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBorderTop",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48zm56 112a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm336 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-144 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM8 352a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm432 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-240 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM56 256a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm336 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-144 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM8 448a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm432 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-240 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-48-192a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-48 192a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm240 0a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-48-192a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalBoreHole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoreHole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-8.8 0-16 7.2-16 16v242c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62V16c0-8.8-7.2-16-16-16zm32 320a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM80 160h48v160c0 70.7 57.3 128 128 128s128-57.3 128-128V160h48c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V208c0-26.5 21.5-48 48-48zm80 0c0-17.7-14.3-32-32-32H80c-44.2 0-80 35.8-80 80v224c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V208c0-44.2-35.8-80-80-80h-48c-17.7 0-32 14.3-32 32v160c0 53-43 96-96 96s-96-43-96-96V160z"
        }
    ]
};

const FalBottleDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBottleDroplet",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 16c0-8.8 7.2-16 16-16h144c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8v113.1c38.3 22.1 64 63.5 64 110.9v192c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V256c0-47.4 25.7-88.7 64-110.9V32h-8c-8.8 0-16-7.2-16-16zm120 16h-64v113.1c0 11.4-6.1 22-16 27.7-28.8 16.7-48 47.7-48 83.2v192c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V256c0-35.5-19.2-66.5-48-83.2-9.9-5.7-16-16.3-16-27.7V32zm0 305c0-5.6-4-17.2-14.6-33.5-5.4-8.3-11.5-16.5-17.4-23.6-5.9 7.2-12 15.3-17.4 23.6C132 319.8 128 331.4 128 337c0 16.6 13.8 31 32 31 11.5 0 19.3-3.4 23.8-7.5 4-3.6 8.2-10.3 8.2-23.5zm32 0c0 42-28.7 63-64 63s-64-28.2-64-63c0-31 34.9-73.5 53.2-93.6 5.9-6.5 15.8-6.5 21.6 0C189.1 263.5 224 306 224 337z"
        }
    ]
};

const FalBottleWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBottleWater",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96h64V32h-64v64zm-32 6.3V24c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v78.3c6.4 2.4 12.6 5.5 18.4 9.2l13.6 8.6c20 12.7 32.1 34.8 32.1 58.5 0 10.9-2.5 21.2-7 30.4 4.5 9.4 7 19.9 7 31 0 11.5-2.7 22.3-7.5 32 4.8 9.7 7.5 20.5 7.5 32s-2.7 22.3-7.5 32c4.8 9.7 7.5 20.5 7.5 32 0 13.1-3.5 25.4-9.6 36 6.1 10.6 9.6 22.9 9.6 36 0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72 0-13.1 3.5-25.4 9.6-36-6.1-10.6-9.6-22.9-9.6-36 0-11.5 2.7-22.3 7.5-32-4.8-9.7-7.5-20.5-7.5-32s2.7-22.3 7.5-32c-4.8-9.7-7.5-20.5-7.5-32 0-11.1 2.5-21.6 7-31-4.5-9.2-7-19.5-7-30.4 0-23.7 12.1-45.8 32.1-58.5l13.6-8.6c5.8-3.7 12-6.8 18.4-9.2zm34.7 25.7c-12.7 0-25.1 3.6-35.9 10.5l-13.6 8.6C70.5 154 64 165.8 64 178.6c0 8.6 2.9 16.5 7.7 22.8 3.2 4.2 3.3 10.5.2 14.7-5 6.7-7.9 14.9-7.9 23.9 0 9.3 3.1 17.8 8.4 24.6 3.3 4.2 3.3 10.7 0 14.9-5.3 6.7-8.4 15.2-8.4 24.5s3.1 17.8 8.4 24.6c3.3 4.2 3.3 10.7 0 14.9-5.3 6.7-8.4 15.2-8.4 24.5 0 9.9 3.6 19 9.6 26 4.3 5.1 4.3 14.9 0 20-6 7-9.6 16.1-9.6 26 0 22.1 17.9 40 40 40h112c22.1 0 40-17.9 40-40 0-9.9-3.6-19-9.6-26-4.3-5.1-4.3-14.9 0-20 6-7 9.6-16.1 9.6-26 0-9.3-3.1-17.8-8.4-24.6-3.3-4.2-3.3-10.7 0-14.9 5.3-6.8 8.4-15.3 8.4-24.6s-3.1-17.8-8.4-24.6c-3.3-4.2-3.3-10.7 0-14.9 5.3-6.8 8.4-15.3 8.4-24.6 0-8.9-2.9-17.2-7.9-23.9-3.1-4.2-3-10.6.2-14.7 4.8-6.3 7.7-14.2 7.7-22.8 0-12.8-6.5-24.7-17.3-31.5l-13.6-8.6c-10.6-6.7-23.1-10.3-35.8-10.3h-58.6zM96 240c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm16 112h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalBowArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowArrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M511.7 18.9c1-5.2-.7-10.5-4.4-14.3S498.2-.7 493.1.3l-128 24c-5.8 1.1-10.6 5.3-12.3 11s-.2 11.8 4 16L397.4 92 153.7 335.7l-59.9-15c-8.2-2-16.8.4-22.8 6.3L7 391c-6.1 6.1-8.5 15-6.2 23.4s8.9 14.8 17.3 16.9l50 12.5 12.5 50c2.1 8.4 8.5 15 16.9 17.3s17.3 0 23.4-6.2l64-64c6-6 8.4-14.6 6.3-22.8l-15-59.9L420 114.6l40.7 40.7c4.2 4.2 10.4 5.7 16 4s9.9-6.5 11-12.3l24-128zm-49.9 92.3-61-61.1L476 36l-14.1 75.2zm-81.2 88C403 234.1 416 275.5 416 320c0 47.9-15 92.3-40.7 128.7l-122-122.1-22.6 22.6 158 158.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-13-13C429.5 429.2 448 376.8 448 320c0-53.3-16.3-102.9-44.2-143.9l-23.1 23.1zM4.7 123.3l158 158.1 22.6-22.6-122-122.1C99.7 111 144.1 96 192 96c44.5 0 85.9 13 120.8 35.3l23.1-23.1C294.9 80.3 245.3 64 192 64c-56.8 0-109.2 18.5-151.6 49.7l-13-13c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM99.3 436c-2.9-11.5-11.8-20.4-23.3-23.3l-36.3-9.1 50.8-50.8 54.9 13.7 13.7 54.9-50.8 50.8-9-36.2z"
        }
    ]
};

const FalBowlChopsticksNoodles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlChopsticksNoodles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M499.1 31.7c8.7-1.7 14.3-10.2 12.6-18.8S501.5-1.4 492.9.3L192 60.5v32.6l307.1-61.4zM160 150.4V32c0-8.8-7.2-16-16-16s-16 7.2-16 16v192H96V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v38.1L12.9 96.3C4.2 98-1.4 106.5.3 115.1s10.2 14.3 18.8 12.6l44.9-9v38L14.9 160c-8.8.6-15.5 8.2-14.9 17s8.2 15.5 17 14.9l47-3.1V224H50.9C23.3 224 1.4 247.3 3 274.8l.6 10.3c4.9 84.1 55.9 155.1 127.5 189.2 7.6 21.9 28.4 37.6 52.9 37.6h144c24.5 0 45.3-15.7 52.9-37.6 71.6-34.1 122.5-105.1 127.5-189.2l.6-10.3c1.6-27.6-20.3-50.8-47.9-50.8H160v-73.6zm32 29.9L497.1 160c8.8-.6 15.5-8.2 14.9-17s-8.2-15.5-17-14.9l-303 20.1v32.1zm-30.7 283.6c-2.8-8.1-8.7-14.7-16.5-18.4-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9h410.2c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2-7.7 3.7-13.7 10.3-16.5 18.4-3.3 9.4-12.2 16.1-22.7 16.1H184c-10.4 0-19.4-6.7-22.7-16.1z"
        }
    ]
};

const FalBowlChopsticks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlChopsticks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m499.1 31.7-480 96C10.5 129.4 2 123.8.3 115.1S4.2 98 12.9 96.3l480-96c8.7-1.7 17.1 3.9 18.8 12.6s-3.9 17.1-12.6 18.8zM512 142.9c.6 8.8-6.1 16.4-14.9 17l-480 32c-8.8.6-16.4-6.1-17-14.9s6.1-16.4 14.9-17l480-32c8.8-.6 16.4 6.1 17 14.9zM144.8 445.5c7.7 3.7 13.7 10.3 16.5 18.4 3.3 9.4 12.2 16.1 22.7 16.1h144c10.4 0 19.4-6.7 22.7-16.1 2.8-8.1 8.7-14.7 16.5-18.4 61.4-29.2 105-90.1 109.3-162.2l.6-10.3c.5-9.2-6.8-16.9-16-16.9H50.9c-9.2 0-16.5 7.7-16 16.9l.6 10.3c4.2 72.1 47.8 133 109.3 162.2zM3 274.8C1.4 247.3 23.3 224 50.9 224h410.2c27.6 0 49.5 23.2 47.9 50.8l-.6 10.3c-5 84.1-55.9 155.1-127.5 189.2-7.6 22-28.4 37.7-52.9 37.7H184c-24.5 0-45.3-15.7-52.9-37.6C59.5 440.3 8.5 369.3 3.6 285.2L3 274.8z"
        }
    ]
};

const FalBowlFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlFood",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.8 98.2C213.9 77.5 233.8 64 256 64s42.1 13.5 52.2 34.2c2 4.1 5.6 7.2 10 8.4s9.1.6 12.9-1.9C340 99.2 350.2 96 361 96c27.8 0 52.1 21.2 57.8 51 1.5 7.7 8.3 13.2 16.1 13h1.1c23.3 0 44 20.5 44 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-39.4-27.5-73.5-64.9-79.2C435 91.6 401.5 64 361 64c-11.4 0-22.3 2.2-32.3 6.2C312.2 47.2 286 32 256 32s-56.2 15.2-72.7 38.2c-10-4-20.9-6.2-32.3-6.2-40.5 0-74 27.6-86.1 64.8C27.5 134.5 0 168.6 0 208c0 8.8 7.2 16 16 16s16-7.2 16-16c0-27.5 20.7-48 44-48h1.1c7.8.2 14.7-5.3 16.1-13 5.7-29.8 30-51 57.8-51 10.8 0 21 3.2 29.8 8.7 3.8 2.4 8.6 3.1 12.9 1.9s8-4.3 10-8.4zm-74.5 326.9c-2.7-9-9.2-16.4-17.8-20.2C65.9 385 33.9 340.3 32.1 288h447.8c-1.8 52.3-33.9 97-79.4 116.9-8.6 3.8-15.2 11.2-17.8 20.2-4 13.3-16.2 22.9-30.7 22.9H160c-14.5 0-26.7-9.6-30.7-22.9zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480h192c29 0 53.5-19.3 61.4-45.7 58.1-25.4 98.6-83.4 98.6-150.8 0-15.1-12.3-27.4-27.4-27.4H27.4z"
        }
    ]
};

const FalBowlHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlHot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c8.8 0 16 7.2 16 16v16c0 20.1 9.5 39.1 25.6 51.2 24.2 18.1 38.4 46.6 38.4 76.8v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-20.1-9.5-39.1-25.6-51.2C142.2 90.7 128 62.2 128 32V16c0-8.8 7.2-16 16-16zm.8 445.5c7.7 3.7 13.7 10.3 16.5 18.4 3.3 9.4 12.2 16.1 22.7 16.1h144c10.4 0 19.4-6.7 22.7-16.1 2.8-8.1 8.7-14.7 16.5-18.4 61.4-29.2 105-90.1 109.3-162.2l.6-10.3c.5-9.2-6.8-16.9-16-16.9H50.9c-9.2 0-16.5 7.7-16 16.9l.6 10.3c4.2 72.1 47.8 133 109.3 162.2zM3 274.8C1.4 247.2 23.3 224 50.9 224h410.2c27.6 0 49.5 23.2 47.9 50.8l-.6 10.3c-4.9 84.1-55.9 155.1-127.5 189.2-7.6 22-28.4 37.7-52.9 37.7H184c-24.5 0-45.3-15.7-52.9-37.6C59.5 440.3 8.5 369.3 3.6 285.2L3 274.8zM288 16v16c0 20.1 9.5 39.1 25.6 51.2 24.2 18.1 38.4 46.6 38.4 76.8v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-20.1-9.5-39.1-25.6-51.2C270.2 90.7 256 62.2 256 32V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalBowlRice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlRice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zM48 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm81.3 233.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 385 33.9 340.3 32.1 288h447.8c-1.8 52.3-33.9 97-79.4 116.9-8.6 3.8-15.2 11.2-17.8 20.2-4 13.3-16.2 22.9-30.7 22.9H160c-14.5 0-26.7-9.6-30.7-22.9zM27.4 256C12.3 256 0 268.3 0 283.4c0 67.4 40.6 125.4 98.6 150.8C106.5 460.7 131 480 160 480h192c29 0 53.5-19.3 61.4-45.7 58.1-25.4 98.6-83.4 98.6-150.8 0-15.1-12.3-27.4-27.4-27.4H27.4zM224 208c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm-96 0c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm-32-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm224 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm-32-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm128 80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm-32-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm-96-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32z"
        }
    ]
};

const FalBowlScoop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlScoop",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 224h-32c0-88.4-71.6-160-160-160S64 135.6 64 224H32c0-106 86-192 192-192s192 86 192 192zm29.9 65.9c-8.5 67.9-63.4 119.9-130.5 125.6-4.1.3-8.2.5-12.4.5h-28.8l26.7 32 31.5 37.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2H128c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17l31.5-37.8 26.7-32H145c-4.2 0-8.3-.2-12.4-.5-67.1-5.7-122-57.7-130.5-125.6L.1 274c-.6-4.6.8-9.1 3.9-12.6s7.4-5.4 12-5.4h416c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9zM34.1 288c7.9 55 55.1 96 110.9 96h158c55.8 0 102.9-41 110.9-96H34.1zm164.3 148.5L162.2 480h123.6l-36.3-43.5-25.5-30.7-25.6 30.7z"
        }
    ]
};

const FalBowlScoops = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlScoops",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M335.3 64.7c-5-.5-10.1-.7-15.3-.7-7.8 0-15.5.6-23 1.6C279.4 45.1 253.2 32 224 32s-55.4 13.1-73 33.6c-7.5-1.1-15.2-1.6-23-1.6-5.2 0-10.3.2-15.3.7C134.7 26.1 176.3 0 224 0s89.3 26.1 111.3 64.7zM200 118.2c-7.1 8-13.3 16.7-18.7 26A95.51 95.51 0 0 0 128 128c-53 0-96 43-96 96H0C0 153.3 57.3 96 128 96c26.7 0 51.5 8.2 72 22.2zM448 224h-32c0-53-43-96-96-96s-96 43-96 96h-32c0-70.7 57.3-128 128-128s128 57.3 128 128zm-2.1 65.9c-8.5 67.9-63.4 119.9-130.5 125.6-4.1.3-8.2.5-12.4.5h-28.8l26.7 32 31.5 37.8c4 4.8 4.8 11.4 2.2 17s-8.3 9.2-14.5 9.2H128c-6.2 0-11.9-3.6-14.5-9.2s-1.8-12.3 2.2-17l31.5-37.8 26.7-32H145c-4.2 0-8.3-.2-12.4-.5-67.1-5.7-122-57.7-130.5-125.6L.1 274c-.6-4.6.8-9.1 3.9-12.6s7.4-5.4 12-5.4h416c4.6 0 9 2 12 5.4s4.5 8 3.9 12.6l-2 15.9zM34.1 288c7.9 55 55.1 96 110.9 96h158c55.8 0 102.9-41 110.9-96H34.1zm164.3 148.5L162.2 480h123.6l-36.3-43.5-25.5-30.7-25.6 30.7z"
        }
    ]
};

const FalBowlSoftServe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlSoftServe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5.8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2 0 8.1-6.6 14.7-14.7 14.7H164c-37.6 0-68 30.4-68 68 0 10.2 2.3 19.9 6.3 28.6C62.7 165.4 32 199.1 32 240c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80 0-41.4-31.4-75.4-71.7-79.6 4.9-9.7 7.7-20.8 7.7-32.4C416 57.3 358.7 0 288 0h-32zm32 49.3c0-6-1.1-11.8-3.3-17.3h3.3c53 0 96 43 96 96 0 13.1-6.3 24.7-16 32h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h120c26.5 0 48 21.5 48 48s-21.5 48-48 48H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h56c8.8 0 16-7.2 16-16s-7.2-16-16-16h-26.6c-8.2-6.6-13.4-16.7-13.4-28 0-19.9 16.1-36 36-36h77.3c25.8 0 46.7-20.9 46.7-46.7zM64 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 57.4 46.6 104 104 104h46.1l-20.4 40.8c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6h160c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6.7-15.6L329.9 448H376c57.4 0 104-46.6 104-104v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 39.8-32.2 72-72 72h-72c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6l20.4 40.8H201.9l20.4-40.8c2.5-5 2.2-10.9-.7-15.6s-8.1-7.6-13.6-7.6h-72c-39.8 0-72-32.2-72-72v-8z"
        }
    ]
};

const FalBowlSpoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlSpoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 160c-49 0-80-33.1-80-64s31-64 80-64 80 33.1 80 64-31 64-80 64zm0 32c55.5 0 101.6-34.6 110.5-80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H222.5c-8.9-45.4-55-80-110.5-80C50.1 0 0 43 0 96s50.1 96 112 96zm49.3 271.9c-2.8-8.1-8.7-14.7-16.5-18.4-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9h410.2c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2-7.7 3.7-13.7 10.3-16.5 18.4-3.3 9.4-12.2 16.1-22.7 16.1H184c-10.4 0-19.4-6.7-22.7-16.1zM50.9 224C23.3 224 1.4 247.2 3 274.8l.6 10.3c4.9 84.1 55.9 155.1 127.5 189.2 7.6 21.9 28.4 37.6 52.9 37.6h144c24.5 0 45.3-15.7 52.9-37.6 71.6-34.1 122.5-105.1 127.5-189.2l.6-10.3c1.6-27.6-20.3-50.8-47.9-50.8H50.9z"
        }
    ]
};

const FalBowlingBallPin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlingBallPin",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 32c22.1 0 40 17.9 40 40v4.4c0 6.4-.8 12.8-2.3 19l-9.4 37.4c-2.2 8.9-3.6 18-4.1 27.2h-48.4c-.5-9.2-1.9-18.3-4.1-27.2l-9.4-37.4c-1.6-6.2-2.3-12.6-2.3-19V72c0-22.1 17.9-40 40-40zm-31.5 187c3-8.8 5-17.8 6.2-27h50.5c1.8 13.4 5.4 26.5 10.8 38.9l30.8 70.4c8.6 19.8 13.1 41.1 13.1 62.7 0 26.2-6.6 51.9-19.1 74.9L502.5 480h-77l-20.9-38.3c-6.6 9.5-13.9 18.4-21.8 26.8l16.9 31c4.2 7.7 12.3 12.5 21.1 12.5h86.5c8.8 0 16.9-4.8 21.1-12.5l24.6-45.3c15.1-27.7 23-58.7 23-90.2 0-26-5.4-51.7-15.8-75.5l-30.8-70.4c-6.2-14.2-9.4-29.4-9.4-44.9v-5.5c0-9.2 1.1-18.3 3.3-27.2l9.4-37.4c2.2-8.8 3.3-17.7 3.3-26.8V72c0-39.8-32.2-72-72-72s-72 32.2-72 72v4.4c0 9 1.1 18 3.3 26.8l9.4 37.4c2.2 8.9 3.3 18 3.3 27.2v3.5c9.9 14.8 18.1 30.8 24.5 47.7zM208 128a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384a208 208 0 1 0 0-416 208 208 0 1 0 0 416zm-8-224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-56-40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56-40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalBowlingBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlingBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm240-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-120-8a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalBowlingPins = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBowlingPins",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c-22.1 0-40 17.9-40 40v4.4c0 6.4.8 12.8 2.3 19l9.4 37.4c2.2 8.9 3.6 18 4.1 27.2h48.4c.5-9.2 1.9-18.3 4.1-27.2l9.4-37.4c1.6-6.2 2.3-12.6 2.3-19V72c0-22.1-17.9-40-40-40zM91.9 230.9l-30.8 70.5C52.5 321.1 48 342.5 48 364.1c0 26.2 6.6 51.9 19.1 74.9l22.4 41h77l22.4-41.1c12.5-23 19.1-48.7 19.1-74.9 0-21.6-4.5-42.9-13.1-62.7l-30.8-70.4c-5.4-12.4-9.1-25.5-10.8-38.9h-50.5c-1.8 13.4-5.4 26.5-10.8 38.9zM56 72c0-39.8 32.2-72 72-72s72 32.2 72 72v4.4c0 9-1.1 18-3.3 26.8l-9.4 37.4c-2.2 8.9-3.3 18-3.3 27.2v5.5c0 15.5 3.2 30.7 9.4 44.9l30.8 70.4c10.4 23.8 15.8 49.5 15.8 75.5 0 31.5-7.9 62.5-23 90.2l-24.7 45.2c-4.2 7.7-12.3 12.5-21.1 12.5H84.7c-8.8 0-16.9-4.8-21.1-12.5L39 454.2c-15.1-27.7-23-58.7-23-90.2 0-26 5.4-51.7 15.8-75.5l30.8-70.4c6.2-14.1 9.4-29.4 9.4-44.9v-5.5c0-9.2-1.1-18.3-3.3-27.2l-9.4-37.4C57.1 94.4 56 85.4 56 76.4V72zm328-40c-22.1 0-40 17.9-40 40v4.4c0 6.4.8 12.8 2.3 19l9.4 37.4c2.2 8.9 3.6 18 4.1 27.2h48.4c.5-9.2 1.9-18.3 4.1-27.2l9.4-37.4c1.6-6.2 2.3-12.6 2.3-19V72c0-22.1-17.9-40-40-40zm-36.1 198.9-30.8 70.4c-8.6 19.8-13.1 41.1-13.1 62.7 0 26.2 6.6 51.9 19.1 74.9l22.4 41.1h77l22.4-41.1c12.5-23 19.1-48.7 19.1-74.9 0-21.6-4.5-42.9-13.1-62.7l-30.8-70.4c-5.4-12.4-9.1-25.5-10.8-38.9h-50.5c-1.8 13.4-5.4 26.5-10.8 38.9zM312 72c0-39.8 32.2-72 72-72s72 32.2 72 72v4.4c0 9-1.1 18-3.3 26.8l-9.4 37.4c-2.2 8.9-3.3 18-3.3 27.2v5.5c0 15.5 3.2 30.7 9.4 44.9l30.8 70.4c10.4 23.8 15.8 49.5 15.8 75.5 0 31.5-7.9 62.5-23 90.2l-24.7 45.2c-4.2 7.7-12.3 12.5-21.1 12.5h-86.5c-8.8 0-16.9-4.8-21.1-12.5L295 454.2c-15.1-27.7-23-58.7-23-90.2 0-26 5.4-51.7 15.8-75.5l30.8-70.4c6.2-14.2 9.4-29.4 9.4-44.9v-5.5c0-9.2-1.1-18.3-3.3-27.2l-9.4-37.4c-2.2-8.8-3.3-17.7-3.3-26.8V72z"
        }
    ]
};

const FalBoxArchive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxArchive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 64H32v64h448V64zm0 96H32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zm-320 80c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm288-48h32v224c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192h32v224c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192z"
        }
    ]
};

const FalBoxBallot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxBallot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32v192h256V32H160zm-32 0c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V32zM48 160h48v32H48c-8.8 0-16 7.2-16 16v112h512V208c0-8.8-7.2-16-16-16h-48v-32h48c26.5 0 48 21.5 48 48v256c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V208c0-26.5 21.5-48 48-48zm496 192H32v112c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V352z"
        }
    ]
};

const FalBoxCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 64h102.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128h176v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192h208zm-32-32H42.1l34.2-77c5.1-11.6 16.6-19 29.2-19H208v96zm192.9-90c-10.3-23.1-33.2-38-58.5-38H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zm-69.6 181.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 345.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalBoxCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 64h102.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128h208v-2.4c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h232.2c-8.1-9.8-15.2-20.6-21-32H64c-17.7 0-32-14.3-32-32V192h208zm-32-32H42.1l34.2-77c5.1-11.6 16.6-19 29.2-19H208v96zm224 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalBoxDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxDollar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 64h102.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128h176v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192h208zm-32-32H42.1l34.2-77c5.1-11.6 16.6-19 29.2-19H208v96zm192.9-90c-10.3-23.1-33.2-38-58.5-38H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM240 216c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7-13 7.7-23.9 21.1-23.8 40.5.1 18.4 10.8 30.1 22.7 37.3 10.5 6.3 23.8 10.4 34.8 13.7l1.6.5c12.5 3.8 22.2 6.9 29 11.2 5.9 3.7 7.7 7 7.7 11.6.1 6.6-2.7 10.8-7.8 14-5.8 3.6-14.5 5.6-23.7 5.3-11.8-.4-22.7-4.1-36.3-8.7-2.3-.8-4.7-1.6-7.1-2.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1 9.2 3.2 19.7 6.8 30.9 8.9V424c0 8.8 7.2 16 16 16s16-7.2 16-16v-17.1c8.7-1.4 17.4-4.3 25.1-9.1 13.3-8.3 23.2-22.2 22.9-41.6-.2-18.5-10.6-30.6-22.7-38.2-11-6.9-25-11.2-36.3-14.6l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9-6-3.6-7.2-6.4-7.3-10.1 0-5.4 2.4-9.4 8.1-12.8 6.2-3.7 15.1-5.7 23.6-5.5 10.1.2 21 2.3 32.1 5.3 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V216z"
        }
    ]
};

const FalBoxHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 64h102.4c12.6 0 24.1 7.4 29.2 19l34.2 77H240V64zm0 128h176v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192h208zm-32-32H42.1l34.2-77c5.1-11.6 16.6-19 29.2-19H208v96zm192.9-90c-10.3-23.1-33.2-38-58.5-38H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70zM146.7 264.5c14.3-14.3 37.4-14.3 51.7 0l14.3 14.3c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7l14.3-14.3c14.3-14.3 37.4-14.3 51.7 0s14.3 37.4 0 51.7L224 393.4l-77.3-77.3c-14.3-14.3-14.3-37.4 0-51.7zm74.3-22.7c-26.8-26.8-70.2-26.8-96.9 0s-26.8 70.2 0 96.9l77.3 77.3c12.5 12.5 32.8 12.5 45.3 0l77.3-77.3c26.8-26.8 26.8-70.2 0-96.9s-70.2-26.8-96.9 0l-3 3-3-3z"
        }
    ]
};

const FalBoxOpenFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxOpenFull",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c53 0 96 43 96 96 0 8.8 7.2 16 16 16s16-7.2 16-16C384 57.3 326.7 0 256 0S128 57.3 128 128c0 8.8 7.2 16 16 16s16-7.2 16-16c0-53 43-96 96-96zM80.4 161.5c-14.1-1.6-27.5 6.2-33.1 19.2l-32 74.7c-9.9 22.8 3.4 49 27.7 54.6l159.2 36.7c18.9 4.4 38.6-3.1 49.9-18.9l67.9-94.9 67.9 95.1c11.3 15.8 31 23.2 49.9 18.9L597 310c24.3-5.6 37.6-31.8 27.8-54.7l-32-74.7c-5.6-13-19-20.8-33.1-19.2L320 189.2 80.4 161.5zm-3.7 31.8 214.5 24.8-65.1 91.2c-3.8 5.3-10.3 7.7-16.6 6.3L50.2 278.9c-4.9-1.1-7.5-6.4-5.6-10.9l32-74.7zM544 348.7v61.8c0 7.3-5 13.7-12.1 15.5L336 475V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v139l-195.9-49c-7.1-1.7-12.1-8.1-12.1-15.5v-61.8l-32-9.1v71c0 22 15 41.2 36.4 46.6l208 52c7.6 1.9 15.6 1.9 23.3 0l208-52c21.4-5.3 36.4-24.5 36.4-46.6v-71l-32 9.1zM348.8 218.1l214.5-24.8 32 74.7c2 4.6-.7 9.8-5.6 10.9l-159.1 36.7c-6.3 1.5-12.9-1-16.6-6.3l-65.1-91.2zm146.4-181c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-32 96c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l32-96z"
        }
    ]
};

const FalBoxOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxOpen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80.4 49.5 320 77.2l239.6-27.7c14.1-1.6 27.5 6.2 33.1 19.2l32 74.7c9.8 22.9-3.5 49.1-27.8 54.7l-159.1 36.7c-18.9 4.4-38.6-3.1-49.9-18.9l-67.9-95-67.9 95.1c-11.3 15.8-30.9 23.2-49.9 18.9L43 198c-24.3-5.6-37.6-31.8-27.8-54.7l32-74.7c5.6-13 19-20.8 33.1-19.2zm-3.7 31.8-32 74.7c-2 4.6.7 9.8 5.6 10.9l159.2 36.7c6.3 1.5 12.9-1 16.6-6.3l65.1-91.2L76.7 81.3zM544 236.7l32-9.1v151c0 22-15 41.2-36.4 46.6l-208 52c-7.6 1.9-15.6 1.9-23.3 0l-208-52C79 419.7 64 400.5 64 378.5v-151l32 9.1v141.9c0 7.3 5 13.7 12.1 15.5L304 443V208c0-8.8 7.2-16 16-16s16 7.2 16 16v235l195.9-49c7.1-1.8 12.1-8.2 12.1-15.5V236.7zM348.8 106.1l65.1 91.2c3.8 5.3 10.3 7.7 16.6 6.3l159.2-36.7c4.9-1.1 7.5-6.4 5.6-10.9l-32-74.7-214.5 24.8z"
        }
    ]
};

const FalBoxTaped = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxTaped",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 32H105.6c-25.3 0-48.2 14.9-58.5 38L5.5 163.6c-3.6 8.2-5.5 17-5.5 26V416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V189.6c0-9-1.9-17.8-5.5-26L400.9 70c-10.3-23.1-33.2-38-58.5-38H264zm24 128-18-96h72.4c12.6 0 24.1 7.4 29.2 19l34.2 77H288zm-32.6 0h-62.8l18-96h26.9l18 96zm.6 32v64h-64v-64h64zm-96 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64h128v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192h128zm0-32H42.1l34.2-77c5.1-11.6 16.6-19 29.2-19H178l-18 96z"
        }
    ]
};

const FalBoxTissue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxTissue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32c12.6 0 17.5 3.4 20.5 6.2 4.7 4.4 8.4 11.1 14.9 24.1l.7 1.5c5.5 11 13.7 27.5 27.4 40.4 16 15.2 37.1 23.8 64.5 23.8h77.5l-70.4 176H165L97 32h111zm-88 224 12 48h-20c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-22.4l19.2-48 12.8-32 36.5-91.2c1.3-3.2 1.9-6.6 1.9-10C448 108 436 96 421.2 96H336c-40 0-52-24-64-48S248 0 208 0H92.5C76.8 0 64 12.8 64 28.5c0 2.3.3 4.7.9 6.9L112 224l8 32zm-33 0-8-32H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-19.9l-12.8 32H464c8.8 0 16 7.2 16 16v112H32V272c0-8.8 7.2-16 16-16h39zM32 416h448v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-48z"
        }
    ]
};

const FalBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBox",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M342.4 64H240v96h165.9l-34.2-77c-5.1-11.6-16.6-19-29.2-19zM416 192H32v224c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192zM42.1 160H208V64H105.6C93 64 81.5 71.4 76.4 83l-34.3 77zM342.4 32c25.3 0 48.2 14.9 58.5 38l41.6 93.6c3.6 8.2 5.5 17 5.5 26V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V189.6c0-9 1.9-17.8 5.5-26L47.1 70c10.3-23.1 33.2-38 58.5-38h236.8z"
        }
    ]
};

const FalBoxesPacking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxesPacking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M592 32H304c-8.8 0-16 7.2-16 16v80h-32V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H381.3c1.8-5 2.7-10.4 2.7-16v-16h208c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16zm-36.7 284.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 302.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V302.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64zM352 192H32v64h320v-64zM0 256v-64c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288c-17.7 0-32-14.3-32-32zm64 32v192h256V288H64zm80 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalBoxesStacked = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxesStacked",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c17.7 0 32 14.3 32 32v128h32V64c0-35.3-28.7-64-64-64H192c-35.3 0-64 28.7-64 64v128h32V64c0-17.7 14.3-32 32-32h32v56c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V32h32zm-128 0h64v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V32zm71.6 480H512c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64H327.6c8.3 9.2 14.8 20.1 19 32h5.4v56c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-56h32c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H346.5c-4.2 11.9-10.7 22.8-19 32zM384 256h64v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm-128 0c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288c0-17.7 14.3-32 32-32h32v56c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-56h32zm-128 56v-56h64v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8zm128-88H64c-35.3 0-64 28.7-64 64v160c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64z"
        }
    ]
};

const FalBoxingGlove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBoxingGlove",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 112c0-44.2 35.8-80 80-80h160c44.2 0 80 35.8 80 80v16h-16c-38.7 0-71 27.5-78.4 64H144c-26.5 0-48-21.5-48-48v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 44.2 35.8 80 80 80h113.6c7.4 36.5 39.7 64 78.4 64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c26.5 0 48 21.5 48 48v38.9c0 17-6.7 33.3-18.7 45.3L336.4 353a55.924 55.924 0 0 0-16.4 39.6V456c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V351.6c0-4.6-1.9-8.9-5.3-11.9C42.3 325 32 303.7 32 280V112zM112 0C50.1 0 0 50.1 0 112v168c0 30.5 12.2 58.2 32 78.4V456c0 30.9 25.1 56 56 56h208c30.9 0 56-25.1 56-56v-63.4c0-6.4 2.5-12.5 7-17l60.9-60.9c18-18 28.1-42.4 28.1-67.9V208c0-38.7-27.5-71-64-78.4V112C384 50.1 333.9 0 272 0H112zm40.9 338.7c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l28 18.7-28 18.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l39.1-26.1 39.1 26.1c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-28-18.7 28-18.7c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4L192 364.8l-39.1-26.1z"
        }
    ]
};

const FalBracketCurlyRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBracketCurlyRight",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 112c0-44.2-35.8-80-80-80H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c26.5 0 48 21.5 48 48v53.5c0 21.2 8.4 41.6 23.4 56.6l34 33.9-33.9 33.9c-15 15-23.4 35.4-23.4 56.6V400c0 26.5-21.5 48-48 48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c44.2 0 80-35.8 80-80v-53.5c0-12.7 5.1-24.9 14.1-33.9l45.3-45.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-45.3-45.3c-9-9-14.1-21.2-14.1-33.9V112z"
        }
    ]
};

const FalBracketCurly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBracketCurly",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 112c0-44.2 35.8-80 80-80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-26.5 0-48 21.5-48 48v53.5c0 21.2-8.4 41.6-23.4 56.6l-34 33.9 33.9 33.9c15 15 23.4 35.4 23.4 56.6V400c0 26.5 21.5 48 48 48h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-44.2 0-80-35.8-80-80v-53.5c0-12.7-5.1-24.9-14.1-33.9L4.7 267.3c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3L50 199.4c9-9 14.1-21.2 14.1-33.9V112z"
        }
    ]
};

const FalBracketRoundRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBracketRoundRight",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M33.9 40.4c-4.2 7.8-1.3 17.5 6.4 21.7C80.5 83.8 160 153.4 160 256S80.5 428.2 40.4 449.9c-7.8 4.2-10.7 13.9-6.4 21.7s13.9 10.7 21.7 6.4C100.8 453.6 192 375.3 192 256S100.8 58.4 55.6 33.9c-7.8-4.2-17.5-1.3-21.7 6.4z"
        }
    ]
};

const FalBracketRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBracketRound",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M158.1 40.4c4.2 7.8 1.3 17.5-6.4 21.7C111.5 83.8 32 153.4 32 256s79.5 172.2 119.6 193.9c7.8 4.2 10.7 13.9 6.4 21.7s-13.9 10.7-21.7 6.4C91.2 453.6 0 375.3 0 256S91.2 58.4 136.4 33.9c7.8-4.2 17.5-1.3 21.7 6.4z"
        }
    ]
};

const FalBracketSquareRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBracketSquareRight",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 80c0-26.5-21.5-48-48-48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48V80z"
        }
    ]
};

const FalBracketSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBracketSquare",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-26.5 21.5-48 48-48h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-26.5 0-48-21.5-48-48V80z"
        }
    ]
};

const FalBracketsCurly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBracketsCurly",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32c-44.2 0-80 35.8-80 80v53.5c0 12.7-5.1 24.9-14.1 33.9L4.7 244.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3L50 312.6c9 9 14.1 21.2 14.1 33.9V400c0 44.2 35.8 80 80 80h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-26.5 0-48-21.5-48-48v-53.5c0-21.2-8.4-41.6-23.4-56.6l-34-33.9 33.9-33.9c15-15 23.4-35.4 23.4-56.6V112c0-26.5 21.5-48 48-48h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm288 0h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c26.5 0 48 21.5 48 48v53.5c0 21.2 8.4 41.6 23.4 56.6l34 33.9-33.9 33.9c-15 15-23.4 35.4-23.4 56.6V400c0 26.5-21.5 48-48 48H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c44.2 0 80-35.8 80-80v-53.5c0-12.7 5.1-24.9 14.1-33.9l45.3-45.3c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-45.3-45.3c-9-9-14.1-21.2-14.1-33.9V112c0-44.2-35.8-80-80-80z"
        }
    ]
};

const FalBracketsRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBracketsRound",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 62.1C111.5 83.8 32 153.4 32 256s79.5 172.2 119.6 193.9c7.8 4.2 10.7 13.9 6.4 21.7s-13.9 10.7-21.7 6.4C91.2 453.6 0 375.3 0 256S91.2 58.4 136.4 33.9c7.8-4.2 17.5-1.3 21.7 6.4s1.3 17.5-6.4 21.7zm208.8 0c-7.8-4.2-10.7-13.9-6.4-21.7s13.9-10.7 21.7-6.4C420.8 58.4 512 136.7 512 256s-91.2 197.6-136.4 222.1c-7.8 4.2-17.5 1.3-21.7-6.4s-1.3-17.5 6.4-21.7C400.5 428.2 480 358.6 480 256S400.5 83.8 360.4 62.1z"
        }
    ]
};

const FalBracketsSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBracketsSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm352 0h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FalBraille = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBraille",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm160 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM32 416a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm64 0a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM32 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm64-160a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm128-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm128-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-64 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM416 224a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM240 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM64 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 144a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm336-144a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalBrainArrowCurvedRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrainArrowCurvedRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144.2 75.4c-.6 6.7-5.4 12.4-12 14C111.4 94.7 96 113.6 96 136c0 3.1.3 6.2.9 9.2 1.5 7.6-2.7 15.2-10 18C68.8 170 56 187.6 56 208c0 5.2.8 10.3 2.4 15 2 6.1.2 12.8-4.6 17C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3 6.7 4.2 9.3 12.6 6.3 19.8-2.9 6.7-4.5 14.1-4.5 21.9 0 30.9 25.1 56 56 56 3.3 0 6.5-.3 9.5-.8 7.5-1.3 14.9 2.9 17.6 10 6.9 18 24.4 30.8 44.8 30.8 26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48-25 0-45.5 19.1-47.8 43.4zM256 480c-14.6 19.4-37.8 32-64 32-29.6 0-55.5-16.1-69.3-40H120c-48.6 0-88-39.4-88-88 0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65-.9-4.9-1.4-9.9-1.4-15 0-29.6 16.1-55.5 40-69.3V136c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0c26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32 37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136v2.7c20.5 11.8 35.2 32.5 39.1 56.7-15.4 5.6-27.7 17.3-34.2 32.3 0-1.6.3-3.2.8-4.7 1.5-4.7 2.4-9.7 2.4-15 0-20.4-12.8-38-30.9-44.9-7.3-2.8-11.5-10.4-10-18 .6-3 .9-6 .9-9.2 0-22.4-15.4-41.3-36.2-46.5-6.6-1.7-11.4-7.3-12-14C365.5 51.1 345 32 320 32c-26.5 0-48 21.5-48 48v352c0 25.6 20 46.5 45.2 47.9 5 11.8 10.9 22.1 17 30.8-4.6.8-9.4 1.3-14.2 1.3-26.2 0-49.4-12.6-64-32zm270.7-248 108.6 108.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3L526.6 472c-5.1 5.1-12 8-19.1 8-15.1.1-27.5-12.2-27.5-27.3V400h-16c-35.3 0-64 28.7-64 64v32c0 6.4-3.8 12.2-9.8 14.7s-12.8 1.2-17.4-3.2C358.2 493.3 336 459.4 336 416c0-61.9 50.1-112 112-112h32v-52.6c0-15 12.1-27.2 27.2-27.3 7.3 0 14.3 2.8 19.5 8zM512 320c0 8.8-7.2 16-16 16h-48c-44.2 0-80 35.8-80 80 0 8.5 1.2 16.6 3 24 10.7-41.4 48.2-72 93-72h32c8.8 0 16 7.2 16 16v57.4l89.4-89.4-89.4-89.4V320z"
        }
    ]
};

const FalBrainCircuit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrainCircuit",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c26.5 0 48 21.5 48 48v48h-27.3c-6.2-14.1-20.3-24-36.7-24-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24H240v112h-48c-24.9 0-45.4 19-47.8 43.2C130 321.3 120 335.5 120 352c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.2-9.6-30.1-23.4-36.4 1.9-6.7 8.1-11.6 15.4-11.6h48v128c0 26.5-21.5 48-48 48-20.4 0-37.9-12.8-44.8-30.8-2.7-7.1-10.1-11.3-17.6-10-3.1.5-6.3.8-9.5.8-30.9 0-56-25.1-56-56 0-7.8 1.6-15.2 4.4-21.8 3.1-7.2.4-15.7-6.3-19.8C44 331 32 310.9 32 288c0-19.1 8.4-36.3 21.7-48.1 4.8-4.2 6.6-10.9 4.6-17-1.5-4.7-2.4-9.7-2.4-15 0-20.4 12.8-38 30.9-44.9 7.3-2.8 11.5-10.4 10-18-.6-3-.9-6-.9-9.2 0-22.4 15.4-41.3 36.2-46.5 6.6-1.7 11.4-7.3 12-14C146.5 51.1 167 32 192 32zm80 128h48c8.8 0 16 7.2 16 16v11.3c-14.1 6.2-24 20.3-24 36.7 0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7V176c0-26.5-21.5-48-48-48h-48V80c0-26.5 21.5-48 48-48 25 0 45.5 19.1 47.8 43.4.6 6.7 5.4 12.4 12 14 20.8 5.3 36.2 24.2 36.2 46.6 0 3.1-.3 6.2-.9 9.2-1.5 7.6 2.7 15.2 10 18C443.2 170 456 187.6 456 208c0 5.2-.8 10.3-2.4 15-2 6.1-.2 12.8 4.6 17 13.4 11.7 21.8 28.9 21.8 48 0 22.9-12 43-30.2 54.3-6.7 4.2-9.3 12.6-6.3 19.8 2.8 6.7 4.4 14.1 4.4 21.8 0 30.9-25.1 56-56 56-3.3 0-6.5-.3-9.5-.8-7.5-1.3-14.9 2.9-17.6 10-6.9 18-24.4 30.8-44.8 30.8-26.5 0-48-21.5-48-48V384h59.3c6.2 14.1 20.3 24 36.7 24 22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24H272V160zm-80 352c26.2 0 49.4-12.6 64-32 14.6 19.4 37.8 32 64 32 29.6 0 55.5-16.1 69.3-40h2.7c48.6 0 88-39.4 88-88 0-7.6-1-15-2.8-22 21.2-17.6 34.8-44.2 34.8-74 0-25.1-9.6-48-25.4-65 .9-4.9 1.4-9.9 1.4-15 0-29.6-16.1-55.5-40-69.3V136c0-33.6-20.7-62.4-50.1-74.2C389.7 26.4 357.9 0 320 0c-26.2 0-49.4 12.6-64 32-14.6-19.4-37.8-32-64-32-37.9 0-69.7 26.4-77.9 61.8C84.7 73.6 64 102.4 64 136v2.7c-23.9 13.8-40 39.7-40 69.3 0 5.1.5 10.1 1.4 15C9.6 240 0 262.9 0 288c0 29.8 13.6 56.4 34.8 74-1.8 7-2.8 14.4-2.8 22 0 48.6 39.4 88 88 88h2.7c13.8 23.9 39.7 40 69.3 40zm-16-384a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm176-112a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm32 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalBrain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144.2 75.4c-.6 6.7-5.4 12.4-12 14C111.4 94.7 96 113.6 96 136c0 3.1.3 6.2.9 9.2 1.5 7.6-2.7 15.2-10 18C68.8 170 56 187.6 56 208c0 5.2.8 10.3 2.4 15 2 6.1.2 12.8-4.6 17C40.4 251.7 32 268.9 32 288c0 22.9 12 43 30.2 54.3 6.7 4.2 9.3 12.6 6.3 19.8-2.9 6.7-4.5 14.1-4.5 21.9 0 30.9 25.1 56 56 56 3.3 0 6.5-.3 9.5-.8 7.5-1.3 14.9 2.9 17.6 10 6.9 18 24.4 30.8 44.8 30.8 26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48-25 0-45.5 19.1-47.8 43.4zM256 480c-14.6 19.4-37.8 32-64 32-29.6 0-55.5-16.1-69.3-40H120c-48.6 0-88-39.4-88-88 0-7.6 1-15 2.8-22C13.6 344.4 0 317.8 0 288c0-25.1 9.6-48 25.4-65-.9-4.9-1.4-9.9-1.4-15 0-29.6 16.1-55.5 40-69.3V136c0-33.6 20.7-62.4 50.1-74.2C122.3 26.4 154.1 0 192 0c26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32 37.9 0 69.7 26.4 77.9 61.8C427.3 73.6 448 102.4 448 136v2.7c23.9 13.8 40 39.7 40 69.3 0 5.1-.5 10.1-1.4 15 15.8 17.1 25.4 40 25.4 65 0 29.8-13.6 56.4-34.8 74 1.8 7.1 2.8 14.4 2.8 22 0 48.6-39.4 88-88 88h-2.7c-13.8 23.9-39.7 40-69.3 40-26.2 0-49.4-12.6-64-32zm16-48c0 26.5 21.5 48 48 48 20.4 0 37.9-12.8 44.8-30.8 2.7-7.1 10.1-11.3 17.6-10 3.1.5 6.3.8 9.5.8 30.9 0 56-25.1 56-56 0-7.8-1.6-15.2-4.4-21.8-3.1-7.2-.4-15.7 6.3-19.8C468 331 480 310.9 480 288c0-19.1-8.4-36.3-21.7-48.1-4.8-4.2-6.6-10.9-4.6-17 1.5-4.7 2.4-9.7 2.4-15 0-20.4-12.8-38-30.9-44.9-7.3-2.8-11.5-10.4-10-18 .6-3 .9-6 .9-9.2 0-22.4-15.4-41.3-36.2-46.5-6.6-1.7-11.4-7.3-12-14C365.5 51.1 345 32 320 32c-26.5 0-48 21.5-48 48v352z"
        }
    ]
};

const FalBrakeWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrakeWarning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm16-336c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm-16 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM77.5 100.6c4.8-7.4 2.6-17.3-4.8-22.1s-17.3-2.6-22.1 4.8C18.5 133.2 0 192.4 0 256s18.5 122.8 50.5 172.7c4.8 7.4 14.7 9.6 22.1 4.8s9.6-14.7 4.8-22.1C48.7 366.6 32 313.3 32 256s16.7-110.6 45.5-155.4zm512-17.3c-4.8-7.4-14.7-9.6-22.1-4.8s-9.6 14.7-4.8 22.1C591.3 145.4 608 198.7 608 256s-16.7 110.6-45.5 155.4c-4.8 7.4-2.6 17.3 4.8 22.1s17.3 2.6 22.1-4.8c32-49.9 50.6-109.1 50.6-172.7s-18.6-122.8-50.5-172.7z"
        }
    ]
};

const FalBrazilianRealSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrazilianRealSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c8.8 0 16 7.2 16 16v48.5c16.8 1.4 33.3 5.4 48.9 11.9l13.3 5.6c8.2 3.4 12 12.8 8.6 20.9s-12.8 12-20.9 8.6l-13.3-5.6C436.9 99.4 420 96 403 96h-15.7c-37.2 0-67.3 30.1-67.3 67.3 0 28.6 18.1 54.1 45.1 63.6l80.3 28c39.9 13.9 66.6 51.5 66.6 93.8 0 53.7-42.7 97.5-96 99.3v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48.5c-22.1-1.8-43.5-8.6-62.6-20l-25.6-15.3c-7.6-4.5-10-14.4-5.5-21.9s14.4-10.1 21.9-5.5l25.6 15.3c17.4 10.4 37.3 15.9 57.5 15.9h17.3c37.2 0 67.3-30.1 67.3-67.3 0-28.6-18.1-54.1-45.1-63.6l-80.3-28c-39.9-13.9-66.6-51.5-66.6-93.8 0-53.7 42.7-97.5 96-99.3V16c0-8.8 7.2-16 16-16zM0 80c0-26.5 21.5-48 48-48h64c79.5 0 144 64.5 144 144 0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3l-57.1-149.8c-2.6.1-5.3.2-7.9.2H32v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V80zm32 208h80c61.9 0 112-50.1 112-112S173.9 64 112 64H48c-8.8 0-16 7.2-16 16v208z"
        }
    ]
};

const FalBreadLoaf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBreadLoaf",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 224c-17.7 0-32-14.3-32-32 0-45.8 30.4-77.3 77.4-98.9C156.4 71.4 211.6 64 240 64s83.6 7.4 130.6 29.1c47 21.7 77.4 53.1 77.4 98.9 0 17.7-14.3 32-32 32s-32 14.3-32 32v176c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V256c0-17.7-14.3-32-32-32zm352 32h128v176c0 8.8-7.2 16-16 16H413.3c1.8-5 2.7-10.4 2.7-16V256zm155.3-31.7c-1.1-.2-2.2-.3-3.3-.3h-96.6c5.4-9.4 8.6-20.3 8.6-32 0-64-44-104-96-128h16c28.4 0 83.6 7.4 130.6 29.1 47 21.7 77.4 53.1 77.4 98.9 0 17.7-14.3 32-32 32-1.6 0-3.2.1-4.7.3zM112 480h416c26.5 0 48-21.5 48-48V256c35.3 0 64-28.7 64-64C640 64 464 32 400 32H240C176 32 0 64 0 192c0 35.3 28.7 64 64 64v176c0 26.5 21.5 48 48 48z"
        }
    ]
};

const FalBreadSliceButter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBreadSliceButter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 256v176c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V256c0-17.7 14.3-32 32-32s32-14.3 32-32c0-44.3-32.4-76.2-84.6-98.6C344.1 71.4 284.5 64 256 64s-88.1 7.4-139.4 29.4C64.4 115.8 32 147.7 32 192c0 17.7 14.3 32 32 32s32 14.3 32 32zm352 0v176c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V256c-35.3 0-64-28.7-64-64C0 64 192 32 256 32s256 32 256 160c0 35.3-28.7 64-64 64zm-254.1 20.7c-6.2 6.2-6.2 16.4 0 22.6l50.7 50.7c6.2 6.2 16.4 6.2 22.6 0l50.7-50.7c6.2-6.2 6.2-16.4 0-22.6L267.2 226c-6.2-6.2-16.4-6.2-22.6 0l-50.7 50.7zm96-73.4 50.7 50.7c18.7 18.7 18.7 49.1 0 67.9l-50.7 50.7c-18.7 18.7-49.1 18.7-67.9 0l-50.7-50.7c-18.7-18.7-18.7-49.1 0-67.9l50.7-50.7c18.7-18.7 49.1-18.7 67.9 0z"
        }
    ]
};

const FalBreadSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBreadSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 224c-17.7 0-32-14.3-32-32 0-44.3 32.4-76.2 84.6-98.6C167.9 71.4 227.5 64 256 64s88.1 7.4 139.4 29.4c52.2 22.4 84.6 54.3 84.6 98.6 0 17.7-14.3 32-32 32s-32 14.3-32 32v176c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V256c0-17.7-14.3-32-32-32zm384 64v-32c35.3 0 64-28.7 64-64C512 64 320 32 256 32S0 64 0 192c0 35.3 28.7 64 64 64v176c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V288z"
        }
    ]
};

const FalBridgeCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBridgeCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64V64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm448 32v64h-96V64h96zm-128 0v64h-96V64h96zm-128 0v64h-96V64h96zM48 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c35.3 0 64 28.7 64 64v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-96c0-35.3 28.7-64 64-64 9 0 17.5 1.8 25.2 5.2 5.6-9.3 12.1-18.1 19.3-26.2-13.3-7-28.4-11-44.5-11-53 0-96 43-96 96v96c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-96c0-53-43-96-96-96H48zm448 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FalBridgeCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBridgeCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32h544c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm448 32h-96v64h96V64zm-128 0h-96v64h96V64zm-128 0h-96v64h96V64zM48 240h16c53 0 96 43 96 96v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-96c0-53 43-96 96-96 16.1 0 31.2 4 44.6 10.9-7.2 8.1-13.7 16.9-19.3 26.2-7.7-3.3-16.3-5.2-25.2-5.2-35.3 0-64 28.7-64 64v96c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-35.3-28.7-64-64-64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm560 128a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalBridgeCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBridgeCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32h544c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm448 32h-96v64h96V64zm-128 0h-96v64h96V64zm-128 0h-96v64h96V64zM48 240h16c53 0 96 43 96 96v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-96c0-53 43-96 96-96 16.1 0 31.2 4 44.6 10.9-7.2 8.1-13.7 16.9-19.3 26.2-7.7-3.3-16.3-5.2-25.2-5.2-35.3 0-64 28.7-64 64v96c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V336c0-35.3-28.7-64-64-64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm560 128a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm203.3-36.7L518.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalBridgeLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBridgeLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32h544c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm272 208c40.6 0 75.4 25.3 89.4 60.9C394 312.6 384 331.2 384 352v-16c0-35.3-28.7-64-64-64s-64 28.7-64 64v96c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-96c0-35.3-28.7-64-64-64H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c53 0 96 43 96 96v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-96c0-53 43-96 96-96zM496 64h-96v64h96V64zm-128 0h-96v64h96V64zm-128 0h-96v64h96V64zm288 160c-26.5 0-48 21.5-48 48v48h96v-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48zm0 80v128h160V352H448z"
        }
    ]
};

const FalBridgeSuspension = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBridgeSuspension",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c6.4 0 11.9 3.7 14.5 9.2l6.6 13.2C181.4 87.1 247.6 128 320 128S458.6 87.1 490.9 22.4l6.6-13.2C500.1 3.7 505.6 0 512 0c7.2 0 13.3 4.7 15.3 11.3 14.5 43 58.7 87.5 102.6 104.9 8.2 3.3 12.2 12.6 9 20.8s-12.6 12.2-20.8 9c-33-13.1-66-38.6-90.1-69.1V256h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V76.8c-24.1 30.5-57.1 56-90.1 69.1-8.2 3.3-17.5-.8-20.8-9s.8-17.5 9-20.8C54 98.7 98.2 54.3 112.7 11.3 114.7 4.7 120.8 0 128 0zm16 256h64V129.9a223.01 223.01 0 0 1-64-55.8V256zm96 0h64v-96.6c-22.2-1.6-43.7-6.5-64-14.3V256zm96 0h64V145.2c-20.3 7.8-41.8 12.7-64 14.3V256zm96 0h64V74a223.01 223.01 0 0 1-64 55.8V256zM16 320h16c53 0 96 43 96 96v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16c0-70.7 57.3-128 128-128s128 57.3 128 128v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48c0-53 43-96 96-96h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-35.3 0-64 28.7-64 64v48c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-16c0-53-43-96-96-96s-96 43-96 96v16c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-48c0-35.3-28.7-64-64-64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalBridgeWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBridgeWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 96H32v80.1c53.3 1.9 96 45.7 96 99.5V361c-9.9-5.7-21-8.6-32-8.6v-76.8c0-37.4-30.2-67.6-67.6-67.6C12.7 208 0 195.3 0 179.6V96c0-17.7 14.3-32 32-32h512c17.7 0 32 14.3 32 32v83.6c0 15.7-12.7 28.4-28.4 28.4-37.3 0-67.6 30.2-67.6 67.6v76.9c-11 0-22.1 2.8-32 8.6v-85.5c0-53.8 42.7-97.6 96-99.5V96zM192 384.5V272c0-53 43-96 96-96s96 43 96 96v112.5c-10.4 0-21.3-2.2-32-6.1V272c0-35.3-28.7-64-64-64s-64 28.7-64 64v106.4c-10.3 3.8-21.1 6.1-32 6.1zm0 63.5c20.9 0 41.6-9.9 58.2-21.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z"
        }
    ]
};

const FalBridge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBridge",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h64v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64V64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm448 32v64h-96V64h96zm-128 0v64h-96V64h96zm-128 0v64h-96V64h96zM16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c35.3 0 64 28.7 64 64v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-96c0-35.3 28.7-64 64-64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16c-53 0-96 43-96 96v96c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-96c0-53-43-96-96-96s-96 43-96 96v96c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-96c0-53-43-96-96-96H16z"
        }
    ]
};

const FalBriefcaseArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBriefcaseArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32h160c8.8 0 16 7.2 16 16v48H160V48c0-8.8 7.2-16 16-16zm-48 16v48H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80h304c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h80zm155.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h185.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
        }
    ]
};

const FalBriefcaseBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBriefcaseBlank",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48v48h192V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 48V48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v48h64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm240 32H64c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-80z"
        }
    ]
};

const FalBriefcaseMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBriefcaseMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32h160c8.8 0 16 7.2 16 16v48H160V48c0-8.8 7.2-16 16-16zm-48 16v48H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80h304c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h80zm96 48c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48z"
        }
    ]
};

const FalBriefcase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBriefcase",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48v48h192V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 48V48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v48h64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm240 32H64c-17.7 0-32 14.3-32 32v96h448v-96c0-17.7-14.3-32-32-32h-80zm112 160H336v48c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-48H32v128c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V288zm-272 0v48h96v-48h-96z"
        }
    ]
};

const FalBrightnessLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrightnessLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 80a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-24 112a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm176-176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM56 256a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm96-128a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm256 256a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm0-256a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM104 384a24 24 0 1 0 48 0 24 24 0 1 0-48 0z"
        }
    ]
};

const FalBrightness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrightness",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 104c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v88zm16 88a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 160c8.8 0 16-7.2 16-16v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16zM0 256c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm408-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h88c8.8 0 16-7.2 16-16s-7.2-16-16-16h-88zM75 437c6.2 6.2 16.4 6.2 22.6 0l56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L75 414.4c-6.2 6.2-6.2 16.4 0 22.6zm277.2-299.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L437 97.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-62.2 62.2zM75 75c-6.2 6.2-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L97.6 75c-6.2-6.2-16.4-6.2-22.6 0zm299.8 277.2c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l62.2 62.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-62.2-62.2z"
        }
    ]
};

const FalBringForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBringForward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 480h224c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-64v-32h64c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-64h32v64c0 17.7 14.3 32 32 32zM64 320h224c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32zm224 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64zm-32-96V96H96v160h160zm32 0c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h160c17.7 0 32 14.3 32 32v160z"
        }
    ]
};

const FalBringFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBringFront",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h128c17.7 0 32 14.3 32 32h32c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v128c0 35.3 28.7 64 64 64h64v-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm384 480h128c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64h-64v32h64c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32h-32c0 35.3 28.7 64 64 64zm-32-384c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h192zM224 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H224zm32 96h128v128H256V192zm-32 0v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalBroccoli = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBroccoli",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-37.2 0-69.5 21.2-85.4 52.1-8.4-2.7-17.3-4.1-26.6-4.1-48.6 0-88 39.4-88 88 0 10.7 1.9 20.9 5.4 30.4C25.5 180.3 0 215.2 0 256c0 53 43 96 96 96h8s47.7 54.5 80.2 138.3c5 12.8 17.1 21.7 30.9 21.7H297c13.8 0 25.9-8.9 30.9-21.7C360.3 406.5 408 352 408 352h8c53 0 96-43 96-96 0-40.8-25.5-75.7-61.4-89.6 3.5-9.5 5.4-19.7 5.4-30.4 0-48.6-39.4-88-88-88-9.3 0-18.2 1.4-26.6 4.1C325.5 21.2 293.2 0 256 0zm19.2 352-2 4.9L256 400l-17.2-43.1-2-4.9h38.4zm-72.9 0 24 59.9C231.1 424 242.9 432 256 432s24.9-8 29.7-20.1l24-59.9h57.7c-4.1 5.6-8.9 12.3-13.9 20-16.9 25.5-38.2 62.1-55.4 106.7-.2.6-.6 1-.9 1.2-.1.1-.2.1-.2.1h-81.9s-.1 0-.2-.1c-.3-.2-.6-.6-.9-1.2-17.3-44.6-38.5-81.2-55.4-106.7-5.1-7.7-9.8-14.4-13.9-20h57.7zm-7.7-274.2C202.5 51.3 227 32 256 32s53.5 19.3 61.4 45.8c1.4 4.7 4.8 8.5 9.3 10.3s9.6 1.5 13.9-.9C348.7 82.6 358 80 368 80c30.9 0 56 25.1 56 56 0 11.8-3.6 22.7-9.8 31.7-3.1 4.6-3.7 10.4-1.5 15.5s6.9 8.6 12.4 9.4c31 4.4 54.9 31.1 54.9 63.4 0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64 0-32.3 23.9-59 54.9-63.4 5.5-.8 10.2-4.3 12.4-9.4s1.7-10.9-1.5-15.5c-6.2-9-9.8-19.9-9.8-31.7 0-30.9 25.1-56 56-56 10 0 19.3 2.6 27.4 7.2 4.2 2.4 9.3 2.7 13.9.9s8-5.6 9.3-10.3z"
        }
    ]
};

const FalBroomBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBroomBall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M571.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-208 208 45.3 45.3c4.8 4.8 7.4 11.2 7.4 17.9 0 12.4-9 23-21.2 25l-54.7 9.1 1.4 9.8c6.6 46.3-9 93-42 126-27.8 27.8-65.6 43.5-105 43.5l-171.9.1C10.1 512 0 501.9 0 489.4c0-6 2.4-11.8 6.6-16l59.7-59.7 15-15L96 384H81.3c-8.3 0-15.3-5.8-16.9-13.6-.3-1.2-.4-2.4-.4-3.7 0-29.9 11.9-58.5 33-79.7l10.5-10.5c33.1-33.1 79.7-48.6 126-42l9.8 1.4 9.1-54.7c2-12.2 12.6-21.2 25-21.2 6.7 0 13.2 2.7 17.9 7.4l45.3 45.3 208-208c6.2-6.2 16.4-6.2 22.6 0zm-238 296.6 43.5-7.2-94.9-94.9-7.2 43.5 58.7 58.7zm-79.6-31.6-24.7-3.5c-36.3-5.2-72.9 7-98.9 33l-10.5 10.5c-11.6 11.6-19.3 26.4-22.3 42.3 12.4.5 23.4 8.2 28.2 19.7 5 12 2.2 25.7-6.9 34.9L45.3 480h149.2c30.9 0 60.5-12.3 82.4-34.1 25.9-25.9 38.1-62.6 33-98.9l-3.5-24.7-52.6-52.6zM512 432a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FalBroomWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBroomWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-144 144-18.6-18.6c-20.2-20.2-51.4-24.6-76.3-10.7L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l205.4 205.3c6 6 14.1 9.3 22.6 9.3 11.6 0 22.3-6.3 27.9-16.4l127.4-229.4c13.9-25 9.5-56.1-10.7-76.3l-18.6-18.6 144-144zM299.5 152.8l59.7 59.7c10.1 10.1 12.3 25.7 5.3 38.2l-21.2 38.1-120.1-120.2 38.1-21.2c12.5-6.9 28.1-4.8 38.2 5.3zm-105.4 32 133.1 133.1-90 162.1-123.3-123.3 41.4-41.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-41.4 41.4-59.2-59.3 162.1-90z"
        }
    ]
};

const FalBroom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBroom",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M571.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-208 208-45.3-45.3c-4.8-4.8-11.2-7.4-17.9-7.4-12.4 0-23 9-25 21.2l-9.1 54.7-9.8-1.4c-46.3-6.6-93 9-126 42L97 287c-21.1 21.1-33 49.8-33 79.7 0 1.3.1 2.5.4 3.7 1.7 7.8 8.6 13.6 16.9 13.6H96l-14.7 14.7-15 15-59.7 59.7c-4.2 4.2-6.6 10-6.6 16C0 501.9 10.1 512 22.6 512h171.9c39.4 0 77.2-15.6 105-43.5 33.1-33.1 48.6-79.7 42-126l-1.4-9.8 54.7-9.1c12.2-2 21.2-12.6 21.2-25 0-6.7-2.7-13.2-7.4-17.9l-45.3-45.3 208-208zM274.7 242.7l7.2-43.5 94.9 94.9-43.5 7.2-58.7-58.7zM229 266.2l24.7 3.5 52.6 52.6 3.5 24.7c5.2 36.3-7 72.9-33 98.9-21.8 21.8-51.4 34.1-82.3 34.1H45.3l73.4-73.4c9.2-9.2 11.9-22.9 6.9-34.9-4.8-11.5-15.8-19.2-28.2-19.7 2.9-16 10.7-30.8 22.3-42.4l10.5-10.5c25.9-25.9 62.6-38.1 98.9-33z"
        }
    ]
};

const FalBrowser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrowser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64v64h320V96c0-17.7-14.3-32-32-32H160zm-32 0H64c-17.7 0-32 14.3-32 32v32h96V64zm-96 96v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalBrowsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrowsers",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32c17.7 0 32 14.3 32 32v32H256V32h256zm-352 0h64v64h-96V64c0-17.7 14.3-32 32-32zm-32 320V128h416v224c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zM160 0c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v272c0 70.7 57.3 128 128 128h336c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"
        }
    ]
};

const FalBrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBrush",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 352c-17.7 0-32 14.3-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7-14.3-32-32-32H80c-26.5 0-48-21.5-48-48v-16h320v16c0 26.5-21.5 48-48 48h-48zm96-96H32V64c0-17.7 14.3-32 32-32h32v112c0 8.8 7.2 16 16 16s16-7.2 16-16V32h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16V32h96c17.7 0 32 14.3 32 32v192zM80 384h48v64c0 35.3 28.7 64 64 64s64-28.7 64-64v-64h48c44.2 0 80-35.8 80-80V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v240c0 44.2 35.8 80 80 80z"
        }
    ]
};

const FalBucket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBucket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 144c0 8.8-7.2 16-16 16s-16-7.2-16-16C64 64.5 128.5 0 208 0h32c79.5 0 144 64.5 144 144 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112h-32C146.1 32 96 82.1 96 144zM0 208c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16h-12l-30.7 246c-3 24-23.4 42-47.6 42H106.4c-24.2 0-44.6-18-47.6-42L28 224H16c-8.8 0-16-7.2-16-16zm60.2 16 30.3 242c1 8 7.8 14 15.9 14h235.2c8.1 0 14.9-6 15.9-14l30.2-242H60.2z"
        }
    ]
};

const FalBugSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBugSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 304c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-8c0-22.9-7.4-44.2-20-61.4l79.3-79.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L437.4 180c-17.2-12.6-38.4-20-61.4-20h-74.3l40.5 32H376c39.8 0 72 32.2 72 72v11.5l36.1 28.5H560zM411.4 409.7c-19.7 20.1-46 33.7-75.4 37.4v-96.9l-32-25.3V447c-63.1-7.9-112-61.7-112-127v-56c0-8.5 1.5-16.6 4.2-24.2l-26.1-20.6C163.6 232.8 160 248 160 264v8H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v16c0 30.2 8.4 58.4 22.9 82.5l-82.2 82.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l79-79C231.5 460.1 273.4 480 320 480c46 0 87.4-19.4 116.6-50.4l-25.2-19.9zM224 98.7l37.2 29.3h126.4c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96s-96 43-96 96v2.7zM320 32c35.3 0 64 28.7 64 64H256c0-35.3 28.7-64 64-64zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalBug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBug",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c-35.3 0-64 28.7-64 64h128c0-35.3-28.7-64-64-64zm-96 64c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96zm-123.3 4.7c6.2-6.2 16.4-6.2 22.6 0l79.3 79.3c17.2-12.6 38.4-20 61.4-20h112c22.9 0 44.2 7.4 61.4 20l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L396 202.6c12.6 17.2 20 38.4 20 61.4v8h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v16c0 30.2-8.4 58.4-22.9 82.5l82.2 82.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79-79C344.5 460.1 302.6 480 256 480s-88.5-19.9-117.7-51.6l-79 79c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l82.2-82.2C104.4 378.4 96 350.2 96 320v-16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-8c0-22.9 7.4-44.2 20-61.4l-79.3-79.3c-6.2-6.2-6.2-16.4 0-22.6zM128 320c0 65.3 48.9 119.1 112 127V256c0-8.8 7.2-16 16-16s16 7.2 16 16v191c63.1-7.9 112-61.7 112-127v-56c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v56z"
        }
    ]
};

const FalBugs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBugs",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m156.7 102.8 34-80.6c3.4-8.1-.4-17.5-8.5-21s-17.5.4-21 8.5L128 88.6 94.7 9.8c-3.4-8.1-12.8-12-21-8.5s-12 12.8-8.5 21l34 80.6c-13.8 7-24.8 18.8-30.6 33.2H37.1L31.7 109c-1.7-8.8-10.2-14.4-18.8-12.7S-1.4 106.5.3 115.1l8 40C9.8 162.6 16.4 168 24 168h40v49.8l-45.1 15c-5.7 1.9-9.9 6.9-10.8 12.9l-8 56c-1.2 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6l6.6-46.2 30.9-10.3c10 22.6 32.5 38.3 58.7 38.3s48.7-15.7 58.6-38.3l30.9 10.3 6.6 46.2c1.2 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1l-8-56c-.9-6-5-11-10.8-12.9l-45.1-15V168h40c7.6 0 14.2-5.4 15.7-12.9l8-40c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6l-5.3 27.1h-31.6c-5.8-14.4-16.8-26.2-30.6-33.2zM160 224c0 17.7-14.3 32-32 32s-32-14.3-32-32v-64c0-17.7 14.3-32 32-32s32 14.3 32 32v64zm332.3 55.4 69.7-52.8c7-5.3 8.4-15.4 3.1-22.4s-15.4-8.4-22.4-3.1l-68.2 51.6 10.6-84.9c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-10.8 86.8c-15.4-.9-30.8 3.9-43.1 13.4l-27.3-15.8L381 222c2.8-8.4-1.7-17.5-10-20.3s-17.5 1.7-20.3 10l-13.1 38.6c-2.4 7.2.6 15.2 7.2 19l34.6 20-24.9 43.1-46.5-9.3c-5.9-1.2-12.1 1-15.8 5.8l-34.9 44.5c-5.5 7-4.2 17 2.7 22.5s17 4.2 22.5-2.7l28.8-36.7 32 6.5c-2.7 24.5 8.9 49.4 31.6 62.4s50 10.7 69.9-3.8l21.6 24.4-17.4 43.3c-3.3 8.2.7 17.5 8.9 20.8s17.5-.7 20.8-8.9l21.1-52.5c2.3-5.6 1.1-12-2.9-16.6l-31.5-35.5 24.9-43.1 34.6 20c6.6 3.8 15 2.4 20-3.3l26.9-30.6c5.8-6.6 5.2-16.7-1.5-22.6s-16.7-5.2-22.6 1.5l-18.3 20.8-27.3-15.8c2.2-15.4-1.4-31.1-9.9-44.1zM434.6 386c-8.8 15.3-28.4 20.5-43.7 11.7s-20.6-28.4-11.7-43.7l32-55.4c8.8-15.3 28.4-20.5 43.7-11.7s20.5 28.4 11.7 43.7l-32 55.4z"
        }
    ]
};

const FalBuildingCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingCircleArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h256c17.7 0 32 14.3 32 32v202.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c19.5 0 37-8.7 48.7-22.5-7.7-8-14.6-16.8-20.6-26.1-5.4 9.9-16 16.6-28.1 16.6h-64v-64c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm160 384v64h-64v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-3.3-211.3c-6.2 6.2-6.2 16.4 0 22.6l28.7 28.7H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalBuildingCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h256c17.7 0 32 14.3 32 32v202.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c19.5 0 37-8.7 48.7-22.5-7.7-8-14.6-16.8-20.6-26.1-5.4 9.9-16 16.6-28.1 16.6h-64v-64c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm160 384v64h-64v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zm240-32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalBuildingCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h256c17.7 0 32 14.3 32 32v202.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c19.5 0 37-8.7 48.7-22.5-7.7-8-14.6-16.8-20.6-26.1-5.4 9.9-16 16.6-28.1 16.6h-64v-64c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm160 384v64h-64v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zm128 80a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalBuildingCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h256c17.7 0 32 14.3 32 32v202.8c9.1-12.9 19.9-24.5 32-34.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c19.5 0 37-8.7 48.7-22.5-7.7-8-14.6-16.8-20.6-26.1-5.4 9.9-16 16.6-28.1 16.6h-64v-64c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm160 384v64h-64v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zm128 80a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-121.4 0 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
        }
    ]
};

const FalBuildingColumns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingColumns",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8 0 178 14 192 31.2 192h449.6c17.2 0 31.2-14 31.2-31.2 0-11.2-6-21.6-15.8-27.1L263.9 2.1zM306.6 160c3.5-7.3 5.4-15.4 5.4-24 0-30.9-25.1-56-56-56s-56 25.1-56 56c0 8.6 1.9 16.7 5.4 24H34.3L256 34.4 477.7 160H306.6zM256 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h384c8.8 0 16-7.2 16-16s-7.2-16-16-16V224h-32v128h-80V224h-32v128h-96V224h-32v128H96V224H64v128zm-24 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h432c8.8 0 16-7.2 16-16s-7.2-16-16-16H40zm-24 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalBuildingFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingFlag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h64v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zm160 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64v-64zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H128zM64 120c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24v-48zm32 8v32h32v-32H96zm152-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm8 64h32v-32h-32v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24v-48zm32 8v32h32v-32H96zm152-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm8 64h32v-32h-32v32zM432 0c8.8 0 16 7.2 16 16v16h160c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448v272c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zm16 192h160V64H448v128z"
        }
    ]
};

const FalBuildingLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h256c17.7 0 32 14.3 32 32v208c0-30.5 12.2-58.2 32-78.4V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c2.8 0 5.6-.2 8.3-.5-5.3-9.3-8.3-20-8.3-31.5h-64v-64c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm160 384v64h-64v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zm208-64c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80v128H384V352h160z"
        }
    ]
};

const FalBuildingNgo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingNgo",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32H64c-11.8 0-22.2 6.4-27.7 16H2C9.1 20.4 34.2 0 64 0h256c29.8 0 54.9 20.4 62 48h-34.3c-5.5-9.6-15.9-16-27.7-16zM0 240h32v208c0 17.7 14.3 32 32 32h64v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V240h32v208c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V240zm192 144c-17.7 0-32 14.3-32 32v64h64v-64c0-17.7-14.3-32-32-32zM168 80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V96c0-8.8 7.2-16 16-16zm136 32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32zM61.3 87.1l34.7 52V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4L64 148.8V192c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM208 264c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48zm32 8v32h32v-32h-32zm-136-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm8 64h32v-32h-32v32z"
        }
    ]
};

const FalBuildingShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingShield",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h64v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c1.3 0 2.6-.1 3.9-.2 7.9 8.6 16.6 16.9 26.3 24.7-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v143l-32 12.8V64c0-17.7-14.3-32-32-32zm-48 208c-8.8 0-16 7.2-16 16v64h-8c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h48c8.2 0 15.4 4.1 19.7 10.3l-14.1 5.7H272zm-80 144c-17.7 0-32 14.3-32 32v64h64v-64c0-17.7-14.3-32-32-32zM88 96h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm8 64h32v-32H96v32zm128-40c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48zm32 8v32h32v-32h-32zM88 224h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm8 64h32v-32H96v32zm224.1 13.4c1.3 53 22.6 129.5 95.9 170V263l-95.9 38.4zm223.9 0L448 263v208.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7 120 48c9 3.7 15 12.5 15 22.3 0 63.3-25.9 168.8-134.8 214.2-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z"
        }
    ]
};

const FalBuildingUn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingUn",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h64v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zm160 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64v-64zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H128zm120-288h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm8 64h32v-32h-32v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24v-48zm32 8v32h32v-32H96zM237.3 71.1l34.7 52V80c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V176c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM112 80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalBuildingUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h256c17.7 0 32 14.3 32 32v329.4c9.2-10.2 20-18.9 32-25.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c3.2 0 6.4-.2 9.5-.7-5.5-9.2-8.9-19.9-9.4-31.3H256v-64c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm160 384v64h-64v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM64 120v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zM64 248v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24zm32 8h32v32H96v-32zm152-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm8 64v-32h32v32h-32zm192-16a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM384 477.1c0-33.7 27.4-61.1 61.1-61.1h101.8c33.7 0 61.1 27.4 61.1 61.1 0 1.6-1.3 2.9-2.9 2.9H386.9c-1.6 0-2.9-1.3-2.9-2.9zm61.1-93.1c-51.4 0-93.1 41.7-93.1 93.1 0 19.3 15.6 34.9 34.9 34.9h218.2c19.3 0 34.9-15.6 34.9-34.9 0-51.4-41.7-93.1-93.1-93.1H445.1z"
        }
    ]
};

const FalBuildingWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildingWheat",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32h-64v-64c0-35.3-28.7-64-64-64s-64 28.7-64 64v64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h256zM192 384c17.7 0 32 14.3 32 32v64h-64v-64c0-17.7 14.3-32 32-32zM64 512h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64zM88 96c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88zm8 64v-32h32v32H96zm128-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zm32 8h32v32h-32v-32zM88 224c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88zm8 64v-32h32v32H96zm128-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zm32 8h32v32h-32v-32zm368-64h-16c-33.4 0-62.8 17-80 42.9-17.2-25.9-46.6-42.9-80-42.9h-16c-8.8 0-16 7.2-16 16v16c0 24.6 9.2 47 24.4 64H432c-8.8 0-16 7.2-16 16v16c0 24.6 9.2 47 24.4 64H432c-8.8 0-16 7.2-16 16v16c0 53 43 96 96 96h32c53 0 96-43 96-96v-16c0-8.8-7.2-16-16-16h-8.4c15.2-17 24.4-39.4 24.4-64v-16c0-8.8-7.2-16-16-16h-8.4c15.2-17 24.4-39.4 24.4-64v-16c0-8.8-7.2-16-16-16zm-80 96c0-35.3 28.7-64 64-64 0 35.3-28.7 64-64 64zm-32 0c-35.3 0-64-28.7-64-64 35.3 0 64 28.7 64 64zm16 32h8.4c-3.1 3.4-5.9 7.1-8.4 10.9-2.6-3.8-5.4-7.5-8.4-10.9h8.4zm0 106.9c-2.6-3.8-5.4-7.5-8.4-10.9h16.8c-3.1 3.4-5.9 7.1-8.4 10.9zm16-42.9c0-35.3 28.7-64 64-64 0 35.3-28.7 64-64 64zm-32 0c-35.3 0-64-28.7-64-64 35.3 0 64 28.7 64 64zm32 96c0-35.3 28.7-64 64-64 0 35.3-28.7 64-64 64zm-32 0c-35.3 0-64-28.7-64-64 35.3 0 64 28.7 64 64zm16-448c-8.8 0-16 7.2-16 16v112c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm64 48c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zm-144 64c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v48z"
        }
    ]
};

const FalBuilding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuilding",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h64v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zm160 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64v-64zm-96 96H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H128zM64 120c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24v-48zm32 8v32h32v-32H96zm152-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm8 64h32v-32h-32v32zM64 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24v-48zm32 8v32h32v-32H96zm152-32h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm8 64h32v-32h-32v32z"
        }
    ]
};

const FalBuildings = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuildings",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h160zM288 0c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H288zm-96 128H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h152.4c-8.3-9.2-14.8-20.1-19-32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h128v-32zM88 320c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88zm8 64v-32h32v32H96zm224 8c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v48zm32-8v-32h32v32h-32zM88 192c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88zm8 64v-32h32v32H96zM320 88v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zm32 8h32v32h-32V96zm-8 192h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24zm8-64h32v32h-32v-32z"
        }
    ]
};

const FalBullhorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBullhorn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 44.2c0-7.2-8.8-10.8-13.8-5.5l-23.8 25.2c-41.9 44.1-95.7 74.5-154.4 87.6v177c58.7 13.1 112.5 43.4 154.4 87.6l23.8 25.1c5 5.3 13.8 1.7 13.8-5.5V44.2zM192 323.1V156.9c-5.8.7-11.6 1.1-17.5 1.5l-29.6 1.6H64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h80.8l29.7 1.6c5.8.3 11.7.8 17.5 1.5zM379 16.7c24.9-26.3 69-8.7 69 27.5v391.6c0 36.2-44.2 53.8-69 27.5l-23.8-25.1c-43.3-45.7-101-74.9-163.1-82.8V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56V352c-35.3 0-64-28.7-64-64v-96c0-35.3 28.7-64 64-64h79.6l29.2-1.6c69.4-3.9 134.6-34.1 182.4-84.5L379 16.7zM96 352v104c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V352.9l-16.4-.9H96zm400-160c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalBullseyeArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBullseyeArrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M326.3 9.8C304 3.4 280.4 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-24.4-3.4-48-9.8-70.3l-22.8 25.4c-1.1 1.2-2.1 2.3-3.3 3.4 2.5 13.5 3.8 27.3 3.8 41.5 0 123.7-100.3 224-224 224S32 379.7 32 256 132.3 32 256 32c14.2 0 28.1 1.3 41.5 3.8 1.1-1.1 2.2-2.2 3.4-3.3l25.4-22.7zm-51.7 87.3c-6.1-.7-12.3-1.1-18.6-1.1-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160c0-6.3-.4-12.5-1.1-18.6-2.7-.2-5.4-.5-8.1-.9l-25-4.2c1.4 7.7 2.2 15.6 2.2 23.7 0 70.7-57.3 128-128 128s-128-57.3-128-128 57.3-128 128-128c8.1 0 16 .8 23.7 2.2l-4.2-25c-.5-2.7-.8-5.4-.9-8.1zm66.9 96.1 70.4 11.7c16.3 2.7 32.8-3.1 43.8-15.5l43.9-49.4c11.7-13.1 5.8-33.9-11-38.9l-59.7-17.9-18-59.8c-5-16.8-25.8-22.7-38.9-11l-49.4 43.9c-12.3 11-18.2 27.5-15.5 43.8l11.7 70.4-74.2 74.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l74.2-74.2zm27.8-27.8 51.3-51.3 46.8 14-35.6 40c-3.7 4.1-9.2 6.1-14.6 5.2l-47.9-8zm28.6-73.9-51.3 51.3-8-47.9c-.9-5.4 1-10.9 5.2-14.6l40-35.6 14 46.8z"
        }
    ]
};

const FalBullseyePointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBullseyePointer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480c123.7 0 224-100.3 224-224S379.7 32 256 32 32 132.3 32 256c0 10.4.7 20.6 2.1 30.6l-9.6 3.5C16.7 293 9.8 297.8 4.6 304 1.5 288.5 0 272.4 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256-114.6 256-256 256c-16.4 0-32.5-1.5-48.1-4.5 6.2-5.3 11-12.1 13.9-19.9l3.5-9.6c10 1.4 20.2 2.1 30.6 2.1zm-7.7-64.2 11.7-31.9c68.8-2.1 124-58.6 124-127.9 0-70.7-57.3-128-128-128-69.3 0-125.8 55.1-127.9 124l-31.9 11.7c-.1-2.6-.2-5.1-.2-7.7 0-88.4 71.6-160 160-160s160 71.6 160 160-71.6 160-160 160c-2.6 0-5.2-.1-7.7-.2zM271 261.5l-79.2 215c-2.3 6.2-8.1 10.3-14.7 10.5s-12.6-3.8-15.1-9.9l-30.5-74L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l104.2-104.2-74-30.5c-6.1-2.5-10-8.5-9.9-15.1s4.3-12.4 10.5-14.7l215-79.2c5.9-2.2 12.4-.7 16.8 3.7s5.9 11 3.7 16.8zM143.3 360c3.9 1.6 7.1 4.8 8.7 8.7l24 58.2L229 283 85.1 336l58.2 24z"
        }
    ]
};

const FalBullseye = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBullseye",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 128a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-288a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FalBuoyMooring = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuoyMooring",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 16c0-8.8 7.2-16 16-16s16 7.2 16 16v49.1c46.7 6.7 85.5 42.3 94.6 89.9l45.8 240.3c-.4.3-.8.5-1.2.8-8.8 6.1-18.5 11.1-28.5 14.6L397.4 320H178.6l-17.3 90.7c-9.9-3.5-19.7-8.5-28.4-14.6-.4-.3-.8-.6-1.2-.8L177.4 155c9.1-47.6 47.8-83.2 94.6-89.9V16zm-63.1 145-24.2 127h206.6l-24.2-127c-7.1-37.6-40.6-65-79.1-65s-72 27.4-79.1 65zM192 480c20.9 0 41.6-9.9 58.2-21.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z"
        }
    ]
};

const FalBuoy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBuoy",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h12.3L147 304H96c-17.7 0-32 14.3-32 32v16c0 13.3 1.8 26.1 5.2 38.3 10-4.6 20.9-6.5 31.7-5.7-3.2-10.3-4.9-21.2-4.9-32.6v-16h384v16c0 11.4-1.7 22.3-4.8 32.6 10.8-.8 21.7 1.1 31.7 5.7 3.4-12.2 5.2-25.1 5.2-38.3v-16c0-17.7-14.3-32-32-32H429L371.7 32H384c8.8 0 16-7.2 16-16s-7.2-16-16-16H192zm147 32 9.8 46.4-60.8 76-60.8-76L237 32h102zm-120.3 87 48.8 61-83.7 104.6L218.7 119zm69.3 86.6 78.7 98.4H209.3l78.7-98.4zm104.2 79L308.5 180l48.8-61 34.9 165.7zM192 480c-20.9 0-41.7-9.9-58.2-21.2-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"
        }
    ]
};

const FalBurgerCheese = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBurgerCheese",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M445 221.8C428.9 132.1 350.4 64 256 64S83.1 132.1 67 221.8v.1c0 .1.1.2.3.3.7.8 2.4 1.7 4.7 1.7h368c2.4 0 4-1 4.7-1.7l.3-.3v-.1zM72 256c-22.1 0-40.4-18.1-36.5-39.8C54.3 111.5 145.9 32 256 32s201.7 79.5 220.5 184.2c3.9 21.7-14.4 39.8-36.5 39.8H72zm358.5 96H448c17.7 0 32 14.3 32 32 0 53-43 96-96 96H128c-53 0-96-43-96-96 0-17.7 14.3-32 32-32h145.5l48 32H64c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64h-65.5l48-32zM160 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80-16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm112 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 288h192c3.2 0 6.2.9 8.9 2.7l87.1 58.1 87.1-58.1c2.6-1.8 5.7-2.7 8.9-2.7h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-59.2l-92 61.3c-5.4 3.6-12.4 3.6-17.8 0L219 320H32c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalBurgerFries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBurgerFries",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3v218.4c-8.5 2.4-19 4.3-32 5.1V57.9l-32-16v229.6c-13-.9-23.5-2.7-32-5.1V16c0-5.5 2.9-10.7 7.6-13.6zm127.5 231.4c-1 4-2.9 9-7.1 14.1v-39.3l27.1-124.1-27.1 5.4V57.3l44.9-9c5.3-1.1 10.8.6 14.6 4.5s5.4 9.4 4.2 14.6l-28.4 130c-15.5 8-24.9 23.6-28 36.4zm88.7-55.6c-10.2 4.1-19.5 8.8-28.1 13.7h-7.2l19.8-99.1c1.7-8.7 10.2-14.3 18.8-12.6s14.3 10.2 12.6 18.8l-15.8 79.1zM192 304c27.6 0 48.8-3.7 65.2-9.5-.9 6.3-1.2 12.4-1.2 18.1 0 5.3.7 10.3 2.1 15.2-18.6 5.3-40.4 8.2-66.1 8.2-49.1 0-84.4-10.7-109.1-28.4C61 291.8 50 272.4 44.7 256h-9.8l54.3 224H260c3.7 11.9 9.7 22.7 17.6 32H89.2c-14.8 0-27.6-10.1-31.1-24.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224h32.9c9.5 0 17.2 8.3 19.5 17.5C79.6 265 102.7 304 192 304zM21.4 192c-.9 0-1.7 0-2.5.1L.3 99.1C-1.4 90.5 4.2 82 12.9 80.3S30 84.2 31.7 92.9L51.5 192H21.4zm98.8 63.6c-10.3-7.4-13.9-15.8-15.4-21.7-3-12.1-11.4-26.5-25.2-34.9L56.2 58.6c-1.2-6.9 2.3-13.8 8.6-16.9L112 18.1v35.8L89.7 65l31.9 191.5c-.5-.3-1-.7-1.4-1zm210.7 23.9c-5.7 6.2-9.2 14.6-10.4 24.4h287c-1.2-9.8-4.7-18.2-10.4-24.4-8.3-9-20.6-20.1-37.1-30.1-.8 8.1-7.6 14.5-15.9 14.5-8.8 0-16-7.2-16-16 0-4.6 1.9-8.7 5-11.6-15.7-6.1-33.9-10.5-54.9-11.9 1.2 2.2 1.9 4.8 1.9 7.5 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7.7-5.3 1.9-7.5-21 1.4-39.2 5.9-54.9 11.9 3.1 2.9 5 7 5 11.6 0 8.8-7.2 16-16 16-8.3 0-15.1-6.3-15.9-14.5-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9 14.6 15.7 19.5 36.1 19.5 54.7 0 12.9-10.5 23.4-23.4 23.4H311.4c-12.9 0-23.4-10.5-23.4-23.4 0-18.7 4.9-39.1 19.5-54.7 24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3h277.4c20.6 0 37.3 16.7 37.3 37.3 0 32.4-26.3 58.7-58.7 58.7H346.7c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3 0 14.7 11.9 26.7 26.7 26.7h234.6c14.7 0 26.7-11.9 26.7-26.7 0-2.9-2.4-5.3-5.3-5.3H325.3z"
        }
    ]
};

const FalBurgerGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBurgerGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.1 40.7 42.2 160h299.5l10.1-119.3c.4-4.7-3.3-8.7-8-8.7H40.1c-4.7 0-8.4 4-8 8.7zM44.9 192l21.8 258.7c1.4 16.6 15.2 29.3 31.9 29.3H260c3.7 11.9 9.7 22.7 17.6 32h-179c-33.3 0-61-25.5-63.8-58.6L.2 43.4C-1.7 20 16.7 0 40.1 0h303.7c23.4 0 41.8 20 39.9 43.4l-11.2 133.1c-12.2 4.7-23.4 10.1-33.5 16v-.4H44.9zM331 279.4c-5.7 6.2-9.2 14.6-10.4 24.4h287c-1.2-9.8-4.7-18.2-10.4-24.4-8.3-9-20.6-20.1-37.1-30.1-.8 8.1-7.6 14.5-15.9 14.5-8.8 0-16-7.2-16-16 0-4.6 1.9-8.7 5-11.6-15.7-6.1-33.9-10.5-54.9-11.9 1.2 2.2 1.9 4.8 1.9 7.5 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7.7-5.3 1.9-7.5-21 1.4-39.2 5.9-54.9 11.9 3.1 2.9 5 7 5 11.6 0 8.8-7.2 16-16 16-8.3 0-15.1-6.3-15.9-14.5-16.6 10-28.8 21.1-37.1 30.1zm133-87.6c82 0 132.6 40 156.5 65.9 14.6 15.7 19.5 36.1 19.5 54.7 0 12.9-10.5 23.4-23.4 23.4H311.4c-12.9 0-23.4-10.5-23.4-23.4 0-18.7 4.9-39.1 19.5-54.7 24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3h277.4c20.6 0 37.3 16.7 37.3 37.3 0 32.4-26.3 58.7-58.7 58.7H346.7c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3 0 14.7 11.9 26.7 26.7 26.7h234.6c14.7 0 26.7-11.9 26.7-26.7 0-2.9-2.4-5.3-5.3-5.3H325.3z"
        }
    ]
};

const FalBurgerLettuce = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBurgerLettuce",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64c94.4 0 172.9 68.1 189 157.8v.1c0 .1-.1.2-.3.3-.7.8-2.4 1.7-4.7 1.7H72c-2.4 0-4-1-4.7-1.7l-.3-.3v-.1C83.1 132.1 161.6 64 256 64zM35.5 216.2C31.6 237.9 49.9 256 72 256h368c22.1 0 40.4-18.1 36.5-39.8C457.7 111.5 366.1 32 256 32S54.3 111.5 35.5 216.2zM128 448c-35.3 0-64-28.7-64-64h384c0 35.3-28.7 64-64 64H128zm-96-64c0 53 43 96 96 96h256c53 0 96-43 96-96 0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm144-240a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm80-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112 16a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM80 334.4c19.6 0 35.2-9.4 47.6-16.8l2.1-1.3c13.5-8.1 24.4-14 38.3-14 13.5 0 22.2 5.5 34.9 13.7s28.6 18.3 53.1 18.3c24.4 0 39.5-10.1 51.6-18.1l.4-.3c11.8-7.9 20.7-13.6 36-13.6 15.7 0 26.7 6 39.5 13.9l2.6 1.6c11.7 7.3 26.6 16.5 45.9 16.5 18.5 0 32.7-4.6 42.4-9.5 4.9-2.4 8.6-4.9 11.2-6.9 1.3-1 2.3-1.8 3.1-2.5.4-.3.7-.6.9-.8l.3-.3.1-.1h.1L479.9 304l10.2 10.2c5.6-5.6 5.6-14.7 0-20.4-5.6-5.6-14.6-5.6-20.2-.1l-.2.2c-.2.2-.7.6-1.4 1.1-1.4 1-3.7 2.6-6.8 4.1-6.2 3.1-16 6.5-29.6 6.5-10.9 0-19.2-5.1-32.6-13.4l-.8-.5c-13.3-8.2-30.3-18.1-54.5-18.1-24.4 0-39.5 10.1-51.6 18.1l-.4.3c-11.8 7.9-20.7 13.6-36 13.6-15.5 0-25.3-5.9-37.5-13.7l-1.4-.9c-11.9-7.7-26.9-17.4-49.1-17.4-22.7 0-39.8 10.1-53.1 18-14.2 8.5-23.6 14-34.9 14-13.5 0-23.3-3.4-29.6-6.5-3.1-1.6-5.4-3.1-6.8-4.1-.7-.5-1.2-.9-1.4-1.1l-.2-.2c-5.6-5.5-14.7-5.4-20.2.1-5.6 5.6-5.6 14.7 0 20.4L32 304l-10.2 10.2.1.1.3.3c.2.2.6.5.9.8.8.7 1.8 1.5 3.1 2.5 2.6 2 6.3 4.4 11.2 6.9 9.8 4.9 24 9.5 42.4 9.5z"
        }
    ]
};

const FalBurgerSoda = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBurgerSoda",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M202.4 36.4C207.8 15 227 0 249 0h23c8.8 0 16 7.2 16 16s-7.2 16-16 16h-23c-7.3 0-13.7 5-15.5 12.1l-21 83.9H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h163.5l22.9-91.6zM60.3 468l-23-276h32.1l22.8 273.3c.7 8.3 7.6 14.7 15.9 14.7H260c3.7 11.9 9.7 22.7 17.5 32H108.2c-25 0-45.8-19.1-47.8-44zm270.6-188.6c-5.7 6.2-9.2 14.6-10.4 24.4h287c-1.2-9.8-4.7-18.2-10.4-24.4-8.3-9-20.6-20.1-37.1-30.1-.8 8.1-7.6 14.5-15.9 14.5-8.8 0-16-7.2-16-16 0-4.6 1.9-8.7 5-11.6-15.7-6.1-33.9-10.5-54.9-11.9 1.2 2.2 1.9 4.8 1.9 7.5 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-2.7.7-5.3 1.9-7.5-21 1.4-39.2 5.9-54.9 11.9 3.1 2.9 5 7 5 11.6 0 8.8-7.2 16-16 16-8.3 0-15.1-6.3-15.9-14.5-16.6 10-28.8 21.1-37.1 30.1zM464 191.8c82 0 132.6 40 156.5 65.9 14.6 15.7 19.5 36.1 19.5 54.7 0 12.9-10.5 23.4-23.4 23.4H311.4c-12.9 0-23.4-10.5-23.4-23.4 0-18.7 4.9-39.1 19.5-54.7 24-25.8 74.5-65.9 156.5-65.9zm-176 184c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 77.3c0-20.6 16.7-37.3 37.3-37.3h277.4c20.6 0 37.3 16.7 37.3 37.3 0 32.4-26.3 58.7-58.7 58.7H346.7c-32.4 0-58.7-26.3-58.7-58.7zm37.3-5.3c-2.9 0-5.3 2.4-5.3 5.3 0 14.7 11.9 26.7 26.7 26.7h234.6c14.7 0 26.7-11.9 26.7-26.7 0-2.9-2.4-5.3-5.3-5.3H325.3z"
        }
    ]
};

const FalBurger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBurger",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64c94.4 0 172.9 68.1 189 157.8v.1c0 .1-.1.2-.3.3-.7.8-2.4 1.7-4.7 1.7H72c-2.4 0-4-1-4.7-1.7l-.3-.3v-.1C83.1 132.1 161.6 64 256 64zm184 192c22.1 0 40.4-18.1 36.5-39.8C457.7 111.5 366.1 32 256 32S54.3 111.5 35.5 216.2C31.6 237.9 49.9 256 72 256h368zM128 448c-35.3 0-64-28.7-64-64h384c0 35.3-28.7 64-64 64H128zm-96-64c0 53 43 96 96 96h256c53 0 96-43 96-96 0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm-16-80c0 8.8 7.2 16 16 16h448c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16zm144-144a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm112-48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalBurrito = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBurrito",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M242 62c8.2-35.5 40-62 78-62 11.4 0 22.2 2.4 32 6.7 9.8-4.3 20.6-6.7 32-6.7 34.6 0 64.1 22 75.2 52.8C490 63.9 512 93.4 512 128c0 11.4-2.4 22.2-6.7 32 4.3 9.8 6.7 20.6 6.7 32 0 38-26.5 69.8-62 78L241.9 478.1C220.2 499.8 190.7 512 160 512s-60.2-12.2-81.9-33.9l-44.2-44.2C12.2 412.2 0 382.7 0 352s12.2-60.2 33.9-81.9L242 62zm44-15.9c21.5 32.7 34 71.8 34 113.9 0 11.9-1 23.6-2.9 34.9 11.4-1.9 23-2.9 34.9-2.9 42.1 0 81.2 12.5 113.9 33.9 8.7-8.7 14.1-20.7 14.1-34 0-8.8-2.3-16.9-6.4-24-2.9-5-2.9-11.1 0-16 4.1-7 6.4-15.2 6.4-24 0-22.8-15.9-41.9-37.2-46.8-6-1.4-10.6-6-12-12-4.9-21.2-24-37.1-46.8-37.1-8.8 0-16.9 2.3-24 6.4-5 2.9-11.1 2.9-16 0-7-4.1-15.2-6.4-24-6.4-13.3 0-25.3 5.4-33.9 14.1zM56.6 411.3l44.1 44.1c15.7 15.8 37.1 24.6 59.3 24.6s43.6-8.8 59.3-24.6L431.7 243c-23.9-12.2-51-19-79.7-19-15.2 0-29.9 1.9-43.9 5.5C279.5 310.2 202.5 368 112 368c-28.3 0-55.4-5.7-80-15.9 0 22.2 8.9 43.5 24.6 59.3zm0-118.6c-7.9 7.9-14 17.1-18.2 27.2C60.8 330.2 85.7 336 112 336c79.2 0 146.2-52.3 168.3-124.3 5-16.3 7.7-33.7 7.7-51.7 0-28.7-6.9-55.8-19-79.7L56.6 292.7z"
        }
    ]
};

const FalBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBurst",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M146.5 211.2c3.3-9.6 1.8-20.1-3.9-28.4L54.9 54.9l127.9 87.7c8.3 5.7 18.9 7.2 28.4 3.9s17-10.8 20.1-20.4L256 50l26.9 83c2.7 8.3 8.6 15.1 16.4 18.9s16.8 4.3 25 1.3l54.3-19.8-19.8 54.3c-3 8.2-2.5 17.2 1.3 25s10.6 13.7 18.9 16.4l83 26.9-79.6 25.8c-9 2.9-16.2 9.6-19.8 18.4s-3.1 18.6 1.3 27l40.9 77.8-77.7-41c-8.4-4.4-18.2-4.9-27-1.3s-15.5 10.8-18.4 19.8L256 462l-25.8-79.6c-2.9-9-9.6-16.2-18.4-19.8s-18.6-3.1-27 1.3L107 404.8l41-77.7c4.4-8.4 4.9-18.2 1.3-27s-10.8-15.5-19.8-18.4L50 256l76.1-24.7c9.6-3.1 17.2-10.6 20.4-20.1zm26.9-113.9L37.6 4.2C28-2.3 15.2-1.1 7 7s-9.4 21-2.8 30.5l93.1 135.9 18.9 27.5-31.7 10.3-67.9 22C6.7 236.4 0 245.6 0 256s6.7 19.6 16.6 22.8l72.2 23.4 30.9 10-15.1 28.8-37.8 71.8c-4.9 9.3-3.2 20.7 4.3 28.1s18.8 9.2 28.1 4.3l71.8-37.8 28.7-15.1 10 30.9 23.4 72.2c3.2 9.9 12.4 16.6 22.8 16.6s19.6-6.7 22.8-16.6l23.4-72.2 10-30.9 28.9 15.1 71.9 37.8c9.3 4.9 20.7 3.2 28.1-4.3s9.2-18.8 4.3-28.1L407.4 341l-15.1-28.7 30.9-10 72.2-23.4c9.9-3.2 16.6-12.4 16.6-22.8s-6.7-19.6-16.6-22.8l-76.1-24.6-30.5-9.9 11-30.1 14.7-40.4c3.2-8.8 1-18.6-5.6-25.2s-16.4-8.8-25.2-5.6l-40.4 14.7-30.1 11-9.9-30.5-24.6-76C275.6 6.7 266.4 0 256 0s-19.6 6.7-22.8 16.6l-22 67.9-10.3 31.7-27.5-18.9z"
        }
    ]
};

const FalBusSchool = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBusSchool",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c105.1 0 146.3 31.1 158.8 47 .4.6 1.2 2.1 1.2 5.3V128H96V84.3c0-3.3.8-4.5 1-4.8C110.9 63.2 158.3 32 256 32zM96 245.5V160h144v80H128c-11.2 0-22 1.9-32 5.5zm176-5.5v-80h144v85.5c-10-3.5-20.8-5.5-32-5.5H272zm176 24.4V84.3c0-7.7-1.8-17.1-8.1-25.1C419.2 32.9 366.9 0 256 0 152.4 0 94.5 33 72.6 58.8 65.8 66.9 64 76.6 64 84.3v180.1C44.4 282 32 307.6 32 336v56c0 22.3 13.1 41.6 32 50.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h320v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-53.4c18.9-9 32-28.3 32-50.6v-56c0-28.4-12.4-54-32-71.6zM128 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM64 336c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v56c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24v-56zM192 80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zM32 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm480 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalBusSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBusSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M33.2 90c16-19.8 72.9-58 190.8-58 126.8 0 175.9 38.1 190.7 57.5.6.8 1.3 2.5 1.3 5.6v.9H32v-.8c0-3.2.8-4.6 1.2-5.1zM32 128h384v128H32V128zm384 160v96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-96h384zM224 0C100.2 0 32.5 40.1 8.3 69.9 1.8 77.9 0 87.4 0 95.2V384c0 23.7 12.9 44.4 32 55.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h320v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-56.6c19.1-11.1 32-31.7 32-55.4V95.2c0-7.8-1.8-17-7.8-25C417.2 40 356.6 0 224 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalBus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32C170.1 32 113.2 70.2 97.2 90c-.4.5-1.2 1.9-1.2 5.1V128h384V95.2c0-3.1-.8-4.9-1.3-5.6C463.9 70.1 414.8 32 288 32zM96 256h176v-96H96v96zm208 0h176v-96H304v96zM96 384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-96H96v96zM72.3 69.9C96.5 40.1 164.2 0 288 0c132.6 0 193.2 40 216.2 70.2 6 7.9 7.8 17.2 7.8 25V384c0 23.7-12.9 44.4-32 55.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H128v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-56.6c-19.1-11-32-31.7-32-55.4V95.2c0-7.7 1.8-17.2 8.3-25.3zM136 352a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm280-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM240 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zM32 144v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm544 0v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalBusinessTime = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalBusinessTime",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48v48h192V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 48V48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v48h64c35.3 0 64 28.7 64 64v32.7c-5.3-.5-10.6-.7-16-.7s-10.7.2-16 .7V160c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v96h328.2c-8.1 9.8-15.2 20.6-21 32H208v48h114.9c-1.9 10.4-2.9 21.1-2.9 32H208c-17.7 0-32-14.3-32-32v-48H32v128c0 17.7 14.3 32 32 32h275.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm368 384a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalButter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalButter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 96v192h-32V96H128c-17.7 0-32 14.3-32 32v160H64V128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v160h-32V128c0-17.7-14.3-32-32-32h-32zM0 336c0-8.8 7.2-16 16-16h608c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v48c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-48H16c-8.8 0-16-7.2-16-16zm64 16v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-48H64z"
        }
    ]
};

const FalC = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalC",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M356.9 120.3c-74.4-75-194.9-75-269.3 0s-74.4 196.5 0 271.4 194.9 75 269.3 0c6.2-6.3 16.3-6.3 22.5 0s6.2 16.4 0 22.7c-86.8 87.5-227.5 87.5-314.4 0S-21.8 185 65 97.5s227.5-87.5 314.4 0c6.2 6.3 6.2 16.4 0 22.7s-16.3 6.3-22.5 0z"
        }
    ]
};

const FalCabin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCabin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M237.1 10c11.3-8.3 26.6-8.3 37.8 0L352 66.6V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v104h-.6l13 9.6c12.3 9 19.6 23.3 19.6 38.6 0 21.4-14 39.5-33.3 45.6.9 3.3 1.3 6.7 1.3 10.2v16c0 9-3 17.3-8 24 5 6.7 8 15 8 24v16c0 9-3 17.3-8 24 5 6.7 8 15 8 24v16c0 9-3 17.3-8 24 5 6.7 8 15 8 24v16c0 22.1-17.9 40-40 40h-80c-22.1 0-40-17.9-40-40v-16c0-9 3-17.3 8-24-5-6.7-8-15-8-24v-16c0-9 3-17.3 8-24-5-6.7-8-15-8-24v-16c0-9 3-17.3 8-24-5-6.7-8-15-8-24v-16c0-2.7.3-5.4.8-8H191.2c.5 2.6.8 5.3.8 8v16c0 9-3 17.3-8 24 5 6.7 8 15 8 24v16c0 9-3 17.3-8 24 5 6.7 8 15 8 24v16c0 9-3 17.3-8 24 5 6.7 8 15 8 24v16c0 22.1-17.9 40-40 40H72c-22.1 0-40-17.9-40-40v-16c0-9 3-17.3 8-24-5-6.7-8-15-8-24v-16c0-9 3-17.3 8-24-5-6.7-8-15-8-24v-16c0-9 3-17.3 8-24-5-6.7-8-15-8-24v-16c0-3.5.5-7 1.3-10.2C14 247.6 0 229.5 0 208.1c0-15.2 7.3-29.6 19.6-38.6L237.1 10zM360 416h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm80 32h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm8-104v-16c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zm-88-120h104.1c8.8 0 15.9-7.1 15.9-15.9 0-5.1-2.4-9.8-6.5-12.8L256 35.8 38.5 195.4c-4.1 3-6.5 7.7-6.5 12.8 0 8.8 7.1 15.9 15.9 15.9H360zm0 32c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-80zM72 416h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm80 32H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8zm8-104v-16c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8zm-88-88c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H72zm376-119V64h-64v26l64 47zm-192-9a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FalCabinetFiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCabinetFiling",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 240H32V64c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v176zM0 256v192c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v192zm416 192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V272h384v176zM160 96c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h128v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16c0-17.7-14.3-32-32-32H160zm0 256c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h128v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16c0-17.7-14.3-32-32-32H160z"
        }
    ]
};

const FalCableCar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCableCar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-72 8a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm104 200v96H192v-96h128zm32 0h64c17.7 0 32 14.3 32 32v64h-96v-96zm96 128v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64h384zM64 352v-64c0-17.7 14.3-32 32-32h64v96H64zm352-128H272v-82.9l227.1-45.4c8.7-1.7 14.3-10.2 12.6-18.8s-10.2-14.3-18.8-12.6l-240 48-240 48C4.2 162-1.4 170.5.3 179.1s10.2 14.3 18.8 12.6L240 147.5V224H96c-35.3 0-64 28.7-64 64v160c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64z"
        }
    ]
};

const FalCactus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCactus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 464c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16V96c0-35.3 28.7-64 64-64s64 28.7 64 64v368zm32-112V96c0-53-43-96-96-96s-96 43-96 96v128h-48c-8.8 0-16-7.2-16-16v-64c0-26.5-21.5-48-48-48S0 117.5 0 144v64c0 61.9 50.1 112 112 112h48v144c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-16h48c61.9 0 112-50.1 112-112v-64c0-26.5-21.5-48-48-48s-48 21.5-48 48v64c0 8.8-7.2 16-16 16h-48zm0 32h48c26.5 0 48-21.5 48-48v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 44.2-35.8 80-80 80h-48v-32zm-240-96c-44.2 0-80-35.8-80-80v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5 21.5 48 48 48h48v32h-48zm144-144a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm16 240a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalCakeCandles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCakeCandles",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M82.5 70.9c-1.6 2.6-2.5 5.7-2.5 8.8C80 88.8 87.4 96 96 96s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L96 49.7 82.5 70.9zm-27-17.1L86.2 5.4C88.3 2 92 0 96 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26 0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26zM384 256h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H64c-17.7 0-32 14.3-32 32v80c13.3 0 26.1-6 36.3-13.1 2.2-1.5 4.7-3.9 7.4-6.4C81.9 342.7 89 336 96 336s14.1 6.7 20.3 12.5c2.7 2.5 5.2 4.9 7.4 6.4 10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4 6.2-5.8 13.3-12.5 20.3-12.5s14.1 6.7 20.3 12.5c2.7 2.5 5.2 4.9 7.4 6.4 10.2 7.1 23 13.1 36.3 13.1s26.1-6 36.3-13.1c2.2-1.5 4.7-3.9 7.4-6.4 6-5.7 13-12.3 19.8-12.4 7.2-.2 15.1 6.8 21.8 12.5 2.8 2.4 5.3 4.6 7.5 6 10.3 6.7 22.7 12.4 35.2 13.3V288c0-17.7-14.3-32-32-32zM32 400v80h384v-80.1c-21.1-.9-39.8-10.2-52.6-18.5-4.1-2.7-7.8-5.4-10.9-7.8-2.8 2.4-6.1 5-9.8 7.5C329.8 390 310.6 400 288 400s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2-2.7 2.3-5.9 4.7-9.4 7.2-12.8 8.9-32 18.9-54.6 18.9s-41.8-10-54.6-18.9c-3.5-2.4-6.7-4.9-9.4-7.2-2.7 2.3-5.9 4.7-9.4 7.2C73.8 390 54.6 400 32 400zm32-176h16v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h96v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h96v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h16c35.3 0 64 28.7 64 64v192c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V288c0-35.3 28.7-64 64-64zM224 49.7l-13.5 21.2c-1.6 2.6-2.5 5.7-2.5 8.8 0 9.1 7.4 16.3 16 16.3s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L224 49.7zm-9.8-44.3C216.3 2 220 0 224 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26 0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26l30.7-48.3zm124.3 65.5c-1.6 2.6-2.5 5.7-2.5 8.8 0 9.1 7.4 16.3 16 16.3s16-7.2 16-16.3c0-3.2-.9-6.3-2.5-8.8L352 49.7l-13.5 21.2zm-27-17.1 30.7-48.4C344.3 2 348 0 352 0s7.7 2 9.8 5.4l30.7 48.3c4.9 7.7 7.5 16.8 7.5 26 0 26.5-21.5 48.3-48 48.3s-48-21.8-48-48.3c0-9.2 2.6-18.2 7.5-26z"
        }
    ]
};

const FalCakeSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCakeSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 64 52.3 256H480c0-64-28-112-65-144s-83-48-119-48zM0 272c0-9.8 4.5-19.1 12.2-25.1l264-208c5.6-4.4 12.6-6.9 19.8-6.9 44.3 0 97.6 19.2 139.9 55.8C479.2 125.2 512 181.7 512 256v159.5c0 35.4-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V272zm32 80h448v-40.2.2-24H32v64zm0 32v32c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-32H32z"
        }
    ]
};

const FalCalculatorSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalculatorSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c8.8 0 16 7.2 16 16v224h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h224V16c0-8.8 7.2-16 16-16zm88 96h40V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h8zM53.1 341.1c6.2-6.2 16.4-6.2 22.6 0l36.3 36.3 36.3-36.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L134.6 400l36.3 36.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L112 422.6l-36.3 36.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 400l-36.3-36.3c-6.2-6.2-6.2-16.4 0-22.6zM48 96h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm288 256h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCalculator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalculator",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 160v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160h320zm0-32H32V64c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v64zm32 0V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128zM72 224a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72-72a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm24 72a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm-24 120a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM80 400c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
        }
    ]
};

const FalCalendarArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarArrowDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM32 192h384v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zm32-96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm176 160c0-8.8-7.2-16-16-16s-16 7.2-16 16v121.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 377.4V256z"
        }
    ]
};

const FalCalendarArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM32 192h384v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zm32-96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm144 320c0 8.8 7.2 16 16 16s16-7.2 16-16V294.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7V416z"
        }
    ]
};

const FalCalendarCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM32 192h384v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zm32-96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm267.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l112-112z"
        }
    ]
};

const FalCalendarCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h266.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192h416v-64c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM64 96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm256 272a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalCalendarCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h266.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192h416v-64c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM64 96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm368 160a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FalCalendarCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h266.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192h416v-64c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM64 96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm256 272a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-128-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FalCalendarCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarCircleUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h266.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192h416v-64c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM64 96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm428 366.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6h56.4c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8h-56.4c-21.8 0-42.2 9.6-56.1 25.8-17.2-19.7-27.7-45.6-27.7-73.8 0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM576 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
        }
    ]
};

const FalCalendarClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v64.7c-5.3-.5-10.6-.7-16-.7s-10.7.2-16 .7v-.7H32v256c0 17.7 14.3 32 32 32h232.2c10 12.1 21.7 22.9 34.6 32H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm272 96H64c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32zm48 384a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalCalendarDay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarDay",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM32 192h384v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zm32-96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm40 160h80c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8zm-40 8v80c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40v-80c0-22.1-17.9-40-40-40h-80c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FalCalendarDays = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarDays",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm304 192H312v72h104v-72zm0 104H312v80h104v-80zm0 112H312v72h72c17.7 0 32-14.3 32-32v-40zm-136-32v-80H168v80h112zm-112 32v72h112v-72H168zm-32-32v-80H32v80h104zM32 408v40c0 17.7 14.3 32 32 32h72v-72H32zm0-144h104v-72H32v72zm136 0h112v-72H168v72zM384 96H64c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FalCalendarExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarExclamation",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm304 192H32v256c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192zm-32-96H64c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32zM200 416a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm40-160v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalCalendarHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM32 192h384v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zm32-96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm80 205.3c0-16.2 13.1-29.3 29.3-29.3 7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6 16.2 0 29.3 13.1 29.3 29.3 0 7.8-3.1 15.2-8.6 20.7L224 393.4 152.6 322c-5.5-5.5-8.6-12.9-8.6-20.7zm29.3-61.3c-33.8 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"
        }
    ]
};

const FalCalendarImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarImage",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm304 192H32v256c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192zm-32-96H64c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32zM230 265.4c12.5-18.1 39.2-18.4 52.2-.6l96.3 132.4c15.4 21.2.3 50.8-25.9 50.8H95.1c-26 0-41.2-29.4-26-50.6l51-71.3c11.5-16.1 34.7-18 48.7-4l13.1 13.1 48.1-69.8zM352.6 416l-96.3-132.4-59.2 85.5c-2.7 3.9-7 6.4-11.7 6.8s-9.4-1.3-12.8-4.6L146 344.7 95.1 416h257.5zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalCalendarLinesPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarLinesPen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h194.8c-3.1-8.8-3.7-18.4-1.4-27.8l1.1-4.2H64c-17.7 0-32-14.3-32-32V192h416v-64c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM64 96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm-16-80c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm422.8-8 17.4 17.4c6.2 6.2 6.2 16.4 0 22.6l-24.8 24.8-40-40 24.8-24.8c6.2-6.2 16.4-6.2 22.6 0zM342.5 417.7l106.2-106.2 40 40-106.3 106.2c-2.1 2.1-4.6 3.5-7.4 4.2l-49 12.3 12.3-49c.7-2.8 2.2-5.4 4.2-7.4zm131-176.3L319.8 395.1c-6.2 6.2-10.5 13.9-12.6 22.3l-18.7 74.9c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l74.9-18.7c8.4-2.1 16.1-6.5 22.3-12.6l153.7-153.8c18.7-18.7 18.7-49.1 0-67.9l-17.4-17.4c-18.7-18.7-49.1-18.7-67.9 0z"
        }
    ]
};

const FalCalendarLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarLines",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm304 192H32v256c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192zm-32-96H64c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32zM96 368c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm16-112h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCalendarMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H96c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H160V16zM64 192h384v256c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zm32-96h320c17.7 0 32 14.3 32 32v32H64v-32c0-17.7 14.3-32 32-32zm240 256c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h160z"
        }
    ]
};

const FalCalendarPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarPen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm304 192H64v256c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192zm-32-96H96c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32zm-88.4 161.9c-6.2-6.2-16.4-6.2-22.6 0l-12.2 12.2 29.1 29.1 12.2-12.2c6.2-6.2 6.2-16.4 0-22.6l-6.4-6.4zm-28.4 63.9-29.1-29.1L182 381l-8.6 37.7L211 410l88.2-88.2zm-16.9-86.5c18.7-18.7 49.1-18.7 67.9 0l6.4 6.4c18.7 18.7 18.7 49.1 0 67.9l-123 123c-4.3 4.3-9.6 7.2-15.5 8.6L168 452.7c-17.3 4-32.7-11.5-28.8-28.8l11.5-50.2c1.3-5.9 4.3-11.2 8.6-15.5l123-123z"
        }
    ]
};

const FalCalendarPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm304 192H64v256c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192zm-32-96H96c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32zm-64 240c0 8.8-7.2 16-16 16h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64h64c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalCalendarRange = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarRange",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm304 192H64v256c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192zm-32-96H96c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32zm0 176c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16h160c8.8 0 16 7.2 16 16zM272 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16zM128 272a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm224 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-16a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FalCalendarStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarStar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H96c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H160V16zM64 192h384v256c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zm32-96h320c17.7 0 32 14.3 32 32v32H64v-32c0-17.7 14.3-32 32-32zm181.5 135.5c-8.8-17.8-34.2-17.8-43 0l-22 44.6-49.2 7.2c-19.7 2.9-27.5 27.1-13.3 40.9l35.6 34.7-8.4 49c-3.4 19.6 17.2 34.6 34.8 25.3l44-23.2 44 23.2c17.6 9.3 38.2-5.7 34.8-25.3l-8.4-49 35.6-34.7c14.2-13.9 6.4-38.1-13.3-40.9l-49.2-7.2-22-44.6zm-40.1 66.3 18.6-37.6 18.6 37.6 3.7 7.5 8.3 1.2 41.5 6-30 29.3-6 5.9 1.4 8.3 7.1 41.4-37.1-19.5-7.4-3.9-7.4 3.9-37.1 19.5 7.1-41.4 1.4-8.3-6-5.9-30-29.3 41.5-6 8.3-1.2 3.7-7.5z"
        }
    ]
};

const FalCalendarUsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarUsers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v64H96v-64c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm39.4 512c5.4-9.4 8.6-20.3 8.6-32h128c0 11.7 3.1 22.6 8.6 32H247.4zM480 96H160c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32zm48 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm-48 224c-17.7 0-32 14.3-32 32h160c0-17.7-14.3-32-32-32h-96zm-64 32c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64 0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32zM160 304a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm0 176h160c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm32-64h96c35.3 0 64 28.7 64 64 0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32 0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalCalendarWeek = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarWeek",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H128V16zM32 192h384v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192zm32-96h320c17.7 0 32 14.3 32 32v32H32v-32c0-17.7 14.3-32 32-32zm40 160h240c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8zm-40 8v80c0 22.1 17.9 40 40 40h240c22.1 0 40-17.9 40-40v-80c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FalCalendarXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendarXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H96c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H160V16zM64 192h384v256c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V192zm32-96h320c17.7 0 32 14.3 32 32v32H64v-32c0-17.7 14.3-32 32-32zm235.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 313.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 336l52.7-52.7z"
        }
    ]
};

const FalCalendar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c8.8 0 16 7.2 16 16v48h192V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm304 192H32v256c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192zm-32-96H64c-17.7 0-32 14.3-32 32v32h384v-32c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FalCalendars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCalendars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0c8.8 0 16 7.2 16 16v48h160V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h32c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h32V16c0-8.8 7.2-16 16-16zm-48 96c-17.7 0-32 14.3-32 32v32h352v-32c0-17.7-14.3-32-32-32H160zm320 96H128v160c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V192zM32 208v176c0 53 43 96 96 96h240c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 512 0 454.7 0 384V208c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalCamcorder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCamcorder",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-26.5 21.5-48 48-48h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-44.2 0-80 35.8-80 80v48c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H96v-48zm-16 80h240c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h16zm440.3 268.5c5.1 2.3 10.6 3.5 16.2 3.5 21.8 0 39.5-17.7 39.5-39.5v-209c0-21.8-17.7-39.5-39.5-39.5-5.6 0-11.1 1.2-16.2 3.5L416 226.4v35.1l117.4-52.8c1-.4 2-.7 3.1-.7 4.2 0 7.5 3.4 7.5 7.5v209c0 4.2-3.4 7.5-7.5 7.5-1.1 0-2.1-.2-3.1-.7L416 378.5v35.1l104.3 46.9zM64 240c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalCameraCctv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraCctv",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32 32 200l288 120 192-128L128 32zm-27.8-15.9c8-14 25.2-19.9 40.1-13.7l384 160c10.9 4.5 18.4 14.7 19.5 26.5s-4.3 23.2-14.1 29.7l-192 128c-8.9 5.9-20.2 7-30.1 2.9L222 313.8l-47 123.9c-2.4 6.2-8.3 10.3-15 10.3H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16v48h117l43.6-114.4-172.9-72c-8.5-3.5-15-10.5-18-19.2s-2-18.2 2.5-26.2l96-168zm296.7 329.5 31.4-20.9 83.3 37.9 27.6-66.3-41-18.2 31.5-21 36.7 16.3c7.9 3.5 11.6 12.8 8.3 20.8l-40 96c-3.3 8-13.5 12-21.4 8.4l-116.4-53z"
        }
    ]
};

const FalCameraMovie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraMovie",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c40.8 0 76.4 21.8 96 54.3C259.6 21.8 295.2 0 336 0c61.9 0 112 50.1 112 112s-50.1 112-112 112H144c-61.9 0-112-50.1-112-112S82.1 0 144 0zM64 112c0 44.2 35.8 80 80 80h192c44.2 0 80-35.8 80-80s-35.8-80-80-80c-39.6 0-72.5 28.8-78.9 66.6-1.3 7.7-8 13.4-15.8 13.4h-2.7c-7.8 0-14.5-5.6-15.8-13.4C216.5 60.8 183.6 32 144 32c-44.2 0-80 35.8-80 80zm80-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM136 288h-8c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32H136zm0-32h216c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64V320c0-11.7 3.1-22.6 8.6-32H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h120zm312 184.9 85.4 38.4c1 .4 2 .7 3.1.7 4.2 0 7.5-3.4 7.5-7.5V291.9c0-3.2-2.9-5.6-6-5.1-.4.1-.9.2-1.3.4L448 327.1V292l75.6-34c2.9-1.3 6-2.2 9.1-2.8 22.6-3.8 43.3 13.7 43.3 36.6v180.7c0 21.8-17.7 39.5-39.5 39.5-5.6 0-11.1-1.2-16.2-3.5L448 476v-35.1z"
        }
    ]
};

const FalCameraPolaroid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraPolaroid",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448h448c17.7 0 32-14.3 32-32v-44.6c0-6.3-1.9-12.5-5.4-17.8l-1.1-1.6h-499l-1.1 1.6c-3.5 5.3-5.4 11.4-5.4 17.8V416c0 17.7 14.3 32 32 32zm452.2-128-28.1-42.2c-5.3-7.9-8.1-17.1-8.1-26.6V96c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32v155.2c0 9.5-2.8 18.7-8.1 26.6L59.8 320h456.4zM512 480H64c-35.3 0-64-28.7-64-64v-44.6c0-12.6 3.7-25 10.7-35.5L61.3 260c1.8-2.6 2.7-5.7 2.7-8.9V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v155.2c0 3.2.9 6.2 2.7 8.9l50.6 75.8c7 10.5 10.7 22.9 10.7 35.5V416c0 35.3-28.7 64-64 64zm-96-328a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-128-8a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48a80 80 0 1 1-160 0 80 80 0 1 1 160 0zM112 384h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCameraRetro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraRetro",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 112H64c-17.7 0-32 14.3-32 32v80h113.1c22.1-38.3 63.5-64 110.9-64s88.7 25.7 110.9 64H480V96c0-17.7-14.3-32-32-32H277.3c-6.9 0-13.7 2.2-19.2 6.4l-46.9 35.2c-5.5 4.2-12.3 6.4-19.2 6.4zM32 256v160c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256H380c2.6 10.2 4 21 4 32 0 70.7-57.3 128-128 128s-128-57.3-128-128c0-11 1.4-21.8 4-32H32zM0 416V144c0-35.3 28.7-64 64-64h128l46.9-35.2C250 36.5 263.5 32 277.3 32H448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm352-128a96 96 0 1 0-192 0 96 96 0 1 0 192 0zM64 48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalCameraRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraRotate",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M255.1 32c-20.7 0-39 13.2-45.5 32.8L199.1 96H128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-71.1l-10.4-31.2C423.9 45.2 405.6 32 384.9 32H255.1zm-15.2 42.9c2.2-6.5 8.3-10.9 15.2-10.9h129.8c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9H512c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h82.7c6.9 0 13-4.4 15.2-10.9l14-42.1zM416 272c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v25.4l-14.1-14.1C368.5 185.8 344.7 176 320 176c-39 0-73.3 19.9-93.3 50.1-4.9 7.4-2.9 17.3 4.5 22.2s17.3 2.9 22.2-4.5c14.3-21.6 38.8-35.8 66.6-35.8 16.2 0 31.8 6.5 43.3 17.9l14.1 14.1H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h64zm-192 32c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-25.4l14.1 14.1c17.4 17.5 41.2 27.3 65.9 27.3 39 0 73.3-19.9 93.3-50.1 4.9-7.4 2.9-17.3-4.5-22.2s-17.3-2.9-22.2 4.5C372.3 353.8 347.8 368 320 368c-16.2 0-31.8-6.5-43.3-17.9L262.6 336H288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z"
        }
    ]
};

const FalCameraSecurity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraSecurity",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h320zm-40.1 384H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h40.1l-36.5 59.4c-4.6 7.4-4.8 16.7-.5 24.3s12.3 12.3 21 12.3H360c8.7 0 16.7-4.7 21-12.3s4-16.9-.5-24.3L343.9 416zm-202.2 0h164.6l39.4 64H102.3l39.4-64zM224 304a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 208a128 128 0 1 0 256 0 128 128 0 1 0-256 0z"
        }
    ]
};

const FalCameraSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 376.6V160c0-35.3-28.7-64-64-64h-71.1l-10.4-31.2C423.9 45.2 405.6 32 384.9 32H255.1c-20.7 0-39 13.2-45.5 32.8l-5.9 17.8 26.7 21.1L240 75c2.2-6.5 8.3-10.9 15.2-10.9h129.7c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9H512c17.7 0 32 14.3 32 32v191.3l32 25.3zM96 160.7l-28.3-22.3c-2.4 6.8-3.7 14-3.7 21.6v256c0 35.3 28.7 64 64 64h372.4l-40.5-32H128c-17.7 0-32-14.3-32-32V160.7zm282.4 222.9-27.6-21.8c-9.5 4-19.9 6.1-30.8 6.1-44.2 0-80-35.8-80-80 0-4.4.3-8.6 1-12.8l-27.6-21.8c-3.5 10.9-5.4 22.5-5.4 34.6 0 61.9 50.1 112 112 112 21.4 0 41.4-6 58.4-16.4z"
        }
    ]
};

const FalCameraViewfinder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraViewfinder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48C21.5 0 0 21.5 0 48zm216.6 48c-16.7 0-31.6 10.3-37.5 26l-2.3 6H152c-30.9 0-56 25.1-56 56v144c0 30.9 25.1 56 56 56h208c30.9 0 56-25.1 56-56V184c0-30.9-25.1-56-56-56h-24.9l-2.3-6c-5.8-15.7-20.8-26-37.4-26h-78.8zm-7.5 37.2c1.2-3.1 4.2-5.2 7.5-5.2h78.7c3.3 0 6.3 2.1 7.5 5.2l6.2 16.4c2.3 6.2 8.3 10.4 15 10.4h36c13.3 0 24 10.7 24 24v144c0 13.3-10.7 24-24 24H152c-13.3 0-24-10.7-24-24V184c0-13.3 10.7-24 24-24h36c6.7 0 12.6-4.1 15-10.4l6.2-16.4zM224 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM464 0h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zm464 48c26.5 0 48-21.5 48-48v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96z"
        }
    ]
};

const FalCameraWebSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraWebSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 224C544 100.3 443.7 0 320 0c-57.2 0-109.5 21.5-149.1 56.8L196.5 77C229.9 48.9 273 32 320 32c106 0 192 86 192 192 0 30.9-7.3 60.1-20.3 86l25.6 20.2c17-31.6 26.7-67.8 26.7-106.2zM427.4 422.3l7.4 9.7h4.8l-12.3-9.7zm-29.1-23C374.4 410.1 347.9 416 320 416c-106 0-192-86-192-192 0-12.1 1.1-24 3.3-35.5l-27.8-22C98.6 184.9 96 204.1 96 224c0 73.7 35.6 139 90.5 179.9L133 473.4c-5.6 7.2-6.5 17-2.5 25.2S142.9 512 152 512h336c9.1 0 17.5-5.2 21.5-13.4 1.5-3 2.3-6.3 2.4-9.5l-11.5-9.1H168.2l45.3-58.9c31.7 17.2 68 26.9 106.5 26.9 38.4 0 74.5-9.7 106.1-26.7l-27.8-22zM176 224c0 79.5 64.5 144 144 144 11.6 0 22.8-1.4 33.6-3.9L318 336c-51.4-.9-94.3-36.3-106.5-84.1l-35.5-28v.1zm256 0c0 12.1-1.9 23.7-5.4 34.6l26.4 20.8c7.1-17.1 11-35.8 11-55.4 0-79.5-64.5-144-144-144-31.7 0-61 10.2-84.7 27.6l26.4 20.8c17-10.4 37-16.4 58.4-16.4 61.9 0 112 50.1 112 112zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalCameraWeb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCameraWeb",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm133.5 371.9C412.4 363 448 297.7 448 224 448 100.3 347.7 0 224 0S0 100.3 0 224c0 73.7 35.6 139 90.5 179.9L37 473.4c-5.6 7.2-6.5 17-2.5 25.2S46.9 512 56 512h336c9.1 0 17.5-5.2 21.5-13.4s3.1-18-2.5-25.2l-53.5-69.5zm-27.1 17.3 45.4 58.8H72.2l45.3-58.9c31.7 17.2 68 26.9 106.5 26.9s74.8-9.7 106.5-26.9zM224 112a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
        }
    ]
};

const FalCamera = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCamera",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.1 32c-20.7 0-39 13.2-45.5 32.8L135.1 96H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-71.1l-10.4-31.2C359.9 45.2 341.6 32 320.9 32H191.1zm-15.2 42.9c2.2-6.5 8.3-10.9 15.2-10.9h129.8c6.9 0 13 4.4 15.2 10.9l14 42.1c2.2 6.5 8.3 10.9 15.2 10.9H448c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h82.7c6.9 0 13-4.4 15.2-10.9l14-42.1zM256 400a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm-80-112a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FalCampfire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCampfire",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232.2 3.4c-2.5-2.3-5.6-3.4-8.8-3.4-3.2 0-6.4 1.1-9 3.4-29.9 27-55.3 57.7-73.2 87.1-17.7 29-29.2 60.2-29.2 84.2 0 79.8 63.3 145.3 144 145.3 79.9 0 144-65.5 144-145.3 0-18.3-8.7-46.3-21.7-71.8C365 77 346.2 49.7 323.9 29.1c-5-4.7-12.9-4.7-18 0-1.5 1.4-3.1 2.9-4.6 4.4-6.9 7-13.4 15-19.2 22.4-6.3-7.7-12.8-15.1-19.5-22.3-9.7-10.5-19.9-20.6-30.4-30.2zM282.4 85c8.8-.1 17.1-4.2 22.5-11.1 3.4-4.3 6.8-8.5 10.1-12.3 14.6 16.1 27.5 35.6 37.3 54.6 12.2 23.7 18.5 46.9 18.5 58.5 0 64.1-51.5 116.2-114.9 116.2-64.2 0-114.9-52-114.9-116.2 0-16.4 8.4-42.1 24.9-69 14.3-23.4 34-48 57.3-70.7 12.8 12.4 24.9 25.5 36.4 39.5 5.6 6.8 14 10.7 22.8 10.6zm-57.9.8c-4.9 0-9.5 2.2-12.5 6-13.4 16.7-24.3 30.8-31.8 43.7-7.6 13.3-12.3 26.3-12.3 40.8 0 26.4 9.7 48.5 26.4 63.9 16.5 15.3 38.8 23 62.5 23 19.5 0 37-5.6 53-16.4l.3-.2c34.3-24.2 42.4-71.4 23-107.7v-.1c-1.7-3.5-4.1-8.2-7.6-13-2.9-3.9-7.4-6.3-12.3-6.5s-9.6 1.9-12.7 5.6l-19.6 23.2-14.5-18.6c-13.5-17.3-27.5-35.4-29.3-37.7-3-3.8-7.6-6.1-12.5-6.1zm68 98.2 16.7-19.7c6.4 21.2-.5 44.2-17.3 56.2-10.9 7.3-22.2 10.8-35 10.8-16.8 0-31-5.4-40.8-14.5-9.6-8.9-16.1-22.2-16.1-40.4 0-7.2 2.1-14.7 8-24.8 4-6.9 9.4-14.5 16.4-23.8l16.7 21.5 18.3 23.6 6 7.7 1.7 2.1.4.6.1.1 12.6-9.8-12.6 9.8c3 3.8 7.5 6.1 12.3 6.2s9.4-2 12.5-5.6zM21.9 289.1c-8.2-3.3-17.5.7-20.8 8.9s.7 17.5 8.9 20.8L212.9 400 10.1 481.1c-8.2 3.3-12.2 12.6-8.9 20.8s12.6 12.2 20.8 8.9l234-93.6 234.1 93.6c8.2 3.3 17.5-.7 20.8-8.9s-.7-17.5-8.9-20.8L299.1 400 502 318.9c8.2-3.3 12.2-12.6 8.9-20.8s-12.6-12.2-20.8-8.9L256 382.8 21.9 289.1z"
        }
    ]
};

const FalCampground = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCampground",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M394.3 3.7c6.8 5.7 7.7 15.8 2 22.5l-87.4 104.2 223.9 266.8c7.2 8.6 11.2 19.5 11.2 30.8v36c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-36c0-11.3 4-22.2 11.2-30.9l223.9-266.7-87.4-104.1c-5.7-6.8-4.8-16.9 2-22.5s16.9-4.8 22.5 2l83.8 99.7 83.7-99.8c5.7-6.8 15.8-7.7 22.5-2zm-326.6 414c-2.4 2.9-3.7 6.5-3.7 10.3v36c0 8.8 7.2 16 16 16h49.9l1.5-1.9 144-184c3-3.9 7.7-6.1 12.6-6.1s9.6 2.3 12.6 6.1l144 184 1.5 1.9H496c8.8 0 16-7.2 16-16v-36c0-3.8-1.3-7.4-3.7-10.3L288 155.3 67.7 417.7zM170.6 480h234.8L288 330 170.6 480z"
        }
    ]
};

const FalCanFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCanFood",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 432V285.6c-12.8 6.5-27.7 11.9-43.7 16.2-6.5 1.7-13.3 3.3-20.4 4.7-1.3 43-36.6 77.6-80 77.6s-78.7-34.5-80-77.6c-7-1.4-13.8-3-20.4-4.7-16-4.3-30.8-9.7-43.7-16.2V432c0 3 1.5 7.5 7.6 13.3 6.1 5.8 15.9 11.8 29.2 17.1C111.4 473.1 149.3 480 192 480s80.6-6.9 107.2-17.6c13.4-5.3 23.1-11.3 29.2-17.1 6.1-5.8 7.6-10.3 7.6-13.3zm0-183.7V127.6c-7.4 4.7-15.9 8.9-24.9 12.5C279.8 152.6 237.7 160 192 160s-87.8-7.4-119.1-19.9c-9.1-3.6-17.5-7.8-24.9-12.5v120.7c11.7 8.5 29.3 16.4 51.9 22.5 5.6 1.5 11.4 2.9 17.5 4.1 11.7-29.8 40.7-50.9 74.6-50.9s62.9 21.1 74.5 50.9c6.1-1.2 11.9-2.6 17.5-4.1 22.7-6.1 40.3-14 51.9-22.5zM48 80c0 3 1.5 7.5 7.6 13.3 6.1 5.8 15.9 11.8 29.2 17.1C111.4 121.1 149.3 128 192 128s80.6-6.9 107.2-17.6c13.4-5.3 23.1-11.3 29.2-17.1C334.5 87.5 336 83 336 80s-1.5-7.5-7.6-13.3c-6.1-5.8-15.9-11.8-29.2-17.1C272.6 38.9 234.7 32 192 32s-80.6 6.9-107.2 17.6c-13.4 5.3-23.1 11.3-29.2 17.1C49.5 72.5 48 77 48 80zm320 0v360c0 39.8-78.8 72-176 72S16 479.8 16 440V72C16 32.2 94.8 0 192 0s176 32.2 176 72v8zM192 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalCandleHolder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCandleHolder",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 112c0 26.5 21.5 48 48 48s48-21.5 48-48c0-8.8-6.5-24-20.5-43.1-9.1-12.5-19.5-23.8-27.5-32.1-8 8.3-18.4 19.6-27.5 32.1C118.5 88 112 103.2 112 112zm48 80c-44.2 0-80-35.8-80-80 0-39.6 49.1-90.1 66.2-106.6C149.9 1.9 154.8 0 160 0s10.1 1.9 13.8 5.4C190.9 21.9 240 72.4 240 112c0 44.2-35.8 80-80 80zM0 496c0-8.8 7.2-16 16-16h48V272c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v208h72.6c-5.4-9.4-8.6-20.3-8.6-32 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64H16c-8.8 0-16-7.2-16-16zm128-240h-16c-8.8 0-16 7.2-16 16v208h128V272c0-8.8-7.2-16-16-16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48zm256 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalCandyBar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCandyBar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M155.5 74.7c2.3-6.4 8.3-10.7 15.1-10.7H576c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V234.5c0-6.8 4.3-12.8 10.7-15.1C41.8 208.5 64 178.8 64 144c0-8.8 7.2-16 16-16 34.8 0 64.5-22.2 75.5-53.3zM192 96v96h128V96H192zm-32 30.4c-17 17.4-39.7 29.2-65 32.6-1.6 11.7-4.9 22.8-9.8 33H160v-65.6zm-96 96c-9.2 9.4-20 17.1-32 22.8V320h128v-96H64v-1.6zM32 352v32c0 17.7 14.3 32 32 32h96v-64H32zm160 64h128v-64H192v64zm128-96v-96H192v96h128zm32 96h224c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H352v320z"
        }
    ]
};

const FalCandyCane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCandyCane",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M361 96c10.1 0 19.5 2.7 27.7 7.5-.6-.3-1.2-.7-1.7-1l46.2-46.2c.5.4.9.7 1.4 1.1C414.2 41.5 388.7 32 361 32c-11.3 0-22.5 1.6-33.2 4.7L348 97.5c-5.7 1.4-11.2 3.7-16.3 6.8l-12.6 7.9-20.7-62.4c-.2.1-.3.2-.5.3L271 66.9c-15 9.4-19.5 29.1-10.2 44.1s29.1 19.5 44.1 10.2l26.8-16.8 16.1 25.7-16.1-25.7c8.7-5.5 18.9-8.4 29.2-8.4zm48.6 29.1c4.1 7.7 6.5 16.6 6.5 25.9v5.6c0 1.7-.1 3.4-.2 5.1l61.6 20.5c-2.2 10.5-5.8 20.7-10.5 30.2l-62-20.7c-4.6 6.4-10.4 12-17.3 16.3l-57.8 36.1 60.4 37.7-30.2 18.9-60.4-37.7-77 48.1 60.4 37.7-30.2 18.9-60.4-37.7-73 45.6 60.4 37.7-30.2 18.9-60.6-37.6L47 420.9C32 430.3 27.5 450 36.8 465s29.1 19.5 44.1 10.2l340.5-212.8c36.4-22.8 58.6-62.7 58.6-105.7V151c0-36.6-16.5-69.3-42.4-91.1 6.7 5.6 12.8 12 18.1 19l-46.2 46.2zM361 128c-4.3 0-8.6 1.2-12.2 3.5L322 148.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2L280.9 23c24-15 51.8-23 80.1-23 83.4 0 151 67.6 151 151v5.6c0 54-27.8 104.2-73.6 132.8L97.9 502.3c-30 18.7-69.5 9.6-88.2-20.4s-9.6-69.5 20.4-88.2l340.4-212.8c8.4-5.2 13.5-14.4 13.5-24.3V151c0-12.7-10.3-23-23-23z"
        }
    ]
};

const FalCandyCorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCandyCorn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 0c44.1 0 90.4 4.2 132.6 18.1C629 23.5 640 38.8 640 56c0 20.1-7 52-15.6 84-9.1 33.8-21.4 73-34.7 110.4-13.2 37.2-27.9 73.6-41.6 101.3-13.4 27-32.9 64.3-68.1 64.3s-54.6-37.3-68.1-64.3c-13.8-27.7-28.4-64.1-41.6-101.3C357 213 344.7 173.8 335.6 140 327 108 320 76.1 320 56c0-17.2 11.4-32.6 27.8-38.1C390 4.4 436 0 480 0zm122.6 48.4C564.9 36.1 522.3 32 480 32c-42.1 0-84.4 4.2-122.2 16.3-3.6 1.3-5.8 4.7-5.8 7.7 0 13.3 4.4 36.2 11.3 63.4 1.2-.2 2.6-.3 4.1-.5 6.2-.8 15.2-1.8 26.2-2.8 22-2 52.6-4.1 86.4-4.1s64.3 2 86.4 4.1c11 1 20 2 26.2 2.8 1.6.2 2.9.4 4.1.5C603.6 92.2 608 69.3 608 56c0-3.4-2.2-6.5-5.4-7.6zM371.8 150.6c8.1 28.2 18.1 59.3 28.7 89.1l1.3 3.7c21.1-1.8 48.4-3.4 78.2-3.4s57.1 1.6 78.2 3.4l1.3-3.7c10.6-29.8 20.6-60.9 28.7-89.1-5.9-.7-14.4-1.7-24.8-2.6-21.4-2-50.9-3.9-83.4-3.9s-62.1 2-83.4 3.9c-10.4 1-18.9 1.9-24.8 2.6zm68.8 186.9c6.9 13.8 13.5 26.4 21.5 35.7 7.6 8.8 13.1 10.9 17.9 10.9s10.4-2.1 17.9-10.9c8-9.2 14.6-21.8 21.5-35.7 8.8-17.6 18.1-39.3 27.2-62.9-19-1.4-41.9-2.5-66.6-2.5s-47.6 1.1-66.6 2.5c9.1 23.6 18.4 45.3 27.2 62.9zM85.1 203.3c31.2-31.2 67-61 106.6-81 15.4-7.7 34-4.7 46.2 7.5 14.2 14.2 31.8 41.8 48.3 70.4 17.5 30.3 36.5 66.8 53.6 102.6 16.9 35.7 32.4 71.8 42.2 101 9.6 28.6 22.2 68.7-2.7 93.6s-65 12.2-93.6 2.7c-29.3-9.8-65.4-25.2-101-42.2-35.9-17-72.3-36.1-102.6-53.5-28.7-16.5-56.2-34.2-70.4-48.3-12.2-12.2-15-31.2-7.3-46.6 20.3-39.4 49.7-75 80.8-106.2zM206 150.9c-35.4 17.9-68.4 45.2-98.3 75.1C78 255.7 51 288.6 32.9 323.9c-1.7 3.4-.8 7.4 1.4 9.5 9.4 9.4 28.8 22.5 52.8 36.8.7-1 1.6-2.1 2.6-3.3 3.8-4.9 9.5-12 16.5-20.5 14.2-17 34.3-40 58.2-63.9s46.9-44 63.9-58.2c8.5-7.1 15.6-12.7 20.5-16.5 1.2-1 2.3-1.8 3.3-2.6-14.3-24.1-27.4-43.4-36.8-52.8-2.4-2.4-6.1-3-9.2-1.5zm-91 235.4c25.7 14.2 54.7 29.1 83.3 42.7l3.5 1.7c13.7-16.2 31.9-36.6 52.9-57.7s41.5-39.2 57.7-52.9l-1.7-3.5C297.1 288 282.2 259 268 233.3c-4.7 3.7-11.4 9-19.4 15.7-16.5 13.7-38.7 33.2-61.8 56.2s-42.5 45.3-56.2 61.8c-6.7 8.1-12 14.7-15.7 19.4zm180.8 83.5c14.7 4.9 28.2 9.1 40.4 10 11.6.9 17-1.6 20.4-5s5.8-8.8 5-20.4c-.9-12.2-5.1-25.7-10-40.4-6.3-18.6-15.1-40.6-25.3-63.7-14.4 12.4-31.4 27.8-48.9 45.3s-32.9 34.5-45.3 48.9c23.1 10.2 45.1 19 63.7 25.3z"
        }
    ]
};

const FalCandy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCandy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M376.9 405.6C359.2 412.3 340 416 320 416c-4.9 0-9.7-.2-14.4-.6L183.8 171.9c12.8-20.7 30.1-38.2 50.6-51.2l142.5 284.9zm28.6-14.3L263.1 106.4C280.8 99.7 300 96 320 96c4.9 0 9.7.2 14.4.6l121.8 243.5c-12.8 20.7-30.1 38.2-50.6 51.2zm-14.2 43.1c10-4 19.5-8.8 28.6-14.3 40.9-24.9 71.7-64.7 84.9-111.8l91.9 49c10.5 5.6 23.5 2.7 30.6-6.9 9.1-12.3 3.8-24.5-5.3-35.4-5.4-6.4-12-12.3-17.9-17.5-3.2-2.9-6.3-5.6-8.7-8 2.8-1 5.8-2 9-3 8.3-2.7 17.6-5.7 24.6-10.5 6.5-4.5 11.1-10.7 11.1-19.8s-4.6-15.3-11.1-19.8c-7-4.9-16.2-7.8-24.6-10.5-3.2-1-6.3-2-9-3 2.4-2.4 5.4-5.1 8.7-8 5.9-5.2 12.6-11.2 17.9-17.5 9.2-10.9 14.4-23.1 5.3-35.4-7.1-9.6-20.1-12.5-30.6-6.9l-91.9 49c-19.6-69.8-77.4-123.4-149.3-136.8-11.5-2.2-23.3-3.3-35.4-3.3h-.1c-25.2 0-49.2 4.8-71.3 13.7-10 4-19.6 8.8-28.6 14.3-40.9 24.9-71.7 64.7-84.9 111.8l-91.9-49c-10.5-5.6-23.5-2.7-30.6 6.9-9.1 12.3-3.8 24.5 5.3 35.4 5.4 6.4 12 12.3 17.9 17.5 3.2 2.9 6.3 5.6 8.7 8-2.8 1-5.8 2-9 3-8.3 2.7-17.6 5.7-24.6 10.5-6.4 4.6-11 10.8-11 19.9s4.6 15.3 11.1 19.8c7 4.9 16.2 7.8 24.6 10.5 3.2 1 6.3 2 9 3-2.4 2.4-5.4 5.1-8.7 8-5.9 5.2-12.6 11.2-17.9 17.5-9.2 11-14.5 23.2-5.4 35.5 7.1 9.6 20.1 12.5 30.6 6.9l91.9-49c19.6 69.5 77.4 123.1 149.3 136.5 12.1 2.3 24.6 3.4 37.4 3.3 24.5-.2 47.9-5.1 69.4-13.7zm-126-27.9C203.9 384.1 160 325.2 160 256c0-16.2 2.4-31.8 6.9-46.5l98.5 196.9zm109.4-300.9C436.1 127.9 480 186.8 480 256c0 16.2-2.4 31.8-6.9 46.5l-98.4-196.9zM512 256c0-6.3-.3-12.4-.9-18.5l54.9-29.3c-3.2 6.5-4.2 14-2.6 21.4 2.3 10.8 10 19.8 20.4 23.7 2.8 1.1 5.6 2 8.1 2.8h.1-.1c-2.4.8-5.3 1.7-8.1 2.8-10.4 3.9-18.1 12.8-20.4 23.7-1.6 7.3-.6 14.8 2.6 21.4l-54.9-29.3c.6-6.1.9-12.3.9-18.5zm-383.1-18.5c-.6 6.1-.9 12.3-.9 18.5s.3 12.4.9 18.5l-55 29.3c3.2-6.5 4.2-14 2.6-21.4-2.3-10.8-10-19.8-20.4-23.7-2.8-1.1-5.6-2-8.1-2.8h-.1.1c2.4-.8 5.3-1.7 8.1-2.8 10.4-3.9 18.1-12.8 20.4-23.7 1.6-7.3.6-14.8-2.6-21.4l54.9 29.3z"
        }
    ]
};

const FalCannabis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCannabis",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.3 7.1c-3-4.4-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1c-14.2 21.2-33.8 60-48 104.1-10.3 31.7-18.1 67.2-18.7 101.4-51.5-36.1-114.6-55.8-148.9-62.6-5.2-1-10.7.6-14.4 4.4s-5.4 9.2-4.4 14.5c7.1 35.4 28.1 101.4 66.7 153.5-21.4 8.8-40.3 19.5-52.8 26.6-2.2 1.2-4.2 2.4-6 3.4-5.1 2.8-8.2 8.2-8.2 14s3.2 11.2 8.2 14c14.1 7.8 41.4 22.7 72.2 33.1 20.7 7 44.6 12.7 67.8 11.8l-12.7 33c-2.3 6.1-.8 13 4 17.4s11.7 5.6 17.6 2.9l75-34.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-51.7l75 34.2c5.9 2.7 12.9 1.6 17.6-2.9s6.3-11.3 4-17.4l-12.7-33c23.2.9 47.1-4.8 67.8-11.8 30.7-10.5 58.1-25.3 72.2-33.1 5.1-2.8 8.2-8.2 8.2-14s-3.2-11.2-8.2-14c-13-7.2-35.1-18.7-60.8-27.3 40-52.5 61.5-120.2 68.7-156.1 1.1-5.2-.6-10.7-4.4-14.5s-9.2-5.4-14.4-4.4c-34.3 6.8-97.4 26.5-148.9 62.6-.6-34.2-8.4-69.8-18.7-101.4-14.2-44-33.8-82.9-48-104.1zm2.7 402V336c0-8.8-7.2-16-16-16s-16 7.2-16 16v73.1l-52.5 24 8.8-22.8c2.3-5.8.9-12.4-3.5-16.9s-10.9-6-16.8-3.9c-20.8 7.4-48.7 3.3-77.2-6.4-14.9-5-29-11.3-41-17.2 14.3-7.5 31.1-15.5 48.7-21 5.2-1.6 9.2-5.8 10.7-11s.1-10.9-3.5-14.9C79.1 280.5 57 226.4 45.9 187.5c41 11.6 98.7 35.2 137.7 72.3 5 4.8 12.5 5.8 18.6 2.5s9.4-10.1 8.2-16.9c-6.6-37.5 1.2-82.7 14.8-124.5 9.2-28.3 20.6-54.1 30.9-73.5 10.3 19.4 21.7 45.1 30.9 73.5 13.5 41.8 21.4 87 14.8 124.5-1.2 6.8 2.1 13.6 8.2 16.9s13.6 2.2 18.6-2.5c39-37.1 96.7-60.7 137.7-72.3-11.7 40.2-34.9 96.5-71.3 135.2-3.9 4.2-5.3 10.2-3.6 15.7s6.2 9.7 11.8 10.9c17.9 4 35.2 10.6 49.8 17.2-11.8 5.7-25.4 11.7-39.7 16.6-28.5 9.7-56.4 13.8-77.2 6.4-5.9-2.1-12.5-.6-16.8 3.9s-5.7 11.1-3.5 16.9l8.8 22.8-52.5-24z"
        }
    ]
};

const FalCapsules = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCapsules",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240h160v-96c0-44.2-35.8-80-80-80s-80 35.8-80 80v96zM0 256V144C0 82.1 50.1 32 112 32s112 50.1 112 112v24.2c3-32.2 19.3-63 47.3-83 50.7-36.2 120.5-23.6 156 28.1l128.4 187.3c35.5 51.7 23.2 123-27.5 159.2s-120.5 23.6-156-28.1L243.8 244.4c-11.5-16.8-18-35.7-19.8-54.8V368c0 61.9-50.1 112-112 112S0 429.9 0 368V256zm192 16H32v96c0 44.2 35.8 80 80 80s80-35.8 80-80v-96zm206.6 141.6c25.5 37.1 75.1 45.8 111 20.1 36.3-26 45.5-77.6 19.7-115.1l-52.7-76.8-2.2 1.6-130 91.2 54.2 79.1zm57.5-196.4 2.5-1.7-57.7-84.2c-25.5-37.1-75.1-45.8-111-20.1-36.3 26-45.5 77.6-19.7 115.1l56.1 81.8 129.8-90.9z"
        }
    ]
};

const FalCarBattery = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarBattery",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm256 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zM64 160c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64zM0 192c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm368 16c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16zM96 256h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCarBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarBolt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m113.6 98.2-28.3 94.4c3.5-.4 7.1-.6 10.7-.6h32v32H96c-7.4 0-14.5 1.3-21.2 3.6l-.1.3-.5-.1C49.6 236.7 32 260.3 32 288v96h448v-96c0-27.7-17.6-51.3-42.3-60.2l-.5.1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H384v-32h32c3.6 0 7.2.2 10.7.6l-28.3-94.4c-6.1-20.3-24.8-34.2-46-34.2H159.6c-21.2 0-39.9 13.9-46 34.2zM48.3 204.7l.4-1.3L83 89c10.2-33.8 41.3-57 76.6-57h192.8c35.3 0 66.5 23.2 76.6 57l34.3 114.4.4 1.3c28.9 16.5 48.3 47.6 48.3 83.3v176c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-35.7 19.4-66.8 48.3-83.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-84.7-172.7L230.6 192H320c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l68.7-68.7H192c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalCarBuilding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarBuilding",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h224c17.7 0 32 14.3 32 32v101.2c9.4-7.6 20.3-13.4 32-17V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v352c0 35.3 28.7 64 64 64h160v-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm200 160h-48c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h41.6c3.7-3.7 7.7-7.1 11.9-10.2l18.3-64.2c-1.1-12.1-11.3-21.6-23.8-21.6zM88 64c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24H88zm8 64V96h32v32H96zm96-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zm32 8h32v32h-32V96zM88 192c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88zm8 64v-32h32v32H96zm128-32h32v32h-32v-32zM88 320c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H88zm8 64v-32h32v32H96zm284.2-176h135.6c14.3 0 26.8 9.5 30.8 23.2l16.2 56.8H333.2l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L297 298.1c-24.5 13.7-41 39.9-41 69.9v128c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h320v32c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H380.2c-28.6 0-53.7 18.9-61.5 46.4zM608 416v16H288v-64c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v48zm-272-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCarBump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarBump",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m131.7 88.2 172.6-46.3c20.5-5.5 42.1 3.1 53.3 21.1l48.2 78c-4.6.5-9.3 1.4-14 2.7L106.9 220c-4.7 1.2-9.1 2.8-13.4 4.7l2.7-91.6c.6-21.2 15.1-39.5 35.6-44.9zM60.9 243.3l-.1 4.8c-21.3 23.4-30.6 56.7-21.8 89.5l22 82.1 4.3 16.3 15.8 58.8c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6l-11.8-44.2 1.5-.4 408.5-109.5 1.5-.4 11.8 44.1c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6l-11.8-44.1-8.3-30.9-22-82.1c-8.8-32.8-33.5-57-63.6-66.6l-2.5-4-58.4-94.9C366.2 16.2 330.1 1.9 296 11L123.4 57.2c-34.1 9.1-58.2 39.6-59.3 74.9l-3.2 111.2zm54.3 7.6L400 174.6c34.1-9.1 69.2 11.1 78.4 45.3l22 82.1L91.9 411.5l-22-82.1c-9.1-34.1 11.1-69.2 45.3-78.4zm42.2 58a22.8 22.8 0 1 0-44.1 11.8 22.8 22.8 0 1 0 44.1-11.8zm263-46.9a22.8 22.8 0 1 0-11.8-44.1 22.8 22.8 0 1 0 11.8 44.1zm43.4 236.2c4.1-28.4 28.5-50.3 58.1-50.3s54 21.8 58.1 50.3c1.3 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1c-6.3-44-44.1-77.7-89.8-77.7s-83.5 33.8-89.8 77.7c-1.3 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6z"
        }
    ]
};

const FalCarBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.5 17.3C187.9 11.6 182.2 8 176 8s-11.9 3.6-14.5 9.3l-32.1 69.9-74.7-18.5c-6.1-1.5-12.5.7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6-60.9 46.8c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l25.7-21.3c.3-2.9.8-5.8 1.6-8.7l11.8-43.9-32.7 27 1-55.3c.1-7.7-5.2-14.4-12.7-15.9l-54.1-11.2 43.8-33.7c6.1-4.7 8-13 4.5-19.9l-24.8-49.4 53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9l23-50.2 23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l48.2-11.9 23.2-38.7-66.3 16.4-32.1-69.9zm190.4 69.6 164.4 44c13.8 3.7 23.5 16.1 23.7 30.4l1.3 75.7-264-70.7 38.9-64.9c7.3-12.3 21.9-18.2 35.7-14.5zm-63.2-2-46.2 77c-32.6 2.9-61.4 25.6-70.3 59L175 318.8c-.3 1.3-.6 2.6-.7 3.8l-.3-.1-14.9 55.5c-2.7 10 3.2 20.2 13.2 22.9s20.2-3.2 22.9-13.2l9.7-36 360.5 96.6-9.7 36.1c-2.7 10 3.2 20.2 13.2 22.9s20.2-3.2 22.9-13.2l15.4-57.5h-.1c.2-.6.4-1.1.5-1.7l26.2-97.8c8.9-33.4-4.6-67.5-31.4-86.3l-1.4-90c-.5-28.6-19.8-53.4-47.4-60.8L389.2 56c-27.6-7.4-56.8 4.4-71.5 28.9zM569 269.8c25.6 6.9 40.8 33.2 33.9 58.8l-24.1 90.1L208 319.3l24.1-90.1c6.9-25.6 33.2-40.8 58.8-33.9l278 74.5zM278.3 294a28 28 0 1 0 14.5-54.1 28 28 0 1 0-14.5 54.1zm286.6 47.8a28 28 0 1 0-54.1-14.5 28 28 0 1 0 54.1 14.5z"
        }
    ]
};

const FalCarBus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarBus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M45.8 70.1C38.8 75.7 34.7 84.5 33 96h318c-1.7-11.5-5.9-20.3-12.9-25.9C316.2 52.8 271 32 192 32S67.8 52.8 45.8 70.1zM32 128v96h144v-96H32zm0 128v96c0 17.7 14.3 32 32 32h160v32H64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-56.6c-19.1-11-32-31.7-32-55.4V110.2C0 88.9 4.5 62.1 26 45 54.8 22.2 107.5 0 192 0s137.2 22.2 166 45c21.5 17 26 43.9 26 65.2V144h-3.8c-9.8 0-19.2 1.5-28.2 4.2V128H208v96h76.9l-9.1 32H32zm72 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm276.2-80c-14.3 0-26.8 9.5-30.8 23.2L333.2 288h229.6l-16.2-56.8c-3.9-13.7-16.5-23.2-30.8-23.2H380.2zm-61.5 14.4c7.8-27.5 33-46.4 61.5-46.4h135.6c28.6 0 53.7 18.9 61.5 46.4l21.7 75.7c24.5 13.7 41 39.9 41 69.9v128c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32H288v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-30 16.6-56.2 41-69.9l21.6-75.7zM608 416v-48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v64h320v-16zm-272-64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalCarCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarCircleBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M113.6 98.2c6.1-20.3 24.8-34.2 46-34.2h192.8c21.2 0 39.9 13.9 46 34.2l28.3 94.4c-3.5-.4-7.1-.6-10.7-.6H96c-3.6 0-7.2.2-10.7.6l28.3-94.4zM74.3 227.8l.5.1.1-.3c6.6-2.3 13.8-3.6 21.2-3.6h298.7c19.5-13.7 41.9-23.6 66.2-28.5L429 89c-10.2-33.8-41.3-57-76.6-57H159.6C124.3 32 93.1 55.2 83 89L48.7 203.4l-.4 1.3C19.4 221.2 0 252.3 0 288v176c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h294.6c-2.9-10.3-4.9-21-5.9-32H32v-96c0-27.7 17.6-51.3 42.3-60.2zM104 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm280 48a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-96.1-81c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1.6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2h-35.6l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"
        }
    ]
};

const FalCarGarage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarGarage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328.5 2.5c-5.2-3.3-11.9-3.3-17.1 0l-304 192c-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5L320 34.9l295.5 186.6c7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1l-304-192zM252.2 208h135.6c14.3 0 26.8 9.5 30.8 23.2l16.2 56.8H205.2l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L169 298.1c-24.5 13.7-41 39.9-41 69.9v128c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h320v32c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H252.2c-28.6 0-53.7 18.9-61.5 46.4zM480 416v16H160v-64c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v48zm-272-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCarMirrors = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarMirrors",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.6 64c-21.2 0-39.9 13.9-46 34.2l-28.3 94.4c3.5-.4 7.1-.6 10.7-.6h320c3.6 0 7.2.2 10.7.6l-28.3-94.4c-6.1-20.3-24.8-34.2-46-34.2H191.6zm-84.9 163.9-.5-.1C81.6 236.7 64 260.3 64 288v96h448v-96c0-27.7-17.6-51.3-42.3-60.2l-.5.1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H128c-7.4 0-14.5 1.3-21.2 3.6l-.1.3zM56.4 224H32c-8.8 0-16-7.2-16-16s7.2-16 16-16h52.1L115 89c10.2-33.8 41.3-57 76.6-57h192.8c35.3 0 66.5 23.2 76.6 57l30.9 103H544c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24.4c15.2 17 24.4 39.4 24.4 64v176c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-24.6 9.2-47 24.4-64zm55.6 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalCarOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarOn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 24c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V24zm-83.8 184h135.6c14.3 0 26.8 9.5 30.8 23.2l16.2 56.8H141.2l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L105 298.1C80.6 311.8 64 338 64 368v128c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h320v32c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H188.2c-28.6 0-53.7 18.9-61.5 46.4zM416 416v16H96v-64c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v48zm-272-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM44.7 44.7c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-48-48c-6.2-6.2-16.4-6.2-22.6 0zm400 0-48 48c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FalCarRear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarRear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M159.6 64h192.8c21.2 0 39.9 13.9 46 34.2l28.3 94.4c-3.5-.4-7.1-.6-10.7-.6H96c-3.6 0-7.2.2-10.7.6l28.3-94.4c6.1-20.3 24.8-34.2 46-34.2zM74.7 227.9l.1-.3c6.6-2.3 13.8-3.6 21.2-3.6h320c7.4 0 14.5 1.3 21.2 3.6l.1.3.5-.1c24.6 8.9 42.3 32.5 42.3 60.2H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32c0 17.7-14.3 32-32 32h-96v-32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v32H64c-17.7 0-32-14.3-32-32v-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c0-27.7 17.6-51.3 42.3-60.2l.5.1zM320 384H192v-32h128v32zM48.7 203.4l-.4 1.3C19.4 221.2 0 252.3 0 288v64c0 23.7 12.9 44.4 32 55.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h384v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-56.6c19.1-11.1 32-31.7 32-55.4v-64c0-35.7-19.4-66.8-48.3-83.3l-.4-1.3L429 89c-10.2-33.8-41.3-57-76.6-57H159.6C124.3 32 93.1 55.2 83 89L48.7 203.4z"
        }
    ]
};

const FalCarSideBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarSideBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M126.8 94.2 87.6 192H160v32H64c-17.7 0-32 14.3-32 32v112h33.3c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80h130.6c7.6-45.4 47.1-80 94.7-80s87.1 34.6 94.7 80H608v-48c0-53-43-96-96-96h-64v-32h30.7l-88-110c-9.1-11.4-22.9-18-37.5-18H171.3c-19.6 0-37.3 11.9-44.6 30.2zm-74 98.8L97.1 82.3C109.2 51.9 138.6 32 171.3 32h181.9c24.3 0 47.3 11 62.5 30l104.2 130.2C586.9 196.3 640 252 640 320v48c0 17.7-14.3 32-32 32h-33.3c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H254.7c-7.6 45.4-47.1 80-94.7 80s-87.1-34.6-94.7-80H32c-17.7 0-32-14.3-32-32V256c0-31.5 22.8-57.7 52.8-63zM418 368c-1.3 5.1-2 10.5-2 16s.7 10.9 2 16c7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48zM96 384c0 5.5.7 10.9 2 16 7.1 27.6 32.2 48 62 48s54.9-20.4 62-48c1.3-5.1 2-10.5 2-16s-.7-10.9-2-16c-7.1-27.6-32.2-48-62-48s-54.9 20.4-62 48c-1.3 5.1-2 10.5-2 16zm251.3-260.7L278.6 192H368c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l68.7-68.7H240c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalCarSide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarSide",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 64H224v128H87.6l39.1-97.8c7.4-18.3 25-30.2 44.6-30.2zM256 192V64h97.2c14.6 0 28.4 6.6 37.5 18l88 110H256zm263.9.2L415.7 62c-15.2-19-38.2-30-62.5-30H171.3c-32.7 0-62.1 19.9-74.3 50.3L52.8 193C22.8 198.3 0 224.5 0 256v112c0 17.7 14.3 32 32 32h33.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80h130.6c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H608c17.7 0 32-14.3 32-32v-48c0-68-53.1-123.7-120.1-127.8zM542 400c-7.1 27.6-32.2 48-62 48s-54.9-20.4-62-48c-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16zm-156.7-32H254.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H32V256c0-17.7 14.3-32 32-32h448c53 0 96 43 96 96v48h-33.3c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80zM160 448c-29.8 0-54.9-20.4-62-48-1.3-5.1-2-10.5-2-16s.7-10.9 2-16c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48c1.3 5.1 2 10.5 2 16s-.7 10.9-2 16c-7.1 27.6-32.2 48-62 48z"
        }
    ]
};

const FalCarTilt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarTilt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m131.7 88.2 172.6-46.3c20.5-5.5 42.1 3.1 53.3 21.1l48.2 78c-4.6.5-9.3 1.4-14 2.7L106.9 220c-4.7 1.2-9.1 2.8-13.4 4.7l2.7-91.6c.6-21.2 15.1-39.5 35.6-44.9zM60.9 243.3l-.1 4.8c-21.3 23.4-30.6 56.7-21.8 89.5l22 82.1 4.3 16.3 11.8 44H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16H108.6l-10-37.2 1.5-.4 408.6-109.5 1.5-.4 11.8 44.1c2.2 8.1 10.5 12.9 18.6 10.8s12.9-10.5 10.8-18.6l-11.8-44.1-8.3-30.9-22-82.1c-8.8-32.8-33.5-57-63.6-66.6l-2.5-4-58.4-94.9C366.2 16.2 330.1 1.9 296 11L123.4 57.2c-34.1 9.1-58.2 39.6-59.3 74.9l-3.2 111.2zm54.3 7.6L400 174.6c34.1-9.1 69.2 11.1 78.4 45.3l22 82.1L91.9 411.5l-22-82.1c-9.1-34.1 11.1-69.2 45.3-78.4zm42.2 58a22.8 22.8 0 1 0-44.1 11.8 22.8 22.8 0 1 0 44.1-11.8zm263-46.9a22.8 22.8 0 1 0-11.8-44.1 22.8 22.8 0 1 0 11.8 44.1z"
        }
    ]
};

const FalCarTunnel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarTunnel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C132.3 32 32 132.3 32 256v240c0 8.8-7.2 16-16 16s-16-7.2-16-16V256C0 114.6 114.6 0 256 0s256 114.6 256 256v240c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-123.7-100.3-224-224-224zm-81.3 234.7-19 54.3c4-.7 8.1-1 12.2-1H344c4.2 0 8.3.4 12.2 1l-19-54.3c-2.2-6.4-8.2-10.7-15-10.7H189.8c-6.8 0-12.9 4.3-15.1 10.7zm-61.2 78.2 31-88.7c6.7-19.3 24.9-32.2 45.3-32.2h132.4c20.4 0 38.6 12.9 45.3 32.2l31 88.7C409.4 357.5 416 374 416 392v104c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H128v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V392c0-18 6.6-34.5 17.5-47.1zM128 448h256v-56c0-22.1-17.9-40-40-40H168c-22.1 0-40 17.9-40 40v56zm32-48a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalCarWash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarWash",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M76.3 92.5C74.7 93.9 71 96 64 96c-8.8 0-16-7.2-16-16 0-1.7 1.6-8.3 8.6-19.6 2.3-3.7 4.8-7.5 7.4-11 2.6 3.6 5.2 7.3 7.4 11C78.4 71.7 80 78.3 80 80c0 8.4-2.6 11.4-3.7 12.5zM64 128c26.5 0 48-16 48-48 0-22.2-23-52-37.2-68.2-5.8-6.7-15.8-6.7-21.6 0C39 28 16 57.8 16 80c0 26.5 21.5 48 48 48zm176-48c0 8.4-2.6 11.4-3.7 12.5-1.6 1.4-5.3 3.5-12.3 3.5-8.8 0-16-7.2-16-16 0-1.7 1.6-8.3 8.6-19.6 2.3-3.7 4.8-7.5 7.4-11 2.6 3.6 5.2 7.3 7.4 11 7 11.3 8.6 17.9 8.6 19.6zm32 0c0-22.2-23-52-37.2-68.2-5.8-6.7-15.9-6.7-21.7 0C199 28 176 57.8 176 80c0 26.5 21.5 48 48 48s48-16 48-48zM156.2 208h135.6c14.3 0 26.8 9.5 30.8 23.2l16.2 56.8H109.2l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L73 298.1C48.6 311.8 32 338 32 368v128c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h320v32c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H156.2c-28.6 0-53.7 18.9-61.5 46.4zM384 416v16H64v-64c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v48zm-272-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm40-296c0 8.4-2.6 11.4-3.7 12.5-1.6 1.4-5.3 3.5-12.3 3.5-8.8 0-16-7.2-16-16 0-1.7 1.6-8.3 8.6-19.6 2.3-3.7 4.8-7.5 7.4-11 2.6 3.6 5.2 7.3 7.4 11 7 11.3 8.6 17.9 8.6 19.6zm32 0c0-22.2-23-52-37.2-68.2-5.8-6.7-15.9-6.7-21.7 0C359 28 336 57.8 336 80c0 26.5 21.5 48 48 48s48-16 48-48z"
        }
    ]
};

const FalCarWrench = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarWrench",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 40c22 0 41 12.6 50.2 31.1l4.4 8.9h226.8l4.4-8.9C383 52.6 402 40 424 40c25.4 0 46.8 16.9 53.7 40H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h45.7c-6.9 23.1-28.3 40-53.7 40-22 0-41-12.6-50.2-31.1l-4.4-8.9H142.6l-4.4 8.9C129 139.4 110 152 88 152c-25.4 0-46.8-16.9-53.7-40H80c8.8 0 16-7.2 16-16s-7.2-16-16-16H34.3C41.2 56.9 62.6 40 88 40zM0 96c0 48.6 39.4 88 88 88 30.9 0 58.1-15.9 73.8-40h188.4c15.7 24.1 42.9 40 73.8 40 48.6 0 88-39.4 88-88S472.6 8 424 8c-30.9 0-58.1 15.9-73.8 40H161.8C146.1 23.9 118.9 8 88 8 39.4 8 0 47.4 0 96zm188.2 112h135.6c14.3 0 26.8 9.5 30.8 23.2l16.2 56.8H141.2l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L105 298.1C80.6 311.8 64 338 64 368v128c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h320v32c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H188.2c-28.6 0-53.7 18.9-61.5 46.4zM416 416v16H96v-64c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v48zm-272-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m113.6 98.2-28.3 94.4c3.5-.4 7.1-.6 10.7-.6h320c3.6 0 7.2.2 10.7.6l-28.3-94.4c-6.1-20.3-24.8-34.2-46-34.2H159.6c-21.2 0-39.9 13.9-46 34.2zM74.3 227.8C49.6 236.7 32 260.3 32 288v96h448v-96c0-27.7-17.6-51.3-42.3-60.2l-.5.1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H96c-7.4 0-14.5 1.3-21.2 3.6l-.1.3-.5-.1zm-26-23.1.4-1.3L83 89c10.2-33.8 41.3-57 76.6-57h192.8c35.3 0 66.5 23.2 76.6 57l34.3 114.4.4 1.3c28.9 16.5 48.3 47.6 48.3 83.3v176c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-35.7 19.4-66.8 48.3-83.3zM104 272a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm280 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalCaravanSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCaravanSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 64c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h21.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H544V192c0-70.7-57.3-128-128-128H80zm16 352H80c-44.2 0-80-35.8-80-80V112c0-44.2 35.8-80 80-80h336c88.4 0 160 71.6 160 160v192h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H288c0 53-43 96-96 96s-96-43-96-96zm160-256H128v64h128v-64zm-128-32h128c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm224 32v64h64v-64h-64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm-64 256a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FalCaravan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCaravan",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 64c70.7 0 128 57.3 128 128v192h-64V168c0-22.1-17.9-40-40-40h-80c-22.1 0-40 17.9-40 40v216h-37.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H80c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h336zM80 416h16c0 53 43 96 96 96s96-43 96-96h336c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V192c0-88.4-71.6-160-160-160H80C35.8 32 0 67.8 0 112v224c0 44.2 35.8 80 80 80zm368-192h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v128h-96V168c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v56zm-320-64h128v64H128v-64zm-32 0v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32zm96 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FalCardClub = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCardClub",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h256zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm144 331.9c7.5 2.7 15.6 4.1 24 4.1 39.8 0 72-32.2 72-72 0-28.3-16.3-52.7-40-64.5-.3-39.5-32.4-71.5-72-71.5s-71.7 32-72 71.5c-23.7 11.8-40 36.2-40 64.5 0 39.8 32.2 72 72 72 8.4 0 16.5-1.4 24-4.1V352h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-20.1zM152 200c0-22.1 17.9-40 40-40s40 17.9 40 40c0 2.5-.2 4.9-.6 7.2-1.5 8.1 3.5 16 11.4 18.3 16.9 4.7 29.2 20.2 29.2 38.5 0 22.1-17.9 40-40 40-11.2 0-21.3-4.6-28.6-12-3-3.1-7.1-4.8-11.4-4.8s-8.4 1.7-11.4 4.8c-7.3 7.4-17.4 12-28.6 12-22.1 0-40-17.9-40-40 0-18.3 12.3-33.8 29.2-38.5 8-2.2 12.9-10.1 11.4-18.3-.4-2.3-.6-4.7-.6-7.2z"
        }
    ]
};

const FalCardDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCardDiamond",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm203.3 84.7 96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0zM192 329.4l73.4-73.4-73.4-73.4-73.4 73.4 73.4 73.4z"
        }
    ]
};

const FalCardHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCardHeart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 157.3c0 7.8 3.1 15.2 8.6 20.7l71.4 71.4 71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7 0-16.2-13.1-29.3-29.3-29.3-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0L162 200.6c-5.5-5.5-12.9-8.6-20.7-8.6-16.2 0-29.3 13.1-29.3 29.3zm29.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.9-82.7C86.5 253.1 80 237.5 80 221.3c0-33.8 27.4-61.3 61.3-61.3z"
        }
    ]
};

const FalCardSpade = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCardSpade",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm180.7 68.2c6.2-6.2 16.4-6.2 22.6 0l33.9 33.9 59.8 59.8c25 25 25 65.5 0 90.5-24.5 24.5-63.9 25-89 1.5V352h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-34.2c-25.1 23.5-64.5 23-89-1.5-25-25-25-65.5 0-90.5l59.7-59.7 33.9-33.9zm11.3 33.9-22.6 22.6-59.7 59.7c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l25.8-25.8c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7l25.8 25.8c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-59.7-59.7-22.8-22.6z"
        }
    ]
};

const FalCardsBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCardsBlank",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M202.3 468.3c6.7 11 20.9 14.8 32.1 8.6 0 0 .1 0 .1-.1l192.9-111.3s.1 0 .1-.1c11.2-6.7 15-21.2 8.4-32.6L269.2 44.1c-6.6-11.5-21.3-15.4-32.8-8.8L44.1 146.4c-11.3 6.5-15.3 20.9-9 32.3 0 .1.1.1.1.2l167 289.3c0 .1.1.1.1.2zm-27.5 16.4c-.2-.3-.3-.6-.5-.9L7.6 195.2c-.2-.3-.3-.6-.5-.9-14.9-26.5-5.7-60.2 20.7-75.5L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.3 26.5 6.3 60.3-20 75.8-.2.1-.5.3-.7.4l-192.3 111c-.2.1-.5.3-.7.4-26.4 14.9-59.8 6-75.3-20zM324.1 499l33.2-19.1c.9.1 1.8.2 2.7.2h224c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H373l-18.3-31.8c1.7-.2 3.5-.2 5.3-.2h224c30.9 0 56 25.1 56 56v336c0 30.9-25.1 56-56 56H360c-13.7 0-26.2-4.9-35.9-13z"
        }
    ]
};

const FalCards = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCards",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M202.3 468.3c6.7 11 20.9 14.8 32.1 8.6 0 0 .1 0 .1-.1l192.9-111.3s.1 0 .1-.1c11.2-6.7 15-21.2 8.4-32.6L269.2 44.1c-6.6-11.5-21.3-15.4-32.8-8.8L44.1 146.4c-11.3 6.5-15.3 20.9-9 32.3 0 .1.1.1.1.2l167 289.3c0 .1.1.1.1.2zm-27.5 16.4c-.2-.3-.3-.6-.5-.9L7.6 195.2c-.2-.3-.3-.6-.5-.9-14.9-26.5-5.7-60.2 20.7-75.5L220.7 7.5c26.6-15.4 60.7-6.3 76.1 20.4l167 289.3c15.3 26.5 6.3 60.3-20 75.8-.2.1-.5.3-.7.4l-192.3 111c-.2.1-.5.3-.7.4-26.4 14.9-59.8 6-75.3-20zM360 512c-13.7 0-26.2-4.9-35.9-13l33.2-19.1c.9.1 1.8.2 2.7.2h224c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24H373l-18.3-31.8c1.7-.2 3.5-.2 5.3-.2h224c30.9 0 56 25.1 56 56v336c0 30.9-25.1 56-56 56H360zm109.4-349.2-.1.1c-6.7 5.7-7 16-1.1 22.2l35.9 37 35.7-37c5.9-6.1 5.6-16.4-.9-22.2-5.1-4.2-13.4-4-19.1 1.7l-3.9 4.3c-3 3.3-7.2 5.2-11.7 5.3s-8.7-1.7-11.8-5l-4.3-4.5c-5.9-5.9-14.4-5.8-18.9-1.9zm-21-24.2c16.5-14.3 39.3-13.3 55.6-2.2 16.2-11.1 38.9-11.9 55.6 2.1l.2.2c20.5 17.9 21.5 49.4 3 68.6L520.6 251l-.2.2c-8.8 8.8-23.7 9.5-33-.3l-42.3-43.6c-18.5-19.2-17.6-50.8 3.2-68.7zM252.2 340.4l48.2-27.8c7.7-4.4 17.4-1.8 21.9 5.9s1.8 17.4-5.9 21.9l-48.2 27.8c-7.7 4.4-17.4 1.8-21.9-5.9s-1.8-17.4 5.9-21.9zm-27-40.1 5.9-27.4c.9-4.4 3.6-8.1 7.5-10.4s8.4-2.9 12.7-1.6l27.6 8.1c12.9 3.5 26.2-3.2 29.6-13.2v-.1c5-14.2-3.4-30-17.5-34L200.8 196l-22.6 90.8c-3.5 14.2 5.8 29.3 20.3 32.3 10.9 1.8 23-5.6 26.7-18.9zm31 7.9c-7.4 27.8-34.3 47.5-63.4 42.5l-.4-.1c-32.7-6.5-53.3-39.7-45.3-71.5l26.6-106.9c1-4.2 3.8-7.8 7.5-10s8.2-2.7 12.4-1.5L299.9 191c31.5 9.1 50 43.5 38.8 75.4-10.1 29.4-42.9 40.6-68.5 33.6l-.3-.1-11.2-3.3-2.4 10.9c-.1.2-.1.5-.2.7z"
        }
    ]
};

const FalCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCaretDown",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M165.6 349.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 236.3c-1.4-1.3-2.2-3.2-2.2-5.2 0-3.9 3.2-7.1 7.1-7.1h241.7c3.9 0 7.1 3.2 7.1 7.1 0 2-.8 3.8-2.2 5.2L165.6 349.8zm22 23.3 120.1-113.5c7.8-7.4 12.3-17.7 12.3-28.4 0-21.6-17.5-39.1-39.1-39.1L39.1 192C17.5 192 0 209.5 0 231.1c0 10.8 4.4 21.1 12.3 28.4l120.1 113.6c7.4 7 17.3 10.9 27.6 10.9s20.1-3.9 27.6-10.9z"
        }
    ]
};

const FalCaretLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCaretLeft",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M34.2 261.6c-1.3-1.4-2.2-3.5-2.2-5.6s.8-4.2 2.2-5.6l113.5-120.2c1.3-1.4 3.2-2.2 5.2-2.2 3.9 0 7.1 3.2 7.1 7.1v241.7c0 3.9-3.2 7.1-7.1 7.1-2 0-3.8-.8-5.2-2.2L34.2 261.6zm-23.3 22 113.5 120.1c7.4 7.8 17.7 12.3 28.4 12.3 21.6 0 39.1-17.5 39.1-39.1V135.2c0-21.6-17.5-39.1-39.1-39.1-10.8 0-21.1 4.4-28.5 12.3l-113.4 120C3.9 235.9 0 245.8 0 256s3.9 20.1 10.9 27.6z"
        }
    ]
};

const FalCaretRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCaretRight",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M221.8 250.4c1.3 1.4 2.2 3.5 2.2 5.6s-.8 4.2-2.2 5.6L108.3 381.8c-1.3 1.4-3.2 2.2-5.2 2.2-3.9 0-7.1-3.2-7.1-7.1V135.2c0-3.9 3.2-7.1 7.1-7.1 2 0 3.8.8 5.2 2.2l113.5 120.1zm23.3-22L131.6 108.3c-7.4-7.8-17.7-12.3-28.4-12.3C81.5 96 64 113.5 64 135.1v241.7c0 21.6 17.5 39.1 39.1 39.1 10.8 0 21.1-4.4 28.4-12.3l113.6-120c7-7.4 10.9-17.3 10.9-27.6s-3.9-20.1-10.9-27.6z"
        }
    ]
};

const FalCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCaretUp",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154.4 162.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2.8 5.6 2.2l120.2 113.5c1.4 1.3 2.2 3.2 2.2 5.2 0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1 0-2 .8-3.8 2.2-5.2l120.2-113.5zm-22-23.3L12.3 252.4C4.4 259.8 0 270.1 0 280.9 0 302.5 17.5 320 39.1 320h241.8c21.6 0 39.1-17.5 39.1-39.1 0-10.8-4.4-21.1-12.3-28.4L187.6 138.9c-7.4-7-17.3-10.9-27.6-10.9s-20.1 3.9-27.6 10.9z"
        }
    ]
};

const FalCarrot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCarrot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 88c0-23.9 14.5-45.4 23-55.8h.1c.1-.1.4-.2.9-.2.4 0 .7.1.8.1C352.9 42.3 368 65.6 368 96c0 14.7-1.8 22.9-3.2 26.9-.6 1.6-1 2.6-1.2 2.9-5.2 6.3-4.8 15.6 1.1 21.4s15.2 6.2 21.4 1.1c.4-.2 1.3-.7 2.9-1.2 4-1.3 12.2-3.2 26.9-3.2 30.4 0 53.7 15.1 63.9 23.2 0 .1.1.4.1.8 0 .5-.1.8-.2.9v.1c-10.4 8.5-32 23-55.8 23-17.7 0-28.7-3.3-37.7-8.6-9.8-5.7-18.3-14-31-26.7s-21.1-21.2-26.7-31c-5.3-9.1-8.6-20-8.6-37.7zm96 24c-6.3 0-11.9.3-16.8.8.5-4.9.8-10.5.8-16.8 0-40.9-20.2-71.2-30.2-83.9C363.1 3.7 353.2 0 344 0s-19 3.7-25.7 11.8C308.7 23.6 288 52.5 288 88c0 19.5 3.3 34.8 9.9 48.2-14.3-5.3-29.7-8.2-45.8-8.2-50.9 0-97.2 29.3-119.1 75.2L2.3 477.7C-2 486.9-.2 497.8 7 505s18.1 9.1 27.3 4.7L308.8 379c45.9-21.9 75.2-68.2 75.2-119.1 0-16.1-2.9-31.5-8.2-45.8 13.4 6.6 28.6 9.9 48.2 9.9 35.5 0 64.4-20.7 76.2-30.3 8.1-6.7 11.8-16.5 11.8-25.7s-3.7-19.1-12.1-25.8c-12.7-10.1-43-30.2-83.9-30.2zm-163.9 48c55.2 0 99.9 44.7 99.9 99.9 0 38.5-22.2 73.6-56.9 90.2l-120.9 57.5-34.9-34.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l26.9 26.9-102.7 48.9 110.8-232.7 29 29c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-36.6-36.6c18-29.6 50.3-48.1 85.4-48.1z"
        }
    ]
};

const FalCars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCars",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M124.2 32h135.6c14.3 0 26.8 9.5 30.8 23.2l16.2 56.8H77.2l16.2-56.8c4-13.7 16.5-23.2 30.8-23.2zM62.7 46.4 41 122.1C16.6 135.8 0 162 0 192v128c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h225.6c3.7-3.7 7.7-7.1 11.9-10.2l6.2-21.8H32v-64c0-26.5 21.5-48 48-48h224c11.8 0 22.6 4.3 31 11.3 10.3-5.5 21.6-9.2 33.6-10.6-6.8-9.2-15.5-17-25.6-22.6l-21.7-75.7C313.5 18.9 288.4 0 259.8 0H124.2C95.6 0 70.5 18.9 62.7 46.4zM80 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm300.2-16h135.6c14.3 0 26.8 9.5 30.8 23.2l16.2 56.8H333.2l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2zm-61.5 14.4L297 298.1c-24.5 13.7-41 39.9-41 69.9v128c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h320v32c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-7.8-27.5-33-46.4-61.5-46.4H380.2c-28.6 0-53.7 18.9-61.5 46.4zM608 416v16H288v-64c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v48zm-272-16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm248-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCartArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h37.9c22.8 0 42.5 16 47 38.4L145.4 256h321.1c14.7 0 27.5-10 31-24.2l47-187.7c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-46.9 187.6c-7.1 28.5-32.7 48.5-62.1 48.5H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2l-58.9-288C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zm192 464a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zM336 16v137.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalCartArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h37.9c22.8 0 42.5 16 47 38.4L145.4 256h321.1c14.7 0 27.5-10 31-24.2l47-187.7c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-46.9 187.6c-7.1 28.5-32.7 48.5-62.1 48.5H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2l-58.9-288C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zm192 464a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm-88-248V86.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 86.6V208c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalCartCircleArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartCircleArrowDown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h51.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5h160.7c-.5-5.3-.7-10.6-.7-16s.2-10.7.7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64h434.4l-36 128.3c10.9.6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100l-4.4-19.5C93.9 5.2 87.5 0 80 0H16zm168 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm424-144a112 112 0 1 1-224 0 112 112 0 1 1 224 0zm-256 0a144 144 0 1 0 288 0 144 144 0 1 0-288 0zm211.3-3.3c-6.2-6.2-16.4-6.2-22.6 0L512 393.4V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56 56c6.2 6.2 16.4 6.2 22.6 0l56-56c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalCartCircleArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartCircleArrowUp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h51.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5h160.7c-.5-5.3-.7-10.6-.7-16s.2-10.7.7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64h434.4l-36 128.3c10.9.6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100l-4.4-19.5C93.9 5.2 87.5 0 80 0H16zm168 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm200-144a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-211.3 3.3c6.2 6.2 16.4 6.2 22.6 0l28.7-28.7V432c0 8.8 7.2 16 16 16s16-7.2 16-16v-89.4l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0l-56 56c-6.2 6.2-6.2 16.4 0 22.6z"
        }
    ]
};

const FalCartCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h51.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5h160.7c-.5-5.3-.7-10.6-.7-16s.2-10.7.7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64h434.4l-36 128.3c10.9.6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100l-4.4-19.5C93.9 5.2 87.5 0 80 0H16zm168 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm312-256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalCartCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h51.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5h160.7c-.5-5.3-.7-10.6-.7-16s.2-10.7.7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64h434.4l-36 128.3c10.9.6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100l-4.4-19.5C93.9 5.2 87.5 0 80 0H16zm168 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm200-144a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalCartCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h51.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5h160.7c-.5-5.3-.7-10.6-.7-16s.2-10.7.7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64h434.4l-36 128.3c10.9.6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100l-4.4-19.5C93.9 5.2 87.5 0 80 0H16zm168 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm200-144a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-128-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FalCartCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h51.2l77.2 339.5c1.7 7.3 8.1 12.5 15.6 12.5h160.7c-.5-5.3-.7-10.6-.7-16s.2-10.7.7-16H172.8l-14.5-64h181c5.9-11.4 12.9-22.2 21-32H151L107.3 64h434.4l-36 128.3c10.9.6 21.6 2.2 31.9 4.7l35-124.3C578.3 52.3 563 32 541.8 32H100l-4.4-19.5C93.9 5.2 87.5 0 80 0H16zm168 432a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm200-144a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"
        }
    ]
};

const FalCartFlatbedBoxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartFlatbedBoxes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h64c8.8 0 16 7.2 16 16v320c0 26.5 21.5 48 48 48h24.6c-5.4 9.4-8.6 20.3-8.6 32 0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32h177.2c-5.4 9.4-8.6 20.3-8.6 32 0 35.3 28.7 64 64 64s64-28.7 64-64c0-11.7-3.1-22.6-8.6-32H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16-7.2-16-16V48c0-26.5-21.5-48-48-48H16zm528 448a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-320 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-416h128v224H224V64zm-32 0v224c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32zm320 0v64h-64V64h64zm-64-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-64zm0 192h128v64H448v-64zm-32 0v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalCartFlatbedEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartFlatbedEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h64c26.5 0 48 21.5 48 48v320c0 8.8 7.2 16 16 16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16h-56.6c5.4 9.4 8.6 20.3 8.6 32 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H144c-26.5 0-48-21.5-48-48V48c0-8.8-7.2-16-16-16H16C7.2 32 0 24.8 0 16zm512 400a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-320 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FalCartFlatbedSuitcase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartFlatbedSuitcase",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h64c26.5 0 48 21.5 48 48v320c0 8.8 7.2 16 16 16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16h-56.6c5.4 9.4 8.6 20.3 8.6 32 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H144c-26.5 0-48-21.5-48-48V48c0-8.8-7.2-16-16-16H16C7.2 32 0 24.8 0 16zm512 400a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-320 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM336 32c-8.8 0-16 7.2-16 16v32h128V48c0-8.8-7.2-16-16-16h-96zm144 48h32c35.3 0 64 28.7 64 64v112c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h32V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v32zm-208 32h-16c-17.7 0-32 14.3-32 32v112c0 17.7 14.3 32 32 32h16V112zm32 176h160V112H304v176zm192 0h16c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32h-16v176z"
        }
    ]
};

const FalCartFlatbed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartFlatbed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h64c26.5 0 48 21.5 48 48v320c0 8.8 7.2 16 16 16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16h-56.6c5.4 9.4 8.6 20.3 8.6 32 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H279.4c5.4 9.4 8.6 20.3 8.6 32 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-11.7 3.1-22.6 8.6-32H144c-26.5 0-48-21.5-48-48V48c0-8.8-7.2-16-16-16H16C7.2 32 0 24.8 0 16zm512 400a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm-320 32a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM320 64h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-80v128c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L400 164l-54.4 40.8c-4.8 3.6-11.3 4.2-16.8 1.5S320 198 320 192V64zm32 0v96l38.4-28.8a15.9 15.9 0 0 1 19.2 0L448 160V64h-96zM240 32h320c26.5 0 48 21.5 48 48v192c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FalCartMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h37.9c22.8 0 42.5 16 47 38.4L145.4 256h321.1c14.7 0 27.5-10 31-24.2l47-187.7c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-46.9 187.6c-7.1 28.5-32.7 48.5-62.1 48.5H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2l-58.9-288C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zm192 464a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zM256 112h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCartPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartPlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h37.9c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.2c-15.2 0-28.3-10.7-31.4-25.6L152 288h314.5c29.4 0 55-20 62.1-48.5l46.9-187.6c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-46.9 187.7C494 246 481.2 256 466.5 256H145.4L100.9 38.4C96.3 16 76.7 0 53.9 0H16zm152 456a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM240 128c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalCartShoppingFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartShoppingFast",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 16c0-8.8 7.2-16 16-16h37.9c20.6 0 38.6 13 45.3 32h440.3c20.8 0 36.1 19.6 31 39.8l-41.9 167.7c-7.1 28.5-32.7 48.5-62.1 48.5H216l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H255.2c-30.4 0-56.6-21.4-62.7-51.2l-58.9-288C132 37.3 125.5 32 117.9 32H80c-8.8 0-16-7.2-16-16zm466.5 240c14.7 0 27.5-10 31-24.2l42-167.8H170.1l39.3 192h321.1zM256 480a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zM16 128h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCartShopping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartShopping",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h37.9c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.2c-15.2 0-28.3-10.7-31.4-25.6L152 288h314.5c29.4 0 55-20 62.1-48.5l42-167.7c5-20.2-10.2-39.8-31-39.8H99.1C92.5 13 74.4 0 53.9 0H16zm90.1 64h433.4l-41.9 167.8C494 246 481.2 256 466.5 256H145.4L106.1 64zM168 456a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
        }
    ]
};

const FalCartXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCartXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h37.9c22.8 0 42.5 16 47 38.4L145.4 256h321.1c14.7 0 27.5-10 31-24.2l47-187.7c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-46.9 187.6c-7.1 28.5-32.7 48.5-62.1 48.5H152l7.9 38.4c3 14.9 16.1 25.6 31.4 25.6H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H191.2c-30.4 0-56.6-21.4-62.7-51.2l-58.9-288C68 37.3 61.5 32 53.9 32H16C7.2 32 0 24.8 0 16zm192 464a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm280 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zM379.3 91.3 342.6 128l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 150.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalCashRegister = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCashRegister",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h192zM80 0C53.5 0 32 21.5 32 48v32c0 26.5 21.5 48 48 48h80v32H87.5c-31.8 0-58.9 23.4-63.4 54.9L.6 379.5c-.4 3-.6 6-.6 9V448c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-59.5c0-3-.2-6.1-.6-9l-23.6-164.6c-4.5-31.5-31.5-54.9-63.4-54.9H192v-32h80c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H80zM32 448v-32h448v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zm424.2-228.5L479.7 384H32.3l23.5-164.5c2.3-15.8 15.8-27.5 31.7-27.5h337c15.9 0 29.4 11.7 31.7 27.5zM112 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"
        }
    ]
};

const FalCassetteBetamax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCassetteBetamax",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 160v256c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V160H32zm0-32h512V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v32zm544-32v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64zM240 304a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm72 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm200-48v96h96v-96h-96zm-32 0c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96z"
        }
    ]
};

const FalCassetteTape = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCassetteTape",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32h-33.9l-23.4-64.4c-6.9-19-24.9-31.6-45.1-31.6H166.4c-20.2 0-38.2 12.6-45.1 31.6L97.9 448H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h448zm-67.9 384H131.9l19.4-53.5c2.3-6.3 8.3-10.5 15-10.5h243.3c6.7 0 12.7 4.2 15 10.5l19.5 53.5zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm96 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32s-3.1-22.6-8.6-32h145.2c-5.4 9.4-8.6 20.3-8.6 32s3.1 22.6 8.6 32H215.4zM160 288h256c35.3 0 64-28.7 64-64s-28.7-64-64-64H160c-35.3 0-64 28.7-64 64s28.7 64 64 64zm256-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FalCassetteVhs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCassetteVhs",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 160v256c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V160H32zm0-32h512V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v32zm544-32v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64zM136 208h304c3.5 0 6.9 1.1 9.7 3.3L440 224l9.7-12.7h.1l.2.1.5.4c.4.3 1 .8 1.6 1.3 1.3 1.1 3.2 2.7 5.3 4.8 4.3 4.1 9.9 10.2 15.6 18 11.3 15.5 23 38.8 23 68s-11.8 52.5-23 68c-5.7 7.8-11.3 13.8-15.6 18-2.1 2.1-4 3.7-5.3 4.8-.7.6-1.2 1-1.6 1.3l-.5.4-.2.1h-.1l-9.7-12.7 9.7 12.7c-2.8 2.1-6.2 3.3-9.7 3.3H136c-3.5 0-6.9-1.1-9.7-3.3L136 384l-9.7 12.7h-.1l-.2-.1-.5-.4c-.4-.3-1-.8-1.6-1.3-1.3-1.1-3.2-2.7-5.3-4.8-4.3-4.1-9.9-10.2-15.6-18-11.3-15.5-23-38.8-23-68s11.8-52.5 23-68c5.7-7.8 11.3-13.8 15.6-18 2.1-2.1 4-3.7 5.3-4.8.7-.6 1.2-1 1.6-1.3l.5-.4.2-.1h.1l9.7 12.7-9.7-12.7c2.8-2.1 6.2-3.3 9.7-3.3zm4.9 33c-3.2 3.1-7.6 7.8-11.9 13.7-8.7 12.1-17 28.8-17 49.2s8.2 37.2 17 49.2c4.3 6 8.7 10.6 11.9 13.7.4.4.7.7 1.1 1h50V336c-17.7 0-32-14.3-32-32s14.3-32 32-32v-32h-50.1c-.3.3-.7.7-1.1 1zM352 368V240H224v128h128zm82.1 0c.3-.3.7-.7 1.1-1 3.2-3.1 7.6-7.8 11.9-13.7 8.7-12.1 17-28.8 17-49.2s-8.2-37.2-17-49.2c-4.3-6-8.7-10.6-11.9-13.7-.4-.4-.7-.7-1.1-1H384v32c17.7 0 32 14.3 32 32s-14.3 32-32 32v32h50.1z"
        }
    ]
};

const FalCastle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCastle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 40c0-22.1 17.9-40 40-40h24c22.1 0 40 17.9 40 40v24h32V40c0-22.1 17.9-40 40-40h32c22.1 0 40 17.9 40 40v24h32V40c0-22.1 17.9-40 40-40h24c22.1 0 40 17.9 40 40v184h32v-24c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v232c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V200c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v24h32V40zm40-8c-4.4 0-8 3.6-8 8v184h320V40c0-4.4-3.6-8-8-8h-24c-4.4 0-8 3.6-8 8v40c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8h-32c-4.4 0-8 3.6-8 8v40c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8h-24zm328 224H80c-8.8 0-16-7.2-16-16v-40c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8v232c0 26.5 21.5 48 48 48h144v-80c0-53 43-96 96-96s96 43 96 96v80h144c26.5 0 48-21.5 48-48V200c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v40c0 8.8-7.2 16-16 16h-64zM384 400c0-35.3-28.7-64-64-64s-64 28.7-64 64v80h128v-80z"
        }
    ]
};

const FalCatSpace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCatSpace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 288c-70.7 0-128-57.3-128-128 0-32.5 12.1-62.1 32-84.7V160c0 53 43 96 96 96s96-43 96-96V75.3c19.9 22.6 32 52.2 32 84.7 0 70.7-57.3 128-128 128zm0-256c25.4 0 49.2 7.4 69.1 20.2L482.4 80h-68.8l-34.7-27.8C398.8 39.4 422.6 32 448 32zm64 274.7c56.5-24.7 96-81.1 96-146.7C608 71.6 536.4 0 448 0S288 71.6 288 160c0 4.6.2 9.1.6 13.6-69.8 18.5-127.1 64.8-160.6 125.6V176.5c0-40.3-30-74.4-70.1-79.4l-7.9-1c-8.8-1.1-16.8 5.1-17.9 13.9s5.1 16.8 13.9 17.9l7.9 1c24 3 42 23.4 42 47.6V432c0 44.2 35.8 80 80 80h170.8c20.6 0 37.3-16.7 37.3-37.3 0-25.8-16.7-47.7-39.8-55.6l71.8-39.9V464c0 26.5 21.5 48 48 48s48-21.5 48-48V306.7zm-32 10.1V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-5.7-3-10.9-7.9-13.8s-10.9-3-15.9-.2L304 404.8V392c0-39.8-32.2-72-72-72h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c22.1 0 40 17.9 40 40v40c0 8.8 7.2 16 16 16h37.3c14.7 0 26.7 11.9 26.7 26.7 0 2.9-2.4 5.3-5.3 5.3H176c-26.5 0-48-21.5-48-48v-8c0-103.1 69.2-192 166.5-218.8C314 271.5 375.3 320 448 320c11 0 21.7-1.1 32-3.2zM240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V80h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V16zm144 81.3 14 11.2c2.8 2.3 6.4 3.5 10 3.5h80c3.6 0 7.2-1.2 10-3.5l14-11.2V160c0 35.3-28.7 64-64 64s-64-28.7-64-64V97.3zm32 70.7a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalCat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 33v111c0 44.2 35.8 80 80 80s80-35.8 80-80V33c0-.5-.4-1-1-1-.3 0-.5.1-.7.3L472 70.6c-6 6-14.1 9.4-22.6 9.4h-34.8c-8.5 0-16.6-3.4-22.6-9.4l-38.3-38.3c-.2-.2-.4-.3-.7-.3-.5 0-1 .4-1 1zm1-33c8.7 0 17.1 3.5 23.3 9.7L414.6 48h34.7l38.4-38.3C493.9 3.5 502.3 0 511 0c18.2 0 33 14.8 33 33v111c0 61.9-50.1 112-112 112s-112-50.1-112-112V33c0-18.2 14.8-33 33-33zM128 299.2C161.8 237.7 220.1 191 290.9 173c2.2 10.6 5.5 20.9 9.9 30.5C200.2 228.2 128 318.7 128 424v8c0 26.5 21.5 48 48 48h170.6c2.9 0 5.3-2.4 5.3-5.3 0-14.7-11.9-26.7-26.7-26.7H288c-8.8 0-16-7.2-16-16v-40c0-22.1-17.9-40-40-40h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8c39.8 0 72 32.2 72 72v4.4L421.4 292c3-2.6 6.7-4 10.5-4h.2c2.2 0 4.4.5 6.4 1.4 5.7 2.6 9.4 8.3 9.4 14.6v160c0 8.8 7.2 16 16 16s16-7.2 16-16V279.8c11.4-4 22.1-9.4 32-16.1V464c0 26.5-21.5 48-48 48s-48-21.5-48-48V339.6l-86.1 76.5c30.3 2.3 54.1 27.6 54.1 58.5 0 20.6-16.7 37.3-37.3 37.3l-42.6.1H175.9c-44.1-.1-79.9-35.9-79.9-80V176.5c0-24.2-18-44.6-42-47.6l-7.9-1c-8.8-1.1-15-9.1-13.9-17.9s9.1-15 17.9-13.9l7.9 1c40 5 70.1 39 70.1 79.4v122.7zM384 128a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalCauldron = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCauldron",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm96 24a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM60.1 244.9C72 223 85.2 204.3 94.9 192h258.2c9.7 12.3 22.9 31 34.8 52.9 16.4 30.1 28.1 62.2 28.1 89.5 0 45.1-21.4 80.4-56.1 105.5C324.5 465.5 275.4 480 224 480s-100.5-14.5-135.9-40.1C53.4 414.8 32 379.5 32 334.4c0-27.3 11.7-59.4 28.1-89.5zM55.2 192C30.2 228.1 0 283.9 0 334.4c0 37.4 11.9 69.4 32 95.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-34.2c42.3 32.8 100.6 50.2 160 50.2s117.7-17.4 160-50.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-66.1c20.1-26.1 32-58.1 32-95.5 0-50.5-30.2-106.3-55.2-142.4H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h39.2z"
        }
    ]
};

const FalCediSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCediSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0c8.8 0 16 7.2 16 16v48h4c44 0 84.7 14.2 117.5 38.3 7.1 5.2 8.7 15.2 3.4 22.4s-15.2 8.7-22.4 3.4C299.1 108 265 96 228 96h-4v320h4c37 0 71.1-12 98.5-32.1 7.1-5.2 17.1-3.7 22.4 3.4s3.7 17.1-3.4 22.4C312.7 433.8 272 448 228 448h-4v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-51.2C101.2 428.2 32 350.3 32 256S101.2 83.8 192 67.2V16c0-8.8 7.2-16 16-16zM64 256c0 76 54.5 140.1 128 156.1V99.9C118.5 115.9 64 180 64 256z"
        }
    ]
};

const FalCentSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCentSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0c8.8 0 16 7.2 16 16v48h4c44 0 84.7 14.2 117.5 38.3 7.1 5.2 8.7 15.2 3.4 22.4s-15.2 8.7-22.4 3.4C299.1 108 265 96 228 96c-90.9 0-164 72-164 160s73.1 160 164 160c37 0 71.1-12 98.5-32.1 7.1-5.2 17.1-3.7 22.4 3.4s3.7 17.1-3.4 22.4C312.7 433.8 272 448 228 448h-4v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-51.2C101.2 428.2 32 350.3 32 256S101.2 83.8 192 67.2V16c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalCertificate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCertificate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M170.7 108.3c7.5-4.3 12.9-11.5 15-19.8L198 39.9l35 36c6 6.2 14.3 9.7 22.9 9.7s16.9-3.5 22.9-9.7l35-36 12.3 48.6c2.1 8.4 7.5 15.5 15 19.8s16.4 5.4 24.7 3.1l48.3-13.6-13.5 48.2c-2.3 8.3-1.2 17.2 3.1 24.7s11.5 12.9 19.8 15l48.6 12.3-36 35c-6.2 6-9.7 14.3-9.7 22.9s3.5 16.9 9.7 22.9l36 35-48.6 12.3c-8.4 2.1-15.5 7.5-19.8 15s-5.4 16.4-3.1 24.7l13.6 48.3-48.2-13.5c-8.3-2.3-17.2-1.2-24.7 3.1s-12.9 11.5-15 19.8L314 472.1l-35-36c-6-6.2-14.3-9.7-22.9-9.7s-16.9 3.5-22.9 9.7l-35 36-12.3-48.6c-2.1-8.4-7.5-15.5-15-19.8s-16.4-5.4-24.7-3.1l-48.4 13.6 13.6-48.2c2.3-8.3 1.2-17.2-3.1-24.7s-11.5-12.9-19.8-15l-48.7-12.4 36-35c6.2-6 9.7-14.3 9.7-22.9s-3.5-16.9-9.7-22.9l-36-35 48.6-12.3c8.4-2.1 15.5-7.5 19.8-15s5.4-16.4 3.1-24.7L97.8 97.8l48.2 13.6c8.3 2.3 17.2 1.2 24.7-3.1zM49.6 162.6l-31.5 8c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l23.3 22.6L53.5 256l-23 22.3L7.3 301c-6.3 6-8.7 15-6.5 23.4s8.9 14.9 17.3 17.1l31.5 8 31 7.9-8.7 30.8-8.8 31.2c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l31.2-8.8 30.8-8.7 7.9 31 8 31.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l22.6-23.3 22.3-23.1 22.3 22.9 22.7 23.3c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l8-31.5 7.9-31 30.8 8.7 31.2 8.8c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-8.8-31.2-8.7-30.8 31-7.9 31.5-8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-23.3-22.6-23.1-22.2 22.9-22.3 23.3-22.7c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-31.5-8-31-7.9 8.7-30.8 8.8-31.2c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1L388 71.8l-30.8 8.7-7.9-31-8-31.5c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3l-22.7 23.2-22.3 23-22.3-23L211 7.3C205 1 196-1.4 187.6.8s-14.9 8.9-17.1 17.3l-8 31.5-7.9 31-30.8-8.7-31.1-8.8c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l8.8 31.2 8.7 30.8-31 7.9z"
        }
    ]
};

const FalChairOffice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChairOffice",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c17.7 0 32 14.3 32 32v160h32V64c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64v160h32V64c0-17.7 14.3-32 32-32h128zM64 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80zm352 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80zm-64 144 32 64H64l32-64h256zm-112 96h144c11.1 0 21.4-5.7 27.2-15.2s6.4-21.2 1.4-31.1l-32-64c-5.4-10.9-16.5-17.7-28.6-17.7H96c-12.1 0-23.2 6.8-28.6 17.7l-32 64c-5 9.9-4.4 21.7 1.4 31.1S52.9 384 64 384h144v48h-16c-35.3 0-64 28.7-64 64 0 8.8 7.2 16 16 16s16-7.2 16-16c0-17.7 14.3-32 32-32h16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h16c17.7 0 32 14.3 32 32 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-28.7-64-64-64h-16v-48z"
        }
    ]
};

const FalChair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32v192h-32V37.5C122.7 50.6 96 86.2 96 128v96H64v-96C64 57.3 121.3 0 192 0h64c70.7 0 128 57.3 128 128v96h-32v-96c0-41.8-26.7-77.4-64-90.5V224h-32V32h-64zM64 288l-32 64h384l-32-64H64zm-28.6-14.3C40.8 262.8 51.9 256 64 256h320c12.1 0 23.2 6.8 28.6 17.7l32 64c5 9.9 4.4 21.7-1.4 31.1S427.1 384 416 384v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H64v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384c-11.1 0-21.4-5.7-27.2-15.2s-6.4-21.2-1.4-31.1l32-64z"
        }
    ]
};

const FalChalkboardUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChalkboardUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 32H224c-17.7 0-32 14.3-32 32v36c-10.2-2.6-21-4-32-4V64c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336.8c-5.3-11.4-11.8-22.2-19.5-32H384v-48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v48c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zm-32 352v-48c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v48h128zM224 224a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zM32.1 480h255.8c-2.8-53.5-47-96-101.2-96h-53.4c-54.2 0-98.4 42.5-101.2 96zM0 485.3C0 411.7 59.7 352 133.3 352h53.3c73.7 0 133.4 59.7 133.4 133.3 0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3z"
        }
    ]
};

const FalChalkboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChalkboard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 88c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24v328h32V88c0-30.9-25.1-56-56-56H88c-30.9 0-56 25.1-56 56v328h32V88zm160 312v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H416v-48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48zm48-16h96c8.8 0 16 7.2 16 16v40H256v-40c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalChampagneGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChampagneGlass",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M74.5 160h171l7.3 53.6c7.7 56.3-36 106.4-92.8 106.4S59.5 269.9 67.2 213.6l7.3-53.6zm4.4-32 13-96H228l13.1 96H78.8zM60.2 27.7 35.5 209.3C25.9 279.4 75.8 342.4 144 351v129H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64V351c68.2-8.6 118.1-71.6 108.5-141.7L259.8 27.7C257.6 11.8 244.1 0 228.1 0H91.9c-16 0-29.5 11.8-31.7 27.7z"
        }
    ]
};

const FalChampagneGlasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChampagneGlasses",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M98.1 186.2C73.2 233.5 95.7 292 146 310.3s105.1-12 116.5-64.3l10.9-50.1L122 140.8l-23.9 45.4zm182.1-21.9 19.2-88.6L179.3 32 137 112.2l143.2 52.1zm-210.4 7 81.1-154.2c7.5-14.2 24.2-20.6 39.3-15.2l120.2 43.8c3.6 1.3 6.8 3.2 9.6 5.6 2.8-2.4 6-4.3 9.6-5.6L449.8 1.9c15-5.5 31.8 1 39.3 15.2l81.2 154.2c31.4 59.7 7.4 132.3-50.6 162.6l42 115.4 56.9-20.7c8.3-3 17.5 1.3 20.5 9.6s-1.3 17.5-9.6 20.5l-71.9 26.2-72 26.1c-8.3 3-17.5-1.3-20.5-9.6s1.3-17.5 9.6-20.5l56.9-20.7-42-115.4c-63.9 14.1-129-26.1-143.3-92l-26.3-121-26.2 121c-14.3 65.9-79.4 106.2-143.3 92l-42 115.4 56.9 20.8c8.3 3 12.6 12.2 9.6 20.5s-12.2 12.6-20.5 9.6l-72-26.2-72-26.2c-8.3-3-12.6-12.2-9.6-20.5s12.2-12.6 20.5-9.6l56.9 20.7 42-115.4c-58-30.3-82-102.9-50.6-162.6zm472.1 14.9L518 140.8l-151.4 55.1 10.9 50.1c11.3 52.3 66.2 82.5 116.5 64.3s72.8-76.7 47.9-124.1zm-182.1-21.9L503 112.2 460.7 32 340.6 75.7l19.2 88.6z"
        }
    ]
};

const FalChargingStation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChargingStation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c17.7 0 32 14.3 32 32v416H64V64c0-17.7 14.3-32 32-32h160zM32 64v416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V288h16c26.5 0 48 21.5 48 48v48c0 35.3 28.7 64 64 64s64-28.7 64-64V270.4c36.5-7.4 64-39.7 64-78.4v-48c0-8.8-7.2-16-16-16h-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-16c-8.8 0-16 7.2-16 16v48c0 38.7 27.5 71 64 78.4V384c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-44.2-35.8-80-80-80h-16V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64zm432 96h80v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32h16zm-259.2-38.4c5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2l-72 96c-3.6 4.8-4.2 11.3-1.5 16.8S114 224 120 224h80l-52.8 70.4c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2l72-96c3.6-4.8 4.2-11.3 1.5-16.8S238 192 232 192h-80l52.8-70.4z"
        }
    ]
};

const FalChartArea = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartArea",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v352c0 44.2 35.8 80 80 80h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm265.4 166.6c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l39.6-39.6 62 72.3c2.5 2.9 3.9 6.6 3.9 10.4V352H128V243.9c0-4.2 1.7-8.3 4.7-11.3l91.3-91.3 73.4 73.4zm0-45.3-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-91.3 91.3c-9 9-14.1 21.2-14.1 33.9V352c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-94.2c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-16.9 16.9L320 192l-22.6-22.6z"
        }
    ]
};

const FalChartBar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartBar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32c8.8 0 16 7.2 16 16v352c0 26.5 21.5 48 48 48h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm112 112c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm16 80h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalChartBullet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartBullet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 32c8.8 0 16 7.2 16 16v16h176c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H288v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h208V48c0-8.8 7.2-16 16-16zM160 96v96h96V96h-96zm128 0v96h176c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H288zm-160 0H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h80V96zm240 160c8.8 0 16 7.2 16 16v16h80c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-80v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h304v-16c0-8.8 7.2-16 16-16zM224 416h128v-96H224v96zm160-96v96h80c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-80zm-192 0H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h144v-96z"
        }
    ]
};

const FalChartCandlestick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartCandlestick",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v352c0 44.2 35.8 80 80 80h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm288 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v48.8c-18.3 3.7-32 19.8-32 39.2v80c0 19.4 13.8 35.5 32 39.2V304c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.8c18.3-3.7 32-19.8 32-39.2v-80c0-19.4-13.8-35.5-32-39.2V48zM176 64c-8.8 0-16 7.2-16 16v48.8c-18.3 3.7-32 19.8-32 39.2v112c0 19.4 13.8 35.5 32 39.2V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.8c18.3-3.7 32-19.8 32-39.2V168c0-19.4-13.8-35.5-32-39.2V80c0-8.8-7.2-16-16-16zm144 72v80c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8zm104 88h16c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm-8-32v.8c-18.3 3.7-32 19.8-32 39.2v48c0 19.4 13.8 35.5 32 39.2V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.8c18.3-3.7 32-19.8 32-39.2v-48c0-19.4-13.8-35.5-32-39.2V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v48zm-232-32c4.4 0 8 3.6 8 8v112c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V168c0-4.4 3.6-8 8-8h16z"
        }
    ]
};

const FalChartColumn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartColumn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32c8.8 0 16 7.2 16 16v352c0 26.5 21.5 48 48 48h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm128 224c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm112-112v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 48c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm112-80v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalChartGantt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartGantt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32c8.8 0 16 7.2 16 16v352c0 26.5 21.5 48 48 48h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm112 112c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16zm80 80h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm160 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalChartLineDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartLineDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v352c0 44.2 35.8 80 80 80h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm288 288c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4L331.3 180.7c-6.2-6.2-16.4-6.2-22.6 0L224 265.4 123.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l84.7-84.7L425.4 320H336c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalChartLineUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartLineUpDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v352c0 44.2 35.8 80 80 80h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm336 48h57.4L288 233.4l-68.7-68.7c-3-3-7.1-4.7-11.3-4.7s-8.3 1.7-11.3 4.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l84.7-84.7 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0L448 118.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0 288h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.4l-68.7-68.7-22.6 22.6 68.7 68.7H368c-8.8 0-16 7.2-16 16s7.2 16 16 16z"
        }
    ]
};

const FalChartLineUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartLineUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v352c0 44.2 35.8 80 80 80h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm288 96c0 8.8 7.2 16 16 16h89.4L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0L448 182.6V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalChartLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartLine",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v352c0 44.2 35.8 80 80 80h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm443.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L320 265.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l84.7 84.7c6.2 6.2 16.4 6.2 22.6 0l144-144z"
        }
    ]
};

const FalChartMixedUpCircleCurrency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartMixedUpCircleCurrency",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h72.2l-153 139.1L201.8 67.4c-5.6-4.4-13.5-4.5-19.2-.3l-176 128c-7.1 5.2-8.7 15.2-3.5 22.4s15.2 8.7 22.4 3.5l166.2-121 134.5 104.6c6.1 4.8 14.8 4.4 20.6-.8L512 53.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H416zM208 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v160zm-16-208c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM80 432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48zm256 48a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-169.4 25.4a35.9 35.9 0 1 1 50.7-50.7 35.9 35.9 0 1 1-50.7 50.7zm-10 32.6c21.6 13.2 49.1 13.2 70.7 0l9.3 9.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-9.3-9.3c13.2-21.6 13.2-49.1 0-70.7l9.3-9.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-9.3 9.3c-21.6-13.2-49.1-13.2-70.7 0l-9.3-9.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l9.3 9.3c-13.2 21.6-13.2 49.1 0 70.7l-9.3 9.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l9.3-9.3z"
        }
    ]
};

const FalChartMixedUpCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartMixedUpCircleDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h72.2l-153 139.1L201.8 67.4c-5.6-4.4-13.5-4.5-19.2-.3l-176 128c-7.1 5.2-8.7 15.2-3.5 22.4s15.2 8.7 22.4 3.5l166.2-121 134.5 104.6c6.1 4.8 14.8 4.4 20.6-.8L512 53.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H416zM192 448c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16s16 7.2 16 16v160c0 8.8-7.2 16-16 16zm0-224c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V272c0-26.5-21.5-48-48-48zM80 432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64zM64 320c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-26.5-21.5-48-48-48zm256 48a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-167.9-29c-.1-1.9.3-2.9.8-3.6.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1 8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.6c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1z"
        }
    ]
};

const FalChartMixed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartMixed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.8 37.2c5.9 6.5 5.5 16.7-1.1 22.6l-176 160c-6.3 5.7-16 5.5-22.1-.5L190.4 101l-165 119.9c-7.1 5.2-17.2 3.6-22.4-3.5S-.6 200.2 6.5 195l176-128c6.4-4.6 15.2-3.9 20.7 1.6l117.3 117.3L485.2 36.2c6.5-5.9 16.7-5.5 22.6 1.1zM80 432v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16zM64 320c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48s-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zm144-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V272zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v160c0 26.5-21.5 48-48 48s-48-21.5-48-48V272zm192 160v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16zm-16-144c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48s-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zm144-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V272zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v160c0 26.5-21.5 48-48 48s-48-21.5-48-48V272z"
        }
    ]
};

const FalChartNetwork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartNetwork",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c4.5 0 8.9-.5 13.1-1.3l38.1 83.2c-26.6 17.2-45.4 45.4-50.1 78.1H126c-7.1-27.6-32.2-48-62-48-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h99.2c7.8 54.3 54.4 96 110.9 96 35 0 66.3-16.1 86.8-41.2l91.8 55.1c-1.7 5.8-2.6 11.9-2.6 18.2 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4l-91.8-55.1c5.6-13.3 8.7-28 8.7-43.3 0-18.7-4.6-36.3-12.7-51.8L537.2 179c10.8 8.2 24.2 13.1 38.8 13.1 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 9.1 1.9 17.8 5.4 25.7l-100.8 72.4c-20.4-21.1-49-34.2-80.6-34.2-11 0-21.6 1.6-31.7 4.5l-38.5-84.1c13.6-11.7 22.2-29 22.2-48.4 0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64zm352-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32 352a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM64 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm272-48a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FalChartPieSimpleCircleCurrency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartPieSimpleCircleCurrency",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 224h106.8c-12.9 9.1-24.5 19.9-34.6 32H272c-8.8 0-16-7.2-16-16V17.7C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4-3.8-.2-7.6-.4-11.5-.4-7.1 0-14.2.4-21.1 1.2-19.7-87.6-95-154.1-186.9-160.7V224zm-32 64h83.2c-5.2 10.1-9.4 20.8-12.6 32H224c-17.7 0-32-14.3-32-32V69.6C100.3 91.2 32 173.7 32 272c0 114.9 93.1 208 208 208 37.1 0 71.9-9.7 102-26.7 5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512 107.5 512 0 404.5 0 272 0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288h32zm240 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm25.4 169.4a35.9 35.9 0 1 0-50.7-50.7 35.9 35.9 0 1 0 50.7 50.7zm10 32.6c-21.6 13.2-49.1 13.2-70.7 0l-9.3 9.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l9.3-9.3c-13.2-21.6-13.2-49.1 0-70.7l-9.3-9.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l9.3 9.3c21.6-13.2 49.1-13.2 70.7 0l9.3-9.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-9.3 9.3c13.2 21.6 13.2 49.1 0 70.7l9.3 9.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-9.3-9.3z"
        }
    ]
};

const FalChartPieSimpleCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartPieSimpleCircleDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 224h106.8c-12.9 9.1-24.5 19.9-34.6 32H272c-8.8 0-16-7.2-16-16V17.7C256 8.1 263.4 0 273.1 0c116 0 212.7 82.7 234.4 192.4-3.8-.2-7.6-.4-11.5-.4-7.1 0-14.2.4-21.1 1.2-19.7-87.6-95-154.1-186.9-160.7V224zm-32 64h83.2c-5.2 10.1-9.4 20.8-12.6 32H224c-17.7 0-32-14.3-32-32V69.6C100.3 91.2 32 173.7 32 272c0 114.9 93.1 208 208 208 37.1 0 71.9-9.7 102-26.7 5.2 9.4 11.3 18.3 18.1 26.5C324.8 500.3 283.8 512 240 512 107.5 512 0 404.5 0 272 0 156.5 81.5 60.1 190.2 37.2c18.1-3.8 33.8 11 33.8 29.5V288h32zm240 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-23.2 111.4c-.4.7-.9 1.6-.8 3.6v.1c0 .4 0 1.9 4.8 4.5 5.6 3 13.5 5.2 23.9 8.2h.2c9.3 2.6 21.1 6 30.5 11.5 10.2 6 20 16.1 20.5 32.3.5 18.2-9.7 30.4-21.7 36.9-5.8 3.1-12.1 5.1-18.3 6.2v26.8H480v-27.4c-8.6-1.7-16.7-4.3-23.7-6.6-1.7-.6-3.4-1.1-5-1.6l-15.3-4.7 9.5-30.6 15.3 4.8c2 .6 3.9 1.2 5.8 1.8 11.4 3.6 20.4 6.5 29.9 6.8 6.7.2 13.8-1.1 18.5-3.6 2.2-1.2 3.4-2.4 4-3.3.5-.8 1.1-2.1 1-4.5 0-1.4-.2-3-4.7-5.6-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3-9.9-5.3-20.6-14.7-21.6-30.7-1.2-18.8 10-30.9 21.8-37.2 5.7-3.1 12-5.1 18-6.3V272h32v25.4c6.3.9 12.3 2.3 17.9 3.7l15.5 3.9-7.7 31.1-15.5-3.9c-9.3-2.3-18.2-4-26.4-4.1-6.2-.1-13.6 1.3-18.7 4-2.4 1.3-3.6 2.5-4.2 3.4z"
        }
    ]
};

const FalChartPieSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartPieSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 17.7V240c0 8.8 7.2 16 16 16h222.3c9.6 0 17.7-7.4 17.7-17.1C512 107 405 0 273.1 0 263.4 0 256 8.1 256 17.7zm32 14.8c102.4 7.3 184.2 89.1 191.5 191.5H288V32.5zM192 288c0 17.7 14.3 32 32 32h218.4C420.8 411.7 338.3 480 240 480c-114.9 0-208-93.1-208-208 0-98.3 68.3-180.8 160-202.4V288zm32-221.3c0-18.5-15.7-33.3-33.8-29.5C81.5 60.1 0 156.5 0 272c0 132.5 107.5 240 240 240 115.5 0 211.9-81.5 234.8-190.2 3.8-18.1-11-33.8-29.5-33.8H224V66.7z"
        }
    ]
};

const FalChartPie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartPie",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M511.3 208H336V32.7c93.3 7.7 167.6 82.1 175.3 175.3zM320 240h208.5c8.4 0 15.4-6.5 15.5-14.9V224C544 100.3 443.7 0 320 0h-1.1C310.5 0 304 7.1 304 15.5V224c0 8.8 7.2 16 16 16zm-86.6 70.6 141.9 142C344.9 470 309.6 480 272 480c-114.9 0-208-93.1-208-208 0-98.3 68.3-180.8 160-202.4V288c0 8.5 3.4 16.6 9.4 22.6zM239 34.3C122.1 50.3 32 150.7 32 272c0 132.5 107.5 240 240 240 51.8 0 99.8-16.4 139-44.3 7.7-5.5 8.2-16.5 1.5-23.1L256 288V49.6c0-9.2-7.8-16.6-17-15.4zm250.6 378L397.3 320h141.1c-8.3 35-25.4 66.6-48.9 92.3zM573.8 305c1.3-9.2-6.1-17-15.4-17H358.6c-14.3 0-21.4 17.2-11.3 27.3l131.4 131.4c5.8 5.8 15.2 6.3 21.2.7 39.3-36.7 66.2-86.5 73.9-142.3z"
        }
    ]
};

const FalChartPyramid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartPyramid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.8 87.7c-6.2-10.6-21.5-10.6-27.6 0L181.3 192h149.4L269.8 87.7zM106.7 320h298.6l-56-96H162.7l-56 96zM88 352l-42 71.9c-6.2 10.7 1.5 24.1 13.9 24.1h392.2c12.3 0 20-13.4 13.8-24.1L424 352H88zM214.5 71.6c18.5-31.8 64.4-31.8 82.9 0l196.2 336.2c18.7 32-4.4 72.2-41.5 72.2H59.9c-37 0-60.1-40.2-41.5-72.2L214.5 71.6z"
        }
    ]
};

const FalChartRadar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartRadar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 288a64.158 64.158 0 0 1 0-64l92.3-159.8c11.4-19.8 32.6-32 55.4-32h184.6c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64l-92.3 159.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16h184.6c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16H163.7c-11.4 0-22 6.1-27.7 16L43.7 240zM312 160c0 17.8-8.3 33.6-21.2 43.9l24.1 60.3c1.7-.2 3.4-.2 5.1-.2 30.9 0 56 25.1 56 56s-25.1 56-56 56c-29.2 0-53.2-22.3-55.8-50.8l-54.7-10.9c-9.4 17.7-28 29.8-49.5 29.8-30.9 0-56-25.1-56-56s25.1-56 56-56c6.8 0 13.4 1.2 19.4 3.5l31.6-42.3c-6.9-9.3-11-20.8-11-33.3 0-30.9 25.1-56 56-56s56 25.1 56 56zm-41.5 133.8c3.6-6.9 8.7-12.9 14.7-17.7l-24.1-60.3c-1.7.2-3.4.2-5.1.2-6.8 0-13.4-1.2-19.4-3.5L205 254.7c5.9 8 9.8 17.7 10.8 28.2l54.7 10.9zM256 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-184-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalChartScatter3d = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartScatter3d",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v232.6L37.7 451.8c-6.7 5.7-7.6 15.8-1.9 22.6s15.8 7.6 22.5 1.9L256 309l197.7 167.2c6.7 5.7 16.8 4.9 22.6-1.9s4.9-16.8-1.9-22.6L272 280.6V48zm112 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-328-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM32 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm200 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalChartScatterBubble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartScatterBubble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32c8.8 0 16 7.2 16 16v352c0 26.5 21.5 48 48 48h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm160 291.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm208 32a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-48-92.8a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zm0-67.2a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm176 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalChartScatter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartScatter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v352c0 44.2 35.8 80 80 80h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zm160 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56-216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM160 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalChartSimpleHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartSimpleHorizontal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 240c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16v-32zm32 32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v32zM224 400c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-32zm32 32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v32zm96-320V80c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16zm-16 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48z"
        }
    ]
};

const FalChartSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 64c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm-32-32c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-32zM80 256c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16h32zm-32-32c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm320-96h32c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-48 16v288c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalChartTreeMap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartTreeMap",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 64c8.8 0 16 7.2 16 16v112c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h128zM48 32C21.5 32 0 53.5 0 80v112c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm128 272c8.8 0 16 7.2 16 16v112c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V320c0-8.8 7.2-16 16-16h128zM48 272c-26.5 0-48 21.5-48 48v112c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H48zM304 64h160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm-48 16v32c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48zm208 144c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h160zm-160-32c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H304zm0 192h160c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm-48 16v32c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H304c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalChartUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 32H224c-17.7 0-32 14.3-32 32v36c-10.2-2.6-21-4-32-4V64c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H336.8c-5.3-11.4-11.8-22.2-19.5-32H576c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zm-176 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-57.4L395.3 267.3c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7 89.4-89.4H416c-8.8 0-16-7.2-16-16zM160 288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-26.7 256c-54.2 0-98.4 42.5-101.2 96h255.8c-2.8-53.5-47-96-101.2-96h-53.4zm0-32h53.3c73.7 0 133.4 59.7 133.4 133.3 0 14.7-11.9 26.7-26.7 26.7H26.7C11.9 512 0 500.1 0 485.3 0 411.7 59.7 352 133.3 352z"
        }
    ]
};

const FalChartWaterfall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChartWaterfall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32c8.8 0 16 7.2 16 16v352c0 26.5 21.5 48 48 48h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zm128 192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm112-80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-80c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm112 16v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalCheckDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCheckDouble",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M331.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 201.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l160-160zm112 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 425.4 27.3 292.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l144 144c6.2 6.2 16.4 6.2 22.6 0l272-272z"
        }
    ]
};

const FalCheckToSlot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCheckToSlot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64c-8.8 0-16 7.2-16 16v304h320V80c0-8.8-7.2-16-16-16H144zm336 16v304h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM48 320h16v32H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v-32h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zm331.3-146L272.6 280.6c-6.2 6.2-16.4 6.2-22.6 0l-53.3-53.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l42 42 95.4-95.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4l260.7-260.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalCheeseSwiss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCheeseSwiss",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 240.2V256h-66.7c-6.6-18.6-24.4-32-45.3-32s-38.7 13.4-45.3 32H32c0-9.3 4.6-18 12.4-23.1l148.7-99.2c-.7 3.3-1.1 6.7-1.1 10.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-23.6-17-43.2-39.4-47.2l44.1-29.4-17.8-26.7 17.8 26.6c3.3-2.2 7.2-3.4 11.1-3.4 97.3.1 176.2 79 176.2 176.3zM322.7 288c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32H480v128c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288h290.7zm-19-256c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256v160c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V240.2C512 125.2 418.8 32 303.8 32zM160 368a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm16-240a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 144a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalCheese = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCheese",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 240.2V256H32c0-9.3 4.6-18 12.4-23.1L292.6 67.4l-17.7-26.7 17.8 26.6c3.3-2.2 7.2-3.4 11.1-3.4 97.3.1 176.2 79 176.2 176.3zM32 288h448v128c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V288zM303.8 32c-10.3 0-20.3 3-28.9 8.7L26.6 206.2C10 217.3 0 236 0 256v160c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V240.2C512 125.2 418.8 32 303.8 32z"
        }
    ]
};

const FalCherries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCherries",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m288 16 8.2-13.7c-4.7-2.8-10.5-3-15.4-.6s-8.2 7.3-8.7 12.7v.4L272 16c-.1 1.1-.3 2.8-.6 5-.6 4.4-1.5 10.8-2.8 18.7-2.7 16-7.1 38.2-13.9 63-13.8 50.2-37 109.3-74.4 150.5-.2.2-.3.3-.4.5C163.8 241.9 133.5 224 96 224c0 0-96 0-96 112 0 144 144 176 192 176s192-32 192-176c0-112-96-112-96-112-21.3 0-40.2 5.8-55.6 12.9 25.7-40.5 42.3-86.8 53-125.7 7.2-26.1 11.8-49.4 14.6-66.2l.2-1.2c1 .7 2 1.5 3.1 2.3 14.5 11 33.7 27.1 53 47.8 36.2 39 71 92.5 75.3 156.9-13.2-9.1-33.5-20.4-58.3-24.9 12.6 11.5 23.6 26.5 31.3 45.5 4.6 2.7 8.7 5.5 12.1 8 18.4 13.7 44.3 13.7 62.7 0 13.5-10 37-23.4 64.4-23.5h.1c.3 0 .8 0 1.6.1 1.6.1 4.2.4 7.4 1.1 6.5 1.3 14.9 3.8 23 8.5C590 273.9 608 291.3 608 336c0 68-29.4 101.7-61.9 120.2-35 20-76.5 23.8-98.1 23.8-14.6 0-42.6-4-71.1-15.9-7 9.2-14.8 17.4-23 24.8 36.5 17.4 73.8 23.1 94.1 23.1 48 0 192-16 192-176 0-112-96-112-96-112-35 0-63.7 15.6-80.3 27.3-4.1-75.9-44.8-137.1-83.9-179.2-20.8-22.3-41.5-39.7-57-51.5-7.8-5.9-14.3-10.4-18.9-13.5-2.3-1.5-4.1-2.7-5.4-3.5-.6-.4-1.1-.7-1.5-.9l-.4-.3-.1-.1-8.2 13.7zm-.3 243.2c.2 0 .7 0 1.5.1 1.5.1 4 .4 7.1 1 6.3 1.2 14.3 3.6 22 8.1 13.1 7.6 30.5 24 30.5 67.6 0 57.7-27.7 91.3-61.3 112.1-35.5 22-76.8 28.7-95.5 28.7s-60-6.8-95.5-28.7C62.9 427.3 35.2 393.7 35.2 336c0-43.6 17.5-60 30.5-67.6 7.7-4.5 15.7-6.9 22-8.1 3.1-.6 5.5-.9 7.1-1 .8-.1 1.3-.1 1.5-.1 19.6.1 37.2 7.1 50.9 15.1 6.7 3.9 12 7.9 15.6 10.8 1.8 1.4 3 2.5 3.8 3.2.4.3.6.6.7.7 13.7 13.5 35.8 13.5 49.5 0l.7-.7c.8-.7 2-1.8 3.8-3.2 3.5-2.9 8.8-6.8 15.6-10.8 13.6-8 31.3-15.1 50.9-15.1z"
        }
    ]
};

const FalChessBishopPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessBishopPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32h64c8.8 0 16 7.2 16 16 0 6-3.3 11.2-8.1 13.9 4 4.2 8.2 8.8 12.4 13.8 21.1 25.4 43.7 63 43.7 108.3 0 16.6-4.4 30.1-10.8 40.9C219.5 227 224 233 224 240c0 8.8-7.2 16-16 16h-11.9l9.6 96h-32.2l-9.6-96H92.1l-9.6 96H50.3l9.6-96H48c-8.8 0-16-7.2-16-16 0-7 4.5-13 10.8-15.1C36.4 214.1 32 200.6 32 184c0-45.3 22.6-82.9 43.7-108.2 4.2-5 8.4-9.7 12.4-13.8-4.8-2.8-8.1-8-8.1-14 0-8.8 7.2-16 16-16zm75.5 192c10.2-7.5 20.5-19.8 20.5-40 0-18.9-5.2-36.6-13-52.4l-31.7 31.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l37-37c-2-2.6-3.9-5.1-5.9-7.5-9.4-11.1-18.8-20-25.8-26.1-.7-.6-1.4-1.2-2-1.7-.6.5-1.3 1.1-2 1.7-7 6.1-16.4 15-25.7 26.2C81.4 118.9 64 149.3 64 184c0 20.2 10.3 32.5 20.5 40h87.1zm45.9 175.1 32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8 0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1h124.4c11.1 0 21.4 5.7 27.2 15.1zM65.8 416l-32.7 52.7c-.7 1.2-1.1 2.5-1.1 3.9 0 4.1 3.3 7.4 7.4 7.4h177.2c4.1 0 7.4-3.3 7.4-7.4 0-1.4-.4-2.7-1.1-3.9L190.2 416H65.8z"
        }
    ]
};

const FalChessBishop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessBishop",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h11.6c-12 10.9-25.8 24.7-39.7 40.8C39 115.7 0 177.6 0 248.7c0 53.2 37.2 80 64 92.3v11h32v-21.6c0-6.7-4.1-12.7-10.4-15-23.1-8.6-53.6-27.3-53.6-66.7 0-59.7 33-114.3 68.1-155 17.4-20.2 34.7-36.4 47.8-47.6 4.7-4 8.8-7.3 12.1-10 3.3 2.6 7.4 6 12.1 10 13.1 11.2 30.4 27.5 47.8 47.6 7.2 8.4 14.3 17.3 21.1 26.7l-76.2 76.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l71.2-71.2c17.3 30.4 29.4 64.6 29.4 100.7 0 39.4-30.5 58-53.6 66.7-6.3 2.3-10.4 8.3-10.4 15V352h32v-10.9c26.8-12.3 64-39.1 64-92.3 0-71.2-39-133-75.9-175.9-13.9-16.2-27.7-30-39.7-40.9H216c8.8 0 16-7.2 16-16s-7.2-16-16-16H104zm150.2 416 32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9 0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4 0-1.4.4-2.7 1.1-3.9L65.8 416h188.4zm0-32H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6 0 494.3 17.7 512 39.4 512h241.2c21.8 0 39.4-17.7 39.4-39.4 0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"
        }
    ]
};

const FalChessBoard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessBoard",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm88 0h272c13.3 0 24 10.7 24 24v272c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24zm8 72h40v-40H96v40zm72 0h40v-40h-40v40zm72 0h40v-40h-40v40zm72 0h40v-40h-40v40zm0 32v40h40v-40h-40zm0 72v40h40v-40h-40zm0 72v40h40v-40h-40zm-32 0h-40v40h40v-40zm-72 0h-40v40h40v-40zm-72 0H96v40h40v-40zm0-32v-40H96v40h40zm0-72v-40H96v40h40zm32 0h40v-40h-40v40zm72 0h40v-40h-40v40zm0 32v40h40v-40h-40zm-32 0h-40v40h40v-40z"
        }
    ]
};

const FalChessClockFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessClockFlip",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H64c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64h-96V64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H400zM96 80c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm480 80c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h512zm-112 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 192a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM119.4 247.4a80 80 0 1 1 113.2 113.2 80 80 0 1 1-113.2-113.2zm135.8 135.8A112 112 0 1 0 96.8 224.8a112 112 0 1 0 158.4 158.4zM464 240c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-8.8-7.2-16-16-16zm-242.7 41.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-33.9 33.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l33.9-33.9z"
        }
    ]
};

const FalChessClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v64h384c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h96V64h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h128zm304 48c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16zM64 160c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64zm112 224a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm344.6 168.6a80 80 0 1 0-113.2-113.2 80 80 0 1 0 113.2 113.2zM384.8 224.8a112 112 0 1 1 158.4 158.4 112 112 0 1 1-158.4-158.4zM176 240c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zm333.3 41.4-33.9 33.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalChessKingPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessKingPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H52.6C41.2 96 32 105.2 32 116.6c0 2.2.4 4.4 1.1 6.5L66.7 224H56c-8.8 0-16 7.2-16 16s7.2 16 16 16h13.8l-13.1 96H89l13.1-96h51.8l13.1 96h32.3l-13.1-96H200c8.8 0 16-7.2 16-16s-7.2-16-16-16h-10.7l33.6-100.8c.7-2.1 1.1-4.3 1.1-6.5 0-11.4-9.2-20.6-20.6-20.6H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V16zm11.6 208h-55.2l-32-96h119.2l-32 96zm34.6 160H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6 0 494.3 17.7 512 39.4 512h177.2c21.8 0 39.4-17.7 39.4-39.4 0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1zM33.1 468.7 65.8 416h124.4l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9 0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4 0-1.4.4-2.7 1.1-3.9z"
        }
    ]
};

const FalChessKing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessKing",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-40c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v48H59.6C26.7 128 0 154.7 0 187.6c0 8.2 1.7 16.3 4.9 23.8L66.1 352H101L34.3 198.6c-1.5-3.5-2.3-7.2-2.3-11 0-15.2 12.4-27.6 27.6-27.6h328.8c15.2 0 27.6 12.4 27.6 27.6 0 3.8-.8 7.5-2.3 11L347 352h34.9L443 211.4c3.3-7.5 4.9-15.6 4.9-23.8 0-32.9-26.7-59.6-59.6-59.6H240V80h40c8.8 0 16-7.2 16-16s-7.2-16-16-16h-40V16zm142.9 452.7c.7 1.2 1.1 2.5 1.1 3.9 0 4.1-3.3 7.4-7.4 7.4H71.4c-4.1 0-7.4-3.3-7.4-7.4 0-1.4.4-2.7 1.1-3.9L97.8 416h252.4l32.7 52.7zM97.8 384c-11.1 0-21.4 5.7-27.2 15.1l-32.7 52.7c-3.8 6.2-5.9 13.4-5.9 20.8 0 21.7 17.7 39.4 39.4 39.4h305.2c21.8 0 39.4-17.7 39.4-39.4 0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1H97.8z"
        }
    ]
};

const FalChessKnightPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessKnightPiece",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M53.3 96h80.4C210.1 96 272 157.9 272 234.3c0 12.7-1.7 25.3-5.2 37.5L244.3 352h33.2l20.1-71.5c4.2-15 6.4-30.6 6.4-46.2 0-94-76.3-170.3-170.3-170.3H45.3c-16 0-28.9 12.9-28.9 28.9 0 8.2 3.5 16 9.6 21.5l7.7 6.9c-11.1 14-17.3 31.5-17.3 49.5l-.2 65.1c-.1 26.9 17.6 49.7 42.1 57.3-6.3 11.7-9.8 25-9.8 38.7l-.3 20.1h32l.2-19.8v-.2c0-15.6 7.4-30.3 19.9-39.7l76.1-46.7c7.5-4.6 9.9-14.5 5.3-22s-14.5-9.9-22-5.3l-36.5 22.4c-1.2.4-2.3.9-3.4 1.5L90.3 260c-4.4 2.6-9.4 4-14.5 4-15.3-.1-27.7-12.6-27.7-27.9l.2-65.1c0-11.7 4.3-23 12.1-31.7l7.6-8.6c5.8-6.6 5.3-16.6-1.3-22.5L53.3 96zM96 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM65.8 416h188.4l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9 0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4 0-1.4.4-2.7 1.1-3.9L65.8 416zm188.4-32H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6 0 494.3 17.7 512 39.4 512h241.2c21.8 0 39.4-17.7 39.4-39.4 0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"
        }
    ]
};

const FalChessKnight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessKnight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 35.8c0-2.1 1.7-3.8 3.8-3.8h130.8C315.3 32 384 100.7 384 185.4c0 8.8-.8 17.6-2.3 26.3L357.3 352h32.5l23.5-134.9c1.8-10.5 2.7-21.1 2.7-31.8C416 83 333 0 230.6 0H99.8C80 0 64 16 64 35.8c0 13.6 7.7 25.9 19.8 32l1.3.6C71.6 83.1 64 102.3 64 122.4l-.3 104.4c-.1 23.2 11.1 45 30 58.5l1.9 1.4c4.5 3.2 9.3 5.8 14.3 7.8l-6.9 5c-17.8 13-30.4 31.6-35.8 52.5h33.7c4.4-10.5 11.5-19.7 21-26.6l53.8-39.1 89.9-65.4c7.1-5.2 8.7-15.2 3.5-22.4s-15.2-8.7-22.4-3.5l-89.9 65.4c-12.7 9.2-29.8 9.3-42.6.2l-1.9-1.4c-10.4-7.5-16.6-19.5-16.6-32.4l.3-104.4c0-12.7 5.1-24.8 14.1-33.8l13.3-13.3c3.6-3.6 5.3-8.8 4.5-13.9s-4-9.4-8.6-11.7L98.1 39.2c-1.3-.6-2.1-1.9-2.1-3.4zM366.2 416l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9 0 4.1-3.3 7.4-7.4 7.4H55.4c-4.1 0-7.4-3.3-7.4-7.4 0-1.4.4-2.7 1.1-3.9L81.8 416h284.4zM81.8 384c-11.1 0-21.4 5.7-27.2 15.1l-32.7 52.7c-3.8 6.2-5.9 13.4-5.9 20.8 0 21.7 17.7 39.4 39.4 39.4h337.2c21.8 0 39.4-17.7 39.4-39.4 0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1H81.8zM148 168a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"
        }
    ]
};

const FalChessPawnPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessPawnPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 176a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm16 80h-6.1l10.7 96h-32.3l-10.7-96h-51.3l-10.7 96H59.5l10.7-96H64c-8.8 0-16-7.2-16-16s7.2-16 16-16c-10-13.4-16-30-16-48 0-44.2 35.8-80 80-80s80 35.8 80 80c0 18-6 34.6-16 48 8.8 0 16 7.2 16 16s-7.2 16-16 16zm-1.8 128c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8 0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1h124.4zM33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9 0 4.1 3.3 7.4 7.4 7.4h177.2c4.1 0 7.4-3.3 7.4-7.4 0-1.4-.4-2.7-1.1-3.9L190.2 416H65.8l-32.7 52.7z"
        }
    ]
};

const FalChessPawn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessPawn",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 144a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm16 112h-20.6l18.6 96h-32.6l-18.6-96h-85.6l-18.6 96H66l18.6-96H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h17.6C60.9 203.7 48 175.3 48 144 48 82.1 98.1 32 160 32s112 50.1 112 112c0 31.3-12.9 59.7-33.6 80H256c8.8 0 16 7.2 16 16s-7.2 16-16 16zM65.8 416l-32.7 52.7c-.7 1.2-1.1 2.5-1.1 3.9 0 4.1 3.3 7.4 7.4 7.4h241.2c4.1 0 7.4-3.3 7.4-7.4 0-1.4-.4-2.7-1.1-3.9L254.2 416H65.8zm188.4-32c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8 0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1h188.4z"
        }
    ]
};

const FalChessQueenPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessQueenPiece",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm67.8 41.4c6.5 1.2 11.6 6.2 12.8 12.7 2.8 14.8 15.8 25.9 31.4 25.9 5.6 0 10.7-1.4 15.3-3.9 6.1-3.3 13.7-2.3 18.8 2.5s6.3 12.4 3.2 18.7L201.9 224h6.1c8.8 0 16 7.2 16 16s-7.2 16-16 16h-15.3l4.4 96h-32l-4.4-96H95.3l-4.4 96h-32l4.4-96H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h6.1L2.8 121.3C-.3 115.1 1 107.5 6 102.7s12.6-5.9 18.8-2.5c4.5 2.5 9.7 3.9 15.3 3.9 15.6 0 28.6-11.1 31.4-25.9 1.3-6.5 6.3-11.5 12.8-12.7s13 1.7 16.5 7.3C106.4 81.9 116.5 88 128 88s21.6-6.1 27.3-15.2c3.5-5.6 10-8.5 16.5-7.3zM89.9 224h76.2l44.1-88.3c-19.2-1.7-35.9-11.9-46.4-26.7-10.2 6.9-22.5 11-35.8 11s-25.6-4-35.8-11c-10.6 14.8-27.3 25-46.4 26.7L89.9 224zm100.3 160c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8 0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1h124.4zM65.8 416l-32.7 52.7c-.7 1.2-1.1 2.5-1.1 3.9 0 4.1 3.3 7.4 7.4 7.4h177.2c4.1 0 7.4-3.3 7.4-7.4 0-1.4-.4-2.7-1.1-3.9L190.2 416H65.8z"
        }
    ]
};

const FalChessQueen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessQueen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-95.2 0c-14 0-24.5 10-28 21.3-9 29.4-36.5 50.8-68.8 50.8-12.1 0-23.4-3-33.4-8.2-5.6-3-12.6-3.1-18.6 0-10.1 5.4-13.5 18.2-7.5 28L97.1 352h37.7L49.3 215.1c4.8.7 9.7 1 14.7 1 44.8 0 82.9-28.3 97.5-67.9 19.9 31.1 54.8 51.8 94.5 51.8s74.6-20.7 94.5-51.8c14.7 39.6 52.8 67.9 97.5 67.9 5 0 9.9-.4 14.7-1L377.1 352h37.7l92.6-148.2c5.9-9.5 2.8-22.1-7-27.6-6.1-3.5-13.3-3.4-19.1-.3-10 5.3-21.4 8.2-33.5 8.2-32.4 0-59.8-21.4-68.8-50.8-3.5-11.3-13.9-21.3-28-21.3-11.3 0-20.6 6.6-25.4 15.2C312 151.6 285.9 168 256 168s-56-16.4-69.8-40.8c-4.8-8.6-14.1-15.2-25.4-15.2zm-31 304h252.4l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9 0 4.1-3.3 7.4-7.4 7.4H103.4c-4.1 0-7.4-3.3-7.4-7.4 0-1.4.4-2.7 1.1-3.9l32.7-52.7zm252.4-32H129.8c-11.1 0-21.4 5.7-27.2 15.1l-32.7 52.7c-3.8 6.2-5.9 13.4-5.9 20.8 0 21.8 17.7 39.4 39.4 39.4h305.2c21.8 0 39.4-17.7 39.4-39.4 0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"
        }
    ]
};

const FalChessRookPiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessRookPiece",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 112c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v112c0 3.7-1.3 7.4-3.7 10.2l-35.9 43.1 4.4 74.6h-32.1l-4.7-79c-.2-4.1 1.1-8.1 3.7-11.2l36.3-43.5V128h-48v24c0 8.8-7.2 16-16 16s-16-7.2-16-16v-24h-64v24c0 8.8-7.2 16-16 16s-16-7.2-16-16v-24H48v90.2l36.3 43.6c2.6 3.1 3.9 7.1 3.7 11.2l-4.7 79h-32l4.4-74.6-36-43.2c-2.4-2.9-3.7-6.5-3.7-10.2V112zm144 96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM33.1 468.7c-.7 1.2-1.1 2.5-1.1 3.9 0 4.1 3.3 7.4 7.4 7.4h241.2c4.1 0 7.4-3.3 7.4-7.4 0-1.4-.4-2.7-1.1-3.9L254.2 416H65.8l-32.7 52.7zM254.2 384c11.1 0 21.4 5.7 27.2 15.1l32.7 52.7c3.9 6.2 5.9 13.4 5.9 20.8 0 21.8-17.7 39.4-39.4 39.4H39.4C17.7 512 0 494.3 0 472.6c0-7.3 2.1-14.5 5.9-20.8l32.7-52.7c5.8-9.4 16.1-15.1 27.2-15.1h188.4z"
        }
    ]
};

const FalChessRook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChessRook",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v121.3c0 14 6.1 27.3 16.8 36.4L87.6 255l-5.1 97h32l5.5-103.2c.3-5-1.8-9.8-5.6-13l-44.8-38.4c-3.5-3-5.6-7.5-5.6-12.1V64h80v40c0 8.8 7.2 16 16 16s16-7.2 16-16V64h96v40c0 8.8 7.2 16 16 16s16-7.2 16-16V64h80v121.3c0 4.7-2 9.1-5.6 12.1l-44.8 38.4c-3.8 3.2-5.8 8-5.6 13l5.5 103.2h32l-5.1-97 38.8-33.3c10.6-9.1 16.8-22.4 16.8-36.4V64c0-17.7-14.3-32-32-32H64zm160 128c-26.5 0-48 21.5-48 48v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h-32v-48zM97.8 416h252.4l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9 0 4.1-3.3 7.4-7.4 7.4H71.4c-4.1 0-7.4-3.3-7.4-7.4 0-1.4.4-2.7 1.1-3.9L97.8 416zm252.4-32H97.8c-11.1 0-21.4 5.7-27.2 15.1l-32.7 52.7c-3.8 6.2-5.9 13.4-5.9 20.8 0 21.7 17.7 39.4 39.4 39.4h305.2c21.8 0 39.4-17.7 39.4-39.4 0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1z"
        }
    ]
};

const FalChess = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChess",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32H52.6C41.2 96 32 105.2 32 116.6c0 2.2.4 4.4 1.1 6.5L66.7 224H56c-8.8 0-16 7.2-16 16s7.2 16 16 16h13.8l-13.1 96H89l13.1-96h51.8l13.1 96h32.3l-13.1-96H200c8.8 0 16-7.2 16-16s-7.2-16-16-16h-10.7l33.6-100.8c.7-2.1 1.1-4.3 1.1-6.5 0-11.4-9.2-20.6-20.6-20.6H144V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V16zm11.6 208h-55.2l-32-96h119.2l-32 96zm34.6 160H65.8c-11.1 0-21.4 5.7-27.2 15.1L5.9 451.8C2.1 458 0 465.2 0 472.6 0 494.3 17.7 512 39.4 512h177.2c21.8 0 39.4-17.7 39.4-39.4 0-7.3-2.1-14.5-5.9-20.8l-32.7-52.7c-5.8-9.4-16.1-15.1-27.2-15.1zM33.1 468.7 65.8 416h124.4l32.7 52.7c.7 1.2 1.1 2.5 1.1 3.9 0 4.1-3.3 7.4-7.4 7.4H39.4c-4.1 0-7.4-3.3-7.4-7.4 0-1.4.4-2.7 1.1-3.9zM452.5 416l26.5 51.2c.6 1.2 1 2.6 1 4 0 4.8-3.9 8.8-8.8 8.8H328.8c-4.8 0-8.8-3.9-8.8-8.8 0-1.4.3-2.8 1-4l26.5-51.2h105zm-105-32c-12 0-22.9 6.7-28.4 17.3l-26.5 51.2c-3 5.8-4.6 12.2-4.6 18.7 0 22.5 18.2 40.8 40.8 40.8h142.4c22.5 0 40.8-18.2 40.8-40.8 0-6.5-1.6-12.9-4.6-18.7l-26.5-51.2c-5.5-10.6-16.5-17.3-28.4-17.3h-105zM304 160c-8.8 0-16 7.2-16 16v80c0 3.7 1.3 7.4 3.7 10.2l36.3 43.6V352h32v-48c0-3.7-1.3-7.4-3.7-10.2L320 250.2V192h32v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h32v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h32v58.2l-36.3 43.5c-2.4 2.9-3.7 6.5-3.7 10.2v48h32v-42.1l36.3-43.5c2.4-2.9 3.7-6.5 3.7-10.2V176c0-8.8-7.2-16-16-16H304z"
        }
    ]
};

const FalChestnut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChestnut",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328.7 163.3c-14.2-14.2-29.7-27.3-46.4-41-2.8-2.3-5.6-4.5-8.4-6.9-13.9-11.4-28.5-23.3-42.5-36-2.5-2.3-5-4.6-7.4-7-2.4 2.3-4.8 4.7-7.4 7-14 12.7-28.6 24.6-42.5 36l-8.4 6.9c-16.6 13.7-32.2 26.8-46.4 41C72.8 209.8 32 270 32 352h384c0-82-40.8-142.2-87.3-188.7zM37.5 384c13.2 37.3 48.7 64 90.5 64h192c41.8 0 77.4-26.7 90.5-64h-373zm313.8-243.3C400.8 190.2 448 258 448 352c0 70.7-57.3 128-128 128H128C57.3 480 0 422.7 0 352c0-94 47.2-161.8 96.7-211.3 18.1-18.1 37.7-34.1 57.3-50.2 13.9-11.4 27.8-22.7 41.1-34.8 7.6-6.9 12.7-12.3 15.5-16.6 3-4.5 8-7.1 13.3-7.1s10.3 2.7 13.3 7.1c2.9 4.3 7.9 9.7 15.5 16.6 13.3 12.1 27.2 23.4 41.1 34.8 19.6 16.1 39.3 32.1 57.3 50.2z"
        }
    ]
};

const FalChevronDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChevronDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4l180.7-180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"
        }
    ]
};

const FalChevronLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChevronLeft",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256l180.7 180.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z"
        }
    ]
};

const FalChevronRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChevronRight",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"
        }
    ]
};

const FalChevronUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChevronUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"
        }
    ]
};

const FalChevronsDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChevronsDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m52.7 75.3 192 192c6.2 6.2 16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4 75.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zm0 192 192 192c6.2 6.2 16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 425.4 75.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"
        }
    ]
};

const FalChevronsLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChevronsLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256 267.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-192 192zm384-192-192 192c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256 459.3 75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FalChevronsRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChevronsRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m75.3 459.3 192-192c6.2-6.2 6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L233.4 256 52.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm192 0 192-192c6.2-6.2 6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L425.4 256 244.7 436.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"
        }
    ]
};

const FalChevronsUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChevronsUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M267.3 52.7c-6.2-6.2-16.4-6.2-22.6 0l-192 192c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 86.6l180.7 180.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-192-192zm192 384-192-192c-6.2-6.2-16.4-6.2-22.6 0l-192 192c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l180.7 180.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"
        }
    ]
};

const FalChfSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChfSign",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 112c0-44.2 35.8-80 80-80h4.2c28 0 53.6 15.8 66.1 40.8 4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2C114.6 73 100.1 64 84.2 64H80c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h4.2c15.9 0 30.4-9 37.5-23.2 4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5c-12.5 25-38.1 40.8-66.1 40.8H80c-44.2 0-80-35.8-80-80V112zm208-80c8.8 0 16 7.2 16 16v176h160V48c0-8.8 7.2-16 16-16s16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H224v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm240 16c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v160h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H480v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V48z"
        }
    ]
};

const FalChildCombatant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChildCombatant",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm240 272v-10.7l52.2-17.4.9-.3c6.5-2.2 10.9-8.3 10.9-15.2V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v72l-32 8V160c0-17.7-14.3-32-32-32V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16v96c-17.7 0-32 14.3-32 32v34.7c-18.6 6.6-32 24.4-32 45.3v112c0 19.9 12.1 36.9 29.3 44.2.9.4 1.8.7 2.7 1V496c0 8.8 7.2 16 16 16h96c4.9 0 9.4-2.2 12.5-6s4.2-8.7 3.1-13.5l-4.3-19.5-9.1-41-7.1-32H528c8.8 0 16-7.2 16-16s-7.2-16-16-16h-44l-4-17.8V336zm-27.3 38.9 5.6 25.1 1.5 6.9 9.1 41.1 7.1 32h-60v-96c0-4.2-1.6-8-4.3-10.9-2.9-3.2-7.1-5.1-11.7-5.1-6.4 0-12-3.8-14.5-9.3-.7-1.6-1.2-3.3-1.4-5.1-.1-.5-.1-1-.1-1.6V240c0-2.4.5-4.7 1.5-6.7 2.5-5.5 8.1-9.3 14.5-9.3 4.6 0 8.8-2 11.7-5.1 2.6-2.9 4.3-6.7 4.3-10.9v-48h32v192c0 1.2.1 2.3.4 3.5l.4 1.7 2.4 10.8 1.5 6.9zM144 199.9c7.7-5.1 16.8-7.9 26.3-7.9h11.3c9.5 0 18.6 2.8 26.3 7.9V352H144V199.9zm0 184.1h64v112c0 8.8 7.2 16 16 16s16-7.2 16-16V243.3l42.4 69.1c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-59.8-97.5c-14.5-23.7-40.4-38.2-68.2-38.2h-11.4c-27.8 0-53.7 14.5-68.2 38.2l-59.7 97.4c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3l42.3-69V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384z"
        }
    ]
};

const FalChildDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChildDress",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM96 400H72c-5 0-9.7-2.3-12.7-6.3s-4-9.1-2.8-13.9l41.5-154-69.4 88.1c-5.5 6.9-15.5 8.1-22.5 2.7S-2 301 3.4 294.1l74.3-94.2c18.8-23.9 47.1-38.3 77.3-39.8 1.2-.1 2.5-.1 3.7-.1h2.6c1.2 0 2.5 0 3.7.1 30.2 1.5 58.4 15.9 77.3 39.8l74.3 94.2c5.5 6.9 4.3 17-2.7 22.5s-17 4.3-22.5-2.7L222 225.8l41.5 154c1.3 4.8.3 9.9-2.8 13.9S253 400 248 400h-24v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96h-64v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96zm60.8-207.9c-10.1.8-18.7 7.8-21.4 17.7L92.9 368h134.2l-42.6-158.2c-2.7-9.9-11.3-16.9-21.4-17.7-1.1 0-2.1-.1-3.2-.1s-2.1 0-3.2.1z"
        }
    ]
};

const FalChildReaching = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChildReaching",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-16 124c-27.8-14.9-51.4-37.4-67.5-65.8l-10.4-18.3c-4.4-7.7-1.7-17.5 6-21.8s17.5-1.7 21.8 6l10.4 18.3c24.4 43 70.1 69.6 119.5 69.6 48.9 0 94.1-26 118.7-68.2l11.6-19.9c4.5-7.6 14.2-10.2 21.9-5.8s10.2 14.2 5.8 21.9l-11.6 19.9c-16 27.5-39.1 49.4-66.2 63.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h-96v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V188zm32 13.1V352h96V201c-15.4 4.6-31.6 7-48.1 7-16.4 0-32.5-2.4-47.9-6.9z"
        }
    ]
};

const FalChild = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChild",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM73.9 240.2c1.9-3.1 3.9-6 6.1-8.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V384h96v112c0 8.8 7.2 16 16 16s16-7.2 16-16V231.3c2.2 2.8 4.2 5.8 6.1 8.9l44.3 72.2c4.6 7.5 14.5 9.9 22 5.3s9.9-14.5 5.3-22l-44.3-72.2C249.2 184 206.3 160 160 160s-89.2 24-113.4 63.5L2.4 295.6c-4.6 7.5-2.3 17.4 5.3 22s17.4 2.3 22-5.3L74 240.1zM208 352h-96V204.1c14.5-7.8 31-12.1 48-12.1s33.5 4.3 48 12.1V352z"
        }
    ]
};

const FalChildren = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChildren",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm416 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm64 128c-11.6 0-22.6 3.4-32 9.6V352h64V201.6c-9.4-6.2-20.4-9.6-32-9.6zm-32 304c0 8.8-7.2 16-16 16s-16-7.2-16-16V243.3l-42.4 69.1c-4.6 7.5-14.5 9.9-22 5.3s-9.9-14.5-5.3-22l56.9-92.7c16.4-26.7 45.5-43 76.8-43s60.4 16.3 76.8 43l56.8 92.6c4.6 7.5 2.3 17.4-5.3 22s-17.4 2.3-22-5.3l-42.3-69V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h-64v112zM96 400H72c-5 0-9.7-2.3-12.7-6.3s-4-9.1-2.8-13.9l38-141.2-49.2 74.2c-4.9 7.4-14.8 9.4-22.2 4.5s-9.4-14.8-4.5-22.2L79.8 203a96.3 96.3 0 0 1 74.5-42.9c1.4-.1 2.9-.2 4.4-.2h2.6c1.5 0 2.9.1 4.4.2a96.3 96.3 0 0 1 74.5 42.9l61.1 92.1c4.9 7.4 2.9 17.3-4.5 22.2s-17.3 2.9-22.2-4.5l-49.2-74.2 38 141.2c1.3 4.8.3 9.9-2.8 13.9s-7.7 6.3-12.7 6.3H224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96h-64v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96zm60.5-207.9c-10 .9-18.4 7.9-21.1 17.7L92.9 368h134.2l-42.6-158.2c-2.6-9.8-11.1-16.8-21.1-17.7-1.2-.1-2.3-.1-3.5-.1s-2.3 0-3.5.1z"
        }
    ]
};

const FalChimney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChimney",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64h384v64H32V64zm0 96v304c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h96v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h192v48c0 8.8 7.2 16 16 16s16-7.2 16-16V160c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v64c0 17.7 14.3 32 32 32zm352 0v96H192v-96h192zm-224 0v96H64v-96h96zm16 224H64v-96h192v96h-80zm112 0v-96h96v96h-96z"
        }
    ]
};

const FalChopsticks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChopsticks",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M43.6 464.5 333.7 42.7c5.3-6.6 13.2-10.7 22-10.7 15.4 0 28.3 12.7 28.3 29 0 6.7-2.2 12.8-5.9 17.7L43.6 464.5zM355.7 0c-19.4 0-36.5 9.2-47.5 23.4l-.3.4-.3.4L6.2 462.4c-10 13.4-7.7 32.4 5.5 42.9 13.3 10.6 32.5 8.3 43-4.8L402.6 99.3l.3-.3.3-.4c8-10.4 12.8-23.5 12.8-37.6 0-33.5-26.8-61-60.3-61zM174.6 467.9l385.8-365.2c5-4.2 11.5-6.7 18.6-6.7 16.2 0 29 12.9 29 28.6 0 8.5-3.7 16.1-9.8 21.4L174.6 467.9zM579 64c-15.1 0-29 5.5-39.6 14.5l-.3.3-.3.3L138.5 458c-12.7 11.1-14.1 30.4-3 43.3 11 12.8 30.3 14.3 43.2 3.7L618 171.2l.3-.3.3-.3c13-11.1 21.4-27.6 21.4-46C640 91 612.5 64 579 64z"
        }
    ]
};

const FalChurch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalChurch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-40c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v39.4l-115.5 77c-17.8 11.9-28.5 31.9-28.5 53.3V480H64c-17.7 0-32-14.3-32-32v-69.9c0-10.9 5.5-21 14.6-26.9l81.4-52.6v-38.1l-98.8 63.9C11 336.2 0 356.4 0 378.1V448c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64v-69.9c0-21.7-11-41.9-29.2-53.7L512 260.5v38.1l81.4 52.7c9.1 5.9 14.6 16 14.6 26.9V448c0 17.7-14.3 32-32 32h-96V249.7c0-21.4-10.7-41.4-28.5-53.3l-115.5-77V80h40c8.8 0 16-7.2 16-16s-7.2-16-16-16h-40V16zm112 464h-64v-96c0-35.3-28.7-64-64-64s-64 28.7-64 64v96h-64V249.7c0-10.7 5.3-20.7 14.2-26.6L320 147.2 433.8 223c8.9 6 14.2 16 14.2 26.7V480zm-96-96v96h-64v-96c0-17.7 14.3-32 32-32s32 14.3 32 32z"
        }
    ]
};

const FalCircle0 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle0",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384c-53 0-96 43-96 96v64c0 53 43 96 96 96s96-43 96-96v-64c0-53-43-96-96-96zm-64 96c0-35.3 28.7-64 64-64s64 28.7 64 64v64c0 35.3-28.7 64-64 64s-64-28.7-64-64v-64z"
        }
    ]
};

const FalCircle1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm264-125.8c4.9 2.9 8 8.1 8 13.8v208h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V171.6l-32.1 18.3c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l56-32c5-2.8 11-2.8 16 .1z"
        }
    ]
};

const FalCircle2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-39-337.6c9.8-9.2 22.7-14.2 36.1-14 28.2.4 50.9 23.4 50.9 51.6 0 13.7-5.4 26.8-15.1 36.5L180.7 356.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H230.6l80.9-80.9c15.7-15.7 24.5-37 24.5-59.1 0-45.7-36.7-83-82.4-83.6-21.7-.3-42.7 7.8-58.5 22.7L181 164.3c-6.4 6.1-6.7 16.2-.7 22.6s16.2 6.7 22.6.7l14.1-13.2z"
        }
    ]
};

const FalCircle3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle3",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-384c-8.8 0-16 7.2-16 16s7.2 16 16 16h100.7l-79.2 67.9c-5.1 4.4-6.9 11.5-4.6 17.7S201.3 256 208 256l63.5-.3c26.7-.1 48.4 21.5 48.4 48.2 0 26.6-21.6 48.2-48.2 48.2h-36c-17.5 0-34-8.2-44.5-22.2l-2.5-3.4c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4l2.5 3.4c16.5 22.1 42.5 35 70.1 35h36c44.3 0 80.2-35.9 80.2-80.2 0-44.4-36.1-80.4-80.6-80.2l-19.9.1 78.9-67.6c5.1-4.4 6.9-11.4 4.6-17.7s-8.3-10.4-15-10.4H176z"
        }
    ]
};

const FalCircle4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle4",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm229.9-126.9c8.2 3.3 12.2 12.6 8.9 20.8L183.6 288H288v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H160c-5.3 0-10.3-2.6-13.2-7s-3.6-10-1.6-14.9l64-160c3.3-8.2 12.6-12.2 20.8-8.9z"
        }
    ]
};

const FalCircle5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle5",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-384c-7.3 0-13.7 5-15.5 12.1l-24 96c-1.1 4.5-.2 9.3 2.4 13.1s6.9 6.3 11.5 6.7l98.8 10c22.1 2.2 38.8 20.8 38.8 42.9 0 23.8-19.3 43.2-43.2 43.2h-44c-16.8 0-32.4-8.3-41.8-22.3l-1.8-2.7c-4.9-7.3-14.9-9.3-22.2-4.4s-9.3 14.9-4.4 22.2l1.8 2.7c15.3 22.8 40.9 36.4 68.3 36.4h44c41.5 0 75.2-33.7 75.2-75.2 0-38.6-29.2-70.9-67.6-74.8l-80.3-8 16.5-65.9H320c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"
        }
    ]
};

const FalCircle6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle6",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm43.7-378.9c-6-6.5-16.1-6.9-22.6-.8l-82.7 76.8c-22 20.4-34.4 49-34.4 78.9 0 53 43 96 96 96s96-43 96-96c0-51.8-41-94-92.3-95.9l39.1-36.3c6.5-6 6.9-16.1.8-22.6zM256 224a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FalCircle7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle7",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-384c-8.8 0-16 7.2-16 16s7.2 16 16 16h132.4L194.1 360.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l128-224c2.8-5 2.8-11-.1-16s-8.1-8-13.8-8H176z"
        }
    ]
};

const FalCircle8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle8",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm268-128c37.6 0 68 30.4 68 68 0 20.2-8.8 38.4-22.9 50.9 18.8 13.8 30.9 36 30.9 61.1 0 42-34 76-76 76h-24c-42 0-76-34-76-76 0-25.1 12.1-47.3 30.9-61.1-14-12.5-22.9-30.6-22.9-50.9 0-37.6 30.4-68 68-68h24zm-24 104h24c19.9 0 36-16.1 36-36s-16.1-36-36-36h-24c-19.9 0-36 16.1-36 36s16.1 36 36 36zm24 32h-24c-24.3 0-44 19.7-44 44s19.7 44 44 44h24c24.3 0 44-19.7 44-44s-19.7-44-44-44z"
        }
    ]
};

const FalCircle9 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle9",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm-3.7 159.9C201 318 160 275.8 160 224c0-53 43-96 96-96s96 43 96 96c0 30-12.5 58.6-34.4 78.9l-82.7 76.8c-6.5 6-16.6 5.6-22.6-.8s-5.6-16.6.8-22.6l39.1-36.3z"
        }
    ]
};

const FalCircleA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleA",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-400c-6.1 0-11.6 3.4-14.3 8.8l-112 224c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l27.5-55.1h140.2l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-112-224c-2.7-5.4-8.3-8.8-14.3-8.8zm0 51.8L310.1 272H201.9L256 163.8z"
        }
    ]
};

const FalCircleAmpersand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleAmpersand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-328c0-13.3 10.7-24 24-24h16.8c12.8 0 23.2 10.4 23.2 23.2 0 10.2-5 19.8-13.5 25.6l-21.8 15-22.1-23.3c-4.3-4.5-6.6-10.4-6.6-16.6zm68.7 51.2c17.1-11.8 27.3-31.2 27.3-52 0-30.5-24.7-55.2-55.2-55.2H232c-30.9 0-56 25.1-56 56 0 14.4 5.5 28.2 15.4 38.6l18.6 19.5-38.7 26.6C154.2 280.5 144 300 144 320.8c0 34.9 28.3 63.2 63.2 63.2h36c23.3 0 45.1-11.2 58.6-30.2l6.3-8.8 32.4 34c6.1 6.4 16.2 6.6 22.6.6s6.6-16.2.6-22.6L327 318.5l38-53.2c5.1-7.2 3.5-17.2-3.7-22.3s-17.2-3.5-22.3 3.7l-34.5 48.2-45.4-47.7 17.5-12.1zm-87.1 59.9 42.9-29.5 53.2 55.8-9.8 13.8c-7.5 10.5-19.6 16.8-32.5 16.8h-36c-17.4 0-31.4-14-31.4-31.2 0-10.3 5.1-19.9 13.5-25.7z"
        }
    ]
};

const FalCircleArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleArrowDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm56-160H176c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16v105.4l132.7-132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L214.6 320H312c8.8 0 16 7.2 16 16s-7.2 16-16 16z"
        }
    ]
};

const FalCircleArrowDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleArrowDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zm0-480a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-56 352h136c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v105.4L187.3 164.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 320H200c-8.8 0-16 7.2-16 16s7.2 16 16 16z"
        }
    ]
};

const FalCircleArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm107.3-228.7-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V144c0-8.8 7.2-16 16-16s16 7.2 16 16v185.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalCircleArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleArrowLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM228.7 148.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L182.6 272H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H182.6l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FalCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm283.3 107.3 96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l68.7 68.7H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h185.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"
        }
    ]
};

const FalCircleArrowUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleArrowUpLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm56-352H176c-8.8 0-16 7.2-16 16v144c0 8.8 7.2 16 16 16s16-7.2 16-16V214.6l132.7 132.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 192H312c8.8 0 16-7.2 16-16s-7.2-16-16-16z"
        }
    ]
};

const FalCircleArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-480a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-56 160h136c8.8 0 16 7.2 16 16v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.6L187.3 347.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L297.4 192H200c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCircleArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm107.3-283.3-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l68.7-68.7V368c0 8.8 7.2 16 16 16s16-7.2 16-16V182.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"
        }
    ]
};

const FalCircleB = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleB",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-352v192c0 17.7 14.3 32 32 32h104c39.8 0 72-32.2 72-72 0-26.6-14.4-49.8-35.9-62.3 12.3-12.9 19.9-30.4 19.9-49.7 0-39.8-32.2-72-72-72h-88c-17.7 0-32 14.3-32 32zm160 40c0 22.1-17.9 40-40 40h-88v-80h88c22.1 0 40 17.9 40 40zM192 352v-80h104c22.1 0 40 17.9 40 40s-17.9 40-40 40H192z"
        }
    ]
};

const FalCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleBolt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm191.7 8H240c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9 85.2-80.6H272c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9-85.2 80.6zm121.9-152c14.7 0 24.4 15.2 18.2 28.5L297 216h49.4c11.9 0 21.6 9.7 21.6 21.6 0 5.9-2.4 11.6-6.7 15.7L212.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5-14.7 0-24.4-15.2-18.2-28.5L215 296h-49.4c-11.9 0-21.6-9.7-21.6-21.6 0-5.9 2.4-11.6 6.7-15.7l149.1-141.2c3.7-3.5 8.7-5.5 13.8-5.5z"
        }
    ]
};

const FalCircleBookOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleBookOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm144-69.7v130l.7-.1C157 314.1 174 312 192 312c18.4 0 35.4 5.9 48 11.8V186.3c-2.4-1-5.3-2.1-8.5-3.2-10.8-3.7-25-7.2-39.5-7.2s-28.7 3.5-39.5 7.2c-3.2 1.1-6.1 2.2-8.5 3.2zm102 178.2-.1-.1c-.2-.1-.4-.3-.8-.6-.7-.5-1.8-1.3-3.3-2.3-2.9-2-7.2-4.6-12.5-7.3-10.6-5.4-24-10.2-37.3-10.2-15.7 0-30.8 1.9-42 3.8-5.6 1-10.1 1.9-13.3 2.6-1.6.4-2.8.6-3.6.8l-.9.2h-.2c-4.8 1.3-9.9.2-13.8-2.8s-6.2-7.7-6.2-12.7V176c0-5.9 3.3-11.4 8.5-14.1L128 176l-7.5-14.1.1-.1.4-.2c.3-.2.7-.4 1.2-.6 1.1-.5 2.5-1.2 4.4-2.1 3.7-1.7 9-3.9 15.5-6 12.7-4.3 30.6-8.8 49.8-8.8s37.1 4.5 49.8 8.8c5.7 1.9 10.6 3.9 14.2 5.5 3.6-1.6 8.5-3.5 14.2-5.5 12.7-4.3 30.6-8.8 49.8-8.8s37.1 4.5 49.8 8.8c6.4 2.2 11.7 4.4 15.5 6 1.9.8 3.4 1.5 4.4 2.1.5.3.9.5 1.2.6l.4.2.1.1-7.5 14.1 7.5-14.1c5.2 2.8 8.5 8.2 8.5 14.1v160c0 5-2.3 9.6-6.2 12.7s-9 4.1-13.8 2.8h-.2l-.9-.2c-.8-.2-2-.5-3.6-.8-3.1-.7-7.7-1.6-13.3-2.6-11.2-1.9-26.3-3.8-42-3.8-13.3 0-26.7 4.8-37.4 10.3-5.2 2.7-9.5 5.3-12.5 7.3-1.5 1-2.6 1.8-3.3 2.3-.4.3-.6.5-.8.6l-.1.1c-.3.3-.7.5-1 .8-.3.2-.6.4-.9.5-2.3 1.4-5 2.1-7.6 2.2h-1.3c-2.7-.1-5.3-1-7.7-2.4-.5-.3-1-.7-1.5-1zm26-40.7c12.6-6 29.6-11.8 48-11.8 18.1 0 35 2.1 47.3 4.2l.7.1v-130c-2.4-1-5.3-2.1-8.5-3.2-10.8-3.7-25-7.2-39.5-7.2s-28.7 3.5-39.5 7.2c-3.2 1.1-6.1 2.2-8.5 3.2v137.5z"
        }
    ]
};

const FalCircleBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleBookmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-336c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v158.7l-54-43.2c-5.8-4.7-14.1-4.7-20 0l-54 43.2V176zm16-48c-26.5 0-48 21.5-48 48v192c0 6.2 3.5 11.8 9.1 14.4s12.1 1.9 16.9-1.9l70-56 70 56c4.8 3.8 11.4 4.6 16.9 1.9s9.1-8.3 9.1-14.4V176c0-26.5-21.5-48-48-48h-96z"
        }
    ]
};

const FalCircleC = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleC",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-67.9-188.1c-37.5-37.5-37.5-98.3 0-135.8s98.3-37.5 135.8 0c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-50-50-131-50-181 0s-50 131 0 181 131 50 181 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-37.5 37.5-98.3 37.5-135.8 0z"
        }
    ]
};

const FalCircleCalendar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleCalendar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM208 96c8.8 0 16 7.2 16 16v16h64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h16v-16c0-8.8 7.2-16 16-16zm-48 80v16h192v-16c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm192 48H160v112c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16V224z"
        }
    ]
};

const FalCircleCamera = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleCamera",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-56.8-369.5-7.5 17.5H184c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h144c30.9 0 56-25.1 56-56v-80c0-30.9-25.1-56-56-56h-7.7l-7.5-17.5c-3.8-8.8-12.5-14.5-22.1-14.5h-69.4c-9.6 0-18.3 5.7-22.1 14.5zm27.4 17.5h58.9l9.6 22.3c2.5 5.9 8.3 9.7 14.7 9.7H328c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h18.3c6.4 0 12.2-3.8 14.7-9.7l9.6-22.3zM256 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalCircleCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleCaretDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zm0-480a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm0 352c9.6 0 18.7-4 25.2-11l95.5-102.8c4.7-5.1 7.3-11.8 7.3-18.7 0-15.2-12.3-27.5-27.5-27.5h-201c-15.2 0-27.5 12.3-27.5 27.5 0 6.9 2.6 13.6 7.3 18.7L230.8 341c6.5 7 15.6 11 25.2 11zm1.7-32.7c-.4.5-1.1.7-1.7.7s-1.3-.3-1.7-.7L165.8 224h180.3l-88.4 95.3z"
        }
    ]
};

const FalCircleCaretLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleCaretLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zm-352 0c0 9.6 4 18.7 11 25.2l102.8 95.5c5.1 4.7 11.8 7.3 18.7 7.3 15.2 0 27.5-12.3 27.5-27.5v-201c0-15.2-12.3-27.5-27.5-27.5-6.9 0-13.6 2.6-18.7 7.3L171 230.8c-7 6.5-11 15.6-11 25.2zm32.7 1.7c-.5-.4-.7-1.1-.7-1.7s.3-1.3.7-1.7l95.3-88.5v180.3l-95.3-88.4z"
        }
    ]
};

const FalCircleCaretRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleCaretRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm352 0c0-9.6-4-18.7-11-25.2l-102.8-95.5c-5.1-4.7-11.8-7.3-18.7-7.3-15.2 0-27.5 12.3-27.5 27.5v201c0 15.2 12.3 27.5 27.5 27.5 6.9 0 13.6-2.6 18.7-7.3L341 281.2c7-6.5 11-15.6 11-25.2zm-32.7-1.7c.5.4.7 1.1.7 1.7s-.3 1.3-.7 1.7L224 346.2V165.9l95.3 88.4z"
        }
    ]
};

const FalCircleCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleCaretUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-352c-9.6 0-18.7 4-25.2 11l-95.5 102.8c-4.7 5.1-7.3 11.8-7.3 18.7 0 15.2 12.3 27.5 27.5 27.5h201c15.2 0 27.5-12.3 27.5-27.5 0-6.9-2.6-13.6-7.3-18.7L281.2 171c-6.5-7-15.6-11-25.2-11zm-1.7 32.7c.4-.5 1.1-.7 1.7-.7s1.3.3 1.7.7l88.5 95.3H165.8l88.4-95.3z"
        }
    ]
};

const FalCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm107.3-308.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalCircleChevronDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleChevronDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zm0-480a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM132.7 235.3l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 313.4 155.3 212.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"
        }
    ]
};

const FalCircleChevronLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleChevronLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM276.7 132.7l-112 112c-6.2 6.2-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L198.6 256l100.7-100.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FalCircleChevronRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleChevronRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm235.3 123.3 112-112c6.2-6.2 6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L313.4 256 212.7 356.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0z"
        }
    ]
};

const FalCircleChevronUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleChevronUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm123.3-235.3-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 198.6l100.7 100.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"
        }
    ]
};

const FalCircleD = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleD",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-160h-64V160h64c53 0 96 43 96 96s-43 96-96 96zm-65.2-224c-17 0-30.8 13.8-30.8 30.8v194.4c0 17 13.8 30.8 30.8 30.8H256c70.7 0 128-57.3 128-128s-57.3-128-128-128h-65.2z"
        }
    ]
};

const FalCircleDashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleDashed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M18.8 232c8.2 0 15.1-6.2 16.5-14.3 5.7-33.3 18.8-64.1 37.5-90.7 4.7-6.7 4.3-16-1.5-21.8-6.7-6.7-17.8-6.2-23.3 1.5-22.5 31.4-38.2 68-44.6 107.7-1.6 9.4 5.9 17.6 15.4 17.6zM127 72.8c26.5-18.7 57.3-31.8 90.6-37.6 8.2-1.3 14.4-8.2 14.4-16.4 0-9.5-8.2-17-17.5-15.4-39.8 6.4-76.4 22.1-107.8 44.6-7.7 5.5-8.2 16.6-1.5 23.3 5.8 5.8 15.1 6.3 21.8 1.5zm153 420.4c0 9.5 8.2 17 17.5 15.4 39.7-6.5 76.4-22.1 107.7-44.6 7.7-5.5 8.2-16.6 1.5-23.3-5.8-5.8-15.1-6.3-21.8-1.5-26.5 18.7-57.3 31.8-90.6 37.6-8.1 1.4-14.3 8.2-14.3 16.5zM439.2 385c-4.7 6.7-4.3 16 1.5 21.8 6.7 6.7 17.8 6.2 23.3-1.5 22.5-31.4 38.2-68 44.6-107.7 1.5-9.4-5.9-17.5-15.4-17.5-8.2 0-15.1 6.2-16.5 14.3-5.7 33.3-18.8 64.1-37.6 90.6zm-334 55.7c-6.7 6.7-6.2 17.8 1.5 23.3 31.4 22.5 68 38.2 107.7 44.6 9.4 1.5 17.5-5.9 17.5-15.4 0-8.2-6.2-15.1-14.3-16.5-33.3-5.7-64.1-18.8-90.6-37.6-6.7-4.7-16-4.3-21.8 1.5zM48 405.3c5.5 7.7 16.6 8.2 23.3 1.5 5.8-5.8 6.3-15.1 1.5-21.8-18.7-26.6-31.8-57.4-37.5-90.7-1.4-8.1-8.3-14.3-16.5-14.3-9.5 0-17 8.2-15.4 17.5 6.4 39.8 22.1 76.4 44.6 107.8zm358.8-334c6.7-6.7 6.2-17.8-1.5-23.3-31.4-22.5-68-38.2-107.7-44.6-9.4-1.6-17.6 5.9-17.6 15.4 0 8.2 6.2 15.1 14.3 16.5 33.3 5.7 64.1 18.8 90.7 37.5 6.7 4.7 16 4.3 21.8-1.5zm32.4 55.7c18.7 26.5 31.8 57.3 37.6 90.6 1.4 8.1 8.2 14.3 16.5 14.3 9.5 0 17-8.2 15.4-17.5-6.5-39.7-22.1-76.4-44.6-107.7-5.5-7.7-16.6-8.2-23.3-1.5-5.8 5.8-6.3 15.1-1.5 21.8z"
        }
    ]
};

const FalCircleDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleDivide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-328a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-96 56c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zm120 112a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCircleDollarToSlot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleDollarToSlot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384a208 208 0 1 0 0-416 208 208 0 1 0 0 416zM64 352h-8c-30.9 0-56 25.1-56 56v48c0 30.9 25.1 56 56 56h400c30.9 0 56-25.1 56-56v-48c0-30.9-25.1-56-56-56h-8c-8.6 11.5-18.3 22.2-28.8 32H456c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h36.8c-10.5-9.8-20.2-20.5-28.8-32zm208-248c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7-13 7.7-23.9 21.1-23.8 40.5.1 18.4 10.8 30.1 22.7 37.3 10.5 6.3 23.8 10.4 34.8 13.7l1.6.5c12.5 3.8 22.2 6.9 29 11.2 5.9 3.7 7.7 7 7.7 11.6.1 6.6-2.7 10.8-7.8 14-5.8 3.6-14.5 5.6-23.7 5.3-11.8-.4-22.7-4.1-36.3-8.7-2.3-.8-4.7-1.6-7.1-2.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1 9.2 3.2 19.7 6.8 30.9 8.9V312c0 8.8 7.2 16 16 16s16-7.2 16-16v-17.1c8.7-1.4 17.4-4.3 25.1-9.1 13.3-8.3 23.2-22.2 22.9-41.6-.2-18.5-10.6-30.6-22.7-38.2-11-6.9-25-11.2-36.3-14.6l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9-6-3.6-7.2-6.4-7.3-10.1 0-5.4 2.4-9.4 8.1-12.8 6.2-3.7 15.1-5.7 23.6-5.5 10.1.2 21 2.3 32.1 5.3 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V104z"
        }
    ]
};

const FalCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm272-136v23c13.5 1 26.6 4.6 39.6 8.3 1.5.4 3.1.9 4.6 1.3 8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2l-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5-19.1-2.8-36.6-.4-49.3 5.1-12.9 5.6-18.6 13.1-19.8 19.5-1.8 9.8 2.1 16.5 10.2 21.7 10.6 6.8 26.5 11.3 45.8 16.8l.3.1c17.7 5 38.9 11.1 54.3 21.7 19 13 27.8 33.8 23.6 56.5-4 21.6-18.9 36-37.8 43.6-9.9 4-21.1 6.3-33.1 6.9V392c0 8.8-7.2 16-16 16s-16-7.2-16-16v-25.9c-8.1-1.3-21.8-5.2-32.4-8.4-6.9-2.1-13.8-4.3-20.7-6.5-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3 11.2 3.4 22.7 6.6 28.1 7.4 19.8 2.9 36.5 1.3 48-3.4 11.2-4.5 16.8-11.3 18.3-19.7 1.9-10.5-1.5-18.4-10.2-24.4-12-8.2-26.8-12.3-40.9-16.2-2.3-.6-4.7-1.3-6.9-1.9-17.1-4.8-37-10.5-51.7-19.9-8.1-5.2-15.7-12.1-20.5-21.7-4.9-9.8-6.2-20.8-4-32.8 3.8-20.7 20-35.1 38.6-43.1 7.4-3.2 15.6-5.6 24.3-7.1V120c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalCircleDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleDot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0z"
        }
    ]
};

const FalCircleDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm-80-184c0 4.4 3.6 8 8 8h113.4c3.7 0 6.6-3 6.6-6.6 0-1.8-.7-3.4-1.9-4.7l-25.4-25.4c-6.2-6.2-6.2-16.4 0-22.6l59.1-59.1c3.6-3.6 4.9-9 3.3-13.9-.7-2-1.8-3.8-3.3-5.3l-22.1-22.1c-1.5-1.5-3.3-2.6-5.3-3.3-4.9-1.6-10.3-.4-13.9 3.3l-59.1 59.1c-6.2 6.2-16.4 6.2-22.6 0L187.4 210c-1.2-1.2-2.9-1.9-4.7-1.9-3.7 0-6.6 3-6.6 6.6V328zm8 40c-22.1 0-40-17.9-40-40V214.6c0-21.3 17.3-38.6 38.6-38.6 10.2 0 20.1 4.1 27.3 11.3l14.1 14.1 47.7-47.7c12.2-12.2 30.3-16.5 46.7-11 6.7 2.2 12.8 6 17.8 11l22.1 22.1c5 5 8.8 11.1 11 17.8 5.5 16.4 1.2 34.5-11 46.7L310.6 288l14.1 14.1c7.2 7.2 11.3 17.1 11.3 27.3 0 21.3-17.3 38.6-38.6 38.6H184z"
        }
    ]
};

const FalCircleDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 1 0-448 224 224 0 1 1 0 448zm0-480a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm80 328c0 4.4-3.6 8-8 8H214.6c-3.7 0-6.6-3-6.6-6.6 0-1.8.7-3.4 1.9-4.7l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6l-59.1-59.1c-3.6-3.6-4.9-9-3.3-13.9.7-2 1.8-3.8 3.3-5.3l22.1-22.1c1.5-1.5 3.3-2.6 5.3-3.3 4.9-1.6 10.3-.4 13.9 3.3l59.1 59.1c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c1.2-1.2 2.9-1.9 4.7-1.9 3.7 0 6.6 3 6.6 6.6V328zm-8 40c22.1 0 40-17.9 40-40V214.6c0-21.3-17.3-38.6-38.6-38.6-10.2 0-20.1 4.1-27.3 11.3L288 201.4l-47.7-47.7c-12.2-12.2-30.3-16.5-46.7-11-6.7 2.2-12.8 6-17.8 11l-22.1 22.1c-5 5-8.8 11.1-11 17.8-5.5 16.4-1.2 34.5 11 46.7l47.7 47.7-14.1 14.1c-7.2 7.2-11.3 17.1-11.3 27.3 0 21.3 17.3 38.6 38.6 38.6H328z"
        }
    ]
};

const FalCircleDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm0 480a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-112c-9.2 0-18-3.5-24.7-9.7l-91-84a38.29 38.29 0 0 1-12.3-28.1c0-21.1 17.1-38.3 38.3-38.3H192V160c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v80h25.7c21.1 0 38.3 17.1 38.3 38.3 0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7zm-3-33.2c.8.8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.9 2-4.6 0-3.5-2.8-6.3-6.3-6.3H304c-8.8 0-16-7.2-16-16V160c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16h-41.7c-3.5 0-6.3 2.8-6.3 6.3 0 1.7.7 3.4 2 4.6l91 84z"
        }
    ]
};

const FalCircleE = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleE",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-384c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H192v-80h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H192v-80h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H192z"
        }
    ]
};

const FalCircleEllipsisVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleEllipsisVertical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalCircleEllipsis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleEllipsis",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-480a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm24 256a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm72-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-168 24a24 24 0 1 1-48 0 24 24 0 1 1 48 0z"
        }
    ]
};

const FalCircleEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleEnvelope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm160-96h192c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32zm192 48.5V192H160v16.5l88.5 47.1c2.3 1.2 4.9 1.9 7.5 1.9s5.2-.6 7.5-1.9l88.5-47.1zm0 36.2-73.4 39.1c-7 3.7-14.7 5.6-22.6 5.6s-15.6-1.9-22.6-5.6l-73.4-39V320h192v-75.2z"
        }
    ]
};

const FalCircleEuro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleEuro",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm128 16h24.2c-.7-5-1-10.1-1-15.2 0-5.7.4-11.3 1.2-16.8H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h34.2c18.2-37.9 56.9-64 101.7-64H305c8.8 0 16 7.2 16 16s-7.2 16-16 16h-41.1c-26.3 0-49.6 12.6-64.4 32H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H184.9c-1.1 5.4-1.7 11-1.7 16.8 0 5.2.5 10.3 1.4 15.2H288c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.6c14.7 20.3 38.5 33.5 65.5 33.5H305c8.8 0 16 7.2 16 16s-7.2 16-16 16h-41.1c-45.4 0-84.5-26.8-102.4-65.5H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCircleExclamationCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleExclamationCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32c95.3 0 176.7 59.5 209.1 143.4 3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C458 68 364.9 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c75.8 0 144-33 190.8-85.3 5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3c-41 45.9-100.6 74.7-167 74.7C132.3 480 32 379.7 32 256zm240-112c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm-16 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm363.3-195.3c-6.2-6.2-16.4-6.2-22.6 0L480 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCircleF = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleF",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-384c-17.7 0-32 14.3-32 32v208c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H192v-80h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H192z"
        }
    ]
};

const FalCircleG = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleG",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-256c0-53 43-96 96-96 24.6 0 47 9.2 64 24.4 6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6C318.7 140.3 288.8 128 256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128c0-8.8-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h62.7c-7.6 45.4-47.1 80-94.7 80-53 0-96-43-96-96z"
        }
    ]
};

const FalCircleH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleH",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm112-368c0-8.8-7.2-16-16-16s-16 7.2-16 16v96H176v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h160v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
        }
    ]
};

const FalCircleHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleHalfStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 479.4V32.6C123.8 40.8 32 137.7 32 256s91.8 215.2 208 223.4zM480 256c0-118.3-91.8-215.2-208-223.4v446.8c116.2-8.2 208-105.1 208-223.4zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FalCircleHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 34.3C115.5 49.8 32 143.2 32 256s83.5 206.2 192 221.7V34.3zm.1-32.3C241.6-.2 256 14.3 256 32v448c0 17.7-14.4 32.2-31.9 30C97.8 494.3 0 386.6 0 256S97.8 17.7 224.1 2z"
        }
    ]
};

const FalCircleHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM131.9 164.9c-29.4 29.8-29.4 78.2 0 108l101.6 103.2c6.2 6.3 14.3 9.4 22.5 9.4s16.3-3.1 22.5-9.4l101.6-103.2c29.4-29.8 29.4-78.2 0-108-27.8-28.2-71.9-29.7-101.5-4.6-5.8 4.9-11 10.4-16.3 15.9-2.1 2.2-4.2 4.5-6.4 6.6-2.1-2.2-4.3-4.4-6.4-6.6-5.2-5.5-10.5-11-16.3-15.9-29.6-25.1-73.7-23.6-101.5 4.6zm83.6 22.5 29.1 29.6c6.3 6.4 16.5 6.4 22.8 0l29.1-29.6c16.8-17.1 44-17.1 60.8 0 17.1 17.4 17.1 45.7 0 63.1L256 353.3 154.7 250.4c-17.1-17.4-17.1-45.7 0-63.1 16.8-17.1 44-17.1 60.8 0z"
        }
    ]
};

const FalCircleI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleI",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-384c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v192h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64V160h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
        }
    ]
};

const FalCircleInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleInfo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-48-160c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V240c0-8.8-7.2-16-16-16h-40c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96h-32zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalCircleJ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleJ",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm80-368c0-8.8-7.2-16-16-16s-16 7.2-16 16v144c0 35.3-28.7 64-64 64s-64-28.7-64-64v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53 43 96 96 96s96-43 96-96V144z"
        }
    ]
};

const FalCircleK = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleK",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm91.1-356.5c6.4-6.1 6.5-16.3.4-22.6s-16.3-6.5-22.6-.4L192 260.8V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16v-62.7l44.6-43.1 86.6 115.4c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4l-89-118.6 87.3-84.3z"
        }
    ]
};

const FalCircleL = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleL",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-368c0-8.8-7.2-16-16-16s-16 7.2-16 16v208c0 17.7 14.3 32 32 32h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H192V144z"
        }
    ]
};

const FalCircleLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zm-400 0c0 9.2 3.5 18 9.7 24.7l84 91c7.2 7.8 17.4 12.3 28.1 12.3 21.1 0 38.3-17.1 38.3-38.3V320h80c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48h-80v-25.7c0-21.1-17.1-38.3-38.3-38.3-10.7 0-20.9 4.5-28.1 12.3l-84 91c-6.2 6.7-9.7 15.6-9.7 24.7zm33.2 3c-.8-.8-1.2-1.9-1.2-3s.4-2.2 1.2-3l84-91c1.2-1.3 2.9-2 4.6-2 3.5 0 6.3 2.8 6.3 6.3V208c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16v41.7c0 3.5-2.8 6.3-6.3 6.3-1.7 0-3.4-.7-4.6-2l-84-91z"
        }
    ]
};

const FalCircleLocationArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleLocationArrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm127.7 27c-11.7 0-21.9-8.3-24.2-19.8-2.4-11.4 3.7-23.1 14.5-27.7L338.5 141c9.5-3.9 20.2-1.9 27.3 5.3 7.2 7.1 9.2 17.8 5.2 27.2L276.5 394c-3.9 9.1-12.9 15-22.8 15-1.6 0-3.3-.1-4.9-.5-11.5-2.3-19.8-12.5-19.8-24.3V283H127.7zm35.3-32h66c17.7 0 32 14.3 32 32v66l73.5-171.4L163.1 251z"
        }
    ]
};

const FalCircleM = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleM",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-98.9-377.2c-4-5.7-11.3-8.2-17.9-6.1S128 137 128 144v224c0 8.8 7.2 16 16 16s16-7.2 16-16V194.8l82.9 118.4c3 4.3 7.9 6.8 13.1 6.8s10.1-2.5 13.1-6.8L352 194.8V368c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-7-4.5-13.2-11.2-15.3s-13.9.4-17.9 6.1L256 276.1l-98.9-141.3z"
        }
    ]
};

const FalCircleMicrophoneLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleMicrophoneLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-416c-35.3 0-64 28.7-64 64v96c0 35.3 28.7 64 64 64s64-28.7 64-64v-96c0-35.3-28.7-64-64-64zm32 64h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v32h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c0 17.7-14.3 32-32 32s-32-14.3-32-32v-96c0-17.7 14.3-32 32-32s32 14.3 32 32zm-128 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 65.3 48.9 119.1 112 127v17c0 8.8 7.2 16 16 16s16-7.2 16-16v-17c63.1-7.9 112-61.7 112-127v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 53-43 96-96 96s-96-43-96-96v-16z"
        }
    ]
};

const FalCircleMicrophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleMicrophone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm192-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 35.3-28.7 64-64 64s-64-28.7-64-64v-96zm64-32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-112 96c8.8 0 16 7.2 16 16v16c0 53 43 96 96 96s96-43 96-96v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 65.3-48.9 119.1-112 127v17c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17c-63.1-7.9-112-61.7-112-127v-16c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-272c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
        }
    ]
};

const FalCircleN = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleN",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-67-377.3c-4-5.7-11.3-8.1-17.9-5.9S160 137 160 144v224c0 8.8 7.2 16 16 16s16-7.2 16-16V193.9l131 183.4c4 5.7 11.3 8.1 17.9 5.9S352 374.9 352 368V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v174.1L189 134.7z"
        }
    ]
};

const FalCircleNodes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleNodes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M376.2 121.7c7 4 15.2 6.3 23.8 6.3 2.6 0 5.2-.2 7.6-.6 22.9-3.7 40.4-23.5 40.4-47.4 0-26.5-21.5-48-48-48s-48 21.5-48 48v2c.5 11.4 4.9 21.7 11.9 29.7 3.5 4 7.6 7.4 12.2 10zm-5.9 32.6c-15.2-6.1-28.2-16.8-37.1-30.3l-174.5 69.7c.8 4.6 1.3 9.4 1.3 14.3 0 14.4-3.8 27.9-10.5 39.6l138 120.8c13-9.9 29.2-16 46.7-16.3l36-197.7zm-4.5 203.4c29.4 11.8 50.2 40.6 50.2 74.3 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-14.4 3.8-27.9 10.5-39.6l-138-120.8C115 281.9 98.2 288 80 288c-44.2 0-80-35.8-80-80s35.8-80 80-80c27.9 0 52.5 14.3 66.8 36l174.5-69.7c-.8-4.6-1.3-9.4-1.3-14.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 43.6-34.9 79.1-78.3 80l-36 197.7zm-246-122.9c.7-1 1.3-2 1.9-3.1 4-7 6.3-15.1 6.3-23.8 0-26.5-21.5-48-48-48s-48 21.5-48 48 21.5 48 48 48c8.5 0 16.6-2.2 23.5-6.2 6.5-3.7 12.1-8.8 16.3-15zm171.6 179.4c-2.2 5.5-3.4 11.5-3.4 17.8 0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48c-14 0-26.6 6-35.3 15.5-2.7 2.9-5 6.1-6.9 9.6-.9 1.6-1.7 3.4-2.4 5.1z"
        }
    ]
};

const FalCircleNotch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleNotch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M207.4 20.4c2.4 8.5-2.6 17.3-11.2 19.7C101.5 66.2 32 153 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224c0-103-69.5-189.8-164.3-215.9-8.5-2.4-13.5-11.2-11.2-19.7s11.2-13.5 19.7-11.2C432.5 39.1 512 138.2 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 138.2 79.5 39.1 187.7 9.2c8.5-2.4 17.3 2.6 19.7 11.2z"
        }
    ]
};

const FalCircleO = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleO",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm96-256a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm-96-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256z"
        }
    ]
};

const FalCircleP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleP",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-384c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h72c48.6 0 88-39.4 88-88s-39.4-88-88-88h-88zm88 144h-72V160h72c30.9 0 56 25.1 56 56s-25.1 56-56 56z"
        }
    ]
};

const FalCircleParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleParking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208 32h80c35.3 0 64-28.7 64-64s-28.7-64-64-64h-80v128zm80 32h-80v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V152c0-13.3 10.7-24 24-24h88c53 0 96 43 96 96s-43 96-96 96z"
        }
    ]
};

const FalCirclePause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCirclePause",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm224-80v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalCirclePhoneFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCirclePhoneFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-480a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm52.8 144.1c-1.9-.4-3.8.6-4.5 2.3l-24 56c-.7 1.6-.2 3.5 1.1 4.7l20.3 16.6c6.1 5 7.6 13.6 3.7 20.4-14.7 25.4-35.9 46.6-61.4 61.4-6.8 3.9-15.4 2.4-20.4-3.7L207 281.5c-1.1-1.4-3-1.8-4.7-1.1l-56 24c-1.8.8-2.7 2.6-2.3 4.5l12 56c.4 1.8 2 3.2 3.9 3.2 114.9 0 208-93.1 208-208 0-1.9-1.3-3.5-3.2-3.9l-56-12zm-33.9-10.3c6.8-15.8 23.8-24.6 40.6-21l56 12C388.1 128.4 400 143 400 160c0 132.5-107.4 240-240 240-17 0-31.6-11.9-35.2-28.5l-12-56c-3.6-16.8 5.2-33.9 21-40.6l56-24c14.7-6.3 31.9-2.1 42 10.3l7.5 9.2c11.9-8.6 22.4-19.1 31-31l-9.2-7.5c-12.4-10.2-16.6-27.3-10.3-42l24-56z"
        }
    ]
};

const FalCirclePhoneHangup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCirclePhoneHangup",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM112 248.6c.1-.5.3-1.2 1.1-1.9 78.8-72.9 207-72.9 285.7 0 .8.7 1 1.4 1.1 1.9s0 1.1-.4 1.8l-21.7 35.2c-1 1.7-4.1 3.2-7.4 1.9l-46.2-17.6c-2.4-.9-2.9-2.6-2.9-3.4l2.8-18.1c1.2-7.8-3.4-15.3-10.9-17.7-37-11.9-77.4-11.9-114.3 0-7.5 2.4-12.1 9.9-10.9 17.7l2.8 18.1c0 .9-.5 2.5-2.9 3.4l-46.2 17.6c-3.3 1.2-6.4-.3-7.4-1.9l-21.7-35.2c-.4-.7-.5-1.2-.4-1.8zm308.6-25.4c-91-84.3-238.2-84.3-329.2 0-12.3 11.4-15.1 29.5-6.2 44l21.7 35.2c9.6 15.6 29.4 21.4 46 15l46.2-17.6c14.9-5.7 25.1-20.3 23.3-36.9 0-.2-.1-.5-.1-.7l-.7-4.5c22.5-5.1 46.1-5.1 68.6 0l-.7 4.5c0 .2-.1.5-.1.7-1.8 16.6 8.5 31.3 23.3 36.9l46.3 17.7c16.6 6.3 36.4.6 46-15l21.7-35.2c8.9-14.4 6.1-32.6-6.2-44z"
        }
    ]
};

const FalCirclePhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCirclePhone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-52.8-367.9c1.9-.4 3.8.6 4.5 2.3l24 56c.7 1.6.2 3.5-1.1 4.7l-20.3 16.6c-6.1 5-7.6 13.6-3.7 20.4 14.7 25.4 35.9 46.6 61.4 61.4 6.8 3.9 15.4 2.4 20.4-3.7l16.6-20.3c1.1-1.4 3-1.8 4.7-1.1l56 24c1.8.8 2.7 2.6 2.3 4.5l-12 56c-.4 1.8-2 3.2-3.9 3.2-114.9 0-208-93.1-208-208 0-1.9 1.3-3.5 3.2-3.9l56-12zm33.9-10.3c-6.8-15.8-23.8-24.6-40.6-21l-56 12C123.9 128.4 112 143 112 160c0 132.5 107.4 240 240 240 17 0 31.6-11.9 35.2-28.5l12-56c3.6-16.8-5.2-33.9-21-40.6l-56-24c-14.7-6.3-31.9-2.1-42 10.3l-7.5 9.2c-11.9-8.6-22.4-19.1-31-31l9.2-7.5c12.4-10.2 16.6-27.3 10.3-42l-24-56z"
        }
    ]
};

const FalCirclePlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCirclePlay",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm72.7-256L208 329.7V182.3L328.7 256zM212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z"
        }
    ]
};

const FalCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCirclePlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-16-160c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
        }
    ]
};

const FalCircleQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleQ",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-256c0-53 43-96 96-96s96 43 96 96c0 20.7-6.6 39.9-17.7 55.6l-50.9-50.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l50.9 50.9c-15.8 11.2-35 17.8-55.7 17.8-53 0-96-43-96-96zm224 0c0-70.7-57.3-128-128-128s-128 57.3-128 128 57.3 128 128 128c29.6 0 56.8-10 78.5-26.9l22.2 22.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-22.2-22.2C374 312.8 384 285.6 384 256z"
        }
    ]
};

const FalCircleQuarterStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleQuarterStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256c0-123.7-100.3-224-224-224v176c0 26.5-21.5 48-48 48H32c0 123.7 100.3 224 224 224s224-100.3 224-224zM224 34.3C125.9 48.3 48.3 125.9 34.3 224H208c8.8 0 16-7.2 16-16V34.3zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FalCircleQuarter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleQuarter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 34.3V224H34.3c14-98.1 91.6-175.7 189.7-189.7zM2 224.1C-.2 241.6 14.3 256 32 256h192c17.7 0 32-14.3 32-32V32c0-17.7-14.4-32.2-31.9-30C108.2 16.4 16.4 108.2 2 224.1z"
        }
    ]
};

const FalCircleQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleQuarters",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M402.7 425.3 256 278.6 109.3 425.3C148.6 459.4 199.9 480 256 480s107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256s-20.6-107.4-54.7-146.7L278.6 256l146.7 146.7zm-22.6-316C363.4 52.6 312.1 32 256 32S148.6 52.6 109.3 86.7L256 233.4 402.7 86.7zm-316 22.6C52.6 148.6 32 199.9 32 256s20.6 107.4 54.7 146.7L233.4 256 86.7 109.3zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FalCircleQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8H280c35.5 0 64 29 64 64.3 0 24-13.4 46.2-34.9 57.2L272 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16v-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7 0-17.8-14.4-32.3-32-32.3h-57.1c-10.9 0-20.5 7.4-23.2 17.9l-.2.7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalCircleR = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleR",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-64-384c-17.7 0-32 14.3-32 32v208c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h71.4l59.3 88.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-50.5-75.7c31-11 53.2-40.6 53.2-75.4 0-44.2-35.8-80-80-80h-80zm80 128h-80v-96h80c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
        }
    ]
};

const FalCircleRadiation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleRadiation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-95.4-363.9c2.4-2.1 5.3-2.8 8.4-2 3.3.8 6.9 3.2 9.1 7.1l37.2 64.4c7.4-7.8 16.9-13.5 27.7-16l-37.2-64.4c-12.7-22-43.9-32.9-66.4-13-28.1 24.9-48.2 58.6-56 96.9-5.9 29.4 19.1 51 44.5 51h74.3c-1.5-5.1-2.3-10.4-2.3-16s.8-10.9 2.3-16H128c-4.5 0-8.4-1.9-10.7-4.4-2.2-2.3-3.1-5.1-2.5-8.3 6.3-31.3 22.7-58.9 45.8-79.3zm54.7 146.4-37.2 64.4c-12.7 22-6.6 54.4 21.9 64 17.6 5.9 36.5 9.1 56 9.1s38.4-3.2 56-9.1c28.5-9.6 34.6-42 21.9-64l-37.2-64.4c-7.4 7.8-16.9 13.5-27.7 16l37.2 64.4c2.3 3.9 2.6 8.2 1.6 11.4-.9 3.1-2.9 5.2-5.9 6.2-14.4 4.8-29.8 7.4-45.8 7.4s-31.5-2.6-45.8-7.4c-3-1-5-3.2-5.9-6.2-1-3.3-.7-7.5 1.6-11.4l37-64.4c-10.8-2.6-20.3-8.2-27.7-16zm94.4-22.5H384c25.4 0 50.5-21.5 44.5-51-7.7-38.3-27.8-72.1-56-96.9-22.5-19.9-53.7-9-66.4 13L269 201.5c10.8 2.6 20.3 8.2 27.7 16l37.2-64.4c2.3-3.9 5.8-6.3 9.1-7.1 3.1-.7 6-.1 8.4 2 23.1 20.4 39.5 48 45.8 79.3.6 3.1-.3 5.9-2.5 8.3-2.3 2.5-6.2 4.4-10.7 4.4h-74.3c1.5 5.1 2.3 10.4 2.3 16s-.8 10.9-2.3 16zm-53.7 8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalCircleRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm400 0c0-9.2-3.5-18-9.7-24.7l-84-91a38.29 38.29 0 0 0-28.1-12.3c-21.1 0-38.3 17.1-38.3 38.3V192h-80c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h80v25.7c0 21.1 17.1 38.3 38.3 38.3 10.7 0 20.9-4.5 28.1-12.3l84-91c6.2-6.7 9.7-15.6 9.7-24.7zm-33.2-3c.8.8 1.2 1.9 1.2 3s-.4 2.2-1.2 3l-84 91c-1.2 1.3-2.9 2-4.6 2-3.5 0-6.3-2.8-6.3-6.3V304c0-8.8-7.2-16-16-16h-96c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16v-41.7c0-3.5 2.8-6.3 6.3-6.3 1.7 0 3.4.7 4.6 2l84 91z"
        }
    ]
};

const FalCircleS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleS",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-63.3-322c2-10.7 9.2-19.1 23.1-24.4 14.3-5.5 34.5-7.2 57.9-3.8 7 1 23.4 4.5 31 6.4 8.6 2.2 17.3-3 19.4-11.6s-3-17.3-11.6-19.4c-8.2-2.1-25.7-5.8-34.1-7-26.9-4-53.1-2.6-74.1 5.6-21.5 8.3-38.6 24.2-43.1 48.5-2.5 13.9-1.2 26.6 4 37.7 5.2 11 13.6 19.1 23 25.2 17.5 11.5 41.3 18.1 62 23.8l1.5.4c22.6 6.3 41.6 11.7 54.4 20.1 6 4 9.7 8 11.7 12.3 1.9 4.1 3 9.7 1.5 18.2-2 10.7-9.2 19.1-23.1 24.4-14.3 5.5-34.5 7.2-57.9 3.8-14.3-2.2-41.3-10-56.4-14.8-8.4-2.7-17.4 2-20.1 10.5s2 17.4 10.5 20.1c15 4.7 44.2 13.3 61.2 15.9h.1c26.9 4 53.1 2.6 74.1-5.6 21.5-8.3 38.6-24.2 43.1-48.5 2.5-13.9 1.2-26.6-4-37.7-5.2-11-13.6-19.1-23-25.2-17.5-11.5-41.3-18.1-62-23.8l-1.5-.4c-22.6-6.3-41.6-11.7-54.4-20.1-6-4-9.7-8-11.7-12.3-1.9-4.1-3-9.7-1.5-18.2z"
        }
    ]
};

const FalCircleSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleSmall",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 256a128 128 0 1 0-256 0 128 128 0 1 0 256 0zM0 256a160 160 0 1 1 320 0 160 160 0 1 1-320 0z"
        }
    ]
};

const FalCircleSortDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleSortDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM244.7 411.3c6.2 6.2 16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H160c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l96 96zM198.6 320h114.7L256 377.4 198.6 320zm-49.9-123.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l84.7-84.7 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96z"
        }
    ]
};

const FalCircleSortUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleSortUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm244.7-155.3c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zM198.6 192h114.7L256 134.6 198.6 192zm-49.9 123.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l84.7 84.7 84.7-84.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96z"
        }
    ]
};

const FalCircleSort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleSort",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm244.7-155.3c6.2-6.2 16.4-6.2 22.6 0l96 96c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l96-96zM198.6 192h114.7L256 134.6 198.6 192zm-49.9 123.3c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h192c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96zM256 377.4l57.4-57.4H198.7l57.3 57.4z"
        }
    ]
};

const FalCircleStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleStar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm14.3-399.1c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-36.2 73.4-81 11.8c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l58.6 57.2-13.8 80.7c-1 6 1.4 12.1 6.4 15.6s11.5 4.1 16.8 1.2l72.4-38 72.5 38.1c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.6L338 282.7l58.6-57.2c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-81.1-11.8-36.2-73.4zm-40 95.1 25.7-51.8 25.6 51.9c2.3 4.7 6.8 8 12 8.8l57.3 8.3-41.5 40.4c-3.8 3.7-5.5 9-4.6 14.2l9.8 57.1-51.2-26.9c-4.7-2.5-10.2-2.5-14.9 0l-51.2 26.9 9.8-57.1c.9-5.2-.8-10.5-4.6-14.2L161 225.1l57.3-8.3c5.2-.8 9.7-4 12-8.8z"
        }
    ]
};

const FalCircleSterling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleSterling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm259.6-112c-20.2 0-36.5 16.5-36.4 36.7l.3 43.3H272c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48.4c-.9 22.5-7.1 44.4-18 64H328c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-5.9 0-11.4-3.3-14.2-8.5s-2.4-11.6 1-16.5l9.2-13.5c11.7-17 18.4-36.9 19.5-57.5H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h15.5l-.3-43.1c-.3-38 30.4-68.9 68.4-68.9 10.6 0 21.1 2.5 30.6 7.2l20.9 10.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-20.9-10.5c-5.1-2.5-10.6-3.8-16.3-3.8z"
        }
    ]
};

const FalCircleStop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleStop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm160-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192zm32 0v128h128V192H192z"
        }
    ]
};

const FalCircleT = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleT",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM144 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v192c0 8.8 7.2 16 16 16s16-7.2 16-16V176h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
        }
    ]
};

const FalCircleThreeQuartersStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleThreeQuartersStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M477.7 288H272c-26.5 0-48-21.5-48-48V34.3C115.4 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224 112.8 0 206.2-83.4 221.7-192zm2.3-32c0-123.7-100.3-224-224-224v208c0 8.8 7.2 16 16 16h208zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FalCircleThreeQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleThreeQuarters",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 288c-17.7 0-32-14.3-32-32V34.3C115.5 49.8 32 143.2 32 256c0 123.7 100.3 224 224 224 112.8 0 206.2-83.5 221.7-192H256zM224.1 2C241.6-.2 256 14.3 256 32v224h224c17.7 0 32.2 14.4 30 31.9C494.3 414.2 386.6 512 256 512 114.6 512 0 397.4 0 256 0 125.4 97.8 17.7 224.1 2z"
        }
    ]
};

const FalCircleTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleTrash",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm160-112h41.4l11.3-11.3c3-3 7.1-4.7 11.3-4.7h64c4.2 0 8.3 1.7 11.3 4.7l11.3 11.3H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-2.1L338 354.1c-1.1 16.8-15.1 29.9-31.9 29.9H205.9c-16.8 0-30.8-13.1-31.9-29.9L162.1 176H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm157.8 32H194.2l11.7 176h100.2l11.7-176z"
        }
    ]
};

const FalCircleU = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleU",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-352c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 61.9 50.1 112 112 112s112-50.1 112-112V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 44.2-35.8 80-80 80s-80-35.8-80-80V160z"
        }
    ]
};

const FalCircleUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleUpLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-328c0-4.4 3.6-8 8-8h113.4c3.7 0 6.6 3 6.6 6.6 0 1.8-.7 3.4-1.9 4.7l-25.4 25.4c-6.2 6.2-6.2 16.4 0 22.6l59.1 59.1c3.6 3.6 4.9 9 3.3 13.9-.7 2-1.8 3.8-3.3 5.3l-22.1 22.1c-1.5 1.5-3.3 2.6-5.3 3.3-4.9 1.6-10.3.4-13.9-3.3l-59.1-59.1c-6.2-6.2-16.4-6.2-22.6 0L187.4 302c-1.2 1.2-2.9 1.9-4.7 1.9-3.7 0-6.6-3-6.6-6.6V184zm8-40c-22.1 0-40 17.9-40 40v113.4c0 21.3 17.3 38.6 38.6 38.6 10.2 0 20.1-4.1 27.3-11.3l14.1-14.1 47.7 47.7c12.2 12.2 30.3 16.5 46.7 11 6.7-2.2 12.8-6 17.8-11l22.1-22.1c5-5 8.8-11.1 11-17.8 5.5-16.4 1.2-34.5-11-46.7L310.6 224l14.1-14.1c7.2-7.2 11.3-17.1 11.3-27.3 0-21.3-17.3-38.6-38.6-38.6H184z"
        }
    ]
};

const FalCircleUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-480a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm80 184c0-4.4-3.6-8-8-8H214.6c-3.7 0-6.6 3-6.6 6.6 0 1.8.7 3.4 1.9 4.7l25.4 25.4c6.2 6.2 6.2 16.4 0 22.6l-59.1 59.1c-3.6 3.6-4.9 9-3.3 13.9.7 2 1.8 3.8 3.3 5.3l22.1 22.1c1.5 1.5 3.3 2.6 5.3 3.3 4.9 1.6 10.3.4 13.9-3.3l59.1-59.1c6.2-6.2 16.4-6.2 22.6 0l25.4 25.4c1.2 1.2 2.9 1.9 4.7 1.9 3.7 0 6.6-3 6.6-6.6V184zm-8-40c22.1 0 40 17.9 40 40v113.4c0 21.3-17.3 38.6-38.6 38.6-10.2 0-20.1-4.1-27.3-11.3L288 310.6l-47.7 47.7c-12.2 12.2-30.3 16.5-46.7 11-6.7-2.2-12.8-6-17.8-11l-22.1-22.1c-5-5-8.8-11.1-11-17.8-5.5-16.4-1.2-34.5 11-46.7l47.7-47.7-14.1-14.1c-7.2-7.2-11.3-17.1-11.3-27.3 0-21.3 17.3-38.6 38.6-38.6H328z"
        }
    ]
};

const FalCircleUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-400c-9.2 0-18 3.5-24.7 9.7l-91 84a38.29 38.29 0 0 0-12.3 28.1c0 21.1 17.1 38.3 38.3 38.3H192v80c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V272h25.7c21.1 0 38.3-17.1 38.3-38.3 0-10.7-4.5-20.9-12.3-28.1l-91-84c-6.7-6.2-15.6-9.7-24.7-9.7zm-3 33.2c.8-.8 1.9-1.2 3-1.2s2.2.4 3 1.2l91 84c1.3 1.2 2 2.9 2 4.6 0 3.5-2.8 6.3-6.3 6.3H304c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V256c0-8.8-7.2-16-16-16h-41.7c-3.5 0-6.3-2.8-6.3-6.3 0-1.7.7-3.4 2-4.6l91-84z"
        }
    ]
};

const FalCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleUser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M412.1 416.6c-14-55.5-64.2-96.6-124.1-96.6h-64c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256 32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zM383.6 440c-36.1 25.2-80.1 40-127.6 40s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1h64c50.4 0 91.6 38.8 95.7 88.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0-160 0z"
        }
    ]
};

const FalCircleV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleV",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-97.7-359.2c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l112 224c2.7 5.4 8.3 8.8 14.3 8.8s11.6-3.4 14.3-8.8l112-224c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L256 348.2l-97.7-195.4z"
        }
    ]
};

const FalCircleVideo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleVideo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm32-320v128H160V192h128zm32 9.8V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-9.8l74.9 25c4.9 1.6 10.2.8 14.4-2.2s6.6-7.8 6.6-13V192c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-74.9 25zm0 33.7 64-21.3v83.6l-64-21.3v-41z"
        }
    ]
};

const FalCircleW = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleW",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM135.1 170.8c-2.9-8.4-12-12.8-20.4-9.9s-12.8 12-9.9 20.4l72 208c2.3 6.5 8.4 10.8 15.3 10.8s13-4.6 15.1-11.1L256 236.5l48.8 152.4c2.1 6.6 8.2 11 15.1 11.1s13.1-4.3 15.3-10.8l72-208c2.9-8.4-1.5-17.5-9.9-20.4s-17.5 1.5-20.4 9.9l-56.3 162.7-49.4-154.3c-2.1-6.6-8.2-11.1-15.2-11.1s-13.1 4.5-15.2 11.1l-49.4 154.3-56.3-162.6z"
        }
    ]
};

const FalCircleWaveformLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleWaveformLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm288-112v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm-128 32v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V200c0-8.8 7.2-16 16-16s16 7.2 16 16zm-128 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 24v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalCircleX = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleX",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-83.9-378.4c-5.8-6.7-15.9-7.5-22.6-1.7s-7.5 15.9-1.7 22.6L234.9 256l-87 101.6c-5.8 6.7-5 16.8 1.7 22.6s16.8 5 22.6-1.7l83.8-97.9 83.9 97.8c5.8 6.7 15.8 7.5 22.6 1.7s7.5-15.8 1.7-22.6L277.1 256l87.1-101.6c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7L256 231.4l-83.9-97.8z"
        }
    ]
};

const FalCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-75.3-331.3c-6.2 6.2-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalCircleY = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleY",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM156 149.5c-5.8-6.7-15.9-7.3-22.6-1.5s-7.3 15.9-1.5 22.6L240 294v90c0 8.8 7.2 16 16 16s16-7.2 16-16v-90l108-123.5c5.8-6.7 5.1-16.8-1.5-22.6s-16.8-5.1-22.6 1.5L256 263.7 156 149.5z"
        }
    ]
};

const FalCircleYen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleYen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm165.2-107.8c6.5-5.9 16.7-5.5 22.6 1.1l68.2 75 68.2-75c5.9-6.5 16.1-7 22.6-1.1s7 16.1 1.1 22.6L271 255.2h1v.8h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v17c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-32h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-.8h1l-76.8-84.5c-5.9-6.5-5.5-16.7 1.1-22.6z"
        }
    ]
};

const FalCircleZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircleZ",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-80-384c-8.8 0-16 7.2-16 16s7.2 16 16 16h128.9L163 358.7c-3.5 4.9-3.9 11.3-1.2 16.6S170 384 176 384h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H207.1L349 153.3c3.5-4.9 3.9-11.3 1.2-16.6S342 128 336 128H176z"
        }
    ]
};

const FalCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"
        }
    ]
};

const FalCirclesOverlap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCirclesOverlap",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232 415.8c-25.2-36.2-40-80.3-40-127.8 0-99.1 64.3-183.1 153.5-212.7C312.4 48.2 270.1 32 224 32 118 32 32 118 32 224s86 192 192 192c2.7 0 5.4-.1 8-.2zm36.4-5C353 390.8 416 314.7 416 224c0-46.7-16.7-89.5-44.4-122.8C287 121.2 224 197.3 224 288c0 46.7 16.7 89.5 44.4 122.8zm-11.6 34.8c-10.7 1.6-21.7 2.4-32.8 2.4C100.3 448 0 347.7 0 224S100.3 0 224 0c62.3 0 118.6 25.4 159.2 66.4 10.7-1.6 21.6-2.4 32.8-2.4 123.7 0 224 100.3 224 224S539.7 512 416 512c-62.3 0-118.6-25.4-159.2-66.4zM408 96.2c25.2 36.3 40 80.3 40 127.8 0 99.1-64.3 183.1-153.5 212.7C327.6 463.8 369.9 480 416 480c106 0 192-86 192-192S522 96 416 96c-2.7 0-5.4.1-8 .2z"
        }
    ]
};

const FalCitrusSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCitrusSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M427.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-400 400c-6.2 6.2-6.2 16.4 0 22.6C58.9 481.5 132.5 512 209.1 512h4C378.2 512 512 378.2 512 213.2v-4c0-76.7-30.5-150.2-84.7-204.5zM278.8 175.8l89.4-89.4c21.5 25.2 36.9 55.9 43.7 89.7H279l-.2-.2zm16.8 32.2h120.2c.1 2.7.2 5.3.2 8 0 49.5-18 94.7-47.7 129.7l-82.5-82.5c10.7-16.5 14-36.5 9.8-55.2zm50.1 160.3C310.7 398 265.5 416 216 416c-2.7 0-5.3-.1-8-.2v-122c18.4 4.6 38.2 1.8 54.9-8.4l82.8 82.8zM176 412c-33.7-6.9-64.4-22.2-89.7-43.7l89.7-89.7V412zm272-196c0-58.3-21.5-111.6-57-152.3L415.6 39C457 85.8 480 146.3 480 209.1v4C480 360.5 360.5 480 213.2 480h-4c-62.9 0-123.4-23-170.2-64.4L63.7 391c40.8 35.5 94 57 152.3 57 128.1 0 232-103.9 232-232zm-191.8-17.5c13.1 15.7 12.2 39.1-2.5 53.8s-38.1 15.6-53.8 2.5l56.3-56.3z"
        }
    ]
};

const FalCitrus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCitrus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 96c35.3 0 64-28.7 64-64h-64c-35.3 0-64 28.7-64 64h64zm0 32h-80c-8.8 0-16-7.2-16-16V96c0-10 1.5-19.7 4.4-28.8-11.8-2.1-24-3.2-36.4-3.2-114.9 0-208 93.1-208 208s93.1 208 208 208 208-93.1 208-208c0-44.3-13.9-85.5-37.5-119.2 10.3-3.6 20-8.5 28.9-14.5C481 176.5 496 222.5 496 272c0 132.5-107.5 240-240 240S16 404.5 16 272 123.5 32 256 32c17.8 0 35.1 1.9 51.8 5.6C325.3 14.7 353 0 384 0h80c8.8 0 16 7.2 16 16v16c0 53-43 96-96 96z"
        }
    ]
};

const FalCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 16v48h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16v80H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h133.5c4.2 11.9 10.7 22.8 19 32H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm416 176c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H288c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-64zm0-128v96h64c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H288c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h160c35.3 0 64 28.7 64 64zM320 392v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24zm32-8h32v-32h-32v32zm-8-320h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm8 64h32V96h-32v32zm-32 136v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24zm32-8h32v-32h-32v32zm152 192c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48zm8-64v32h32v-32h-32zm-32-88v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24zm32-8h32v-32h-32v32zM88 352c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88zm8-64v32h32v-32H96zm-32-88v-48c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zm32-8h32v-32H96v32z"
        }
    ]
};

const FalClapperboardPlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClapperboardPlay",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 192v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192h448zm0-32h-97.4l87.3-87.3C476.1 78.5 480 86.8 480 96v64zm-249.4 0 96-96h106.8l-96 96H230.6zm-45.3 0H78.6l96-96h106.8l-96 96zM64 64h65.4l-96 96H32V96c0-17.7 14.3-32 32-32zm448 96V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160zm-295.9 66.2c-4.9-2.9-11.1-2.9-16.1-.1s-8.1 8.1-8.1 13.9v160c0 5.7 3.1 11 8.1 13.9s11.1 2.8 16.1-.1l136-80c4.9-2.9 7.9-8.1 7.9-13.8s-3-10.9-7.9-13.8l-136-80zm96.3 93.8L224 372V268l88.4 52z"
        }
    ]
};

const FalClapperboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClapperboard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 192v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192H32zm350.6-32H480V96c0-9.2-3.9-17.5-10.1-23.3L382.6 160zm-45.3 0 96-96H326.6l-96 96h106.8zm-56-96H174.6l-96 96h106.8l96-96zm-152 0H64c-17.7 0-32 14.3-32 32v64h1.4l96-96zM512 96v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64z"
        }
    ]
};

const FalClarinet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClarinet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 112c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v32h44.6c7.9 0 15.6-2.3 22.2-6.7l55.9-37.3c7.4-4.9 16.8-5.4 24.6-1.2S640 127.1 640 136v240c0 8.9-4.9 17-12.7 21.2s-17.3 3.7-24.6-1.2l-55.9-37.3c-6.6-4.4-14.3-6.7-22.2-6.7H113.4c-8.6 0-17.1-1.3-25.3-3.7l-71-21.3C7 323.9 0 314.6 0 304v-96c0-10.6 7-19.9 17.1-23l71-21.3c8.2-2.5 16.7-3.7 25.3-3.7H256v-32h-16c-8.8 0-16-7.2-16-16zm224 16h-64v32h64v-32zm-96 0h-64v32h64v-32zm256 22.9-43.4 29c-11.8 7.9-25.7 12.1-39.9 12.1H113.4c-5.5 0-10.9.8-16.1 2.4L32 214v84l65.3 19.6a54.6 54.6 0 0 0 16.1 2.4h411.2c14.2 0 28.1 4.2 39.9 12.1l43.4 29V150.9zM272 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalClawMarks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClawMarks",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M36.7 4.7c6.2-6.2 16.4-6.2 22.6 0l111.6 111.6c13.5 13.5 21.1 31.8 21.1 50.9V192h24.8c19.1 0 37.4 7.6 50.9 21.1l95.2 95.2c13.5 13.5 21.1 31.8 21.1 50.9V384h24.8c19.1 0 37.4 7.6 50.9 21.1l79.6 79.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79.6-79.6c-7.5-7.5-17.7-11.7-28.3-11.7H368c-8.8 0-16-7.2-16-16v-40.8c0-10.6-4.2-20.8-11.7-28.3l-95.2-95.2c-7.5-7.5-17.7-11.7-28.3-11.7H176c-8.8 0-16-7.2-16-16v-40.8c0-10.6-4.2-20.8-11.7-28.3L36.7 27.3c-6.2-6.2-6.2-16.4 0-22.6zm0 224c6.2-6.2 16.4-6.2 22.6 0l81.9 81.9c12 12 18.7 28.3 18.7 45.3V384H188c17 0 33.3 6.7 45.3 18.7l81.9 81.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-81.9-81.9c-6-6-14.1-9.4-22.6-9.4H144c-8.8 0-16-7.2-16-16v-44c0-8.5-3.4-16.6-9.4-22.6l-81.9-82c-6.2-6.2-6.2-16.4 0-22.6zm246.6-224 17.9 17.9c12 12 18.7 28.3 18.7 45.3V96H348c17 0 33.3 6.7 45.3 18.7l35.9 35.9c12 12 18.7 28.3 18.7 45.3V224H476c17 0 33.3 6.7 45.3 18.7l17.9 17.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-17.9-17.9c-6-6-14.1-9.4-22.6-9.4H432c-8.8 0-16-7.2-16-16v-44c0-8.5-3.4-16.6-9.4-22.6l-35.9-35.9c-6-6-14.1-9.4-22.6-9.4H304c-8.8 0-16-7.2-16-16V67.9c0-8.5-3.4-16.6-9.4-22.6l-17.9-18c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FalClipboardCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClipboardCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112c-20.9 0-38.7 13.4-45.3 32H64c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zm128 112c17.7 0 32 14.3 32 32v304c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-16zM208 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm91.3 171.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 345.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalClipboardListCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClipboardListCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112c-20.9 0-38.7 13.4-45.3 32H64c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zm128 112c17.7 0 32 14.3 32 32v304c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-16zM208 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-36.7 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 249.4l-12.7-12.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l24 24c6.2 6.2 16.4 6.2 22.6 0l48-48zM192 272c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-32 96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm-48 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalClipboardList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClipboardList",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112c-20.9 0-38.7 13.4-45.3 32H64c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zm128 112c17.7 0 32 14.3 32 32v304c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-16zM208 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-72 192a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalClipboardMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClipboardMedical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112c-20.9 0-38.7 13.4-45.3 32H64c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zm128 112c17.7 0 32 14.3 32 32v304c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-16zM208 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-32 128c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 80v-48h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z"
        }
    ]
};

const FalClipboardPrescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClipboardPrescription",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112c-20.9 0-38.7 13.4-45.3 32H64c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zm128 112c17.7 0 32 14.3 32 32v304c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-16zM208 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-96 128c-8.8 0-16 7.2-16 16v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h41.4l48 48-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L262.6 368l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 345.4l-31.2-31.2C227.3 305.1 240 286 240 264c0-30.9-25.1-56-56-56h-72zm72 80h-56v-48h56c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
        }
    ]
};

const FalClipboardQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClipboardQuestion",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112c-20.9 0-38.7 13.4-45.3 32H64c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zm128 112c17.7 0 32 14.3 32 32v304c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-16zM208 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM104.7 233.8l-.2.7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H216c17.6 0 32 14.5 32 32.3 0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V352c0 8.8 7.2 16 16 16s16-7.2 16-16v-19.7l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2 0-35.2-28.5-64.3-64-64.3h-57.1c-25.5 0-47.7 17.2-54.2 41.8zM216 416a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalClipboardUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClipboardUser",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112c-20.9 0-38.7 13.4-45.3 32H64c-35.3 0-64 28.7-64 64v304c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zm128 112c17.7 0 32 14.3 32 32v304c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-16zM208 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 64h64c26.5 0 48 21.5 48 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FalClipboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClipboard",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c-22.3 0-41.2 15.3-46.5 36-1.8 7.1-8.2 12-15.5 12h-18c-8.8 0-16 7.2-16 16v32h192V96c0-8.8-7.2-16-16-16h-18c-7.3 0-13.7-4.9-15.5-12-5.3-20.7-24.1-36-46.5-36zm-73.3 16C131 19.8 159.2 0 192 0s61 19.8 73.3 48h6.7c20.9 0 38.7 13.4 45.3 32h2.7c35.3 0 64 28.7 64 64v304c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V144c0-35.3 28.7-64 64-64h2.7c6.6-18.6 24.4-32 45.3-32h6.7zM320 128c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-16c-17.7 0-32 14.3-32 32v304c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32v16zM192 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalClockDesk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockDesk",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224a192 192 0 1 1 384 0 192 192 0 1 1-384 0zm384 115.4V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V339.4C71.2 404.5 142.5 448 224 448s152.8-43.5 192-108.6zM0 224v224c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V224C448 100.3 347.7 0 224 0S0 100.3 0 224zM224 96c-8.8 0-16 7.2-16 16v112c0 4.2 1.7 8.3 4.7 11.3l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 217.4V112c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalClockEightThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockEightThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 0 448 0 224 224 0 1 0-448 0zm480 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM240 400V285.9l-71.1 47.4c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l96-64c4.9-3.3 11.2-3.6 16.4-.8s8.5 8.2 8.5 14.1v144c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalClockEight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockEight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm272-144v144c0 5.3-2.7 10.3-7.1 13.3l-96 64c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l88.9-59.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalClockElevenThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockElevenThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 0 448 0 224 224 0 1 0-448 0zm480 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM240 400V260.8l-61.3-92c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4l64 96c1.8 2.6 2.7 5.7 2.7 8.9V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalClockEleven = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockEleven",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm240-144v91.2l-34.7-52c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l64 96c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FalClockFiveThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockFiveThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM272 400v-91.2l34.7 52c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-64-96c-3.9-5.9-11.2-8.5-17.9-6.4s-11.4 8.3-11.4 15.3V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalClockFive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockFive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm272-144v139.2l61.3 92c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-64-96c-1.8-2.6-2.7-5.7-2.7-8.9V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalClockFourThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockFourThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM272 400V285.9l71.1 47.4c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-96-64c-4.9-3.3-11.2-3.6-16.4-.8s-8.5 8.2-8.5 14.1v144c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalClockNineThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockNineThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM272 400V256c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v128c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalClockNine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockNine",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm272-144v144c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalClockOneThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockOneThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM272 400V260.8l61.3-92c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-1.8 2.6-2.7 5.7-2.7 8.9V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalClockOne = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockOne",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm272-144v91.2l34.7-52c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2l-64 96c-3.9 5.9-11.2 8.5-17.9 6.4s-11.4-8.3-11.4-15.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalClockRotateLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockRotateLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 132V48c0-8.8-7.2-16-16-16S0 39.2 0 48v128c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H53.6C89.5 84.3 166.7 32 256 32c123.7 0 224 100.3 224 224S379.7 480 256 480c-73.3 0-138.3-35.2-179.2-89.6-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C97.9 471.8 172.2 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm224-4c-8.8 0-16 7.2-16 16v112c0 4.2 1.7 8.3 4.7 11.3l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L272 249.4V144c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalClockSevenThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockSevenThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 0 448 0 224 224 0 1 0-448 0zm480 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM240 400v-91.2l-34.7 52c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l64-96c3.9-5.9 11.2-8.5 17.9-6.4s11.4 8.3 11.4 15.3V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalClockSeven = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockSeven",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm240-144v139.2l-61.3 92c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c1.8-2.6 2.7-5.7 2.7-8.9V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FalClockSixThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockSixThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM272 400V256c0-8.8-7.2-16-16-16s-16 7.2-16 16v144c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalClockSix = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockSix",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm272-144v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalClockTenThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockTenThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zM272 400V256c0-5.3-2.7-10.3-7.1-13.3l-96-64c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l88.9 59.3V400c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalClockTen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockTen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm240-144v114.1l-71.1-47.4c-7.4-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2l96 64c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FalClockThreeThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockThreeThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 0 448 0 224 224 0 1 0-448 0zm480 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM240 400V256c0-8.8 7.2-16 16-16h112c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96v128c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalClockThree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockThree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm240-144v144c0 8.8 7.2 16 16 16h112c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FalClockTwelveThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockTwelveThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm272-112v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalClockTwelve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockTwelve",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm272-144v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalClockTwoThirty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockTwoThirty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 0 448 0 224 224 0 1 0-448 0zm480 0a256 256 0 1 1-512 0 256 256 0 1 1 512 0zM240 400V256c0-5.3 2.7-10.3 7.1-13.3l96-64c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2L272 264.6V400c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalClockTwo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClockTwo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm272-144v114.1l71.1-47.4c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2l-96 64c-4.9 3.3-11.2 3.6-16.4.8s-8.5-8.2-8.5-14.1V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zm240-144v144c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FalClone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h224c17.7 0 32-14.3 32-32v-64h32v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64v32H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32zm160-160h224c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32zm-64-32V64c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64z"
        }
    ]
};

const FalClosedCaptioningSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClosedCaptioningSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.4 480l-40.5-32H96c-17.7 0-32-14.3-32-32V135.4l-32-25.2V416c0 35.3 28.7 64 64 64h404.4zM139.6 32l40.5 32H544c17.7 0 32 14.3 32 32v280.6l32 25.3V96c0-35.3-28.7-64-64-64H139.6zm233.9 184.7c11.7-15 30-24.7 50.5-24.7 17.4 0 33.2 7 44.8 18.3 6.3 6.2 16.4 6.1 22.6-.2s6.1-16.4-.2-22.6c-17.3-17-41-27.4-67.2-27.4-30.7 0-58.1 14.4-75.6 36.9l25.1 19.8zm-222.4-12.5c-9.5 15-15.1 32.7-15.1 51.8 0 53 43 96 96 96 26.2 0 49.9-10.5 67.2-27.4.7-.6 1.2-1.3 1.8-2l-25.2-19.9C264.3 313.4 249 320 232 320c-35.3 0-64-28.7-64-64 0-11.6 3.1-22.4 8.4-31.8l-25.3-20z"
        }
    ]
};

const FalClosedCaptioning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClosedCaptioning",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 96c-35.3 0-64 28.7-64 64s28.7 64 64 64c17.4 0 33.2-7 44.8-18.3 6.3-6.2 16.4-6.1 22.6.2s6.1 16.4-.2 22.6c-17.3 17-41 27.4-67.2 27.4-53 0-96-43-96-96s43-96 96-96c26.2 0 49.9 10.5 67.2 27.4 6.3 6.2 6.4 16.3.2 22.6s-16.3 6.4-22.6.2C233.2 199 217.4 192 200 192zm192 0c-35.3 0-64 28.7-64 64s28.7 64 64 64c17.4 0 33.2-7 44.8-18.3 6.3-6.2 16.4-6.1 22.6.2s6.1 16.4-.2 22.6c-17.3 17-41 27.4-67.2 27.4-53 0-96-43-96-96s43-96 96-96c26.2 0 49.9 10.5 67.2 27.4 6.3 6.2 6.4 16.3.2 22.6s-16.3 6.4-22.6.2C425.2 199 409.4 192 392 192z"
        }
    ]
};

const FalClothesHanger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClothesHanger",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M212.2 85.8C220.4 36.3 263.2 0 313.4 0 370.1 0 416 45.9 416 102.6v8.1c0 36.1-17.6 70-47.2 90.7l-20.7 14.5 264.4 180.9c17.2 11.7 27.5 31.2 27.5 52.1 0 34.9-28.3 63.1-63.1 63.1H63.1C28.3 512 0 483.7 0 448.9c0-20.8 10.3-40.3 27.5-52.1l283.4-194 39.5-27.7c21-14.7 33.6-38.8 33.6-64.5v-8.1c0-39-31.6-70.6-70.6-70.6-34.5 0-64 25-69.7 59l-3.9 23.6c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l3.9-23.6zM320 235.4 45.6 423.2C37.1 429 32 438.6 32 448.9c0 17.2 13.9 31.1 31.1 31.1h513.8c17.2 0 31.1-13.9 31.1-31.1 0-10.3-5.1-19.9-13.6-25.7L320 235.4z"
        }
    ]
};

const FalCloudArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudArrowDown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm-43.3 267.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7V176c0-8.8 7.2-16 16-16s16 7.2 16 16v153.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80z"
        }
    ]
};

const FalCloudArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudArrowUp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm-43.3 212.7 80-80c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 214.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z"
        }
    ]
};

const FalCloudBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudBinary",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm-96 184c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-16zm40-8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16zm72-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c-8.8 0-16-7.2-16-16zm120-16h16c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-16c0-22.1 17.9-40 40-40zm-8 40v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8zM192 320c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c-8.8 0-16-7.2-16-16zm80 24c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-16zm40-8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16zm88-32h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCloudBoltMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudBoltMoon",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M387.7 101.7c7.9-27.6 28-50.1 54.2-61.6-12.8 19-20.3 41.8-20.3 66.3 0 53.9 35.9 99.2 85.1 114.2-8.2 2.2-16.7 3.4-25.6 3.4-4.2 0-8.3-.3-12.4-.8 4.9 10.2 8.3 21.2 10 32.8h2.4c34.9 0 66.7-13.8 89.9-36.1 5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-4.9.8-10 1.3-15.2 1.3-49 0-88.4-39.3-88.4-87.4 0-32.6 18-61.1 44.9-76.1 6.1-3.4 9.3-10.5 7.8-17.4S499 1 492 .4c-3.6-.3-7.3-.5-10.9-.5-54 .1-100.5 33.1-119.7 80 9.8 5.9 18.7 13.3 26.3 21.8zM112 160c0-35.3 28.7-64 64-64 29.1 0 53.7 19.4 61.4 46 1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2 26.5 0 48 21.5 48 48 0 8.8-2.3 16.9-6.4 24-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8h8.5c26.5 0 48 21.5 48 48s-21.5 48-48 48h-25c5.7 8.5 9 18.7 9 29.7 0 .8 0 1.5-.1 2.3h16c44.2 0 80-35.8 80-80 0-39.3-28.4-72.1-65.8-78.7 1.2-5.6 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4C241.4 82.6 210.9 64 176 64c-53 0-96 43-96 96v1.3C34.6 168.9 0 208.4 0 256c0 46.9 33.6 85.9 78 94.3.9-1 1.8-1.9 2.7-2.8l29.1-27.6H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.3c4.9.1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm31.7 216 85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4h-48.3zm121.9-152c-5.1 0-10.1 2-13.8 5.5L102.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7 0 11.9 9.7 21.6 21.6 21.6H167l-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5 5.1 0 10.1-2 13.8-5.5l149.1-141.2c4.3-4.1 6.7-9.7 6.7-15.7 0-11.9-9.7-21.6-21.6-21.6H249l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"
        }
    ]
};

const FalCloudBoltSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudBoltSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1l-84.7 14.1c-5.4.9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-7.2-7.9-13.4-16.7-18.4-26.2l-35.2 24.6-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8L85 217.1c3.9-5.5 3.9-12.8 0-18.4l-41.3-59.1 71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71L198.9 85c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 8.5 51c8.8-7.5 18.7-13.9 29.3-18.8l-10.5-62.4zM208 120c-48.6 0-88 39.4-88 88 0 31 16 58.2 40.1 73.9.6-12.5 2.9-24.5 6.8-35.7-9.3-10-15-23.4-15-38.1 0-30.9 25.1-56 56-56 13.2 0 25.4 4.6 35 12.3 2.4-11 6.3-21.4 11.3-31.1C240.8 124.8 225 120 208 120zm96 72c0-35.3 28.7-64 64-64 29.1 0 53.7 19.4 61.4 46 1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2 26.5 0 48 21.5 48 48 0 8.8-2.3 16.9-6.4 24-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8h8.5c26.5 0 48 21.5 48 48s-21.5 48-48 48h-16.1c-.5 11.8-4.9 23-12.4 32h28.4c44.2 0 80-35.8 80-80 0-39.3-28.4-72.1-65.8-78.7 1.2-5.6 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.9 96 368 96c-53 0-96 43-96 96v1.3c-45.4 7.6-80 47.1-80 94.7 0 42 27 77.7 64.6 90.7 1.6-10.9 6.5-21.1 14.1-29.1-27-7.6-46.7-32.3-46.7-61.6 0-35.3 28.7-64 64-64h1.3c4.9.1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm31.7 184 85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4h-48.3zm121.9-152c-5.1 0-10.1 2-13.8 5.5L294.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7 0 11.9 9.7 21.6 21.6 21.6H359l-34.9 75.5c-6.1 13.3 3.6 28.5 18.2 28.5 5.1 0 10.1-2 13.8-5.5l149.2-141.2c4.3-4.1 6.7-9.7 6.7-15.7 0-11.9-9.7-21.6-21.6-21.6H441l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"
        }
    ]
};

const FalCloudBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudBolt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72h-24v23.4c2.6 2.6 5 5.5 7.1 8.6H408c57.4 0 104-46.6 104-104 0-55.2-43-100.3-97.3-103.8-7.5-45.3-47.1-80-94.7-80-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112c0 2.6.1 5.3.3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h53.8l33.8-32H104c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm95.7 264 85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4h-48.3zm121.9-152c-5.1 0-10.1 2-13.8 5.5L150.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7 0 11.9 9.7 21.6 21.6 21.6H215l-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5 5.1 0 10.1-2 13.8-5.5l149.1-141.2c4.3-4.1 6.7-9.7 6.7-15.7 0-11.9-9.7-21.6-21.6-21.6H297l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"
        }
    ]
};

const FalCloudCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm155.3 203.3-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7 116.7-116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalCloudDrizzle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudDrizzle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112c0 2.6.1 5.3.3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104zM64 376c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40zm-288 72c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48z"
        }
    ]
};

const FalCloudExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm48 128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm-24 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalCloudFog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudFog",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 112c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H168c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8C471.2 66.7 431.6 32 384 32c-19.3 0-37.3 5.7-52.4 15.5C311.3 18.8 277.9 0 240 0c-61.9 0-112 50.1-112 112 0 2.6.1 5.3.3 7.9C90.6 135.5 64 172.6 64 216c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104zM0 400c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm64 96c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm224 0c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalCloudHailMixed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudHailMixed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112c0 2.6.1 5.3.3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104zM24 512a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM183.9 370.1c-7.7-4.4-17.4-1.7-21.8 6l-64 112c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l64-112c4.4-7.7 1.7-17.4-6-21.8zm192 0c-7.7-4.4-17.4-1.7-21.8 6l-64 112c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l64-112c4.4-7.7 1.7-17.4-6-21.8zm-282 21.8c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32zm192 0c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32zm192 0c4.4-7.7 1.7-17.4-6-21.8s-17.4-1.7-21.8 6l-18.3 32c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l18.3-32z"
        }
    ]
};

const FalCloudHail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudHail",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32c-44.2 0-80 35.8-80 80 0 5.4.5 10.6 1.5 15.7 1.7 8.3-3.5 16.5-11.7 18.6-31 8-53.9 36.2-53.9 69.7 0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72s-32.2-72-72-72c-2.2 0-4.4.1-6.6.3-4.5.4-8.9-1.1-12.2-4.1s-5.2-7.3-5.2-11.8v-.3c0-35.3-28.7-64-64-64-17.8 0-33.9 7.2-45.5 19-3.7 3.7-9 5.4-14.1 4.5s-9.6-4.3-11.8-9C235.9 51 208.2 32 176 32zm238.7 80.2C469 115.7 512 160.8 512 216c0 57.4-46.6 104-104 104H104C46.6 320 0 273.4 0 216c0-43.4 26.6-80.5 64.3-96.1-.2-2.6-.3-5.2-.3-7.9C64 50.1 114.1 0 176 0c37.9 0 71.3 18.8 91.6 47.5C282.7 37.7 300.7 32 320 32c47.6 0 87.2 34.7 94.7 80.2zM96 392a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168-72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-40 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalCloudMeatball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudMeatball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 117.6c0-47.6 36.5-84.8 80-84.8 31.7 0 59.6 19.7 72.5 48.9 2.2 4.9 6.6 8.4 11.9 9.3s10.7-.9 14.4-4.8c11.7-12.4 27.7-19.9 45.2-19.9 34.6 0 64 29.7 64 68v.3c0 4.5 1.9 8.8 5.2 11.9s7.8 4.5 12.3 4.1c2.1-.2 4.3-.3 6.5-.3 39 0 72 33.5 72 76.4s-33 76.4-72 76.4h-19.2c2.5 7.9 3.7 16.1 3.7 24.2 2.4 2.4 4.7 5 6.8 7.8h8.5c58.2 0 104-49.3 104-108.4 0-56.8-42.3-104.5-97.2-108.2-7.2-47.2-46.3-84.2-94.8-84.2-19.3 0-37.3 6-52.3 16.1C247.6 20.7 214.2.8 176 .8c-62.6 0-112 53-112 116.8 0 3 .1 6 .3 9C26.3 142.9 0 181.9 0 226.8c0 59.1 45.8 108.4 104 108.4h8.5c2.1-2.7 4.4-5.3 6.8-7.8 0-8.2 1.2-16.4 3.7-24.2h-18.9c-39 0-72-33.5-72-76.4 0-36.1 23.4-65.7 54-74 8.1-2.2 13.1-10.2 11.5-18.4-1-5.4-1.6-11-1.6-16.8zM32 400a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm352 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-272-96c0-8.8 7.2-16 16-16s16 7.2 16 16c0 .5 0 1.1-.1 1.6-.7 7 3.3 13.6 9.8 16.3s14 .8 18.5-4.6c.3-.4.7-.8 1.1-1.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-.4.4-.8.7-1.2 1.1-5.4 4.5-7.3 12-4.6 18.5s9.3 10.5 16.3 9.8c.5 0 1-.1 1.6-.1 8.8 0 16 7.2 16 16s-7.2 16-16 16c-.5 0-1.1 0-1.6-.1-7-.7-13.6 3.3-16.3 9.8s-.8 14 4.6 18.5c.4.3.8.7 1.2 1.1 6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-.4-.4-.7-.8-1.1-1.2-4.5-5.4-12-7.3-18.5-4.6s-10.5 9.3-9.8 16.3c0 .5.1 1 .1 1.6 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-.5 0-1.1.1-1.6.7-7-3.3-13.6-9.8-16.3s-14-.8-18.5 4.6c-.3.4-.7.8-1.1 1.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c.4-.4.8-.7 1.2-1.1 5.4-4.5 7.3-12 4.6-18.5s-9.3-10.5-16.3-9.8c-.5 0-1 .1-1.6.1-8.8 0-16-7.2-16-16s7.2-16 16-16c.5 0 1.1 0 1.6.1 7 .7 13.6-3.3 16.3-9.8s.8-14-4.6-18.5c-.4-.3-.8-.7-1.2-1.1-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l8.5-8.5-8.5 8.5c.4.4.7.8 1.1 1.2 4.5 5.4 12 7.3 18.5 4.6s10.5-9.3 9.8-16.3c0-.5-.1-1-.1-1.6zm144 80c0-18.4-10.4-34.4-25.5-42.4 5-16.4 1.1-35.1-11.9-48.1s-31.6-17-48.1-11.9c-8.1-15.2-24-25.5-42.4-25.5s-34.4 10.4-42.4 25.5c-16.4-5-35.1-1.1-48.1 11.9s-17 31.6-11.9 48.1c-15.2 8.1-25.5 24-25.5 42.4s10.4 34.4 25.5 42.4c-5 16.4-1.1 35.1 11.9 48.1s31.6 17 48.1 11.9c8.1 15.2 24 25.5 42.4 25.5s34.4-10.4 42.4-25.5c16.4 5 35.1 1.1 48.1-11.9s17-31.6 11.9-48.1c15.2-8.1 25.5-24 25.5-42.4z"
        }
    ]
};

const FalCloudMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudMinus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm-48 240h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalCloudMoonRain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudMoonRain",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M357.5 109.6c10.8-32.9 36.5-59.3 69.4-71-17.1 22.5-27.3 50.4-27.3 80.8 0 63.2 44.1 116.1 103.2 130.4-10.6 3.7-21.9 5.8-33.7 6.2 4.6 9.8 7.9 20.4 9.5 31.5 34-3.1 64.7-17.8 87.8-40.1 5.1-4.9 6.4-12.5 3.2-18.7s-10.1-9.7-17-8.6c-5.8 1-11.7 1.5-17.8 1.5-57.2 0-103.4-45.9-103.4-102.2 0-38.1 21.1-71.4 52.5-89 6.1-3.4 9.3-10.5 7.8-17.4S484.4 1 477.4.4c-4.1-.3-8.2-.5-12.3-.5-63.9.1-118.4 41.3-137.7 98.6 10.7 2.3 20.7 6.1 30 11.1zM88.6 418.5c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zm96 0c-7.5-4.7-17.4-2.4-22 5.1l-40 64c-4.7 7.5-2.4 17.4 5.1 22s17.4 2.4 22-5.1l40-64c4.7-7.5 2.4-17.4-5.1-22zM112 192c0-35.3 28.7-64 64-64 29.1 0 53.7 19.4 61.4 46 1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2 26.5 0 48 21.5 48 48 0 8.8-2.3 16.9-6.4 24-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8h8.5c26.5 0 48 21.5 48 48s-21.5 48-48 48H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.3c4.9.1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96v1.3C34.6 200.9 0 240.4 0 288c0 53 43 96 96 96 1.1 0 2.1 0 3.2-.1H368c44.2 0 80-35.8 80-80 0-39.3-28.4-72.1-65.8-78.7 1.2-5.6 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4C241.4 114.6 210.9 96 176 96z"
        }
    ]
};

const FalCloudMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudMoon",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M460.6 35.9c-30 32-48.4 75-48.4 122.4 0 90.8 67.6 165.8 155.1 177.2-21.5 10.8-45.8 16.9-71.5 16.9-24.6 0-47.9-5.6-68.7-15.5 17.7 11 32.1 26.8 41.3 45.6 8.9 1.3 18.1 1.9 27.4 1.9 52 0 99.1-20.7 133.6-54.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-8.1 1.4-16.5 2.1-25.1 2.1-80.7 0-146.2-65.6-146.2-146.6 0-54.8 30-102.6 74.4-127.8 6.1-3.5 9.2-10.5 7.7-17.3S519 1.3 512 .7c-5.4-.5-10.8-.7-16.3-.7C389.8 0 304 86.1 304 192.2c0 10.8.9 21.5 2.6 31.8 11.8.3 23.2 2.4 33.9 6.1-2.9-12.2-4.5-24.8-4.5-37.9 0-76.4 53.3-140.2 124.6-156.3zM112 320c0-35.3 28.7-64 64-64 29.1 0 53.7 19.4 61.4 46 1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2 26.5 0 48 21.5 48 48 0 8.8-2.3 16.9-6.4 24-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8h8.5c26.5 0 48 21.5 48 48s-21.5 48-48 48H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.3c4.9.1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96v1.3C34.6 328.9 0 368.4 0 416c0 53 43 96 96 96 1.1 0 2.1 0 3.2-.1H368c44.2 0 80-35.8 80-80 0-39.4-28.4-72.1-65.8-78.7 1.2-5.6 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4-16.9-27.8-47.4-46.4-82.3-46.4z"
        }
    ]
};

const FalCloudMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm137.1 154.8c4.3 3 6.9 7.9 6.9 13.2v128c0 .5 0 1-.1 1.5 0 .8.1 1.6.1 2.5 0 24.3-21.5 44-48 44s-48-19.7-48-44 21.5-44 48-44c5.6 0 11 .9 16 2.5v-67.4l-96 36V360c0 .5 0 1-.1 1.5 0 .8.1 1.6.1 2.5 0 24.3-21.5 44-48 44s-48-19.7-48-44 21.5-44 48-44c5.6 0 11 .9 16 2.5V248c0-6.7 4.1-12.6 10.4-15l128-48c4.9-1.8 10.4-1.2 14.7 1.8zM384 332c0-4.1-4.5-12-16-12s-16 7.9-16 12 4.5 12 16 12 16-7.9 16-12zm-128 32c0-4.1-4.5-12-16-12s-16 7.9-16 12 4.5 12 16 12 16-7.9 16-12z"
        }
    ]
};

const FalCloudPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudPlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm32 352v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalCloudQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm-39.3 169.8c6.5-24.6 28.7-41.8 54.2-41.8H344c35.5 0 64 29 64 64.3 0 24-13.4 46.2-34.9 57.2L336 300.3V320c0 8.8-7.2 16-16 16s-16-7.2-16-16v-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7 0-17.8-14.4-32.3-32-32.3h-57.1c-10.9 0-20.5 7.4-23.2 17.9l-.2.7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM296 384a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalCloudRain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudRain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112c0 2.6.1 5.3.3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104zM82.3 451.9 96 426.7l13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1v3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c0-3.2.8-6.3 2.3-9.1zm-28.1-15.3c-4.1 7.5-6.2 15.9-6.2 24.4v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9-5.6-10.5c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4.8-23.6 43.5zm188.1 15.3 13.7-25.2 13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1v3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c0-3.2.8-6.3 2.3-9.1zm-28.1-15.3c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9-5.6-10.4c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4.8-23.6 43.5zm201.8-10 13.7 25.2c1.5 2.8 2.3 5.9 2.3 9.1v3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c0-3.2.8-6.3 2.3-9.1l13.7-25.1zm-18.2-33.5-23.6 43.5c-4.1 7.5-6.2 15.8-6.2 24.3v3c0 26.5 21.5 48 48 48s48-21.5 48-48v-3c0-8.5-2.1-16.9-6.2-24.3l-23.6-43.5-.4-.8-5.4-9.9-5.6-10.4c-1.3-2.5-3.9-4-6.8-4s-5.4 1.5-6.8 4l-5.6 10.4-5.4 9.9-.4.8z"
        }
    ]
};

const FalCloudRainbow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudRainbow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M284.8 196.9C337.4 98.8 440.9 32 560 32c8.8 0 16-7.2 16-16s-7.2-16-16-16C427.8 0 313.1 74.5 255.5 183.9c7.2 4.8 13.9 10.1 20.1 16 3-1.1 6.1-2.1 9.3-3zm155.4 78.9c6 1.5 11.8 3.3 17.5 5.5 21.1-34.4 59-57.3 102.4-57.3 8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-99.6 27.1-126.8 68.2 2.7 5 5 10.3 7 15.6zM389 212.1C428.4 161 490.4 128 560 128c8.8 0 16-7.2 16-16s-7.2-16-16-16c-82.5 0-155.5 40.2-200.6 102.2 10.5 3.4 20.4 8.1 29.5 13.9zM96 304c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8-7.5-45.5-47.1-80.2-94.7-80.2-19.3 0-37.3 5.7-52.4 15.5-20.3-28.7-53.7-47.5-91.6-47.5-61.9 0-112 50.1-112 112 0 2.6.1 5.3.3 7.9C26.6 327.5 0 364.6 0 408c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104z"
        }
    ]
};

const FalCloudShowersHeavy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudShowersHeavy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112c0 2.6.1 5.3.3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104zM94.3 375.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l64-128zm120 0c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l64-128zm112 0c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l64-128zm120 0c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l64-128z"
        }
    ]
};

const FalCloudShowersWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudShowersWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176.1 99.3C178.6 61.7 209.8 32 248 32c26.4 0 49.4 14.2 62 35.4 2.3 3.8 6 6.5 10.3 7.5s8.9.1 12.5-2.4c7.7-5.3 17-8.4 27.2-8.4 23 0 42.2 16.1 46.9 37.7 1.6 7.3 8.1 12.6 15.6 12.6h18.6c21.5 0 38.9 17.4 38.9 38.9s-17.4 38.9-38.9 38.9H134.9C113.4 192 96 174.6 96 153.1s17.4-38.9 38.9-38.9h25.3c8.4 0 15.4-6.6 16-15zM248 0c-50 0-91.7 35.3-101.7 82.3h-11.4C95.7 82.3 64 114 64 153.1S95.7 224 134.9 224h306.2c39.1 0 70.9-31.7 70.9-70.9s-31.7-70.9-70.9-70.9h-6.8C422.5 52.8 393.7 32 360 32c-11.1 0-21.7 2.3-31.3 6.4C309.6 15 280.6 0 248 0zM141.3 280.9c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96zM192 480c-20.9 0-41.7-9.9-58.2-21.2-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480zm280.9-221.3c-7.4-4.9-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c4.9-7.4 2.9-17.3-4.4-22.2zm-219.6 22.2c4.9-7.4 2.9-17.3-4.4-22.2s-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96zm107.6-22.2c-7.4-4.9-17.3-2.9-22.2 4.4l-64 96c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l64-96c4.9-7.4 2.9-17.3-4.4-22.2z"
        }
    ]
};

const FalCloudShowers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudShowers",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112c0 2.6.1 5.3.3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104zM128 384c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80zm-96 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80zm192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80z"
        }
    ]
};

const FalCloudSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 352c0-49.1-27.7-91.8-68.3-113.2 2.8-9.8 4.3-20.1 4.3-30.8 0-61.9-50.1-112-112-112-17.2 0-33.5 3.9-48 10.8C384.1 61.5 331.5 32 272 32c-35.5 0-68.6 10.5-96.2 28.6l26.8 21.2C223.2 70.5 246.8 64 272 64c48.7 0 91.7 24.1 117.8 61.2 9 12.7 25.8 17.2 39.9 10.5 10.3-4.9 21.9-7.7 34.3-7.7 44.2 0 80 35.8 80 80 0 7.7-1.1 15-3 22-4.1 14.5 2.5 30 15.8 37.1 30.5 16.1 51.2 48.1 51.2 84.9 0 15.1-3.5 29.4-9.7 42.2l25.6 20.2c10.2-18.5 16.1-39.8 16.1-62.4zM101.3 164.9c-2.9 11.3-4.6 23.1-5.1 35.2C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144h356.4l-40.5-32H144c-61.9 0-112-50.1-112-112 0-48.8 31.2-90.3 74.8-105.7 12.3-4.3 20.8-15.7 21.3-28.8.2-4.9.7-9.7 1.4-14.4l-28.2-22.2z"
        }
    ]
};

const FalCloudSleet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudSleet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112c0 2.6.1 5.3.3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104zM94.3 375.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l64-128zm256 0c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l64-128zM192 368c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32zm240-16c-8.8 0-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalCloudSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudSnow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 112c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H104c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8C407.2 66.7 367.6 32 320 32c-19.3 0-37.3 5.7-52.4 15.5C247.3 18.8 213.9 0 176 0 114.1 0 64 50.1 64 112c0 2.6.1 5.3.3 7.9C26.6 135.5 0 172.6 0 216c0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104zM64 352c-8.8 0-16 7.2-16 16v32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H80v-32c0-8.8-7.2-16-16-16zm384 0c-8.8 0-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32c0-8.8-7.2-16-16-16zm-176 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32z"
        }
    ]
};

const FalCloudSunRain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudSunRain",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1l-84.7 14.1c-5.4.9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l56-39.2c-7.2-7.9-13.4-16.7-18.4-26.2l-35.2 24.6-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8L85 217.1c3.9-5.5 3.9-12.8 0-18.4l-41.3-59.1 71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71L198.9 85c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 8.5 51c8.8-7.5 18.7-13.9 29.3-18.8l-10.5-62.4zM208 120c-48.6 0-88 39.4-88 88 0 31 16 58.2 40.1 73.9.6-12.5 2.9-24.5 6.8-35.7-9.3-10-15-23.4-15-38.1 0-30.9 25.1-56 56-56 13.2 0 25.4 4.6 35 12.3 2.4-11 6.3-21.4 11.3-31.1C240.8 124.8 225 120 208 120zm87.3 297.7c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l32-64c4-7.9.7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l32-64c3.9-7.9.7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l32-64c4-7.9.7-17.5-7.2-21.5zm96 0c-7.9-4-17.5-.7-21.5 7.2l-32 64c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l32-64c4-7.9.7-17.5-7.2-21.5zM304 192c0-35.3 28.7-64 64-64 29.1 0 53.7 19.4 61.4 46 1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2 26.5 0 48 21.5 48 48 0 8.8-2.3 16.9-6.4 24-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8h8.5c26.5 0 48 21.5 48 48s-21.5 48-48 48H288c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.3c4.9.1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96v1.3c-45.4 7.6-80 47.1-80 94.7 0 53 43 96 96 96 1.1 0 2.1 0 3.2-.1H560c44.2 0 80-35.8 80-80 0-39.3-28.4-72.1-65.8-78.7 1.2-5.6 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4C433.4 114.6 402.9 96 368 96z"
        }
    ]
};

const FalCloudSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1l-84.7 14.1c-5.4.9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c3.2-20.2 11-38.9 22.5-54.8l-44.4 31.1-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4l-41.4-59.2 71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71L198.9 85c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l71 11.8-40.2 57.5c11.4-3.3 23.4-5.1 35.8-5.1 2.2 0 4.5.1 6.7.2l38.5-55c3.1-4.5 3.8-10.3 1.6-15.4s-6.7-8.7-12.1-9.6l-84.9-14.1-14.1-84.7zm-59.9 275c7.8-30.6 26.5-56.8 51.9-74.1.1-2.1.2-4.2.2-6.3 0-48.6-39.4-88-88-88s-88 39.4-88 88 39.4 88 88 88c12.8 0 24.9-2.7 35.9-7.6zM264 208a56 56 0 1 1-112 0 56 56 0 1 1 112 0zm40 112c0-35.3 28.7-64 64-64 29.1 0 53.7 19.4 61.4 46 1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2 26.5 0 48 21.5 48 48 0 8.8-2.3 16.9-6.4 24-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8h8.5c26.5 0 48 21.5 48 48s-21.5 48-48 48H288c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.3c4.9.1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96v1.3c-45.4 7.6-80 47.1-80 94.7 0 53 43 96 96 96 1.1 0 2.1 0 3.2-.1H560c44.2 0 80-35.8 80-80 0-39.4-28.4-72.1-65.8-78.7 1.2-5.6 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4-16.9-27.8-47.4-46.4-82.3-46.4z"
        }
    ]
};

const FalCloudWord = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudWord",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M429.7 135.7c10.3-4.9 21.9-7.7 34.3-7.7 44.2 0 80 35.8 80 80 0 7.7-1.1 15-3 22-4.1 14.5 2.5 30 15.8 37.1 30.5 16.1 51.2 48.1 51.2 84.9 0 53-43 96-96 96H144c-61.9 0-112-50.1-112-112 0-48.8 31.2-90.3 74.8-105.7 12.3-4.3 20.8-15.7 21.3-28.8C131.5 125 194.6 64 272 64c48.7 0 91.7 24.1 117.8 61.2 9 12.7 25.8 17.2 39.9 10.5zM416 106.8C384.1 61.5 331.5 32 272 32c-94.6 0-171.7 74.6-175.8 168.1C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-49.1-27.7-91.8-68.3-113.2 2.8-9.8 4.3-20.1 4.3-30.8 0-61.9-50.1-112-112-112-17.2 0-33.5 3.9-48 10.8zM512 368c0-8.8-7.2-16-16-16H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16zm-272-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-112-48c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm272-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FalCloudXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112h368c53 0 96-43 96-96 0-36.8-20.7-68.8-51.2-84.9-13.4-7.1-20-22.5-15.8-37.1 2-6.9 3-14.3 3-22 0-44.2-35.8-80-80-80-12.3 0-23.9 2.8-34.3 7.7a31.93 31.93 0 0 1-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8 14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112 0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128H144C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zm-27.3 180.7c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M429.7 135.7c10.3-4.9 21.9-7.7 34.3-7.7 44.2 0 80 35.8 80 80 0 7.7-1.1 15-3 22-4.1 14.5 2.5 30 15.8 37.1 30.5 16.1 51.2 48.1 51.2 84.9 0 53-43 96-96 96H144c-61.9 0-112-50.1-112-112 0-48.8 31.2-90.3 74.8-105.7 12.3-4.3 20.8-15.7 21.3-28.8C131.5 125 194.6 64 272 64c48.7 0 91.7 24.1 117.8 61.2 9 12.7 25.8 17.2 39.9 10.5zM416 106.8C384.1 61.5 331.5 32 272 32c-94.6 0-171.7 74.6-175.8 168.1C40.2 219.9 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-49.1-27.7-91.8-68.3-113.2 2.8-9.8 4.3-20.1 4.3-30.8 0-61.9-50.1-112-112-112-17.2 0-33.5 3.9-48 10.8z"
        }
    ]
};

const FalCloudsMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudsMoon",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 160c0-57.7 38-106.5 90.3-122.5-21.2 25.7-33.9 58.8-33.9 94.8 0 72.3 51.4 132.7 119.7 146.1-14.9 6.2-31.3 9.6-48.5 9.6-19.9 0-38.7-4.6-55.5-12.7 2.5 6.8 4.5 13.8 5.8 21.1 14.2 5.5 27.2 13.4 38.5 23.2 3.7.3 7.4.4 11.2.4 43.2 0 82.5-17.3 111.2-45.3 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-6.5 1.1-13.2 1.7-20 1.7-64.3 0-116.5-52.3-116.5-116.9 0-43.7 23.9-81.8 59.3-101.9 6.1-3.5 9.2-10.5 7.7-17.3S532 1.2 525.1.6c-4.5-.4-9-.6-13.5-.6C423.4 0 352 71.7 352 160c0 11.5 1.2 22.7 3.5 33.4 12.9 2 25.2 5.9 36.6 11.4-5.2-14-8-29.1-8-44.8zm-48.1 96c35.3 0 64 28.7 64 64 0 4.4-.4 8.7-1.3 12.8-1 4.8.3 9.7 3.4 13.4s7.7 5.8 12.6 5.8h1.3c35.3 0 64 28.7 64 64s-28.7 64-64 64H144c-26.5 0-48-21.5-48-48s21.5-48 48-48h8.5c5.7 0 11-3 13.9-8s2.9-11.1 0-16c-4.1-7-6.4-15.2-6.4-24 0-26.5 21.5-48 48-48 15.7 0 29.6 7.5 38.4 19.2 3.6 4.8 9.7 7.2 15.7 6.1s10.8-5.4 12.5-11.3c7.8-26.6 32.4-46 61.4-46zm96 64c0-53-43-96-96-96-34.9 0-65.4 18.6-82.2 46.4-13-9.1-28.7-14.4-45.8-14.4-44.2 0-80 35.8-80 80 0 5.9.6 11.7 1.9 17.2C92.4 359.9 64 392.6 64 432c0 44.2 35.8 80 80 80h268.7c1.1 0 2.1.1 3.2.1 53 0 96-43 96-96 0-47.6-34.6-87-80-94.7v-1.3zM320 192.1c0-35.3-28.6-64-64-64-7.4 0-14.6 1.3-21.2 3.6-11.5-30.1-40.6-51.6-74.8-51.6-38.9 0-71.3 27.8-78.5 64.6-3.1-.4-6.3-.6-9.5-.6-39.8 0-72 32.2-72 72s32.2 72 72 72h34.8c5.7-12 13.4-22.8 22.8-32H72.1c-22.1 0-40-17.9-40-40s17.9-40 40-40c1.8 0 3.6.1 5.3.3 16.8 2.2 32.3-9 35.6-25.6 4.3-22.1 23.8-38.7 47.1-38.7 20.4 0 38 12.8 44.9 30.9 6.2 16.2 24.1 24.6 40.5 18.8 3.3-1.1 6.8-1.8 10.6-1.8 17.7 0 32 14.3 32 32v.9c0 2.9-.3 5.8-.7 8.6 10.3-4.2 21.3-7.2 32.7-8.6v-.9z"
        }
    ]
};

const FalCloudsSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCloudsSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M303.8 13.4c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1l-84.7 14.1c-5.4.9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l24.4-17c3.2-20.2 11-38.9 22.5-54.8l-44.4 31.1-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8 41.4-59.2c3.9-5.5 3.9-12.8 0-18.4l-41.4-59.2 71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71L198.9 85c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l10.4 1.7c9.9-11.5 22.5-20.6 36.8-26.3L318 98.1l-14.2-84.7zm-12.2 203.8c-2.1-7.9-3.3-16.3-3.3-24.9 0-5.7.5-11.3 1.5-16.7C276.9 143 245.2 120 208 120c-48.6 0-88 39.4-88 88s39.4 88 88 88c12.8 0 24.9-2.7 35.9-7.6 7.3-28.9 24.5-53.9 47.7-71.1zM264 208a56 56 0 1 1-112 0 56 56 0 1 1 112 0zm309.9 47.6c8.2 8 15.2 17.2 20.7 27.4 26.6-10.6 45.4-36.5 45.4-66.9 0-39.8-32.2-72-72-72-3.2 0-6.4.2-9.5.6-7.1-36.8-39.5-64.6-78.5-64.6-34.2 0-63.3 21.4-74.8 51.6-6.6-2.3-13.8-3.6-21.2-3.6-35.3 0-64 28.6-64 64 0 3 .2 6 .6 8.9 9.9-3.9 20.4-6.7 31.4-8v-.9c0-17.7 14.3-32 32-32 3.8 0 7.3.6 10.6 1.8 16.4 5.7 34.3-2.6 40.5-18.8 6.9-18.1 24.4-30.9 44.9-30.9 23.3 0 42.8 16.7 47.1 38.7 3.2 16.6 18.8 27.8 35.6 25.6 1.7-.2 3.5-.3 5.3-.3 22.1 0 40 17.9 40 40 0 20.1-14.8 36.7-34.1 39.5zM304 320c0-35.3 28.7-64 64-64 29.1 0 53.7 19.4 61.4 46 1.7 5.8 6.5 10.2 12.5 11.3s12-1.3 15.7-6.1c8.8-11.7 22.7-19.2 38.4-19.2 26.5 0 48 21.5 48 48 0 8.8-2.3 16.9-6.4 24-2.9 5-2.9 11.1 0 16s8.1 8 13.9 8h8.5c26.5 0 48 21.5 48 48s-21.5 48-48 48H288c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.3c4.9.1 9.5-2 12.6-5.8s4.4-8.7 3.4-13.4c-.8-4.1-1.3-8.4-1.3-12.8zm64-96c-53 0-96 43-96 96v1.3c-45.4 7.6-80 47.1-80 94.7 0 53 43 96 96 96 1.1 0 2.1 0 3.2-.1H560c44.2 0 80-35.8 80-80 0-39.4-28.4-72.1-65.8-78.7 1.2-5.6 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-17 0-32.8 5.3-45.8 14.4-16.9-27.8-47.4-46.4-82.3-46.4z"
        }
    ]
};

const FalClouds = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClouds",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32c39.9 0 73 29.2 79 67.4.9 5.6 4.7 10.3 9.9 12.4s11.2 1.2 15.7-2.3C323.5 101 337.1 96 352 96c35.3 0 64 28.7 64 64 0 14.7-5 28.3-13.3 39.1l.9.8c12.2-4.5 25.3-7.2 39-7.8 3.6-10 5.5-20.8 5.5-32.1 0-53-43-96-96-96-14 0-27.2 3-39.2 8.4C296.8 30.1 255.9 0 208 0 151.6 0 104.9 41.7 97.1 96H96c-53 0-96 43-96 96s43 96 96 96h64.9c1.2-11.1 3.7-21.8 7.3-32H96c-35.3 0-64-28.7-64-64s28.7-64 64-64c4.4 0 8.7.4 12.8 1.3 4.8 1 9.7-.3 13.4-3.4s5.9-7.7 5.8-12.6V112c0-44.2 35.8-80 80-80zm16 272c0-44.2 35.8-80 80-80 32.2 0 59.9 19 72.6 46.4 2.2 4.8 6.6 8.1 11.8 9s10.4-.8 14.1-4.5c11.6-11.7 27.7-19 45.5-19 35.3 0 64 28.7 64 64v.3c0 4.5 1.9 8.8 5.2 11.8s7.8 4.5 12.2 4.1c2.2-.2 4.3-.3 6.6-.3 39.8 0 72 32.2 72 72s-32.2 72-72 72H232c-39.8 0-72-32.2-72-72 0-33.5 22.9-61.7 53.9-69.7 8.2-2.1 13.3-10.3 11.7-18.6-1-5.1-1.5-10.3-1.5-15.7zm416 104c0-55.2-43-100.3-97.3-103.8-7.5-45.5-47.1-80.2-94.7-80.2-19.3 0-37.3 5.7-52.4 15.5-20.3-28.7-53.7-47.5-91.6-47.5-61.9 0-112 50.1-112 112 0 2.6.1 5.3.3 7.9-37.7 15.6-64.3 52.7-64.3 96.1 0 57.4 46.6 104 104 104h304c57.4 0 104-46.6 104-104z"
        }
    ]
};

const FalClover = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClover",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 64c-17.1 0-31 13.9-31 31v3.3c0 7.9 2 15.7 5.8 22.6l43.9 79.4c3.4 6.2 2.4 14-2.7 19.1s-12.8 6.1-19.1 2.7l-79.3-44c-6.9-3.8-14.7-5.8-22.6-5.8H63c-17.1 0-31 13.9-31 31 0 8.2 3.3 16.1 9.1 21.9l19.5 19.5c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3l-19.5 19.5c-5.8 5.8-9.1 13.7-9.1 21.9 0 17.1 13.9 31 31 31h3.3c7.9 0 15.7-2 22.6-5.8l79.4-43.9c6.2-3.4 14-2.4 19.1 2.7s6.1 12.8 2.7 19.1l-43.9 79.4c-3.8 6.9-5.8 14.7-5.8 22.6v3.2c0 17.1 13.9 31 31 31 8.2 0 16.1-3.3 21.9-9.1l19.5-19.5c3-3 7.1-4.7 11.3-4.7s8.3 1.7 11.3 4.7l19.5 19.5c5.8 5.8 13.7 9.1 21.9 9.1 17.1 0 31-13.9 31-31v-3.3c0-7.9-2-15.7-5.8-22.6l-44-79.4c-3.4-6.2-2.4-14 2.7-19.1s12.8-6.1 19.1-2.7l79.4 43.9c6.9 3.8 14.7 5.8 22.6 5.8h3.2c17.1 0 31-13.9 31-31 0-8.2-3.3-16.1-9.1-21.9l-19.5-19.5c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l19.5-19.5c5.8-5.8 9.1-13.7 9.1-21.9 0-17.1-13.9-31-31-31h-3.1c-8 0-15.8 2-22.8 5.9L281 222c-6.2 3.5-14 2.4-19-2.6s-6.2-12.7-2.9-19l42.9-79.5c3.7-6.9 5.7-14.6 5.7-22.4V95c0-17.1-13.9-31-31-31-8.2 0-16.1 3.3-21.9 9.1l-19.5 19.4c-3 3-7.1 4.7-11.3 4.7s-8.3-1.7-11.3-4.7l-19.5-19.4c-5.8-5.8-13.7-9.1-21.9-9.1zm-63 31c0-34.8 28.2-63 63-63 16.7 0 32.7 6.6 44.5 18.5l8.2 8.2 8.2-8.2C244 38.6 260 32 276.7 32c34.8 0 63 28.2 63 63v3.5c0 13.1-3.3 26-9.5 37.6l-16.7 31 30-16.8c11.7-6.6 25-10 38.4-10h3.1c34.8 0 63 28.2 63 63 0 16.7-6.6 32.7-18.5 44.5l-8.2 8.2 8.2 8.2C441.4 276 448 292 448 308.7c0 34.8-28.2 63-63 63h-3.3c-13.3 0-26.5-3.4-38.1-9.8l-30.8-17 17 30.8c6.5 11.7 9.8 24.8 9.8 38.1v3.2c0 34.8-28.2 63-63 63-16.7 0-32.7-6.6-44.5-18.5l-8.2-8.2-8.2 8.2C204 473.4 188 480 171.3 480c-34.8 0-63-28.2-63-63v-3.3c0-13.3 3.4-26.5 9.8-38.1l17-30.8-30.8 17c-11.7 6.5-24.8 9.8-38.1 9.8H63c-34.8 0-63-28.2-63-63C0 292 6.6 276 18.5 264.2l8.2-8.2-8.2-8.2C6.6 236 0 220 0 203.3c0-34.8 28.2-63 63-63h3.3c13.3 0 26.5 3.4 38.1 9.8l30.8 17-17-30.8c-6.5-11.7-9.8-24.8-9.8-38.1V95z"
        }
    ]
};

const FalClub = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalClub",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M358.3 154.9c1.1-6.1 1.7-12.4 1.7-18.9 0-57.4-46.6-104-104-104S152 78.6 152 136c0 6.5.6 12.8 1.7 18.9 1.6 8.8-.5 17.9-5.9 25s-13.5 11.7-22.4 12.6C73 197.8 32 242.1 32 296c0 57.4 46.6 104 104 104 39.7 0 74.2-22.2 91.8-55 5.6-10.4 16.4-16.9 28.2-16.9s22.6 6.5 28.2 16.9c17.6 32.8 52.1 55 91.8 55 57.4 0 104-46.6 104-104 0-53.9-41-98.2-93.4-103.5-8.9-.9-17-5.5-22.4-12.6s-7.5-16.2-5.9-25zm31.5 5.8c7.4.7 14.7 2.1 21.7 4C469.4 180.3 512 233.1 512 296c0 75.1-60.9 136-136 136-39.4 0-74.9-16.8-99.7-43.5-1.5-1.6-2.9-3.2-4.3-4.8V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-96.4c-1.4 1.6-2.8 3.3-4.3 4.8-24.8 26.8-60.3 43.6-99.7 43.6C60.9 432 0 371.1 0 296c0-62.9 42.6-115.8 100.6-131.3 7-1.9 14.3-3.2 21.7-4-1.3-7.1-2.1-14.5-2.2-22V136C120 60.9 180.9 0 256 0s136 60.9 136 136v2.7c-.1 7.5-.9 14.8-2.2 22z"
        }
    ]
};

const FalCoconut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoconut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.5 40c45.4-14 79.7-8.9 98.6 9.9s23.9 53.2 9.9 98.6C367.2 193 336 244 290 290s-97 77.2-141.6 91c-45.4 14-79.7 8.9-98.6-9.9S26 317.9 40 272.5c13.8-44.6 45-95.6 91-141.6s97-77.2 141.6-91zm121.2-12.8C362.4-4.1 312.8-5.9 263.1 9.4c-50.5 15.6-105.8 50-154.8 98.9S25 212.6 9.4 263.1c-15.3 49.7-13.5 99.3 17.8 130.6l42.4 42.4A259.15 259.15 0 0 0 252.9 512C396 512 512 396 512 252.9c0-68.7-27.3-134.6-75.9-183.2l-42.4-42.5zm27.3 72.9c37.9 41.7 59 96.1 59 152.8 0 4.1-.1 8.2-.3 12.2l-20.4-20.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l37.4 37.4c-8.5 36.5-25.9 69.7-49.7 97.1l-45.1-45.1c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l45.1 45.1c-27.4 23.8-60.5 41.1-97.1 49.7l-37.4-37.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.3 20.4c-4 .2-8.1.3-12.2.3-56.6 0-111-21.1-152.8-59 18.5.1 38.1-3.3 57.8-9.4 50.5-15.6 105.8-50 154.8-98.9s83.4-104.3 98.9-154.8c6.1-19.7 9.4-39.3 9.4-57.8zm-102.7 3.2c3.5 3.5 9.6 17-1.7 48.8-10.4 29.4-32.9 64.9-66.2 98.2s-68.9 55.9-98.2 66.2c-31.8 11.2-45.4 5.1-48.8 1.7s-9.6-17 1.7-48.8c10.4-29.4 32.9-64.9 66.2-98.2s68.9-55.9 98.2-66.2c31.8-11.2 45.4-5.1 48.8-1.7zm22.6-22.6c-34.4-34.4-120.5-4-192.3 67.9s-102.2 158-67.9 192.3 120.5 4 192.3-67.9 102.2-158 67.9-192.3z"
        }
    ]
};

const FalCodeBranch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCodeBranch",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4v115.2c20.3-20.7 48.7-33.6 80-33.6h96c44.2 0 80-35.8 80-80v-1.6c-36.5-7.4-64-39.7-64-78.4 0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4v1.6c0 61.9-50.1 112-112 112h-96c-44.2 0-80 35.8-80 80v1.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80S0 476.2 0 432c0-38.7 27.5-71 64-78.4V158.4C27.5 151 0 118.7 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80zm208 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalCodeCommit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCodeCommit",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 352a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm127-80c-7.9 63.1-61.7 112-127 112s-119.1-48.9-127-112H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h177c7.9-63.1 61.7-112 127-112s119.1 48.9 127 112h177c8.8 0 16 7.2 16 16s-7.2 16-16 16H447z"
        }
    ]
};

const FalCodeCompare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCodeCompare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M322.8 484.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1s5.5 16.7-1.1 22.6l-57.4 52H336c44.2 0 80-35.8 80-80V158.4c-36.5-7.4-64-39.7-64-78.4 0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4V320c0 61.9-50.1 112-112 112h-70.6l57.4 52.2zM384 80a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM189.2 27.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1l88 80c3.3 3 5.2 7.3 5.2 11.8s-1.9 8.8-5.2 11.8l-88 80c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6l57.4-52H176c-44.2 0-80 35.8-80 80v161.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80S0 476.2 0 432c0-38.7 27.5-71 64-78.4V192c0-61.9 50.1-112 112-112h70.6l-57.4-52.2zM128 432a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FalCodeFork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCodeFork",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4V192c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-33.6c-36.5-7.4-64-39.7-64-78.4 0-44.2 35.8-80 80-80s80 35.8 80 80c0 38.7-27.5 71-64 78.4V192c0 44.2-35.8 80-80 80h-64v81.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V272h-64c-44.2 0-80-35.8-80-80v-33.6C27.5 151 0 118.7 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80zm64 304a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM416 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FalCodeMerge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCodeMerge",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16.9 126.2C133 150.5 160 118.4 160 80c0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4v195.2C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4V234.5c26.4 32.6 66.8 53.5 112 53.5h81.6c7.4 36.5 39.7 64 78.4 64 44.2 0 80-35.8 80-80s-35.8-80-80-80c-38.7 0-71 27.5-78.4 64H208c-57 0-104.1-42.6-111.1-97.8zM416 272a48 48 0 1 1-96 0 48 48 0 1 1 96 0zM128 432a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FalCodePullRequestClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCodePullRequestClosed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm32 0c0 38.7-27.5 71-64 78.4v195.2c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V158.4C59.5 151 32 118.7 32 80c0-44.2 35.8-80 80-80s80 35.8 80 80zM64 432a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm336 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16-126.4V208c0-8.8 7.2-16 16-16s16 7.2 16 16v145.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4zM332.7 12.7c6.2-6.2 16.4-6.2 22.6 0L400 57.4l44.7-44.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L422.6 80l44.7 44.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L400 102.6l-44.7 44.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L377.4 80l-44.7-44.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalCodePullRequestDraft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCodePullRequestDraft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm64 78.4c36.5-7.4 64-39.7 64-78.4 0-44.2-35.8-80-80-80S0 35.8 0 80c0 38.7 27.5 71 64 78.4v195.2C27.5 361 0 393.3 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-38.7-27.5-71-64-78.4V158.4zM32 432a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm32-448a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalCodePullRequest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCodePullRequest",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M323.8 5.2c5.9 6.5 5.5 16.7-1.1 22.6L265.4 80H336c61.9 0 112 50.1 112 112v161.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V192c0-44.2-35.8-80-80-80h-70.6l57.4 52.2c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-88-80c-3.3-3-5.2-7.3-5.2-11.8s1.9-8.8 5.2-11.8l88-80c6.5-5.9 16.7-5.5 22.6 1.1zM432 384a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM128 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-32 78.4v195.2c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80S0 476.2 0 432c0-38.7 27.5-71 64-78.4V158.4C27.5 151 0 118.7 0 80 0 35.8 35.8 0 80 0s80 35.8 80 80c0 38.7-27.5 71-64 78.4zM128 432a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FalCodeSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCodeSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 256 203.3 91.3zm169.4 0L537.4 256 372.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"
        }
    ]
};

const FalCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCode",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M405.1.8c-8.4-2.8-17.4 1.7-20.2 10.1l-160 480c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l160-480c2.8-8.4-1.7-17.4-10.1-20.2zM172 117.4c-5.9-6.6-16-7.2-22.6-1.3l-144 128C2 247.1 0 251.4 0 256s2 8.9 5.4 12l144 128c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6L40.1 256l130.5-116c6.6-5.9 7.2-16 1.3-22.6zm296.1 0c-5.9 6.6-5.3 16.7 1.3 22.6l130.5 116-130.5 116c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128c-6.6-5.9-16.7-5.3-22.6 1.3z"
        }
    ]
};

const FalCoffeeBean = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoffeeBean",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M388.3 108.6c21.2 27.9 29.6 65.9 23.5 108.9-7 49.3-33.2 102.9-78.3 148s-98.7 71.3-148 78.3c-40.4 5.8-76.5-1.4-103.8-19.8.1-.1.1-.3.2-.4 16.5-34.5 37.5-72.2 57.4-92.3 29.7-29.9 59.7-44.9 91.8-61l.5-.3c32-15.9 66.1-32.9 99.7-66.8 22.8-22.9 42.6-61.6 56.9-94.7zm-24.7-23.8c-.6 1.4-1.2 2.9-1.8 4.4-14.5 34.5-33.5 71.8-53.1 91.5-29.7 29.9-59.7 44.9-91.8 61l-.5.3c-32 15.9-66.1 32.9-99.7 66.8-22.2 22.4-43.4 59.9-59.5 92.6-22.6-28.1-31.8-67.1-25.5-111.4 7-49.3 33.2-102.9 78.3-148s98.7-71.3 148-78.3c41.4-5.9 78.1 1.7 105.7 21.1zM390 64.7C313.6 2.4 181.6 25 87.3 119.3c-98.9 98.9-119 239.2-44.9 313.5l.1.1C50 440.4 58.3 447 67 452.6c.4.3.8.5 1.2.8C146 502 267.6 476.6 356 388.1c99-99 119-239.4 44.8-313.6-3.5-3.5-7.1-6.8-10.9-9.8z"
        }
    ]
};

const FalCoffeeBeans = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoffeeBeans",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M476.8 258c50-50 39.9-141.2-22.6-203.6S300.5-18.2 250.5 31.8 210.6 173 273.1 235.4 426.8 308 476.8 258zm-22.6-22.6c-33 33-103.4 32.3-158.4-22.6-40.6-40.6-51.6-89.6-41.3-125.8 3.9 6.2 8 12 12.3 17.1 27.7 32.7 61.1 44.7 90.6 55.2l1 .3c30.1 10.8 56.2 20.4 78.2 46.3 6.4 7.5 12.6 17.8 18.4 28.7l-.7.7zm6.3-49.7c-27.7-32.7-61.1-44.7-90.6-55.2l-1-.3c-30.1-10.8-56.2-20.4-78.2-46.3-6.4-7.5-12.6-17.8-18.4-28.7l.7-.7c33-33 103.4-32.3 158.4 22.6 40.6 40.6 51.6 89.6 41.3 125.8-3.9-6.2-8-12-12.3-17.1zM128 480c-46.7 0-96-50.3-96-128 0-57.4 26.9-99.8 59.8-118.1-1.6 7.1-2.8 14.2-3.4 20.8-3.6 42.7 11.6 74.8 25 103.1l.4.9c13.7 28.9 25.4 54.2 22.5 88-.8 9.8-3.6 21.5-7.3 33.3h-1zm39.6-30.7c3.6-42.7-11.6-74.8-25-103.1l-.4-.9c-13.7-28.9-25.4-54.2-22.5-88 .8-9.8 3.6-21.5 7.3-33.3h1c46.7 0 96 50.3 96 128 0 57.4-26.9 99.8-59.8 118.1 1.6-7.1 2.8-14.2 3.4-20.8zM128 512c70.7 0 128-71.6 128-160s-57.3-160-128-160S0 263.6 0 352s57.3 160 128 160z"
        }
    ]
};

const FalCoffeePot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoffeePot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 64c-26.5 0-48 21.5-48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-44.2 35.8-80 80-80h373.6c14.6 0 26.4 11.8 26.4 26.4 0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9v8c0 55.5-34.6 99.4-55.9 121.2-9.9 10.1-23.8 14.8-38.1 14.8H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344v-8c0-65.4 32.7-123.2 82.7-157.9l-48.4-109c-.7-1.6-1.3-3.4-1.7-5.1H80zm365 0H131l49.8 112h214.4L445 64zm-29 144H160c-26.4 19.9-46.5 47.7-56.7 80h369.4c-10.1-32.3-30.2-60.1-56.7-80zm63.2 112H96.8c-.5 5.3-.8 10.6-.8 16v8c0 42.6 27.2 78.8 46.8 98.8 2.7 2.8 7.7 5.2 15.2 5.2h260c7.5 0 12.5-2.4 15.2-5.2 19.6-20 46.8-56.2 46.8-98.8v-8c0-5.4-.3-10.7-.8-16z"
        }
    ]
};

const FalCoffinCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoffinCross",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M35.6 136c-2.3 2.6-3.6 6-3.6 9.5 0 1.4.2 2.7.6 4L128.1 480H256l95.5-330.6c.4-1.3.6-2.6.6-4 0-3.5-1.3-6.9-3.6-9.5l-91-104h-131l-91 104zm-24.1-21.1 91-104c6-6.9 14.8-10.9 24-10.9h131c9.2 0 18 4 24.1 10.9l91 104c7.4 8.5 11.5 19.3 11.5 30.6 0 4.4-.6 8.7-1.8 12.9l-95.6 330.5c-4 13.7-16.5 23.1-30.7 23.1H128.1c-14.3 0-26.8-9.4-30.7-23.1L1.8 158.3C.6 154.1 0 149.8 0 145.4c0-11.2 4.1-22.1 11.5-30.6zM208 112v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V208h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalCoffin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoffin",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M126.5 32h131l91 104c2.3 2.6 3.6 6 3.6 9.5 0 1.4-.2 2.7-.6 4L255.9 480H128L32.6 149.4c-.4-1.3-.6-2.6-.6-4 0-3.5 1.3-6.9 3.6-9.5l91-104zm-24.1-21.1-91 104a46.668 46.668 0 0 0-9.6 43.4l95.5 330.6c4 13.7 16.5 23.1 30.7 23.1h127.9c14.3 0 26.8-9.4 30.7-23.1l95.5-330.6c1.2-4.2 1.8-8.5 1.8-12.9 0-11.2-4.1-22.1-11.5-30.6l-91-104C275.5 4 266.7 0 257.5 0h-131c-9.2 0-18 4-24.1 10.9z"
        }
    ]
};

const FalCoinBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoinBlank",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M90.7 281.9C49 258.5 32 231.1 32 208s17-50.5 58.7-73.9C131.4 111.2 189.8 96 256 96s124.6 15.2 165.3 38.1C463 157.5 480 184.9 480 208s-17 50.5-58.7 73.9C380.6 304.8 322.2 320 256 320s-124.6-15.2-165.3-38.1zM240 351.7v64c-22.5-.7-44-3-64-6.6v-64.3c20.3 3.8 41.8 6.1 64 6.9zM96 320.4c14.8 6.7 30.8 12.4 48 17.1v64.6c-17.7-4.7-33.8-10.5-48-17v-64.7zm-32-17.2v63.6c-23.5-16.9-32-34-32-46.8v-42.2c9 9.2 19.8 17.7 32 25.5zm208 112.5v-64c22.2-.8 43.7-3.1 64-6.9v64.3c-20 3.6-41.5 5.8-64 6.6zm176-112.5c12.2-7.8 23-16.3 32-25.5v42.2c0 12.9-8.5 29.9-32 46.8v-63.6zm-32 17.2v64.7c-14.2 6.5-30.3 12.3-48 17v-64.6c17.2-4.7 33.2-10.5 48-17.1zM256 64C114.6 64 0 128.5 0 208v112c0 70.7 114.6 128 256 128s256-57.3 256-128V208c0-79.5-114.6-144-256-144z"
        }
    ]
};

const FalCoinFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoinFront",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-416a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 352a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm16-272c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
        }
    ]
};

const FalCoinVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoinVertical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 256c0-66.2-15.2-124.6-38.1-165.3C194.5 49 167.1 32 144 32S93.5 49 70.1 90.7C47.2 131.4 32 189.8 32 256s15.2 124.6 38.1 165.3C93.5 463 120.9 480 144 480s50.5-17 73.9-58.7C240.8 380.6 256 322.2 256 256zm24.8 80h64.3c3.6-20 5.8-41.5 6.6-64h-64c-.8 22.2-3.1 43.7-6.9 64zm-7.3 32c-4.7 17.2-10.5 33.2-17.1 48h64.7c6.5-14.2 12.3-30.3 17-48h-64.6zm-59.7 112H256c12.8 0 29.9-8.5 46.8-32h-63.6c-7.8 12.2-16.3 23-25.5 32zm74-240h64c-.7-22.5-3-44-6.6-64h-64.4c3.8 20.3 6.1 41.8 6.9 64zm-74-208c9.2 9 17.7 19.8 25.5 32h63.6c-16.9-23.5-34-32-46.8-32h-42.3zm59.8 112h64.6c-4.7-17.7-10.5-33.8-17-48h-64.8c6.7 14.8 12.4 30.8 17.1 48zM144 512C64.5 512 0 397.4 0 256S64.5 0 144 0h112c70.7 0 128 114.6 128 256s-57.3 256-128 256H144zM88 256c0 47.1 7.4 89.1 18.8 118.7 5.7 14.8 12.2 25.8 18.5 32.7 6.3 6.9 11.3 8.6 14.7 8.6s8.3-1.7 14.7-8.6c6.3-6.9 12.8-17.8 18.5-32.7C184.6 345.1 192 303.1 192 256s-7.4-89.1-18.8-118.7c-5.7-14.8-12.2-25.8-18.5-32.7-6.4-6.9-11.3-8.6-14.7-8.6s-8.3 1.7-14.7 8.6c-6.3 6.9-12.8 17.8-18.5 32.7C95.4 166.9 88 208.9 88 256zm52-192c15.4 0 28.3 8.2 38.3 19 9.9 10.9 18.2 25.7 24.7 42.7 13.2 34.1 21 80.2 21 130.2s-7.8 96.1-21 130.2c-6.6 17-14.8 31.9-24.7 42.7-9.9 10.9-22.9 19-38.3 19s-28.3-8.2-38.3-19c-9.9-10.9-18.2-25.7-24.7-42.7-13.2-34-21-80-21-130.1s7.8-96.1 21-130.2c6.6-17 14.8-31.9 24.7-42.7 9.9-10.9 22.9-19 38.3-19z"
        }
    ]
};

const FalCoin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 320c66.2 0 124.6-15.2 165.3-38.1C463 258.5 480 231.1 480 208s-17-50.5-58.7-73.9C380.6 111.2 322.2 96 256 96s-124.6 15.2-165.3 38.1C49 157.5 32 184.9 32 208s17 50.5 58.7 73.9C131.4 304.8 189.8 320 256 320zm-80 24.8v64.3c20 3.6 41.5 5.8 64 6.6v-64c-22.2-.8-43.7-3.1-64-6.9zm-32-7.3c-17.2-4.7-33.2-10.5-48-17.1v64.7c14.2 6.5 30.3 12.3 48 17v-64.6zM32 277.8V320c0 12.9 8.5 29.9 32 46.8v-63.6c-12.2-7.8-23-16.3-32-25.5zm240 74v64c22.5-.7 44-3 64-6.6v-64.3c-20.3 3.8-41.8 6.1-64 6.9zm208-74c-9 9.2-19.8 17.7-32 25.5v63.6c23.5-16.9 32-34 32-46.8v-42.2zm-112 59.7v64.6c17.7-4.7 33.8-10.5 48-17v-64.7c-14.8 6.7-30.8 12.4-48 17.1zM0 208C0 128.5 114.6 64 256 64s256 64.5 256 144v112c0 70.7-114.6 128-256 128S0 390.7 0 320V208zm256-56c-47.1 0-89.1 7.4-118.7 18.8-14.8 5.7-25.8 12.2-32.7 18.5-6.9 6.4-8.6 11.3-8.6 14.7s1.7 8.3 8.6 14.7c6.9 6.3 17.8 12.8 32.7 18.5C166.9 248.6 208.9 256 256 256s89.1-7.4 118.7-18.8c14.8-5.7 25.8-12.2 32.7-18.5 6.9-6.3 8.6-11.3 8.6-14.7s-1.7-8.3-8.6-14.7c-6.9-6.3-17.8-12.8-32.7-18.5C345.1 159.4 303.1 152 256 152zm192 52c0 15.4-8.2 28.3-19 38.3-10.9 9.9-25.7 18.2-42.7 24.7-34.1 13.2-80.2 21-130.2 21s-96.1-7.8-130.2-21c-17-6.6-31.9-14.8-42.7-24.7-10.9-9.9-19-22.9-19-38.3s8.2-28.3 19-38.3c10.9-9.9 25.7-18.2 42.7-24.7 34.1-13.2 80.2-21 130.2-21s96.1 7.8 130.2 21c17 6.6 31.9 14.8 42.7 24.7 10.9 9.9 19 22.9 19 38.3z"
        }
    ]
};

const FalCoins = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCoins",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80c0 2.4 1.3 6.8 8.3 12.8 1.4 1.2 2.9 2.4 4.6 3.6-15.4.6-30.4 1.9-44.9 3.9V80c0-15.3 8.6-27.7 19.4-37 10.9-9.4 25.7-17.1 42.7-23.2C224.1 7.3 270 0 320 0s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2C503.4 52.3 512 64.7 512 80v217.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4c-10.4 3.9-21.8 7.4-34.1 10.3v-33c8.2-2.2 15.8-4.6 22.8-7.2 14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2v-66.3c-8.7 5.6-18.8 10.5-29.9 14.7-10.4 3.9-21.8 7.4-34.1 10.3v-33c8.2-2.2 15.8-4.6 22.8-7.2 14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2v-58c-8.8 5.4-19 10.1-30.1 14.1-17.3 6.3-37.6 11.3-60 14.6-1.9-1.9-3.8-3.8-5.7-5.5-10.1-9.1-21.7-16.4-33.8-22.5 34.8-2.3 65.4-8.4 88.5-16.8 14.9-5.4 25.8-11.5 32.8-17.4 7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C409.3 39 367.2 32 320 32s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4-7 6-8.3 10.4-8.3 12.8zM32 208c0 2.4 1.3 6.8 8.3 12.8 6.9 5.9 17.8 12 32.8 17.4C102.7 249 144.8 256 192 256s89.3-7 119-17.8c14.9-5.4 25.8-11.5 32.8-17.4 7-6 8.3-10.4 8.3-12.8s-1.3-6.8-8.3-12.8c-6.9-5.9-17.8-12-32.8-17.4C281.3 167 239.2 160 192 160s-89.3 7-119 17.8c-14.9 5.4-25.8 11.5-32.8 17.4-7 6-8.3 10.4-8.3 12.8zm-32 0c0-15.3 8.6-27.7 19.4-37 10.9-9.4 25.7-17.1 42.7-23.2C96.1 135.3 142 128 192 128s95.9 7.3 129.9 19.7c16.9 6.2 31.8 13.9 42.7 23.2 10.9 9.3 19.4 21.8 19.4 37v217.9c0 15.4-8.2 28.2-19.1 38s-25.7 17.9-42.7 24.4C288.1 501.3 242 509 192 509s-96.1-7.7-130.1-20.7c-17-6.5-31.8-14.6-42.7-24.4S0 441.3 0 425.9V208zm352 46.1c-8.8 5.4-19 10.1-30.1 14.1C287.9 280.7 242 288 192 288s-95.9-7.3-129.9-19.7c-11.1-4-21.3-8.7-30.1-14.1V312c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 355.7 144.8 363 192 363s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2v-57.9zM32 425.9c0 3.1 1.6 8 8.5 14.2s17.8 12.6 32.7 18.2C102.9 469.6 144.8 477 192 477s89.1-7.3 118.8-18.6c14.9-5.7 25.8-12 32.7-18.2s8.5-11.1 8.5-14.2v-66.3c-8.7 5.6-18.8 10.5-29.9 14.7-34 13-80.1 20.6-130.1 20.6s-96.1-7.7-130.1-20.7c-11-4.2-21.1-9.1-29.9-14.7v66.2z"
        }
    ]
};

const FalColonSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalColonSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M255.6 19.6c2-8.6-3.3-17.2-11.9-19.2s-17.2 3.3-19.2 11.9l-12.3 52.3C111.6 72.5 32 154.9 32 256c0 70.8 39 132.4 96.9 165.7l-16.5 70.7c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9l14.9-64.1c14.2 5.3 29.1 9 44.6 10.9l-10.7 45.9c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9l12.1-51.8c41.1-1.6 79-15.5 109.8-38.2 7.1-5.2 8.7-15.2 3.4-22.4s-15.2-8.7-22.4-3.4c-23.6 17.3-52.2 28.6-83.3 31.4l69.2-296.5c4.9 2.9 9.6 6 14.1 9.3 7.1 5.2 17.1 3.7 22.4-3.4s3.7-17.1-3.4-22.4c-8-5.9-16.6-11.2-25.5-15.9l15.6-66.8c2-8.6-3.3-17.2-11.9-19.2s-17.2 3.3-19.2 11.9l-14.2 61.5c-14.3-4.7-29.4-7.8-45-9.1l10.5-45.1zm-51.1 78-68 291.2C92.7 360.1 64 311.2 64 256c0-80.3 60.8-147.3 140.5-158.4zm-38.6 306.5 71.8-307.8c15.7.9 30.9 4 45.1 8.9l-72.3 310c-15.6-1.6-30.6-5.4-44.6-11z"
        }
    ]
};

const FalColon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalColon",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm96 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalColumns3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalColumns3",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64v384h128c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H448zm-32 0H224v384h192V64zM192 448V64H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h128zM0 96c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalComet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalComet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c0-26.4-30.1-41.4-51.2-25.6L81.1 147.2C30 185.5 0 246.1 0 309.8 0 420.9 90 512 201.3 512c64.6 0 125.3-31 163.2-83.4l134.1-185.9c15.3-21.2.2-50.7-25.9-50.7h-26.1L509 50.3c2-4.5 3-9.5 3-14.4C512 16 496 0 476.2 0c-5 0-9.9 1-14.4 3L320 65.4V32zm154.6.3c.5-.2 1-.3 1.5-.3 2.1 0 3.8 1.7 3.8 3.8 0 .5-.1 1.1-.3 1.5l-72.2 164.3c-2.2 4.9-1.7 10.7 1.2 15.2s8 7.3 13.4 7.3h50.6L338.5 409.8c-31.8 44.1-82.9 70.2-137.2 70.2C107.9 480 32 403.4 32 309.8c0-53.8 25.3-104.8 68.3-137L288 32v57.9c0 5.4 2.7 10.4 7.3 13.4s10.2 3.4 15.2 1.2l164.1-72.2zM169.1 283.7c10.4-1.5 19.4-8.1 24.1-17.5l14.8-30 14.8 30.1c4.7 9.4 13.7 16 24.1 17.5l33.2 4.8-24 23.4c-7.5 7.4-11 17.9-9.2 28.3l5.7 33.1-29.7-15.6c-9.3-4.9-20.5-4.9-29.8 0l-29.7 15.6 5.7-33.1c1.8-10.4-1.7-21-9.2-28.3l-24-23.4 33.2-4.8zm53.3-90.8c-2.7-5.5-8.3-8.9-14.3-8.9s-11.7 3.5-14.3 8.9l-29.2 59.2-65.3 9.5c-6 .9-11 5.1-12.9 10.9s-.3 12.2 4 16.4l47.2 46-11.2 65c-1 6 1.4 12.1 6.4 15.7s11.5 4.1 16.8 1.2l58.4-30.7 58.4 30.7c5.4 2.8 11.9 2.4 16.9-1.2s7.4-9.6 6.4-15.7l-11.2-65 47.2-46c4.4-4.3 5.9-10.6 4-16.4s-6.9-10-12.9-10.9l-65.3-9.5-29.2-59.2z"
        }
    ]
};

const FalComma = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalComma",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 352.3c0-17.8-14.4-32.3-32.3-32.3-16.1 0-29.7 11.8-31.9 27.7l-18 125.8c-.5 3.4 2.2 6.5 5.7 6.5 1.9 0 3.7-1 4.8-2.6l66-101.9c3.8-5.8 5.8-12.6 5.8-19.5v-3.7zm32 0v3.7c0 13.1-3.8 25.9-10.9 36.9l-66 101.9C84.2 505.5 72.3 512 59.5 512c-23 0-40.6-20.3-37.3-43l18-125.8c4.5-31.7 31.6-55.2 63.6-55.2 35.5 0 64.3 28.8 64.3 64.3z"
        }
    ]
};

const FalCommand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0s88 39.4 88 88v56h160V88c0-48.6 39.4-88 88-88s88 39.4 88 88-39.4 88-88 88h-56v160h56c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88v-56H176v56c0 48.6-39.4 88-88 88S0 472.6 0 424s39.4-88 88-88h56V176H88c-48.6 0-88-39.4-88-88zm144 56V88c0-30.9-25.1-56-56-56S32 57.1 32 88s25.1 56 56 56h56zm32 192h160V176H176v160zm-32 32H88c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56v-56zm224 0v56c0 30.9 25.1 56 56 56s56-25.1 56-56-25.1-56-56-56h-56zm0-224h56c30.9 0 56-25.1 56-56s-25.1-56-56-56-56 25.1-56 56v56z"
        }
    ]
};

const FalCommentArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v137.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 281.4V144z"
        }
    ]
};

const FalCommentArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-64 120c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L172.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 206.6V296c0 8.8 7.2 16 16 16s16-7.2 16-16V168c0-8.8-7.2-16-16-16H192z"
        }
    ]
};

const FalCommentArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 150.6 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7V320c0 8.8 7.2 16 16 16s16-7.2 16-16V182.6z"
        }
    ]
};

const FalCommentCaptions = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentCaptions",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm288 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm-256 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"
        }
    ]
};

const FalCommentCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm107.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalCommentCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-36.7 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 240l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"
        }
    ]
};

const FalCommentDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm16 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7-13 7.7-23.9 21.1-23.8 40.5.1 18.4 10.8 30.1 22.7 37.3 10.5 6.3 23.8 10.4 34.8 13.7l1.6.5c12.5 3.8 22.2 6.9 29 11.2 5.9 3.7 7.7 7 7.7 11.6.1 6.6-2.7 10.8-7.8 14-5.8 3.6-14.5 5.6-23.7 5.3-11.8-.4-22.7-4.1-36.3-8.7-2.3-.8-4.7-1.6-7.1-2.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1 9.2 3.2 19.7 6.8 30.9 8.9V344c0 8.8 7.2 16 16 16s16-7.2 16-16v-17.1c8.7-1.4 17.4-4.3 25.1-9.1 13.3-8.3 23.2-22.2 22.9-41.6-.2-18.5-10.6-30.6-22.7-38.2-11-6.9-25-11.2-36.3-14.6l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9-6-3.6-7.2-6.4-7.3-10.1 0-5.4 2.4-9.4 8.1-12.8 6.2-3.7 15.1-5.7 23.6-5.5 10.1.2 21 2.3 32.1 5.3 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V136z"
        }
    ]
};

const FalCommentDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM128 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCommentExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm0 80c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCommentHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-80 189.3c0-16.2 13.1-29.3 29.3-29.3 7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6 16.2 0 29.3 13.1 29.3 29.3 0 7.8-3.1 15.2-8.6 20.7L256 313.4 184.6 242c-5.5-5.5-8.6-12.9-8.6-20.7zm29.3-61.3c-33.8 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"
        }
    ]
};

const FalCommentImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-72 128a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm104.2 16c.1 0 .2.1.3.1L379.4 288H133.3l41.7-47.7c.1-.2.4-.3.6-.3.2 0 .5.1.6.3l19 25.3c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.4c.1-.1.2-.2.3-.2zm-25.9-19L208 229.3l-6.2-8.2c-6.2-8.3-15.9-13.1-26.2-13.1-9.5 0-18.4 4.1-24.7 11.2l-48.1 55c-4.4 5-6.8 11.5-6.8 18.2 0 15.3 12.4 27.6 27.6 27.6h264.6c15.4 0 27.8-12.4 27.8-27.8 0-6.4-2.2-12.6-6.2-17.5L313.3 156c-6.2-7.6-15.4-12-25.1-12-10.2 0-19.8 4.8-25.9 13z"
        }
    ]
};

const FalCommentLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM144 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
        }
    ]
};

const FalCommentMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-16 96c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48z"
        }
    ]
};

const FalCommentMiddleTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentMiddleTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216.9 117.7 256 39.6l39.1 78.1c4.3 8.6 12.3 14.8 21.7 16.9C415.4 156.5 480 227.6 480 304c0 91.3-93.8 176-224 176S32 395.3 32 304c0-76.4 64.6-147.5 163.3-169.4 9.4-2.1 17.4-8.3 21.7-16.9zm44.5-89-5.4-2.8 5.5 2.7zm62.2 74.7-44.5-89C274.8 5.5 265.8 0 256 0s-18.8 5.5-23.2 14.3l-44.5 89C79.8 127.5 0 208.2 0 304c0 114.9 114.6 208 256 208s256-93.1 256-208c0-95.8-79.8-176.5-188.3-200.7z"
        }
    ]
};

const FalCommentMiddle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentMiddle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m216.9 394.3 39.1 78.1 39.1-78.1c4.3-8.6 12.3-14.8 21.7-16.9C415.4 355.5 480 284.4 480 208c0-91.3-93.8-176-224-176S32 116.7 32 208c0 76.4 64.6 147.5 163.3 169.4 9.4 2.1 17.4 8.3 21.7 16.9zm44.5 89-5.5 2.7 5.5-2.7zm62.2-74.7-44.5 89c-4.4 8.8-13.3 14.3-23.2 14.3s-18.8-5.5-23.2-14.3l-44.5-89C79.8 384.5 0 303.8 0 208 0 93.1 114.6 0 256 0s256 93.1 256 208c0 95.8-79.8 176.5-188.3 200.7z"
        }
    ]
};

const FalCommentMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
        }
    ]
};

const FalCommentMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm89.1 82.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V187.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V128c0-5.2-2.6-10.2-6.9-13.2zM320 276c0 4.1-4.5 12-16 12s-16-7.9-16-12 4.5-12 16-12 16 7.9 16 12zm-128 32c0 4.1-4.5 12-16 12s-16-7.9-16-12 4.5-12 16-12 16 7.9 16 12z"
        }
    ]
};

const FalCommentPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentPen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm60.3 147.7c4.9 4.9 4.9 12.9 0 17.8l-8.1 8.1-17.8-17.8 8.1-8.1c4.9-4.9 12.9-4.9 17.8 0zm-109.2 91.4 60.7-60.7 17.8 17.8-60.8 60.8c-2.1 2.1-4.6 3.5-7.4 4.2L198 298l4.9-19.5c.7-2.8 2.2-5.4 4.2-7.4zM275.8 157l-91.4 91.5c-6.1 6.2-10.5 13.9-12.6 22.3l-11.3 45.3c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l45.3-11.3c8.4-2.1 16.2-6.5 22.3-12.6l91.4-91.5c17.4-17.4 17.4-45.6 0-63s-45.7-17.4-63.1 0z"
        }
    ]
};

const FalCommentPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-16 304c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
        }
    ]
};

const FalCommentQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-87.3 121.8-.2.7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3 0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V272c0 8.8 7.2 16 16 16s16-7.2 16-16v-19.7l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2 0-35.2-28.5-64.3-64-64.3h-57.1c-25.5 0-47.7 17.2-54.2 41.8zM280 336a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCommentQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentQuote",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-48 144v48h-48v-48h48zm-48 80h48c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C215 322.7 240 290.7 240 254v-78c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm144-80h48v48h-48v-48zm48 80c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C359 322.7 384 290.7 384 254v-78c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48z"
        }
    ]
};

const FalCommentSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm377.6 400C378.1 411.5 350 416 320 416c-31.9 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.4 14.7-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6 14.3-23.8 22.6-49.3 25.7-76.3 1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100 0-22.9 5.9-45.3 16.7-66.1L87 153.6c-14.8 26.3-23 55.6-23 86.4 0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C249.5 441.3 284 448 320 448c40.6 0 78.9-7.7 113-21.3l-29.4-23.2zM320 32c-51.1 0-98.6 12.1-138.6 33.1L209.2 87c32.1-14.5 69.6-23 110.8-23 130.2 0 224 84.6 224 176 0 31-10.8 61.2-30.1 87.5l25.3 20C562.6 316.1 576 279.3 576 240c0-114.8-114.5-208-256-208z"
        }
    ]
};

const FalCommentSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentSmile",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-64 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-164.1 68.1c-6.6 5.9-7.1 16-1.3 22.6C179.5 334.5 215.7 352 256 352s76.5-17.5 101.4-45.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3c-19 21.2-46.7 34.6-77.5 34.6s-58.5-13.4-77.5-34.7c-5.9-6.6-16-7.1-22.6-1.3z"
        }
    ]
};

const FalCommentSms = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentSms",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-53.1 144.8c-6.5 2.2-10.9 8.3-10.9 15.2v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-48l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 240v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-6.9-4.4-13-10.9-15.2s-13.7.1-17.9 5.6L256 229.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm-90.9 38c0-1.1.2-1.6.4-1.9.3-.4.9-1.2 2.4-2 3.1-1.8 8-3 12.9-2.9 6.6.1 16.7 1.6 23.3 3.4 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4-9.3-.1-20.4 1.9-29.7 7.4C88.6 189.3 80 199.8 80 215c.1 14.7 8.8 24 17.7 29.4 7.6 4.6 17.1 7.4 24.3 9.6l1.2.4c8.5 2.6 14.2 4.5 18 6.9 2.7 1.7 2.7 2.4 2.7 3.1v.2c0 1.6-.3 2.3-.6 2.7-.3.5-.9 1.2-2.1 2-2.8 1.7-7.5 2.9-12.8 2.8-7.2-.2-14.2-2.6-23.7-5.8-1.3-.4-2.7-.9-4.1-1.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1.4 2.4.8 3.6 1.2 9 3.1 20.9 7.2 33.2 7.6 9.8.3 21.2-1.6 30.7-7.6 10.2-6.4 18-17.3 17.8-32.3-.2-14.7-8.5-24.2-17.6-29.9-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8-1.6-1-2.1-1.6-2.2-1.7v-.4zm256 0c0-1.1.2-1.6.4-1.9.3-.4.9-1.2 2.4-2 3.1-1.8 8-3 12.9-2.9 6.1.1 12.9 1.4 20.1 3.4 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4-9.3-.1-20.3 1.9-29.7 7.4-9.9 5.9-18.6 16.4-18.5 31.6.1 14.7 8.8 24 17.7 29.4 7.6 4.6 17.1 7.4 24.3 9.6l1.2.4c8.5 2.6 14.2 4.5 18 6.9 2.7 1.7 2.7 2.4 2.7 3.1v.2c0 1.6-.3 2.3-.6 2.7-.3.5-.9 1.2-2.1 2-2.8 1.7-7.5 2.9-12.8 2.8-7-.2-13.5-2.4-22.6-5.5-1.5-.5-3.2-1.1-4.9-1.6-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2.4 2.6.9 4 1.4 8.8 3 20.4 7 32.6 7.4 9.8.3 21.2-1.6 30.7-7.6 10.2-6.4 18-17.3 17.8-32.3-.2-14.7-8.5-24.2-17.6-29.9-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8-1.6-1-2.1-1.6-2.2-1.7v-.4z"
        }
    ]
};

const FalCommentText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentText",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-64 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v112c0 8.8 7.2 16 16 16s16-7.2 16-16V192h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H192z"
        }
    ]
};

const FalCommentXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176-93.8 176-224 176c-32 0-63-5.9-93.5-16.2-9.9-3.3-20.7-1.8-29.2 4.2-15.4 10.7-31.4 20-48.4 27.4l6.3 14.6-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5 0 .1.1.1.1.2-2.6 22.6-9.5 43.5-21.3 63.1-6.5 10.8-13.5 20.8-21.7 29-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3 19.2-8.4 37.1-18.7 53.9-30.5.2-.1.5-.2.7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zm-75.3 132.7c-6.2 6.2-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 240l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 217.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalComment = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalComment",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64C125.8 64 32 148.6 32 240c0 37.1 15.5 70.6 40 100 5.2 6.3 8.4 14.8 7.4 23.9-3.1 27-11.4 52.5-25.7 76.3-.5.9-1.1 1.8-1.6 2.6 11.1-2.9 22.2-7 32.7-11.5l6.4 14.7-6.4-14.7c17-7.4 33-16.7 48.4-27.4 8.5-5.9 19.4-7.5 29.2-4.2C193 410.1 224 416 256 416c130.2 0 224-84.6 224-176S386.2 64 256 64zM0 240C0 125.2 114.5 32 256 32s256 93.2 256 208-114.5 208-256 208c-36 0-70.5-6.7-103.8-17.9-.2-.1-.5 0-.7.1-16.9 11.7-34.7 22.1-53.9 30.5C73.6 471.1 44.7 480 16 480c-6.5 0-12.3-3.9-14.8-9.8s-1.1-12.8 3.4-17.4c8.1-8.2 15.2-18.2 21.7-29C38 404.2 45 383.2 47.6 360.7c0 0-.1-.1-.1-.2C19.6 327.1 0 286.6 0 240z"
        }
    ]
};

const FalCommentsDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentsDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6 4.8 5 5.8 12.5 2.5 18.6C68.7 311.4 56.9 332 42 351.1c31.3-3 63.2-13.2 91.5-26 6-2.7 11.9-5.6 18-8.7 3.2-1.6 6.8-2.1 10.2-1.4 15.6 3.1 30.9 5 46.3 5 102.3 0 176-69.2 176-144S310.3 32 208 32zM0 176C0 78.9 93.1 0 208 0s208 78.9 208 176-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5-3.8-8.7-2-18.9 4.4-25.8l.1-.1C22 326.6 34.3 307.1 46 286 19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110 11.7 21 24 40.6 39.5 57.5l.1.1c6.5 7 8.2 17.1 4.4 25.8-3.8 8.8-12.5 14.5-22 14.5-43 0-86.5-13.3-122.7-29.7-4.9-2.2-9.6-4.5-14.3-6.8-15.3 2.8-30.9 4.6-47 4.6-82.1 0-153-40.2-186.8-98.5 11.5-1.6 22.8-3.9 33.8-6.8 29.4 42.6 84.8 73.3 153 73.3 15.3 0 30.6-1.9 46.3-5 3.5-.7 7.1-.2 10.2 1.4 6.1 3.1 12 6 18 8.7 28.4 12.9 60.2 23.1 91.5 26-14.9-19-26.8-39.7-37.6-59.9-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5-.9-11.1-2.8-21.9-5.6-32.3zM224 83.6v13.8c7.2 1.1 14.1 2.7 20.5 4.4 8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7-7.4-.1-15.1 1.6-20.5 4.7-4.8 2.8-6.5 5.8-6.4 9.8 0 2.3.6 4.4 5.7 7.4 6 3.6 14.5 6.2 25.9 9.6l.5.2c10.1 3 22.9 6.8 33 13.1 11.2 7 21 18.2 21.2 35.5.2 18-9.1 30.9-21.5 38.5-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16v-14.4c-9.7-1.9-18.8-5-26.7-7.7-1.9-.7-3.8-1.3-5.5-1.9-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2.7 4.4 1.5 6.5 2.2 12.2 4.1 21.9 7.4 32.3 7.7 8 .3 15.6-1.5 20.5-4.5 4.2-2.6 6.3-5.7 6.2-10.8 0-3.2-1.1-5.6-6.1-8.7-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4c-9.8-2.9-22-6.6-31.6-12.3-11-6.6-21.2-17.4-21.3-34.7-.1-18.1 10.2-30.5 22.3-37.6 6.5-3.8 13.7-6.2 20.8-7.6v-14c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalCommentsQuestionCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentsQuestionCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 176c0-74.8 73.7-144 176-144s176 69.2 176 144-73.7 144-176 144c-15.3 0-30.6-1.9-46.3-5-3.5-.7-7.1-.2-10.2 1.4-6.1 3.1-12 6-18 8.7-28.4 12.9-60.2 23.1-91.5 26 14.9-19 26.8-39.7 37.6-59.9 3.3-6.1 2.3-13.6-2.5-18.6C50 244.2 32 213.1 32 176zM208 0C93.1 0 0 78.9 0 176c0 44.2 19.8 80.1 46 110-11.7 21-24 40.6-39.5 57.5l-.1.1c-6.5 7-8.2 17.1-4.4 25.8 3.8 8.9 12.4 14.6 22 14.6 43 0 86.5-13.3 122.7-29.7 4.9-2.2 9.6-4.5 14.3-6.8 15.3 2.8 30.9 4.6 47 4.6 114.9 0 208-78.9 208-176S322.9 0 208 0zm239.4 160.5C541.6 167 608 233 608 304c0 37.1-18 68.2-45.1 96.6-4.8 5-5.8 12.5-2.5 18.6 10.9 20.2 22.7 40.8 37.6 59.9-31.3-3-63.2-13.2-91.5-26-6-2.7-11.9-5.6-18-8.7-3.2-1.6-6.8-2.1-10.2-1.4-15.6 3.1-30.9 5-46.3 5-68.2 0-123.6-30.7-153.1-73.3-11 3-22.3 5.2-33.8 6.8C279 439.8 349.9 480 432 480c16.1 0 31.7-1.8 47-4.6 4.6 2.3 9.4 4.6 14.3 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5 3.8-8.7 2-18.9-4.4-25.8l-.1-.1c-15.5-17-27.8-36.5-39.5-57.5 26.2-29.9 46-65.8 46-110 0-94.4-87.8-171.5-198.2-175.8 2.8 10.4 4.7 21.2 5.6 32.3zM539.3 266c-6.2-6.2-16.4-6.2-22.6 0l-74 74-31.4-31.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l42.7 42.8c6.2 6.2 16.4 6.2 22.6 0l85.3-85.3c6.2-6.2 6.2-16.4 0-22.6zM147.9 104.1l-.3.9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4h41.3c6.5 0 11.7 5.3 11.7 11.7 0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9v9.5c0 8.8 7.2 16 16 16s16-7.2 16-16v-.3l23.4-13.4c13.6-7.8 22-22.3 22-37.9 0-24.2-19.6-43.7-43.7-43.7h-41.4c-16.4 0-31 10.3-36.4 25.7zM230.7 236a22.7 22.7 0 1 0-45.3 0 22.7 22.7 0 1 0 45.3 0z"
        }
    ]
};

const FalCommentsQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCommentsQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6 4.8 5 5.8 12.5 2.5 18.6C68.7 311.4 56.9 332 42 351.1c31.3-3 63.2-13.2 91.5-26 6-2.7 11.9-5.6 18-8.7 3.2-1.6 6.8-2.1 10.2-1.4 15.6 3.1 30.9 5 46.3 5 102.3 0 176-69.2 176-144S310.3 32 208 32zM0 176C0 78.9 93.1 0 208 0s208 78.9 208 176-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5-3.8-8.7-2-18.9 4.4-25.8l.1-.1C22 326.6 34.3 307.1 46 286 19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110 11.7 21 24 40.6 39.5 57.5l.1.1c6.5 7 8.2 17.1 4.4 25.8-3.8 8.8-12.5 14.5-22 14.5-43 0-86.5-13.3-122.7-29.7-4.9-2.2-9.6-4.5-14.3-6.8-15.3 2.8-30.9 4.6-47 4.6-82.1 0-153-40.2-186.8-98.5 11.5-1.6 22.8-3.9 33.8-6.8 29.4 42.6 84.8 73.3 153 73.3 15.3 0 30.6-1.9 46.3-5 3.5-.7 7.1-.2 10.2 1.4 6.1 3.1 12 6 18 8.7 28.4 12.9 60.2 23.1 91.5 26-14.9-19-26.8-39.7-37.6-59.9-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5-.9-11.1-2.8-21.9-5.6-32.3zm-293.9-24.1c5.5-15.4 20.1-25.7 36.4-25.7h41.3c24.2 0 43.7 19.6 43.7 43.7 0 15.7-8.4 30.1-22 37.9L224 173.4v.3c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.5c0-5.7 3.1-11 8-13.9l31.4-18c3.6-2.1 5.9-6 5.9-10.2 0-6.5-5.3-11.7-11.7-11.7h-41.3c-2.8 0-5.3 1.8-6.3 4.4l-.3.9c-3 8.3-12.1 12.7-20.4 9.7s-12.7-12.1-9.7-20.4l.3-.9zM185.3 236a22.7 22.7 0 1 1 45.3 0 22.7 22.7 0 1 1-45.3 0z"
        }
    ]
};

const FalComments = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalComments",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 176c0-74.8 73.7-144 176-144s176 69.2 176 144-73.7 144-176 144c-15.3 0-30.6-1.9-46.3-5-3.5-.7-7.1-.2-10.2 1.4-6.1 3.1-12 6-18 8.7-28.4 12.9-60.2 23.1-91.5 26 14.9-19 26.8-39.7 37.6-59.9 3.3-6.1 2.3-13.6-2.5-18.6C50 244.2 32 213.1 32 176zM208 0C93.1 0 0 78.9 0 176c0 44.2 19.8 80.1 46 110-11.7 21-24 40.6-39.5 57.5l-.1.1c-6.5 7-8.2 17.1-4.4 25.8 3.8 8.9 12.4 14.6 22 14.6 43 0 86.5-13.3 122.7-29.7 4.9-2.2 9.6-4.5 14.3-6.8 15.3 2.8 30.9 4.6 47 4.6 114.9 0 208-78.9 208-176S322.9 0 208 0zm239.4 160.5C541.6 167 608 233 608 304c0 37.1-18 68.2-45.1 96.6-4.8 5-5.8 12.5-2.5 18.6 10.9 20.2 22.7 40.8 37.6 59.9-31.3-3-63.2-13.2-91.5-26-6-2.7-11.9-5.6-18-8.7-3.2-1.6-6.8-2.1-10.2-1.4-15.6 3.1-30.9 5-46.3 5-68.2 0-123.6-30.7-153.1-73.3-11 3-22.3 5.2-33.8 6.8C279 439.8 349.9 480 432 480c16.1 0 31.7-1.8 47-4.6 4.6 2.3 9.4 4.6 14.3 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5 3.8-8.7 2-18.9-4.4-25.8l-.1-.1c-15.5-17-27.8-36.5-39.5-57.5 26.2-29.9 46-65.8 46-110 0-94.4-87.8-171.5-198.2-175.8 2.8 10.4 4.7 21.2 5.6 32.3z"
        }
    ]
};

const FalCompactDisc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCompactDisc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm72 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-120 0c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-97.2 78.8-176 176-176 8.8 0 16 7.2 16 16s-7.2 16-16 16c-79.5 0-144 64.5-144 144z"
        }
    ]
};

const FalCompassDrafting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCompassDrafting",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-21.7 86.2c-12.8 6.3-27.1 9.8-42.3 9.8s-29.5-3.5-42.3-9.8l-71.5 125.2C176.1 325.6 214.8 336 256 336c88.8 0 166.4-48.2 207.9-120 4.4-7.6 14.2-10.3 21.9-5.8s10.3 14.2 5.8 21.9c-47 81.3-134.9 136-235.6 136-47 0-91.1-11.9-129.7-32.8L29.9 503.9c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l97-169.8c-32.1-22.7-59-52.1-78.7-86.2-4.4-7.6-1.8-17.4 5.8-21.9s17.4-1.8 21.9 5.8c16.9 29.2 39.8 54.6 67 74.3l72.5-126.9C170.5 146.1 160 122.3 160 96c0-53 43-96 96-96s96 43 96 96c0 26.3-10.5 50.1-27.6 67.4l48.4 84.7c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6l-46.7-81.7zM409 375.9c-4.4-7.7-1.7-17.4 6-21.8s17.4-1.7 21.8 6l73.1 128c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6l-73.1-128z"
        }
    ]
};

const FalCompassSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCompassSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448.8 439.3C412.4 464.9 368 480 320 480 196.3 480 96 379.7 96 256c0-29.3 5.6-57.2 15.8-82.8l-26.1-20.6C71.8 184.2 64 219.2 64 256c0 141.4 114.6 256 256 256 58.2 0 111.9-19.4 154.9-52.2l-26.1-20.6zM320 0c-58.2 0-111.9 19.4-154.9 52.2l26.1 20.6C227.6 47.1 272 32 320 32c123.7 0 224 100.3 224 224 0 29.3-5.6 57.2-15.8 82.8l26.1 20.6c14-31.6 21.7-66.6 21.7-103.4C576 114.6 461.4 0 320 0zM186.9 348.6c-8.3 25 15.5 48.8 40.5 40.5l111-37-30-23.7-91.1 30.4 27-80.9-26.7-21.1-30.6 91.9zm114.7-188.7 30 23.7 91.1-30.4-27 80.9 26.7 21.1 30.6-91.9c8.3-25-15.5-48.8-40.5-40.5l-111 37zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalCompass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCompass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm92.6-389.1-146.5 48.9c-14.3 4.8-25.6 16-30.4 30.4l-48.8 146.4c-8.3 25 15.5 48.8 40.5 40.5l146.5-48.8c14.3-4.8 25.6-16 30.4-30.4l48.8-146.5c8.3-25-15.5-48.8-40.5-40.5zm10.1 30.4-48.8 146.5c-1.6 4.8-5.3 8.5-10.1 10.1l-146.5 48.8 48.8-146.5c1.6-4.8 5.3-8.5 10.1-10.1l146.5-48.8zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalCompressWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCompressWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 80c0-8.8 7.2-16 16-16s16 7.2 16 16v128c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h112V80zm16 208c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V320H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h128zM352 80c0-8.8 7.2-16 16-16s16 7.2 16 16v112h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V80zm144 208c8.8 0 16 7.2 16 16s-7.2 16-16 16H384v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16h128z"
        }
    ]
};

const FalCompress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCompress",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16V48zM16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h112v112c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16H16zM320 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H320V48zm-16 272c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V352h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"
        }
    ]
};

const FalComputerClassic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalComputerClassic",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c17.7 0 32 14.3 32 32v304c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h320zM64 0C28.7 0 0 28.7 0 64v304c0 23.7 12.9 44.4 32 55.4V480c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-56.6c19.1-11.1 32-31.7 32-55.4V64c0-35.3-28.7-64-64-64H64zm0 432h320v48H64v-48zM352 96v128H96V96h256zM96 64c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H96zm128 272c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zM96 360a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalComputerMouseScrollwheel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalComputerMouseScrollwheel",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 352V160c0-70.7-57.3-128-128-128h-64C89.3 32 32 89.3 32 160v192c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128zM0 160C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160v192c0 88.4-71.6 160-160 160h-64C71.6 512 0 440.4 0 352V160zm208-48v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalComputerMouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalComputerMouse",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 224H32v128c0 70.7 57.3 128 128 128h64c70.7 0 128-57.3 128-128V224H192zm192-32v160c0 88.4-71.6 160-160 160h-64C71.6 512 0 440.4 0 352V160C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160v32zM208 32v160h144v-32c0-70.7-57.3-128-128-128h-16zm-32 0h-16C89.3 32 32 89.3 32 160v32h144V32z"
        }
    ]
};

const FalComputerSpeaker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalComputerSpeaker",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 384c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h229.5c4.2-11.9 10.7-22.8 19-32H64C28.7 32 0 60.7 0 96v256c0 35.3 28.7 64 64 64h224v-32H64zm48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h200.4c-8.3-9.2-14.8-20.1-19-32H112zM576 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h192zM384 32c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H384zm96 352a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm112-176a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalComputer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalComputer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 384h97.8l-21.3 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-60.5l-21.3-64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v224c0 35.3 28.7 64 64 64zm110.2 64 21.3-64h56.9l21.3 64h-99.5zM528 64h64c8.8 0 16 7.2 16 16v48h-96V80c0-8.8 7.2-16 16-16zm-16 96h96v32h-96v-32zm0 272V224h96v208c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zM480 80v352c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48zm80 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalContainerStorage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalContainerStorage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h16v384H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm48 416V64h512v384H64zm128-304c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V144z"
        }
    ]
};

const FalConveyorBeltArm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalConveyorBeltArm",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0 8.8 7.2 16 16 16h77.1l-5.5 32.7c-22.5 4-39.6 23.6-39.6 47.3 0 26.5 21.5 48 48 48 18.6 0 34.8-10.6 42.8-26.2L448 158v50c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8-5.9-14.8-13.9-15.9l-195.1-26c-2.9-13.8-11.8-25.5-23.8-32.1l6.3-38H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm72 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm248 176h32v32h-32v-32zm-32-8v40h-64v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40h-64v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v40c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96h-32v-40c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zM96 352h448c35.3 0 64 28.7 64 64s-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64zm64-64v32h-32v-32h32zm128 32v-32h32v32h-32zM128 440a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalConveyorBeltBoxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalConveyorBeltBoxes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h192zM112 0C85.5 0 64 21.5 64 48v192c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H112zm416 96c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16h96zm-96-32c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48h-96zm176 352c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h448c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96H96zm56 96a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalConveyorBeltEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalConveyorBeltEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 352c-35.3 0-64 28.7-64 64s28.7 64 64 64h448c35.3 0 64-28.7 64-64s-28.7-64-64-64H96zM0 416c0-53 43-96 96-96h448c53 0 96 43 96 96s-43 96-96 96H96c-53 0-96-43-96-96zm128-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalConveyorBelt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalConveyorBelt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 32c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h64v112c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L320 116l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5S400 150 400 144V32h64zm-192 0h96v80l-38.4-28.8a15.9 15.9 0 0 0-19.2 0L272 112V32zM176 0c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176zm432 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h448c35.3 0 64 28.7 64 64zM96 320c-53 0-96 43-96 96s43 96 96 96h448c53 0 96-43 96-96s-43-96-96-96H96zm56 96a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm216-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCookieBite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCookieBite",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m182.8 28.4-74 39.5c-19.7 10.5-35.6 27-45.4 47.1l-36.7 75.6c-9.8 20.1-13 42.9-9.1 64.9l14.5 82.8c3.9 22.1 14.6 42.3 30.7 57.9l60.3 58.4c16.1 15.6 36.6 25.6 58.7 28.7l83 11.7c22.1 3.1 44.6-.9 64.4-11.4l74-39.5c19.7-10.5 35.6-27 45.4-47.2l36.7-75.5c9.8-20.1 13-42.9 9.1-64.9-.9-5.3-5.3-9.3-10.6-10.1-51.5-8.2-92.8-47.1-104.5-97.4-1.8-7.6-8-13.4-15.7-14.6-54.6-8.7-97.7-52-106.2-106.8-.8-5.4-4.9-9.8-10.3-10.6-22.1-3.1-44.6.9-64.4 11.4zm46.3 19.7c15 58.3 62 103.6 121.2 116.4 15.6 54.1 59 96.4 113.7 110.5 0 11.2-2.5 22.3-7.5 32.5L419.8 383c-6.8 14.1-17.9 25.6-31.7 32.9l-74 39.5c-13.7 7.3-29.4 10.1-44.8 7.9l-83-11.7c-15.4-2.2-29.7-9.2-40.9-20l-60.3-58.4c-11.2-10.9-18.7-25-21.4-40.4L49.1 250c-2.7-15.4-.5-31.3 6.4-45.4L92.2 129c6.8-14.1 17.9-25.6 31.7-32.9l74-39.5c9.7-5.2 20.4-8.1 31.2-8.6zM184 192a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm8 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-120a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm40 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalCookie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCookie",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M242.7 48.7c-15.4-2.2-31.1.6-44.8 7.9l-74 39.5c-13.8 7.3-24.8 18.9-31.7 32.9l-36.7 75.6c-6.8 14.1-9.1 30-6.4 45.4l14.5 82.8c2.7 15.4 10.2 29.6 21.4 40.4l60.3 58.4c11.2 10.9 25.5 17.9 40.9 20l83 11.7c15.4 2.2 31.1-.6 44.8-7.9l74-39.5c13.7-7.3 24.8-18.8 31.7-32.9l36.7-75.5c6.8-14.1 9.1-30 6.4-45.4l-14.6-82.8c-2.7-15.4-10.2-29.6-21.4-40.4l-60.2-58.4c-11.2-10.9-25.5-17.9-40.9-20l-83-11.7zm-59.9-20.3c19.7-10.5 42.3-14.5 64.4-11.4l83 11.7c22.1 3.1 42.7 13.2 58.7 28.7l60.3 58.4c16.1 15.6 26.8 35.8 30.7 57.9l14.6 82.8c3.9 22.1.7 44.8-9.1 64.9L448.6 397c-9.8 20.1-25.7 36.6-45.4 47.2l-74 39.5a105.83 105.83 0 0 1-64.4 11.4l-83-11.7c-22.1-3.1-42.7-13.2-58.7-28.7l-60.3-58.5c-16-15.6-26.8-35.9-30.6-57.9l-14.6-82.8c-3.9-22.1-.7-44.8 9.1-64.9L63.4 115c9.8-20.1 25.7-36.6 45.4-47.2l74-39.5zM160 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm8 184a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm8-104a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm56 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalCopy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCopy",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 352H224c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h108.1c4.2 0 8.3 1.7 11.3 4.7l67.9 67.9c3 3 4.7 7.1 4.7 11.3V320c0 17.7-14.3 32-32 32zm49.9-270.1-67.8-67.8c-9-9-21.2-14.1-33.9-14.1H224c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9zM64 128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64v-32h-32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h64v-32H64z"
        }
    ]
};

const FalCopyright = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCopyright",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm67.9-188.1c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8 98.3-37.5 135.8 0c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-50-50-131-50-181 0s-50 131 0 181 131 50 181 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FalCorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCorn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 0c-14.6 0-28.1 4.9-38.8 13.1C401.4 9.8 392.9 8 384 8c-20.3 0-38.5 9.5-50.2 24.3-1.9-.2-3.9-.3-5.8-.3-20.3 0-38.5 9.5-50.2 24.3-1.9-.2-3.9-.3-5.8-.3-21.9 0-41.2 11-52.7 27.7 7.7 10.3 14.7 21 21 32 0-.2.1-.4.1-.6C242.7 99.8 256 88 272 88c3.1 0 6.1.4 8.9 1.3 7.3 2.1 15.1-1.2 18.6-8C304.9 71 315.7 64 328 64c3.1 0 6.1.4 8.9 1.3 7.3 2.1 15.1-1.2 18.6-8C360.9 47 371.7 40 384 40c6.9 0 13.2 2.1 18.4 5.8 6.7 4.7 16 3.6 21.3-2.7C429.6 36.3 438.3 32 448 32c17.7 0 32 14.3 32 32 0 9.7-4.3 18.4-11.2 24.3-6.2 5.4-7.4 14.6-2.6 21.3 3.7 5.2 5.8 11.5 5.8 18.4 0 12.3-7 23.1-17.3 28.4-6.8 3.5-10.1 11.3-8 18.6.8 2.8 1.3 5.8 1.3 8.9 0 12.3-7 23.1-17.3 28.4-6.8 3.5-10.1 11.3-8 18.6.8 2.8 1.3 5.8 1.3 8.9 0 10.9-5.4 20.5-13.7 26.3 8.7 6.3 17.1 13.4 24.9 21C448 275.6 456 258.7 456 240c0-2-.1-3.9-.3-5.8 14.8-11.7 24.3-29.9 24.3-50.2 0-2-.1-3.9-.3-5.8 14.8-11.7 24.3-29.9 24.3-50.2 0-8.9-1.8-17.4-5.1-25.2C507.1 92.1 512 78.6 512 64c0-35.3-28.7-64-64-64zM163.3 68.7c-3.9-3.9-9.6-5.5-15-4.3s-9.7 5.3-11.5 10.5l-22 65.9c-.7 2-1.7 3.9-3.1 5.5l-76.1 87C12.7 259.5 0 293.2 0 328.1V342c0 36.2 13.6 71.1 38.2 97.7l24 26C89.5 495.2 127.9 512 168 512h11c38.2 0 74.8-15.2 101.8-42.2l69.5-69.5c1.7-1.7 3.6-2.9 5.8-3.7l81.4-29.6c5.1-1.9 9-6.2 10.2-11.6s-.4-10.9-4.3-14.8l-29.1-29.1C378.6 276 330.3 256 280 256c-10.8 0-21.6.9-32.1 2.7-1.9-69.5-30.3-135.7-79.6-185l-5-5zM216 266v1.1c-26.2 9.4-50.2 24.5-70.2 44.5l-94 94C39 387 32 364.8 32 342v-13.9c0-27.1 9.8-53.3 27.7-73.8l76.1-87c4.2-4.8 7.4-10.4 9.4-16.4l13.5-40.5C195.6 153.7 216 208.8 216 266zM85.7 444l-13-14.1 95.7-95.7C198 304.6 238.1 288 280 288s82 16.6 111.6 46.2l11.3 11.3-57.7 21c-6.6 2.4-12.6 6.2-17.5 11.2l-69.5 69.5c-21 21-49.5 32.8-79.2 32.8h-11c-31.3 0-61.1-13.1-82.3-36z"
        }
    ]
};

const FalCorner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCorner",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 176c0-8.8 7.2-16 16-16h384c26.5 0 48 21.5 48 48v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8-7.2-16-16-16H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalCouch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCouch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c53 0 96 43 96 96v37.5c10-3.5 20.8-5.5 32-5.5v-32c0-70.7-57.3-128-128-128H192C121.3 32 64 89.3 64 160v32c11.2 0 22 1.9 32 5.5V160c0-53 43-96 96-96h256zM96 320v112c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32zM80 480c20.9 0 38.7-13.4 45.3-32h389.4c6.6 18.6 24.4 32 45.3 32h32c26.5 0 48-21.5 48-48V288c0-35.3-28.7-64-64-64s-64 28.7-64 64H128c0-35.3-28.7-64-64-64S0 252.7 0 288v144c0 26.5 21.5 48 48 48h32zm48-64v-96h384v96H128zm416 16V288c0-17.7 14.3-32 32-32s32 14.3 32 32v144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalCow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 144v264c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8v-72c0-53 43-96 96-96s96 43 96 96v72c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V240c0-5.5 2.9-10.7 7.6-13.6s10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3v62.7c0 3 .9 6 2.5 8.6l37.3 58.6c5.6 8.8 15.3 14.1 25.7 14.1 16.8 0 30.5-13.6 30.5-30.5V298c0-3.3-1-6.4-2.8-9.1L594.8 274c-1.9-2.7-2.8-5.9-2.8-9.1V200c0-4.4-3.6-8-8-8-4 0-7.3 2.9-7.9 6.7-1.1 6.4-5.9 11.6-12.3 13s-12.9-1.1-16.7-6.5l-51.7-74.7A79.735 79.735 0 0 0 429.7 96h-30c-1.9 26.9-13.4 52.3-32.5 71.4l-3.1 3.1c-24 24-56.6 37.5-90.5 37.5h-3.2c-33.9 0-66.5-13.5-90.5-37.5l-3.1-3.1c-16.6-16.6-27.4-37.8-31.2-60.5C134.8 115.7 128 129 128 144zm71.4.8 3.1 3.1c18 18 42.4 28.1 67.9 28.1h3.2c25.5 0 49.9-10.1 67.9-28.1l3.1-3.1c13.2-13.2 21.3-30.4 23.1-48.8H176.4c1.8 18.4 9.9 35.6 23.1 48.8zm8.6 231V408c0 22.1-17.9 40-40 40h-32c-22.1 0-40-17.9-40-40V144c0-18 6-34.6 16-48-26.5 0-48 21.5-48 48v124.8c0 28.3-22.9 51.2-51.2 51.2C5.7 320 0 314.3 0 307.2V288c0-23.7 12.9-44.4 32-55.4V144c0-44.2 35.8-80 80-80h317.7c36.8 0 71.2 18 92.1 48.2l38.5 55.6c6.6-4.9 14.9-7.8 23.7-7.8 22.1 0 40 17.9 40 40v59.9l7.5 10.8c5.6 8 8.5 17.6 8.5 27.3v87.5c0 34.5-28 62.5-62.5 62.5-21.4 0-41.2-10.9-52.7-28.9l-37.3-58.6c-4.9-7.7-7.5-16.6-7.5-25.8v-52.8l-32-16V408c0 22.1-17.9 40-40 40h-32c-22.1 0-40-17.9-40-40v-32.2c-6.6 2-14.6 3.8-24 5.3V392c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8.1c-2.6.1-5.3.1-8 .1s-5.4 0-8-.1v8.1c0 8.8-7.2 16-16 16s-16-7.2-16-16v-10.9c-9.4-1.5-17.4-3.3-24-5.3zm0-33.8c2.1.8 4.7 1.8 7.7 2.7 11.4 3.5 29.8 7.3 56.3 7.3s44.9-3.8 56.3-7.3c3-.9 5.6-1.9 7.7-2.7v-6c0-35.3-28.7-64-64-64s-64 28.7-64 64v6zm344-22a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalCowbellCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCowbellCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32h96c8.8 0 16 7.2 16 16v48H160V48c0-8.8 7.2-16 16-16zm-48 16v48h-16c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416h214.6c-2.9-10.3-4.9-21-5.9-32H48c-5 0-9.8-2.4-12.8-6.4s-4-9.2-2.6-14l64-224c2-6.9 8.2-11.6 15.4-11.6h224c7.1 0 13.4 4.7 15.4 11.6l18.2 63.8c9.9-3.7 20.2-6.6 30.8-8.6l-18.3-64C376.3 110.2 357.4 96 336 96h-16V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48zm128 400c0 17.7-14.3 32-32 32s-32-14.3-32-32h-32c0 35.3 28.7 64 64 64 29.2 0 53.9-19.6 61.5-46.4-3.8-5.7-7.2-11.5-10.3-17.6H256zm64-80a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-128-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FalCowbell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCowbell",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32h96c8.8 0 16 7.2 16 16v48H160V48c0-8.8 7.2-16 16-16zm-48 16v48h-16c-21.4 0-40.3 14.2-46.2 34.8l-64 224c-4.1 14.5-1.2 30.1 7.8 42.1S32.9 416 48 416h352c15.1 0 29.3-7.1 38.3-19.1s12-27.6 7.8-42.1l-64-224C376.3 110.2 357.4 96 336 96h-16V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48zm16 80h192c7.1 0 13.4 4.7 15.4 11.6l64 224c1.4 4.8.4 10-2.6 14S405 384 400 384H48c-5 0-9.8-2.4-12.8-6.4s-4-9.2-2.6-14l64-224c2-6.9 8.2-11.6 15.4-11.6h32zm80 384c35.3 0 64-28.7 64-64h-32c0 17.7-14.3 32-32 32s-32-14.3-32-32h-32c0 35.3 28.7 64 64 64z"
        }
    ]
};

const FalCrab = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrab",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 32c-38.7 0-71 27.5-78.4 64h97.1c4.2 0 8.3-1.7 11.3-4.7l6.6-6.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-6.6 6.6c-9 9-21.2 14.1-33.9 14.1H32v20.1c0 11.5 6.2 22.1 16.1 27.8l78.8 45C145.1 206 167.5 196 192 193v-49c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v49c24.5 3.1 46.9 13.1 65.1 28l78.8-45c10-5.7 16.1-16.3 16.1-27.8V128h-98.7c-12.7 0-24.9-5.1-33.9-14.1l-6.6-6.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l6.6 6.6c3 3 7.1 4.7 11.3 4.7h97.1C471 59.5 438.7 32 400 32h-16l25.6 19.2c7.1 5.3 8.5 15.3 3.2 22.4s-15.3 8.5-22.4 3.2l-64-48c-5.5-4.1-7.8-11.3-5.6-17.9S329.1 0 336 0h64c61.9 0 112 50.1 112 112v36.1c0 23-12.3 44.2-32.2 55.6l-72.1 41.2c6 8.3 11.1 17.4 15 27.1h37.5l28.6-14.3c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-2.2 1.1-4.7 1.7-7.2 1.7H431c.7 5.2 1 10.6 1 16v8l22.2 9.2c1.9.8 3.7 2 5.2 3.5l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L439 365.6l-25.7-10.7-31.1 31.1 39.5 15c2.1.8 4 2 5.6 3.6l32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-29.6-29.6-49.8-19-15.1 15.1 35.1 25.3c4.2 3 6.7 7.9 6.7 13v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-23.8L318.1 448H193.9L160 472.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-5.2 2.5-10 6.7-13l35.2-25.1-15.1-15.1-49.8 19-29.7 29.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c1.6-1.6 3.5-2.8 5.6-3.6l39.6-15.1-31.1-31.2-25.7 10.8-29.8 29.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c1.5-1.5 3.2-2.6 5.2-3.5L80 328v-8c0-5.4.3-10.8 1-16H48c-2.5 0-4.9-.6-7.2-1.7l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2L51.8 272h37.5c3.9-9.7 9-18.8 15-27.1l-72.1-41.2C12.3 192.3 0 171.1 0 148.1V112C0 50.1 50.1 0 112 0h64c6.9 0 13 4.4 15.2 10.9s-.1 13.7-5.6 17.9l-64 48c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4L128 32h-16zm192 192h-96c-53 0-96 43-96 96v2.7l93.3 93.3h101.4l93.3-93.3V320c0-53-43-96-96-96z"
        }
    ]
};

const FalCrateApple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrateApple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M219.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm192 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zM75 126c6.3-10.4 13.1-14 21-14 9.3 0 23.1 3.9 35.6 8.8 18.2 7.1 38.5 7.1 56.7 0 12.5-4.9 26.4-8.8 35.6-8.8 7.9 0 14.7 3.6 21 14 6.8 11.2 11 28 11 45.5 0 7.1-.5 14-1.5 20.6h32.3c.8-6.7 1.2-13.5 1.2-20.6 0-43.6-20.4-91.4-64-91.4-15.6 0-34.1 5.9-47.2 11-10.7 4.2-22.8 4.2-33.5 0C130.1 85.9 111.6 80 96 80c-43.6 0-64 47.8-64 91.4 0 7 .4 13.9 1.2 20.6h32.3c-1-6.6-1.5-13.4-1.5-20.6 0-17.5 4.2-34.2 11-45.5zm403.7 66c.8-6.7 1.2-13.5 1.2-20.6 0-43.6-20.4-91.4-64-91.4-15.6 0-34.1 5.9-47.2 11-10.7 4.2-22.8 4.2-33.5 0-12.4-4.8-29.6-10.3-44.6-11 3.4 4 6.4 8.3 9 12.7 4.5 7.4 8.2 15.3 11.1 23.6 4.3 1.3 8.6 2.8 12.8 4.5 18.2 7.1 38.5 7.1 56.7 0 12.5-4.9 26.4-8.8 35.6-8.8 7.9 0 14.7 3.6 21 14 6.8 11.2 11 28 11 45.5 0 7.1-.5 14-1.5 20.6h32.3zM32 384h448v72c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24v-72zm0-32v-72c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24v72H32zm480 0v-72c0-30.9-25.1-56-56-56H56c-30.9 0-56 25.1-56 56v176c0 30.9 25.1 56 56 56h400c30.9 0 56-25.1 56-56V352zM96 304a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalCrateEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrateEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 384v72c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24v-72h448zm0-32H32v-72c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24v72zm32 0v-72c0-30.9-25.1-56-56-56H56c-30.9 0-56 25.1-56 56v176c0 30.9 25.1 56 56 56h400c30.9 0 56-25.1 56-56V352zM96 304a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM96 432a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalCreditCardBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCreditCardBlank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 272c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalCreditCardFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCreditCardFront",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm32 272c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H240zm160-208h64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-64c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h64c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-64c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FalCreditCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCreditCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v32h512V96c0-17.7-14.3-32-32-32H64zm-32 96v64h512v-64H32zm0 96v160c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V256H32zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 272c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalCricketBatBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCricketBatBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-151 151 30.1 30.1c21.9 21.9 21.9 57.3 0 79.2L178 495.9c-10 10-24.4 16.7-40.4 15.6-11.3-.8-28.6-2.8-46.4-8.2-17.3-5.1-37.1-14.2-52.2-30.3-16.2-15-25.2-34.9-30.4-52.2l30.6-9.3c4.4 14.5 11.2 28.4 21.6 38 .6.5 1.1 1.1 1.6 1.6 9.6 10.4 23.5 17.2 38 21.6 14.7 4.4 29.3 6.2 39.3 6.9 5.6.4 11.2-1.9 15.6-6.3L308.7 320H240c-26.5 0-48-21.5-48-48v-68.7L38.7 356.6c-4.4 4.4-6.7 10.1-6.3 15.6.7 10 2.4 24.6 6.9 39.3l-30.7 9.3C3.2 403 1.2 385.7.5 374.4c-1.1-16 5.6-30.4 15.6-40.4l208.3-208.3c21.9-21.9 57.3-21.9 79.2 0l30.1 30.1 151-151c6.2-6.2 16.4-6.2 22.6 0zM224 171.3V272c0 8.8 7.2 16 16 16h100.7l23-23c9.4-9.4 9.4-24.6 0-33.9L281 148.3c-9.4-9.4-24.6-9.4-33.9 0l-23 23zM480 432a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FalCroissant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCroissant",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 288c0-15.3 1.3-30.2 3.9-44.7l169.6 68.4-124 96.4-11.7 8.3c-.9.2-1.7.3-2.3.2-.6-.1-.9-.2-1-.3-.1 0-.2-.2-.5-.6-21.6-37.6-34-81.1-34-127.7zM7.4 222.9C2.6 243.8 0 265.6 0 288c0 52.3 14 101.4 38.4 143.7 9.3 16.2 28.9 20.8 45.3 13.7 25.7 27.9 57.4 50 93.2 64.3 3.9 1.5 8 2.3 12.2 2.3h5.4c16.3 0 29.6-13.2 29.6-29.6 0-1.6-.1-3.3-.4-4.9L208 384v-33.8l34.1-26.5c18.9 2 38.1-4.5 51.9-18.4l11.3-11.3c13.9-13.9 20.4-33 18.4-51.9l26.5-34.1H384l93.6 15.6c1.6.3 3.2.4 4.9.4 16.3 0 29.6-13.2 29.6-29.6V189c0-4.2-.7-8.3-2.3-12.2-14.3-35.8-36.5-67.5-64.3-93.2 7.1-16.4 2.5-36-13.7-45.3C389.4 14 340.3 0 288 0c-22.4 0-44.2 2.6-65.1 7.4-7.3-4.7-15.9-7.4-25-7.4-5 0-10 .8-14.6 2.5C99.6 33.2 33.2 99.6 2.5 183.3.8 188 0 193 0 197.9c0 9.1 2.7 17.7 7.4 24.9zm235.9-187c14.5-2.6 29.4-3.9 44.7-3.9 46.6 0 90.1 12.4 127.7 34.1.4.2.5.4.6.5.1.1.2.4.3 1 .1.6.1 1.4-.2 2.3l-8.3 11.7-96.4 124-68.4-169.7zM188.6 480c-30-12-56.8-30.4-78.8-53.4l66.2-51.5v11.5l.4 2.6 15.2 90.8h-3zm186.5-304 51.4-66.1c23 21.9 41.4 48.7 53.4 78.8v2.9l-90.7-15.1-2.6-.4h-11.5zM32.5 194.3C60 119.5 119.5 60 194.3 32.5c.8-.3 2-.5 3.6-.5 5.6 0 10.6 3.4 12.7 8.6l79.1 196.2c4.8 11.9 2 25.5-7.1 34.6l-11.3 11.3c-9.1 9.1-22.7 11.8-34.6 7.1L40.6 210.7c-5.2-2.1-8.6-7.1-8.6-12.7 0-1.6.3-2.8.5-3.6z"
        }
    ]
};

const FalCropSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCropSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v80H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v240c0 26.5 21.5 48 48 48h208v-32H144c-8.8 0-16-7.2-16-16V16zm256 480c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80V144c0-26.5-21.5-48-48-48H160v32h208c8.8 0 16 7.2 16 16v352z"
        }
    ]
};

const FalCrop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m416 118.6 91.3-91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L393.4 96H160v32h201.4L128 361.4V16c0-8.8-7.2-16-16-16S96 7.2 96 16v80H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v240c0 26.5 21.5 48 48 48h208v-32H150.6L384 150.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80V118.6z"
        }
    ]
};

const FalCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCross",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 40c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v88h88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-88v216c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40V256H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h88V40zm40-8c-4.4 0-8 3.6-8 8v104c0 8.8-7.2 16-16 16H40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h104c8.8 0 16 7.2 16 16v232c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V240c0-8.8 7.2-16 16-16h104c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H240c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8h-48z"
        }
    ]
};

const FalCrosshairsSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrosshairsSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M479.4 240H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h95.4C471.6 383 383 471.6 272 479.4V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v95.4C129 471.6 40.4 383 32.6 272H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H32.6C40.4 129 129 40.4 240 32.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V32.6C383 40.4 471.6 129 479.4 240zM0 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0z"
        }
    ]
};

const FalCrosshairs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrosshairs",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c8.8 0 16 7.2 16 16v32.6c102.1 7.8 183.6 89.3 191.4 191.4H496c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32.6c-7.8 102.1-89.3 183.6-191.4 191.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32.6C137.9 455.6 56.4 374.1 48.6 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h32.6C56.4 137.9 137.9 56.4 240 48.6V16c0-8.8 7.2-16 16-16zM80.7 272c7.6 84.4 74.8 151.7 159.3 159.3V384c0-8.8 7.2-16 16-16s16 7.2 16 16v47.3c84.4-7.6 151.7-74.8 159.3-159.3H384c-8.8 0-16-7.2-16-16s7.2-16 16-16h47.3C423.7 155.6 356.4 88.3 272 80.7V128c0 8.8-7.2 16-16 16s-16-7.2-16-16V80.7C155.6 88.3 88.3 155.6 80.7 240H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80.7zM256 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalCrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.7 412.7 63.2 384h209.4l48.6 118.1c3.4 8.2 12.7 12.1 20.9 8.7s12.1-12.7 8.7-20.9L307.2 384H320c16 0 31.4-1.9 46.3-5.6l50.9 123.7c3.4 8.2 12.7 12.1 20.9 8.7s12.1-12.7 8.7-20.9l-50.2-121.8C464.5 338.5 512 270.8 512 192v-48l128-32c0-44.2-35.8-80-80-80h-72.4C470 12.4 444.4 0 416 0c-53 0-96 43-96 96v51L52.4 352l-8.6 6.6-37.5 28.7c-7 5.4-8.3 15.4-3 22.4s15.4 8.3 22.4 3zM506.5 64H560c18 0 33.7 9.9 41.9 24.5L512 111V96c0-11.2-1.9-22-5.5-32zM132.7 330.8l186.7-143C313.6 250 268 302.1 205.9 315.2l-73.2 15.5zM320 352H186.8l25.7-5.5c81.3-17.2 139.5-89 139.5-172.2V96c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 88.4-71.6 160-160 160zM440 96a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalCrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M309 106c11.4-7 19-19.7 19-34 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-57.3 114.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24 0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40h.7l45.7 251.4c5.5 30.4 32 52.6 63 52.6h277.2c30.9 0 57.4-22.1 63-52.6L535.3 176h.7c22.1 0 40-17.9 40-40s-17.9-40-40-40-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106zM117.9 421.7 78.8 206.4l62.3 49.9c31.8 25.5 79 15.1 97.2-21.4l49.7-99.3 49.7 99.4c18.2 36.4 65.4 46.8 97.2 21.4l62.3-49.9-39.1 215.2c-2.8 15.2-16 26.3-31.5 26.3H149.4c-15.5 0-28.7-11.1-31.5-26.3z"
        }
    ]
};

const FalCrutch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrutch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M292.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l192 192c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-192-192c-6.2-6.2-16.4-6.2-22.6 0zm-96.1 160.1L162.4 199a79.956 79.956 0 0 0-21.9 40.9l-24.4 122c-1.9 9.3-6.4 17.8-13.1 24.5L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l98.3-98.3c6.7-6.7 15.2-11.3 24.5-13.1l122-24.4c15.5-3.1 29.7-10.7 40.9-21.9l34.3-34.3 94.1-94.1-22.6-22.6-82.8 82.8L230.6 176l82.7-82.7-22.6-22.7-94 94-.1.1-.1.1zm11.4 33.8L313.4 304l-23 23c-6.7 6.7-15.2 11.3-24.5 13.1l-117.5 23.5 23.5-117.5c1.9-9.3 6.4-17.8 13.1-24.5l23-23z"
        }
    ]
};

const FalCrutches = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrutches",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m443.3 4.7 192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM290.4 199l34.2-34.2.1-.1.1-.1 94-94 22.6 22.6-82.8 82.8L464 281.4l82.7-82.7 22.6 22.6-94.1 94.1-34.2 34.2a79.956 79.956 0 0 1-40.9 21.9l-122 24.4c-9.3 1.9-17.8 6.4-24.5 13.1l-98.3 98.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l98.3-98.3c6.7-6.7 11.3-15.2 13.1-24.5l24.4-122c3.1-15.5 10.7-29.7 21.9-40.9zm22.6 22.6c-6.7 6.7-11.3 15.2-13.1 24.5l-23.5 117.5 117.5-23.5c9.3-1.9 17.8-6.4 24.5-13.1l23-23L336 198.6l-23 23zM196.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L198.6 48l98.7 98.7-22.6 22.6L176 70.6 70.6 176 176 281.4l66.7-66.7c-2.4 6.1-4.2 12.4-5.5 18.9l-8 39.9-30.6 30.5 20.4 20.4-6.2 31.2c-.3 1.4-.8 2.8-1.4 4.1-4.4-2.9-8.5-6.3-12.3-10.1l-34.3-34.3L48 198.6l-20.7 20.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192zm187.8 402.5 21.9-4.4c5.1-1 10.1-2.4 15-4.1l85.9 85.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L386.4 409c-.6-.6-1.2-1.2-1.9-1.8z"
        }
    ]
};

const FalCruzeiroSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCruzeiroSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 256c0-105.9 86.6-192 193.7-192 49.6 0 94.9 18.5 129.2 48.9 6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6c-39.9-35.4-92.7-57-150.4-57C133.2 32 32 132.2 32 256s101.2 224 225.7 224c57.7 0 110.5-21.6 150.4-57 6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3c-34.2 30.4-79.5 48.9-129.1 48.9-11.5 0-22.7-1-33.7-2.9V320c0-26.5 21.5-48 48-48 15.1 0 29.3 7.1 38.4 19.2l4.8 6.4c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4L336 272c-15.1-20.1-38.8-32-64-32-18 0-34.6 6-48 16v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v196.7C117.3 410 64 339.1 64 256z"
        }
    ]
};

const FalCrystalBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCrystalBall",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 224c0 49.2-18.5 94-48.9 128h40.7c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128h40.7C50.5 318 32 273.2 32 224c0-106 86-192 192-192s192 86 192 192zM64 384c-5.6 0-10.8 2.9-13.7 7.8l-46.2 77c-2.7 4.4-4.1 9.5-4.1 14.7C0 499.2 12.8 512 28.5 512h391c15.8 0 28.5-12.8 28.5-28.5 0-5.2-1.4-10.2-4.1-14.7l-46.2-77c-2.9-4.8-8.1-7.8-13.7-7.8H64zm-29.3 96 38.4-64h301.8l38.4 64H34.7zM288 144c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16zM144 96c-8.8 0-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalCube = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCube",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M261.5 35.1c-3.6-1.3-7.5-1.3-11 0L44.1 110.7 256 194l211.9-83.2-206.4-75.7zM32 385.7c0 6.7 4.2 12.7 10.5 15L240 473.1V222L32 140.3v245.4zm240 87.4 197.5-72.4c6.3-2.3 10.5-8.3 10.5-15V140.3L272 222v251zM239.5 5c10.7-3.9 22.4-3.9 33 0l208 76.3c18.9 6.9 31.5 24.9 31.5 45.1v259.3c0 20.1-12.6 38.1-31.5 45.1l-208 76.2c-10.7 3.9-22.4 3.9-33 0l-208-76.3C12.6 423.8 0 405.8 0 385.7V126.4c0-20.1 12.6-38.1 31.5-45.1L239.5 5z"
        }
    ]
};

const FalCubesStacked = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCubesStacked",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64h-64v64h64V64zm-64-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zM98.7 234.7l32 55.4 55.4-32-32-55.4-55.4 32zm-27.7 16c-8.8-15.3-3.6-34.9 11.7-43.7l55.4-32c15.3-8.8 34.9-3.6 43.7 11.7l32 55.4c8.8 15.3 3.6 34.9-11.7 43.7l-55.4 32c-15.3 8.8-34.9 3.6-43.7-11.7l-32-55.4zM352 224h-64v64h64v-64zm-96 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm96 224h64v-64h-64v64zm-32-64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm-64 0h-64v64h64v-64zm-64-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zM32 384v64h64v-64H32zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-64z"
        }
    ]
};

const FalCubes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCubes",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M293.4 32.8c-3.5-1.2-7.3-1.2-10.8 0l-104 37.1c-2.3.8-4.4 2.2-6.1 3.9L288 118l115.4-44.2c-1.7-1.7-3.7-3-6.1-3.9l-104-37.1zM168 212.8h.1L272 249.9V146.2l-104-39.9v106.5zm136 37.1 103.9-37.1h.1V106.3l-104 39.9v103.7zM440 85v127.8h.1l104 37.1c19.1 6.8 31.9 24.9 31.9 45.2v126.3c0 19.4-11.7 36.9-29.6 44.4l-104 43c-11.8 4.9-25 4.9-36.7 0L288 460.1l-117.6 48.7c-11.8 4.9-25 4.9-36.7 0l-104-43c-18-7.5-29.7-25-29.7-44.4V295.2c0-20.3 12.8-38.4 31.9-45.2l104-37.1h.1V85c0-20.3 12.8-38.4 31.9-45.2l104-37.1c10.4-3.7 21.8-3.7 32.3 0l104 37.1c19 6.8 31.8 24.9 31.8 45.2zM272 308.2l-112 40.4v129.8l112-46.3V308.2zm-230.1 128 86.1 35.6V348.1l-96-39.2v112.5c0 6.5 3.9 12.3 9.9 14.8zM416 478.4V348.6l-112-40.4v123.9l112 46.3zm32-6.6 86.1-35.6c6-2.5 9.9-8.3 9.9-14.8V308.9l-96 39.2v123.7zM157.4 243c-3.5-1.2-7.3-1.2-10.8 0l-102 36.4 99.8 40.8 114.1-41.1L157.4 243zm261.2 0-101.1 36.1 114.1 41.1 99.8-40.8-102-36.4c-3.5-1.2-7.3-1.2-10.8 0z"
        }
    ]
};

const FalCucumber = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCucumber",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m195.9 451.9 256-256c37.5-37.5 37.5-98.3 0-135.8s-98.3-37.5-135.8 0l-256 256c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0zm21.8 23.4c-50 49.2-130.5 48.9-180.2-.8-50-50-50-131 0-181l95.2-95.2c-7-9.4-6.2-22.7 2.3-31.2s21.9-9.3 31.2-2.3L293.5 37.5c50-50 131-50 181 0 49.7 49.7 50 130.2.8 180.2 7 9.4 6.2 22.7-2.3 31.3s-21.8 9.3-31.2 2.3L251.3 441.7c7 9.4 6.2 22.7-2.3 31.2s-21.9 9.3-31.3 2.3zM128 308a20 20 0 1 1 40 0 20 20 0 1 1-40 0zm204-84a20 20 0 1 1 0 40 20 20 0 1 1 0-40zm12-108a20 20 0 1 1 40 0 20 20 0 1 1-40 0z"
        }
    ]
};

const FalCupStrawSwoosh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCupStrawSwoosh",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M202.4 36.4C207.8 15 227 0 249 0h23c8.8 0 16 7.2 16 16s-7.2 16-16 16h-23c-7.3 0-13.7 5-15.5 12.1l-21 83.9H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h163.5l22.9-91.6zM60.3 468l-23-276h32.1l14.5 173.1c29-3.7 48.3-10.6 62.3-18.6 17.1-9.8 27.6-22 39.1-36.1l2-2.5c10.8-13.4 23.2-28.6 42.5-41 19.3-12.3 44.4-21.2 80.6-24.9l4.2-50h32.1l-23 276c-2.1 24.9-22.9 44-47.8 44H108.2c-25 0-45.8-19.1-47.8-44zm247.4-193.5c-29 3.6-47.5 10.9-60.7 19.4-14.8 9.5-24.2 21.1-35.5 35l-1.4 1.7c-11.8 14.5-25.4 30.7-48 43.7-18.7 10.7-42.7 18.6-75.6 22.7l5.7 68.3c.7 8.3 7.6 14.7 15.9 14.7h167.7c8.3 0 15.3-6.4 15.9-14.7l15.9-190.9z"
        }
    ]
};

const FalCupStraw = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCupStraw",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M249 0c-22 0-41.2 15-46.6 36.4L179.5 128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H212.5l21-83.9C235.2 37 241.6 32 249 32h23c8.8 0 16-7.2 16-16s-7.2-16-16-16h-23zM37.3 192l23 276c2.1 24.9 22.9 44 47.8 44h167.7c25 0 45.8-19.1 47.8-44l23-276h-32l-22.8 273.3c-.7 8.3-7.6 14.7-15.9 14.7H108.2c-8.3 0-15.3-6.4-15.9-14.7L69.4 192H37.3z"
        }
    ]
};

const FalCupTogo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCupTogo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M87.9 42.9 70.2 96h307.6l-17.7-53.1c-2.2-6.5-8.3-10.9-15.2-10.9H103.1c-6.9 0-13 4.4-15.2 10.9zM47.6 128H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h20.5l21-63.2C64.1 13.2 82.4 0 103.1 0h241.8c20.7 0 39 13.2 45.5 32.8L411.5 96H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H47.7zm27 325.9L47.4 160h32.1l5.9 64h277.1l5.9-64h32.1l-27.1 293.9c-3 32.9-30.7 58.1-63.7 58.1H138.3c-33.1 0-60.7-25.2-63.7-58.1zm285-197.9H88.4l11.9 128h247.4l11.9-128zm-14.8 160H103.2l3.2 35c1.5 16.5 15.3 29 31.9 29h171.4c16.5 0 30.3-12.6 31.9-29l3.2-35z"
        }
    ]
};

const FalCupcake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCupcake",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5.8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2 0 8.1-6.6 14.7-14.7 14.7H148c-36.2 0-65.8 28.3-67.9 64H80c-44.2 0-80 35.8-80 80s35.8 80 80 80h288c44.2 0 80-35.8 80-80s-35.8-80-80-80C368 57.3 310.7 0 240 0h-32zm32 49.3c0-6-1.1-11.8-3.3-17.3h3.3c53 0 96 43 96 96 0 4-.6 7.8-1.7 11.4-1.4 4.8-.5 10.1 2.5 14.1s7.8 6.4 12.8 6.4H368c26.5 0 48 21.5 48 48s-21.5 48-48 48H80c-26.5 0-48-21.5-48-48s21.5-48 48-48h17.4c4.9 0 9.5-2.2 12.5-6.1s4.1-8.8 3-13.6c-.6-2.7-1-5.4-1-8.3 0-19.9 16.1-36 36-36h45.3c25.9.1 46.8-20.8 46.8-46.6zM89.7 471.4c3.7 23.4 23.8 40.6 47.4 40.6h173.7c23.6 0 43.8-17.2 47.4-40.6L382 320h-32.4l-22.9 146.5c-1.2 7.8-7.9 13.5-15.8 13.5h-29.5l13.3-160h-32.1l-13.3 160h-50.6l-13.3-160h-32.1l13.3 160h-29.5c-7.9 0-14.6-5.7-15.8-13.5L98.4 320H66l23.7 151.4z"
        }
    ]
};

const FalCurlingStone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCurlingStone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 112c0-26.5 21.5-48 48-48h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-44.2 0-80 35.8-80 80v48c-35.3 0-64 28.7-64 64v1.1C41.7 232.9 0 279.6 0 336v32c0 61.9 50.1 112 112 112h352c61.9 0 112-50.1 112-112v-32c0-56.4-41.7-103.1-96-110.9V224c0-35.3-28.7-64-64-64H192v-48zm256 112H128c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32zM112 448c-44.2 0-80-35.8-80-80h512c0 44.2-35.8 80-80 80H112zM32 336c0-44.2 35.8-80 80-80h352c44.2 0 80 35.8 80 80H32z"
        }
    ]
};

const FalCustard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalCustard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m49.8 384 66.3-271.2c7-28.6 32.7-48.8 62.2-48.8h219.5c29.5 0 55.2 20.2 62.2 48.8L526.2 384h-32.9l-40.6-166c-18.1-5.7-37.2-10-52.7-10-18.7 0-32.3 6.4-49.1 14.4l-.7.3c-16.4 7.9-35.8 17.3-62.2 17.3s-45.8-9.4-62.2-17.2l-.7-.3c-16.7-8-30.4-14.4-49.1-14.4-15.5 0-34.6 4.4-52.7 10L82.7 384H49.8zM132 182.3c14.7-3.7 30-6.3 44-6.3 26.4 0 45.8 9.4 62.2 17.2l.7.3c16.7 8 30.4 14.4 49.1 14.4s32.3-6.4 49.1-14.4l.7-.3c16.4-7.9 35.8-17.2 62.2-17.2 14 0 29.3 2.6 44 6.3l-15.1-61.9c-3.6-14.3-16.4-24.4-31.1-24.4H178.2c-14.7 0-27.6 10.1-31.1 24.4L132 182.3zM0 432c0-8.8 7.2-16 16-16h544c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalD = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalD",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 64c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h112c106 0 192-86 192-192S266 64 160 64H48zM0 80c0-26.5 21.5-48 48-48h112c123.7 0 224 100.3 224 224S283.7 480 160 480H48c-26.5 0-48-21.5-48-48V80z"
        }
    ]
};

const FalDagger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDagger",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v112H48c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48v-16h192v16c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48H208V16zM48 160h16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16zm272 0h16c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16v-16zm-80 237.9c0 4.9-1.5 9.7-4.3 13.8L192 474.1l-43.7-62.4c-2.8-4-4.3-8.8-4.3-13.8V192h-32v205.9c0 11.5 3.5 22.7 10.1 32.1l50.2 71.7c4.5 6.4 11.8 10.2 19.7 10.2s15.2-3.8 19.7-10.2l50.2-71.7c6.6-9.4 10.1-20.6 10.1-32.1V192h-32v205.9z"
        }
    ]
};

const FalDash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDash",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalDatabase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDatabase",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 80.4v101.7c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 218.9 270 224 224 224s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3V80.4c.3-.8 1.6-3.2 6.2-7.1 7.3-6.2 19.9-13.2 38.1-19.7C112.6 40.6 164.8 32 224 32s111.4 8.6 147.6 21.6c18.3 6.5 30.8 13.5 38.1 19.7 4.7 4 6 6.4 6.2 7.1zm0 139.1v90.6c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 346.9 270 352 224 352s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3v-90.6c17.2 8.9 38.1 16.3 61.2 21.9 37.5 9.3 82.6 14.6 130.8 14.6s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9zM32 431.6v-84c17.2 8.9 38.1 16.3 61.2 21.9 37.5 9.2 82.6 14.5 130.8 14.5s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9v84c-.3.8-1.6 3.2-6.2 7.1-7.3 6.2-19.9 13.2-38.1 19.7-36.3 13-88.5 21.6-147.7 21.6s-111.4-8.6-147.6-21.6c-18.3-6.5-30.8-13.5-38.1-19.7-4.7-4-6-6.4-6.2-7.1zm384.1-.3a.1.1 0 1 0-.2 0 .1.1 0 1 0 .2 0zm-384.2 0a.1.1 0 1 0 .1 0 .1.1 0 1 0-.1 0zm0-350.6a.1.1 0 1 0 .1-.1.1.1 0 1 0-.1.1zm384.1-.1a.1.1 0 1 0-.1.3.1.1 0 1 0 .1-.3zM448 432V80c0-44.2-100.3-80-224-80S0 35.8 0 80v352c0 44.2 100.3 80 224 80s224-35.8 224-80z"
        }
    ]
};

const FalDeerRudolph = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDeerRudolph",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c8.8 0 16 7.2 16 16v24c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 8.6-1.9 16.7-5.4 24H416c13.3 0 24-10.7 24-24V16c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 22-12.7 41.1-31.2 50.2l35 35C483.1 108 500.2 96 520 96c26.5 0 48 21.5 48 48s-21.5 48-48 48c-2.9 0-5.7-.3-8.4-.7-3.4 27.5-26.8 48.7-55.2 48.7h-52.5l-18.6 61.8c-.9 3-1.4 6.1-1.4 9.2v161c0 22.1-17.9 40-40 40H312c-22.1 0-40-17.9-40-40V368h-14.8c-24.1 0-47.7-5.7-69-16.6-.9 17.8-10.1 34.4-25.3 44.6-9.3 6.2-13.4 17.9-9.8 28.6l11.6 34.8c8.6 25.9-10.6 52.6-37.9 52.6H97.3c-17.2 0-32.5-11-37.9-27.4l-21.5-64.4c-4.4-13.1-4.4-27.3 0-40.5l8.5-25.4c1.1-3.3 1.6-6.7 1.6-10.1v-4.3c0-8.5-3.4-16.6-9.4-22.6l-3.9-3.9c-.7-.7-1.5-1.5-2.2-2.3L32 321c-.6 8.8-8.1 15.5-17 15s-15.5-8.1-15-17l3.3-53c3.2-50.6 45.1-90 95.8-90h201.6l10-35.9-13.8 9.2c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l40-26.7H280c-30.9 0-56-25.1-56-56V16c0-8.8 7.2-16 16-16zm108.3 124.2-20 72.1c-1.9 6.9-8.2 11.7-15.4 11.7H104c-30.9 0-56 25.1-56 56v4.1c0 8.5 3.4 16.6 9.4 22.6l3.9 3.9c12 12 18.7 28.3 18.7 45.3v4.3c0 6.9-1.1 13.7-3.3 20.2l-8.5 25.4c-2.2 6.6-2.2 13.7 0 20.2l21.5 64.4c1.1 3.3 4.1 5.5 7.6 5.5h29.4c5.5 0 9.3-5.4 7.6-10.5l-11.6-34.8c-8.1-24.3 1.1-51.1 22.4-65.3 8.2-5.4 12.4-15.1 10.8-24.8l-3.7-21.9c-1-6.3 1.7-12.6 7.1-16.1s12.3-3.4 17.6.1l13.7 9.2c19.7 13.2 42.9 20.2 66.6 20.2H288c8.8 0 16 7.2 16 16v120c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V311c0-6.2.9-12.4 2.7-18.4l22-73.3c2-6.8 8.3-11.4 15.3-11.4h64.4c13 0 23.6-10.6 23.6-23.6 0-6.3-2.5-12.3-6.9-16.7l-60.4-60.4c-7.2-7.2-17-11.3-27.2-11.3-17.3 0-32.5 11.5-37.1 28.2zM400 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm136 16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalDeer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDeer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 30.9 25.1 56 56 56h39.2l-40 26.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l13.8-9.2-10 35.9H99.2c-50.7 0-92.7 39.4-95.8 90L0 319c-.6 8.8 6.2 16.4 15 17s16.4-6.2 17-15l.6-9.9c.7.8 1.4 1.5 2.2 2.3l3.9 3.9c6 6 9.4 14.1 9.4 22.6v4.3c0 3.4-.6 6.9-1.6 10.1L38 379.7c-4.4 13.1-4.4 27.3 0 40.5l21.5 64.4C64.8 501 80.1 512 97.3 512h29.4c27.3 0 46.6-26.7 37.9-52.6L153 424.6c-3.6-10.7.5-22.4 9.8-28.6 15.2-10.1 24.4-26.8 25.3-44.6 21.3 10.9 45 16.6 69 16.6H272v104c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V311c0-3.1.5-6.2 1.4-9.2l18.5-61.8h52.5c30.7 0 55.6-24.9 55.6-55.6 0-14.7-5.9-28.9-16.3-39.3l-54.9-54.9C459.3 81.1 472 62 472 40V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 13.3-10.7 24-24 24h-69.4c3.5-7.3 5.4-15.4 5.4-24V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24V16zm129.4 80c10.2 0 20 4.1 27.2 11.3l60.4 60.4c4.4 4.4 6.9 10.4 6.9 16.7 0 13-10.6 23.6-23.6 23.6H392c-7.1 0-13.3 4.6-15.3 11.4l-22 73.3c-1.8 6-2.7 12.2-2.7 18.4V472c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8V352c0-8.8-7.2-16-16-16h-30.8c-23.7 0-46.9-7-66.6-20.2l-13.7-9.2c-5.3-3.5-12.2-3.6-17.6-.1s-8.1 9.8-7.1 16.1l3.7 21.9c1.6 9.7-2.6 19.4-10.8 24.8-21.4 14.2-30.5 41-22.4 65.3l11.6 34.8c1.7 5.2-2.1 10.5-7.6 10.5H97.3c-3.4 0-6.5-2.2-7.6-5.5l-21.5-64.3c-2.2-6.6-2.2-13.7 0-20.2l8.5-25.4c2.2-6.5 3.3-13.4 3.3-20.2V340c0-17-6.7-33.3-18.7-45.3l-3.9-3.9c-6-6-9.4-14.1-9.4-22.6V264c0-30.9 25.1-56 56-56h208.9c7.2 0 13.5-4.8 15.4-11.7l20-72.1C353 107.5 368.1 96 385.4 96zm30.6 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalDeleteLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDeleteLeft",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 128c0-17.7-14.3-32-32-32H205.3c-8.5 0-16.6 3.4-22.6 9.4L32 256l150.6 150.6c6 6 14.1 9.4 22.6 9.4H512c17.7 0 32-14.3 32-32V128zm-32-64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H205.3c-17 0-33.3-6.7-45.3-18.7L9.4 278.6c-6-6-9.4-14.1-9.4-22.6s3.4-16.6 9.4-22.6L160 82.7c12-12 28.3-18.7 45.3-18.7H512zm-84.7 116.7c6.2 6.2 6.2 16.4 0 22.6L374.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalDeleteRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDeleteRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 128c0-17.7 14.3-32 32-32h306.7c8.5 0 16.6 3.4 22.6 9.4L544 256 393.4 406.6c-6 6-14.1 9.4-22.6 9.4H64c-17.7 0-32-14.3-32-32V128zm32-64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h306.7c17 0 33.3-6.7 45.3-18.7l150.6-150.7c6-6 9.4-14.1 9.4-22.6s-3.4-16.6-9.4-22.6L416 82.7c-12-12-28.3-18.7-45.3-18.7H64zm84.7 116.7c-6.2 6.2-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L246.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalDemocrat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDemocrat",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M92.9 0C84.3 0 76 4.6 71.6 12.6c-2.4 4.3-6 11.3-9.2 18.7C59.6 37.9 56 47.5 56 56c0 16 6.9 29.6 14.8 40.1l-51.3 59.4C6.9 170 0 188.6 0 207.8v5.4C0 254.5 33.5 288 74.7 288c17.5 0 34.4-6.1 47.8-17.3l13.7-11.4 23.8 71.3V464c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48v-48h128v48c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V208c0-4.9-.4-9.7-1.3-14.4 2.9 2.9 5.5 5.8 8 8.7 9.2 10.9 15.9 21.8 20.2 30.1 2.2 4.1 3.7 7.5 4.7 9.8.5 1.1.9 2 1.1 2.6l.2.6v.1c3 8.3 12.2 12.6 20.5 9.5s12.6-12.2 9.6-20.5l-15 5.5 15-5.5v-.1l-.1-.3-.4-1c-.3-.9-.8-2-1.5-3.5-1.3-2.9-3.2-7.1-5.7-12-5.1-9.8-13-22.8-24.1-35.9-22.2-26.2-58.3-53.6-111-53.7H277.5c-4.3 0-8.5-1.7-11.5-4.8l-40.1-41.3c3.6-7.6 6.1-16.3 6.1-25.9 0-8.5-3.6-18.1-6.4-24.7-3.1-7.4-6.8-14.4-9.2-18.7C212 4.6 203.7 0 195.1 0c-5.8 0-11.4 2-15.8 5.8L144 35.5 108.7 5.8C104.3 2 98.7 0 92.9 0zm403 160h.3c26.4.1 47.8 21.5 47.8 48v112H190.2l-31-93.1c-1.7-5-5.7-8.9-10.8-10.3s-10.6-.3-14.6 3.1l-31.7 26.4c-7.7 6.4-17.4 9.9-27.4 9.9-23.6 0-42.7-19.1-42.7-42.7v-5.4c0-11.5 4.1-22.7 11.7-31.4l60.4-69.9c5.5-6.3 5.1-15.9-.8-21.8C94.2 75.6 88 65.5 88 56v-.3c0-.2.1-.5.1-.9.1-.8.4-1.7.7-2.9.7-2.4 1.7-5.2 3-8.2 1.1-2.5 2.3-5.1 3.4-7.5l37.5 31.5c3.7 3.1 8.5 4.4 13.3 3.5.6-.1 1.1-.2 1.7-.3 3-.4 5.7-1.7 8-3.6l37-31.1c1.2 2.4 2.3 4.9 3.4 7.5 1.3 3 2.3 5.8 3 8.2.3 1.2.6 2.1.7 2.9.1.4.1.7.1.9v.3c0 6.1-2.5 12.5-7.2 19.1-4.4 6.3-3.8 14.9 1.6 20.4l48.7 50c9 9.3 21.4 14.5 34.4 14.5h218.5zM192 464V352h352v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8-7.2-16-16-16H288c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16zm80-256c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16zm96-16c-8.8 0-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalDesktopArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDesktopArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0h176v32H64c-17.7 0-32 14.3-32 32v192h512V64c0-17.7-14.3-32-32-32H336V0h176c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zM32 288v64c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-64H32zm202.9 192h106.2l-10.7-64h-84.8l-10.7 64zM304 16v153.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalDesktop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDesktop",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32H64c-17.7 0-32 14.3-32 32v192h512V64c0-17.7-14.3-32-32-32zm64 224v96c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v192zM32 288v64c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-64H32zm202.9 192h106.2l-10.7-64h-84.8l-10.7 64z"
        }
    ]
};

const FalDharmachakra = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDharmachakra",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c8.8 0 16 7.2 16 16v32.6c45.4 3.5 86.7 21.5 119.3 49.4l23.1-23c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-23 23.1c27.9 32.6 46 73.9 49.4 119.3H496c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32.6c-3.5 45.4-21.5 86.7-49.4 119.3l23 23.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-23.1-23c-32.6 27.9-73.9 46-119.3 49.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32.6c-45.4-3.5-86.7-21.5-119.3-49.4l-23.1 23c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l23-23.1C70.1 358.7 52 317.4 48.6 272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h32.6c3.5-45.4 21.5-86.7 49.4-119.3L75 97.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l23.1 23c32.6-27.9 73.9-46 119.3-49.4V16c0-8.8 7.2-16 16-16zM120.7 143.4c-22.2 26.7-36.7 60-40 96.6h80.6c2.4-14.4 8.1-27.9 16.4-39.6l-57-57zm79.6 34.4c11.4-8.1 24.9-13.9 39.6-16.4V80.7c-36.6 3.3-69.9 17.8-96.6 40l57 57zm10.2 33.2c-11.5 11.6-18.4 27.5-18.5 44.5v1c0 3.3.3 6.7.9 10.1 2.3 13.5 8.6 25.3 17.6 34.4l.3.3c.1.1.2.2.2.3 11.6 11.5 27.5 18.4 44.5 18.5h1c3.3 0 6.7-.3 10.1-.9 13.5-2.3 25.3-8.6 34.4-17.6l.3-.3.2-.2c14-14.1 21.2-34.5 17.6-55.6-2.3-13.5-8.6-25.3-17.6-34.4l-.3-.3-.2-.2c-11.6-11.5-27.5-18.4-44.5-18.5h-1c-3.3 0-6.7.3-10.1.9-13.5 2.3-25.3 8.6-34.4 17.6l-.3.3c-.1.1-.2.2-.3.2zm-32.8 100.6c-8.1-11.4-13.9-24.9-16.4-39.6H80.7c3.3 36.6 17.8 69.9 40 96.6l57-57zm-34.4 79.6c26.7 22.2 60 36.7 96.6 40v-80.5c-14.4-2.4-27.9-8.1-39.6-16.4l-57 57zm168.3-57c-11.4 8.1-24.9 13.9-39.6 16.4v80.6c36.6-3.3 69.9-17.8 96.6-40l-57-57zm79.6 34.4c22.2-26.7 36.7-60 40-96.6h-80.5c-2.4 14.4-8.1 27.9-16.4 39.6l57 57zm-57-168.3c8.1 11.4 13.9 24.9 16.4 39.6h80.6c-3.3-36.6-17.8-69.9-40-96.6l-57 57zm34.4-79.6c-26.7-22.2-60-36.7-96.6-40v80.6c14.4 2.4 27.9 8.1 39.6 16.4l57-57z"
        }
    ]
};

const FalDiagramCells = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramCells",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v64zm-32 64c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h384zm64 192v-64c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64zm-64 32H64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32z"
        }
    ]
};

const FalDiagramLeanCanvas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramLeanCanvas",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64v256h96V96c0-17.7-14.3-32-32-32h-64zm-32 0h-96v128h96V64zm-128 0h-64v256h64V64zm-96 0h-96v128h96V64zm-128 0H64c-17.7 0-32 14.3-32 32v224h96V64zM32 352v64c0 17.7 14.3 32 32 32h240v-96H32zm304 96h240c17.7 0 32-14.3 32-32v-64H336v96zM0 96c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm256 224v-96h-96v96h96zm224-96h-96v96h96v-96z"
        }
    ]
};

const FalDiagramNested = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramNested",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h96zm-32 160h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v96c0 26.5 21.5 48 48 48h32v96c0 44.2 35.8 80 80 80h96v32c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v32h-96c-26.5 0-48-21.5-48-48v-96zm176 144v-32c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-64z"
        }
    ]
};

const FalDiagramNext = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramNext",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v64zm-208 64h176c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h176v105.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V224zm176 256c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384z"
        }
    ]
};

const FalDiagramPredecessor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramPredecessor",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 352c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-64zm32 64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64zM256 96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V96zm23.4-32c5.4 9.4 8.6 20.3 8.6 32v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h304c35.3 0 64 28.7 64 64v89.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7V96c0-17.7-14.3-32-32-32h-88.6zM96 112h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalDiagramPrevious = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramPrevious",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 352c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-64zm-208-64h176c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h176V182.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 182.6V288zM448 32c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384z"
        }
    ]
};

const FalDiagramProject = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramProject",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 64c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24h80zm56 104v-24h192v24c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56v24H192V88c0-30.9-25.1-56-56-56H56C25.1 32 0 57.1 0 88v80c0 30.9 25.1 56 56 56h80c8.6 0 16.7-1.9 24-5.4l72.2 96.3c-5.2 8.5-8.2 18.5-8.2 29.1v80c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-80c0-30.9-25.1-56-56-56h-80c-8.6 0-16.7 1.9-24 5.4l-72.2-96.3c5.2-8.5 8.2-18.5 8.2-29.1zm224 0V88c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24zm-56 152c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h80z"
        }
    ]
};

const FalDiagramSankey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramSankey",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.1 64c-5.6 0-10.8 2.9-13.7 7.8L263 200.7c-8.7 14.5-24.3 23.3-41.2 23.3H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h205.9c5.6 0 10.8-2.9 13.7-7.8L313 55.3c8.6-14.5 24.3-23.3 41.1-23.3H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H354.1zM201.7 320l74.5 120.4c2.9 4.7 8.1 7.6 13.6 7.6H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H289.8c-16.6 0-32.1-8.6-40.8-22.7L164 320H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h164.9l.7-.4.3.4H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H201.7z"
        }
    ]
};

const FalDiagramSubtask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramSubtask",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h384zM144 224h304c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h48v96c0 44.2 35.8 80 80 80h32v16c0 35.3 28.7 64 64 64h160c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64H288c-35.3 0-64 28.7-64 64v16h-32c-26.5 0-48-21.5-48-48v-96zm304 96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h160z"
        }
    ]
};

const FalDiagramSuccessor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramSuccessor",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 352c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-64zm32 64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64zM256 96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V96zm23.4-32c5.4 9.4 8.6 20.3 8.6 32v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h304c35.3 0 64 28.7 64 64v89.4l36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7V96c0-17.7-14.3-32-32-32h-88.6zM96 368h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalDiagramVenn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiagramVenn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 448c-106 0-192-86-192-192S118 64 224 64c21.5 0 42.1 3.5 61.4 10-56.6 40.7-93.4 107-93.4 182s36.8 141.3 93.4 182c-19.3 6.5-39.9 10-61.4 10zm191.3-208H224.7c1.4-16.7 4.9-32.8 10.3-48h170.1c5.4 15.2 8.9 31.3 10.3 48zm-190.6 32h190.6c-1.4 16.7-4.9 32.8-10.3 48H234.9c-5.4-15.2-8.9-31.3-10.3-48zm25 80h140.6c-16.9 29.1-41.2 53.5-70.3 70.3-29.1-16.9-53.5-41.2-70.3-70.3zm0-192c16.9-29.1 41.2-53.5 70.3-70.3 29.1 16.9 53.5 41.2 70.3 70.3H249.7zM224 480c34.4 0 66.9-7.7 96-21.6 29.1 13.8 61.6 21.6 96 21.6 123.7 0 224-100.3 224-224S539.7 32 416 32c-34.4 0-66.9 7.7-96 21.6C290.9 39.7 258.4 32 224 32 100.3 32 0 132.3 0 256s100.3 224 224 224zM416 64c106 0 192 86 192 192s-86 192-192 192c-21.5 0-42.1-3.5-61.4-10 56.6-40.7 93.4-107 93.4-182s-36.8-141.3-93.4-182c19.3-6.5 39.9-10 61.4-10z"
        }
    ]
};

const FalDialHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDialHigh",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 248h127c-7.9 63.1-61.7 112-127 112-70.7 0-128-57.3-128-128s57.3-128 128-128c65.3 0 119.1 48.9 127 112H288c-8.8 0-16 7.2-16 16s7.2 16 16 16zm160-16a160 160 0 1 0-320 0 160 160 0 1 0 320 0zm120 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDialLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDialLow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0 360c-65.3 0-119.1-48.9-127-112h127c8.8 0 16-7.2 16-16s-7.2-16-16-16H161c7.9-63.1 61.7-112 127-112 70.7 0 128 57.3 128 128s-57.3 128-128 128zM128 288a160 160 0 1 0 320 0 160 160 0 1 0-320 0zm440 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDialMax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDialMax",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm90.5 322.5-.4.4.8-.8-.4.4zm-79.2-101.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l89.8 89.8c-50.2 39.1-122.8 35.5-169-10.6-50-50-50-131 0-181s131-50 181 0c46.2 46.2 49.7 118.8 10.6 169l-89.8-89.8zm101.8 124.4a160 160 0 1 0-226.2-226.2 160 160 0 1 0 226.2 226.2zM568 288a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDialMedLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDialMedLow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-90.5 322.5c-46.2-46.2-49.7-118.8-10.6-169l89.8 89.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-89.8-89.8c50.2-39.1 122.9-35.5 169 10.6 50 50 50 131 0 181s-131 50-181 0zm-22.6-203.6a160 160 0 1 0 226.2 226.2 160 160 0 1 0-226.2-226.2zM568 288a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDialMed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDialMed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm16 232V161c63.1 7.9 112 61.7 112 127 0 70.7-57.3 128-128 128s-128-57.3-128-128c0-65.3 48.9-119.1 112-127v127c0 8.8 7.2 16 16 16s16-7.2 16-16zm-16-160a160 160 0 1 0 0 320 160 160 0 1 0 0-320zm280 160a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDialMin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDialMin",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-11.3 220.7-89.8 89.8c-39.1-50.2-35.5-122.9 10.6-169 50-50 131-50 181 0s50 131 0 181c-46.2 46.2-118.8 49.7-169 10.6l89.8-89.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM174.9 401.1a160 160 0 1 0 226.2-226.2 160 160 0 1 0-226.2 226.2zM568 288a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDialOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDialOff",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-16 232v127c-63.1-7.9-112-61.7-112-127 0-70.7 57.3-128 128-128s128 57.3 128 128c0 65.3-48.9 119.1-112 127V288c0-8.8-7.2-16-16-16s-16 7.2-16 16zm16 160a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm280-160a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDial = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDial",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm11.3 243.3 89.8-89.8c39.1 50.2 35.5 122.9-10.6 169-50 50-131 50-181 0s-50-131 0-181c46.2-46.2 118.8-49.7 169-10.6l-89.8 89.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm101.8-124.4a160 160 0 1 0-226.2 226.2 160 160 0 1 0 226.2-226.2zM568 288a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM32 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM120 480a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDiamondExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiamondExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216zm-34-22.6c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM256 128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-24 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalDiamondHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiamondHalfStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 44.7v422.6l205.7-205.6c3.1-3.1 3.1-8.2 0-11.3L272 44.7zm-32 422.6V44.7L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3L240 467.3zM227.7 11.7c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216z"
        }
    ]
};

const FalDiamondHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiamondHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M227.7 11.7C235.5 3.9 245.8 0 256 0v512c-10.2 0-20.5-3.9-28.3-11.7l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zM224 451.3V60.7L34.3 250.3c-3.1 3.1-3.1 8.2 0 11.3L224 451.3z"
        }
    ]
};

const FalDiamondTurnRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiamondTurnRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M261.7 34.3c-3.1-3.1-8.2-3.1-11.3 0l-216 216c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3l-216-216zm-34-22.6c15.6-15.6 40.9-15.6 56.6 0l216 216c15.6 15.6 15.6 40.9 0 56.6l-216 216c-15.6 15.6-40.9 15.6-56.6 0l-216-216c-15.6-15.6-15.6-40.9 0-56.6l216-216zm65 137c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7H232c-13.3 0-24 10.7-24 24v56c0 8.8-7.2 16-16 16s-16-7.2-16-16v-56c0-30.9 25.1-56 56-56h97.4l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiamond",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M250.3 34.3c3.1-3.1 8.2-3.1 11.3 0l216 216c3.1 3.1 3.1 8.2 0 11.3l-216 216c-3.1 3.1-8.2 3.1-11.3 0l-216-216c-3.1-3.1-3.1-8.2 0-11.3l216-216zm33.9-22.6c-15.6-15.6-40.9-15.6-56.6 0l-216 216c-15.6 15.6-15.6 40.9 0 56.6l216 216c15.6 15.6 40.9 15.6 56.6 0l216-216c15.6-15.6 15.6-40.9 0-56.6l-216-216z"
        }
    ]
};

const FalDiceD10 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceD10",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m213.8 84.1-158.2 180 92.7-21.8 65.5-158.2zM48.6 298.6l191.4 165v-135l-83.1-55.4-108.3 25.4zm223.4 165 191.4-165-108.3-25.4-83.1 55.4v135zm184.4-199.5-158.2-180 65.4 158.2 92.7 21.8zM256 0c6.9 0 13.5 3 18 8.2l232 264c4.2 4.8 6.4 11.1 5.9 17.5s-3.4 12.3-8.3 16.5l-232 200c-9 7.8-22.3 7.8-31.3 0l-232-200C3.5 302 .5 296 .1 289.7S1.7 277 6 272.2l232-264C242.5 3 249.1 0 256 0zm0 300.8 76.2-50.8L256 65.8 179.8 250l76.2 50.8z"
        }
    ]
};

const FalDiceD12 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceD12",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200.3 32c-2.8 0-5.6.7-8 2.1l-63.6 36.8L256 111.2l127.3-40.3-63.6-36.8c-2.4-1.4-5.2-2.1-8-2.1H200.3zM92 92.8c-.8.9-1.6 1.9-2.2 2.9l-55.6 96.5c.6.5 1.2 1 1.7 1.6l95.8 106.4L240 246.1V139.7L92 92.8zM32 237.3v74.4c0 2.8.7 5.6 2.1 8l55.7 96.5c1.4 2.4 3.4 4.5 5.9 5.9l62.7 36.2-44.5-130-81.9-91zM199.7 480h112c.7 0 1.4 0 2.1-.1l50.6-151.8L256 273.9l-108.3 54.2 52 151.9zM355 457.5l61.2-35.4c2.4-1.4 4.5-3.4 5.9-5.9l55.7-96.5c1.4-2.4 2.1-5.2 2.1-8v-74.4L398 328.2l-43 129.3zm122.8-265.3-55.7-96.5c-.6-1.1-1.3-2-2.2-2.9L272 139.7v106.4l108.3 54.1 95.8-106.4c.5-.6 1.1-1.1 1.7-1.6zM176.3 6.4c7.3-4.2 15.6-6.4 24-6.4h111.4c8.4 0 16.7 2.2 24 6.4l96.5 55.7c7.3 4.2 13.4 10.3 17.6 17.6l55.7 96.5c4.2 7.3 6.4 15.6 6.4 24v111.5c0 8.4-2.2 16.7-6.4 24l-55.7 96.5c-4.2 7.3-10.3 13.4-17.6 17.6l-96.5 55.7c-7.3 4.2-15.6 6.4-24 6.4H200.3c-8.4 0-16.7-2.2-24-6.4l-96.6-55.7c-7.3-4.2-13.4-10.3-17.6-17.6L6.4 335.7c-4.2-7.3-6.4-15.6-6.4-24V200.3c0-8.4 2.2-16.7 6.4-24l55.8-96.6c4.2-7.3 10.3-13.4 17.6-17.6l96.5-55.7z"
        }
    ]
};

const FalDiceD20 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceD20",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M217.5 56.4 77.9 140.2l61.4 44.7 78.2-128.5zM64 169.6v150.7l59.2-107.6L64 169.6zM104.8 388 240 469.1v-70.3L104.8 388zM272 469.1 407.2 388 272 398.8v70.3zm176-148.8V169.6l-59.2 43L448 320.3zm-13.9-180.1L294.5 56.4l78.2 128.4 61.4-44.7zM243.7 3.4c7.6-4.6 17.1-4.6 24.7 0l200 120c7.2 4.3 11.7 12.1 11.7 20.6v224c0 8.4-4.4 16.2-11.7 20.6l-200 120c-7.6 4.6-17.1 4.6-24.7 0l-200-120C36.4 384.2 32 376.4 32 368V144c0-8.4 4.4-16.2 11.7-20.6l200-120zm-18.4 362.1L145 239.4 81.9 354l143.3 11.5zM338.9 224H173.1L256 354.2 338.9 224zM256 54.8 172.5 192h167L256 54.8zm30.7 310.7L430.1 354 367 239.4l-80.3 126.1z"
        }
    ]
};

const FalDiceD4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceD4",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240.1 56.5 35.4 310.6l204.7 155.3V56.5zm32 409.2 204.5-155.1L272.1 56.7v409.1zM256 0c7.3 0 14.1 3.3 18.7 8.9l232 288c4.1 5.1 5.9 11.5 5.1 18s-4.1 12.3-9.3 16.2l-232 176c-8.6 6.5-20.4 6.5-29 0l-232-176c-5.2-3.9-8.5-9.8-9.3-16.2s1.1-12.9 5.1-18l232-288C241.9 3.3 248.7 0 256 0z"
        }
    ]
};

const FalDiceD6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceD6",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M220.1 35.6 47.9 136.2l176 101.2L400 133 228 35.5l11.6-20.4-11.5 20.4c-2.5-1.4-5.5-1.4-8 .1zM32 164v202.6c0 2.9 1.6 5.6 4.1 7L208 469.9V265.3L32 164zm208 305.9 171.9-96.3c2.5-1.4 4.1-4.1 4.1-7V160.8L240 265.1v204.8zm-36.1-462c12.3-7.2 27.5-7.3 39.9-.3L427.7 112c12.5 7.1 20.3 20.4 20.3 34.8v219.8c0 14.5-7.8 27.8-20.5 34.9l-184 103c-12.1 6.8-26.9 6.8-39.1 0l-184-103C7.8 394.4 0 381.1 0 366.6V150.1c0-14.2 7.5-27.4 19.8-34.5L203.9 7.9z"
        }
    ]
};

const FalDiceD8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceD8",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 51.3 44.3 247.1l195.7 81V51.3zM72.8 293.5 240 460.7v-98L72.8 293.5zM272 460.7l167.2-167.2L272 362.7v98zm195.8-213.6L272 51.3v276.8l195.8-81zM239 7c9.4-9.4 24.6-9.4 33.9 0L505 239c9.4 9.4 9.4 24.6 0 33.9L273 505c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L239 7z"
        }
    ]
};

const FalDiceFive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceFive",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm216 24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalDiceFour = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceFour",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 168a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDiceOne = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceOne",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalDiceSix = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceSix",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-24 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168-120a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm24 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-216 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDiceThree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceThree",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalDiceTwo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiceTwo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDice",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M252.3 57c-15.6-15.6-40.9-15.6-56.6 0L57 195.7c-15.6 15.6-15.6 40.9 0 56.6L195.7 391c15.6 15.6 40.9 15.6 56.6 0L391 252.3c15.6-15.6 15.6-40.9 0-56.6L252.3 57zm-79.2-22.7c28.1-28.1 73.7-28.1 101.8 0l138.8 138.8c28.1 28.1 28.1 73.7 0 101.8L274.9 413.7c-28.1 28.1-73.7 28.1-101.8 0L34.3 274.9c-28.1-28.1-28.1-73.7 0-101.8L173.1 34.3zM320 448v-34.2l32-32V448c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H466.7c0-10.8-1.7-21.6-5-32H576c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64H384c-35.3 0-64-28.7-64-64zm160-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM224 144a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-104 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 152a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm104-152a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalDinosaur = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDinosaur",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M417.6 19.2C426.7 7.1 440.9 0 456 0h13c94.5 0 171 76.5 171 170.9v50.9c0 76.5-39.4 147.6-104.3 188.2L512 424.9V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-11c-3.5.9-7.5 1.8-11.7 2.6-14.2 3-32.3 6-52.4 7.5-.5-11.2-3.4-21.9-8.2-31.5 20.5-1.1 39.4-4.1 54-7.2 9.1-1.9 16.5-3.8 21.6-5.3 2.5-.7 4.5-1.3 5.8-1.7.6-.2 1.1-.4 1.4-.5l.3-.1h.1c4.9-1.6 10.2-.8 14.4 2.2s6.6 7.8 6.6 13v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-47.7c0-2.8.6-5.6 2-8s3.4-4.5 5.8-6l31-19.4c55.5-34.7 89.2-95.6 89.2-161v-51C608 94.2 545.8 32 469.1 32H456c-5.1 0-9.8 2.4-12.8 6.4l-6.8 9.1c-6.7 8.9-15.8 15.9-26.1 20-11 4.4-18.2 15.1-18.2 26.9v1.8c0 17.5 14.2 31.7 31.7 31.7h74.5c34.1 0 61.8 27.7 61.8 61.8v23c0 32.7-26.5 59.1-59.1 59.1-27.3 0-53.9-8.5-76.2-24.4l-26-18.6c-33.7-24.1-74-37-115.4-37-49.6 0-97.3 18.5-133.9 51.9l-88.4 80.7c-18.5 17-29.1 41-29.1 66.1 0 49.4 40.1 89.5 89.5 89.5h121c7.5 0 13.5-6.1 13.5-13.5 0-6.4-4.4-11.9-10.7-13.2l-97.6-21.1C117.5 425.6 96 398.9 96 368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 15.8 11 29.5 26.5 32.8l97.6 21.2c20.9 4.5 35.9 23 35.9 44.5 0 25.1-20.4 45.5-45.5 45.5h-121C54.4 512 0 457.6 0 390.5c0-34.1 14.4-66.7 39.6-89.7l88.2-80.5c42.5-38.8 97.9-60.3 155.5-60.3 48.1 0 94.9 15 134 43l26 18.6c16.8 12 36.9 18.4 57.6 18.4 15 0 27.1-12.1 27.1-27.1v-23c0-16.5-13.4-29.8-29.8-29.8h-74.5c-35.2 0-63.7-28.5-63.7-63.7v-1.9c0-24.9 15.2-47.4 38.3-56.6 4.9-2 9.2-5.3 12.4-9.5l6.8-9.1zM448 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalDiploma = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiploma",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M253.2 80.8C245 70.2 232.4 64 219 64h-3c-22.1 0-40 17.9-40 40s17.9 40 40 40h85.8l-48.6-63.2zm-97 63.2c-7.7-11.4-12.1-25.2-12.1-40 0-39.8 32.2-72 72-72h3c23.3 0 45.3 10.8 59.5 29.3l41.4 53.9 41.5-53.9C375.7 42.8 397.7 32 421 32h3c39.8 0 72 32.2 72 72 0 14.8-4.5 28.6-12.1 40H544c65.1.3 96 71.5 96 128 0 56.9-24.1 119.2-81 140.7-10.5 4-22.5 4.2-33.4 1.8L400 386.6V464c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6.7L320 449.9l-56.8 28.4c-5 2.5-10.9 2.2-15.6-.7s-7.6-8.1-7.6-13.6v-77.4l-125.6 27.9-6.9-31.2L240 353.8V176H96.1c-18.9.1-33.9 9.9-45.5 28.1C38.5 223.1 32 248.8 32 272c0 50.8 21.4 96.1 60.3 110.8 3.5 1.3 9.1 1.8 15.1.5l6.9 31.2c-10.9 2.4-22.9 2.2-33.4-1.8C24.1 391.2 0 328.9 0 272c0-56.5 30.9-127.7 96-128h60.1zM400 176v177.8l132.6 29.5c6 1.3 11.6.9 15.1-.5 38.9-14.7 60.3-60 60.3-110.8 0-23.2-6.5-48.9-18.6-67.9-11.6-18.2-26.6-28-45.5-28.1H400zm24-32c22.1 0 40-17.9 40-40s-17.9-40-40-40h-3c-13.4 0-26 6.2-34.1 16.8L338.2 144H424zm-88 32h-64v262.1l40.8-20.4c4.5-2.3 9.8-2.3 14.3 0l40.9 20.4V176h-32z"
        }
    ]
};

const FalDiscDrive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDiscDrive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64h320c17.7 0 32 14.3 32 32v352H64V96c0-17.7 14.3-32 32-32zm384 384V96c0-35.3-28.7-64-64-64H96c-35.3 0-64 28.7-64 64v352H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16zm-224-64a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM96 256a160 160 0 1 0 320 0 160 160 0 1 0-320 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalDisease = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDisease",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64.1 280.3c0-15.6-6.2-30.5-17.2-41.5l-29.2-29.2A60.101 60.101 0 0 1 .1 167.1c0-37.2 33.4-65.5 70.1-59.4l59.6 9.9c37.9 6.3 76-10.2 97.3-42.1l9.4-14.1C248.7 43 269.2 32 291.3 32c30.9 0 57.6 21.4 64.3 51.5l7.1 31.5c8.1 36.2 37.1 64 73.6 70.7l28 5.1c27.7 5.1 47.8 29.2 47.8 57.3 0 24.1-14.8 45.6-37.2 54.3L438 316.7c-32.5 12.6-53.9 43.9-53.9 78.8v25.2c0 32.7-26.5 59.3-59.3 59.3-13.5 0-26.5-4.6-37-13l-30.9-24.7c-21.3-17-47.7-26.3-75-26.3h-10c-7.9 0-15.8.9-23.6 2.6l-62.2 13.8c-36 8-70.1-19.4-70.1-56.2 0-15.5 6.2-30.3 17.3-41.2l13.1-12.8c11.3-11 17.7-26.2 17.7-42zM253.6 93.2c-28.3 42.4-78.9 64.3-129.2 56l-59.6-9.9C47.6 136.4 32 149.7 32 167.1c0 7.5 3 14.6 8.3 19.9l29.2 29.2c17 17 26.6 40.1 26.6 64.1 0 24.4-9.8 47.8-27.3 64.8l-13.1 12.8c-4.9 4.8-7.7 11.4-7.7 18.3 0 16.4 15.1 28.5 31.1 25l62.3-13.8c10-2.2 20.3-3.4 30.5-3.4h10c34.5 0 68 11.7 94.9 33.3l31 24.7c4.8 3.9 10.8 6 17 6 15.1 0 27.3-12.2 27.3-27.3v-25.2c0-48.1 29.5-91.2 74.3-108.6l36.9-14.3c10.1-3.9 16.8-13.7 16.8-24.5 0-12.7-9.1-23.6-21.6-25.9l-28-5.1c-49.1-9-88.1-46.4-99-95.2l-7.1-31.5C320.9 75 307.2 64 291.3 64c-11.3 0-21.9 5.7-28.2 15.1l-9.4 14.1zM304 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-168 32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm152 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalDisplayArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDisplayArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0h176v32H64c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H336V0h176c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm181.6 416-10.7 64h106.2l-10.7-64h-84.8zM304 16v217.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalDisplayChartUpCircleCurrency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDisplayChartUpCircleCurrency",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h448c17.7 0 32 14.3 32 32v134.6c11.2 3.2 21.9 7.4 32 12.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h149.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h250.8c-12.9-9.1-24.5-19.9-34.6-32H234.9l10.7-64h81c-2.9-10.3-4.9-21-5.9-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm416 160.7V112c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6v48c10.3-2.9 21-4.9 32-5.9zm16 63.3a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-25.4-169.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1-50.7-50.7zm60.7 83.4 9.3 9.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-9.3-9.3c13.2-21.6 13.2-49.1 0-70.7l9.3-9.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-9.3 9.3c-21.6-13.2-49.1-13.2-70.7 0l-9.3-9.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l9.3 9.3c-13.2 21.6-13.2 49.1 0 70.7l-9.3 9.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l9.3-9.3c21.6 13.2 49.1 13.2 70.7 0z"
        }
    ]
};

const FalDisplayChartUpCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDisplayChartUpCircleDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h448c17.7 0 32 14.3 32 32v134.6c11.2 3.2 21.9 7.4 32 12.6V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h149.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h250.8c-12.9-9.1-24.5-19.9-34.6-32H234.9l10.7-64h81c-2.9-10.3-4.9-21-5.9-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm416 160.7V112c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6v48c10.3-2.9 21-4.9 32-5.9zm16 63.3a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm-23.2-176.6c.6-.9 1.8-2.1 4.2-3.4 5.1-2.7 12.5-4.1 18.7-4 8.2.1 17.1 1.8 26.4 4.1 8.6 2.1 17.3-3.1 19.4-11.7s-3.1-17.3-11.7-19.4c-5.6-1.4-11.6-2.7-17.9-3.7V288c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.5c-6.1 1.2-12.3 3.2-18 6.3-11.8 6.3-23 18.4-21.8 37.2 1 16 11.7 25.3 21.6 30.7 8.8 4.7 19.7 7.8 28.6 10.3l1.8.5c10.3 2.9 17.9 5.2 23.2 8.3 4.5 2.7 4.7 4.2 4.7 5.6.1 2.4-.5 3.7-1 4.5-.6 1-1.8 2.2-4 3.3-4.7 2.5-11.8 3.8-18.5 3.6-9.5-.3-18.5-3.1-29.9-6.8-1.9-.6-3.8-1.2-5.8-1.8-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20c1.6.5 3.3 1 5 1.6 7 2.3 15.1 4.8 23.7 6.6v11.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.6c6.2-1.1 12.5-3.1 18.3-6.2 12.1-6.5 22.3-18.7 21.7-36.9-.5-16.2-10.3-26.3-20.5-32.3-9.4-5.6-21.2-8.9-30.5-11.5h-.2c-10.4-2.9-18.3-5.2-23.9-8.2-4.8-2.6-4.8-4-4.8-4.5v-.1c-.1-1.9.3-2.9.8-3.6z"
        }
    ]
};

const FalDisplayChartUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDisplayChartUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h448zM64 416h149.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-58.4l-10.7-64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64zm170.9 64 10.7-64h84.9l10.7 64H234.9zM368 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4L304 249.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L224 214.6l68.7 68.7c3 3 7.1 4.7 11.3 4.7s8.3-1.7 11.3-4.7L448 150.6V208c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96z"
        }
    ]
};

const FalDisplayCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDisplayCode",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h448zM64 416h149.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-58.4l-10.7-64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64zm170.9 64 10.7-64h84.9l10.7 64H234.9zm16.4-324.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L198.6 208l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"
        }
    ]
};

const FalDisplayMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDisplayMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h448zM64 416h149.1l-10.7 64H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-58.4l-10.7-64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64zm170.9 64 10.7-64h84.9l10.7 64H234.9zM272 96c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48z"
        }
    ]
};

const FalDisplaySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDisplaySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 110.3V352c0 35.3 28.7 64 64 64h149.1l-10.7 64H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16h-58.4l-10.7-64h24.3l-40.5-32H96c-17.7 0-32-14.3-32-32V135.6l-32-25.3zm562.5 281C603 380.5 608 366.8 608 352V64c0-35.3-28.7-64-64-64H96c-1.5 0-3 .1-4.4.2H99L139.4 32H544c17.7 0 32 14.3 32 32v288c0 7.3-2.5 14.1-6.6 19.5l25.1 19.8zM277.6 416h84.9l10.7 64H266.9l10.7-64zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalDisplay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDisplay",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zm149.1 384H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64zm32.4 0-10.7 64h106.3l-10.7-64h-84.8z"
        }
    ]
};

const FalDistributeSpacingHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDistributeSpacingHorizontal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 0c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM320 368c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v224zm32-224c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V144zM64 16c0-8.8-7.2-16-16-16S32 7.2 32 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16V16z"
        }
    ]
};

const FalDistributeSpacingVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDistributeSpacingVertical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 464c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16zM144 320c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H144zm224 32c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h224zM496 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 32 0 39.2 0 48s7.2 16 16 16h480z"
        }
    ]
};

const FalDitto = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDitto",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 98.3V96c0-17.7-14.3-32-32-32S32 78.3 32 96v2.3c0 2 .2 3.9.5 5.9L58 251c.5 2.9 3 5 6 5s5.5-2.1 6-5l25.5-146.8 30.9 5.4-30.9-5.4c.3-1.9.5-3.9.5-5.9zm-96 0V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4l-25.5 146.8C98.3 274.7 82.5 288 64 288s-34.3-13.3-37.5-31.5L1 109.6c-.7-3.8-1-7.5-1-11.4zm288 0V96c0-17.7-14.3-32-32-32s-32 14.3-32 32v2.3c0 2 .2 3.9.5 5.9L250 251c.5 2.9 3 5 6 5s5.5-2.1 6-5l25.5-146.8 30.9 5.4-30.9-5.4c.3-1.9.5-3.9.5-5.9zm-96 0V96c0-35.3 28.7-64 64-64s64 28.7 64 64v2.3c0 3.8-.3 7.6-1 11.4l-25.5 146.8c-3.2 18.2-19 31.5-37.5 31.5s-34.3-13.3-37.5-31.5L193 109.6c-.7-3.8-1-7.5-1-11.4z"
        }
    ]
};

const FalDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDivide",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm192-176c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h384z"
        }
    ]
};

const FalDna = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDna",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c8.8 0 16 7.2 16 16 0 120.2-94.2 188.6-179.7 250.9l-2.8 2.1c-37.8 27.5-73.9 54-102.9 83.1h187c-19.8-19.8-42.8-38.4-67.5-57 3.2-2.3 6.4-4.6 9.7-6.9 5.9-4.2 11.7-8.4 17.6-12.7C349.4 330.4 416 394.9 416 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-5.5-.2-10.8-.7-16H64.7c-.4 5.2-.7 10.5-.7 16 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-113.2 83.6-180.5 164.8-240C115.6 196.5 32 129.2 32 16c0-8.8 7.2-16 16-16s16 7.2 16 16c0 5.5.2 10.8.7 16h318.6c.4-5.2.7-10.5.7-16 0-8.8 7.2-16 16-16zm-22.4 64H70.4c6.5 23.4 17.6 44.5 32.2 64h242.9c14.6-19.5 25.7-40.6 32.2-64zm-60.1 96h-187c26.6 26.7 59.1 51.1 93.5 76.2 34.4-25.1 66.9-49.5 93.5-76.2zM70.4 448h307.2c-6.5-23.5-17.6-44.5-32.2-64.1-.5 0-.9.1-1.4.1H104c-.5 0-.9 0-1.4-.1C88 403.5 76.8 424.5 70.4 448z"
        }
    ]
};

const FalDoNotEnter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDoNotEnter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm112-16v32c0 4.4 3.6 8 8 8h272c4.4 0 8-3.6 8-8v-32c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8zm-32 0c0-22.1 17.9-40 40-40h272c22.1 0 40 17.9 40 40v32c0 22.1-17.9 40-40 40H120c-22.1 0-40-17.9-40-40v-32z"
        }
    ]
};

const FalDogLeashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDogLeashed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M67.4 6.1C72.9-.8 82.9-2 89.9 3.4L307 174l24.9-149.2C334.2 10.5 346.6 0 361.2 0c9.3 0 18.1 4.4 23.8 11.9L400 32h44.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v16c0 53-43 96-96 96h-42.7l-5.3 32v200c0 30.9-25.1 56-56 56h-16c-30.9 0-56-25.1-56-56v-80.7c-10.3 3.3-21 5.7-32 7.1-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1V456c0 30.9-25.1 56-56 56h-16c-30.9 0-56-25.1-56-56V208c0-.7 0-1.4.1-2-.7-.2-1.4-.3-2.1-.5-27.9-7.2-50.3-29.1-57.6-58.1L.5 131.9c-2.1-8.6 3.1-17.3 11.6-19.4s17.3 3.1 19.4 11.6l3.9 15.5c.3 1.4.8 2.7 1.2 4.1 2 5.8 5.1 11.1 9 15.6 8.9 10.4 22 16.7 36.4 16.7h175.7L70.1 28.6c-6.9-5.5-8.1-15.5-2.7-22.5zm255.5 343.4c8.2 6 13.1 15.6 13.1 25.8V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V261.9h-.1L307.6 208H288v138.7c2.1-.6 4.2-1.2 6.3-1.9 9.7-3.1 20.4-1.4 28.6 4.6zm-66.9 2.3V208H96v248c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-80.7c0-10.2 4.9-19.8 13.1-25.8s18.9-7.8 28.6-4.6c14.5 4.6 30.1 7.2 46.3 7.2 2.7 0 5.4-.1 8-.2zm149.8-133.1c2.6-15.4 15.9-26.7 31.6-26.7H480c35.3 0 64-28.7 64-64v-16c0-8.8-7.2-16-16-16h-32c-8.5 0-16.6-3.4-22.6-9.4l-18-17.9c-3-3-7.1-4.7-11.3-4.7H400c-10.1 0-19.6-4.7-25.6-12.8l-11.9-15.8-24.3 145.9c-.4 2.3-1 4.4-1.8 6.5l67.9 39.6 1.4-8.6zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalDog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDog",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M322.9 349.5c8.2 6 13.1 15.6 13.1 25.8V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V261.9h-.1L307.6 208H96v248c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-80.7c0-10.2 4.9-19.8 13.1-25.8s18.9-7.8 28.6-4.6c14.5 4.6 30.1 7.2 46.3 7.2s31.7-2.5 46.3-7.2c9.7-3.1 20.4-1.4 28.6 4.6zm82.9-130.7c2.6-15.4 15.9-26.7 31.6-26.7H480c35.3 0 64-28.7 64-64V112c0-8.8-7.2-16-16-16h-32c-8.5 0-16.6-3.4-22.6-9.4l-18-17.9c-3-3-7.1-4.7-11.3-4.7H400c-10.1 0-19.6-4.7-25.6-12.8l-11.9-15.8-24.3 145.9c-.4 2.3-1 4.4-1.8 6.5l67.9 39.6 1.4-8.6zM45.6 159.3c8.9 10.4 22 16.7 36.4 16.7h224.7l25.2-151.2C334.2 10.5 346.6 0 361.2 0c9.3 0 18.1 4.4 23.8 11.9L400 32h44.1c12.7 0 24.9 5.1 33.9 14.1L496 64h32c26.5 0 48 21.5 48 48v16c0 53-43 96-96 96h-42.7l-5.3 32v200c0 30.9-25.1 56-56 56h-16c-30.9 0-56-25.1-56-56v-80.7c-10.3 3.3-21 5.7-32 7.1-7.9 1-15.9 1.6-24 1.6s-16.1-.5-24-1.6c-11-1.4-21.7-3.8-32-7.1V456c0 30.9-25.1 56-56 56h-16c-30.9 0-56-25.1-56-56V208c0-.7 0-1.4.1-2-.7-.2-1.4-.3-2.1-.5-27.9-7.2-50.3-29.1-57.6-58.1L.5 131.9c-2.1-8.6 3.1-17.3 11.6-19.4s17.3 3.1 19.4 11.6l3.9 15.5c.3 1.4.8 2.7 1.2 4.1 2 5.8 5.1 11.1 9 15.6zM432 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalDollarSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDollarSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v47.5c-6.3.1-12.6.3-18.8.9-24 2-47.9 7.8-67.4 20.6-20.1 13.1-34.6 33-39.9 61-3.8 20.3-1.9 38.2 5.7 53.7 7.4 15.3 19.5 26.8 33.5 35.7 26.7 17 63.6 26.7 97.2 35.5l1.7.4c35.7 9.4 67.8 17.9 89.8 31.9 10.6 6.8 17.8 14.2 21.9 22.6 4 8.3 5.8 19 3 33.8-3.9 20.7-18.4 36.4-42.9 46-24.9 9.8-59.1 12.6-98 7-24.4-3.6-61-12.1-91.3-25.2-8.1-3.5-17.5.2-21 8.4s.2 17.5 8.4 21c33.6 14.5 73.1 23.5 99.3 27.4h.1c6.4.9 12.7 1.6 18.9 2.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.6c23.2-.7 44.8-4.7 63.4-11.9 32-12.5 56.2-35.7 62.7-69.9 3.8-20.3 1.9-38.2-5.7-53.7-7.4-15.3-19.6-26.8-33.5-35.6-26.7-17-63.6-26.7-97.2-35.5l-1.7-.4c-35.7-9.4-67.8-17.9-89.8-31.9-10.6-6.8-17.8-14.2-21.9-22.6-4-8.3-5.8-19-3-33.8 3.6-19.3 13.1-31.8 26-40.2 13.4-8.8 31.5-13.7 52.6-15.5 42.3-3.5 91.3 6 124.3 14 8.6 2.1 17.2-3.2 19.3-11.8s-3.2-17.2-11.8-19.3C238 74 207.8 67.6 176.1 64.9V16z"
        }
    ]
};

const FalDollyEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDollyEmpty",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M8 16C8 7.2 15.2 0 24 0h64.9c20.7 0 39 13.2 45.5 32.8l106.9 320.5c4.8-.9 9.7-1.3 14.7-1.3 34.1 0 63.2 21.3 74.7 51.4L554.5 321c8.3-3.1 17.5 1.2 20.5 9.5s-1.2 17.5-9.5 20.5l-229.6 84.6C334 478.1 299 512 256 512c-44.2 0-80-35.8-80-80 0-27.8 14.1-52.2 35.6-66.6L104.1 42.9C101.9 36.4 95.8 32 88.9 32H24c-8.8 0-16-7.2-16-16zm296 416a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FalDolly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDolly",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 0C15.2 0 8 7.2 8 16s7.2 16 16 16h64.9c6.9 0 13 4.4 15.2 10.9l107.5 322.5C190.1 379.8 176 404.2 176 432c0 44.2 35.8 80 80 80 43 0 78-33.9 79.9-76.4L565.5 351c8.3-3.1 12.5-12.3 9.5-20.5s-12.3-12.5-20.5-9.5l-223.8 82.4C319.2 373.3 290.1 352 256 352c-5 0-9.9.5-14.7 1.3L134.5 32.8C127.9 13.2 109.6 0 88.9 0H24zm232 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm96.8-201.1c3 8.3 12.2 12.6 20.5 9.6s12.6-12.2 9.6-20.5l-19.2-52.6 60.1-21.9 54.7 150.4-150.3 54.6-54.7-150.3 60.1-21.9 19.2 52.6zm-109.4-19.8 54.7 150.4c6 16.6 24.4 25.2 41 19.1l150.4-54.7c16.6-6 25.2-24.4 19.1-41L453.9 86.5c-6-16.6-24.4-25.2-41-19.1l-150.4 54.7c-16.6 6-25.2 24.4-19.1 41z"
        }
    ]
};

const FalDolphin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDolphin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32h49.1c40.5 0 78.7 9.4 112.7 26.2 4 2 8.5 2.2 12.7.7 32.4-12.1 73.2-24.6 105.2-26.6-.8 3.3-2.2 7.6-4.2 13-7.2 18.6-20.2 42.3-31.2 61.1-3.4 5.8-2.8 13.1 1.5 18.3 36.3 44.1 58.2 100.5 58.2 162.2 0 54.4-33.6 100.9-81.2 119.9 10.9-15.5 17.2-34.4 17.2-54.8 0-46.5-33-85.2-76.8-94.1-4.7-1-9.6.3-13.3 3.3s-5.9 7.6-5.9 12.4V325c0 6.1-4.9 11-11 11-2.9 0-5.6-1.1-7.7-3.1l-73.8-72.3c-3-2.9-7-4.6-11.2-4.6H50.2c-10 0-18.2-8.1-18.2-18.2 0-6.5 3.4-12.4 9-15.7l25.1-14.6c6.9-4.1 9.8-12.6 6.7-20-5.6-13.4-8.8-28-8.8-43.5 0-61.9 50.1-112 112-112zm280.6-6.3a.1.1 0 1 0-.2.1.1.1 0 1 0 .2-.1zM320 416h-38.1l-1-2.1c-19-37.9-57.8-61.9-100.2-61.9H176c-5.5 0-10.7 2.9-13.6 7.6s-3.2 10.6-.7 15.6l28.4 56.8-28.4 56.8c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6h4.7c42.4 0 81.2-24 100.2-61.9l1-2.1h69c89 0 161.1-72.1 161.1-161.1 0-65.3-21.8-125.6-58.6-173.8 10-17.5 21-38.4 27.9-56.2 3.9-10.2 7.4-21.4 7.3-30.9 0-4.8-1-11.5-5.6-17.3-5.1-6.4-12.4-8.7-19-8.7-37 0-83.5 13.9-118.3 26.5C309 9.5 268.2 0 225.1 0H176C96.5 0 32 64.5 32 144c0 14.8 2.2 29.1 6.4 42.6l-13.5 7.9C9.5 203.5 0 220 0 237.8 0 265.5 22.5 288 50.2 288h159.6l69.1 67.7c8 7.9 18.8 12.3 30.1 12.3 23.7 0 43-19.2 43-43v-28.4c19.1 11.1 32 31.8 32 55.4 0 35.3-28.7 64-64 64zm-116.4-28.7c20.9 6.2 38.6 20.8 48.7 40.9l1.9 3.8-1.9 3.8c-10 20.1-27.8 34.7-48.7 40.9l18.8-37.5c2.3-4.5 2.3-9.8 0-14.3l-18.8-37.5zM152 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDongSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDongSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32c-8.8 0-16 7.2-16 16v16h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v107.3c-23.5-26.6-57.8-43.3-96-43.3-70.7 0-128 57.3-128 128s57.3 128 128 128c38.2 0 72.5-16.8 96-43.3V400c0 8.8 7.2 16 16 16s16-7.2 16-16V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V48c0-8.8-7.2-16-16-16zM96 288a96 96 0 1 1 192 0 96 96 0 1 1-192 0zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalDonut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDonut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 208c0-29.2 19-60.4 59.9-86 40.5-25.3 98.4-42 164.1-42 3.1 0 6.2 0 9.3.1l-20.6 20.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l39.8-39.8c44.4 6.1 83.3 20 112.9 38.5 41 25.6 60 56.8 60 86v15c-.6 8.5-3.7 16.5-8.8 23.2-5.3 6.8-12.4 11.9-20.6 14.5l-.3.1-.3.1c-6.6 2.5-12.6 6-17.9 10.5-.1-3.9-1.7-7.8-4.7-10.8l-32-32c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c3.6 3.6 8.6 5.1 13.3 4.6-7.7 9.5-17.5 17.2-28.7 22.3-12.6 5.9-26.6 8.3-40.4 7.2h-1.2c-15.9-.2-31.7 2.9-46.4 9h-.1c-14.2 6.1-29.6 9.1-45 9h-.3c-15.5.1-30.8-2.9-45.1-9h-.1c-14.7-6.1-30.5-9.2-46.4-9h-1.2c-13.9 1.1-27.8-1.4-40.4-7.2-12.5-5.8-23.4-14.8-31.5-26.1-7-10.6-17.2-18.8-29.1-23.2l-.4-.1-.4-.1c-8.2-2.6-15.3-7.7-20.6-14.5-5.2-6.7-8.2-14.8-8.8-23.2V208zm0 73.4c5.9 4.1 12.3 7.3 19.2 9.6 5.5 2.1 10.2 6 13.4 10.9l.2.3.2.3c11.3 15.9 26.6 28.5 44.2 36.7 17.5 8.1 36.7 11.6 55.9 10.2 11.4 0 22.7 2.2 33.2 6.6 18.2 7.7 37.9 11.6 57.7 11.5 19.8.2 39.4-3.7 57.6-11.5 10.5-4.4 21.8-6.6 33.2-6.6 19.2 1.5 38.4-2 55.9-10.1 17.7-8.2 32.9-20.8 44.2-36.6l.2-.3.2-.3c3.2-5 7.9-8.8 13.4-10.9 6.9-2.3 13.3-5.5 19.2-9.6V304c0 29.2-19 60.4-59.9 86-40.5 25.3-98.4 42-164.1 42s-123.6-16.7-164.1-42C51 364.4 32 333.2 32 304v-22.6zM256 48C114.6 48 0 119.6 0 208v96c0 88.4 114.6 160 256 160s256-71.6 256-160v-96c0-88.4-114.6-160-256-160zm-48 143.9s0-.1.1-.3c.1-.3.4-.9 1.1-1.7 1.5-1.7 4.2-4 8.7-6.2 8.9-4.5 22.4-7.7 38.1-7.7s29.2 3.2 38.1 7.7c4.5 2.2 7.2 4.5 8.7 6.2.7.8 1 1.4 1.1 1.7.1.2.1.3.1.3v.2c0 .1 0 .1-.1.3-.1.3-.4.9-1.1 1.7-1.5 1.7-4.2 4-8.7 6.2-8.9 4.5-22.4 7.7-38.1 7.7s-29.2-3.2-38.1-7.7c-4.5-2.2-7.2-4.5-8.7-6.2-.7-.8-1-1.4-1.1-1.7-.1-.2-.1-.3-.1-.3v-.1c0-.1 0 0 0 0v-.1zm-4.4-36.9c-13.3 6.7-27.6 18.8-27.6 37s14.3 30.3 27.6 36.9C217.8 236 236.4 240 256 240s38.2-3.9 52.4-11.1c13.3-6.6 27.6-18.8 27.6-36.9s-14.3-30.3-27.6-36.9c-14.2-7.2-32.8-11.1-52.4-11.1s-38.2 3.9-52.4 11.1zm-32.3-15.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zm224-6.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zM64 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm91.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32zm176 38.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"
        }
    ]
};

const FalDoorClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDoorClosed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 32c17.7 0 32 14.3 32 32v416H128V64c0-17.7 14.3-32 32-32h256zm64 448V64c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64v416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80zm-72-224a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalDoorOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDoorOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 480H96V86.2c0-7.5 5.1-13.9 12.4-15.6l166-38.3c.8-.2 1.7-.3 2.5-.3 6.1 0 11.1 5 11.1 11.1V480zm32 0V43.1C320 19.3 300.7 0 276.9 0c-3.3 0-6.5.4-9.7 1.1l-166 38.3C79.4 44.4 64 63.8 64 86.2V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h304v-32zm-88-192c13.2 0 24-14.4 24-32s-10.8-32-24-32-24 14.4-24 32 10.7 32 24 32zM464 64H352v32h112c8.8 0 16 7.2 16 16v384c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V112c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FalDove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDove",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M273 128.8c-.7 5-1 10.1-1 15.2v21.6c-5.2-1.6-10.5-3.4-15.9-5.3-22.5-30-40.1-66.5-45.7-109.4-9.9 15.5-21.1 37.2-30.5 65-9.1-8.3-17.2-17.4-24-27.5 15.1-38.2 32.9-64.6 45.3-79.1 5.2-6 13.4-7.8 21-5.8 10.9 2.9 18 13.1 18.4 24.4 1.3 38.9 13.9 72.5 32.4 100.8zM64.7 42.2C68.8 35.5 76 32 83.2 32c10.7 0 19.3 7.6 21.5 17.2 12.8 56.5 50.9 94.7 94.7 119.9 36.2 20.8 75.4 32.1 104.7 36.8V144c0-44.2 35.8-80 80-80h99.7c15.5 0 28.2 12.7 28.2 28.3 0 5.6-1.7 11-4.7 15.7L480 148.8V288c0 88.4-71.6 160-160 160h-71.4l-78.9 60.7c-2.8 2.2-6.2 3.3-9.8 3.3-82.6 0-138.2-45.8-156.7-70.4-3-4.1-4-9.3-2.5-14.2s5.1-8.7 9.9-10.5l123-44.3C89.2 341.3 32 282.5 32 184c0-75.8 20-121.4 32.7-141.8zm16.2 39.4C72.5 103 64 136.5 64 184c0 103.8 74 156.5 113.7 178.6 5.5 3.1 8.7 9 8.2 15.3s-4.6 11.6-10.5 13.8l-130.7 47c21.4 18.2 59.2 39.8 110 41.2l78.8-60.6c2.8-2.2 6.2-3.3 9.8-3.3H320c70.7 0 128-57.3 128-128V144c0-3.2.9-6.2 2.7-8.9L476.8 96H384c-26.5 0-48 21.5-48 48v80c0 4.5-1.9 8.7-5.2 11.8s-7.7 4.5-12.2 4.2c-33.6-2.8-86.6-15.1-135.3-43-42.5-24.4-82.7-61.4-102.5-115.3zM360 160a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalDownFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.2 447.2c.5.5 1.1.8 1.8.8s1.4-.3 1.8-.8l124.4-131.9c1.2-1.2 1.8-2.9 1.8-4.6 0-3.7-3-6.7-6.7-6.7H288c-8.8 0-16-7.2-16-16V168c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v120c0 8.8-7.2 16-16 16h-57.3c-3.7 0-6.7 3-6.7 6.7 0 1.7.7 3.3 1.8 4.6l124.4 131.9zM224 480c-9.5 0-18.6-3.9-25.1-10.8l-124.4-132C67.8 330 64 320.5 64 310.7c0-21.4 17.3-38.7 38.7-38.7H144V168c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v104h41.3c21.4 0 38.7 17.3 38.7 38.7 0 9.9-3.8 19.4-10.5 26.5l-124.4 132c-6.5 6.9-15.6 10.8-25.1 10.8zM32 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm384 0a24 24 0 1 1 0-48 24 24 0 1 1 0 48zM104 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm72-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalDownFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.2 447.2c.5.5 1.1.8 1.8.8s1.4-.3 1.8-.8l124.4-131.9c1.2-1.2 1.8-2.9 1.8-4.6 0-3.7-3-6.7-6.7-6.7H256c-8.8 0-16-7.2-16-16V168c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v120c0 8.8-7.2 16-16 16H70.7c-3.7 0-6.7 3-6.7 6.7 0 1.7.7 3.3 1.8 4.6l124.4 131.9zM192 480c-9.5 0-18.6-3.9-25.1-10.8l-124.4-132C35.8 330 32 320.5 32 310.7c0-21.4 17.3-38.7 38.7-38.7H112V168c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v104h41.3c21.4 0 38.7 17.3 38.7 38.7 0 9.9-3.8 19.4-10.5 26.5l-124.4 132c-6.5 6.9-15.6 10.8-25.1 10.8zM16 32h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48s7.2-16 16-16z"
        }
    ]
};

const FalDownLeftAndUpRightToCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownLeftAndUpRightToCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M447 256c18.2 0 33-14.8 33-33 0-8.7-3.5-17.1-9.7-23.3L442.6 172l55.7-55.7c15.6-15.6 15.6-40.9 0-56.6l-46-46c-15.6-15.7-41-15.7-56.6 0L340 69.4l-27.7-27.7c-6.2-6.2-14.6-9.7-23.3-9.7-18.2 0-33 14.8-33 33v159c0 17.7 14.3 32 32 32h159zm.7-33.7c.2.2.3.4.3.7 0 .5-.4 1-1 1H288V65c0-.5.4-1 1-1 .3 0 .5.1.7.3l39 39c6.2 6.2 16.4 6.2 22.6 0l67-67c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-67 67c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39zM65 256c-18.2 0-33 14.8-33 33 0 8.7 3.5 17.1 9.7 23.3L69.4 340l-55.7 55.7c-15.7 15.6-15.7 41 0 56.6l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0l55.6-55.8 27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7 18.2 0 33-14.8 33-33V288c0-17.7-14.3-32-32-32H65zm-1 33c0-.5.4-1 1-1h159v159c0 .5-.4 1-1 1-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-67 67c-3.1 3.1-8.2 3.1-11.3 0l-46.1-46c-3.1-3.1-3.1-8.2 0-11.3l67-67c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7z"
        }
    ]
};

const FalDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 384c-4.4 0-8-3.6-8-8V174.6c0-3.7 3-6.6 6.6-6.6 1.8 0 3.4.7 4.7 1.9l61.4 61.4c6.2 6.2 16.4 6.2 22.6 0L272 118.6c4.2-4.2 10-6.6 16-6.6s11.8 2.4 16 6.6l25.4 25.4c4.2 4.2 6.6 10 6.6 16s-2.4 11.8-6.6 16L216.7 288.7c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l61.4 61.4c1.2 1.2 1.9 2.9 1.9 4.7 0 3.7-3 6.6-6.6 6.6H72zm-40-8c0 22.1 17.9 40 40 40h201.4c21.3 0 38.6-17.3 38.6-38.6 0-10.2-4.1-20.1-11.3-27.3L250.6 300 352 198.6c10.2-10.2 16-24.1 16-38.6s-5.8-28.4-16-38.6L326.6 96c-10.2-10.2-24.1-16-38.6-16s-28.4 5.8-38.6 16L148 197.4l-50.1-50.1c-7.2-7.2-17-11.3-27.3-11.3-21.3 0-38.6 17.3-38.6 38.6V376z"
        }
    ]
};

const FalDownLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownLong",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 352H38.7c-3.7 0-6.7 3-6.7 6.7 0 1.9.8 3.7 2.2 5L160 476.2l125.8-112.5c1.4-1.3 2.2-3.1 2.2-5 0-3.7-3-6.7-6.7-6.7H232c-17.7 0-32-14.3-32-32V48c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v272c0 17.7-14.3 32-32 32zm86 154.7c-3.8 3.4-8.8 5.3-14 5.3s-10.1-1.9-14-5.3L12.9 387.5C4.7 380.2 0 369.7 0 358.7 0 337.3 17.3 320 38.7 320H88V48c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v272h49.3c21.4 0 38.7 17.3 38.7 38.7 0 11-4.7 21.5-12.9 28.8L174 506.7z"
        }
    ]
};

const FalDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 384c4.4 0 8-3.6 8-8V174.6c0-3.7-3-6.6-6.6-6.6-1.8 0-3.4.7-4.7 1.9l-61.4 61.4c-6.2 6.2-16.4 6.2-22.6 0L112 118.6c-4.2-4.2-10-6.6-16-6.6s-11.8 2.4-16 6.6L54.6 144c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l112.7 112.7c3 3 4.7 7.1 4.7 11.3s-1.7 8.3-4.7 11.3l-61.4 61.4c-1.2 1.2-1.9 2.9-1.9 4.7 0 3.7 3 6.6 6.6 6.6H312zm40-8c0 22.1-17.9 40-40 40H110.6C89.3 416 72 398.7 72 377.4c0-10.2 4.1-20.1 11.3-27.3l50.1-50.1L32 198.6c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6L57.4 96C67.6 85.8 81.5 80 96 80s28.4 5.8 38.6 16L236 197.4l50.1-50.1c7.2-7.2 17.1-11.3 27.3-11.3 21.3 0 38.6 17.3 38.6 38.6V376z"
        }
    ]
};

const FalDownToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownToBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.2 319.2c.5.5 1.1.8 1.8.8s1.4-.3 1.8-.8l124.4-131.9c1.2-1.2 1.8-2.9 1.8-4.6 0-3.7-3-6.7-6.7-6.7H288c-8.8 0-16-7.2-16-16V40c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v120c0 8.8-7.2 16-16 16h-57.3c-3.7 0-6.7 3-6.7 6.7 0 1.7.7 3.3 1.8 4.6l124.4 131.9zM224 352c-9.5 0-18.6-3.9-25.1-10.8l-124.4-132C67.8 202 64 192.5 64 182.7c0-21.4 17.3-38.7 38.7-38.7H144V40c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v104h41.3c21.4 0 38.7 17.3 38.7 38.7 0 9.9-3.8 19.3-10.5 26.5l-124.4 132c-6.5 6.9-15.6 10.8-25.1 10.8zM32 336v96c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80v-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalDownToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.2 351.2c.5.5 1.1.8 1.8.8s1.4-.3 1.8-.8l124.4-131.9c1.2-1.2 1.8-2.9 1.8-4.6 0-3.7-3-6.7-6.7-6.7H288c-8.8 0-16-7.2-16-16V72c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v120c0 8.8-7.2 16-16 16h-57.3c-3.7 0-6.7 3-6.7 6.7 0 1.7.7 3.3 1.8 4.6l124.4 131.9zM224 384c-9.5 0-18.6-3.9-25.1-10.8l-124.4-132C67.8 234 64 224.5 64 214.7c0-21.4 17.3-38.7 38.7-38.7H144V72c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v104h41.3c21.4 0 38.7 17.3 38.7 38.7 0 9.9-3.8 19.3-10.5 26.5l-124.4 132c-6.5 6.9-15.6 10.8-25.1 10.8zm192 44a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-384 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm312 24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-72 24a24 24 0 1 1-48 0 24 24 0 1 1 48 0z"
        }
    ]
};

const FalDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 448h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm174.2-96.8c.5.5 1.1.8 1.8.8s1.4-.3 1.8-.8l124.4-131.9c1.2-1.2 1.8-2.9 1.8-4.6 0-3.7-3-6.7-6.7-6.7H256c-8.8 0-16-7.2-16-16V72c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v120c0 8.8-7.2 16-16 16H70.7c-3.7 0-6.7 3-6.7 6.7 0 1.7.7 3.3 1.8 4.6l124.4 131.9zM192 384c-9.5 0-18.6-3.9-25.1-10.8l-124.4-132C35.8 234 32 224.5 32 214.7c0-21.4 17.3-38.7 38.7-38.7H112V72c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v104h41.3c21.4 0 38.7 17.3 38.7 38.7 0 9.9-3.8 19.3-10.5 26.5l-124.4 132c-6.5 6.9-15.6 10.8-25.1 10.8z"
        }
    ]
};

const FalDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M189.7 448h4.6c4.4 0 8.6-1.8 11.6-5l142.6-149.8c2.2-2.3 3.5-5.4 3.5-8.7 0-6.9-5.6-12.6-12.6-12.6H256c-8.8 0-16-7.2-16-16V80c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v176c0 8.8-7.2 16-16 16H44.6c-6.9 0-12.6 5.6-12.6 12.6 0 3.2 1.2 6.3 3.5 8.7L178.1 443c3 3.2 7.2 5 11.6 5zM384 284.6c0 11.4-4.4 22.5-12.3 30.7L229 465.1c-9.1 9.5-21.6 14.9-34.8 14.9h-4.6c-13.1 0-25.7-5.4-34.8-14.9L12.3 315.3C4.4 307 0 296 0 284.6 0 260 20 240 44.6 240H112V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v160h67.4c24.6 0 44.6 20 44.6 44.6z"
        }
    ]
};

const FalDownload = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDownload",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v313.4L139.3 228.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V16zM140.1 320H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64h-76.1l-32 32H448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h108.1l-32-32zM432 416a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalDragon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDragon",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288.8 10.9C291 4.4 297.1 0 304 0h179.8c32.7 0 63.8 14.3 85 39.1l56 65.4c9.7 11.4 15.1 25.8 15.1 40.8 0 34.6-28.1 62.7-62.7 62.7h-22.7c-21.2 0-41.6-8.4-56.6-23.4l-8.6-8.6H480v12c0 17.6 8.3 34.2 22.4 44.8l90.7 68c29.5 22.2 46.9 56.9 46.9 93.9 0 62-48 112.7-108.9 117-1 .2-2 .3-3.1.3H48.4c-24.7.2-45.9-18.5-48.2-43.6-2.4-26.4 17-49.8 43.4-52.2l378.3-35-29-34.9c-26.5-31.6-40.9-71.5-40.9-112.6v-79.8l-55.2-27.6c-5-2.5-8.3-7.4-8.8-12.9s1.9-10.9 6.3-14.2l47-35.2-46.9-35.2c-5.5-4.1-7.8-11.3-5.6-17.9zM525.9 480c.4-.1.8-.1 1.3-.1 45-2.3 80.8-39.6 80.8-85.2 0-26.9-12.6-52.2-34.1-68.3l-90.7-68C461 241.8 448 215.7 448 188v-28c0-8.8 7.2-16 16-16h32c4.2 0 8.3 1.7 11.3 4.7l13.3 13.3c9 9 21.2 14.1 33.9 14.1h22.8c17 0 30.7-13.8 30.7-30.7 0-7.3-2.6-14.4-7.4-20l-56-65.4c-15.2-17.8-37.4-28-60.8-28H352l25.6 19.2c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-43.3 32.5 40.8 20.4c5.4 2.7 8.8 8.3 8.8 14.3v89.7c0 33.7 11.8 66.3 33.4 92.2l41.7 49.9c3.2 3.9 5 8.8 5 13.9 0 11.2-8.5 20.6-19.7 21.6L46.5 448.1c-8.8.8-15.3 8.6-14.5 17.4.8 8.4 7.8 14.6 16.1 14.5h477.8zM320 199.4v38.5L171.7 139c-6.1-4-14.1-3.5-19.5 1.4L63 219.7l127.6-11.6c6.7-.6 13.1 3 15.9 9.1s1.6 13.3-3.2 18.1L150.6 288h176.6c3 11 6.8 21.7 11.5 32H112c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l48.8-48.8-132 12c-6.9.6-13.4-3.2-16.1-9.6s-1.2-13.7 4-18.3l125.5-111.5c16.3-14.5 40.4-16.2 58.5-4.1l130.6 87zM495.2 57.7l32 16c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z"
        }
    ]
};

const FalDrawCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDrawCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm58.5-6c-10 22.4-32.4 38-58.5 38s-48.6-15.6-58.5-38c-50.1 17.6-89.9 57.4-107.5 107.5 22.4 10 38 32.4 38 58.5s-15.6 48.6-38 58.5c17.7 50.1 57.4 89.9 107.5 107.5 10-22.4 32.4-38 58.5-38s48.6 15.6 58.5 38c50.1-17.7 89.9-57.4 107.5-107.5-22.4-10-38-32.4-38-58.5s15.6-48.6 38-58.5c-17.6-50.1-57.4-89.9-107.5-107.5zm139.6 102.3c32.5 3.1 57.9 30.4 57.9 63.7s-25.4 60.7-57.9 63.7c-20.5 63.6-70.7 113.9-134.3 134.3-3.1 32.6-30.5 58-63.8 58s-60.7-25.4-63.7-57.9c-63.6-20.5-113.9-70.8-134.4-134.4C25.4 316.7 0 289.3 0 256s25.4-60.7 57.9-63.7c20.5-63.6 70.8-113.9 134.4-134.4C195.3 25.4 222.7 0 256 0s60.7 25.4 63.7 57.9c63.6 20.5 113.9 70.7 134.3 134.3zM256 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM96 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm352 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalDrawPolygon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDrawPolygon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-16 62v196c22.5 5.8 40.2 23.5 46 46h196c2.9-11.1 8.6-21 16.4-28.9l-32.2-53.7c-5.8 1.7-11.9 2.6-18.2 2.6-35.3 0-64-28.7-64-64s28.7-64 64-64c6.3 0 12.4.9 18.2 2.6l32.2-53.7c-7.8-7.9-13.5-17.8-16.4-28.9H126c-5.8 22.5-23.5 40.2-46 46zm285.8 196.6c5.8-1.7 11.9-2.6 18.2-2.6 35.3 0 64 28.7 64 64s-28.7 64-64 64c-29.8 0-54.9-20.4-62-48H126c-7.1 27.6-32.2 48-62 48-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62V158c-27.6-7.1-48-32.2-48-62 0-35.3 28.7-64 64-64 29.8 0 54.9 20.4 62 48h196c7.1-27.6 32.2-48 62-48 35.3 0 64 28.7 64 64s-28.7 64-64 64c-6.3 0-12.4-.9-18.2-2.6l-32.2 53.7C345 222.6 352 238.5 352 256s-7 33.4-18.4 44.9l32.2 53.7zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM352 96a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm32 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-96-160a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalDrawSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDrawSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96c29.8 0 54.9 20.4 62 48h196c7.1-27.6 32.2-48 62-48 35.3 0 64 28.7 64 64 0 29.8-20.4 54.9-48 62v196c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64-29.8 0-54.9-20.4-62-48H126c-7.1 27.6-32.2 48-62 48-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62V158c-27.6-7.1-48-32.2-48-62 0-35.3 28.7-64 64-64zm62 368h196c5.8-22.5 23.5-40.2 46-46V158c-22.5-5.8-40.2-23.5-46-46H126c-5.8 22.5-23.5 40.2-46 46v196c22.5 5.8 40.2 23.5 46 46zm-30 16a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm256 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm32-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalDreidel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDreidel",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M443.3 36.7c6.2 6.2 6.2 16.4 0 22.6L321.9 180.7l73.4 73.4c18.7 18.7 18.7 49.1 0 67.9L256 461.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V269.3c0-17 6.7-33.3 18.7-45.3L158.1 84.7c18.7-18.7 49.1-18.7 67.9 0l73.4 73.4L420.7 36.7c6.2-6.2 16.4-6.2 22.6 0zm-240 70.6c-6.2-6.2-16.4-6.2-22.6 0l-57.4 57.4 192 192 57.4-57.4c6.2-6.2 6.2-16.4 0-22.6L203.3 107.3zm89.4 272-192-192-59.3 59.3c-6 6-9.4 14.1-9.4 22.6V416c0 17.7 14.3 32 32 32h146.7c8.5 0 16.6-3.4 22.6-9.4l59.3-59.3z"
        }
    ]
};

const FalDroneFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDroneFront",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 96c8.8 0 16 7.2 16 16v16h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h112v-16c0-8.8 7.2-16 16-16zm352 0c8.8 0 16 7.2 16 16v16h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h112v-16c0-8.8 7.2-16 16-16zM128 256v-64h32v55.1l12.6 7.9 50.6-33.7c28.7-19.1 62.3-29.3 96.8-29.3s68.1 10.2 96.8 29.3l50.6 33.7 12.6-7.9V192h32v64c0 5.5-2.8 10.6-7.5 13.6l-58.1 36.3 7.7 9.2c16.8 20.1 26 45.5 26 71.7V400c0 8.8-7.2 16-16 16s-16-7.2-16-16v-13.2c0-18.7-6.6-36.8-18.5-51.2L419 323l-42.5 26.6c-2.5 1.6-5.5 2.4-8.5 2.4h-96c-3 0-5.9-.8-8.5-2.4L221 323l-10.5 12.6c-12 14.4-18.5 32.5-18.5 51.2V400c0 8.8-7.2 16-16 16s-16-7.2-16-16v-13.2c0-26.2 9.2-51.6 26-71.7l7.7-9.2-58.1-36.3c-4.7-2.9-7.5-8.1-7.5-13.6zm309.6 17.6-38.5-25.7c-23.4-15.6-51-23.9-79.1-23.9s-55.6 8.3-79.1 23.9l-38.5 25.7 74.2 46.4h86.8l74.2-46.4z"
        }
    ]
};

const FalDrone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDrone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 32c39.6 0 72.5 28.8 78.9 66.6 1.5 8.7 9.7 14.6 18.4 13.1s14.6-9.7 13.1-18.4C213.6 40.4 167.5 0 112 0 50.1 0 0 50.1 0 112c0 55.5 40.4 101.6 93.4 110.5 8.7 1.5 17-4.4 18.4-13.1s-4.4-17-13.1-18.4C60.8 184.5 32 151.6 32 112c0-44.2 35.8-80 80-80zm286.7 0c44.2 0 80 35.8 80 80 0 39.6-28.8 72.5-66.6 78.9-8.7 1.5-14.6 9.7-13.1 18.4s9.7 14.6 18.4 13.1c53-8.9 93.4-54.9 93.4-110.5 0-61.9-50.1-112-112-112-55.6.1-101.7 40.5-110.6 93.5-1.5 8.7 4.4 17 13.1 18.4s17-4.4 18.4-13.1c6.4-37.9 39.3-66.7 79-66.7zM32 398.7c0-39.6 28.8-72.5 66.6-78.9 8.7-1.5 14.6-9.7 13.1-18.4s-9.7-14.6-18.4-13.1C40.4 297.1 0 343.2 0 398.7c0 61.9 50.1 112 112 112 55.5 0 101.6-40.4 110.5-93.4 1.5-8.7-4.4-17-13.1-18.4s-17 4.4-18.4 13.1c-6.3 37.8-39.3 66.6-78.9 66.6-44.2 0-80-35.8-80-80zm366.7 80c-39.6 0-72.5-28.8-78.9-66.6-1.5-8.7-9.7-14.6-18.4-13.1s-14.6 9.7-13.1 18.4c8.9 53 54.9 93.4 110.5 93.4 61.9 0 112-50.1 112-112 0-55.5-40.4-101.6-93.4-110.5-8.7-1.5-17 4.4-18.4 13.1s4.4 17 13.1 18.4c37.8 6.3 66.6 39.3 66.6 78.9 0 44.2-35.8 80-80 80zM112 432c17.7 0 32-14.3 32-32 0-2.9-.4-5.6-1.1-8.3l39.7-39.7h146.8l39.7 39.7c-.7 2.6-1.1 5.4-1.1 8.3 0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32c-2.9 0-5.6.4-8.3 1.1L352 329.4V182.6l39.7-39.7c2.6.7 5.4 1.1 8.3 1.1 17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32c0 2.9.4 5.6 1.1 8.3L329.4 160H182.6l-39.7-39.7c.7-2.6 1.1-5.4 1.1-8.3 0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32c2.9 0 5.6-.4 8.3-1.1l39.7 39.7v146.8l-39.7 39.7c-2.6-.7-5.4-1.1-8.3-1.1-17.7 0-32 14.3-32 32s14.3 32 32 32zm80-112V192h128v128H192z"
        }
    ]
};

const FalDropletDegree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDropletDegree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 480c-88.4 0-160-71.6-160-160 0-16.2 6.1-39.2 18.3-67.5 11.9-27.6 28.5-57.5 46.6-86.8 35.9-58 76.4-110.9 94.5-133.7h1.3c18.1 22.9 58.6 75.7 94.5 133.7 18.1 29.2 34.6 59.1 46.6 86.8 12.1 28.3 18.2 51.3 18.2 67.5 0 88.4-71.6 160-160 160zM0 320c0 106 86 192 192 192s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm384-208a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0z"
        }
    ]
};

const FalDropletPercent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDropletPercent",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 480c-88.4 0-160-71.6-160-160 0-16.2 6.1-39.2 18.3-67.5 11.9-27.6 28.5-57.5 46.6-86.8 35.9-58 76.4-110.9 94.5-133.7h1.3c18.1 22.9 58.6 75.7 94.5 133.7 18.1 29.2 34.6 59.1 46.6 86.8 12.1 28.3 18.2 51.3 18.2 67.5 0 88.4-71.6 160-160 160zM0 320c0 106 86 192 192 192s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm267.3-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM160 264a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm88 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalDropletSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDropletSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480c-88.4 0-160-71.6-160-160 0-16.2 6.1-39.2 18.3-67.5 2.8-6.4 5.8-13 9.1-19.7l-25.7-20.3C141.8 252.1 128 290.3 128 320c0 106 86 192 192 192 56.1 0 106.7-24.1 141.8-62.5l-25.2-19.9C407.4 460.6 366 480 320 480zm141.7-227.5c7.6 17.6 12.8 33.1 15.7 46.2l34.5 27.3c.1-2 .1-4 .1-6 0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7-13.3 16.8-39 50.2-66.4 90.3l25.2 19.9c27-39.7 52.6-73 66-89.9h1.3c18.1 22.9 58.6 75.7 94.5 133.7 18.1 29.2 34.6 59.1 46.6 86.8zM240 320c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112 8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDroplet",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 480c-88.4 0-160-71.6-160-160 0-16.2 6.1-39.2 18.3-67.5 11.9-27.6 28.5-57.5 46.6-86.8 35.9-58 76.4-110.9 94.5-133.7h1.3c18.1 22.9 58.6 75.7 94.5 133.7 18.1 29.2 34.6 59.1 46.6 86.8 12.1 28.3 18.2 51.3 18.2 67.5 0 88.4-71.6 160-160 160zM0 320c0 106 86 192 192 192s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3-6-7.5-14.9-11.7-24.5-11.7h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm112 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112 8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"
        }
    ]
};

const FalDrumSteelpan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDrumSteelpan",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 160c0-19.9-16.1-43.9-64.8-64.5-24.6-10.4-54.7-18.5-88.9-23.9-21.4 61.1-16.2 121.3 21.2 173 25.5-5.2 48.4-11.9 67.7-20.1 48.7-20.6 64.8-44.6 64.8-64.5zm-195.7 14.5c-15.2 8.4-36.8 17.5-60.3 17.5s-45.1-9.1-60.3-17.5c-4.2 26.2-13.5 51.7-28.6 75.9 27.5 3.7 57.4 5.6 88.8 5.6s61.3-2 88.8-5.6c-15-24.2-24.4-49.7-28.6-75.9zm-2.6-36.1c.4-23.5 4.5-47.4 12.2-71-22.1-2.2-45.5-3.4-69.9-3.4s-47.8 1.2-69.9 3.4c7.7 23.6 11.8 47.5 12.2 71 3.3 2.3 7.4 5 12.2 7.6 13.1 7.5 29.5 14 45.5 14s32.4-6.5 45.5-13.9c4.7-2.7 8.9-5.3 12.2-7.7zM96.8 224.5c19.3 8.2 42.2 14.9 67.7 20.1 37.5-51.8 42.6-112 21.2-173-34.2 5.4-64.3 13.5-88.9 23.9C48.1 116.1 32 140.1 32 160s16.1 43.9 64.8 64.5zM576 160v184c0 47.6-38.6 81.6-89.5 102.9C434.7 468.6 364.4 480 288 480s-146.7-11.4-198.5-33.1C38.6 425.6 0 391.6 0 344V160C0 80 128.9 32 288 32s288 48 288 128zm-32 62.8C496.1 264.4 399.5 288 288 288S79.9 264.4 32 222.8V344c0 27.4 22.3 53.4 69.9 73.4C148.5 436.9 214.2 448 288 448s139.5-11.1 186.2-30.6c47.6-19.9 69.8-46 69.8-73.4V222.8z"
        }
    ]
};

const FalDrum = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDrum",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M509.6 39.5c4.7 7.5 2.4 17.4-5.1 22l-86.3 53.9C475.4 133 512 162.8 512 208v160c0 22.6-13.6 41.6-32.3 56.2-18.8 14.7-44.9 26.8-75.1 35.9C362.8 472.7 311.3 480 256 480s-106.8-7.3-148.6-19.9C77.1 451 51.1 439 32.3 424.2 13.6 409.6 0 390.6 0 368V208C0 128 114.6 96 256 96c42.7 0 82.9 2.9 118.3 9.2l113.2-70.8c7.5-4.7 17.4-2.4 22 5.1zM332 131.6c-23.5-2.4-49-3.6-76-3.6-69 0-128.5 7.9-169.4 23.8C45.3 167.9 32 187.6 32 208c0 11.2 11.3 31.5 55.7 50.6C129 276.5 188.5 288 256 288s127-11.5 168.3-29.4c44.4-19.1 55.7-39.4 55.7-50.6 0-20.4-13.3-40.1-54.6-56.2-13.1-5.1-28.2-9.4-44.8-12.8l-132.1 82.6c-7.5 4.7-17.4 2.4-22-5.1s-2.4-17.4 5.1-22L332 131.6zm148 131.6c-16.2 12.8-38.1 24-64 32.9v126.4c18.3-7 33.2-15 44-23.5 14.8-11.5 20-22.2 20-31V263.2zm-96 42.3c-33.3 8.2-71.4 13.3-112 14.3v128c41.5-1.1 79.7-6.6 112-15.1V305.5zm-144 14.3c-40.6-1.1-78.7-6.1-112-14.3v127.2c32.3 8.5 70.5 14 112 15.1v-128zM96 296.1c-25.9-8.9-47.8-20.1-64-32.9V368c0 8.8 5.3 19.5 20 31 10.8 8.5 25.6 16.5 44 23.5V296.1z"
        }
    ]
};

const FalDrumstickBite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDrumstickBite",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 272c0 26.5 21.5 48 48 48h88.2c-5.3-15-8.2-31.2-8.2-48 0-79.5 64.5-144 144-144 2.6 0 5.3.1 7.9.2C452.2 72.2 398.8 32 336 32c-79.5 0-144 64.5-144 144v96zm-32 0v-96C160 78.8 238.8 0 336 0c86.5 0 158.5 62.5 173.2 144.8 2.1 11.8-10.3 20.1-22 17.6-7.5-1.6-15.3-2.4-23.2-2.4-61.9 0-112 50.1-112 112 0 19.2 4.8 37.2 13.3 53 5.7 10.5 1.1 24.8-10.8 26-6.1.6-12.3 1-18.5 1h-96c-3 0-6-.2-8.9-.5L192 390.6v.1c0 .1-.1.5-.1 1.2.1 1.5.7 3.5 2 5.2 8.9 12 14.2 26.9 14.2 42.9 0 39.8-32.2 72-72 72-37.2 0-67.8-28.2-71.6-64.4C28.2 443.8 0 413.2 0 376c0-39.8 32.2-72 72-72 16.1 0 30.9 5.3 42.9 14.2 1.7 1.2 3.7 1.9 5.2 2 .7 0 1.1-.1 1.2-.1h.1l39.1-39.1c-.3-2.9-.5-5.9-.5-8.9zm12.2 42.4L144 342.7c-15 15-36.5 9.9-48.1 1.2-6.7-5-14.9-7.9-23.9-7.9-22.1 0-40 17.9-40 40s17.9 40 40 40c13.1 0 24 10.9 24 24 0 22.1 17.9 40 40 40s40-17.9 40-40c0-9-2.9-17.2-7.9-23.8-8.7-11.7-13.7-33.2 1.2-48.1l28.2-28.2c-10.3-6.4-18.9-15.1-25.4-25.4z"
        }
    ]
};

const FalDrumstick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDrumstick",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 272v-96c0-79.5 64.5-144 144-144s144 64.5 144 144-64.5 144-144 144h-96c-26.5 0-48-21.5-48-48zm-32-96v96c0 3 .2 6 .5 8.9L121.4 320h-.1c-.1 0-.5.1-1.2.1-1.5-.1-3.5-.7-5.2-2-12-8.8-26.8-14.1-42.9-14.1-39.8 0-72 32.2-72 72 0 37.2 28.2 67.8 64.4 71.6C68.2 483.8 98.8 512 136 512c39.8 0 72-32.2 72-72 0-16.1-5.3-30.9-14.2-42.9-1.2-1.7-1.9-3.7-2-5.2 0-.7.1-1.1.1-1.2v-.1l39.1-39.1c2.9.3 5.9.5 8.9.5h96c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176zm12.2 138.4c6.4 10.3 15.1 18.9 25.4 25.4L169.3 368c-15 15-9.9 36.5-1.2 48.1 4.9 6.7 7.9 14.9 7.9 23.8 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1-10.9-24-24-24-22.1 0-40-17.9-40-40s17.9-40 40-40c9 0 17.2 2.9 23.8 7.9 11.7 8.7 33.2 13.7 48.1-1.2l28.2-28.2z"
        }
    ]
};

const FalDryerHeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDryerHeat",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm176 208a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm115.3-75.3 4.7 4.7c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l4.7 4.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm80 0 4.7 4.7c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6l-9.4 9.4c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16l4.7 4.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7c-10.2-10.2-16-24.1-16-38.6s5.8-28.4 16-38.6l9.4-9.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16l-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FalDryer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDryer",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h320zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 96a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 296c-56.4 0-103.1-41.7-110.9-96H176c8.8 0 16-7.2 16-16s-7.2-16-16-16h-62.9c7.8-54.3 54.4-96 110.9-96 61.9 0 112 50.1 112 112s-50.1 112-112 112zM80 304a144 144 0 1 0 288 0 144 144 0 1 0-288 0z"
        }
    ]
};

const FalDuck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDuck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 259v-23.6c0-17.3 7.1-31.9 15.3-42.5l19.4 15.1-19.4-15.1c10.5-13.5 16.7-30.4 16.7-48.9 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 26.2 12.6 49.5 32.2 64.2 9.8 7.3 14.5 19.5 12.3 31.5s-11.1 21.7-22.8 25l-165 46.2c-7 2-14.5 1.5-21.2-1.4l-43.3-18.6C36.5 378 108.4 448 196 448h116c53 0 96-43 96-96 0-27.5-11.5-52.2-30-69.7-6.4-6-10-14.4-10-23.2zm32-19v19c24.6 23.3 40 56.3 40 93 0 70.7-57.3 128-128 128H196C87.8 480 0 391 0 282.7 0 268.1 11.9 256 26.6 256c3.6 0 7.2.7 10.5 2.1L88 280l128.4-36 36.6-10.2c-9.8-7.3-18.3-16.1-25.2-26.2-12.5-18.1-19.8-40-19.8-63.6 0-61.9 50.1-112 112-112 54.1 0 99.3 38.4 109.7 89.4 9.6 1.3 19.3 1.3 28.9.1l24.2-3c15.5-1.9 29.2 10.1 29.2 25.8 0 52.9-42.9 95.7-95.7 95.7H400zm31.6-86.2c-1.7 20-8.8 38.6-19.7 54.2h4.4c32.9 0 59.9-24.9 63.3-56.8l-17 2.1c-10.3 1.3-20.7 1.5-31 .5zM312 152a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm13.2 159.7c-6.2 46.7-41.4 87-90.7 99.3-40.4 10.1-81.2-.9-109.7-26.2-6.6-5.9-7.2-16-1.3-22.6s16-7.2 22.6-1.3c20.7 18.3 50.6 26.6 80.7 19.1 36.8-9.2 62.3-39 66.7-72.5 1.2-8.8 9.2-14.9 18-13.7s14.9 9.2 13.7 18z"
        }
    ]
};

const FalDumbbell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDumbbell",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 64c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zm-80 349.3V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V272h128v160c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-18.7c5 1.8 10.4 2.7 16 2.7h32c26.5 0 48-21.5 48-48v-96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-96c0-26.5-21.5-48-48-48h-32c-5.6 0-11 1-16 2.7V80c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48v160H256V80c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48v18.7c-5-1.7-10.4-2.7-16-2.7H80c-26.5 0-48 21.5-48 48v96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v96c0 26.5 21.5 48 48 48h32c5.6 0 11-1 16-2.7zM512 144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144zm-32 224v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v288zM128 144v224c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalDumpsterFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDumpsterFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M423.4 32H519c14.7 0 27.5 10 31 24.2l18.5 74c-10.5-5.9-22.7-7.5-34.2-4.7L519 64h-76l6.1 32.3c-10.7-1.3-21.8 1.2-31.2 7.3L410.4 64H304v96h58c-8.8 10.6-17 21.3-24.5 32h-309C12.8 192 0 179.2 0 163.5c0-2.3.3-4.7.9-6.9l25-100.4C29.5 42 42.3 32 57 32h366.4zm-85.8 416H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-15.1L45.1 288H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h25.3l-3.8-32h32.3l22.5 192h222.1c6.6 11.4 14.4 22.2 23.2 32zM272 64H165.3l-18 96H272V64zm-139.3 0H57l-24 96h81.7l18-96zm376.7 157.5c-9.6.1-18.8-4.1-25-11.5-12.9-15.5-26.5-30-40.8-43.7-26.1 25-48 52.3-64 78.1-18.3 29.6-27.6 57.9-27.6 75.8 0 70.3 56.2 127.8 128 127.8 71 0 128-57.6 128-127.8 0-12.8-7-38.2-20.6-64.3-10.9-21.1-25.4-42.6-41.8-60.5-3.8 4.4-7.7 9.1-11.6 14-6 7.5-15.1 12-24.7 12.1zm-21.8-56.4c7.4 7.9 14.5 16 21.5 24.4 6.4-8.1 13.6-16.8 21.2-24.5 1.7-1.7 3.5-3.4 5.2-5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C640 408 568.7 480 480 480c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8 11.8 10.6 23.1 21.7 34 33.4zM445.1 224c4.8 0 9.4 2.2 12.4 6 2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1v.1c21.3 39.3 12.3 90.4-25 116.5l-.3.2C521.3 410 502.3 416 481 416c-25.9 0-50.2-8.4-68.2-24.8-18.1-16.6-28.8-40.5-28.8-69.2 0-15.7 5-29.7 13.4-44.2 8.2-14.1 20.2-29.5 35.1-47.9 3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L507 319l-12.6 9.9-.1-.2-.5-.6-1.8-2.4-6.6-8.4-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2-6.6 11.3-9.1 19.8-9.1 28.1 0 20.3 7.3 35.4 18.4 45.6 11.2 10.2 27.4 16.3 46.5 16.3 14.7 0 27.6-4 40-12.2 20.1-14.2 27.8-41.8 18.9-66.5z"
        }
    ]
};

const FalDumpster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDumpster",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M423.4 32H57c-14.7 0-27.5 10-31 24.2L.9 156.6c-.6 2.3-.9 4.6-.9 6.9C0 179.2 12.8 192 28.5 192h519c15.7 0 28.5-12.8 28.5-28.5 0-2.3-.3-4.7-.9-6.9l-25-100.4C546.5 42 533.7 32 519 32h-95.6zM37.5 224l3.8 32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h29.1L64 448.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-15.1L530.9 288H560c8.8 0 16-7.2 16-16s-7.2-16-16-16h-25.3l3.8-32h-32.3l-22.5 192H92.3L69.8 224H37.5zm490.2-64h-66.5L443 64h76l24 96h-15.2zM410.4 64l18.2 96H304V64h106.4zM272 64v96H147.3l18-96H272zm-139.3 0-18 96H33l24-96h75.7z"
        }
    ]
};

const FalDungeon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalDungeon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.3 163.6c6.2 4.2 11.9 9.1 17.1 14.4 6.1 6.3 14 11 22.7 13.5-1.6 8.9-.8 18 2.2 26.2s5 16.9 6 25.9c1.1 10.4 5.7 20.5 12.9 28.5-7.6 8.5-12.2 19.7-12.2 32v48c0 12.3 4.6 23.5 12.2 32-7.6 8.5-12.2 19.7-12.2 32v48c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V416c0-12.3-4.6-23.5-12.2-32 7.6-8.5 12.2-19.7 12.2-32v-48c0-12.3-4.6-23.5-12.2-32 7.9-8.8 12.6-20.7 11.6-34.2-2.1-30.4-9.6-59.3-21.4-85.8-6.1-13.8-17.3-22.4-29.8-25.8 2.1-12.8-1-26.6-10.8-37.9-17.9-20.6-39-38.3-62.5-52.3-13-7.7-27.1-8.3-39.3-3.9-5.7-11.7-16.2-21.1-30.8-24.7C297.2 2.5 276.9 0 256 0s-41.2 2.5-60.7 7.2c-14.6 3.6-25.1 13-30.8 24.7-12.2-4.4-26.3-3.8-39.3 3.9-23.6 14-44.7 31.7-62.5 52.3-9.8 11.3-13 25.1-10.8 37.9-12.5 3.5-23.7 12.1-29.8 25.8-11.9 26.7-19.3 55.6-21.5 86-1 13.5 3.7 25.4 11.6 34.2C4.6 280.5 0 291.7 0 304v48c0 12.3 4.6 23.5 12.2 32C4.6 392.5 0 403.7 0 416v48c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48v-48c0-12.3-4.6-23.5-12.2-32 7.6-8.5 12.2-19.7 12.2-32v-48c0-12.3-4.6-23.5-12.2-32 7.2-8 11.7-18.1 12.9-28.5 1-9 3.1-17.7 6-25.9 3-8.2 3.8-17.4 2.2-26.2 8.7-2.4 16.6-7.2 22.7-13.5 5.2-5.3 10.9-10.2 17.1-14.4 7.2-4.9 13.2-11.9 17.1-20 8.5 3 17.6 3.8 26.2 2.2 6.5-1.2 13.2-1.8 20-1.8s13.5.6 20 1.8c8.6 1.5 17.7.8 26.2-2.2 3.9 8.1 9.9 15.1 17.1 20zm62-5c-6.9 4.6-16.2 3.1-22-2.9-6.7-6.9-14-13.1-21.9-18.5-6.7-4.6-9.8-13.1-6.8-20.6l.2-.6 17.9-44.8c3.5-8.7 13.6-12.6 21.6-7.8 20.6 12.3 39.1 27.8 54.8 45.8 6 6.9 4.2 17.4-3.5 22.5l-1 .7-39.4 26.2zm16.2 27.6 1.5-1 39.4-26.2c7.8-5.2 18.5-2.6 22.3 6 10.3 23.2 16.8 48.5 18.7 75.1.6 8.8-6.6 16-15.4 16h-48c-8.8 0-15.9-7.2-16.9-16-1.3-11.6-3.9-22.7-7.8-33.3-2.7-7.5-.5-16.1 6.2-20.5zM416 400h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zM193 59.3l-.2-.4c-3.4-8.6 1.1-18.3 10.1-20.5 17-4.1 34.8-6.3 53.1-6.3s36.1 2.2 53.1 6.3c9 2.2 13.5 11.9 10.1 20.5l-.2.4v.1l-17.9 44.8c-3.1 7.6-11.4 11.6-19.4 10.1-8.3-1.5-16.9-2.3-25.7-2.3s-17.3.8-25.7 2.3c-8.1 1.5-16.4-2.5-19.4-10.1L193 59.3zm-51.3 4.1c8-4.8 18.2-.9 21.6 7.8l17.9 44.8.2.6c3 7.5-.1 16-6.8 20.6-7.9 5.4-15.3 11.6-21.9 18.5-5.8 6-15.1 7.5-22 2.9l-39.3-26.3-1-.7c-7.6-5.1-9.5-15.6-3.5-22.5 15.7-18 34.1-33.5 54.8-45.8zM51.3 165c3.8-8.6 14.5-11.2 22.3-6l39.4 26.2 1.5 1c6.6 4.4 8.9 13 6.2 20.5-3.9 10.6-6.5 21.7-7.8 33.3-1 8.8-8 16-16.9 16H48c-8.8 0-16.1-7.2-15.4-16 1.9-26.6 8.4-51.9 18.7-75.1zM112 304v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm288 0c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-48zM32 416c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-48zm240-224c0-8.8-7.2-16-16-16s-16 7.2-16 16v272c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm-64 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 8.8 7.2 16 16 16s16-7.2 16-16V224zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 8.8 7.2 16 16 16s16-7.2 16-16V224z"
        }
    ]
};

const FalE = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalE",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16V272h208c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V80c0-8.8 7.2-16 16-16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H48z"
        }
    ]
};

const FalEarDeaf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEarDeaf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m507.3 27.3-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-320 320-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM240 96c-79.5 0-144 64.5-144 144 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-97.2 78.8-176 176-176s176 78.8 176 176c0 51.3-21.9 97.4-56.9 129.6-4.8 4.4-7.1 9.7-7.1 14.4 0 70.7-57.3 128-128 128h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c53 0 96-43 96-96 0-15.4 7.4-28.7 17.5-38 28.6-26.3 46.5-64.1 46.5-106 0-79.5-64.5-144-144-144zm0 64c-44.2 0-80 35.8-80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112s112 50.1 112 112c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2-35.8-80-80-80z"
        }
    ]
};

const FalEarListen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEarListen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M350 8.2c-4.3 7.7-1.5 17.5 6.2 21.8C430.1 71 480 149.7 480 240c0 8.8 7.2 16 16 16s16-7.2 16-16c0-102.4-56.6-191.6-140.2-238-7.7-4.3-17.5-1.5-21.8 6.2zM96 240c0-79.5 64.5-144 144-144s144 64.5 144 144c0 41.9-17.9 79.7-46.5 106-10.1 9.2-17.5 22.6-17.5 38 0 53-43 96-96 96h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c70.7 0 128-57.3 128-128 0-4.8 2.4-10 7.1-14.4 35-32.2 56.9-78.3 56.9-129.6 0-97.2-78.8-176-176-176S64 142.8 64 240c0 8.8 7.2 16 16 16s16-7.2 16-16zm64 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM32 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm20.7-131.3c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM160 240c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112s-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalEarMuffs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEarMuffs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c-91.9 0-167.4 70.5-175.3 160.3-11.7 1-22.7 4.2-32.6 9.2C115.5 89.7 207.3 0 320 0s204.5 89.7 207.9 201.5c-9.9-5.1-20.9-8.3-32.6-9.2C487.4 102.5 411.9 32 320 32zm176 192.6c9 1.3 17.2 4.7 24.3 9.7 5-1.5 10.3-2.2 15.7-2.2 19.9 0 37.5 10.4 47.4 26.1 23.4 6.7 40.6 28.3 40.6 53.9 0 5.1-.7 10.1-2 14.9 11.1 10.2 18 24.9 18 41.1s-6.9 30.9-18 41.1c1.3 4.7 2 9.7 2 14.9 0 25.6-17.2 47.2-40.6 53.9-9.9 15.6-27.5 26-47.4 26-5.5 0-10.7-.8-15.7-2.2-9.1 6.4-20.3 10.2-32.3 10.2-30.9 0-56-25.1-56-56 0-10.2 2.7-19.8 7.5-28-4.8-8.2-7.5-17.8-7.5-28 0-11.9 3.7-22.9 10-32-6.3-9.1-10-20.1-10-32 0-10.2 2.7-19.8 7.5-28-4.8-8.2-7.5-17.8-7.5-28 0-30.9 25.1-56 56-56 2.7 0 5.4.2 8 .6zm-344-.6c30.9 0 56 25.1 56 56 0 10.2-2.7 19.8-7.5 28 4.8 8.2 7.5 17.8 7.5 28 0 11.9-3.7 22.9-10 32 6.3 9.1 10 20.1 10 32 0 10.2-2.7 19.8-7.5 28 4.8 8.2 7.5 17.8 7.5 28 0 30.9-25.1 56-56 56-12 0-23.2-3.8-32.3-10.2-5 1.5-10.3 2.2-15.7 2.2-20 0-37.5-10.4-47.4-26.1C33.2 471.2 16 449.6 16 424c0-5.1.7-10.1 2-14.9C6.9 398.9 0 384.3 0 368s6.9-30.9 18-41.1c-1.3-4.7-2-9.7-2-14.9 0-25.6 17.2-47.2 40.6-53.9C66.5 242.4 84 232 104 232c5.5 0 10.7.8 15.7 2.2 7.1-5 15.3-8.4 24.3-9.7 2.6-.4 5.3-.6 8-.6zm20.8 100c-5.7-9.9-5.7-22.1 0-32 2-3.5 3.2-7.6 3.2-12 0-13.3-10.7-24-24-24-5.2 0-9.9 1.6-13.8 4.4-8 5.6-18.1 7.3-27.4 4.6-2.1-.6-4.4-1-6.8-1-8.5 0-16 4.4-20.3 11.2-4.2 6.7-10.7 11.5-18.3 13.7C55.3 291.8 48 301.1 48 312c0 2.3.3 4.4.9 6.4 3.2 11.5-.4 23.9-9.1 32C34.9 354.8 32 361 32 368s2.9 13.2 7.7 17.6c8.8 8.1 12.3 20.4 9.1 32-.5 2-.9 4.1-.9 6.4 0 10.9 7.3 20.2 17.4 23.1 7.6 2.2 14.1 7 18.3 13.7C88 467.6 95.5 472 104 472c2.4 0 4.6-.3 6.8-1 9.4-2.7 19.5-1 27.4 4.6 3.9 2.8 8.6 4.4 13.8 4.4 13.3 0 24-10.7 24-24 0-4.4-1.2-8.5-3.2-12-5.7-9.9-5.7-22.1 0-32 2-3.5 3.2-7.6 3.2-12 0-5.1-1.6-9.8-4.3-13.7-7.7-11-7.7-25.6 0-36.6 2.7-3.9 4.3-8.6 4.3-13.7 0-4.4-1.2-8.5-3.2-12zM464 280c0 4.4 1.2 8.5 3.2 12 5.7 9.9 5.7 22.1 0 32-2 3.5-3.2 7.6-3.2 12 0 5.1 1.6 9.8 4.3 13.7 7.7 11 7.7 25.6 0 36.6-2.7 3.9-4.3 8.6-4.3 13.7 0 4.4 1.2 8.5 3.2 12 5.7 9.9 5.7 22.1 0 32-2 3.5-3.2 7.6-3.2 12 0 13.3 10.7 24 24 24 5.2 0 9.9-1.6 13.8-4.4 8-5.6 18.1-7.3 27.4-4.6 2.1.6 4.4 1 6.8 1 8.5 0 16-4.4 20.3-11.2 4.2-6.7 10.7-11.5 18.3-13.7 10.1-2.9 17.4-12.2 17.4-23.1 0-2.3-.3-4.4-.9-6.4-3.2-11.5.4-23.9 9.1-32 4.8-4.4 7.7-10.7 7.7-17.6s-2.9-13.2-7.7-17.6c-8.8-8.1-12.3-20.4-9.1-32 .5-2 .9-4.1.9-6.4 0-10.9-7.3-20.2-17.4-23.1-7.6-2.2-14.1-7-18.3-13.7-4.3-6.8-11.8-11.2-20.3-11.2-2.4 0-4.6.3-6.8 1-9.4 2.7-19.5 1-27.4-4.6-3.9-2.8-8.6-4.4-13.8-4.4-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FalEar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192v176c0 61.9 50.1 112 112 112s112-50.1 112-112c0-16.4 8.2-32.2 22.5-41.4C322.8 298.1 352 248.5 352 192zm32 0c0 67.8-35.1 127.4-88.2 161.5-4.9 3.2-7.8 8.6-7.8 14.5 0 79.5-64.5 144-144 144S0 447.5 0 368V192C0 86 86 0 192 0s192 86 192 192zm-272 0v6.3c0 10.7 5.3 20.7 14.2 26.6l8.9 5.9c15.5 10.4 24.9 27.8 24.9 46.5 0 16.6-7.4 32.3-20.1 42.9l-33.7 28c-6.8 5.7-16.9 4.7-22.5-2s-4.7-16.9 2-22.5l33.7-28c5.4-4.5 8.6-11.2 8.6-18.3 0-8-4-15.4-10.6-19.9l-8.9-5.9C90.7 239.7 80 219.7 80 198.3V192c0-61.9 50.1-112 112-112s112 50.1 112 112v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-44.2-35.8-80-80-80s-80 35.8-80 80z"
        }
    ]
};

const FalEarthAfrica = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEarthAfrica",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256c0-16.8-1.8-33.1-5.3-48.8l-47.2-11.8c-4.1-1-8.4.2-11.3 3.1-2 2-3.6 4.2-4.9 6.7l-.3.6c-7.9 15.8-22.1 27.3-38.6 31.9l15.1 15.1c8 8 12.5 18.9 12.5 30.2 0 19.5-13.2 36.5-32 41.4v6.2c0 17.3-5.6 34.2-16 48l-25.6 34.1c-9.1 12.2-23.3 19.3-38.4 19.3-26.5 0-48-21.5-48-48v-48h-32c-35.3 0-64-28.7-64-64v-28c0-17.6 8.3-34.2 22.4-44.8l39.4-29.5c8.4-6.3 18.5-9.7 29-9.7 5.2 0 10.3.8 15.3 2.5l32 10.7c4.3 1.4 9 1.6 13.4.5l34.3-8.6c3.7-.9 6.3-4.3 6.3-8.1 0-2.8-1.4-5.4-3.7-6.9L306 132.6c-7.6 7.3-17.7 11.4-28.2 11.4-6.3 0-12.5-1.5-18.2-4.3l-13.2-6.6c-23.9 36.9-83 14.6-74.9-30.2l3.5-18.6c.4-2 .2-4.1-.4-6.1l-9-27.1C86.9 85.8 32 164.5 32 256c0 123.7 100.3 224 224 224s224-100.3 224-224zm-16.5-84.6C430.1 89.6 349.8 32 256 32c-20.9 0-41.2 2.9-60.4 8.2l9.3 27.8c2.4 7.1 2.9 14.6 1.6 22l-3.4 18.7c-1.9 10.2 12 15.2 17.1 6.1 7.4-13.4 24.1-18.5 37.8-11.7l16 8c1.2.6 2.5.9 3.8.9 2.3 0 4.5-.9 6.1-2.5l3.5-3.5c8.5-8.5 21.7-9.8 31.7-3.1l30.9 20.6c11.2 7.5 18 20.1 18 33.5 0 18.5-12.6 34.6-30.5 39.1l-34.3 8.6c-10.3 2.6-21.2 2.2-31.3-1.2l-32-10.7c-1.7-.6-3.4-.8-5.1-.8-3.5 0-7 1.1-9.8 3.3l-39.4 29.5c-6 4.5-9.6 11.6-9.6 19.2v28c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32v48c0 8.8 7.2 16 16 16 5 0 9.8-2.4 12.8-6.4l25.6-34.1c6.2-8.3 9.6-18.4 9.6-28.8v-12.1c0-11.2 7.6-21 18.5-23.7l5.3-1.3c4.8-1.2 8.2-5.5 8.2-10.5 0-2.9-1.1-5.6-3.2-7.6l-40.2-40.2c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9h19.7c11.3 0 21.6-6.4 26.7-16.5l.3-.6c2.8-5.6 6.4-10.7 10.9-15.1 10.9-10.9 26.8-15.3 41.7-11.6l28.2 7.1zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FalEarthAmericas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEarthAmericas",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480C132.3 480 32 379.7 32 256c0-11.8.9-23.3 2.7-34.6l3 6.7c9.3 21 27.3 37 49.2 43.9l63 19.7c15.5 4.9 26.1 19.2 26.1 35.5v15c0 17 9.6 32.6 24.8 40.2 4.4 2.2 7.2 6.7 7.2 11.6v22.7c0 26.2 21.2 47.4 47.4 47.4 21.8 0 40.7-14.8 46-35.9l4.4-17.6c2.6-10.2 9.2-19 18.3-24.2l11.6-6.6c19.9-11.4 32.2-32.6 32.2-55.6v-8.3c0-17-6.7-33.3-18.7-45.3l-3.9-3.9c-12-12-28.3-18.7-45.3-18.7h-48.7c-5 0-9.9-1.2-14.3-3.4l-45.9-22.9c-2.1-1-3.8-2.7-4.8-4.8l-.7-1.4c-2.3-4.6-.4-10.2 4.2-12.5 2.2-1.1 4.8-1.3 7.1-.5l24.2 8.1c15 5 31.5-.7 40.3-13.8 8.6-12.9 7.7-30-2.2-41.9l-17.9-21.5c-2.5-3-2.5-7.4.1-10.3l20.1-23.5c13.2-15.4 15.3-37.4 5.2-55.1L259.6 32c77.5 1.2 145.4 41.8 184.7 102.6l-38.2 15.3c-23.6 9.4-35.7 35.6-27.7 59.7l16.9 50.7c5.2 15.6 18 27.4 33.9 31.4l45.8 11.5C453.3 404.3 363.5 480 256 480zM48 172.7c29.3-73 95.8-127 176-138.4l14.9 26.1c3.4 5.9 2.7 13.2-1.7 18.4l-20.1 23.5c-12.7 14.8-12.9 36.6-.4 51.6l17.9 21.5c.9 1.1 1 2.6.2 3.7-.8 1.2-2.2 1.7-3.6 1.2l-24.2-8.2c-10.4-3.5-21.7-2.7-31.5 2.2-20.4 10.2-28.7 35-18.5 55.4l.7 1.4c4.1 8.3 10.9 15 19.2 19.2l45.9 22.9c8.9 4.4 18.7 6.8 28.6 6.8h48.8c8.5 0 16.6 3.4 22.6 9.4l3.9 3.9c6 6 9.4 14.1 9.4 22.6v8.3c0 11.5-6.2 22.1-16.1 27.8l-11.6 6.6c-16.7 9.6-28.8 25.5-33.5 44.2l-4.4 17.6c-1.7 6.9-7.9 11.7-15 11.7-8.5 0-15.4-6.9-15.4-15.4v-22.8c0-17-9.6-32.6-24.8-40.2-4.4-2.2-7.2-6.7-7.2-11.6v-15c0-30.3-19.7-57-48.6-66.1l-63-19.7C83.3 237.2 72.6 227.6 67 215l-19-42.3zM480 256c0 5.2-.2 10.3-.5 15.4l-42.6-10.6c-5.3-1.3-9.6-5.3-11.3-10.5l-16.9-50.7c-2.7-8 1.4-16.8 9.2-19.9l41.8-16.7c13 28.3 20.2 59.9 20.2 93.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512z"
        }
    ]
};

const FalEarthAsia = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEarthAsia",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256c0-91.8-55.2-170.7-134.2-205.3l-22.3 55.8c-4.8 11.9-15 20.8-27.4 24l-17 4.3c-5.6 1.4-7.9 8-4.5 12.6l16.1 21.5c10.2 13.6 10.7 32.1 1.3 46.2l-10.7 16.1c-10.4 15.6-27.9 24.9-46.6 24.9h-2.3c-5.4 0-9.2 5.2-7.7 10.3l6 19.9c7.4 24.8-11.1 49.8-37 49.8-16.8 0-32.2-9.5-39.7-24.5l-9.3-18.5c-2.4-4.9-9-5.9-12.8-2.1l-15.4 15.4c-9.5 9.5-23 13.6-36.1 10.9l-42-8.4C62 407 150.5 480 256 480c47.4 0 91.4-14.7 127.6-39.9l-8.5-6.1-10.6 3.9c-27.7 10.3-58.6-2.7-70.6-29.6l-5.5-12.3c-11.9-26.5-1.5-57.7 23.8-71.8l36.2-20.2 6.1-9.5c9-14 24.4-22.5 41.1-22.5s32.1 8.5 41.1 22.5l1.9 2.9 15.7-4.4c7.5-2.1 15.4-1.9 22.8.4 2-12.2 3.1-24.7 3.1-37.4zm-11.6 68.4c-1.8-.9-3.8-1-5.6-.5l-15.8 4.4c-13.4 3.8-27.8-1.7-35.3-13.5l-2-3.1c-3.1-4.8-8.4-7.7-14.1-7.7s-11 2.9-14.1 7.7l-6.1 9.5c-2.8 4.4-6.7 8.1-11.4 10.7l-36.2 20.2c-10.9 6.1-15.3 19.4-10.2 30.8l5.5 12.4c5.2 11.5 18.4 17.1 30.3 12.7l18.6-7c5-1.9 10.6-1.1 15 2l22.4 16.2c27.3-25.6 48.1-58 59.9-94.5l-.9-.4zM315.6 40c-19-5.2-38.9-8-59.6-8C132.3 32 32 132.3 32 256c0 6.4.3 12.8.8 19l53.7 10.7c2.6.5 5.3-.3 7.2-2.2l15.4-15.4c19.3-19.3 51.9-14 64.1 10.4l9.3 18.5c2.1 4.2 6.4 6.8 11 6.8 4.5 0 7.7-4.3 6.4-8.6l-6-19.9c-7.7-25.7 11.5-51.5 38.3-51.5h2.3c8 0 15.5-4 20-10.7l10.7-16.1c1.9-2.8 1.8-6.5-.3-9.2l-16.1-21.5c-17.2-22.9-5.5-55.9 22.3-62.8l17-4.3c2.5-.6 4.5-2.4 5.5-4.8l22-54.4zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm163.9 88.5 32 8c8.6 2.1 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6l-32-8c-8.6-2.1-13.8-10.8-11.6-19.4s10.8-13.8 19.4-11.6zm84.2 3c-8.6-2.1-13.8-10.8-11.6-19.4l8-32c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4l-8 32c-2.1 8.6-10.8 13.8-19.4 11.6zm118.2-204.3-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z"
        }
    ]
};

const FalEarthEurope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEarthEurope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M477.7 288h-38.3c-6.2 0-12.3-2.2-17.1-6.2l-15.9-13.2c-4.6-3.8-5.2-10.5-1.5-15.2 14.6-18.3 1.6-45.4-21.8-45.4h-3.7c-6.3 0-11.4-5.1-11.4-11.4v-9.4c0-18.4-22.2-27.6-35.2-14.6l-32.1 32.1a6.64 6.64 0 0 1-9.4 0l-2.8-2.8c-6.3-6.3-14.8-9.8-23.7-9.8-10.5 0-20.5 5-26.8 13.4l-10.7 14.3c-2 2.7-5.2 4.3-8.5 4.3-5.9 0-10.7-4.8-10.7-10.7v-1.6c0-3.3 1.3-6.4 3.6-8.7l18.7-18.7c6.2-6.2 9.7-14.7 9.7-23.5 0-4.3 2.4-8.2 6.2-10.1l59.2-29.6c20.2-10.1 26.9-35.6 14.2-54.3-8.9-13.2-25.1-19.1-40-15.3l4.5-17.8C394.5 47.5 480 141.8 480 256c0 10.9-.8 21.5-2.3 32zm-7 32c-3.3 11-7.4 21.7-12.3 32h-19.8c-10.2 0-20.1-4.1-27.3-11.3l-4-4C396.6 326 382.2 320 367.1 320c-5.9 0-11.7-2.1-16.1-6l-26.6-22.8c-14.5-12.4-33-19.3-52.1-19.3h-20.9c-15.8 0-31.2 4.7-44.4 13.4l-27.4 18.3c-22.3 14.8-35.6 39.8-35.6 66.6v3.2c0 21.2 8.4 41.6 23.4 56.6l16 16c11.5 11.5 27.1 17.9 43.3 17.9 11.4 0 21.2 6.5 26.1 16C130.6 478.3 32 378.6 32 256c0-122.2 97.9-221.6 219.5-224l-6.9 27.6c-4.9 19.7 15.4 36.2 33.7 27.3l8.1-3.9c2.4-1.2 5.3-.4 6.8 1.8 1.8 2.7.8 6.3-2 7.8L232 122.2c-14.7 7.3-23.9 22.3-23.9 38.7 0 .3-.1.6-.4.9L189 180.4c-8.3 8.3-13 19.6-13 31.3v1.6c0 23.6 19.1 42.7 42.7 42.7 13.4 0 26.1-6.3 34.1-17.1l10.7-14.3c.3-.4.7-.6 1.2-.6.4 0 .8.2 1.1.4l2.8 2.8c15.1 15.1 39.6 15.1 54.7 0l15.4-15.4c5.8 15.3 20 26.5 36.9 28-9.5 17.6-5.6 40 10.3 53.3l15.9 13.2c10.5 8.8 23.8 13.6 37.5 13.6h31.3zm-30.9 64c-35.1 50.3-90.2 85.5-153.8 94-6.8-26.4-30.8-46-59.3-46-7.8 0-15.2-3.1-20.7-8.6l-16-16c-9-9-14.1-21.2-14.1-33.9v-3.2c0-16.1 8-31 21.4-39.9l27.4-18.3c7.9-5.3 17.1-8.1 26.6-8.1h20.9c11.5 0 22.5 4.1 31.2 11.6l26.6 22.8c10.3 8.8 23.4 13.7 37 13.7 6.6 0 12.9 2.6 17.5 7.3l4 4c13.2 13.2 31.2 20.7 49.9 20.7h1.2zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-68.7-411.3c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalEarthOceania = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEarthOceania",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm16.7-303.5c-5-1.3-10.3 0-14.3 3.3l-25.2 21.5c-1.9 1.6-4.4 2.2-6.8 1.7l-.3-.1-4-5.3C211.8 216 195.8 208 178.7 208s-33.1 8-43.4 21.7l-5.3 7-35.3 16.8C66 267.1 54.4 302 69.2 330.1l3.3 6.2c12.6 24 40.6 35.5 66.5 27.3l20.4-6.5 45.8 15.9 27 17.4c9.6 6.2 20.9 9.5 32.3 9.5 18.4 0 35.7-8.4 47-22.9l12.1-15.4c8-10.2 12.4-22.9 12.4-35.9s-4.4-25.6-12.4-35.9l-18-22.9c-3.8-4.9-6.9-10.3-9.2-16.1l-12.8-32.7c-1.9-4.8-6-8.4-11-9.7zm-94 31.5c7 0 13.6 3.3 17.8 8.9l4 5.3c4.7 6.2 11.5 10.6 19.2 12.1l.3.1c12.1 2.5 24.6-.8 34-8.7l8.1-6.9 4.6 11.8c3.4 8.7 8 16.8 13.8 24.2l17.9 22.9c3.6 4.6 5.6 10.3 5.6 16.1s-2 11.5-5.6 16.1l-12.1 15.4c-5.2 6.7-13.3 10.6-21.8 10.6-5.3 0-10.5-1.5-15-4.4L220.8 345c-1.1-.7-2.2-1.3-3.5-1.7l-52.7-18.2c-3.3-1.1-6.8-1.2-10.1-.1l-25.4 8.1c-11.1 3.5-23.1-1.4-28.5-11.7l-3.3-6.2c-6.3-12.1-1.4-27 10.9-32.8l35.3-16.8c4.7-2.2 8.7-5.5 11.8-9.7l5.3-7c4.2-5.6 10.8-8.9 17.8-8.9zm103-114.6c-12.4-14.4-32.1-20.2-50.2-14.7l-43.1 12.9c-19.8 5.9-23.3 32.4-5.8 43.3l39.4 24.6c9.4 5.8 20.4 8.3 31.4 6.9l37.9-4.7c19-2.4 27.7-24.9 15.2-39.4l-24.8-28.9zm-41 15.9c6.1-1.8 12.6.1 16.7 4.9l15.1 17.6-23.2 2.9c-3.6.5-7.3-.4-10.5-2.3l-24.4-15.2 26.2-7.9zM248 432c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm183.2-125.1c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l8 24c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-8-24zm-19.9 80.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32z"
        }
    ]
};

const FalEclipse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEclipse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6l90.4-62.3 90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.6-52.2c-10.3-4.5-20.2-9.9-29.6-15.9l-7 38-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8l-94.3-17.4L97.7 265c3.8-5.5 3.8-12.7 0-18.2l-54.5-79 94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5L247 97.6c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 7 38.1c9.4-6.1 19.3-11.4 29.6-15.9l-9.6-52.2zM256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c13.7 0 27-2.2 39.4-6.2-6.5-9-12.3-18.4-17.3-28.4-7.1 1.7-14.5 2.6-22.1 2.6-53 0-96-43-96-96s43-96 96-96c7.6 0 15 .9 22.1 2.6 5-9.9 10.8-19.4 17.3-28.4-12.4-4-25.7-6.2-39.4-6.2zm64 128a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm320 0a176 176 0 1 0-352 0 176 176 0 1 0 352 0z"
        }
    ]
};

const FalEggFried = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEggFried",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M461.1 182.8c31.6 42.6 22.6 102.7-19.9 134.3-13.4 9.9-28.4 15.8-43.8 18-23.8 3.3-49.1 13.4-70.9 26.8-21.6 13.3-42.8 31.8-55.7 54.1-35.3 61.2-113.6 82.2-174.8 46.9S13.8 349.2 49.1 288c28.1-48.6 42.7-116.9 47.2-168.4 2-22.3 11.7-44 29.1-60.8 38.2-36.7 99-35.5 135.7 2.7 17.9 18.6 42.8 36.8 68.2 51.6s53.5 27.6 78.5 33.9c20.6 5.3 39.6 17.4 53.3 35.8zM415.8 116c-42.4-10.9-101.2-45.1-131.5-76.7-49-51-130-52.6-181-3.6C80.1 58 67.1 87 64.5 116.8 60.2 166.1 46.2 229.1 21.4 272-22.7 348.5 3.5 446.4 80 490.6s174.4 18 218.6-58.6c18.8-32.5 66.1-60 103.3-65.2 20.5-2.9 40.6-10.8 58.4-24 56.8-42.1 68.7-122.3 26.6-179.1-18.2-24.6-43.5-40.7-71-47.8zM224 336a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM96 240a128 128 0 1 0 256 0 128 128 0 1 0-256 0zm88 0c0-22.1 17.9-40 40-40 8.8 0 16-7.2 16-16s-7.2-16-16-16c-39.8 0-72 32.2-72 72 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalEgg = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEgg",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 464c-85.2 0-160-84.3-160-176 0-50.8 14.7-113.1 43.5-161.7C104.2 77.9 143.4 48 192 48s87.8 29.9 116.5 78.3C337.3 174.9 352 237.2 352 288c0 91.7-74.8 176-160 176zM0 288c0 106 86 208 192 208s192-102 192-208c0-112-64-272-192-272S0 176 0 288zm170.8-154c6.5-6 7-16.1 1-22.6s-16.1-7-22.6-1c-23.9 21.8-41.1 52.7-52.3 84.2C85.7 226.1 80 259.7 80 288c0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.5 5-54.4 15.1-82.8 10.1-28.5 25-54.1 43.7-71.2z"
        }
    ]
};

const FalEggplant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEggplant",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M482.7 51.9C491.1 64.5 496 79.7 496 96v96c0 17.7-14.3 32-32 32h-4c-24.3 0-44-19.7-44-44v-10c0-1.1-.9-2-2-2-38.7 0-70-31.3-70-70 0-1.1-.9-2-2-2h-10c-24.3 0-44-19.7-44-44v-4c0-17.7 14.3-32 32-32h96c16.3 0 31.5 4.9 44.1 13.3l24.6-24.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24.6 24.6zM416 48h-96v4c0 6.6 5.4 12 12 12h10c18.8 0 34 15.2 34 34 0 21 17 38 38 38 18.8 0 34 15.2 34 34v10c0 6.6 5.4 12 12 12h4V96c0-26.5-21.5-48-48-48zm-246.1 91.3c32.9-16 66-32 94.7-52.2 5 9.6 12 18 20.5 24.7-11.3 8.1-23.1 15.4-34.8 22.2-21.2 12.2-45.5 24-68.4 35.1-14.1 6.8-27.6 13.4-39.5 19.7-34 17.8-61.7 35.7-80.9 58.3-18.2 21.5-30 48.8-29.4 88.5 1 78.3 65.9 144.3 144.3 144.4 66.7.1 127.2-45.1 176.8-113.6 27.4-37.8 49.9-80.7 66.7-121.9 9 5.6 19.2 9.3 30.1 10.8C400.8 377 304.5 512.2 176.4 512 79.9 511.9 1.4 431.3 0 336c-1.6-113.5 83.4-154.7 169.9-196.7z"
        }
    ]
};

const FalEject = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEject",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 96c-4.5 0-8.8 1.9-11.8 5.2l-176 192c-4.3 4.7-5.4 11.4-2.9 17.3s8.3 9.6 14.6 9.6H400c6.3 0 12.1-3.7 14.6-9.6s1.4-12.6-2.9-17.3l-176-192c-3-3.3-7.3-5.2-11.8-5.2zm0-32c13.5 0 26.3 5.6 35.4 15.6l176 192c12.9 14 16.2 34.3 8.6 51.8S419 352 400 352H48c-19 0-36.3-11.2-43.9-28.7s-4.3-37.7 8.6-51.8l176-192c9-9.9 21.8-15.5 35.3-15.5zM16 416h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalElephant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalElephant",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 111.8c0-44.1 35.7-79.8 79.8-79.8 41.5 0 76.1 31.8 79.6 73.2l.7 8.1c.7 8.8 8.5 15.3 17.3 14.6s15.4-8.5 14.6-17.3l-.7-8.1c-1.1-13-4.4-25.4-9.5-36.7C466.1 76.2 512 128.7 512 192v112c0 8.8 7.2 16 16 16s16-7.2 16-16V192c0-88.4-71.6-160-160-160h-1.9c-20.2-19.9-48-32-78.3-32-30.5 0-58.2 12.3-78.4 32.1C118 35.6 32 123.7 32 232v51.1c0 25.4-8.7 50.1-24.5 70l-4 4.9C-2 364.9-.9 375 6 380.5s17 4.4 22.5-2.5l3.9-4.9c20.4-25.5 31.6-57.3 31.6-90V232c0-82.4 59.3-150.9 137.4-165.2-6.1 13.8-9.4 29-9.4 45.1 0 58.2 44.6 106.6 102.5 111.4l8.1.7c8.8.7 16.5-5.8 17.3-14.6s-5.8-16.5-14.6-17.3l-8.1-.7c-41.4-3.4-73.2-38-73.2-79.6zm189.4 183.5c-2.8-4.4-7.8-7.3-13.4-7.3-8.8 0-16 7.2-16 16v160c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-80c0-.7 0-1.4-.1-2 .5-3.8-.4-7.8-2.7-11.2-5.1-7.2-15-9-22.3-4-15.6 10.8-34.5 17.2-54.9 17.2s-39.3-6.4-54.8-17.2c-7.2-5.1-17.2-3.3-22.3 4-2.4 3.4-3.2 7.4-2.7 11.2-.1.7-.1 1.4-.1 2v80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V352c0-8.8-7.2-16-16-16s-16 7.2-16 16v112c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-57.3c14.8 6 31 9.3 48 9.3s33.2-3.3 48-9.3V464c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V349.6c7.2 7.2 14.7 13.2 22.8 18.1 3 1.9 6.1 3.5 9.2 5v10.4c0 53.5 43.4 96.9 96.9 96.9 44.4 0 83.2-30.2 94-73.4l.7-2.7c2.1-8.6-3.1-17.3-11.6-19.4s-17.3 3.1-19.4 11.6l-.7 2.7c-7.2 28.9-33.2 49.1-62.9 49.1-36 .1-65-28.9-65-64.8v-.8c7.6 1.1 15.6 1.7 24 1.7 36.6 0 73.4-10.3 99.4-36.8 6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6.2c-18 18.4-45.3 27.2-76.6 27.2-20.5 0-35.4-3.6-48.6-11.7-13.5-8.2-26.6-22-42-45zM480 208a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalElevator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalElevator",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m155.3 4.7 64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L144 38.6 91.3 91.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0zm160 0L368 57.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM64 160c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64zM0 192c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192zm184 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm248 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM144 384c-17.7 0-32 14.3-32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-17.7-14.3-32-32-32h-32zm160 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalEllipsisStrokeVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEllipsisStrokeVertical",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm32 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm96 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalEllipsisStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEllipsisStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm-160 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm-128 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-96 0a64 64 0 1 0 128 0 64 64 0 1 0-128 0z"
        }
    ]
};

const FalEllipsisVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEllipsisVertical",
    "viewBox": "0 0 128 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FalEllipsis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEllipsis",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 256a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-160 0a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FalEmptySet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEmptySet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M491.3 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-66 66C363.4 52.6 312.1 32 256 32 132.3 32 32 132.3 32 256c0 56.1 20.6 107.4 54.7 146.7l-66 66c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l66-66C148.6 459.4 199.9 480 256 480c123.7 0 224-100.3 224-224 0-56.1-20.6-107.4-54.7-146.7l66-66zM380 109.4 109.4 380C81.1 346.5 64 303.3 64 256c0-106 86-192 192-192 47.3 0 90.5 17.1 124 45.4zM132 402.6 402.6 132c28.3 33.5 45.4 76.7 45.4 124 0 106-86 192-192 192-47.3 0-90.5-17.1-124-45.4z"
        }
    ]
};

const FalEngineWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEngineWarning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 80c0 8.8-7.2 16-16 16h-80v32h76.6c12.6 0 25 3.7 35.5 10.7l51.4 34.3c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-26.5 0-48-21.5-48-48v-64H32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64v-64c0-26.5 21.5-48 48-48h144V96h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c8.8 0 16 7.2 16 16zm-112 80H144c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h28.8c9.7 0 18.9 4.4 25 12l32 40c6.1 7.6 15.3 12 25 12H448c17.7 0 32-14.3 32-32V226.3c0-10.7-5.3-20.7-14.2-26.6l-51.4-34.3c-5.3-3.5-11.4-5.4-17.8-5.4H304zm304 64h-32v192h32V224zm-32-32h32c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm-272 0c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16zm-24 160a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalEngine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEngine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 80c0 8.8-7.2 16-16 16h-80v32h76.6c12.6 0 25 3.7 35.5 10.7l51.4 34.3c17.8 11.9 28.5 31.9 28.5 53.3V384c0 35.3-28.7 64-64 64H254.8c-19.4 0-37.8-8.8-50-24l-32-40H144c-26.5 0-48-21.5-48-48v-64H32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64v-64c0-26.5 21.5-48 48-48h144V96h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h192c8.8 0 16 7.2 16 16zm-112 80H144c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h28.8c9.7 0 18.9 4.4 25 12l32 40c6.1 7.6 15.3 12 25 12H448c17.7 0 32-14.3 32-32V226.3c0-10.7-5.3-20.7-14.2-26.6l-51.4-34.3c-5.3-3.5-11.4-5.4-17.8-5.4H304zm-136 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm216-32v192h32V224h-32zm-32 0c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V224z"
        }
    ]
};

const FalEnvelopeCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEnvelopeCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96h384c17.7 0 32 14.3 32 32v32.7c5.3-.5 10.6-.7 16-.7s10.7.2 16 .7V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h296.2c-8.1-9.8-15.2-20.6-21-32H64c-17.7 0-32-14.3-32-32V207.6l176.7 129.5c28.2 20.6 66.5 20.6 94.6 0l17.1-12.5c1-16.2 4.3-31.8 9.4-46.6l-45.4 33.3c-16.9 12.4-39.9 12.4-56.8 0L32 167.9V128c0-17.7 14.3-32 32-32zm432 128a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 353.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalEnvelopeDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEnvelopeDot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-64 304V190.9c-5.2.7-10.6 1.1-16 1.1-13.8 0-27-2.5-39.2-7.1L284.4 311.3c-16.9 12.4-39.9 12.4-56.8 0L32 167.9V128c0-17.7 14.3-32 32-32h321.1c-.7-5.2-1.1-10.6-1.1-16s.4-10.8 1.1-16H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64zM32 207.6l176.7 129.5c28.2 20.6 66.5 20.6 94.6 0L480 207.6V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V207.6z"
        }
    ]
};

const FalEnvelopeOpenDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEnvelopeOpenDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M392 32H120c-13.3 0-24 10.7-24 24v166.5l-18.5-15.3c-4.2-3.4-8.7-6.3-13.5-8.6V56c0-30.9 25.1-56 56-56h272c30.9 0 56 25.1 56 56v142.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3v189c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V259c0-1.6-1.3-3-3-3-.7 0-1.3.2-1.9.7L294.5 405.1c-10.8 8.9-24.5 13.8-38.5 13.8s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zm-35 3c0-19.3 15.6-35 35-35 8.1 0 15.9 2.8 22.2 7.9l180.6 148.4c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5l180.7-148.4c6.3-5.1 14.1-7.9 22.2-7.9 19.3 0 35 15.6 35 35v189c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V259zM272 88v17.3c8.5 1.2 16.7 3.1 24.1 5.1 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3-8.4-.1-17.4 1.8-23.6 5.5-5.7 3.4-8.1 7.3-8.1 12.8 0 3.7 1.3 6.5 7.3 10.1 6.9 4.1 16.6 7.1 29.2 10.9l.5.1c11.3 3.4 25.3 7.6 36.3 14.6 12.1 7.6 22.4 19.7 22.7 38.2.3 19.3-9.6 33.3-22.9 41.6-7.7 4.8-16.4 7.6-25.1 9.1V296c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17.8c-11.2-2.1-21.7-5.7-30.9-8.9-2.1-.7-4.2-1.4-6.2-2.1-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5.8 4.8 1.6 7.1 2.4 13.6 4.6 24.6 8.4 36.3 8.7 9.1.3 17.9-1.7 23.7-5.3 5.1-3.2 7.9-7.3 7.8-14-.1-4.6-1.8-7.8-7.7-11.6-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5c-11-3.3-24.3-7.3-34.8-13.7-12-7.2-22.6-18.9-22.7-37.3-.1-19.4 10.8-32.8 23.8-40.5 7.5-4.4 15.8-7.2 24.1-8.7V88c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalEnvelopeOpenText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEnvelopeOpenText",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M392 32H120c-13.3 0-24 10.7-24 24v166.5l-18.5-15.3c-4.2-3.4-8.7-6.3-13.5-8.6V56c0-30.9 25.1-56 56-56h272c30.9 0 56 25.1 56 56v142.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3v189c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V259c0-1.6-1.3-3-3-3-.7 0-1.3.2-1.9.7L294.5 405.1c-10.8 8.9-24.5 13.8-38.5 13.8s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zm-35 3c0-19.3 15.6-35 35-35 8.1 0 15.9 2.8 22.2 7.9l180.6 148.4c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5l180.7-148.4c6.3-5.1 14.1-7.9 22.2-7.9 19.3 0 35 15.6 35 35v189c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V259zm176-131h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalEnvelopeOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEnvelopeOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241.6 36.8 45 182.4c-8.1 6-13 15.6-13 25.7v3.2l10.2 8.3 195.6 160.7c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5l195.6-160.7 10.2-8.3v-3.2c0-10.1-4.8-19.7-13-25.7L270.4 36.8c-4.2-3.1-9.2-4.8-14.4-4.8s-10.3 1.7-14.4 4.8zM32 252.7V448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V252.7L294.5 405.1c-10.8 8.9-24.5 13.8-38.5 13.8s-27.7-4.9-38.5-13.8L32 252.7zM222.5 11c9.7-7.1 21.4-11 33.5-11s23.8 3.9 33.5 11l196.6 145.7c16.3 12.1 25.9 31.1 25.9 51.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208.1c0-20.3 9.6-39.4 25.9-51.4L222.5 11z"
        }
    ]
};

const FalEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEnvelope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v39.9l195.6 143.4c16.9 12.4 39.9 12.4 56.8 0L480 167.9V128c0-17.7-14.3-32-32-32H64zM32 207.6V384c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V207.6L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
        }
    ]
};

const FalEnvelopesBulk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEnvelopesBulk",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 32h288c8.8 0 16 7.2 16 16v16h32V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v144h32V48c0-8.8 7.2-16 16-16zm112 112c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H416v32h176c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v48h32v-48zM48 256h288c8.8 0 16 7.2 16 16v5L196.9 391.9c-1.4 1-3.1 1.6-4.9 1.6s-3.5-.6-4.9-1.6L32 277v-5c0-8.8 7.2-16 16-16zM32 464V316.8l136 100.8c6.9 5.1 15.3 7.9 24 7.9s17-2.8 24-7.9l136-100.8V464c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16zm16-240c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm448-64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64zm16 64v-32h32v32h-32z"
        }
    ]
};

const FalEnvelopes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEnvelopes",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v19.6L364.4 247.3c-16.9 12.4-39.9 12.4-56.8 0L128 115.6V96c0-17.7 14.3-32 32-32h352zM128 320V155.3l160.7 117.8c28.2 20.7 66.5 20.7 94.6 0L544 155.3V320c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm32-288c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 70.7 57.3 128 128 128h336c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"
        }
    ]
};

const FalEquals = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEquals",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h384c8.8 0 16-7.2 16-16s-7.2-16-16-16H32zm0 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h384c8.8 0 16-7.2 16-16s-7.2-16-16-16H32z"
        }
    ]
};

const FalEraser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEraser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M353 74.3c-9.4-9.4-24.6-9.4-33.9 0l-111 111L390.6 368l111-111c9.4-9.4 9.4-24.6 0-33.9L353 74.3zM74.3 319c-9.4 9.4-9.4 24.6 0 33.9l88 88c4.5 4.5 10.6 7 17 7h121.4c6.4 0 12.5-2.5 17-7l50.3-50.3L185.4 208 74.3 319zM296.4 51.7c21.9-21.9 57.3-21.9 79.2 0l148.7 148.7c21.9 21.9 21.9 57.3 0 79.2L355.9 448H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H304v-.1c-1.1.1-2.2.1-3.3.1H179.3c-14.9 0-29.1-5.9-39.6-16.4l-88-88c-21.9-21.9-21.9-57.3 0-79.2L296.4 51.7z"
        }
    ]
};

const FalEscalator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEscalator",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm211.3 91.8C409.9 135 428.6 128 448 128h112c44.2 0 80 35.8 80 80s-35.8 80-80 80h-81.9L244.7 492.2C230.1 505 211.4 512 192 512H80c-44.2 0-80-35.8-80-80s35.8-80 80-80h81.9l233.4-204.2zM448 160c-11.6 0-22.9 4.2-31.6 11.9L178.5 380c-2.9 2.6-6.7 4-10.5 4H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h112c11.6 0 22.9-4.2 31.6-11.9L461.5 260c2.9-2.6 6.7-4 10.5-4h88c26.5 0 48-21.5 48-48s-21.5-48-48-48H448zm-140.1 21.7-24.6 21.5c-7.7-16.1-24.2-27.2-43.3-27.2-26.5 0-48 21.5-48 48v59.2l-32 28V224c0-44.2 35.8-80 80-80 28.7 0 53.8 15.1 67.9 37.7z"
        }
    ]
};

const FalEthernet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEthernet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32h32v-32c0-17.7 14.3-32 32-32h32V96zm224 0H160v48c0 8.8-7.2 16-16 16H96v48c0 8.8-7.2 16-16 16H32v192h64v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h64V224h-48c-8.8 0-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16V96z"
        }
    ]
};

const FalEuroSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEuroSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M34.3 224c-1.5 10.5-2.3 21.1-2.3 32s.8 21.5 2.3 32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h25.3C68.8 412.5 154.5 480 256 480h49c8.8 0 16-7.2 16-16s-7.2-16-16-16h-49c-83.6 0-154.7-53.4-181.1-128H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H66.7C65 277.6 64 266.9 64 256s.9-21.6 2.7-32H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H74.9C101.3 117.4 172.4 64 256 64h49c8.8 0 16-7.2 16-16s-7.2-16-16-16h-49C154.5 32 68.8 99.5 41.3 192H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h18.3z"
        }
    ]
};

const FalExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalExclamation",
    "viewBox": "0 0 64 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v304c0 8.8 7.2 16 16 16s16-7.2 16-16V48zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalExpandWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalExpandWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16h128zM0 304c0-8.8 7.2-16 16-16s16 7.2 16 16v112h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V304zM496 64c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128zm-16 240c0-8.8 7.2-16 16-16s16 7.2 16 16v128c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h112V304z"
        }
    ]
};

const FalExpand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalExpand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16h128zM0 336c0-8.8 7.2-16 16-16s16 7.2 16 16v112h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16V336zM432 32c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h128zm-16 304c0-8.8 7.2-16 16-16s16 7.2 16 16v128c0 8.8-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h112V336z"
        }
    ]
};

const FalExplosion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalExplosion",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.4 20.4c2.2-7.7-1.7-15.9-9-19.1s-16-.4-20.1 6.4L342.2 294.6l-38.7-154.5c-1.8-7.1-8.2-12.1-15.5-12.1s-13.7 5-15.5 12.1l-41.2 164.6-108-108c-5.2-5.2-13.4-6.2-19.7-2.3s-9.1 11.6-6.8 18.7l39.8 119.5-87.4-12.4c-6.6-.9-13 2.3-16.2 8.1s-2.5 13 1.8 18.1l81 96 4.8 5.7h41.9l-22.2-26.3-54-64 71.5 10.1c5.5.8 11-1.3 14.5-5.6s4.6-10 2.9-15.3l-26.6-79.7 80.1 80.1c4.1 4.1 10 5.6 15.6 4.1s9.9-5.9 11.3-11.5L288 210l32.5 129.9c1.6 6.3 6.8 11 13.2 11.9s12.7-2 16.1-7.6l129.5-215.9-62.7 219.3c-1.5 5.3-.2 11 3.4 15.1s9.2 6 14.6 5.1l53.5-8.9-52.4 62.9-21.9 26.2h41.7l4.8-5.8 80-96c4.3-5.1 4.9-12.4 1.6-18.2s-9.9-8.9-16.5-7.8l-71 11.8 89-311.7zM304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H382.7c-7.6-45.4-47.1-80-94.7-80s-87.1 34.6-94.7 80H16zm210 0c7.1-27.6 32.2-48 62-48s54.9 20.4 62 48H226z"
        }
    ]
};

const FalEyeDropperFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEyeDropperFull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m198.1 172.7 22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 39.9c-6.2-6.2-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1c-2.5 4.4-3.8 9.3-3.8 14.3C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4l109.3-109.3c6.2-6.2 6.2-16.4 0-22.6l-112-112zm-109.2 132 97.9-98 89.4 89.4-97.9 97.9c-9 9-21.2 14.1-33.9 14.1H83.8l-3.7 2.1-42.4 24.2 24.2-42.4 2.1-3.7v-49.7c0-12.7 5.1-24.9 14.1-33.9z"
        }
    ]
};

const FalEyeDropperHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEyeDropperHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m198.1 172.7 22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 62.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1c-2.5 4.4-3.8 9.3-3.8 14.3C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4l109.3-109.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H102.6l84.7-84.7zM64 378.5c0-9.5 2.8-18.7 8-26.5h177.4l-81.9 81.9c-9 9-21.2 14.1-33.9 14.1H83.8l-3.7 2.1-42.4 24.2 24.2-42.4 2.1-3.7v-49.7z"
        }
    ]
};

const FalEyeDropper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEyeDropper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m198.1 172.7 22.6 22.6 95.9 95.9 22.6 22.6 17.4 17.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17.4-17.4 22.6-22.6 98.3-98.3c39-39 39-102.2 0-141.1s-102.2-39-141.1 0l-98.3 98.3-22.6 22.6-17.4-17.4c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17.4 17.4zm45.3 0L364.2 51.9c26.5-26.5 69.4-26.5 95.9 0s26.5 69.4 0 95.9L339.3 268.6l-95.9-95.9zm-56.1 62.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L55.4 321.9c-15 15-23.4 35.4-23.4 56.6v41.2L3.8 469.1c-2.5 4.4-3.8 9.3-3.8 14.3C0 499.2 12.8 512 28.6 512c5 0 9.9-1.3 14.2-3.8L92.2 480h41.2c21.2 0 41.6-8.4 56.6-23.4l109.3-109.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L167.4 433.9c-9 9-21.2 14.1-33.9 14.1H83.8l-3.7 2.1-42.4 24.2 24.2-42.4 2.1-3.7v-49.7c0-12.7 5.1-24.9 14.1-33.9l109.2-109.3z"
        }
    ]
};

const FalEyeEvil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEyeEvil",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M258.1 126.1c-11.2 3.2-21.8 7.3-31.7 12.1-8.6 4.1-18.4 4.8-27.4 2l-55.9-17.5 18.6 28.3c8.3 12.6 8.2 29-.2 41.5-4.5 6.7-8.3 13.7-11.3 20.8-4.1 9.7-12 17.2-21.9 20.7l-61.8 22 61.8 22.1c9.9 3.5 17.8 11 21.9 20.7 3 7.1 6.8 14.1 11.3 20.8 8.4 12.5 8.5 28.9.2 41.5l-18.6 28.3 55.9-17.6c9.1-2.8 18.9-2.1 27.4 2 9.9 4.8 20.5 8.8 31.7 12.1 8.9 2.6 16.5 8.3 21.3 16.1l40.6 65 40.6-64.9c4.9-7.8 12.5-13.6 21.3-16.1 11.2-3.2 21.8-7.3 31.7-12.1 8.6-4.1 18.4-4.8 27.4-2l55.9 17.5-18.6-28.4c-8.3-12.6-8.2-29 .2-41.5 4.5-6.7 8.3-13.7 11.3-20.8 4.1-9.7 12-17.2 21.9-20.7l61.8-22-61.8-22.1c-9.9-3.5-17.8-11-21.9-20.7-3-7.1-6.8-14.1-11.3-20.8-8.4-12.5-8.5-28.9-.2-41.5l18.6-28.3-55.9 17.6c-9.1 2.8-18.9 2.1-27.4-2-9.9-4.8-20.5-8.8-31.7-12.1-8.9-2.6-16.5-8.3-21.3-16.1L320 45l-40.6 64.9c-4.9 7.8-12.5 13.6-21.3 16.1zM0 256c0-9.6 6-18.2 15.1-21.4l100.6-35.9c4-9.4 8.9-18.5 14.7-27.1l-41.2-62.8c-5.3-8-4.9-18.5.8-26.1s15.7-10.9 24.9-8l95.3 29.8c11.8-5.7 24.4-10.5 37.5-14.3l47.8-76.5C300.8 5.1 310 0 320 0s19.2 5.1 24.5 13.6l47.8 76.5c13.1 3.8 25.7 8.6 37.5 14.3l95.3-29.8c9.2-2.9 19.1.3 24.9 8s6.1 18.1.8 26.1l-41.3 62.7c5.8 8.6 10.7 17.7 14.7 27.1l100.6 35.9c9 3.2 15.1 11.8 15.1 21.4s-6 18.2-15.1 21.4l-100.5 36.1c-4 9.4-8.9 18.5-14.7 27.1l41.3 62.7c5.3 8 4.9 18.5-.8 26.1s-15.7 10.9-24.9 8l-95.3-29.8c-11.8 5.7-24.4 10.5-37.5 14.3l-47.8 76.5C339.2 506.9 330 512 320 512s-19.2-5.1-24.5-13.6l-47.8-76.5c-13.1-3.8-25.7-8.6-37.5-14.3l-95.3 29.8c-9.2 2.9-19.1-.3-24.9-8s-6.1-18.1-.8-26.1l41.3-62.7c-5.8-8.6-10.7-17.7-14.7-27.1L15.1 277.4C6 274.2 0 265.6 0 256zm249.2-21.5c-.8 4.3-1.2 8.8-1.2 13.5 0 39.8 32.2 72 72 72s72-32.2 72-72c0-4.6-.4-9.1-1.2-13.5l-.4.1c-13.6 5.3-27.9 9.2-42.7 11.3.2 3-.2 6.1-1.4 9.3-5.5 14.4-13.5 24.4-18.1 29.3-2.1 2.3-5.1 3.4-8.2 3.4s-6.1-1.1-8.2-3.4c-4.5-4.9-12.6-14.9-18.1-29.3-1.2-3.2-1.6-6.3-1.4-9.3-14.8-2.1-29.1-6-42.7-11.3l-.4-.1zM220.1 219c4.9-16.8 25-20.6 41.3-14.1 18.2 7.2 37.9 11.1 58.6 11.1s40.5-3.9 58.6-11.1c16.3-6.4 36.4-2.7 41.3 14.1 2.7 9.2 4.1 18.9 4.1 29 0 57.4-46.6 104-104 104s-104-46.6-104-104c0-10 1.4-19.8 4.1-29z"
        }
    ]
};

const FalEyeLowVision = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEyeLowVision",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5S621 514 614 508.5L6.1 28.6C-.8 23.1-2 13 3.4 6.1zm602.1 262.2c-10.3 24.6-28.3 57-53.9 89l-25.1-19.8c23.6-29.5 40.3-59.4 49.5-81.5-13.3-32-42.1-80-85.2-120S390.4 64 320 64c-39.8 0-75.4 10.2-106.6 26.3l-27.3-21.5C224 46.8 268.8 32 320 32c80.8 0 145.5 36.8 192.6 80.6 46.8 43.5 78.1 95.4 93 131.1 3.3 7.9 3.3 16.7 0 24.6zM448 256c0 6.3-.5 12.4-1.3 18.5l-30.9-24.4c-3-50.3-44.8-90.1-95.8-90.1-5.6 0-11.2.5-16.5 1.4L272.6 137c14.7-5.8 30.6-9.1 47.4-9.1 70.7 0 128 57.3 128 128zm-342-92.5 320 256c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5l-320-256c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5zM67.5 238c5.5-6.9 15.6-8 22.5-2.5l250 200c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5l-250-200c-6.9-5.5-8-15.6-2.5-22.5zm38.5 98.3 124 99.2c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5L86 361.3c-6.9-5.5-8-15.6-2.5-22.5s15.6-8 22.5-2.5z"
        }
    ]
};

const FalEyeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEyeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm579.6 264.9c3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C465.5 68.8 400.8 32 320 32c-51.2 0-96 14.8-133.9 36.8l27.3 21.5C244.6 74.2 280.2 64 320 64c70.4 0 127.7 32 170.8 72 43.1 40 71.9 88 85.2 120-9.2 22.1-25.9 52-49.5 81.5l25.1 19.8c25.6-32 43.7-64.4 53.9-89zM88.4 154.7c-25.6 32-43.7 64.4-53.9 89-3.3 7.9-3.3 16.7 0 24.6 14.9 35.7 46.2 87.7 93 131.1 47 43.8 111.7 80.6 192.5 80.6 51.2 0 96-14.8 133.9-36.8l-27.3-21.5C395.4 437.8 359.8 448 320 448c-70.4 0-127.7-32-170.8-72-43.1-40-71.9-88-85.2-120 9.2-22.1 25.9-52 49.5-81.5l-25.1-19.8zM320 384c16.7 0 32.7-3.2 47.4-9.1l-30.9-24.4c-5.4.9-10.9 1.4-16.5 1.4-51 0-92.8-39.8-95.8-90.1l-30.9-24.4c-.9 6-1.3 12.2-1.3 18.5 0 70.7 57.3 128 128 128zm128-128c0-70.7-57.3-128-128-128-16.7 0-32.7 3.2-47.4 9.1l30.9 24.4c5.4-.9 10.9-1.4 16.5-1.4 51 0 92.8 39.8 95.8 90.1l30.9 24.4c.9-6 1.3-12.2 1.3-18.5z"
        }
    ]
};

const FalEye = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEye",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120-13.3 32-42.1 80-85.2 120S358.4 448 288 448s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4 142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1 3.3-7.9 3.3-16.7 0-24.6-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zm-96 224a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm224 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0z"
        }
    ]
};

const FalEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalEyes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 256c0 55.6-16.9 104.7-42.8 139.2-25.9 34.5-59.1 52.8-93.2 52.8s-67.3-18.3-93.2-52.8c-7-9.3-13.3-19.6-18.8-30.8 7.6 2.4 15.6 3.7 24 3.7 44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5 5.3-41.7 20.2-78.3 40.7-105.7C100.7 82.3 133.9 64 168 64s67.3 18.3 93.2 52.8C287.1 151.3 304 200.4 304 256zm16-95.5C293.1 84.5 235.2 32 168 32 75.2 32 0 132.3 0 256s75.2 224 168 224c67.2 0 125.1-52.5 152-128.5 26.9 76 84.8 128.5 152 128.5 92.8 0 168-100.3 168-224S564.8 32 472 32c-67.2 0-125.1 52.5-152 128.5zm58.8 234.7c-7-9.3-13.3-19.6-18.8-30.8 7.6 2.4 15.6 3.7 24 3.7 44.2 0 80-35.8 80-80s-35.8-80-80-80c-17.1 0-32.9 5.4-45.9 14.5 5.3-41.7 20.2-78.3 40.7-105.7C404.7 82.3 437.9 64 472 64s67.3 18.3 93.2 52.8C591.1 151.3 608 200.4 608 256s-16.9 104.7-42.8 139.2S506.1 448 472 448s-67.3-18.3-93.2-52.8zM32 288a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm352-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FalF = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalF",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32C21.5 32 0 53.5 0 80v384c0 8.8 7.2 16 16 16s16-7.2 16-16V272h208c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V80c0-8.8 7.2-16 16-16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H48z"
        }
    ]
};

const FalFaceAngryHorns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceAngryHorns",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480c141.4 0 256-114.6 256-256 0-24.6-3.5-48.4-9.9-70.9 44.3-59.4 67.4-135 73.6-166 1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5-29.8-8.9-59-20.3-78.3-33.1-5.4-3.6-12.4-3.6-17.8 0S-1 12.8.3 19.1c6.2 31 29.3 106.6 73.6 166-6.4 22.5-9.9 46.3-9.9 70.9 0 141.4 114.6 256 256 256zm232.4-363.4c-12.2-26.4-28.8-50.4-48.8-71 13.1-3 27.6-6.8 42.3-11.2 17.7-5.3 36.2-11.7 53.2-19.1-9.2 28.9-24.6 66.9-46.6 101.3zM94.1 66.4c14.7 4.4 29.2 8.1 42.3 11.2-20 20.6-36.6 44.6-48.8 71-22.1-34.3-37.4-72.4-46.7-101.3 17 7.4 35.5 13.8 53.2 19.1zm308.6 345.5c6.6-5.9 7.1-16 1.2-22.6-16.1-17.9-44.2-37.3-83.9-37.3s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM240.4 296c13.3 0 24-10.7 24-24 0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6 0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7 0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FalFaceAngry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceAngry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm82.7-116.1c6.6-5.9 7.1-16 1.2-22.6-16.1-17.9-44.2-37.3-83.9-37.3s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2c11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2zM176.4 264c13.3 0 24-10.7 24-24 0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6 0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7 0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FalFaceAnguished = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceAnguished",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm251.8 48h8.4c50.7 0 91.8 41.1 91.8 91.8 0 11.2-9 20.2-20.2 20.2H180.2c-11.2 0-20.2-9-20.2-20.2 0-50.7 41.1-91.8 91.8-91.8zm8.4 32h-8.4c-29 0-53.2 20.6-58.6 48h125.6c-5.5-27.4-29.6-48-58.6-48zM152.4 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z"
        }
    ]
};

const FalFaceAnxiousSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceAnxiousSweat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0c141.4 0 256 114.6 256 256S429.4 512 288 512c-57.6 0-110.8-19.1-153.6-51.2-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23-5.4 8.5-9.8 16.4-12.8 23.1-2.6 5.8-3.2 8.8-3.4 9.5v.1c0 12.3 11.7 26.8 32 26.8s32-14.5 32-26.7v-.1c-.1-.7-.8-3.7-3.4-9.6-3-6.7-7.4-14.5-12.8-23.1-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0 17.6 21.7 55.5 72.2 55.5 97.2 0 32.5-28.7 58.7-64 58.7S0 405.8 0 373.3c0-25 38.1-75.5 55.5-97.2zM367.6 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-20.3-100.7-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm153.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM283.8 304h8.4c50.7 0 91.8 41.1 91.8 91.8 0 11.2-9 20.2-20.2 20.2H212.2c-11.2 0-20.2-9-20.2-20.2 0-50.7 41.1-91.8 91.8-91.8zm67 80c-5.5-27.4-29.6-48-58.6-48h-8.4c-29 0-53.2 20.6-58.6 48h125.6z"
        }
    ]
};

const FalFaceAstonished = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceAstonished",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm288 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64v-32zm-39.6-128a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 128c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z"
        }
    ]
};

const FalFaceAwesome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceAwesome",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-72-304h-80v-16c0-22.1 17.9-40 40-40h1.4c-.9 2.5-1.4 5.2-1.4 8 0 13.3 10.7 24 24 24 5.2 0 10.1-1.7 14-4.5 1.3 3.9 2 8.1 2 12.5v16zm-40-88c-39.8 0-72 32.2-72 72v16c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32v-16c0-39.8-32.2-72-72-72zm236.1 53.1c2.5 5.8 3.9 12.2 3.9 18.9v16h-96v-16c0-26.5 21.5-48 48-48 2 0 3.9.1 5.8.3-3.6 4.2-5.8 9.7-5.8 15.7 0 13.3 10.7 24 24 24 8.4 0 15.8-4.3 20.1-10.9zM256 192v17.9c0 16.6 13.5 30.1 30.1 30.1h99.8c16.6 0 30.1-13.5 30.1-30.1V192c0-44.2-35.8-80-80-80s-80 35.8-80 80zm4.7 224H248c-2 0-4 0-5.9-.1 7.2-27.5 32.2-47.9 61.9-47.9 15.9 0 30.5 5.8 41.7 15.5-2.8 2.7-5.7 5.2-8.7 7.6-21.5 15.7-47.9 24.9-76.3 24.9zm-50.6-4.2c-51.5-12.9-91.9-54.6-102.3-107.8h281c-2.8 20.6-10.3 39.6-21.5 55.9-16.9-14.9-39-23.9-63.3-23.9-46.1 0-84.6 32.5-93.9 75.8zm146.2 4.8c36-26.5 60.7-67.7 65-115.3 1.4-15.7-11-29.3-26.8-29.3H92.8c-11.2 0-19.9 9.6-18.9 20.7 8 88 81.7 155.3 170.1 155.3h21.4c34.2 0 65.8-11.7 90.9-31.4z"
        }
    ]
};

const FalFaceBeamHandOverMouth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceBeamHandOverMouth",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3c40.4-45.2 65.1-105 65.1-170.6C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm111.5-76.1c2.1-8.6 6.7-18.2 12.9-25.4 6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.8-11.6-24.6-21.5-43.4-21.5s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zm172.9-25.4c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.8-11.6-24.6-21.5-43.4-21.5s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm-51.1 146.8L248 318.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7 4.7 7.2 4.7 11.3-1.6 8.2-4.7 11.3l-16 16-34 34-17.3 17.3c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 34-34c6.2-6.2 16.4-6.2 22.6 0 .7.7 1.3 1.4 1.8 2.1 4.4 6.2 3.8 14.9-1.8 20.5l-5.1 5.1-26.9 26.9-2 2-17.3 17.3c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0 .7.7 1.3 1.4 1.8 2.1 4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2v-86.4c0-11 9-20 20-20 9.1 0 16.8 6.1 19.2 14.5.2.8.4 1.7.6 2.5.1 1 .2 2 .2 3v19.7c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8.7.5 1.4 1.1 2.1 1.8 6.2 6.2 6.2 16.4 0 22.6l-34 34zM254 222.1l-47 47c-9.4-13.7-25.1-22.7-43-22.7-28.7 0-52 23.3-52 52v86.4c0 70.3 56.9 127.2 127.2 127.2 33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9 16.9-18.8 16.3-47.8-1.8-65.9-1-1-2.1-2-3.2-3 3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2-18.7-18.7-49.1-18.7-67.9 0z"
        }
    ]
};

const FalFaceClouds = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceClouds",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M99.8 54.9c-2.6 5.5-8.2 9.1-14.4 9.1H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h152c22.1 0 40-17.9 40-40s-17.9-40-40-40c-8.7 0-16.6 2.7-23.2 7.4-3.6 2.6-8.1 3.5-12.4 2.7s-8.1-3.5-10.4-7.2C162.9 39.5 150.3 32 136 32c-15.9 0-29.7 9.3-36.2 22.9zM136 0c20.3 0 38.6 8.4 51.6 21.8 8.7-3.7 18.3-5.8 28.4-5.8 39.8 0 72 32.2 72 72s-32.2 72-72 72H64c-35.3 0-64-28.7-64-64s28.7-64 64-64h12.1C89 12.7 111 0 136 0zm152.3 1.9C298.7.7 309.3 0 320 0c141.4 0 256 114.6 256 256 0 7.3-.3 14.5-.9 21.7-9.4-6-20-10.2-31.3-12.2.1-3.1.2-6.3.2-9.4C544 132.3 443.7 32 320 32c-3.6 0-7.1.1-10.7.2-5.3-11.2-12.4-21.4-21-30.3zM96 256c0 90.7 54 168.9 131.6 204.1 4 15.5 11.2 29.7 20.9 41.8C141.9 470.9 64 372.6 64 256c0-22.1 2.8-43.5 8.1-64h33.2c-6 20.3-9.3 41.8-9.3 64zm120.4-48a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM416 304c-35.3 0-64 28.7-64 64 0 8.8-7.2 16-16 16-26.5 0-48 21.5-48 48s21.5 48 48 48h224c26.5 0 48-21.5 48-48 0-24.7-18.6-45-42.5-47.7-4.4-.5-8.4-2.8-11-6.3s-3.7-8-2.9-12.4c.3-1.8.5-3.7.5-5.6 0-17.7-14.3-32-32-32-9.2 0-17.6 3.9-23.4 10.2-3.4 3.7-8.4 5.5-13.4 5s-9.5-3.4-12-7.8C459.9 316.6 439.4 304 416 304zm-94.9 49.4c7-46.1 46.8-81.4 94.9-81.4 28.7 0 54.5 12.6 72 32.5 9.4-5.4 20.3-8.5 32-8.5 33.9 0 61.6 26.3 63.9 59.6 32.5 10.2 56.1 40.5 56.1 76.4 0 44.2-35.8 80-80 80H336c-44.2 0-80-35.8-80-80 0-39.1 28-71.6 65.1-78.6z"
        }
    ]
};

const FalFaceConfounded = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceConfounded",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm216.9 98.7 39.1 26.1 39.1-26.1c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 387.2l-39.1 26.1c-5.4 3.6-12.4 3.6-17.8 0L208 387.2l-39.1 26.1c-4.8 3.2-10.9 3.6-16 1l-32-16c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l23.7 11.8 40.3-26.8c5.4-3.6 12.4-3.6 17.8 0zm-87.6-137.9c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l35.4-17.5-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 256l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
        }
    ]
};

const FalFaceConfused = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceConfused",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm171.1 139.6-1.1.9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5l1.1-.9C205 327.5 272 304 341 304h11c8.8 0 16 7.2 16 16s-7.2 16-16 16h-11c-61.8 0-121.7 21-169.9 59.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceCowboyHat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceCowboyHat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168.1 118.9c5.7-17.2 13-35.7 21.4-51.9 6.9-13.2 13.7-23.2 19.8-29.4 3.5-3.5 5.7-4.9 6.7-5.4.8.4 2.2 1.3 4.2 3 20.3 17.8 51.2 17.8 71.5 0 2-1.8 3.4-2.6 4.2-3 1 .5 3.2 1.8 6.7 5.4 6.1 6.2 12.9 16.2 19.8 29.4 8.4 16.2 15.7 34.8 21.4 51.9-27.7 5.9-57.2 9.1-87.9 9.1s-60.2-3.2-87.9-9.1zM296 0c-8.9 0-17.4 4.2-25.4 11.2-8.2 7.2-21.1 7.2-29.3 0C233.4 4.2 224.9 0 216 0c-34.2 0-63 62.1-79 110.9-30.5-9.2-58.1-21.9-81.8-37.3l-.3-.2c-1-.6-2-1.3-2.9-1.9l-6.9-4.8C42.6 65 39.7 64 36.7 64c-9 0-15.7 8.3-12.9 16.7 1.1 3.5 2.4 7 3.8 10.4.4 1 .8 2 1.3 3l.2.4C61.5 169.9 150.8 224 256 224s194.5-54.1 227-129.4l.2-.4c.4-1 .9-2 1.3-3 1.4-3.4 2.7-6.9 3.8-10.4 2.7-8.5-4-16.8-13-16.8-3 0-6 1-8.4 2.8l-6.9 4.8c-1 .6-1.9 1.3-2.9 1.9l-.3.2c-23.7 15.3-51.3 28-81.8 37.2C359 62.1 330.2 0 296 0zm-40 192c-69.9 0-129-26.2-166.1-64.1C138.7 148.5 195.7 160 256 160s117.3-11.5 166.1-32.1C385 165.8 325.9 192 256 192zm-180.2 8C58.1 230.6 48 266.1 48 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-37.9-10.1-73.4-27.8-104-8.6 6.2-17.6 12-27 17.2 14.5 25.7 22.8 55.3 22.8 86.8 0 97.2-78.8 176-176 176S80 401.2 80 304c0-31.5 8.3-61.1 22.8-86.7-9.4-5.3-18.5-11-27-17.2zM192 304a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 106.1c25.9 0 51-2.6 74.9-7.4-19.5 23.7-46.5 37.4-74.9 37.4s-55.4-13.7-74.9-37.4c23.9 4.8 49 7.4 74.9 7.4zm124.5-29.6c4.8-12.1-7.8-22.5-20.2-18.5-31.7 10.3-67.1 16.1-104.4 16.1s-72.7-5.8-104.4-16.1c-12.3-4-24.9 6.4-20.2 18.5 21.3 54 69 91.6 124.5 91.6s103.3-37.6 124.5-91.6z"
        }
    ]
};

const FalFaceDiagonalMouth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceDiagonalMouth",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm372.4 63.4-224 64c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8l224-64c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceDisappointed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceDisappointed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm316.1 154.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM211.3 267.3l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm89.4 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"
        }
    ]
};

const FalFaceDisguise = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceDisguise",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-16.5 1.8-32.5 5.2-48H72c0 50.1 38.4 91.2 87.3 95.6-9.6 7.9-15.3 19.7-15.3 32.4 0 15.9 9 30.4 23.1 37.5L147.5 398c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l23.9-29.9 7.3 3.6-10.5 26.3c-3.3 8.2.7 17.5 8.9 20.8s17.5-.7 20.8-8.9l10-24.9c2.4.7 4.8 1.3 7.2 1.8V432c0 8.8 7.2 16 16 16s16-7.2 16-16v-25.2c2.4-.5 4.8-1.1 7.2-1.8l10 24.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-10.5-26.3 7.3-3.6 23.7 29.9c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-19.6-24.5C359 366.4 368 351.9 368 336c0-12.7-5.7-24.5-15.3-32.4 49-4.4 87.3-45.5 87.3-95.6h34.8c3.4 15.5 5.2 31.5 5.2 48zm-262-26.5-21.4 35.7c-1.1.6-1.9 1-2.6 1.3-7.9 3.5-16.8 5.5-26.1 5.5-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64c0 2.5-.1 4.9-.4 7.3-5.4 3.6-10.1 8.4-13.5 14.1zm75.9 0c-3.5-5.8-8.1-10.6-13.5-14.1-.3-2.4-.4-4.9-.4-7.3 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-9.3 0-18.1-2-26.1-5.5-.6-.3-1.5-.7-2.6-1.3L294 229.5zM465.3 176h-30.8c-5.3-14.9-14.1-28-25.4-38.5l5.2-10.3c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-3.5 7c-4.6-2-9.3-3.6-14.2-4.9V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v16.3c-4.4.4-8.7 1-13 2l-4.7-9.5c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l3.6 7.3c-16.4 10.2-29.5 25.3-37.3 43.1-7.8-17.9-20.9-32.9-37.3-43.1l3.6-7.3c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-4.7 9.5c-4.2-.9-8.6-1.6-13-2V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v19c-4.9 1.3-9.6 2.9-14.2 4.9l-3.5-7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l5.2 10.3c-11 10.5-19.8 23.6-25 38.5H46.7C78.9 91.8 160.5 32 256 32s177.1 59.8 209.3 144zm34.1.4C465.9 74 369.6 0 256 0S46.1 74 12.6 176.4C5.4 177.9 0 184.3 0 192c0 4.7 2 9 5.3 11.9C1.8 220.7 0 238.1 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-17.9-1.8-35.3-5.3-52.1 3.3-2.9 5.3-7.2 5.3-11.9 0-7.7-5.4-14.1-12.6-15.6zM256 240c4.3 0 8.3 2.3 10.5 6l39.8 66.3 2.4 4 4.2 2.1 17.7 8.8c3.4 1.7 5.5 5.1 5.5 8.8s-2.1 7.2-5.5 8.8l-53.1 26.5c-13.5 6.8-29.4 6.8-42.9 0l-53.1-26.5c-3.4-1.7-5.5-5.1-5.5-8.8s2.1-7.2 5.5-8.8l17.7-8.8 4.2-2.1 2.4-4 39.7-66.3c2.2-3.7 6.2-6 10.5-6zm-64-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalFaceDizzy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceDizzy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208 96a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalFaceDotted = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceDotted",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-17.1 0-33.8 1.7-49.9 4.9-8.7 1.7-14.3 10.1-12.6 18.8s10.1 14.3 18.8 12.6C226.4 33.5 241 32 256 32s29.6 1.5 43.7 4.3c8.7 1.7 17.1-3.9 18.8-12.6s-3.9-17.1-12.6-18.8C289.8 1.7 273.1 0 256 0zm142.2 43.1c-7.3-4.9-17.3-2.9-22.2 4.4s-2.9 17.3 4.4 22.2c24.4 16.4 45.5 37.4 61.8 61.8 4.9 7.3 14.9 9.3 22.2 4.4s9.3-14.9 4.4-22.2c-18.7-27.9-42.7-51.9-70.6-70.6zM131.6 69.7c7.3-4.9 9.3-14.9 4.4-22.2s-14.9-9.3-22.2-4.4c-28 18.7-52 42.7-70.7 70.7-4.9 7.3-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4c16.4-24.4 37.4-45.5 61.8-61.8zM36.3 212.3c1.7-8.7-3.9-17.1-12.6-18.8s-17.1 3.9-18.8 12.6C1.7 222.2 0 238.9 0 256s1.7 33.8 4.9 49.9c1.7 8.7 10.1 14.3 18.8 12.6s14.3-10.1 12.6-18.8C33.5 285.6 32 271 32 256s1.5-29.6 4.3-43.7zm470.9-6.2c-1.7-8.7-10.1-14.3-18.8-12.6s-14.3 10.1-12.6 18.8c2.8 14.1 4.3 28.8 4.3 43.7s-1.5 29.6-4.3 43.7c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6c3.2-16.2 4.9-32.9 4.9-49.9s-1.7-33.8-4.9-49.9zM69.7 380.4c-4.9-7.3-14.9-9.3-22.2-4.4s-9.3 14.9-4.4 22.2c18.7 27.9 42.7 51.9 70.6 70.6 7.3 4.9 17.3 3 22.2-4.4s2.9-17.3-4.4-22.2c-24.4-16.4-45.5-37.4-61.8-61.8zm399.2 17.8c4.9-7.3 3-17.3-4.4-22.2s-17.3-2.9-22.2 4.4c-16.4 24.4-37.4 45.5-61.8 61.8-7.3 4.9-9.3 14.9-4.4 22.2s14.9 9.3 22.2 4.4c27.9-18.7 51.9-42.7 70.6-70.6zm-256.6 77.5c-8.7-1.7-17.1 3.9-18.8 12.6s3.9 17.1 12.6 18.8c16.2 3.2 32.9 4.9 49.9 4.9s33.8-1.7 49.9-4.9c8.7-1.7 14.3-10.1 12.6-18.8s-10.1-14.3-18.8-12.6c-14.1 2.8-28.7 4.3-43.7 4.3s-29.6-1.5-43.7-4.3zM176.4 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM184 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H184z"
        }
    ]
};

const FalFaceDowncastSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceDowncastSweat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M79.8 68.6c5.4 8.5 9.8 16.4 12.8 23.1 2.6 5.8 3.2 8.8 3.4 9.6v.1c0 12.1-11.7 26.6-32 26.6s-32-14.5-32-26.7v-.1c.2-.7.8-3.7 3.4-9.5 3-6.7 7.4-14.6 12.8-23.1 5-7.9 10.5-15.8 15.8-23 5.3 7.2 10.8 15.1 15.8 23zM72.5 4.1c-4.3-5.5-12.8-5.5-17.1 0C38.1 25.8 0 76.3 0 101.3 0 133.8 28.7 160 64 160s64-26.2 64-58.7c0-25-37.9-75.5-55.5-97.2zM256 32c123.7 0 224 100.3 224 224S379.7 480 256 480 32 379.7 32 256c0-20.7 2.8-40.7 8.1-59.7 2.4-8.5-2.6-17.3-11.2-19.7s-17.3 2.6-19.7 11.2C3.2 209.5 0 232.4 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256S397.4 0 256 0c-43.1 0-83.8 10.7-119.5 29.5-7.8 4.1-10.8 13.8-6.7 21.6s13.9 10.9 21.7 6.7C182.7 41.3 218.2 32 256 32zM96 272c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm208-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zM173.3 411.9c6.6 5.9 16.7 5.4 22.6-1.2 11.7-13 31.6-26.7 60.1-26.7s48.4 13.7 60.1 26.7c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6C323.8 371.4 295.7 352 256 352s-67.8 19.4-83.9 37.3c-5.9 6.6-5.4 16.7 1.2 22.6z"
        }
    ]
};

const FalFaceDrooling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceDrooling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3c40.4-45.2 65.1-105 65.1-170.6C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c8.8 0 16-7.2 16-16s-7.2-16-16-16C132.3 480 32 379.7 32 256zm320 114.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V344.2c4.6-4.7 8.7-9.5 12.5-14.2 5.5-6.9 4.4-17-2.5-22.5s-17-4.4-22.5 2.5c-22.8 28.5-61.3 58-115.5 58s-92.7-29.5-115.5-58c-5.5-6.9-15.6-8-22.5-2.5s-8 15.6-2.5 22.5c26.7 33.4 73.5 70 140.5 70 11.2 0 21.9-1 32-2.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16v-76.2c11.7-4.7 22.3-10.4 32-16.9zM158.6 189.6c8.2-7.8 19.1-13.6 33.4-13.6 8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.1 0-42.5 10.2-55.4 22.4-12.6 12-20.4 26.3-23.8 36.5-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1c1.9-5.8 7-15.4 15.4-23.5zm210.2 23.5c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2c-3.4-10.2-11.1-24.6-23.8-36.5-12.8-12.3-31.2-22.5-55.3-22.5-8.8 0-16 7.2-16 16s7.2 16 16 16c14.3 0 25.2 5.8 33.4 13.6 8.4 8 13.5 17.7 15.4 23.5z"
        }
    ]
};

const FalFaceExhaling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceExhaling",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c40.8 0 78.9-10.9 111.8-29.9 7.7-4.4 17.4-1.8 21.9 5.9s1.8 17.4-5.9 21.9C346.2 499.6 302.5 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c135.7 0 246.7 105.5 255.4 238.9.6 8.8-6.1 16.4-14.9 17s-16.4-6.1-17-14.9C471.8 124.3 374.7 32 256 32zm.1 376.1a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm60.8-89.6c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm-121.6 0c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm299.6 49.6c26.1 0 47.4 19.2 51.3 44.1 17.9 10.3 29.9 29.7 29.9 51.9s-12 41.6-29.9 51.8c-3.9 24.9-25.3 44.2-51.3 44.2-14.2 0-27-5.7-36.4-15-2.2.3-4.4.4-6.6.4-27.3 0-49.4-21.1-51.7-47.7l-60.7-18.4c-6.7-2-11.4-8.3-11.4-15.3s4.6-13.3 11.4-15.3l62-18.8c5.5-22.9 25.9-40.1 50.5-40.1h.7c9.4-13.2 24.7-21.8 42.2-21.8zM476.3 333c-3 7.7-11.2 11.8-19.2 9.6-1.6-.5-3.4-.7-5.2-.7-10.8 0-19.9 8.9-19.9 20.4 0 7-4.6 13.3-11.4 15.3l-21.4 6.5 22.1 6.7c7.8 2.4 12.6 10.3 11.1 18.4-.2 1.3-.4 2.6-.4 4 0 11.4 9.1 20.4 19.9 20.4 2.5 0 4.8-.4 6.9-1.3 7.1-2.7 15.1 0 19.2 6.4 3.6 5.7 9.8 9.4 16.8 9.4 10.8 0 19.9-8.9 19.9-20.4v-1.3c-.4-7.2 4-13.8 10.8-16.1 10.7-3.6 18.5-14 18.5-26.2s-7.8-22.6-18.5-26.2c-6.8-2.3-11.2-8.9-10.8-16.1v-1.3c0-11.4-9.1-20.4-19.9-20.4-8.3 0-15.6 5.2-18.6 12.9z"
        }
    ]
};

const FalFaceExplode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceExplode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 32c-11.2 0-21.3 4.6-28.6 12-3 3.1-7.1 4.8-11.4 4.8s-8.4-1.7-11.4-4.8c-7.3-7.4-17.4-12-28.6-12-22.1 0-40 17.9-40 40v4.2c0 6.3-3.7 12-9.5 14.6s-12.5 1.5-17.2-2.7c-5.6-5-13.1-8.1-21.3-8.1-17.7 0-32 14.3-32 32s14.3 32 32 32h112c8.8 0 16 7.2 16 16s-7.2 16-16 16h-18.7c1.8 5 2.7 10.4 2.7 16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-8.8-7.2-16-16-16h-48c-35.3 0-64-28.7-64-64s28.7-64 64-64c6.7 0 13.1 1 19.1 2.9C156.2 21.4 183.6 0 216 0c14.8 0 28.6 4.5 40 12.1A72.01 72.01 0 0 1 296 0c32.4 0 59.8 21.4 68.9 50.9 6-1.9 12.5-2.9 19.1-2.9 35.3 0 64 28.7 64 64s-28.7 64-64 64h-48c-8.8 0-16 7.2-16 16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-26.5 21.5-48 48-48h48c17.7 0 32-14.3 32-32s-14.3-32-32-32c-8.2 0-15.7 3.1-21.3 8.1-4.7 4.2-11.4 5.3-17.2 2.7s-9.5-8.3-9.5-14.6V72c0-22.1-17.9-40-40-40zM32 260.3c3.1-.7 6.1-1.8 9-3.4l28.7-16.1c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0l25.5-14.4c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0l25.5-14.4c9.7-5.5 21.6-5.5 31.4 0l25.5 14.4c9.7 5.5 21.6 5.5 31.4 0l25.4-14.4c9.7-5.5 21.6-5.5 31.4 0l28.6 16.1c2.8 1.6 5.8 2.7 9 3.4 5.7 1.2 11.6.9 17.2-1l9.5-3.3 5.3-1.8v1.8c0 11.1-.7 22-2.1 32.7C493.9 414.7 386.3 512 256 512S18.1 414.7 2.1 288.7C.7 278 0 267.1 0 256v-1.8l5.3 1.8 9.5 3.3c5.6 1.9 11.5 2.3 17.2 1zm53.3 8.4-28.6 16.1c-6.8 3.8-14.2 6.3-21.8 7.5C52.3 398.8 144.7 480 256 480s203.7-81.2 221.1-187.7c-7.6-1.2-14.9-3.7-21.8-7.5l-28.7-16.1-25.5 14.4c-19.5 11-43.3 11-62.8 0l-25.5-14.4-25.5 14.4c-19.5 11-43.3 11-62.8 0L199 268.7l-25.5 14.4c-19.5 11-43.3 11-62.8 0l-25.4-14.4zm91 43.3a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM256 352c35.3 0 64 28.7 64 64v5.3c0 14.7-11.9 26.7-26.7 26.7h-74.6c-14.7 0-26.7-11.9-26.7-26.7V416c0-35.3 28.7-64 64-64zm-32 64h64c0-17.7-14.3-32-32-32s-32 14.3-32 32z"
        }
    ]
};

const FalFaceExpressionless = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceExpressionless",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm160 80h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-128c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zm176-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalFaceEyesXmarks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceEyesXmarks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm251.8 48h8.4c50.7 0 91.8 41.1 91.8 91.8 0 11.2-9 20.2-20.2 20.2H180.2c-11.2 0-20.2-9-20.2-20.2 0-50.7 41.1-91.8 91.8-91.8zm8.4 32h-8.4c-29 0-53.2 20.6-58.6 48h125.6c-5.5-27.4-29.6-48-58.6-48zM100.7 132.7c6.2-6.2 16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L182.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6zm192 0c6.2-6.2 16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L374.6 192l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352 214.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalFaceFearful = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceFearful",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm251.8 48h8.4c50.7 0 91.8 41.1 91.8 91.8 0 11.2-9 20.2-20.2 20.2H180.2c-11.2 0-20.2-9-20.2-20.2 0-50.7 41.1-91.8 91.8-91.8zm8.4 32h-8.4c-29 0-53.2 20.6-58.6 48h125.6c-5.5-27.4-29.6-48-58.6-48zM136.4 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm216-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM176 112c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm173 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8zM160 176a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm80 48a80 80 0 1 1-160 0 80 80 0 1 1 160 0zm64 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"
        }
    ]
};

const FalFaceFlushed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceFlushed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm160.4-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm168 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM192 368h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FalFaceFrownOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceFrownOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm22 192.1c-22.4-9.5-47.7-14.8-74.5-14.8-26.8 0-52 5.3-74.4 14.8-11.2 4.7-23.8 3.1-32.8-3.6-9.7-7.2-14.9-20.4-9-33.9 19.2-44.1 64.2-74.7 116.2-74.7s97 30.6 116.2 74.7c5.9 13.6.8 26.7-9 33.9-9 6.6-21.5 8.3-32.8 3.5zM260 319.9c-36.9 0-68.5 20.3-83.9 49.5 25.6-10.4 54-16.1 83.9-16.1 29.9 0 58.4 5.8 84 16.1-15.4-29.2-47.1-49.5-84-49.5z"
        }
    ]
};

const FalFaceFrownSlight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceFrownSlight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm347.9 138.5C330 373.8 299.4 352 256 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5s93.8 27.9 116.1 53.5c5.8 6.7 5.1 16.8-1.6 22.6s-16.8 5.1-22.6-1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceFrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceFrown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm159.3 132.7c-2.6 8.4-11.6 13.2-20 10.5s-13.2-11.6-10.5-20C145.2 326.1 196.3 288 256 288s110.8 38.1 127.3 91.3c2.6 8.4-2.1 17.4-10.5 20s-17.4-2.1-20-10.5C340.5 349.4 302.1 320 256 320s-84.5 29.4-96.7 68.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceGlasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGlasses",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480C132.3 480 32 379.7 32 256c0-22.2 3.2-43.7 9.3-64h7.3c-.4 2.6-.6 5.3-.6 8v48c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-48c0-2.7-.2-5.4-.6-8h33.1c-.4 2.6-.6 5.3-.6 8v48c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-48c0-2.7-.2-5.4-.6-8h7.3c6 20.3 9.3 41.8 9.3 64 0 123.7-100.3 224-224 224zm-32-319.2c-10.2-10.4-24.3-16.8-40-16.8h-80c-15.3 0-29.1 6.1-39.2 16H53.6C89.5 84.3 166.6 32 256 32s166.5 52.3 202.4 128h-11.2c-10.1-9.9-23.9-16-39.2-16h-80c-15.7 0-29.8 6.4-40 16.8v-.8h-64v.8zM256 0C148.6 0 56.6 66.2 18.6 160H16c-8.8 0-16 7.2-16 16 0 6.1 3.5 11.5 8.5 14.2C3 211.2 0 233.2 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256c0-22.8-3-44.8-8.5-65.8 5.1-2.7 8.5-8 8.5-14.2 0-8.8-7.2-16-16-16h-2.6C455.4 66.2 363.4 0 256 0zM141.5 339.9c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zM304 200c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48zm-200-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-80c-13.3 0-24-10.7-24-24v-48c0-13.3 10.7-24 24-24zm88.4 48a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm152 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalFaceGrimace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrimace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm256 224a256 256 0 1 1-512 0 256 256 0 1 1 512 0zm-344 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v-48h-8zm40 48h32v-48h-32v48zm96 0v-48h-32v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zm-168-80h176c30.9 0 56 25.1 56 56s-25.1 56-56 56H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-15.6-80a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceGrinBeamSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinBeamSweat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432.2 68.6c-5.4 8.5-9.8 16.4-12.8 23.1-2.6 5.8-3.2 8.8-3.4 9.6v.1c0 12.2 11.7 26.7 32 26.7s32-14.5 32-26.7v-.1c-.2-.7-.8-3.7-3.4-9.5-3-6.7-7.4-14.6-12.8-23.1-5-7.9-10.5-15.8-15.8-23-5.3 7.2-10.8 15.1-15.8 23zm7.3-64.5c4.3-5.5 12.8-5.5 17.1 0 17.3 21.7 55.4 72.2 55.4 97.2 0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-25 37.9-75.5 55.5-97.2zM256 32C132.3 32 32 132.3 32 256s100.3 224 224 224 224-100.3 224-224c0-20.7-2.8-40.7-8.1-59.7-2.4-8.5 2.6-17.3 11.2-19.7s17.3 2.6 19.7 11.2c6 21.7 9.2 44.6 9.2 68.3 0 141.4-114.6 256-256 256S0 397.4 0 256 114.6 0 256 0c43.1 0 83.8 10.7 119.5 29.5 7.8 4.1 10.8 13.8 6.7 21.6s-13.9 10.9-21.7 6.7C329.3 41.3 293.8 32 256 32zm90 313.8c-28.5 5.4-58.7 8.3-89.9 8.3s-61.4-2.9-89.9-8.3c22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3zm33.8-41.1c12.3-3.7 24.2 7 19.1 18.7-24.1 54.6-79 92.7-142.8 92.7S137.4 378 113.3 323.4c-5.2-11.7 6.8-22.4 19.1-18.7 37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4zm-236.3-84.8c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 10-11.6 24.8-21.5 43.6-21.5s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4zm172.9-25.4c-6.2 7.2-10.8 16.8-12.9 25.4-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 10-11.6 24.8-21.5 43.6-21.5s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5z"
        }
    ]
};

const FalFaceGrinBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3 22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7S137.3 378 113.2 323.4c-5.2-11.7 6.8-22.4 19.1-18.7 37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zm-242.4-135c-6.2 7.2-10.8 16.8-12.9 25.4-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 10-11.5 24.8-21.4 43.6-21.4s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 10-11.5 24.8-21.4 43.6-21.4s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"
        }
    ]
};

const FalFaceGrinHearts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinHearts",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3 22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7S137.3 378 113.2 323.4c-5.2-11.7 6.8-22.4 19.1-18.7 37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM195.1 144.6c-9.3-2.5-18.8 3-21.3 12.3l-4.3 16.1c-2.3 8.5-11.1 13.6-19.6 11.3l-16.1-4.3c-9.3-2.5-18.8 3-21.3 12.3s3 18.8 12.3 21.3l65.2 17.3 17.4-65c2.5-9.3-3-18.8-12.3-21.3zm-52.2 4c7.1-26.3 34.1-42 60.4-34.9s42 34.1 34.9 60.4l-17.4 65c-4.6 17.1-22.1 27.2-39.2 22.6l-65.1-17.4c-26.3-7.1-42-34.1-34.9-60.4s34.1-42 60.4-34.9l.7.2.2-.6zm226.1 0 .2.6.7-.2c26.3-7.1 53.4 8.6 60.4 34.9s-8.6 53.4-34.9 60.4l-65.1 17.4c-17.1 4.6-34.6-5.6-39.2-22.6l-17.4-65c-7.1-26.3 8.6-53.4 34.9-60.4s53.4 8.6 60.4 34.9zm-52.2-4c-9.3 2.5-14.8 12-12.3 21.3l17.4 65 65.1-17.4c9.3-2.5 14.8-12 12.3-21.3s-12-14.8-21.3-12.3l-16 4.3c-8.5 2.3-17.3-2.8-19.6-11.3l-4.3-16.1c-2.5-9.3-12-14.8-21.3-12.3z"
        }
    ]
};

const FalFaceGrinSquintTears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinSquintTears",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M421 91.1c1.3-6.5 2.8-13.3 4.5-19.8 2.3-9.2 4.9-17.3 7.5-23.6 2.3-5.7 4-8.1 4.4-8.7.1-.1.1-.2 0-.1 9-9 24.7-9.5 35 .9s9.8 26 .9 35c.1-.1 0 0-.1 0-.5.4-3 2-8.7 4.4-6.4 2.6-14.5 5.1-23.6 7.5-6.6 1.7-13.3 3.2-19.8 4.5zm-36.9 26c-1 6.4 4.4 11.8 10.8 10.8 25.8-3.5 84-13.6 100.9-30.5 22-22 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9c-16.9 16.9-26.9 75.2-30.5 100.9zM32 256C32 132.3 132.3 32 256 32c31.4 0 61.2 6.4 88.3 18.1 8.1 3.5 17.5-.3 21-8.4s-.3-17.5-8.4-21C325.9 7.4 291.8 0 256 0 114.6 0 0 114.6 0 256c0 36.4 7.6 71 21.3 102.4 3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1C38.7 318.2 32 287.9 32 256zm458.7-102.4c-3.5-8.1-13-11.8-21.1-8.3s-11.8 13-8.3 21.1c12 27.4 18.6 57.7 18.6 89.6 0 123.7-100.3 224-224 224-32.4 0-63.1-6.9-90.9-19.2-8.1-3.6-17.5 0-21.1 8.1s0 17.5 8.1 21.1c31.8 14.1 66.9 22 103.9 22 141.4 0 256-114.6 256-256 0-36.4-7.6-71-21.3-102.4zM325.4 325.4c22.1-22 41.4-45.4 57.7-69.5.7 32.6-11.4 65.6-36.5 90.7s-58 37.2-90.7 36.5c24-16.3 47.4-35.6 69.5-57.7zm79.3-122.7c-4.6-11.9-20.6-11.1-26.7.2-18.5 34.3-43.8 68.4-75.2 99.8s-65.5 56.7-99.8 75.2c-11.3 6.1-12.2 22.1-.2 26.7 55.6 21.5 121.4 9.7 166.5-35.5s57-110.9 35.5-166.5zM104.8 284c2.8 8.4 11.9 12.9 20.2 10.1l37.5-12.5-12.5 37.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l22.7-67.9c1.9-5.7.4-12.1-3.9-16.4s-10.6-5.8-16.4-3.9l-67.9 22.6c-8.4 2.8-12.9 11.9-10.1 20.2zm189.3-159c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-22.6 67.9c-1.9 5.7-.4 12.1 3.9 16.4s10.6 5.8 16.4 3.9l67.9-22.6c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-37.5 12.5 12.3-37.7zM71.2 425.4c6.6-1.7 13.3-3.2 19.8-4.5-1.3 6.5-2.8 13.3-4.5 19.8-2.3 9.2-4.9 17.3-7.5 23.6-2.3 5.7-4 8.1-4.4 8.7-.1.1-.1.1 0 .1-9 9-24.7 9.5-35-.9s-9.8-26-.9-35c-.1.1 0 0 .1 0 .5-.4 3-2 8.7-4.4 6.4-2.6 14.5-5.1 23.6-7.5zm45.9-41.3c-25.8 3.5-84 13.6-100.9 30.5-22 22-21.5 57.9.9 80.3s58.3 22.8 80.3.9c16.9-16.9 26.9-75.2 30.5-100.9 1-6.4-4.4-11.8-10.8-10.8z"
        }
    ]
};

const FalFaceGrinSquint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinSquint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3 22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7S137.3 378 113.2 323.4c-5.2-11.7 6.8-22.4 19.1-18.7 37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM129.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l35.4-17.5-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
        }
    ]
};

const FalFaceGrinStars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinStars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm90-166.2c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm33.8-41.1c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7 24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7c5.2-11.7-6.8-22.4-19.1-18.7zM160 104c-6.2 0-11.8 3.5-14.4 9.1l-19.3 40.4-44.4 5.9c-6.1.8-11.2 5.1-13.1 10.9s-.3 12.3 4.2 16.5l32.5 30.9-8.2 44.1c-1.1 6.1 1.3 12.2 6.3 15.9s11.6 4.1 17 1.1l39.4-21.4 39.4 21.4c5.4 2.9 12 2.5 17-1.1s7.5-9.8 6.3-15.9l-8.2-44.1 32.5-30.9c4.5-4.2 6.1-10.7 4.2-16.5s-7-10.1-13.1-10.9l-44.4-5.9-19.3-40.4c-2.7-5.6-8.3-9.1-14.4-9.1zm0 53.2 8.6 18c2.3 4.9 7 8.3 12.3 9l19.8 2.6-14.5 13.7c-3.9 3.7-5.7 9.2-4.7 14.5l3.6 19.6-17.6-9.5c-4.8-2.6-10.5-2.6-15.3 0l-17.6 9.5 3.6-19.6c1-5.3-.8-10.8-4.7-14.5L119 186.8l19.8-2.6c5.4-.7 10-4.1 12.3-9l8.6-18zM352 104c-6.2 0-11.8 3.5-14.4 9.1l-19.3 40.4-44.4 5.9c-6.1.8-11.2 5.1-13.1 10.9s-.3 12.3 4.2 16.5l32.5 30.9-8.2 44.1c-1.1 6.1 1.3 12.2 6.3 15.9s11.6 4.1 17 1.1l39.4-21.4 39.4 21.4c5.4 2.9 12 2.5 17-1.1s7.4-9.8 6.3-15.9l-8.2-44.1 32.5-30.9c4.5-4.2 6.1-10.7 4.2-16.5s-7-10.1-13.1-10.9l-44.4-5.9-19.3-40.4c-2.7-5.6-8.3-9.1-14.4-9.1zm0 53.2 8.6 18c2.3 4.9 7 8.3 12.3 9l19.8 2.6-14.5 13.7c-3.9 3.7-5.7 9.2-4.7 14.5l3.6 19.6-17.6-9.5c-4.8-2.6-10.5-2.6-15.3 0l-17.6 9.5 3.6-19.6c1-5.3-.8-10.8-4.7-14.5L311 186.8l19.8-2.6c5.4-.7 10-4.1 12.3-9l8.6-18z"
        }
    ]
};

const FalFaceGrinTears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinTears",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M110.9 175.4C143.3 91.5 224.7 32 320 32s176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C522 68 428.9 0 320 0S118 68 81.1 163.9c-3.2 8.2.9 17.5 9.2 20.7s17.5-.9 20.7-9.2zm19.5 200c-4.7-7.5-14.6-9.7-22.1-5s-9.7 14.6-5 22.1C148.7 464.3 228.8 512 320 512s171.3-47.7 216.6-119.5c4.7-7.5 2.5-17.4-5-22.1s-17.4-2.5-22.1 5C469.8 438.3 399.8 480 320 480s-149.8-41.7-189.5-104.5zM320 354.1c31.2 0 61.4-2.9 89.9-8.3-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3zm142.8-30.7c5.2-11.7-6.8-22.4-19.1-18.7-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7 24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7zm-242.4-129c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.8-11.5-24.6-21.4-43.4-21.4s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm147.1 25.4c2.1-8.6 6.7-18.2 12.9-25.4 6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.8-11.5-24.6-21.4-43.4-21.4s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zm180.1 39.7c7.5 1.2 15.4 2.7 23 4.4 9.2 2.1 17.3 4.4 23.5 6.8 5 1.9 7.3 3.3 8 3.7.1.1.2.1.2.1 7.2 7.3 9.2 23.4-3.6 36.2-12.8 12.8-28.8 10.8-36.2 3.6s0-.1-.1-.2c-.4-.6-1.8-2.9-3.7-7.9-2.4-6.3-4.7-14.4-6.7-23.6-1.7-7.6-3.2-15.5-4.4-23.1zm-35.5-24.2c2.9 26 11.1 84.8 27.7 101.4 21.6 21.6 58.1 19.9 81.5-3.5s25.1-60 3.5-81.5c-16.6-16.6-75.3-24.9-101.4-27.7-6.5-.8-12.1 4.9-11.3 11.3zM88 282.6c-2.1 9.2-4.3 17.3-6.7 23.6-1.9 5-3.3 7.3-3.7 7.9-.1.1-.1.2-.1.2-7.3 7.2-23.4 9.1-36.2-3.6s-10.8-28.8-3.6-36.2.1 0 .2-.1c.6-.4 2.9-1.8 8-3.7 6.3-2.4 14.4-4.7 23.5-6.8 7.6-1.7 15.5-3.2 23-4.4-1.2 7.5-2.7 15.4-4.4 23.1zm12.2 54.2c16.6-16.6 24.8-75.4 27.7-101.4.8-6.5-4.9-12.1-11.3-11.3-26.1 2.8-84.8 11.1-101.4 27.7-21.6 21.6-19.9 58.1 3.5 81.5s60 25.1 81.5 3.5z"
        }
    ]
};

const FalFaceGrinTongueSquint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinTongueSquint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6 7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm104.5-65.7 35.4 17.7-35.4 17.7c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32c5.4-2.7 8.8-8.3 8.8-14.3s-3.4-11.6-8.8-14.3l-64-32c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5zm246.2-21.5c-4-7.9-13.6-11.1-21.5-7.2l-64 32c-5.4 2.7-8.8 8.3-8.8 14.3s3.4 11.6 8.8 14.3l64 32c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5L340.2 208l35.4-17.7c7.9-4 11.1-13.6 7.2-21.5zM352 416v-32.6c20.2-15.7 36.4-36.2 46.9-59.9 5.2-11.7-6.8-22.4-19.1-18.7-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7 10.4 23.6 26.6 44.1 46.8 59.8V416c0 53 43 96 96 96s96-43 96-96zm-32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64v-37.4c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9 2.8 12.6 20.8 12.6 23.6 0 2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"
        }
    ]
};

const FalFaceGrinTongueWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinTongueWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C132.3 32 32 132.3 32 256c0 79.8 41.7 149.8 104.5 189.5 7.5 4.7 9.7 14.6 5 22.1s-14.6 9.7-22.1 5C47.7 427.3 0 347.2 0 256 0 114.6 114.6 0 256 0s256 114.6 256 256c0 91.2-47.7 171.3-119.5 216.6-7.5 4.7-17.4 2.5-22.1-5s-2.5-17.4 5-22.1C438.3 405.8 480 335.8 480 256c0-123.7-100.3-224-224-224zm96 351.4V416c0 53-43 96-96 96s-96-43-96-96v-32.7c-20.2-15.7-36.3-36.2-46.8-59.8-5.2-11.7 6.8-22.4 19.1-18.7 37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7-10.4 23.6-26.6 44.2-46.9 59.9zm-32-4.7c0-14.7-11.9-26.6-26.6-26.6h-2c-11.3 0-21.1 7.9-23.6 18.9-2.8 12.6-20.8 12.6-23.6 0-2.5-11.1-12.3-18.9-23.6-18.9h-2c-14.7 0-26.6 11.9-26.6 26.6V416c0 35.3 28.7 64 64 64s64-28.7 64-64v-37.4zM336 256a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM124.8 233.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0zM336.4 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceGrinTongue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinTongue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6 7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm144.4-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM352 416v-32.6c20.2-15.7 36.4-36.2 46.9-59.9 5.2-11.7-6.8-22.4-19.1-18.7-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7 10.4 23.6 26.6 44.1 46.8 59.8V416c0 53 43 96 96 96s96-43 96-96zm-32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64v-37.4c0-14.7 11.9-26.6 26.6-26.6h2c11.3 0 21.1 7.9 23.6 18.9 2.8 12.6 20.8 12.6 23.6 0 2.5-11.1 12.3-18.9 23.6-18.9h2c14.7 0 26.6 11.9 26.6 26.6V416z"
        }
    ]
};

const FalFaceGrinWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinWide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm90-166.2c-22.6 23.6-54.5 38.3-89.9 38.3s-67.3-14.7-89.9-38.3c28.5 5.4 58.7 8.3 89.9 8.3s61.4-2.9 89.9-8.3zm33.8-41.1c-37.3 11.1-79.3 17.4-123.8 17.4s-86.4-6.3-123.8-17.4c-12.3-3.7-24.2 7-19.1 18.7 24.1 54.6 79 92.7 142.8 92.7s118.7-38.1 142.8-92.7c5.2-11.7-6.8-22.4-19.1-18.7zM192 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalFaceGrinWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrinWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3 22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7S137.3 378 113.2 323.4c-5.2-11.7 6.8-22.4 19.1-18.7 37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
        }
    ]
};

const FalFaceGrin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceGrin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 98.1c-31.2 0-61.4-2.9-89.9-8.3 22.6 23.6 54.5 38.3 89.9 38.3s67.3-14.7 89.9-38.3c-28.5 5.4-58.7 8.3-89.9 8.3zm142.8-30.7c-24.1 54.6-79 92.7-142.8 92.7S137.3 378 113.2 323.4c-5.2-11.7 6.8-22.4 19.1-18.7 37.3 11.1 79.3 17.4 123.8 17.4s86.4-6.3 123.8-17.4c12.3-3.7 24.2 7 19.1 18.7zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceHandOverMouth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceHandOverMouth",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3c40.4-45.2 65.1-105 65.1-170.6C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm144.4-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-95 125.3L248 318.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7 4.7 7.2 4.7 11.3-1.6 8.2-4.7 11.3l-16 16-34 34-17.3 17.3c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 34-34c6.2-6.2 16.4-6.2 22.6 0 .7.7 1.3 1.4 1.8 2.1 4.4 6.2 3.8 14.9-1.8 20.5l-5.1 5.1-26.9 26.9-2 2-17.3 17.3c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0 .7.7 1.3 1.4 1.8 2.1 4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2v-86.4c0-11 9-20 20-20 9.1 0 16.8 6.1 19.2 14.5.2.8.4 1.7.6 2.5.1 1 .2 2 .2 3v19.7c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8.7.5 1.4 1.1 2.1 1.8 6.2 6.2 6.2 16.4 0 22.6l-34 34zm-11.3-79.2-47.1 47c-9.4-13.7-25.1-22.7-43-22.7-28.7 0-52 23.3-52 52v86.4c0 70.3 56.9 127.2 127.2 127.2 33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9 16.9-18.8 16.3-47.8-1.8-65.9-1-1-2.1-2-3.2-3 3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2-18.7-18.7-49.1-18.7-67.9 0z"
        }
    ]
};

const FalFaceHandPeeking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceHandPeeking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M185.6 76.8C223 48.7 269.6 32 320 32c66.3 0 125.9 28.8 167 74.7 5.9 6.6 16 7.1 22.6 1.3s7.1-16 1.3-22.6C464 33 395.8 0 320 0c-57.6 0-110.8 19.1-153.6 51.2-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2zm-55.1 298.7c-4.7-7.5-14.6-9.7-22.1-5s-9.7 14.6-5 22.1C148.7 464.3 228.8 512 320 512c65.6 0 125.4-24.7 170.7-65.2 6.6-5.9 7.1-16 1.3-22.6s-16-7.1-22.6-1.3c-39.6 35.5-91.9 57-149.3 57-79.8 0-149.8-41.7-189.5-104.5zM415 232c.7-2.6 1-5.2 1-8 0-1.6-.1-3.2-.4-4.8l18 12.8H415zm-53.8 14.5c-5.8 6.9-9.2 15.8-9.2 25.5 0 13.4 6.6 25.3 16.7 32.5-.5 2.4-.7 4.9-.7 7.5 0 22.1 17.9 40 40 40h8v.9c0 22.1 17.9 40 40 40h64.8c31.6 0 61.9-12.6 84.3-34.9 46.2-46.2 46.5-120.9 1-167.6l-.2-.1-.8-.8-.1-.1-45-45.1c-17.2-17.2-45-17.2-62.2 0-7.3 7.3-11.5 16.6-12.6 26.2l-37.9-27.1c-18-12.8-43-8.7-55.8 9.3-8.5 11.9-9.6 26.9-4 39.4-1.1-.1-2.3-.2-3.4-.2-17.7 0-32 14.3-32 32 0 8.8 3.5 16.7 9.2 22.5zm-71.5 130.2c7.1-5.1 17.8-8.7 30.3-8.7s23.2 3.6 30.3 8.7c7.2 5.1 9.7 10.7 9.7 15.3s-2.5 10.2-9.7 15.3c-7.1 5.1-17.8 8.7-30.3 8.7s-23.2-3.6-30.3-8.7c-7.2-5.1-9.7-10.7-9.7-15.3s2.5-10.2 9.7-15.3zm-18.6-26C258 360.1 248 374.4 248 392s10 31.9 23.1 41.3c13.1 9.4 30.5 14.7 48.9 14.7s35.8-5.3 48.9-14.7C382 423.9 392 409.6 392 392s-10-31.9-23.1-41.3c-13.1-9.4-30.5-14.7-48.9-14.7s-35.8 5.3-48.9 14.7zm108.3-206.6c-2-6.3-8.7-9.8-15-7.9-37.3 11.7-64.4 46.6-64.4 87.8 0 20.7 6.8 39.8 18.4 55.2 4 5.3 11.5 6.4 16.8 2.4s6.4-11.5 2.4-16.8c-8.5-11.4-13.6-25.5-13.6-40.8 0-30.4 20-56.2 47.6-64.9 6.3-2 9.8-8.7 7.9-15zM96 88.3l-61.1 61.1-.8.8-.1.2C-11.5 197-11.2 271.7 35 318c22.4 22.4 52.7 34.9 84.3 34.9H184c22.1 0 40-17.9 40-40v-.9h8c22.1 0 40-17.9 40-40 0-2.6-.2-5.1-.7-7.5 10.1-7.3 16.7-19.1 16.7-32.5s-6.6-25.3-16.7-32.5c.5-2.4.7-4.9.7-7.5 0-22.1-17.9-40-40-40h-75.2l1.5-1.5c17.2-17.2 17.2-45 0-62.2s-45-17.2-62.2 0zm92.9 209.3c6.2 2 10.7 7.6 11.1 14.3v.9c0 8.8-7.2 16-16 16h-64.8c-25.2 0-49.5-10-67.3-27.9-36.9-36.9-37.2-96.6-.8-133.8l.8-.8 61.1-61c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3L122.8 152l-.5.5-4.2 4.2-5.7 5.7c-5 5-1.5 13.7 5.7 13.7H232c8.8 0 16 7.2 16 16v.2c-.1 8.8-7.2 15.8-16 15.8h-62.4c-2.2 0-4 1.8-4 4s1.8 4 4 4H248c4.6 0 8.7 1.9 11.6 5 2.7 2.9 4.4 6.8 4.4 11s-1.7 8.2-4.4 11c-2.9 3.1-7 5-11.6 5h-78.4c-2.2 0-4 1.8-4 4s1.8 4 4 4H232c8.8 0 16 7.1 16 15.9v.1c0 8.8-7.2 16-16 16h-62c-2.5 0-4.5 2-4.5 4.5s2 4.5 4.5 4.5h14c1.7 0 3.3.3 4.9.8zM376 272c0-8.8 7.2-16 16-16h74.6c7.4 0 13.4-6 13.4-13.4 0-4.3-2.1-8.4-5.6-10.9L414.7 189c-7.2-5.1-8.9-15.1-3.7-22.3s15.1-8.9 22.3-3.7l73.1 52.2 3.6 2.5 3.6 2.5 1.5 1.1c2.3 1.6 5.1 2.3 7.8 2 9.3-1.1 13.2-12.4 6.6-19l-1.3-1.3-3.1-3.1-3.1-3.1-7.3-7.3c-7.8-7.8-7.8-20.5 0-28.3s20.5-7.8 28.3 0l45.1 45.1.8.8c36.4 37.2 36.1 96.9-.8 133.8a95.148 95.148 0 0 1-67.3 27.9H456c-8.8 0-16-7.2-16-16v-.9c.5-8.4 7.4-15.1 16-15.1h19.5c2.5 0 4.5-2 4.5-4.5s-2-4.5-4.5-4.5H408c-8.8 0-16-7.2-16-16v-.1c0-8.8 7.2-15.9 16-15.9h68c2.2 0 4-1.8 4-4s-1.8-4-4-4h-84c-4.6 0-8.7-1.9-11.6-5-2.7-2.9-4.4-6.8-4.4-11z"
        }
    ]
};

const FalFaceHandYawn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceHandYawn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 57.4-21.6 109.7-57 149.3-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3c40.4-45.2 65.1-105 65.1-170.6C512 114.6 397.4 0 256 0S0 114.6 0 256c0 57.6 19.1 110.8 51.2 153.6 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4C48.7 353 32 306.5 32 256zm233.3 45.3L248 318.6c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7 4.7 7.2 4.7 11.3-1.6 8.2-4.7 11.3l-16 16-34 34-17.3 17.3c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 34-34c6.2-6.2 16.4-6.2 22.6 0 .7.7 1.3 1.4 1.8 2.1 4.4 6.2 3.8 14.9-1.8 20.5l-5.1 5.1-26.9 26.9-2 2-17.3 17.3c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0 .7.7 1.3 1.4 1.8 2.1 4.4 6.2 3.8 14.9-1.8 20.5L344 414.6l-37.5 37.5C288.7 470 264.4 480 239.2 480c-52.6 0-95.2-42.6-95.2-95.2v-86.4c0-11 9-20 20-20 9.1 0 16.8 6.1 19.2 14.5.2.8.4 1.7.6 2.5.1 1 .2 2 .2 3v19.7c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8.7.5 1.4 1.1 2.1 1.8 6.2 6.2 6.2 16.4 0 22.6l-34 34zM254 222.1l-47 47c-9.4-13.7-25.1-22.7-43-22.7-28.7 0-52 23.3-52 52v86.4c0 70.3 56.9 127.2 127.2 127.2 33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9 16.9-18.8 16.3-47.8-1.8-65.9-1-1-2.1-2-3.2-3 3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2-18.7-18.7-49.1-18.7-67.9 0zM220.5 110c-5.5-6.9-15.6-8-22.5-2.5l-80 64c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l80-64c6.9-5.5 8-15.6 2.5-22.5zm73.5 22.5 80 64c6.9 5.5 17 4.4 22.5-2.5s4.4-17-2.5-22.5l-80-64c-6.9-5.5-17-4.4-22.5 2.5s-4.4 17 2.5 22.5z"
        }
    ]
};

const FalFaceHeadBandage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceHeadBandage",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c2.4 0 4.9 0 7.3.1a637.5 637.5 0 0 0-84.8 35c-17.1 1.4-34.1 3.2-51 5.4C195.8 47 240.2 32 288 32zm80.1-19.2C342.9 4.5 316 0 288 0 213.6 0 146.6 31.8 99.8 82.4c-12.5 2.5-25 5.2-37.3 8.2-8.2 2-15.3 7.1-19.7 14.3-15.9 25.7-27.8 54-35 84.1-2.4 10.2.3 20.9 7.2 28.7-2.5 2.8-4.9 5.6-7.3 8.5C3 231.7.4 238.6.1 245.8c0 3.4-.1 6.8-.1 10.2 0 31.4 5 61.7 14.4 90.1 3.8 11.6 13.9 20 26 21.7s24.1-3.7 30.9-13.8c31.3-46.3 69.9-87.2 114.1-121-.7 2.2-1.1 4.6-1.1 7.1 0 13.3 10.7 24 24 24s24-10.7 24-24c0-13.1-10.5-23.7-23.5-24 12-8.2 24.4-15.8 37.2-23 13.9-.7 27.9-1 41.9-1 83.4 0 163.9 12.3 239.8 35.1 11 3.3 22.8.5 31.2-7.4s11.8-19.6 9.2-30.7c-7.2-30.1-19.1-58.4-34.9-84.1-3.3-5.3-8-9.5-13.5-12.1-.6-6-2.9-11.9-6.9-16.8-21.2-26.5-47-49.1-76.2-66.8-6.1-3.7-13.4-5.2-20.5-4.4-16.2 2-32.2 4.6-48.1 7.9zm138.2 109.4c7.3 11.9 13.7 24.4 19 37.5 4.8 11.8 8.7 24.1 11.7 36.7-11.9-3.6-23.9-6.9-36-10-59.4-15.1-121.2-24-184.8-26h-.8c-9.1-.3-18.3-.4-27.5-.4-17.1 0-34.1.5-51 1.5-48.2 2.8-95.4 9.6-141.2 20-7 1.6-13.9 3.3-20.9 5-12.1 3.1-24.1 6.4-36 10l1.5-6c2.8-10.5 6.2-20.8 10.2-30.7 5.4-13.3 11.8-26 19.3-38 23.2-5.6 46.8-10.3 70.7-14.1.8-.1 1.6-.3 2.5-.4 25-3.9 50.4-6.9 76.1-8.7 22.8-1.8 45.8-2.6 68.9-2.6 40 0 79.3 2.5 118 7.4l6.6.9c31.7 4.3 62.9 10.1 93.5 17.5.1.2.2.3.3.5zM177 199.3c-40.6 29.4-77 64.4-108 103.7-8.5 10.7-16.5 21.7-24.2 33.1-4.4-13.3-7.7-27.1-9.9-41.3C33 282.1 32 269.2 32 256c0-3 .1-6.1.2-9.1 5.9-7 12-13.8 18.2-20.5 41-12.2 83.3-21.3 126.6-27.1zM300.6 64.1c38.3-13 78.3-22.2 119.5-27.4 13.7 8.3 26.6 17.9 38.5 28.5 6.1 5.5 11.9 11.2 17.5 17.2-56.8-11.3-115.5-17.5-175.5-18.3zm242.8 209c.6-8.8-6.1-16.4-14.9-17s-16.4 6.1-17 14.9C503.8 387.7 406.7 480 288 480c-73.3 0-138.3-35.2-179.2-89.6-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C129.9 471.8 204.2 512 288 512c135.7 0 246.7-105.5 255.4-238.9zM373.2 397.5c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6C373.2 354.3 340.2 336 296 336c-16.4 0-31.4 2.5-44.8 6.8-8.4 2.7-13.1 11.6-10.5 20.1s11.6 13.1 20.1 10.5c10.4-3.3 22.1-5.3 35.2-5.3 34.8 0 60.4 14.2 77.2 29.5zM392.4 240a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalFaceHoldingBackTears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceHoldingBackTears",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320.6-139.6c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9-1 8.1-7.9 14-15.9 14 10 13.4 16 30 16 48s-6 34.6-16 48v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.7c-9.8 4.3-20.6 6.7-32 6.7-44.2 0-80-35.8-80-80 0-41.5 31.5-75.6 72-79.6-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2zM180.4 96.6c8.5 2.4 13.4 11.3 11 19.8l-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8 40.4 4 72 38.1 72 79.6v64c0 8.8-7.2 16-16 16s-16-7.2-16-16c-13.4 10-30 16-48 16-11.4 0-22.2-2.4-32-6.7v6.7c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c-10-13.4-16-30-16-48s6-34.6 16-48c-8 0-14.9-5.9-15.9-14-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11zM208 240a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm144 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-192-80c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32c17.7 0 32-14.3 32-32zm160 32c17.7 0 32-14.3 32-32 17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32zm1.9 129.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C328.9 410.3 298.8 432 256 432s-72.9-21.7-90.1-41.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6C203 384.4 224.9 400 256 400s53-15.6 65.9-30.5z"
        }
    ]
};

const FalFaceHushed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceHushed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176.4-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM179 160.9c-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16c-4.4 0-8.8.3-13 .9zm141-.9c-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8-4.3-.6-8.6-.9-13-.9zm-32 224a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalFaceIcicles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceIcicles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C132.3 32 32 132.3 32 256c0 .5 0 .9-.1 1.4l-7.7 186.5c-.1 2.3-2 4.1-4.3 4.1-2.2 0-4.1-1.7-4.2-3.9L.2 258.7c-.1-.9-.2-1.8-.2-2.7C0 114.6 114.6 0 256 0s256 114.6 256 256c0 .7 0 1.4-.1 2l-15.7 250.1c-.1 2.2-2 3.9-4.2 3.9-2.3 0-4.1-1.8-4.2-4.1L480 257v-1c0-123.7-100.3-224-224-224zm-88 288c-13.3 0-24 10.7-24 24s10.7 24 24 24h8v-48h-8zm40 48h32v-48h-32v48zm96 0v-48h-32v48h32zm32 0h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48zm-168-80h176c30.9 0 56 25.1 56 56 0 15.7-6.4 29.8-16.8 40l-9.3 90.7c-.3 3-2.8 5.3-5.9 5.3s-5.6-2.3-5.9-5.3l-7.7-75.7c-3.4.6-6.8 1-10.4 1h-26.7l-7.1 42.7c-.5 3-3.1 5.3-6.2 5.3s-5.7-2.2-6.2-5.3l-7.1-42.7H168c-30.9 0-56-25.1-56-56s25.1-56 56-56zm-15.6-80a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM256 512c-80.2 0-151.8-36.9-198.7-94.6l2.2-53.7C97.6 433 171.3 480 256 480c11.6 0 23-.9 34.1-2.6 4.3 1.7 9 2.6 13.9 2.6 9.7 0 18.7-3.6 25.5-9.7l.8 7.7c.8 7.7 3.9 14.7 8.5 20.3-26 8.9-53.8 13.7-82.8 13.7zm151.3-49.5 4.7-45.8c15.5-15 28.8-32.2 39.4-51.2l1.7 53.8c-13.4 16.2-28.8 30.7-45.8 43.1z"
        }
    ]
};

const FalFaceKissBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceKissBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm277.4 47.1c-11-5.4-25.7-9.3-39.1-11.2-6.6-.9-11.1-7-10.2-13.6s7-11.1 13.6-10.2c15.1 2.1 32.4 6.6 46.3 13.4 6.9 3.4 13.6 7.7 18.7 13 5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13-1.1.5-2.1 1-3.3 1.5l3.3 1.5c6.9 3.4 13.6 7.7 18.7 13 5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13-13.9 6.8-31.2 11.3-46.3 13.4-6.6.9-12.6-3.6-13.6-10.2s3.6-12.6 10.2-13.6c13.4-1.9 28.1-5.8 39.1-11.2 5.5-2.7 9.5-5.5 11.9-8 2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8-10.9-5.4-25.5-9.3-38.8-11.2-.9-.1-1.8-.3-2.7-.6-1.7-.6-3.2-1.6-4.4-2.8s-2.2-2.7-2.8-4.4c-.5-1.3-.7-2.6-.7-4.1s.2-2.8.7-4.1c.6-1.7 1.6-3.2 2.8-4.4s2.7-2.2 4.4-2.8c.9-.3 1.7-.5 2.7-.6 13.3-1.9 27.9-5.8 38.8-11.2 5.5-2.7 9.5-5.5 11.9-8 2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8zM156.5 194.5c-6.2 7.2-10.8 16.8-12.9 25.4-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 9.9-11.6 24.7-21.5 43.5-21.5s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 9.9-11.6 24.7-21.5 43.5-21.5s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"
        }
    ]
};

const FalFaceKissClosedEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceKissClosedEyes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm277.4 47.1c-11-5.4-25.7-9.3-39.1-11.2-6.6-.9-11.1-7-10.2-13.6s7-11.1 13.6-10.2c15.1 2.1 32.4 6.6 46.3 13.4 6.9 3.4 13.6 7.7 18.7 13 5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13-1.1.5-2.1 1-3.3 1.5l3.3 1.5c6.9 3.4 13.6 7.7 18.7 13 5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13-13.9 6.8-31.2 11.3-46.3 13.4-6.6.9-12.6-3.6-13.6-10.2s3.6-12.6 10.2-13.6c13.4-1.9 28.1-5.8 39.1-11.2 5.5-2.7 9.5-5.5 11.9-8 2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8-10.9-5.4-25.5-9.3-38.8-11.2-.9-.1-1.8-.3-2.7-.6-1.7-.6-3.2-1.6-4.4-2.8s-2.2-2.7-2.8-4.4c-.5-1.3-.7-2.6-.7-4.1s.2-2.8.7-4.1c.6-1.7 1.6-3.2 2.8-4.4s2.7-2.2 4.4-2.8c.9-.3 1.7-.5 2.7-.6 13.3-1.9 27.9-5.8 38.8-11.2 5.5-2.7 9.5-5.5 11.9-8 2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8zm-66.2-69.5c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
        }
    ]
};

const FalFaceKissWinkHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceKissWinkHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M325.2 469.1c-21.8 7.1-45 10.9-69.2 10.9-123.7 0-224-100.3-224-224S132.3 32 256 32s224 100.3 224 224c0 25.9-4.4 50.8-12.5 73.9 10.9 1.2 21.2 4.5 30.6 9.5 9-26.2 13.9-54.2 13.9-83.4C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c28.6 0 56.1-4.7 81.8-13.4-4.9-6.5-8.7-14.1-10.8-22.6l-1.8-7zM222.3 291.9c13.4 1.9 28.1 5.8 39.1 11.2 5.5 2.7 9.5 5.5 11.9 8 2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8-10.9 5.4-25.5 9.3-38.8 11.2-.9.1-1.8.3-2.7.6-1.7.6-3.2 1.6-4.4 2.8s-2.2 2.7-2.8 4.4c-.5 1.3-.7 2.7-.7 4.1s.2 2.8.7 4.1c.6 1.7 1.6 3.2 2.8 4.4s2.7 2.2 4.4 2.8c.9.3 1.7.5 2.7.6 13.3 1.9 27.9 5.8 38.8 11.2 5.5 2.7 9.5 5.5 11.9 8 2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8-11 5.4-25.7 9.3-39.1 11.2-6.6.9-11.1 7-10.2 13.6s7 11.1 13.6 10.2c15.1-2.1 32.4-6.6 46.3-13.4 6.9-3.4 13.6-7.7 18.7-13 5.2-5.4 9.3-12.6 9.3-21.4s-4.1-16-9.3-21.4c-5.1-5.4-11.8-9.6-18.7-13-1.1-.5-2.1-1-3.3-1.5l3.3-1.5c6.9-3.4 13.6-7.7 18.7-13 5.2-5.4 9.3-12.6 9.3-21.4s-4.1-16-9.3-21.4c-5.1-5.4-11.8-9.6-18.7-13-13.9-6.8-31.2-11.3-46.3-13.4-6.6-.9-12.6 3.6-13.6 10.2s3.6 12.6 10.2 13.6zm-46-59.9a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm194.8 1.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm70.1 127.5c-7.4-29-36.5-47.3-65.8-39.2-28.9 8.1-45.1 38.6-37.7 67.4l20.3 78.8c4.5 17.4 22.3 27.7 39.6 22.9l74.9-21c28.9-8.1 45.1-38.6 37.7-67.4-7.4-29-36.5-47.3-65.8-39.2l-2.4.7-.8-3zm-57.1-8.3c10.8-3 22.9 3.5 26.1 16.3L415 388c1.1 4.2 3.8 7.7 7.5 9.9s8.2 2.7 12.3 1.5l18.1-5.1c10.8-3 22.9 3.5 26.1 16.3 3.3 13-4.2 25.5-15.3 28.6l-74.9 21-20.2-78.8c-3.3-13 4.2-25.5 15.3-28.6z"
        }
    ]
};

const FalFaceKiss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceKiss",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm277.4 39.1c-11-5.4-25.7-9.3-39.1-11.2-6.6-.9-11.1-7-10.2-13.6s7-11.1 13.6-10.2c15.1 2.1 32.4 6.6 46.3 13.4 6.9 3.4 13.6 7.7 18.7 13 5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13-1.1.5-2.1 1-3.3 1.5l3.3 1.5c6.9 3.4 13.6 7.7 18.7 13 5.2 5.4 9.3 12.6 9.3 21.4s-4.1 16-9.3 21.4c-5.1 5.4-11.8 9.6-18.7 13-13.9 6.8-31.2 11.3-46.3 13.4-6.6.9-12.6-3.6-13.6-10.2s3.6-12.6 10.2-13.6c13.4-1.9 28.1-5.8 39.1-11.2 5.5-2.7 9.5-5.5 11.9-8 2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8-10.9-5.4-25.5-9.3-38.8-11.2-.9-.1-1.8-.3-2.7-.6-1.7-.6-3.2-1.6-4.4-2.8s-2.2-2.7-2.8-4.4c-.5-1.3-.7-2.6-.7-4.1s.2-2.8.7-4.1c.6-1.7 1.6-3.2 2.8-4.4s2.7-2.2 4.4-2.8c.9-.3 1.7-.5 2.7-.6 13.3-1.9 27.9-5.8 38.8-11.2 5.5-2.7 9.5-5.5 11.9-8 2.4-2.5 2.7-4.1 2.7-4.9s-.3-2.4-2.7-4.9c-2.4-2.6-6.4-5.3-11.9-8zm-125-87.1a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceLaughBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceLaughBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 144c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288h259c14.2 0 25.4 12.3 21.8 26-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm30-99.5c-6.2 7.2-10.8 16.8-12.9 25.4-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 9.9-11.6 24.7-21.5 43.5-21.5s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 9.9-11.6 24.7-21.5 43.5-21.5s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"
        }
    ]
};

const FalFaceLaughSquint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceLaughSquint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 144c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288h259c14.2 0 25.4 12.3 21.8 26-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm2.9-135.2c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l35.3-17.5-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 192l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
        }
    ]
};

const FalFaceLaughWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceLaughWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 144c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288h259c14.2 0 25.4 12.3 21.8 26-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm25.9-96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
        }
    ]
};

const FalFaceLaugh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceLaugh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 144c52 0 97.1-32.8 115.7-80H140.3c18.6 47.2 63.7 80 115.7 80zM126.5 288h259c14.2 0 25.4 12.3 21.8 26-18.1 68-79 118-151.3 118s-133.2-50-151.3-118c-3.6-13.7 7.6-26 21.8-26zm25.9-96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceLying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceLying",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.8 0 149.8-41.7 189.5-104.5 4.7-7.5 14.6-9.7 22.1-5s9.7 14.6 5 22.1C427.3 464.3 347.2 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c117.8 0 216.9 79.5 246.8 187.7 2.3 8.5-2.6 17.3-11.2 19.7s-17.3-2.6-19.7-11.2C445.8 101.5 359 32 256 32zM152.4 176a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm160 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM188.8 393.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c17.5-23.3 45.4-38.4 76.8-38.4 13.6 0 26.6 2.8 38.4 8 8.1 3.5 11.8 13 8.3 21.1s-13 11.8-21.1 8.3c-7.8-3.4-16.5-5.3-25.6-5.3-20.9 0-39.5 10-51.2 25.6zM288 224h160c35.3 0 64 28.7 64 64s-28.7 64-64 64h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H288c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalFaceMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceMask",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M444.8 416c-40.4 39.6-95.8 64-156.8 64s-116.4-24.4-156.8-64h18.2c9 18.9 28.3 32 50.6 32h176c22.3 0 41.6-13.1 50.6-32h18.2zm27.1-32H432v-72c0-3.8-.4-7.5-1.1-11l.6 1.2 80.5-43c-.7 46.4-15.4 89.3-40.1 124.8zm37.9-159.9-92.9 49.6C406.6 262.8 392.1 256 376 256H200c-16.1 0-30.6 6.8-40.8 17.7l-93-49.6C81.7 115.5 175.1 32 288 32s206.3 83.5 221.8 192.1zm29.9-15.5C517.4 89.9 413.2 0 288 0S58.6 89.9 36.4 208.6c-7.1-2-14.9 1.1-18.5 7.9-4.2 7.8-1.2 17.5 6.6 21.6l7.9 4.2c-.2 4.5-.4 9.1-.4 13.7 0 141.4 114.6 256 256 256s256-114.6 256-256c0-4.6-.1-9.1-.4-13.7l7.9-4.2c7.8-4.2 10.7-13.8 6.6-21.6-3.6-6.8-11.4-9.9-18.5-7.9zM64 259.2l80.4 42.9.6-1.2c-.7 3.6-1.1 7.3-1.1 11v72h-39.8C79.4 348.5 64.7 305.6 64 259.2zM376 288c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h176zm-176 40c0 8.8 7.2 16 16 16h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H216c-8.8 0-16 7.2-16 16zm0 48c0 8.8 7.2 16 16 16h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H216c-8.8 0-16 7.2-16 16zm40-200c8.8 0 16-7.2 16-16s-7.2-16-16-16c-55.4 0-93.6 23-107.3 36.7-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c7.6-7.6 37.7-27.3 84.7-27.3zm180.7 27.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6C429.6 167 391.4 144 336 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c47 0 77.1 19.7 84.7 27.3z"
        }
    ]
};

const FalFaceMehBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceMehBlank",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zm256 224a256 256 0 1 1-512 0 256 256 0 1 1 512 0zm-359.6-48a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceMeh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceMeh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 1-448 0 224 224 0 1 1 448 0zM256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zm-79.6 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM176 336c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
        }
    ]
};

const FalFaceMelting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceMelting",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 256c0 21.5-3 42.3-8.7 62-6.5 22.7-2.1 46.4 9.5 64.6.6.9 1.2 1.9 1.9 2.8-29 6.1-50.7 31.8-50.7 62.6 0 11.7 3.1 22.6 8.6 32H101.3c7.3-9.4 12.9-19.6 16.7-28.9 11.5-27.7 16.2-65.6 1.3-95.4-15-30-23.4-63.8-23.4-99.8C96 132.3 196.3 32 320 32s224 100.3 224 224zM16 512h544c8.8 0 16-7.2 16-16s-7.2-16-16-16c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-19.9c-27.7 0-45.6-30.6-38-57.2 6.5-22.5 9.9-46.2 9.9-70.8C576 114.6 461.4 0 320 0S64 114.6 64 256c0 41 9.6 79.7 26.7 114 18.4 37-8 110-49.3 110H16c-8.8 0-16 7.2-16 16s7.2 16 16 16zm233.3-299.8a24 24 0 1 0 12.4-46.4 24 24 0 1 0-12.4 46.4zm183.9 24.4a24 24 0 1 0-46.4-12.4 24 24 0 1 0 46.4 12.4zm-220 46.7c-3.9-7.9-13.4-11.3-21.4-7.4s-11.3 13.4-7.4 21.4c14.8 30.5 45.1 67.5 98.3 81.7s97.9-2.6 126-21.7c7.3-5 9.2-14.9 4.3-22.2s-14.9-9.2-22.2-4.3c-22.7 15.4-57.9 28.5-99.8 17.2s-65.8-40.2-77.8-64.8z"
        }
    ]
};

const FalFaceMonocle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceMonocle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 371.4V224c0-8.8-7.2-16-16-16-.9 0-1.8.1-2.7.2-10.7-46-52-80.2-101.3-80.2-57.4 0-104 46.6-104 104s46.6 104 104 104c37.1 0 69.6-19.4 88-48.5v106.4c0 5.9.4 11.8 1.2 17.6C376.5 453.7 319.3 480 256 480 132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224c0 42.2-11.7 81.7-32 115.4zm3.9 49.4c37.5-44.5 60.1-102 60.1-164.8C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c65.8 0 125.9-24.8 171.2-65.7 10.2 22.8 27.1 42.5 48.9 56.1l11.4 7.1c7.5 4.7 17.4 2.4 22-5.1s2.4-17.4-5.1-22l-11.4-7.1c-20.2-12.6-34.7-32.2-41.3-54.5zM176.4 184a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm136 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm15.6-80a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM160 352c0 8.8 7.2 16 16 16 14.3 0 37.9 2.9 60.6 11.7 22.8 8.8 42.7 22.7 53.1 43.4 4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5c-15.3-30.5-43.3-48.6-70.1-59-27-10.3-54.6-13.8-72.3-13.8-8.8 0-16 7.2-16 16zm145.2-246.1c8-6.4 18-9.9 28.2-9.9 8.9 0 17.6 2.6 25.1 7.6l8.6 5.7c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-8.6-5.7c-12.7-8.5-27.6-13-42.8-13-17.5 0-34.5 6-48.2 16.9L262 99.5c-6.9 5.5-8 15.6-2.5 22.5s15.6 8 22.5 2.5l23.2-18.6z"
        }
    ]
};

const FalFaceNauseated = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceNauseated",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm203.3-155.3c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zM175.6 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm160 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-26.9-60.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4zM146.2 272.6c4.4-7.6 14.2-10.3 21.9-5.8 19.5 11.3 33.8 30.5 38.4 53.3h99.2c4.6-22.8 18.9-42 38.4-53.3 7.7-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6s9.6 33.3 24 41.6c7.6 4.4 10.3 14.2 5.8 21.9s-14.2 10.3-21.9 5.8c-19.5-11.3-33.8-30.5-38.4-53.3h-99.3c-4.6 22.8-18.9 42-38.4 53.3-7.6 4.4-17.4 1.8-21.9-5.8s-1.8-17.4 5.8-21.9c14.4-8.3 24-23.8 24-41.6s-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9z"
        }
    ]
};

const FalFaceNoseSteam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceNoseSteam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 10.1-.7 20.1-2 29.9-1.2 8.8 5 16.8 13.7 18s16.8-5 18-13.7c1.5-11.2 2.3-22.6 2.3-34.1C512 114.6 397.4 0 256 0S0 114.6 0 256c0 11.6.8 22.9 2.3 34.1 1.2 8.8 9.2 14.9 18 13.7s14.9-9.2 13.7-18c-1.3-9.8-2-19.7-2-29.9zm179.2 219.5c-8.7-1.8-17.1 3.8-18.9 12.5s3.8 17.1 12.5 18.9c16.6 3.4 33.7 5.1 51.2 5.1s34.6-1.8 51.2-5.1c8.7-1.8 14.3-10.2 12.5-18.9s-10.2-14.3-18.9-12.5c-14.5 2.9-29.5 4.5-44.8 4.5s-30.3-1.5-44.8-4.5zM204 312.2c3.8-6.3 2.8-14.4-2.4-19.5s-13.2-6.2-19.5-2.4L115 330.6c-1.1-1.4-2.3-2.8-3.7-4.1-18.7-18.7-49.1-18.7-67.9 0-2.7 2.7-5 5.6-6.9 8.8-13.8-1.3-27.9 3.3-38.4 13.8-17.9 17.9-18.7 46.4-2.5 65.2-10.3 23.4-5.8 51.8 13.4 70.9s47.5 23.6 70.9 13.4c18.9 16.2 47.3 15.4 65.2-2.5 10.5-10.5 15.1-24.6 13.9-38.3 3.1-1.9 6.1-4.2 8.8-6.9 18.7-18.7 18.7-49.1 0-67.9-1.3-1.3-2.7-2.5-4.1-3.7l40.3-67.1zm124.3-21.1c-6.3-3.8-14.4-2.8-19.5 2.4s-6.2 13.3-2.4 19.5l40.3 67.1c-1.4 1.1-2.8 2.4-4.1 3.7-18.7 18.7-18.7 49.1 0 67.9 2.7 2.7 5.6 5 8.8 6.9-1.2 13.7 3.4 27.8 13.9 38.3 17.9 17.9 46.4 18.7 65.2 2.5 23.4 10.3 51.8 5.8 70.9-13.4s23.6-47.5 13.4-70.9c16.2-18.9 15.4-47.3-2.5-65.2-10.5-10.5-24.6-15.1-38.3-13.9-1.9-3.1-4.2-6.1-6.9-8.8-18.7-18.7-49.1-18.7-67.9 0-1.3 1.3-2.5 2.7-3.7 4.1L328.4 291zm-211.7 75.7 26.9-16.2-16.2 26.9c-2.6 4.4-3 9.8-1 14.5s6.1 8.2 11.1 9.3c2.8.7 5.4 2.1 7.6 4.3 6.2 6.2 6.2 16.4 0 22.6-2.3 2.3-5.2 3.8-8.2 4.4-4.9 1-9 4.1-11.2 8.5s-2.3 9.6-.1 14.1c2.9 6 1.8 13.3-3.1 18.2-6.2 6.2-16.4 6.2-22.6 0-1-1-1.9-2.2-2.6-3.4-2.3-4-6.2-6.8-10.7-7.7s-9.2.2-12.9 3c-12.5 9.6-30.6 8.7-42.1-2.8s-12.4-29.5-2.8-42.1c2.8-3.7 3.9-8.4 3-12.9s-3.7-8.4-7.7-10.7c-1.2-.7-2.3-1.5-3.4-2.6-6.2-6.2-6.2-16.4 0-22.6 4.9-4.9 12.3-6 18.2-3.1 4.5 2.1 9.7 2.1 14.1-.1s7.6-6.4 8.5-11.2c.6-3 2-5.8 4.4-8.2 6.2-6.2 16.4-6.2 22.6 0 2.2 2.2 3.6 4.8 4.3 7.6 1.2 5 4.6 9.1 9.3 11.1s10.1 1.6 14.5-1zm266.2 11.7-16.2-26.9 26.9 16.2c4.4 2.6 9.8 3 14.5 1s8.2-6.1 9.3-11.1c.7-2.8 2.1-5.4 4.3-7.6 6.2-6.2 16.4-6.2 22.6 0 2.3 2.3 3.8 5.2 4.4 8.2 1 4.9 4.1 9 8.5 11.2s9.6 2.3 14.1.1c6-2.9 13.3-1.8 18.2 3.1 6.2 6.2 6.2 16.4 0 22.6-1 1-2.2 1.9-3.4 2.6-4 2.3-6.8 6.2-7.7 10.7s.2 9.2 3 12.9c9.6 12.5 8.7 30.6-2.8 42.1s-29.5 12.4-42.1 2.8c-3.7-2.8-8.4-3.9-12.9-3s-8.4 3.7-10.7 7.7c-.7 1.2-1.5 2.3-2.6 3.4-6.2 6.2-16.4 6.2-22.6 0-4.9-4.9-6-12.3-3.1-18.2 2.1-4.5 2.1-9.7-.1-14.1s-6.4-7.6-11.2-8.5c-3-.6-5.8-2-8.2-4.4-6.2-6.2-6.2-16.4 0-22.6 2.2-2.2 4.9-3.6 7.6-4.3 5-1.2 9.1-4.6 11.1-9.3s1.6-10.1-1-14.5zM96 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm192 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm101.1-96.8c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1c-41.3 13.8-74.2 39.9-86.3 51.9-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c9.3-9.3 38.2-32.3 73.7-44.1zm-266.1 0c35.5 11.8 64.4 34.8 73.7 44.1 6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-12-12-45-38.1-86.3-51.9-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2z"
        }
    ]
};

const FalFaceParty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceParty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 256C96 132.3 196.3 32 320 32c91.8 0 170.8 55.3 205.4 134.4 3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1C515.2 63.2 425 0 320 0c-56.8 0-109.3 18.5-151.8 49.9L21.1.8C15.2-1.1 8.7.5 4.4 4.9S-1.2 16 1.1 21.7L70 200.9c-3.9 17.8-6 36.2-6 55.1 0 141.4 114.6 256 256 256 75.8 0 144-33 190.8-85.3 5.9-6.6 5.3-16.7-1.3-22.6-3-2.7-6.8-4.1-10.6-4.1h-.1c-4.4 0-8.7 1.8-11.9 5.3-41 45.9-100.6 74.7-167 74.7C196.3 480 96 379.7 96 256zm43.8-181.9c-22.6 22.4-41.1 49-54.1 78.5l-11.8-30.7c.5-.7 1-1.4 1.4-2.1 10.9-19.6 24.1-37.7 39.3-54.1l25.2 8.4zM81.6 54.7c-8 9.4-15.4 19.3-22.2 29.6L43.1 41.9l38.5 12.8zm193.6 178.9c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm160 0c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm-53.8 69.5c5.5 2.7 9.5 5.5 11.9 8 2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8-10.9 5.4-25.5 9.3-38.8 11.2-.9.1-1.8.3-2.7.6-1.7.6-3.2 1.6-4.4 2.8s-2.2 2.7-2.8 4.4c-.5 1.3-.7 2.7-.7 4.1s.2 2.8.7 4.1c.6 1.7 1.6 3.2 2.8 4.4s2.7 2.2 4.4 2.8c.9.3 1.7.5 2.7.6 13.3 1.9 27.9 5.8 38.8 11.2 5.5 2.7 9.5 5.5 11.9 8 2.4 2.5 2.7 4.1 2.7 4.9s-.3 2.4-2.7 4.9c-2.4 2.6-6.4 5.3-11.9 8-11 5.4-25.7 9.3-39.1 11.2-6.6.9-11.1 7-10.2 13.6s7 11.1 13.6 10.2c15.1-2.1 32.4-6.6 46.3-13.4 6.9-3.4 13.6-7.7 18.7-13 5.2-5.4 9.3-12.6 9.3-21.4 0-8-3.5-14.8-8-20h180c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48s21.5 48 48 48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H412c4.5-5.2 8-12 8-20 0-8.8-4.1-16-9.3-21.4-5.1-5.4-11.8-9.6-18.7-13-13.9-6.8-31.2-11.3-46.3-13.4-6.6-.9-12.6 3.6-13.6 10.2s3.7 12.6 10.2 13.6c13.4 1.9 28.1 5.8 39.1 11.2z"
        }
    ]
};

const FalFacePensive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFacePensive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm208 128h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm179.2-113.6c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm-43.1-55.2c-4-7.9-.7-17.5 7.2-21.5l22.9-11.4c14.5-7.2 27.2-17.6 37.4-30.2l14.4-18c5.5-6.9 15.6-8 22.5-2.5s8 15.6 2.5 22.5l-14.4 18c-13 16.3-29.4 29.5-48 38.8l-22.9 11.4c-7.9 4-17.5.7-21.5-7.2zm341.5-21.5c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L386 210.9c-18.6-9.3-35-22.6-48.1-38.8l-14.4-18c-5.5-6.9-4.4-17 2.5-22.5s17-4.4 22.5 2.5l14.4 18c10.1 12.7 22.9 23 37.4 30.2l22.9 11.4z"
        }
    ]
};

const FalFacePersevering = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFacePersevering",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm316.1 154.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM129.3 232.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l35.4-17.5-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 272l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM211.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"
        }
    ]
};

const FalFacePleading = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFacePleading",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm280.1 154.7c-4.7-5.3-12.7-10.7-24.1-10.7s-19.4 5.4-24.1 10.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c9.2-10.2 25.2-21.3 47.9-21.3s38.7 11.1 47.9 21.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zm51.5-314.1c8.5-2.4 17.4 2.5 19.8 11l1.5 5.2c7 24.7 28.1 42.7 53.6 45.9l11.5 1.4c8.8 1.1 15 9.1 13.9 17.9-1 8.1-7.9 14-15.9 14 10 13.4 16 30 16 48 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-41.5 31.5-75.6 72-79.6-10-10.8-17.6-24.1-21.9-38.8l-1.5-5.2c-2.4-8.5 2.5-17.4 11-19.8zm-140.2 19.8-1.5 5.2c-4.2 14.8-11.8 28-21.9 38.8 40.4 4 72 38.1 72 79.6 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-18 6-34.6 16-48-8 0-14.9-5.9-15.9-14-1.1-8.8 5.1-16.8 13.9-17.9l11.5-1.4c25.5-3.2 46.6-21.3 53.6-45.9l1.5-5.2c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zM160 288a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm240-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-272 0c17.7 0 32-14.3 32-32 17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32zm224-32c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32c17.7 0 32-14.3 32-32z"
        }
    ]
};

const FalFacePouting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFacePouting",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm85.3-102.7c4.5-3.5 8.4-8.6 10-15.1 1.6-6.7.5-13.5-2.7-19.5C331.2 342 296.1 320 256 320c-40.1 0-75.1 22-92.5 54.7-3.2 6-4.3 12.8-2.7 19.5 1.6 6.5 5.4 11.6 10 15.1 8.8 6.8 21.2 8.7 32.4 4.5 16.2-6.1 34-9.4 52.9-9.4s36.7 3.4 52.9 9.4c11.2 4.2 23.6 2.4 32.4-4.5zm-25.7-27.1c-18.5-6.4-38.6-9.9-59.6-9.9-20.9 0-41 3.5-59.6 9.8 13-18.1 34.7-30.1 59.6-30.1s46.7 12.1 59.6 30.2zM176.4 264c13.3 0 24-10.7 24-24 0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6 0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7 0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FalFaceRaisedEyebrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceRaisedEyebrow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-55.6-272a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm29.4-118.5 4.9 7.4c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-4.9-7.4c-19.6-29.4-61.2-33.5-86.2-8.5l-29.5 29.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l29.5-29.5c10.7-10.7 28.5-8.9 36.9 3.7zM112 160c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm64 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"
        }
    ]
};

const FalFaceRelieved = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceRelieved",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm187.3 92.7c13 13 35.8 27.3 68.7 27.3s55.6-14.3 68.7-27.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C329.4 389.2 298.9 408 256 408s-73.4-18.8-91.3-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm199.9-110.3c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2zm82.4-131.5c2.8 8.4-1.7 17.4-10.1 20.2l-6.3 2.1c-23.6 7.9-44 23.4-57.8 44.1l-7.6 11.5c-4.9 7.4-14.8 9.3-22.2 4.4s-9.3-14.8-4.4-22.2l7.6-11.5c17.8-26.6 43.9-46.6 74.3-56.7l6.3-2.1c8.4-2.8 17.4 1.7 20.2 10.1zM315 127.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l6.3 2.1c30.4 10.1 56.5 30.1 74.3 56.7l7.6 11.5c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4l-7.7-11.5c-13.8-20.7-34.1-36.3-57.8-44.1l-6.3-2.1z"
        }
    ]
};

const FalFaceRollingEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceRollingEyes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm192 112h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32-96c26.5 0 48-21.5 48-48 0-14.3-6.3-27.2-16.2-36 .2 1.3.2 2.6.2 4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4.1-2.7.2-4-10 8.8-16.2 21.7-16.2 36 0 26.5 21.5 48 48 48zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm240 80c0-14.3-6.3-27.2-16.2-36 .2 1.3.2 2.6.2 4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-1.4.1-2.7.2-4-10 8.8-16.2 21.7-16.2 36 0 26.5 21.5 48 48 48s48-21.5 48-48zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FalFaceSadCry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSadCry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 439.8V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v186.4c-29.1 13.8-61.6 21.6-96 21.6s-66.9-7.7-96-21.6V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v167.8C70 399.4 32 332.1 32 256 32 132.3 132.3 32 256 32s224 100.3 224 224c0 76.1-38 143.4-96 183.8zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-60.8-278.4c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm121.6 0c17.6-23.5 52.8-23.5 70.4 0 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM288 352c0 17.7-14.3 32-32 32s-32-14.3-32-32v-24c0-17.7 14.3-32 32-32s32 14.3 32 32v24zm-32-88c-35.3 0-64 28.7-64 64v24c0 35.3 28.7 64 64 64s64-28.7 64-64v-24c0-35.3-28.7-64-64-64z"
        }
    ]
};

const FalFaceSadSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSadSweat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0c141.4 0 256 114.6 256 256S429.4 512 288 512c-57.6 0-110.8-19.1-153.6-51.2-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2C191 463.3 237.5 480 288 480c123.7 0 224-100.3 224-224S411.7 32 288 32zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23-5.4 8.5-9.8 16.4-12.8 23.1-2.6 5.8-3.2 8.8-3.4 9.5v.1c0 12.3 11.7 26.8 32 26.8s32-14.5 32-26.7v-.1c-.1-.7-.8-3.7-3.4-9.6-3-6.7-7.4-14.5-12.8-23.1-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0 17.6 21.7 55.5 72.2 55.5 97.2 0 32.5-28.7 58.7-64 58.7S0 405.8 0 373.3c0-25 38.1-75.5 55.5-97.2zm292.7 134.6c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM391.6 272a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm3.7-99.3c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm153.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"
        }
    ]
};

const FalFaceSadTear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSadTear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-480a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm-96 300.4c-5.5 6.9-11 14.3-16.2 22-11.4 17.1-15.8 29-15.8 34.9 0 12.2 11.7 26.7 32 26.7s32-14.5 32-26.7c0-5.9-4.4-17.8-15.8-34.9-5.1-7.7-10.7-15.1-16.2-22zm-8.6-40.3c4.3-5.5 12.8-5.5 17.1 0 1.6 2 3.3 4.1 5.2 6.3 18.9 23 50.3 61.2 50.3 90.8 0 32.5-28.7 58.7-64 58.7s-64-26.2-64-58.7c0-29.2 30.8-66.9 49.6-90 2.1-2.6 4.1-5 5.8-7.2zM256 320c45 0 85.6 20.5 115.7 53.1 6 6.5 5.6 16.6-.9 22.6s-16.6 5.6-22.6-.9c-25-27.1-57.4-42.9-92.3-42.9-8.8 0-16-7.2-16-16s7.2-16 16-16zm103.6-112a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceSaluting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSaluting",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368.8 32.6c-10.1-.8-20.1-.8-30-.3-8.8.5-16.4-6.2-16.9-15.1S328.1.8 336.9.3c11.2-.6 22.7-.6 34.2.3C512.1 11.2 617.8 134 607.2 275S473.8 521.7 332.8 511.1C221.7 503 132.5 424.8 104.9 323c-2.3-8.5 2.7-17.3 11.3-19.6s17.3 2.7 19.6 11.3c24.1 89 102.2 157.4 199.5 164.7 123.4 9.3 230.9-83.3 240.1-206.6S492.1 41.9 368.8 32.7zM235 345.2c5.2-7.2 15.2-8.8 22.3-3.6 17.5 12.6 48.9 27 94.6 27s77.2-14.4 94.6-27c7.2-5.2 17.2-3.5 22.3 3.6s3.5 17.2-3.6 22.3c-22.7 16.4-60.7 33-113.4 33s-90.6-16.6-113.4-33c-7.2-5.2-8.8-15.2-3.6-22.3zm37.3-160.6a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM257.5 89.4l-38 23.9c5.2 3.6 9.8 8.3 13.4 14.1 14 22.5 7.2 52.2-15.2 66.3l-64 40.1-.1.1-29 18.2c-43.7 27.3-101.4 7.7-119.4-40.6-13.6-36.4.2-77.3 33.1-97.9L206.7 7.8c22.4-14.1 52-7.2 66 15.3s7.2 52.2-15.2 66.3zm-17-27.3c7.5-4.7 9.8-14.6 5.1-22s-14.6-9.8-22-5.1L54.7 140.4c-20 12.5-28.4 37.3-20.1 59.4 11 29.3 46 41.2 72.6 24.6l93.3-58.3c7.5-4.7 9.8-14.6 5.1-22s-14.6-9.8-22-5.1L128 173.7v-41.3l112.5-70.3z"
        }
    ]
};

const FalFaceScream = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceScream",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M543.2 274.5c.5-6.1.8-12.3.8-18.5 0-123.7-100.3-224-224-224S96 132.3 96 256c0 6.2.3 12.4.8 18.5-10.5-2.5-21.4-3.2-32.2-1.9-.4-5.5-.5-11-.5-16.6C64 114.6 178.6 0 320 0s256 114.6 256 256c0 5.6-.2 11.1-.5 16.6-10.8-1.3-21.7-.6-32.2 1.9zM407.6 462.2c-2.7 12.2-4.9 24.5-6.4 36.6-25.5 8.6-52.8 13.2-81.2 13.2-28.4 0-55.6-4.6-81.1-13.1-1.5-12.2-3.6-24.4-6.4-36.6 26.9 11.4 56.4 17.7 87.5 17.7s60.7-6.3 87.6-17.8zM224.3 164.4c-13.1 5.8-26.4 17.1-36.1 33-9.7 15.9-13.3 32.2-12.1 45.3 1.2 13 6.9 21.7 14.7 26 8.1 4.4 19.5 4.7 32.7-1.1 13.1-5.8 26.4-17.1 36.1-33 9.7-15.9 13.3-32.2 12.1-45.3-1.2-13-6.9-21.7-14.7-26-8.1-4.4-19.5-4.7-32.7 1.1zm-12.9-29.3c19.4-8.6 41.8-10.4 61 .1 19.4 10.6 29.3 30.3 31.2 51.2 1.9 20.8-3.8 43.9-16.6 64.9-12.8 21-30.9 37-50.5 45.6-19.4 8.6-41.8 10.4-61-.1-19.4-10.6-29.3-30.3-31.2-51.2-1.9-20.8 3.8-43.9 16.6-64.9 12.8-21 30.9-37 50.5-45.6zm204.2 29.3c-13.2-5.8-24.6-5.5-32.7-1.1-7.9 4.3-13.5 13-14.7 26-1.2 13.1 2.4 29.4 12.1 45.3 9.7 15.9 23 27.2 36.1 33 13.2 5.8 24.6 5.5 32.7 1.1 7.9-4.3 13.5-13 14.7-26 1.2-13.1-2.4-29.4-12.1-45.3-9.7-15.9-23-27.2-36.1-33zm12.9-29.3c19.5 8.6 37.7 24.6 50.5 45.6 12.8 21 18.5 44.1 16.6 64.9-1.9 20.9-11.8 40.6-31.2 51.2-19.2 10.5-41.5 8.7-61 .1s-37.7-24.6-50.5-45.6c-12.8-21-18.5-44.1-16.6-64.9 1.9-20.9 11.8-40.6 31.2-51.2 19.2-10.5 41.5-8.7 61-.1zM352 352c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32zm-96 0c0-35.3 28.7-64 64-64s64 28.7 64 64v32c0 35.3-28.7 64-64 64s-64-28.7-64-64v-32zm-142.4-34.2c29.4 24.5 52.9 60.4 69 97.8 13.7 31.8 22.5 65.7 24.8 96.4H65.8c-2.8-41.8-18-83.5-40-116.9-6.6-9.9-9.8-21.2-9.8-32.3 0-19.2 9.5-38 26.9-49.2 22.5-14.5 51.3-12 70.8 4.2zm500.6 77.3c-22.1 33.4-37.2 75.1-40 116.9H432.6c2.3-30.7 11.1-64.6 24.8-96.4 16.1-37.4 39.6-73.2 69-97.8 19.5-16.2 48.3-18.8 70.8-4.2 18.2 11.8 27.7 31.8 26.8 52-.5 10.2-3.7 20.5-9.7 29.6zM48 362.8c0 5 1.4 10.1 4.4 14.6 25.3 38.2 42.6 86 45.5 134.6h77.4c-2.3-26-9.9-55.5-22.1-83.8-14.8-34.3-35.6-65.4-60-85.8-9.1-7.5-22.5-8.7-32.9-2-8 5.2-12.2 13.7-12.2 22.4zm544 1.2c.4-9.1-3.9-18.2-12.2-23.6-10.4-6.7-23.9-5.6-32.9 2-24.4 20.4-45.3 51.5-60.1 85.8-12.1 28.3-19.8 57.8-22.1 83.8h77.4c2.9-48.6 20.2-96.4 45.4-134.6 2.8-4.2 4.2-8.8 4.4-13.4z"
        }
    ]
};

const FalFaceShush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceShush",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 45.8-13.7 88.4-37.3 123.9-4.9 7.4-2.9 17.3 4.5 22.2s17.3 2.9 22.2-4.5C496.3 357 512 308.3 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 83.8 40.2 158.1 102.4 204.8 7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4C67.2 394.3 32 329.3 32 256zm168.4-112a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm160 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-195.7 84.7c-6.2 6.2-6.2 16.4 0 22.6 10.3 10.3 24.7 20.8 43.3 28v28.4c-32.5 10.2-56 40.5-56 76.3v48c0 44.2 35.8 80 80 80h57.5c28.5 0 55.5-12.7 73.7-34.5l25.6-30.7c17-20.4 14.2-50.6-6.1-67.6-11.6-9.7-26.4-12.9-40.1-10.2-4.4-23.2-18.8-42.8-38.6-54.2v-35.5c18.6-7.2 33.1-17.7 43.3-28 6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0c-5.3 5.3-12.2 10.8-20.7 15.4V240c0-26.5-21.5-48-48-48s-48 21.5-48 48v4.1c-8.5-4.7-15.4-10.1-20.7-15.4-6.2-6.2-16.4-6.2-22.6 0zM256 224c8.8 0 16 7.2 16 16v64h-32v-64c0-8.8 7.2-16 16-16zm-38.8 154 76.7 69.7c7.9-1.1 15.1-5 20.2-11.2l25.6-30.7c5.7-6.8 15.7-7.7 22.5-2s7.7 15.7 2 22.5L338.7 457c-12.2 14.6-30.2 23-49.2 23H232c-26.5 0-48-21.5-48-48v-48c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-8.8-7.2-16-16-16h-32c-6.7 0-12.5 4.1-14.8 10z"
        }
    ]
};

const FalFaceSleeping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSleeping",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32c33.1 0 64.5 7.2 92.7 20 8 3.7 17.5.1 21.2-7.9s.1-17.5-7.9-21.2C329.6 8.2 293.8 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-37.8-8.2-73.6-22.9-105.9-3.7-8-13.1-11.6-21.2-7.9s-11.6 13.1-7.9 21.2c12.8 28.2 20 59.6 20 92.7 0 123.7-100.3 224-224 224S32 379.7 32 256zm200 128a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm8-256h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-25.4l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S390.5 96 384 96h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16zm96-112c0 8.8 7.2 16 16 16h25.4l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4S425.5 96 432 96h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-25.4l36.7-36.7c4.6-4.6 5.9-11.5 3.5-17.4S502.5 0 496 0h-64c-8.8 0-16 7.2-16 16zm-28.8 222.4c-17.6 23.5-52.8 23.5-70.4 0-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0 5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2zm-262.4 0c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4c30.4 40.5 91.2 40.5 121.6 0 5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2c-17.6 23.5-52.8 23.5-70.4 0z"
        }
    ]
};

const FalFaceSleepy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSleepy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c31.9 0 62.2-6.7 89.6-18.6 8.1-3.5 17.5.2 21.1 8.3s-.2 17.5-8.3 21.1C327 504.4 292.4 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0s256 114.6 256 256c0 23.6-3.2 46.5-9.2 68.3-2.4 8.5-11.2 13.5-19.7 11.2s-13.5-11.2-11.2-19.7c5.2-19 8.1-39 8.1-59.7C480 132.3 379.7 32 256 32zm64.3 285c1.4-7.5 8-13 15.7-13 27.8 0 70.8 13.3 106.7 36.6C478.5 363.7 512 399.9 512 448c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-16.2-.1-39.4-7.2-61.5-6.9-21.5-20.2-41.1-46.7-51.7-7.1-2.8-11.2-10.3-9.8-17.9zm76 34.8c4.7 8.1 8.3 16.5 11 25 8.8 27.2 8.8 54.9 8.8 70.8v.5c0 17.7 14.3 32 32 32s32-14.3 32-32c0-31.9-22.5-59.7-54.7-80.6-9.4-6.1-19.3-11.3-29.1-15.7zm-87.3 78c-16.2-6.1-34-9.4-52.9-9.4-18.8 0-36.7 3.4-52.9 9.4-11.2 4.2-23.6 2.3-32.4-4.5-4.5-3.5-8.4-8.6-10-15.1-1.6-6.7-.5-13.5 2.7-19.5C180.9 358 215.9 336 256 336s75.2 22.1 92.5 54.7c3.2 6 4.3 12.8 2.7 19.5-1.6 6.5-5.5 11.6-10 15.1-8.8 6.8-21.2 8.7-32.4 4.5zM256 368c-24.9 0-46.7 12.1-59.6 30.2 18.5-6.4 38.6-9.8 59.6-9.8s41.1 3.5 59.6 9.9C302.7 380 280.9 368 256 368zm131.2-129.6c5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2c17.6 23.5 52.8 23.5 70.4 0zm-262.4 0c17.6 23.5 52.8 23.5 70.4 0 5.3-7.1 15.3-8.5 22.4-3.2s8.5 15.3 3.2 22.4c-30.4 40.5-91.2 40.5-121.6 0-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2z"
        }
    ]
};

const FalFaceSmileBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmileBeam",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm-7.6-131c-6.2 7.2-10.8 16.8-12.9 25.4-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 9.9-11.6 24.7-21.5 43.5-21.5s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5zm147.1 25.4c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4c3.2-12.7 9.8-27.1 19.9-38.6 9.9-11.6 24.7-21.5 43.5-21.5s33.6 9.9 43.7 21.5c10 11.5 16.7 25.9 19.9 38.6 2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6c-2.1-8.6-6.7-18.2-12.9-25.4-6.2-7.1-12.8-10.5-19.5-10.5s-13.4 3.4-19.5 10.5c-6.2 7.2-10.8 16.8-12.9 25.4z"
        }
    ]
};

const FalFaceSmileHalo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmileHalo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480.3 78.1a.1.1 0 1 0-.2 0 .1.1 0 1 0 .2 0zm-7.4-3.5c3.2 2.4 5 4.2 6.1 5.4-1.1 1.2-2.9 3-6.1 5.4-9 6.6-24 13.9-45.4 20.6-42.5 13.3-103.1 22-171.5 22s-129-8.7-171.5-22c-21.4-6.7-36.4-14-45.4-20.6-3.2-2.4-5-4.2-6.1-5.4 1.1-1.2 2.9-3 6.1-5.4 9-6.6 24-13.9 45.4-20.6C127 40.7 187.6 32 256 32s129 8.7 171.5 22c21.4 6.7 36.4 14 45.4 20.6zM31.7 78.1a.1.1 0 1 0 .2 0 .1.1 0 1 0-.2 0zm0 3.8a.1.1 0 1 0 .2 0 .1.1 0 1 0-.2 0zm448.5-.1a.2.2 0 1 0-.1.3.2.2 0 1 0 .1-.3zM512 80c0-44.2-114.6-80-256-80S0 35.8 0 80s114.6 80 256 80 256-35.8 256-80zM45.6 156.5C26.7 190.7 16 230.1 16 272c0 132.5 107.5 240 240 240s240-107.5 240-240c0-41.9-10.7-81.3-29.6-115.5-9.5 3.9-19.7 7.6-30.5 11C453.8 198.2 464 233.9 464 272c0 114.9-93.1 208-208 208S48 386.9 48 272c0-38.1 10.2-73.8 28.1-104.5-10.9-3.4-21.1-7.1-30.5-11zm110.9 94c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.9-11.6-24.7-21.5-43.5-21.5s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm-14.9 89.4c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6c-18 20.7-48.6 42.5-92 42.5s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm162-64c2.1-8.6 6.7-18.2 12.9-25.4 6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.9-11.6-24.7-21.5-43.5-21.5s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6z"
        }
    ]
};

const FalFaceSmileHearts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmileHearts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M422.7 21.4C391.3 7.7 356.5 0 320 0 178.6 0 64 114.6 64 256c0 11.1.7 22 2.1 32.7 10.4 1.4 20.5 4.6 30 9.7 1.2-.6 2.4-1.3 3.6-1.8-2.4-13.2-3.7-26.7-3.7-40.6C96 132.3 196.3 32 320 32c34.4 0 66.9 7.7 96 21.6.2-10.9 2.4-21.9 6.7-32.1zm111.8 169.9c6.2 20.5 9.5 42.2 9.5 64.7 0 24.2-3.8 47.6-11 69.4 3.8 1.4 7.4 3.1 11 5 7.4-4 15.3-6.8 23.4-8.5 5.6-21 8.6-43.1 8.6-65.9 0-23.6-3.2-46.4-9.1-68-10.4 3.8-21.5 4.9-32.3 3.3zM428.5 452c-32.1 17.8-69.1 28-108.5 28-46.7 0-90.1-14.3-126-38.7l-22.9 23C213 494.3 264.4 512 320 512c47.3 0 91.6-12.8 129.6-35.2l-8.3-8.3c-5-5.1-9.3-10.6-12.9-16.5zM275.2 233.6c5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c17.6-23.5 52.8-23.5 70.4 0zm-69.7 90.3c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 346.2 363.4 368 320 368s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm159.3-90.3c17.6-23.5 52.8-23.5 70.4 0 5.3 7.1 15.3 8.5 22.4 3.2s8.5-15.3 3.2-22.4c-30.4-40.5-91.2-40.5-121.6 0-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2zM486.7 38.7c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0L569 38.7c8.9-9 23.3-9 32.2 0 9 9 9 23.7 0 32.7l-55.4 55.8c-1 1-2.6 1-3.6 0l-55.5-55.8c-9-9-9-23.7 0-32.7zm54.9-22.6c-21.4-21.6-56.2-21.6-77.6 0-21.4 21.5-21.4 56.3 0 77.8l55.5 55.8c13.5 13.6 35.5 13.6 49 0L624 94c21.4-21.5 21.4-56.3 0-77.8-21.4-21.6-56.2-21.6-77.6 0l-2.4 2.4-2.4-2.4zm-448 320c-21.4-21.6-56.2-21.6-77.6 0-21.3 21.6-21.3 56.4 0 77.9l55.5 55.8c13.5 13.6 35.5 13.6 49 0L176 414c21.4-21.5 21.4-56.3 0-77.8-21.4-21.6-56.2-21.6-77.6 0l-2.4 2.4-2.4-2.4zm-54.9 22.6c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0 9 9 9 23.7 0 32.7l-55.3 55.8c-1 1-2.6 1-3.6 0l-55.6-55.8c-9-9-9-23.7 0-32.7zm448 32c8.9-9 23.3-9 32.2 0l13.7 13.8c6.3 6.3 16.4 6.3 22.7 0l13.7-13.8c8.9-9 23.3-9 32.2 0 9 9 9 23.7 0 32.7l-55.4 55.8c-1 1-2.6 1-3.6 0l-55.5-55.8c-9-9-9-23.7 0-32.7zm54.9-22.6c-21.4-21.6-56.2-21.6-77.6 0-21.4 21.5-21.4 56.3 0 77.8l55.5 55.8c13.5 13.6 35.5 13.6 49 0L624 446c21.4-21.5 21.4-56.3 0-77.8-21.4-21.6-56.2-21.6-77.6 0l-2.3 2.3-2.4-2.4z"
        }
    ]
};

const FalFaceSmileHorns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmileHorns",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480c141.4 0 256-114.6 256-256 0-24.6-3.5-48.4-9.9-70.9 44.3-59.4 67.4-135 73.6-166 1.3-6.3-1.4-12.8-6.8-16.4s-12.4-3.6-17.8 0c-19.3 12.9-48.5 24.2-78.4 33.1-23.3 7-46 12.2-63 15.5C430.9 19.1 377.7 0 320 0S209.1 19.1 166.2 51.3c-17-3.3-39.7-8.6-63-15.5-29.8-8.9-59-20.3-78.3-33.1-5.4-3.6-12.4-3.6-17.8 0S-1 12.8.3 19.1c6.2 31 29.3 106.6 73.6 166-6.4 22.5-9.9 46.3-9.9 70.9 0 141.4 114.6 256 256 256zm232.4-363.4c-12.2-26.4-28.8-50.4-48.8-71 13.1-3 27.6-6.8 42.3-11.2 17.7-5.3 36.2-11.7 53.2-19.1-9.2 28.9-24.6 66.9-46.6 101.3zM94.1 66.4c14.7 4.4 29.2 8.1 42.3 11.2-20 20.6-36.6 44.6-48.8 71-22.1-34.3-37.4-72.4-46.7-101.3 17 7.4 35.5 13.8 53.2 19.1zm111.4 281.5c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C394 370.2 363.4 392 320 392s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm34.9-51.9c13.3 0 24-10.7 24-24 0-2.6-.4-5.1-1.2-7.4l19.7 6.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-96-32c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l39.6 13.2c-6.2 4.3-10.2 11.5-10.2 19.6 0 13.3 10.7 24 24 24zm184-24c0-8.2-4.1-15.5-10.4-19.8l39.1-13c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-96 32c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l20.6-6.9c-.8 2.4-1.3 5-1.3 7.7 0 13.3 10.7 24 24 24s24-10.7 24-24z"
        }
    ]
};

const FalFaceSmilePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmilePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 16v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM416 288a192 192 0 1 0-384 0 192 192 0 1 0 384 0zM0 288a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm144.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-153.5 90.1c4.5 11.2 15.1 29.1 31.8 44 16.4 14.6 38.1 25.9 65.3 25.9s48.9-11.3 65.3-25.9c16.7-14.9 27.3-32.8 31.8-44 3.3-8.2 12.6-12.2 20.8-8.9s12.2 12.6 8.9 20.8c-6.2 15.4-19.5 37.5-40.2 56-20.8 18.6-49.8 34-86.6 34s-65.8-15.4-86.7-34.1c-20.7-18.5-34-40.6-40.2-56-3.3-8.2.7-17.5 8.9-20.8s17.5.7 20.8 8.9z"
        }
    ]
};

const FalFaceSmileRelaxed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmileRelaxed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
        }
    ]
};

const FalFaceSmileTear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmileTear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM141.5 323.9c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5 8.8 0 16-7.2 16-16s-7.2-16-16-16c-43.4 0-74-21.8-91.9-42.5-5.8-6.7-15.9-7.4-22.6-1.6zm194.3-1.5c5.1-7.7 10.7-15.1 16.2-22 5.5 6.9 11 14.3 16.2 22 11.4 17.1 15.8 29 15.8 34.9 0 12.2-11.7 26.7-32 26.7s-32-14.5-32-26.7c0-5.9 4.4-17.8 15.8-34.9zm7.7-62.3c-1.6 2-3.3 4.1-5.2 6.3-18.9 23-50.3 61.2-50.3 90.8 0 32.5 28.7 58.7 64 58.7s64-26.2 64-58.7c0-29.2-30.8-66.9-49.6-90-2.1-2.6-4.1-5-5.8-7.2-4.3-5.5-12.8-5.5-17.1 0zM200.4 208a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalFaceSmileTongue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmileTongue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 8.8 7.2 16 16 16s16-7.2 16-16C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c36.4 0 71-7.6 102.4-21.3 8.1-3.5 11.8-13 8.3-21.1s-13-11.8-21.1-8.3c-27.4 12-57.7 18.6-89.6 18.6C132.3 480 32 379.7 32 256zm124.5-61.5c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.9-11.6-24.7-21.5-43.5-21.5s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm160 0c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.9-11.6-24.7-21.5-43.5-21.5s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm-224.6 78c-8.5 2.3-13.6 11.1-11.3 19.6C102 372.3 171.9 432 256 432c31 0 60.1-8.1 85.5-22.4l45.3 29.6c36.8 24 86.2 12.2 108.2-25.8l1.4-2.4c21.4-37.1 9.8-84.4-26.3-107.5l-45.2-28.8c-1.4-1-3-1.7-4.8-2.2-8.5-2.3-17.3 2.8-19.6 11.3C382.5 351.5 324.1 400 256 400s-126.5-48.5-144.5-116.1c-2.3-8.5-11.1-13.6-19.6-11.3zm278 117.4c24.1-20.3 43.1-46.9 54.9-77.3l28.1 17.9c21.7 13.8 28.6 42.2 15.8 64.5l-1.4 2.4c-12.8 22.2-41.6 29-63 15l-34.4-22.5z"
        }
    ]
};

const FalFaceSmileUpsideDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmileUpsideDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256a224 224 0 1 1 448 0 224 224 0 1 1-448 0zm480 0a256 256 0 1 0-512 0 256 256 0 1 0 512 0zm-347.9-69.5C182 165.8 212.6 144 256 144s74 21.8 91.9 42.5c5.8 6.7 15.9 7.4 22.6 1.6s7.4-15.9 1.6-22.6c-22.3-25.6-61-53.5-116.1-53.5s-93.8 27.9-116.1 53.5c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6zM200.4 304a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm136-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"
        }
    ]
};

const FalFaceSmileWink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmileWink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm148.4 25.6c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"
        }
    ]
};

const FalFaceSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmile",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm164.1 69.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6c-22.3 25.6-61 53.5-116.1 53.5s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zM152.4 208a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFaceSmilingHands = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmilingHands",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M110.9 175.4C143.3 91.5 224.7 32 320 32s176.7 59.5 209.1 143.4c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C522 68 428.9 0 320 0S118 68 81.1 163.9c-3.2 8.2.9 17.5 9.2 20.7s17.5-.9 20.7-9.2zM290.1 478c-8.8-1.2-16.8 5-18 13.7s5 16.8 13.7 18c11.2 1.5 22.6 2.3 34.1 2.3s22.9-.8 34.1-2.3c8.8-1.2 14.9-9.2 13.7-18s-9.2-14.9-18-13.7c-9.8 1.3-19.7 2-29.9 2s-20.1-.7-29.9-2zm93.9-93.2v-86.4c0-11 9-20 20-20 9.1 0 16.8 6.1 19.2 14.5.2.8.4 1.7.6 2.5.1 1 .2 2 .2 3v19.7c0 7.1 8.6 10.7 13.7 5.7l5.7-5.7 10.4-10.4 2.3-2.3 9.4-9.4 51.3-51.3c5.6-5.6 14.3-6.2 20.5-1.8.7.5 1.4 1.1 2.1 1.8 6.2 6.2 6.2 16.4 0 22.6l-34 34-17.4 17.3c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 34-34 16-16c3.1-3.1 7.2-4.7 11.3-4.7s8.2 1.6 11.3 4.7 4.7 7.2 4.7 11.3-1.6 8.2-4.7 11.3l-16 16-34 34-17.3 17.3c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 34-34c6.2-6.2 16.4-6.2 22.6 0 .7.7 1.3 1.4 1.8 2.1 4.4 6.2 3.8 14.9-1.8 20.5l-5.1 5.1-26.9 26.9-2 2-17.3 17.3c-2.6 2.6-2.6 6.8 0 9.4s6.8 2.6 9.4 0l17.3-17.3 2-2c6.2-6.2 16.4-6.2 22.6 0 .7.7 1.3 1.4 1.8 2.1 4.4 6.2 3.8 14.9-1.8 20.5L584 414.6l-37.5 37.5C528.7 470 504.4 480 479.2 480c-52.6 0-95.2-42.6-95.2-95.2zM320 400c11.6 0 22.4-1.2 32.5-3.4 6 64.7 60.4 115.4 126.7 115.4 33.7 0 66.1-13.4 89.9-37.3l56.8-56.8c18.1-18.1 18.7-47.1 1.8-65.9 16.9-18.8 16.3-47.8-1.8-65.9-1-1-2.1-2-3.2-3 3.7-15.7-.5-32.8-12.8-45s-29.4-16.5-45-12.8c-.9-1.1-1.9-2.2-3-3.2-18.7-18.7-49.1-18.7-67.9 0l-47 47c-9.4-13.7-25.1-22.7-43-22.7-28.7 0-52 23.3-52 52v65.4c-9.8 2.7-20.4 4.2-32 4.2s-22.2-1.5-32-4.2v-65.4c0-28.7-23.3-52-52-52-17.9 0-33.6 9-43 22.7L145.9 222c-18.7-18.7-49.1-18.7-67.9 0-1 1-2 2.1-3 3.2-15.7-3.7-32.8.5-45 12.8s-16.5 29.4-12.8 45c-1.1.9-2.2 1.9-3.2 3-18.1 18.2-18.7 47.2-1.8 66-16.9 18.8-16.3 47.8 1.8 65.9l56.8 56.8C94.7 498.6 127 512 160.7 512c66.3 0 120.7-50.7 126.7-115.4 10.1 2.2 21 3.4 32.5 3.4zm-99.5-221.5c6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.9-11.6-24.7-21.5-43.5-21.5s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6c2.1-8.6 6.7-18.2 12.9-25.4zm147.1 25.4c2.1-8.6 6.7-18.2 12.9-25.4 6.2-7.1 12.8-10.5 19.5-10.5s13.4 3.4 19.5 10.5c6.2 7.2 10.8 16.8 12.9 25.4 2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4c-3.2-12.7-9.8-27.1-19.9-38.6-9.9-11.6-24.7-21.5-43.5-21.5s-33.6 9.9-43.7 21.5c-10 11.5-16.7 25.9-19.9 38.6-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6zm-266.9 63.4c-6.2-6.2-6.2-16.4 0-22.6.7-.7 1.4-1.3 2.1-1.8 6.2-4.4 14.9-3.8 20.5 1.8l51.3 51.3 9.4 9.4 2.3 2.3 10.4 10.4 5.7 5.7c5 5 13.7 1.5 13.7-5.7v-19.7c0-1 .1-2 .2-3 .1-.9.3-1.7.6-2.5 2.4-8.4 10.1-14.5 19.2-14.5 11 0 20 9 20 20v86.4c0 52.6-42.6 95.2-95.2 95.2-25.2 0-49.5-10-67.3-27.9L56 414.6l-19.3-19.3c-5.6-5.6-6.2-14.3-1.8-20.5.5-.7 1.1-1.4 1.8-2.1 6.2-6.2 16.4-6.2 22.6 0l2 2L78.6 392c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l-17.3-17.3-2-2-26.9-26.9-5.1-5.1c-5.6-5.6-6.2-14.3-1.8-20.5.5-.7 1.1-1.4 1.8-2.1 6.2-6.2 16.4-6.2 22.6 0l34 34 17.3 17.3c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l-17.3-17.3-34-34-16-16c-3.1-3.1-4.7-7.2-4.7-11.3s1.6-8.2 4.7-11.3S59.9 256 64 256s8.2 1.6 11.3 4.7l16 16 34 34 17.3 17.3c2.6 2.6 6.8 2.6 9.4 0s2.6-6.8 0-9.4l-17.3-17.3-34-34z"
        }
    ]
};

const FalFaceSmirking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSmirking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm375.8 82.6-.2 1.2c-5.8 34.7-35.8 60.2-71 60.2H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h112.6c19.6 0 36.2-14.1 39.5-33.4l.2-1.2c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalFaceSpiralEyes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSpiralEyes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm312.9 118.9 14.8-9.9c14.3-9.6 32.7-10.7 48.1-3l15.4 7.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-15.4-7.7c-5.1-2.6-11.3-2.2-16 1l-14.8 9.9c-16.1 10.7-37.1 10.7-53.3 0l-12.5-8.3c-5.4-3.6-12.4-3.6-17.8 0l-12.5 8.3c-16.1 10.7-37.1 10.7-53.3 0l-14.8-9.9c-4.8-3.2-10.9-3.6-16-1l-15.4 7.7c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l15.4-7.7c15.4-7.7 33.8-6.6 48.1 3l14.8 9.9c5.4 3.6 12.4 3.6 17.8 0l12.5-8.3c16.1-10.7 37.1-10.7 53.3 0l12.5 8.3c5.4 3.6 12.4 3.6 17.8 0zm-139-263.3c.3 6.6-4.9 12.2-11.5 12.5-46.9 1.9-82.2 45-78.1 84.3v.6c2 40.2 40.8 70.7 76.2 66.7h.6c36.3-2 62.1-35.7 58.4-64.5v-.6c-2.1-29.8-31.3-51-56-47.5h-.6c-25.7 2.2-42 26.2-38.9 44.5l.1.4v.4c2.1 19.5 21.5 31.3 35.5 28.6l.3-.1h.3c15.2-2.1 22-16.3 19.9-24l-.1-.4-.1-.4c-.9-4.3-3.4-7.4-6.5-9.2-.9-.5-1.8-.9-2.6-1.2 1.7 1.9 2.8 4.2 3 6.9 1 11.1-8.8 15.8-14.1 16.4-6.6.8-13.4-2.2-17.6-8.5-5-6.8-4.4-15.6-1.8-21.8 2.9-7 8.9-13.2 17.8-16 9.2-3.3 19.4-1.3 27.5 3.3 8.3 4.9 15.5 13.4 17.9 24.8 5.8 22.8-11.9 49.5-39.5 53.6-27.7 5.3-59.8-16.2-63.6-49.2-5.4-33 21.9-68.7 60.3-72.1 38.2-5.2 79.6 25.8 82.9 69.3 5.4 43.3-31.5 88.2-80.6 91.2-48.8 5.3-99.6-35.2-102.5-89.1-5.5-53.8 41.1-108.1 101-110.5 6.6-.3 12.2 4.9 12.5 11.5zM349.6 292c46.9-1.9 82.2-45 78.1-84.3v-.6c-2-40.2-40.8-70.7-76.2-66.7h-.6c-36.3 2-62.1 35.7-58.4 64.5v.6c2.1 29.8 31.3 51 56 47.5h.6c25.7-2.2 42-26.2 38.9-44.5l-.1-.4v-.4c-2.1-19.5-21.5-31.3-35.5-28.6l-.3.1h-.3c-15.2 2.1-21.9 16.3-19.9 24l.1.4.1.4c.9 4.3 3.4 7.4 6.5 9.2.9.5 1.8.9 2.6 1.2-1.7-1.9-2.8-4.2-3-6.9-1-11.1 8.8-15.8 14.1-16.4 6.6-.8 13.4 2.2 17.6 8.5 5 6.8 4.4 15.6 1.8 21.8-2.9 7-8.9 13.2-17.8 16-9.2 3.3-19.4 1.3-27.5-3.3-8.3-4.9-15.5-13.4-17.9-24.8-5.8-22.8 11.9-49.5 39.5-53.6 27.7-5.3 59.8 16.2 63.6 49.2 5.4 33-21.9 68.7-60.3 72.1-38.2 5.2-79.6-25.8-82.9-69.3-5.4-43.3 31.5-88.2 80.6-91.2 48.8-5.3 99.6 35.2 102.5 89.1 5.5 53.8-41.1 108.1-101 110.5-6.6.3-12.2-4.9-12.5-11.5s4.9-12.2 11.5-12.5z"
        }
    ]
};

const FalFaceSunglasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSunglasses",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480C132.3 480 32 379.7 32 256c0-16.4 1.8-32.5 5.1-47.9l4.4 26.4c5.1 30.9 31.8 53.5 63.1 53.5h78.7c31.3 0 58-22.6 63.1-53.5l8-48c.6-3.5.9-7.1.9-10.5h1.3c0 3.5.3 7 .9 10.5l8 48c5.1 30.9 31.8 53.5 63.1 53.5h78.7c31.3 0 58-22.6 63.1-53.5l4.4-26.4c3.4 15.4 5.1 31.5 5.1 47.9 0 123.7-100.3 224-224 224zm-9.2-336c-11-19-31.5-32-55.4-32H96.7c-4.6 0-9.1.5-13.4 1.4C124.3 63.7 186.5 32 256 32s131.7 31.7 172.8 81.4c-4.3-.9-8.8-1.4-13.4-1.4h-94.7c-24 0-44.5 13-55.4 32h-18.5zm9.2 368a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM141.5 339.9c-6.7 5.8-7.4 15.9-1.6 22.6 22.2 25.7 61 53.5 116.1 53.5s93.8-27.9 116.1-53.5c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6C330 362.2 299.4 384 256 384s-74-21.8-91.9-42.5c-5.8-6.7-15.9-7.4-22.6-1.6zm147.6-158.6c-3.3-19.5 11.8-37.3 31.6-37.3h40.7l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4L316 253.4c-9.7-4.2-17.1-13.1-18.9-24.1l-8-48zm69.5 74.7 52.7-52.7c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9h-25.4l32-32h8.7c19.8 0 34.8 17.8 31.6 37.3l-8 48c-2.6 15.4-15.9 26.7-31.6 26.7h-48.7zM96.7 144h40.7l-36.7 36.7c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h25.4L92 253.4c-9.7-4.2-17.1-13.1-18.9-24.1l-8-48C61.8 161.8 76.9 144 96.7 144zm90.7 59.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9h-25.5l32-32h8.7c19.8 0 34.8 17.8 31.6 37.3l-8 48c-2.6 15.4-15.9 26.7-31.6 26.7h-48.7l52.7-52.7z"
        }
    ]
};

const FalFaceSurprise = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSurprise",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"
        }
    ]
};

const FalFaceSwear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceSwear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M534.7 192C507.2 99.5 421.5 32 320 32S132.8 99.5 105.3 192H72.1C100.5 81.6 200.7 0 320 0s219.5 81.6 247.9 192h-33.2zm-270.3-16c0 13.3-10.7 24-24 24s-24-10.7-24-24c0-8.1 4-15.3 10.2-19.6L187 143.2c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1l96 32c8.4 2.8 12.9 11.9 10.1 20.2S291.3 178 283 175.2l-19.7-6.6c.8 2.3 1.2 4.8 1.2 7.4zm136 24c-13.3 0-24-10.7-24-24 0-2.7.4-5.3 1.3-7.7l-20.6 6.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l96-32c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-39.1 13c6.3 4.3 10.4 11.6 10.4 19.8 0 13.3-10.7 24-24 24zM32 288v160c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm-32 0c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v160c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V288zm400 64h-16v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-32h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h32v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-80 0v32h32v-32h-32zm250.4-52.1c6.7 5.8 7.5 15.9 1.7 22.6l-96 112c-5.8 6.7-15.8 7.5-22.6 1.7s-7.5-15.8-1.7-22.6l96-112c5.8-6.7 15.8-7.5 22.6-1.7zM448 320a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM208 288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm-24 136a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-56-120v1.8c4.6.8 8.7 1.7 12.1 2.6 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-7.9-2.1-18.5-3.9-26.8-2.9-4.1.5-6.3 1.4-7.4 2.2-.6.4-1.2.9-1.5 2.9-.2 1-.1 1.6-.1 1.8.1.1.5.6 1.5 1.3 3.7 2.5 9.6 4.4 19.2 7.3l.7.2c8 2.4 19.1 5.8 27.6 11.9 4.7 3.4 9.3 8.2 12.1 14.7 2.9 6.6 3.4 13.8 2.2 21.1-2 11.5-7.9 20.5-17 25.9-4.9 3-10.1 4.6-15.3 5.4v.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-3c-8.1-1.9-15.3-4.2-20.2-5.9-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c9.5 3.2 21.9 6.9 32 7.1 5 .1 7.6-.8 8.8-1.5.5-.3 1.4-.9 2-4 .2-1.2.2-1.9.2-2.3 0-.4-.1-.6-.1-.6 0-.1-.3-.6-1.6-1.6-3.5-2.5-9.3-4.6-18.7-7.4l-1.5-.4c-7.7-2.3-18.3-5.5-26.4-11-4.7-3.2-9.4-7.7-12.4-14.1-3.1-6.5-3.7-13.7-2.5-20.9 1.8-10.2 7-18.1 14.5-23.5 5.3-3.8 11.2-5.9 16.9-7V304c0-8.8 7.2-16 16-16s16 7.2 16 16zm-31.9 39.4v-.1.1z"
        }
    ]
};

const FalFaceThermometer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceThermometer",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32C164.3 32 64 132.3 64 256s100.3 224 224 224c95.3 0 176.7-59.5 209.1-143.4 3.2-8.2 12.4-12.4 20.7-9.2s12.4 12.4 9.2 20.7C490 444 396.9 512 288 512 146.6 512 32 397.4 32 256S146.6 0 288 0c83.8 0 158.1 40.2 204.8 102.4 5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2C426.3 67.2 361.3 32 288 32zm114.5 364.1c-6.7 5.8-16.8 5.1-22.6-1.6C362 373.8 331.4 352 288 352s-74 21.8-91.9 42.5c-5.8 6.7-15.9 7.4-22.6 1.6s-7.4-15.9-1.6-22.6c22.2-25.7 61-53.5 116.1-53.5 13.5 0 26 1.7 37.5 4.6L477 179.4c19.6-18.8 50.6-18.4 69.8.7 19.8 19.8 19.4 52.1-.9 71.4L408 382.9c.3 4.8-1.5 9.8-5.5 13.2zm-43.9-58.9c11.3 5.9 21.1 13 29.6 20.3l8.4-8-5.1-5.1c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l5.5 5.6 15.4-14.7-5.8-5.8c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l6.3 6.3 15.4-14.7-6.6-6.6c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7 7 15.4-14.7-7.4-7.4c-4.7-4.7-4.7-12.3 0-17s12.3-4.7 17 0l7.8 7.8 11.5-11c7.3-6.9 7.4-18.5.3-25.6-6.9-6.9-18-7-25-.3L358.5 337.2zM208.4 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalFaceThinking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceThinking",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 108.4-76.9 198.8-179.2 219.5-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5C424 483.2 512 379.9 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 23.6 3.2 46.5 9.2 68.3 2.4 8.5 11.2 13.5 19.7 11.2s13.5-11.2 11.2-19.7c-5.2-19-8.1-39-8.1-59.7zm165.1.8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l70.5 23.5-97.5 38.2V320c0-26.5-21.5-48-48-48s-48 21.5-48 48v120c0 39.8 32.2 72 72 72h47.8c29.4 0 55.9-17.9 66.9-45.3l23.9-59.6 47-18.4c20.9-8.2 32.8-29.4 30.1-50.7-2.3-18.7-15.1-34.7-33.3-40.8l-121.3-40.4zM320 342.7v1.3c0 6.4-3.9 12.4-10.2 14.9l-53.5 20.9c-4.3 1.7-7.7 5.2-9.2 9.5-.1.2-.1.4-.2.6l-26 64.9c-6.1 15.2-20.8 25.2-37.1 25.2H136c-22.1 0-40-17.9-40-40V320c0-8.8 7.2-16 16-16s16 7.2 16 16v52.2c0 5.3 2.6 10.2 7 13.2s9.9 3.6 14.9 1.7l148.3-58c8.2-3.2 17.5.8 20.7 9.1.6 1.5.9 3 1.1 4.5zM200.4 192a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm136 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-120-87.2 13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3c-30.9-26.4-75-30.5-110.2-10.4l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4c23.5-13.4 52.9-10.6 73.4 7z"
        }
    ]
};

const FalFaceTired = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceTired",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 94c24.2 0 48.2 3.4 71.4 10-3.5-5.1-7.7-10.3-12.6-15.2-15.5-15.5-36.2-26.8-58.7-26.8s-43.2 11.3-58.7 26.8c-4.9 4.9-9.2 10.1-12.6 15.2 23.2-6.7 47.2-10 71.4-10zm0-64c33.5 0 61.8 16.7 81.3 36.2 9.8 9.8 17.8 20.8 23.4 31.5 5.5 10.4 9.3 21.8 9.3 32.4 0 5.2-2.5 10.1-6.8 13.1s-9.7 3.7-14.6 2l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2l-16.5 5.8c-4.9 1.8-10.3 1-14.6-2s-6.8-7.9-6.8-13.1c0-10.6 3.8-21.9 9.3-32.4 5.6-10.7 13.6-21.6 23.4-31.5 19.5-19.5 47.9-36.2 81.3-36.2zM129.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l35.4-17.5-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5z"
        }
    ]
};

const FalFaceTissue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceTissue",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32C132.3 32 32 132.3 32 256c0 8.8-7.2 16-16 16s-16-7.2-16-16C0 114.6 114.6 0 256 0s256 114.6 256 256-114.6 256-256 256c-8.8 0-16-7.2-16-16s7.2-16 16-16c123.7 0 224-100.3 224-224S379.7 32 256 32zm39.1 306.7c5.4-3.6 12.4-3.6 17.8 0l40.3 26.8 23.7-11.8c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-32 16c-5.1 2.6-11.3 2.2-16-1L304 371.2l-39.1 26.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l48-32zM136.5 190.3c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l35.4-17.5-35.4-17.7zm246.2-21.5c4 7.9.7 17.5-7.2 21.5L340.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2zM223.8 306.6l-32 192c-1.1 6.7-6.3 11.9-13 13.1s-13.4-1.9-16.7-7.8l-26-45.5-84.2 21.1c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l21.1-84.2-45.5-26c-5.9-3.4-9-10-7.8-16.7s6.4-11.9 13.1-13l192-32c5.1-.8 10.3.8 13.9 4.5s5.3 8.8 4.5 13.9zM79.9 354.1c6.2 3.6 9.3 10.8 7.6 17.8L70 442l70.1-17.5c7-1.7 14.2 1.4 17.8 7.6l9.7 17 20.9-125.6-125.6 20.9 17 9.7z"
        }
    ]
};

const FalFaceTongueMoney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceTongueMoney",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6 7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm96 32c-17.1 0-33.2 14.3-31 33.7 4.8 43.9 27.4 82.4 60.3 108.2l4.3 3.4C169.7 478 208.9 512 256 512s86.3-34 94.5-78.7l4.3-3.4c32.9-25.8 55.4-64.3 60.3-108.2 2.1-19.4-13.9-33.7-31-33.7H128zm160 32h32v96c0 35.3-28.7 64-64 64s-64-28.7-64-64v-96h96zm-159 0h31v68.7c-16.6-18.8-27.8-42.5-31-68.7zm254 0c-3.3 26.1-14.4 49.9-31 68.7V320h31zM192 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1-7.5 5.4-12.6 13.5-14.4 23.6-1.3 7.3-.7 14.5 2.2 21.2 2.9 6.6 7.6 11.3 12.4 14.6 8.4 5.8 19.3 9 27.2 11.2l1.1.3c9.6 2.7 15.4 4.6 18.8 7 2.6 1.8 2.2 6.4-.6 8-1.2.7-3.8 1.6-8.8 1.5-10.1-.2-22.5-3.9-32-7.1-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6v11c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2 9.1-5.5 15-14.4 17-25.9 1.3-7.3.7-14.5-2.2-21.2-2.9-6.6-7.6-11.3-12.4-14.6-7.1-5-15.5-7.2-23.9-9.4-8.2-2.2-16.4-4.3-23.3-9.1-2.4-1.7-2.4-5.3.2-7.2 1-.7 3.1-1.7 7.1-2.1 8.2-.9 18.7 1 27 3.2 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7v-10zm144-16c-8.8 0-16 7.2-16 16v9.3c-5.7 1.2-11.6 3.3-17 7.1-7.5 5.4-12.6 13.5-14.4 23.6-1.3 7.3-.7 14.5 2.2 21.2 2.9 6.6 7.6 11.3 12.4 14.6 8.4 5.8 19.4 9 27.2 11.2l1.1.3c9.5 2.7 15.4 4.6 18.8 7 2.6 1.8 2.2 6.4-.6 8-1.2.7-3.8 1.6-8.8 1.5-10.1-.2-22.5-3.9-32-7.1-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c5.1 1.7 12.6 4.2 21.1 6v11c0 8.8 7.2 16 16 16s16-7.2 16-16v-8.9c4.8-.9 9.8-2.5 14.4-5.2 9.1-5.5 15-14.4 17-25.9 1.3-7.3.7-14.5-2.2-21.2-2.9-6.6-7.6-11.3-12.4-14.6-7.1-5-15.5-7.2-23.9-9.4-8.2-2.2-16.4-4.3-23.3-9.1-2.4-1.7-2.4-5.3.2-7.2 1-.7 3.1-1.7 7.1-2.1 8.2-.9 18.7 1 27 3.2 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-3.4-.9-7.5-1.9-12.1-2.7v-10c0-8.8-7.2-16-16-16zm-68.8 259.6c0-6.4-5.4-11.6-12-11.6s-12 5.2-12 11.6v6.8c-4.3.8-8.7 2.4-12.7 5.2-5.6 4-9.5 9.8-10.8 17.2-.9 5.3-.5 10.6 1.7 15.4 2.2 4.8 5.7 8.2 9.3 10.6 6.3 4.2 14.5 6.5 20.4 8.1l.8.2c7.2 2 11.5 3.3 14.1 5.1 1.9 1.3 1.6 4.6-.4 5.8-.9.5-2.8 1.1-6.6 1.1-7.6-.1-16.9-2.9-24-5.2-6.3-2-13.1 1.3-15.2 7.4s1.3 12.7 7.6 14.7c3.8 1.2 9.5 3 15.8 4.4v7.8c0 6.4 5.4 11.6 12 11.6s12-5.2 12-11.6v-6.5c3.6-.6 7.3-1.8 10.8-3.8 6.8-4 11.2-10.5 12.7-18.9.9-5.3.5-10.6-1.7-15.4-2.2-4.8-5.7-8.2-9.3-10.6-5.4-3.6-11.7-5.2-17.9-6.8-6.2-1.6-12.3-3.2-17.5-6.6-1.8-1.2-1.8-3.9.2-5.2.7-.5 2.3-1.2 5.3-1.5 6.1-.6 14 .7 20.2 2.3 6.4 1.7 13-2 14.7-8.3s-2.1-12.6-8.5-14.2c-2.5-.7-5.7-1.4-9.1-2v-7.2z"
        }
    ]
};

const FalFaceTongueSweat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceTongueSweat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32C174.4 32 80.6 116.5 66 226.1c-1.2 8.8-9.2 14.9-18 13.7s-14.9-9.2-13.7-18C50.9 96.6 158.2 0 288 0c141.4 0 256 114.6 256 256 0 83.8-40.2 158.1-102.4 204.8-42.8 32.1-96 51.2-153.6 51.2s-110.8-19.1-153.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4s15.3-8.5 22.4-3.2c15.6 11.8 32.9 21.5 51.3 28.9a94.9 94.9 0 0 1-12.9-47.3c-10.2-7.2-16-15.7-16-24.7 0-26.5 50.1-48 112-48s112 21.5 112 48c0 9-5.8 17.5-16 24.7a94.9 94.9 0 0 1-12.9 47.3c18.4-7.4 35.7-17.1 51.3-28.9C476.8 394.3 512 329.3 512 256c0-123.7-100.3-224-224-224zM64 317.5c-5.3 7.2-10.8 15.1-15.8 23-5.4 8.5-9.8 16.4-12.8 23.1-2.6 5.8-3.2 8.8-3.4 9.5v.1c0 12.3 11.7 26.8 32 26.8s32-14.5 32-26.7v-.1c-.1-.7-.8-3.7-3.4-9.6-3-6.7-7.4-14.5-12.8-23.1-5-7.9-10.5-15.8-15.8-23zm-8.6-41.4c4.3-5.5 12.8-5.5 17.1 0 17.6 21.7 55.5 72.2 55.5 97.2 0 32.5-28.7 58.7-64 58.7S0 405.8 0 373.3c0-25 38.1-75.5 55.5-97.2zM367.6 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-136 24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-20.3-100.7-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm153.4-22.6c6.2-6.2 16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4c-6.2-6.2-6.2-16.4 0-22.6zM224 417.6c0 34.5 27.9 62.4 62.4 62.4h3.2c34.5 0 62.4-27.9 62.4-62.4V403c0-14.9-12.1-27-27-27h-2.5c-10.9 0-20.4 7.4-23 18-3 12-20 12-23 0-2.6-10.6-12.1-18-23-18H251c-14.9 0-27 12.1-27 27v14.6z"
        }
    ]
};

const FalFaceUnamused = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceUnamused",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm316.1 138.7c-11.7-13-31.6-26.7-60.1-26.7s-48.4 13.7-60.1 26.7c-5.9 6.6-16 7.1-22.6 1.2s-7.1-16-1.2-22.6c16.1-17.9 44.2-37.3 83.9-37.3s67.8 19.4 83.9 37.3c5.9 6.6 5.4 16.7-1.2 22.6s-16.7 5.4-22.6-1.2zM112 192h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h64c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalFaceViewfinder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceViewfinder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0C21.5 0 0 21.5 0 48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm416 0h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-26.5-21.5-48-48-48zM0 464c0 26.5 21.5 48 48 48h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zm464 48c26.5 0 48-21.5 48-48v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96zM240 216a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40-112a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm-41.6-136c-4.4-7.6-14.2-10.3-21.9-5.8s-10.3 14.2-5.8 21.9c13.8 23.9 39.7 40 69.3 40s55.5-16.1 69.3-40c4.4-7.6 1.8-17.4-5.8-21.9s-17.4-1.8-21.9 5.8c-8.3 14.4-23.8 24-41.6 24s-33.3-9.6-41.6-24z"
        }
    ]
};

const FalFaceVomit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceVomit",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32C164.3 32 64 132.3 64 256c0 57.4 21.6 109.7 57 149.3 5.9 6.6 5.3 16.7-1.3 22.6s-16.7 5.3-22.6-1.3C56.7 381.4 32 321.6 32 256 32 114.6 146.6 0 288 0s256 114.6 256 256c0 65.6-24.7 125.4-65.2 170.7-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c35.5-39.6 57-91.9 57-149.3C512 132.3 411.7 32 288 32zM161.3 168.8c4-7.9 13.6-11.1 21.5-7.2l64 32c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l35.4-17.5-35.4-17.7c-7.9-4-11.1-13.6-7.2-21.5zm246.2 21.5L372.2 208l35.4 17.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-5.4-2.7-8.8-8.3-8.8-14.3s3.4-11.6 8.8-14.3l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 488a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm520-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-248-64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm92.5-47.6c8.6-1.9 17.2 3.5 19.1 12.1l6.1 27.4c5.2 23.5 20.8 43.4 42.3 54.2l39.1 19.6c6.6 3.3 10.1 10.8 8.4 18s-8.2 12.3-15.6 12.3H112c-7.4 0-13.9-5.1-15.6-12.3s1.8-14.7 8.4-18l39.2-19.6c21.5-10.8 37.1-30.7 42.3-54.2l6.1-27.4c1.9-8.6 10.5-14.1 19.1-12.1s14.1 10.5 12.1 19.1l-6.1 27.4c-5.8 26.2-20.8 49.2-41.9 65.1h224.8c-21.1-15.9-36.1-38.9-41.9-65.1l-6.1-27.4c-1.9-8.6 3.5-17.2 12.1-19.1zm-189.1 4c-2.4 8.5-11.3 13.4-19.8 11s-13.4-11.3-11-19.8c5.6-19.8 24.1-38.7 48-52.1C217.3 297.6 250 288 288 288s70.7 9.6 95.4 23.5c24 13.5 42.4 32.3 48 52.1 2.4 8.5-2.5 17.3-11 19.8s-17.3-2.5-19.8-11c-2.4-8.3-12.6-21.5-32.9-33-19.7-11.1-47-19.4-79.7-19.4s-60 8.3-79.7 19.4c-20.4 11.5-30.6 24.7-32.9 33z"
        }
    ]
};

const FalFaceWeary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceWeary",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm256 94c24.2 0 48.2 3.4 71.4 10-3.5-5.1-7.7-10.3-12.6-15.2-15.5-15.5-36.2-26.8-58.7-26.8s-43.2 11.3-58.7 26.8c-4.9 4.9-9.2 10.1-12.6 15.2 23.2-6.7 47.2-10 71.4-10zm0-64c33.5 0 61.8 16.7 81.3 36.2 9.8 9.8 17.8 20.8 23.4 31.5 5.5 10.4 9.3 21.8 9.3 32.4 0 5.2-2.5 10.1-6.8 13.1s-9.7 3.7-14.6 2l-16.5-5.9C307.7 386.4 282 382 256 382s-51.8 4.5-76.2 13.2l-16.5 5.8c-4.9 1.8-10.3 1-14.6-2s-6.8-7.9-6.8-13.1c0-10.6 3.8-21.9 9.3-32.4 5.6-10.7 13.6-21.6 23.4-31.5 19.5-19.5 47.9-36.2 81.3-36.2zm-44.7-121.3c6.2 6.2 6.2 16.4 0 22.6l-7.4 7.4a159.96 159.96 0 0 1-86.8 44.7l-2.5.4c-8.7 1.5-17-4.4-18.4-13.2s4.4-17 13.2-18.4l2.5-.4c26.3-4.4 50.6-16.9 69.5-35.7l7.4-7.4c6.2-6.2 16.4-6.2 22.6 0zm89.4 22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l7.4 7.4c18.9 18.9 43.2 31.4 69.5 35.7l2.5.4c8.7 1.5 14.6 9.7 13.2 18.4s-9.7 14.6-18.4 13.2l-2.5-.4c-32.9-5.5-63.3-21.1-86.8-44.7l-7.4-7.4z"
        }
    ]
};

const FalFaceWoozy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceWoozy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm205.3-135.1c-28 42-69.6 64.1-88.3 70.3-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2c13.4-4.5 48.5-22.9 71.7-57.7 4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2zm6.6 118.6-64 16c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l64-16c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4zm199.4 107.8L372 386.6a73.114 73.114 0 0 1-51.7 21.4c-13.7 0-27.1-3.8-38.7-11.1l-14.2-8.9a67.216 67.216 0 0 0-60.7-5.4c-30.4 12.2-64.8 8.6-92-9.6l-11.5-7.7c-7.4-4.9-9.3-14.8-4.4-22.2s14.8-9.3 22.2-4.4l11.5 7.7a67.53 67.53 0 0 0 62.4 6.5c29.4-11.8 62.7-8.8 89.6 8l14.2 8.9c6.5 4.1 14.1 6.2 21.8 6.2 10.9 0 21.3-4.3 29-12l39.3-39.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-83.6-177.4c-4.5 8.9-7.7 22.4-7.7 38.1s3.2 29.2 7.7 38.1c2.2 4.5 4.5 7.2 6.2 8.7.8.7 1.4 1 1.7 1.1.2.1.3.1.3.1h.2s.1 0 .3-.1c.3-.1.9-.4 1.7-1.1 1.7-1.5 4-4.2 6.2-8.7 4.5-8.9 7.7-22.4 7.7-38.1s-3.2-29.2-7.7-38.1c-2.2-4.5-4.5-7.2-6.2-8.7-.8-.7-1.4-1-1.7-1.1-.2-.1-.3-.1-.3-.1s-.1 0-.3.1c-.3.1-.9.4-1.7 1.1-1.7 1.5-4 4.2-6.2 8.7zm-28.6-14.3c6.6-13.3 18.8-27.6 36.9-27.6s30.3 14.3 36.9 27.6C380 169.8 384 188.4 384 208s-3.9 38.2-11.1 52.4c-6.6 13.3-18.7 27.6-36.9 27.6s-30.3-14.3-36.9-27.6c-7.2-14.2-11.1-32.8-11.1-52.4s3.9-38.2 11.1-52.4z"
        }
    ]
};

const FalFaceWorried = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceWorried",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm308.9 173.8c-16.2-6.1-34-9.4-52.9-9.4-18.8 0-36.7 3.4-52.9 9.4-11.2 4.2-23.6 2.3-32.4-4.5-4.5-3.5-8.4-8.6-10-15.1-1.6-6.7-.5-13.5 2.7-19.5C180.9 358 215.9 336 256 336c40.1 0 75.2 22.1 92.5 54.7 3.2 6 4.3 12.8 2.7 19.5-1.6 6.5-5.5 11.6-10 15.1-8.8 6.8-21.2 8.7-32.4 4.5zM256 368c-24.9 0-46.7 12.1-59.6 30.2 18.5-6.4 38.6-9.8 59.6-9.8s41.1 3.5 59.6 9.9C302.7 380 280.9 368 256 368zm-103.6-96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm184-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM192 160c-4.4 0-8.8.3-13 .9-21.2 2.8-40.6 12.4-56.1 26.8-6.5 6-16.6 5.7-22.6-.8s-5.7-16.6.8-22.6c20.1-18.7 45.5-31.5 73.7-35.2 5.6-.7 11.4-1.1 17.2-1.1 8.8 0 16 7.2 16 16s-7.2 16-16 16zm141 .9c-4.3-.6-8.6-.9-13-.9-8.8 0-16-7.2-16-16s7.2-16 16-16c5.8 0 11.6.4 17.2 1.1 28.2 3.7 53.7 16.4 73.7 35.2 6.5 6 6.8 16.2.8 22.6s-16.2 6.8-22.6.8c-15.5-14.5-34.8-24-56.1-26.8z"
        }
    ]
};

const FalFaceZany = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceZany",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 79.8-41.7 149.8-104.5 189.5-7.5 4.7-9.7 14.6-5 22.1s14.6 9.7 22.1 5C464.3 427.3 512 347.2 512 256 512 114.6 397.4 0 256 0S0 114.6 0 256c0 91.2 47.7 171.3 119.5 216.6 7.5 4.7 17.4 2.5 22.1-5s2.5-17.4-5-22.1C73.7 405.8 32 335.8 32 256zm272-64c-26.5 0-48-21.5-48-48 0-3.9.5-7.7 1.4-11.4C261 143.9 271.5 152 284 152c15.5 0 28-12.5 28-28 0-12.5-8.1-23-19.4-26.6 3.6-.9 7.5-1.4 11.4-1.4 26.5 0 48 21.5 48 48s-21.5 48-48 48zm0 32a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm-160-40a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm24-72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-4.5 166.7c-2.3 6.2-3.5 12.9-3.5 19.9v5.4c0 53 43 96 96 96s96-43 96-96v-5.4c0-2.3-.1-4.6-.4-6.9 57.3-37.6 82-108 64.4-173.2-3.7-13.7-19.6-18.7-31.8-11.6L159.8 348.5c-12.3 7.1-15.8 23.4-5.8 33.4 3.1 3.1 6.2 6 9.5 8.8zm175.4-17c-10.8-13.2-27.1-21.6-45.5-21.6h-2c-13.3 0-25.6 4.6-35.4 12.5-9.7-7.9-22.1-12.5-35.4-12.5h-2.9l170.5-98.4c6.9 46-11.6 92.6-49.3 120.1zM291.4 384h2c14.7 0 26.6 11.9 26.6 26.6v5.4c0 35.3-28.7 64-64 64s-64-28.7-64-64v-5.4c0-14.7 11.9-26.6 26.6-26.6h2c6.7 0 12.8 2.7 17.2 7.2l.2.3c1.6 1.7 3 3.6 4.1 5.8.9 1.8 1.6 3.7 2 5.7 2.8 12.6 20.8 12.6 23.6 0 .4-2 1.1-3.9 2-5.7 1.1-2.1 2.5-4.1 4.1-5.8l.2-.3c4.4-4.5 10.6-7.2 17.2-7.2z"
        }
    ]
};

const FalFaceZipper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaceZipper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 10.1-.7 20.1-2 29.9-1.2 8.8 5 16.8 13.7 18s16.8-5 18-13.7c1.5-11.2 2.3-22.6 2.3-34.1C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c32.4 0 63.5-6 92.1-17.1 8.2-3.2 12.4-12.4 9.2-20.7s-12.4-12.4-20.7-9.2c-25 9.6-52.1 14.9-80.6 14.9C132.3 480 32 379.7 32 256zm192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32zm48-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32zm40.4-128a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm136 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm34.7 84.7-22.5 22.5c-9.6 9.6-12.1 24.1-6.3 36.3l29.2 61.8c21.7 45.9 82.3 56.4 118.2 20.5s25.4-96.5-20.5-118.2l-61.8-29.2c-12.2-5.8-26.7-3.2-36.3 6.3zm84.4 51.8c25.9 12.2 31.8 46.4 11.6 66.6s-54.4 14.3-66.6-11.6l-29.2-61.8 22.5-22.5 61.8 29.2zm1 40c4.7-4.7 4.7-12.3 0-17s-12.3-4.7-17 0l-16 16c-4.7 4.7-4.7 12.3 0 17s12.3 4.7 17 0l16-16z"
        }
    ]
};

const FalFalafel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFalafel",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160.4 177.7c-11.7-15.9-11.2-38 1.5-53.4 2.3-2.7 3.1-6.5 2.2-10.1-5.1-20.1 4.7-41.3 23.7-50 3.1-1.4 5.4-4.3 6.1-7.9C198 35.9 216 21 237 21.6c3.3.1 6.5-1.4 8.6-4.3C258 .5 280.7-4.9 299.3 4.9c3 1.6 6.5 1.6 9.4 0 18.6-9.8 41.3-4.4 53.7 12.4 2.1 2.9 5.3 4.4 8.6 4.3 21-.6 39 14.3 42.9 34.7.7 3.6 3.1 6.5 6.1 7.9 19 8.7 28.8 29.9 23.7 50-.9 3.6 0 7.4 2.2 10.1 13.2 16 13.2 39.3 0 55.3-2.3 2.7-3.1 6.5-2.2 10.1.2 1 .5 2 .6 3-4.2.6-8.4 1.6-12.5 3-6.6-2.2-13.4-3.4-20.2-3.7-1.4-11.7 2-23.6 9.6-32.8 3.5-4.2 3.5-10.4 0-14.5-8.8-10.7-12-25-8.6-38.4 1.4-5.5-1.4-10.9-6-13-12.6-5.8-21.6-17.4-24.2-30.9-1.1-5.5-5.7-9-10.6-8.9-13.9.4-27-6.1-35.3-17.3-3.1-4.3-8.6-5.4-13-3.1-12.3 6.5-27 6.5-39.3 0-4.4-2.3-9.9-1.2-13 3.1C263.1 47.5 250 54 236 53.6c-4.9-.1-9.5 3.4-10.6 8.9-2.6 13.6-11.6 25.2-24.2 30.9-4.6 2.1-7.4 7.5-6 13 3.4 13.4.2 27.7-8.6 38.4-3.5 4.2-3.5 10.4 0 14.5 4.7 5.6 7.8 12.3 9.1 19.3-11.4-3.1-23.5-3.5-35.3-.9zM240 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm27.2 182.2c-.5-3.7-2.8-7.1-6.5-8.8-12.8-5.7-22-17.2-24.7-30.9-1.1-5.3-5.8-9.1-11.3-8.9-14 .4-27.3-6-35.7-17.1-3.3-4.3-9.2-5.7-14.1-3.2-12.4 6.4-27.2 6.4-39.6 0-4.9-2.5-10.8-1.1-14.1 3.2-8.4 11.2-21.7 17.5-35.7 17.1-5.5-.2-10.2 3.7-11.3 8.9-2.7 13.7-12 25.2-24.7 30.9-5 2.2-7.6 7.7-6.2 12.9 3.5 13.5.2 27.9-8.8 38.6-3.5 4.1-3.5 10.1 0 14.3 9 10.7 12.3 25 8.8 38.6-1.3 5.2 1.3 10.6 6.2 12.9 12.8 5.7 22 17.2 24.7 30.9 1.1 5.3 5.8 9.1 11.3 8.9 14-.4 27.3 6 35.7 17.1 3.3 4.3 9.2 5.7 14.1 3.2 12.4-6.4 27.2-6.4 39.6 0 4.9 2.5 10.8 1.1 14.1-3.2 8.4-11.1 21.7-17.5 35.7-17.1 5.5.2 10.2-3.7 11.3-8.9 2.7-13.7 12-25.2 24.7-30.9 2.5-1.1 4.4-3 5.5-5.3-.1 12 2.8 23.7 8.2 34.2l-.7.3c-3.3 1.5-5.7 4.4-6.4 8-4.1 20.6-22.5 35.2-43.5 34.6-3.6-.1-7.1 1.6-9.2 4.4-12.7 16.8-35.6 22-54.3 12.4-3.2-1.7-7.1-1.7-10.3 0-18.7 9.6-41.6 4.4-54.3-12.4-2.2-2.9-5.6-4.5-9.2-4.4-21 .6-39.4-14-43.5-34.6-.7-3.5-3.1-6.5-6.4-8-19.2-8.6-29.4-29.7-24.2-50.1.9-3.5.1-7.1-2.3-9.9-13.6-16.1-13.6-39.6 0-55.6 2.3-2.7 3.2-6.4 2.3-9.9-5.3-20.4 5-41.5 24.2-50.1 3.3-1.5 5.7-4.4 6.4-8 4.1-20.6 22.5-35.2 43.5-34.6 3.6.1 7.1-1.6 9.2-4.4 12.7-16.8 35.6-22 54.3-12.4 3.2 1.7 7.1 1.7 10.3 0 18.7-9.6 41.6-4.4 54.3 12.4 2.2 2.9 5.6 4.5 9.2 4.4 21-.6 39.4 14 43.5 34.6.7 3.5 3.1 6.5 6.4 8 2.9 1.3 5.6 2.9 8.1 4.7-7.6 9.7-12.6 21.2-14.6 33.3zM64 368a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm16-48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm224 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm48 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm13.1-159c-3.7-2-8.4-1-11.1 2.7-7.9 10.8-20.6 17-34 16.6-4.1-.1-8.1 2.8-9 7.6-2.5 13.1-11.2 24.2-23.3 29.8-3.9 1.8-6.3 6.4-5.1 11.2 3.3 12.9.2 26.7-8.3 36.9-3 3.6-3 8.9 0 12.5 8.5 10.3 11.5 24 8.3 36.9-1.2 4.7 1.2 9.4 5.1 11.2 12.2 5.6 20.8 16.7 23.3 29.8.9 4.7 4.9 7.7 9 7.6 13.4-.4 26.1 5.9 34 16.6 2.7 3.6 7.4 4.6 11.1 2.7 11.9-6.3 26-6.3 37.8 0 3.7 2 8.4 1 11.1-2.7 7.9-10.8 20.6-17 34-16.6 4.1.1 8.1-2.8 9-7.6 2.5-13.1 11.2-24.2 23.3-29.8 3.9-1.8 6.3-6.4 5.1-11.2-2.5-9.7-1.3-19.9 3-28.8-25.6-4.9-53-20.9-75.5-43.4-24.1-24.1-40.5-53.5-44.2-80.3-1.3-.5-2.5-1.1-3.7-1.7zm14.9-28.3c1.3.7 2.6 1 4 1 4.3 0 8.5 1.7 11.5 4.8s4.6 7.3 4.5 11.6c-.5 18.2 11 45.6 35.6 70.2 26.8 26.8 56.4 37.7 74.2 35.3 4.5-.6 9.1.7 12.6 3.7s5.5 7.3 5.6 11.9c.2 9.7-3 19.5-9.6 27.4-1.9 2.3-2.7 5.6-1.9 8.7 4.9 19.4-4.5 39.7-22.8 48.1-2.6 1.2-4.6 3.7-5.2 6.8-3.8 19.6-21.1 34-41.4 33.4-2.8-.1-5.5 1.2-7.3 3.7-12 16.2-33.8 21.4-51.8 12-2.5-1.3-5.5-1.3-8 0-17.9 9.4-39.8 4.2-51.8-12-1.8-2.4-4.6-3.7-7.3-3.7-20.2.6-37.5-13.8-41.4-33.4-.6-3.1-2.6-5.6-5.2-6.8-18.3-8.4-27.7-28.8-22.8-48.1.8-3.1 0-6.3-1.9-8.7-12.8-15.4-12.8-37.9 0-53.3 1.9-2.3 2.7-5.6 1.9-8.7-4.9-19.4 4.5-39.7 22.8-48.1 2.6-1.2 4.6-3.7 5.2-6.8 3.8-19.6 21.1-34 41.4-33.4 2.8.1 5.5-1.2 7.3-3.7 12-16.2 33.8-21.4 51.8-12z"
        }
    ]
};

const FalFamilyDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFamilyDress",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-15.7 64h31.4c11.5 0 21.8 6.1 27.5 15.6-2.1-7.5-3.2-15.4-3.2-23.6 0-6.3.7-12.5 1.9-18.4-8.1-3.6-16.9-5.6-26.2-5.6h-31.4c-28.6 0-53.7 18.9-61.5 46.4L11.7 343.2C5.8 363.7 21.2 384 42.4 384H64v112c0 8.8 7.2 16 16 16s16-7.2 16-16V384h49.6c-1-5.2-1.6-10.5-1.6-16v-16H42.4l39.1-136.8C85.4 201.5 98 192 112.3 192zm254.1 192H416v112c0 8.8 7.2 16 16 16s16-7.2 16-16V384h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4h-31.5c-9.3 0-18.1 2-26.2 5.6 1.3 5.9 1.9 12.1 1.9 18.4 0 8.2-1.1 16.1-3.2 23.6 5.7-9.5 16-15.6 27.5-15.6h31.4c14.3 0 26.8 9.5 30.8 23.2L469.6 352H368v16c0 5.5-.6 10.8-1.6 16zM384 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-128 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c26.5 0 48 21.5 48 48v32c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-32c0-26.5 21.5-48 48-48zm-48 125.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h32v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-82.7c18.6-6.6 32-24.4 32-45.3v-32c0-44.2-35.8-80-80-80s-80 35.8-80 80v32c0 20.9 13.4 38.7 32 45.3z"
        }
    ]
};

const FalFamilyPants = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFamilyPants",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-6.2 172-4.1 49.3C52.1 304 66.8 320 85.6 320h59.6c-.7 5.2-1.1 10.6-1.1 16v16H96v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c7 0 13.8.9 20.2 2.6-1.7 6.9-2.6 14-2.6 21.4 0 3.9.3 7.8.8 11.6-5.7-2.4-11.9-3.6-18.4-3.6h-44.8c-25 0-45.8 19.1-47.8 44zM416 352h-48v-16c0-5.4-.4-10.8-1.1-16h59.6c18.7 0 33.4-16 31.9-34.7l-4.2-49.3c-2.1-24.9-22.9-44-47.8-44h-44.8c-6.5 0-12.7 1.3-18.4 3.6.5-3.8.8-7.7.8-11.6 0-7.4-.9-14.6-2.6-21.4 6.5-1.7 13.3-2.6 20.2-2.6h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352zm0-288a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-64 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c-26.5 0-48 21.5-48 48v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-26.5-21.5-48-48-48zm-48 125.3c-18.6-6.6-32-24.4-32-45.3v-32c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 20.9-13.4 38.7-32 45.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-82.7z"
        }
    ]
};

const FalFamily = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFamily",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-22.4 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C52.1 304 66.8 320 85.6 320h59.6c-.7 5.2-1.1 10.6-1.1 16v16H96v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c7 0 13.8.9 20.2 2.6-1.7 6.9-2.6 14-2.6 21.4 0 3.9.3 7.8.8 11.6-5.7-2.4-11.9-3.6-18.4-3.6h-44.8zM416 384h-49.6c1-5.2 1.6-10.5 1.6-16v-16h101.6l-39.1-136.8c-3.9-13.7-16.5-23.2-30.8-23.2h-31.4c-11.5 0-21.8 6.1-27.5 15.6 2.1-7.5 3.2-15.4 3.2-23.6 0-6.3-.7-12.5-1.9-18.4 8.1-3.6 17-5.6 26.2-5.6h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384zM384 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM256 208a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 160c-26.5 0-48 21.5-48 48v32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-32c0-26.5-21.5-48-48-48zm-48 125.3c-18.6-6.6-32-24.4-32-45.3v-32c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 20.9-13.4 38.7-32 45.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-82.7z"
        }
    ]
};

const FalFanTable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFanTable",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 224a192 192 0 1 0-384 0 192 192 0 1 0 384 0zm32 0c0 118.3-91.8 215.2-208 223.4V480h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h128v-32.6C91.8 439.2 0 342.3 0 224 0 100.3 100.3 0 224 0s224 100.3 224 224zm-224-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-55.4-99.7c-32.8 13.2-48.6 50.5-35.4 83.3 9.3 23 30.4 37.7 53.6 39.8 5.8.5 10.9 4.2 13.2 9.6s1.5 11.6-2.1 16.2L150 318.6c-2.7 3.5-2.1 8.5 1.4 11.2 27.9 21.8 68.1 16.8 89.8-11 15.3-19.5 17.4-45.2 7.6-66.3-2.5-5.3-1.8-11.6 1.7-16.3s9.3-7.1 15.1-6.3l77.1 10.8c4.4.6 8.4-2.4 9-6.8 4.9-35-19.5-67.4-54.5-72.3-24.6-3.5-47.9 7.5-61.3 26.5-3.4 4.8-9.1 7.3-14.9 6.7s-10.8-4.5-13-9.9l-29-72.2c-1.7-4.1-6.3-6.1-10.4-4.4zm60 41.6c19.9-15.9 46-23.9 73.3-20 52.5 7.4 89.1 55.9 81.7 108.4-3.1 21.9-23.3 37.1-45.2 34l-52.6-7.3c3.8 25.2-2.3 51.8-19.3 73.5-32.6 41.8-93 49.2-134.8 16.5-17.4-13.6-20.5-38.7-6.9-56.1l32.8-41.9c-23.7-9.3-43.7-27.9-54-53.4-19.9-49.2 3.9-105.1 53-125 20.5-8.3 43.8 1.6 52.1 22.1l19.9 49.3z"
        }
    ]
};

const FalFan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFan",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M242.5 134.2c-1.1 10.6 3.2 21 11.4 27.8s19.2 9.1 29.4 6.1c16.9-4.9 39.3-8.2 68.8-8.2h.1c59.5-.2 108.2 37.9 123.1 92.2l-97.5-9.7c-10.6-1.1-21 3.2-27.8 11.4s-9.1 19.2-6.2 29.4c4.9 16.9 8.2 39.3 8.2 68.8v.1c.2 59.5-37.9 108.2-92.2 123.1l9.7-97.5c1.1-10.6-3.2-21-11.4-27.8s-19.2-9.1-29.4-6.1c-16.9 4.9-39.3 8.2-68.8 8.2h-.1c-59.5.2-108.2-37.9-123.1-92.2l97.5 9.7c10.6 1.1 21-3.2 27.8-11.4s9.1-19.2 6.1-29.4c-4.9-16.9-8.2-39.3-8.2-68.8v-.1c-.2-59.5 37.9-108.2 92.2-123.1l-9.7 97.5zm237.6 118.5zM32 259.3zM252.7 32zm21.6 105.5 3.4-33.9 6.8-68.3c1.9-18.8-13.1-35.5-31.6-31.5C179.9 19.2 127.7 82.7 128 160c0 16.6 1 31.5 2.7 44.9 1.6 12.2 3.9 23.1 6.7 32.8l-33.9-3.4-68.3-6.8c-18.8-1.9-35.5 13.1-31.5 31.6C19.2 332.2 82.8 384.3 160 384c16.6 0 31.5-1 44.9-2.7 12.2-1.6 23.1-3.9 32.8-6.7l-3.4 33.9-6.8 68.3c-1.9 18.8 13.1 35.5 31.6 31.5 73.1-15.5 125.2-79 124.9-156.3 0-16.6-1-31.5-2.7-44.9-1.6-12.2-3.9-23.1-6.7-32.8l33.9 3.4 68.3 6.8c18.8 1.9 35.5-13.1 31.5-31.6-15.5-73.1-79-125.2-156.3-124.9-16.6 0-31.5 1-44.9 2.7-12.2 1.6-23.1 3.9-32.8 6.7zM256 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalFarm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFarm",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 480c-8.8 0-16-7.2-16-16V192h123.7l17.1-32H32v-48c0-44.2 35.8-80 80-80s80 35.8 80 80v12l3-5.7c6.1-11.5 15.6-20.8 27.1-26.7C212.5 39.5 166.9 0 112 0 50.1 0 0 50.1 0 112v352c0 26.5 21.5 48 48 48h96c-7-9.3-12-20.2-14.4-32H48zM380.8 68.1c-8.2-3.6-17.5-3.6-25.7 0l-116.5 51c-6.6 2.9-12 7.9-15.4 14.3l-59.4 111.5c-2.5 4.6-3.8 9.8-3.8 15.1v204c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V260c0-5.3-1.3-10.4-3.8-15.1l-59.5-111.5c-3.4-6.4-8.8-11.4-15.4-14.3l-116.5-51zM368 97.5l116.5 51L544 260v204c0 8.8-7.2 16-16 16h-80v-64c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v64h-80c-8.8 0-16-7.2-16-16V260l59.5-111.6L368 97.5zM416 480h-96v-64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v64zm-80-256h64v64h-64v-64zm0-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64z"
        }
    ]
};

const FalFaucetDrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaucetDrip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h128v48h-18.7c-12.7 0-24.9 5.1-33.9 14.1l-34 33.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h112c4.2 0 8.3-1.7 11.3-4.7l38.6-38.6c3-3 7.1-4.7 11.3-4.7h69.5c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7h48c61.9 0 112 50.1 112 112 0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16 0-26.5-21.5-48-48-48h-60.8c-5.7 0-11 3-13.8 8-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40c-2.9-4.9-8.1-8-13.8-8H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h116.1c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48H368c8.8 0 16 7.2 16 16 0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48 0-79.5-64.5-144-144-144h-41.4l-33.9-33.9c-9-9-21.2-14.1-33.9-14.1H240V64h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V16zm208 415.6 13.3 21.3c1.8 2.8 2.7 6.1 2.7 9.4v1.7c0 8.8-7.2 16-16 16s-16-7.2-16-16v-1.7c0-3.3.9-6.6 2.7-9.4l13.3-21.3zm-12.2-40.8-28.2 45.1c-4.9 7.9-7.6 17-7.6 26.4v1.7c0 26.5 21.5 48 48 48s48-21.5 48-48v-1.7c0-9.3-2.6-18.5-7.6-26.4l-28.2-45.1c-2.6-4.2-7.3-6.8-12.2-6.8s-9.6 2.6-12.2 6.8z"
        }
    ]
};

const FalFaucet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFaucet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h128v48h-18.7c-12.7 0-24.9 5.1-33.9 14.1l-34 33.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h112c4.2 0 8.3-1.7 11.3-4.7l38.6-38.6c3-3 7.1-4.7 11.3-4.7h69.5c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7h48c61.9 0 112 50.1 112 112 0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16 0-26.5-21.5-48-48-48h-60.8c-5.7 0-11 3-13.8 8-13.9 24-39.7 40-69.3 40s-55.5-16.1-69.3-40c-2.9-4.9-8.1-8-13.8-8H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h116.1c20.2 29 53.8 48 91.9 48s71.7-19 91.9-48H368c8.8 0 16 7.2 16 16 0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48 0-79.5-64.5-144-144-144h-41.4l-33.9-33.9c-9-9-21.2-14.1-33.9-14.1H240v-48h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V80z"
        }
    ]
};

const FalFax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFax",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0-17.7 14.3-32 32-32h196.1c8.5 0 16.6 3.4 22.6 9.4l27.9 27.9c6 6 9.4 14.1 9.4 22.6V160h32V91.9c0-17-6.7-33.3-18.7-45.3l-27.9-27.9C421.4 6.7 405.1 0 388.1 0H192c-35.3 0-64 28.7-64 64v72.6c-9.4-5.4-20.3-8.6-32-8.6H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h32c19.1 0 36.3-8.4 48-21.7 11.7 13.3 28.9 21.7 48 21.7h256c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H160V64zm0 160h288c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V224zm-32-32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32zm168 112a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-120 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalFeatherPointed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFeatherPointed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M102.2 348.1C89.9 302.4 89.8 224.5 160 154.3c40.6-40.6 98.9-69.8 159.1-89.6C379 44.9 438.2 35.3 477.9 32c0 0 .2 0 .4.1.3.1.6.3 1 .7s.6.7.7 1c.1.2.1.4.1.4-3.3 39.7-12.9 98.9-32.7 158.7-3.4 10.5-7.2 20.9-11.2 31.1H310.6l37.6-37.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L116.1 373.3c-7-8.6-11.6-16.9-13.9-25.2zm13.8 70.5c11.7 9.9 24.7 18 39.6 22 54.1 14.6 144.7 14 224.8-66.1 91.1-91 124.6-254 131.5-337.7.8-9.9-3-19.6-10-26.6S485.2-.6 475.3.2C391.5 7 228.5 40.5 137.4 131.6c-80.1 80.1-80.7 170.7-66.1 224.8 4 14.8 12.1 27.8 22 39.6L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l88.7-88.7zm22.7-22.7 43.9-43.9h175.1c-70.2 70.2-148.2 70.1-193.8 57.8-8.3-2.2-16.6-6.9-25.2-13.9zM385 320H214.6l64-64h143.8c-10.8 22.9-23.2 44.6-37.4 64z"
        }
    ]
};

const FalFeather = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFeather",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M325.6 163.8 96 393.4V330c0-59.4 23.6-116.4 65.6-158.4L265.4 67.9c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l5.5 5.5c23 23 35.9 54.1 35.9 86.6 0 22.8-6.3 44.9-18 64H310.6l37.6-37.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm-47 92.2h156.1l-64 64H214.6l64-64zm60.1 96c-41.8 41-98.1 64-156.8 64h-63.3l64-64h156.1zM64 330v95.3L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448H182c67.9 0 133-27 181-75l103.7-103.7c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-5.5-5.5C432.3 16.3 393 0 352 0s-80.3 16.3-109.3 45.3L139 149c-48 48-75 113.1-75 181z"
        }
    ]
};

const FalFence = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFence",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c5 0 9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2V160h64v-42.7c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2V160h64v-42.7c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4s9.8 2.4 12.8 6.4l44.8 59.7c4.2 5.5 6.4 12.3 6.4 19.2V448c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64h-64v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64h-64v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V117.3c0-6.9 2.2-13.7 6.4-19.2l44.8-59.7c3-4 7.8-6.4 12.8-6.4zm224 352V117.3l-32-42.6-32 42.7V448h64v-64zm32-32h64V192h-64v160zm96 0v96h64V117.3l-32-42.6-32 42.7V352zM192 192h-64v160h64V192zm-96 0v-74.7L64 74.7l-32 42.6V448h64V192z"
        }
    ]
};

const FalFerrisWheel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFerrisWheel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-60.2 18.7c-20.4 4.8-39.6 12.9-56.9 23.7 3.3 6.5 5.2 13.9 5.2 21.7 0 7.4-1.7 14.4-4.7 20.7l68.2 68.2c5.1-3 10.6-5.3 16.5-6.8V93.3c-12.7-4.5-23-14.2-28.2-26.6zM272 194c5.9 1.5 11.4 3.8 16.5 6.8l68.2-68.2c-3-6.3-4.7-13.3-4.7-20.7 0-7.8 1.9-15.2 5.2-21.7-17.3-10.8-36.5-18.8-56.9-23.7C295 79 284.7 88.8 272 93.3V194zm39.1 29.5c3 5.1 5.3 10.6 6.8 16.5h100.8c4.3-12.1 13.3-22 24.9-27.5-4.5-20.5-12.2-39.8-22.7-57.3-6.3 3.1-13.4 4.8-20.9 4.8-7.4 0-14.4-1.7-20.7-4.7l-68.2 68.2zM418.7 272H318c-4.6 17.9-16.7 32.7-32.8 41l81.4 176.3c2.3 5 1.9 10.7-1 15.3s-8 7.4-13.5 7.4H160c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3L226.8 313c-16.1-8.2-28.2-23.1-32.8-41H93.3c-4.2 11.8-12.8 21.5-23.9 27 4.9 20.4 13.1 39.5 24 56.8 5.7-2.4 12-3.7 18.6-3.7 26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48c0-8.1 2-15.7 5.5-22.3-14.9-22.4-26-47.7-32.1-74.8C16 298 0 278.9 0 256c0-22.5 15.5-41.4 36.3-46.6 5.7-28.2 16.7-54.6 31.8-77.9-2.7-6-4.1-12.6-4.1-19.5 0-26.5 21.5-48 48-48 6.7 0 13 1.4 18.8 3.8 23.6-15.9 50.4-27.5 79.2-33.5C215.9 14.5 234.3 0 256 0s40.1 14.5 46 34.3c28.8 6 55.6 17.6 79.2 33.5C387 65.4 393.3 64 400 64c26.5 0 48 21.5 48 48 0 6.9-1.5 13.6-4.1 19.5 15.2 23.3 26.1 49.7 31.8 77.9 20.9 5.2 36.3 24.1 36.3 46.6 0 22.9-16 42-37.4 46.8-6.1 27.1-17.1 52.4-32.1 74.8 3.5 6.7 5.5 14.3 5.5 22.3 0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48c6.6 0 12.9 1.3 18.6 3.7 10.9-17.3 19.1-36.4 24-56.8-11.1-5.5-19.7-15.2-23.9-27zM194 240c1.5-5.9 3.8-11.4 6.8-16.5l-68.2-68.2c-6.3 3-13.3 4.7-20.7 4.7-7.5 0-14.6-1.7-20.9-4.8-10.4 17.5-18.1 36.8-22.6 57.3C79.9 218 89 227.9 93.3 240H194zm254 16a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm-384 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm64-144a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm272 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 272a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-304 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm144-89.8L185 480h142l-71-153.8zm0-38.2a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalFerry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFerry",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-17.7 0-32 14.3-32 32h-68c-17.1 0-28.7 17.4-22.2 33.2L114.7 96H112c-26.5 0-48 21.5-48 48v151.1c0 8.7 2.4 17.2 6.8 24.7l43.4 72.4c4.5 7.6 14.4 10 22 5.5s10-14.4 5.5-21.9L108.3 320h359.4l-33.5 55.8c-4.5 7.6-2.1 17.4 5.5 21.9s17.4 2.1 21.9-5.5l43.4-72.4c4.5-7.5 6.8-16 6.8-24.7V144c0-26.5-21.5-48-48-48h-2.7l12.8-30.8c6.6-15.8-5-33.2-22.2-33.2H384c0-17.7-14.3-32-32-32H224zm192 288H160v-96h256v96zm32 0V176c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v112H96V144c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v144h-32zM426.7 96H149.3L136 64h88V32h128v32h88l-13.3 32zM192 480c-20.9 0-41.7-9.9-58.2-21.2-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"
        }
    ]
};

const FalFieldHockeyStickBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFieldHockeyStickBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500.3 100.9C520.7 72 513.7 32 484.9 11.7S416-1.8 395.7 27.1L147.6 379.4c-2 2.8-5.1 4.4-8.5 4.4-5.3 0-10.5-4.7-10.5-11 0-1.6.4-3.1.9-4.4l17-38.5c14.3-32.3-.3-70.1-32.7-84.4s-70.1.3-84.4 32.7l-17 38.5C4.8 334 .7 352.9.6 371.8 0 448.3 61.9 512 139.4 511.8c44.9-.1 86.9-22 112.8-58.7l248.1-352.2zm-26.1-18.5-54 76.7-51.2-38.4 52.9-75.1c10.1-14.5 30.1-17.9 44.5-7.8s17.9 30.2 7.8 44.6zm-72.5 102.9L226.1 434.6c-19.9 28.2-52.2 45-86.7 45.1C79.9 480 32.1 431 32.6 372c.1-14.6 3.2-29.1 9.1-42.5l17-38.5c7.1-16.2 26-23.5 42.2-16.3s23.5 26 16.3 42.2l-17 38.5c-2.4 5.3-3.6 11.2-3.7 17.1-.2 23.9 19.2 43.3 42.6 43.2 13.8 0 26.7-6.8 34.6-18l176.8-250.8 51.2 38.4zM432 384a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"
        }
    ]
};

const FalFileArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileArrowDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm144 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v121.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4V240z"
        }
    ]
};

const FalFileArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileArrowUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm144 278.6 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7V400c0 8.8 7.2 16 16 16s16-7.2 16-16V278.6z"
        }
    ]
};

const FalFileAudio = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileAudio",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm194 226.3c-7.6-4.6-17.4-2.1-22 5.4s-2.1 17.4 5.4 22c28 16.8 46.6 47.4 46.6 82.3s-18.6 65.5-46.5 82.3c-7.6 4.6-10 14.4-5.4 22s14.4 10 22 5.4c37.1-22.4 62-63.1 62-109.7s-24.9-87.3-62-109.7zm-18.3 67c-5.9-6.6-16-7.1-22.6-1.3s-7.1 16-1.3 22.6c5.1 5.7 8.1 13.1 8.1 21.3s-3.1 15.7-8.1 21.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3c10.1-11.1 16.3-26.1 16.3-42.5s-6.2-31.4-16.3-42.7zm-56.9-43.8c-5.6-2.6-12.3-1.8-17 2.2L122.2 288H80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h42.2l43.6 36.3c4.8 4 11.4 4.8 17 2.2s9.2-8.3 9.2-14.5V264c0-6.2-3.6-11.9-9.2-14.5zM160 298.2v75.7l-21.8-18.1c-2.9-2.4-6.5-3.7-10.2-3.7H96V320h32c3.7 0 7.4-1.3 10.2-3.7l21.8-18.1z"
        }
    ]
};

const FalFileBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileBinary",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-32zm-16 48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64zm144-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v96h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V272c0-8.8-7.2-16-16-16h-32z"
        }
    ]
};

const FalFileCertificate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCertificate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 448c0 17.7-14.3 32-32 32H224v16c0 5.5-1 10.9-2.7 16H448c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64v71.1l.1-.1c1.5-.7 4-2 6.6-3 8.2-3.4 16.9-4.6 25.3-4V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256zm-.5-288H368c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4zM69.8 358.5l-2.1 15.2 2.1-15.2L59 357l-1.5-10.8c-1.4-10.4-6.9-19.8-15.1-26.2l-19.6 25.2L42.4 320l-8.6-6.7 4.1-10.1c4-9.7 4-20.6 0-30.3l-4.1-10.1 8.6-6.7-19.6-25.4-13.5 10.5c-8.5 6.6-11.6 18.1-7.5 28L8.2 285c.8 1.9.8 4.1 0 6l-6.4 15.8c-4.1 10-1 21.4 7.5 28l13.5 10.4c1.7 1.3 2.7 3.2 3 5.2l2.3 16.9c1.5 10.7 9.8 19.1 20.5 20.5L64 390v106c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l39.1-26.1 39.1 26.1c4.9 3.3 11.2 3.6 16.4.8s8.5-8.2 8.5-14.1V390l15.4-2.1c10.7-1.5 19.1-9.8 20.5-20.5l2.3-16.9-31.7-4.3L197 357l-10.8 1.5c-10.4 1.4-19.8 6.9-26.2 15.1l-6.7 8.6-10.1-4.1c-9.7-4-20.6-4-30.3 0l-10.1 4.1-6.8-8.6c-6.4-8.3-15.8-13.7-26.2-15.1zm-47-127.7L42.4 256c8.3-6.4 13.7-15.8 15.1-26.2L29.3 226l28.2 3.8L59 219l10.8-1.5c10.4-1.4 19.8-6.9 26.2-15.1l6.7-8.6 10.1 4.1c9.7 4 20.6 4 30.3 0l-11.3-27.6 11.3 27.6 10.1-4.1 6.7 8.6c6.4 8.3 15.8 13.7 26.2 15.1L197 219l1.5 10.8c1.4 10.4 6.9 19.8 15.1 26.2l8.6 6.7-4.1 10.1c-4 9.7-4 20.6 0 30.3l4.1 10.1-8.6 6.7c-8.3 6.4-13.7 15.8-15.1 26.2l31.7 4.3c.3-2.1 1.4-4 3-5.2l13.5-10.4c8.5-6.6 11.6-18.1 7.5-28l-6.4-15.8a7.8 7.8 0 0 1 0-6l6.5-15.8c4.1-10 1-21.4-7.5-28l-13.5-10.4c-1.7-1.3-2.7-3.2-3-5.2l-2.3-16.9c-1.5-10.7-9.8-19.1-20.5-20.5l-16.9-2.3c-2.1-.3-4-1.4-5.2-3L175 169.4c-6.6-8.5-18.1-11.6-28-7.5l-16 6.3c-1.9.8-4.1.8-6 0l-15.8-6.5c-10-4.1-21.4-1-28 7.5l-10.5 13.6c-1.3 1.7-3.2 2.7-5.2 3l-16.9 2.3c-10.7 1.5-19.1 9.8-20.5 20.5l-2.3 16.9c-.3 2.1-1.4 4-3 5.2zM160 466.1l-23.1-15.4c-5.4-3.6-12.4-3.6-17.8 0L96 466.1v-50.5c4.3.8 8.9.3 13.2-1.4l15.8-6.5c1.9-.8 4.1-.8 6 0l15.8 6.5c4.3 1.8 8.9 2.2 13.2 1.4v50.5z"
        }
    ]
};

const FalFileChartColumn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileChartColumn",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm144 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16V240zm96 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm-192 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64z"
        }
    ]
};

const FalFileChartPie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileChartPie",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm112 224v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16 0-61.9-50.1-112-112-112-8.8 0-16 7.2-16 16zm32 17.6c31.3 6.4 56 31.1 62.4 62.4H208v-62.4zm-56-21c-46.3 13.8-80 56.7-80 107.4 0 61.9 50.1 112 112 112 50.7 0 93.6-33.7 107.4-80h-34c-12.3 28.3-40.5 48-73.3 48-44.2 0-80-35.8-80-80 0-32.8 19.7-61 48-73.3v-34z"
        }
    ]
};

const FalFileCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm219.3 294c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-95.4 95.4-42-42c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l53.3 53.2c6.2 6.2 16.4 6.2 22.6 0L283.3 294z"
        }
    ]
};

const FalFileCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h232.2c9.8 11.8 21 22.3 33.5 31.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalFileCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h232.2c9.8 11.8 21 22.3 33.5 31.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalFileCircleInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCircleInfo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h232.2c9.8 11.8 21 22.3 33.5 31.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-32a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-32 96c0-8.8 7.2-16 16-16v-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16v48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalFileCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h232.2c9.8 11.8 21 22.3 33.5 31.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalFileCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h232.2c9.8 11.8 21 22.3 33.5 31.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalFileCircleQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCircleQuestion",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h232.2c9.8 11.8 21 22.3 33.5 31.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-86.4c0-23 18.6-41.6 41.6-41.6h40.5c25.4 0 45.9 20.6 45.9 45.9 0 17.1-9.5 32.7-24.5 40.6L447.8 387c-1.4 7.4-7.9 12.9-15.7 12.9-8.8 0-16-7.2-16-16v-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3 0-7.7-6.2-13.9-13.9-13.9h-40.6c-5.3 0-9.6 4.3-9.6 9.6v6.5c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.4z"
        }
    ]
};

const FalFileCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h232.2c9.8 11.8 21 22.3 33.5 31.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9v34.7c-11.2 3.2-21.9 7.4-32 12.6V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalFileCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCode",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm91.3 299.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-48 48c-6.2 6.2-6.2 16.4 0 22.6l48 48c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L118.6 336l36.7-36.7zm144 25.4-48-48c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l48-48c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalFileContract = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileContract",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm54.2 253.8L144 349l16.7 55.6c1.7 5.8 6.6 10.1 12.5 11.2s12-1.3 15.6-6.2l17.6-23.4c1-1.4 2.7-2.2 4.4-2.2 2.1 0 4 1.2 4.9 3l10.1 20.1c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-54.2l-5.6-11.3c-6.4-12.6-19.4-20.6-33.6-20.6-11 0-21.4 4.8-28.5 13.1L169.6 323c-3.4-11.3-13.8-19-25.6-19s-22.2 7.7-25.6 19.1l-14.9 49.5c-2 6.8-8.3 11.4-15.3 11.4H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h8.2c21.2 0 39.9-13.9 46-34.2z"
        }
    ]
};

const FalFileCsv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileCsv",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h32v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V288h-32v-96H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16h-34.9c-7.2 0-13.1 5.9-13.1 13.1 0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2 0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1 0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2 0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66 10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalFileDashedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileDashedLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32v-96h-32v96c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64v-96h-32v96zm0-256v64h32v-92.1c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64v192h32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112zm-.5-32H368c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4zM48 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H464z"
        }
    ]
};

const FalFileDoc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileDoc",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h32v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V288h-32v-96H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v96zm264-128h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40zm-168 40c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40h-16c-22.1 0-40-17.9-40-40v-80zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-16z"
        }
    ]
};

const FalFileExcel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileExcel",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm85.1 246.8c-5.1-7.2-15-9-22.3-3.9s-9 15-3.9 22.3l49.6 70.8-49.6 70.8c-5.1 7.2-3.3 17.2 3.9 22.3s17.2 3.3 22.3-3.9l42.9-61.3 42.9 61.3c5.1 7.2 15 9 22.3 3.9s9-15 3.9-22.3L211.5 336l49.6-70.8c5.1-7.2 3.3-17.2-3.9-22.3s-17.2-3.3-22.3 3.9L192 308.1l-42.9-61.3z"
        }
    ]
};

const FalFileExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileExclamation",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm128 224c-8.8 0-16 7.2-16 16v112c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.8-7.2-16-16-16zm24 192a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalFileExport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileExport",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v64h32v-92.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64v-80h-32v80zm-.5-288H240c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4zm123.8 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l68.7 68.7H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h313.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"
        }
    ]
};

const FalFileHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileHeart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm61.7 306.8c0-11.9 9.6-21.5 21.5-21.5h1.5c6 0 11.7 2.3 16 6.5l16.1 15.6c6.2 6 16.1 6 22.3 0l16.1-15.6c4.3-4.2 10.1-6.5 16-6.5h1.5c11.9 0 21.5 9.6 21.5 21.5 0 5.8-2.3 11.4-6.5 15.4L192 380.4l-59.8-58.1c-4.2-4-6.5-9.6-6.5-15.4zm21.5-53.5c-29.5 0-53.5 23.9-53.5 53.5 0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4 0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5z"
        }
    ]
};

const FalFileImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileImage",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM0 64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm72 192a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm109.3 112.9c-2.9 4.3-7.7 7-12.9 7.1s-10.1-2.2-13.2-6.4l-14.4-19.3L99 416h186.1l-65.4-104.7-38.4 57.6zm38.6-96.9c8 0 15.5 4.1 19.8 11l76 121.5c2.8 4.5 4.3 9.7 4.3 15.1 0 15.7-12.7 28.4-28.4 28.4H92.4C76.7 448 64 435.3 64 419.6c0-5.4 1.5-10.7 4.4-15.2l51.8-81.4c4.3-6.8 11.9-10.9 19.9-10.9 7.4 0 14.4 3.5 18.9 9.4l8.1 10.9 33.3-49.9c4.3-6.5 11.6-10.4 19.4-10.4z"
        }
    ]
};

const FalFileImport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileImport",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 448c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32v-80h-32v80c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64v192h32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256zm-.5-288H368c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4zm-196.2 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l68.7 68.7H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h313.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6l-96-96z"
        }
    ]
};

const FalFileInvoiceDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileInvoiceDollar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM0 64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 16c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm144 99.6v13.6c8.3 1.1 16.3 2.7 23.7 4.5 8.6 2 13.9 10.7 11.9 19.3s-10.7 13.9-19.3 11.9c-11.2-2.6-22.2-4.6-32.5-4.8-8.7-.1-17.9 1.7-24.3 5.1-6.1 3.2-7.4 6.3-7.4 9.4 0 1.5.2 3.6 6.6 7 7 3.7 16.8 6.4 29.4 9.8l.5.1c11.3 3 25.2 6.8 36.1 12.9 11.8 6.6 23.1 17.7 23.4 35.9.3 18.9-10.6 31.7-23.6 38.9-7.5 4.1-15.9 6.6-24.4 7.9v13.5c0 8.8-7.2 16-16 16s-16-7.2-16-16v-14.2c-10.9-1.9-21.2-5-30.3-7.8-2.1-.7-4.2-1.3-6.2-1.9-8.5-2.5-13.3-11.4-10.8-19.9s11.4-13.3 19.9-10.8c2.4.7 4.8 1.4 7.1 2.1 13.6 4.1 24.8 7.5 36.8 7.9 9.4.3 18.5-1.6 24.4-4.9 5.4-3 7.2-6.2 7.1-10.4 0-2.4-.8-4.9-7-8.4-6.9-3.9-16.8-6.7-29.2-10l-1.6-.4c-11-3-24.2-6.5-34.6-12.1-11.5-6.2-23.3-16.9-23.4-35.1-.1-19 11.9-31.3 24.5-37.9 7.3-3.8 15.4-6.2 23.4-7.5v-13.7c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalFileInvoice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileInvoice",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm160 288c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm64-96H96v-64h192v64zM96 240c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H96z"
        }
    ]
};

const FalFileLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileLines",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
        }
    ]
};

const FalFileLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c0 11.4 3 22.2 8.3 31.5-2.7.3-5.5.5-8.3.5H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V192zm-144-32h111.5c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16zm224 64c-26.5 0-48 21.5-48 48v48h96v-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48zm0 80v128h160V352H384z"
        }
    ]
};

const FalFileMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileMagnifyingGlass",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 320a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-8.4 78.3C215.9 409.4 196.7 416 176 416c-53 0-96-43-96-96s43-96 96-96 96 43 96 96c0 20.7-6.6 39.9-17.7 55.6l45.1 45.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-45.1-45.1zM352 448V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM0 64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"
        }
    ]
};

const FalFileMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileMedical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm112 224c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 80v-48h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z"
        }
    ]
};

const FalFileMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm32 320c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
        }
    ]
};

const FalFileMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileMusic",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM0 64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm304 168c0-5.2-2.6-10.2-6.9-13.2s-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V291.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V232zm-48 160c-11.5 0-16-7.9-16-12s4.5-12 16-12 16 7.9 16 12-4.5 12-16 12zm-128 32c-11.5 0-16-7.9-16-12s4.5-12 16-12 16 7.9 16 12-4.5 12-16 12z"
        }
    ]
};

const FalFilePdf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilePdf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h32v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V288h-32v-96H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56h-16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V368z"
        }
    ]
};

const FalFilePen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilePen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h194.6l-1.1 4.5c-2.3 9.2-1.8 18.8 1.3 27.5H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9v121.9l-32 32V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zm167 104c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 39.9 39.9 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6L518.6 264zM342.4 417.5c-2.1 2.1-3.5 4.6-4.2 7.4l-12.2 49 48.9-12.2c2.8-.7 5.4-2.2 7.4-4.2l106.2-106.2-39.9-39.9-106.2 106.1zm130.9-176.1c18.7-18.7 49.1-18.7 67.9 0l17.3 17.3c18.7 18.7 18.7 49.1 0 67.9L405 480.1c-6.2 6.2-13.9 10.5-22.3 12.6l-74.8 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.8c2.1-8.4 6.5-16.2 12.6-22.3l153.5-153.5z"
        }
    ]
};

const FalFilePlusMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilePlusMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm144 240c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48zm-80 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"
        }
    ]
};

const FalFilePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilePlus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm112 416c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64z"
        }
    ]
};

const FalFilePowerpoint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilePowerpoint",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm64 240c-8.8 0-16 7.2-16 16v176c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h56c39.8 0 72-32.2 72-72s-32.2-72-72-72h-72zm72 112h-56v-80h56c22.1 0 40 17.9 40 40s-17.9 40-40 40z"
        }
    ]
};

const FalFilePrescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilePrescription",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm48 224c-8.8 0-16 7.2-16 16v144c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h41.4l48 48-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L262.6 384l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 361.4l-31.2-31.2C227.3 321.1 240 302 240 280c0-30.9-25.1-56-56-56h-72zm72 80h-56v-48h56c13.3 0 24 10.7 24 24s-10.7 24-24 24z"
        }
    ]
};

const FalFileShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileShield",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480c1.3 0 2.6-.1 3.9-.2 7.9 8.6 16.6 16.9 26.3 24.7-9 4.8-19.3 7.6-30.2 7.6H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V207l-32 12.8V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256zm31.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zm-31.4 141.4c1.3 53 22.6 129.5 95.9 170V263l-95.9 38.4zm223.9 0L448 263v208.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7 120 48c9 3.7 15 12.5 15 22.3 0 63.3-25.9 168.8-134.8 214.2-5.9 2.5-12.6 2.5-18.5 0C313.9 464.8 288 359.3 288 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z"
        }
    ]
};

const FalFileSignature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileSignature",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480c17.7 0 32-14.3 32-32v-10.7l23.8-5.9c2.8-.7 5.6-1.6 8.2-2.7V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9v39.8l-32 32V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256zm-80-320h111.5c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16zm-96 189-9.8 32.8c-6.1 20.3-24.8 34.2-46 34.2H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h8.2c7.1 0 13.3-4.6 15.3-11.4l14.9-49.5c3.4-11.3 13.8-19.1 25.6-19.1s22.2 7.7 25.6 19.1l12.6 42.1c7.1-8.3 17.5-13.1 28.5-13.1 14.2 0 27.2 8 33.5 20.7l5.6 11.3h41.7l15.7-62.6c2.1-8.4 6.5-16.1 12.6-22.3l153.7-153.8c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 384.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-2 .5-4.1.6-6.1.3H240c-6.1 0-11.6-3.4-14.3-8.8L215.6 387c-.9-1.8-2.8-3-4.9-3-1.7 0-3.3.8-4.4 2.2l-17.6 23.4c-3.6 4.8-9.7 7.2-15.6 6.2s-10.8-5.4-12.5-11.2L144 349zm374.8-181c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6L518.8 168zM342.5 321.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l106.3-106.2-40-40-106.2 106.3z"
        }
    ]
};

const FalFileSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 163.9c0-12.7-5.1-24.9-14.1-33.9L382.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-23 0-43.2 12.2-54.5 30.4L163 50.5c5.1-10.9 16.2-18.5 29-18.5h128v112c0 26.5 21.5 48 48 48h112v108.8l32 25.2V163.9zM160 448V211.2L128 186v262c0 35.3 28.7 64 64 64h256c23 0 43.2-12.2 54.5-30.4L477 461.5c-5.1 10.9-16.2 18.5-29 18.5H192c-17.7 0-32-14.3-32-32zm319.5-288H368c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalFileSpreadsheet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileSpreadsheet",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm32 384h80v32H96v-32zm0-32v-32h80v32H96zm112 64v-32h80v32h-80zm0-64v-32h80v32h-80zm112 16V256c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-48zm-32-112v32H96v-32h192z"
        }
    ]
};

const FalFileUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileUser",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480h-16v-16c0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80v16H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-48-16v16H112v-16c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48zm-32-304c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm128 256a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FalFileVideo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileVideo",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm144 288v96H96v-96h112zm32 96v-.4l58.1 23.2c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2V280c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L240 288.4v-.4c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h112c17.7 0 32-14.3 32-32zm48-15.6-48-19.2v-26.4l48-19.2v64.7z"
        }
    ]
};

const FalFileWaveform = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileWaveform",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-64H64v64c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L318.1 14.1c-9-9-21.2-14.1-33.9-14.1H128C92.7 0 64 28.7 64 64v224h32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256zm-.5-288H304c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4zM270.3 264.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-52.4 104.9-32.5-43.3c-3-4-7.8-6.4-12.8-6.4H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h120l43.2 57.6c3.3 4.4 8.7 6.8 14.2 6.3s10.4-3.8 12.9-8.8l49.7-99.3 17.7 35.4c2.7 5.4 8.3 8.8 14.3 8.8h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-54.1l-27.6-55.2z"
        }
    ]
};

const FalFileWord = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileWord",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm39.2 235.1c-2.7-8.4-11.7-13.1-20.1-10.4S70 236.4 72.7 244.8l56 176c2.2 6.8 8.5 11.3 15.6 11.1s13.2-4.9 15.1-11.8L192 300.8l32.6 119.4c1.9 6.8 8 11.6 15.1 11.8s13.4-4.4 15.6-11.1l56-176c2.7-8.4-2-17.4-10.4-20.1s-17.4 2-20.1 10.4l-39.6 124.3-33.8-123.7c-1.9-7-8.2-11.8-15.4-11.8s-13.5 4.8-15.4 11.8l-33.8 123.7-39.6-124.4z"
        }
    ]
};

const FalFileXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileXmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128v112c0 26.5 21.5 48 48 48h112v256c0 17.7-14.3 32-32 32zm-80-320c-8.8 0-16-7.2-16-16V32.5c2.8.7 5.4 2.1 7.4 4.2l115.9 115.9c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm52.7 260.7c-6.2 6.2-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 336l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 313.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalFileZip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileZip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V288h-32v-96H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm287.5-320c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM240 352h64c5.5 0 10.7 2.9 13.6 7.6s3.2 10.6.7 15.6L265.9 480H304c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6L278.1 384H240c-8.8 0-16-7.2-16-16s7.2-16 16-16zm144 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-8.8 7.2-16 16-16h24c30.9 0 56 25.1 56 56s-25.1 56-56 56h-8v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V368zm32 64h8c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8v48z"
        }
    ]
};

const FalFileZipper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFileZipper",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM0 64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm64 16c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm32 48h32c7.1 0 13.4 4.7 15.4 11.6l14.6 51.3c1.3 4.6 2 9.3 2 14v3.1c0 26.5-21.5 48-48 48s-48-21.5-48-48v-3.1c0-4.7.7-9.5 2-14l14.7-51.3c2-6.9 8.2-11.6 15.4-11.6zm.7 71.7c-.5 1.7-.7 3.5-.7 5.2v3.1c0 8.8 7.2 16 16 16s16-7.2 16-16v-3.1c0-1.8-.2-3.5-.7-5.2L115.9 288H108l-11.3 39.7z"
        }
    ]
};

const FalFile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFile",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16h111.5zM0 64C0 28.7 28.7 0 64 0h156.1C232.8 0 245 5.1 254 14.1l115.9 115.8c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"
        }
    ]
};

const FalFilesMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilesMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 384c17.7 0 32-14.3 32-32V144h-80c-17.7 0-32-14.3-32-32V32H160c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h224zm6-272-54-54.5V112h54zM96 64c0-35.3 28.7-64 64-64h144c12.8 0 25.1 5.1 34.1 14.2l96 96.8a48 48 0 0 1 13.9 33.8V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64zM16 96c8.8 0 16 7.2 16 16v272c0 53 43 96 96 96h208c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 512 0 454.7 0 384V112c0-8.8 7.2-16 16-16zm245.3 64h21.3c17.7 0 32 14.3 32 32v21.3H336c17.7 0 32 14.3 32 32v21.3c0 17.7-14.3 32-32 32h-21.3V320c0 17.7-14.3 32-32 32h-21.4c-17.7 0-32-14.3-32-32v-21.3H208c-17.7 0-32-14.3-32-32v-21.4c0-17.7 14.3-32 32-32h21.3V192c0-17.7 14.3-32 32-32zm0 32v37.3c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7H208v21.3h37.3c8.8 0 16 7.2 16 16V320h21.3v-37.3c0-8.8 7.2-16 16-16h37.3v-21.4h-37.2c-8.8 0-16-7.2-16-16V192h-21.4z"
        }
    ]
};

const FalFiles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFiles",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 384c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h144v80c0 17.7 14.3 32 32 32h80v208c0 17.7-14.3 32-32 32H160zM336 57.5l54 54.5h-54V57.5zM160 0c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V144.8a48 48 0 0 0-13.9-33.8l-96-96.8C329.1 5.1 316.8 0 304 0H160zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v272c0 70.7 57.3 128 128 128h208c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"
        }
    ]
};

const FalFillDrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFillDrip",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M36.7 4.7c6.2-6.2 16.4-6.2 22.6 0l97.4 97.4 64.4-64.4c28.1-28.1 73.7-28.1 101.8 0l151.4 151.4c28.1 28.1 28.1 73.7 0 101.8L283.9 481.4c-37.5 37.5-98.3 37.5-135.8 0L30.6 363.9c-37.5-37.5-37.5-98.3 0-135.8l103.5-103.4-97.4-97.4c-6.2-6.2-6.2-16.4 0-22.6zm208 230.6-88-88L53.3 250.7C42.8 261.2 36.7 274.4 35 288h397l19.7-19.7c15.6-15.6 15.6-40.9 0-56.6L300.3 60.3c-15.6-15.6-40.9-15.6-56.6 0l-64.4 64.4 88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0zM39.2 320c3.1 7.7 7.8 15 14.1 21.3l117.4 117.4c25 25 65.5 25 90.5 0L400 320H39.2zM544 448c0-.1-.1-1.2-.6-3.4-.6-2.4-1.5-5.4-2.8-9.1-2.7-7.4-6.8-16.2-11.7-25.8-5.2-10.2-11.2-20.6-16.9-30.3-5.8 9.7-11.7 20.1-16.9 30.3-4.9 9.6-8.9 18.4-11.7 25.8-1.4 3.7-2.3 6.7-2.8 9.1-.5 2.2-.6 3.3-.6 3.4 0 17.7 14.3 32 32 32s32-14.3 32-32zm32 0c0 35.3-28.7 64-64 64s-64-28.7-64-64c0-25.2 32.6-79.6 51.2-108.7 6-9.4 19.5-9.4 25.5 0C543.4 368.4 576 422.8 576 448z"
        }
    ]
};

const FalFill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFill",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M59.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l97.4 97.4L30.6 228.1c-37.5 37.5-37.5 98.3 0 135.8l117.5 117.5c37.5 37.5 98.3 37.5 135.8 0l190.4-190.5c28.1-28.1 28.1-73.7 0-101.8L322.9 37.7c-28.1-28.1-73.7-28.1-101.8 0l-64.4 64.4L59.3 4.7zm97.4 142.6 88 88c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-88-88 64.4-64.4c15.6-15.6 40.9-15.6 56.6 0l151.4 151.4c15.6 15.6 15.6 40.9 0 56.6L432 288H35c1.7-13.6 7.8-26.8 18.2-37.3l103.5-103.4zm-103.4 194c-6.3-6.3-11-13.6-14.1-21.3H400L261.3 458.7c-25 25-65.5 25-90.5 0L53.3 341.3z"
        }
    ]
};

const FalFilmCanister = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilmCanister",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16h16v384H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm48 416V96h224v384H64zm320-280v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8zm8 152c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16zm88-152v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8zm-128-40h176c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16-26.5 0-48 21.5-48 48v32c0 8.8-7.2 16-16 16H352v32h112c26.5 0 48-21.5 48-48v-32c0-8.8 7.2-16 16-16 26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H352v32z"
        }
    ]
};

const FalFilmSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilmSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 352v96h256V64H128v288zm-32 16H32v48c0 17.7 14.3 32 32 32h32v-80zm0-32v-64H32v64h64zm0-96v-64H32v64h64zm0-96V64H64c-17.7 0-32 14.3-32 32v48h64zm320 128v64h64v-64h-64zm0 96v80h32c17.7 0 32-14.3 32-32v-48h-64zm0-128h64v-64h-64v64zm0-96h64V96c0-17.7-14.3-32-32-32h-32v80zM64 32h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalFilmSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilmSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.4 480 448 438.6v9.4H192V240H96v-79.3l-32-25.3V416c0 35.3 28.7 64 64 64h372.4zM139.6 32 192 73.4V64h256v208h96v79.3l32 25.3V96c0-35.3-28.7-64-64-64H139.6zM160 448h-32c-17.7 0-32-14.3-32-32v-48h64v80zM96 272h64v64H96v-64zm384-96h64v64h-64v-64zm0-32V64h32c17.7 0 32 14.3 32 32v48h-64z"
        }
    ]
};

const FalFilm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilm",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 448V272h256v176H128zm256-208H128V64h256v176zM96 448H64c-17.7 0-32-14.3-32-32v-48h64v80zM32 272h64v64H32v-64zm64-96v64H32v-64h64zm0-112v80H32V96c0-17.7 14.3-32 32-32h32zm320 272v-64h64v64h-64zm0 112v-80h64v48c0 17.7-14.3 32-32 32h-32zm0-272h64v64h-64v-64zm64-80v48h-64V64h32c17.7 0 32 14.3 32 32zm-32-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64z"
        }
    ]
};

const FalFilms = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilms",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 272v-48h224v128H224v-80zm0-80V64h224v128H224zM464 32H160c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64h-48zM160 64h32v64h-64V96c0-17.7 14.3-32 32-32zm-32 96h64v96h-64v-96zm0 160v-32h64v64h-32c-17.7 0-32-14.3-32-32zm384 32h-32v-64h64v32c0 17.7-14.3 32-32 32zm32-96h-64v-96h64v96zm0-128h-64V64h32c17.7 0 32 14.3 32 32v32zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 70.7 57.3 128 128 128h336c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"
        }
    ]
};

const FalFilterCircleDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilterCircleDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 39.5C0 17.7 17.7 0 39.5 0h433C494.3 0 512 17.7 512 39.5c0 9.2-3.2 18.1-9.1 25.2L394.2 196.1c-24.4 5.3-47 15.8-66.4 30.1L478.3 44.3c1.1-1.3 1.7-3 1.7-4.8 0-4.2-3.4-7.5-7.5-7.5h-433c-4.2 0-7.5 3.4-7.5 7.5 0 1.8.6 3.4 1.7 4.8l186.6 225.5c2.4 2.9 3.7 6.5 3.7 10.2v88.2l34 26.4c2.7 18.1 8.3 35.3 16.1 51.2-3.1-1.2-6.1-2.8-8.7-4.9l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3v-82.4L9.1 64.7C3.2 57.6 0 48.7 0 39.5zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-23.2 111.4c-.4.7-.9 1.6-.8 3.6v.1c0 .4 0 1.9 4.8 4.5 5.6 3 13.5 5.2 23.9 8.2h.2c9.3 2.6 21.1 6 30.5 11.5 10.2 6 20 16.1 20.5 32.3.5 18.2-9.7 30.4-21.7 36.9-5.8 3.1-12.1 5.1-18.3 6.2v10.8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-11.4c-8.6-1.7-16.7-4.3-23.7-6.6-1.7-.6-3.4-1.1-5-1.6-8.4-2.6-13.2-11.6-10.5-20s11.6-13.2 20-10.5c2 .6 3.9 1.2 5.8 1.8 11.4 3.6 20.4 6.5 29.9 6.8 6.7.2 13.8-1.1 18.5-3.6 2.2-1.2 3.4-2.4 4-3.3.5-.8 1.1-2.1 1-4.5 0-1.4-.2-3-4.7-5.6-5.3-3.1-12.9-5.4-23.2-8.3l-1.8-.5c-8.9-2.5-19.8-5.6-28.6-10.3-9.9-5.3-20.6-14.7-21.6-30.7-1.2-18.8 10-30.9 21.8-37.2 5.7-3.1 12-5.1 18-6.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v9.4c6.3.9 12.3 2.3 17.9 3.7 8.6 2.1 13.8 10.8 11.7 19.4s-10.8 13.8-19.4 11.7c-9.3-2.3-18.2-4-26.4-4.1-6.2-.1-13.6 1.3-18.7 4-2.4 1.3-3.6 2.5-4.2 3.4z"
        }
    ]
};

const FalFilterCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilterCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 39.5C0 17.7 17.7 0 39.5 0h433C494.3 0 512 17.7 512 39.5c0 9.2-3.2 18.1-9.1 25.2L394.2 196.1c-24.4 5.3-47 15.8-66.4 30.1L478.3 44.3c1.1-1.3 1.7-3 1.7-4.8 0-4.2-3.4-7.5-7.5-7.5h-433c-4.2 0-7.5 3.4-7.5 7.5 0 1.8.6 3.4 1.7 4.8l186.6 225.5c2.4 2.9 3.7 6.5 3.7 10.2v88.2l34 26.4c2.7 18.1 8.3 35.3 16.1 51.2-3.1-1.2-6.1-2.8-8.7-4.9l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3v-82.4L9.1 64.7C3.2 57.6 0 48.7 0 39.5zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalFilterList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilterList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M27.6 64C12.4 64 0 76.4 0 91.6c0 6.7 2.4 13.2 6.8 18.2L112 230v130c0 10 4.7 19.5 12.7 25.5l76.2 57.5c4.2 3.2 9.4 4.9 14.7 4.9 13.5 0 24.4-10.9 24.4-24.4V230l105.2-120.2c4.4-5 6.8-11.5 6.8-18.2 0-15.2-12.4-27.6-27.6-27.6H27.6zM140 213.5 37.3 96h277.4L212 213.5c-2.6 2.9-4 6.7-4 10.5v184.3L144 360V224c0-3.9-1.4-7.6-4-10.5zM336 400c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H336zm-16-144c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm80-176c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FalFilterSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilterSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm541 93.3c5.9-7.1 9.1-16 9.1-25.2 0-21.8-17.7-39.5-39.5-39.5H139.6l40.5 32h356.4c4.2 0 7.5 3.4 7.5 7.5 0 1.8-.6 3.4-1.7 4.8l-137 165.5 25.1 19.8L566.9 96.7zM352 362.8v83.3c0 1-.8 1.9-1.9 1.9-.4 0-.8-.1-1.1-.4l-61-47.4v-87.9L256 287v113.2c0 9.9 4.6 19.2 12.4 25.3l61 47.4c5.9 4.6 13.3 7.1 20.8 7.1 18.7 0 33.9-15.2 33.9-33.9v-58l-32-25.3z"
        }
    ]
};

const FalFilter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 71.5C0 49.7 17.7 32 39.5 32h433c21.8 0 39.5 17.7 39.5 39.5 0 9.2-3.2 18.1-9.1 25.2L320 317.8v128.3c0 18.7-15.2 33.9-33.9 33.9-7.5 0-14.8-2.5-20.8-7.1l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3v-82.4L9.1 96.7C3.2 89.6 0 80.7 0 71.5zM39.5 64c-4.2 0-7.5 3.4-7.5 7.5 0 1.8.6 3.4 1.7 4.8l186.6 225.5c2.4 2.9 3.7 6.5 3.7 10.2v88.2l61 47.4c.3.3.7.4 1.1.4 1 0 1.9-.8 1.9-1.9V312c0-3.7 1.3-7.3 3.7-10.2L478.3 76.3c1.1-1.3 1.7-3 1.7-4.8 0-4.2-3.4-7.5-7.5-7.5h-433z"
        }
    ]
};

const FalFilters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFilters",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M231.1 32C209.5 32 192 49.5 192 71.1c0 9.7 3.6 19.1 10.2 26.3L352 262.2v97.7c0 10.2 4.9 19.9 13.2 25.9l79.8 58c3.8 2.7 8.3 4.2 13 4.2 12.2 0 22-9.9 22-22V262.2L629.8 97.4c6.5-7.2 10.2-16.6 10.2-26.3 0-21.6-17.5-39.1-39.1-39.1H231.1zM224 71.1c0-3.9 3.2-7.1 7.1-7.1h369.8c3.9 0 7.1 3.2 7.1 7.1 0 1.8-.7 3.5-1.8 4.8l-154 169.4c-2.7 2.9-4.2 6.8-4.2 10.8v150.3l-64-46.5V256c0-4-1.5-7.8-4.2-10.8l-154-169.4c-1.2-1.3-1.8-3-1.8-4.8zM164.5 96H39.1C17.5 96 0 113.5 0 135.1c0 9.7 3.6 19.1 10.2 26.3L160 326.2v65.7c0 10.2 4.9 19.9 13.2 25.9l79.8 58c3.8 2.7 8.3 4.2 13 4.2 12.2 0 22-9.9 22-22V326.2l32-35.2v-16.4L305.8 259l-45.7 50.3c-2.7 2.9-4.2 6.8-4.2 10.8v118.3l-64-46.5V320c0-4-1.5-7.8-4.2-10.8L33.8 139.8c-1.2-1.3-1.8-3-1.8-4.8 0-3.9 3.2-7.1 7.1-7.1h147.7l-8.3-9.1c-6.1-6.7-10.8-14.5-14-22.9z"
        }
    ]
};

const FalFingerprint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFingerprint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32c70.3 0 133 32.4 174.1 83 5.6 6.9 15.6 7.9 22.5 2.4s7.9-15.6 2.4-22.5C408.1 37 336.3 0 256 0 114.6 0 0 114.6 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48zm470.8-68.3c-2.4-8.5-11.2-13.5-19.7-11.2s-13.5 11.2-11.2 19.7c5.2 19 8.1 39 8.1 59.7v48c0 8.8 7.2 16 16 16s16-7.2 16-16V256c0-23.6-3.2-46.5-9.2-68.3zM256 80c-22.8 0-44.6 4.3-64.6 12.2-9.7 3.8-12 16.1-5.2 24.1 4.8 5.6 12.8 7.2 19.7 4.6 15.6-5.8 32.5-9 50.1-9 79.5 0 144 64.5 144 144v24.9c0 28.3-1.8 56.6-5.5 84.6-1.3 9.7 6.2 18.5 16 18.5 7.9 0 14.6-5.8 15.6-13.6 3.9-29.6 5.8-59.5 5.8-89.5V256c0-97.2-78.8-176-176-176zm-110.9 62.1c-6-7-16.8-7.6-22.8-.5C95.9 172.3 80 212.3 80 256v24.9c0 27.8-3.4 55.4-10.2 82.3-2.6 10.4 5 20.8 15.7 20.8 7 0 13.2-4.6 15-11.4 7.7-29.9 11.6-60.7 11.6-91.7V256c0-34.7 12.3-66.5 32.7-91.4 5.4-6.5 5.9-16.1.3-22.5zM256 160c-53 0-96 43-96 96v24.9c0 38.6-5.4 77-15.9 114-3 10.4 4.7 21.1 15.5 21.1 6.9 0 13-4.5 14.9-11.1 11.6-40.2 17.5-82 17.5-124V256c0-35.3 28.7-64 64-64s64 28.7 64 64v24.9c0 38.8-3.9 77.5-11.7 115.4-2.1 10.1 5.5 19.7 15.8 19.7 7.4 0 13.9-5.1 15.4-12.4 8.3-40.3 12.5-81.4 12.5-122.7V256c0-53-43-96-96-96zm16 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v24.9c0 60.9-11.2 121.2-33.1 178.1l-5.9 15.3c-3.2 8.2.9 17.5 9.2 20.7s17.5-.9 20.7-9.2l5.9-15.3C260.1 410 272 345.7 272 280.9V256z"
        }
    ]
};

const FalFireBurner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFireBurner",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M349.4 93.5c-9.6.1-18.8-4.1-25-11.5-12.9-15.5-26.5-30-40.8-43.7-26.1 25-48 52.3-64 78.1-18.3 29.6-27.6 57.9-27.6 75.8 0 70.3 56.2 127.8 128 127.8 71 0 128-57.6 128-127.8 0-12.8-7-38.2-20.6-64.3-10.9-21.1-25.4-42.6-41.8-60.5-3.8 4.4-7.7 9.1-11.6 14-6 7.5-15.1 12-24.7 12.1zm-21.9-56.4c7.4 7.9 14.5 16 21.5 24.4 6.4-8.1 13.6-16.8 21.2-24.5 1.7-1.7 3.5-3.4 5.2-5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8 11.8 10.6 23.1 21.7 34 33.4zM285.1 96c4.8 0 9.4 2.2 12.4 6 2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1v.1c21.3 39.3 12.3 90.4-25 116.5l-.3.2C361.3 282 342.3 288 321 288c-25.9 0-50.2-8.4-68.2-24.8-18.1-16.6-28.8-40.5-28.8-69.2 0-15.7 5-29.7 13.4-44.2 8.2-14.1 20.2-29.5 35.1-47.9 3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L347 191l-12.6 9.9-.1-.2-.5-.6-1.8-2.4-6.6-8.5-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2-6.6 11.3-9.1 19.8-9.1 28.1 0 20.3 7.3 35.4 18.4 45.6 11.2 10.3 27.4 16.4 46.5 16.4 14.7 0 27.6-4 40-12.2 20.1-14.2 27.8-41.8 18.9-66.5zM32 272c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v96h512v-96h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16v114.7c18.6 6.6 32 24.4 32 45.3v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-32c0-20.9 13.4-38.7 32-45.3V272zm0 160v32c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm160-8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFireExtinguisher = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFireExtinguisher",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96V64l160-32v96L320 96zm-32-32h-96V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c-55.5 0-104.4 28.3-133 71.1-7.3 11-13.4 22.9-17.8 35.6-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8c3.6-10.1 8.4-19.7 14.3-28.4C76.5 118.6 115.6 96 160 96v33.1c-54.3 7.8-96 54.4-96 110.9v208c0 35.3 28.7 64 64 64h96c35.3 0 64-28.7 64-64V240c0-56.4-41.7-103.1-96-110.9V96h96c0 15.3 10.8 28.4 25.7 31.4l160 32c9.4 1.9 19.1-.6 26.6-6.6s11.7-15.2 11.7-24.7V32c0-9.6-4.3-18.7-11.7-24.7S483.1-1.2 473.7.7l-160 32c-15 3-25.7 16.1-25.7 31.4zm-112 96c44.2 0 80 35.8 80 80v144H96V240c0-44.2 35.8-80 80-80zm80 288c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-32h160v32z"
        }
    ]
};

const FalFireFlameCurved = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFireFlameCurved",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M53.9 186.1C19.4 220.6 0 267.4 0 316.2v11.5C0 429.5 82.5 512 184.3 512h15.1c102 0 184.6-82.6 184.6-184.6 0-66.1-27.1-129.2-74.9-174.8l-78.2-74.4c-9.5-9.1-14.9-21.6-14.9-34.8V21.3C216 9.6 206.4 0 194.7 0c-6.7 0-13 3.2-17.1 8.5l-19.5 26c-14.4 19.3-23.2 42.2-25.2 66.2l-.9 10.8c-.9 11.3-.4 22.5 1.6 33.5a128 128 0 0 0 16.4 43.3c.6 1.1 1.3 2.1 2 3.2 1.6 2.5 3.4 5 5.2 7.5l32 42.7c7 9.3 10.8 20.7 10.8 32.4v14c0 22.1-17.9 40-40 40s-40-17.9-40-40v-99.8c0-10.8-6.1-20.2-15-25-4-2.1-8.5-3.3-13.3-3.3-7.5 0-14.7 3-20 8.3l-17.8 17.8zM184.5 52.6c2.1 18.5 10.7 35.8 24.3 48.7l78.2 74.5c41.5 39.5 65 94.3 65 151.6 0 84.3-68.3 152.6-152.6 152.6h-15.1C100.2 480 32 411.8 32 327.7v-11.5c0-40.3 16-79 44.5-107.5L88 197.3V288c0 39.8 32.2 72 72 72s72-32.2 72-72v-14c0-18.6-6-36.7-17.2-51.6l-32-42.7c-14.1-18.8-20.8-42.1-18.9-65.6l.9-10.8c1.5-18 8-35.2 18.9-49.6l.8-1.1zm18.7-24.9-8.5-6.4 8.5 6.4z"
        }
    ]
};

const FalFireFlameSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFireFlameSimple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M341.8 265.5C310.2 178.6 258.9 100.2 192 36.4 125.1 100.2 73.8 178.6 42.2 265.5l-.7 1.9c-6.3 17.4-9.5 35.7-9.5 54.1C32 408.7 104.2 480 192 480s160-71.3 160-158.4c0-18.5-3.2-36.8-9.5-54.1l27.2-9.9-27.2 9.9-.7-1.9zm30.1-10.9.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3c72.9 68 128.7 152.4 162.7 246.1zM192 160c9.3 0 18.3 3.7 24.9 10.3l8.9 8.9c28.8 28.8 52.1 62.7 68.6 99.9l1.9 4.3c5 11.3 7.6 23.7 7.6 36C304 381.2 254 432 192 432S80 381.2 80 319.5c0-12.4 2.6-24.7 7.6-36l1.9-4.3c16.5-37.2 39.8-71.1 68.6-99.9l8.9-8.9c6.6-6.6 15.6-10.3 24.9-10.3zm-2.3 32.9-8.9 8.9c-26 26-47.1 56.6-62 90.3l-1.9 4.3c-3.2 7.2-4.9 15.1-4.9 23 0 44.3 35.9 80.5 80 80.5s80-36.2 80-80.5c0-7.9-1.7-15.8-4.9-23l-1.9-4.3c-15-33.6-36-64.3-62-90.3l-8.9-8.9c-.6-.6-1.4-.9-2.3-.9s-1.7.4-2.3.9z"
        }
    ]
};

const FalFireFlame = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFireFlame",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M341.8 265.5C310.2 178.6 258.9 100.2 192 36.4 125.1 100.2 73.8 178.6 42.2 265.5l-.7 1.9c-6.3 17.4-9.5 35.7-9.5 54.1C32 408.7 104.2 480 192 480s160-71.3 160-158.4c0-18.5-3.2-36.8-9.5-54.1l27.2-9.9-27.2 9.9-.7-1.9zm30.1-10.9.7 1.9c7.6 20.9 11.5 42.9 11.5 65.1C384 426.7 297.2 512 192 512S0 426.7 0 321.6c0-22.2 3.9-44.2 11.5-65.1l.7-1.9C46.2 160.8 102 76.5 174.9 8.5l3.3-3C181.9 2 186.9 0 192 0s10.1 2 13.8 5.5l3.3 3c72.9 68 128.7 152.4 162.7 246.1zM187.4 206v.6c0 16.1 6.3 31.6 17.5 43.3l8.2 8.5c9.9 10.3 15.5 24.1 15.5 38.4 0 30.5-24.7 55.3-55.3 55.3h-2.5c-31.9 0-57.7-25.8-57.7-57.7v-22.3c-11 12.2-17.1 28.1-17.1 44.7v3.2c0 53 43 96 96 96h7.3c49 0 88.7-39.7 88.7-88.7 0-27.9-12.2-54.3-33.4-72.4L210 216.8c-9.7-8.3-16.4-19.6-19-31.9-2.4 6.8-3.6 13.9-3.6 21.1zm9.9-78c13.5 0 24.4 10.9 24.4 24.4v20.2c0 7.6 3.3 14.9 9.1 19.8l44.6 38.1c28.3 24.2 44.6 59.5 44.6 96.7 0 66.7-54.1 120.8-120.7 120.8H192c-70.7 0-128-57.3-128-128v-3.2c0-27.9 11.8-54.6 32.6-73.3l5.3-4.8c4.8-4.3 10.9-6.7 17.4-6.7 14.3 0 25.9 11.6 25.9 25.9v36.4c0 14.2 11.5 25.7 25.7 25.7h2.5c12.8 0 23.3-10.4 23.3-23.3 0-6-2.3-11.8-6.5-16.1l-8.2-8.5c-17-17.6-26.4-41.1-26.4-65.5v-.6c0-13.9 3-27.6 8.9-40.2l10.9-23.6c4-8.6 12.6-14.1 22.1-14.1z"
        }
    ]
};

const FalFireHydrant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFireHydrant",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c8.8 0 16 7.2 16 16v17c57.9 7.2 103.8 53.1 111 111h17c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h17c7.2-57.9 53.1-103.8 111-111V16c0-8.8 7.2-16 16-16zm0 64c-47.6 0-87.1 34.6-94.7 80h189.4c-7.6-45.4-47.1-80-94.7-80zM32 496c0-8.8 7.2-16 16-16h16v-80H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h16v-32h32v272h192V208h32v32h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-16v80h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16zm288-128h16c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v96zm-256 0v-96H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h16zm160-48a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalFireSmoke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFireSmoke",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M349.4 93.5c9.6-.1 18.7-4.5 24.7-12.1 3.9-4.9 7.8-9.6 11.6-14 16.4 17.8 30.9 39.4 41.8 60.5C441 154 448 179.4 448 192.2c0 25.3-7.4 48.9-20.1 68.8 7.4 5.8 14.3 12.1 20.7 18.9 2.7-1.8 5.5-3.5 8.4-5.2 14.6-24.1 23-52.4 23-82.5 0-20.2-9.6-50.9-24.2-79-14.7-28.5-35.6-58.5-60.3-81.2-5.6-5.1-14.4-5.2-20 0-1.8 1.6-3.5 3.3-5.2 5-7.7 7.7-14.8 16.4-21.2 24.5-7-8.4-14.1-16.5-21.5-24.4-10.9-11.6-22.2-22.8-34-33.4-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 30 8.2 58.3 22.7 82.4 3 1.7 5.9 3.5 8.7 5.3 6.3-6.8 13.2-13.1 20.6-18.8-12.7-19.9-20-43.6-20-68.9 0-17.9 9.4-46.2 27.6-75.8 15.9-25.8 37.9-53.1 64-78.1 14.4 13.8 28 28.4 40.8 43.9 6.2 7.4 15.3 11.6 25 11.5zM224 194c0 19.2 4.8 36.3 13.5 50.5 9.5-5.1 19.6-9.3 30.1-12.6-7.1-9.6-11.5-22.2-11.5-38 0-8.3 2.5-16.8 9.1-28.1 4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.5 1.8 2.4.5.6.1.2L347 191l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1c6.9 19 3.9 39.8-7 54.8 10.5 3.3 20.5 7.5 30 12.6 16.2-27 17-62.2 1.3-91.1v-.1c-1.9-3.9-4.5-9-8.3-14.1-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5-3-3.8-7.6-6-12.4-6s-9.4 2.2-12.5 5.9c-14.9 18.4-26.9 33.8-35.1 47.9C229 164.3 224 178.3 224 194zm-10.1 170c15-44.2 56.9-76 106.1-76s91.1 31.8 106.1 76c2.1 6.2 7.7 10.5 14.2 10.8s12.6-3.2 15.4-9.1c12.9-27 40.4-45.7 72.3-45.7 44.2 0 80 35.8 80 80s-35.8 80-80 80H112c-44.2 0-80-35.8-80-80s35.8-80 80-80c31.9 0 59.4 18.7 72.3 45.7 2.8 5.9 8.9 9.5 15.4 9.1s12.1-4.7 14.2-10.8zM320 256c-52.6 0-98.6 28.2-123.7 70.3-20.5-23.5-50.7-38.3-84.3-38.3C50.1 288 0 338.1 0 400s50.1 112 112 112h416c61.9 0 112-50.1 112-112s-50.1-112-112-112c-33.6 0-63.8 14.8-84.3 38.3C418.6 284.2 372.6 256 320 256z"
        }
    ]
};

const FalFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFire",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M239.7 109.4c6.1 7.7 15.5 12.1 25.3 12s19.1-4.7 25.1-12.5c8.4-11 16.9-21.7 25.6-31.1 27.8 28.8 52.1 65.5 69.8 101.1 19.6 39.4 30.5 75.7 30.5 97.6C416 388.3 328.8 480 224 480c-106 0-192-91.6-192-203.5 0-29.9 14.4-70.8 40.9-115.4 24.7-41.6 59.3-85.3 100.2-124.7 23.5 22.7 45.7 47 66.6 73zm25-20c-6.9-8.6-13.9-17-21-25.2-18.1-20.6-37-40.2-56.7-58.7-7.8-7.3-19.9-7.3-27.7-.1-46.5 43.2-86 92.3-113.9 139.3C17.8 191.2 0 238.1 0 276.5 0 404.1 98.4 512 224 512c124.2 0 224-107.8 224-235.5 0-29.3-13.5-71.1-33.8-111.9-20.7-41.4-49.9-85-84.5-118-7.8-7.5-20.1-7.5-28-.1-5.7 5.4-11.2 11.3-16.5 17.4-7.3 8.4-14.2 17.2-20.5 25.5zM128 306.8c0-23.7 13-46.3 47.1-89.1 16.8 21.3 46.2 58.7 62.6 79.6 12.5 15.9 36.3 16.3 49.4 1l23.4-27.2c17.8 38.8 9.4 86.6-24.9 110.7-18.5 12.2-37.9 18.2-59.9 18.2-28.2 0-52.6-9-69.8-24.7-17-15.5-28-38.4-28-68.5zm72-109.2c-12.7-16.1-37-16.2-49.8-.1C116.8 239.4 96 270.3 96 306.8c0 38.5 14.3 70.2 38.4 92.1 23.9 21.8 56.4 33.1 91.3 33.1 28.5 0 54.1-8 77.7-23.7l.3-.2c51.2-35.7 59.1-104.2 33.9-154.6-10.7-21.4-37.3-19.7-49.9-5.1l-24.9 29c-16.5-21-46-58.5-62.8-79.8z"
        }
    ]
};

const FalFireplace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFireplace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0C14.3 0 0 14.3 0 32v64c0 17.7 14.3 32 32 32v352c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352c0-88.4 71.6-160 160-160s160 71.6 160 160v128c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zm544 128v352h-64V352c0-106-86-192-192-192s-192 86-192 192v128H64V128h512zM32 32h576v64H32V32zm309.4 300.7c9.6-.1 18.7-4.5 24.7-12.1l1.7-2.1c8.7 10.6 16.4 22.6 22.5 34.5 9.6 18.5 14 35.5 14 42.7 0 46.3-37.6 84.3-84.4 84.3-47.3 0-84.4-37.9-84.4-84.3 0-10.7 5.9-29.6 18.8-50.6 9.9-16.1 23.3-33.1 39.1-49.2 8 8 15.6 16.4 22.9 25.2 6.2 7.4 15.3 11.6 25 11.5zm77.3 5.6c-10.7-20.7-25.9-42.5-43.9-59-3.2-2.9-7.8-3.6-11.6-1.9-1.1.5-2.1 1.1-2.9 1.9-7 6.4-13.5 14.3-19.2 21.5-7-8.4-14.2-16.4-21.7-24.1-6-6.2-12.3-12.1-18.6-17.9-2-1.8-4.6-2.7-7.1-2.7-2.6 0-5.2.9-7.3 2.7-24.2 21.6-44.7 46.1-59.2 69.7-14.3 23.2-23.6 48.2-23.6 67.4 0 63.8 51.1 116.3 116.4 116.3 64.5 0 116.4-52.4 116.4-116.3 0-14.7-7-37-17.6-57.4zM307 353.4c-3.1-3.9-7.8-6.2-12.7-6.1s-9.6 2.4-12.6 6.3c-4.7 6.2-8.6 11.8-11.8 17.2-5.5 9.4-8.2 17.5-8.2 26.3s7.2 16 16 16 16-7.2 16-16c0-1 .1-2.8 1.8-6.4l18.8 24c5.9 7.5 14.9 12 24.5 12.2s18.8-3.9 25-11.2l9.6-11.2c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7l-9.6 11.2-21.5-27.4-11-14z"
        }
    ]
};

const FalFishBones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFishBones",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m42.4 141.5 27.3 22.8c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5l-45.4-38C40.3 98.1 34.6 96 28.7 96c-17.1 0-29.3 16.7-24 33L46 256 4.7 383c-5.3 16.3 6.8 33 24 33 5.9 0 11.6-2.1 16.1-5.8l-10.2-12.3 10.2 12.3 45.4-37.9c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2l-27.3 22.7 32-98.5H144v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h64v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h48v120.9c0 11.3 11.4 19 21.4 13.8 20.1-10.3 38.2-22.9 54-36.3 39.1-33 66.9-72.4 81-99.8 4.7-9.2 4.7-20.1 0-29.3-14.1-27.4-41.9-66.8-81-99.8-15.8-13.4-33.9-26-54-36.3-10.1-5.1-21.4 2.5-21.4 13.8v121h-48v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-64v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-64v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H74.5l-32-98.5zm405.3 117.7c.2-1 .3-2.1.3-3.2s-.1-2.2-.3-3.2V148.1c8.2 5.6 16 11.5 23.4 17.7 35.6 30 60.9 66.1 73.2 90.1v.3c-12.4 24-37.7 60.1-73.2 90.1-7.3 6.2-15.1 12.1-23.4 17.7V259.2z"
        }
    ]
};

const FalFishCooked = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFishCooked",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M143.4 191.2c21.4-23.6 49.6-47.6 80.7-65.6C255.3 107.5 288.4 96 320 96c51.6 0 108.2 26.5 152.4 61.5 22 17.4 40.2 36.4 52.9 54.3 13 18.4 18.7 33.7 18.7 44.2s-5.7 25.8-18.7 44.2c-12.6 17.9-30.9 36.9-52.9 54.3-44.2 35-100.8 61.5-152.4 61.5-31.6 0-64.7-11.5-95.9-29.6-31.1-18-59.3-42-80.7-65.6-5.4-5.9-14.3-7-20.9-2.4l-84.9 58.4 24.5-110.4c1.5-6.9 1.5-14 0-20.8L37.6 135.2l84.9 58.4c6.6 4.5 15.5 3.5 20.9-2.4zM320 64c-39.1 0-77.8 14.1-111.9 33.9-29.8 17.2-56.8 39.3-78.7 61.6l-85.7-58.9c-4.4-3-9.6-4.6-14.9-4.6C12 96-.5 111.6 3.2 128l27.6 124.5c.5 2.3.5 4.7 0 6.9L3.2 384c-3.6 16.4 8.8 32 25.6 32 5.3 0 10.5-1.6 14.9-4.6l-9.1-13.2 9.1 13.2 85.6-58.9c21.9 22.4 49 44.4 78.7 61.6 34.2 19.8 72.9 33.9 112 33.9 61.4 0 124.8-30.9 172.3-68.5 23.9-18.9 44.4-40.1 59.2-60.9 14.3-20.4 24.5-42.4 24.5-62.6s-10.2-42.2-24.5-62.6c-14.7-20.8-35.2-42-59.2-60.9C444.8 94.9 381.4 64 320 64zm-4.7 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm112 16c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm16 112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64z"
        }
    ]
};

const FalFishFins = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFishFins",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M247.8 148c13.4-6.2 20.8-20.8 17.9-35.3L256 64l77.6 58.2c4.9 3.7 10.8 5.9 16.9 6.3 47.2 3.4 88 23.2 120.3 47.5 35.5 26.7 60.8 58.7 73.2 80-12.4 21.3-37.6 53.3-73.2 80-32.3 24.2-73.1 44.1-120.3 47.5-6.1.4-12 2.6-16.9 6.3L256 448l9.7-48.6c2.9-14.5-4.5-29.1-17.9-35.3-17.1-7.9-32.7-17.6-46.6-28-13.8-10.4-26.1-21.6-36.8-32.8-10.2-10.7-26.5-13-39.3-5.5L32 352l45.8-80.1c5.6-9.8 5.6-21.9 0-31.8L32 160l93.1 54.3c12.8 7.5 29 5.2 39.3-5.5 10.7-11.2 23-22.4 36.8-32.8 13.9-10.5 29.6-20.2 46.6-28zM9.5 137.3c-10.3 10.2-12.5 26-5.3 38.6L50 256 4.2 336.1c-7.2 12.6-5 28.4 5.3 38.6s26.1 12.2 38.7 4.9l93.1-54.3c11.8 12.3 25.4 24.8 40.7 36.3 15.5 11.6 33 22.5 52.4 31.5l-9.7 48.6c-2.6 13 3.1 26.3 14.3 33.3s25.6 6.5 36.3-1.5l77.6-58.2c54.9-4 101.5-27 137.2-53.8 39.2-29.4 67.2-64.7 81.6-89.5 5.8-9.9 5.8-22.2 0-32.1-14.4-24.8-42.5-60.1-81.6-89.5-35.8-26.8-82.3-49.8-137.2-53.8l-77.7-58.2c-10.6-8-25-8.5-36.3-1.5S222 57.3 224.6 70.3l9.7 48.6c-19.4 9-36.9 19.9-52.4 31.5-15.3 11.5-29 23.9-40.7 36.3l-93.1-54.3c-12.5-7.3-28.4-5.3-38.7 4.9zM416 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalFish = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFish",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M162.4 306.8c11.1 13.4 24.1 26.8 38.7 39.2 35.5 30 81.4 54 134.8 54s99.3-24 134.8-54c35.5-30 60.8-66 73.2-90-12.4-24-37.6-60-73.2-90-35.5-30-81.4-54-134.8-54s-99.3 24-134.8 54c-14.6 12.4-27.6 25.8-38.7 39.2L145.1 226l-23.4-13.6L32 160l45.8 80.1 9.1 15.9-9.1 15.9L32 352l89.7-52.3 23.4-13.7 17.3 20.8zM4.2 336.1 50 256 4.2 175.9c-7.2-12.6-5-28.4 5.3-38.6s26.1-12.2 38.7-4.9l89.7 52.3c12.2-14.6 26.5-29.4 42.7-43.1C219.7 108.5 272.6 80 336 80s116.3 28.5 155.5 61.5c39.1 33 66.9 72.4 81 99.8 4.7 9.2 4.7 20.1 0 29.3-14.1 27.4-41.9 66.8-81 99.8C452.3 403.5 399.4 432 336 432s-116.3-28.5-155.5-61.5c-16.2-13.7-30.5-28.5-42.7-43.1l-89.7 52.2c-12.5 7.3-28.4 5.3-38.7-4.9s-12.4-26-5.2-38.6zM416 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFishingRod = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFishingRod",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280.4 32c-4 0-7.9.6-11.7 1.8l-64.5 19.8C130.4 76.3 80 144.5 80 221.8V288h8c22.1 0 40 17.9 40 40v144c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V328c0-22.1 17.9-40 40-40h8v-66.2C48 130.5 107.6 49.9 194.8 23l64.5-19.8c6.8-2.1 13.9-3.2 21.1-3.2C319.9 0 352 32.1 352 71.6V136c0 8.8-7.2 16-16 16s-16-7.2-16-16V71.6c0-21.9-17.7-39.6-39.6-39.6zm48.5 145.7c4.5-2.3 9.8-2.3 14.3 0 17.9 8.9 43.7 27.1 65.2 53.4C430 257.5 448 292.9 448 336c0 33.5-15.1 80.9-58.2 115.8l23.5 35.3c3.3 4.9 3.6 11.2.8 16.4s-8.2 8.5-14.1 8.5H272c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5.8-16.4l23.5-35.3C239.1 416.9 224 369.5 224 336c0-43.1 18-78.5 39.6-104.9 21.5-26.3 47.4-44.4 65.2-53.4zM256 336c0 27.3 13.9 70 56.9 98.7 7.4 4.9 9.3 14.8 4.4 22.2L301.9 480h68.2l-15.4-23.1c-4.9-7.4-2.9-17.3 4.4-22.2 43-28.7 56.9-71.4 56.9-98.7 0-33.7-14-62.3-32.4-84.7-15.6-19-33.8-33-47.6-41.1-13.8 8.1-32 22.1-47.6 41.1-18.4 22.4-32.4 51-32.4 84.7zM88 320H40c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zm272-32a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFlagCheckered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlagCheckered",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16v-99.8l101.8-27.8c36.4-9.9 75.1-6.1 108.8 10.8 48.7 24.4 105.7 26 155.8 4.6l30.2-12.9c11.8-5 19.4-16.6 19.4-29.4V59.3c0-24.4-26.4-39.8-47.6-27.6l-15.8 9c-40.6 23.2-90.2 24.6-132.1 3.7-37.9-18.9-81.4-23.2-122.2-12.1L32 59.1V16zm0 76.2L128 66v67.5l-96 20.9V92.2zm0 94.9 96-20.9v71.3l-96 20.9v-71.2zm128-27.8 3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6.5 3.2.9 4.8 1.3v70.7L228 233.7c-22.1-6.5-45.3-7.6-67.9-3.3v-71.1zm160 26.9c17.5 1.3 35.2-.1 52.5-4l43.5-10v71.2L365.3 255c-14.9 3.4-30.2 4.5-45.3 3.1v-71.9zm-32 98.6v77.3c-10.6-2.7-21-6.5-31-11.5-30.2-15.1-63.7-21.6-97-19v-68.3l3.5-.8c18.3-4 37.4-3.3 55.4 2l64.4 18.9c1.6.5 3.2.9 4.8 1.3zm32 81.8v-76.4c17.5 1.3 35.2-.1 52.5-4l43.5-10v65.3l-30.2 12.9c-21 9-43.5 13.1-65.8 12.3zm0-212.6V91c27.8-.8 55.5-8.4 80.4-22.6l15.6-8.8v79.7L365.3 151c-14.9 3.4-30.2 4.5-45.3 3.1zm-32-65v58.6l-60.1-17.7c-22.1-6.5-45.3-7.6-67.9-3.3V59.1c26.7-3 53.9 1.8 78.2 13.9 15.9 8 32.7 13.3 49.8 16zM32 291.2l96-20.9v66.6c-.9.2-1.7.4-2.6.7L32 363.1v-71.9z"
        }
    ]
};

const FalFlagPennant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlagPennant",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16V350.9l400.9-137.7c9.1-3.1 15.1-11.6 15.1-21.2s-6.1-18.1-15.1-21.2L32 33.1V16zm0 50.9L396.1 192 32 317.1V66.9z"
        }
    ]
};

const FalFlagSwallowtail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlagSwallowtail",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16V352h392c13.3 0 24-10.7 24-24 0-5.2-1.7-10.2-4.8-14.4L352 192l91.2-121.6c3.1-4.2 4.8-9.2 4.8-14.4 0-13.3-10.7-24-24-24H32V16zm0 48h376l-81.6 108.8a32.1 32.1 0 0 0 0 38.4L408 320H32V64z"
        }
    ]
};

const FalFlagUsa = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlagUsa",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16V392l96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4 44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0-35.1-17.6-75.4-22-113.5-12.5L32 56V16zm0 298.6 107.1-23c33.6-7.2 68.6-4.4 100.7 8.1l25.8 10c45.2 17.6 95.1 18.8 141.2 3.5l9.2-3.1v35.6l-34.7 13c-37.9 14.2-80 12-116.2-6.1-44.7-22.4-96-28-144.5-15.9L32 359v-44.4zm0-32.7v-39.3l102.2-21.9c36.4-7.8 74.3-3.9 108.4 11.3l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9v34.4l-19.3 6.4c-38.9 13-81.2 11.9-119.4-2.9l-25.8-10c-37.9-14.7-79.2-18-119-9.5L32 281.9zm0-72V89l108.7-27.2c6.4-1.6 12.8-2.7 19.3-3.3v126.6c-10.9.6-21.7 2-32.5 4.3L32 209.9zm160-24v-47.8c17.4 2.1 34.4 6.7 50.6 13.9l13.8 6.2c50.6 22.5 108 23.9 159.6 3.9v45.7l-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zm0-80V59.3c13.9 2 27.4 6.2 40.1 12.6 55.3 27.7 120.4 27.7 175.8 0l8.1-4.1v59.9l-11.3 4.4c-43.7 17-92.4 15.8-135.3-3.2l-13.8-6.2c-20.3-9-41.8-14.7-63.6-16.9zM88 120a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-32 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm32 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16V392l96.3-24.1c41.1-10.3 84.6-5.5 122.5 13.4 44.2 22.1 95.5 24.8 141.7 7.4l34.7-13c12.5-4.7 20.8-16.6 20.8-30V66.1c0-23-24.2-38-44.8-27.7l-9.6 4.8c-46.3 23.2-100.8 23.2-147.1 0-35.1-17.6-75.4-22-113.5-12.5L32 56V16zm0 73 108.7-27.2c30.7-7.7 63.1-4.1 91.4 10 55.3 27.7 120.4 27.7 175.8 0l8.1-4.1v278l-34.7 13c-37.9 14.2-80 12-116.2-6.1-44.7-22.4-96-28-144.5-15.9L32 359V89z"
        }
    ]
};

const FalFlashlight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlashlight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m401.8 325.4 31.5 21c24 16 50.8 27.1 78.7 32.9V132.7c-28 5.8-54.7 16.9-78.7 32.9l-31.5 21-8.1 5.4H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h345.7l8.1 5.4zM544 383.6c4.5.3 9 .4 13.5.4H592c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16h-34.5c-4.5 0-9 .1-13.5.4v255.2zM0 304v-96c0-26.5 21.5-48 48-48h336l31.5-21c42.1-28 91.5-43 142-43H592c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-34.5c-50.5 0-100-15-142-43L384 352H48c-26.5 0-48-21.5-48-48zm224-48c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalFlaskGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlaskGear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 196.8V32H160v164.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320h203.7c2.2 13.3 10.3 25 21.2 32H81.2l-43.7 71c-3.6 5.9-5.5 12.7-5.5 19.6 0 20.7 16.7 37.4 37.4 37.4H351c15.6 13.1 36.9 13.7 53 4.8v.9c0 6.7 1.5 13.5 4.2 19.7-9 4.3-19 6.6-29.7 6.6H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4l108.2-175.8c6.2-10.1 9.5-21.7 9.5-33.5V32h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v164.8c0 11.8 3.3 23.5 9.5 33.5L336 241c-4.9 6.4-9.5 13.1-13.6 20.3-1.9 3.3-3.7 6.6-5.4 10l-14.8-24.1c-9.3-15.2-14.2-32.6-14.2-50.4zm175.3 43c-3.1 16.6-14 29.5-26.6 36.7-13 7.4-30 9.9-46 3.7l-17.2 30.5c12.8 11.4 18.5 27.7 18.5 42.4s-5.7 31-18.5 42.4l17.2 30.5c15.9-6.3 33-3.7 46 3.7 12.6 7.2 23.6 20.1 26.6 36.7H497c3-16.6 13.9-29.5 26.5-36.7 12.9-7.4 30-9.9 45.9-3.6l17.2-30.5c-12.8-11.4-18.5-27.7-18.5-42.4s5.7-31 18.5-42.4l-17.2-30.5c-15.9 6.3-32.9 3.7-45.9-3.6-12.6-7.2-23.5-20.2-26.5-36.7h-33.7zm43.5-32c11.8 0 21.4 9.6 21.4 21.4v1.6c0 7.5 4.6 14.2 11.1 18 6.5 3.7 14.5 4.2 21 .3l1.8-1c10.7-6.3 24.4-2.6 30.5 8.2l26.4 46.8c5.7 10.2 2.3 23.1-7.8 29-7.3 4.3-11.2 12.6-11.2 21s3.9 16.7 11.2 21c10 5.9 13.5 18.8 7.8 29L592.5 450c-6.1 10.8-19.9 14.5-30.5 8.2l-1.8-1c-6.5-3.8-14.5-3.4-21 .3-6.5 3.7-11.1 10.4-11.1 18v1.5c0 11.8-9.6 21.4-21.4 21.4h-53.3c-11.7 0-21.3-9.5-21.3-21.3v-1.4c0-7.6-4.6-14.4-11.3-18.2-6.6-3.7-14.7-4.2-21.2-.3l-1.6 1c-10.7 6.3-24.4 2.6-30.5-8.2L341 403.1c-5.7-10.2-2.3-23.1 7.8-29 7.3-4.3 11.2-12.5 11.2-21s-3.9-16.7-11.2-21c-10-5.9-13.5-18.8-7.8-29l26.4-46.9c6.1-10.8 19.9-14.5 30.5-8.2l1.6 1c6.5 3.9 14.6 3.4 21.2-.3 6.6-3.8 11.3-10.6 11.3-18.2v-1.4c0-11.7 9.5-21.3 21.3-21.3h53.4zm-82.7 145.3a56 56 0 1 1 112.1 0 56 56 0 1 1-112.1 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalFlaskRoundPoison = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlaskRoundPoison",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32h128v125.7c0 18.2 10.1 33.7 24.4 42C364.9 230.3 400 287.1 400 352c0 47.4-18.7 90.4-49.2 122.1-3.1 3.2-8.8 5.9-17 5.9H114.2c-8.2 0-13.9-2.7-17-5.9C66.7 442.4 48 399.4 48 352c0-64.9 35.1-121.7 87.6-152.2 14.3-8.3 24.4-23.9 24.4-42V32zm160 125.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v125.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3 10.3 10.7 25.1 15.7 40 15.7h219.6c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9-5.2-3-8.5-8.4-8.5-14.4zM128 312c0-36.4 39.2-72 96-72s96 35.6 96 72c0 20.5-11.7 40.1-32.7 54-8.7 5.8-15.3 15.8-15.3 27.7V416h-96v-22.3c0-11.9-6.6-21.9-15.3-27.7-21-13.9-32.7-33.5-32.7-54zm96-104c-66.9 0-128 43.2-128 104 0 33.6 19.3 62.3 47.1 80.7.5.3.7.6.9.9.1.1.1.2.1.2V416c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32v-22.3s0-.1.1-.2c.1-.2.4-.6.9-.9 27.6-18.3 46.9-47 46.9-80.6 0-60.8-61.1-104-128-104zm64 104a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalFlaskRoundPotion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlaskRoundPotion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32h128v125.7c0 18.2 10.1 33.7 24.4 42C364.8 230.3 400 287 400 351.9c-55.6-1.3-87.4-15.5-115.7-30.1-2.9-1.5-5.7-3-8.6-4.5C248.3 302.9 220 288 176 288c-47 0-83.5 12.8-108.4 25.8-6.6 3.5-12.4 6.9-17.4 10.2 8.5-53 40.6-98.1 85.4-124.2 14.3-8.3 24.4-23.9 24.4-42V32zm237.1 351.8c-6.3 34.7-22.8 65.8-46.3 90.2-3.1 3.2-8.8 5.9-17 5.9H114.2c-8.2 0-13.9-2.7-17-5.9-27.6-28.6-45.5-66.5-48.7-108.5 1-.6 1.9-1.4 2.8-2.2l.2-.2c.3-.2.7-.6 1.3-1.2 1.2-1.1 3.2-2.7 5.8-4.7 5.2-4 13.2-9.5 23.8-15 21.1-11 52.6-22.2 93.6-22.2 35.8 0 57.7 11.4 85.1 25.8 2.8 1.4 5.6 2.9 8.5 4.4 30.6 15.8 66.7 31.9 127.5 33.6zM51.3 363.4zm0 0zM320 157.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v125.7c0 6-3.3 11.4-8.5 14.4C57.6 208.2 16 275.2 16 352c0 56 22.1 106.9 58.2 144.3 10.3 10.7 25.1 15.7 40 15.7h219.6c15 0 29.7-5 40.1-15.7C409.9 458.9 432 408 432 352c0-76.8-41.6-143.8-103.5-179.9-5.2-3-8.5-8.4-8.5-14.4z"
        }
    ]
};

const FalFlaskVial = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlaskVial",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 0 0 7.2 0 16s7.2 16 16 16h16v320c0 53 43 96 96 96 11.2 0 22-1.9 32-5.5 0-14.2 3-28.3 8.8-41.2-11.1 9.2-25.3 14.7-40.8 14.7-35.3 0-64-28.7-64-64V192h128v160c0 4-.4 7.8-1 11.6l33-53.7V32zM64 32h128v128H64V32zM304 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v187.5L201.8 411.6c-6.4 10.4-9.8 22.3-9.8 34.5 0 36.4 29.5 65.9 65.9 65.9h316.2c36.4 0 65.9-29.5 65.9-65.9 0-12.2-3.4-24.1-9.8-34.5L512 219.5V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm176 32v192c0 3 .8 5.9 2.4 8.4l53.9 87.6H295.7l53.9-87.6c1.6-2.5 2.4-5.4 2.4-8.4V32h128zM229 428.4l47-76.4h280l47 76.4c3.3 5.3 5 11.5 5 17.8 0 18.7-15.2 33.9-33.9 33.9H257.9c-18.7 0-33.9-15.2-33.9-33.9 0-6.3 1.7-12.4 5-17.8z"
        }
    ]
};

const FalFlask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlask",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 196.8V32H160v164.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320h246.2l-44.8-72.9c-9.4-15.1-14.3-32.5-14.3-50.3zM128 32h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v164.8c0 11.8 3.3 23.5 9.5 33.5l108.2 175.9a69.54 69.54 0 0 1 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4H69.4C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4l108.2-175.8c6.2-10.1 9.5-21.7 9.5-33.5V32zM37.5 423c-3.6 5.9-5.5 12.7-5.5 19.6 0 20.7 16.7 37.4 37.4 37.4h309.2c20.7 0 37.4-16.7 37.4-37.4 0-6.9-1.9-13.7-5.5-19.6l-43.7-71H81.2l-43.7 71z"
        }
    ]
};

const FalFlatbreadStuffed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlatbreadStuffed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m256.8 32 59.9 32.9c11.7 6.4 25.1 9 38.4 7.5l51.5-6.1 17.9-17.9c4.6-4.6 10-8.3 15.8-11.1-6.1-3.9-13.4-5.7-21-4.8l-67.9 8.1c-6.6.8-13.3-.5-19.2-3.7L272.2 4c-12.8-7-28.7-4.5-38.7 6.1l-46.9 49.8c-4.6 4.9-10.5 8.2-17.1 9.5l-67.1 13.3c-14.3 2.8-24.9 15-25.7 29.6l-3.8 68.3c-.4 6.7-2.8 13-7 18.2l-42.8 53.3c-9.1 11.4-9.4 27.5-.7 39.2l40.9 54.8c4 5.3 6.2 11.8 6.4 18.5l.9 41.2c2.6-4.9 5.9-9.4 9.9-13.3l21.3-21.5-.2-7.1c-.3-13.3-4.7-26.3-12.7-37L48 272.1l42.8-53.3c8.4-10.4 13.3-23.2 14-36.5l3.8-68.3 67.1-13.3c13.1-2.6 25-9.2 34.2-19L256.8 32zm169.9 104.7 36.6-36.6c29.7 39.8 48.8 87 48.8 139.9 0 132.5-107.5 240-240 240-52.9 0-100.1-19.1-139.9-48.8l79.6-79.6 86-86 86-86 43-43zm56.1-63.6c-4.3-5.4-10.6-8.6-17.4-9s-13.5 2.2-18.3 7l-43 43-43 43-86 86-86 86-86 86c-4.8 4.8-7.4 11.5-7 18.3s3.7 13.2 9 17.4C150.8 487.1 207.3 512 272 512c150.2 0 272-121.8 272-272 0-64.7-24.9-121.2-61.2-166.9zM272 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-48-48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-72-208c-66.3 0-120 53.7-120 120 0 27.2 9.1 52.3 24.3 72.5l22.9-22.9c-9.6-14.2-15.2-31.2-15.2-49.6 0-48.6 39.4-88 88-88 18.4 0 35.4 5.6 49.5 15.3l22.9-22.9C284.3 153.1 259.2 144 232 144z"
        }
    ]
};

const FalFlatbread = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlatbread",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm363.3-84.7-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-112-70.6c6.2 6.2 6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0zm160 182.6-128 128c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalFloppyDiskCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFloppyDiskCircleArrowRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96v320c0 17.7 14.3 32 32 32h211.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7s-10.7.2-16 .7v-22.2c0-8.5-3.4-16.6-9.4-22.6l-74.5-74.5c-3.4-3.4-7.6-6-12.1-7.6V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64c-17.7 0-32 14.3-32 32zm192 144c25.1 0 47.4 11.5 62.1 29.5-6.9 10.2-12.8 21.2-17.4 32.8-7-17.8-24.4-30.4-44.7-30.4-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6-.3 4.2-.4 8.4-.4 12.6 0 8.3.6 16.5 1.7 24.6-10.2 4.8-21.7 7.5-33.7 7.5-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64v96h192V64H96zm336 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-3.3 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalFloppyDiskCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFloppyDiskCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96v320c0 17.7 14.3 32 32 32h211.2c5.9 11.4 12.9 22.2 21 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v22.2c-5.3-.5-10.6-.7-16-.7s-10.7.2-16 .7v-22.2c0-8.5-3.4-16.6-9.4-22.6l-74.5-74.5c-3.4-3.4-7.6-6-12.1-7.6V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64c-17.7 0-32 14.3-32 32zm192 144c25.1 0 47.4 11.5 62.1 29.5-6.9 10.2-12.8 21.2-17.4 32.8-7-17.8-24.4-30.4-44.7-30.4-26.5 0-48 21.5-48 48s21.5 48 48 48c12.5 0 23.9-4.8 32.4-12.6-.3 4.2-.4 8.4-.4 12.6 0 8.3.6 16.5 1.7 24.6-10.2 4.8-21.7 7.5-33.7 7.5-44.2 0-80-35.8-80-80s35.8-80 80-80zM96 64v96h192V64H96zm448 304a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm166.6 0 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368z"
        }
    ]
};

const FalFloppyDiskPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFloppyDiskPen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96v320c0 17.7 14.3 32 32 32h202.3l-8 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h245.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3v49.7l-32 32v-81.7c0-8.5-3.4-16.6-9.4-22.6l-74.5-74.5c-3.4-3.4-7.6-6-12.1-7.6V160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64c-17.7 0-32 14.3-32 32zm64-32v96h192V64H96zm80 256a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm294.8-135.9c-6.2-6.2-16.4-6.2-22.6 0L471.3 289l40 40 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zM342.5 417.8c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.2c2.8-.7 5.4-2.2 7.4-4.2l106.3-106.2-40-40-106.2 106.2zm131-176.3c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 480.5c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3l153.7-153.7z"
        }
    ]
};

const FalFloppyDisk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFloppyDisk",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32v96c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V65.8c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm64-32h192v96H96V64zM0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3l-74.6-74.5c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zm272 224a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"
        }
    ]
};

const FalFloppyDisks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFloppyDisks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 352c0 17.7 14.3 32 32 32h288c17.7 0 32-14.3 32-32V138.5c0-8.5-3.4-16.6-9.4-22.6l-74.5-74.5c-3.4-3.4-7.6-6-12.1-7.6V112c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V32c-17.7 0-32 14.3-32 32v288zM352 32H192v80h160V32zM192 0h181.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V352c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h32zM32 112v256c0 61.9 50.1 112 112 112h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H144C64.5 512 0 447.5 0 368V112c0-8.8 7.2-16 16-16s16 7.2 16 16zm264 192a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm0-112a72 72 0 1 1 0 144 72 72 0 1 1 0-144z"
        }
    ]
};

const FalFlorinSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlorinSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M322.4 32c-32.1 0-61.2 19.2-73.7 48.8L188.2 224H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h126.6l-68.8 162.7C98.3 436.5 80.9 448 61.6 448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h45.6c32.1 0 61.2-19.2 73.7-48.8L209.4 256H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H222.9l55.3-130.7c7.5-17.8 24.9-29.3 44.2-29.3H368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-45.6z"
        }
    ]
};

const FalFlowerDaffodil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlowerDaffodil",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200 0c-48.6 0-88 39.4-88 88 0 21.3 7.6 40.8 20.1 56-12.6 15.2-20.1 34.7-20.1 56 0 48.6 39.4 88 88 88 14.4 0 28-3.5 40-9.6v118.2C200.8 331.5 129.5 288 48 288H28c-15.5 0-28 12.5-28 28 0 108.2 87.8 196 196 196h120c108.2 0 196-87.8 196-196 0-15.5-12.5-28-28-28h-20c-81.5 0-152.8 43.5-192 108.6V278.4c12 6.1 25.6 9.6 40 9.6 48.6 0 88-39.4 88-88 0-21.3-7.6-40.8-20.1-56 12.6-15.2 20.1-34.7 20.1-56 0-48.6-39.4-88-88-88-21.3 0-40.8 7.6-56 20.1C240.8 7.6 221.3 0 200 0zm-56 88c0-30.9 25.1-56 56-56 17.6 0 33.3 8.1 43.6 20.8 3 3.8 7.6 5.9 12.4 5.9s9.4-2.2 12.4-5.9C278.7 40.1 294.4 32 312 32c30.9 0 56 25.1 56 56 0 17.6-8.1 33.3-20.8 43.6-3.8 3-5.9 7.6-5.9 12.4s2.2 9.4 5.9 12.4c12.7 10.3 20.8 26 20.8 43.6 0 30.9-25.1 56-56 56-17.6 0-33.3-8.1-43.6-20.8-3-3.8-7.6-5.9-12.4-5.9s-9.4 2.2-12.4 5.9c-10.3 12.7-26 20.8-43.6 20.8-30.9 0-56-25.1-56-56 0-17.6 8.1-33.3 20.8-43.6 3.8-3 5.9-7.6 5.9-12.4s-2.2-9.4-5.9-12.4c-12.7-10.3-20.8-26-20.8-43.6zM32 320h16c95.1 0 174.1 69.2 189.3 160H196c-89.2 0-161.8-71.3-164-160zm448 0c-2.1 88.7-74.7 160-164 160h-41.3c15.2-90.8 94.2-160 189.3-160h16zM288 144a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FalFlowerTulip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlowerTulip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M268 5.4C264.9 2 260.6 0 256 0s-8.9 2-12 5.4l-54.5 61.3-68.3-47.8c-4.9-3.4-11.3-3.8-16.6-1.1S96 26 96 32v128c0 70.7 57.3 128 128 128h16v108.6C200.8 331.5 129.5 288 48 288H28c-15.5 0-28 12.5-28 28 0 108.2 87.8 196 196 196h120c108.2 0 196-87.8 196-196 0-15.5-12.5-28-28-28h-20c-81.5 0-152.8 43.5-192 108.6V288h16c70.7 0 128-57.3 128-128V32c0-6-3.3-11.4-8.6-14.2s-11.7-2.3-16.6 1.1l-68.3 47.8L268 5.4zM256 256h-32c-53 0-96-43-96-96V62.7l54.8 38.4c6.7 4.7 15.7 3.6 21.1-2.5l52-58.5 52 58.5c5.4 6.1 14.5 7.1 21.1 2.5l55-38.4V160c0 53-43 96-96 96h-32zm-60 224c-89.2 0-161.8-71.3-164-160h16c95.1 0 174.1 69.2 189.3 160H196zm120 0h-41.3c15.2-90.8 94.2-160 189.3-160h16c-2.1 88.7-74.7 160-164 160z"
        }
    ]
};

const FalFlower = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlower",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 168c0 33.6-12.2 64.3-32.3 88 20.1 23.7 32.3 54.4 32.3 88 0 75.1-60.9 136-136 136-33.6 0-64.3-12.2-88-32.3-23.7 20.1-54.4 32.3-88 32.3C60.9 480 0 419.1 0 344c0-33.6 12.2-64.3 32.3-88C12.2 232.3 0 201.6 0 168 0 92.9 60.9 32 136 32c33.6 0 64.3 12.2 88 32.3C247.7 44.2 278.4 32 312 32c75.1 0 136 60.9 136 136zM203.3 88.7C185.1 73.3 161.7 64 136 64 78.6 64 32 110.6 32 168c0 25.7 9.3 49.1 24.7 67.3 10.1 11.9 10.1 29.5 0 41.4C41.3 294.9 32 318.3 32 344c0 57.4 46.6 104 104 104 25.7 0 49.1-9.3 67.3-24.7 11.9-10.1 29.5-10.1 41.4 0 18.2 15.4 41.6 24.7 67.3 24.7 57.4 0 104-46.6 104-104 0-25.7-9.3-49.1-24.7-67.3-10.1-11.9-10.1-29.5 0-41.4 15.4-18.2 24.7-41.6 24.7-67.3 0-57.4-46.6-104-104-104-25.7 0-49.1 9.3-67.3 24.7-11.9 10.1-29.5 10.1-41.4 0zM272 256a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FalFlute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlute",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 320h416c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H160v128zm-32 0V192H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64zM64 160h512c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64zm256 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalFluxCapacitor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFluxCapacitor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm228.7 223.2c3.7.5 7.5.8 11.3.8 44.2 0 80-35.8 80-80s-35.8-80-80-80-80 35.8-80 80c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80c3.8 0 7.6-.3 11.3-.8L110 209.9c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0l46.1 46.1 46.1-46.1c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9l-45.3 45.3zm-118.9 18.5C155.6 288.4 144 310.8 144 336c0 44.2 35.8 80 80 80s80-35.8 80-80c0-25.2-11.6-47.6-29.8-62.3l-2.2 2.2V336c0 26.5-21.5 48-48 48s-48-21.5-48-48v-60.1l-2.2-2.2zm-18.5-109c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l75.3 75.3V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-73.4l75.3-75.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 233.4l-68.7-68.7z"
        }
    ]
};

const FalFlyingDisc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFlyingDisc",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M401.7 78.3c14.5 14.5 21.3 46 4.4 96.7-16.2 48.7-52 105.9-104.6 158.5s-109.7 88.4-158.4 104.6c-50.8 16.9-82.3 10-96.7-4.4-12.1-12.1-18.9-36.1-10.9-73.4 3 5.8 7 11.5 12.3 16.8 20 20 45.9 21.8 63.4 19.8 18.1-2 36.3-8.8 52.8-17 33.6-16.6 70.7-44.5 105.1-78.9s62.2-71.5 78.9-105.1c8.2-16.6 14.9-34.7 17-52.8 2-17.5.2-43.4-19.8-63.4-5.3-5.3-11-9.3-16.8-12.3 37.2-8 61.3-1.2 73.4 10.9zm-296.6 97.2C8.3 282-28.4 404.2 23.7 456.3c55.3 55.3 189.8 10.5 300.4-100.1S479.6 111 424.3 55.7C372.2 3.6 250 40.3 143.6 137c-6.7 6-13.3 12.3-19.8 18.8s-12.8 13.1-18.7 19.7zm23.7 21.5c5.7-6.2 11.5-12.4 17.6-18.5 6.1-6.1 12.3-12 18.5-17.7 26.8-24.2 54-43.2 78.1-55.2 14.8-7.3 29.2-12.4 42.2-13.9 13-1.5 27 .5 37.2 10.6s12.1 24.2 10.6 37.2c-1.5 13-6.5 27.4-13.9 42.2-14.7 29.7-40.3 64.1-72.8 96.7s-67 58.1-96.7 72.8c-14.8 7.3-29.2 12.4-42.2 13.9-13 1.5-27-.5-37.2-10.6s-12.1-24.2-10.6-37.2c1.5-13 6.5-27.4 13.9-42.2 12-24.1 31-51.3 55.2-78.1z"
        }
    ]
};

const FalFolderArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm208 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v121.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V208z"
        }
    ]
};

const FalFolderArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm208 214.6 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7V368c0 8.8 7.2 16 16 16s16-7.2 16-16V246.6z"
        }
    ]
};

const FalFolderBookmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderBookmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96v320c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-32v176c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6.7L336 289.9l-56.8 28.4c-5 2.5-10.9 2.2-15.6-.7s-7.6-8.1-7.6-13.6V117c-3.3-2.3-6.5-4.8-9.4-7.7l-35.9-35.9c-6-6-14.1-9.4-22.6-9.4H64c-17.7 0-32 14.3-32 32zm352 32h-92.1c-1.3 0-2.6 0-3.9-.1v150.2l40.8-20.4c4.5-2.3 9.8-2.3 14.3 0l40.9 20.4V128zm16-32h48c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h124.1c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4H400z"
        }
    ]
};

const FalFolderClosed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderClosed",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v32H32V96zm0 128h448v192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V224zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64z"
        }
    ]
};

const FalFolderGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderGear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm144 160v.7c0 1-.8 3.4-4.1 5.3-3.2 1.8-5.5 1.4-6.5.8l-.6-.3c-15.3-8.8-34.9-3.6-43.7 11.7l-16 27.7c-8.8 15.3-3.6 34.9 11.7 43.7l.6.3c.9.5 2.6 2.4 2.6 6.1s-1.6 5.6-2.6 6.1l-.6.3c-15.3 8.8-20.5 28.4-11.7 43.7l16 27.7c8.8 15.3 28.4 20.6 43.7 11.7l.6-.3c.9-.5 3.3-1 6.5.8 3.3 1.9 4.1 4.3 4.1 5.3v.7c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-.7c0-1 .8-3.4 4.1-5.3 3.2-1.8 5.5-1.4 6.5-.8l.6.3c15.3 8.8 34.9 3.6 43.7-11.7l16-27.7c8.8-15.3 3.6-34.9-11.7-43.7l-.6-.3c-.9-.5-2.6-2.4-2.6-6.1s1.6-5.6 2.6-6.1l.6-.3c15.3-8.8 20.6-28.4 11.7-43.7l-16-27.7c-8.8-15.3-28.4-20.5-43.7-11.7l-.6.3c-.9.5-3.3 1-6.5-.8-3.3-1.9-4.1-4.3-4.1-5.3v-.7c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v.7c0 15.1 9.4 26.8 20 33 10.7 6.2 25.5 8.3 38.5.8l.6-.3 16 27.7-.6.3c-13 7.5-18.6 21.4-18.6 33.8s5.5 26.3 18.6 33.8l.6.3-16 27.7-.6-.3c-13-7.5-27.8-5.4-38.5.8-10.6 6.2-20 17.9-20 33v.7h-32v-.7c0-15.1-9.4-26.8-20-33-10.7-6.2-25.5-8.3-38.5-.8l-.6.3-16-27.7.6-.3c13-7.5 18.6-21.4 18.6-33.8s-5.5-26.3-18.6-33.8l-.6-.3 16-27.7.6.3c13 7.5 27.8 5.4 38.5-.8 10.6-6.2 20-17.9 20-33v-.7h32zm8 96a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalFolderGrid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderGrid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm48 272v-32h32v32h-32zm-32-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zm160 40v-32h32v32h-32zm-32-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zm160 8h32v32h-32v-32zm-8-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48z"
        }
    ]
};

const FalFolderHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm112 221.3c0-16.2 13.1-29.3 29.3-29.3 7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6 16.2 0 29.3 13.1 29.3 29.3 0 7.8-3.1 15.2-8.6 20.7L256 345.4 184.6 274c-5.5-5.5-8.6-12.9-8.6-20.7zm29.3-61.3c-33.8 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"
        }
    ]
};

const FalFolderImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm88 160a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm135.9 32.1L380.3 352H131.5l44.6-63.8 19 25.4c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.5zm-25.5-19.4L208 277.3l-6.5-8.7c-6-8-15.4-12.7-25.3-12.7-10.3 0-20 5-26 13.5l-49.1 70.2c-3.3 4.7-5.1 10.4-5.1 16.2 0 15.6 12.6 28.2 28.2 28.2h263.7c15.5 0 28.1-12.6 28.1-28.1 0-5.9-1.9-11.7-5.3-16.4l-97-134.3c-6-8.3-15.6-13.2-25.8-13.2-10 0-19.4 4.7-25.5 12.7z"
        }
    ]
};

const FalFolderMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderMagnifyingGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm176 176a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160c20.7 0 39.9-6.6 55.6-17.7l45.1 45.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-45.1-45.1c11.2-15.8 17.8-35 17.8-55.7 0-53-43-96-96-96s-96 43-96 96 43 96 96 96z"
        }
    ]
};

const FalFolderMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm176 144c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48z"
        }
    ]
};

const FalFolderMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm96 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
        }
    ]
};

const FalFolderMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm281.1 146.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V251.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V192c0-5.2-2.6-10.2-6.9-13.2zM320 340c0 4.1-4.5 12-16 12s-16-7.9-16-12 4.5-12 16-12 16 7.9 16 12zm-128 32c0 4.1-4.5 12-16 12s-16-7.9-16-12 4.5-12 16-12 16 7.9 16 12z"
        }
    ]
};

const FalFolderOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 160v32h32v-32c0-35.3-28.7-64-64-64H298.5c-17 0-33.3-6.7-45.3-18.7l-26.5-26.6c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h400c19.6 0 37.3-11.9 44.6-30.2l64-160c5.9-14.8 4.1-31.5-4.8-44.7S543.9 224 528 224H128c-19.6 0-37.3 11.9-44.6 30.2L32 382.8V96c0-17.7 14.3-32 32-32h117.5c8.5 0 16.6 3.4 22.6 9.4l22.6-22.6-22.6 22.6 26.5 26.5c18 18 42.4 28.1 67.9 28.1H416c17.7 0 32 14.3 32 32zm-64 288H64c-5.3 0-10.3-2.6-13.2-7s-3.6-10-1.6-14.9l64-160c2.4-6.1 8.3-10.1 14.9-10.1H528c5.3 0 10.3 2.6 13.2 7s3.6 10 1.6 14.9l-64 160c-2.4 6.1-8.3 10.1-14.8 10.1h-80z"
        }
    ]
};

const FalFolderPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm176 352c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
        }
    ]
};

const FalFolderTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderTree",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16v352c0 26.5 21.5 48 48 48h208v-32H48c-8.8 0-16-7.2-16-16V128h224V96H32V16zm362.7 16 21.7 21.7C423 60.3 432 64 441.3 64H544v128H320V32h74.7zM288 32v160c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H441.3c-.8 0-1.7-.3-2.3-.9L417.4 9.4c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32zm32 288h74.7l21.7 21.7c6.6 6.6 15.6 10.3 24.9 10.3H544v128H320V320zm-32 0v160c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32H441.3c-.8 0-1.7-.3-2.3-.9l-21.7-21.7c-6-6-14.1-9.4-22.6-9.4H320c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalFolderUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderUser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm192 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 64h64c26.5 0 48 21.5 48 48 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2-35.8-80-80-80h-64c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FalFolderXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolderXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h124.1c8.5 0 16.6 3.4 22.6 9.4l35.9 35.9c12 12 28.3 18.7 45.3 18.7H448c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zm32-64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H291.9c-8.5 0-16.6-3.4-22.6-9.4l-35.9-35.9c-12-12-28.3-18.7-45.3-18.7H64zm116.7 180.7c-6.2 6.2-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 288l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 265.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalFolder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H291.9c-17 0-33.3-6.7-45.3-18.7l-35.9-35.9c-6-6-14.1-9.4-22.6-9.4H64zM0 96c0-35.3 28.7-64 64-64h124.1c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4H448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalFolders = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFolders",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 352H160c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h117.5c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c18 18 42.4 28.1 67.9 28.1H512c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32zM349.3 77.3l-26.6-26.6c-12-12-28.3-18.7-45.3-18.7H160c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H394.5c-17 0-33.3-6.7-45.3-18.7zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 70.7 57.3 128 128 128h336c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"
        }
    ]
};

const FalFonduePot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFonduePot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M282.1 32.3c-4.3-1.2-8.7 1.4-9.8 5.6l-24 88c-1.2 4.3 1.4 8.7 5.6 9.8s8.7-1.4 9.8-5.6l24-88c1.2-4.3-1.4-8.7-5.6-9.8zm-19.6 135.2-7.4 24.5h-33.4l9.7-32.4c-12.3-9.6-18.4-26-14-42.1l24-88c5.8-21.3 27.8-33.9 49.1-28.1s33.9 27.8 28.1 49.1l-24 88c-4.3 15.6-17.2 26.5-32.1 29zM223.4 256h1.2-1.2zm88 0h1.1-1.1zm65.7-88.6L361.5 192h-37.9l26.9-42.2c-8.3-12.7-8.9-29.6-.2-43.3l56-88C418.1-.1 442.8-5.6 461.5 6.3s24.1 36.6 12.3 55.2l-56 88c-8.9 14-25.2 20.6-40.6 17.9zm67.2-134.1c-3.7-2.4-8.7-1.3-11 2.5l-56 88c-2.4 3.7-1.3 8.7 2.5 11s8.7 1.3 11-2.5l56-88c2.4-3.7 1.3-8.7-2.5-11zM32 256v64c0 70.7 57.3 128 128 128h128c70.7 0 128-57.3 128-128v-64H160v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80H32zm-32 0c0-17.7 14.3-32 32-32h464c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v64c0 52.3-25.1 98.8-64 128v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-29.3c-19.6 8.6-41.2 13.3-64 13.3H160c-22.8 0-44.4-4.8-64-13.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48C25.1 418.8 0 372.3 0 320v-64z"
        }
    ]
};

const FalFontAwesome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFontAwesome",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v416c0 8.8 7.2 16 16 16s16-7.2 16-16V111.9c25.5-.8 50.8-5.3 75-13.3l35.3-11.8c13.4-4.5 27.5-6.8 41.7-6.8s28.3 2.3 41.7 6.8l46.7 15.6c19.2 6.4 39.4 9.7 59.6 9.7s40.4-3.3 59.6-9.7l24.4-8.2v270.3L381.5 376c-16 5.3-32.7 8-49.5 8s-33.5-2.7-49.5-8l-46.7-15.6c-16.7-5.6-34.2-8.4-51.8-8.4s-35.1 2.8-51.8 8.4l-25.2 8.4c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l25.2-8.4c13.4-4.5 27.5-6.8 41.7-6.8s28.3 2.3 41.7 6.8l46.7 15.6c19.2 6.4 39.4 9.7 59.6 9.7s40.4-3.3 59.6-9.7l45.4-15.1 10.9-3.6V49.8l-21.1 7L381.5 72c-16 5.3-32.7 8-49.5 8s-33.5-2.7-49.5-8l-46.7-15.6C219.1 50.8 201.6 48 184 48s-35.1 2.8-51.8 8.4L96.9 68.2c-21 7-42.8 10.9-64.9 11.7V48z"
        }
    ]
};

const FalFontCase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFontCase",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.9 42.3C188.6 36.1 182.6 32 176 32s-12.6 4.1-14.9 10.3l-160 416c-3.2 8.2.9 17.5 9.2 20.7s17.5-.9 20.7-9.2L76.2 352h199.6l45.3 117.7c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7l-160-416zM263.5 320h-175L176 92.6 263.5 320zM624 160c-8.8 0-16 7.2-16 16v34.7c-22.6-30.8-59-50.7-100-50.7-68.5 0-124 55.5-124 124v72c0 68.5 55.5 124 124 124 41 0 77.4-19.9 100-50.7V464c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zM416 284c0-50.8 41.2-92 92-92s92 41.2 92 92v72c0 50.8-41.2 92-92 92s-92-41.2-92-92v-72z"
        }
    ]
};

const FalFont = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFont",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M238.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8L37.4 448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H72.1l40.6-96h222.5l40.6 96H352c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-21.4L238.7 41.8zm83 278.2H126.3L224 89.1 321.7 320z"
        }
    ]
};

const FalFootballHelmet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFootballHelmet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m456 198.7-178.9 22.4c-30.3 3.8-53.1 29.6-53.1 60.1 0 9.4 2.2 18.7 6.4 27.1l38.2 76.4c2.2 4.4 3.4 9.3 3.4 14.3v.9c0 17.7-14.3 32-32 32h-2.9c-4.3 0-8.6-.9-12.6-2.6l-93.9-40.2c-8-3.4-16.5-5.2-25.2-5.2H92c-27.6-35.3-44-79.7-44-128C48 141.1 141.1 48 256 48c95 0 175.2 63.7 200 150.7zm6.4 31.4c17.5-2.2 30.2-18.3 25.7-35.3C461.1 91.9 367.4 16 256 16 123.5 16 16 123.5 16 256c0 56.3 19.4 108.1 51.9 149.1 5.7 7.1 14.4 10.9 23.5 10.9h14c4.3 0 8.6.9 12.6 2.6l93.9 40.2c8 3.4 16.5 5.2 25.2 5.2h2.9c35.3 0 64-28.7 64-64v-.9c0-9.9-2.3-19.7-6.8-28.6L288 352h39.7l9.6 50.9c10.1 54 57.2 93.1 112.1 93.1h17c25.2 0 45.6-20.4 45.6-45.6V368c0-26.5-21.5-48-48-48H354.3l-14-74.5 122.2-15.3zm-154 19.2 13.3 70.7H272l-13-26c-2-4-3-8.4-3-12.8 0-14.4 10.7-26.6 25.1-28.4l27.4-3.4zM200 336a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm280 48H366.3l-6-32H464c8.8 0 16 7.2 16 16v16zm-105.3 32H480v34.4c0 7.5-6.1 13.6-13.6 13.6h-17c-32.7 0-61.6-19.3-74.7-48z"
        }
    ]
};

const FalFootball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFootball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456.2 55.4c-48.9-8.2-92.4-10.8-130.9-8.7l139.5 139.5c3.4-47.1-.8-92.9-8.6-130.8zM220 67.1c-58.9 21.9-99.6 59-126.7 103.2-21.6 35.2-34.6 74.9-41.3 115l175.3 175.4.5.5c23.5-3.6 44.8-9.1 64.2-16.3 58.9-21.9 99.6-58.9 126.7-103.2 21.6-35.2 34.6-74.9 41.3-115L284.7 51.3l-.5-.5c-23.5 3.6-44.8 9.2-64.2 16.3zM47.2 325.8c-3.4 47.1.8 92.9 8.6 130.8 48.9 8.2 92.4 10.8 130.9 8.7L47.2 325.8zM208.9 37.1c65.5-24.3 148.7-30.6 252.6-13.3 13 2.2 23.4 12.1 26.1 25.1 17.5 84.8 18.6 211.3-41.6 309.5-30.6 50-76.8 92-142.9 116.5-65.6 24.3-148.7 30.7-252.6 13.3-13-2.2-23.4-12.1-26.1-25.1C6.9 378.3 5.8 251.8 66 153.6c30.6-50 76.8-92 142.9-116.5zm82.4 119.5 64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 56 64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-56 56 64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FalForkKnife = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalForkKnife",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m64 9.7 209.7 224.7-22.6 22.6L42.9 34C38.4 49 32 77.1 32 112c0 41 12.6 72.2 36.6 104.6 21 28.3 50.1 56.9 87.3 93.2 6.6 6.4 13.4 13.1 20.5 20.1l.1.1.8.8-22.6 22.6-.8-.8c-6.8-6.7-13.5-13.3-20-19.6-37-36.2-68.3-66.8-91-97.4C15.6 198.8 0 161.1 0 112c0-42.4 8.6-75.8 13.6-91.6C17.6 7.6 29.4 0 41.7 0 50.2 0 58.2 3.5 64 9.7zm420.3 497.2L316.6 327.3l22.6-22.6 168.5 180.4c6 6.5 5.7 16.6-.8 22.6s-16.6 5.7-22.6-.8zM468.9 6.5c5.2 7.1 3.7 17.1-3.4 22.4l-114.4 83.8c-3.1 2.3-6.1 4.8-8.8 7.6l-1.6 1.6C327.5 135.2 320 153.2 320 172s7.5 36.8 20.8 50.1l13.1 13.1c13.3 13.3 31.3 20.8 50.1 20.8s36.8-7.5 50.1-20.8l1.6-1.6c2.7-2.7 5.3-5.7 7.6-8.8l83.8-114.3c5.2-7.1 15.2-8.7 22.4-3.4s8.7 15.2 3.4 22.4l-83.8 114.3c-3.3 4.4-6.9 8.6-10.7 12.5l-1.6 1.6C457.5 277.2 431.3 288 404 288c-25 0-49.1-9.1-67.8-25.5L91.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l244.8-244.9C297.1 221.1 288 197 288 172c0-27.3 10.8-53.5 30.1-72.8l1.6-1.6c3.9-3.9 8.1-7.5 12.5-10.7L446.5 3.1c7.1-5.2 17.1-3.7 22.4 3.4zm39.1 31c5.8 6.7 5.1 16.8-1.5 22.6l-128 112c-6.6 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l128-112c6.7-5.8 16.8-5.1 22.6 1.5zM538.5 68c6.7 5.8 7.3 15.9 1.5 22.6l-112 128c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l112-128c5.8-6.7 15.9-7.3 22.6-1.5z"
        }
    ]
};

const FalFork = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFork",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M401.5 28.9c7.1-5.2 8.7-15.2 3.4-22.4s-15.2-8.7-22.4-3.4L268.2 86.9c-4.4 3.3-8.6 6.9-12.5 10.7l-1.6 1.6C234.8 118.5 224 144.7 224 172c0 25 9.1 49.1 25.5 67.8L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l244.9-244.8C290.9 278.9 315 288 340 288c27.3 0 53.5-10.8 72.8-30.1l1.6-1.6c3.9-3.9 7.5-8.1 10.7-12.5l83.8-114.3c5.2-7.1 3.7-17.1-3.4-22.4s-17.1-3.7-22.4 3.4l-83.8 114.4c-2.3 3.1-4.8 6.1-7.6 8.8l-1.6 1.6C376.8 248.5 358.8 256 340 256s-36.8-7.5-50.1-20.8l-13.1-13.1C263.5 208.8 256 190.8 256 172s7.5-36.8 20.8-50.1l1.6-1.6c2.7-2.7 5.7-5.3 8.8-7.6l114.3-83.8zm41 31.1c6.6-5.8 7.3-15.9 1.5-22.6s-15.9-7.3-22.6-1.5l-128 112c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l128-112zM476 90.5c5.8-6.7 5.1-16.8-1.5-22.6s-16.8-5.1-22.6 1.5l-112 128c-5.8 6.7-5.1 16.8 1.5 22.6s16.8 5.1 22.6-1.5l112-128z"
        }
    ]
};

const FalForklift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalForklift",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c-17.7 0-32 14.3-32 32v128H80c-44.2 0-80 35.8-80 80v176c0 53 43 96 96 96s96-43 96-96h64c0 53 43 96 96 96s96-43 96-96c0-28.4-12.4-54-32-71.6v-84.9c0-4.7-1-9.3-3-13.5L306.8 18.5C301.6 7.2 290.2 0 277.8 0H160zm-32 192h19.5l94.8 87.5c5.9 5.5 13.7 8.5 21.7 8.5h120v37.5c-10-3.5-20.8-5.5-32-5.5-41.8 0-77.4 26.7-90.5 64h-75c-13.2-37.3-48.7-64-90.5-64-24.6 0-47 9.2-64 24.4V240c0-26.5 21.5-48 48-48h48zm136 64-104-96V32h117.8l104.5 224H264zm88 224a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-256 0a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM512 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V16z"
        }
    ]
};

const FalFort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFort",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96h160v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM0 160c0 23.7 12.9 44.4 32 55.4V448c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V215.4c19.1-11.1 32-31.7 32-55.4V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v144c0 11.7 3.1 22.6 8.6 32H215.4c5.4-9.4 8.6-20.3 8.6-32V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v48H32V16c0-8.8-7.2-16-16-16S0 7.2 0 16v144zm400 320v-80c0-44.2-35.8-80-80-80s-80 35.8-80 80v80h-48V224h256v256h-48zm80-256h96v224c0 17.7-14.3 32-32 32h-64V224zM64 448V224h96v256H96c-17.7 0-32-14.3-32-32zm304 32h-96v-80c0-26.5 21.5-48 48-48s48 21.5 48 48v80zm240-320c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32V96h160v64z"
        }
    ]
};

const FalForwardFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalForwardFast",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 64c-8.8 0-16 7.2-16 16v135.8L301.4 70.2c-5-4-11.2-6.2-17.6-6.2-15.4 0-27.8 12.4-27.8 27.8v150.1L45.4 70.2c-5-4-11.2-6.2-17.6-6.2C12.4 64 0 76.4 0 91.8v328.4C0 435.6 12.4 448 27.8 448c6.4 0 12.6-2.2 17.6-6.2L256 270.1v150.1c0 15.4 12.4 27.8 27.8 27.8 6.4 0 12.6-2.2 17.6-6.2L480 296.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zm-17.3 192L288 411.4V100.6L478.7 256zM32 100.6 222.7 256 32 411.4V100.6z"
        }
    ]
};

const FalForwardStep = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalForwardStep",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 80c0-8.8 7.2-16 16-16s16 7.2 16 16v352c0 8.8-7.2 16-16 16s-16-7.2-16-16V296.2L77.4 441.8c-5 4-11.2 6.2-17.6 6.2-15.4 0-27.8-12.4-27.8-27.8V91.8C32 76.4 44.4 64 59.8 64c6.4 0 12.6 2.2 17.6 6.2L256 215.8V80zM64 100.6v310.8L254.7 256 64 100.6z"
        }
    ]
};

const FalForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalForward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M474.4 256 256 414.1V97.9L474.4 256zM254 64c-16.6 0-30 13.5-30 30v103.4L47.7 69.7C42.5 66 36.4 64 30 64 13.5 64 0 77.5 0 94v324c0 16.6 13.5 30 30 30 6.3 0 12.5-2 17.6-5.7L224 314.6V418c0 16.6 13.5 30 30 30 6.3 0 12.5-2 17.6-5.7l230.5-166.9c6.2-4.5 9.9-11.7 9.9-19.4s-3.7-14.9-9.9-19.4L271.7 69.7C266.5 66 260.4 64 254 64zm-30 211.1-192 139V97.9l192 139v38.2z"
        }
    ]
};

const FalFrame = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFrame",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 112c0-8.8-7.2-16-16-16h-48V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H96V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h256v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V128h48c8.8 0 16-7.2 16-16zM96 384V128h256v256H96z"
        }
    ]
};

const FalFrancSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFrancSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 32c-22.1 0-40 17.9-40 40v248H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v112c0 8.8 7.2 16 16 16s16-7.2 16-16V352h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H96v-96h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V72c0-4.4 3.6-8 8-8h200c8.8 0 16-7.2 16-16s-7.2-16-16-16H104z"
        }
    ]
};

const FalFrenchFries = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFrenchFries",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l64 32c5.4 2.7 8.8 8.3 8.8 14.3v218.4c-8.5 2.4-19 4.3-32 5.1V57.9l-32-16v229.6c-13-.9-23.5-2.7-32-5.1V16c0-5.5 2.9-10.7 7.6-13.6zm127.5 231.4c-1 4-2.9 9-7.1 14.1v-39.3l27.1-124.1-27.1 5.4V57.3l44.9-9c5.3-1.1 10.8.6 14.6 4.5s5.4 9.4 4.2 14.6l-28.4 130c-15.5 8-24.9 23.6-28 36.4zm83.5-41.8h-30.1l19.8-99.1c1.7-8.7 10.2-14.3 18.8-12.6s14.3 10.2 12.6 18.8L365.1 192c-.8 0-1.7-.1-2.5-.1zm-341.2 0c-.9 0-1.7 0-2.5.1L.3 99.1C-1.4 90.5 4.2 82 12.9 80.3S30 84.2 31.7 92.9L51.5 192H21.4zm98.8 63.6c-10.3-7.4-13.9-15.8-15.4-21.7-3-12.1-11.4-26.5-25.2-34.9L56.2 58.6c-1.2-6.9 2.3-13.8 8.6-16.9L112 18.1v35.8L89.7 65l31.9 191.5c-.5-.3-1-.7-1.4-1zM89.2 480h205.6l54.3-224h-9.8c-5.3 16.4-16.3 35.8-38.2 51.6-24.7 17.7-60 28.4-109.1 28.4s-84.4-10.7-109.1-28.4C61 291.8 50 272.4 44.7 256h-9.8l54.3 224zm-31.1 7.5L.6 250.5c-.4-1.7-.6-3.3-.6-5.1C0 233.6 9.6 224 21.4 224h32.9c9.5 0 17.2 8.3 19.5 17.5C79.6 265 102.7 304 192 304s112.4-39 118.2-62.5c2.3-9.2 10-17.5 19.5-17.5h32.9c11.8 0 21.4 9.6 21.4 21.4 0 1.7-.2 3.4-.6 5.1l-57.5 237c-3.5 14.4-16.3 24.5-31.1 24.5H89.2c-14.8 0-27.6-10.1-31.1-24.5z"
        }
    ]
};

const FalFrog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFrog",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 64c-26.5 0-48 21.5-48 48 0 .6 0 1.1-.1 1.7-.8 8-7.6 14.3-15.9 14.3h-3.2C152.3 128 32 248.3 32 396.8V416c0 17.7 14.3 32 32 32h272c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-4.1 0-8.2-1.6-11.3-4.7-6.2-6.2-6.2-16.4 0-22.6l8.8-8.8c1.7-1.7 3.2-3.4 4.7-5.3 8.9-11.1 13.8-25 13.8-39.4 0-12.5-3.7-24.2-9.9-34-11.2-17.5-30.9-29.2-53.3-29.2-16.8 0-32.8 6.7-44.7 18.5l-40.8 40.8c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l40.8-40.8c17.8-17.9 42.1-27.9 67.3-27.9 20.7 0 39.9 6.6 55.5 17.9 24 17.3 39.7 45.5 39.7 77.3 0 17.4-4.7 34.2-13.5 48.9 25.3 1.3 45.5 22.3 45.5 47.9 0 26.5-21.5 48-48 48H64c-35.3 0-64-28.7-64-64v-19.2C0 234.4 128.6 102.1 289.6 96.2 296.9 59.6 329.2 32 368 32c41.4 0 75.4 31.4 79.6 71.7 38.1 7.3 69.1 18.5 90.1 27.6C562.6 142 576 166.7 576 192c0 25.5-13.4 49.1-35.2 62.2l-117.1 70.2L519.8 448H560c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-4.9 0-9.6-2.3-12.6-6.2l-112-144c-2.8-3.6-3.9-8.3-3.1-12.8s3.6-8.4 7.5-10.8l132.6-79.5c12.2-7.3 19.7-20.5 19.7-34.7 0-14.4-7.5-26.4-19-31.4-21.5-9.3-54.8-21.1-95.7-27.7-8.2-1.3-14.1-8.7-13.4-17.1.1-1.3.2-2.6.2-3.9 0-26.5-21.5-48-48-48zm0 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalFunction = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFunction",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 80c0-44.2 35.8-80 80-80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-26.5 0-48 21.5-48 48v112h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v174.1c0 41.1-31.1 75.5-72 79.6l-22.4 2.2c-8.8.9-16.6-5.5-17.5-14.3s5.5-16.6 14.3-17.5l22.4-2.2c24.5-2.5 43.2-23.2 43.2-47.8V224H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V80zm221.5 80.5C272.8 206.1 256 260.9 256 320s16.8 113.9 45.5 159.5c4.7 7.5 2.5 17.4-5 22.1s-17.4 2.5-22.1-5C242.5 445.9 224 385.2 224 320s18.5-125.9 50.5-176.5c4.7-7.5 14.6-9.7 22.1-5s9.7 14.6 5 22.1zm260.9 0c-4.7-7.5-2.5-17.4 5-22.1s17.4-2.5 22.1 5c32 50.7 50.5 111.4 50.5 176.6s-18.5 125.9-50.5 176.5c-4.7 7.5-14.6 9.7-22.1 5s-9.7-14.6-5-22.1C591.2 433.9 608 379.1 608 320s-16.8-113.9-45.5-159.5zm-183.1 84.2 52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FalFutbol = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalFutbol",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M299.3 475.8c.1-.8.2-1.7.4-2.6l21.7-85.8c1.5-5.9 1.4-12.4-2.2-17.3l-3.9-5.3c-6.6-9.1-18.5-12.2-29.8-12.2h-59.1c-11.3 0-23.1 3.1-29.8 12.2l-3.9 5.3c-3.6 4.9-3.7 11.4-2.2 17.3l21.7 85.8c.2.9.4 1.7.4 2.6 14 2.7 28.5 4.2 43.3 4.2s29.3-1.4 43.3-4.2zm35.3-10c38.3-14.3 71.6-38.8 96.6-70.2l-72.5-4.8c-1.4-.1-2.8.3-4 1.2s-2 2.1-2.3 3.4l-17.8 70.5zm117.1-100.7c13.9-24.9 23.2-52.7 26.7-82.3-.8-.3-1.5-.7-2.3-1.2l-74.9-47.1c-5.1-3.2-11.3-5.1-17.1-3.3l-6.3 2c-10.7 3.5-17.3 13.8-20.8 24.5L338.8 314c-3.5 10.7-4.2 22.9 2.4 32l3.9 5.3c3.6 4.9 9.7 7 15.8 7.4l88.3 5.9c.9.1 1.7.2 2.6.4zm28.1-119c-1.8-41.9-15.1-80.7-36.9-113.6l-27 67.5c-.5 1.3-.6 2.7-.2 4.1v.2c.5 1.3 1.3 2.4 2.5 3.2l61.5 38.7zm-59.6-142.5c-19.7-21.2-43.4-38.6-70-50.9-.6.6-1.2 1.3-1.9 1.8l-68 56.6c-4.7 3.9-8.4 9.2-8.4 15.3v6.6c0 11.2 7.8 20.7 16.9 27.3l47.9 34.8c9.1 6.6 20.5 11.1 31.2 7.6l6.3-2c5.8-1.9 9.7-7.1 11.9-12.7l32.9-82.1c.3-.8.7-1.6 1.1-2.3zM315.7 40.1c-19-5.3-39.1-8.1-59.7-8.1s-40.7 2.8-59.7 8.1l55.8 46.5c1.1.9 2.5 1.4 3.9 1.4s2.8-.5 3.9-1.4l55.8-46.5zm-154 12.7c-26.6 12.3-50.3 29.7-70 50.9.4.7.8 1.5 1.1 2.3l33 82c2.3 5.6 6.2 10.8 11.9 12.7l6.3 2c10.7 3.5 22.1-1 31.2-7.6l47.9-34.8c9.1-6.6 16.9-16.1 16.9-27.3v-6.6c0-6.1-3.7-11.4-8.4-15.3l-68-56.6c-.7-.6-1.3-1.2-1.9-1.8zm-92.6 79.7C47.4 165.3 34 204.2 32.2 246.1l61.5-38.7c1.2-.7 2.1-1.9 2.5-3.2v-.2c.4-1.3.4-2.8-.2-4.1l-27-67.4zM33.6 282.8c3.5 29.6 12.8 57.4 26.7 82.3.8-.2 1.7-.3 2.6-.4l88.3-5.9c6.1-.4 12.2-2.5 15.8-7.4l3.9-5.3c6.6-9.1 5.9-21.4 2.4-32L155 257.8c-3.5-10.7-10.1-21.1-20.8-24.5l-6.3-2c-5.8-1.9-12 0-17.1 3.3l-74.9 47c-.7.5-1.5.9-2.3 1.2zm47.2 112.8c25 31.4 58.3 55.9 96.6 70.2l-17.8-70.5c-.3-1.4-1.2-2.6-2.3-3.4s-2.6-1.2-4-1.2l-72.5 4.8zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm241.9-69.8L194 221c-8.4 6.1-11.9 16.9-8.7 26.8l18.3 56.3c3.2 9.9 12.4 16.6 22.8 16.6h59.2c10.4 0 19.6-6.7 22.8-16.6l18.3-56.3c3.2-9.9-.3-20.7-8.7-26.8l-47.9-34.8c-8.4-6.1-19.8-6.1-28.2 0z"
        }
    ]
};

const FalG = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalG",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64C118 64 32 150 32 256s86 192 192 192c98.5 0 179.8-74.3 190.7-169.9.2-1.5-.3-2.8-1.4-4-1.2-1.2-3.1-2.2-5.3-2.2H242.3c-8.8 0-16-7.2-16-16s7.2-16 16-16H408c21.5 0 41.3 17.9 38.5 41.8C433.7 393.4 339 480 224 480 100.3 480 0 379.7 0 256S100.3 32 224 32c57.4 0 109.7 21.6 149.3 57 6.6 5.9 7.1 16 1.3 22.6s-16 7.1-22.6 1.3C318 82.5 273.2 64 224 64z"
        }
    ]
};

const FalGalaxy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGalaxy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 184c0-83.9 68.1-152 152-152h12.8c-36.8 27.2-62.2 66.6-72.1 110.5-1.4 6 .9 12.3 5.8 16.1s11.5 4.5 17.1 1.7c20.5-10.4 43.7-16.3 68.4-16.3 83.9 0 152 68.1 152 152v12.8c-27.2-36.9-66.6-62.2-110.5-72.1-6-1.4-12.3.9-16.2 5.8s-4.5 11.5-1.7 17.1c10.5 20.5 16.4 43.7 16.4 68.4 0 83.9-68.1 152-152 152h-12.8c36.9-27.2 62.2-66.6 72.1-110.5 1.4-6-.9-12.3-5.8-16.2s-11.5-4.5-17.1-1.7C231.9 362.1 208.7 368 184 368c-83.9 0-152-68.1-152-152v-12.8c27.2 36.9 66.6 62.2 110.5 72.1 6 1.4 12.3-.9 16.1-5.8s4.5-11.5 1.7-17.1C149.9 231.9 144 208.7 144 184zM296 0C194.4 0 112 82.4 112 184c0 17.2 2.4 33.9 6.8 49.7-24.3-11.1-45.7-28.3-61.8-50.5L48.1 171c-5-6.9-13-11-21.5-11C11.9 160 0 171.9 0 186.6V216c0 101.6 82.4 184 184 184 17.2 0 33.9-2.4 49.7-6.8-11.1 24.3-28.4 45.7-50.6 61.8l9.4 12.9-9.3-12.9-12.2 8.9c-6.9 5-11 13-11 21.5 0 14.7 11.9 26.6 26.6 26.6H216c101.6 0 184-82.4 184-184 0-17.2-2.4-33.9-6.8-49.7 24.3 11.1 45.7 28.4 61.8 50.6l8.9 12.2c5 6.9 13 11 21.5 11 14.7 0 26.6-11.9 26.6-26.6V296c0-101.6-82.4-184-184-184-17.2 0-33.9 2.4-49.7 6.8 11.1-24.3 28.4-45.7 50.6-61.8l12.1-8.9c6.9-5 11-13 11-21.5C352 11.9 340.1 0 325.4 0H296zm-40 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32-64a32 32 0 1 1 64 0 32 32 0 1 1-64 0z"
        }
    ]
};

const FalGalleryThumbnails = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGalleryThumbnails",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h448zM64 0C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm0 448v32H32v-32h32zm-32-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32H32zm160 32h32v32h-32v-32zm-32 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm224 0v32h-32v-32h32zm-32-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm160 32h32v32h-32v-32zm-32 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalGameBoardSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGameBoardSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 144h112V128H96v112zm144-120v120h120c13.3 0 24 10.7 24 24v128c0 13.3-10.7 24-24 24H232c-13.3 0-24-10.7-24-24V272H88c-13.3 0-24-10.7-24-24V120c0-13.3 10.7-24 24-24h128c13.3 0 24 10.7 24 24zm0 264h112V272H240v112z"
        }
    ]
};

const FalGameBoard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGameBoard",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 16v32h64v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h64v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-64v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-64v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 128h64v-64h-64v64zm96 0h64v-64h-64v64zm0 32v64h64v-64h-64zm-32 0h-64v64h64v-64z"
        }
    ]
};

const FalGameConsoleHandheldCrank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGameConsoleHandheldCrank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zm384 32v160h32v-96c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32v48c0 8.8-7.2 16-16 16h-48v128c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64zM96 128v128h256V128H96zm-32 0c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zm448 64h32v-32h-32v32zM128 336v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalGameConsoleHandheld = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGameConsoleHandheld",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v352c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v352c0 53-43 96-96 96H96c-53 0-96-43-96-96V64zm96 160h192V96H96v128zM64 80c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v144c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V80zm144 280a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM96 304c0-8.8 7.2-16 16-16s16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16z"
        }
    ]
};

const FalGamepadModern = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGamepadModern",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 352h208c14.7 0 27.5 10 31 24.2l3.6 14.3c8.4 33.8 38.8 57.4 73.6 57.4 41.9 0 75.8-33.9 75.8-75.8v-2.8c0-4.5-.4-8.9-1.1-13.3l-32.8-190.7c-7-40.7-32.2-71.3-66.5-79.9C464.1 74.5 401.1 64 320 64S175.9 74.5 132.4 85.4c-34.4 8.5-59.6 39.1-66.5 79.9L33.1 356.1c-.8 4.4-1.1 8.8-1.1 13.3v2.8c0 41.9 33.9 75.8 75.8 75.8 34.8 0 65.1-23.7 73.6-57.4l3.6-14.3c3.6-14.2 16.4-24.2 31-24.2zm211.6 46.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3.5-12.5 1.6-18.7l32.7-190.9c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM208 160v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16zm200 112a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalGamepad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGamepad",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 96c-88.4 0-160 71.6-160 160s71.6 160 160 160h256c88.4 0 160-71.6 160-160S536.4 96 448 96H192zM0 256C0 150 86 64 192 64h256c106 0 192 86 192 192s-86 192-192 192H192C86 448 0 362 0 256zm208-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16zm200 112a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalGarageCar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGarageCar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0l262.1 110.4c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v272c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H128v272c0 8.8-7.2 16-16 16s-16-7.2-16-16V224zm156.9 75.1L238.4 344h163.2L387 299.1c-2.1-6.6-8.3-11.1-15.2-11.1H268.2c-6.9 0-13.1 4.5-15.2 11.1zm164.6-9.9 20.6 63.6c15.6 9.9 25.9 27.4 25.9 47.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H208v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-19.8 10.3-37.3 25.9-47.2l20.6-63.6c6.4-19.8 24.9-33.2 45.7-33.2h103.6c20.8 0 39.2 13.4 45.7 33.2zM208 448h224v-48c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24v48zm24-32a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm160-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalGarageOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGarageOpen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M313.8 36c4-1.7 8.4-1.7 12.4 0l262.2 110.4c11.9 5 19.6 16.6 19.6 29.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16V175.9c0-25.8-15.4-49-39.2-59L338.6 6.5c-11.9-5-25.3-5-37.3 0L39.2 116.9c-23.8 10-39.2 33.2-39.2 59V496c0 8.8 7.2 16 16 16s16-7.2 16-16V175.9c0-12.9 7.7-24.5 19.6-29.5L313.8 36zM128 192c-17.7 0-32 14.3-32 32v272c0 8.8 7.2 16 16 16s16-7.2 16-16V288h384v208c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-17.7-14.3-32-32-32H128zm384 64H128v-32h384v32zm-299.5 64-10.6 32.8c-15.6 9.9-25.9 27.4-25.9 47.2v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h224v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-19.8-10.3-37.3-25.9-47.2L427.5 320h-33.7l7.8 24H238.4l7.8-24h-33.7zM432 400v48H208v-48c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24zm-184 32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm160-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalGarage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGarage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0l262.1 110.4c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v272c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V224zm32 96h384v-96H128v96zm144 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalGarlic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGarlic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48c0-8.8 7.2-16 16-16h32v38.2c0 51.4 18.4 101.1 51.9 140.2l17.1 19.9c17.5 20.4 27.1 46.5 27.1 73.3C336 365.6 285.8 416 224 416c-61.9 0-112-50.1-112-112v-5.3c0-24.4 7.6-48.3 21.8-68.2l15.2-21.2c24.6-34.5 39.2-75 42.3-117.1.4-3.6.6-7.3.6-11V48zm-32 0v27.2c0 4.7-.2 9.3-.5 14-2.1 16.4-10.4 31.6-23.5 42l-83.3 66.6C19.4 224.5 0 264.8 0 307.5 0 385.1 62.9 448 140.5 448h3.5v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h3.5c77.6 0 140.5-62.9 140.5-140.5 0-42.7-19.4-83-52.7-109.7L376 131.2c-15.2-12.1-24-30.5-24-50V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48zM72.7 222.8l61-48.8c-3.3 5.7-6.8 11.3-10.7 16.7l-15.2 21.2C89.7 237.3 80 267.6 80 298.7v5.3c0 45.1 20.7 85.4 53.2 111.8C76.7 412 32 365 32 307.5c0-33 15-64.1 40.7-84.7zM371.5 416h-57.2C347 389.5 368 348.9 368 303.7c0-34.5-12.3-68-34.8-94.2l-17.1-19.9C287.7 156.4 272 114 272 70.2V32h32c8.8 0 16 7.2 16 16v33.2c0 29.2 13.3 56.7 36 75l83.3 66.6c25.7 20.6 40.7 51.8 40.7 84.7 0 59.9-48.6 108.5-108.5 108.5z"
        }
    ]
};

const FalGasPumpSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGasPumpSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 362.8V480H128V186l-32-25.3V480H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-91.9l-32-25.3zM144.6 36c4.6-2.5 9.8-4 15.4-4h160c17.7 0 32 14.3 32 32v135.7l32 25.3V64c0-35.3-28.7-64-64-64H160c-15.9 0-30.4 5.8-41.6 15.3L144.6 36zM576 157.1c0-17.9-7.5-35.1-20.8-47.2l-80.4-73.7c-6.5-6-16.6-5.5-22.6 1s-5.5 16.6 1 22.6L480 84.4V160c0 35.3 28.7 64 64 64v127.3l32 25.3V157.1zm-64-43.4 21.6 19.8c6.6 6.1 10.4 14.6 10.4 23.6V192c-17.7 0-32-14.3-32-32v-46.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalGasPump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGasPump",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c17.7 0 32 14.3 32 32v128H64V64c0-17.7 14.3-32 32-32h160zm32 192v256H64V224h224zM32 64v416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V288h16c26.5 0 48 21.5 48 48v48c0 35.3 28.7 64 64 64s64-28.7 64-64V157.1c0-17.9-7.5-35.1-20.8-47.2l-80.4-73.7c-6.5-6-16.6-5.5-22.6 1s-5.5 16.6 1 22.6L416 84.4V160c0 35.3 28.7 64 64 64v160c0 17.7-14.3 32-32 32s-32-14.3-32-32v-48c0-44.2-35.8-80-80-80h-16V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64zm448 128c-17.7 0-32-14.3-32-32v-46.3l21.6 19.8c6.6 6.1 10.4 14.6 10.4 23.6V192z"
        }
    ]
};

const FalGaugeCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeCircleBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480c32.2 0 62.8-6.8 90.5-19 5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c119.4 0 219.6 81.7 248 192.2-2.6-.1-5.3-.2-8-.2-8.4 0-16.7.6-24.8 1.7C444.3 100.3 358.1 32 256 32 132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62V96c0-8.8 7.2-16 16-16s16 7.2 16 16v194c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm272-112a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm264 224a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm191.9-81c4.3 3.7 5.4 9.9 2.6 14.9L516.4 356H552c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9l30.1-54.1H440c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1.6z"
        }
    ]
};

const FalGaugeCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeCircleMinus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480c32.2 0 62.8-6.8 90.5-19 5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c119.4 0 219.6 81.7 248 192.2-2.6-.1-5.3-.2-8-.2-8.4 0-16.7.6-24.8 1.7C444.3 100.3 358.1 32 256 32 132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62V96c0-8.8 7.2-16 16-16s16 7.2 16 16v194c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm272-112a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm152 336a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalGaugeCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480c32.2 0 62.8-6.8 90.5-19 5.8 9.3 12.5 18 19.8 26.1C333 503 295.5 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c119.4 0 219.6 81.7 248 192.2-2.6-.1-5.3-.2-8-.2-8.4 0-16.7.6-24.8 1.7C444.3 100.3 358.1 32 256 32 132.3 32 32 132.3 32 256s100.3 224 224 224zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62V96c0-8.8 7.2-16 16-16s16 7.2 16 16v194c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64zM144 120a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM72 256a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm272-112a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm264 224a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalGaugeHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeHigh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-416a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-56 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-18.6-7.9-35.3-20.5-47l82.6-153.4c4.2-7.8 1.3-17.5-6.5-21.7s-17.5-1.3-21.7 6.5l-82.6 153.4c-4.9-1.2-10-1.8-15.3-1.8-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64zM168 144a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM96 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm344-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalGaugeLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-480a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm24 96a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-56 256a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-32 0c0-18.6 7.9-35.3 20.5-47l-82.6-153.4c-4.2-7.8-1.3-17.5 6.5-21.7s17.5-1.3 21.7 6.5l82.6 153.4c4.9-1.2 10-1.8 15.3-1.8 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64zm200-208a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm24 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-296 24a24 24 0 1 1-48 0 24 24 0 1 1 48 0z"
        }
    ]
};

const FalGaugeMax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeMax",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-480a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm24 96a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-56 256a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-32 0c0-35.3 28.7-64 64-64 17.5 0 33.4 7 44.9 18.4l106.9-64.1c7.6-4.5 17.4-2.1 22 5.5s2.1 17.4-5.5 22l-106.9 64c1.7 5.8 2.6 11.9 2.6 18.2 0 35.3-28.7 64-64 64s-64-28.7-64-64zm200-208a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM96 232a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72-88a24 24 0 1 1-48 0 24 24 0 1 1 48 0z"
        }
    ]
};

const FalGaugeMin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeMin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-416a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-56 256a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-35.3-28.7-64-64-64-17.5 0-33.4 7-44.9 18.4l-106.9-64.1c-7.6-4.5-17.4-2.1-22 5.5s-2.1 17.4 5.5 22l106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2 0 35.3 28.7 64 64 64s64-28.7 64-64zM168 144a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm248 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24-136a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalGaugeSimpleHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeSimpleHigh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64 0-18.6-7.9-35.3-20.5-47l82.6-153.4c4.2-7.8 1.3-17.5-6.5-21.7s-17.5-1.3-21.7 6.5l-82.6 153.4c-4.9-1.2-10-1.8-15.3-1.8-35.3 0-64 28.7-64 64s28.7 64 64 64z"
        }
    ]
};

const FalGaugeSimpleLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeSimpleLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-480a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64 0-18.6 7.9-35.3 20.5-47l-82.6-153.4c-4.2-7.8-1.3-17.5 6.5-21.7s17.5-1.3 21.7 6.5l82.6 153.4c4.9-1.2 10-1.8 15.3-1.8 35.3 0 64 28.7 64 64s-28.7 64-64 64z"
        }
    ]
};

const FalGaugeSimpleMax = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeSimpleMax",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480a224 224 0 1 0 0-448 224 224 0 1 0 0 448zm0-480a256 256 0 1 1 0 512 256 256 0 1 1 0-512zm0 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64s28.7-64 64-64c17.5 0 33.4 7 44.9 18.4l106.9-64.1c7.6-4.5 17.4-2.1 22 5.5s2.1 17.4-5.5 22l-106.9 64c1.7 5.8 2.6 11.9 2.6 18.2 0 35.3-28.7 64-64 64z"
        }
    ]
};

const FalGaugeSimpleMin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeSimpleMin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64s-28.7-64-64-64c-17.5 0-33.4 7-44.9 18.4l-106.9-64.1c-7.6-4.5-17.4-2.1-22 5.5s-2.1 17.4 5.5 22l106.8 64.1c-1.7 5.8-2.6 11.9-2.6 18.2 0 35.3 28.7 64 64 64z"
        }
    ]
};

const FalGaugeSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGaugeSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64 0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v194c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64z"
        }
    ]
};

const FalGauge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGauge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96c35.3 0 64-28.7 64-64 0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v194c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64zM144 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24 88a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-24-136a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalGavel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGavel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M315.3 4.7c6.2 6.2 6.2 16.4 0 22.6L302.6 40 472 209.4l12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-24 24-96 96-24 24c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l12.7-12.7L184 158.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24-24 96-96 24-24c6.2-6.2 16.4-6.2 22.6 0zM206.6 136 376 305.4l73.4-73.4L280 62.6 206.6 136zM144 320 32 432l48 48 112-112-48-48zm-22.6-22.6c12.5-12.5 32.8-12.5 45.3 0l12.7 12.7 49.8-49.8 22.6 22.6-49.8 49.8 12.7 12.7c12.5 12.5 12.5 32.8 0 45.3l-112 112c-12.5 12.5-32.8 12.5-45.3 0l-48-48c-12.5-12.5-12.5-32.8 0-45.3l112-112z"
        }
    ]
};

const FalGearCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGearCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M225.7 34c-1.1 1-1.9 2.3-2.4 3.8l-13.7 47.7c-3.5 12.1-12.2 21.1-22.5 26.1-7.6 3.6-14.8 7.8-21.7 12.5-9.4 6.5-21.7 9.5-33.9 6.5l-48.2-12c-1.5-.4-3-.3-4.4.2-5.4 6.9-10.4 14.2-15 21.8l-4.2 7.3c-4.2 7.5-7.9 15.3-11.2 23.4.3 1.5 1 2.9 2.1 4L85.2 211c8.7 9 12.2 21.1 11.3 32.5-.3 4.1-.5 8.3-.5 12.5s.2 8.4.5 12.5c.9 11.4-2.6 23.5-11.3 32.5l-34.5 35.8c-1.1 1.1-1.8 2.5-2.1 4 3.3 8 7 15.8 11.2 23.4l4.2 7.3c4.6 7.6 9.6 14.8 15 21.8 1.4.5 2.9.5 4.4.2l48.2-12c12.2-3 24.4 0 33.9 6.5 6.9 4.7 14.1 8.9 21.7 12.5 10.3 4.9 19.1 14 22.5 26.1l13.7 47.7c.4 1.5 1.3 2.8 2.4 3.8 9.9 1.3 20 2 30.3 2s20.4-.7 30.3-2c1.1-1 1.9-2.3 2.4-3.8l13.7-47.7c3.5-12.1 12.2-21.1 22.5-26.1 7.6-3.6 14.8-7.8 21.7-12.5 9.4-6.5 21.7-9.5 33.9-6.5l48.2 12c1.5.4 3 .3 4.4-.2 5.4-6.9 10.4-14.2 14.9-21.8l4.2-7.3c4.2-7.5 7.9-15.3 11.2-23.4-.3-1.5-1-2.9-2.1-4L426.8 301c-8.7-9-12.2-21.1-11.3-32.5.3-4.1.5-8.3.5-12.5s-.2-8.4-.5-12.5c-.9-11.4 2.6-23.5 11.3-32.5l34.5-35.7c1.1-1.1 1.8-2.5 2.1-4-3.3-8-7-15.8-11.2-23.3l-4.3-7.4c-4.6-7.6-9.5-14.8-14.9-21.8-1.4-.5-2.9-.5-4.4-.2l-48.2 12c-12.2 3-24.4 0-33.9-6.5-6.9-4.7-14.1-8.9-21.7-12.5-10.3-4.9-19.1-14-22.5-26.1l-13.6-47.7c-.4-1.5-1.3-2.8-2.4-3.8-9.9-1.3-20-2-30.3-2s-20.4.7-30.3 2zm-8.1-31.1C230.1 1 243 0 256 0s25.9 1 38.4 2.9c1.7.3 3.4.8 5 1.6 9.5 4.9 16.9 13.6 20 24.5l13.7 47.7c.6 2.2 2.5 4.5 5.6 6 9.1 4.3 17.8 9.4 26 15 2.8 1.9 5.8 2.4 8 1.8l48.2-12c10.9-2.7 22.1-.7 31.1 5.1 1.5.9 2.8 2.1 3.9 3.5 7.1 8.9 13.6 18.2 19.5 28l.1.3 4.5 7.6.1.3c5.4 9.7 10.2 19.9 14.3 30.4.6 1.6 1 3.3 1.1 5 .5 10.8-3.3 21.6-11.2 29.8l-34.5 35.7c-1.6 1.7-2.7 4.4-2.4 7.8a188.025 188.025 0 0 1 0 30c-.3 3.4.8 6.2 2.4 7.8l34.5 35.7c7.9 8.2 11.7 19 11.2 29.8-.1 1.7-.5 3.4-1.1 5-4.1 10.5-8.9 20.6-14.3 30.4l-.1.3-4.4 7.6-.1.3c-5.9 9.8-12.4 19.2-19.5 28-1.1 1.4-2.4 2.6-3.9 3.5-9 5.7-20.2 7.8-31.1 5.1l-48.2-12c-2.2-.6-5.2-.1-8 1.8-8.2 5.7-16.9 10.7-26 15-3.1 1.5-4.9 3.8-5.6 6L319.4 483c-3.1 10.8-10.5 19.5-20 24.5-1.6.8-3.2 1.4-5 1.6C281.9 511 269 512 256 512s-25.9-1-38.4-2.9c-1.7-.3-3.4-.8-5-1.6-9.5-4.9-16.9-13.6-20-24.5l-13.7-47.7c-.6-2.2-2.5-4.5-5.6-6-9.1-4.3-17.8-9.4-26-15-2.8-1.9-5.8-2.4-8-1.8l-48.2 12c-10.9 2.7-22.1.7-31.1-5.1-1.5-.9-2.8-2.1-3.9-3.5-7.1-8.9-13.7-18.3-19.6-28.1l-.1-.3L32 380l-.1-.3c-5.4-9.8-10.2-19.9-14.3-30.4-.6-1.6-1-3.3-1.1-5-.5-10.8 3.3-21.6 11.2-29.8l34.5-35.7c1.6-1.7 2.7-4.4 2.4-7.8-.4-5-.6-10-.6-15s.2-10.1.6-15c.3-3.4-.8-6.2-2.4-7.8l-34.5-35.8c-7.9-8.2-11.7-19-11.2-29.8.1-1.7.5-3.4 1.1-5 4.1-10.5 8.9-20.6 14.3-30.4l.1-.3 4.4-7.6.1-.3c5.9-9.7 12.5-19 19.6-27.9 1.1-1.4 2.4-2.6 3.9-3.5 9-5.7 20.2-7.8 31.1-5.1l48.2 12c2.2.6 5.2.1 8-1.8 8.2-5.7 16.9-10.7 26-15 3.1-1.5 4.9-3.8 5.6-6L192.6 29c3.1-10.8 10.5-19.5 20-24.5 1.6-.8 3.2-1.4 5-1.6zm70.2 159.8-32 192c-1.5 8.7-9.7 14.6-18.4 13.2s-14.6-9.7-13.2-18.4l32-192c1.5-8.7 9.7-14.6 18.4-13.2s14.6 9.7 13.2 18.4zm-100.5 64.6L158.6 256l28.7 28.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6l40-40c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm160-22.6 40 40c6.2 6.2 6.2 16.4 0 22.6l-40 40c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FalGearComplexCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGearComplexCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m215 62.8 4.9-24.3-15.7-3.1 15.7 3.1c.3-1.5 1-2.8 1.9-3.8 11.1-1.8 22.6-2.7 34.2-2.7s23.1.9 34.2 2.6c1 1.1 1.6 2.4 1.9 3.8l4.9 24.4c2.9 14.4 13.2 25.2 25.5 30.3l1.5.6c12.3 5.2 27.3 4.8 39.5-3.3l20.6-13.8c1.2-.8 2.6-1.3 4.1-1.3 9.1 6.7 17.7 14 25.6 21.9l.8.8c7.9 8 15.3 16.5 21.9 25.6-.1 1.4-.5 2.8-1.3 4.1l-13.8 20.6c-8.1 12.2-8.5 27.1-3.3 39.5l.6 1.5c5.1 12.4 15.9 22.6 30.3 25.5l24.3 4.9c1.5.3 2.8 1 3.8 1.9 1.7 11.1 2.6 22.4 2.6 34v.4c0 11.6-.9 22.9-2.6 34-1.1 1-2.4 1.6-3.8 1.9l-24.1 5.1c-14.4 2.9-25.2 13.2-30.3 25.5l-.6 1.5c-5.2 12.3-4.8 27.3 3.3 39.5l13.8 20.6c.8 1.2 1.3 2.6 1.3 4.1-13.6 18.5-29.9 34.9-48.4 48.4-1.4-.1-2.8-.5-4.1-1.3l-20.6-13.8c-12.2-8.1-27.1-8.5-39.5-3.3l-1.5.6c-12.4 5.1-22.6 15.9-25.5 30.3l-4.9 24.3c-.3 1.5-1 2.8-1.9 3.8-11.1 1.7-22.6 2.6-34.2 2.6s-23.1-.9-34.2-2.6c-1-1.1-1.6-2.4-1.9-3.8l-5-24.2c-2.9-14.4-13.2-25.2-25.5-30.3l-1.5-.6c-12.3-5.2-27.3-4.8-39.5 3.3l-20.6 13.8c-1.2.8-2.6 1.3-4.1 1.3-18.5-13.6-34.9-29.9-48.4-48.4.1-1.4.5-2.8 1.3-4.1l13.8-20.6c8.1-12.2 8.5-27.1 3.3-39.5l-.6-1.5c-5.1-12.4-15.9-22.6-30.3-25.5l-24.3-4.9c-1.5-.3-2.8-1-3.8-1.9-1.9-11.2-2.8-22.7-2.8-34.3s.9-23.1 2.6-34.2c1.1-1 2.4-1.6 3.8-1.9l24.4-4.9c14.4-2.9 25.2-13.2 30.3-25.5l.6-1.5c5.2-12.3 4.8-27.3-3.3-39.5l-13.8-20.8c-.8-1.2-1.3-2.6-1.3-4.1 6.7-9.1 14-17.7 22-25.7l.8-.8c8-7.9 16.6-15.3 25.7-22 1.4.1 2.8.5 4.1 1.3l20.6 13.8c12.2 8.1 27.1 8.5 39.5 3.3l1.5-.6c12.4-5.1 22.7-15.9 25.5-30.3zM256 0c-14.8 0-29.3 1.3-43.4 3.7-2 .3-3.9 1-5.6 2.1-9.4 5.6-16.3 15.1-18.6 26.4l-4.9 24.3c-.5 2.6-2.6 5.4-6.3 6.9h-.1l-1.7.7h-.1c-3.7 1.5-7.1 1-9.4-.4L145.5 50c-9.6-6.4-21.2-8.2-31.7-5.6-1.9.5-3.8 1.3-5.4 2.5-11.8 8.3-22.8 17.5-33 27.6l-.8.8c-10.2 10.3-19.4 21.3-27.7 33-1.2 1.6-2 3.5-2.5 5.4-2.6 10.6-.8 22.1 5.6 31.7L63.8 166c1.5 2.2 2 5.7.4 9.4v.1l-.7 1.7v.1c-1.5 3.7-4.3 5.8-6.9 6.3l-24.3 4.9c-11.4 2.3-20.8 9.2-26.4 18.6-1 1.7-1.7 3.6-2.1 5.6C1.3 226.7 0 241.2 0 256s1.3 29.3 3.7 43.4c.3 2 1 3.9 2.1 5.6 5.6 9.4 15.1 16.3 26.4 18.6l24.3 4.9c2.6.5 5.4 2.6 6.9 6.3v.1l.7 1.7v.1c1.5 3.7 1 7.1-.4 9.4L50 366.5c-6.4 9.6-8.2 21.2-5.6 31.7.5 1.9 1.3 3.8 2.5 5.4 16.8 23.8 37.6 44.6 61.5 61.5 1.6 1.2 3.5 2 5.4 2.5 10.6 2.6 22.1.8 31.7-5.6l20.6-13.8c2.2-1.5 5.7-2 9.4-.4h.1l1.7.7h.1c3.7 1.5 5.8 4.3 6.3 6.9l4.9 24.3c2.3 11.4 9.2 20.8 18.6 26.4 1.7 1 3.6 1.7 5.6 2.1 14.1 2.4 28.6 3.7 43.4 3.7s29.3-1.3 43.4-3.7c2-.3 3.9-1 5.6-2.1 9.4-5.6 16.3-15.1 18.6-26.4l4.9-24.3c.5-2.6 2.6-5.4 6.3-6.9h.1l1.7-.7h.1c3.7-1.5 7.1-1 9.4.4l20.2 13.8c9.6 6.4 21.2 8.2 31.7 5.6 1.9-.5 3.8-1.3 5.4-2.5 23.8-16.8 44.6-37.6 61.5-61.4 1.2-1.6 2-3.5 2.5-5.4 2.6-10.6.8-22.1-5.6-31.7L448.2 346c-1.5-2.2-2-5.7-.4-9.4v-.1l.7-1.7v-.1c1.5-3.7 4.3-5.8 6.9-6.3l24.3-4.9-3.1-15.7 3.1 15.7c11.4-2.3 20.8-9.2 26.4-18.6 1-1.7 1.7-3.6 2.1-5.6 2.4-14 3.7-28.5 3.7-43.2v-.4c0-14.7-1.3-29.1-3.7-43.2-.3-2-1-3.9-2.1-5.6-5.6-9.4-15.1-16.3-26.4-18.6l-24.3-4.9c-2.6-.5-5.4-2.6-6.9-6.3v-.1l-.7-1.7v-.1c-1.5-3.7-1-7.1.4-9.4l13.8-20.3c6.4-9.6 8.2-21.2 5.6-31.7-.5-1.9-1.3-3.8-2.5-5.4-8.3-11.7-17.5-22.7-27.6-32.9l-.9-.9c-10.1-10.1-21.1-19.3-32.9-27.6-1.6-1.2-3.5-2-5.4-2.5-10.6-2.6-22.1-.8-31.7 5.6l-20.7 13.6c-2.2 1.5-5.7 2-9.4.4h-.1l-1.7-.7h-.1c-3.7-1.5-5.8-4.3-6.3-6.9l-4.9-24.3c-2.3-11.4-9.2-20.8-18.6-26.4-1.7-1-3.6-1.7-5.6-2.1C285.3 1.3 270.8 0 256 0zm31.8 162.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-32 192c-1.5 8.7 4.4 17 13.2 18.4s17-4.4 18.4-13.2l32-192zm-100.5 64.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-40 40c-6.2 6.2-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L158.6 256l28.7-28.7zm160-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l28.7 28.7-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l40-40c6.2-6.2 6.2-16.4 0-22.6l-40-40z"
        }
    ]
};

const FalGearComplex = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGearComplex",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m215 62.8 4.9-24.3-15.7-3.1 15.7 3.1c.3-1.5 1-2.8 1.9-3.8 11.1-1.8 22.6-2.7 34.2-2.7s23.1.9 34.2 2.6c1 1.1 1.6 2.4 1.9 3.8l4.9 24.4c2.9 14.4 13.2 25.2 25.5 30.3l1.5.6c12.3 5.2 27.3 4.8 39.5-3.3l20.6-13.8c1.2-.8 2.6-1.3 4.1-1.3 9.1 6.7 17.7 14 25.6 21.9l.8.8c7.9 8 15.3 16.5 21.9 25.6-.1 1.4-.5 2.8-1.3 4.1l-13.8 20.6c-8.1 12.2-8.5 27.1-3.3 39.5l.6 1.5c5.1 12.4 15.9 22.6 30.3 25.5l24.3 4.9c1.5.3 2.8 1 3.8 1.9 1.7 11.1 2.6 22.4 2.6 34v.4c0 11.6-.9 22.9-2.6 34-1.1 1-2.4 1.6-3.8 1.9l-24.1 5.1c-14.4 2.9-25.2 13.2-30.3 25.5l-.6 1.5c-5.2 12.3-4.8 27.3 3.3 39.5l13.8 20.6c.8 1.2 1.3 2.6 1.3 4.1-13.6 18.5-29.9 34.9-48.4 48.4-1.4-.1-2.8-.5-4.1-1.3l-20.6-13.8c-12.2-8.1-27.1-8.5-39.5-3.3l-1.5.6c-12.4 5.1-22.6 15.9-25.5 30.3l-4.9 24.3c-.3 1.5-1 2.8-1.9 3.8-11.1 1.7-22.6 2.6-34.2 2.6s-23.1-.9-34.2-2.6c-1-1.1-1.6-2.4-1.9-3.8l-5-24.2c-2.9-14.4-13.2-25.2-25.5-30.3l-1.5-.6c-12.3-5.2-27.3-4.8-39.5 3.3l-20.6 13.8c-1.2.8-2.6 1.3-4.1 1.3-18.5-13.6-34.9-29.9-48.4-48.4.1-1.4.5-2.8 1.3-4.1l13.8-20.6c8.1-12.2 8.5-27.1 3.3-39.5l-.6-1.5c-5.1-12.4-15.9-22.6-30.3-25.5l-24.3-4.9c-1.5-.3-2.8-1-3.8-1.9-1.9-11.2-2.8-22.7-2.8-34.3s.9-23.1 2.6-34.2c1.1-1 2.4-1.6 3.8-1.9l24.4-4.9c14.4-2.9 25.2-13.2 30.3-25.5l.6-1.5c5.2-12.3 4.8-27.3-3.3-39.5l-13.8-20.8c-.8-1.2-1.3-2.6-1.3-4.1 6.7-9.1 14-17.7 22-25.7l.8-.8c8-7.9 16.6-15.3 25.7-22 1.4.1 2.8.5 4.1 1.3l20.6 13.8c12.2 8.1 27.1 8.5 39.5 3.3l1.5-.6c12.4-5.1 22.7-15.9 25.5-30.3zM256 0c-14.8 0-29.3 1.3-43.4 3.7-2 .3-3.9 1-5.6 2.1-9.4 5.6-16.3 15.1-18.6 26.4l-4.9 24.3c-.5 2.6-2.6 5.4-6.3 6.9h-.1l-1.7.7h-.1c-3.7 1.5-7.1 1-9.4-.4L145.5 50c-9.6-6.4-21.2-8.2-31.7-5.6-1.9.5-3.8 1.3-5.4 2.5-11.8 8.3-22.8 17.5-33 27.6l-.8.8c-10.2 10.3-19.4 21.3-27.7 33-1.2 1.6-2 3.5-2.5 5.4-2.6 10.6-.8 22.1 5.6 31.7L63.8 166c1.5 2.2 2 5.7.4 9.4v.1l-.7 1.7v.1c-1.5 3.7-4.3 5.8-6.9 6.3l-24.3 4.9c-11.4 2.3-20.8 9.2-26.4 18.6-1 1.7-1.7 3.6-2.1 5.6C1.3 226.7 0 241.2 0 256s1.3 29.3 3.7 43.4c.3 2 1 3.9 2.1 5.6 5.6 9.4 15.1 16.3 26.4 18.6l24.3 4.9c2.6.5 5.4 2.6 6.9 6.3v.1l.7 1.7v.1c1.5 3.7 1 7.1-.4 9.4L50 366.5c-6.4 9.6-8.2 21.2-5.6 31.7.5 1.9 1.3 3.8 2.5 5.4 16.8 23.8 37.6 44.6 61.5 61.5 1.6 1.2 3.5 2 5.4 2.5 10.6 2.6 22.1.8 31.7-5.6l20.6-13.8c2.2-1.5 5.7-2 9.4-.4h.1l1.7.7h.1c3.7 1.5 5.8 4.3 6.3 6.9l4.9 24.3c2.3 11.4 9.2 20.8 18.6 26.4 1.7 1 3.6 1.7 5.6 2.1 14.1 2.4 28.6 3.7 43.4 3.7s29.3-1.3 43.4-3.7c2-.3 3.9-1 5.6-2.1 9.4-5.6 16.3-15.1 18.6-26.4l4.9-24.3c.5-2.6 2.6-5.4 6.3-6.9h.1l1.7-.7h.1c3.7-1.5 7.1-1 9.4.4l20.2 13.8c9.6 6.4 21.2 8.2 31.7 5.6 1.9-.5 3.8-1.3 5.4-2.5 23.8-16.8 44.6-37.6 61.5-61.4 1.2-1.6 2-3.5 2.5-5.4 2.6-10.6.8-22.1-5.6-31.7L448.2 346c-1.5-2.2-2-5.7-.4-9.4v-.1l.7-1.7v-.1c1.5-3.7 4.3-5.8 6.9-6.3l24.3-4.9-3.1-15.7 3.1 15.7c11.4-2.3 20.8-9.2 26.4-18.6 1-1.7 1.7-3.6 2.1-5.6 2.4-14 3.7-28.5 3.7-43.2v-.4c0-14.7-1.3-29.1-3.7-43.2-.3-2-1-3.9-2.1-5.6-5.6-9.4-15.1-16.3-26.4-18.6l-24.3-4.9c-2.6-.5-5.4-2.6-6.9-6.3v-.1l-.7-1.7v-.1c-1.5-3.7-1-7.1.4-9.4l13.8-20.3c6.4-9.6 8.2-21.2 5.6-31.7-.5-1.9-1.3-3.8-2.5-5.4-8.3-11.7-17.5-22.7-27.6-32.9l-.9-.9c-10.1-10.1-21.1-19.3-32.9-27.6-1.6-1.2-3.5-2-5.4-2.5-10.6-2.6-22.1-.8-31.7 5.6l-20.7 13.6c-2.2 1.5-5.7 2-9.4.4h-.1l-1.7-.7h-.1c-3.7-1.5-5.8-4.3-6.3-6.9l-4.9-24.3c-2.3-11.4-9.2-20.8-18.6-26.4-1.7-1-3.6-1.7-5.6-2.1C285.3 1.3 270.8 0 256 0zm-64 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm160 0a96 96 0 1 0-192 0 96 96 0 1 0 192 0z"
        }
    ]
};

const FalGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8 9.9-1.3 20-2 30.3-2s20.4.7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1 7.6 3.6 14.8 7.8 21.7 12.5 9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4.2 5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5.3 4.1.5 8.3.5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8-1.4.5-2.9.5-4.4.2l-48.2-12c-12.2-3-24.4 0-33.9 6.5-6.9 4.7-14.1 8.9-21.7 12.5-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1-7.6-3.6-14.8-7.8-21.7-12.5-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5.4-3 .3-4.4-.2-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5-.3-4.1-.5-8.3-.5-12.5s.2-8.4.5-12.5c.9-11.4-2.6-23.5-11.3-32.5l-34.5-35.8c-1.1-1.1-1.8-2.5-2.1-4 3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8 1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5 6.9-4.7 14.1-8.9 21.7-12.5 10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9-1.7.3-3.4.8-5 1.6-9.5 4.9-16.9 13.6-20 24.5l-13.7 47.7c-.6 2.2-2.5 4.5-5.6 6-9.1 4.3-17.8 9.4-26 15-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5.9-2.8 2.1-3.9 3.5-7.1 8.9-13.7 18.2-19.6 28l-.1.3L32 132l-.1.3c-5.4 9.8-10.2 19.9-14.3 30.4-.6 1.6-1 3.3-1.1 5-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8-.4 5-.6 10-.6 15s.2 10.1.6 15c.3 3.4-.8 6.2-2.4 7.8l-34.5 35.8c-7.9 8.2-11.7 19-11.2 29.8.1 1.7.5 3.4 1.1 5 4.1 10.5 8.9 20.6 14.3 30.4l.1.3 4.4 7.6.1.3c5.9 9.8 12.4 19.2 19.6 28.1 1.1 1.4 2.4 2.6 3.9 3.5 9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8 8.2 5.7 16.9 10.7 26 15 3.1 1.5 4.9 3.8 5.6 6l13.7 47.5c3.1 10.8 10.5 19.5 20 24.5 1.6.8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6 9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6 9.1-4.3 17.8-9.4 26-15 2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1.7 31.1-5.1 1.5-.9 2.8-2.1 3.9-3.5 7.1-8.9 13.6-18.2 19.5-28l.1-.3 4.5-7.6.1-.3c5.4-9.7 10.2-19.9 14.3-30.4.6-1.6 1-3.3 1.1-5 .5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8a188.025 188.025 0 0 0 0-30c-.3-3.4.8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8-.1-1.7-.5-3.4-1.1-5-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.1-.3c-5.9-9.8-12.4-19.2-19.5-28-1.1-1.4-2.4-2.6-3.9-3.5-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2.6-5.2.1-8-1.8-8.2-5.7-16.9-10.7-26-15-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zm-56 256a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm144 0a88 88 0 1 0-176 0 88 88 0 1 0 176 0z"
        }
    ]
};

const FalGears = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGears",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m146.2 40.7-6.9 25.1c-1.4 5.2-5.4 9.4-10.6 11-14.6 4.6-27.9 12.4-39 22.5-4 3.7-9.6 5.1-14.9 3.7l-25.1-6.6c-2.2 3.1-4.3 6.3-6.3 9.6l-2.4 4.2c-1.8 3.3-3.5 6.6-5 10l18.3 18.5c3.8 3.9 5.4 9.4 4.2 14.7-1.7 7.3-2.5 14.8-2.5 22.6s.8 15.3 2.4 22.5c1.2 5.3-.4 10.8-4.2 14.7l-18.3 18.6c1.5 3.4 3.2 6.7 5 10l2.5 4.3c2 3.3 4.1 6.5 6.3 9.6l25.2-6.7c5.3-1.4 10.9 0 14.9 3.7 11.1 10.2 24.3 17.9 39 22.5 5.2 1.6 9.2 5.8 10.6 11l6.9 25.1c4.5.5 9.1.7 13.8.7s9.2-.2 13.8-.7l6.9-25.1c1.4-5.2 5.4-9.4 10.6-11 14.6-4.6 27.9-12.4 39-22.5 4-3.7 9.6-5.1 14.9-3.7l25.2 6.6c2.2-3 4.2-6.1 6.1-9.3l2.8-4.8c1.7-3.2 3.4-6.4 4.8-9.7l-18.3-18.5c-3.8-3.9-5.4-9.4-4.2-14.7 1.6-7.2 2.4-14.8 2.4-22.6s-.8-15.3-2.4-22.6c-1.2-5.3.4-10.8 4.2-14.7l18.3-18.5c-1.5-3.3-3.1-6.5-4.8-9.7l-2.8-4.8c-1.9-3.2-4-6.3-6.1-9.3l-25.4 6.6c-5.3 1.4-10.9 0-14.9-3.7-11.1-10.2-24.3-17.9-39-22.5-5.2-1.6-9.2-5.8-10.6-11l-6.9-25.1c-4.5-.5-9.1-.7-13.8-.7s-9.2.2-13.8.7zm-15.4-30.2C140.3 8.9 150.1 8 160 8s19.7.9 29.1 2.5c6.1 1.1 11 5.6 12.7 11.5l7.5 27.2c13.1 5.1 25.1 12.1 35.9 20.7l27.3-7.1c6-1.6 12.3.5 16.3 5.2 5.6 6.7 10.7 13.8 15.2 21.3l.2.3 2.9 5.1.2.3c4.1 7.5 7.7 15.4 10.7 23.6 2.1 5.8.7 12.3-3.6 16.7l-19.8 20.1c1 6.8 1.6 13.7 1.6 20.7s-.5 13.9-1.6 20.7l19.8 20.1c4.3 4.4 5.8 10.9 3.6 16.7-3 8.2-6.6 16-10.7 23.6l-.2.3-3 5.1-.2.3c-4.5 7.5-9.6 14.6-15.2 21.3-4 4.7-10.3 6.8-16.3 5.2l-27.3-7.1c-10.7 8.6-22.8 15.6-35.8 20.7l-7.5 27c-1.6 6-6.6 10.5-12.7 11.5-9.5 1.7-19.2 2.5-29.1 2.5s-19.7-.9-29.2-2.5c-6.1-1.1-11-5.6-12.7-11.5l-7.5-27.2c-13.1-5.1-25.1-12.1-35.8-20.7l-27.3 7.1c-6 1.6-12.3-.5-16.3-5.2-5.7-6.8-10.9-14-15.4-21.6l-.1-.2-2.6-4.5-.1-.2c-4.2-7.6-7.9-15.6-10.9-23.9-2.1-5.8-.7-12.3 3.6-16.7l19.8-20.1c-1-6.9-1.5-13.8-1.5-20.8s.5-13.9 1.6-20.7L5.7 135.2c-4.3-4.4-5.8-10.9-3.6-16.7 3-8.3 6.7-16.3 10.9-23.9l.1-.2 2.6-4.5.1-.2C20.4 82 25.6 74.8 31.3 68c4-4.7 10.3-6.8 16.3-5.2l27.3 7.1c10.7-8.6 22.8-15.6 35.8-20.7l7.5-27.2c1.6-6 6.6-10.5 12.7-11.5zM104 176a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168.7 165.8 25.1 6.9c5.2 1.4 9.4 5.4 11 10.6 4.6 14.6 12.4 27.9 22.5 39 3.7 4 5.1 9.6 3.7 14.9l-6.6 25.2c3.1 2.2 6.3 4.3 9.6 6.3l4.2 2.4c3.3 1.8 6.6 3.5 10 5l18.5-18.3c3.9-3.8 9.4-5.4 14.7-4.2 7.2 1.6 14.8 2.4 22.5 2.4s15.3-.8 22.5-2.4c5.3-1.2 10.8.4 14.7 4.2l18.5 18.3c3.4-1.5 6.7-3.2 10-5l4.3-2.5c3.3-2 6.5-4.1 9.6-6.3l-6.5-25.2c-1.4-5.3 0-10.9 3.7-14.9 10.2-11.1 17.9-24.3 22.5-39 1.6-5.2 5.8-9.2 11-10.6l25.1-6.9c.5-4.5.7-9.1.7-13.8s-.2-9.2-.7-13.8l-25.1-6.9c-5.2-1.4-9.4-5.4-11-10.6-4.6-14.7-12.4-27.9-22.5-39-3.7-4-5.1-9.6-3.7-14.9l6.6-25.2c-3-2.2-6.1-4.2-9.3-6.1l-4.8-2.8c-3.2-1.7-6.4-3.4-9.7-4.8l-18.5 18.3c-3.9 3.8-9.4 5.4-14.7 4.2-7.2-1.6-14.8-2.4-22.6-2.4s-15.3.8-22.6 2.4c-5.3 1.2-10.8-.4-14.7-4.2l-18.5-18.3c-3.3 1.5-6.5 3.1-9.7 4.8l-4.8 2.8c-3.2 1.9-6.3 4-9.3 6.1l6.6 25.2c1.4 5.3 0 10.9-3.7 14.9-10.2 11.1-17.9 24.3-22.5 39-1.6 5.2-5.8 9.2-11 10.6l-25.1 6.9c-.5 4.5-.7 9.1-.7 13.8s.2 9.2.7 13.8zm-30.2 15.4c-1.7-9.5-2.5-19.2-2.5-29.2s.9-19.7 2.5-29.1c1.1-6.1 5.6-11 11.5-12.7l27.2-7.5c5.1-13.1 12.1-25.1 20.7-35.9l-7.1-27.3c-1.6-6 .5-12.3 5.2-16.3 6.7-5.6 13.8-10.7 21.3-15.2l.3-.2 5.1-2.9.3-.2c7.5-4.1 15.4-7.7 23.6-10.7 5.8-2.1 12.3-.7 16.7 3.6l20.1 19.8c6.8-1 13.7-1.6 20.7-1.6s13.9.5 20.7 1.6l20.1-19.8c4.4-4.3 10.9-5.8 16.7-3.6 8.2 3 16 6.6 23.6 10.7l.3.2 5.1 3 .3.2c7.5 4.5 14.6 9.6 21.3 15.2 4.7 4 6.7 10.3 5.2 16.3l-7.1 27.3c8.6 10.7 15.6 22.8 20.7 35.8l27.2 7.5c6 1.6 10.5 6.6 11.5 12.7 1.7 9.5 2.5 19.2 2.5 29.1s-.9 19.7-2.5 29.2c-1.1 6.1-5.6 11-11.5 12.7l-27.2 7.5c-5.1 13.1-12.1 25.1-20.7 35.8l7.1 27.3c1.6 6-.5 12.3-5.2 16.3-6.8 5.7-14 10.9-21.6 15.4l-.2.1-4.5 2.6-.2.1c-7.6 4.2-15.6 7.9-23.9 10.9-5.8 2.1-12.3.7-16.7-3.6L485 486.5c-6.8 1-13.7 1.6-20.7 1.6s-13.9-.5-20.7-1.6l-20.1 19.8c-4.4 4.3-10.9 5.8-16.7 3.6-8.3-3-16.3-6.7-23.9-10.9l-.2-.1-4.5-2.6-.2-.1c-7.6-4.6-14.9-9.8-21.6-15.4-4.7-4-6.8-10.3-5.2-16.3l7.1-27.3c-8.6-10.7-15.6-22.8-20.7-35.8l-27.6-7.6c-6-1.6-10.5-6.6-11.5-12.7zM464 408a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm24-56a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalGem = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGem",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c-5.2 0-10.1 2.5-13.1 6.8l-112 160c-4.3 6.2-3.7 14.6 1.4 20.1l240 256c3 3.2 7.2 5.1 11.7 5.1s8.6-1.8 11.7-5.1l240-256c5.2-5.5 5.8-13.9 1.4-20.1l-112-160c-3-4.3-7.9-6.8-13.1-6.8H128zm.9 42.7L222.7 192h-176l82.2-117.3zM52.9 224h406.2L256 440.6 52.9 224zm412.3-32h-176l93.9-117.3L465.3 192zM350.7 64 256 182.4 161.3 64h189.4z"
        }
    ]
};

const FalGenderless = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGenderless",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 112a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352z"
        }
    ]
};

const FalGhost = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGhost",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M242.7 506c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l29.3-33.4c11.6-13.3 32.1-14 44.5-1.5l2.3 2.3c4.2 4.2 10 6.6 16 6.6 12.5 0 22.6-10.1 22.6-22.6V192C384 86 298 0 192 0S0 86 0 192v265.4C0 469.9 10.1 480 22.6 480c6 0 11.8-2.4 16-6.6l2.3-2.3c12.5-12.5 32.9-11.8 44.5 1.5l29.3 33.4c3.3 3.8 8.2 6 13.3 6s9.9-2.2 13.3-6l26.6-30.5c12.7-14.6 35.4-14.6 48.2 0l26.6 30.5zM32 438.1V192c0-88.4 71.6-160 160-160s160 71.6 160 160v246.1c-25.1-14-57.6-9.3-77.6 13.4l-18.4 21-15.8-18.1c-25.5-29.1-70.8-29.1-96.3 0L128 472.5l-18.4-21.1c-20-22.7-52.5-27.4-77.6-13.3zM152 192a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalGif = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGif",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm240 128c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm48 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-48h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm-224 80c0-35.3 28.7-64 64-64 14.4 0 27.7 4.8 38.4 12.8 7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4c-16-12.1-36-19.2-57.6-19.2-53 0-96 43-96 96s43 96 96 96c21.6 0 41.6-7.1 57.6-19.2 4-3 6.4-7.8 6.4-12.8v-64c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v39.4c-9.4 5.4-20.3 8.6-32 8.6-35.3 0-64-28.7-64-64z"
        }
    ]
};

const FalGiftCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGiftCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M397.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1H400c26.5 0 48-21.5 48-48s-21.5-48-48-48h-2.9zm-130 96-45-72.1C212.8 41 196.5 32 178.9 32H176c-26.5 0-48 21.5-48 48s21.5 48 48 48h91.1zm20.9-27 38.8-62c15.1-24.2 41.7-39 70.3-39h2.9c44.2 0 80 35.8 80 80 0 18-6 34.6-16 48h48c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h48c-10-13.4-16-30-16-48 0-44.2 35.8-80 80-80h2.9c28.6 0 55.2 14.7 70.3 39l38.8 62zm-112 59H64c-17.7 0-32 14.3-32 32v96h512v-96c0-17.7-14.3-32-32-32H322.2l58.1 69.8c5.7 6.8 4.7 16.9-2 22.5s-16.9 4.7-22.5-2L288 169l-67.7 81.3c-5.7 6.8-15.7 7.7-22.5 2s-7.7-15.7-2-22.5l58-69.8H176zM32 320v64h512v-64H32zm512 128v-32H32v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32z"
        }
    ]
};

const FalGift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGift",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M365.1 32c-17.6 0-33.9 9-43.2 23.9l-45 72.1H368c26.5 0 48-21.5 48-48s-21.5-48-48-48h-2.9zm-130 96-45-72.1C180.8 41 164.5 32 146.9 32H144c-26.5 0-48 21.5-48 48s21.5 48 48 48h91.1zm20.9-27 38.8-62C310 14.8 336.5 0 365.1 0h2.9c44.2 0 80 35.8 80 80 0 18-6 34.6-16 48h32c26.5 0 48 21.5 48 48v64c0 20.9-13.4 38.7-32 45.3V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V285.3C13.4 278.7 0 260.9 0 240v-64c0-26.5 21.5-48 48-48h32c-10-13.4-16-30-16-48 0-44.2 35.8-80 80-80h2.9c28.6 0 55.2 14.7 70.3 39l38.8 62zm-112 59H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h192v-96h-96zm128 0v96h192c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H272zm-32 128H64v160c0 17.7 14.3 32 32 32h144V288zm32 192h144c17.7 0 32-14.3 32-32V288H272v192z"
        }
    ]
};

const FalGifts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGifts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M193.1 21.3c3-8.3-1.4-17.5-9.7-20.4s-17.5 1.4-20.4 9.7l-18.5 52.2-17.3-51.9C124.4 2.6 115.3-2 106.9.8S94 12.7 96.8 21.1L113 69.7 65.4 35.1c-7.1-5.2-17.2-3.6-22.4 3.5S39.4 55.8 46.5 61l48.3 35H64c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h136.6c-5.4-9.4-8.6-20.3-8.6-32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h160c13.5 0 25.1 8.4 29.8 20.3 5.7-10 13.1-18.9 21.6-26.4C263.8 106.2 245.1 96 224 96h-30.8l48.2-35.1c7.1-5.2 8.7-15.2 3.5-22.4s-15.2-8.7-22.4-3.5l-46.2 33.7 16.8-47.4zm168.7 151.3 39.6 51.4H336c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32.2-32 10 0 19.6 4.7 25.6 12.6zM272 192c0 11.7 3.1 22.6 8.6 32H272c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-8.6c5.4-9.4 8.6-20.3 8.6-32 0-35.4-28.9-64-64.2-64-19.9 0-38.8 9.2-51 25.1L432 211.4l-44.8-58.3c-12.2-15.8-31.1-25.1-51-25.1-35.3 0-64.2 28.6-64.2 64zm-16 80c0-8.8 7.2-16 16-16h144v96H256v-80zm0 192v-80h160v96H272c-8.8 0-16-7.2-16-16zm352 0c0 8.8-7.2 16-16 16H448v-96h160v80zm0-192v80H448v-96h144c8.8 0 16 7.2 16 16zm-136-48h-9.4l39.6-51.4c6.1-7.9 15.6-12.6 25.6-12.6 17.7 0 32.2 14.4 32.2 32 0 17.7-14.3 32-32 32h-56z"
        }
    ]
};

const FalGingerbreadMan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGingerbreadMan",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 20.5-7.7 39.2-20.4 53.3-4.2 4.7-5.3 11.4-2.7 17.2s8.3 9.5 14.6 9.5H368c26.5 0 48 21.5 48 48s-21.5 48-48 48h-7c-32.4 0-50.3 37.7-29.7 62.8l41.7 50.7c16.8 20.5 13.9 50.7-6.6 67.6s-50.7 13.9-67.6-6.6l-45.3-55c-15.4-18.7-43.9-18.7-59.3 0l-45.3 55c-16.8 20.5-47.1 23.4-67.6 6.6s-23.2-47.1-6.4-67.6l41.7-50.7c20.7-25.1 2.8-62.8-29.6-62.8h-7c-26.5 0-48-21.5-48-48s21.5-48 48-48h72.4c6.3 0 12-3.7 14.6-9.5s1.5-12.5-2.7-17.2C151.7 151.2 144 132.5 144 112zM224 0c-61.9 0-112 50.1-112 112 0 17.2 3.9 33.4 10.8 48H80c-44.2 0-80 35.8-80 80s35.8 80 80 80h7c5.4 0 8.4 6.3 4.9 10.5l-41.7 50.7C22.1 415.3 27 465.7 61.1 493.8l9.1-11.1-9.1 11.1c34.1 28.1 84.5 23.2 112.6-10.9l45.3-55c2.6-3.1 7.3-3.1 9.9 0l45.3 55c28.1 34.1 78.5 39 112.6 10.9s39-78.5 10.9-112.6L356 330.5c-3.4-4.2-.5-10.5 4.9-10.5h7c44.2 0 80-35.8 80-80s-35.8-80-80-80h-42.7c6.9-14.6 10.8-30.8 10.8-48C336 50.1 285.9 0 224 0zm-32 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32 128a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-144a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-48 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalGlassCitrus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlassCitrus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M373.4 255.9C432.7 253.1 480 204 480 144c0-61.9-50.1-112-112-112-44.7 0-83.2 26.2-101.2 64h-34.6C252 40.1 305.3 0 368 0c79.5 0 144 64.5 144 144 0 79-63.6 143.1-142.3 144l3.7-32.1zM40.9 160c-4.8 0-8.5 4.2-7.9 8.9L43 256h266l10-87.1c.5-4.7-3.2-8.9-7.9-8.9H40.9zm24.5 291.7C67.3 467.8 81 480 97.2 480h157.5c16.3 0 29.9-12.2 31.8-28.3L305.3 288H46.6l18.8 163.7zM1.2 172.6C-1.6 148.8 17 128 40.9 128H311c23.9 0 42.5 20.8 39.7 44.6l-32.4 282.7c-3.7 32.3-31.1 56.7-63.6 56.7H97.2c-32.5 0-59.9-24.4-63.6-56.7L1.2 172.6z"
        }
    ]
};

const FalGlassEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlassEmpty",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40.1 32c-4.7 0-8.4 4-8 8.7l34.6 410c1.4 16.6 15.2 29.3 31.9 29.3h186.8c16.6 0 30.5-12.7 31.9-29.3l34.6-410c.4-4.7-3.3-8.7-8-8.7H40.1zM.2 43.4C-1.7 20 16.7 0 40.1 0h303.7c23.4 0 41.8 20 39.9 43.4l-34.6 410c-2.8 33.1-30.5 58.6-63.8 58.6H98.6c-33.3 0-61-25.5-63.8-58.6L.2 43.4z"
        }
    ]
};

const FalGlassHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlassHalf",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7h303.7c4.7 0 8.4 4 8 8.7L336 228.1V224H48v5.1L32.1 40.7zM50.3 256h283.3l-16.4 194.7c-1.4 16.6-15.2 29.3-31.8 29.3H98.6c-16.6 0-30.5-12.7-31.9-29.3L50.3 256zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410c2.8 33.1 30.5 58.6 63.8 58.6h186.8c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1z"
        }
    ]
};

const FalGlassWaterDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlassWaterDroplet",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7h303.7c4.7 0 8.4 4 8 8.7l-22.3 264.7-23.9 12c-19.2 9.6-42.3 7.2-59.1-6.3-31.8-25.5-77.1-25.5-108.9 0-16.8 13.4-39.9 15.9-59.1 6.3l-24-12L32.1 40.7zm25.4 302 6.6 3.3c30.4 15.2 66.9 11.3 93.4-9.9 20.1-16.1 48.8-16.1 68.9 0 26.5 21.2 63 25.1 93.4 9.9l6.5-3.2-9.1 108c-1.4 16.5-15.2 29.2-31.8 29.2H98.6c-16.6 0-30.5-12.7-31.9-29.3l-9.1-108zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410c2.8 33.1 30.5 58.6 63.8 58.6h186.8c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1zM192 216c-19.6 0-32-14.5-32-28v-.1c.1-.6.6-3.3 2.9-8.8 2.6-6.1 6.5-13.4 11.4-21.3 5.4-8.8 11.6-17.8 17.6-26 6 8.2 12.1 17.1 17.6 26 4.9 8 8.8 15.2 11.4 21.3 2.3 5.5 2.8 8.2 2.9 8.8v.1c0 13.5-12.4 28-32 28zm0 32c35.3 0 64-26.9 64-60 0-24-33.7-70.1-52.2-93.5-6.1-7.7-17.5-7.7-23.6 0C161.7 117.9 128 164 128 188c0 33.1 28.7 60 64 60z"
        }
    ]
};

const FalGlassWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlassWater",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7h303.7c4.7 0 8.4 4 8 8.7l-8.2 97.7-38 19c-19.2 9.6-42.3 7.2-59.1-6.3-31.8-25.5-77.1-25.5-108.9 0-16.8 13.4-39.9 15.9-59.1 6.3l-38.1-19-8.3-97.7zm11.4 135L64.1 186c30.4 15.2 66.9 11.3 93.4-9.9 20.1-16.1 48.8-16.1 68.9 0 26.5 21.2 63 25.1 93.4 9.9l20.5-10.3-23.2 275c-1.3 16.6-15.1 29.3-31.7 29.3H98.6c-16.6 0-30.5-12.7-31.9-29.3L43.5 175.6zM40.1 0C16.7 0-1.7 20 .2 43.4l34.6 410c2.8 33.1 30.5 58.6 63.8 58.6h186.8c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1z"
        }
    ]
};

const FalGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlass",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.1 40.7c-.4-4.7 3.3-8.7 8-8.7h303.7c4.7 0 8.4 4 8 8.7L347.1 96H36.8l-4.7-55.3zm7.4 87.3h305l-27.3 322.7c-1.4 16.6-15.2 29.3-31.8 29.3H98.6c-16.6 0-30.5-12.7-31.9-29.3L39.5 128zm.6-128C16.7 0-1.7 20 .2 43.4l34.6 410c2.8 33.1 30.5 58.6 63.8 58.6h186.8c33.3 0 61-25.5 63.8-58.6l34.6-410C385.6 20 367.2 0 343.8 0H40.1z"
        }
    ]
};

const FalGlassesRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlassesRound",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M116.8 64c-14.4 0-26.9 9.7-30.5 23.6L46.6 241.5C70.5 220.6 101.8 208 136 208c55.1 0 102.6 32.8 124 80h56c21.3-47.2 68.8-80 124-80 34.2 0 65.5 12.6 89.4 33.5L489.7 87.6C486.1 73.7 473.6 64 459.2 64c-4.9 0-9.7 1.1-14.1 3.3l-22 11c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l22-11c8.8-4.4 18.5-6.7 28.4-6.7 29 0 54.2 19.6 61.5 47.6l48.7 188.8c4.4 17 6.6 34.4 6.6 52V344c0 75.1-60.9 136-136 136s-136-60.9-136-136c0-8.2.7-16.2 2.1-24h-36.2c1.4 7.8 2.1 15.8 2.1 24 0 75.1-60.9 136-136 136S0 419.1 0 344v-23.6c0-17.5 2.2-35 6.6-52L55.3 79.6c7.2-28 32.5-47.6 61.5-47.6 9.9 0 19.6 2.3 28.4 6.7l22 11c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-22-11c-4.4-2.2-9.2-3.3-14.1-3.3zM544 344a104 104 0 1 0-208 0 104 104 0 1 0 208 0zM136 448a104 104 0 1 0 0-208 104 104 0 1 0 0 208z"
        }
    ]
};

const FalGlasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlasses",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M116.8 64c-14.4 0-26.9 9.7-30.5 23.6L38.1 274.4c31-12 65-18.4 97.6-18.4 40.1 0 82.2 9.6 118.5 27.3 2.6 1.3 4.9 2.9 7 4.7h53.7c2.1-1.8 4.4-3.4 7-4.7 36.2-17.8 78.4-27.3 118.5-27.3 32.6 0 66.6 6.3 97.6 18.4L489.7 87.6C486.1 73.7 473.6 64 459.2 64c-4.9 0-9.7 1.1-14.1 3.3l-22 11c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l22-11c8.8-4.4 18.5-6.7 28.4-6.7 29 0 54.2 19.6 61.5 47.6l50.7 196.6c3 11.8 4.6 23.8 4.6 36V368c0 61.9-50.1 112-112 112h-44.3c-59.4 0-108.5-46.4-111.8-105.8l-3.5-54.2h-32.8l-3.4 54.2C264.9 433.6 215.8 480 156.3 480H112C50.1 480 0 429.9 0 368v-56.2c0-12 1.6-23.9 4.6-35.5L55.3 79.6c7.2-28 32.5-47.6 61.5-47.6 9.9 0 19.6 2.3 28.4 6.7l22 11c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-22-11c-4.4-2.2-9.2-3.3-14.1-3.3zM32 312v56c0 44.2 35.8 80 80 80h44.3c42.5 0 77.5-33.2 79.9-75.6v-.2L240 312v-.1c-31.8-15.5-69-24-104.3-24-35.1 0-72.2 8.4-103.7 24zm512 0c-31.4-15.6-68.6-24-103.7-24-35.3 0-72.5 8.5-104.3 24v.1l3.8 60.2v.2c2.4 42.4 37.4 75.6 79.9 75.6H464c44.2 0 80-35.8 80-80V312z"
        }
    ]
};

const FalGlobePointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlobePointer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M317.9 422.7C296.4 465.6 272.7 480 256 480c-7.9 0-17.3-3.2-27.3-11l-6.9 18.6c-2.9 7.8-7.7 14.7-13.9 19.9 15.6 3 31.6 4.5 48.1 4.5 141.4 0 256-114.6 256-256S397.4 0 256 0 0 114.6 0 256c0 16.4 1.5 32.5 4.5 48.1 5.3-6.2 12.1-11 19.9-13.9l9.6-3.5c-1.4-10-2.1-20.2-2.1-30.6 0-22.2 3.2-43.7 9.3-64H132c-2.5 19.2-3.9 39.3-4 60l32.2-11.9c.5-16.7 1.9-32.8 4.1-48.1h183.4c2.8 20.2 4.3 41.7 4.3 64s-1.5 43.8-4.3 64h-64.1l-11.8 32H342c-5.9 27-14.2 50.9-24.1 70.7zM194.1 89.3C215.6 46.4 239.3 32 256 32s40.4 14.4 61.9 57.3c9.9 19.8 18.2 43.7 24.1 70.7H170c5.9-27 14.2-50.9 24.1-70.7zM384 256c0-22.1-1.4-43.5-4-64h90.8c6 20.3 9.3 41.8 9.3 64s-3.2 43.7-9.3 64H380c2.6-20.5 4-41.9 4-64zm-9.3-96c-9.6-47.6-26.2-88-47.2-116.3 57.8 19.5 105 61.8 130.9 116.3h-83.7zm-321.1 0c25.9-54.5 73.1-96.9 130.9-116.3-21 28.3-37.5 68.8-47.2 116.3H53.6zm321.1 192h83.8c-25.9 54.5-73.1 96.9-130.9 116.3 21-28.3 37.6-68.8 47.2-116.3zM271 261.5c2.2-5.9.7-12.4-3.7-16.8s-11-5.9-16.8-3.7l-215 79.2c-6.2 2.3-10.3 8.1-10.5 14.7s3.8 12.6 9.9 15.1l74 30.5L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l104.2-104.2 30.5 74c2.5 6.1 8.5 10 15.1 9.9s12.4-4.3 14.7-10.5l79.2-215zM143.3 360l-58.2-24L229 283l-53 143.9-24-58.2c-1.6-3.9-4.8-7.1-8.7-8.7z"
        }
    ]
};

const FalGlobeSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlobeSnow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 224c0 49.2-18.5 94-48.9 128h40.7c25.3-36.3 40.2-80.4 40.2-128C448 100.3 347.7 0 224 0S0 100.3 0 224c0 47.6 14.8 91.7 40.2 128h40.7C50.5 318 32 273.2 32 224c0-106 86-192 192-192s192 86 192 192zM240 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-27.3 44.7-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7v34.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.6V352h32v-73.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 233.4v-34.8l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zM360 176a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM80 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM50.3 391.8l-46.2 77c-2.7 4.4-4.1 9.5-4.1 14.7C0 499.2 12.8 512 28.5 512h391c15.8 0 28.5-12.8 28.5-28.5 0-5.2-1.4-10.2-4.1-14.7l-46.2-77c-2.9-4.8-8.1-7.8-13.7-7.8H64c-5.6 0-10.8 2.9-13.7 7.8zM73.1 416h301.8l38.4 64H34.7l38.4-64z"
        }
    ]
};

const FalGlobeStand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlobeStand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M28.7 348.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l10-10c37.7 32.8 83.8 50.8 130.7 54.1V480H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H224v-64.6c51.9-3.7 102.7-25.4 142.4-65 83.7-83.7 87.3-217.1 10.9-305.1l10-10c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-20.9 20.9c-6.2 6.2-6.2 16.4 0 22.6 75 75 75 196.5 0 271.5s-196.5 75-271.5 0c-6.2-6.2-16.4-6.2-22.6 0l-21 21zM80 192a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm288 0a160 160 0 1 0-320 0 160 160 0 1 0 320 0z"
        }
    ]
};

const FalGlobe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGlobe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480c16.7 0 40.4-14.4 61.9-57.3 9.9-19.8 18.2-43.7 24.1-70.7H170c5.9 27 14.2 50.9 24.1 70.7 21.5 42.9 45.2 57.3 61.9 57.3zm-91.7-160h183.4c2.8-20.2 4.3-41.7 4.3-64s-1.5-43.8-4.3-64H164.3c-2.8 20.2-4.3 41.7-4.3 64s1.5 43.8 4.3 64zm5.7-160h172c-5.9-27-14.2-50.9-24.1-70.7C296.4 46.4 272.7 32 256 32s-40.4 14.4-61.9 57.3c-9.9 19.8-18.2 43.7-24.1 70.7zm210 32c2.6 20.5 4 41.9 4 64s-1.4 43.5-4 64h90.8c6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64H380zm78.5-32c-25.9-54.5-73.1-96.9-130.9-116.3 21 28.3 37.6 68.8 47.2 116.3h83.8zm-321.1 0c9.6-47.6 26.2-88 47.2-116.3-57.9 19.4-105.2 61.8-131 116.3h83.7zm-96 32c-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64H132c-2.6-20.5-4-41.9-4-64s1.4-43.5 4-64H41.3zm286.1 276.3c57.8-19.5 105-61.8 130.9-116.3h-83.7c-9.6 47.6-26.2 88-47.2 116.3zm-143 0c-21-28.3-37.5-68.8-47.2-116.3H53.6c25.9 54.5 73.1 96.9 130.9 116.3zM256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512z"
        }
    ]
};

const FalGoalNet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGoalNet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 112c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48v352c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112v352c0 8.8 7.2 16 16 16s16-7.2 16-16V112zm144 0c-8.8 0-16 7.2-16 16v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64h-64v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64h-64v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64h-64v-64c0-8.8-7.2-16-16-16zm16 112h64v64h-64v-64zm96 0h64v64h-64v-64zm96 0h64v64h-64v-64zM192 384v-64h64v64h-64zm96 0v-64h64v64h-64zm96 0v-64h64v64h-64z"
        }
    ]
};

const FalGolfBallTee = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGolfBallTee",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 320c38.9-29.2 64-75.7 64-128 0-88.4-71.6-160-160-160S32 103.6 32 192c0 52.3 25.1 98.8 64 128H48.9C18.5 286 0 241.2 0 192 0 86 86 0 192 0s192 86 192 192c0 49.2-18.5 94-48.9 128H288zM80 352h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8-7.2-16-16-16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm146.1-103.4c0-4.9 5.1-9.1 8.4-5.4 5.2 5.9 8.4 13.7 8.4 22.1 0 18.5-15 33.5-33.5 33.5-8.5 0-16.2-3.2-22.1-8.4-3.7-3.3.5-8.4 5.4-8.4 18.5 0 33.5-15 33.5-33.5zm-52.3-49.3c18.5 0 33.5-15 33.5-33.5 0-4.9 5.1-9.1 8.4-5.4 5.2 5.9 8.4 13.7 8.4 22.1 0 18.5-15 33.5-33.5 33.5-8.5 0-16.2-3.2-22.1-8.4-3.7-3.3.5-8.4 5.4-8.4zm113.5-17.5c0-4.9 5.1-9.1 8.4-5.4 5.2 5.9 8.4 13.7 8.4 22.1 0 18.5-15 33.5-33.5 33.5-8.5 0-16.2-3.2-22.1-8.4-3.7-3.3.5-8.4 5.4-8.4 18.5 0 33.5-15 33.5-33.5z"
        }
    ]
};

const FalGolfClub = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGolfClub",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M510.3 23.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L303.5 365.1l-243-65.7C30 291.2 0 314.2 0 345.8V464c0 26.5 21.5 48 48 48h178.3c24.2 0 46.4-13.7 57.2-35.4l42.7-85.5 184-368zM52.2 330.4l236.8 64-34 68c-5.4 10.8-16.5 17.7-28.6 17.7H48c-8.8 0-16-7.2-16-16V448h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-22.2c0-10.5 10-18.2 20.2-15.4z"
        }
    ]
};

const FalGolfFlagHole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGolfFlagHole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M135.6 2.4c4.7-2.9 10.6-3.2 15.6-.7l224 112c5.4 2.7 8.8 8.3 8.8 14.3s-3.4 11.6-8.8 14.3L160 249.9v61.7c29.6-4.9 62.1-7.6 96-7.6 141.4 0 256 46.6 256 104S397.4 512 256 512 0 465.4 0 408c0-32.8 37.5-62.1 96-81.2v33.8c-3.1 1.1-6.1 2.3-9 3.5-20.9 8.5-35.7 17.8-44.7 26.5-9 8.6-10.3 14.5-10.3 17.4s1.3 8.8 10.3 17.4c9.1 8.7 23.8 18 44.7 26.5 41.7 16.9 101.4 28.1 169 28.1s127.3-11.2 169-28.1c20.9-8.5 35.7-17.8 44.7-26.5 9-8.6 10.3-14.5 10.3-17.4s-1.3-8.8-10.3-17.4c-9.1-8.7-23.8-18-44.7-26.5-41.7-16.9-101.4-28.1-169-28.1-34.5 0-67 2.9-96 8v28.2c17-7.6 39.4-12.2 64-12.2 53 0 96 21.5 96 48s-43 48-96 48-96-21.5-96-48V16c0-5.5 2.9-10.7 7.6-13.6zM160 214.1 332.2 128 160 41.9v172.2zm128.4 191.3v.1-.1zm-10.8-2.7c-12.1-6-31-10.7-53.6-10.7s-41.5 4.7-53.6 10.7c-4.3 2.1-6.9 4-8.5 5.3 1.6 1.4 4.2 3.2 8.5 5.3 12.1 6 31 10.7 53.6 10.7s41.5-4.7 53.6-10.7c4.3-2.1 6.9-4 8.5-5.3-1.6-1.4-4.2-3.2-8.5-5.3zm10.8 7.9a.4.4 0 1 0 .8-.4.4.4 0 1 0-.8.4z"
        }
    ]
};

const FalGopuram = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGopuram",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c8.8 0 16 7.2 16 16v16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16v114.7c18.6 6.6 32 24.4 32 45.3v48c0 .9 0 1.8-.1 2.7 18.7 6.6 32.1 24.4 32.1 45.3v80c0 .9 0 1.8-.1 2.7 18.7 6.6 32.1 24.4 32.1 45.3v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-20.9 13.4-38.7 32.1-45.3-.1-.9-.1-1.8-.1-2.7v-80c0-20.9 13.4-38.8 32.1-45.3-.1-.9-.1-1.8-.1-2.7v-48c0-20.9 13.4-38.7 32-45.3V16c0-8.8 7.2-16 16-16zm112 480h64c0-17.7-14.3-32-32-32s-32 14.3-32 32zm96 0h64v-96H128v96h64c0-35.3 28.7-64 64-64s64 28.7 64 64zM128 80v48h256V64H128v16zm-16 80c-8.8 0-16 7.2-16 16v48h64v-64h-48zm48 96v96h48v-16c0-26.5 21.5-48 48-48s48 21.5 48 48v16h48v-96H160zm112-48v16h48v-64H192v64h48v-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 144v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h32zm144-128v-48c0-8.8-7.2-16-16-16h-48v64h64zm0 32h-32v96h64v-80c0-8.8-7.2-16-16-16h-16zm0 224h48c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-48v96zM128 256H80c-8.8 0-16 7.2-16 16v80h64v-96zM96 384H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48v-96z"
        }
    ]
};

const FalGraduationCap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGraduationCap",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M307.2 66.2 47.6 160l74 26.7c10.3-6.9 21.5-12.6 33.4-17.1l159.4-59.8c8.3-3.1 17.5 1.1 20.6 9.4s-1.1 17.5-9.4 20.6l-159.4 59.8c-1.5.5-2.9 1.1-4.3 1.7l145.3 52.5c4.1 1.5 8.4 2.2 12.8 2.2s8.7-.8 12.8-2.2L592.4 160 332.8 66.2c-4.1-1.5-8.4-2.2-12.8-2.2s-8.7.8-12.8 2.2zm-10.9 217.7-169.4-61.2c-27.5 23.3-44.8 57.2-46.7 94.2 5.9 13.2 10.2 27.5 13.4 41.5 6.4 27.6 10.7 65.9 2.1 108.7-.9 4.3-3.4 8-7.1 10.4s-8.2 3.1-12.4 2l-64-16C7 462.2 2.8 458.4 1 453.3s-.9-10.7 2.3-14.9c8.6-11.7 16-24.6 22.5-37.6C37.2 377.8 48 348.4 48 320c0-.6 0-1.2.1-1.8 1.4-41 18-79.1 45.1-107.7l-77.4-27.9C6.3 179.1 0 170.1 0 160s6.3-19.1 15.8-22.6L296.3 36.1c7.6-2.7 15.6-4.1 23.7-4.1s16.1 1.4 23.7 4.1l280.5 101.3c9.5 3.4 15.8 12.5 15.8 22.6s-6.3 19.1-15.8 22.6L343.7 283.9c-7.6 2.7-15.6 4.1-23.7 4.1s-16.1-1.4-23.7-4.1zm-122-10-13.9 132.4c.7.8 1.8 2.1 3.7 3.7 6 5.2 16.5 11.5 31.9 17.5 30.4 11.9 74.3 20.5 124 20.5s93.6-8.6 124.1-20.6c15.4-6 25.8-12.3 31.9-17.5 1.9-1.6 3-2.8 3.7-3.7l-14-132.4 31-11.2L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.3-145.4 31 11.2zM480.5 405a.2.2 0 1 0-.3-.1.2.2 0 1 0 .3.1zm-321 0a.1.1 0 1 0 .2 0 .1.1 0 1 0-.2 0zM67 444.2c2.5-20.7 1.7-40-.5-56.7-3.8 10-8 19.3-12.1 27.6-3.8 7.6-7.9 15.2-12.5 22.8l25.1 6.3z"
        }
    ]
};

const FalGramophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGramophone",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M67.2 278c-.5 1.8.2 3.7 1.8 4.7 1.5 1 3.6 1.1 5.4-.2 80.8-56.9 145.7-73.7 193.6-73.9-84.6-64.1-123-146-134.8-175.8-.1-.3-.3-.6-.5-.7-.2-.1-.3-.1-.3-.1L67.2 278zm300.8-.3c0 1.1 0 2.1-.1 3.2 0 1.1.1 2.3.1 3.4 0 37.4-30.3 67.7-67.7 67.7H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h117.9c22.3-.1 40.5-17.4 42-39.3-1-17.2-9.2-29.6-21.1-33.4-35.5-11.3-109.8-17.6-222 61.4-12.2 8.6-28.8 9.2-41.6.7-12.9-8.6-19-24.5-15-39.5l65.1-246C105.1 9.8 117.8 0 132.3 0c13.9 0 25.7 8.8 30.6 21 12.5 31.4 58 127.5 163.5 188 24.1 13.8 41.6 39.2 41.6 68.7zM304 416H80c-8.8 0-16 7.2-16 16v48h256v-48c0-8.8-7.2-16-16-16zM80 384h224c26.5 0 48 21.5 48 48v48h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-48c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FalGrapes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrapes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M447.5 221.1c-4.5-10.7-10.5-20.6-17.9-29.3 21.6-2 40.7-14.9 50.2-22.8v-.1c.1-.1.2-.4.2-.9 0-.4-.1-.7-.1-.8-10.2-8.1-33.5-23.2-63.9-23.2-14.7 0-22.9 1.8-26.9 3.2-1.6.6-2.6 1-2.9 1.2-6.3 5.2-15.6 4.8-21.4-1.1s-6.2-15.2-1.1-21.4c.2-.4.7-1.3 1.2-2.9 1.3-4 3.2-12.2 3.2-26.9 0-30.4-15.1-53.7-23.2-63.9-.1 0-.4-.1-.8-.1-.5 0-.8.1-.9.2h-.1c-7.9 9.6-20.8 28.6-22.8 50.2-8.8-7.5-18.6-13.5-29.4-18 6.1-24.5 20-43.7 27.4-52.7C325 3.7 334.8 0 344 0s19.1 3.7 25.8 12.1c10 12.7 30.2 43 30.2 83.9 0 6.3-.3 11.9-.8 16.8 4.9-.5 10.5-.8 16.8-.8 40.9 0 71.2 20.2 83.9 30.2 8.4 6.7 12.1 16.5 12.1 25.8 0 9.2-3.7 19-11.8 25.7-9 7.4-28.2 21.3-52.7 27.4zM320 456c-18.4 0-35.2-6.9-47.9-18.2-12.4 25-38.3 42.2-68.1 42.2-19 0-36.3-7-49.6-18.4C142.6 491.1 113.7 512 80 512c-44.2 0-80-35.8-80-80 0-33.7 20.9-62.6 50.4-74.4C39 344.3 32 327 32 308c0-29.8 17.2-55.7 42.2-68.1A71.865 71.865 0 0 1 56 192c0-39.8 32.2-72 72-72 17.6 0 33.8 6.3 46.3 16.9C186.4 108.1 214.9 88 248 88c44.2 0 80 35.8 80 80 0 6.2-.7 12.2-2 18 5.8-1.3 11.8-2 18-2 44.2 0 80 35.8 80 80 0 33.1-20.1 61.6-48.9 73.7 10.6 12.5 16.9 28.7 16.9 46.3 0 39.8-32.2 72-72 72zm-24-288a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-168 64a40 40 0 1 0 0-80 40 40 0 1 0 0 80zm144 56a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-164 64a44 44 0 1 0 0-88 44 44 0 1 0 0 88zM80 480a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm124-32a44 44 0 1 0 0-88 44 44 0 1 0 0 88zm156-64a40 40 0 1 0-80 0 40 40 0 1 0 80 0zm-16-72a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalGrateDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrateDroplet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h320c17.7 0 32 14.3 32 32v88.9c7.8-11.1 19.1-19.1 32-22.7V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h280.2c-6.6-9.9-12-20.6-16.1-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm320 64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h224.9c-.6-5.3-.9-10.6-.9-16s.3-10.7.9-16H312V272h40v32l32-60V128zm-288 0h40v112H96V128zm72 112V128h40v112h-40zm72 0V128h40v112h-40zm72 0V128h40v112h-40zm-32 32v112h-40V272h40zm-72 0v112h-40V272h40zm-72 0v112H96V272h40zm257.4 90.4L464 230l70.6 132.4c6.2 11.6 9.4 24.5 9.4 37.6 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-13.1 3.2-26.1 9.4-37.6zm-28.2-15.1c-8.7 16.2-13.2 34.3-13.2 52.7 0 61.9 50.1 112 112 112s112-50.1 112-112c0-18.4-4.5-36.5-13.2-52.7l-75.3-141.2c-4.6-8.7-13.7-14.1-23.5-14.1s-18.9 5.4-23.5 14.1l-75.3 141.2z"
        }
    ]
};

const FalGrate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrate",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 0h256c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm0 32v112h40V128H96zm72 112h40V128h-40v112zm72 0h40V128h-40v112zm72 0h40V128h-40v112zm0 32v112h40V272h-40zm-32 0h-40v112h40V272zm-72 0h-40v112h40V272zm-72 0H96v112h40V272z"
        }
    ]
};

const FalGreaterThanEqual = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGreaterThanEqual",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.9 62.8c-8.2-3.3-12.1-12.7-8.8-20.9S45.8 29.8 54 33.1l352 144c6 2.5 9.9 8.3 9.9 14.8s-3.9 12.3-9.9 14.8l-352 144c-8.2 3.3-17.5-.6-20.9-8.8s.6-17.5 8.8-20.9l315.8-129L41.9 62.8zM432 448c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h416z"
        }
    ]
};

const FalGreaterThan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGreaterThan",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M1.7 72.8c-4 7.9-.7 17.5 7.2 21.5L332.2 256 8.8 417.7c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l352-176c5.4-2.7 8.8-8.3 8.8-14.3s-3.4-11.6-8.8-14.3l-352-176c-7.9-4-17.5-.7-21.5 7.2z"
        }
    ]
};

const FalGrid2Plus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrid2Plus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 64H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 288H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm-96-32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zM336 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-96zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80zm96 192c8.8 0 16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalGrid2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrid2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80zM32 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zm48 240c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16H80zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-96zM432 64h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zm-96-32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 288c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-96zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-96z"
        }
    ]
};

const FalGrid4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrid4",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 97.6V56h41.6v41.6H24zm0 119.5v-41.6h41.6v41.6H24zm0 119.5v-41.7h41.6v41.6H24zM24 456v-41.6h41.6V456H24zM16 32C7.2 32 0 39.2 0 48v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.6c0-8.8-7.2-16-16-16H16zM0 286.9v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.6c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.6c0-8.8-7.2-16-16-16H16zM143.5 97.6V56h41.6v41.6h-41.6zm0 119.5v-41.6h41.6v41.6h-41.6zm0 119.5v-41.7h41.6v41.6h-41.6zm0 119.5v-41.7h41.6V456h-41.6zm-8-424c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-57.6zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.7c0-8.8-7.2-16-16-16h-57.6zm-16 135.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.8c0-8.8-7.2-16-16-16h-57.6c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.6c0-8.8-7.2-16-16-16h-57.6zM262.9 56h41.6v41.6h-41.6V56zm0 119.5h41.6v41.6h-41.6v-41.6zm0 119.5h41.6v41.6h-41.6v-41.7zm0 119.5h41.6V456h-41.6v-41.6zM238.9 48v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-57.6c-8.8 0-16 7.2-16 16zm0 119.5v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.6c0-8.8-7.2-16-16-16h-57.6c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.7c0-8.8-7.2-16-16-16h-57.6zm-16 135.5V464c0 8.8 7.2 16 16 16h57.6c8.8 0 16-7.2 16-16v-57.6c0-8.8-7.2-16-16-16h-57.6c-8.8 0-16 7.2-16 16zM382.4 97.6V56H424v41.6h-41.6zm0 119.5v-41.6H424v41.6h-41.6zm0 119.5v-41.7H424v41.6h-41.6zm0 119.5v-41.7H424V456h-41.6zm-8-424c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-57.6zm0 119.5c-8.8 0-16 7.2-16 16v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16v-57.7c0-8.8-7.2-16-16-16h-57.6zm-16 135.5v57.6c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16v-57.8c0-8.8-7.2-16-16-16h-57.6c-8.8 0-16 7.2-16 16zm16 103.5c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16v-57.6c0-8.8-7.2-16-16-16h-57.6z"
        }
    ]
};

const FalGrid5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrid5",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24 56h16v16H24V56zm-8-24C7.2 32 0 39.2 0 48v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H16zm8 120h16v16H24v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16zm8 136v-16h16v16H24zM0 240v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm24 104h16v16H24v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16zm8 136v-16h16v16H24zM0 432v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM120 56h16v16h-16V56zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-32zm8 136v-16h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm24 104h16v16h-16v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm8 136v-16h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm24 104h16v16h-16v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM216 72V56h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm24 104h16v16h-16v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm8 136v-16h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm24 104h16v16h-16v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm8 136v-16h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zM312 56h16v16h-16V56zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-32zm8 136v-16h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm24 104h16v16h-16v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm8 136v-16h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm24 104h16v16h-16v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zM408 72V56h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm24 104h16v16h-16v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm8 136v-16h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm24 104h16v16h-16v-16zm-8-24c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32zm8 136v-16h16v16h-16zm-24-24v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalGridDividers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGridDividers",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h480c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zm64 112v64h64v-64H64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64zm32 288v64h64v-64H64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64zm256-288h-64v64h64v-64zm-64-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm0 320v64h64v-64h-64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm256-288h-64v64h64v-64zm-64-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm0 320v64h64v-64h-64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zM16 288h480c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalGridHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGridHorizontal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 160c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H40zm-40 8c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48zm40 152c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H40zm-40 8c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48zm248-168h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48-32h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40zm0 192c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48zm-40 8c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48zm248-168h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48-32h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40zm0 192c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48zm-40 8c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48z"
        }
    ]
};

const FalGridRound2Plus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGridRound2Plus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zM64 384a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm256-288a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm-96 144c8.8 0 16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalGridRound2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGridRound2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 192a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm-96 320a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm96-256a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm64 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192zm0 224a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm96-64a96 96 0 1 1-192 0 96 96 0 1 1 192 0z"
        }
    ]
};

const FalGridRound4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGridRound4",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M44.8 56a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 76.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm44.8 98.7a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 196.3a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm65.6 119.4a20.8 20.8 0 1 1-41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zM0 435.2a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zM185.1 76.8a20.8 20.8 0 1 1-41.6 0 20.8 20.8 0 1 1 41.6 0zM164.3 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm65.6 119.5a20.8 20.8 0 1 1-41.6 0 20.8 20.8 0 1 1 41.6 0zM164.3 271a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm185-358.5a20.8 20.8 0 1 1-41.6 0 20.8 20.8 0 1 1 41.6 0zM283.7 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zm65.6 119.5a20.8 20.8 0 1 1-41.6 0 20.8 20.8 0 1 1 41.6 0zM283.7 271a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zM424 76.8a20.8 20.8 0 1 1-41.6 0 20.8 20.8 0 1 1 41.6 0zM403.2 32a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0zM424 315.7a20.8 20.8 0 1 1-41.6 0 20.8 20.8 0 1 1 41.6 0zm-20.8-44.8a44.8 44.8 0 1 0 0 89.6 44.8 44.8 0 1 0 0-89.6zm0 143.5a20.8 20.8 0 1 1 0 41.6 20.8 20.8 0 1 1 0-41.6zm-44.8 20.8a44.8 44.8 0 1 0 89.6 0 44.8 44.8 0 1 0-89.6 0z"
        }
    ]
};

const FalGridRound5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGridRound5",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 64a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm8 128a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm40 96a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM136 64a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm40 96a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm40 96a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96-360a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm40 96a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm40 96a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM328 64a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm40 96a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm40 96a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm96-360a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm40 96a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm40 96a8 8 0 1 1-16 0 8 8 0 1 1 16 0zm-8-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 120a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm-32 8a32 32 0 1 0 64 0 32 32 0 1 0-64 0z"
        }
    ]
};

const FalGridRound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGridRound",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM64 32a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm32 224a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 416a64 64 0 1 0 128 0 64 64 0 1 0-128 0zM256 96a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 160a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM384 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 160a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm0 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-64 32a64 64 0 1 0 128 0 64 64 0 1 0-128 0z"
        }
    ]
};

const FalGrid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrid",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zm48 192c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40H40zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-48zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48zM360 64h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FalGrillFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrillFire",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 64H40c-4.4 0-8 3.6-8 8v24c0 106 86 192 192 192 4.7 0 9.4-.2 14-.5-4.4 10.8-8 21.7-10.5 32.5h-3.6c-19.9 0-39.2-2.6-57.6-7.5l-26.1 57.3c4.3 4.2 8.1 8.9 11.1 14.1H227c1.9 11 4.8 21.7 8.5 32H160c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c5.7 0 11.1.7 16.4 2.1l23.7-52C56 267.9 0 188.5 0 96V72c0-22.1 17.9-40 40-40h368c22.1 0 40 17.9 40 40v24c0 24.1-3.8 47.3-10.9 69.1-8.5-8.6-17.2-17-26.2-25.1 3.3-14.1 5.1-28.8 5.1-44V72c0-4.4-3.6-8-8-8zM96 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm349.4-130.5c-9.6.1-18.8-4.1-25-11.5-12.9-15.5-26.5-30-40.8-43.7-26.1 25-48 52.3-64 78.1-18.3 29.6-27.6 57.9-27.6 75.8 0 70.3 56.2 127.8 128 127.8 71 0 128-57.6 128-127.8 0-12.8-7-38.2-20.6-64.3-10.9-21.1-25.4-42.6-41.8-60.5-3.8 4.4-7.7 9.1-11.6 14-6 7.5-15.1 12-24.7 12.1zm-21.8-56.4c7.4 7.9 14.5 16 21.5 24.4 6.4-8.1 13.6-16.8 21.2-24.5 1.7-1.7 3.5-3.4 5.2-5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79C576 440 504.7 512 416 512c-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8 11.8 10.6 23.1 21.7 34 33.4zM381.1 256c4.8 0 9.4 2.2 12.4 6 2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1v.1c21.3 39.3 12.3 90.4-25 116.5l-.3.2C457.3 442 438.3 448 417 448c-25.9 0-50.2-8.4-68.2-24.8-18.1-16.6-28.8-40.5-28.8-69.2 0-15.7 5-29.7 13.4-44.2 8.2-14.1 20.2-29.5 35.1-47.9 3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L443 351l-12.6 9.9-.1-.2-.5-.6-1.8-2.4-6.6-8.4-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2-6.6 11.3-9.1 19.8-9.1 28.1 0 20.3 7.3 35.4 18.4 45.6 11.2 10.2 27.4 16.3 46.5 16.3 14.7 0 27.6-4 40-12.2 20.1-14.2 27.8-41.8 18.9-66.5z"
        }
    ]
};

const FalGrillHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrillHot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c-8.8 0-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2v-4c0-8.8-7.2-16-16-16zm144 352h-64c-88.4 0-160-71.6-160-160h384c0 88.4-71.6 160-160 160zM32 160c-17.7 0-32 14.3-32 32 0 80.5 49.5 149.4 119.7 177.9l-7.4 16.2c-5.2-1.4-10.7-2.1-16.4-2.1-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48h178l17.6 38.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2l-54.3-119.4C398.5 341.4 448 272.5 448 192c0-17.7-14.3-32-32-32H32zm108.4 241.9 10.2-22.4c13.4 2.9 27.2 4.5 41.5 4.5h64c14.2 0 28.1-1.5 41.5-4.5l23.7 52.5H158c-3-11.7-9.2-22-17.6-30.1zM64 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2v-4z"
        }
    ]
};

const FalGrill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrill",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 64c4.4 0 8 3.6 8 8v24c0 106-86 192-192 192S32 202 32 96V72c0-4.4 3.6-8 8-8h368zM40 32C17.9 32 0 49.9 0 72v24c0 92.5 56 171.9 136 206.1l-23.7 52c-5.2-1.4-10.7-2.1-16.4-2.1-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64h168.7l24.8 54.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2L312 302.1C392 267.9 448 188.5 448 96V72c0-22.1-17.9-40-40-40H40zm100.4 337.9 26.1-57.3c18.4 4.9 37.7 7.5 57.6 7.5s39.2-2.6 57.6-7.5l32.4 71.4H151.4c-3-5.2-6.8-10-11.1-14.1zM96 448a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FalGripDotsVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGripDotsVertical",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM0 96a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm64 160a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm48 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm48 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm16 208a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FalGripDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGripDots",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-160 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 176a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm272 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-176 48a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm64 0a48 48 0 1 1-96 0 48 48 0 1 1 96 0zM64 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FalGripLinesVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGripLinesVertical",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalGripLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGripLines",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 192c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16zm0 128c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FalGripVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGripVertical",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 440v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8zm8 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40zm184-40v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8zm8 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40zM32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8v-48zM0 280c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40v48zm224 0v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8zm8 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40zM32 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72zM0 120c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v48zm224 0V72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8zm8 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40z"
        }
    ]
};

const FalGrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGrip",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48zm40-8c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48zm-40-184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48zm40-8c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48zM200 384h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm48 32h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40zm0-224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48zm40-8c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48zM40 384h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm48 32H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40zm0-224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48zm40-8c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48z"
        }
    ]
};

const FalGroupArrowsRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGroupArrowsRotate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M207.3 36.7c2.5 8.5-2.3 17.4-10.8 19.9-14.2 4.2-27.8 10-40.6 17 2.6 7 4 14.5 4 22.4 0 35.3-28.7 64-64 64-7.9 0-15.4-1.4-22.4-4-7 12.8-12.7 26.4-17 40.6-2.5 8.5-11.4 13.3-19.9 10.8S23.3 196 25.8 187.5c5.2-17.6 12.4-34.3 21.3-50C37.7 126.3 32 111.8 32 96c0-35.3 28.7-64 64-64 15.8 0 30.3 5.7 41.5 15.3 15.6-8.9 32.4-16.1 50-21.3 8.5-2.5 17.4 2.3 19.9 10.8zm97.3 0c2.5-8.5 11.4-13.3 19.9-10.8 17.6 5.2 34.3 12.4 50 21.3C385.7 37.7 400.2 32 416 32c35.3 0 64 28.7 64 64 0 15.8-5.7 30.3-15.3 41.5 8.9 15.6 16.1 32.4 21.3 50 2.5 8.5-2.3 17.4-10.8 19.9s-17.4-2.3-19.9-10.8c-4.2-14.2-10-27.8-17-40.6-7 2.6-14.5 4-22.4 4-35.3 0-64-28.7-64-64 0-7.9 1.4-15.4 4-22.4-12.8-7-26.4-12.7-40.6-17-8.5-2.5-13.3-11.4-10.8-19.9zm-268 268c8.5-2.5 17.4 2.3 19.9 10.8 4.2 14.2 10 27.8 17 40.6 7-2.6 14.5-4 22.4-4 35.3 0 64 28.7 64 64 0 7.9-1.4 15.4-4 22.4 12.8 7 26.4 12.7 40.6 17 8.5 2.5 13.3 11.4 10.8 19.9s-11.4 13.3-19.9 10.8c-17.6-5.2-34.3-12.4-50-21.3-11.1 9.4-25.6 15.1-41.4 15.1-35.3 0-64-28.7-64-64 0-15.8 5.7-30.3 15.3-41.5-8.9-15.6-16.1-32.4-21.3-50-2.5-8.5 2.3-17.4 10.8-19.9zm438.6 0c8.5 2.5 13.3 11.4 10.8 19.9-5.2 17.6-12.4 34.3-21.3 50 9.5 11.2 15.3 25.7 15.3 41.5 0 35.3-28.7 64-64 64-15.8 0-30.3-5.7-41.5-15.3-15.6 8.9-32.4 16.1-50 21.3-8.5 2.5-17.4-2.3-19.9-10.8s2.3-17.4 10.8-19.9c14.2-4.2 27.8-10 40.6-17-2.6-7-4-14.5-4-22.4 0-35.3 28.7-64 64-64 7.9 0 15.4 1.4 22.4 4 7-12.8 12.7-26.4 17-40.6 2.5-8.5 11.4-13.3 19.9-10.8zM96 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm288-288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 288a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM144.8 168.8c0-8.8 7.2-16 16-16h45.6c14.6 0 26.4 11.8 26.4 26.4v45.6c0 8.8-7.2 16-16 16s-16-7.2-16-16v-13.3c-10 12.4-16 28.1-16 45.3 0 28 15.9 52.2 39.3 64.2 7.9 4 11 13.7 7 21.5s-13.7 11-21.5 7c-33.6-17.2-56.7-52.2-56.7-92.7 0-27.6 10.8-52.8 28.4-71.4l.6-.6h-21c-8.8 0-16-7.2-16-16zm208 192h-45.6c-14.6 0-26.4-11.8-26.4-26.4v-45.6c0-8.8 7.2-16 16-16s16 7.2 16 16v11.7c10-12.4 16-28.1 16-45.3 0-28-15.9-52.2-39.3-64.2-7.9-4-11-13.7-7-21.5s13.7-11 21.5-7c33.6 17.2 56.7 52.2 56.7 92.7 0 27.6-10.8 52.8-28.4 71.4-.8.8-1.6 1.6-2.5 2.2h22.9c8.8 0 16 7.2 16 16s-7.2 16-16 16z"
        }
    ]
};

const FalGuaraniSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGuaraniSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0c-8.8 0-16 7.2-16 16v50.7C69.2 81.9 0 160.9 0 256s69.2 174.1 160 189.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c106 0 192-86 192-192 0-8.8-7.2-16-16-16H192V96c43.6 0 83.1 17.4 112 45.7 6.3 6.2 16.4 6.1 22.6-.2s6.1-16.4-.2-22.6C291.8 85 244.3 64 192 64V16c0-8.8-7.2-16-16-16zm-16 99.2v313.6C87 398 32 333.4 32 256S87 114 160 99.2zM192 416V272h159.2c-8 80.9-76.2 144-159.2 144z"
        }
    ]
};

const FalGuitarElectric = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGuitarElectric",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m391.1 67.8 52.6-35L473.3 55c7.6 5.7 8.3 16.7 1.7 23.4-6.1 6.1-15.9 6.1-22 0l-9.7-9.7c-6.2-6.2-16.4-6.2-22.6 0L384 105.4V81.1c0-5.3 2.7-10.3 7.1-13.3zM352 136c0 .4 0 .9.1 1.3l-68.2 68.2c-8-10.2-13.4-20.5-12.1-27.7 1.6-8.9 5.8-16.9 9.9-24.7 8.9-16.7 17.2-32.4-3.3-53.1-15.9-16.1-41.8-16.1-57.7 0l-29.9 30.2c-9.4 9.5-15 21.1-20.6 32.8-5.6 11.6-11.1 23.1-20.3 32.3-16.5 16.7-38.1 23.8-59.8 30.8-21.8 7.1-43.7 14.3-60.6 31.4-39.3 39.7-39.3 104 0 143.7l79.9 80.8c39.4 39.9 103.5 39.9 142.9 0 17-17.2 24-39.3 31-61.3 6.9-21.9 13.8-43.7 30.5-60.5 8.7-8.8 19.5-13.8 30.3-18.8 10.9-5.1 21.8-10.1 30.6-19l21.6-21.8c15.8-15.9 15.8-41.7 0-57.6-16.5-16.7-29.8-12.3-44-7.7-7.2 2.4-14.7 4.8-22.9 4.6-5.5-.2-14-4.9-22.8-11.9L432 102.6c18.7 17 47.5 16.5 65.6-1.6 20.5-20.5 18-54.3-5.1-71.6L461 5.7C456 2 450 0 443.8 0c-5.6 0-11.2 1.7-15.9 4.8l-54.5 36.4C360 50.1 352 65.1 352 81.1V136zm-113.4 36.1c-3 17.4 4.7 32.7 9.4 40.7 5.7 9.7 13.4 18.9 21 26.7 7.7 7.9 16.4 15.4 25.1 21.2 4.3 2.9 9.1 5.8 14.2 8 4.6 2.1 11.7 4.7 20 4.9 11.4.3 21.1-2.1 27.9-4.1 2.3-.7 4.9-1.5 6.9-2.2l1.8-.6c2.4-.8 4-1.2 5.3-1.5l.3-.1c.5.4 1.1.9 1.8 1.7 2.8 2.8 2.8 7.5 0 10.3l-21.6 21.8c-3.8 3.9-9.1 6.7-20.8 12.1l-1.4.7c-10.1 4.7-25.8 11.9-38.8 25-22.4 22.7-31.5 51.3-37.9 71.8l-.8 2.4c-7.3 23.1-12.4 37.1-22.7 47.6a66.642 66.642 0 0 1-95.1 0l-79.8-80.8c-26.3-26.6-26.3-69.8 0-96.5 10.2-10.4 24-15.5 46.9-23l2.4-.8c20.3-6.6 48.7-15.8 71.1-38.4 13.2-13.3 20.9-29.3 26-40.1l.7-1.5c6-12.4 9.4-18.8 14.1-23.6l29.9-30.2c2.8-2.8 7.2-2.8 9.9 0 1.4 1.4 2.2 2.4 2.7 3.1-.1.2-.2.5-.3.7-1 2.6-2.2 4.7-4 8.2-1 1.9-2.2 4.1-3.7 7.1-3.6 6.9-8.4 17.1-10.5 29.2zm130.9 92.3a.1.1 0 1 0 0 .2.1.1 0 1 0 0-.2zM257.8 128a.1.1 0 1 0-.2 0 .1.1 0 1 0 .2 0zM148.7 276.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm-48 48c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalGuitar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGuitar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M445.7 33c.6-.6 1.5-1 2.3-1s1.7.3 2.3 1L479 61.7c.6.6 1 1.5 1 2.3s-.3 1.7-1 2.3l-39 39-42.9 9.5 9.5-42.8 39-39zm-69.3 27.5-15 67.5-35.5 35.5c-51.7-42.9-120-48-158.3-9.6-12 12-19.7 26.8-23.4 43.2-4.1 18.1-20.8 33.5-39.4 34.5-27.9 1.4-53.8 11.6-73.4 31.2C-17.4 311.7-8.3 400 51.8 460.2s148.5 69.3 197.4 20.4c19.6-19.6 29.8-45.5 31.2-73.4.9-18.5 16.4-35.3 34.5-39.4 16.4-3.7 31.2-11.4 43.2-23.4 38.3-38.3 33.3-106.6-9.6-158.3l35.5-35.5 67.5-15c3-.7 5.7-2.2 7.8-4.3L501.7 89c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L473 10.3C466.3 3.7 457.4 0 448 0s-18.3 3.7-25 10.3l-42.3 42.4c-2.2 2.2-3.6 4.9-4.3 7.8zm-73.3 125.7-74.4 74.4c-6.3-3-13.3-4.7-20.7-4.7-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48c0-7.4-1.7-14.4-4.7-20.7l74.4-74.4c34.5 42.9 31.7 91 9.7 113-7.3 7.3-16.6 12.3-27.6 14.8-30.7 6.9-57.7 34.7-59.4 69-1.1 21-8.6 39.1-21.9 52.4-32.2 32.2-99.9 31.8-152.1-20.4S21.8 317.6 54 285.4c13.3-13.3 31.4-20.9 52.4-21.9 34.3-1.7 62.1-28.7 69-59.4 2.5-11 7.5-20.3 14.8-27.6 22-22 70.1-24.8 113 9.7zM208 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalGuitars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGuitars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32v51.2c0 6.3 1.9 12.5 5.4 17.8l26.6 39.8v36C57.7 183 16 219.7 16 264c0 14 4.2 27.3 11.6 39.1 8.2 13 7.5 32-2.9 43.4C9.2 363.7 0 385 0 408c0 57.4 57.3 104 128 104 29.3 0 56.3-8 77.8-21.4-5.4-9.4-9.3-19.7-11.6-30.6-16.3 12-38.8 20.1-66.2 20.1-59.5 0-96-38.1-96-72 0-14.1 5.6-27.9 16.5-40 20.9-23.2 21.3-58 6.2-82-4.5-7.1-6.7-14.5-6.7-22 0-21.6 22.4-49.2 64-54.9v65.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3v-65.8c41.6 5.7 64 33.4 64 54.9 0 7.5-2.2 14.9-6.7 22-15.1 23.9-14.7 58.8 6.2 82 .4.5.9 1 1.3 1.5 1.9-4.6 3.9-8.9 5.7-13l.3-.7c3.7-8.4 6.9-15.6 9.5-22-3-10.1-1.5-21.8 4.1-30.7 1.1-1.7 2.1-3.5 3.1-5.3-.9-4.9-2.7-10.7-5.7-19.2l-.5-1.4c-3.7-10.7-9.3-26.7-9.3-44.6v-23c-17.4-17.3-42.9-29.4-72-32.7v-36l26.6-39.9c3.5-5.3 5.4-11.4 5.4-17.8V32c0-17.7-14.3-32-32-32h-32C94.3 0 80 14.3 80 32zm64 288a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16-212.8-16-24V32h32v51.2l-16 24zm216.9-56.4c2.4-11 12.1-18.8 23.3-18.8h3.8c10.9 0 20 9 20 20.2 0 10.9-8.9 19.8-19.6 19.8-11.2 0-20.4 9.2-20.4 20.4v57l-17.4-19.9c-3.3-3.8-4.7-8.9-3.6-13.9l13.9-64.8zm-34.4 99.8L352 198v42h-8c-43.3 0-57.3-29.2-61.8-48.2-2.1-8.6-9.3-15.8-18.2-15.8s-16 7.2-16 16v40.6c0 12.4 4 24 8 35.5 4 11.6 8 23.3 8 35.9 0 20-9.3 40.9-19 62.5-10.3 23.2-21 47.1-21 71.7 0 40.8 33 73.8 73.8 73.8h140.4c40.8 0 73.8-33 73.8-73.8 0-24.5-10.7-48.5-21-71.7-9.6-21.6-19-42.5-19-62.5 0-12 4-22.9 8.1-33.8 4-10.7 7.9-21.4 7.9-33V208c0-8.8-7.2-16-16-16s-16.2 7.3-19.5 15.5c-5.7 14-20.8 32.5-60.5 32.5h-8V102.7c23-5.3 40-26.1 40-50.5C424 23.6 400.8 0 372 0h-3.8c-26.3 0-49.1 18.4-54.6 44.1L299.7 109c-3.2 14.8.8 30.3 10.8 41.7zm54.3 121.1c1 .2 2.1.3 3.2.3s2.2-.1 3.2-.3H392c24.2 0 44-5.6 59.5-15.6l-1.2 3.3-.4 1.2c-3.8 10.1-9.5 25.6-9.5 43.4 0 27 12 53.8 20.9 73.6l1.8 4.1c10.5 23.5 17.3 40.6 17.3 56.5 0 23.3-18.9 42.1-42.1 42.1H297.8c-23.3 0-42.1-18.9-42.1-42.1 0-15.9 6.8-33 17.3-56.5l1.8-4.1c8.9-19.9 20.9-46.6 20.9-73.6 0-18-5.5-34-9.3-44.8l-.4-1.3c-.7-1.9-1.3-3.7-1.8-5.3 15.1 11.9 35 19.2 59.9 19.2h20.8zM320 352c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalGunSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGunSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM473.4 240c8.5 0 16.6-3.4 22.6-9.4l22.6-22.6H576c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-32V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H180.1l40.5 32H576v80h-57.4c-8.5 0-16.6 3.4-22.6 9.4L473.4 208H362.5l40.5 32h70.4zm-223.9 41.9L208 448H96l40.1-160.5c4.3-17 1.3-33.8-6.7-47.5h67l-40.5-32H64v-72.6l-32-25.2V208c0 17.7 14.3 32 32 32h10c20.8 0 36.1 19.6 31 39.8L65 440.2c-2.4 9.6-.2 19.7 5.8 27.5S86.1 480 96 480h112c14.7 0 27.5-10 31-24.2l38-152.1-27.5-21.7z"
        }
    ]
};

const FalGunSquirt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGunSquirt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c-53 0-96 43-96 96 0 47.3 34.3 86.7 79.4 94.6L33 440.2c-2.4 9.6-.2 19.7 5.8 27.5S54.1 480 64 480h104c14.7 0 27.5-10 31-24.2L225 352h63v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-55l16-64h199c35.6 0 66.6-19.3 83.2-48h4.8c22.1 0 40-17.9 40-40v-16c0-22.1-17.9-40-40-40h-4.8c-16.6-28.7-47.6-48-83.2-48H128V48zm-16 48h336c26.2 0 48.8 15.8 58.7 38.4 2.5 5.8 8.3 9.6 14.7 9.6H536c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-14.7c-6.4 0-12.1 3.8-14.7 9.6-9.8 22.6-32.4 38.4-58.6 38.4H96c-35.3 0-64-28.7-64-64s28.7-64 64-64h16zm-16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM64 448l48-192h104l-48 192H64z"
        }
    ]
};

const FalGun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalGun",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 32c8.8 0 16 7.2 16 16v16h32c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32h-57.4L464 230.6c-6 6-14.1 9.4-22.6 9.4h-46.1l-28.6 80.1c-6.8 19.1-24.9 31.9-45.2 31.9H233l-26 103.8c-3.5 14.2-16.3 24.2-31 24.2H64c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l40.1-160.4c5-20.2-10.2-39.8-31-39.8H32c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h448V48c0-8.8 7.2-16 16-16zM241 320h80.5c6.8 0 12.8-4.3 15.1-10.6l24.7-69.4H261l-20 80zM32 96v112h409.4l22.6-22.6c6-6 14.1-9.4 22.6-9.4H544V96H32zm196 144H97.5c8 13.7 10.9 30.5 6.7 47.5L64 448h112l52-208z"
        }
    ]
};

const FalH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalH",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 256v208c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v176H32V48c0-8.8-7.2-16-16-16S0 39.2 0 48v416c0 8.8 7.2 16 16 16s16-7.2 16-16V256h320z"
        }
    ]
};

const FalH1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalH1",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 80c0-5.7-3-10.9-7.9-13.8s-10.9-2.9-15.9-.2l-72 40c-7.7 4.3-10.5 14-6.2 21.8s14 10.5 21.8 6.2l48.2-26.8V416h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64V80zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h256v160c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v160H32V80z"
        }
    ]
};

const FalH2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalH2",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h256v160c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v160H32V80zm400.1 41.5c19.2-16.5 43.7-25.5 69-25.5h5.9c47 0 85 38.1 85 85 0 23.1-9.4 45.2-26.1 61.2l-185 178.2c-4.7 4.5-6.2 11.5-3.7 17.5s8.3 10 14.8 10h232c8.8 0 16-7.2 16-16s-7.2-16-16-16H431.7l156.4-150.6c23-22 35.9-52.5 35.9-84.3 0-64.6-52.4-117-117-117h-5.8c-33 0-64.8 11.8-89.9 33.2l-21.7 18.6c-6.7 5.8-7.5 15.9-1.7 22.6s15.8 7.5 22.6 1.7l21.7-18.6z"
        }
    ]
};

const FalH3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalH3",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h256v160c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v160H32V80zm368-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h160L421 228.4c-4.7 4.5-6.3 11.5-3.8 17.5s8.3 10.1 14.9 10.1h96c44.2 0 80 35.8 80 80s-35.8 80-80 80h-72.7c-19.6 0-36.2-14.1-39.5-33.4l-.2-1.2c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l.2 1.2c5.8 34.7 35.8 60.2 71 60.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112h-56L611 91.6c4.7-4.5 6.3-11.5 3.8-17.5S606.5 64 600 64H400z"
        }
    ]
};

const FalH4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalH4",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m447.7 83-36.3 189H608V80c0-8.8 7.2-16 16-16s16 7.2 16 16v352c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H392c-4.8 0-9.3-2.1-12.3-5.8s-4.3-8.5-3.4-13.2l40-208c1.7-8.7 10.1-14.4 18.7-12.7s14.4 10.1 12.7 18.7zM16 64c8.8 0 16 7.2 16 16v160h256V80c0-8.8 7.2-16 16-16s16 7.2 16 16v352c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H32v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalH5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalH5",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h256v160c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v160H32V80zm400-16c-7.6 0-14.2 5.4-15.7 12.9l-32 160c-.9 4.7.3 9.6 3.3 13.3s7.6 5.9 12.4 5.9h128c44.2 0 80 35.8 80 80s-35.8 80-80 80h-71.6c-17.2 0-32.5-11-37.9-27.4l-3.2-9.7c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l3.2 9.7c9.8 29.4 37.3 49.2 68.3 49.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H419.5l25.6-128H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"
        }
    ]
};

const FalH6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalH6",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h256v160c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v160H32V80zm473.4-12.9c-7.1-5.2-17.2-3.6-22.4 3.5l-99.7 137.2A163.59 163.59 0 0 0 352 304c0 79.5 64.5 144 144 144s144-64.5 144-144-64.5-144-144-144c-15 0-29.6 2.3-43.2 6.6l56.1-77.2c5.2-7.1 3.6-17.2-3.5-22.4zM496 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"
        }
    ]
};

const FalHammerCrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHammerCrash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m283.7 379.4 11.9-48.2c10.4 4.3 21.3 5.6 31.9 4.4l-4.4 17.7 71.3-35.9c6.9-3.5 15.2-1.6 19.9 4.5l48.7 63.3 16.3-78.2c1.6-7.5 8.3-12.9 15.9-12.7l79.8 1.4-50.9-61.5c-4.9-5.9-4.9-14.5 0-20.4l50.9-61.5-79.8 1.4c-7.7.1-14.4-5.2-15.9-12.7L463 62.8l-30.4 39.5c-5.4-6.3-12.1-11.6-20-15.6l-6.1-3 52.3-68c3.8-5 10.2-7.2 16.2-5.8s10.8 6.2 12.1 12.3l20.8 99.3 101.4-1.8c6.2-.1 12 3.4 14.7 9.1s1.9 12.3-2.1 17.1L557.3 224l64.7 78.1c4 4.8 4.8 11.5 2.1 17.1s-8.5 9.2-14.7 9.1L508 326.5l-20.8 99.3c-1.3 6.1-6 10.9-12.1 12.3s-12.4-.9-16.2-5.8L397 351.8l-90.6 45.7c-5.6 2.8-12.3 2.1-17.2-1.8s-7.1-10.3-5.6-16.4zM72 48l-40 80 288 144 64-128-192-96H72zM43.4 33.7C48.8 22.8 59.9 16 72 16h120c5 0 9.9 1.2 14.3 3.4l192 96c15.8 7.9 22.2 27.1 14.3 42.9l-64 128c-7.9 15.8-27.1 22.2-42.9 14.3l-97.9-48.9-28.6-14.3-28.6-14.3-28.6-14.3-104.3-52.2c-15.8-7.9-22.2-27.1-14.3-42.9l40-80zM5.1 442.5l102.6-205.1 28.6 14.3L33.7 456.9c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2L164.9 266l28.6 14.3L90.9 485.5C79 509.2 50.2 518.8 26.5 507s-33.3-40.7-21.4-64.5z"
        }
    ]
};

const FalHammerWar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHammerWar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v37.2L36.7 32.4C17.7 29.5 0 44.7 0 64v192c0 19.3 17.7 34.5 36.7 31.6L187.2 265c3.1-.5 6.3-.5 9.5 0l150.5 22.6c19.1 2.9 36.7-12.4 36.7-31.6V64c0-19.3-17.7-34.5-36.7-31.6L208 53.2V16zm0 283.1-16-2.4-16 2.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V299.1zM32 255.8V64.2l.1-.1.1-.1 150.3 22.6c6.3.9 12.7.9 19 0L351.8 64l.1.1.1.1v191.6l-.1.1h-.2l-150.2-22.5c-6.3-.9-12.7-.9-19 0L32.2 256l-.1-.1-.1-.1z"
        }
    ]
};

const FalHammer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHammer",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M398.5 206.8c8.6-.1 16.8 3.3 22.9 9.4l50.6 50.5 42.7-42.7-48.3-48.3c-6.5-6.5-9.9-15.4-9.3-24.5 1-17-5.2-34.2-18.5-46.7L394 62.4C373.2 42.9 345.8 32 317.2 32h-18c-15.7 0-31.2 3.3-45.5 9.7l-17.6 7.8 51.2 27.9C297.6 83 304 93.8 304 105.5v12.1c0 12.6 5 24.7 13.9 33.7l38.1 38.1c11.7 11.7 27.1 17.5 42.4 17.4zm138.8-5.4 3.3 3.3 8-8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16-3.3-3.3-50.6-50.6c-23.6.2-47.3-8.7-65.4-26.7L295.2 174c-14.8-15-23.2-35.2-23.2-56.4v-12.1L192.3 62c-5.3-2.9-8.6-8.6-8.3-14.7s3.9-11.5 9.5-14l47.2-21C259.1 4.2 279 0 299.2 0h18.1c36.7 0 72 14 98.7 39.1l44.6 42c20.5 19.3 30.1 45.9 28.5 72l48.3 48.3zM27.4 377.1l233.5-194.5c3.5 4.9 7.5 9.6 11.8 14l9.7 9.7L47.9 401.7c-10.1 8.4-15.9 20.9-15.9 34 0 24.5 19.8 44.3 44.3 44.3 13.1 0 25.6-5.8 34-15.9l195.4-234.5 5.1 5.1c6 6 12.4 11.2 19.2 15.7L134.9 484.6C120.4 502 98.9 512 76.3 512 34.1 512 0 477.8 0 435.7c0-22.6 10.1-44.1 27.4-58.6z"
        }
    ]
};

const FalHamsa = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHamsa",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c17.7 0 32 14.3 32 32v144c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-17.7 14.3-32 32-32s32 14.3 32 32v176c0 8.8 7.2 16 16 16h50.7c16.2 0 29.3 13.1 29.3 29.3 0 7.8-3.1 15.2-8.6 20.7l-90.2 90.2C348 461.3 303 480 256 480s-92-18.7-125.3-51.9l-90.1-90.2c-5.5-5.4-8.6-12.9-8.6-20.6 0-16.2 13.1-29.3 29.3-29.3H112c8.8 0 16-7.2 16-16V96c0-17.7 14.3-32 32-32s32 14.3 32 32v112c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7 14.3-32 32-32zm0-32c-27.9 0-51.7 17.9-60.4 42.8C185.4 36 173.2 32 160 32c-35.3 0-64 28.7-64 64v160H61.3C27.4 256 0 283.4 0 317.3c0 16.2 6.5 31.8 17.9 43.3l90.2 90.2C147.3 490 200.5 512 256 512s108.7-22 147.9-61.3l90.2-90.2c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3H416V96c0-35.3-28.7-64-64-64-13.2 0-25.4 4-35.6 10.8C307.7 17.9 283.9 0 256 0zm-79.1 349.3c6.5-6.7 18.7-18.4 33.5-28.2 15.1-10.1 31.1-17 45.6-17s30.5 6.9 45.6 17c14.8 9.9 27 21.5 33.5 28.2.4.5.9 1.3.9 2.7s-.5 2.3-.9 2.7c-6.5 6.7-18.7 18.4-33.5 28.2-15.1 10.1-31.1 17-45.6 17s-30.5-6.9-45.6-17c-14.8-9.9-27-21.5-33.5-28.2-.4-.5-.9-1.3-.9-2.7s.5-2.3.9-2.7zM256 272c-23.8 0-46.2 11-63.4 22.4-17.4 11.6-31.4 25.1-38.7 32.7-6.7 7-9.9 16.1-9.9 25s3.2 18 9.9 25c7.3 7.6 21.3 21 38.7 32.7C209.8 421 232.2 432 256 432s46.2-11 63.4-22.4c17.4-11.6 31.4-25.1 38.7-32.7 6.7-7 9.9-16.1 9.9-25s-3.2-18-9.9-25c-7.3-7.6-21.3-21-38.7-32.7C302.2 283 279.8 272 256 272zm0 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalHandBackFist = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandBackFist",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c0-35.3 28.7-64 64-64 23.9 0 44.8 13.1 55.7 32.5 2.7-.4 5.5-.5 8.3-.5 23.9 0 44.8 13.1 55.7 32.5 2.7-.4 5.5-.5 8.3-.5 23.9 0 44.8 13.1 55.7 32.5 2.7-.4 5.5-.5 8.3-.5 35.3 0 64 28.7 64 64v80c0 49.6-25.1 93.3-63.2 119.2-.4.3-.6.6-.7.7 0 .1 0 .1-.1.1v136c0 8.8-7.2 16-16 16s-16-7.2-16-16V360.1c0-11.6 6.3-21.5 14.8-27.4 29.7-20.1 49.2-54.1 49.2-92.7v-80c0-17.7-14.3-32-32-32-4.2 0-8.2.8-11.8 2.2-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C315.2 106 302.7 96 288 96c-4.2 0-8.2.8-11.8 2.2-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C251.2 74 238.7 64 224 64c-4.2 0-8.2.8-11.8 2.2-4.2 1.7-9 1.5-13.1-.6s-7.1-5.7-8.3-10.1C187.2 42 174.7 32 160 32c-17.7 0-32 14.3-32 32v144c0 8.8-7.2 16-16 16s-16-7.2-16-16v-57.4l-17.9 18c-9 9-14.1 21.2-14.1 33.9V256c0 44.2 29.9 81.5 70.6 92.6 13.5 3.7 25.4 15.8 25.4 32.1V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V380.7s-.1-.1-.2-.3c-.3-.4-.8-.8-1.6-1C71.9 364.7 32 315 32 256v-53.5c0-21.2 8.4-41.6 23.4-56.6L96 105.4V64z"
        }
    ]
};

const FalHandBackPointDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandBackPointDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 512c-30.9 0-56-25.1-56-56V255.4c-3.2-2-6.4-4.2-9.5-6.5L48 232c-20.1-15.1-32-38.8-32-64v-19.5c0-53 29.1-101.7 75.7-126.8l8.3-4.5C121 5.9 144.4 0 168.3 0H304c61.9 0 112 50.1 112 112v96c0 35.3-28.7 64-64 64-2.8 0-5.6-.2-8.3-.5-11 19.4-31.8 32.5-55.7 32.5-5.3 0-10.5-.7-15.5-1.9-10.8 20.2-32 33.9-56.5 33.9-8.5 0-16.6-1.7-24-4.7V456c0 30.9-25.1 56-56 56zm-24-56c0 13.3 10.7 24 24 24s24-10.7 24-24V298.5c0-7.1 4.6-13.3 11.4-15.3s14 .6 18 6.5c5.8 8.7 15.6 14.3 26.7 14.3 15.6 0 28.6-11.2 31.4-25.9 1-5.1 4.4-9.5 9.2-11.6s10.3-1.8 14.8.9c4.8 2.9 10.5 4.6 16.6 4.6 14.7 0 27.2-10 30.9-23.6 1.2-4.4 4.2-8.1 8.3-10.1s8.8-2.2 13.1-.6c3.6 1.4 7.6 2.2 11.8 2.2 17.7 0 32-14.3 32-32V112c0-44.2-35.8-80-80-80H168.3c-18.5 0-36.8 4.6-53.1 13.4l-7.6-14.1 7.6 14.1-8.3 4.5C70.6 69.4 48 107.3 48 148.5V168c0 15.1 7.1 29.3 19.2 38.4L80 216v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v288z"
        }
    ]
};

const FalHandBackPointLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandBackPointLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 168c0-30.9 25.1-56 56-56h200.6c2-3.2 4.2-6.4 6.5-9.5L280 80c15.1-20.1 38.8-32 64-32h19.5c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3V336c0 61.9-50.1 112-112 112h-96c-35.3 0-64-28.7-64-64 0-2.8.2-5.6.5-8.3-19.4-11-32.5-31.8-32.5-55.7 0-5.3.7-10.5 1.9-15.5-20.2-10.8-33.9-32-33.9-56.5 0-8.5 1.7-16.6 4.7-24H56c-30.9 0-56-25.1-56-56zm56-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h157.5c7.1 0 13.3 4.6 15.3 11.4s-.6 14-6.5 18c-8.7 5.8-14.3 15.6-14.3 26.7 0 15.6 11.2 28.6 25.9 31.4 5.1 1 9.5 4.4 11.6 9.2s1.8 10.3-.9 14.8c-2.9 4.8-4.6 10.5-4.6 16.6 0 14.7 10 27.2 23.6 30.9 4.4 1.2 8.1 4.2 10.1 8.3s2.2 8.8.6 13.1c-1.4 3.6-2.2 7.6-2.2 11.8 0 17.7 14.3 32 32 32h96c44.2 0 80-35.8 80-80V200.5c0-18.5-4.6-36.8-13.4-53.1l14.1-7.6-14.1 7.6-4.5-8.3C442.6 102.6 404.7 80 363.5 80H344c-15.1 0-29.3 7.1-38.4 19.2L296 112h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H56z"
        }
    ]
};

const FalHandBackPointRibbon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandBackPointRibbon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 0c-30.9 0-56 25.1-56 56v8H16c-6.2 0-11.8 3.5-14.4 9.1S-.3 85.2 3.5 90l24 30-24 30c-3.8 4.8-4.6 11.4-1.9 16.9S9.8 176 16 176h80v80.6c-3.2 2-6.4 4.2-9.5 6.5L64 280c-20.1 15.1-32 38.8-32 64v19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H320c61.9 0 112-50.1 112-112v-96c0-35.3-28.7-64-64-64-2.8 0-5.6.2-8.3.5-11-19.4-31.8-32.5-55.7-32.5-5.3 0-10.5.7-15.5 1.9-10.8-20.2-32-33.9-56.5-33.9-8.5 0-16.6 1.7-24 4.7V56c0-30.9-25.1-56-56-56zm-24 176h48v37.5c0 7.1 4.6 13.3 11.4 15.3s14-.6 18-6.5c5.8-8.7 15.6-14.3 26.7-14.3 15.6 0 28.6 11.2 31.4 25.9 1 5.1 4.4 9.5 9.2 11.6s10.3 1.8 14.8-.9c4.8-2.9 10.5-4.6 16.6-4.6 14.7 0 27.2 10 30.9 23.6 1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1.6c3.6-1.4 7.6-2.2 11.8-2.2 17.7 0 32 14.3 32 32v96c0 44.2-35.8 80-80 80H184.3c-18.5 0-36.8-4.6-53.1-13.4l-8.3-4.5C86.6 442.6 64 404.7 64 363.5V344c0-15.1 7.1-29.3 19.2-38.4L96 296v48c0 8.8 7.2 16 16 16s16-7.2 16-16V176zm48-32H49.3l11.2-14c4.7-5.8 4.7-14.1 0-20L49.3 96H176v48zm0-80h-48v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8z"
        }
    ]
};

const FalHandBackPointRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandBackPointRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 168c0-30.9-25.1-56-56-56H255.4c-2-3.2-4.2-6.4-6.5-9.5L232 80c-15.1-20.1-38.8-32-64-32h-19.5c-53 0-101.7 29.1-126.8 75.7l-4.5 8.3C5.9 153 0 176.4 0 200.3V336c0 61.9 50.1 112 112 112h96c35.3 0 64-28.7 64-64 0-2.8-.2-5.6-.5-8.3 19.4-11 32.5-31.8 32.5-55.7 0-5.3-.7-10.5-1.9-15.5 20.2-10.8 33.9-32 33.9-56.5 0-8.5-1.7-16.6-4.7-24H456c30.9 0 56-25.1 56-56zm-56-24c13.3 0 24 10.7 24 24s-10.7 24-24 24H298.5c-7.1 0-13.3 4.6-15.3 11.4s.6 14 6.5 18c8.7 5.8 14.3 15.6 14.3 26.7 0 15.6-11.2 28.6-25.9 31.4-5.1 1-9.5 4.4-11.6 9.2s-1.8 10.3.9 14.8c2.9 4.8 4.6 10.5 4.6 16.6 0 14.7-10 27.2-23.6 30.9-4.4 1.2-8.1 4.2-10.1 8.3s-2.2 8.8-.6 13.1c1.4 3.6 2.2 7.6 2.2 11.8 0 17.7-14.3 32-32 32h-96c-44.2 0-80-35.8-80-80V200.5c0-18.5 4.6-36.8 13.4-53.1l-14.1-7.6 14.1 7.6 4.5-8.3C69.4 102.6 107.3 80 148.5 80H168c15.1 0 29.3 7.1 38.4 19.2L216 112h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h288z"
        }
    ]
};

const FalHandBackPointUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandBackPointUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 0c-30.9 0-56 25.1-56 56v200.6c-3.2 2-6.4 4.2-9.5 6.5L48 280c-20.1 15.1-32 38.8-32 64v19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H304c61.9 0 112-50.1 112-112v-96c0-35.3-28.7-64-64-64-2.8 0-5.6.2-8.3.5-11-19.4-31.8-32.5-55.7-32.5-5.3 0-10.5.7-15.5 1.9-10.8-20.2-32-33.9-56.5-33.9-8.5 0-16.6 1.7-24 4.7V56c0-30.9-25.1-56-56-56zm-24 56c0-13.3 10.7-24 24-24s24 10.7 24 24v157.5c0 7.1 4.6 13.3 11.4 15.3s14-.6 18-6.5c5.8-8.7 15.6-14.3 26.7-14.3 15.6 0 28.6 11.2 31.4 25.9 1 5.1 4.4 9.5 9.2 11.6s10.3 1.8 14.8-.9c4.8-2.9 10.5-4.6 16.6-4.6 14.7 0 27.2 10 30.9 23.6 1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1.6c3.6-1.4 7.6-2.2 11.8-2.2 17.7 0 32 14.3 32 32v96c0 44.2-35.8 80-80 80H168.3c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C70.6 442.6 48 404.7 48 363.5V344c0-15.1 7.1-29.3 19.2-38.4L80 296v48c0 8.8 7.2 16 16 16s16-7.2 16-16V56z"
        }
    ]
};

const FalHandDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M210.7 38.8C218 16.3 239.1 0 264 0s46 16.3 53.3 38.8c7.9-4.3 17-6.8 26.7-6.8 30.9 0 56 25.1 56 56v13.4c7.3-3.5 15.4-5.4 24-5.4 30.9 0 56 25.1 56 56v184c0 97.2-78.8 176-176 176h-8.5c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0l32.4 32.4V88c0-30.9 25.1-56 56-56 9.7 0 18.8 2.5 26.7 6.8zM208 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v239.4c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L73 279c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l103.7 103.8c40.5 40.5 95.4 63.3 152.7 63.3h8.5c79.5 0 144-64.5 144-144V152c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v184c0 8.8-7.2 16-16 16s-16-7.2-16-16V88zm32 232a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm48 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 112a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-64-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-80-32a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalHandFingersCrossed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandFingersCrossed",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M189.8 4.4c-28.5-12.1-61.3 1.3-73.4 29.8L112 44.6l-4.4-10.5C95.5 5.7 62.7-7.6 34.2 4.4S-7.6 49.3 4.4 77.8l46.8 110.6-22.8 53.8-12.8 30.4C5.8 285.8 0 302.2 0 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V240c0-3.2-.9-6.1-2.5-8.6-7.1-22.8-28.3-39.4-53.5-39.4-12.1 0-23.3 3.8-32.5 10.4C285.6 186.5 268 176 248 176c-30.9 0-56 25.1-56 56v1.7l-19.2-45.4 46.8-110.5c12.1-28.5-1.3-61.3-29.8-73.4zm-34.4 225 4.5 10.6H151l4.5-10.6zm-86.8-82.1L33.9 65.4c-5.2-12.2.5-26.3 12.8-31.5s26.3.5 31.5 12.8l16.4 39-26 61.6zM80 240c-5.7 0-11.3.6-16.6 1.7l82.5-195.1c5.2-12.2 19.2-17.9 31.5-12.8s17.9 19.2 12.8 31.5l-74 174.7H80zm168-32c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64c0-13.3 10.7-24 24-24zm32.5 133.6C290.4 357.5 308 368 328 368c8.4 0 16.4-1.9 23.5-5.2C346.1 428.5 291 480 224 480h-64c-70.7 0-128-57.3-128-128v-32c0-26.5 21.5-48 48-48h88c13.2 0 24 10.7 24 24s-10.7 24-24 24h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8 10.2 10.4 24.3 16.8 40 16.8 12.1 0 23.3-3.8 32.5-10.4zM352 312c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64z"
        }
    ]
};

const FalHandFist = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandFist",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M254.2 233.7c7.7 4 16.5 6.3 25.8 6.3 12.1 0 23.3-3.8 32.5-10.4C322.4 245.5 340 256 360 256c8.6 0 16.7-1.9 24-5.4v5.4c0 38.6-19.5 72.6-49.2 92.7-8.6 5.8-14.8 15.7-14.8 27.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V376l.1-.1c.1-.2.3-.5.7-.7C390.9 349.3 416 305.6 416 256V152c0-30.9-25.1-56-56-56-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56-9.7 0-18.8 2.5-26.7 6.8C246 16.3 224.9 0 200 0s-46 16.3-53.3 38.8c-7.9-4.3-17-6.8-26.7-6.8-30.9 0-56 25.1-56 56v112c0 2.6.2 5.1.5 7.6C44.8 222.2 32 245.6 32 272c0 59 39.9 108.7 94.2 123.5.8.2 1.3.6 1.6 1 .1.2.2.3.2.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-99.3c0-16.3-11.9-28.4-25.4-32.1C93.9 353.5 64 316.2 64 272c0-26.5 21.5-48 48-48h88c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c30.9 0 56-25.1 56-56 0-4.9-.6-9.7-1.8-14.3zM224 197.4c-7.3-3.5-15.4-5.4-24-5.4h-24V56c0-13.3 10.7-24 24-24s24 10.7 24 24v141.4zm-80-5.4h-32c-5.5 0-10.8.6-16 1.6V88c0-13.3 10.7-24 24-24s24 10.7 24 24v104zm240 0v8c0 13.3-10.7 24-24 24s-24-10.7-24-24v-48c0-13.3 10.7-24 24-24s24 10.7 24 24v40zM256 88c0-13.3 10.7-24 24-24s24 10.7 24 24v96c0 13.3-10.7 24-24 24s-24-10.7-24-24V88z"
        }
    ]
};

const FalHandHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M210.7 38.8C218 16.3 239.1 0 264 0s46 16.3 53.3 38.8c7.9-4.3 17-6.8 26.7-6.8 30.9 0 56 25.1 56 56v13.4c7.3-3.5 15.4-5.4 24-5.4 30.9 0 56 25.1 56 56v184c0 97.2-78.8 176-176 176h-8.5c-65.8 0-128.9-26.1-175.4-72.6L16.4 335.6c-21.9-21.9-21.9-57.3 0-79.2s57.3-21.9 79.2 0l32.4 32.4V88c0-30.9 25.1-56 56-56 9.7 0 18.8 2.5 26.7 6.8zM208 88c0-13.3-10.7-24-24-24s-24 10.7-24 24v239.4c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5L73 279c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l103.7 103.8c40.5 40.5 95.4 63.3 152.7 63.3h8.5c79.5 0 144-64.5 144-144V152c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V88c0-13.3-10.7-24-24-24-13.2 0-24 10.7-24 23.9V240c0 8.8-7.2 16-16 16s-16-7.2-16-16V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v184c0 8.8-7.2 16-16 16s-16-7.2-16-16V88zm13.7 250.8c0 5.8 2.3 11.4 6.5 15.4l59.8 58.2 59.8-58.1c4.2-4 6.5-9.6 6.5-15.4 0-11.9-9.6-21.5-21.5-21.5h-1.5c-6 0-11.7 2.3-16 6.5l-16.1 15.6c-6.2 6-16.1 6-22.3 0l-16.1-15.6c-4.3-4.2-10.1-6.5-16-6.5h-1.5c-11.9 0-21.5 9.6-21.5 21.5zm21.5-53.5h1.5c14.3 0 28.1 5.6 38.4 15.6l4.9 4.8 4.9-4.8c10.3-10 24-15.6 38.4-15.6h1.5c29.5 0 53.5 23.9 53.5 53.5 0 14.4-5.8 28.3-16.2 38.4l-70.9 69c-6.2 6-16.1 6-22.3 0l-70.9-69c-10.4-10.1-16.2-23.9-16.2-38.4 0-29.5 23.9-53.5 53.5-53.5z"
        }
    ]
};

const FalHandHoldingBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHoldingBox",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32v96c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6.7l56.8-28.4 56.8 28.4c5 2.5 10.9 2.2 15.6-.7s7.6-8.1 7.6-13.6V32h64c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h64zm16-32h-80c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H224zm16 32h96v70.1l-40.8-20.4c-4.5-2.3-9.8-2.3-14.3 0L240 102.1V32zm-44.6 272c-15.8 0-31.2 4.7-44.4 13.4L75.2 368H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c3.2 0 6.2-.9 8.9-2.7l79.9-53.3c7.9-5.3 17.1-8.1 26.6-8.1H344c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h148.6c2.9 0 5.7-.8 8.2-2.3l98.5-58.6c3.4-2 7.2-3 11.1-3h1.3c11.2 0 20.3 9.1 20.3 20.3 0 6.9-3.5 13.3-9.2 17l-119.7 77.8c-13 8.4-28.1 12.9-43.6 12.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h355.5c21.7 0 42.9-6.3 61-18.1l119.6-77.8C567 406.5 576 390 576 372.3c0-28.9-23.4-52.3-52.3-52.3h-1.3c-9.7 0-19.1 2.6-27.5 7.6L400.2 384h-5.6c3.5-7.3 5.4-15.4 5.4-24 0-30.9-25.1-56-56-56H195.4z"
        }
    ]
};

const FalHandHoldingDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHoldingDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 24v17.3c8.5 1.2 16.7 3.1 24.1 5.1 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3-8.4-.1-17.3 1.8-23.6 5.5-5.7 3.4-8.1 7.3-8.1 12.8 0 3.7 1.3 6.5 7.3 10.1 6.9 4.1 16.6 7.1 29.2 10.9l.5.1c11.3 3.4 25.3 7.6 36.3 14.6 12.1 7.6 22.4 19.7 22.7 38.2.3 19.3-9.6 33.3-22.9 41.6-7.7 4.8-16.4 7.6-25.1 9.1V232c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17.8c-11.2-2.1-21.7-5.7-30.9-8.9-2.1-.7-4.2-1.4-6.2-2.1-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5.8 4.8 1.6 7.1 2.4 13.6 4.6 24.6 8.4 36.3 8.7 9.1.3 17.9-1.7 23.7-5.3 5.1-3.2 7.9-7.3 7.8-14-.1-4.6-1.8-7.8-7.7-11.6-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5c-11-3.3-24.3-7.3-34.8-13.7-12-7.2-22.6-18.9-22.7-37.3-.1-19.3 10.8-32.7 23.8-40.4 7.5-4.4 15.8-7.2 24.1-8.7V24c0-8.8 7.2-16 16-16s16 7.2 16 16zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56 0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3 0 17.7-9 34.2-23.8 43.8l-119.6 77.8c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h355.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17 0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1l-79.9 53.2c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h59.2l75.8-50.6z"
        }
    ]
};

const FalHandHoldingDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHoldingDroplet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.6 121.1c-7.6 11-11.6 24-11.6 37.2v1.7c0 35.3 28.7 64 64 64s64-28.7 64-64v-1.7c0-13.3-4-26.3-11.6-37.2L288 44.8l-52.4 76.3zM209.2 103l66.3-96.4C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6l66.3 96.4c11.2 16.3 17.2 35.6 17.2 55.3v1.7c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56 0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3 0 17.7-9 34.2-23.8 43.8l-119.6 77.8c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h355.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17 0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1l-79.9 53.2c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h59.2l75.8-50.6z"
        }
    ]
};

const FalHandHoldingHand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHoldingHand",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M425 226.6c-13.1 8.8-28.6 13.4-44.4 13.4H232c-30.9 0-56-25.1-56-56 0-8.6 1.9-16.7 5.4-24h-5.6l-94.7 56.4c-8.3 4.9-17.8 7.6-27.5 7.6h-1.3C23.4 224 0 200.6 0 171.7c0-17.7 9-34.2 23.8-43.9l119.6-77.7c18.2-11.8 39.4-18.1 61-18.1H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H204.5c-15.5 0-30.6 4.5-43.6 12.9L41.2 154.7c-5.8 3.7-9.2 10.1-9.2 17 0 11.2 9.1 20.3 20.3 20.3h1.3c3.9 0 7.7-1.1 11.1-3l98.5-58.7c2.5-1.5 5.3-2.3 8.2-2.3H320c8.8 0 16 7.2 16 16s-7.2 16-16 16h-88c-13.3 0-24 10.7-24 24s10.7 24 24 24h148.6c9.5 0 18.7-2.8 26.6-8.1l79.9-53.3c2.6-1.8 5.7-2.7 8.9-2.7h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-59.2L425 226.6zm-274 58.8c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56 0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3 0 17.7-9 34.2-23.8 43.8l-119.6 77.8c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h355.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17 0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1l-79.9 53.2c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h59.2l75.8-50.6z"
        }
    ]
};

const FalHandHoldingHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHoldingHeart",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.9 28.9C191.7.7 235.8-.8 265.3 24.3c5.8 4.9 11 10.4 16.3 15.9 2.1 2.2 4.2 4.5 6.4 6.6 2.1-2.2 4.3-4.4 6.4-6.6 5.2-5.5 10.5-11 16.3-15.9C340.2-.8 384.3.7 412.1 28.9c29.4 29.8 29.4 78.2 0 108L310.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L163.9 136.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0-17.1 17.4-17.1 45.7 0 63.1L288 217.3l101.3-102.9c17.1-17.4 17.1-45.7 0-63.1-16.8-17.1-44-17.1-60.8 0l-29.1 29.6c-6.3 6.4-16.5 6.4-22.8 0l-29.1-29.5zm-96.5 266c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56 0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3 0 17.7-9 34.2-23.8 43.8l-119.6 77.8c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h355.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17 0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1l-79.9 53.2c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h59.2l75.8-50.6z"
        }
    ]
};

const FalHandHoldingMagic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHoldingMagic",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80c0 26.5 21.5 48 48 48h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-44.2 0-80-35.8-80-80s35.8-80 80-80h120c66.3 0 120 53.7 120 120s-53.7 120-120 120h-56v24c0 8.8-7.2 16-16 16s-16-7.2-16-16v-26.5c0-16.3 13.2-29.5 29.5-29.5H328c48.6 0 88-39.4 88-88s-39.4-88-88-88H208c-26.5 0-48 21.5-48 48zm-9 237.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56 0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3 0 17.7-9 34.2-23.8 43.8l-119.6 77.8c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h355.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17 0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1l-79.9 53.2c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h59.2l75.8-50.6z"
        }
    ]
};

const FalHandHoldingMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHoldingMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M266.7 0h42.7c17.7 0 32 14.3 32 32v42.7H384c17.7 0 32 14.3 32 32v42.7c0 17.7-14.3 32-32 32h-42.7V224c0 17.7-14.3 32-32 32h-42.6c-17.7 0-32-14.3-32-32v-42.7H192c-17.7 0-32-14.3-32-32v-42.6c0-17.7 14.3-32 32-32h42.7V32c0-17.7 14.3-32 32-32zm0 32v58.7c0 8.8-7.2 16-16 16H192v42.7h58.7c8.8 0 16 7.2 16 16V224h42.7v-58.7c0-8.8 7.2-16 16-16h58.7v-42.6h-58.8c-8.8 0-16-7.2-16-16V32h-42.7zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56 0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3 0 17.7-9 34.2-23.8 43.8l-119.6 77.8c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h355.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17 0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1l-79.9 53.2c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h59.2l75.8-50.6z"
        }
    ]
};

const FalHandHoldingSeedling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHoldingSeedling",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M125.1 0H144c88.4 0 160 71.6 160 160v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-29.1C161.8 176 96 110.2 96 29.1 96 13 109 0 125.1 0zM144 32h-16c1.5 62.1 52.4 112 114.9 112H271c-7.9-63.1-61.7-112-127-112zm192 144v-16c0-5.4-.2-10.7-.7-16 61.5-1.2 111.1-50.6 112.7-112h-16c-45.7 0-85.8 23.9-108.4 59.9-4.3-11.4-9.7-22.3-16-32.5C336.9 23.2 381.7 0 432 0h18.9C467 0 480 13 480 29.1c0 80.2-64.2 145.3-144 146.9zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56 0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3 0 17.7-9 34.2-23.8 43.8l-119.6 77.8c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h355.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17 0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1l-79.9 53.2c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h59.2l75.8-50.6z"
        }
    ]
};

const FalHandHoldingSkull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHoldingSkull",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 128c0 33.3 20 63.5 51.9 81 6.4 3.5 9.6 10.9 7.8 17.9l-7.2 29.1h119l-7.3-29.1c-1.8-7.1 1.5-14.4 7.8-17.9 32-17.5 52-47.7 52-81 0-51.1-48.1-96-112-96s-112 44.9-112 96zM288 0c77.5 0 144 55.4 144 128 0 42.6-23.3 79.6-57.9 102.6l9.4 37.5c1.2 4.8.1 9.8-2.9 13.7s-7.7 6.2-12.6 6.2H208c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l9.4-37.5c-34.6-23-57.9-60-57.9-102.6C144 55.4 210.5 0 288 0zm-40 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM151 317.4c13.1-8.8 28.6-13.4 44.4-13.4H344c30.9 0 56 25.1 56 56 0 8.6-1.9 16.7-5.4 24h5.6l94.7-56.4c8.3-4.9 17.8-7.6 27.5-7.6h1.3c28.9 0 52.3 23.4 52.3 52.3 0 17.7-9 34.2-23.8 43.8l-119.6 77.8c-18.2 11.8-39.4 18.1-61 18.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h355.5c15.5 0 30.6-4.5 43.6-12.9l119.6-77.8c5.8-3.7 9.2-10.2 9.2-17 0-11.2-9.1-20.3-20.3-20.3h-1.3c-3.9 0-7.7 1.1-11.1 3l-98.5 58.7c-2.5 1.5-5.3 2.3-8.2 2.3H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H195.4c-9.5 0-18.7 2.8-26.6 8.1l-79.9 53.2c-2.6 1.8-5.7 2.7-8.9 2.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h59.2l75.8-50.6z"
        }
    ]
};

const FalHandHolding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHolding",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M195.4 304c-15.8 0-31.2 4.7-44.4 13.4L75.2 368H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c3.2 0 6.2-.9 8.9-2.7l79.9-53.3c7.9-5.3 17.1-8.1 26.6-8.1H344c13.3 0 24 10.7 24 24s-10.7 24-24 24h-88c-8.8 0-16 7.2-16 16s7.2 16 16 16h148.6c2.9 0 5.7-.8 8.2-2.3l98.5-58.6c3.4-2 7.2-3 11.1-3h1.3c11.2 0 20.3 9.1 20.3 20.3 0 6.9-3.5 13.3-9.2 17l-119.7 77.8c-13 8.4-28.1 12.9-43.6 12.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h355.5c21.7 0 42.9-6.3 61-18.1l119.6-77.8C567 406.5 576 390 576 372.3c0-28.9-23.4-52.3-52.3-52.3h-1.3c-9.7 0-19.1 2.6-27.5 7.6L400.2 384h-5.6c3.5-7.3 5.4-15.4 5.4-24 0-30.9-25.1-56-56-56H195.4z"
        }
    ]
};

const FalHandHorns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandHorns",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 32c13.3 0 24 10.7 24 24v184H80c-5.5 0-10.8.6-16 1.6V56c0-13.3 10.7-24 24-24zm56 117.4V56c0-30.9-25.1-56-56-56S32 25.1 32 56v200c-19.4 14.6-32 37.8-32 64v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V120c0-30.9-25.1-56-56-56s-56 25.1-56 56v61.4c-7.3-3.5-15.4-5.4-24-5.4-9.7 0-18.8 2.5-26.7 6.8C214 160.3 192.9 144 168 144c-8.6 0-16.7 1.9-24 5.4zm0 50.6c0-13.3 10.7-24 24-24s24 10.7 24 24v45.4c-7.3-3.5-15.4-5.4-24-5.4h-24v-40zm80 72v-40c0-13.2 10.8-24 24-24 13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-24zm-112 0h56c13.2 0 24 10.7 24 24s-10.7 24-24 24h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8 10.2 10.4 24.3 16.8 40 16.8 30.9 0 56-25.1 56-56V120c0-13.3 10.7-24 24-24s24 10.7 24 24v232c0 70.7-57.3 128-128 128h-64c-70.7 0-128-57.3-128-128v-32c0-26.5 21.5-48 48-48h32z"
        }
    ]
};

const FalHandLizard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandLizard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 120c0-30.9 25.1-56 56-56h230.6c36.2 0 70.1 17.5 91.1 46.9l113.4 158.8c13.6 19 20.9 41.8 20.9 65.1V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-97.2c0-16.7-5.2-32.9-14.9-46.5L351.7 129.5c-15-21-39.3-33.5-65.1-33.5H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h200c35.3 0 64 28.7 64 64s-28.7 64-64 64H120c-13.3 0-24 10.7-24 24s10.7 24 24 24h152c3.2 0 6.2.9 8.9 2.7l96 64c4.4 3 7.1 8 7.1 13.3v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-23.4L267.2 352H120c-30.9 0-56-25.1-56-56s25.1-56 56-56h136c17.7 0 32-14.3 32-32s-14.3-32-32-32H56c-30.9 0-56-25.1-56-56z"
        }
    ]
};

const FalHandLove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandLove",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 32c13.3 0 24 10.7 24 24v240c0 30.9 25.1 56 56 56 15.7 0 29.8-6.4 40-16.8 10.2 10.4 24.3 16.8 40 16.8 30.9 0 56-25.1 56-56V120c0-13.3 10.7-24 24-24s24 10.7 24 24v216c0 79.5-64.5 144-144 144h-8.5c-57.3 0-112.2-22.8-152.7-63.3L39 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V56c0-13.3 10.7-24 24-24zm104 264c0 13.3-10.7 24-24 24s-24-10.7-24-24v-96.1c0-13.2 10.8-23.9 24-23.9 13.3 0 24 10.7 24 24v96zm32-64c0-13.3 10.7-24 24-24s24 10.7 24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64zm48-50.6c-7.3-3.5-15.4-5.4-24-5.4-9.7 0-18.8 2.5-26.7 6.8C310 160.3 288.9 144 264 144c-8.6 0-16.7 1.9-24 5.4V56c0-30.9-25.1-56-56-56s-56 25.1-56 56v232.8l-32.4-32.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2l103.8 103.8c46.5 46.5 109.6 72.6 175.3 72.6h8.5c97.2 0 176-78.8 176-176V120c0-30.9-25.1-56-56-56s-56 25.1-56 56v61.4z"
        }
    ]
};

const FalHandMiddleFinger = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandMiddleFinger",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 56c0-13.3 10.7-24 24-24s24 10.7 24 24v170.7c0 5.2 2.5 10.1 6.8 13.1s9.7 3.8 14.6 2c3.3-1.2 6.9-1.8 10.7-1.8 14.7 0 27.2 10 30.9 23.6 1.2 4.4 4.2 8.1 8.3 10.1s8.8 2.2 13.1.6c3.6-1.4 7.6-2.2 11.8-2.2 17.7 0 32 14.3 32 32v96c0 44.2-35.8 80-80 80H184.3c-18.5 0-36.8-4.6-53.1-13.4l-7.6 14.1 7.6-14.1-8.3-4.5C86.6 442.6 64 404.7 64 363.5V344c0-15.1 7.1-29.3 19.2-38.4l22.5-16.9c2-1.5 4.1-3 6.3-4.4V344c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-.9-.1-1.9-.2-2.8.2-.9.2-1.8.2-2.8V256c0-17.7 14.3-32 32-32 8.2 0 15.7 3.1 21.3 8.1 4.7 4.2 11.4 5.3 17.2 2.7s9.5-8.3 9.5-14.6V56zm24-56c-30.9 0-56 25.1-56 56v138c-5.1-1.3-10.5-2-16-2-32.5 0-59.3 24.2-63.4 55.6-9.1 4.2-17.8 9.4-26 15.5L64 280c-20.1 15.1-32 38.8-32 64v19.5c0 53 29.1 101.7 75.7 126.8l8.3 4.5c21 11.3 44.4 17.2 68.3 17.2H320c61.9 0 112-50.1 112-112v-96c0-35.3-28.7-64-64-64-2.8 0-5.6.2-8.3.5-11-19.4-31.8-32.5-55.7-32.5V56c0-30.9-25.1-56-56-56z"
        }
    ]
};

const FalHandPeace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandPeace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M253.4.3c-30.8-3-58.2 19.6-61.1 50.3L177.9 199 123.8 66.8c-11.7-28.6-44.4-42.3-73-30.6s-42.3 44.4-30.6 73l64.3 157.3C71.8 280.7 64 299.4 64 320v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V240c0-3.2-.9-6.1-2.5-8.6-7.1-22.8-28.3-39.4-53.5-39.4-12.1 0-23.3 3.8-32.5 10.4C349.6 186.5 332 176 312 176c-6.9 0-13.6 1.3-19.7 3.6l11.4-118.2c3-30.8-19.6-58.2-50.3-61.1zM111.1 247 49.8 97.1c-5-12.3.9-26.3 13.1-31.3s26.3.9 31.3 13.1L160.1 240H144c-11.7 0-22.8 2.5-32.9 7zm120.9-7h-25.9l18-186.3c1.3-13.2 13-22.9 26.2-21.6s22.9 13 21.6 26.2l-18 186.1c-6.7-2.9-14.1-4.4-21.9-4.4zm80-32c13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-64c0-13.3 10.7-24 24-24zm32.5 133.6C354.4 357.5 372 368 392 368c8.4 0 16.4-1.9 23.5-5.2C410.1 428.5 355 480 288 480h-64c-70.7 0-128-57.3-128-128v-32c0-26.5 21.5-48 48-48h88c13.2 0 24 10.7 24 24s-10.7 24-24 24h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8 10.2 10.4 24.3 16.8 40 16.8 12.1 0 23.3-3.8 32.5-10.4zM416 312c0 13.2-10.8 24-24 24-13.3 0-24-10.7-24-24v-64c0-13.3 10.7-24 24-24 13.2 0 24 10.7 24 24v64z"
        }
    ]
};

const FalHandPointDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandPointDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 456c0 13.3 10.7 24 24 24s24-10.7 24-24V272H80c-5.5 0-10.8-.6-16-1.6V456zm48-216h56c13.2 0 24-10.7 24-24s-10.7-24-24-24h-56c-8.8 0-16-7.2-16-16s7.2-16 16-16h56c15.7 0 29.8 6.4 40 16.8 10.2-10.4 24.3-16.8 40-16.8 13.8 0 26.4 5 36.1 13.2 10.3-12.9 26.1-21.2 43.9-21.2 8.6 0 16.7 1.9 24 5.4C350.6 87.9 293.8 32 224 32h-64C89.3 32 32 89.3 32 160v32c0 26.5 21.5 48 48 48h32zm32 32v40c0 13.3 10.7 24 24 24s24-10.7 24-24v-45.4c-7.3 3.5-15.4 5.4-24 5.4h-24zm0 90.6V456c0 30.9-25.1 56-56 56s-56-25.1-56-56V256c-19.4-14.6-32-37.8-32-64v-32C0 71.6 71.6 0 160 0h64c88.4 0 160 71.6 160 160v104c0 30.9-25.1 56-56 56-12.1 0-23.3-3.8-32.5-10.4C285.6 325.5 268 336 248 336c-9.7 0-18.8-2.5-26.7-6.8C214 351.7 192.9 368 168 368c-8.6 0-16.7-1.9-24-5.4zM224 240v40c0 13.2 10.8 24 24 24 13.3 0 24-10.7 24-24v-64c0-13.3-10.7-24-24-24s-24 10.7-24 24v24zm128 0v-32c0-13.3-10.7-24-24-24s-24 10.7-24 24v56c0 13.3 10.7 24 24 24s24-10.7 24-24v-24z"
        }
    ]
};

const FalHandPointLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandPointLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h184v-32c0-5.5.6-10.8 1.6-16H56zm216 48v56c0 13.2 10.7 24 24 24s24-10.7 24-24v-56c0-8.8 7.2-16 16-16s16 7.2 16 16v56c0 15.7-6.4 29.8-16.8 40 10.4 10.2 16.8 24.3 16.8 40 0 13.8-5 26.4-13.2 36.1 12.9 10.3 21.2 26.1 21.2 43.9 0 8.6-1.9 16.7-5.4 24 69.5-1.4 125.4-58.2 125.4-128v-64c0-70.7-57.3-128-128-128h-32c-26.5 0-48 21.5-48 48v32zm-32 32h-40c-13.3 0-24 10.7-24 24s10.7 24 24 24h45.4c-3.5-7.3-5.4-15.4-5.4-24v-24zm-90.6 0H56c-30.9 0-56-25.1-56-56s25.1-56 56-56h200c14.6-19.4 37.8-32 64-32h32c88.4 0 160 71.6 160 160v64c0 88.4-71.6 160-160 160H248c-30.9 0-56-25.1-56-56 0-12.1 3.8-23.3 10.4-32.5C186.5 349.6 176 332 176 312c0-9.7 2.5-18.8 6.8-26.7C160.3 278 144 256.9 144 232c0-8.6 1.9-16.7 5.4-24zM272 288h-40c-13.2 0-24 10.8-24 24 0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24s-10.7-24-24-24h-24zm0 128h32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-56c-13.3 0-24 10.7-24 24s10.7 24 24 24h24z"
        }
    ]
};

const FalHandPointRibbon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandPointRibbon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 56c0-13.3 10.7-24 24-24s24 10.7 24 24v8h-48v-8zm-32 8H32c-6.2 0-11.8 3.5-14.4 9.1S15.7 85.2 19.5 90l24 30-24 30c-3.8 4.8-4.6 11.4-1.9 16.9S25.9 176 32 176h64v80c-19.4 14.6-32 37.8-32 64v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V248c0-30.9-25.1-56-56-56-12.1 0-23.3 3.8-32.5 10.4C349.6 186.5 332 176 312 176c-9.7 0-18.8 2.5-26.7 6.8C278 160.3 256.9 144 232 144c-8.6 0-16.7 1.9-24 5.4V56c0-30.9-25.1-56-56-56S96 25.1 96 56v8zm80 32v48H65.3l11.2-14c4.7-5.8 4.7-14.1 0-20L65.3 96H176zm0 80v64h-32c-5.5 0-10.8.6-16 1.6V176h48zm0 96h56c13.2 0 24 10.7 24 24s-10.7 24-24 24h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8 10.2 10.4 24.3 16.8 40 16.8 13.8 0 26.4-5 36.1-13.2 10.3 12.9 26.1 21.2 43.9 21.2 8.6 0 16.7-1.9 24-5.4-1.4 69.5-58.2 125.4-128 125.4h-64c-70.7 0-128-57.3-128-128v-32c0-26.5 21.5-48 48-48h32zm32-32v-40c0-13.3 10.7-24 24-24s24 10.7 24 24v45.4c-7.3-3.5-15.4-5.4-24-5.4h-24zm80 32v-40c0-13.2 10.8-24 24-24 13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-24zm128 0v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v24z"
        }
    ]
};

const FalHandPointRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandPointRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 128c13.3 0 24 10.7 24 24s-10.7 24-24 24H272v-32c0-5.5-.6-10.8-1.6-16H456zm-216 48v56c0 13.2-10.7 24-24 24s-24-10.7-24-24v-56c0-8.8-7.2-16-16-16s-16 7.2-16 16v56c0 15.7 6.4 29.8 16.8 40-10.4 10.2-16.8 24.3-16.8 40 0 13.8 5 26.4 13.2 36.1-12.9 10.3-21.2 26.1-21.2 43.9 0 8.6 1.9 16.7 5.4 24C87.9 414.6 32 357.8 32 288v-64c0-70.7 57.3-128 128-128h32c26.5 0 48 21.5 48 48v32zm32 32h40c13.3 0 24 10.7 24 24s-10.7 24-24 24h-45.4c3.5-7.3 5.4-15.4 5.4-24v-24zm90.6 0H456c30.9 0 56-25.1 56-56s-25.1-56-56-56H256c-14.6-19.4-37.8-32-64-32h-32C71.6 64 0 135.6 0 224v64c0 88.4 71.6 160 160 160h104c30.9 0 56-25.1 56-56 0-12.1-3.8-23.3-10.4-32.5C325.5 349.6 336 332 336 312c0-9.7-2.5-18.8-6.8-26.7C351.7 278 368 256.9 368 232c0-8.6-1.9-16.7-5.4-24zM240 288h40c13.2 0 24 10.8 24 24 0 13.3-10.7 24-24 24h-64c-13.3 0-24-10.7-24-24s10.7-24 24-24h24zm0 128h-32c-13.3 0-24-10.7-24-24s10.7-24 24-24h56c13.3 0 24 10.7 24 24s-10.7 24-24 24h-24z"
        }
    ]
};

const FalHandPointUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandPointUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 56c0-13.3 10.7-24 24-24s24 10.7 24 24v184H80c-5.5 0-10.8.6-16 1.6V56zm48 216h56c13.2 0 24 10.7 24 24s-10.7 24-24 24h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56c15.7 0 29.8-6.4 40-16.8 10.2 10.4 24.3 16.8 40 16.8 13.8 0 26.4-5 36.1-13.2 10.3 12.9 26.1 21.2 43.9 21.2 8.6 0 16.7-1.9 24-5.4-1.4 69.5-58.2 125.4-128 125.4h-64c-70.7 0-128-57.3-128-128v-32c0-26.5 21.5-48 48-48h32zm32-32v-40c0-13.3 10.7-24 24-24s24 10.7 24 24v45.4c-7.3-3.5-15.4-5.4-24-5.4h-24zm0-90.6V56c0-30.9-25.1-56-56-56S32 25.1 32 56v200c-19.4 14.6-32 37.8-32 64v32c0 88.4 71.6 160 160 160h64c88.4 0 160-71.6 160-160V248c0-30.9-25.1-56-56-56-12.1 0-23.3 3.8-32.5 10.4C285.6 186.5 268 176 248 176c-9.7 0-18.8 2.5-26.7 6.8C214 160.3 192.9 144 168 144c-8.6 0-16.7 1.9-24 5.4zM224 272v-40c0-13.2 10.8-24 24-24 13.3 0 24 10.7 24 24v64c0 13.3-10.7 24-24 24s-24-10.7-24-24v-24zm128 0v32c0 13.3-10.7 24-24 24s-24-10.7-24-24v-56c0-13.3 10.7-24 24-24s24 10.7 24 24v24z"
        }
    ]
};

const FalHandPointer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandPointer",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 56c0-13.3 10.7-24 24-24s24 10.7 24 24v132.2c0 6.3 3.7 12 9.5 14.6s12.5 1.5 17.2-2.7c5.7-5.1 13.1-8.1 21.3-8.1 16.8 0 30.7 13 31.9 29.5.5 6.1 4.3 11.4 10 13.7s12.1 1.1 16.7-3c5.7-5.1 13.2-8.2 21.4-8.2 16.8 0 30.7 13 31.9 29.5.5 6.1 4.3 11.4 10 13.7s12.1 1.1 16.7-3c5.7-5.1 13.2-8.2 21.4-8.2 17.7 0 32 14.3 32 32v112c0 44.2-35.8 80-80 80H205.7c-36.1 0-70.3-16.3-93.1-44.3l-75.2-92.6c-8.4-10.3-6.8-25.4 3.5-33.8s25.4-6.8 33.8 3.5l25 30.7c4.3 5.3 11.4 7.3 17.8 5s10.6-8.3 10.6-15.1V56zm24-56c-30.9 0-56 25.1-56 56v232.8c-20-20.5-52.7-22.7-75.3-4.3-24 19.5-27.7 54.8-8.2 78.8l75.2 92.5c28.9 35.5 72.2 56.2 118 56.2H336c61.9 0 112-50.1 112-112V288c0-35.3-28.7-64-64-64-7.9 0-15.4 1.4-22.4 4-10.4-21.3-32.3-36-57.6-36-7.9 0-15.4 1.4-22.4 4-10.4-21.3-32.3-36-57.6-36-5.5 0-10.9.7-16 2V56c0-30.9-25.1-56-56-56zm72 320c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalHandScissors = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandScissors",
    "viewBox": "0 0 544 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.2 284.4c-2.4-33 22.4-61.8 55.5-64.2l72.8-5.3-76.3-21c-32-8.8-50.7-41.8-41.9-73.8s41.8-50.7 73.8-41.9L265.5 127c1.8-2.9 3.8-5.7 5.8-8.4L288 96c15.1-20.1 38.8-32 64-32h19.5c53 0 101.7 29.1 126.8 75.7l4.5 8.3c11.3 21 17.2 44.4 17.2 68.3V336c0 70.7-57.3 128-128 128h-88c-35.3 0-64-28.7-64-64 0-2.8.2-5.6.5-8.3-19.4-11-32.5-31.8-32.5-55.7 0-2.2.1-4.3.3-6.4L68.4 339.8c-33 2.4-61.8-22.4-64.2-55.5zM62 252.1c-15.4 1.1-27 14.5-25.9 30s14.5 27 30 25.9l163.2-12c5.9-.4 11.6 2.4 14.7 7.5s3.3 11.4.3 16.5c-2.7 4.7-4.3 10.2-4.3 16 0 14.7 10 27.2 23.6 30.9 4.4 1.2 8.1 4.2 10.1 8.3s2.2 8.8.6 13.1c-1.4 3.6-2.2 7.6-2.2 11.8 0 17.7 14.3 32 32 32h88c53 0 96-43 96-96V216.4c0-18.5-4.6-36.8-13.4-53.1l14.1-7.6-14.1 7.6-4.5-8.3c-19.6-36.4-57.5-59-98.7-59H352c-15.1 0-29.3 7.1-38.4 19.2L297 137.4l51.6 15.3c8.5 2.5 13.3 11.4 10.8 19.9s-11.4 13.3-19.9 10.8L206.6 144 79.4 109c-14.9-4.1-30.3 4.7-34.4 19.6s4.7 30.3 19.6 34.4l165.8 45.6c7.5 2.1 12.4 9.2 11.7 17s-7 13.8-14.8 14.4L62 252.1z"
        }
    ]
};

const FalHandSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandSparkles",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 0c-24.9 0-46 16.3-53.3 38.8-7.9-4.3-17-6.8-26.7-6.8-30.9 0-56 25.1-56 56v200.8l-32.4-32.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2l103.8 103.8c46.5 46.5 109.6 72.6 175.3 72.6h8.5c37.3 0 71.8-11.6 100.3-31.3-9.6-5.5-17.4-13.7-22.3-23.6-22.5 14.5-49.3 22.9-78 22.9h-8.5c-57.3 0-112.2-22.8-152.7-63.3L103 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V88c0-13.3 10.7-24 24-24s24 10.7 24 24v152c0 8.8 7.2 16 16 16s16-7.2 16-16V56c0-13.3 10.7-24 24-24s24 10.7 24 24v184c0 8.8 7.2 16 16 16s16-7.2 16-16V87.9C384 74.7 394.8 64 408 64c13.3 0 24 10.7 24 24v152c0 8.8 7.2 16 16 16s16-7.2 16-16v-88.1c0-13.2 10.8-23.9 24-23.9 13.3 0 24 10.7 24 24v187.2c7.1-11.9 18.5-20.9 32-24.9V152c0-30.9-25.1-56-56-56-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56-9.7 0-18.8 2.5-26.7 6.8C374 16.3 352.9 0 328 0zM96 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V80zm240 224c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32zm240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FalHandSpock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandSpock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M217.4 1.9c29.9-8.1 60.6 9.6 68.7 39.4L327.4 194l25.8-125.3c6.2-30.3 35.8-49.8 66.1-43.6s49.8 35.8 43.6 66.1l-2.5 12c12.3-7 27.2-9.3 41.9-5.4 29.9 7.9 47.8 38.5 39.9 68.4L481 398.6c-17.3 65.8-76.2 112-144 113.4h-18.4c-58.8 0-115.8-20.9-160.6-59L51.7 362.7c-23.6-20-26.4-55.4-6.4-78.9l12 10.2-12-10.2c20-23.6 55.4-26.4 78.9-6.4l31.5 26.8-49-150.8c-9.6-29.4 6.5-61 35.9-70.6 13.3-4.3 27-3.4 39 1.6l-3.7-13.7c-8.1-29.9 9.6-60.6 39.4-68.7zM335.3 480h.5c53.8-.8 100.6-37.4 114.3-89.6l61.1-232.3c3.4-12.8-4.3-25.9-17.1-29.3s-25.9 4.3-29.3 17.1l-34.3 130.2c-1.8 7-8.2 11.9-15.5 11.9h-5.8c-4.8 0-9.4-2.2-12.4-5.9s-4.2-8.6-3.3-13.3l38-184c2.7-13-5.7-25.7-18.7-28.3s-25.7 5.7-28.3 18.7l-39.4 191.2c-1.5 7.3-7.8 12.5-15.2 12.8s-14-4.7-15.9-11.8L255.2 49.7c-3.5-12.8-16.6-20.4-29.4-16.9s-20.4 16.6-16.9 29.4l55.6 205.6c1.3 4.8.3 9.9-2.7 13.9s-7.7 6.3-12.7 6.3h-2.7c-6.9 0-13.1-4.5-15.2-11.1l-48.4-148.3c-4.1-12.6-17.6-19.5-30.2-15.4s-19.5 17.6-15.4 30.2l66.5 204.5c2.2 6.8-.4 14.3-6.3 18.2s-13.8 3.5-19.3-1.1l-74.5-63.3c-10.1-8.6-25.2-7.4-33.8 2.7s-7.4 25.2 2.7 33.8l106.2 90.3c39.1 33.2 88.6 51.4 139.9 51.4h16.7z"
        }
    ]
};

const FalHandWave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandWave",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354.3 95.8c8.7-1.2 14.8-9.4 13.6-18.1l-1.2-8.5C361.7 34 334 6.3 298.8 1.3L290.3.2C281.6-1 273.4 5 272.2 13.8s4.8 16.9 13.6 18.1l8.5 1.2c21.1 3 37.7 19.6 40.7 40.7l1.2 8.5c1.3 8.7 9.4 14.8 18.1 13.6zM13.7 368.2C5 369.4-1.1 377.5.2 386.3l1.2 8.5c5 35.2 32.7 62.9 67.9 67.9l8.5 1.2c8.7 1.2 16.9-4.8 18.1-13.6s-4.8-16.9-13.6-18.1l-8.5-1.2c-21.1-3-37.7-19.6-40.7-40.7l-1.2-8.5c-1.2-8.7-9.4-14.8-18.1-13.6zM150.4 62.4c-21-10.8-47.5-7.3-65.1 10.3s-21 44.1-10.3 65.1c-8.7 2.6-16.8 7.3-23.7 14.1-21.9 21.9-21.9 57.3 0 79.2l9.5 9.5c-7.6 2.7-14.8 7.1-20.9 13.2-21.8 21.8-21.9 57.2-.2 79.1l123.2 124.2c34.8 35.1 82.2 54.9 131.7 54.9C397 512 480 429 480 326.6V152c0-30.9-25.1-56-56-56s-56 25.1-56 56v11L243.7 38.7c-21.9-21.9-57.3-21.9-79.2 0-6.8 6.8-11.5 15-14.1 23.7zM108 95.3c9.4-9.4 24.6-9.4 33.9 0l8.8 8.8.1.1L288 241.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L187.1 95.3l-.1-.1c-9.3-9.4-9.3-24.5.1-33.9 9.4-9.4 24.6-9.4 33.9 0l151.7 151.6c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V152c0-13.3 10.7-24 24-24s24 10.7 24 24v174.5c0 84.8-68.7 153.5-153.4 153.5-40.9 0-80.1-16.4-109-45.4l-123-124.3c-9.3-9.4-9.3-24.6.1-34 9.4-9.4 24.7-9.4 34.1 0l36 36 .1.1 42.1 42.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-42.2-42.2-49.8-49.7-.1-.1L74 208.4c-9.4-9.4-9.4-24.6 0-33.9 9.3-9.3 24.4-9.4 33.8-.1l123.6 123.5c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-46.5-46.5-.1-.1-99.4-99.5c-9.4-9.4-9.4-24.6 0-33.9z"
        }
    ]
};

const FalHand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 0c-24.9 0-46 16.3-53.3 38.8-7.9-4.3-17-6.8-26.7-6.8-30.9 0-56 25.1-56 56v200.8l-32.4-32.4c-21.9-21.9-57.3-21.9-79.2 0s-21.9 57.3 0 79.2l103.8 103.8c46.5 46.5 109.6 72.6 175.3 72.6h8.5c97.2 0 176-78.8 176-176V152c0-30.9-25.1-56-56-56-8.6 0-16.7 1.9-24 5.4V88c0-30.9-25.1-56-56-56-9.7 0-18.8 2.5-26.7 6.8C310 16.3 288.9 0 264 0zm-80 64c13.3 0 24 10.7 24 24v152c0 8.8 7.2 16 16 16s16-7.2 16-16V56c0-13.3 10.7-24 24-24s24 10.7 24 24v184c0 8.8 7.2 16 16 16s16-7.2 16-16V87.9c0-13.2 10.8-23.9 24-23.9 13.3 0 24 10.7 24 24v152c0 8.8 7.2 16 16 16s16-7.2 16-16v-88.1c0-13.2 10.8-23.9 24-23.9 13.3 0 24 10.7 24 24v184c0 79.5-64.5 144-144 144h-8.5c-57.3 0-112.2-22.8-152.7-63.3L39 313c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l59.7 59.7c4.6 4.6 11.5 5.9 17.4 3.5s9.9-8.3 9.9-14.8V88c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FalHandcuffs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandcuffs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-56 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-32 72c13.3 0 24 10.7 24 24 22.1 0 40 17.9 40 40v21.3c56.5 24.7 96 81.1 96 146.7 0 88.4-71.6 160-160 160S0 440.4 0 352c0-65.6 39.5-122 96-146.7V184c0-22.1 17.9-40 40-40 0-13.3 10.7-24 24-24zm32 75.2V184c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v11.2c10.3-2.1 21-3.2 32-3.2s21.7 1.1 32 3.2zM288 352a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-64 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm416 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-64-72c0-22.1 17.9-40 40-40 0-13.3 10.7-24 24-24s24 10.7 24 24c22.1 0 40 17.9 40 40v21.3c56.5 24.7 96 81.1 96 146.7 0 88.4-71.6 160-160 160-47.4 0-90-20.6-119.3-53.3-5.9-6.6-5.3-16.7 1.3-22.6s16.7-5.3 22.6 1.3C408 463.5 442.1 480 480 480c70.7 0 128-57.3 128-128s-57.3-128-128-128c-37.9 0-72 16.5-95.4 42.7-5.9 6.6-16 7.1-22.6 1.3s-7.1-16-1.3-22.6c15.2-17 34-30.7 55.3-40V184zm32 11.2c10.3-2.1 21-3.2 32-3.2s21.7 1.1 32 3.2V184c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v11.2zM368 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm80 48a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalHandsAslInterpreting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsAslInterpreting",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M146.5 3.7C122-6.5 93.9 5.1 83.7 29.5L9.8 206.8C3.3 222.4 0 239.1 0 256c0 70.7 57.3 128 128 128h80c41.5 0 77.7-22.6 97-56 10.7-18.4 7.7-41-5.8-56 13.5-15 16.4-37.6 5.8-56-5.5-9.5-12.4-18.2-20.4-25.6l31-7.8c25.7-6.4 41.4-32.5 34.9-58.2S318 83 292.3 89.5l-16.8 4.2 10-7.8c20.9-16.3 24.6-46.5 8.2-67.4l-12.6 9.9 12.6-9.9c-16.3-20.9-46.5-24.6-67.4-8.2L176 49.7c.7-19.4-10.5-38.1-29.5-46zM263.8 256h-.6c-5.5-.1-10.7-3-13.6-8-8.3-14.4-23.9-24-41.6-24-26.5 0-48 21.5-48 48s21.5 48 48 48c17.7 0 33.3-9.6 41.6-24 2.9-5 8.1-7.9 13.6-8h.6c2.6 0 5.2.7 7.7 2.2 7.6 4.4 10.3 14.2 5.8 21.9-13.8 23.9-39.7 40-69.3 40h-80c-53 0-96-43-96-96 0-12.7 2.5-25.2 7.4-36.9l73.8-177.4c3.4-8.2 12.8-12 20.9-8.6s12 12.8 8.6 20.9l-14.8 35.8c-2.8 6.7-.7 14.5 5.1 18.9s13.8 4.4 19.6-.1l93.6-73.3c7-5.4 17-4.2 22.5 2.7s4.2 17-2.7 22.5l-69.3 54.2c-5.9 4.7-7.8 12.8-4.5 19.6s10.9 10.3 18.3 8.5l89.8-22.4c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-66.3 16.6c-6.7 1.7-11.5 7.4-12.1 14.3s3.4 13.3 9.7 16c16 6.8 29.4 18.7 38 33.7 4.4 7.6 1.8 17.4-5.8 21.9-2.5 1.4-5.1 2.1-7.7 2.2zm-41.9 8c1.7 2.9 3.6 5.6 5.8 8-2.1 2.4-4.1 5.1-5.8 8-2.8 4.9-8 8-13.9 8-8.8 0-16-7.2-16-16s7.2-16 16-16c5.9 0 11.1 3.2 13.9 8zm271.6 244.3c24.5 10.2 52.6-1.4 62.8-25.8l73.8-177.2c6.5-15.6 9.8-32.3 9.8-49.2 0-70.7-57.3-128-128-128H432c-41.5 0-77.7 22.6-97 56-10.7 18.4-7.7 41 5.8 56-13.5 15-16.4 37.6-5.8 56 5.5 9.5 12.4 18.2 20.4 25.6l-31 7.8c-25.7 6.4-41.4 32.5-34.9 58.2s32.5 41.4 58.2 34.9l16.8-4.2-10 7.8c-20.9 16.3-24.6 46.5-8.2 67.4s46.5 24.6 67.4 8.2l50.3-39.5c-.7 19.4 10.6 38.1 29.5 46zM376.2 256h.6c5.5.1 10.7 3 13.6 8 8.3 14.4 23.9 24 41.6 24 26.5 0 48-21.5 48-48s-21.5-48-48-48c-17.7 0-33.3 9.6-41.6 24-2.9 5-8.1 7.9-13.6 8h-.6c-2.6 0-5.2-.7-7.7-2.2-7.6-4.4-10.3-14.2-5.8-21.9 13.8-23.9 39.7-40 69.3-40h80c53 0 96 43 96 96 0 12.7-2.5 25.2-7.4 36.9l-73.8 177.4c-3.4 8.2-12.8 12-20.9 8.6s-12-12.8-8.6-20.9l14.9-35.8c2.8-6.7.7-14.5-5.1-18.9s-13.8-4.4-19.6.1l-93.6 73.3c-7 5.4-17 4.2-22.5-2.7s-4.2-17 2.7-22.5l69.3-54.2c5.9-4.7 7.8-12.8 4.5-19.6s-10.9-10.3-18.3-8.5l-89.8 22.4c-8.6 2.1-17.3-3.1-19.4-11.6s3.1-17.3 11.6-19.4l66.3-16.6c6.7-1.7 11.5-7.4 12.1-14.3s-3.4-13.3-9.7-16c-16-6.8-29.4-18.7-38-33.7-4.4-7.6-1.8-17.4 5.8-21.9 2.5-1.4 5.1-2.1 7.7-2.2zm41.9-8c-1.7-2.9-3.6-5.6-5.8-8 2.1-2.4 4.1-5.1 5.8-8 2.8-4.9 8-8 13.9-8 8.8 0 16 7.2 16 16s-7.2 16-16 16c-5.9 0-11.1-3.2-13.9-8z"
        }
    ]
};

const FalHandsBound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsBound",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16.8 48c0-26.8 21.9-48.4 48.7-48 26 .4 47.2 23.7 47.2 49.7l-.7 105 61.9 73.3c7.1 8.4 20.1-1.8 13.6-10.7l-28.6-39.2c-13.4-18.5-13.1-44.6 2.5-61.4 25.5-27.4 60.5-15.2 74.4 4l42.3 58.4c16.6 22.1 25.6 49.1 25.6 76.9v96H336v-96.1c0-27.7 9-54.7 25.6-76.9l42.3-58.4c13.9-19.2 48.9-31.4 74.4-4 15.6 16.7 15.9 42.9 2.5 61.4l-28.6 39.2c-6.5 9 6.5 19.1 13.6 10.7l61.9-73.4-.7-104.9c0-26 21.2-49.4 47.2-49.7 26.8-.4 48.7 21.2 48.7 48l.8 138.2c0 11-3.7 21.5-10.5 30L506.4 349.9c-.5.7-1.1 1.4-1.6 2.1H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h22.9c-.5-.7-1-1.4-1.6-2.1L26.5 216.2c-6.7-8.5-10.5-19-10.5-30L16.8 48zm153.4 304h101.7l-.1-96.1c0-20.6-6.7-41.1-19.5-58L210 139.6c-5.4-7.4-15.4-8.7-22.3-3.5-7.9 5.6-8.4 15.7-3.5 22.2l30.5 42.2c.2.2.5.5.5.8 26.1 39.7-33.8 86.7-70.7 42.4l-57.1-68.5c-4.8-5.8-7.5-13.1-7.4-20.7l.6-105.9c0-22.4-32-21.7-32-.7L48 186.2c0 3.6 1.2 7.2 3.5 10l106.8 133.7c5 6.2 9 13.9 11.9 22.1zm311.2-22.1 106.9-133.7c2.2-2.7 3.5-6.4 3.5-10l-.7-138.3c0-21-32-21.6-32 .7l.6 105.9c0 7.5-2.6 14.9-7.4 20.7l-57.1 68.5c-36.8 44.4-96.8-2.6-70.7-42.4 0-.2.2-.5.5-.8l30.5-42.2c4.9-6.5 4.4-16.6-3.5-22.2-7-5.2-17-3.9-22.3 3.5L387.4 198c-12.7 16.9-19.5 37.4-19.5 58l-.1 96.1h101.8c2.9-8.2 6.9-15.9 11.9-22.1zM112 416h416c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-96v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-96v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalHandsBubbles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsBubbles",
    "viewBox": "0 0 608 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM240 448c0 3.2-.2 6.4-.5 9.5C271.3 491 316.2 512 366.1 512H496c26.5 0 48-21.5 48-48 0-6.2-1.2-12.2-3.4-17.7C561 440.8 576 422.1 576 400c0-6.2-1.2-12.2-3.4-17.7C593 376.8 608 358.1 608 336s-15-40.8-35.4-46.3c2.2-5.5 3.4-11.4 3.4-17.7 0-26.5-21.5-48-48-48H419.8c12.2-13.6 16-33.7 8.1-51.5-10.8-24.2-39.1-35.1-63.4-24.4l-69.1 30.7c-62.9 28-103.4 90.3-103.4 159.1 0 9.6.8 19.1 2.3 28.3 27.4 16.9 45.7 47.2 45.7 81.8zM31.9 224.2c-.4 55 25.1 106 67.4 138.8 12.6-6.7 26.9-10.6 42.1-11-47.7-24.3-77.9-73.6-77.5-127.6l.5-75.7c.1-8.8 7.3-15.9 16.1-15.9s15.9 7.3 15.9 16.1l-.3 46.2c-.1 7.6 5.2 14.1 12.6 15.7s14.9-2.1 18-9l71.4-157.6c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2l-39.6 87.4c-3.6 8-.1 17.5 8 21.2s17.5.1 21.2-8l39.6-87.4 13.2-29.1c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2l-13.3 29.1-39.1 86.4c11.1-7.9 23.1-14.8 35.9-20.5l.4-.2 10.2-4.4L314.7 97c3.6-8 13.1-11.6 21.2-8s11.6 13.1 8 21.2l-7.2 15.9 40.3-17.5c2.1-20-8.6-40-27.9-48.7-5.7-2.6-11.6-4-17.5-4.2 3.4-20.9-7.4-42.3-27.6-51.4s-43.3-3.2-56.8 13.1c-4.1-4.2-9-7.8-14.7-10.4-24.2-10.9-52.6-.2-63.5 24l-44.6 98.6c-7.4-16.7-24.1-28.5-43.6-28.6-26.5-.2-48.2 21.2-48.3 47.7l-.5 75.6zm345.6-46.9c8.1-3.6 17.5 0 21.1 8.1s0 17.5-8.1 21.1l-42.2 18.8c-6.9 3.1-10.7 10.6-9.2 17.9s8.1 12.7 15.7 12.7H528c8.8 0 16 7.2 16 16s-7.1 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-31.9l-64.1.1c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 15.9 7.2 15.9 16s-7.2 16-16 16H366.1C287.6 480 224 416.4 224 337.9c0-56.1 33.1-107 84.4-129.8l69.1-30.7zM112 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm272-304a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FalHandsClapping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsClapping",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V16zm-120.9 2.7c-7.4 4.9-9.3 14.8-4.4 22.2l32 48c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-32-48c-4.9-7.4-14.8-9.3-22.2-4.4zm209.8 0c-7.4-4.9-17.3-2.9-22.2 4.4l-32 48c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l32-48c4.9-7.4 2.9-17.3-4.4-22.2zM153.9 152c4.8 0 9.3 1.9 12.7 5.3l126.1 126c2.9 2.9 6.9 4.7 11.3 4.7 8.8 0 16-7.2 16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v129.6c0 78.6-63.8 142.4-142.4 142.4-37.8 0-74-15-100.7-41.7l-33.6-33.6-16-16-22-22c-3.4-3.4-5.3-7.9-5.3-12.7 0-10 8-18 17.9-18 4.8 0 9.3 1.9 12.7 5.2l38.1 38.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-38-38.1-48-48c-3.4-3.4-5.3-7.9-5.3-12.7 0-9.9 8-17.9 17.9-17.9 4.8 0 9.3 1.9 12.7 5.3l86.1 86.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86-86.2-24-24c-3.4-3.4-5.3-7.9-5.3-12.7 0-9.9 8-17.9 17.9-17.9 4.8 0 9.3 1.9 12.7 5.3l32 32 78.1 78.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-78.1-78.1c-3.4-3.4-5.2-7.9-5.2-12.7 0-9.9 8-17.9 17.9-17.9zM31.1 211.7C12.9 219.1 0 237 0 257.9c0 13.2 5.3 25.9 14.6 35.3l15 15C12.2 316.1 0 333.6 0 353.9c0 13.2 5.3 25.9 14.6 35.3l22 22 16 16 33.6 33.6C119 493.6 163.4 512 209.6 512c96.3 0 174.4-78.1 174.4-174.4V208c0-26.5-21.5-48-48-48s-48 21.5-48 48v25.4l-98.7-98.7c-9.4-9.4-22.1-14.6-35.3-14.6-20.4 0-37.9 12.2-45.7 29.7C99 140.9 86.7 136 73.9 136 46.4 136 24 158.4 24 185.9c0 9.1 2.5 18 7.1 25.7zm329.7 266.4c-11.7 12.6-25 23.7-39.5 33.1 5.4.5 10.9.8 16.4.8 96.2 0 174.3-78.1 174.3-174.4V208c0-26.5-21.5-48-48-48s-48 21.5-48 48v70.7l4.7 4.7c2.9 2.9 6.9 4.7 11.3 4.7 8.8 0 16-7.2 16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16v129.6c0 70.7-51.6 129.4-119.2 140.5z"
        }
    ]
};

const FalHandsHoldingChild = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsHoldingChild",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm48 96c-2.9 0-5.7.2-8.5.7l-3.7 63.3h24.4l-3.7-63.3c-2.8-.4-5.6-.7-8.5-.7zm-16 128.9c-.5 8.8-8.1 15.6-16.9 15s-15.6-8.1-15-16.9l6.4-108.3-27.2 27.3c-6.2 6.3-16.4 6.3-22.6 0s-6.3-16.4 0-22.6l29.6-29.7c16.3-16.5 38.5-25.7 61.7-25.7s45.4 9.2 61.7 25.6l29.6 29.7c6.2 6.3 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-27.1-27.2 6.4 108.4c.5 8.8-6.2 16.4-15 16.9s-16.4-6.2-16.9-15l-2-33h-28.2l-1.9 32.9zM64 64c35.3 0 64 28.7 64 64v124.3c0 4.6.4 9.1 1.3 13.5 2.1-3.2 4.6-6.3 7.4-9.1 21.7-21.7 56.9-21.7 78.6 0l91.3 91.3c5.1 5.1 9.6 10.6 13.4 16.6 3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0 2.8 2.8 5.3 5.9 7.4 9.1.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64v216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 44-44c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16-44-44-10.7-10.8c-19.2-19.1-30-45.1-30-72.2V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-83.9-83.9c-21-21-32.8-49.5-32.8-79.2V128c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalHandsHoldingCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsHoldingCircle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 128a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm-224 0a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM64 64c35.3 0 64 28.7 64 64v124.3c0 4.6.4 9.1 1.3 13.5 2.1-3.2 4.6-6.3 7.4-9.1 21.7-21.7 56.9-21.7 78.6 0l91.3 91.3c5.1 5.1 9.6 10.6 13.4 16.6 3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0 2.8 2.8 5.3 5.9 7.4 9.1.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64v216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 44-44c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16-44-44-10.7-10.8c-19.2-19.1-30-45.1-30-72.2V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-83.9-83.9c-21-21-32.8-49.5-32.8-79.2V128c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalHandsHoldingDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsHoldingDiamond",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m342.6 9.4 96 96c12.5 12.5 12.5 32.8 0 45.3l-96 96c-12.5 12.5-32.8 12.5-45.3 0l-96-96c-12.5-12.5-12.5-32.8 0-45.3l96-96c12.5-12.5 32.8-12.5 45.3 0zM224 128l96 96 96-96-96-96-96 96zM64 64c35.3 0 64 28.7 64 64v124.3c0 4.6.4 9.1 1.3 13.5 2.1-3.2 4.6-6.3 7.4-9.1 21.7-21.7 56.9-21.7 78.6 0l91.3 91.3c5.1 5.1 9.6 10.6 13.4 16.6 3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0 2.8 2.8 5.3 5.9 7.4 9.1.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64v216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 44-44c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16-44-44-10.7-10.8c-19.2-19.1-30-45.1-30-72.2V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-83.9-83.9c-21-21-32.8-49.5-32.8-79.2V128c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalHandsHoldingDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsHoldingDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c8.8 0 16 7.2 16 16v16.8c11 1.2 21.6 3.7 31.2 6.3 8.5 2.3 13.5 11.1 11.2 19.7S367.3 72.3 358.8 70c-12.1-3.3-24-5.8-35-5.9-9.2-.1-19.1 2.1-26.1 6.3-6.4 3.9-9.6 8.8-9.6 15.8 0 5.1 2 8.7 8.7 12.8 7.6 4.7 18.3 8.1 31.9 12.3l.4.1c12.3 3.8 27.3 8.5 39.1 16.1 12.9 8.3 23.6 21.3 23.8 40.9.3 20.6-9.9 35.6-24 44.5-9.7 6.2-20.9 9.5-32 10.6V240c0 8.8-7.2 16-16 16s-16-7.2-16-16v-18.6c-11-2.4-21.3-6-30.4-9.3-2.3-.8-4.6-1.6-6.7-2.4-8.4-2.9-12.8-12-10-20.3s12-12.8 20.3-10c2.6.9 5.2 1.8 7.7 2.7 14.7 5.1 26.8 9.3 39.7 9.8 10 .3 19.7-1.9 26.2-6.1 5.8-3.7 9.3-8.9 9.2-17.1-.1-6.1-2.6-10.2-9.2-14.4-7.6-4.9-18.2-8.4-31.7-12.6l-1.7-.5c-11.9-3.7-26.3-8.1-37.5-15.1-12.8-7.9-23.7-20.4-23.8-39.9-.1-20.6 11.1-34.9 25-43.3 7.1-4.3 15-7.2 22.9-8.9V16c0-8.8 7.2-16 16-16zM64 64c35.3 0 64 28.7 64 64v124.3c0 4.6.4 9.1 1.3 13.5 2.1-3.2 4.6-6.3 7.4-9.1 21.7-21.7 56.9-21.7 78.6 0l91.3 91.3c5.1 5.1 9.6 10.6 13.4 16.6 3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0 2.8 2.8 5.3 5.9 7.4 9.1.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64v216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 44-44c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16-44-44-10.7-10.8c-19.2-19.1-30-45.1-30-72.2V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-83.9-83.9c-21-21-32.8-49.5-32.8-79.2V128c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalHandsHoldingHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsHoldingHeart",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M195.9 28.9C223.7.7 267.8-.8 297.3 24.3c5.8 4.9 11 10.4 16.3 15.9 2.1 2.2 4.2 4.5 6.4 6.6 2.1-2.2 4.3-4.4 6.4-6.6 5.2-5.5 10.5-11 16.3-15.9C372.2-.8 416.3.7 444.1 28.9c29.4 29.8 29.4 78.2 0 108L342.5 240.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L195.9 136.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0-17.1 17.4-17.1 45.7 0 63.1L320 217.3l101.3-102.9c17.1-17.4 17.1-45.7 0-63.1-16.8-17.1-44-17.1-60.8 0l-29.1 29.6c-6.3 6.4-16.5 6.4-22.8 0l-29.1-29.5zM64 64c35.3 0 64 28.7 64 64v124.3c0 4.6.4 9.1 1.3 13.5 2.1-3.2 4.6-6.3 7.4-9.1 21.7-21.7 56.9-21.7 78.6 0l91.3 91.3c5.1 5.1 9.6 10.6 13.4 16.6 3.8-5.9 8.3-11.5 13.4-16.6l91.3-91.3c21.7-21.7 56.9-21.7 78.6 0 2.8 2.8 5.3 5.9 7.4 9.1.9-4.4 1.3-8.9 1.3-13.5V128c0-35.3 28.7-64 64-64s64 28.7 64 64v216.2c0 29.7-11.8 58.2-32.8 79.2l-83.9 83.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l83.9-83.9c15-15 23.4-35.4 23.4-56.6V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v124.3c0 27.1-10.8 53.1-29.9 72.2l-10.8 10.8-44 44-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 44-44c9.2-9.2 9.2-24.2 0-33.4s-24.2-9.2-33.4 0L356 370.6c-12.8 12.8-20 30.2-20 48.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-77.1c0-18.1-7.2-35.5-20-48.3l-91.3-91.3c-9.2-9.2-24.2-9.2-33.4 0s-9.2 24.2 0 33.4l44 44 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16-44-44-10.7-10.8c-19.2-19.1-30-45.1-30-72.2V128c0-17.7-14.3-32-32-32s-32 14.3-32 32v216.2c0 21.2 8.4 41.6 23.4 56.6l83.9 83.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-83.9-83.9c-21-21-32.8-49.5-32.8-79.2V128c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalHandsHolding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsHolding",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128c0-35.3-28.7-64-64-64S0 92.7 0 128v216.2c0 29.7 11.8 58.2 32.8 79.2l83.9 83.9c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-83.9-83.9c-15-15-23.4-35.4-23.4-56.6V128c0-17.7 14.3-32 32-32s32 14.3 32 32v124.3c0 27.1 10.8 53.1 29.9 72.2l10.7 10.8 44 44 16 16c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16-44-44c-9.2-9.2-9.2-24.2 0-33.4s24.2-9.2 33.4 0l91.4 91.3c12.8 12.8 20 30.2 20 48.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-77.1c0-18.1 7.2-35.5 20-48.3l91.3-91.3c9.2-9.2 24.2-9.2 33.4 0s9.2 24.2 0 33.4l-44 44-16 16c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l16-16 44-44 10.8-10.8c19.2-19.2 29.9-45.1 29.9-72.2V128c0-17.7 14.3-32 32-32s32 14.3 32 32v216.2c0 21.2-8.4 41.6-23.4 56.6l-83.9 83.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l83.9-83.9c21-21 32.8-49.5 32.8-79.2V128c0-35.3-28.7-64-64-64s-64 28.7-64 64v124.3c0 4.6-.4 9.1-1.3 13.5-2.1-3.2-4.6-6.3-7.4-9.1-21.7-21.7-56.9-21.7-78.6 0L333.4 348c-5.1 5.1-9.6 10.6-13.4 16.6-3.8-5.9-8.3-11.5-13.4-16.6l-91.3-91.3c-21.7-21.7-56.9-21.7-78.6 0-2.8 2.8-5.3 5.9-7.4 9.1-.9-4.4-1.3-8.9-1.3-13.5V128z"
        }
    ]
};

const FalHandsPraying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandsPraying",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M283.4 32c-6.8 0-13.2 3.4-17.1 9l-86.8 127.4C166.8 187 160 209 160 231.5v50.3c0 20-12.4 37.9-31.1 44.9L21.6 367c-8.3 3.1-17.5-1.1-20.6-9.4s1.1-17.5 9.4-20.6l107.2-40.2c6.2-2.3 10.4-8.3 10.4-15v-50.3c0-28.9 8.7-57.2 25-81.1L239.9 23C249.7 8.6 266 0 283.4 0c14.2 0 27.2 5.7 36.6 14.8C329.5 5.7 342.4 0 356.6 0c17.4 0 33.7 8.6 43.5 23L487 150.4c16.3 23.9 25 52.2 25 81.1v50.3c0 6.7 4.1 12.6 10.4 15L629.6 337c8.3 3.1 12.5 12.3 9.4 20.6s-12.3 12.5-20.6 9.4l-107.3-40.2c-18.7-7-31.1-24.9-31.1-44.9v-50.4c0-22.5-6.8-44.5-19.5-63.1L373.7 41c-3.8-5.6-10.2-9-17.1-9-11.4 0-20.6 9.2-20.6 20.6V59c0 5.3 1.6 10.5 4.5 15l51.3 76.9c15.8 23.7 24.2 51.4 24.2 79.9V304c0 8.8-7.2 16-16 16s-16-7.2-16-16v-72c0-13.3-10.7-24-24-24s-24 10.7-24 24v74.2c0 48.9 31.7 92.1 78.3 106.8l214.5 67.8c8.4 2.7 13.1 11.6 10.4 20.1s-11.6 13.1-20.1 10.4l-214.5-67.8c-37.5-11.8-67.4-38-84.6-71.3-17.2 33.3-47.2 59.5-84.6 71.3L20.8 511.3c-8.4 2.7-17.4-2-20.1-10.4s2-17.4 10.4-20.1L225.7 413c46.6-14.7 78.3-57.9 78.3-106.8V232c0-13.3-10.7-24-24-24s-24 10.7-24 24v72c0 8.8-7.2 16-16 16s-16-7.2-16-16v-73.2c0-28.4 8.4-56.2 24.2-79.9L299.5 74c3-4.4 4.5-9.6 4.5-15v-6.4c0-11.4-9.2-20.6-20.6-20.6zm36.6 68.8-45.2 67.8c-1.8 2.7-3.5 5.5-5 8.3 3.3-.6 6.7-.9 10.2-.9 15.7 0 29.8 6.4 40 16.8 10.2-10.4 24.3-16.8 40-16.8 3.5 0 6.9.3 10.2.9-1.6-2.8-3.2-5.6-5-8.3L320 100.8z"
        }
    ]
};

const FalHands = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHands",
    "viewBox": "0 0 608 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M439.9 395.4c11.5-2.6 22.9-6.3 34-11.4 62.7-28.4 102.7-91 102.2-159.8l-.5-75.6c-.2-26.5-21.8-47.8-48.3-47.7-19.5.1-36.2 11.9-43.6 28.6L439 31C428.1 6.8 399.7-3.9 375.5 7c-5.7 2.6-10.6 6.1-14.7 10.4C347.3 1.1 324.2-4.8 304 4.3s-31 30.5-27.6 51.3c-5.9.3-11.8 1.7-17.5 4.2-19.3 8.8-30 28.7-27.9 48.7l40.4 17.5-7.2-15.9c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8l21.7 48.1 10.2 4.4.4.2c12.8 5.7 24.8 12.6 35.9 20.5l-39.2-86.3-13.2-29.2c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8l13.2 29.1 39.6 87.5c3.6 8 13.1 11.6 21.2 8s11.6-13.1 8-21.2l-39.7-87.4c-3.6-8-.1-17.5 8-21.2s17.5-.1 21.2 8L481.4 202c3.1 6.9 10.6 10.6 18 9s12.6-8.2 12.6-15.7l-.3-46.2c-.1-8.8 7.1-16 15.9-16.1s16.1 7.1 16.1 15.9l.5 75.7c.4 56.1-32.3 107.3-83.5 130.4-4.6 2.1-9.2 3.9-13.9 5.4-1.3 12-3.6 23.8-6.9 35.1zm-209.4-218 69.1 30.7c51.3 22.8 84.4 73.7 84.4 129.8 0 78.5-63.6 142.1-142.1 142.1H112c-8.8 0-16-7.2-16-16s7.1-16 16-16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h173.2c7.6 0 14.1-5.3 15.7-12.7s-2.2-14.9-9.2-17.9l-42.2-18.8c-8.1-3.6-11.7-13-8.1-21.1s13-11.7 21.1-8.1zM67.4 446.3c-2.2 5.5-3.4 11.5-3.4 17.7 0 26.5 21.5 48 48 48h129.9c96.2 0 174.1-77.9 174.1-174.1 0-68.8-40.5-131.1-103.4-159.1l-69.1-30.7c-24.2-10.8-52.6.1-63.4 24.4-7.9 17.8-4.1 37.8 8.1 51.5H80c-26.5 0-48 21.5-48 48 0 6.2 1.2 12.2 3.4 17.7C15 295.2 0 313.9 0 336s15 40.8 35.4 46.3c-2.2 5.5-3.4 11.5-3.4 17.7 0 22.1 15 40.8 35.4 46.3z"
        }
    ]
};

const FalHandshakeAngle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandshakeAngle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-54.6 54.6c-9 9-21.2 14.1-33.9 14.1H304c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-88c0-8.8 7.2-16 16-16s16 7.2 16 16v24h112c35.3 0 64 28.7 64 64 0 24.5-13.7 45.7-33.9 56.5 1.2 5 1.9 10.2 1.9 15.5 0 29.9-20.5 55-48.3 62.1-3 32.5-30.4 57.9-63.7 57.9H237.3c-4.2 0-8.3 1.7-11.3 4.7l-54.6 54.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l54.6-54.6c9-9 21.2-14.1 33.9-14.1H368c17.7 0 32-14.3 32-32 0-1.8-.2-3.6-.4-5.4-.8-4.7.5-9.5 3.6-13.1s7.6-5.6 12.4-5.6h.4c17.7 0 32-14.3 32-32 0-6.1-1.7-11.7-4.6-16.6-2.7-4.5-3.1-10-.9-14.8s6.5-8.2 11.6-9.2c14.8-2.8 25.9-15.8 25.9-31.4 0-17.7-14.3-32-32-32H336v32c0 35.3-28.7 64-64 64s-64-28.7-64-64V160c0-53 43-96 96-96h114.7c4.2 0 8.3-1.7 11.3-4.7l54.7-54.6c6.2-6.2 16.4-6.2 22.6 0zM125.6 190.3c9.2-24.5 27.6-43.5 50.4-53.8v37.1c-9.1 7.1-16.3 16.7-20.5 27.9l-26.1 69.6c-2.4 6.4-6.2 12.2-11 17.1l-91.1 91.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l91.1-91.1c1.6-1.6 2.9-3.6 3.7-5.7l26.1-69.6zm509.8-57.6c6.2 6.2 6.2 16.4 0 22.6L543.6 247c-1.2-12.5-4.7-24.4-10.2-35l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalHandshakeSimpleSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandshakeSimpleSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm342.6 209.4 11.9-11c6.5-6 6.9-16.1.9-22.6s-16.1-6.9-22.6-.9l-15.6 14.4 25.4 20.1zm-81.7-64.5 27.5-26c17.9-16.9 41.5-26.3 66.1-26.3 22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.9 2.4 6.5 3.8 10.3 3.8H592c8.8 0 16-7.2 16-16s-7.2-16-16-16h-88.7l-40.4-34C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35l-30.9 29.2 25.4 20zm-58.7-46.4c3.1-1 6.2-1.9 9.3-2.7L272.6 64h-8.7c-22.5 0-44.6 5.3-64.5 15.3l28.7 22.6zM54.6 128H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h47.1l-40.5-32zm139 109.8c.2.8.4 1.5.6 2.2h2.3l-2.8-2.2zm176.8 139.5c1.5 9.3-1.1 19.1-7.8 26.6-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6a71.983 71.983 0 0 0-50.9-21.1H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h59.4c10.6 0 20.8 4.2 28.3 11.7l28.6 28.6 15.4 15.4.1.1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6.8-.7 1.6-1.4 2.3-2.2 26.3 21.3 65.3 18.6 88.4-7.3 6.5-7.3 11-15.6 13.6-24.4l-29.7-23.5zm132.5-58.5 40.5 32H592c8.8 0 16-7.2 16-16s-7.2-16-16-16h-89.1z"
        }
    ]
};

const FalHandshakeSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandshakeSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M263.9 64h8.7l-35.2 35.2c-16.6 4.1-32.2 11.9-45.5 23.1l-40.5 34c-2.9 2.4-6.5 3.8-10.3 3.8H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h87.3l36-30.3C197.2 76 230 64 263.9 64zm28.4 35c23.8-22.5 55.3-35 88.1-35 30.2 0 59.4 10.6 82.5 30.1l40.4 33.9H592c8.8 0 16 7.2 16 16s-7.2 16-16 16h-94.5c-3.8 0-7.4-1.3-10.3-3.8l-44.8-37.7C425 104 403.1 96 380.4 96c-24.6 0-48.2 9.4-66.1 26.3l-79.4 75c-14.9 14.1-14.6 38 .8 51.6 13.5 12 33.8 11.8 47-.4l76.1-70.2c6.5-6 16.6-5.6 22.6.9s5.6 16.6-.9 22.6l-8.1 7.5 85.6 85.5c7 7 12.1 15.2 15.1 24H592c8.8 0 16 7.2 16 16s-7.2 16-16 16H475.8c-2.3 13.8-9.2 27-20.6 37-15.7 14-36.5 18.8-55.7 14.8-2.7 8.1-7 15.8-13 22.5-23 25.9-62 28.6-88.4 7.3-.8.7-1.5 1.5-2.3 2.2-26.4 23.6-66.7 22.5-91.8-2.6l-24.3-24.3-.1-.1-15.4-15.4-28.6-28.6c-7.5-7.5-17.7-11.7-28.3-11.7H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h59.4c19.1 0 37.4 7.6 50.9 21.1l28.6 28.6 39.9 39.8c13.1 13.1 34 13.6 47.8 1.3 3.2-2.9 5.8-6.2 7.6-9.8 2.4-4.5 6.7-7.6 11.8-8.4s10.1.9 13.7 4.5l8.1 8.1c13.1 13.1 34.6 12.5 46.9-1.4 5.8-6.5 8.5-14.7 8.1-22.9-.3-6 2.8-11.6 8-14.6s11.6-2.8 16.6.5c11.8 7.6 27.6 6.7 38.6-3 13.7-12.2 14.4-33.5 1.4-46.5L348.9 231l-44.5 41c-25.3 23.4-64.2 23.7-90 .8-29.4-26.1-30.1-71.8-1.5-98.8l79.4-75z"
        }
    ]
};

const FalHandshakeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandshakeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 368V160c0-17.7-14.3-32-32-32h-80v210.7l32 25.3V160h48v208c0 8.8-7.2 16-16 16h-6.6l31.6 25c13.8-8.4 23-23.6 23-41zm-236.7 35.3L371 377.8c-.2 1.1-.2 2.2-.2 3.3.4 8.1-2.3 16.3-8.1 22.9-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6a71.93 71.93 0 0 0-46.3-20.9V173.3L54.6 128H32c-17.7 0-32 14.3-32 32v208c0 26.5 21.5 48 48 48h16c26.5 0 48-21.5 48-48v-15.7c8.9 1 17.2 5 23.6 11.4l28.6 28.6 15.4 15.4.1.1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6.8-.7 1.6-1.4 2.3-2.2 26.3 21.3 65.3 18.6 88.4-7.3 6-6.7 10.3-14.4 13-22.5 1.2.3 2.5.5 3.8.7zM196.4 240l-2.8-2.2c.2.8.4 1.5.6 2.2h2.3zm95.9-141-30.9 29.2 25.4 20 27.5-26c17.9-16.8 41.5-26.2 66.1-26.2 22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.5 2.1 5.6 3.4 8.8 3.7v-38.2l-33-27.7C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35zm-54.9.2L272.6 64h-8.7c-22.5 0-44.6 5.3-64.5 15.3l28.7 22.6c3.1-1 6.2-1.9 9.3-2.7zm121.4 79.1-15.6 14.4 23.1 18.3 18-14.6c2.4-5.6 1.5-12.4-2.9-17.2-6-6.5-16.1-6.9-22.6-.9zM80 160v208c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V160h48z"
        }
    ]
};

const FalHandshake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHandshake",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M263.9 64c-33.9 0-66.7 12-92.6 33.7l-27.3 23v39.1c2.7-.5 5.3-1.7 7.4-3.5l40.5-34c13.3-11.2 28.9-19 45.5-23.1L272.6 64h-8.7zM112 352.3c8.9 1 17.2 5 23.6 11.4l28.6 28.6 15.4 15.4.1.1 24.3 24.3c25.1 25.1 65.4 26.2 91.8 2.6.8-.7 1.6-1.4 2.3-2.2 26.3 21.3 65.3 18.6 88.4-7.3 6-6.7 10.3-14.4 13-22.5 19.2 4 40-.8 55.7-14.8 11.3-10.1 18.2-23.2 20.6-37H528V368c0 26.5 21.5 48 48 48h16c26.5 0 48-21.5 48-48V160c0-17.7-14.3-32-32-32h-80v190.8h-54.9c-3.1-8.7-8.1-17-15.1-24l-85.6-85.6 8.1-7.5c6.5-6 6.9-16.1.9-22.6s-16.1-6.9-22.6-.9l-76.1 70.2c-13.2 12.2-33.6 12.4-47 .4-15.4-13.7-15.7-37.5-.8-51.6l79.4-75c17.9-16.8 41.5-26.2 66.1-26.2 22.7 0 44.6 8 61.9 22.6l44.8 37.7c2.5 2.1 5.6 3.4 8.8 3.7v-38.2l-33-27.7C439.8 74.6 410.6 64 380.4 64c-32.8 0-64.3 12.5-88.1 35l-79.4 75c-28.6 27-27.9 72.7 1.5 98.8 25.8 22.9 64.7 22.5 90-.8l44.5-41 86.5 86.5c13 13 12.4 34.3-1.4 46.5-10.9 9.7-26.7 10.6-38.6 3-5-3.3-11.4-3.4-16.6-.5s-8.3 8.6-8 14.6c.4 8.1-2.3 16.3-8.1 22.9-12.3 13.9-33.8 14.5-46.9 1.4l-8.1-8.1c-3.6-3.6-8.7-5.3-13.7-4.5s-9.4 3.9-11.8 8.4c-1.9 3.6-4.4 6.9-7.6 9.8-13.8 12.3-34.8 11.7-47.8-1.3l-39.9-39.8-28.6-28.6a71.93 71.93 0 0 0-46.3-20.9V128H32c-17.7 0-32 14.3-32 32v208c0 26.5 21.5 48 48 48h16c26.5 0 48-21.5 48-48v-15.7zM80 160v208c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V160h48zm528 0v208c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V160h48z"
        }
    ]
};

const FalHanukiah = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHanukiah",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM64 80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm160 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 96c8.8 0 16 7.2 16 16v240h48V176c0-8.8 7.2-16 16-16s16 7.2 16 16v176h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16v176h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16v173.3c18.6-6.6 32-24.4 32-45.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16v128c0 44.2-35.8 80-80 80H336v96h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h160v-96H112c-44.2 0-80-35.8-80-80V176c0-8.8 7.2-16 16-16s16 7.2 16 16v128c0 20.9 13.4 38.7 32 45.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16v176h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16v176h32V176c0-8.8 7.2-16 16-16s16 7.2 16 16v176h48V112c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalHardDrive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHardDrive",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v168.6c9.4-5.4 20.3-8.6 32-8.6h384c11.7 0 22.6 3.1 32 8.6V96c0-17.7-14.3-32-32-32H64zM32 320v96c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm-32 0V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-96zm320 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalHashtagLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHashtagLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M195.6 32.4c8.6 2 14 10.6 12 19.2L186.3 144h127.1l23-99.6c2-8.6 10.6-14 19.2-12s14 10.6 12 19.2L346.3 144H432c8.8 0 16 7.2 16 16v1.1c-15.1 2.2-29.2 7.3-41.7 14.9h-67.4l-67.3 291.6c-2 8.6-10.6 14-19.2 12s-14-10.6-12-19.2l21.3-92.4H134.6l-23 99.6c-2 8.6-10.6 14-19.2 12s-14-10.6-12-19.2l21.3-92.4H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h93.1L146 176H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h105.4l23-99.6c2-8.6 10.6-14 19.2-12zM178.9 176 142 336h127.1L306 176H178.9zM464 224c-26.5 0-48 21.5-48 48v48h96v-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48zm0 80v128h160V352H384z"
        }
    ]
};

const FalHashtag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHashtag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M207.6 51.6c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h98l-36.9 160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.7l-21.3 92.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6h127.1l-21.3 92.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6H400c8.8 0 16-7.2 16-16s-7.2-16-16-16h-98l36.9-160H432c8.8 0 16-7.2 16-16s-7.2-16-16-16h-85.7l21.3-92.4c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H186.3l21.3-92.4zM178.9 176H306l-36.9 160H142l36.9-160z"
        }
    ]
};

const FalHatBeach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHatBeach",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 224v14.7c.3.5 1.1 1.5 2.6 2.9 4.2 4 11.9 9 24.2 13.9 24.3 9.8 60 16.5 101.2 16.5 11.5 0 22.6-.5 33.1-1.5-.7-3.8-1.1-7.7-1.1-11.8 0-12.5 3.8-24.6 10.8-34.7-.5-.7-1-1.4-1.4-2.2-13.2 1.4-27.1 2.2-41.4 2.2-44.2 0-84.2-7.2-113.1-18.7-4.4-1.8-8.6-3.7-12.5-5.6-1.5 7.9-2.3 16-2.3 24.4zm160-34.7c0-31.1 23.2-56.8 53.3-60.7C382.6 108.3 352.7 96 320 96c-50.9 0-94.9 29.7-115.5 72.8 3.8 2.2 8.6 4.5 14.2 6.8 24.4 9.7 60.1 16.4 101.3 16.4 11.1 0 21.8-.5 32-1.4v-1.3zM320 64c55.7 0 104.7 28.4 133.3 71.5 8.9-4.9 19-7.5 29.4-7.5 33.8 0 61.3 27.4 61.3 61.3 0 12.5-3.8 24.6-10.8 34.7 5.2 7.6 8.7 16.2 10.1 25.3l67 26.8c17.9 7.2 29.7 24.6 29.7 43.9 0 17.7-8.9 34.5-25.1 49.8-16.2 15.3-39.6 29.1-68.6 40.7C488.4 433.7 408.4 448 320 448s-168.4-14.3-226.3-37.5c-29-11.6-52.4-25.4-68.6-40.7C8.9 354.5 0 337.7 0 320c0-19.3 11.8-36.7 29.7-43.9L160 224c0-88.4 71.6-160 160-160zm162.7 256c-12.5 0-24.6-3.8-34.7-10.8-10.1 7-22.2 10.8-34.7 10.8-17.5 0-33.2-7.3-44.4-19-15.4 2-31.8 3-48.9 3-44.2 0-84.2-7.2-113.1-18.7-14.5-5.8-26.2-12.7-34.3-20.3-2.9-2.8-5.4-5.6-7.3-8.6L41.6 305.8c-5.8 2.3-9.6 7.9-9.6 14.2 0 6.1 2.9 15 15.1 26.6 12.3 11.6 31.8 23.5 58.5 34.2C158.9 402.1 234.7 416 320 416s161.1-13.9 214.4-35.2c26.7-10.7 46.2-22.6 58.5-34.2C605.1 335 608 326.1 608 320c0-6.2-3.8-11.9-9.6-14.2l-59.1-23.6c-9.2 22.2-31.1 37.8-56.6 37.8zm-69.4-160c-16.2 0-29.3 13.1-29.3 29.3 0 7.8 3.1 15.2 8.6 20.7l2.7 2.7c6.2 6.2 6.2 16.4 0 22.6l-2.7 2.7c-5.5 5.5-8.6 12.9-8.6 20.7 0 16.2 13.1 29.3 29.3 29.3 7.8 0 15.2-3.1 20.7-8.6l2.7-2.7c6.2-6.2 16.4-6.2 22.6 0l2.7 2.7c5.5 5.5 12.9 8.6 20.7 8.6 16.2 0 29.3-13.1 29.3-29.3 0-7.8-3.1-15.2-8.6-20.7l-2.7-2.7c-6.2-6.2-6.2-16.4 0-22.6l2.7-2.7c5.5-5.5 8.6-12.9 8.6-20.7 0-16.2-13.1-29.3-29.3-29.3-7.8 0-15.2 3.1-20.7 8.6l-2.7 2.7c-6.2 6.2-16.4 6.2-22.6 0l-2.7-2.7c-5.5-5.5-12.9-8.6-20.7-8.6zm34.7 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalHatChef = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHatChef",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M170.9 83.4C187 52.8 219.1 32 256 32s69 20.8 85 51.4c2.5 4.7 7.1 7.9 12.4 8.5s10.5-1.5 13.9-5.5C379.1 72.7 396.5 64 416 64c35.3 0 64 28.7 64 64 0 4-.4 7.8-1 11.6l-.1.5c-3.5 22.8-14.2 58.4-26.1 93.5-11.8 34.7-24.3 67.7-31 84.7-.4 1-1.4 1.8-2.8 1.8h-45.2L399.7 179c1.6-8.7-4.2-17-12.8-18.6s-17 4.2-18.6 12.8l-26.4 144c-.2 1-.3 1.9-.3 2.9H272V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v176h-69.6c0-1-.1-1.9-.3-2.9l-26.4-144c-1.6-8.7-9.9-14.4-18.6-12.8s-14.4 9.9-12.8 18.6L138.2 320H93c-1.4 0-2.4-.8-2.8-1.8-6.6-17-19.2-50-31-84.7-11.9-35.1-22.6-70.7-26.1-93.5l-.1-.5c-.7-3.7-1-7.6-1-11.6 0-35.3 28.7-64 64-64 19.5 0 36.9 8.7 48.6 22.4 3.5 4 8.7 6.1 13.9 5.5s9.9-3.8 12.4-8.5zM256 0c-41.9 0-79.1 20.1-102.4 51.2-16-12-36-19.2-57.6-19.2-53 0-96 43-96 96 0 5.8.5 11.5 1.5 17.1 4 25.9 15.6 63.8 27.4 98.7 12 35.3 24.7 68.8 31.4 86C65.6 343.4 78.7 352 93 352h326c14.3 0 27.4-8.6 32.6-22.2 6.7-17.2 19.4-50.7 31.4-86 11.8-34.9 23.4-72.8 27.4-98.7 1-5.5 1.5-11.2 1.5-17.1 0-53-43-96-96-96-21.6 0-41.6 7.2-57.6 19.2C335.1 20.1 297.9 0 256 0zM64 384v64c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64v-64h-32v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-64H64z"
        }
    ]
};

const FalHatCowboySide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHatCowboySide",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416.6 64.2 195.1 107c-7.1 1.4-12.4 7.3-12.9 14.6l-5 70.6c36.3 1.7 71.2 15.2 99.4 38.4l30.9 25.4h155.2L428.2 72.1c-.9-4.7-5-8.1-9.8-8.1-.6 0-1.3.1-1.9.2zM145 193.7l5.3-74.4c1.5-21.7 17.4-39.6 38.8-43.7l221.4-42.8c2.6-.5 5.3-.8 8-.8 20.2 0 37.5 14.4 41.2 34.2l25 133.5c3.4 1.6 7.2 3.4 11.4 5.5 15.5 7.7 36.2 19.1 57 33.7 20.7 14.5 42.2 32.6 58.5 53.9C628.1 314 640 339.4 640 368c0 44.2-35.8 80-80 80H60.8C27.2 448 0 420.8 0 387.2v-26.1c0-85.2 63-155.7 145-167.4zM525.3 416H560c26.5 0 48-21.5 48-48 0-19.4-8.1-38-21.7-55.7-13.7-17.7-32.2-33.7-51.5-47.1-14.9-10.5-29.9-19.2-42.7-26L525.3 416zm-34.2-8.8L468.7 288H346.3l144.8 119.2zM32 361.1v26.1c0 15.9 12.9 28.8 28.8 28.8h390.6L256.2 255.3c-24.5-20.2-55.3-31.3-87.1-31.3C93.4 224 32 285.4 32 361.1z"
        }
    ]
};

const FalHatCowboy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHatCowboy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M249.7 64c4.3.2 6.7 1.1 8.2 1.8 2.1 1 4.3 2.6 8.5 6.3.6.5 1.2 1.1 1.9 1.7C276.7 81.3 293 96 320 96s43.3-14.7 51.7-22.2c.7-.6 1.3-1.2 1.9-1.7 4.2-3.7 6.4-5.2 8.5-6.3 1.5-.7 3.9-1.6 8.2-1.8.5.4 1.2 1 2.3 1.9 3.9 3.7 8.8 10.5 14.4 21 11.1 21 21.4 50.4 30.2 81.7 8.7 30.9 15.5 62 20.2 85.5.8 4 1.5 7.9 2.2 11.4 10.8-3.7 21-7.6 30.3-11.7C476.4 184.2 441.4 32 392 32c-21.3 0-31.6 9.1-41.2 17.6C342.3 57 334.4 64 320 64s-22.3-7-30.8-14.4C279.6 41.1 269.3 32 248 32c-49.3 0-84.4 152.2-97.9 221.9 9.4 4.1 19.5 8 30.3 11.7.7-3.5 1.4-7.3 2.2-11.3 4.7-23.5 11.5-54.6 20.2-85.5 8.8-31.4 19.1-60.8 30.2-81.8 5.6-10.5 10.6-17.3 14.4-21 1-1 1.8-1.6 2.3-1.9zm139.9-.5a.1.1 0 1 0 0 .2.1.1 0 1 0 0-.2zm-139.3.1a.1.1 0 1 0 .3.1.1.1 0 1 0-.3-.1zm-239 156c-9.5 5.9-13.5 17.9-9.9 28.5 13.5 37.7 38.4 72.3 66.1 100.6C116.4 398.9 196.4 448 320 448s203.7-49.1 252.6-99.2c27.7-28.3 52.6-62.9 66.1-100.6 3.6-10.6-.4-22.6-9.9-28.5-9.5-5.9-21.7-4.5-29.6 3.3-20.4 19.4-45.3 34.8-70.1 47.7-47.3 24.5-117.5 49.3-209 49.3s-161.8-24.8-209-49.3c-24.8-12.9-49.8-28.3-70.2-47.7-7.9-7.9-20.2-9.2-29.6-3.3zm533.1 80.6c14.9-7.7 30.5-16.6 45.5-27.1-11.3 18.7-25.4 36.4-41.1 52.4-43.3 44.4-115.1 89.2-228.8 89.2-113.7 0-185.4-44.8-228.7-89.2-15.6-16-29.8-33.7-41.1-52.4 15 10.4 30.6 19.3 45.5 27.1 51.1 26.6 126.7 53 224.4 53s173.2-26.5 224.3-53z"
        }
    ]
};

const FalHatSanta = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHatSanta",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m357.9 243.4 38.3 76.6H432l-45.5-90.9c-1.7-3.3-2.5-7-2.5-10.7V216c0-13.3 10.7-24 24-24h4.1c2.6 0 5.1.4 7.6 1.2l39.5 13.2c1.6-2.1 3.3-4.1 5.2-6 0-14.3 5.5-28.7 16.4-39.6 2.2-2.2 4.6-4.2 7.1-6l-53.5-63.2c-32-37.8-79-59.6-128.5-59.6-68.8 0-130.7 41.9-156.3 105.8L76.8 320h34.5l68.1-170.3C200.1 97.9 250.2 64 305.9 64c40.1 0 78.2 17.7 104 48.3l51.9 61.3-32-10.7c-5.7-1.9-11.7-2.9-17.7-2.9H408c-30.9 0-56 25.1-56 56v2.3c0 8.7 2 17.3 5.9 25zM448 384c17.7 0 32 14.3 32 32s-14.3 32-32 32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h384zM64 352c-35.3 0-64 28.7-64 64s28.7 64 64 64h384c35.3 0 64-28.7 64-64s-28.7-64-64-64H64zm524.7-83.3a40.6 40.6 0 1 1-57.4-57.4 40.6 40.6 0 1 1 57.4 57.4zm-82.4-82.4c-7.8 7.8-10 18.9-6.8 28.7-9.2 4.5-15.5 14-15.5 25s6.3 20.5 15.5 25.1c-3.2 9.7-1 20.9 6.8 28.7s18.9 10 28.7 6.8c4.5 9.1 14 15.4 25 15.4s20.5-6.3 25.1-15.5c9.7 3.2 20.9 1 28.7-6.8s10-18.9 6.8-28.7c9.1-4.5 15.4-14 15.4-25s-6.3-20.5-15.5-25.1c3.2-9.7 1-20.9-6.8-28.7s-18.9-10-28.7-6.8c-4.5-9.1-14-15.4-25-15.4s-20.5 6.3-25.1 15.5c-9.7-3.2-20.9-1-28.7 6.8z"
        }
    ]
};

const FalHatWinter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHatWinter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c7.2 11.3 20.8 16.9 33.9 14-2.9 13.2 2.7 26.8 14.1 34-11.3 7.2-16.9 20.8-14 33.9-13.1-2.9-26.7 2.7-33.9 14-7.2-11.3-20.8-16.9-33.9-14 2.9-13.1-2.7-26.7-14-33.9 11.3-7.2 16.9-20.8 14-33.9 13.1 2.9 26.7-2.7 33.9-14zm56.5-8.6c-8-8-19.3-10.9-29.6-8.6C277.3 5.9 267.3 0 256 0s-21.3 5.9-27 14.8c-10.3-2.3-21.5.6-29.6 8.6s-10.9 19.3-8.6 29.6c-8.9 5.7-14.8 15.7-14.8 27s5.9 21.3 14.8 27c-2.3 10.3.6 21.5 8.6 29.6s19.3 10.9 29.6 8.6c5.7 8.9 15.7 14.8 27 14.8s21.3-5.9 27-14.8c10.3 2.3 21.5-.6 29.6-8.6s10.9-19.3 8.6-29.6c8.9-5.7 14.8-15.7 14.8-27s-5.9-21.3-14.8-27c2.3-10.3-.6-21.5-8.6-29.6zM32 456c0-13.3 10.7-24 24-24h400c13.3 0 24 10.7 24 24s-10.7 24-24 24H56c-13.3 0-24-10.7-24-24zm-32 0c0 30.9 25.1 56 56 56h400c30.9 0 56-25.1 56-56s-25.1-56-56-56H56c-30.9 0-56 25.1-56 56zm162.5-321.4C64.3 188.2 39.4 321.8 33.6 368h32.3c.8-5.8 1.9-12.8 3.3-20.6.5-2.9 1.1-5.9 1.8-9l8.2-4.1 48.6-24.3c4.8-2.4 10.4-2.2 15.1.4l26.3 15c13.9 8 30.9 8.4 45.3 1.3l34.4-17.2c4.5-2.3 9.8-2.3 14.3 0l34.4 17.2c14.4 7.2 31.3 6.7 45.3-1.3l26.3-15c4.6-2.7 10.3-2.8 15.1-.4l48.7 24.3 8.2 4.1c.6 3.1 1.2 6.1 1.8 9 1.5 7.9 2.5 14.8 3.3 20.6h32.3c-5.8-46.2-30.7-179.8-128.8-233.4-2.5 9-7.3 17.5-14.4 24.6-.9.9-1.8 1.8-2.8 2.6 40.1 21.1 66.4 58.5 84.3 99.1 5.4 12.2 9.9 24.5 13.6 36.4l-31.9-15.9c-14.4-7.2-31.3-6.7-45.3 1.3l-26.3 15c-4.6 2.7-10.3 2.8-15.1.4l-34.4-17.2c-13.5-6.8-29.4-6.8-42.9 0L200.2 298c-4.8 2.4-10.4 2.2-15.1-.4l-26.3-15c-13.9-8-30.9-8.4-45.3-1.3l-31.9 16c3.7-11.9 8.2-24.2 13.6-36.4 17.9-40.6 44.3-78 84.3-99.1-1-.8-1.9-1.7-2.8-2.6-7.1-7.1-11.9-15.6-14.4-24.6z"
        }
    ]
};

const FalHatWitch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHatWitch",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 384h34.9l80.9-185c13.8-31.5 37.3-57.7 67.2-74.8l157.8-90.1c2.4-1.4 5.2-2.1 7.9-2.1h1.5c3.8 0 7.5 1.4 10.4 3.9l82.5 70.7c3.1 2.7 4.9 6.5 4.9 10.6 0 2.2-.5 4.3-1.5 6.3L516.7 175l-1.1-4.3c-6.2-25.1-28.7-42.7-54.6-42.7-18.8 0-36.4 9.4-46.9 25.1l-14.3 21.5c-10.3 15.5-15.8 33.6-15.8 52.2 0 13.2 2.8 26.2 8.1 38.2L445 384h35l-58.6-132c-3.5-7.9-5.4-16.5-5.4-25.2 0-12.3 3.6-24.3 10.4-34.5l14.3-21.5c4.5-6.8 12.1-10.8 20.2-10.8 11.2 0 20.9 7.6 23.6 18.4l7.1 28.3c2.5 10.2 11.7 17.3 22.2 17.3 8.7 0 16.6-4.9 20.5-12.6l36.8-73.6c3.2-6.4 4.9-13.4 4.9-20.6 0-13.4-5.9-26.2-16.1-34.9l-82.4-70.7C468.8 4.1 457.7 0 446.2 0h-1.5c-8.4 0-16.6 2.2-23.8 6.3L263.2 96.5c-35.8 20.5-64.1 51.9-80.6 89.7L96 384zm-43.2 64h470.4c-24.5 15.2-61.9 32-107.2 32H160c-45.3 0-82.7-16.8-107.2-32zm-30.2-32C10.1 416 0 426.1 0 438.6c0 6 2.4 11.7 6.9 15.6C25.9 470.3 82.6 512 160 512h256c77.4 0 134.1-41.7 153.1-57.8 4.6-3.9 6.9-9.6 6.9-15.6 0-12.5-10.1-22.6-22.6-22.6H22.6zM304 352c8.8 0 16 7.2 16 16v16h32v-16c0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48v16h32v-16c0-8.8 7.2-16 16-16h32z"
        }
    ]
};

const FalHatWizard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHatWizard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m408.6 368-60.4-141c-9.3-21.6-10.3-45.9-2.8-68.2l37.3-112-136.2 77.8c-29.6 16.9-53 42.8-66.8 73.9L104.4 368h-35l81.1-182.5c16.6-37.4 44.7-68.4 80.2-88.7l165-94.3c2.8-1.6 6-2.5 9.3-2.5 10.5 0 19 8.5 19 19v1.7c0 2.2-.4 4.4-1.1 6.5l-47.2 141.7c-5 14.9-4.3 31 1.9 45.4L443.4 368h-34.8zm71.4 88c0-13.3-10.7-24-24-24H56c-13.3 0-24 10.7-24 24s10.7 24 24 24h400c13.3 0 24-10.7 24-24zM56 400h400c30.9 0 56 25.1 56 56s-25.1 56-56 56H56c-30.9 0-56-25.1-56-56s25.1-56 56-56zm232-224v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-48 128v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalHeadSideBrain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideBrain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224c0-106 86-192 192-192h16c66.1 0 127.1 40 153.8 96.9 3.2 6.9 6.5 14.2 9.9 21.7 6.2 13.9 12.7 28.5 19.8 42 11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1 0 15.6-12.6 28.2-28.2 28.2h-20c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64v-48h3.8c33.2 0 60.2-26.9 60.2-60.2 0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3-6.7-12.7-12.3-25.5-18.2-38.7-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0h-16C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140 9.4 11.6 14.9 24.6 14.9 37.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm171.1-99.8c4.1-7.3 12-12.2 20.9-12.2s16.8 4.9 20.9 12.2c4.3 7.6 13.9 10.4 21.6 6.2 2.8-1.5 6-2.4 9.5-2.4 7 0 13.2 3.6 16.8 9.1 3.4 5.2 9.5 8 15.7 7.1 1.1-.2 2.3-.3 3.5-.3 13.3 0 24 10.7 24 24s-10.7 24-24 24h-43.3c-5.4 0-10.4 2.7-13.4 7.2s-3.4 10.2-1.3 15.2c1.3 2.9 2 6.2 2 9.6 0 11.6-8.2 21.3-19.2 23.5-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5c25.6-5.2 44.8-27.8 44.8-54.9h24c30.9 0 56-25.1 56-56 0-30.4-24.2-55.2-54.5-56-9.5-9.9-22.8-16-37.5-16-4 0-7.8.4-11.5 1.3C254.3 86.6 239.9 80 224 80s-30.3 6.6-40.5 17.3c-3.7-.9-7.5-1.3-11.5-1.3-22.2 0-41.1 13.9-48.6 33.4-24.8 5.7-43.4 28-43.4 54.6 0 19.2 9.7 36.1 24.3 46.2 3.1 28 26.8 49.8 55.7 49.8v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-43.3c0-5.4-2.7-10.4-7.2-13.4s-10.2-3.4-15.2-1.3c-2.9 1.3-6.2 2-9.6 2-13.3 0-24-10.7-24-24 0-.7 0-1.3.1-2 .6-6.8-3.3-13.3-9.6-16-8.6-3.7-14.5-12.2-14.5-22 0-13.3 10.7-24 24-24h.2c8.2 0 15-6.1 15.9-14.2 1.1-10 9.6-17.8 19.9-17.8 3.5 0 6.7.9 9.5 2.4 7.7 4.2 17.3 1.4 21.6-6.2z"
        }
    ]
};

const FalHeadSideCoughSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideCoughSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32h16c66.1 0 127.1 40 153.8 96.9 3.2 6.9 6.5 14.2 9.9 21.7 6.2 13.9 12.7 28.5 19.8 42 11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1 0 7.4-2.8 14.1-7.4 19.1l25.2 19.9c8.9-10.5 14.3-24.1 14.3-38.9 0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3-6.7-12.7-12.3-25.5-18.2-38.7-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0h-16c-34.8 0-67.7 7.9-97.1 22.1l28.5 22.5C176.8 36.4 199.9 32 224 32zM31.3 109.7C11.4 143.1 0 182.2 0 224c0 52.9 18.4 101.6 49.1 140 9.4 11.6 14.9 24.6 14.9 37.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224c0-34.3 9-66.5 24.7-94.3l-25.4-20zm497.2 229.4 33.7 26.6c8.1-3.8 13.8-12.1 13.8-21.7 0-13.3-10.7-24-24-24-11.6 0-21.2 8.2-23.5 19.1zm63.6 50.2 32 25.3c9.2-3.3 15.8-12.2 15.8-22.6 0-13.3-10.7-24-24-24-12.3 0-22.5 9.3-23.9 21.3zM432 426l-23.6-18.7-66.5-5.5c-3.3-.3-5.8-3-5.8-6.4 0-3.2 2.3-5.9 5.5-6.3l37.1-5.3-34.7-27.4-7 1c-18.9 2.7-33 18.9-33 38 0 20 15.3 36.6 35.2 38.2l59.9 5C396.2 448.7 387 456 376 456h-72c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-8h56c30.9 0 56-25.1 56-56v-6zm208-130a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalHeadSideCough = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideCough",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224c0-106 86-192 192-192h16c66.1 0 127.1 40 153.8 96.9 3.2 6.9 6.5 14.2 9.9 21.7 6.2 13.9 12.7 28.5 19.8 42 11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1 0 15.6-12.6 28.2-28.2 28.2h-20c-8.8 0-16 7.2-16 16v26.1l-79 11.3c-18.9 2.7-33 18.9-33 38 0 20 15.3 36.6 35.2 38.2l59.9 5c-2.9 10-12.1 17.3-23.1 17.3h-72c-8.8 0-16 7.2-16 16v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-8h56c30.9 0 56-25.1 56-56v-8c0-8.3-6.4-15.3-14.7-15.9l-75.5-6.3c-3.3-.3-5.8-3-5.8-6.4 0-3.2 2.3-5.9 5.5-6.3l92.8-13.3c7.9-1.1 13.7-7.9 13.7-15.8v-24h3.8c33.2 0 60.2-26.9 60.2-60.2 0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3-6.7-12.7-12.3-25.5-18.2-38.7-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0h-16C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140 9.4 11.6 14.9 24.6 14.9 37.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm168 168a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm104 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88-120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalHeadSideGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideGear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224c0-106 86-192 192-192h16c66.1 0 127.1 40 153.8 96.9 3.2 6.9 6.5 14.2 9.9 21.7 6.2 13.9 12.7 28.5 19.8 42 11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1 0 15.6-12.6 28.2-28.2 28.2h-20c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64v-48h3.8c33.2 0 60.2-26.9 60.2-60.2 0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3-6.7-12.7-12.3-25.5-18.2-38.7-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0h-16C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140 9.4 11.6 14.9 24.6 14.9 37.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm144-96v.7c0 1-.8 3.4-4.1 5.3-3.2 1.8-5.5 1.4-6.5.8l-.6-.3c-15.3-8.8-34.9-3.6-43.7 11.7l-16 27.7c-8.8 15.3-3.6 34.9 11.7 43.7l.6.3c.9.5 2.6 2.4 2.6 6.1s-1.6 5.6-2.6 6.1l-.6.3c-15.3 8.8-20.5 28.4-11.7 43.7l16 27.7c8.8 15.3 28.4 20.6 43.7 11.7l.6-.3c.9-.5 3.3-1 6.5.8 3.3 1.9 4.1 4.3 4.1 5.3v.7c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-.7c0-1 .8-3.4 4.1-5.3 3.2-1.8 5.5-1.4 6.5-.8l.6.3c15.3 8.8 34.9 3.6 43.7-11.7l16-27.7c8.8-15.3 3.6-34.9-11.7-43.7l-.6-.3c-.9-.5-2.6-2.4-2.6-6.1s1.6-5.6 2.6-6.1l.6-.3c15.3-8.8 20.6-28.4 11.7-43.7l-16-27.7c-8.8-15.3-28.4-20.5-43.7-11.7l-.6.3c-.9.5-3.3 1-6.5-.8-3.3-1.9-4.1-4.3-4.1-5.3v-.7c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v.7c0 15.1 9.4 26.8 20 33 10.7 6.2 25.5 8.3 38.5.8l.6-.3 16 27.7-.6.3c-13 7.5-18.5 21.4-18.5 33.8s5.5 26.3 18.5 33.8l.6.3-16 27.7-.6-.3c-13-7.5-27.8-5.4-38.5.8-10.6 6.2-20 17.9-20 33v.7h-32v-.7c0-15.1-9.4-26.8-20-33-10.7-6.2-25.5-8.3-38.5-.8l-.6.3-16-27.7.6-.3c13-7.5 18.6-21.4 18.6-33.8s-5.5-26.3-18.6-33.8l-.6-.3 16-27.7.6.3c13 7.5 27.8 5.4 38.5-.8 10.6-6.2 20-17.9 20-33v-.7h32zm8 96a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalHeadSideGoggles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideGoggles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M2.3 256c5.8 40.5 22.4 77.5 46.8 108 9.4 11.6 14.9 24.6 14.9 37.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-94.6c0-22.1-9.5-41.9-21.9-57.4-20-25-33.9-55-39.4-88H2.3zM80.9 96C116 56.7 167.1 32 224 32h24c36 0 69.3 11.9 96 32h-56c-28.4 0-54 12.4-71.6 32H80.9zm-45.1 6.6C14.6 113 0 134.8 0 160c0 35.3 28.7 64 64 64h152.4c17.6 19.6 43.1 32 71.6 32h176c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-72.9C356 24.7 304.9 0 248 0h-24C145 0 75.6 40.8 35.7 102.6zM197.5 192H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h133.5c-3.5 10-5.5 20.8-5.5 32s1.9 22 5.5 32zm313.3 96h-33.6c-4.5 9.5-14.2 16-25.4 16H432c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64c35.3 0 64-28.7 64-64v-48h3.8c29.1 0 53.3-20.6 58.9-48zM288 96h96v128h-96c-35.3 0-64-28.7-64-64s28.7-64 64-64zm128 128V96h48c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-48z"
        }
    ]
};

const FalHeadSideHeadphones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideHeadphones",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 38v62.6c10.1-3 20.9-4.6 32-4.6s21.9 1.6 32 4.6V32h-16c-16.6 0-32.7 2.1-48 6zm-32 11.4C77.9 79.7 32 146.5 32 224c0 45.4 15.7 87.1 42.1 120C86.5 359.5 96 379.3 96 401.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-94.6c0-12.8-5.5-25.7-14.9-37.4C18.4 325.6 0 276.9 0 224 0 100.3 100.3 0 224 0h16c78.6 0 150.8 47.3 182.7 115.3 3.8 8.1 7.3 16 10.8 23.8 5.9 13.2 11.6 26 18.2 38.7 10.3 19.6 21.7 36.8 36.9 50.3l3.2 2.8c12.8 11.4 20.2 27.8 20.2 45 0 33.2-26.9 60.2-60.2 60.2H448v48c0 35.3-28.7 64-64 64h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432c0-8.8 7.2-16 16-16h80c17.7 0 32-14.3 32-32v-64c0-8.8 7.2-16 16-16h19.8c15.6 0 28.2-12.6 28.2-28.2 0-8-3.4-15.7-9.5-21.1l-3.2-2.8c-19.2-17.1-32.8-38.1-44-59.4-7-13.5-13.5-28-19.8-42-3.4-7.5-6.6-14.9-9.9-21.7-22.1-47.4-68.4-83.2-121.6-93.7v81c29 20.2 48 53.9 48 91.9 0 61.9-50.1 112-112 112S96 269.9 96 208c0-38.1 19-71.7 48-91.9V49.4zM288 208a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-80 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
        }
    ]
};

const FalHeadSideHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224c0-106 86-192 192-192h16c66.1 0 127.1 40 153.8 96.9 3.2 6.9 6.5 14.2 9.9 21.7 6.2 13.9 12.7 28.5 19.8 42 11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1 0 15.6-12.6 28.2-28.2 28.2h-20c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64v-48h3.8c33.2 0 60.2-26.9 60.2-60.2 0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3-6.7-12.7-12.3-25.5-18.2-38.7-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0h-16C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140 9.4 11.6 14.9 24.6 14.9 37.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm112-34.7c0-16.2 13.1-29.3 29.3-29.3 7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6 16.2 0 29.3 13.1 29.3 29.3 0 7.8-3.1 15.2-8.6 20.7L224 281.4 152.6 210c-5.5-5.5-8.6-12.9-8.6-20.7zm29.3-61.3c-33.8 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"
        }
    ]
};

const FalHeadSideMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideMask",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M78.7 150.2 276.5 272h235.2c-.9-6.6-4.1-12.7-9.2-17.2l-3.2-2.8c-32.6-29-50-70.3-65.4-106.9-2.4-5.8-4.8-11.4-7.2-16.9C402.1 71.5 345.6 32 280 32h-24c-79.9 0-148.4 48.8-177.3 118.2zm-10 31.4C65.6 195.3 64 209.4 64 224c0 45.4 15.7 87.1 42.1 120 12.5 15.5 21.9 35.3 21.9 57.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-94.6c0-12.8-5.5-25.7-14.9-37.4C50.4 325.6 32 276.9 32 224 32 100.3 132.3 0 256 0h24c78.8 0 146.5 47.5 176.1 115.3 2.7 6.1 5.2 12.1 7.7 18.1 15.7 37.1 30.1 70.9 56.8 94.6l3.2 2.8c11.9 10.6 19.1 25.4 20.1 41.2h.1c0 10.6-1.5 21.2-4.4 31.4l-.2.6-46.1 161.6c-7.8 27.5-33 46.4-61.5 46.4H288c-17.7 0-32-14.3-32-32V296.9L68.7 181.7zM376 176a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-88 304h143.7c14.3 0 26.8-9.5 30.8-23.2l4.8-16.8H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h108.4l9.1-32H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h126.7l11.4-40H288v176z"
        }
    ]
};

const FalHeadSideMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224c0-106 86-192 192-192h16c66.1 0 127.1 40 153.8 96.9 3.2 6.9 6.5 14.2 9.9 21.7 6.2 13.9 12.7 28.5 19.8 42 11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1 0 15.6-12.6 28.2-28.2 28.2h-20c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64v-48h3.8c33.2 0 60.2-26.9 60.2-60.2 0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3-6.7-12.7-12.3-25.5-18.2-38.7-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0h-16C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140 9.4 11.6 14.9 24.6 14.9 37.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zM224 96c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 80v-48h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3z"
        }
    ]
};

const FalHeadSideVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSideVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224c0-106 86-192 192-192h16c66.1 0 127.1 40 153.8 96.9 3.2 6.9 6.5 14.2 9.9 21.7 6.2 13.9 12.7 28.5 19.8 42 11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1 0 15.6-12.6 28.2-28.2 28.2h-20c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64v-48h3.8c33.2 0 60.2-26.9 60.2-60.2 0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3-6.7-12.7-12.3-25.5-18.2-38.7-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0h-16C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140 9.4 11.6 14.9 24.6 14.9 37.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm293.8 63.2C302.5 263.9 319 224 352 224c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2 6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C279.9 129.5 240 113 240 80c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C145.5 152.1 129 192 96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C168.1 286.5 208 303 208 336c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2 6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM307.5 208c-17 14.5-26.3 36.8-24.5 59.1-22.3-1.8-44.6 7.4-59.1 24.5-14.5-17-36.8-26.3-59.1-24.5 1.8-22.3-7.4-44.6-24.5-59.1 17-14.5 26.3-36.8 24.5-59.1 22.3 1.8 44.6-7.4 59.1-24.5 6.6 7.8 14.8 13.9 24 18.1 10.9 5 23 7.3 35.1 6.3-1.8 22.3 7.4 44.6 24.5 59.1zm-99.5 8a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 24a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalHeadSide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadSide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224c0-106 86-192 192-192h16c66.1 0 127.1 40 153.8 96.9 3.2 6.9 6.5 14.2 9.9 21.7 6.2 13.9 12.7 28.5 19.8 42 11.1 21.3 24.8 42.3 44 59.4l3.2 2.8c6 5.3 9.5 13 9.5 21.1 0 15.6-12.6 28.2-28.2 28.2h-20c-8.8 0-16 7.2-16 16v64c0 17.7-14.3 32-32 32h-80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h64c35.3 0 64-28.7 64-64v-48h3.8c33.2 0 60.2-26.9 60.2-60.2 0-17.2-7.4-33.6-20.2-45l-3.2-2.8c-15.1-13.5-26.6-30.6-36.9-50.3-6.7-12.7-12.3-25.5-18.2-38.7-3.5-7.8-7-15.7-10.8-23.8C390.8 47.3 318.6 0 240 0h-16C100.3 0 0 100.3 0 224c0 52.9 18.4 101.6 49.1 140 9.4 11.6 14.9 24.6 14.9 37.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-94.6c0-22.1-9.5-41.9-21.9-57.4C47.7 311.1 32 269.4 32 224zm312 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalHeading = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeading",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v160h256V64h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v384h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V256H96v192h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V64H16C7.2 64 0 56.8 0 48z"
        }
    ]
};

const FalHeadphonesSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadphonesSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 288C32 164.3 132.3 64 256 64s224 100.3 224 224v112c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-141.4-114.6-256-256-256S0 146.6 0 288v112c0 8.8 7.2 16 16 16s16-7.2 16-16V288zm128 0v160h-16c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h16zm-16-32c-44.2 0-80 35.8-80 80v64c0 44.2 35.8 80 80 80h16c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32h-16zm208 32h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-16V288zm16-32h-16c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h16c44.2 0 80-35.8 80-80v-64c0-44.2-35.8-80-80-80z"
        }
    ]
};

const FalHeadphones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadphones",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.6 271.6C41 155.5 137.8 64 256 64s215 91.5 223.4 207.6c-13.3-9.8-29.7-15.6-47.4-15.6-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48 44.2 0 80-35.8 80-80V288c0-141.4-114.6-256-256-256S0 146.6 0 288v112c0 44.2 35.8 80 80 80 26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48-17.7 0-34.1 5.8-47.4 15.6zM32 336c0-26.5 21.5-48 48-48 8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16-26.5 0-48-21.5-48-48v-64zm448 0v64c0 26.5-21.5 48-48 48-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16 26.5 0 48 21.5 48 48z"
        }
    ]
};

const FalHeadset = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeadset",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224v144.1c0 26.5-21.5 48-48 48l-82.7-.1c-6.6-18.6-24.4-32-45.3-32h-64c-26.5 0-48 21.5-48 48s21.5 48 48 48h64c20.9 0 38.7-13.4 45.3-32l82.7.1c44.2 0 80.1-35.8 80.1-80V256C512 114.6 397.4 0 256 0S0 114.6 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48zm288 208c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16M144 224h16v128h-16c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48zm-80 48v32c0 44.2 35.8 80 80 80h16c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-16c-44.2 0-80 35.8-80 80zm288-48h16c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48h-16V224zm16-32h-16c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h16c44.2 0 80-35.8 80-80v-32c0-44.2-35.8-80-80-80z"
        }
    ]
};

const FalHeartCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartCircleBolt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m244 130.6-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8.7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8.8-1.7 1.5-2.6 2.2-6.3 4.9-14.1 7.5-22.1 7.5-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4 6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1l5.4-4.5c32.2-25.1 73.9-35.8 114.9-28.4C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1-9.8-4.9-20.2-8.9-30.9-12 .2-2.7.3-5.4.3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm191.9-81c4.3 3.7 5.4 9.9 2.6 14.9L452.4 356H488c5.2 0 9.8 3.3 11.4 8.2s-.1 10.3-4.2 13.4l-96 72c-4.5 3.4-10.8 3.2-15.1-.6s-5.4-9.9-2.6-14.9l30.1-54.1H376c-5.2 0-9.8-3.3-11.4-8.2s.1-10.3 4.2-13.4l96-72c4.5-3.4 10.8-3.2 15.1.6z"
        }
    ]
};

const FalHeartCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m244 130.6-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8.7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8.8-1.7 1.5-2.6 2.2-6.3 4.9-14.1 7.5-22.1 7.5-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4 6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1l5.4-4.5c32.2-25.1 73.9-35.8 114.9-28.4C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1-9.8-4.9-20.2-8.9-30.9-12 .2-2.7.3-5.4.3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalHeartCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m244 130.6-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8.7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8.8-1.7 1.5-2.6 2.2-6.3 4.9-14.1 7.5-22.1 7.5-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4 6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1l5.4-4.5c32.2-25.1 73.9-35.8 114.9-28.4C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1-9.8-4.9-20.2-8.9-30.9-12 .2-2.7.3-5.4.3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalHeartCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m244 130.6-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8.7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8.8-1.7 1.5-2.6 2.2-6.3 4.9-14.1 7.5-22.1 7.5-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4 6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1l5.4-4.5c32.2-25.1 73.9-35.8 114.9-28.4C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1-9.8-4.9-20.2-8.9-30.9-12 .2-2.7.3-5.4.3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalHeartCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m244 130.6-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8.7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8.8-1.7 1.5-2.6 2.2-6.3 4.9-14.1 7.5-22.1 7.5-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4 6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1l5.4-4.5c32.2-25.1 73.9-35.8 114.9-28.4C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1-9.8-4.9-20.2-8.9-30.9-12 .2-2.7.3-5.4.3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalHeartCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m244 130.6-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8.7 1.9 1.2 3 1.2s2.2-.4 3-1.2l10.9-10.2c4.3 10.2 9.6 20 15.7 29.1l-4.9 4.5c-.8.8-1.7 1.5-2.6 2.2-6.3 4.9-14.1 7.5-22.1 7.5-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4 6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1l5.4-4.5c32.2-25.1 73.9-35.8 114.9-28.4C462.2 57.6 512 117.3 512 186.9v3.5c0 6.8-.5 13.5-1.4 20.1-9.8-4.9-20.2-8.9-30.9-12 .2-2.7.3-5.4.3-8.1v-3.5c0-54.2-38.7-100.6-92-110.3-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zM544 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm203.3-36.7L454.6 368l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalHeartCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartCrack",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m272 126.1 7.9-8.9 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8 53.3 9.7 92 56.1 92 110.3v3.5c0 32.3-13.4 63.1-37 85.1L259 446.8c-.8.7-1.9 1.2-3 1.2s-2.2-.4-3-1.2L69.1 275.5c-23.7-22-37.1-52.8-37.1-85.1v-3.5c0-54.2 38.7-100.6 92-110.3 38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 7.9 8.9v18c0 4.2 1.7 8.3 4.7 11.3l34.2 34.2-79.8 53.2c-3.7 2.5-6.2 6.4-6.9 10.9s.5 8.9 3.3 12.4l64 80c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-53.1-66.4 81.5-54.3c4-2.7 6.6-7 7-11.7s-1.2-9.5-4.6-12.9L272 137.4v-11.3zm121.7-81c-40.9-7.4-82.6 3.2-114.7 28.4-1.8 1.4-3.6 2.9-5.4 4.5-4.7 4.1-9.1 8.4-13.3 13.1l-4.3 4.8-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6-32.1-25.2-73.8-35.9-114.8-28.5C49.8 57.6 0 117.3 0 186.9v3.5c0 36 13.1 70.6 36.6 97.5 3.4 3.8 6.9 7.5 10.7 11l184 171.3c6.7 6.3 15.6 9.7 24.8 9.7 8 0 15.8-2.7 22.1-7.5.9-.7 1.8-1.4 2.6-2.2l184-171.2c3.8-3.5 7.3-7.2 10.7-11 23.4-27 36.5-61.6 36.5-97.6v-3.5c0-69.6-49.8-129.3-118.3-141.8z"
        }
    ]
};

const FalHeartHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartHalfStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m272 126.1 7.9-8.9 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8 53.3 9.7 92 56.1 92 110.3v3.5c0 32.3-13.4 63.1-37 85.1L272 434.7V126.1zM256.3 448h-.6.5zM240 434.7 69.1 275.5c-23.7-22-37.1-52.8-37.1-85.1v-3.5c0-54.2 38.7-100.6 92-110.3 38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 7.9 8.9v308.7zM393.7 45.1c-40.9-7.4-82.6 3.2-114.7 28.4-1.8 1.4-3.6 2.9-5.4 4.5-4.7 4.1-9.1 8.4-13.3 13.1l-4.3 4.8-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6-32.1-25.2-73.8-35.9-114.8-28.5C49.8 57.6 0 117.3 0 186.9v3.5c0 36 13.1 70.6 36.6 97.5 3.4 3.8 6.9 7.5 10.7 11l184 171.3c6.7 6.3 15.6 9.7 24.8 9.7 8 0 15.8-2.7 22.1-7.5.9-.7 1.8-1.4 2.6-2.2l184-171.2c3.8-3.5 7.3-7.2 10.7-11 23.4-27 36.5-61.6 36.5-97.6v-3.5c0-69.6-49.8-129.3-118.3-141.8z"
        }
    ]
};

const FalHeartHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartHalf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 451.5V96l-12-12c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5L224 465.1l.3.2 3.5 3.2 9 8.4c2.1 2 4.9 3.1 7.8 3.1 6.3 0 11.5-5.1 11.5-11.5v-17zm-32-30.2L69.4 277C45.6 254.7 32 223.6 32 190.9v-5.8c0-54.2 39.2-100.5 92.7-109.4 35.3-5.9 71.4 5.6 96.7 31l2.6 2.6v312z"
        }
    ]
};

const FalHeartPulse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeartPulse",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M244 130.6c3 3.4 7.4 5.4 12 5.4s8.9-2 12-5.4l12-13.5 4.2-4.7c26-29.2 65.3-42.8 103.8-35.8 53.3 9.7 92 56.1 92 110.3v3.5c0 23.8-7.3 46.7-20.5 66-1.1-.2-2.3-.4-3.5-.4h-84.2c-6.1 0-11.6-3.4-14.3-8.8l-23.2-46.3c-2.7-5.4-8.2-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-48.9 97.9-58.2-129.4c-2.6-5.8-8.4-9.5-14.8-9.4s-12.1 4-14.5 9.8l-31.8 76.3c-2.5 6-8.3 9.8-14.8 9.8H56c-1.2 0-2.4.1-3.5.4C39.3 237.1 32 214.2 32 190.4v-3.5c0-54.2 38.7-100.6 92-110.3 38.5-7 77.8 6.6 103.8 35.8l4.2 4.7 12 13.5zM429.6 288h45.8l.1-.1c23.4-26.9 36.5-61.5 36.5-97.5v-3.5c0-69.6-49.8-129.3-118.3-141.8-40.9-7.4-82.6 3.2-114.7 28.4-1.8 1.4-3.6 2.9-5.4 4.5-4.7 4.1-9.1 8.4-13.3 13.1l-4.3 4.8-4.2-4.7c-5.8-6.5-12-12.4-18.7-17.6-32.1-25.2-73.8-35.9-114.8-28.5C49.8 57.6 0 117.3 0 186.9v3.5c0 36 13.1 70.6 36.6 97.5l.1.1h85.9c19.4 0 36.9-11.7 44.3-29.5l17.6-42.2 56.8 126.3c2.5 5.6 8.1 9.3 14.3 9.4s11.9-3.3 14.6-8.8l49.8-99.4 8.8 17.7c8.1 16.3 24.8 26.5 42.9 26.5h57.8zM69.8 320l161.4 150.3c6.7 6.3 15.6 9.7 24.8 9.7 8 0 15.8-2.7 22.1-7.5.9-.7 1.8-1.4 2.6-2.2L442.2 320h-47L259 446.8c-.8.7-1.9 1.2-3 1.2s-2.2-.4-3-1.2L116.8 320h-47z"
        }
    ]
};

const FalHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m244 130.6-12-13.5-4.2-4.7c-26-29.2-65.3-42.8-103.8-35.8-53.3 9.7-92 56.1-92 110.3v3.5c0 32.3 13.4 63.1 37.1 85.1L253 446.8c.8.7 1.9 1.2 3 1.2s2.2-.4 3-1.2l184-171.3c23.6-22 37-52.8 37-85.1v-3.5c0-54.2-38.7-100.6-92-110.3-38.5-7-77.8 6.6-103.8 35.8l-4.2 4.7-12 13.5c-3 3.4-7.4 5.4-12 5.4s-8.9-2-12-5.4zm34.9-57.1c32.1-25.1 73.8-35.8 114.8-28.4C462.2 57.6 512 117.3 512 186.9v3.5c0 36-13.1 70.6-36.6 97.5-3.4 3.8-6.9 7.5-10.7 11l-184 171.3c-.8.8-1.7 1.5-2.6 2.2-6.3 4.9-14.1 7.5-22.1 7.5-9.2 0-18-3.5-24.8-9.7L47.2 299c-3.8-3.5-7.3-7.2-10.7-11C13.1 261 0 226.4 0 190.4v-3.5C0 117.3 49.8 57.6 118.3 45.1c40.9-7.4 82.6 3.2 114.7 28.4 6.7 5.3 13 11.1 18.7 17.6l4.2 4.7 4.2-4.7c4.2-4.7 8.6-9.1 13.3-13.1l5.4-4.5z"
        }
    ]
};

const FalHeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHeat",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32c8.8 0 16 7.2 16 16v96c0 38.1 12.4 75.1 35.2 105.6l19.2 25.6c27 36 41.6 79.8 41.6 124.8v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-38.1-12.4-75.1-35.2-105.6l-19.2-25.6c-27-36-41.6-79.8-41.6-124.8V48c0-8.8 7.2-16 16-16zM16 96c8.8 0 16 7.2 16 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3C115.9 337 128 377.1 128 418.2V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-45.9c0-34.7-10.3-68.7-29.6-97.6l-31.5-47.3C12.2 239.1 0 198.9 0 157.9V112c0-8.8 7.2-16 16-16zm336 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3C435.9 337 448 377.1 448 418.2V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-45.9c0-34.7-10.3-68.7-29.6-97.6l-31.5-47.3c-22.7-34.1-34.9-74.3-34.9-115.3V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalHelicopterSymbol = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHelicopterSymbol",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M469.7 224H502C487.9 110.9 400 20.7 288 3.1v32.5c94.3 17 168.1 93 181.7 188.4zm32.3 64h-32.3c-13.6 95.4-87.4 171.4-181.7 188.4v32.5C400 491.3 487.9 401.1 502 288zm-508 0C8.7 406.5 104.4 499.8 224 510.9v-32.2C122.1 467.9 40.7 388.8 26.3 288H-6zm0-64h32.3C40.7 123.2 122.1 44.1 224 33.3V1.1C104.5 12.2 8.8 105.5-6 224zm182-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h160v96c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96H176v-96z"
        }
    ]
};

const FalHelicopter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHelicopter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h192v96H144l-33.6-44.8C101.3 71.1 87.1 64 72 64H44.8c-21 0-36.3 19.9-30.9 40.2l22.7 85.1c3.7 14 13.6 25.6 26.9 31.5l124.6 55.4c1.8.8 3.4 1.9 4.8 3.3l90.4 90.4c9 9 21.3 14.1 34 14.1h205.4c30.9 0 56-25.1 56-56v-56c0-79.5-64.5-144-144-144H384V32h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zM72 96c5 0 9.8 2.4 12.8 6.4l38.4 51.2c3 4 7.8 6.4 12.8 6.4h216v192h-34.9c-4.3 0-8.3-1.7-11.3-4.7l-90.4-90.4c-4.2-4.2-9.1-7.5-14.4-9.9L76.5 191.6c-4.4-2-7.7-5.8-9-10.5L44.8 96H72zm312.4 256h-.4V160h48c61.9 0 112 50.1 112 112v56c0 13.2-10.8 24-24 24H384.2zm250.9 123.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-8.6 8.6c-12 12-28.3 18.7-45.3 18.7H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h318.9c25.5 0 49.9-10.1 67.9-28.1l8.6-8.6z"
        }
    ]
};

const FalHelmetBattle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHelmetBattle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M84.4.6c-8.5-2.4-17.4 2.5-19.8 11l-53 185.5C3.2 226.6 25.3 256 56 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-9.4 0-16.2-9-13.6-18.1l53-185.5C97.8 11.9 92.9 3 84.4.6zM295.7 2c-4.8-2.6-10.6-2.6-15.4 0l7.7 14 7.7-14zm215.8 401.9v-.1l-.1-.2-.3-1c-.2-.9-.6-2.2-1-3.9-.9-3.4-2.1-8.3-3.6-14.5-3-12.3-6.9-29.6-10.9-49.4-8-39.8-15.7-88.5-15.7-126.9 0-28.6-13.1-55.9-30.6-79.6-17.6-24-40.7-45.9-63.2-64.4-22.6-18.6-45.2-34-62-44.8-8.4-5.4-15.5-9.7-20.4-12.6-2.5-1.5-4.4-2.6-5.8-3.4l-1.6-.9-.4-.2-.1-.1-7.7 14-7.7-14-.1.1-.4.2-1.6.9c-1.4.8-3.3 1.9-5.8 3.4-5 2.9-12 7.2-20.4 12.6-16.8 10.8-39.4 26.2-62 44.8-22.5 18.5-45.7 40.5-63.2 64.4C109.1 152.1 96 179.4 96 208c0 38.3-7.7 87.1-15.7 126.9-4 19.8-7.9 37.1-10.9 49.4-1.5 6.2-2.7 11.1-3.6 14.5-.4 1.7-.8 3-1 3.9l-.3 1-.1.2v.1c-1.9 7.2 1.4 14.8 8 18.3l166.9 87.4c2.6 1.4 5.5 2.2 8.5 2.5 13 1.1 24.1-9.1 24.1-22.1v-205c0-15.3-10.8-28.4-25.7-31.4l-45.9-9.2c-4.9-1-8.3-5.2-8.3-10.2 0-5.7 4.6-10.4 10.4-10.4h171.2c5.7 0 10.4 4.6 10.4 10.4 0 4.9-3.5 9.2-8.3 10.2l-45.9 9.2c-15 3-25.7 16.1-25.7 31.4v204.8c0 13 11.1 23.2 24.1 22.1 3-.2 5.8-1.1 8.5-2.5l166.9-87.4c6.6-3.5 10-11.1 8-18.3zm-34.1-4.2-141.4 74V285.1l45.9-9.2c19.8-4 34.1-21.4 34.1-41.6 0-23.4-19-42.4-42.4-42.4H202.4C179 192 160 211 160 234.4c0 20.2 14.3 37.6 34.1 41.6l45.9 9.2v188.5l-141.4-74c.6-2.4 1.2-5 1.9-8 3-12.6 7.1-30.4 11.1-50.6 8-40.2 16.3-91.5 16.3-133.1 0-19 8.9-39.5 24.4-60.7 15.4-21 36.3-41 57.8-58.6 21.4-17.5 42.8-32.2 59-42.6 7.7-5 14.2-8.9 18.9-11.6 4.6 2.7 11.1 6.7 18.9 11.6 16.2 10.3 37.6 25 59 42.6s42.3 37.7 57.8 58.6C439.1 168.5 448 189 448 208c0 41.7 8.3 92.9 16.3 133.1 4 20.2 8.1 37.9 11.1 50.6.7 2.9 1.4 5.6 1.9 8zm34-388.1C509 3.1 500.1-1.8 491.6.6s-13.4 11.3-11 19.8l53 185.5c2.6 9.1-4.2 18.1-13.6 18.1-8.8 0-16 7.2-16 16s7.2 16 16 16c30.7 0 52.8-29.4 44.4-58.9l-53-185.5z"
        }
    ]
};

const FalHelmetSafety = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHelmetSafety",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 80v192c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v192c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-64-1.3v34.7C109.9 143.7 64 210.5 64 288v32H32v-32c0-95.5 59.8-177.1 144-209.3zm224 34.7V78.7c83.5 31.9 143 112.4 144 206.9V320h-32v-34.3c-.9-76.5-46.5-142.3-112-172.3zM537.3 384H38.7c-3.7 0-6.7 3-6.7 6.7 0 .4 0 .7.1 1C58.5 408.5 136.6 448 288 448s229.5-39.5 255.9-56.3c0-.2.1-.6.1-1 0-3.7-3-6.7-6.7-6.7zM38.7 352h498.6c21.4 0 38.7 17.3 38.7 38.7 0 11-4.7 21.4-13.9 27.3-30.8 19.9-115 62-274.1 62S44.7 437.9 13.9 418.1C4.7 412.1 0 401.7 0 390.7 0 369.3 17.3 352 38.7 352z"
        }
    ]
};

const FalHelmetUn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHelmetUn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 32c114.9 0 208 93.1 208 208v16H256c-6.9 0-13 4.4-15.2 10.9L212.5 352H77.2c-25 0-45.2-20.2-45.2-45.2V240c0-114.9 93.1-208 208-208zm96 419.4-93.6-88.1 25.1-75.3H336v163.4zm32 28.6V288h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16C480 107.5 372.5 0 240 0S0 107.5 0 240v66.8C0 349.4 34.6 384 77.2 384h140.5L349 507.7c3 2.8 6.9 4.3 11 4.3h104c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm-82.7-376.9c-3.9-5.9-11.2-8.5-17.9-6.4S256 105 256 112v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-43.2l34.7 52c3.9 5.9 11.2 8.5 17.9 6.4s11.4-8.3 11.4-15.3V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.2l-34.7-52zM160 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 26.5 21.5 48 48 48s48-21.5 48-48v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64z"
        }
    ]
};

const FalHexagonCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagonCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 288a64.158 64.158 0 0 1 0-64l92.3-159.8c11.4-19.8 32.6-32 55.4-32h184.6c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64l-92.3 159.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16h184.6c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16H163.7c-11.4 0-22 6.1-27.7 16L43.7 240zm319.6-36.7-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7 116.7-116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalHexagonDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagonDivide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 288a64.158 64.158 0 0 1 0-64l92.3-159.8c11.4-19.8 32.6-32 55.4-32h184.6c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64l-92.3 159.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16h184.6c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16H163.7c-11.4 0-22 6.1-27.7 16L43.7 240zM256 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-96 104h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalHexagonExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagonExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 288a64.158 64.158 0 0 1 0-64l92.3-159.8c11.4-19.8 32.6-32 55.4-32h184.6c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64l-92.3 159.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16h184.6c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16H163.7c-11.4 0-22 6.1-27.7 16L43.7 240zM256 128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-24 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalHexagonImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagonImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 288a64.158 64.158 0 0 1 0-64l92.3-159.8c11.4-19.8 32.6-32 55.4-32h184.6c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64l-92.3 159.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32l29.6 51.3 42.7-42.7c15.4-15.4 40.4-15.6 56.1-.5l55.3 53.4 95.4-101.8c15.8-16.9 42.6-16.9 58.4 0l68.3 72.8 18.8-32.5c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16H163.7c-11.4 0-22 6.1-27.7 16L43.7 240zm92 191.3 69.8-74.4-55.6-53.8c-3.1-3-8.1-3-11.2.1L89.9 352l45.8 79.4zm297.1-97.8-74.9-79.9c-3.2-3.4-8.5-3.4-11.7 0L164.1 447.8h184.2c11.4 0 22-6.1 27.7-16l56.8-98.3zM208 160a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FalHexagonMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagonMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 288a64.158 64.158 0 0 1 0-64l92.3-159.8c11.4-19.8 32.6-32 55.4-32h184.6c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64l-92.3 159.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16h184.6c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16H163.7c-11.4 0-22 6.1-27.7 16L43.7 240zm116.3 0h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalHexagonPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagonPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 288a64.158 64.158 0 0 1 0-64l92.3-159.8c11.4-19.8 32.6-32 55.4-32h184.6c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64l-92.3 159.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16h184.6c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16H163.7c-11.4 0-22 6.1-27.7 16L43.7 240zM240 352v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalHexagonVerticalNftSlanted = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagonVerticalNftSlanted",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M255.8 496.6a64.158 64.158 0 0 1-64 0L32 404.3c-19.8-11.4-32-32.6-32-55.4V164.3c0-22.9 12.2-44 32-55.4l159.8-92.3c19.8-11.4 44.2-11.4 64 0l159.8 92.3c19.8 11.4 32 32.6 32 55.4v184.6c0 22.9-12.2 44-32 55.4l-159.8 92.3zm-48-27.7c9.9 5.7 22.1 5.7 32 0l159.8-92.3c9.9-5.7 16-16.3 16-27.7V164.3c0-11.4-6.1-22-16-27.7L239.8 44.3c-9.9-5.7-22.1-5.7-32 0L48 136.6c-9.9 5.7-16 16.3-16 27.7v184.6c0 11.4 6.1 22 16 27.7l159.8 92.3zM272 123.5c0 12.3-13.3 20-23.9 13.9l-24.2-13.8v117h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V96.3c0-1.6.2-3.2.6-4.7.5-1.9 1.4-3.7 2.6-5.2 1.1-1.5 2.5-2.8 4-3.7 2.5-1.7 5.6-2.6 8.8-2.6h.1c.5 0 1 0 1.4.1 2.5.2 4.8 1 6.8 2.2l47.8 27.3c5 2.8 8.1 8.2 8.1 13.9zm16 27.4c0-12.3 13.3-20 23.9-13.9l72 41.1c7.7 4.4 10.3 14.2 6 21.8s-14.2 10.3-21.8 6l-16.2-9.3v156c0 8.8-7.2 16-16 16s-16-7.2-16-16V178.4l-23.8-13.6c-5-2.8-8.1-8.2-8.1-13.9zm-144.2-22.3c8.8 0 16 7.2 16 16v224c0 7.8-5.7 14.5-13.4 15.8s-15.3-3.3-17.7-10.7l-32.9-98.5v61.4c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.8 5.7-14.5 13.4-15.8s15.3 3.3 17.7 10.7l32.9 98.5V144.6c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalHexagonVerticalNft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagonVerticalNft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M255.8 496.6a64.158 64.158 0 0 1-64 0L32 404.3c-19.8-11.4-32-32.6-32-55.4V164.3c0-22.9 12.2-44 32-55.4l159.8-92.3c19.8-11.4 44.2-11.4 64 0l159.8 92.3c19.8 11.4 32 32.6 32 55.4v184.6c0 22.9-12.2 44-32 55.4l-159.8 92.3zm-48-27.7c9.9 5.7 22.1 5.7 32 0l159.8-92.3c9.9-5.7 16-16.3 16-27.7V164.3c0-11.4-6.1-22-16-27.7L239.8 44.3c-9.9-5.7-22.1-5.7-32 0L48 136.6c-9.9 5.7-16 16.3-16 27.7v184.6c0 11.4 6.1 22 16 27.7l159.8 92.3zM94.7 170.6l33.1 82.9v-76.9c0-8.8 7.2-16 16-16s16 7.2 16 16v160c0 7.7-5.4 14.3-13 15.7s-15-2.6-17.9-9.8l-33.1-82.8v76.9c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160c0-7.7 5.4-14.3 13-15.7s15 2.6 17.9 9.8zm97.1 5.9c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-160zm112-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v144c0 8.8-7.2 16-16 16s-16-7.2-16-16v-144h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalHexagonXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagonXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 288a64.158 64.158 0 0 1 0-64l92.3-159.8c11.4-19.8 32.6-32 55.4-32h184.6c22.9 0 44 12.2 55.4 32L496 224c11.4 19.8 11.4 44.2 0 64l-92.3 159.8c-11.4 19.8-32.6 32-55.4 32H163.7c-22.9 0-44-12.2-55.4-32L16 288zm27.7-48c-5.7 9.9-5.7 22.1 0 32L136 431.8c5.7 9.9 16.3 16 27.7 16h184.6c11.4 0 22-6.1 27.7-16L468.3 272c5.7-9.9 5.7-22.1 0-32L376 80.2c-5.7-9.9-16.3-16-27.7-16H163.7c-11.4 0-22 6.1-27.7 16L43.7 240zm137-59.3c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalHexagon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHexagon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 224a64.158 64.158 0 0 0 0 64l92.3 159.8c11.4 19.8 32.6 32 55.4 32h184.6c22.9 0 44-12.2 55.4-32L496 288c11.4-19.8 11.4-44.2 0-64L403.7 64.2c-11.4-19.8-32.6-32-55.4-32H163.7c-22.9 0-44 12.2-55.4 32L16 224zm27.7 48c-5.7-9.9-5.7-22.1 0-32L136 80.2c5.7-9.9 16.3-16 27.7-16h184.6c11.4 0 22 6.1 27.7 16L468.3 240c5.7 9.9 5.7 22.1 0 32L376 431.8c-5.7 9.9-16.3 16-27.7 16H163.7c-11.4 0-22-6.1-27.7-16L43.7 272z"
        }
    ]
};

const FalHighDefinition = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHighDefinition",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm256 144v160c0 8.8 7.2 16 16 16h48c53 0 96-43 96-96s-43-96-96-96h-48c-8.8 0-16 7.2-16 16zm64 16c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V192h32zm-240-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h96v64c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v64h-96v-64z"
        }
    ]
};

const FalHighlighterLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHighlighterLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M166.6 319.2 122.9 363c-3.1 3.1-3.1 8.2 0 11.3l62.8 62.8c3.1 3.1 8.2 3.1 11.3 0l43.7-43.7c6-6 14.1-9.4 22.6-9.4h48c5.2 0 10-2.5 13-6.7l19.4-27-134.1-134-27 19.4c-4.2 3-6.7 7.8-6.7 13v48c0 8.5-3.4 16.6-9.4 22.6zm196 4.8L523.8 99.5c2.7-3.8 4.2-8.4 4.2-13 0-5.9-2.4-11.6-6.5-15.8l-32.2-32.2c-4.2-4.2-9.9-6.5-15.8-6.5-4.7 0-9.2 1.5-13 4.2L236 197.4 362.6 324zm-51.3 92h-48l-43.7 43.7a39.875 39.875 0 0 1-42 9.3l-36 36c-4.5 4.5-10.6 7-17 7H24c-13.3 0-24-10.7-24-24v-4.7c0-6.4 2.5-12.5 7-17l84-84c-5.2-14.2-2.1-30.7 9.3-42l43.7-43.7v-48c0-15.5 7.4-30 20-39L441.8 10.2C451 3.6 462.1 0 473.5 0c14.4 0 28.2 5.7 38.4 15.9l32.2 32.2c10.2 10.2 15.9 24 15.9 38.4 0 11.4-3.6 22.5-10.2 31.7L350.4 396c-9 12.6-23.5 20-39 20zM111 407.6 38.6 480h82.7l31-31-41.3-41.4zM240 480h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalHighlighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHighlighter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 296.6v-48c0-5.2 2.5-10 6.7-13l27-19.4 134 134.2-19.4 27c-3 4.2-7.8 6.7-13 6.7h-48c-8.5 0-16.6 3.4-22.6 9.4L197 437.1c-3.1 3.1-8.2 3.1-11.3 0l-62.8-62.8c-3.1-3.1-3.1-8.2 0-11.3l43.7-43.7c6-6 9.4-14.1 9.4-22.6zM523.8 99.5 362.6 324 236 197.4 460.5 36.2c3.8-2.7 8.4-4.2 13-4.2 5.9 0 11.6 2.4 15.8 6.5l32.2 32.2c4.2 4.2 6.5 9.9 6.5 15.8 0 4.7-1.5 9.2-4.2 13zM263.4 416h48c15.5 0 30-7.4 39-20l199.4-277.8c6.6-9.2 10.2-20.3 10.2-31.7 0-14.4-5.7-28.2-15.9-38.4l-32.2-32.2C501.7 5.7 487.9 0 473.5 0c-11.4 0-22.5 3.6-31.7 10.2L164 209.6c-12.6 9-20 23.5-20 39v48l-43.7 43.7a39.875 39.875 0 0 0-9.3 42l-84 84c-4.5 4.5-7 10.6-7 17v4.7c0 13.3 10.7 24 24 24h100.7c6.4 0 12.5-2.5 17-7l36-36c14.2 5.2 30.7 2.1 42-9.3l43.7-43.7zm-111 33-31 31H38.6l72.4-72.4 41.4 41.4z"
        }
    ]
};

const FalHillAvalanche = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHillAvalanche",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.7 48c-24.3 0-44.5 18.2-47.5 41.8L448 394.2c17.9 17.9 46.6 18.9 65.6 2.2l4.2-3.7c19.4-17 19.6-47.2.5-64.5-14.3-12.9-35.4-14.8-51.7-4.5l-3 1.9c-7.5 4.7-17.3 2.4-22-5.1s-2.4-17.4 5.1-22.1l3-1.9c28.4-17.8 65.2-14.6 90.1 7.9 33.3 30.2 32.9 82.7-.8 112.3l-4.2 3.7c-31.7 27.8-79.5 26.2-109.3-3.6l-309-309.5c-3.3-3.3-4.9-7.8-4.7-12.2.4-43.8 36-79.2 79.9-79.2 16.9 0 32.6 5.3 45.5 14.3 14.6-9 31.9-14.3 50.3-14.3 53 0 95.9 43 95.9 96 0 4.2-.3 8.3-.8 12.4 29.1 16.5 48.7 47.7 48.7 83.6 0 21.6-7.1 41.6-19.2 57.6-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c8-10.7 12.8-24 12.8-38.4 0-27.1-16.8-50.3-40.6-59.6-7.6-3-11.8-11.3-9.6-19.2 1.5-5.4 2.3-11.2 2.3-17.2 0-35.4-28.6-64-63.9-64-15.5 0-29.7 5.5-40.7 14.7-6.3 5.3-15.6 4.9-21.5-.9-8.7-8.5-20.5-13.7-33.6-13.7zm223.5 16a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1-63.9 0zm31.9 96a31.9 31.9 0 1 1 63.9 0 31.9 31.9 0 1 1-63.9 0zM54.6 96.1l360.7 361.3c20.1 20.2 5.8 54.6-22.6 54.6H64c-35.3 0-64-28.7-64-64V118.7c0-28.5 34.5-42.8 54.6-22.6zM32 448c0 17.7 14.3 32 32 32h328.6L32 118.7V448z"
        }
    ]
};

const FalHillRockslide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHillRockslide",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M238.5 127.7c-5.5-9.7-5.5-21.6 0-31.4l27-48c5.6-10.1 16.3-16.3 27.9-16.3h53.3c11.6 0 22.2 6.2 27.9 16.3l27 48c5.5 9.7 5.5 21.6 0 31.4l-27 48c-5.7 10.1-16.3 16.3-27.9 16.3h-53.3c-11.6 0-22.2-6.2-27.9-16.3l-27-48zM293.4 64l-27 48 27 48h53.3l27-48-27-48h-53.3zM32 118.6V448c0 17.7 14.3 32 32 32h329.4L32 118.6zm-32 0C0 90.1 34.5 75.8 54.6 96L416 457.4c20.2 20.2 5.9 54.6-22.6 54.6H64c-35.3 0-64-28.7-64-64V118.6zm432.3 287.9c-10.1-5.7-16.3-16.3-16.3-27.9v-53.2c0-11.6 6.2-22.2 16.3-27.9l48-27c9.7-5.5 21.6-5.5 31.4 0l48 27c10.1 5.7 16.3 16.3 16.3 27.9v53.3c0 11.6-6.2 22.2-16.3 27.9l-48 27c-9.7 5.5-21.6 5.5-31.4 0l-48-27zm63.7-.9 48-27v-53.2l-48-27-48 27v53.3l48 27zM128 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm224 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FalHippo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHippo",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M427.3 44.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l12.1 12.1c-4.4 3.2-8.4 6.8-12 10.8l-22.8-9C353.6 69.8 323.4 64 292.9 64H224C118 64 32 150 32 256v27.1c0 25.4-8.7 50.1-24.5 70l-4 4.9C-2 364.9-.9 375 6 380.5s17 4.4 22.5-2.5l3.9-4.9c20.4-25.5 31.6-57.3 31.6-90V256c0-88.4 71.6-160 160-160h68.9c26.5 0 52.7 5 77.2 14.9l18.2 7.3c-2.8 8.1-4.3 16.8-4.3 25.9v5c0 9.5-4.5 18.4-10.8 25.6C360 190.1 352 210.1 352 232c0 45.9 35.1 83.6 80 87.6V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h88c2.7 0 5.4-.1 8-.4V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-25.6c28.5-14.6 48-44.2 48-78.4 0-30.8-15.8-57.8-39.7-73.6-4.9-3.2-8.3-8.5-8.3-14.4 0-22.4-9.2-42.7-24.1-57.3l11.4-11.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16.5 16.4c-8.7-3.3-18.3-5.1-28.2-5.1h-48c-5.4 0-10.7.5-15.8 1.6l-20.9-20.9zM448 288h-8c-30.9 0-56-25.1-56-56 0-14 5.1-26.7 13.5-36.5 9.2-10.7 18.5-26.7 18.5-46.5v-5c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48 0 13.4 5.5 24.7 13.2 33-25.7 5.1-45.2 27.7-45.2 55 0 8.8 7.2 16 16 16s16-7.2 16-16c0-13.3 10.7-24 24-24s24 10.7 24 24c0 30.9-25.1 56-56 56H448zm-32 83.8V424c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24v-60.1c0-5.1-2.4-9.9-6.5-12.9s-9.4-3.9-14.3-2.4l-11.3 3.6c-31.2 9.8-64.6 9.8-95.8 0l-11.3-3.6c-4.9-1.5-10.2-.6-14.3 2.4s-6.5 7.8-6.5 12.9V424c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24v-72c0-8.8-7.2-16-16-16s-16 7.2-16 16v72c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56v-38.6c31.5 8.1 64.5 8.1 96 0V424c0 30.9 25.1 56 56 56h32c30.9 0 56-25.1 56-56v-40c-12.3 0-23.5-4.6-32-12.2zM480 144a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-40 32c-8.8 0-16 7.2-16 16s7.2 16 16 16c13.3 0 24 10.7 24 24 0 8.8 7.2 16 16 16s16-7.2 16-16c0-30.9-25.1-56-56-56zm88-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalHockeyMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHockeyMask",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 240c0-59.7 14.9-111.7 44.7-148.1C105.8 56.5 152.1 32 224 32s118.2 24.5 147.3 59.9C401.1 128.3 416 180.3 416 240c0 95.4-12.4 153.6-39.3 188.4C351.6 460.9 308 480 224 480S96.4 460.9 71.3 428.4C44.4 393.6 32 335.4 32 240zM224 0C64 0 0 111 0 240c0 192 48 272 224 272s224-80 224-272C448 111 384 0 224 0zm-64 208c0 17.7-14.3 32-32 32s-32-14.3-32-32v-16h64v16zm-32 64c35.3 0 64-28.7 64-64v-16c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v16c0 35.3 28.7 64 64 64zm192-32c-17.7 0-32-14.3-32-32v-16h64v16c0 17.7-14.3 32-32 32zm64-32v-16c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v16c0 35.3 28.7 64 64 64s64-28.7 64-64zm-208-96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-32 160a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm0 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm32-224a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalHockeyPuck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHockeyPuck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 184c0 9 4.1 18.9 14.3 29.3 10.2 10.5 25.8 20.7 46.3 29.6 41 17.8 98.7 29.1 163.3 29.1s122.4-11.4 163.3-29.1c20.5-8.9 36.1-19.1 46.3-29.6C475.9 202.9 480 193 480 184s-4.1-18.9-14.3-29.3c-10.2-10.5-25.8-20.7-46.3-29.6C378.4 107.4 320.6 96 256 96s-122.4 11.4-163.3 29.1c-20.5 8.9-36.1 19.1-46.3 29.6C36.1 165.1 32 175 32 184zm-32 0c0-19.7 9.3-37.2 23.4-51.7 14.1-14.4 33.6-26.6 56.5-36.5C125.8 75.9 188.1 64 256 64s130.2 11.9 176.1 31.8c22.9 9.9 42.5 22.2 56.5 36.6 14.1 14.5 23.4 32 23.4 51.7V328c0 19.7-9.3 37.2-23.4 51.7-14.1 14.4-33.6 26.6-56.5 36.6C386.2 436.1 323.9 448 256 448s-130.2-11.9-176.1-31.8C57 406.3 37.4 394 23.4 379.6 9.3 365.2 0 347.7 0 328V184zm480 59.6c-13 11-29.4 20.6-47.9 28.6C386.2 292.1 323.9 304 256 304s-130.2-11.9-176.1-31.8c-18.6-8-34.9-17.6-47.9-28.6V328c0 9 4.1 18.9 14.3 29.3 10.2 10.5 25.8 20.7 46.3 29.6 41 17.8 98.7 29.1 163.3 29.1s122.4-11.4 163.3-29.1c20.5-8.9 36.1-19.1 46.3-29.6C475.9 346.9 480 337 480 328v-84.4z"
        }
    ]
};

const FalHockeyStickPuck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHockeyStickPuck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M503.3 1.8c7.8 4.1 10.9 13.7 6.9 21.6l-234.6 454c-11 21.3-32.9 34.6-56.9 34.6H56c-30.9 0-56-25.1-56-56v-80c0-30.9 25.1-56 56-56h264.9L481.8 8.7c4.1-7.9 13.7-10.9 21.6-6.9zM304.4 352H128v128h90.8c12 0 22.9-6.7 28.4-17.3L304.4 352zM56 352c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h40V352H56zm376 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16H432zm-48 16c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v16c0 26.5-21.5 48-48 48H432c-26.5 0-48-21.5-48-48v-16z"
        }
    ]
};

const FalHockeySticks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHockeySticks",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M301.4 288h-34.9L129.8 23.3c-4.1-7.9-1-17.5 6.9-21.6s17.5-1 21.6 6.9L302 286.9l-.6 1.1zm75 64 16.6-32h191c30.9 0 56 25.1 56 56v80c0 30.9-25.1 56-56 56H421.2c-23.9 0-45.9-13.4-56.9-34.6l-26.4-51 18-34.9 36.8 71.2c5.5 10.6 16.5 17.3 28.4 17.3H512V352H376.4zm167.6 0v128h40c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-40zM503.3 1.8c7.8 4.1 10.9 13.7 6.9 21.6l-234.6 454c-11 21.3-32.9 34.6-56.9 34.6H56c-30.9 0-56-25.1-56-56v-80c0-30.9 25.1-56 56-56h264.9L481.8 8.7c4.1-7.9 13.7-10.9 21.6-6.9zM304.4 352H128v128h90.8c12 0 22.9-6.7 28.4-17.3L304.4 352zM56 352c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h40V352H56z"
        }
    ]
};

const FalHollyBerry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHollyBerry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 64a32 32 0 1 1-64 0 32 32 0 1 1 64 0zM256 0a64 64 0 1 0 0 128 64 64 0 1 0 0-128zM128 289.3v-20.9l2.3.8c24 8 49.8 8.7 74.2 2.1l5.9-1.6-1.6 5.9c-6.6 24.4-5.9 50.2 2.1 74.2l1 2.9c-47.3 5.3-83.9 45.4-83.9 94v20.9l-2.3-.8c-24-8-49.8-8.7-74.2-2.1l-5.9 1.6 1.6-5.9c6.6-24.4 5.9-50.2-2.1-74.2l-1-2.9c47.3-5.3 83.9-45.4 83.9-94zm-12.4 207.9 12.8 4.3c15.5 5.2 31.6-6.4 31.6-22.8v-32c0-34.6 28.1-62.7 62.7-62.7 16.4 0 27.9-16 22.8-31.6l-4.3-12.8c-6-18-6.5-37.3-1.5-55.6l5.3-19.4c4.9-17.9-11.6-34.4-29.5-29.5l-19.5 5.3c-18.3 5-37.6 4.4-55.6-1.5l-12.8-4.3C112.1 229.4 96 241 96 257.4v32c0 34.5-28.1 62.6-62.7 62.6-16.4 0-27.9 16-22.8 31.6l4.3 12.8c6 18 6.5 37.3 1.5 55.6L11 471.4c-4.9 17.9 11.6 34.4 29.5 29.5l19.5-5.3c18.3-5 37.6-4.5 55.6 1.5zm46-415.6c-28.4 6.5-49.6 32-49.6 62.4 0 35.3 28.7 64 64 64 30.4 0 55.8-21.2 62.4-49.6-10.9-2-21.2-5.9-30.5-11.3-1.6 16.2-15.3 28.9-31.9 28.9-17.7 0-32-14.3-32-32 0-16.6 12.7-30.3 28.9-31.9-5.4-9.3-9.3-19.6-11.3-30.5zm112 76.8c6.5 28.4 32 49.6 62.4 49.6 35.3 0 64-28.7 64-64 0-30.4-21.2-55.8-49.6-62.4-2 10.9-5.9 21.2-11.3 30.5 16.2 1.5 28.9 15.2 28.9 31.9 0 17.7-14.3 32-32 32-16.6 0-30.3-12.7-31.9-28.9-9.3 5.4-19.6 9.3-30.5 11.3zM384 289.3c0 48.6 36.6 88.7 83.8 94.1l-1 2.9c-8 24-8.7 49.8-2.1 74.2l1.6 5.9-5.9-1.6c-24.4-6.6-50.2-5.9-74.2 2.1l-2.3.8v-20.9c0-48.6-36.6-88.7-83.8-94.1l1-2.9c8-24 8.7-49.8 2.1-74.2l-1.6-5.9 5.9 1.6c24.4 6.6 50.2 5.9 74.2-2.1l2.3-.8v20.9zm12.4 207.9c18-6 37.3-6.5 55.6-1.5l19.4 5.3c17.9 4.9 34.4-11.6 29.5-29.5l-5.2-19.5c-5-18.3-4.5-37.6 1.5-55.6l4.3-12.8c5.2-15.5-6.4-31.6-22.8-31.6-34.6 0-62.7-28.1-62.7-62.7v-32c0-16.4-16-27.9-31.6-22.8l-12.8 4.3c-18 6-37.3 6.5-55.6 1.5l-19.4-5.3c-17.9-4.9-34.4 11.6-29.5 29.5l5.3 19.4c5 18.3 4.4 37.6-1.5 55.6l-4.3 12.8c-5.2 15.5 6.4 31.6 22.8 31.6 34.6 0 62.7 28.1 62.7 62.7v32c0 16.4 16 27.9 31.6 22.8l12.8-4.3z"
        }
    ]
};

const FalHoneyPot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHoneyPot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64h32v80c0 8.8 7.2 16 16 16s16-7.2 16-16V64h176c8.8 0 16 7.2 16 16s-7.2 16-16 16H224v32h96c53 0 96 43 96 96H32c0-53 43-96 96-96V96H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h48zm319.8 173.2c.2-4.3.2-8.7.2-13.2 0-42.9-21.1-80.8-53.4-104 12.9-8.6 21.4-23.3 21.4-40 0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48 0 16.7 8.5 31.4 21.4 40C21.1 143.2 0 181.1 0 224c0 4.5.1 8.9.2 13.2-.1.9-.2 1.8-.2 2.8 0 1.5.2 2.9.6 4.3 7.2 126.3 80.7 199 112.7 224.9 9.3 7.5 21.1 10.9 33.1 10.9h155.2c12 0 23.7-3.3 33.1-10.9 32-25.9 105.5-98.6 112.7-224.9.4-1.4.6-2.8.6-4.3 0-1-.1-1.9-.2-2.8zM414.4 256c-2.4 23.5-7.3 44.9-13.9 64h-353C41 300.9 36 279.5 33.6 256h380.8zm-27.1 96c-23.4 47.9-55.2 78.1-72.7 92.3-2.5 2-6.7 3.7-12.9 3.7H146.4c-6.3 0-10.5-1.7-12.9-3.7-17.5-14.1-49.4-44.4-72.7-92.3h326.5z"
        }
    ]
};

const FalHoodCloak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHoodCloak",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m32 480 .4-.4.2-.2.1-.1C81.7 427 96 348.2 96 288c0-128 44-192 90-224s94-32 102-32h124.6c-1.2 1-2.7 2.2-4.2 3.5-4.4 3.6-9.8 8-13.7 11.6-6.7 6.1-10.5 14.7-10.5 23.8s3.9 17.7 10.6 23.7c44 39.6 85.2 101.2 85.2 193.4 0 60.2 14.3 139 63.3 191.3l.1.1.6.6H416V320c0-70.7-57.3-128-128-128s-128 57.3-128 128v160H32zm160 0V320c0-53 43-96 96-96s96 43 96 96v160H192zm381.6 12.2c4.9-11.9 2.2-25.6-6.8-34.7l-.1-.1C525.8 413.8 512 345 512 288c0-87-33.1-150.3-73.1-194.6-7.4-8.2-15-15.7-22.7-22.6 3.5-3.2 7.4-6.3 11.3-9.5 4.5-3.7 9.1-7.4 13.3-11.4 4-3.7 7.7-7.7 10.7-11.9 4.7-6.5 5.9-15 2.9-22.7C450.8 6.1 441.9 0 432 0H288c-9.8 0-66 0-120.3 37.7C111.4 76.9 64 151.8 64 288c0 57.1-13.9 125.9-54.6 169.4l-.2.2c-9 9.1-11.7 22.8-6.8 34.7 5 12 16.6 19.8 29.6 19.8h512c12.9 0 24.6-7.8 29.6-19.8z"
        }
    ]
};

const FalHorizontalRule = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHorizontalRule",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0-8.8 7.2-16 16-16h608c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalHorseHead = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHorseHead",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M404 40.2c13.7-4.8 28 5.4 28 19.9 0 7-3.5 13.6-9.4 17.5l-31.5 21c-5.3 3.5-8 9.8-6.9 16s5.7 11.3 11.9 12.8l7 1.8c32.1 8 59.4 28.9 75.6 57.8l54.4 97.2c13.9 24.9 10.6 55.9-8.4 77.2a66.953 66.953 0 0 1-50.1 22.5H467c-22.2 0-43.2-10.3-56.8-27.8l-26-33.5c-7.4-9.5-21.1-11.2-30.6-3.8-31.5 24.5-76.6 20.7-103.5-8.7l-30.3-33c-6-6.5-16.1-7-22.6-1s-7 16.1-1 22.6l30.3 33c22.3 24.3 53.2 36.3 84 35.2.2.6.5 1.2.8 1.7l35.9 66.4c3.1 5.8 4.8 12.3 4.8 18.9 0 14.3-11.6 25.9-25.9 25.9H128c-17.7 0-32-14.3-32-32V318c0-102.2 64.7-193.1 161.2-226.7L404 40.2zM375.4 420l-32-59.3c7.4-2.7 14.7-6.2 21.6-10.6l20 25.8c19.7 25.3 50 40.2 82.1 40.2h7.7c28.3 0 55.2-12.1 74-33.2 28-31.5 33-77.3 12.4-114.1l-54.4-97.2c-16-28.7-40.8-51.1-70.4-64.4l4.1-2.7c14.6-10 23.5-26.6 23.5-44.3C464 23.6 428-2 393.5 10L246.6 61.1C137.3 99.1 64 202.2 64 318v130c0 35.3 28.7 64 64 64h198.1c32 0 57.9-25.9 57.9-57.9 0-11.9-3-23.7-8.6-34.2zM400 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalHorseSaddle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHorseSaddle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 144c0-61.9 50.1-112 112-112h37.8c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1h-32c-8.8 0-16 7.2-16 16v52.8c-.3 1.5-.4 3-.3 4.5.2 2.2.3 4.4.3 6.7 0 24-10.4 45.1-26.7 59.6-3.4 3-5.3 7.4-5.3 11.9V472c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8V334.7c0-7.8-5.6-14.5-13.3-15.8-1.4-.2-2.8-.5-4.3-.8L256 304v-49.3c45.4-7.6 80-47.1 80-94.7v-16zm-96 80c-35.3 0-64-28.7-64-64h128c0 35.3-28.7 64-64 64zm-16 30.7v42.1l-21.8-4.9c-5.2-1.2-10.6.3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7 0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1h-33.3c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9 0-4.6-.9-9.3-2.7-13.5l-33.3-80.1c-2.6-6.2-3.9-12.8-3.9-19.5 0-27.1 21.3-49.2 48-50.6 0 47.5 34.6 87 80 94.6zM192 128h-45.3c-33.5 0-62.3 19.9-75.3 48.5C31.3 180.8 0 214.7 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-20.9 13.4-38.7 32-45.3 0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2.4.2.8.2 1.2 0 .4-.1.9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3h33.2c26.5 0 45.6-25.2 38.5-50.7L197.4 404c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4l88.2 19.9V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V318.4c19.6-20 32-47.5 32-78.4 0-1.9-.1-3.9-.1-5.8.1-.7.1-1.4.1-2.2v-40h7.4l1.7 2.5c19 28.6 57.4 36.8 86.5 18.6 20.4-12.7 31.8-35.9 29.6-59.9l-7.7-80.8c-1.5-15.5-7.3-29.7-16.3-41.3C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16h-96c-74.1 0-135.2 56-143.1 128H192zm304-32a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalHorse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHorse",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 144c0 8.8-7.2 16-16 16H146.7c-28 0-50.7 22.7-50.7 50.7 0 6.7 1.3 13.3 3.9 19.5l33.4 80.1c1.8 4.3 2.7 8.9 2.7 13.5 0 4.8-1 9.5-2.8 13.9l-8.1 19c-9.3 21.7-10.9 46-4.6 68.8l13.5 48.6c1 3.5 4.1 5.9 7.7 5.9h33.2c5.3 0 9.1-5 7.7-10.1l-15.9-57.2c-3.4-12.3-2.5-25.3 2.5-37l8.1-19c4.4-10.4 6.7-21.5 6.7-32.8 0-4.6-.4-9.2-1.1-13.7-.9-5.3.9-10.6 4.8-14.3s9.3-5.2 14.5-4L318.4 318c1.4.3 2.8.6 4.3.8 7.7 1.3 13.3 8 13.3 15.8V472c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V311.6c0-4.6 1.9-8.9 5.3-11.9C405.6 285.1 416 264 416 240c0-2.3-.1-4.5-.3-6.7-.1-1.5 0-3.1.3-4.5V176c0-8.8 7.2-16 16-16h32c5.4 0 10.3 2.7 13.3 7.1l6.4 9.6c9.4 14.2 28.5 18.3 42.9 9.2 10.1-6.3 15.8-17.8 14.7-29.7l-7.7-80.8c-2.3-24.6-23-43.4-47.8-43.4H448c-61.9 0-112 50.1-112 112zM549.2 31.1c8.9 11.6 14.8 25.7 16.3 41.3l7.7 80.8c2.3 23.9-9.2 47.1-29.6 59.9-29.1 18.2-67.4 10-86.5-18.6l-1.7-2.5H448v40c0 .7-.1 1.5-.1 2.2.1 1.9.1 3.9.1 5.8 0 30.9-12.4 58.4-32 78.4V472c0 22.1-17.9 40-40 40h-32c-22.1 0-40-17.9-40-40V347.6l-88.1-19.8c-.5 14.3-3.6 28.3-9.2 41.4l-8.1 19c-2.2 5-2.5 10.6-1.1 15.9l15.9 57.2c7.1 25.5-12.1 50.7-38.5 50.7h-33.3c-18 0-33.7-12-38.5-29.3l-13.5-48.6c-8.3-29.8-6.2-61.5 6-90l8.1-19c.2-.4.3-.8.3-1.3 0-.4-.1-.8-.2-1.2l-33.4-80.1c-4.2-10.1-6.4-20.8-6.4-31.7-18.6 6.6-32 24.4-32 45.3v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-41.3 31.3-75.2 71.4-79.5 13-28.6 41.8-48.5 75.3-48.5h158.2c8-72 69-128 143.1-128h96c8.8 0 16 7.2 16 16 0 7-4.5 13-10.8 15.1zM464 96a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalHoseReel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHoseReel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 256C96 132.3 196.3 32 320 32s224 100.3 224 224v96h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h1.9l12 96.1c-7.8 1-13.9 7.7-13.9 15.9 0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16 0-8.1-6.1-14.8-13.9-15.9l12-96.1h1.9c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-96C576 114.6 461.4 0 320 0S64 114.6 64 256s114.6 256 256 256c57.6 0 110.8-19 153.6-51.2 7.1-5.3 8.5-15.3 3.2-22.4s-15.3-8.5-22.4-3.2C417 463.3 370.4 480 320 480 196.3 480 96 379.7 96 256zm477.9 128-12 96h-3.8l-12-96h27.8zM464 256a144 144 0 1 1-288 0 144 144 0 1 1 288 0zM320 80a176 176 0 1 0 0 352 176 176 0 1 0 0-352zm0 240a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0-192 0z"
        }
    ]
};

const FalHose = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHose",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 112c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.9l96.1-12c1 7.8 7.7 13.9 15.9 13.9 8.8 0 16-7.2 16-16V32c0-8.8-7.2-16-16-16-8.1 0-14.8 6.1-15.9 13.9l-96.1-12V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zm32-61.9 96 12v3.8l-96 12V50.1zM48 448h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-35.8-16C4.6 440.5 0 451.7 0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48 0-12.3-4.6-23.5-12.2-32 7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32s-4.6-23.5-12.2-32c7.6-8.5 12.2-19.7 12.2-32 0-26.5-21.5-48-48-48H152c-30.9 0-56-25.1-56-56s25.1-56 56-56h104V80H152c-48.6 0-88 39.4-88 88s39.4 88 88 88h248c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-66.3 0-120-53.7-120-120S85.7 48 152 48h104V16H152C68.1 16 0 84.1 0 168c0 48.8 23 92.2 58.7 120H48c-26.5 0-48 21.5-48 48 0 12.3 4.6 23.5 12.2 32C4.6 376.5 0 387.7 0 400s4.6 23.5 12.2 32zM152 320h248c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h104zM48 384h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalHospitalUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHospitalUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h192c3.2 0 6.4-.2 9.5-.7-5.5-9.2-8.9-19.9-9.4-31.3H64c-17.7 0-32-14.3-32-32v-32h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-64h112c8.8 0 16-7.2 16-16s-7.2-16-16-16H32V64c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v329.4c9.2-10.2 20-18.9 32-25.6V64c0-35.3-28.7-64-64-64H64zm80 80c-13.3 0-24 10.7-24 24v16h-16c-13.3 0-24 10.7-24 24v32c0 13.3 10.7 24 24 24h16v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16h16c13.3 0 24-10.7 24-24v-32c0-13.3-10.7-24-24-24h-16v-16c0-13.3-10.7-24-24-24h-32zm8 56v-24h16v24c0 8.8 7.2 16 16 16h24v16h-24c-8.8 0-16 7.2-16 16v24h-16v-24c0-8.8-7.2-16-16-16h-24v-16h24c8.8 0 16-7.2 16-16zm232 136a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM320 477.1c0-33.7 27.4-61.1 61.1-61.1h101.8c33.7 0 61.1 27.4 61.1 61.1 0 1.6-1.3 2.9-2.9 2.9H322.9c-1.6 0-2.9-1.3-2.9-2.9zm61.1-93.1c-51.4 0-93.1 41.7-93.1 93.1 0 19.3 15.6 34.9 34.9 34.9h218.2c19.3 0 34.9-15.6 34.9-34.9 0-51.4-41.7-93.1-93.1-93.1H381.1z"
        }
    ]
};

const FalHospital = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHospital",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v32h96c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h96V64zm320 272v144h96c17.7 0 32-14.3 32-32V320h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-64h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-32c0-17.7-14.3-32-32-32h-96v208zM160 128H64c-17.7 0-32 14.3-32 32v32h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v64h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H32v128c0 17.7 14.3 32 32 32h96V128zm288 208V64c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v416h64v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v64h64V336zm-96 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64v-64zM304 64h32c13.3 0 24 10.7 24 24v16h16c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24h-16v16c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24v-16h-16c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h16V88c0-13.3 10.7-24 24-24zm8 56c0 8.8-7.2 16-16 16h-24v16h24c8.8 0 16 7.2 16 16v24h16v-24c0-8.8 7.2-16 16-16h24v-16h-24c-8.8 0-16-7.2-16-16V96h-16v24z"
        }
    ]
};

const FalHospitals = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHospitals",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32H320c-17.7 0-32 14.3-32 32v16c-9.3-7-20.2-12-32-14.4V64c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H320c-5.1 0-10-.6-14.7-1.7 6.3-8.9 10.9-19.2 13.2-30.3H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32zm-288 96H64c-17.7 0-32 14.3-32 32v192h224V160c0-17.7-14.3-32-32-32zM32 448c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-64H32v64zM64 96h160c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64zm256 224v-32h224v32H320zm0 96v-32h224v32H320zM136 176h16c4.4 0 8 3.6 8 8v40h40c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-40v40c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-40H88c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h40v-40c0-4.4 3.6-8 8-8zm280-88c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v40h40c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-40v40c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-40h-40c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h40V88z"
        }
    ]
};

const FalHotTubPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHotTubPerson",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c-8.8 0-16 7.2-16 16 0 35.3 17.7 68.3 47.1 87.9l16.1 10.7c20.5 13.8 32.8 36.8 32.8 61.4 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9l-16.1-10.8C268.3 63.6 256 40.6 256 16c0-8.8-7.2-16-16-16zM32 336v-48h240c.5 0 1 0 1.6-.1 1.3 0 2.5.1 3.8.1H448c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336zm170.7-80H32c0-35.3 28.7-64 64-64 13.8 0 27.3 4.5 38.4 12.8l68.3 51.2zM0 272v176c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v16zM384 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7c20.5 13.8 32.8 36.8 32.8 61.4 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9l-16.1-10.8C396.3 63.6 384 40.6 384 16zM112 336c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16zM32 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0A64 64 0 1 0 0 64a64 64 0 1 0 128 0z"
        }
    ]
};

const FalHotdog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHotdog",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m458.9 154.9-304 304c-28.1 28.1-73.7 28.1-101.8 0s-28.1-73.7 0-101.8l304-304c28.1-28.1 73.7-28.1 101.8 0s28.1 73.7 0 101.8zm22.6 22.6c40.6-40.6 40.6-106.5 0-147.1s-106.5-40.6-147.1 0l-304 304c-40.6 40.6-40.6 106.5 0 147.1s106.5 40.6 147.1 0l304-304zm-70.2-60.9c-6.2-6.2-16.4-6.2-22.6 0-7 7-12.5 10.8-17 13.1-4.5 2.3-8.5 3.4-13.6 4.7l-1.5.4c-4.7 1.2-10.9 2.7-17.3 5.6-7.4 3.4-14.8 8.4-22.7 16.3-16.2 16.2-20.5 30.7-24 42.7v.1c-3.1 10.6-5.5 18.8-16 29.2-5.5 5.5-9.5 7.8-12.4 9.1-3 1.3-5.8 1.7-10.6 2.4l-.4.1c-4.6.6-10.9 1.6-18 4.5-7.4 3.1-14.8 8.1-22.6 15.9-16.2 16.2-20.5 30.7-24 42.7v.1c-3.1 10.6-5.5 18.8-16 29.2-5.5 5.5-9.7 8.1-13.3 9.8-3.6 1.6-6.9 2.5-12 3.7l-1.2.3c-5.6 1.4-12.6 3.2-20.4 7.3-7.9 4-16 9.9-25 18.9-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0c7-7 12.5-10.8 17-13.1 4.5-2.3 8.5-3.4 13.6-4.7l1.5-.4c4.7-1.2 10.9-2.7 17.3-5.6 7.4-3.4 14.8-8.4 22.7-16.3 16.2-16.2 20.5-30.7 24-42.7v-.1c3.1-10.6 5.5-18.8 16-29.2 5.5-5.5 9.5-7.8 12.4-9.1 3-1.3 5.8-1.7 10.6-2.4l.4-.1c4.6-.6 10.9-1.6 18-4.5 7.4-3.1 14.8-8.1 22.6-15.9 16.2-16.2 20.5-30.7 24-42.7v-.1c3.1-10.6 5.5-18.8 16-29.2 5.5-5.5 9.7-8.1 13.3-9.8 3.6-1.6 6.9-2.5 12-3.7l1.2-.3c5.6-1.4 12.6-3.2 20.4-7.3 7.9-4 16-9.9 25-18.9 6.2-6.2 6.2-16.4 0-22.6zM264 0c-15.4 0-30.1 6.1-41 17L17 223C6.1 233.9 0 248.6 0 264c0 14.8 5.7 29.1 15.8 39.8l22.6-22.6c-4.1-4.8-6.4-10.9-6.4-17.2 0-6.9 2.7-13.5 7.6-18.3l-22.4-22.5 22.4 22.4 206.1-206c4.9-4.9 11.5-7.6 18.3-7.6 6.3 0 12.4 2.3 17.2 6.5l22.6-22.6C293.1 5.7 278.8 0 264 0zm-55.8 496.2c10.7 10.2 25 15.8 39.8 15.8 15.4 0 30.1-6.1 41-17l206-206c10.9-10.9 17-25.6 17-41 0-14.8-5.7-29.1-15.8-39.8l-22.6 22.6c4.2 4.7 6.5 10.8 6.5 17.2 0 6.9-2.7 13.5-7.6 18.3L266.3 472.4c-4.9 4.9-11.5 7.6-18.3 7.6-6.3 0-12.4-2.3-17.2-6.5l-22.6 22.6z"
        }
    ]
};

const FalHotel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHotel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h16v448H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm256 432v48h-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16zm32 0c0-26.5-21.5-48-48-48s-48 21.5-48 48v48H64V32h384v448H304v-48zm16-336v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32V96h32zM240 64c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-32zm0 32h32v32h-32V96zm-32 128v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32v-32h32zm80-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v32h-32v-32zM96 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32V96h32zm-32 96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v32h-32v-32zm68.4 154.7C211 362.3 232.3 352 256 352s45 10.3 59.6 26.7c5.9 6.6 16 7.1 22.6 1.3s7.1-16 1.3-22.6C319 334.4 289.2 320 256 320s-63 14.4-83.5 37.3c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3z"
        }
    ]
};

const FalHourglassClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHourglassClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-44.7c0-31.6 10.4-62.4 29.6-87.5l70.3-91.8-70.3-91.9C42.4 139 32 108.3 32 76.7V32H16C7.2 32 0 24.8 0 16S7.2 0 16 0h352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v44.7c0 31.6-10.4 62.4-29.6 87.5L252.1 256l23.6 30.9c-5.7 11-10.3 22.7-13.6 34.9l-42.8-56c-4.4-5.7-4.4-13.7 0-19.4L297 144.7c14.9-19.5 23-43.4 23-68V32H64v44.7c0 24.6 8.1 48.5 23 68l77.7 101.6c4.4 5.7 4.4 13.7 0 19.4L87 367.3c-14.9 19.5-23 43.4-23 68V480h232.2c10 12.1 21.7 22.9 34.6 32H16zm176-96h70.6c3.2 11.2 7.4 21.9 12.6 32H112c-6 0-11.5-3.4-14.2-8.7s-2.3-11.7 1.2-16.6l80-112c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3L143.1 416H192zm0-208c-4.9 0-9.5-2.2-12.5-6l-64-80c-3.8-4.8-4.6-11.4-1.9-16.9S121.9 96 128 96h128c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-64 80c-3 3.8-7.6 6-12.5 6zm-30.7-80 30.7 38.4 30.7-38.4h-61.4zM432 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalHourglassEnd = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHourglassEnd",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v44.7c0 31.6-10.4 62.4-29.6 87.5L252.1 256l70.2 91.9c19.3 25.1 29.7 55.8 29.7 87.4V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-44.7c0-31.6 10.4-62.4 29.6-87.5l70.3-91.8-70.3-91.9C42.4 139 32 108.3 32 76.7V32H16C7.2 32 0 24.8 0 16zm64 16v44.7c0 24.6 8.1 48.5 23 68l77.7 101.6c4.4 5.7 4.4 13.7 0 19.4L87 367.3c-14.9 19.5-23 43.4-23 68V480h256v-44.7c0-24.6-8.1-48.5-23-68l-77.7-101.6c-4.4-5.7-4.4-13.7 0-19.4L297 144.7c14.9-19.5 23-43.4 23-68V32H64zm141 278.7 80 112c3.5 4.9 3.9 11.3 1.2 16.6S278 448 272 448H112c-6 0-11.5-3.4-14.2-8.7s-2.3-11.7 1.2-16.6l80-112c3-4.2 7.9-6.7 13-6.7s10 2.5 13 6.7zM192 416h48.9L192 347.5 143.1 416H192z"
        }
    ]
};

const FalHourglassHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHourglassHalf",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-44.7c0-31.6 10.4-62.4 29.6-87.5l70.3-91.8-70.3-91.9C42.4 139 32 108.3 32 76.7V32H16C7.2 32 0 24.8 0 16S7.2 0 16 0h352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v44.7c0 31.6-10.4 62.4-29.6 87.5L252.1 256l70.2 91.9c19.3 25.1 29.7 55.8 29.7 87.4V480h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16zm304-32v-44.7c0-24.6-8.1-48.5-23-68l-77.7-101.6c-4.4-5.7-4.4-13.7 0-19.4L297 144.7c14.9-19.5 23-43.4 23-68V32H64v44.7c0 24.6 8.1 48.5 23 68l77.7 101.6c4.4 5.7 4.4 13.7 0 19.4L87 367.3c-14.9 19.5-23 43.4-23 68V480h256zM192 208c-4.9 0-9.5-2.2-12.5-6l-64-80c-3.8-4.8-4.6-11.4-1.9-16.9S121.9 96 128 96h128c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-64 80c-3 3.8-7.6 6-12.5 6zm-30.7-80 30.7 38.4 30.7-38.4h-61.4zM144 352h96c6.1 0 11.6 3.4 14.3 8.8l32 64c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H112c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l32-64c2.7-5.4 8.3-8.8 14.3-8.8zm-6.1 64h108.2l-16-32h-76.2l-16 32z"
        }
    ]
};

const FalHourglassStart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHourglassStart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 496c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-44.7c0-31.6-10.4-62.4-29.6-87.5L252.1 256l70.2-91.9C341.6 139 352 108.3 352 76.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 0 0 7.2 0 16s7.2 16 16 16h16v44.7c0 31.6 10.4 62.4 29.6 87.5l70.3 91.8-70.3 91.9C42.4 373 32 403.7 32 435.3V480H16c-8.8 0-16 7.2-16 16zm64-16v-44.7c0-24.6 8.1-48.5 23-68l77.7-101.6c4.4-5.7 4.4-13.7 0-19.4L87 144.7c-14.9-19.5-23-43.4-23-68V32h256v44.7c0 24.6-8.1 48.5-23 68l-77.7 101.6c-4.4 5.7-4.4 13.7 0 19.4L297 367.3c14.9 19.5 23 43.4 23 68V480H64zm141-278.7 80-112c3.5-4.9 3.9-11.3 1.2-16.6S278 64 272 64H112c-6 0-11.5 3.3-14.2 8.7S95.5 84.4 99 89.3l80 112c3 4.2 7.9 6.7 13 6.7s10-2.5 13-6.7zM192 96h48.9L192 164.5 143.1 96H192z"
        }
    ]
};

const FalHourglass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHourglass",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h16v44.7c0 31.6 10.4 62.4 29.6 87.5l70.3 91.8-70.3 91.9C42.4 373 32 403.7 32 435.3V480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-44.7c0-31.6-10.4-62.4-29.6-87.5L252.1 256l70.2-91.9C341.6 139 352 108.3 352 76.7V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm304 32v44.7c0 24.6-8.1 48.5-23 68l-77.7 101.6c-4.4 5.7-4.4 13.7 0 19.4L297 367.3c14.9 19.5 23 43.4 23 68V480H64v-44.7c0-24.6 8.1-48.5 23-68l77.7-101.6c4.4-5.7 4.4-13.7 0-19.4L87 144.7c-14.9-19.5-23-43.4-23-68V32h256z"
        }
    ]
};

const FalHouseBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseBlank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0l272 240c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235v197c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM96 206.7V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7z"
        }
    ]
};

const FalHouseBuilding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseBuilding",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32h256c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32H414.4c-2.4 11.8-7.4 22.7-14.4 32h176c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H320c-35.3 0-64 28.7-64 64v31.3l32 29.3V64c0-17.7 14.3-32 32-32zm176 176c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v32h-32v-32zm-32 128v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32v-32h32zM368 80c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v32h-32v-32zm96 0v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32v-32h32zM32 284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V284.2zM0 448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237C7.5 249.1 0 266.2 0 284.2V448zm224-160v64h-64v-64h64zm-64-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64z"
        }
    ]
};

const FalHouseChimneyBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseChimneyBlank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L512 192.3V56c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24v23.4L298.6 4zM416 107.6V64h64v100.1l-64-56.5zM96 432V206.7L288 37.3l192 169.4V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FalHouseChimneyCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseChimneyCrack",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v136.3l58.6 51.7c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235v197c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM480 164.1V64h-64v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48h130.1l-47.4-71.1c-4.9-7.4-2.9-17.3 4.4-22.2l79.8-53.2-82.2-82.2c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c3.4 3.4 5.1 8.1 4.6 12.9s-3.1 9.1-7 11.7l-82.7 55.1 50.4 75.6H432c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7z"
        }
    ]
};

const FalHouseChimneyHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseChimneyHeart",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v136.3l58.6 51.7c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235v197c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM480 164.1V64h-64v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM237.3 256c-16.2 0-29.3 13.1-29.3 29.3 0 7.8 3.1 15.2 8.6 20.7l71.4 71.4 71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7 0-16.2-13.1-29.3-29.3-29.3-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0L258 264.6c-5.5-5.5-12.9-8.6-20.7-8.6zM176 285.3c0-33.8 27.4-61.3 61.3-61.3 16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.7-82.7c-11.5-11.5-17.9-27.1-17.9-43.3z"
        }
    ]
};

const FalHouseChimneyMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseChimneyMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v136.3l58.6 51.7c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235v197c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM480 164.1V64h-64v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM272 176h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32v-32c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7h-48v32h48c8.8 0 16 7.2 16 16v48h32v-48c0-8.8 7.2-16 16-16h48v-32h-48c-8.8 0-16-7.2-16-16v-48h-32z"
        }
    ]
};

const FalHouseChimneyUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseChimneyUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L512 192.3V56c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24v23.4L298.6 4zM416 107.6V64h64v100.1l-64-56.5zM96 432V206.7L288 37.3l192 169.4V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zm160-208a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM248 352h80c22.1 0 40 17.9 40 40v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-39.8-32.2-72-72-72h-80c-39.8 0-72 32.2-72 72v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1 17.9-40 40-40z"
        }
    ]
};

const FalHouseChimneyWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseChimneyWindow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v136.3l58.6 51.7c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235v197c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM480 164.1V64h-64v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM240 192h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32h-96c-17.7 0-32-14.3-32-32v-96c0-17.7 14.3-32 32-32zm0 32v96h96v-96h-96z"
        }
    ]
};

const FalHouseChimney = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseChimney",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0L384 79.4V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v136.3l58.6 51.7c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235v197c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM480 164.1V64h-64v43.6l64 56.5zM96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v160h64c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM336 320h-96v160h96V320z"
        }
    ]
};

const FalHouseCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0l213.9 188.8c-5.4-.5-10.9-.8-16.5-.8-10.2 0-20.2.9-29.9 2.5L288 37.3 96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c1 0 2.1.1 3.1.1-5.1 10.1-9.3 20.7-12.5 31.9H240v160h120.2c10 12.1 21.7 22.9 34.6 32H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM496 480a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalHouseCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0l213.9 188.8c-5.4-.5-10.9-.8-16.5-.8-10.2 0-20.2.9-29.9 2.5L288 37.3 96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c1 0 2.1.1 3.1.1-5.1 10.1-9.3 20.7-12.5 31.9H240v160h120.2c10 12.1 21.7 22.9 34.6 32H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM608 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalHouseCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0l213.9 188.8c-5.4-.5-10.9-.8-16.5-.8-10.2 0-20.2.9-29.9 2.5L288 37.3 96 206.7V432c0 26.5 21.5 48 48 48h64V320c0-17.7 14.3-32 32-32h96c1 0 2.1.1 3.1.1-5.1 10.1-9.3 20.7-12.5 31.9H240v160h120.2c10 12.1 21.7 22.9 34.6 32H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM608 368a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm166.6 0 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
        }
    ]
};

const FalHouseCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseCrack",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3l192 169.4V432c0 26.5-21.5 48-48 48H312.6l-50.4-75.6 82.7-55.1c4-2.7 6.6-7 7-11.7s-1.2-9.5-4.6-12.9l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l82.2 82.2-79.8 53.2c-7.4 4.9-9.3 14.8-4.4 22.2l47.4 71.1H144c-26.5 0-48-21.5-48-48z"
        }
    ]
};

const FalHouseDay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseDay",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM276.7 52.7l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zm133.7 47.2c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7l37.5-32.3V448c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V283.9l37.6 32.2c6.7 5.7 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-224-192zM544 256.5V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V256.5l144-123.4 144 123.4zM336 304v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zm96 0v64h-64v-64h64zM144 176c0-17.7 14.3-32 32-32 13.9 0 25.8 8.9 30.2 21.3 2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4c-8.8-24.9-32.5-42.7-60.4-42.7-35.3 0-64 28.7-64 64 0 27.9 17.8 51.6 42.7 60.4 8.3 2.9 17.5-1.4 20.4-9.8s-1.4-17.5-9.8-20.4c-12.4-4.4-21.3-16.3-21.3-30.2zm-36.7 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zM52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalHouseFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h230.3c-14.2-9.5-27.1-20.9-38.3-33.8v1.8h-96V320h51.6c2.4-10.6 5.9-21.4 10.3-32H240c-17.7 0-32 14.3-32 32v160h-64c-26.5 0-48-21.5-48-48V206.7L288 37.3l120.4 106.3c1.4-1.2 2.7-2.5 4.1-3.7 7.7-6.9 17.2-10.8 26.9-11.7L298.6 4zm210.8 249.5c9.6-.1 18.7-4.5 24.7-12.1 3.9-4.9 7.8-9.6 11.6-14 16.4 17.8 30.9 39.4 41.8 60.5C601 314 608 339.4 608 352.2c0 70.2-57 127.8-128 127.8-71.8 0-128-57.5-128-127.8 0-17.9 9.4-46.2 27.6-75.8 15.9-25.8 37.9-53.1 64-78.1 14.3 13.7 27.9 28.3 40.8 43.7 6.2 7.4 15.3 11.6 25 11.5zm-21.8-56.4c-10.9-11.6-22.2-22.8-34-33.4-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 87.9 70.3 160 160 160 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-1.8 1.6-3.5 3.3-5.2 5-7.7 7.7-14.8 16.4-21.2 24.5-7-8.4-14.1-16.5-21.5-24.4zM445.1 256c-4.8 0-9.4 2.2-12.5 5.9-14.9 18.4-26.9 33.8-35.1 47.9C389 324.3 384 338.3 384 354c0 28.7 10.7 52.6 28.8 69.2 18 16.5 42.3 24.8 68.2 24.8 21.3 0 40.3-6 57.9-17.7l.3-.2c37.3-26.1 46.3-77.2 25-116.5v-.1c-1.9-3.9-4.5-9-8.3-14.1-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5-12.4 8.2-25.3 12.2-40 12.2-19.1 0-35.3-6.1-46.6-16.4-11.1-10.2-18.4-25.3-18.4-45.6 0-8.3 2.5-16.8 9.1-28.1 4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.4 1.8 2.4.5.6.1.2L507 351l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"
        }
    ]
};

const FalHouseFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseFlag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 0c-8.8 0-16 7.2-16 16v496h32V192h144c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H480V16c0-8.8-7.2-16-16-16zm16 160V64h128v96H480zm-64-24L281.6 35.2a15.9 15.9 0 0 0-19.2 0l-256 192c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2L64 224v216c0 39.8 32.2 72 72 72h272c2.7 0 5.4-.2 8-.4v-32.4c-2.6.5-5.3.8-8 .8h-64V352c0-17.7-14.3-32-32-32h-80c-17.7 0-32 14.3-32 32v128h-64c-22.1 0-40-17.9-40-40V200L272 68l144 108v-40zM312 352v128h-80V352h80z"
        }
    ]
};

const FalHouseFloodWaterCircleArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseFloodWaterCircleArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M310.4 86.4c-3.6-10.3-8.1-20.2-13.4-29.6l78-54c5.5-3.8 12.7-3.8 18.2 0l208 144c7.3 5 9.1 15 4 22.3s-15 9.1-22.3 4L560 157.3v119.3c-2.4-1.6-4.6-3.3-6.8-5.1-7.5-6.3-16.2-10.7-25.2-13V135.2L384 35.5l-73.6 51zM224 368c20.9 0 41.6-9.9 58.2-21.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C374.3 358 395.1 368 416 368s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C40 400.1 32 392 32 382.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9C182.3 358 203.1 368 224 368zm-58.2 90.8C182.3 470 203.1 480 224 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C374.3 470 395.1 480 416 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C40 512.1 32 504 32 494.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9zM144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm-3.3 76.7c6.2-6.2 16.4-6.2 22.6 0l56 56c6.2 6.2 6.2 16.4 0 22.6l-56 56c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l28.7-28.7H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h89.4l-28.7-28.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalHouseFloodWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseFloodWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M297.1 2.8c-5.5-3.8-12.7-3.8-18.2 0l-208 144c-7.3 5-9.1 15-4 22.3s15 9.1 22.3 4l22.8-15.8v101.2c7.3 1.9 14.4 5.1 20.9 9.6 3.6 2.5 7.3 4.8 11.1 6.8V135.2l144-99.7 144 99.7V275c3.8-2.1 7.6-4.4 11.2-6.8 6.5-4.5 13.5-7.8 20.8-9.6V157.3l22.9 15.8c7.3 5 17.2 3.2 22.3-4s3.2-17.2-4-22.3l-208-144zm-163.3 344c-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 368.1 0 374.4 0 382.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 358 404.9 368 384 368s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 358 212.9 368 192 368s-41.7-9.9-58.2-21.2zM192 480c-20.9 0-41.7-9.9-58.2-21.2-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"
        }
    ]
};

const FalHouseHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseHeart",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3l192 169.4V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zm112-146.7c0-16.2 13.1-29.3 29.3-29.3 7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6 16.2 0 29.3 13.1 29.3 29.3 0 7.8-3.1 15.2-8.6 20.7L288 377.4 216.6 306c-5.5-5.5-8.6-12.9-8.6-20.7zm29.3-61.3c-33.8 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"
        }
    ]
};

const FalHouseLaptop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseLaptop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M229.6 3.9c6-5.1 14.8-5.1 20.8 0l224 192c6.7 5.8 7.5 15.9 1.7 22.6-3.1 3.7-7.6 5.6-12.1 5.6h-.2c-3.7 0-7.3-1.3-10.3-3.9L416 187.9V224h-32v-63.5L240 37.1 96 160.5V352c0 17.7 14.3 32 32 32h144v32H128c-35.3 0-64-28.7-64-64V187.9l-37.6 32.2c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6l224-192zM352 256h192c26.5 0 48 21.5 48 48v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8-7.2-16-16-16H352c-8.8 0-16 7.2-16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-26.5 21.5-48 48-48zm-80 224h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-64-304h64c17.7 0 32 14.3 32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-64v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FalHouseLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h248.6c-5.4-9.4-8.6-20.3-8.6-32h-16V320c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32v160h-64c-26.5 0-48-21.5-48-48V206.7L288 37.3l168.4 148.6c8.6-7.1 18.2-13 28.7-17.4L298.6 4zM336 480h-96V320h96v160zm192-256c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80h160v128H448V352z"
        }
    ]
};

const FalHouseMedicalCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseMedicalCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h250.8c-12.9-9.1-24.5-19.9-34.6-32H144c-26.5 0-48-21.5-48-48V206.7L288 37.3l178.1 157.2c9.7-1.7 19.7-2.5 29.9-2.5 5.6 0 11.1.3 16.5.8L298.6 4zM368 240h-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c6.7 0 12.9-2 18-5.5-1.3-8.6-2-17.5-2-26.5 0-22.6 4.3-44.2 12-64h-12c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48h32v48c0 8.8 7.2 16 16 16h28.5c7.5-11.4 16.2-22 26-31.3-2.1-.4-4.3-.7-6.5-.7zm128 16a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm44.7-187.3L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"
        }
    ]
};

const FalHouseMedicalCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseMedicalCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h250.8c-12.9-9.1-24.5-19.9-34.6-32H144c-26.5 0-48-21.5-48-48V206.7L288 37.3l178.1 157.2c9.7-1.7 19.7-2.5 29.9-2.5 5.6 0 11.1.3 16.5.8L298.6 4zM368 240h-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c6.7 0 12.9-2 18-5.5-1.3-8.6-2-17.5-2-26.5 0-22.6 4.3-44.2 12-64h-12c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48h32v48c0 8.8 7.2 16 16 16h28.5c7.5-11.4 16.2-22 26-31.3-2.1-.4-4.3-.7-6.5-.7zm16 128a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalHouseMedicalCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseMedicalCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h250.8c-12.9-9.1-24.5-19.9-34.6-32H144c-26.5 0-48-21.5-48-48V206.7L288 37.3l178.1 157.2c9.7-1.7 19.7-2.5 29.9-2.5 5.6 0 11.1.3 16.5.8L298.6 4zM368 240h-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c6.7 0 12.9-2 18-5.5-1.3-8.6-2-17.5-2-26.5 0-22.6 4.3-44.2 12-64h-12c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48h32v48c0 8.8 7.2 16 16 16h28.5c7.5-11.4 16.2-22 26-31.3-2.1-.4-4.3-.7-6.5-.7zm16 128a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-121.4 0 36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368z"
        }
    ]
};

const FalHouseMedicalFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseMedicalFlag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 16v16h144c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H480v320h-32V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm128 144V64H480v96h128zM281.6 35.2 416 136v40L272 68 96 200v240c0 22.1 17.9 40 40 40h272c2.7 0 5.4-.3 8-.8v32.4c-2.6.3-5.3.4-8 .4H136c-39.8 0-72-32.2-72-72V224l-38.4 28.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4l256-192a15.9 15.9 0 0 1 19.2 0zM256 176h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32v-32c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7h-48v32h48c8.8 0 16 7.2 16 16v48h32v-48c0-8.8 7.2-16 16-16h48v-32h-48c-8.8 0-16-7.2-16-16v-48h-32z"
        }
    ]
};

const FalHouseMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3l192 169.4V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zm176-256c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48z"
        }
    ]
};

const FalHouseNight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseNight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M127 1c-4.9-.7-9.9-1-15-1C50.1 0 0 50.1 0 112s50.1 112 112 112c30.6 0 58.4-12.3 78.6-32.2.7-.6 1.3-1.3 1.9-2 2.9-3 5.7-6.2 8.2-9.5 2.3-3 4.5-6.2 6.5-9.5 3.9-6.2-3.2-13.3-10.4-12-2.4.4-4.9.8-7.5.9-1.8.1-3.6.2-5.4.2-2.2 0-4.3-.1-6.5-.3-.4 0-.8-.1-1.2-.1-36-3.7-64.2-34.3-64.2-71.5 0-20.8 8.8-39.5 22.9-52.7.3-.3.6-.5.9-.8 2.9-2.7 6.1-5.1 9.4-7.2 2.1-1.4 4.3-2.6 6.6-3.7 6.6-3.3 8-13.2 1.1-15.9-3.6-1.4-7.2-2.6-10.9-3.6-4-1.1-8.1-2-12.3-2.7-.9-.1-1.8-.3-2.7-.4zM80 88c0 43.9 27.1 81.4 65.5 96.7-10.2 4.7-21.5 7.3-33.5 7.3-44.2 0-80-35.8-80-80 0-38.4 27.1-70.5 63.3-78.2C85.6 49.5 80 68.1 80 88zm330.4 11.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7l37.5-32.3V448c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V283.9l37.6 32.2c6.7 5.7 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-224-192zM544 256.5V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V256.5l144-123.4 144 123.4zM336 304v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zm96 0v64h-64v-64h64zM256 0c-8.8 0-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V80h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V16c0-8.8-7.2-16-16-16zM96 320c-8.8 0-16 7.2-16 16v32H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalHousePersonLeave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHousePersonLeave",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M250.4 3.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L64 187.9V352c0 35.3 28.7 64 64 64h208.8l17.2-17.2 7.4-14.8H128c-17.7 0-32-14.3-32-32V160.5L240 37.1l118.2 101.3c8.3-7.2 17.2-13.6 26.7-19.2L250.4 3.9zM192 192h64v64h-64v-64zm-8-32c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-80zM496 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zM437.6 172.3c1.3-.7 2.6-1.4 3.9-2l-26.6 85c-5.7 18.2 0 38.1 14.4 50.6L529.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8l-30.7-107.4c-1.7-6-5.1-11.3-9.8-15.4L507.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5 32.7-104.5c2.5-.2 5-.3 7.5-.3 15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.8 61.7-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9.7-17.5-7.2-21.5z"
        }
    ]
};

const FalHousePersonReturn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHousePersonReturn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M250.4 3.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L64 187.9V352c0 35.3 28.7 64 64 64h220.6l9.1-32H128c-17.7 0-32-14.3-32-32V160.5L240 37.1l127.9 109.6c5.8-9.1 12.6-17.4 20.4-24.7L250.4 3.9zM192 192h64v64h-64v-64zm-8-32c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-80c0-13.3-10.7-24-24-24h-80zM464 56a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-80 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm138.4 116.3 12.7 6.9c27.5 15 47.4 40.8 55 71.2l2.4 9.6c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4l-2.4-9.5c-9.8-39-35.4-72.2-70.7-91.5l-12.7-6.9c-19.4-10.6-41.2-16.2-63.4-16.2-36.9 0-69.7 23.6-81.4 58.7l-17.1 51.4c-3.4 10.1-10 18.8-18.9 24.8l-29.7 19.8c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l29.7-19.8c14.8-9.9 25.9-24.4 31.5-41.3l8.8-26.4L452.7 331l-43.6 37.8c-4.7 4.1-8.1 9.4-9.8 15.4l-30.7 107.4c-2.4 8.5 2.5 17.4 11 19.8s17.4-2.5 19.8-11L430.1 393l100.6-87.2c14.4-12.5 20.1-32.4 14.4-50.6l-26.6-85c1.3.6 2.6 1.3 3.9 2zm-7.9 92.5c1.9 6.1 0 12.7-4.8 16.9l-30.9 26.8-45-130c10-11.5 24.7-18.4 40.6-18.4 2.5 0 5 .1 7.5.3l32.7 104.5zm6.4 88.9c-7.9 4-11.1 13.6-7.2 21.5l30.8 61.7c1.5 3.1 3.6 5.9 6 8.3l62.2 62.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-62.2-62.2-30.8-61.7c-4-7.9-13.6-11.1-21.5-7.2z"
        }
    ]
};

const FalHouseSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseSignal",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M325.6 3.9c6-5.1 14.8-5.1 20.8 0l224 192c6.7 5.8 7.5 15.9 1.7 22.6s-15.8 7.5-22.6 1.7L512 187.9V352c0 35.3-28.7 64-64 64H278.1c-3.1-11-6.9-21.7-11.3-32H448c17.7 0 32-14.3 32-32V160.5L336 37.1 192 160.5v123.8c-10.1-8.3-20.8-15.9-32-22.7v-73.7l-37.6 32.2c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6l224-192zM304 176h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm0 32v64h64v-64h-64zM16 256c132.5 0 240 107.5 240 240 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 368c0-8.8 7.2-16 16-16 79.5 0 144 64.5 144 144 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalHouseTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseTree",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M404.1 37.1c6.4-7.1 17.4-7.1 23.8 0L538.5 160H480c-6.2 0-11.8 3.6-14.5 9.1s-1.8 12.2 2.1 17l108.2 132.5c.1.2.2.3.2.5 0 .5-.4.9-.9.9H496c-6.3 0-12.1 3.7-14.6 9.5s-1.4 12.6 2.8 17.2L606 480H414.4c-2.4 11.8-7.4 22.7-14.4 32h209.6c16.8 0 30.4-13.6 30.4-30.4 0-7.6-2.8-14.9-8-20.5L532.3 352h42.8c18.1 0 32.9-14.7 32.9-32.9 0-7.6-2.6-14.9-7.4-20.8L513.7 192h34.7c15.2 0 27.6-12.3 27.6-27.6 0-6.8-2.5-13.4-7.1-18.4L451.7 15.7c-19.1-21.2-52.3-21.2-71.4 0l-95.4 106 23.6 21.6 95.6-106.2zM32 284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V284.2zM0 448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L20.8 237C7.5 249.1 0 266.2 0 284.2V448zm224-160v64h-64v-64h64zm-64-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64z"
        }
    ]
};

const FalHouseTsunami = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseTsunami",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 200c0-92 78.8-168 177.9-168 20.6 0 40.4 3.3 58.7 9.4 8.4 2.8 17.4-1.8 20.2-10.2S287 13.8 278.6 11c-21.5-7.1-44.7-11-68.7-11C94.8 0 0 88.8 0 200c0 109.1 74 200 191.2 200h1.8c29.9-.3 56.7-14.2 75.1-26.8 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.7 12.7 46 26.8 76.3 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 358 404.9 368 384 368s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 358 212.9 368 192 368c-66.4-.3-120-53.9-120-120 0-66.2 53.9-120 120.5-120 18.3 0 35.6 4 51 11.3 8 3.7 17.5.3 21.3-7.7s.3-17.5-7.7-21.3c-19.7-9.2-41.6-14.3-64.6-14.3C108.3 96 40 164 40 248c0 3 .1 6.1.3 9.1-5.5-17.8-8.3-37-8.3-57.1zm320-56 96-72 95.5 72 .3 141.2c4.9 2.1 9.9 3.8 14.8 4.9 6.2 1.4 12 3.7 17.2 6.8l-.3-153c0-10-4.7-19.5-12.7-25.5l-95.6-71.9a31.95 31.95 0 0 0-38.5 0l-96 72c-8.1 6-12.8 15.5-12.8 25.6V265c1.7 1 3.3 2 4.8 3.1 8.6 5.9 17.8 10.7 27.2 14.2V144zM192 480c-20.9 0-41.7-9.9-58.2-21.2-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"
        }
    ]
};

const FalHouseTurret = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseTurret",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 448V284.2c0-9 3.8-17.5 10.4-23.6l128-117.3c12.2-11.2 31-11.2 43.2 0l128 117.3c6.6 6.1 10.4 14.6 10.4 23.6V448c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32zm-32-163.8V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V284.2c0-17.9-7.5-35.1-20.8-47.2l-128-117.3c-24.5-22.4-62-22.4-86.5 0L276.8 237c-13.2 12.1-20.8 29.2-20.8 47.2zm160 3.8h64v64h-64v-64zm-32 0v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32zM32 48c0-8.8 7.2-16 16-16h48v64c0 8.8 7.2 16 16 16s16-7.2 16-16V32h96v64c0 8.8 7.2 16 16 16s16-7.2 16-16V32h48c8.8 0 16 7.2 16 16v105.9l32-29.3V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v155.8c0 11.8 4.3 23.1 12.1 31.9L64 294.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-3.9-1.4-7.7-4-10.6l-56-62.9c-2.6-2.9-4-6.7-4-10.6V48zm160 176h-32v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm-16-80c-26.5 0-48 21.5-48 48v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FalHouseUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M277.4 4c6-5.3 15.1-5.3 21.2 0l272 240c6.6 5.8 7.3 16 1.4 22.6s-16 7.3-22.6 1.4L512 235v197c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80V235l-37.4 33c-6.6 5.8-16.8 5.2-22.6-1.4s-5.2-16.8 1.4-22.6l272-240zM96 206.7V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V206.7L288 37.3 96 206.7zM288 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-80 232v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-39.8 32.2-72 72-72h80c39.8 0 72 32.2 72 72v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-22.1-17.9-40-40-40h-80c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FalHouseWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v158c9.9-5.7 20.9-8.6 32-8.6V206.7L288 37.3l192 169.4v177.8c11.1 0 22.1 2.9 32 8.6V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM208 208v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32zm128 0v96h-96v-96h96zM192 480c-20.9 0-41.7-9.9-58.2-21.2-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480z"
        }
    ]
};

const FalHouseWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouseWindow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3l192 169.4V432c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48zm144-240c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32h-96zm0 32h96v96h-96v-96z"
        }
    ]
};

const FalHouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHouse",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235v197c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3l192 169.4V432c0 26.5-21.5 48-48 48h-64V320c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32v160h-64c-26.5 0-48-21.5-48-48zm144 48V320h96v160h-96z"
        }
    ]
};

const FalHryvniaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHryvniaSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M99.7 86.1c21.6-14.4 47-22.1 72.9-22.1H231c40.3 0 73 32.7 73 73 0 21.4-9.3 41.3-25 55H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h204.2L106 281.1c-4.1 2.1-8.1 4.4-11.8 6.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h47.6c-10 16.2-15.6 35.2-15.6 55 0 58 47 105 105 105h58.4c32.3 0 63.8-9.5 90.6-27.4l10.9-7.2c7.4-4.9 9.3-14.8 4.4-22.2s-14.8-9.3-22.2-4.4l-10.9 7.2c-21.6 14.4-46.9 22.1-72.9 22.1H153c-40.3 0-73-32.7-73-73 0-21.4 9.3-41.3 25-55h263c8.8 0 16-7.2 16-16s-7.2-16-16-16H163.8L278 230.9c4.1-2.1 8.1-4.4 11.8-6.9H368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-47.6c10-16.2 15.6-35.2 15.6-55 0-58-47-105-105-105h-58.4c-32.3 0-63.8 9.5-90.6 27.4l-10.9 7.3c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l10.9-7.2z"
        }
    ]
};

const FalHundredPoints = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHundredPoints",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.4 93.3c5-35.2 35.2-61.3 70.7-61.3 43.5 0 76.9 38.5 70.7 81.5l-16.2 113.2c-5 35.2-35.2 61.3-70.7 61.3-43.5 0-76.9-38.5-70.7-81.5l16.2-113.2zM248.1 64c-19.6 0-36.3 14.4-39 33.9L192.9 211c-3.4 23.8 15 45 39 45 19.6 0 36.3-14.4 39-33.9L287.1 109c3.4-23.8-15-45-39-45zM129.8 35.2c4.6 3.5 6.9 9.2 6 15l-40 256c-1.4 8.8-9.6 14.9-18.3 13.6s-14.7-9.3-13.3-18.1L99.7 74.4 54.3 94.6c-8.1 3.6-17.5 0-21-8.1s.3-17.5 8.4-21.1l72-32c5.4-2.4 11.5-1.7 16.1 1.8zM425.6 32c42.8 0 76.1 37.3 71.2 79.8l-11.2 96.7c-4.2 36.1-34.8 63.4-71.2 63.4-42.8 0-76.1-37.3-71.2-79.8l11.2-96.7c4.2-36.1 34.8-63.4 71.2-63.4zm-39.4 67.1L375 195.8c-2.7 23.5 15.7 44.2 39.4 44.2 20.1 0 37.1-15.1 39.4-35.1l11.2-96.7c2.7-23.6-15.7-44.2-39.4-44.2-20.1 0-37.1 15.1-39.4 35.1zm125.7 234.8c1.2 8.8-5 16.8-13.7 18l-480 64c-8.8 1.2-16.8-5-18-13.7s5-16.8 13.7-18l480-64c8.8-1.2 16.8 5 18 13.7zm-45.9 114-256 32c-8.8 1.1-16.8-5.1-17.9-13.9s5.1-16.8 13.9-17.9l256-32c8.8-1.1 16.8 5.1 17.9 13.9s-5.1 16.8-13.9 17.9z"
        }
    ]
};

const FalHurricane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHurricane",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 208c0-89.1 66.2-162.7 152-174.4v65.2c0 16.4 12.1 29.1 26.8 32.1C291.3 147 352 218.1 352 303.4c0 89.1-66.2 162.7-152 174.4v-65.2c0-16.4-12.1-29.1-26.8-32.1C92.7 364.4 32 293.3 32 208zM216 32.8C216 15 200.9-.8 181.4 1.7 79.1 14.8 0 102.2 0 208c0 100.8 71.7 184.9 166.9 203.9.5.1.8.3 1 .5l.1.1v65.9c0 17.8 15.1 33.6 34.6 31.1C304.9 496.6 384 409.3 384 303.4c0-100.8-71.7-184.9-166.9-203.9-.5-.1-.8-.3-1-.5-.1-.1-.1-.2-.1-.2v-66zM240 256a48 48 0 1 1-96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"
        }
    ]
};

const FalHyphen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalHyphen",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalICursor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalICursor",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 14.9C-.6 23.7 6 31.3 14.9 32l8 .6c50.2 3.5 89.1 45.3 89.1 95.7V240H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v111.7c0 50.4-38.9 92.2-89.2 95.8l-8 .6c-8.8.6-15.4 8.2-14.8 17s8.3 15.5 17.1 14.9l8-.6c44.6-3.2 82.5-29 102.9-65.7 20.4 36.7 58.3 62.5 102.9 65.7l8 .6c8.8.6 16.5-6 17.1-14.8s-6-16.5-14.8-17.1l-8-.6c-50.2-3.6-89.2-45.4-89.2-95.8V272h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V128.3c0-50.4 38.9-92.2 89.2-95.8l8-.6c8.8-.6 15.4-8.3 14.8-17.1S247.7-.6 238.9 0l-8 .6c-44.6 3.2-82.5 29-102.9 65.7C107.6 29.6 69.7 3.8 25.1.6l-8-.6C8.3-.6.7 6 0 14.9z"
        }
    ]
};

const FalI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalI",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h128v384H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H176V64h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalIceCream = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIceCream",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0C139.7 0 70.6 65.2 64.4 147.9 36.2 157.7 16 184.5 16 216c0 39.8 32.2 72 72 72h272c39.8 0 72-32.2 72-72 0-31.5-20.2-58.3-48.4-68.1C377.4 65.2 308.3 0 224 0zM96 160c0-70.7 57.3-128 128-128s128 57.3 128 128v.5c0 8 5.8 14.7 13.7 15.9 19.4 2.8 34.3 19.5 34.3 39.6 0 22.1-17.9 40-40 40H88c-22.1 0-40-17.9-40-40 0-20.1 14.9-36.8 34.3-39.6 7.9-1.1 13.8-7.9 13.7-15.9v-.5zm104.1 338.1c4.9 8.6 14 13.9 23.9 13.9s19-5.3 23.9-13.9L349.7 320h-36.8L224 475.5 135.1 320H98.3l101.8 178.1z"
        }
    ]
};

const FalIceSkate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIceSkate",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v7.4l-4.1 1.1L67.6 82.2c-21 5.6-35.6 24.6-35.6 46.4V336c0 26.5 21.5 48 48 48h384c26.5 0 48-21.5 48-48v-30c0-36.7-25-68.7-60.6-77.6L320 195.5V16zM75.9 113.1 288 56.6V128h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h62l141.6 35.4C465 264.7 480 283.9 480 306v30c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V128.6c0-7.2 4.9-13.6 11.9-15.5zM128 432v-16H96v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c44.2 0 80-35.8 80-80 0-8.8-7.2-16-16-16s-16 7.2-16 16c0 26.5-21.5 48-48 48h-80v-64h-32v64H128v-48z"
        }
    ]
};

const FalIcicles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIcicles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 36.6C0 16.4 16.4 0 36.6 0h437.5C495 0 512 17 512 37.9c0 2.4-.2 4.8-.7 7.2L423.7 499c-1.5 7.5-8.1 13-15.8 13s-14.3-5.5-15.7-13.1l-58.5-312-30.2 121c-1.8 7-8.1 12-15.3 12.1s-13.7-4.7-15.6-11.7l-22-79.4-34.9 174.2c-1.5 7.5-8.1 12.9-15.7 12.9s-14.2-5.4-15.7-12.9l-36.2-180.9-28.9 86.8c-2.2 6.6-8.3 11-15.2 11s-13-4.4-15.2-10.9L1.9 48.2C.6 44.5 0 40.6 0 36.6zM36.6 32C34 32 32 34.1 32 36.6c0 .5.1 1 .2 1.5L104 253.4l32.8-98.5c2.3-6.9 8.9-11.4 16.2-10.9s13.3 5.7 14.7 12.8L200 318.4l32.3-161.6c1.5-7.3 7.7-12.6 15.1-12.9s14 4.6 16 11.7l23.8 85.6L320.5 108c1.8-7.3 8.5-12.3 16-12.1s13.9 5.7 15.2 13l56.5 301.3L479.9 39c.1-.4.1-.7.1-1.1 0-3.3-2.6-5.9-5.9-5.9H36.6z"
        }
    ]
};

const FalIcons = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIcons",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M473.7 4.1C493.5.2 512 15.3 512 35.5V168h-.2c.1 1.3.2 2.7.2 4 0 28.7-28.7 52-64 52s-64-23.3-64-52 28.7-52 64-52c11.7 0 22.6 2.5 32 7V35.5L352 61.1V200h-.2c.1 1.3.2 2.7.2 4 0 28.7-28.7 52-64 52s-64-23.3-64-52 28.7-52 64-52c11.7 0 22.6 2.5 32 7V61.1c0-15.3 10.8-28.4 25.7-31.4l128-25.6zM480 172c0-3.1-1.5-7.5-6.9-11.9-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zm-160 32c0-3.1-1.5-7.5-6.9-11.9-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM105.4 54.6l-6-6c-9-9-21.8-13.1-34.4-11-19 3.2-33 19.6-33 38.9v2.9c0 11.9 4.9 23.2 13.6 31.4l82.4 76.9 82.4-76.9c8.7-8.1 13.6-19.5 13.6-31.4v-2.9c0-19.3-13.9-35.8-33-38.9-12.6-2.1-25.4 2-34.4 11l-6 6L128 77.3l-22.6-22.7zM59.7 6c22.8-3.7 46 3.7 62.3 20l6 6 6-6c16.3-16.3 39.5-23.7 62.3-20 34.4 5.8 59.7 35.6 59.7 70.5v2.9c0 20.8-8.6 40.6-23.8 54.8l-90.4 84.3c-3.8 3.5-8.7 5.5-13.8 5.5s-10.1-2-13.8-5.5l-90.4-84.3C8.6 120 0 100.2 0 79.5v-3C0 41.6 25.3 11.8 59.7 6zM72 320H48c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16h-24c-12.1 0-23.2-6.8-28.6-17.7l-7.2-14.3h-72.4l-7.2 14.3C95.2 313.2 84.1 320 72 320zm136.8-46.3L216 288h24c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48h24l7.2-14.3c5.4-10.8 16.5-17.7 28.6-17.7h72.4c12.1 0 23.2 6.8 28.6 17.7zM112 392a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm331.3-172.7L390.6 368H480c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l84.7-84.7H352c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalIdBadge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIdBadge",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm224 160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm0-144c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm-16 320c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalIdCardClip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIdCardClip",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32h-64v64h64V32zM256 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zm64 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-16 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48zM64 64h128v32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H384V64h128c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalIdCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIdCard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32h512c0-17.7-14.3-32-32-32H64zM0 112V96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V112zm544 16H32v288c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V128zM192 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-32 192c-26.5 0-48 21.5-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5-21.5-48-48-48h-64zm176-144c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalIgloo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIgloo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 320v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-96C0 160.9 128.9 32 288 32s288 128.9 288 288zm-32 32H384v96h128c17.7 0 32-14.3 32-32v-64zm0-32c0-46.6-12.5-90.3-34.2-128H480v128h64zM352 192H128v128h69.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H448V192h-96zM96 352H32v64c0 17.7 14.3 32 32 32h128v-96H96zm0-32V192H66.2C44.5 229.7 32 273.4 32 320h64zm391.9-160c-34.1-42.5-81.5-73.9-135.9-87.9V160h135.9zM320 66c-10.5-1.3-21.2-2-32-2-80.8 0-152.9 37.5-199.9 96H320V66zm-32 222c-35.3 0-64 28.7-64 64v96h128v-96c0-35.3-28.7-64-64-64z"
        }
    ]
};

const FalImageLandscape = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalImageLandscape",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96c17.7 0 32 14.3 32 32v256c0 6.1-1.7 11.8-4.6 16.6L377 197.6c-12.8-16-37.2-16-50 0l-82.6 103.3-27.3-37.5c-12.3-17-37.4-17.7-50.6-1.4L45.3 410c-8-5.8-13.3-15.3-13.3-26V128c0-17.7 14.3-32 32-32h448zm-1.3 320H193.3l63-78.8L352 217.6 510.7 416zm-350.6 32H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h96.2zm-7.8-32H81.8l109.5-133.8 32.4 44.6-71.4 89.2zM144 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalImagePolaroidUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalImagePolaroidUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 384H32v32c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-32h-80zm-1.6-32H416V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v256h81.6c7.4-36.5 39.7-64 78.4-64h64c38.7 0 71 27.5 78.4 64zm-187.7 0h154.6c-6.6-18.6-24.4-32-45.3-32h-64c-20.9 0-38.7 13.4-45.3 32zM448 96v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64zm-192 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FalImagePolaroid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalImagePolaroid",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 384v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-32h384zm-310.6-32H32v-9.4l96-96 41.4 41.4-60.7 60.7-3.3 3.3zm45.3 0 52.7-52.7 84.6-84.7 128 128v9.4H150.6zM416 297.4 310.6 192c-12.5-12.5-32.8-12.5-45.3 0L192 265.4 150.6 224c-12.5-12.5-32.8-12.5-45.3 0L32 297.4V96c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v201.4zm32 38.6V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64v-80zM128 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalImagePortrait = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalImagePortrait",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm224 128a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm107.4 128h-86.8c-18.6 0-34 14-36.3 32h159.4c-2.2-18-17.6-32-36.3-32zm-86.9-32h86.9c37.9 0 68.6 30.7 68.6 68.6 0 15.1-12.3 27.4-27.4 27.4H107.4C92.3 384 80 371.7 80 356.6c0-37.9 30.7-68.6 68.6-68.6z"
        }
    ]
};

const FalImageSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalImageSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 96c0-35.3-28.7-64-64-64H139.6l40.5 32H512c17.7 0 32 14.3 32 32v169.4l-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0l-31 31 25.3 20 28.4-28.4c3.1-3.1 8.2-3.1 11.3 0l90.3 90.3v40.7l32 25.3V96zM297.6 319.8l-9.6 9.6-67.7-67.7c-15.6-15.6-40.9-15.6-56.6 0L96 329.4V160.7l-32-25.3V416c0 35.3 28.7 64 64 64h372.4l-40.5-32H214.6l108.2-108.2-25.3-20zM265.4 352l-96 96H128c-17.7 0-32-14.3-32-32v-41.4l90.3-90.3c3.1-3.1 8.2-3.1 11.3 0l67.8 67.7z"
        }
    ]
};

const FalImageUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalImageUser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm288 96a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm107.4 128h-86.8c-18.6 0-34 14-36.3 32h159.4c-2.2-18-17.6-32-36.3-32zm-86.9-32h86.9c37.9 0 68.6 30.7 68.6 68.6 0 15.1-12.3 27.4-27.4 27.4H171.4c-15.1 0-27.4-12.3-27.4-27.4 0-37.9 30.7-68.6 68.6-68.6z"
        }
    ]
};

const FalImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v233.4l67.7-67.7c15.6-15.6 40.9-15.6 56.6 0l67.7 67.7 131.7-131.7c15.6-15.6 40.9-15.6 56.6 0l67.7 67.7V96c0-17.7-14.3-32-32-32H64zM32 374.6V416c0 17.7 14.3 32 32 32h41.4l96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zm357.7-154.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448H448c17.7 0 32-14.3 32-32V310.6l-90.3-90.3zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0z"
        }
    ]
};

const FalImagesUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalImagesUser",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64H160c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h64v-16c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80v16h64c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-64 320H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h352c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64h-64zm-32-32v-16c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v16h160zM16 96c8.8 0 16 7.2 16 16v240c0 53 43 96 96 96h336c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 480 0 422.7 0 352V112c0-8.8 7.2-16 16-16zm352 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-32-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FalImages = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalImages",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64h352c17.7 0 32 14.3 32 32v105.4L486.6 144c-12.5-12.5-32.8-12.5-45.3 0L304 281.4 230.6 208c-12.5-12.5-32.8-12.5-45.3 0L128 265.4V96c0-17.7 14.3-32 32-32zm416 32c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V96zm-112 70.6 80 80V320c0 17.7-14.3 32-32 32H278.6l36.7-36.7L464 166.6zM281.4 304l-48 48H160c-17.7 0-32-14.3-32-32v-9.4l80-80 73.4 73.4zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 70.7 57.3 128 128 128h336c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalInboxFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInboxFull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 327.9V416c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-88.1c0-2.6-.3-5.2-1-7.8v-.1H377.9l-23.2 46.3c-5.4 10.8-16.5 17.7-28.6 17.7H185.9c-12.1 0-23.2-6.8-28.6-17.7L134.1 320H33v.1c-.6 2.5-1 5.1-1 7.8zM421.1 88.2C417.5 74 404.7 64 390 64H122c-14.7 0-27.5 10-31 24.2L41 288h93.1c12.1 0 23.2 6.8 28.6 17.7l23.2 46.3h140.2l23.2-46.3c5.4-10.8 16.5-17.7 28.6-17.7H471L421.1 88.2zM0 416v-88.1c0-5.2.6-10.4 1.9-15.5l58-231.9C67 52 92.6 32 122 32h268c29.4 0 55 20 62.1 48.5l58 231.9c1.3 5.1 1.9 10.3 1.9 15.5V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm176-272h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-32 80h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalInboxIn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInboxIn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v249.4l-84.7-84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l112-112c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 265.4V16zM48 352h66.3c6.1 0 11.6 3.4 14.3 8.8l14.4 28.7c8.1 16.3 24.8 26.5 42.9 26.5h140.2c18.2 0 34.8-10.3 42.9-26.5l-28.6-14.3 28.6 14.3 14.3-28.6c2.7-5.4 8.3-8.8 14.3-8.8H464c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm306.7-5.5-14.3 28.6c-2.7 5.4-8.2 8.8-14.3 8.8H185.9c-6.1 0-11.6-3.4-14.3-8.8l-14.3-28.6c-8.1-16.3-24.8-26.5-42.9-26.5H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-66.3c-18.2 0-34.8 10.3-42.9 26.5z"
        }
    ]
};

const FalInboxOut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInboxOut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m272 54.6 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-112-112c-6.2-6.2-16.4-6.2-22.6 0l-112 112c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L240 54.6V304c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6zM48 352h66.3c6.1 0 11.6 3.4 14.3 8.8l14.4 28.7c8.1 16.3 24.8 26.5 42.9 26.5h140.2c18.2 0 34.8-10.3 42.9-26.5l-28.6-14.3 28.6 14.3 14.3-28.6c2.7-5.4 8.3-8.8 14.3-8.8H464c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm306.7-5.5-14.3 28.6c-2.7 5.4-8.2 8.8-14.3 8.8H185.9c-6.1 0-11.6-3.4-14.3-8.8l-14.3-28.6c-8.1-16.3-24.8-26.5-42.9-26.5H48c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-66.3c-18.2 0-34.8 10.3-42.9 26.5z"
        }
    ]
};

const FalInbox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInbox",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416v-88.1c0-2.6.3-5.2 1-7.8v-.1h101.1l23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7h140.2c12.1 0 23.2-6.8 28.6-17.7l23.2-46.3H479v.1c.6 2.5 1 5.1 1 7.8V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zm439-128h-93.1c-12.1 0-23.2 6.8-28.6 17.7L326.1 352H185.9l-23.2-46.3c-5.4-10.8-16.5-17.7-28.6-17.7H41L90.9 88.2C94.5 74 107.3 64 122 64h268c14.7 0 27.5 10 31 24.2L471 288zM0 327.9V416c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-88.1c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122c-29.4 0-55 20-62.1 48.5l-58 231.9c-1.3 5-1.9 10.2-1.9 15.5z"
        }
    ]
};

const FalInboxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInboxes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m34.7 192-1.4 3.4c-.8 2-1.2 4-1.2 6.2V272c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16v-70.4c0-2.1-.4-4.2-1.2-6.2l-1.4-3.4h-73.6c-6.1 0-11.6 3.4-14.3 8.8l-14.3 28.6c-8.2 16.3-24.8 26.6-43 26.6H179.8c-18.2 0-34.8-10.3-42.9-26.5l-14.3-28.6c-2.7-5.4-8.3-8.8-14.3-8.8H34.7zM48 160h60.2c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8h152.5c6.1 0 11.6-3.4 14.3-8.8l14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5H464L414.8 41.8l29-12.1-29 12.1c-2.5-6-8.3-9.8-14.8-9.8H112c-6.5 0-12.3 3.9-14.8 9.8L48 160zM3.7 183.1l64-153.6C75.1 11.7 92.6 0 112 0h288c19.4 0 36.9 11.7 44.3 29.5l64 153.6c2.4 5.8 3.7 12.1 3.7 18.5V272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-70.4c0-6.3 1.3-12.6 3.7-18.5zM114.3 384H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-66.3c-6.1 0-11.6 3.4-14.3 8.8L369 421.5l-28.6-14.3 14.3-28.6c8.1-16.3 24.8-26.5 42.9-26.5H464c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V400c0-26.5 21.5-48 48-48h66.3c18.2 0 34.8 10.3 42.9 26.5l14.3 28.6c2.7 5.4 8.3 8.8 14.3 8.8h140.3c6.1 0 11.6-3.4 14.3-8.8l28.6 14.4c-8.1 16.3-24.8 26.5-42.9 26.5H185.9c-18.2 0-34.8-10.3-42.9-26.5l-14.3-28.6c-2.7-5.4-8.3-8.8-14.3-8.8z"
        }
    ]
};

const FalIndent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIndent",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 80 0 72.8 0 64zm192 128c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 112h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zM0 448c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm32-236.2v88.4L85.7 256 32 211.8zm89 31.8c7.8 6.4 7.8 18.3 0 24.7l-94.8 78.1C15.7 355 0 347.6 0 334.1V177.9c0-13.5 15.7-20.9 26.2-12.4l94.8 78.1z"
        }
    ]
};

const FalIndianRupeeSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIndianRupeeSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H202.5c28.7 23.2 48.3 57.3 52.6 96H304c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48.9c-8 72-69 128-143.1 128H65.9l183.4 131c7.2 5.1 8.9 15.1 3.7 22.3s-15.1 8.9-22.3 3.7L6.7 317C1 313-1.4 305.7.8 299.1S9 288 16 288h96c56.4 0 103.1-41.7 110.9-96H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h206.9c-7.8-54.3-54.4-96-110.9-96H16C7.2 64 0 56.8 0 48z"
        }
    ]
};

const FalIndustryWindows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIndustryWindows",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v149.3c0 5.9 3.2 11.3 8.5 14.1s11.5 2.5 16.4-.8l138.7-92.5c5.3-3.5 12.4.3 12.4 6.7v81.9c0 6 3.4 11.5 8.7 14.2s11.8 2.3 16.6-1.3l138-99.3c5.3-3.8 12.7 0 12.7 6.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V80zm16-48c-26.5 0-48 21.5-48 48v336c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V158.9c0-32.6-36.9-51.5-63.4-32.5L368 207.5v-50.7c0-31.9-35.6-51-62.2-33.3L192 199.4V80c0-26.5-21.5-48-48-48H80zm56 272c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm104 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24zm32 40v-32h32v32h-32zm120-64c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24h-48zm40 64h-32v-32h32v32zm-288 0v-32h32v32h-32z"
        }
    ]
};

const FalIndustry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIndustry",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 64c-8.8 0-16 7.2-16 16v336c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V158.9c0-6.5-7.4-10.3-12.7-6.5l-138 99.3c-4.9 3.5-11.3 4-16.6 1.3s-8.7-8.2-8.7-14.2v-82c0-6.4-7.1-10.2-12.4-6.7l-138.7 92.5c-4.9 3.3-11.2 3.6-16.4.8s-8.5-8.2-8.5-14.1V80c0-8.8-7.2-16-16-16H80zM32 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v119.4l113.8-75.9c26.6-17.7 62.2 1.3 62.2 33.3v50.6l112.6-81.1c26.5-19.1 63.4-.1 63.4 32.5V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V80z"
        }
    ]
};

const FalInfinity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInfinity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 233.5C0 157.5 61.5 96 137.5 96c39.3 0 76.7 16.8 102.7 46.1l79.8 89.8 79.8-89.8C425.9 112.8 463.3 96 502.5 96c76 0 137.5 61.5 137.5 137.5v45.1c0 75.9-61.5 137.4-137.5 137.4-39.3 0-76.7-16.8-102.7-46.1L320 280.1l-79.8 89.8c-26.1 29.3-63.5 46.1-102.7 46.1C61.5 416 0 354.5 0 278.5v-45zM298.6 256l-82.3-92.6c-20-22.5-48.7-35.4-78.8-35.4C79.2 128 32 175.2 32 233.5v45.1C32 336.8 79.2 384 137.5 384c30.1 0 58.8-12.9 78.8-35.4l82.3-92.6zm42.8 0 82.3 92.6c20 22.5 48.7 35.4 78.8 35.4 58.3 0 105.5-47.2 105.5-105.5v-45c0-58.3-47.2-105.5-105.5-105.5-30.1 0-58.8 12.9-78.8 35.4L341.4 256z"
        }
    ]
};

const FalInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInfo",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM16 176c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v272h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V192H32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalInhaler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInhaler",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m542.5 93.5-113-28.2-16.7 62.2-25.8-25.8 14-51.8c3.4-12.6 16.3-20.2 29-17l128 32c6.3 1.6 11.6 5.6 14.9 11.2s4.1 12.2 2.4 18.4L533.2 248l-25.8-25.8 35.1-128.7zM380.7 186l-9.3 34.5c-5.6 21-24.6 35.5-46.4 35.5h-93c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h224c3.6 0 6.8-2.4 7.7-5.9l37.1-136L380.7 186zM530 290c4.1 4.1 5.6 10 4.1 15.5l-39.5 145C489.8 467.9 474 480 456 480H232c-22.1 0-40-17.9-40-40V264c0-22.1 17.9-40 40-40h93.1c7.2 0 13.6-4.9 15.4-11.8l16.5-61.3c3.2-11.9 18.1-15.9 26.8-7.2L530 290zM8 256a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm96 48a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-72 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-72 24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalInputNumeric = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInputNumeric",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h512zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm32 112c0 8.8 7.2 16 16 16h16v128h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V176c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zm168.7 27.4c9.4-11.3 26.2-12.6 37.2-2.9 10.8 9.5 11.9 25.9 2.5 36.7l-76.6 88.3c-4.1 4.7-5.1 11.4-2.5 17.1s8.3 9.4 14.6 9.4h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H275l53.6-61.9c20.9-24.2 18.4-60.7-5.6-81.8-24.6-21.5-62-18.5-82.9 6.5l-12.4 14.9c-5.7 6.8-4.7 16.9 2 22.5s16.9 4.7 22.5-2l12.4-14.9z"
        }
    ]
};

const FalInputPipe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInputPipe",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm128 48v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalInputText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInputText",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm176 32c6.5 0 12.4 4 14.9 10.1l64 160c3.3 8.2-.7 17.5-8.9 20.8s-17.5-.7-20.8-8.9l-8.8-22h-80.8l-8.8 21.9c-3.3 8.2-12.6 12.2-20.8 8.9s-12.2-12.6-8.9-20.8l64-160c2.4-6.1 8.3-10.1 14.9-10.1zm0 59.1L148.4 288h55.1L176 219.1zM288 176c0-8.8 7.2-16 16-16h56c30.9 0 56 25.1 56 56 0 12.1-3.8 23.3-10.4 32.5C421.5 258.4 432 276 432 296c0 30.9-25.1 56-56 56h-72c-8.8 0-16-7.2-16-16V176zm72 96h-40v48h56c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16zm0-32c13.3 0 24-10.7 24-24s-10.7-24-24-24h-40v48h40z"
        }
    ]
};

const FalIntegral = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIntegral",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 32c-22.1 0-40 17.9-40 40v368c0 39.8-32.2 72-72 72s-72-32.2-72-72v-24c0-8.8 7.2-16 16-16s16 7.2 16 16v24c0 22.1 17.9 40 40 40s40-17.9 40-40V72c0-39.8 32.2-72 72-72s72 32.2 72 72v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V72c0-22.1-17.9-40-40-40z"
        }
    ]
};

const FalInterrobang = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalInterrobang",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 160c0-53 43-96 96-96h32c53 0 96 43 96 96 0 25.2-11.9 48.9-32 64l-60.8 45.6c-1.1.8-2.2 1.7-3.2 2.5V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16v-12c0-17.6 8.3-34.2 22.4-44.8l60.8-45.6c28.2-21.2 44.8-54.3 44.8-89.6 0-70.7-57.3-128-128-128h-32C73.3 32 16 89.3 16 160c0 8.8 7.2 16 16 16s16-7.2 16-16zm112 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalIntersection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIntersection",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 480c8.8 0 16-7.2 16-16V224c0-88.4 71.6-160 160-160s160 71.6 160 160v240c0 8.8 7.2 16 16 16s16-7.2 16-16V224c0-106-86-192-192-192S0 118 0 224v240c0 8.8 7.2 16 16 16z"
        }
    ]
};

const FalIslandTropical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalIslandTropical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M150.8 96H66.9c9.4-27.7 42.2-64 109.1-64 45.5 0 75.1 16.8 92.3 35.9 4.4 4.9 11.2 6.6 17.4 4.3 13.8-5 30.5-8.2 50.3-8.2 66.9 0 99.7 36.3 109.1 64H260.8c-4.2 0-8.3 1.7-11.3 4.7L133.9 248.2c-13-26.2-15.4-75 31.8-122.3l.1-.1c11.4-11.4 22.8-19.8 33.9-26 7.7-4.3 10.5-14 6.3-21.7s-14-10.5-21.7-6.3C173 78.1 161.8 86 150.8 96zM176 0C91.6 0 45.8 49.5 34.7 92.2 29.1 113.6 47.7 128 64 128h58.1c-37.5 52.8-32.9 107.4-13.7 140.3 11.2 19.1 34.5 16.2 46.1 4.6l83.1-83.1c-.4 3.9-.9 7.9-1.4 12.1-5.3 40.7-17 94.1-42.4 150.1H160c-70.7 0-128 57.3-128 128 0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32 0-65-48.4-118.6-111.1-126.9 19.6-64.1 20.6-123.6 16.1-168.7-.9-8.7-1.9-16.8-3.1-24.4H448c16.3 0 34.9-14.4 29.3-35.8C466.2 81.5 420.4 32 336 32c-19 0-36.1 2.5-51.4 6.9C260.8 16.5 224.7 0 176 0zm109.4 160c1.4 8.4 2.7 17.6 3.7 27.6 4.4 44 3.2 102.1-17.4 164.4h-43c23-54.6 34-106.1 39.2-145.9 2.3-18 3.5-33.6 4-46.1h13.5zm2.6 224c53 0 96 43 96 96H64c0-53 43-96 96-96h128z"
        }
    ]
};

const FalItalic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalItalic",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-85L135.3 448H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h85L248.7 64H144c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalJ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJ",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32c8.8 0 16 7.2 16 16v272c0 88.4-71.6 160-160 160S0 408.4 0 320v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 70.7 57.3 128 128 128s128-57.3 128-128V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalJackOLantern = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJackOLantern",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272.6 96.7c-13.2 1.1-26.1 3.8-38.3 7.7l41.1-94c2.8-6.3 9-10.4 15.8-10.4h1.2c2.3 0 4.7.5 6.8 1.4l42.3 18.1c6.4 2.7 10.5 9 10.5 15.9V108c-10.2-4-20.9-7.1-32-9.1V45.1l-20.9-9-26.5 60.6zm-94.7 38c-4 3.2-7.3 6.9-10 10.9-5.3-1-10.6-1.5-16-1.5-31.3 0-60.9 17.1-83.3 47.4S32 264.3 32 312s14.3 90.3 36.7 120.6 52 47.4 83.3 47.4c20.7 0 40.6-7.5 58.1-21.2 5.8-4.5 13.9-4.5 19.7 0 17.6 13.7 37.5 21.2 58.2 21.2s40.6-7.5 58.1-21.2c5.8-4.5 13.9-4.5 19.7 0 17.6 13.7 37.5 21.2 58.2 21.2 31.3 0 60.9-17.1 83.3-47.4S544 359.7 544 312s-14.3-90.3-36.7-120.6-52-47.4-83.3-47.4c-5.4 0-10.8.5-16 1.5-2.7-4-6-7.7-10-10.9-6.2-4.9-12.7-9.5-19.5-13.6 14.3-5.8 29.5-9 45.5-9 43.8 0 82.2 24.1 109 60.4s43 85.7 43 139.6-16.1 103.3-43 139.6S467.8 512 424 512c-24.7 0-47.8-7.7-68-20.9-20.2 13.3-43.3 20.9-68 20.9s-47.8-7.7-68-20.9c-20.2 13.3-43.3 20.9-68 20.9-43.8 0-82.2-24.1-109-60.4S0 365.9 0 312s16.1-103.3 43-139.6S108.2 112 152 112c15.9 0 31.2 3.2 45.5 9-6.8 4.1-13.3 8.6-19.5 13.6zm40 49.9c-6.9 5.5-17 4.4-22.5-2.5s-4.4-17 2.5-22.5c24.6-19.8 56-31.6 90-31.6s65.4 11.8 90 31.6c6.9 5.5 8 15.6 2.5 22.5s-15.6 8-22.5 2.5c-19.2-15.4-43.5-24.6-70-24.6s-50.8 9.2-70 24.6zm2.5 29.4 32 40c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5L208 249.6 188.5 274c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l32-40c3-3.8 7.6-6 12.5-6s9.5 2.2 12.5 6zm160 0 32 40c5.5 6.9 4.4 17-2.5 22.5s-17 4.4-22.5-2.5L368 249.6 348.5 274c-5.5 6.9-15.6 8-22.5 2.5s-8-15.6-2.5-22.5l32-40c3-3.8 7.6-6 12.5-6s9.5 2.2 12.5 6zm55.3 76c12.7-7.5 30.1-6.6 41.6 4.9 7.1 7.1 11.3 18.1 8 29.6-4.3 14.8-16 44-46.1 69.4C409 419.4 361.5 440 288 440s-121-20.6-151.4-46.2c-30.1-25.4-41.9-54.6-46.1-69.4-3.3-11.5 1-22.5 8-29.6 11.5-11.5 28.9-12.4 41.6-4.9 21.5 12.6 73.9 38 147.8 38s126.4-25.4 147.8-38zm18.1 27.2c-.6-.1-1.3.1-1.9.4C427.3 332.1 369.3 360 288 360c-5.4 0-10.8-.1-16-.4v8.4c0 8.8-7.2 16-16 16s-16-7.2-16-16v-11.3c-56.2-7.8-96.5-27.6-116.1-39.1-.6-.3-1.3-.5-1.9-.4-.1 0-.2 0-.3.1 3.5 11.3 12.8 33 35.5 52.2 5.4 4.5 11.6 9 18.8 13.2.7-8.2 7.6-14.6 15.9-14.6 8.8 0 16 7.2 16 16v12.7c21 6.8 47.3 11.3 80 11.3 17.9 0 33.8-1.3 48-3.6V384c0-8.8 7.2-16 16-16s16 7.2 16 16v12.7c22.2-7.2 38.6-17.1 50.7-27.4 22.8-19.2 32-40.9 35.5-52.2h-.3z"
        }
    ]
};

const FalJarWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJarWheat",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 16c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm208 80c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h192zM64 64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm80 384c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h8c44.2 0 80-35.8 80-80 0-8.8-7.2-16-16-16h-24c-26.2 0-49.4 12.6-64 32-14.6-19.4-37.8-32-64-32H72c-8.8 0-16 7.2-16 16 0 44.2 35.8 80 80 80h8v16zm34.7-48c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zM96 368c20.9 0 38.7 13.4 45.3 32H136c-20.9 0-38.7-13.4-45.3-32H96zm82.7-176c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zm85.3-48c0-8.8-7.2-16-16-16h-24c-26.2 0-49.4 12.6-64 32-14.6-19.4-37.8-32-64-32H72c-8.8 0-16 7.2-16 16 0 44.2 35.8 80 80 80h48c44.2 0 80-35.8 80-80zM96 160c20.9 0 38.7 13.4 45.3 32H136c-20.9 0-38.7-13.4-45.3-32H96zm82.7 136c6.6-18.6 24.4-32 45.3-32h5.3c-6.6 18.6-24.4 32-45.3 32h-5.3zm85.3-48c0-8.8-7.2-16-16-16h-24c-26.2 0-49.4 12.6-64 32-14.6-19.4-37.8-32-64-32H72c-8.8 0-16 7.2-16 16 0 44.2 35.8 80 80 80h48c44.2 0 80-35.8 80-80zM96 264c20.9 0 38.7 13.4 45.3 32H136c-20.9 0-38.7-13.4-45.3-32H96z"
        }
    ]
};

const FalJar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJar",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 0h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16S55.2 0 64 0zm0 96c-17.7 0-32 14.3-32 32v64h256v-64c0-17.7-14.3-32-32-32H64zM32 224v128h256V224H32zm0 160v64c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-64H32zM0 128c0-35.3 28.7-64 64-64h192c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"
        }
    ]
};

const FalJedi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJedi",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c8.8 0 16 7.2 16 16v264.9l36.1-24.1c3.2-2.1 7.4-1.7 10.1 1s3.1 6.9 1 10.1l-23.9 35.8 42.2 8.4c3.7.7 6.4 4 6.4 7.8s-2.7 7.1-6.4 7.8l-42.2 8.4 23.9 35.8c2.1 3.2 1.7 7.4-1 10.1s-6.9 3.1-10.1 1L304 359.1v71.7c54.3-7.8 96-54.4 96-110.9 0-36.2-17.1-68.3-43.8-88.8-4.2-3.2-6.5-8.3-6.2-13.6s3.2-10.1 7.8-12.8C397.5 181 424 137.6 424 88c0-20.3-4.5-39.6-12.4-56.9-3-6.5-1.3-14.1 4-18.8s13.2-5.2 19.1-1.4C510 59.3 560 143.8 560 240c0 150.2-121.8 272-272 272S16 390.2 16 240c0-96.2 50-180.7 125.3-229.1 6-3.8 13.8-3.3 19.1 1.4s7 12.3 4 18.8C156.5 48.4 152 67.7 152 88c0 49.6 26.5 93 66.2 116.8 4.5 2.7 7.4 7.5 7.8 12.8s-2 10.4-6.2 13.6C193.1 251.7 176 283.8 176 320c0 56.4 41.7 103.1 96 110.9v-71.8l-36.1 24.1c-3.2 2.1-7.4 1.7-10.1-1s-3.1-6.9-1-10.1l23.9-35.8-42.2-8.4c-3.7-.7-6.4-4-6.4-7.8s2.7-7.1 6.4-7.8l42.2-8.4-23.9-35.8c-2.1-3.2-1.7-7.4 1-10.1s6.9-3.1 10.1-1l36.1 23.9V16c0-8.8 7.2-16 16-16zM64.1 153.5l43.2 43.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-31.1-31.1c-2.2 9.9-3.8 20.1-4.7 30.5.8.6 1.6 1.2 2.4 2l56 56c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-35.5-35.5C61.1 385.2 163.5 480 288 480s226.9-94.8 238.8-216.2l-35.5 35.5c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l56-56c.7-.7 1.5-1.4 2.4-2-.9-10.4-2.5-20.5-4.7-30.5l-31.1 31.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l43.2-43.2c-12.7-32.8-32.3-62.1-57.2-86.1.9 6.7 1.3 13.6 1.3 20.6 0 53.6-25.1 101.4-64.2 132.1C416.7 246 432 281.2 432 320c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.8 15.3-74 40.2-99.9C145.1 189.4 120 141.6 120 88c0-7 .4-13.9 1.3-20.6-24.8 24-44.5 53.3-57.2 86.1z"
        }
    ]
};

const FalJetFighterUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJetFighterUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M270.6 9.5C268.1 3.7 262.3 0 256 0s-12.1 3.7-14.6 9.5l-59.9 134.7c-3.6 8.2-5.5 17-5.5 26v40l-.4.3L32 299.3V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h144v3.4l-42.2 66.8c-3.8 6-5.8 13-5.8 20.1 0 20.8 16.9 37.7 37.7 37.7h180.6c20.8 0 37.7-16.9 37.7-37.7 0-7.1-2-14.1-5.8-20.1L336 387.4V384h144v16c0 8.8 7.2 16 16 16s16-7.2 16-16V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v27.3l-143.6-88.9-.4-.3v-40c0-9-1.9-17.8-5.5-26L270.6 9.5zM480 352H336V247.8l144 89.1V352zm-304 0H32v-15.1l144-89.1V352zm34.8-194.8L256 55.4l45.2 101.8c1.8 4.1 2.8 8.5 2.8 13V392c0 3 .9 6 2.5 8.5l44.6 70.7c.6.9.9 2 .9 3.1 0 3.2-2.6 5.7-5.7 5.7H272v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64h-74.3c-3.2 0-5.7-2.6-5.7-5.7 0-1.1.3-2.1.9-3.1l44.6-70.7c1.6-2.6 2.5-5.5 2.5-8.5V170.2c0-4.5.9-8.9 2.8-13z"
        }
    ]
};

const FalJetFighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJetFighter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32h23.9l104.7 144H224V32zm160.2 176h106c1.9 0 3.8.3 5.6 1l107.6 40.3c2.8 1 4.6 3.7 4.6 6.6s-1.8 5.6-4.6 6.6L495.8 303c-1.8.7-3.7 1-5.6 1H160c-4.2 0-8.3 1.7-11.3 4.7l-38.6 38.6c-3 3-7.1 4.7-11.3 4.7H80c-8.8 0-16-7.2-16-16v-64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-64c0-8.8 7.2-16 16-16h18.7c4.2 0 8.3 1.7 11.3 4.7l38.6 38.6c3 3 7.1 4.7 11.3 4.7h224.3zM32 272v64c0 26.5 21.5 48 48 48h18.7c12.7 0 24.9-5.1 33.9-14.1l34-33.9H192v144c-8.8 0-16 7.2-16 16s7.2 16 16 16h112c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16.6l104.7-144h98.1c5.8 0 11.5-1 16.9-3.1l107.6-40.3c15.3-5.7 25.4-20.3 25.4-36.6s-10.1-30.9-25.4-36.6l-107.6-40.3c-5.4-2-11.1-3.1-16.9-3.1h-98.1L287.4 32H304c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16s7.2 16 16 16v144h-25.4l-33.9-33.9c-9-9-21.2-14.1-33.9-14.1H80c-26.5 0-48 21.5-48 48v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16zm192 208V336h128.6L247.9 480H224z"
        }
    ]
};

const FalJoint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJoint",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 16v27c0 42.4 16.9 83.1 46.9 113.1l21 21c18 18 28.1 42.4 28.1 67.9v27c0 8.8-7.2 16-16 16s-16-7.2-16-16v-27c0-17-6.7-33.3-18.7-45.3l-21-21C436.2 142.7 416 93.9 416 43V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm160 256v-27c0-42.4-16.9-83.1-46.9-113.1l-21-21c-18-18-28.1-42.5-28.1-67.9V16c0-8.8 7.2-16 16-16s16 7.2 16 16v27c0 17 6.7 33.3 18.7 45.3l21 21c36 36 56.2 84.8 56.2 135.8v27c0 8.8-7.2 16-16 16s-16-7.2-16-16zM116.1 452.3c51.8 14 117 27.7 171.9 27.7h35.2l-71.5-85.8-6.6-7.9c-43.9 4.5-90.2 14.9-129.1 25.3-22.9 6.2-45.6 12.8-67.8 20.3 22.3 7.4 45 14.2 67.8 20.3zM284.8 384l71.5 85.7 8.5 10.2h118.4l-71.5-85.8-8.5-10.1H284.8zm160 0 71.5 85.8 8.5 10.2H600c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8H444.8zm-429 25.5c30.1-11 61.1-20.3 92-28.6 52.5-14.2 121-28.9 180.2-28.9h312c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H288c-59.2 0-127.7-14.7-180.2-28.8-30.8-8.3-62-17.8-92-28.6C6.3 451.1 0 442.1 0 432s6.3-19.1 15.8-22.5z"
        }
    ]
};

const FalJoystick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJoystick",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 112a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm32 0c0 56.4-41.7 103.1-96 110.9V320h-32v-97.1c-54.3-7.8-96-54.4-96-110.9C112 50.1 162.1 0 224 0s112 50.1 112 112zM64 304c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm352 112c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-32zM64 352h320c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-32c0-35.3 28.7-64 64-64zM208 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalJugBottle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJugBottle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64V32h64v32h-64zm-32 0H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24v40zm32 96h128c53 0 96 43 96 96v192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256c0-53 43-96 96-96zm0-32C57.3 128 0 185.3 0 256v192c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm128 80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48s48-21.5 48-48v-96c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96zm164 238.6c13.2 10.9 30.1 17.4 48.4 17.4H564c42 0 76-34 76-76 0-19.5-7.4-37.3-19.5-50.8C632.6 372.3 640 355 640 336c0-18.8-7.2-35.9-19-48.8 11.8-13.2 19-30.6 19-49.7 0-28.9-16.7-55.2-42.9-67.5l-4.7-2.2c-11-5.1-23-7.8-35.1-7.8h-88.5c-13.5 0-26.9 3-39.1 8.7l-9.6 4.5c-7.4 3.5-14.1 8.1-19.8 13.7 5.7 11.8 9.9 24.4 12.6 37.7 3.7-9.7 11.1-17.8 20.8-22.3l9.6-4.5c8-3.7 16.7-5.7 25.5-5.7h88.5c7.4 0 14.8 1.6 21.5 4.8l4.7 2.2c14.9 7 24.5 22 24.5 38.5 0 10.9-4.1 20.8-10.9 28.4-11 12.3-10.9 30.9.3 43.1 6.6 7 10.6 16.4 10.6 26.9 0 10.6-4.1 20.2-10.8 27.3-11.4 12.1-11.6 30.9-.5 43.3 7 7.8 11.3 18.1 11.3 29.4 0 24.3-19.7 44-44 44H452.4c-15.5 0-29.3-8-37.1-20.4-1.5 12.5-5.5 24.3-11.3 34.9zM480 104c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v24h32v-24c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v24h32v-24z"
        }
    ]
};

const FalJugDetergent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJugDetergent",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64V32h64v32h-64zm-32 0H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24v40zm32 96h128c53 0 96 43 96 96v192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V256c0-53 43-96 96-96zm0-32C57.3 128 0 185.3 0 256v192c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V256c0-70.7-57.3-128-128-128H128zm128 80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48s48-21.5 48-48v-96c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96z"
        }
    ]
};

const FalJug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalJug",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 85V32h96v53c0 14.2 4.7 28.1 13.5 39.3L363.8 225c13.1 16.9 20.2 37.6 20.2 58.9v4.1H64v-4.1c0-21.3 7.1-42.1 20.2-58.9l78.3-100.7c8.8-11.2 13.5-25 13.5-39.3zm-48-69c0 8.8 7.2 16 16 16v53c0 7.1-2.4 14-6.7 19.6L59 205.3c-17.5 22.5-27 50.1-27 78.6V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V283.9c0-21.8-5.6-43.1-16-61.9 27.6-7.1 48-32.2 48-62 0-35.3-28.7-64-64-64-23.6 0-44.2 12.8-55.3 31.8l-18-23.1C306.4 99 304 92.1 304 85V32c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm250.3 175.5-26.2-33.7c1.1-16.7 15-29.8 31.9-29.8 17.7 0 32 14.3 32 32s-14.3 32-32 32c-2 0-3.9-.2-5.7-.5zM64 384v-64h320v64H64zm0 32h320v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-32z"
        }
    ]
};

const FalK = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalK",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48v416c0 8.8 7.2 16 16 16s16-7.2 16-16V342.6l94.1-94.1 165 225c5.2 7.1 15.2 8.7 22.4 3.4s8.7-15.2 3.4-22.4L149 225.6 315.3 59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L32 297.4V48z"
        }
    ]
};

const FalKaaba = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKaaba",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m544 112-256 80-256-80 256-80 256 80zM22.5 81.5C9.1 85.6 0 98 0 112v288c0 14 9.1 26.4 22.5 30.5l256 80c6.2 1.9 12.9 1.9 19.1 0l256-80C566.9 426.4 576 414 576 400V112c0-14-9.1-26.4-22.5-30.5l-256-80c-6.2-1.9-12.9-1.9-19.1 0l-256 80zM544 191.2l-251.2 78.5c-3.1 1-6.4 1-9.5 0L32 191.2v-45.7l246.5 77c6.2 1.9 12.9 1.9 19.1 0l246.5-77v45.7zm0 33.5v30.5l-20.8 6.5c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l11.2-3.5V400L288 480 32 400V288.8l11.2 3.5c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20L32 255.2v-30.4l241.7 75.5c9.3 2.9 19.3 2.9 28.6 0L544 224.8zm-427.2 57c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l64 20c8.4 2.6 17.4-2.1 20-10.5s-2.1-17.4-10.5-20l-64-20zm352 30.5c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-64 20c-8.4 2.6-13.1 11.6-10.5 20s11.6 13.1 20 10.5l64-20zm-224 9.5c-8.4-2.6-17.4 2.1-20 10.5s2.1 17.4 10.5 20l38.5 12c9.3 2.9 19.3 2.9 28.6 0l38.5-12c8.4-2.6 13.1-11.6 10.5-20s-11.6-13.1-20-10.5l-38.5 12c-3.1 1-6.4 1-9.5 0l-38.5-12z"
        }
    ]
};

const FalKazoo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKazoo",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 144a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm107.3 208c22.8-25.5 36.7-59.1 36.7-96 0-37.3-14.2-71.2-37.4-96.8.2.3.5.5.7.8H576c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-52.7zM482 384h94c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64h-94c-19.8-10.2-42.2-16-66-16s-46.3 5.8-66 16H241.7c-11.8 0-23.4 1.6-34.7 4.8-39.3 11.1-136.7 38.7-184 52.5-13.6 4-23 16.5-23 30.7v80c0 14.2 9.4 26.7 23 30.7 47.3 13.8 144.7 41.4 184 52.5 11.3 3.2 23 4.8 34.7 4.8H350c19.8 10.2 42.2 16 66 16s46.3-5.8 66-16zm-173.3-32h-67c-8.8 0-17.6-1.2-26-3.6l-8.7 30.8 8.7-30.8C176.4 337.3 79.1 309.7 32 296v-80c47.1-13.7 144.4-41.3 183.7-52.4 8.5-2.4 17.2-3.6 26-3.6h67c-22.8 25.5-36.7 59.1-36.7 96s13.9 70.5 36.7 96zm56-147.3c-6.2 6.2-6.2 16.4 0 22.6l28.7 28.7-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l28.7-28.7 28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L438.6 256l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L416 233.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalKerning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKerning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M454.3 23.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-240 480c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l240-480zm-424 81.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l144 288c2.7 5.4 8.3 8.8 14.3 8.8s11.6-3.4 14.3-8.8l144-288c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2L160 364.2 30.3 104.8zm320 302.3 35.6-71.2h188.2l35.6 71.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-144-288c-2.7-5.4-8.2-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-144 288c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2zM480 147.8 558.1 304H401.9L480 147.8z"
        }
    ]
};

const FalKeySkeletonLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKeySkeletonLeftRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M608 128a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm32 0c0 70.7-57.3 128-128 128s-128-57.3-128-128h-96v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16h212c14.2-55.2 64.4-96 124-96 70.7 0 128 57.3 128 128zM32 384a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm-32 0c0-70.7 57.3-128 128-128s128 57.3 128 128h96v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64h64v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v80c0 8.8-7.2 16-16 16H252c-14.2 55.2-64.3 96-124 96C57.3 512 0 454.7 0 384z"
        }
    ]
};

const FalKeySkeleton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKeySkeleton",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256c79.5 0 144-64.5 144-144S383.5 0 304 0 160 64.5 160 144c0 34 11.8 65.2 31.5 89.9L4.7 420.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 432 80 390.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L102.6 368l111.5-111.5C238.8 276.2 270 288 304 288z"
        }
    ]
};

const FalKey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKey",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 176c0-79.5 64.5-144 144-144s144 64.5 144 144-64.5 144-144 144c-11.1 0-22-1.3-32.4-3.6-5.4-1.2-11 .4-14.9 4.3L257.4 352H208c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v48H32v-81.4l162.8-162.8c4.2-4.2 5.7-10.5 3.9-16.2-4.4-13.8-6.7-28.4-6.7-43.7zM336 0c-97.2 0-176 78.8-176 176 0 15.1 1.9 29.8 5.5 43.9L4.7 380.7c-3 3-4.7 7.1-4.7 11.3v104c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-48h40c4.2 0 8.3-1.7 11.3-4.7l30-30c10 1.8 20.2 2.7 30.7 2.7 97.2 0 176-78.8 176-176S433.2 0 336 0zm32 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalKeyboardBrightnessLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKeyboardBrightnessLow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm-24-160a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm296 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM96 408a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalKeyboardBrightness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKeyboardBrightness",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M115.3 172.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l88 88c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-88-88zM304 224c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v128zm132.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l88-88c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-88 88zM0 400c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm208-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FalKeyboardDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKeyboardDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v160c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm184 8h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V88c0-8.8 7.2-16 16-16zM72 184c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16v-16zM88 72h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V88c0-8.8 7.2-16 16-16zm176 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V88zm112-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V88c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V88zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-312 24c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm128 281.4 116.7-116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 473.4z"
        }
    ]
};

const FalKeyboardLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKeyboardLeft",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h352zM224 64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H224zm8 88v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zm-16 112v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm112-208c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zm-16 112v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm112-112c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zm-16 112v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm112-112c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zm-16 112v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm16 80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16h-16zm-216 24c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM107.3 187.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L38.6 256l68.7-68.7z"
        }
    ]
};

const FalKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKeyboard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm88 8h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zM72 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16v-16zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm80-176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-16 112c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-280-8h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalKeynote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKeynote",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zM240 0c-20.9 0-38.7 13.4-45.3 32H184c-44.2 0-80 35.8-80 80v48H93.7c-18.2 0-34.8 10.3-42.9 26.5L5.1 277.9c-3.3 6.7-5.1 14-5.1 21.5V352c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-52.7c0-7.5-1.7-14.8-5.1-21.5l-45.7-91.3c-8.1-16.3-24.8-26.5-42.9-26.5H136v-48c0-26.5 21.5-48 48-48h10.7c6.6 18.6 24.4 32 45.3 32h64c26.5 0 48-21.5 48-48S330.5 0 304 0h-64zM32 352v-32h448v32H32zm3.8-64 43.6-87.2c2.7-5.4 8.3-8.8 14.3-8.8h324.6c6.1 0 11.6 3.4 14.3 8.8l43.6 87.2H35.8zM144 480c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96v-64h-32v64h-96z"
        }
    ]
};

const FalKhanda = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKhanda",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M266.2 3.7c-5.9-4.9-14.6-4.9-20.5 0l-48 40c-5.9 4.9-7.5 13.2-3.8 19.9l.1.1.3.6c.3.5.7 1.3 1.2 2.3 1 2 2.6 5 4.4 8.6.5.9.9 1.9 1.4 2.9C167.1 97.4 144 134 144 176s23.1 78.6 57.3 97.8c-.5 1-1 2-1.4 2.9-1.8 3.7-3.3 6.6-4.4 8.6-.5 1-.9 1.8-1.2 2.3l-.3.6-.1.1c-3.6 6.7-2 15 3.8 19.9l42.3 35.3v19.1l-34.6-23.8-41.1-28.2c-42.8-29.4-68.4-78-68.4-130 0-31.1 9.2-61.6 26.5-87.5l2.8-4.2c4-6 3.5-14-1.3-19.5s-12.7-7-19.2-3.7L112 80l-7.2-14.3h-.1l-.3.2-1 .5c-.8.4-2 1.1-3.5 1.9C97 70 93 72.5 88.1 75.7c-9.7 6.4-22.5 16.1-35.4 29C26.9 130.4 0 170.3 0 224c0 53.1 26.4 100.5 51.2 133.6 12.6 16.7 25.1 30.3 34.5 39.7 4.7 4.7 8.7 8.4 11.5 10.9 1.4 1.3 2.5 2.2 3.3 2.9l.9.8.3.2.1.1 10.3-12.3-10.2 12.3c5.1 4.3 12.4 4.9 18.2 1.6l75.6-43 32.7 22.5-45.8 31.5c-2.1-.6-4.2-.9-6.5-.9-13.3 0-24 10.7-24 24s10.7 24 24 24c11.9 0 21.8-8.7 23.7-20.1l40.2-27.7v28.1c-9.6 5.5-16 15.9-16 27.7 0 17.7 14.3 32 32 32s32-14.3 32-32c0-11.8-6.4-22.2-16-27.7v-28.8l40.2 27.6c1.5 11.8 11.6 21 23.8 21 13.3 0 24-10.7 24-24s-10.7-24-24-24c-2 0-3.9.2-5.7.7l-45.5-31.3 32.7-22.5 75.6 43c5.8 3.3 13 2.7 18.2-1.6L401.1 400l10.2 12.3.1-.1.3-.2.9-.8c.8-.7 1.9-1.7 3.3-2.9 2.8-2.5 6.7-6.2 11.5-10.9 9.4-9.4 21.9-23 34.5-39.7 24.8-33.1 51.2-80.5 51.2-133.6 0-53.7-26.9-93.6-52.7-119.3-12.9-12.9-25.8-22.6-35.4-29-4.8-3.2-8.9-5.7-11.8-7.3-1.5-.8-2.6-1.5-3.5-1.9l-1-.5-.3-.2h-.1l-7.2 14.3 7.2-14.3c-6.5-3.2-14.3-1.7-19.2 3.7s-5.3 13.4-1.3 19.5l2.8 4.2c17.3 25.9 26.5 56.4 26.5 87.5 0 51.9-25.6 100.6-68.4 130L307.6 339 272 363.3v-19.8l42.2-35.2c5.9-4.9 7.5-13.2 3.8-19.9l-.1-.1-.3-.6c-.3-.5-.7-1.3-1.2-2.3-1-2-2.6-5-4.4-8.6-.5-.9-.9-1.9-1.4-2.9C344.9 254.6 368 218 368 176s-23.1-78.6-57.3-97.8c.5-1 1-2 1.4-2.9 1.8-3.7 3.3-6.6 4.4-8.6.5-1 .9-1.8 1.2-2.3l.3-.6.1-.1c3.6-6.7 2-15-3.8-19.9l-48-40zm31.3 103.9c23 14 38.4 39.4 38.4 68.4s-15.4 54.3-38.4 68.4C288.1 221 280 195 280 176s8.1-45 17.6-68.4zm-83.1 136.8c-23-14-38.4-39.4-38.4-68.4s15.4-54.3 38.4-68.4C223.9 131 232 157 232 176s-8.1 45-17.6 68.4zm14.2-183.2-.5-1.1L256 36.8l27.9 23.3-.5 1.1c-3.9 7.8-9 18.8-14.2 31.3-4.6 11-9.3 23.7-13.2 36.8-3.9-13.1-8.7-25.8-13.2-36.8-5.2-12.5-10.3-23.5-14.2-31.3zm14.2 198.4c4.6-11 9.3-23.7 13.2-36.8 3.9 13.1 8.7 25.8 13.2 36.8 5.2 12.5 10.3 23.5 14.2 31.3l.5 1.1-27.9 23.2-27.9-23.3.5-1.1c3.9-7.8 9-18.8 14.2-31.3zM70.2 132.7c-4.1 15.6-6.2 31.7-6.2 47.9 0 62.5 30.8 121 82.2 156.4l20 13.8-52.1 29.7c-1.7-1.6-3.7-3.5-5.8-5.7-8.6-8.6-20.1-21-31.5-36.3C53.6 307.5 32 266.9 32 224c0-39 17.9-69.4 38.2-91.3zM481.1 224c0 42.9-21.6 83.5-44.8 114.4-11.4 15.3-22.9 27.7-31.5 36.3-2.1 2.1-4.1 4-5.8 5.7l-52.1-29.7 20-13.8c51.5-35.4 82.2-93.9 82.2-156.4 0-16.3-2.1-32.4-6.2-47.9 20.2 21.9 38.2 52.3 38.2 91.3z"
        }
    ]
};

const FalKidneys = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKidneys",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M115.7 352c-33.4 0-52.1-14.3-64.3-35.8C37.8 292.5 32 258.9 32 224c0-39 12.1-89.3 35.6-129 23.5-39.6 54.7-63 92.1-63 39.7 0 77.1 22.4 85.8 52.9 6 21.1-2.7 49.4-25.5 75.1-28.7 32.4-24.6 71.3-22 95.6.2 1.6.3 3.2.5 4.7 4.9 49.1-33.6 91.6-82.7 91.6zm0 32c68.1 0 121.3-58.9 114.6-126.8l-.3-2.8c-.6-6.1-1.2-12.2-1.6-18.3l18.8 9.4c5.4 2.7 8.8 8.3 8.8 14.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V259.8c0-18.2-10.3-34.8-26.5-42.9L231.8 202c2.4-7.2 6.2-14.1 12-20.7 26.6-30 42.6-69.3 32.4-105.1C262.2 26.9 207.7 0 159.7 0 53.7 0 0 135.2 0 224c0 74.9 24.3 160 115.7 160zM394.2 86.1c.1-.4.3-.8.4-1.2 8.6-30.5 46-52.9 85.7-52.9 37.4 0 68.5 23.4 92.1 63 23.5 39.7 35.6 90 35.6 129 0 34.9-5.8 68.5-19.4 92.2-12.2 21.4-31 35.8-64.3 35.8-49.1 0-87.6-42.5-82.7-91.6.1-1.5.3-3 .5-4.7 2.6-24.3 6.7-63.2-22-95.6-23.7-26.7-32.4-54.2-25.9-73.9zm-30.4-10c-11.8 35.8 5.8 75.2 32.4 105.1 5.8 6.6 9.6 13.5 12 20.7l-29.7 14.8c-16.2 8.3-26.5 24.9-26.5 43.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16V259.8c0-6.1 3.4-11.6 8.8-14.3l18.8-9.4c-.3 6-.9 12.1-1.6 18.3l-.3 2.8C403 325.1 456.2 384 524.3 384c91.4 0 115.7-85.1 115.7-160 0-88.8-53.7-224-159.7-224-48 0-102.5 26.9-116.5 76.2z"
        }
    ]
};

const FalKipSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKipSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32c8.8 0 16 7.2 16 16v174.4L325.9 35.6c6.9-5.6 16.9-4.5 22.5 2.3s4.5 16.9-2.3 22.5L125.1 240H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H125.1l221 179.6c6.9 5.6 7.9 15.6 2.3 22.5s-15.7 7.9-22.5 2.3L96 289.6V465c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalKitMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKitMedical",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 448h320V64H128v384zm-32 0V64H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h32zM64 32h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm416 416h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-32v384zM272 144h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32v-32c0-17.7 14.3-32 32-32zm0 32v48c0 4.2-1.7 8.3-4.7 11.3s-7.1 4.7-11.3 4.7h-48v32h48c8.8 0 16 7.2 16 16v48h32v-48c0-8.8 7.2-16 16-16h48v-32h-48c-8.8 0-16-7.2-16-16v-48h-32z"
        }
    ]
};

const FalKitchenSet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKitchenSet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm143.1-96c-8 72-69 128-143.1 128C64.5 288 0 223.5 0 144S64.5 0 144 0c74.1 0 135.2 56 143.1 128h67.6c6.6-18.6 24.4-32 45.3-32h96c26.5 0 48 21.5 48 48s-21.5 48-48 48h-96c-20.9 0-38.7-13.4-45.3-32h-67.6zM272 320h48v-32c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v112c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V352h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 0h96v-32h-96v32zm-32 32v112c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16V352H320zm176-224h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-304 16a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0zM0 496c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm160-144v32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16zm0-32h16c26.5 0 48 21.5 48 48s-21.5 48-48 48h-16c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-80c0-8.8 7.2-16 16-16h112zm-32 64v-32H64v64h64v-32z"
        }
    ]
};

const FalKite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKite",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M338.2 50.8 273 344.4 457.4 160 341.1 43.7c-1.3 2.2-2.3 4.5-2.8 7.1zm-79.3 357.1-5.4 1.2-88.2 88.2c-9.4 9.4-22.1 14.6-35.3 14.6-27.6.1-50-22.3-50-49.8V316.3l-55.8 33.4c-4.9 3-11.1 3-16.1.2S0 341.8 0 336v-96c0-5.8 3.1-11.1 8.1-13.9s11.2-2.8 16.1.2L80 259.7V208c0-26.5-21.5-48-48-48H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c44.2 0 80 35.8 80 80v51.7l55.8-33.5c4.9-3 11.1-3 16.1-.2s8.1 8.2 8.1 13.9v96c0 5.8-3.1 11.1-8.1 13.9s-11.2 2.8-16.1-.2L112 316.3v145.8c0 9.9 8 17.9 17.9 17.9 4.8 0 9.3-1.9 12.7-5.3l88.2-88.2 1.2-5.4 75-337.2A55.96 55.96 0 0 1 361.7 0H584c30.9 0 56 25.1 56 56v222.3c0 26.2-18.2 49-43.9 54.7l-337.2 74.9zM480 182.6 295.6 367l293.6-65.2c2.6-.6 4.9-1.5 7.1-2.8L480 182.6zM608 56v-1.3L502.6 160 608 265.4V56zm-24-24H374.6L480 137.4 585.3 32H584zM32 268.3v39.5L64.9 288 32 268.3zm128 39.5v-39.5L127.1 288l32.9 19.7z"
        }
    ]
};

const FalKiwiBird = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKiwiBird",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 384c33.9 0 65.3-10.5 91.2-28.5 33.7-23.4 78.2-51.5 130.4-51.5H464c44.2 0 80-35.8 80-80s-35.8-80-80-80h-50.4c-52.2 0-96.7-28.1-130.4-51.5C257.3 74.5 225.9 64 192 64c-88.4 0-160 71.6-160 160s71.6 160 160 160zm311.3-55.1 40.7 73.4v-99.9c-11.4 11.6-25.2 20.7-40.7 26.5zM546 471.8l-75.5-136c-2.1.1-4.3.2-6.5.2h-50.4c-41.2 0-78.3 22.3-112.1 45.8-13.9 9.7-29.2 17.5-45.4 23.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-50.7c-10.4 1.7-21.1 2.7-32 2.7-22.4 0-44-3.8-64-10.9V464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-73.7C38.6 357.1 0 295.1 0 224 0 118 86 32 192 32c40.7 0 78.4 12.6 109.4 34.2 33.8 23.5 71 45.8 112.1 45.8H464c61.9 0 112 50.1 112 112v240c0 7.3-4.9 13.7-12 15.5s-14.5-1.3-18-7.7zM448 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalKiwiFruit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKiwiFruit",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 176c0-25.2-15.9-52.4-50.9-74.9C330.4 78.8 280.6 64 224 64S117.6 78.8 82.9 101.1C47.9 123.6 32 150.8 32 176s15.9 52.4 50.9 74.9C117.6 273.2 167.4 288 224 288s106.4-14.8 141.1-37.1c35-22.5 50.9-49.7 50.9-74.9zm32 0v80c0 123.7-100.3 224-224 224S0 379.7 0 256v-80C0 96.5 100.3 32 224 32s224 64.5 224 144zm-32 74.2C376.8 292 305.5 320 224 320S71.2 292 32 250.2v5.8c0 106 86 192 192 192s192-86 192-192v-5.8zM280 176c0 13.3-25.1 24-56 24s-56-10.7-56-24 25.1-24 56-24 56 10.7 56 24zm-40-88v24c0 8.8-7.2 16-16 16s-16-7.2-16-16V88c0-8.8 7.2-16 16-16s16 7.2 16 16zm-84.7 12.7 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm160 0c6.2 6.2 6.2 16.4 0 22.6l-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0zM96 160h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-148.7 75.3-16 16c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm128-22.6 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM240 240v24c0 8.8-7.2 16-16 16s-16-7.2-16-16v-24c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalKnifeKitchen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKnifeKitchen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m485.7 33-175 175 76.2 76.2 45-25c5.1-2.8 8.2-8.2 8.2-14v-31.9c0-12.7 5.1-24.9 14.1-33.9l89-89c.6-.6 1-1.5 1-2.3s-.3-1.7-1-2.3L490.3 33c-.6-.6-1.5-1-2.3-1s-1.7.3-2.3 1zM488 0c9.4 0 18.3 3.7 25 10.3L565.7 63c6.6 6.6 10.3 15.6 10.3 25s-3.7 18.3-10.3 25l-89 89c-3 3-4.7 7.1-4.7 11.3v31.9c0 17.4-9.4 33.5-24.7 42l-45 25c-12.5 6.9-28.1 4.8-38.2-5.3L288 230.6c-12.5-12.5-12.5-32.8 0-45.3l175-175C469.7 3.7 478.6 0 488 0zM4.7 468.7l238-238.1 22.6 22.6L46.6 472c21.7 5.1 43.9 8 65.4 8 99.8 0 165.6-39.9 232.5-102.4l-9-9c-12.5-12.5-12.5-32.7 0-45.2l33 33c11.5 12.6 11.3 32.2-1.3 43.9-70.6 66-144 111.7-255.2 111.7-33.9 0-68.6-6.3-100.8-16.8-11.2-3.7-14.9-18.1-6.5-26.5zM416 144a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalKnife = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalKnife",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 9.7c5.8-6.2 13.8-9.7 22.3-9.7 12.3 0 24.1 7.6 28.2 20.4 5 15.9 13.6 49.2 13.6 91.6 0 49.1-15.6 86.8-42.9 123.7-22.7 30.6-54 61.2-91 97.4-6.5 6.4-13.2 12.9-20 19.6l-9.8 9.8c-13.9 13.9-32.7 21.7-52.3 21.7s-38.4-7.8-52.3-21.7l-42-42L27.7 506.9c-6 6.5-16.2 6.8-22.6.8s-6.8-16.2-.8-22.6l185.3-198.6L448 9.7zM223.5 297.1l42.8 42.8c7.9 7.9 18.5 12.3 29.7 12.3s21.8-4.4 29.7-12.3l9.9-9.9.1-.1c7.1-7 13.9-13.7 20.5-20.1 37.2-36.4 66.3-64.9 87.3-93.2C467.4 184.2 480 153 480 112c0-34.9-6.5-63-10.9-78L223.5 297.1z"
        }
    ]
};

const FalL = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalL",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32c8.8 0 16 7.2 16 16v400h240c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalLacrosseStickBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLacrosseStickBall",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 32c-44.3 0-83.7 28.4-97.7 70.4l-.8 2.4c-6.2 18.8-14.3 43-31.6 64.2l-34.4 42c-12.6 15.4-19.5 34.7-19.5 54.7 0 47.7 38.7 86.3 86.3 86.3 19.9 0 39.2-6.9 54.7-19.5l42-34.4c21.1-17.3 45.2-25.3 64-31.5l1.8-.6.8-.3c42-14 70.4-53.3 70.4-97.6v-.4c0-28.8-18.4-62.8-45.6-90.1-27.2-27.2-61.2-45.6-90-45.6h-.4zm.3-32c40.8 0 82.5 24.8 112.7 55s55 71.9 55 112.7v.3c0 58.1-37.2 109.7-92.3 128.1l-.8.3c-19.8 6.6-39.1 13-55.6 26.5l-42 34.4c-21.1 17.3-47.6 26.7-74.9 26.7-26.9 0-51.7-9-71.6-24.1L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l147.4-147.4C137 317.4 128 292.6 128 265.7c0-27.3 9.5-53.8 26.7-74.9l34.4-42c13.5-16.5 19.9-35.8 26.5-55.6l.3-.8C234.3 37.2 285.9 0 344 0h.3zM544 432a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FalLacrosseStick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLacrosseStick",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 32h.4c28.8 0 62.8 18.4 90 45.6 27.2 27.2 45.6 61.2 45.6 90.1v.4c0 44.3-28.4 83.6-70.4 97.6l-.8.3-1.8.6c-18.7 6.2-42.9 14.3-64 31.5l-42 34.4c-15.4 12.6-34.7 19.5-54.7 19.5-47.7 0-86.3-38.7-86.3-86.3 0-19.9 6.9-39.2 19.5-54.7l34.4-42c17.3-21.1 25.4-45.4 31.6-64.2l.8-2.4c14-42 53.4-70.4 97.7-70.4zm113 23C426.8 24.8 385.1 0 344.3 0h-.3c-58.1 0-109.7 37.2-128.1 92.3l-.3.8c-6.6 19.8-13 39.1-26.5 55.6l-34.4 42c-17.3 21.1-26.7 47.6-26.7 74.9 0 26.9 9 51.7 24.1 71.6L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l147.4-147.4c19.9 15.1 44.7 24.1 71.6 24.1 27.3 0 53.8-9.4 74.9-26.7l42-34.4c16.5-13.5 35.8-19.9 55.6-26.5l.8-.3c55.1-18.4 92.3-70 92.3-128.1v-.3c0-40.8-24.8-82.5-55-112.7z"
        }
    ]
};

const FalLambda = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLambda",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h123.5c6.2 0 11.9 3.6 14.5 9.3l7.6 16.5-.3-.1-160 368c-3.5 8.1.2 17.5 8.3 21.1s17.5-.2 21.1-8.3l148.7-342.2 149.5 323.8c7.8 17 24.9 27.9 43.6 27.9H432c8.8 0 16-7.2 16-16s-7.2-16-16-16h-59.5c-6.2 0-11.9-3.6-14.5-9.3L183.1 59.9c-7.8-17-24.9-27.9-43.6-27.9H16z"
        }
    ]
};

const FalLampDesk = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLampDesk",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M381.3 96H480L288 288v-98.7c0-8.5-3.4-16.6-9.4-22.6l-38.1-38.1c-10.5-10.6-16.5-25-16.5-40 0-31.3 25.3-56.6 56.6-56.6 15 0 29.4 6 40 16.6l38.1 38.1c6 6 14.1 9.4 22.6 9.4zm0-32-38.1-38.1C326.6 9.3 304.1 0 280.6 0 231.7 0 192 39.7 192 88.6c0 21.7 7.9 42.5 22.2 58.6l-97.5 97.5c-4 4-5.6 9.9-4.1 15.4L171.2 480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H204.3l-58.5-219.2 90.8-90.8 19.4 19.3V288c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l192-192c9.2-9.2 11.9-22.9 6.9-34.9S493 64 480 64h-98.7zm-2.6 223.9C391 298 406.8 304 424 304c39.8 0 72-32.2 72-72 0-17.2-6-33-16.1-45.4L457 209.5c4.4 6.4 7 14.2 7 22.5 0 22.1-17.9 40-40 40-8.4 0-16.1-2.6-22.5-7l-22.8 22.8z"
        }
    ]
};

const FalLampFloor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLampFloor",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m224 32-64 160h320L416 32H224zm-29.7-11.9C199.1 8 210.9 0 224 0h192c13.1 0 24.9 8 29.7 20.1l64 160c3.9 9.9 2.7 21-3.2 29.8S490.6 224 480 224H160c-10.6 0-20.5-5.3-26.5-14.1s-7.2-20-3.2-29.8l64-160zM208 480h96V256h32v224h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalLampStreet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLampStreet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 168C32 92.9 92.9 32 168 32c72.7 0 132 57 135.8 128.7-83.1 6.9-151.1 66.7-170.3 145.6-6.2 25.5 14.8 45.7 37.5 45.7h298c22.7 0 43.7-20.2 37.5-45.7-19.3-79-87.5-138.9-170.7-145.7C332 71.3 258.3 0 168 0 75.2 0 0 75.2 0 168v328c0 8.8 7.2 16 16 16s16-7.2 16-16V168zm288 24c75.2 0 138.4 51.9 155.4 121.9.3 1.4 0 2.6-1 3.8-1.1 1.3-3 2.3-5.5 2.3H171c-2.4 0-4.4-1-5.5-2.3-1-1.1-1.3-2.4-1-3.8C181.6 243.9 244.8 192 320 192zm-78.4 192c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64h-33.1c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32h-33.1z"
        }
    ]
};

const FalLamp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLamp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 32 32 224h384L336 32H112zM82.5 19.7C87.4 7.8 99.1 0 112 0h224c12.9 0 24.6 7.8 29.5 19.7l80 192c4.1 9.9 3 21.2-2.9 30.1S426.7 256 416 256H32c-10.7 0-20.7-5.3-26.6-14.2s-7-20.2-2.9-30.1l80-192zM160 312.2V288h32v24.2c0 14.8-6.7 27.8-16.5 36.6-6.8 6.1-19.3 18.4-29.8 34.1-10.7 16-17.7 32.9-17.7 49.1 0 17.1 5.8 31.8 12.1 42.6 1 1.7 4.8 5.4 14.4 5.4h139c9.7 0 13.5-3.7 14.4-5.4 6.3-10.8 12.1-25.5 12.1-42.6 0-16.2-7-33.1-17.7-49.1-10.5-15.7-23-28-29.8-34.1-9.8-8.8-16.5-21.8-16.5-36.6V288h32v24.2c0 4.9 2.2 9.5 5.9 12.8 15.8 14.3 58.1 57 58.1 107 0 24.4-8.3 44.6-16.4 58.7-8.5 14.7-25.2 21.3-42.1 21.3h-139c-17 0-33.6-6.6-42.1-21.3C104.3 476.6 96 456.4 96 432c0-50 42.3-92.7 58.1-107 3.6-3.3 5.9-7.9 5.9-12.8z"
        }
    ]
};

const FalLandMineOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLandMineOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM192 400h288.8c6.3 0 12.1 3.7 14.6 9.5l31.4 70.5H113.2l31.3-70.5c2.6-5.8 8.3-9.5 14.6-9.5H192zm32-32v-32c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v32H224zm224 0v-32c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v32h-32.8c-19 0-36.2 11.2-43.9 28.5L84 467c-9.4 21.2 6.1 45 29.2 45h413.6c23.2 0 38.6-23.8 29.2-45l-31.3-70.5c-7.7-17.3-24.9-28.5-43.9-28.5H448zM57.6 131.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4l128 96c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-128-96zm547.2 3.2c-5.3-7.1-15.3-8.5-22.4-3.2l-128 96c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l128-96c7.1-5.3 8.5-15.3 3.2-22.4z"
        }
    ]
};

const FalLandmarkDome = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLandmarkDome",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c8.8 0 16 7.2 16 16v16.7c87.9 7.2 159 73.7 173.3 159.3H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h18.7C81 106.3 152.1 39.9 240 32.7V16c0-8.8 7.2-16 16-16zM99.2 192h313.6C398 119 333.4 64 256 64S114 119 99.2 192zM64 352v-96h32v96h80v-96h32v96h96v-96h32v96h80v-96h32v96c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-40 80c0-8.8 7.2-16 16-16h432c8.8 0 16 7.2 16 16s-7.2 16-16 16H40c-8.8 0-16-7.2-16-16zM0 496c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalLandmarkFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLandmarkFlag",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 32v32h64V32h-64zm80 64h-80v32h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h192V16c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16zM48 368c0-8.8 7.2-16 16-16V192h32v160h80V192h32v160h96V192h32v160h80V192h32v160c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zm-24 64c0-8.8 7.2-16 16-16h432c8.8 0 16 7.2 16 16s-7.2 16-16 16H40c-8.8 0-16-7.2-16-16zM0 496c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalLandmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLandmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8 0 178 14 192 31.2 192h449.6c17.2 0 31.2-14 31.2-31.2 0-11.2-6-21.6-15.8-27.1L263.9 2.1zM256 34.4 477.7 160H34.3L256 34.4zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h384c8.8 0 16-7.2 16-16s-7.2-16-16-16V224h-32v128h-80V224h-32v128h-96V224h-32v128H96V224H64v128zm-40 80c0 8.8 7.2 16 16 16h432c8.8 0 16-7.2 16-16s-7.2-16-16-16H40c-8.8 0-16 7.2-16 16zM0 496c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalLanguage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLanguage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 96v320H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h240zm32 0h240c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H336V96zm304 32c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128zm-465.1 42.1c-2.5-6.1-8.4-10.1-14.9-10.1s-12.4 4-14.9 10.1l-64 160c-3.3 8.2.7 17.5 8.9 20.8s17.5-.7 20.8-8.9l8.8-21.9h80.7l8.8 21.9c3.3 8.2 12.6 12.2 20.8 8.9s12.2-12.6 8.9-20.8l-64-160zm-14.9 49 27.6 68.9h-55.2l27.6-68.9zM496 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h121.2l-.2.6c-8.2 22.6-21.4 42.9-38.2 59.4l-.8-.8-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l20.9 20.9c-5 3.2-10.1 6.2-15.5 8.8l-17.3 8.6c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l17.3-8.6c9.1-4.6 17.8-9.8 26-15.7 5.9 4.4 12.1 8.6 18.4 12.4l18.9 11.3c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-18.9-11.3c-3.4-2-6.7-4.1-9.9-6.4 19.1-19.4 34.1-42.9 43.6-69l4.2-11.6h4.8c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64V176z"
        }
    ]
};

const FalLaptopArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLaptopArrowDown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32h144v32H128c-17.7 0-32 14.3-32 32v256H64V96c0-35.3 28.7-64 64-64zm384 32H368V32h144c35.3 0 64 28.7 64 64v256h-32V96c0-17.7-14.3-32-32-32zM76.8 448h486.4c20.3 0 37.4-13.5 42.9-32H33.9c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384h601.6c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2zM336 48v217.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalLaptopBinary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLaptopBinary",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64h384c17.7 0 32 14.3 32 32v256h32V96c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v256h32V96c0-17.7 14.3-32 32-32zM33.9 416h572.2c-5.5 18.5-22.6 32-42.9 32H76.8c-20.3 0-37.4-13.5-42.9-32zm-14.7-32C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h486.4c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2H19.2zM200 128c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40h-16zm-8 40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-32zm112-40c-8.8 0-16 7.2-16 16s7.2 16 16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16h-16zm80 40v32c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-32c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v32c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8zM192 272c-8.8 0-16 7.2-16 16s7.2 16 16 16v48h32v-64c0-8.8-7.2-16-16-16h-16zm256 16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16v48h32v-64zm-80 24c0-22.1-17.9-40-40-40h-16c-22.1 0-40 17.9-40 40v40h32v-40c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v40h32v-40z"
        }
    ]
};

const FalLaptopCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLaptopCode",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64h384c17.7 0 32 14.3 32 32v256h32V96c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v256h32V96c0-17.7 14.3-32 32-32zM33.9 416h572.2c-5.5 18.5-22.6 32-42.9 32H76.8c-20.3 0-37.4-13.5-42.9-32zm-14.7-32C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h486.4c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2H19.2zm264.1-212.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L230.6 224l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"
        }
    ]
};

const FalLaptopFile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLaptopFile",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 32H128c-17.7 0-32 14.3-32 32v224h224v32H33.9c5.5 18.5 22.7 32 42.9 32H320v32H76.8C34.4 384 0 349.6 0 307.2 0 296.6 8.6 288 19.2 288H64V64c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v32h-32V64c0-17.7-14.3-32-32-32zm-64 432c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16V288h-80c-26.5 0-48-21.5-48-48v-80h-80c-8.8 0-16 7.2-16 16v288zm128-303.5V240c0 8.8 7.2 16 16 16h79.5c-.7-2.8-2.1-5.4-4.2-7.4l-83.9-83.9c-2.1-2.1-4.6-3.5-7.4-4.2zm30.1-18.4L626 226c9 9 14.1 21.2 14.1 33.9V464c0 26.5-21.5 48-48 48H400c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h108.1c12.7 0 24.9 5.1 33.9 14.1z"
        }
    ]
};

const FalLaptopMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLaptopMedical",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64h384c17.7 0 32 14.3 32 32v256h32V96c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v256h32V96c0-17.7 14.3-32 32-32zM33.9 416h572.2c-5.5 18.5-22.6 32-42.9 32H76.8c-20.3 0-37.4-13.5-42.9-32zm-14.7-32C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h486.4c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2H19.2zM304 112c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48z"
        }
    ]
};

const FalLaptopMobile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLaptopMobile",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32h320c17.7 0 32 14.3 32 32v32h32V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v224H19.2C8.6 288 0 296.6 0 307.2 0 349.6 34.4 384 76.8 384H352v-32H76.8c-20.3 0-37.4-13.5-42.9-32H352v-32H96V64c0-17.7 14.3-32 32-32zm288 144c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16H432c-8.8 0-16-7.2-16-16V176zm-32 0v288c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48H432c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalLaptopSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLaptopSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM500.3 480l-40.5-32h-383c-20.3 0-37.4-13.5-42.9-32h385.3l-40.5-32H19.2C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h423.5zM544 351.5l.7.5H576V96c0-35.3-28.7-64-64-64H139.4l40.5 32H512c17.7 0 32 14.3 32 32v255.5zM64 135.6V352h32V160.8l-32-25.2z"
        }
    ]
};

const FalLaptop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLaptop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64H128c-17.7 0-32 14.3-32 32v256H64V96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v256h-32V96c0-17.7-14.3-32-32-32zM76.8 448h486.4c20.3 0 37.4-13.5 42.9-32H33.9c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384h601.6c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2z"
        }
    ]
};

const FalLariSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLariSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32c8.8 0 16 7.2 16 16v50.7c10.4-1.7 21.1-2.7 32-2.7s21.6.9 32 2.7V48c0-8.8 7.2-16 16-16s16 7.2 16 16v58.9c62.8 22.2 110.7 76.2 124.2 142.7 1.8 8.7-3.8 17.1-12.5 18.9s-17.1-3.8-18.9-12.5c-10.5-51.6-45.7-94.1-92.8-114.7V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V131.2c-10.3-2.1-21-3.2-32-3.2s-21.7 1.1-32 3.2V272c0 8.8-7.2 16-16 16s-16-7.2-16-16V141.3C71.5 166 32 222.4 32 288c0 88.4 71.6 160 160 160h176c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h69.8C34.1 413.6 0 354.8 0 288c0-83.6 53.4-154.7 128-181.1V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalLassoSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLassoSparkles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 0c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V96h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V16c0-8.8 7.2-16 16-16zM0 176C0 85.4 112 10.8 256 1.1v32C129.7 42 32 102.6 32 176c0 47.1 40.2 88.9 102.4 115.2 5.5 2.3 11.2 4.5 17 6.6C190.9 311.9 237.8 320 288 320c141.4 0 256-64.5 256-144 0-45.5-37.5-86-96-112.4v-34C525.2 61.2 576 115 576 176c0 97.2-128.9 176-288 176-22.9 0-45.3-1.6-66.7-4.7 11.9 17.2 18.7 38 18.7 59.7 0 58-47 105-105 105H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h87c40.3 0 73-32.7 73-73 0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176zm512 192v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalLasso = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLasso",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 176c0 97.2-128.9 176-288 176-22.9 0-45.3-1.6-66.7-4.7 11.9 17.2 18.7 38 18.7 59.7 0 58-47 105-105 105H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h87c40.3 0 73-32.7 73-73 0-27.6-15.6-52.9-40.4-65.3l-34.9-17.4C52.9 293 0 238.3 0 176 0 78.8 128.9 0 288 0s288 78.8 288 176zM288 320c141.4 0 256-64.5 256-144S429.4 32 288 32 32 96.5 32 176s114.6 144 256 144z"
        }
    ]
};

const FalLayerGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLayerGroup",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9l-217.4 97.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5-64.5 29 210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9l-217.6 97.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zm45.9-148.6 39.1 17.5-64.5 29 210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9l-217.6 97.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z"
        }
    ]
};

const FalLayerMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLayerMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 64h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H408c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-141.8 68.7c6.9-3.1 14.3-4.7 21.8-4.7s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9l-217.4 97.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l217.4-97.5zM288 160c-3 0-6 .6-8.8 1.9L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1c-2.8-1.2-5.7-1.9-8.8-1.9zM48.8 358.1l45.9-20.6 39.1 17.5-64.5 29 210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9l-217.6 97.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9z"
        }
    ]
};

const FalLayerPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLayerPlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 24c0-8.8-7.2-16-16-16s-16 7.2-16 16v40h-40c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v40c0 8.8 7.2 16 16 16s16-7.2 16-16V96h40c8.8 0 16-7.2 16-16s-7.2-16-16-16h-40V24zM288 128c-7.5 0-15 1.6-21.8 4.7L48.8 230.1C38.6 234.7 32 244.8 32 256s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9l-217.4-97.4c-6.9-3.1-14.3-4.7-21.8-4.7zm-8.8 33.9c2.8-1.2 5.7-1.9 8.8-1.9s6 .6 8.8 1.9l210 94.1-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 256l210-94.1zM94.7 337.5l-45.9 20.6C38.6 362.7 32 372.8 32 384s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9l-45.9-20.6-39.1 17.5 64.5 29-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 384l64.5-28.9-39.1-17.6z"
        }
    ]
};

const FalLeafHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeafHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 128h104c37.4 0 71.5-14.3 97.1-37.7 4.5 21.1 6.9 43.3 6.9 66.3 0 149-98.2 258.9-207.2 259.4h-.8c-79.5 0-144-64.5-144-144s64.5-144 144-144zm191.2-73.7C442.6 79.8 411.2 96 376 96H272c-97.2 0-176 78.8-176 176 0 2.5.1 4.9.2 7.4-.1-2.4-.2-4.9-.2-7.4 0-4 .1-8 .4-12-55.2 35.7-92.4 96.9-95 167.1L0 463.4c-.3 8.8 6.6 16.3 15.4 16.6s16.3-6.6 16.6-15.4l1.3-36.3c2-52.5 26.7-98.9 64.7-129.9C110.7 383.1 183.8 448 272 448h1c132.1-.7 239-130.9 239-291.4 0-33.9-4.8-66.5-13.5-96.8l-.4-1.5c-1.1-3.6-2.2-7.2-3.4-10.8s-2.4-7.1-3.7-10.6c-2.6-6.9-12.7-6.6-16.2-.1-1.4 2.7-3 5.3-4.6 7.8-2 3.1-4.1 6.1-6.4 8.9l-.6.8zM97.7 296.6c.1.6.2 1.2.3 1.7l-.3-1.7zm124-53.8c0-11.9 9.6-21.5 21.5-21.5h1.5c6 0 11.7 2.3 16 6.5l16.1 15.6c6.2 6 16.1 6 22.3 0l16.1-15.6c4.3-4.2 10.1-6.5 16-6.5h1.5c11.9 0 21.5 9.6 21.5 21.5 0 5.8-2.3 11.4-6.5 15.4L288 316.4l-59.8-58.1c-4.2-4-6.5-9.6-6.5-15.4zm21.5-53.5c-29.5 0-53.5 23.9-53.5 53.5 0 14.4 5.8 28.3 16.2 38.4l70.9 69c6.2 6 16.1 6 22.3 0l70.9-69c10.4-10.1 16.2-23.9 16.2-38.4 0-29.5-23.9-53.5-53.5-53.5h-1.5c-14.3 0-28.1 5.6-38.4 15.6l-4.9 4.8-4.9-4.8c-10.3-10-24-15.6-38.4-15.6h-1.5z"
        }
    ]
};

const FalLeafMaple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeafMaple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336.9 7.4C334 2.9 329.1.1 323.7 0s-10.4 2.4-13.5 6.8l-61.6 87.7-.6-33.9c-.1-4.9-2.4-9.5-6.3-12.4s-8.9-4-13.7-2.8l-48.7 12.5-38.4-44.8c-2.9-3.4-7.1-5.4-11.5-5.6s-8.8 1.5-11.9 4.6L70.1 59 18 52.5c-5.3-.7-10.5 1.3-14 5.3S-.8 67.3.5 72.4l42.4 162.4-37.2 31.4c-4.1 3.4-6.2 8.7-5.6 14s3.8 10 8.5 12.4L132 357.4 4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L154.6 380l64.7 123.4c2.5 4.7 7.1 7.9 12.4 8.5s10.5-1.5 14-5.6l31.4-37.2 162.4 42.4c5.1 1.3 10.6 0 14.6-3.5s6-8.7 5.3-14l-5.6-44.4c-.6-4.9 1.1-9.8 4.5-13.2l41.4-41.9c3.1-3.2 4.8-7.5 4.6-11.9s-2.2-8.6-5.6-11.5l-44.8-38.4 12.7-48.7c1.2-4.7.2-9.8-2.8-13.7s-7.5-6.2-12.4-6.3l-33.9-.6 87.7-61.6c4.7-3.3 7.3-8.9 6.7-14.7s-4.2-10.7-9.5-13.1l-41.1-18.1c-7.6-3.3-11.3-11.9-8.7-19.7L481.2 51c1.9-5.6.5-11.9-3.6-16.2s-10.3-6-16-4.3l-81.7 23.4c-6.8 1.9-14.1-.8-17.9-6.8L336.9 7.4zM178.3 356.3l137.9-137.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L155.7 333.7 44.5 275.3l19-16.1c9.4-8 13.4-20.6 10.3-32.5L37.4 87.2l36.4 4.6c4.9.6 9.8-1.1 13.2-4.5L127.8 47l33.7 39.3c4 4.6 10.2 6.6 16.1 5.1l38.7-9.9 1.2 62.6c.1 6.9 4.7 13 11.3 15s13.8-.4 17.8-6.1l76-108.1L335 64.2c11.4 18 33.3 26.3 53.7 20.5l52.5-15-18.9 56.2c-7.9 23.5 3.4 49.2 26.1 59.2l15.2 6.7-104.5 73.6c-5.7 4-8.1 11.2-6.1 17.8s8.1 11.2 15 11.3l62.6 1.2-9.9 38.7c-1.5 5.9.5 12.2 5.1 16.1l39.2 33.7-29.3 29.6c-10.4 10.5-15.4 25.1-13.5 39.7l2.6 21-139.5-36.3c-11.9-3.1-24.6.9-32.5 10.3l-16.1 19-58.4-111.2z"
        }
    ]
};

const FalLeafOak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeafOak",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M300 0c-33.3 0-61.7 23.9-67.3 56.7l-1.4 8.2-13.4-10.1c-23.9-18-57.5-15.7-78.7 5.5-13.4 13.4-19.7 32.3-17 51l6.7 47.1c-21.5-5.4-44.9 1.3-60.2 18.8l-6.6 7.5c-19.2 21.9-23.3 53.3-10.2 79.4L64.3 289c7.8 15.6 11.8 32.7 11.8 50.1v74.1L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l74.7-74.7h67.6c17.4 0 34.5 4 50.1 11.8l24.9 12.4c26.1 13.1 57.5 9 79.5-10.2l7.5-6.6c17.5-15.3 24.2-38.7 18.8-60.2l47.1 6.7c18.7 2.7 37.6-3.6 51-17 21.2-21.2 23.5-54.8 5.5-78.7l-10.1-13.4 8.2-1.4c32.8-5.7 56.7-34.1 56.7-67.3 0-22.9-11.4-44.2-30.4-56.9L468 145l5.4-24.8c5.2-23.7-2-48.5-19.2-65.6s-41.9-24.5-65.6-19.3l-24.8 5.4-6.9-10.3C344.2 11.4 322.9 0 300 0zM134 400.6l181.3-181.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L108.1 381.2v-42.1c0-22.4-5.2-44.4-15.2-64.4l-12.4-24.9c-7.2-14.5-5-31.9 5.7-44.1l6.6-7.5c9.4-10.7 25.3-12.8 37.2-4.9 15.5 10.3 35.9-2.5 33.3-21l-9.4-65.6c-1.3-8.8 1.7-17.6 8-23.9 9.9-9.9 25.6-11 36.8-2.6l23.9 18c14.3 10.8 35 2.6 38.1-15.1l3.6-21.1c2.9-17.3 18-30 35.7-30 12.2 0 23.5 6.1 30.2 16.2l6.9 10.3c7.3 11 20.6 16.3 33.5 13.5l24.8-5.4c13.1-2.9 26.7 1.1 36.1 10.6s13.4 23.1 10.6 36.1l-5.4 24.8c-2.8 12.9 2.5 26.2 13.5 33.5l10.3 6.9c10.1 6.7 16.2 18.1 16.2 30.2 0 17.7-12.7 32.8-30.2 35.8l-21.1 3.6c-17.7 3.1-25.9 23.8-15.1 38.1l18 23.9c8.4 11.2 7.3 26.9-2.6 36.8-6.3 6.3-15.1 9.2-23.9 8l-65.6-9.4c-18.4-2.6-31.3 17.8-21 33.3 7.9 11.9 5.8 27.8-4.9 37.2l-7.5 6.6c-12.2 10.7-29.6 12.9-44.1 5.7L234 415.8c-20-10-42-15.2-64.4-15.2H134z"
        }
    ]
};

const FalLeaf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeaf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M132 238.3c23.6-9.3 49.2-14.3 76-14.3h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-28.8 0-56 6.9-80 19.2 1.7 78 65.5 140.8 144 140.8h.8c109-.5 207.2-110.5 207.2-259.4 0-23-2.4-45.2-6.9-66.3-25.6 23.4-59.7 37.7-97.1 37.7H272c-67.9 0-124.9 47-140 110.3zm-35.3 18C104.7 166.4 180.1 96 272 96h104c35.2 0 66.6-16.2 87.2-41.7l.6-.8c2.3-2.9 4.4-5.8 6.4-8.9 1.6-2.5 3.2-5.1 4.6-7.8 3.5-6.5 13.6-6.8 16.2.1 1.3 3.5 2.5 7 3.7 10.6s2.3 7.1 3.4 10.8l.4 1.5c8.8 30.3 13.5 62.8 13.5 96.8 0 160.5-106.9 290.7-239 291.4h-1c-89.4 0-163.2-66.7-174.5-153-40 32.3-65.5 81.7-65.5 137v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-73.9 38.6-138.9 96.7-175.7z"
        }
    ]
};

const FalLeafyGreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeafyGreen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M233.8 27C195.8-9.5 135.4-9 98 28.5c-6 5.9-11 12.3-15 19.2-13 21.9-32.4 42.2-52.1 58.2-2.3 1.8-4.4 3.8-6.5 5.9-25.8 25.8-31.2 64.4-15.9 95.4 5.7 11.7 11 24.1 11 37.1V280c0 14.7 5.8 28.8 16.3 39.2l26.3 26.3c10.4 10.4 16.3 24.5 16.3 39.2v12.9c0 2.9.2 5.8.7 8.7l7.6-7.6c6-6 9.4-14.1 9.4-22.6v-39.2c-3.3-5-7-9.6-11.3-13.9l-26.5-26.3c-4.4-4.4-6.9-10.4-6.9-16.6v-35.7c0-21.1-8.5-39.3-14.3-51.2-9.4-19.2-6-42.9 9.8-58.7l-21.7-21.9L47 134.4c1.3-1.3 2.7-2.5 4-3.6 21.8-17.6 44.1-40.7 59.5-66.8 2.7-4.6 6.1-8.9 10.1-13 25.4-25.4 66.6-25.4 92.1 0l14.7-14.7-14.8 14.8c1.7 1.7 3.2 3.4 4.6 5.1 2.8-6.9 6.2-13.6 10.1-19.8 2-3.2 4.2-6.4 6.4-9.4zM68.7 507.3c6.2 6.2 16.4 6.2 22.6 0l40.6-40.6c12-12 28.3-18.7 45.3-18.7h68.4c17 0 33.3-6.7 45.3-18.7l10.5-10.5c12-12 28.3-18.7 45.3-18.7h43c17 0 33.3-6.7 45.3-18.7l29.1-29.1c10.7-10.7 25-16.4 39.3-21.3 37.5-13.1 64.6-48.9 64.6-91 0-3.4-.2-6.8-.5-10.1-3.1-29.1-2.3-61.5 5-89.9 2.3-8.9 3.5-18.3 3.5-28C576 50.1 525.9 0 464 0c-9.7 0-19 1.2-28 3.5-28.4 7.3-60.8 8.1-89.9 5-3.3-.3-6.7-.5-10.1-.5-42.1 0-77.9 27.1-90.8 64.9-4.9 14.3-10.6 28.6-21.3 39.3l-29.1 29.1c-12 12-18.7 28.3-18.7 45.3v43c0 17-6.7 33.3-18.7 45.3l-10.5 10.5c-12 12-18.7 28.3-18.7 45.3v68.4c0 17-6.7 33.3-18.7 45.3l-40.8 40.3c-6.2 6.2-6.2 16.4 0 22.6zM182.6 416l100.7-100.7 59.3-59.3H432c8.8 0 16-7.2 16-16s-7.2-16-16-16h-57.4l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96-36.7 36.7V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v89.4l-96 96v-62.9c0-8.5 3.4-16.6 9.4-22.6l10.5-10.5c18-18 28.1-42.4 28.1-67.9v-43c0-8.5 3.4-16.6 9.4-22.6l29.1-29.1c16.4-16.4 24-37.1 29-51.5C284.1 58 308 40 336 40c2.3 0 4.6.1 6.8.4 31.7 3.3 68.1 2.7 101.2-5.8 6.4-1.6 13-2.5 20-2.5 44.2 0 80 35.8 80 80 0 6.9-.9 13.6-2.5 20-8.5 33.1-9.2 69.5-5.8 101.2.2 2.2.4 4.5.4 6.8 0 28-18 51.9-43.2 60.6-14.4 4.9-35.2 12.6-51.5 29l-29.1 29.1c-6 6-14.1 9.4-22.6 9.4h-43c-25.5 0-49.9 10.1-67.9 28.1l-10.5 10.5c-6 6-14.1 9.4-22.6 9.4h-63.1z"
        }
    ]
};

const FalLeftFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeftFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.8 257.8c-.5-.5-.8-1.1-.8-1.8s.3-1.4.8-1.8l131.9-124.4c1.2-1.2 2.9-1.8 4.6-1.8 3.7 0 6.7 3 6.7 6.7V192c0 8.8 7.2 16 16 16h120c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H192c-8.8 0-16 7.2-16 16v57.3c0 3.7-3 6.7-6.7 6.7-1.7 0-3.3-.6-4.6-1.8L32.8 257.8zM0 256c0 9.5 3.9 18.6 10.8 25.1l132 124.4c7.2 6.8 16.7 10.5 26.5 10.5 21.4 0 38.7-17.3 38.7-38.7V336h104c22.1 0 40-17.9 40-40v-80c0-22.1-17.9-40-40-40H208v-41.3c0-21.4-17.3-38.7-38.7-38.7-9.9 0-19.3 3.8-26.5 10.5l-132 124.4C3.9 237.4 0 246.5 0 256zm448 176V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v352c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalLeftLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeftLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16S0 71.2 0 80zm320 136h272c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H320c-17.7 0-32 14.3-32 32v49.3c0 3.7-3 6.7-6.7 6.7-1.9 0-3.7-.8-5-2.2L163.8 256l112.5-125.8c1.3-1.4 3.1-2.2 5-2.2 3.7 0 6.7 3 6.7 6.7V184c0 17.7 14.3 32 32 32zm-192 40c0 5.2 1.9 10.1 5.3 14l119.2 133.1c7.3 8.2 17.8 12.9 28.8 12.9 21.4 0 38.7-17.3 38.7-38.7V328h272c26.5 0 48-21.5 48-48v-48c0-26.5-21.5-48-48-48H320v-49.3c0-21.4-17.3-38.7-38.7-38.7-11 0-21.5 4.7-28.8 12.9L133.3 242c-3.4 3.8-5.3 8.8-5.3 14z"
        }
    ]
};

const FalLeftLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeftLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 328v49.3c0 3.7-3 6.7-6.7 6.7-1.9 0-3.7-.8-5-2.2L35.8 256l112.5-125.8c1.3-1.4 3.1-2.2 5-2.2 3.7 0 6.7 3 6.7 6.7V184c0 17.7 14.3 32 32 32h272c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16H192c-17.7 0-32 14.3-32 32zM5.3 242c-3.4 3.9-5.3 8.8-5.3 14s1.9 10.1 5.3 14l119.2 133.1c7.3 8.2 17.8 12.9 28.8 12.9 21.4 0 38.7-17.3 38.7-38.7V328h272c26.5 0 48-21.5 48-48v-48c0-26.5-21.5-48-48-48H192v-49.3c0-21.4-17.3-38.7-38.7-38.7-11 0-21.5 4.7-28.8 12.9L5.3 242z"
        }
    ]
};

const FalLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M502.3 231.3c6.2 6.7 9.7 15.6 9.7 24.7s-3.5 18-9.7 24.7l-84 91a38.29 38.29 0 0 1-28.1 12.3c-21.1 0-38.3-17.1-38.3-38.3V320h-192v25.7c0 21.1-17.1 38.3-38.3 38.3-10.7 0-20.9-4.5-28.1-12.3l-84-91C3.5 274 0 265.2 0 256s3.5-18 9.7-24.7l84-91c7.2-7.8 17.4-12.3 28.1-12.3 21.1 0 38.3 17.1 38.3 38.3V192h192v-25.7c0-21.1 17.1-38.3 38.3-38.3 10.7 0 20.9 4.5 28.1 12.3l84 91zM480 256c0-1.1-.4-2.2-1.2-3l-84-91c-1.2-1.3-2.8-2-4.6-2-3.5 0-6.3 2.8-6.3 6.3V208c0 8.8-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16v-41.7c0-3.5-2.8-6.3-6.3-6.3-1.7 0-3.4.7-4.6 2l-84 91c-.8.8-1.2 1.9-1.2 3s.4 2.2 1.2 3l84 91c1.2 1.3 2.9 2 4.6 2 3.5 0 6.3-2.8 6.3-6.3V304c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v41.7c0 3.5 2.8 6.3 6.3 6.3 1.7 0 3.4-.7 4.6-2l84-91c.8-.8 1.2-1.9 1.2-3z"
        }
    ]
};

const FalLeftToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeftToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 432V80c0-8.8-7.2-16-16-16S0 71.2 0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16zm96.8-174.2c-.5-.5-.8-1.1-.8-1.8s.3-1.4.8-1.8l131.9-124.4c1.2-1.2 2.9-1.8 4.6-1.8 3.7 0 6.7 3 6.7 6.7V192c0 8.8 7.2 16 16 16h120c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H288c-8.8 0-16 7.2-16 16v57.3c0 3.7-3 6.7-6.7 6.7-1.7 0-3.3-.6-4.6-1.8L128.8 257.8zM96 256c0 9.5 3.9 18.6 10.8 25.1l132 124.4c7.2 6.8 16.7 10.5 26.5 10.5 21.4 0 38.7-17.3 38.7-38.7V336h104c22.1 0 40-17.9 40-40v-80c0-22.1-17.9-40-40-40H304v-41.3c0-21.4-17.3-38.7-38.7-38.7-9.9 0-19.3 3.8-26.5 10.5l-132 124.4C99.9 237.4 96 246.5 96 256z"
        }
    ]
};

const FalLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 258.3v-4.6c0-4.4 1.8-8.6 5-11.6L186.8 99.5c2.3-2.2 5.4-3.5 8.7-3.5 6.9 0 12.6 5.6 12.6 12.6V192c0 8.8 7.2 16 16 16h176c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-176c-8.8 0-16 7.2-16 16v83.4c0 6.9-5.6 12.6-12.6 12.6-3.2 0-6.3-1.2-8.7-3.5L37 269.9c-3.2-3-5-7.2-5-11.6zM195.4 64c-11.4 0-22.4 4.4-30.7 12.3L14.9 219C5.4 228 0 240.6 0 253.7v4.6C0 271.4 5.4 284 14.9 293l149.8 142.7c8.3 7.9 19.3 12.3 30.7 12.3 24.6 0 44.6-20 44.6-44.6V336h160c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H240v-67.4C240 84 220 64 195.4 64z"
        }
    ]
};

const FalLemon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLemon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 64c-5.8 0-11.2 1-16.2 2.8-18.9 6.8-44.1 12.9-70.1 7.1-60.7-13.5-128.7 11-178.8 61S28.4 253 41.9 313.7c5.8 26-.3 51.2-7.1 70.1-1.8 5-2.8 10.4-2.8 16.2 0 26.5 21.5 48 48 48 5.8 0 11.2-1 16.2-2.8 18.9-6.8 44.1-12.9 70.1-7.1 60.7 13.5 128.7-11 178.8-61s74.5-118.1 61-178.8c-5.8-26 .3-51.2 7.1-70.1 1.8-5 2.8-10.5 2.8-16.2 0-26.5-21.5-48-48-48zm0-32c44.2 0 80 35.8 80 80 0 9.5-1.7 18.6-4.7 27.1-6 16.7-9.8 35-5.9 52.4 16.4 73.7-13.7 152.4-69.6 208.3s-134.7 86-208.3 69.6c-17.3-3.9-35.7-.1-52.4 5.9-8.4 3-17.6 4.7-27.1 4.7-44.2 0-80-35.8-80-80 0-9.5 1.7-18.6 4.7-27.1 6-16.7 9.8-35 5.9-52.4-16.4-73.6 13.7-152.3 69.6-208.3s134.7-86 208.3-69.6c17.3 3.9 35.7.1 52.4-5.9 8.4-3 17.6-4.7 27.1-4.7zM246.7 134.5l-18.4 8.5c-51.8 23.9-93.4 65.5-117.3 117.3l-8.5 18.4c-3.7 8-13.2 11.5-21.2 7.8s-11.5-13.2-7.8-21.2l8.5-18.4c27.1-58.7 74.3-105.9 133-133l18.4-8.5c8-3.7 17.5-.2 21.2 7.8s.2 17.5-7.8 21.2z"
        }
    ]
};

const FalLessThanEqual = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLessThanEqual",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M406.1 62.8c8.2-3.3 12.1-12.7 8.8-20.9s-12.7-12.1-20.9-8.8l-352 144c-6 2.5-9.9 8.3-9.9 14.8s3.9 12.3 9.9 14.8l352 144c8.2 3.3 17.5-.6 20.9-8.8s-.6-17.5-8.8-20.9L90.3 192 406.1 62.8zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalLessThan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLessThan",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M382.3 72.8c4 7.9.7 17.5-7.2 21.5L51.8 256l323.4 161.7c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-352-176C3.4 267.6 0 262.1 0 256s3.4-11.6 8.8-14.3l352-176c7.9-4 17.5-.7 21.5 7.2z"
        }
    ]
};

const FalLifeRing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLifeRing",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M402.7 425.3C363.4 459.4 312.1 480 256 480s-107.4-20.6-146.7-54.7l91.1-91c15.7 11.1 34.9 17.7 55.6 17.7s39.9-6.6 55.6-17.7l91.1 91zm22.6-22.6-91-91.1c11.1-15.7 17.7-34.9 17.7-55.6s-6.6-39.9-17.7-55.6l91-91.1C459.4 148.6 480 199.9 480 256s-20.6 107.4-54.7 146.7zm22.7 22.7c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L425.4 64C380.2 24.2 320.9 0 256 0S131.8 24.2 86.6 64L75.3 52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L64 86.6C24.2 131.8 0 191.1 0 256s24.2 124.2 64 169.4l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448c45.1 39.8 104.4 64 169.4 64s124.2-24.2 169.4-64l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L448 425.4zM402.7 86.7l-91.1 91.1C295.9 166.6 276.7 160 256 160s-39.9 6.6-55.6 17.7l-91.1-91C148.6 52.6 199.9 32 256 32s107.4 20.6 146.7 54.7zm-225 224.9-91 91.1C52.6 363.4 32 312.1 32 256s20.6-107.4 54.7-146.7l91.1 91.1C166.6 216.1 160 235.3 160 256s6.6 39.9 17.7 55.6zM192 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalLightCeiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightCeiling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c8.8 0 16 7.2 16 16v144.5c123.3 7.6 223 102.5 238 223.6 2.2 17.5-12.4 31.9-30 31.9H32c-17.7 0-32.2-14.4-30-31.9 15-121.2 114.7-216 238-223.6V16c0-8.8 7.2-16 16-16zM34.3 384h443.4C462.2 275.5 368.8 192 256 192S49.8 275.5 34.3 384zM256 512c-38.7 0-71-27.5-78.4-64h33.1c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32h33.1c-7.4 36.5-39.7 64-78.4 64z"
        }
    ]
};

const FalLightEmergencyOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightEmergencyOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M55.2 33.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm-112 0v128h32V192c0-88.4-71.6-160-160-160s-160 71.6-160 160v128h32V192c0-70.7 57.3-128 128-128s128 57.3 128 128zM128 400c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16v-32zm-32 0v32c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48zm224-272c8.8 0 16-7.2 16-16s-7.2-16-16-16c-53 0-96 43-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalLightEmergency = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightEmergency",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 320V192c0-70.7-57.3-128-128-128S96 121.3 96 192v128H64V192c0-88.4 71.6-160 160-160s160 71.6 160 160v128h-32zM48 384c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H48zm0-32h352c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48zm112-160c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-53 43-96 96-96 8.8 0 16 7.2 16 16s-7.2 16-16 16c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FalLightSwitchOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightSwitchOff",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 464v16H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h112v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32h112c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32H208v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM0 448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384zm176-104h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16zm-48 24v-96h128v96c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm0-224c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96H128v-96zM96 368c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v224z"
        }
    ]
};

const FalLightSwitchOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightSwitchOn",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h112v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h112c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H208v16c0 8.8-7.2 16-16 16s-16-7.2-16-16zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm176 104h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-48-24v96h128v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm0 224c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96H128v96zM96 144c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V144z"
        }
    ]
};

const FalLightSwitch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightSwitch",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 48V32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h112v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h112c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H208v16c0 8.8-7.2 16-16 16s-16-7.2-16-16zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm128 304c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96H128v96zm0-224v96h128v-96c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm-32 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V144z"
        }
    ]
};

const FalLightbulbCflOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightbulbCflOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m23.2 1.7 64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-8-4-11.2-13.7-7.2-21.6S15.3-2.3 23.2 1.7zm608 28.6-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 160h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM87.2 318.3l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm480-28.6 64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zM267.9 4.5C302.5-4.1 336 22 336 57.7c0 3.4-.3 6.8-.9 10l76.8-19.2C446.5 39.9 480 66 480 101.7c0 15.6-6.6 29.9-17.3 40 10.6 9.9 17.3 24 17.3 40 0 15.6-6.6 29.9-17.3 40 10.6 9.9 17.3 24 17.3 40 0 25.1-17.1 47.1-41.5 53.2L368 332.5V352h16c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-48v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-48c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h16v-34.5l32-8V352h32v-32c0-7.3 5-13.7 12.1-15.5l82.6-20.7c10.2-2.5 17.3-11.7 17.3-22.1 0-14.8-13.9-25.7-28.3-22.1l-63.8 15.9-64 16h-.1l-63.7 15.9c-34.6 8.7-68.1-17.4-68.1-53.1 0-15.6 6.6-29.9 17.3-40-10.6-9.9-17.3-24-17.3-40 0-15.6 6.6-29.9 17.3-40-10.6-9.9-17.3-24-17.3-40 0-25.1 17.1-47.1 41.5-53.2l66.4-16.6zm84 379.5H256v64h128v-64h-32.1zm-67.8-143.5 146.6-36.7c10.2-2.5 17.3-11.7 17.3-22.1 0-14.8-13.8-25.6-28.2-22.2l-191.7 48-.2.1-18.6 4.6c-10.2 2.5-17.3 11.7-17.3 22.1 0 14.8 13.9 25.7 28.3 22.1l63.8-15.9zm10.4-129.6-66.4 16.6h-.1l-18.8 4.7c-10.2 2.5-17.3 11.7-17.3 22.1 0 14.8 13.8 25.6 28.2 22.2l191.7-47.9.2-.1 18.6-4.6c10.2-2.5 17.3-11.7 17.3-22.1 0-14.8-13.9-25.7-28.3-22.1l-125 31.2h-.1zm9.5-53.2c0-14.8-13.9-25.7-28.3-22.1l-66.4 16.6C199.1 54.7 192 63.8 192 74.3c0 14.8 13.9 25.7 28.3 22.1l66.4-16.6c10.2-2.5 17.3-11.6 17.3-22.1z"
        }
    ]
};

const FalLightbulbCfl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightbulbCfl",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 57.7c0-35.7-33.5-61.8-68.1-53.2L41.5 21.1C17.1 27.2 0 49.2 0 74.3c0 16 6.8 30.1 17.3 40C6.6 124.4 0 138.7 0 154.3c0 16 6.8 30.1 17.3 40C6.6 204.4 0 218.7 0 234.3c0 35.7 33.5 61.8 68.1 53.2l63.7-15.9h.1l64-16 63.8-15.9c14.4-3.6 28.3 7.3 28.3 22.1 0 10.5-7.1 19.6-17.3 22.1l-82.6 20.7c-7.1 1.7-12.1 8.1-12.1 15.4v32h-32v-42.5l-32 8V352H96c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h48c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-16v-19.5l70.5-17.6c24.4-6.1 41.5-28 41.5-53.2 0-16-6.8-30.1-17.3-40 10.8-10.1 17.3-24.4 17.3-40 0-16-6.8-30.1-17.3-40 10.8-10.1 17.3-24.4 17.3-40 0-35.7-33.5-61.8-68.1-53.2l-76.8 19.2c.6-3.3.9-6.6.9-10zM96 384h128v64H96v-64zm174.7-180.2-146.6 36.7-63.8 15.9C45.9 260 32 249.1 32 234.3c0-10.5 7.1-19.6 17.3-22.1l18.6-4.6.2-.1 191.7-47.9c14.3-3.5 28.2 7.4 28.2 22.2 0 10.5-7.1 19.6-17.3 22.1zm-136.2-93 125.2-31.2c14.4-3.6 28.3 7.3 28.3 22.1 0 10.5-7.1 19.6-17.3 22.1l-18.6 4.6-.2.1-191.7 48c-14.4 3.4-28.2-7.4-28.2-22.2 0-10.5 7.1-19.6 17.3-22.1l18.7-4.7h.1l66.4-16.6h.1zm-7.8-31L60.3 96.4C45.9 100 32 89.1 32 74.3c0-10.5 7.1-19.6 17.3-22.1l66.4-16.6C130.1 32 144 42.9 144 57.7c0 10.4-7.1 19.6-17.2 22.1z"
        }
    ]
};

const FalLightbulbDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightbulbDollar",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 176c0 30.6-9.5 58.8-25.7 82.1-4.1 5.9-8.8 12.3-13.6 19-12.7 17.5-27.1 37.2-38 57.1-8.9 16.2-13.7 33.3-16.2 49.9H275c2.2-12 5.9-23.7 11.8-34.5 9.9-18 22.2-34.9 34.5-51.8 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9-10.9-20-25.3-39.7-38-57.1-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176c0-79.5 64.5-144 144-144s144 64.5 144 144zM146.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM112 432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H122.7c-5.9 0-10.7 4.8-10.7 10.7v5.3zm96-344c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7-13 7.7-23.9 21.1-23.8 40.5.1 18.4 10.8 30.1 22.7 37.3 10.5 6.3 23.8 10.4 34.8 13.7l1.6.5c12.5 3.8 22.2 6.9 29 11.2 5.9 3.7 7.7 7 7.7 11.6.1 6.6-2.7 10.8-7.8 14-5.8 3.6-14.5 5.6-23.7 5.3-11.8-.4-22.7-4.1-36.3-8.7-2.3-.8-4.7-1.6-7.1-2.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1 9.2 3.2 19.7 6.8 30.9 8.9V296c0 8.8 7.2 16 16 16s16-7.2 16-16v-17.1c8.7-1.4 17.4-4.3 25.1-9.1 13.3-8.3 23.2-22.2 22.9-41.6-.2-18.5-10.6-30.6-22.7-38.2-11-6.9-25-11.2-36.3-14.6l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9-6-3.6-7.2-6.4-7.3-10.1 0-5.4 2.4-9.4 8.1-12.8 6.2-3.7 15.1-5.7 23.6-5.5 10.1.2 21 2.3 32.1 5.3 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V88z"
        }
    ]
};

const FalLightbulbExclamationOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightbulbExclamationOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m55.2 1.7 64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5S47.3-2.2 55.2 1.7zm544 28.6-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 160h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zM119.2 318.3l-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm416-28.6 64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm-96.8-31.6c16.1-23.3 25.6-51.5 25.6-82.1 0-79.5-64.5-144-144-144S176 96.5 176 176c0 30.6 9.5 58.8 25.7 82.1 4.1 5.9 8.8 12.3 13.6 19 12.7 17.5 27.1 37.2 38 57.1 8.9 16.2 13.7 33.3 16.2 49.9H237c-2.2-12-5.9-23.7-11.8-34.5-9.9-18-22.2-34.9-34.5-51.8-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176 144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4-12.3 16.8-24.6 33.7-34.5 51.8-5.9 10.8-9.6 22.5-11.8 34.5h-32.4c2.5-16.6 7.3-33.7 16.2-49.9 10.9-20 25.3-39.7 38-57.1 4.9-6.7 9.5-13 13.6-19zM320 480c20.9 0 38.7-13.4 45.3-32h-90.6c6.6 18.6 24.4 32 45.3 32zm-80-53.3c0-5.9 4.8-10.7 10.7-10.7h138.6c5.9 0 10.7 4.8 10.7 10.7v5.3c0 44.2-35.8 80-80 80s-80-35.8-80-80v-5.3zM336 112v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalLightbulbExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightbulbExclamation",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 176c0 30.6-9.5 58.8-25.7 82.1-4.1 5.9-8.8 12.3-13.6 19-12.7 17.5-27.1 37.2-38 57.1-8.9 16.2-13.7 33.3-16.2 49.9H275c2.2-12 5.9-23.7 11.8-34.5 9.9-18 22.2-34.9 34.5-51.8 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9-10.9-20-25.3-39.7-38-57.1-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176c0-79.5 64.5-144 144-144s144 64.5 144 144zM146.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM112 432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H122.7c-5.9 0-10.7 4.8-10.7 10.7v5.3zm80-336c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalLightbulbGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightbulbGear",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 176c0 13.7-1.9 27-5.5 39.5 3.3 1 6.5 2.3 9.5 4v-.9c0-17.8 10.2-35.6 28-43.3C367.6 78.4 289 0 192 0 94.8 0 16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9-10.9-20-25.3-39.7-38-57.1-4.9-6.7-9.5-13-13.6-19C57.5 234.8 48 206.6 48 176c0-79.5 64.5-144 144-144s144 64.5 144 144zm-77.5 267c-5.1-8.8-9.3-17.8-12.8-27h-123c-5.9 0-10.7 4.8-10.7 10.7v5.3c0 44.2 35.8 80 80 80 35.2 0 65.1-22.8 75.8-54.4-3.3-4.7-6.4-9.5-9.4-14.6zM192 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80zm-45.3 352h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zm252.6-208.2H433c3 16.6 13.9 29.5 26.5 36.7 12.9 7.4 30 9.9 45.9 3.6l17.2 30.5c-12.8 11.4-18.5 27.7-18.5 42.4s5.7 31 18.5 42.4L505.3 426c-15.9-6.3-32.9-3.7-45.9 3.6-12.6 7.2-23.5 20.2-26.5 36.7h-33.6c-3.1-16.6-14-29.5-26.6-36.7-13-7.4-30-9.9-46-3.7l-17.2-30.5C322.3 384 328 367.7 328 353s-5.7-31-18.5-42.4l17.2-30.5c15.9 6.3 33 3.7 46-3.7 12.6-7.2 23.6-20.1 26.6-36.7zm43.5-32h-53.4c-11.7 0-21.3 9.5-21.3 21.3v1.4c0 7.6-4.6 14.4-11.3 18.2-6.6 3.7-14.7 4.2-21.2.3l-1.6-1c-10.7-6.3-24.4-2.6-30.5 8.2L277 303.1c-5.7 10.2-2.3 23.1 7.8 29 7.3 4.3 11.2 12.6 11.2 21s-3.9 16.7-11.2 21c-10 5.9-13.5 18.8-7.8 29l26.5 46.9c6.1 10.8 19.9 14.5 30.5 8.2l1.6-1c6.5-3.9 14.6-3.4 21.2.3 6.6 3.8 11.3 10.6 11.3 18.2v1.4c0 11.7 9.5 21.3 21.3 21.3h53.4c11.8 0 21.4-9.6 21.4-21.4v-1.6c0-7.5 4.6-14.2 11.1-18 6.5-3.7 14.5-4.2 21-.3l1.8 1c10.7 6.3 24.4 2.6 30.5-8.2l26.4-46.8c5.7-10.2 2.3-23-7.8-29-7.3-4.3-11.2-12.6-11.2-21s3.9-16.7 11.2-21c10-5.9 13.5-18.8 7.8-29l-26.4-46.9c-6.1-10.8-19.9-14.5-30.5-8.2l-1.8 1c-6.5 3.8-14.5 3.4-21-.3-6.5-3.7-11.1-10.4-11.1-18v-1.6c0-11.8-9.6-21.4-21.4-21.4zm-26.7 201.3a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-24-56a24 24 0 1 1 48.1 0 24 24 0 1 1-48.1 0z"
        }
    ]
};

const FalLightbulbOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightbulbOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M55.2 1.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zm544 28.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm544 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zM119.2 318.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-64 32c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l64-32zm416-28.6c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l64 32c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-64-32zM464 176c0 30.6-9.5 58.8-25.7 82.1-4.1 5.9-8.7 12.3-13.6 19-12.7 17.5-27.1 37.2-38 57.1-8.9 16.2-13.7 33.3-16.2 49.9H403c2.2-12 5.9-23.7 11.8-34.5 9.9-18 22.2-34.9 34.5-51.8 5.2-7.1 10.4-14.2 15.4-21.4 19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9-10.9-20-25.3-39.7-38-57.1-4.9-6.7-9.5-13-13.6-19-16.2-23.2-25.7-51.4-25.7-82 0-79.5 64.5-144 144-144s144 64.5 144 144zm-224 0c0-44.2 35.8-80 80-80 8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112 0 8.8 7.2 16 16 16s16-7.2 16-16zm80 304c-20.9 0-38.7-13.4-45.3-32h90.5c-6.6 18.6-24.4 32-45.3 32zm-80-53.3v5.3c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7z"
        }
    ]
};

const FalLightbulbSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightbulbSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M438.3 258.1c-3.3 4.7-6.9 9.7-10.7 15l25.2 19.9c4-5.5 8-11 11.8-16.6 19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0c-59.4 0-112 29.4-143.8 74.5l25.2 19.9C227.3 56.7 270.8 32 320 32c79.5 0 144 64.5 144 144 0 30.6-9.5 58.8-25.7 82.1zM226.5 114.3l25.2 19.9C265.8 111.3 291.1 96 320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-39 0-73.4 20-93.5 50.3zm-25.4 143-52.6-41.6c5.1 22.1 14.3 42.5 26.9 60.5 5 7.2 10.2 14.3 15.4 21.4 12.3 16.8 24.6 33.7 34.5 51.8 5.9 10.8 9.6 22.5 11.8 34.5h32.4c-2.5-16.6-7.3-33.7-16.2-49.9-10.9-20-25.3-39.7-38-57.1-4.9-6.7-9.5-13-13.6-19l-.5-.7zM274.7 448h90.5c-6.6 18.6-24.4 32-45.3 32s-38.7-13.4-45.3-32zM240 432c0 44.2 35.8 80 80 80s80-35.8 80-80v-5.3c0-5.9-4.8-10.7-10.7-10.7H250.7c-5.9 0-10.7 4.8-10.7 10.7v5.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalLightbulb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightbulb",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M310.3 258.1c16.2-23.3 25.7-51.5 25.7-82.1 0-79.5-64.5-144-144-144S48 96.5 48 176c0 30.6 9.5 58.8 25.7 82.1 4.1 5.9 8.8 12.3 13.6 19 12.7 17.5 27.1 37.2 38 57.1 8.9 16.2 13.7 33.3 16.2 49.9H109c-2.2-12-5.9-23.7-11.8-34.5-9.9-18-22.2-34.9-34.5-51.8-5.2-7.1-10.4-14.2-15.4-21.4C27.6 247.9 16 213.3 16 176 16 78.8 94.8 0 192 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3-5 7.2-10.2 14.3-15.4 21.4-12.3 16.8-24.6 33.7-34.5 51.8-5.9 10.8-9.6 22.5-11.8 34.5h-32.4c2.5-16.6 7.3-33.7 16.2-49.9 10.9-20 25.3-39.7 38-57.1 4.9-6.7 9.5-13 13.6-19zM192 96c-44.2 0-80 35.8-80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112 8.8 0 16 7.2 16 16s-7.2 16-16 16zm-45.3 352c6.6 18.6 24.4 32 45.3 32s38.7-13.4 45.3-32h-90.6zM112 432v-5.3c0-5.9 4.8-10.7 10.7-10.7h138.6c5.9 0 10.7 4.8 10.7 10.7v5.3c0 44.2-35.8 80-80 80s-80-35.8-80-80z"
        }
    ]
};

const FalLighthouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLighthouse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M23.2 1.7C15.3-2.3 5.6.9 1.7 8.8S1 26.3 8.9 30.3l128 64c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-128-64zm128 188.6c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-128 64c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l128-64zM312.1 2.1l-112 64c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l8.1-4.6V128h32V71l64-36.6L384 71v57h32V89.3l8.1 4.6c7.7 4.4 17.4 1.7 21.8-6s1.7-17.4-6-21.8l-112-64c-4.9-2.8-11-2.8-15.9 0zM250.2 192h139.6l57.6 288H384v-64c0-35.3-28.7-64-64-64s-64 28.7-64 64v64h-63.4l57.6-288zm-32.6 0-57 285.2c-.2.9-.3 1.9-.4 2.8H144c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16.1c-.1-.9-.2-1.9-.4-2.8L422.4 192h9.6c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16s7.2 16 16 16h9.6zM352 416v64h-64v-64c0-17.7 14.3-32 32-32s32 14.3 32 32zM638.3 8.9c-4-7.9-13.6-11.1-21.5-7.2l-128 64c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l128-64c7.9-4 11.1-13.6 7.2-21.5zm-156.6 160c-4 7.9-.7 17.5 7.2 21.5l128 64c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-128-64c-7.9-4-17.5-.7-21.5 7.2z"
        }
    ]
};

const FalLightsHoliday = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLightsHoliday",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M23.8 66C16 61.7 6.3 64.5 2 72.2S.5 89.7 8.2 94l13.5 7.5c88 48.9 187 74.5 287.6 74.5h21.4c100.6 0 199.6-25.6 287.5-74.5l13.6-7.5c7.7-4.3 10.5-14 6.2-21.8s-14-10.5-21.8-6.2l-13.5 7.5c-83.2 46.2-176.8 70.5-272 70.5h-21.4c-95.2 0-188.8-24.3-272-70.5L23.8 66zm99.8 156.2C86.7 217 50 238.2 37 274.6 20.9 319.9 46.9 414 69.5 422.1s102.2-48.6 118.3-93.8c13-36.5-2.1-76.1-34-95.3l14.6-41.1c-10.4-2.4-20.8-5.1-31.1-8.1l-13.7 38.4zM304 257.6c-36.5 7.4-64 39.7-64 78.4 0 48 56 128 80 128s80-80 80-128c0-38.7-27.5-71-64-78.4V208h-32v49.6zM486.3 233c-31.9 19.2-47 58.9-34 95.3 16.1 45.2 95.7 101.8 118.3 93.8s48.6-102.2 32.5-147.4c-13-36.5-49.7-57.7-86.6-52.4l-13.7-38.4c-10.3 3-20.7 5.6-31.1 8.1l14.6 41zm-357.8 23.2c25 8.9 38 36.3 29.1 61.3-4.9 13.7-22.6 34.4-45.9 52.1-11 8.4-21.5 14.7-29.6 18.3l-.6.3-.3-.6c-4-7.9-8.1-19.4-11.4-32.8-6.9-28.4-7.5-55.7-2.7-69.4 8.9-25 36.3-38 61.3-29.1zM320 288c26.5 0 48 21.5 48 48 0 14.5-9.8 40-25.8 64.5-7.6 11.6-15.3 21-21.7 27.1l-.5.5-.5-.5c-6.4-6.1-14.2-15.6-21.7-27.1-16-24.5-25.8-50-25.8-64.5 0-26.5 21.5-48 48-48zm-6.5 145.2s.1-.1.2-.1l-.2.1c-.1 0-.1.1-.1.1h.1zm12.8-.1a.4.4 0 1 0 .8-.5.4.4 0 1 0-.8.5zm246.6-147.7c4.9 13.7 4.2 41-2.7 69.4-3.2 13.4-7.4 24.9-11.4 32.8l-.3.6-.6-.3c-8.1-3.6-18.6-9.9-29.6-18.3-23.3-17.7-41-38.5-45.9-52.1-8.9-25 4.2-52.4 29.1-61.3s52.4 4.2 61.3 29.1z"
        }
    ]
};

const FalLineColumns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLineColumns",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 320c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm272-240c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm16-144c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm-16 272c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H304c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"
        }
    ]
};

const FalLineHeight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLineHeight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M107.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L80 86.6v338.8l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L112 425.4V86.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM272 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zm-16 176c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H272c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalLinesLeaning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLinesLeaning",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.9 53.7c3.2-8.2-.9-17.5-9.2-20.7s-17.5.9-20.7 9.2L1 458.2c-3.2 8.2.9 17.5 9.2 20.7s17.5-.9 20.7-9.2l160-416zm84.7-21.3c-8.6-2-17.2 3.4-19.2 12l-96 416c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l96-416c2-8.6-3.4-17.2-12-19.2zM368 32c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalLinkHorizontalSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLinkHorizontalSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM640 320c0-70.7-57.3-128-128-128h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c53 0 96 43 96 96 0 24.2-8.9 46.3-23.7 63.1l25.2 19.9c19-22.3 30.5-51.3 30.5-83zM459.9 448l-40.5-32h-83.5c-52.9 0-95.9-42.9-95.9-95.9 0-13.9 3-27.2 8.4-39.2l-25.7-20.3c-9.4 17.8-14.6 38.1-14.6 59.5C208 390.8 265.2 448 335.9 448h124zM400 191.9c0 13.9-3 27.2-8.4 39.2l25.7 20.3c9.4-17.8 14.6-38.1 14.6-59.5C432 121.2 374.8 64 304.1 64h-124l40.5 32h83.5c52.9 0 95.9 42.9 95.9 95.9zm-344.3-63L30.5 109C11.5 131.4 0 160.3 0 192c0 70.7 57.3 128 128 128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-53 0-96-43-96-96 0-24.2 8.9-46.3 23.7-63.1z"
        }
    ]
};

const FalLinkHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLinkHorizontal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64C57.3 64 0 121.3 0 192s57.3 128 128 128h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-53 0-96-43-96-96s43-96 96-96h176.1c52.9 0 95.9 42.9 95.9 95.9 0 50.3-38.9 92-89 95.6l-8.1.6c-8.8.6-15.4 8.3-14.8 17.1s8.3 15.4 17.1 14.8l8.1-.6c66.9-4.8 118.7-60.5 118.7-127.5C432 121.2 374.8 64 304.1 64H128zm384 384c70.7 0 128-57.3 128-128s-57.3-128-128-128h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c53 0 96 43 96 96s-43 96-96 96H335.9c-52.9 0-95.9-42.9-95.9-95.9 0-50.3 38.9-92 89-95.6l8.1-.6c8.8-.6 15.4-8.3 14.8-17.1s-8.3-15.4-17.1-14.8l-8.1.6C259.8 197.4 208 253.1 208 320.1c0 70.7 57.2 127.9 127.9 127.9H512z"
        }
    ]
};

const FalLinkSimpleSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLinkSimpleSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM608 256c0-88.4-71.6-160-160-160h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c70.7 0 128 57.3 128 128 0 35.5-14.4 67.6-37.7 90.8l25.3 19.9C591.1 338 608 299 608 256zm-152 16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-53l40.5 32H456zm-259.6-32H184c-8.8 0-16 7.2-16 16s7.2 16 16 16h53l-40.5-32zm-94.7-74.8-25.2-19.9C48.9 174 32 213 32 256c0 88.4 71.6 160 160 160h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80c-70.7 0-128-57.3-128-128 0-35.5 14.4-67.6 37.7-90.8z"
        }
    ]
};

const FalLinkSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLinkSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 256C0 167.6 71.6 96 160 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-70.7 0-128 57.3-128 128s57.3 128 128 128h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c70.7 0 128-57.3 128-128s-57.3-128-128-128h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c88.4 0 160 71.6 160 160zm-424-16h272c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalLinkSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLinkSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM591.5 256c50-50 50-131 0-181s-131-50-181 0l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L492 310.3l25.3 20 74.2-74.3zM414.6 412.2l-33.4-26.3c-26.1 1.3-52.5-8.1-72.5-28-14.2-14.2-23-31.7-26.4-50.1L249 281.5c-2.4 35.7 10.1 72 37.2 99.1 34.8 34.8 84.6 45.3 128.5 31.7zm-83.4-258.1c14.2 14.2 23 31.7 26.4 50.1l33.4 26.3c2.4-35.7-10.1-72-37.2-99.1-34.8-34.8-84.6-45.3-128.5-31.7l33.4 26.3c26.1-1.3 52.5 8.1 72.5 28zM148 201.7l-25.3-20L48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8l76.9-76.9z"
        }
    ]
};

const FalLink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLink",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M591.5 256c50-50 50-131 0-181s-131-50-181 0l-22.6 22.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1C235.9 257 238.6 333 286 380.4c49.9 49.9 130.9 49.9 180.8 0L591.5 256zm-543 0c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8l124.6-124.5c37.4-37.4 98.1-37.4 135.6 0 35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1C404.1 255 401.4 179 354 131.6c-50.1-50.1-131-50.1-181-.2L48.5 256z"
        }
    ]
};

const FalLips = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLips",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M268.2 126.4c11.6 9.2 28.1 9.2 39.7 0C331.2 107.9 354.3 96 376 96c14.3 0 30.9 5.5 49.4 15.7 18.4 10.1 36 23.4 52.6 36.3 18 14 34.5 29 46.5 42.5l23.9-21.3-23.9 21.3C538.3 206 544 216.3 544 224c0 11.4-5.7 25.3-14.7 43.5C519.5 287 505 310 486 332c-38 44-94 84-166 84h-64c-72 0-128-40-166-84-23.7-27.5-43.6-58.4-54.3-90.6C33.3 234 32 228 32 224c0-7.7 5.7-18 19.5-33.5l-23.4-20.8 23.4 20.8C63.5 177 80 162 98 148c16.5-12.8 34.2-26.1 52.6-36.3C169.1 101.5 185.7 96 200 96c21.7 0 44.8 11.9 68.2 30.4zM576 224c0-21.1-14.2-39.7-27.6-54.8-13.6-15.3-31.7-31.7-50.8-46.5C464.5 97 420 64 376 64c-32.7 0-63 17.5-88 37.3C263 81.5 232.7 64 200 64c-44 0-88.5 33-121.6 58.7-19.1 14.8-37.1 31.2-50.8 46.5C14.2 184.3 0 202.9 0 224c0 9.2 2.6 19.1 5.3 27.5 12.4 37.3 34.9 71.9 60.4 101.4 41.5 48 105.6 95.1 190.3 95.1h64c84.7 0 148.8-47.1 190.2-95.1 20.9-24.2 36.8-49.4 47.7-71.1C566.6 264.3 576 244 576 224zm-219.7-7.1c2-.6 3.8-.9 5.4-.9 38.1.4 66.1 5.6 84.1 11.1 4.7 1.4 8.5 2.9 11.7 4.2l-1.3 1.3c-7.5 7.4-19 16.9-34.3 26.4-30.5 18.8-75.6 37-133.9 37s-103.4-18.2-133.9-37c-15.3-9.4-26.8-19-34.3-26.4l-1.3-1.3c3.2-1.3 7-2.7 11.7-4.2 18-5.5 46-10.7 84.1-11.1 1.6 0 3.4.2 5.4.9 11.6 3.6 44 13.1 68.3 13.1s56.7-9.5 68.3-13.1zM362 184c-5.4-.1-10.5.8-15.3 2.3-12.1 3.8-40 11.7-58.8 11.7s-46.7-7.9-58.8-11.7c-4.7-1.5-9.9-2.4-15.3-2.3-40.7.5-71.7 5.9-93.1 12.5-10.6 3.3-19.2 6.9-25.5 10.6-3.1 1.8-6.2 3.9-8.7 6.4-1.5 1.6-6.5 6.7-6.5 14.5 0 3.1.9 5.5 1.3 6.6.5 1.3 1.1 2.5 1.6 3.4 1 1.8 2.3 3.6 3.6 5.4 2.7 3.5 6.4 7.7 11 12.1 9.2 9 22.6 20 39.9 30.7C172 307.6 222.8 328 288 328s116-20.4 150.7-41.8c17.3-10.7 30.7-21.7 39.9-30.7 4.6-4.5 8.3-8.6 11-12.2 1.3-1.7 2.6-3.6 3.6-5.4.5-.9 1.1-2.1 1.6-3.4.4-1.1 1.3-3.5 1.3-6.6 0-7.8-5-12.9-6.7-14.5-2.5-2.5-5.6-4.6-8.7-6.4-6.3-3.7-14.9-7.3-25.5-10.6-21.4-6.6-52.4-12-93.1-12.5z"
        }
    ]
};

const FalLiraSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLiraSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 152c0-48.6 39.4-88 88-88h7.1c9.5 0 18.9 1.5 27.8 4.5l80 26.7c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-80-26.7c-12.2-4.1-25-6.2-37.9-6.2H168C101.7 32 48 85.7 48 152v72H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v22.1c0 14-.8 28-2.4 41.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h24.5c-7.3 35.6-19.9 70.1-37.4 102.3l-1.1 2c-2.7 5-2.6 11 .3 15.8S10.4 480 16 480h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H42.1c14.4-30.6 24.8-62.9 31-96H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H77.8c1.5-13.9 2.2-27.9 2.2-41.9V256h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H80v-72z"
        }
    ]
};

const FalListCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalListCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M156.3 58.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2l-68.9 82.6-35.6-35.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zm0 160c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2l-68.9 82.6-35.6-35.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zM192 96c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm-32 160c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-64 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FalListDropdown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalListDropdown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v64h448V96c0-17.7-14.3-32-32-32H64zM32 192v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192H32zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 160h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zM352.2 90.3l31.8 19 31.8-19.1c7.6-4.5 17.4-2.1 21.9 5.5s2.1 17.4-5.5 22l-40 24c-5.1 3-11.4 3-16.5 0l-40-24c-7.6-4.5-10-14.4-5.5-22s14.4-10 21.9-5.5z"
        }
    ]
};

const FalListMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalListMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M489.1 0C501.8 0 512 10.2 512 22.9V136c0 6.9-4.5 13.1-11.1 15.2L384 188.9V432c0 44.2-50.1 80-112 80s-112-35.8-112-80 50.1-80 112-80c31.3 0 59.7 9.2 80 24V56c0-6.9 4.4-13 10.9-15.2l119-39.6c2.3-.8 4.8-1.2 7.2-1.2zM332.6 401.5C318.3 391.3 297 384 272 384s-46.3 7.3-60.6 17.5C197.1 411.7 192 422.9 192 432s5.1 20.3 19.4 30.5C225.7 472.7 247 480 272 480s46.3-7.3 60.6-17.5c14.3-10.2 19.4-21.4 19.4-30.5s-5.1-20.3-19.4-30.5zM384 155.3l96-30.9V35.5l-96 32v87.8zM16 64h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80s7.2-16 16-16zm0 128h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalListOl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalListOl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 48c0 8.8 7.2 16 16 16h16v128H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V48c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm160 48c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM58.7 323.9c11.1-11.1 29.2-10.5 39.6 1.3 9.2 10.5 8.9 26.2-.6 36.3l-85.4 91.6c-4.3 4.7-5.5 11.5-3 17.3S17.6 480 24 480h104c8.8 0 16-7.2 16-16s-7.2-16-16-16H60.8l60.3-64.6c20.7-22.2 21.2-56.4 1.3-79.3-22.5-25.7-62.1-27.1-86.3-2.9l-15.4 15.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l15.4-15.4z"
        }
    ]
};

const FalListRadio = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalListRadio",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0A64 64 0 1 0 0 96a64 64 0 1 0 128 0zm64 0c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-96a64 64 0 1 0 0 128 64 64 0 1 0 0-128zm16-96a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM32 416a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FalListTimeline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalListTimeline",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M213.3 128H416V64H213.3l-32 32 32 32zm-22.7-86.6c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm181.3 32H416v-64H213.3l-32 32 32 32zm-22.6-86.6c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3zM181.3 256l32 32H480v-64H213.3l-32 32zm-33.9-11.3 43.3-43.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalListTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalListTree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 112h32V80H32v32zM0 72c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-8v96h64v-8c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-8H64v112c0 8.8 7.2 16 16 16h48v-8c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-8H80c-26.5 0-48-21.5-48-48V144h-8c-13.3 0-24-10.7-24-24V72zm160 24c0-8.8 7.2-16 16-16h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm128 160c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm0 160c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16zm-128 16h32v-32h-32v32zm0-192v32h32v-32h-32z"
        }
    ]
};

const FalListUl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalListUl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm112 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM96 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
        }
    ]
};

const FalList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 112V80h32v32H48zM16 72v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zm160 8c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM48 240h32v32H48v-32zm-8-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H40zm8 224v-32h32v32H48zm-32-40v48c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FalLitecoinSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLitecoinSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v179.5l-51.9 13C3.5 242.6-1.7 251.3.5 259.9s10.8 13.8 19.4 11.6l44.1-11V440c0 22.1 17.9 40 40 40h264c8.8 0 16-7.2 16-16s-7.2-16-16-16H104c-4.4 0-8-3.6-8-8V252.5l179.9-45c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L96 219.5V48z"
        }
    ]
};

const FalLoader = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLoader",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 384v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 256c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm400-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm37-165c6.2 6.2 6.2 16.4 0 22.6l-67.9 67.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L414.4 75c6.2-6.2 16.4-6.2 22.6 0zM165.5 369.1 97.6 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l67.9-67.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM75 75c6.2-6.2 16.4-6.2 22.6 0l67.9 67.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L75 97.6c-6.2-6.2-6.2-16.4 0-22.6zm294.1 271.5 67.9 67.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-67.9-67.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FalLobster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLobster",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 80c0-19.2 11.3-35.8 27.6-43.4L48.3 92.9c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l16-80c.9-4.7-.3-9.6-3.3-13.3S84.8 0 80 0C35.8 0 0 35.8 0 80v48c0 35.3 28.7 64 64 64 6.2 0 12.2-.9 17.9-2.5l26.9 20.1c19.4 14.5 43 22.4 67.2 22.4v24h-32.9c-7.5 0-14.8-1.7-21.5-5.1l-34.4-17.2c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l34.5 17.2c11.1 5.6 23.4 8.4 35.8 8.4H176v16h-53.6c-5.2 0-10.3-.8-15.2-2.5l-38.1-12.7c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l38.1 12.7c8.2 2.7 16.7 4.1 25.3 4.1H176v16h-.9c-12.4 0-24.7 2.9-35.8 8.4l-18.5 9.2c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l18.5-9.2c6.7-3.3 14-5.1 21.5-5.1h.9l18.5 51.7c-24.8 9-42.5 32.6-42.5 60.4 0 8.8 7.2 16 16 16h176c8.8 0 16-7.2 16-16 0-27.8-17.7-51.4-42.5-60.3L336 384h.9c7.4 0 14.8 1.7 21.5 5.1l18.5 9.2c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-18.5-9.2c-11.1-5.6-23.4-8.4-35.8-8.4h-.9v-16h53.6c8.6 0 17.1-1.4 25.3-4.1l38.1-12.7c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1l-38.1 12.7c-4.9 1.6-10 2.5-15.2 2.5H336V288h32.9c12.4 0 24.7-2.9 35.8-8.4l34.5-17.2c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-34.5 17.2c-6.7 3.3-14 5.1-21.5 5.1H336v-24c24.2 0 47.8-7.9 67.2-22.4l26.9-20.1c5.7 1.7 11.7 2.5 17.9 2.5 35.3 0 64-28.7 64-64V80c0-44.2-35.8-80-80-80-4.8 0-9.3 2.1-12.4 5.9s-4.3 8.6-3.3 13.3l16 80c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8l-11.3-56.4C468.7 44.2 480 60.8 480 80v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 16.7 6.4 31.9 16.9 43.3L384 184c-13.8 10.4-30.7 16-48 16 0-25.6-14.7-48.9-32-67.2V80.7c0-15.6 11.3-29 26.7-31.6l7.9-1.3c8.7-1.5 14.6-9.7 13.2-18.4s-9.7-14.6-18.4-13.2l-7.9 1.3C294.6 22.7 272 49.4 272 80.7v25c-3.2-2.2-6.3-4.1-9-5.8-4.3-2.6-9.7-2.6-14 0-2.8 1.6-5.8 3.6-9 5.8v-25c0-31.3-22.6-58-53.5-63.1l-7.9-1.3c-8.7-1.5-17 4.4-18.4 13.2s4.4 17 13.2 18.4l7.9 1.3C196.7 51.7 208 65 208 80.7v52.1c-17.3 18.3-32 41.6-32 67.2-17.3 0-34.2-5.6-48-16l-16.9-12.7c10.5-11.4 16.9-26.6 16.9-43.3V80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V80zm272 120v99.6c-1 .2-2.1.4-3.3.6-9.9 1.8-24.9 3.7-44.7 3.7s-34.9-1.9-44.7-3.7c-1.2-.2-2.2-.4-3.3-.6V200c0-12.1 6.5-26.2 19.3-40.9 9-10.4 19.7-19.2 28.7-25.7 9.1 6.4 19.7 15.3 28.7 25.7 12.8 14.7 19.3 28.8 19.3 40.9zm-96 132.2c11.6 2 27.7 3.8 48 3.8s36.4-1.8 48-3.8v15.4c-1 .2-2.1.4-3.3.6-9.9 1.8-24.9 3.7-44.7 3.7s-34.9-1.9-44.7-3.7c-1.2-.2-2.2-.4-3.3-.6v-15.4zm48 51.8c20 0 35.8-1.7 47.3-3.7l-5.5 15.5c-12.9 2.1-29.3 4.2-41.8 4.2s-28.9-2.1-41.8-4.2l-5.5-15.5c11.5 1.9 27.4 3.7 47.3 3.7zm-30.1 45.8c10 1.2 20.7 2.2 30.1 2.2s20.1-1 30.1-2.2c-2.9 15.2 5.7 30.7 20.7 36.1 7.2 2.6 13.2 7.6 17 14.2H188.3c3.8-6.5 9.7-11.6 17-14.2 15-5.4 23.6-20.8 20.7-36.1z"
        }
    ]
};

const FalLocationArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationArrow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224H48L400 80 256 432V256c0-17.7-14.3-32-32-32zm-32 32h32v176c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8S32.7 256 48 256h144z"
        }
    ]
};

const FalLocationCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationCheck",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140 25.4-31.8 65.8-84.7 99.9-140 17.3-28.1 32.7-56.3 43.6-82.1 11-26.4 16.4-47.8 16.4-63.4zm32 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-84.7-52.7-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7 116.7-116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalLocationCrosshairsSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationCrosshairsSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M395.5 397.1C373 409.2 347.3 416 320 416c-88.4 0-160-71.6-160-160 0-14 1.8-27.7 5.2-40.7l-27-21.3c-5 14.6-8.2 30-9.6 46H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48.7c7.7 93.3 82.1 167.6 175.3 175.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.7c31.6-2.6 61-12.9 86.4-28.9l-27-21.3zM304 64.7c-31.6 2.6-61 12.9-86.4 28.9l27 21.3C267 102.8 292.7 96 320 96c88.4 0 160 71.6 160 160 0 14-1.8 27.7-5.2 40.7l27 21.3c5-14.6 8.2-30 9.6-46H560c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48.7c-7.7-93.3-82-167.6-175.3-175.3V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48.7zM320 352c5.6 0 11.2-.5 16.5-1.4l-55.7-44c-.3-.2-.6-.5-.9-.7l-55.7-44c3 50.3 44.8 90.1 95.8 90.1zm-16.5-190.6 55.7 44c.3.2.6.5.9.7l55.7 44c-3-50.3-44.8-90.1-95.8-90.1-5.6 0-11.2.5-16.5 1.4zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalLocationCrosshairs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationCrosshairs",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c8.8 0 16 7.2 16 16v48.7c93.3 7.7 167.6 82.1 175.3 175.3H496c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48.7c-7.7 93.3-82.1 167.6-175.3 175.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48.7c-93.3-7.7-167.6-82-175.3-175.3H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48.7c7.7-93.3 82-167.6 175.3-175.3V16c0-8.8 7.2-16 16-16zM96 256a160 160 0 1 0 320 0 160 160 0 1 0-320 0zm224 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0z"
        }
    ]
};

const FalLocationDotSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationDotSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M385.8 389.5c-24.4 35.2-48.5 66.5-65.8 88.1-25.4-31.8-65.8-84.7-99.9-140-17.3-28.1-32.7-56.3-43.6-82.1-6.7-15.9-11.4-30-14-42.2L128.1 186c-.1 2-.1 4-.1 6 0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0 17.3-21.6 42-53.6 67.2-89.8l-25.2-19.9zM320 0c-56.2 0-106.7 24.1-141.8 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160 0 15.6-5.4 37-16.6 63.4-3.3 7.7-6.9 15.6-10.9 23.7l25.6 20.2C498.3 259.8 512 221.9 512 192 512 86 426 0 320 0zm80 192c0-44.2-35.8-80-80-80-20.5 0-39.2 7.7-53.3 20.4l25.8 20.3c7.8-5.5 17.3-8.7 27.6-8.7 26.5 0 48 21.5 48 48 0 6.2-1.2 12.2-3.4 17.7l25.7 20.3c6.1-11.3 9.6-24.3 9.6-38zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalLocationDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationDot",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140 25.4-31.8 65.8-84.7 99.9-140 17.3-28.1 32.7-56.3 43.6-82.1 11-26.4 16.4-47.8 16.4-63.4zm32 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"
        }
    ]
};

const FalLocationExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationExclamation",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140 25.4-31.8 65.8-84.7 99.9-140 17.3-28.1 32.7-56.3 43.6-82.1 11-26.4 16.4-47.8 16.4-63.4zm32 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zM192 96c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm-24 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalLocationMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140 25.4-31.8 65.8-84.7 99.9-140 17.3-28.1 32.7-56.3 43.6-82.1 11-26.4 16.4-47.8 16.4-63.4zm32 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zM96 176h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalLocationPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationPen",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140 25.4-31.8 65.8-84.7 99.9-140 17.3-28.1 32.7-56.3 43.6-82.1 11-26.4 16.4-47.8 16.4-63.4zm32 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-131.7-60.3c-4.9-4.9-12.9-4.9-17.8 0l-8.1 8.1 17.8 17.8 8.1-8.1c4.9-4.9 4.9-12.9 0-17.8zm-109.2 91.4c-2 2.1-3.5 4.6-4.2 7.4L134 250l19.4-4.9c2.8-.7 5.4-2.2 7.4-4.2l60.7-60.7-17.8-17.8-60.7 60.7zM211.8 109c17.4-17.4 45.7-17.4 63.1 0s17.4 45.6 0 63l-91.4 91.5c-6.2 6.2-13.9 10.5-22.3 12.6l-45.3 11.3c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l11.3-45.3c2.1-8.4 6.5-16.1 12.6-22.3l91.4-91.4z"
        }
    ]
};

const FalLocationPinLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationPinLock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 477.6c16.8-21.1 40.2-51.4 64-85.5v54.8c-15.3 20.6-29.3 38.6-40.3 52.3-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0c95.7 0 175 70 189.6 161.5a111.7 111.7 0 0 0-30.9 9.9C340.6 92.8 273.4 32 192 32c-88.4 0-160 71.6-160 160 0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140zM144 192a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm208-48c-26.5 0-48 21.5-48 48v48h96v-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H320c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48zm0 80v128h160V352H320z"
        }
    ]
};

const FalLocationPinSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationPinSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 192C512 86 426 0 320 0c-56.2 0-106.7 24.1-141.8 62.5l25.2 19.9C232.6 51.4 274 32 320 32c88.4 0 160 71.6 160 160 0 15.6-5.4 37-16.6 63.4-3.3 7.7-6.9 15.6-10.9 23.7l25.6 20.2C498.3 259.8 512 221.9 512 192zm-335.4 63.4c-6.7-15.9-11.4-30-14-42.2L128.1 186c-.1 2-.1 4-.1 6 0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0 17.3-21.6 42-53.6 67.2-89.8l-25.2-19.9c-24.4 35.2-48.5 66.5-65.8 88.1-25.4-31.8-65.8-84.7-99.9-140-17.3-28.1-32.7-56.3-43.6-82.1zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalLocationPin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationPin",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M335.4 255.4c-10.9 25.9-26.2 54-43.6 82.1-34.1 55.3-74.4 108.2-99.9 140-25.4-31.8-65.8-84.7-99.9-140-17.3-28.1-32.7-56.3-43.6-82.1C37.4 229 32 207.6 32 192c0-88.4 71.6-160 160-160s160 71.6 160 160c0 15.6-5.4 37-16.6 63.4zM215.7 499.2C267 435 384 279.4 384 192 384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2 12.3 15.3 35.1 15.3 47.4 0z"
        }
    ]
};

const FalLocationPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationPlus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140 25.4-31.8 65.8-84.7 99.9-140 17.3-28.1 32.7-56.3 43.6-82.1 11-26.4 16.4-47.8 16.4-63.4zm32 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-208 96v-80H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V96c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalLocationQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationQuestion",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140 25.4-31.8 65.8-84.7 99.9-140 17.3-28.1 32.7-56.3 43.6-82.1 11-26.4 16.4-47.8 16.4-63.4zm32 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-279.3-54.2c6.5-24.6 28.7-41.8 54.2-41.8H216c35.5 0 64 29 64 64.3 0 24-13.4 46.2-34.9 57.2L208 236.3V256c0 8.8-7.2 16-16 16s-16-7.2-16-16v-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7 0-17.8-14.4-32.3-32-32.3h-57.1c-10.9 0-20.5 7.4-23.2 17.9l-.2.7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM168 320a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalLocationSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationSmile",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140 25.4-31.8 65.8-84.7 99.9-140 17.3-28.1 32.7-56.3 43.6-82.1 11-26.4 16.4-47.8 16.4-63.4zm32 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-256-56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-106.7 87.1C132.1 257.3 156 280 192 280s59.9-22.7 66.7-32.9c4.9-7.4 14.8-9.3 22.2-4.4s9.3 14.8 4.4 22.2c-11 16.5-43.9 47.1-93.3 47.1s-82.3-30.6-93.3-47.1c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4z"
        }
    ]
};

const FalLocationXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocationXmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4 10.9 25.9 26.2 54 43.6 82.1 34.1 55.3 74.4 108.2 99.9 140 25.4-31.8 65.8-84.7 99.9-140 17.3-28.1 32.7-56.3 43.6-82.1 11-26.4 16.4-47.8 16.4-63.4zm32 0c0 87.4-117 243-168.3 307.2-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192 0 86 86 0 192 0s192 86 192 192zm-267.3-75.3c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L214.6 192l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L192 214.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalLockA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLockA",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c53 0 96 43 96 96v64H128v-64c0-53 43-96 96-96zM96 128v64H80c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80h-16v-64C352 57.3 294.7 0 224 0S96 57.3 96 128zm-16 96h288c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm49.7 200.8c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l19.5-39.1h92.2l19.6 39.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-80-159.9c-.8-1.6-1.8-3-3.1-4.3-1.4-1.4-3.1-2.6-5-3.4-2.1-.9-4.2-1.3-6.4-1.3s-4.3.4-6.4 1.3c-1.8.8-3.5 1.9-5 3.4-1.3 1.3-2.3 2.7-3 4.3l-79.8 159.8zm64.2-56.8 30.1-60.2 30.1 60.2h-60.2z"
        }
    ]
};

const FalLockHashtag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLockHashtag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128v64h192v-64c0-53-43-96-96-96s-96 43-96 96zm-32 64v-64C96 57.3 153.3 0 224 0s128 57.3 128 128v64h16c44.2 0 80 35.8 80 80v160c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80h16zm-64 80v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48zm144-32c8.8 0 16 7.2 16 16v32h64v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-64v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-64h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16zm16 144h64v-64h-64v64z"
        }
    ]
};

const FalLockKeyholeOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLockKeyholeOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 32c-53 0-96 43-96 96v64h16c44.2 0 80 35.8 80 80v160c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80h240v-64C320 57.3 377.3 0 448 0s128 57.3 128 128v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-53-43-96-96-96zM80 224c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80zm184 144h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16z"
        }
    ]
};

const FalLockKeyhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLockKeyhole",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c53 0 96 43 96 96v64H128v-64c0-53 43-96 96-96zM96 128v64H80c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80h-16v-64C352 57.3 294.7 0 224 0S96 57.3 96 128zm-16 96h288c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm160 88c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80z"
        }
    ]
};

const FalLockOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLockOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 128c0-53 43-96 96-96s96 43 96 96v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-80C576 57.3 518.7 0 448 0S320 57.3 320 128v64H80c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80h-16v-64zm-16 96h32c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48h256z"
        }
    ]
};

const FalLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLock",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128v64h192v-64c0-53-43-96-96-96s-96 43-96 96zm-32 64v-64C96 57.3 153.3 0 224 0s128 57.3 128 128v64h16c44.2 0 80 35.8 80 80v160c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80h16zm-64 80v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalLocust = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLocust",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c106.5 0 194.3 80 206.5 183.2-16.8-14.5-38.6-23.2-62.5-23.2h-50.1L382 136.3c-2.6-4.8-7.5-7.9-13-8.3s-10.7 2.1-14 6.5l-45.3 61.4-40.5-60.8c-2.9-4.3-7.7-7-12.9-7.1s-10.1 2.2-13.2 6.4L176 224h-73.9C63.4 224 32 255.4 32 294.1c0 27.5 16 52.4 41 63.8l1.9.9-71.7 95.6c-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2l75.9-101.2 51 23.3c4.7 2.2 9.5 4.2 14.4 6l-38.9 52.8c-5.2 7.1-3.7 17.1 3.4 22.4s17.1 3.7 22.4-3.4l45.9-62.3c15.1 3.2 30.5 4.8 46 4.8H281l-22.9 40.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6l32-55.9h136.2l27.6 55.2c4 7.9 13.6 11.1 21.5 7.2s11.1-13.6 7.2-21.5l-20.7-41.3c48.5-4.8 86.4-45.8 86.4-95.5V272C576 139.5 468.5 32 336 32h-32zm176 224c35.3 0 63.9 28.5 64 63.7v.4c-.1 35.3-28.7 63.9-64 63.9H248.8c-27.5 0-54.8-5.9-79.8-17.4l-44.6-20.4L192 256h288zm-328 0-57.5 76.6-8.3-3.8C72.7 322.6 64 309.1 64 294.1 64 273 81.1 256 102.1 256H152zm137.2-32H216l39.2-52.3 34.4 51.6-.5.7zm104.2 0h-64.5l37.1-50.3 27.4 50.3zM472 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalLollipop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLollipop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 352c-27 0-52.4-6.7-74.7-18.5 8.7 1.6 17.6 2.5 26.7 2.5h16c75.1 0 136-60.9 136-136v-8c0-57.4-46.6-104-104-104S88 134.6 88 192c0 35.3 28.7 64 64 64s64-28.7 64-64v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-39.8 32.2-72 72-72s72 32.2 72 72v8c0 57.4-46.6 104-104 104h-16c-61.9 0-112-50.1-112-112 0-88.4 71.6-160 160-160s160 71.6 160 160-71.6 160-160 160zM0 192c0 106 86 192 192 192 47.3 0 90.5-17.1 124-45.4l168.7 168.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L338.6 316c28.3-33.5 45.4-76.7 45.4-124C384 86 298 0 192 0S0 86 0 192z"
        }
    ]
};

const FalLoveseat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLoveseat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c53 0 96 43 96 96v37.5c10-3.5 20.8-5.5 32-5.5v-32c0-70.7-57.3-128-128-128H192C121.3 32 64 89.3 64 160v32c11.2 0 22 1.9 32 5.5V160c0-53 43-96 96-96h128zM96 320v112c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V288c0-17.7 14.3-32 32-32s32 14.3 32 32v32zM80 480c20.9 0 38.7-13.4 45.3-32h261.4c6.6 18.6 24.4 32 45.3 32h32c26.5 0 48-21.5 48-48V288c0-35.3-28.7-64-64-64s-64 28.7-64 64H128c0-35.3-28.7-64-64-64S0 252.7 0 288v144c0 26.5 21.5 48 48 48h32zm48-64v-96h256v96H128zm288 16V288c0-17.7 14.3-32 32-32s32 14.3 32 32v144c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalLuchadorMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLuchadorMask",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 480H160c-70.7 0-128-57.3-128-128V224c0-106 86-192 192-192s192 86 192 192v128c0 70.7-57.3 128-128 128zM224 0C100.3 0 0 100.3 0 224v128c0 88.4 71.6 160 160 160h128c88.4 0 160-71.6 160-160V224C448 100.3 347.7 0 224 0zm-64 352h128c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm-6.4-31.7C121.2 323.5 96 350.8 96 384c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64 0-33.2-25.2-60.5-57.6-63.7 1-3.7 1.6-7.6 1.6-11.6 0-7.3-1.8-14.4-5.3-20.7H304c44.2 0 80-35.8 80-80 0-26.5-21.5-48-48-48h-32c-44.2 0-80 35.8-80 80 0-44.2-35.8-80-80-80h-32c-26.5 0-48 21.5-48 48 0 44.2 35.8 80 80 80h13.3c-3.4 6.3-5.3 13.4-5.3 20.7 0 4 .6 7.9 1.6 11.6zm41.7-.3c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l8-8 4.2-4.2.4-.4 10.3-10.3c3.6-3.6 8.5-5.7 13.7-5.7s10 2 13.7 5.7L248 288l.4.4 4.2 4.2 8 8c2.1 2.1 3.3 5 3.3 8 0 6.2-5.1 11.3-11.3 11.3h-57.3zM96 208c0-8.8 7.2-16 16-16h32c26.5 0 48 21.5 48 48 0 8.8-7.2 16-16 16h-32c-26.5 0-48-21.5-48-48zm240-16c8.8 0 16 7.2 16 16 0 26.5-21.5 48-48 48h-32c-8.8 0-16-7.2-16-16 0-26.5 21.5-48 48-48h32z"
        }
    ]
};

const FalLungsVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLungsVirus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c8.8 0 16 7.2 16 16v130.7c-5-1.8-10.4-2.7-16-2.7s-11 1-16 2.7V16c0-8.8 7.2-16 16-16zm96 181.8c-11-1.3-22.4 1.3-32 7.7v-24.2C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8 15.4 22.1 44.3 65.4 71 116.9 26.5 50.9 52.4 112.5 59.6 170.3.2 1.3.2 2.6.2 4v7c0 49.1-39.8 89-89 89-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2c-20.9-5.2-38.7-17.1-51.5-32.9 12.2 1.4 24.9-2 35-10 7 5.5 15.2 9.7 24.2 11.9l72.7 18.2c4.5 1.1 9.2 1.7 13.8 1.7 31.5 0 57-25.5 57-57v-7c-6.5-52.2-30.3-109.7-56.3-159.5s-53.9-91.9-68.9-113.3c-6.7-9.6-17.7-15.1-29.5-15.1-20.6 0-37.3 16.7-37.3 37.3v16.5zM234.8 458.2c-12.8 15.9-30.6 27.7-51.5 32.9l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7-49.1 0-89-39.8-89-89v-7c0-1.3.1-2.7.2-4 7.2-57.9 33.1-119.4 59.6-170.3 26.8-51.5 55.6-94.8 71-116.9 13-18.6 34-28.8 55.8-28.8 38.4 0 69.4 31 69.4 69.3v24.1c-9.6-6.4-21-8.9-32-7.7v-16.4c0-20.6-16.7-37.3-37.3-37.3-11.8 0-22.8 5.5-29.5 15.1-14.9 21.4-43 63.5-68.9 113.3S38.5 363.8 32 416v7c0 31.5 25.5 57 57 57 4.7 0 9.3-.6 13.8-1.7l72.7-18.2c9.1-2.3 17.3-6.4 24.2-11.9 10.2 8 22.8 11.4 35 10zm187-59c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0C375.9 398.5 336 415 336 448c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-33-39.9-49.5-63.2-26.2-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6C241.5 375.9 225 336 192 336c-8.8 0-16-7.2-16-16s7.2-16 16-16c33 0 49.5-39.9 26.2-63.2-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0C264.1 241.5 304 225 304 192c0-8.8 7.2-16 16-16s16 7.2 16 16c0 33 39.9 49.5 63.2 26.2 6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6C398.5 264.1 415 304 448 304c8.8 0 16 7.2 16 16s-7.2 16-16 16c-33 0-49.5 39.9-26.2 63.2zM403.5 320a83.5 83.5 0 1 0-167.1 0 83.5 83.5 0 1 0 167.1 0zM304 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm32 72a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalLungs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalLungs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c8.8 0 16 7.2 16 16v164.1c0 21.9 11.2 42.2 29.6 54l18.4 11.7v-80.5C384 127 415 96 453.3 96c21.7 0 42.8 10.2 55.8 28.8 15.4 22.1 44.3 65.4 71 116.9 26.5 50.9 52.4 112.5 59.6 170.3.2 1.3.2 2.6.2 4v7c0 49.1-39.8 89-89 89-7.3 0-14.5-.9-21.6-2.7l-72.7-18.2C414 480.5 384 442.1 384 398v-76.4l32 20.4v56c0 29.4 20 55 48.5 62.1l72.7 18.2c4.5 1.1 9.2 1.7 13.8 1.7 31.5 0 57-25.5 57-57v-7c-6.5-52.2-30.3-109.7-56.3-159.5s-53.9-91.9-68.9-113.3c-6.7-9.6-17.7-15.1-29.5-15.1-20.6 0-37.3 16.7-37.3 37.3v100.7l88.6 56.4c7.5 4.7 9.7 14.6 4.9 22.1s-14.6 9.7-22.1 4.9L416 304.1l-32-20.4-35.5-22.6c-11.5-7.3-21.1-16.9-28.5-27.9-7.3 11-16.9 20.6-28.5 27.9L256 283.7l-32 20.4-71.4 45.4c-7.5 4.7-17.3 2.5-22.1-4.9s-2.5-17.3 4.9-22.1l88.6-56.4V165.3c0-20.6-16.7-37.3-37.3-37.3-11.8 0-22.8 5.5-29.5 15.1-14.9 21.4-43 63.5-68.9 113.3S38.5 363.8 32 416v7c0 31.5 25.5 57 57 57 4.7 0 9.3-.6 13.8-1.7l72.7-18.2C204 453 224 427.4 224 398v-56l32-20.4V398c0 44.1-30 82.5-72.7 93.1l-72.7 18.2c-7.1 1.8-14.3 2.7-21.6 2.7-49.1 0-89-39.8-89-89v-7c0-1.3.1-2.7.2-4 7.2-57.9 33.1-119.4 59.6-170.3 26.8-51.5 55.6-94.8 71-116.9 13-18.6 34-28.8 55.8-28.8 38.4 0 69.4 31 69.4 69.3v80.4l18.4-11.7c18.5-11.7 29.6-32.1 29.6-54V16c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalM = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalM",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M11.3 32.7c6.7-2.1 14 .5 17.9 6.3L224 323.7 418.8 39c4-5.8 11.2-8.3 17.9-6.3S448 41 448 48v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V99.7L237.2 361c-3 4.4-7.9 7-13.2 7s-10.2-2.6-13.2-7L32 99.7V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-7 4.6-13.2 11.3-15.3z"
        }
    ]
};

const FalMace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m278.3 95.8 9.7-29.2 9.7 29.2c3.3 10 11.4 17.7 21.5 20.6 36.8 10.6 65.8 39.7 76.4 76.4 2.9 10.1 10.6 18.1 20.6 21.5l29.2 9.7-29.2 9.7c-10 3.3-17.7 11.4-20.6 21.5-10.6 36.8-39.7 65.8-76.4 76.4-10.1 2.9-18.1 10.6-21.5 20.6l-9.7 29.2-9.7-29.2c-3.3-10-11.4-17.7-21.5-20.6-36.8-10.6-65.8-39.7-76.4-76.4-2.9-10.1-10.6-18.1-20.6-21.5l-29.2-9.7 29.2-9.7c10-3.3 17.7-11.4 20.6-21.5 10.6-36.8 39.7-65.8 76.4-76.4 10.1-2.9 18.1-10.6 21.5-20.6zm-128.6 88.1-74.8 24.9C68.4 211 64 217.1 64 224s4.4 13 10.9 15.2l74.7 24.9c5.3 18.4 14.2 35.2 25.8 49.8L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l170.8-170.8c14.6 11.6 31.4 20.5 49.8 25.8l24.9 74.7c2.2 6.5 8.3 10.9 15.2 10.9s13-4.4 15.2-10.9l24.9-74.7c47.3-13.7 84.6-51 98.3-98.3l74.7-24.9c6.5-2.2 10.9-8.3 10.9-15.2s-4.4-13-10.9-15.2l-74.7-24.9c-13.7-47.3-51-84.6-98.3-98.3l-24.9-74.6C301 4.4 294.9 0 288 0s-13 4.4-15.2 10.9l-24.9 74.8c-47.3 13.7-84.6 51-98.3 98.3zM288 240a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-16a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
        }
    ]
};

const FalMagnet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMagnet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 64c-8.8 0-16 7.2-16 16v48h80V80c0-8.8-7.2-16-16-16H48zM32 256c0 106 86 192 192 192s192-86 192-192v-96h-80v96c0 61.9-50.1 112-112 112s-112-50.1-112-112v-96H32v96zm384-128V80c0-8.8-7.2-16-16-16h-48c-8.8 0-16 7.2-16 16v48h80zM0 80c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v176c0 44.2 35.8 80 80 80s80-35.8 80-80V80c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v176c0 123.7-100.3 224-224 224S0 379.7 0 256V80z"
        }
    ]
};

const FalMagnifyingGlassArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMagnifyingGlassArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50l141.4 141.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm27.3-299.3c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h153.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
        }
    ]
};

const FalMagnifyingGlassChart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMagnifyingGlassChart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50l141.4 141.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm-80-192v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64-96v160c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zm64 64v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FalMagnifyingGlassDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMagnifyingGlassDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50l141.4 141.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm16-312c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7-13 7.7-23.9 21.1-23.8 40.5.1 18.4 10.8 30.1 22.7 37.3 10.5 6.3 23.8 10.4 34.8 13.7l1.6.5c12.5 3.8 22.2 6.9 29 11.2 5.9 3.7 7.7 7 7.7 11.6.1 6.6-2.7 10.8-7.8 14-5.8 3.6-14.5 5.6-23.7 5.3-11.8-.4-22.7-4.1-36.3-8.7-2.3-.8-4.7-1.6-7.1-2.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1 9.2 3.2 19.7 6.8 30.9 8.9V312c0 8.8 7.2 16 16 16s16-7.2 16-16v-17.1c8.7-1.4 17.4-4.3 25.1-9.1 13.3-8.3 23.2-22.2 22.9-41.6-.2-18.5-10.6-30.6-22.7-38.2-11-6.9-25-11.2-36.3-14.6l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9-6-3.6-7.2-6.4-7.3-10.1 0-5.4 2.4-9.4 8.1-12.8 6.2-3.7 15.1-5.7 23.6-5.5 10.1.2 21 2.3 32.1 5.3 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V104z"
        }
    ]
};

const FalMagnifyingGlassLocation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMagnifyingGlassLocation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50l141.4 141.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm26.2-178.4c-8.3 14.5-17.7 28.2-26.2 39.6-8.5-11.4-17.9-25.1-26.2-39.6-13.7-24-21.8-45.9-21.8-61.6 0-26.5 21.5-48 48-48s48 21.5 48 48c0 15.7-8.1 37.6-21.8 61.6zm-14.8 77c22.1-27 68.6-89.8 68.6-138.6 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6 6 7.3 16.8 7.3 22.7 0zM232 184a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalMagnifyingGlassMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMagnifyingGlassMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50l141.4 141.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm-96-224c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
        }
    ]
};

const FalMagnifyingGlassPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMagnifyingGlassPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50l141.4 141.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208zm-16-112c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
        }
    ]
};

const FalMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMagnifyingGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 208a176 176 0 1 0-352 0 176 176 0 1 0 352 0zm-40.7 158c-36.3 31.2-83.6 50-135.3 50C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 51.7-18.8 99-50 135.3l141.3 141.4c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"
        }
    ]
};

const FalMailboxFlagUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMailboxFlagUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 208V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24h-72v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96-112V64h-64v32h64zM320 64v32h-85.5c32.6 26.4 53.5 66.8 53.5 112v176c0 11.7-3.1 22.6-8.6 32H512c17.7 0 32-14.3 32-32V208c0-32.7-14-62-36.3-82.5 2.7-6.6 4.3-13.9 4.3-21.5V88.2C550.6 114 576 158 576 208v176c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64h176zm-96 352c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112S32 146.1 32 208v176c0 17.7 14.3 32 32 32h160zM96 208c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalMailbox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMailbox",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 208v176c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112S32 146.1 32 208zm256 0v176c0 11.7-3.1 22.6-8.6 32H512c17.7 0 32-14.3 32-32V208c0-61.9-50.1-112-112-112H234.5c32.6 26.4 53.5 66.8 53.5 112zM64 448c-35.3 0-64-28.7-64-64V208C0 128.5 64.5 64 144 64h288c79.5 0 144 64.5 144 144v176c0 35.3-28.7 64-64 64H64zm48-256h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm224 0h152c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24h-48c-13.3 0-24-10.7-24-24v-72h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 96h32v-64h-32v64z"
        }
    ]
};

const FalManatSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalManatSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c-8.8 0-16 7.2-16 16v48.7C77.4 104.8 0 187.3 0 288v176c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-83 63.1-151.2 144-159.2V464c0 8.8 7.2 16 16 16s16-7.2 16-16V128.8c80.9 8 144 76.2 144 159.2v176c0 8.8 7.2 16 16 16s16-7.2 16-16V288c0-100.7-77.4-183.2-176-191.3V48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalMandolin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMandolin",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M459.3 4.7c-5-5.1-12.8-6.2-19.1-2.7l-72 40c-4 2.2-6.8 6-7.8 10.4l-23 99.5-38.6 38.6C227.4 187.1 0 187.6 0 336c0 97.2 78.8 176 176 176 148.4 0 148.9-227.4 145.4-298.8l38.6-38.6 99.5-23c4.4-1 8.2-3.9 10.4-7.8l40-72c3.5-6.2 2.4-14-2.7-19.1l-48-48zm-191.7 217-43.1 43.1c-9.5-5.6-20.6-8.9-32.5-8.9-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64c0-11.9-3.2-23-8.9-32.5l43.1-43.1c.2 28.6-1.4 65.6-7.8 102.1-6.6 37.9-18 72.4-35.6 96.7-16.5 23-38.4 36.9-70.8 36.9-79.5 0-144-64.5-144-144 0-32.4 13.9-54.3 36.8-70.8 24.3-17.6 58.8-29 96.7-35.6 36.5-6.4 73.5-7.9 102.1-7.8zM445.5 122l-72.1 16.6L390 66.5l55.2-30.7 30.9 30.9-30.6 55.3zM192 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FalMango = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMango",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 112c-24.6 0-47-9.2-64-24.4V176c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c-41.3 0-82.7 14.5-114 43.4l-1.2 1.1-1.3 1c-39 29.3-58.5 59.9-78 92l-2.9 4.7C104 333.1 83 367.7 43.2 395.4c-4.7 3.4-8 7.8-9.8 12.7-4.3 11.8 1.8 27.7 19.9 33.3l1.3.4 1.2.5h.1l.6.2c.6.2 1.6.6 2.9 1.1 2.7 1 6.8 2.4 12.2 4.2 10.9 3.5 27 8.2 47.6 13 41.1 9.6 99.7 19.2 168.8 19.2 73.4 0 120.4-29.5 149.7-65.2 30.3-37 42.3-81.4 42.3-109.6 0-36.4-15-73.2-45.9-101.8-14.8-13.7-31.8-24.1-50.1-31.3V140c4 1 8 1.9 12.1 2.5 21.7 8.6 42 21.1 59.7 37.4 37.5 34.6 56.2 80 56.2 125.3 0 70.7-57.5 206.8-224 206.8-144 0-244.1-39.9-244.1-39.9-33.6-10.3-51.8-43.7-40.6-74.7 4.1-11.5 11.8-21.1 21.4-28 34.3-23.8 52.1-53.2 71.2-84.7 20.6-34 42.6-70.4 88.4-104.8C221.7 145.3 270.9 128 320 128V16c0-8.8 7.2-16 16-16h84.7C471.1 0 512 40.9 512 91.3c0 11.4-9.3 20.7-20.7 20.7H416zm16 208c0 61.9-50.1 112-112 112-8.8 0-16-7.2-16-16s7.2-16 16-16c44.2 0 80-35.8 80-80 0-8.8 7.2-16 16-16s16 7.2 16 16zM354 32c7.1 27.6 32.2 48 62 48h62.9c-5.3-27.3-29.3-48-58.2-48H354z"
        }
    ]
};

const FalManhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalManhole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-54.4-389.4C215.8 135.9 235 144 256 144s40.2-8.1 54.4-21.4C363 144.1 400 195.8 400 256s-37 111.9-89.6 133.4C296.2 376.1 277 368 256 368s-40.2 8.1-54.4 21.4C149 367.9 112 316.2 112 256s37-111.9 89.6-133.4zm-1-33.7C130.5 112.1 80 178.2 80 256s50.5 143.9 120.6 167.1c7.1 2.4 14.6-1.4 19.6-7 8.8-9.9 21.6-16.1 35.8-16.1s27 6.2 35.8 16.1c5 5.6 12.4 9.4 19.6 7C381.5 399.9 432 333.8 432 256S381.5 112.1 311.4 88.9c-7.1-2.4-14.6 1.4-19.6 7-8.8 9.9-21.6 16.1-35.8 16.1s-27-6.2-35.8-16.1c-5-5.6-12.4-9.4-19.6-7zM176 192a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm0 64a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48-112a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm80-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm-16 80a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm16 48a16 16 0 1 0 0 32 16 16 0 1 0 0-32z"
        }
    ]
};

const FalMapLocationDot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMapLocationDot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M366.6 155c6.7-15.9 9.4-27.6 9.4-35 0-48.6-39.4-88-88-88s-88 39.4-88 88c0 7.4 2.7 19 9.4 35 6.5 15.4 15.7 32.4 26.4 49.7 17.1 27.8 36.9 54.7 52.2 74.4 15.3-19.7 35.1-46.6 52.2-74.4 10.7-17.3 19.9-34.3 26.4-49.7zm-63.8 157c-7.7 9.6-22 9.6-29.6 0C241.1 271.9 168 174.6 168 120 168 53.7 221.7 0 288 0s120 53.7 120 120c0 54.6-73.1 151.9-105.2 192zm103.1-89.1c-.8.3-1.7.6-2.5.8 8.2-14.2 15.7-28.7 21.8-42.9l117.9-47.2c15.8-6.3 32.9 5.3 32.9 22.3v270.7c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3.5l-218.7-62.5-144 57.6C17.1 512.8 0 501.2 0 484.2V213.4c0-9.8 6-18.6 15.1-22.3l123.2-49.3c2.1 10.4 5.4 20.8 9.2 30.8L32 218.8v253.6l128-51.2V304c0-8.8 7.2-16 16-16s16 7.2 16 16v115.9l192 54.9V304c0-8.8 7.2-16 16-16s16 7.2 16 16v168.4l128-51.2V167.6l-138.1 55.3zM288 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalMapLocation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMapLocation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M376 120c0 7.4-2.7 19-9.4 35-6.5 15.4-15.7 32.4-26.4 49.7-17.1 27.8-36.9 54.7-52.2 74.4-15.3-19.7-35.1-46.6-52.2-74.4-10.7-17.3-19.9-34.3-26.4-49.7-6.7-15.9-9.4-27.6-9.4-35 0-48.6 39.4-88 88-88s88 39.4 88 88zm32 0C408 53.7 354.3 0 288 0S168 53.7 168 120c0 54.6 73.1 151.9 105.2 192 7.7 9.6 22 9.6 29.6 0C334.9 271.9 408 174.6 408 120zm-4.6 103.6c.9-.2 1.7-.4 2.5-.8L544 167.6v253.6l-128 51.2V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v170.8l-192-54.9V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v117.2L32 472.4V218.8l115.5-46.2c-3.9-10-7.2-20.4-9.2-30.8L15.1 191.1C6 194.8 0 203.6 0 213.4v270.8c0 17 17.1 28.6 32.9 22.3l144-57.6 218.7 62.5c3.4 1 7 .8 10.3-.5l155-62c9.1-3.6 15.1-12.5 15.1-22.3V155.8c0-17-17.1-28.6-32.9-22.3l-117.9 47.2c-6.1 14.2-13.6 28.8-21.8 42.9z"
        }
    ]
};

const FalMapPin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMapPin",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm144-112c0 74.1-56 135.2-128 143.1V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V287.1c-72-8-128-69-128-143.1C16 64.5 80.5 0 160 0s144 64.5 144 144zm-192 0c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80 8.8 0 16 7.2 16 16s-7.2 16-16 16c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalMap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMap",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5l218.7 62.5 144-57.6c15.8-6.3 32.9 5.3 32.9 22.3v334.8c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3.5l-218.7-62.5-144 57.6C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8v317.6l128-51.2V71.6L32 122.8zm352 320V124.1L192 69.2v318.7l192 54.9zm32-2.4 128-51.2V71.6l-128 51.2v317.6z"
        }
    ]
};

const FalMarker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMarker",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M330.3 97 353 74.3l20.7-20.7c23.4-23.4 61.3-23.4 84.7 0s23.4 61.3 0 84.7L293.7 303 209 218.3 330.3 97zm-144 144 84.7 84.7-64.2 64.2c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4l64.2-64.2zM307.7 74.3 285.1 97 99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9.9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1L481 161c35.9-35.9 35.9-94.1 0-129.9S386.9-4.8 351 31l-20.7 20.7-13-13.1c-25-25-65.5-25-90.5 0l-94 94c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l94.1-94.1c9.1-9.1 22.3-11.6 33.6-7.4 4.2 1.5 8.2 4 11.6 7.4l13.1 13.1z"
        }
    ]
};

const FalMarsAndVenusBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMarsAndVenusBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M528 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.4l-75.6 75.6C481.1 80.6 442.5 64 400 64c-88.4 0-160 71.6-160 160 0 83 63.1 151.2 144 159.2V416h-40c-8.8 0-16 7.2-16 16s7.2 16 16 16h40v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h40c8.8 0 16-7.2 16-16s-7.2-16-16-16h-40v-32.8c80.9-8 144-76.2 144-159.2 0-34.3-10.8-66.1-29.2-92.2L608 54.6V104c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16h-96zM272 224a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM176 8c-6.3 0-11.9 3.6-14.5 9.3l-32.1 69.9-74.7-18.5c-6.1-1.5-12.5.7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6-60.9 46.8c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.1 3.4 9.5 4.5 14.5 3.1-13.9-17.5-24.9-37.4-32-59.1l-31.5-26.1c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9l-54.1-11.2 43.8-33.7c6.1-4.7 8-13 4.5-19.9l-24.8-49.4 53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9l23-50.2 23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l24.2-6c11.2-16.3 24.9-30.8 40.5-43l-59.6 14.8-32.1-69.9C187.9 11.6 182.3 8 176 8z"
        }
    ]
};

const FalMarsAndVenus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMarsAndVenus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 16c0 8.8 7.2 16 16 16h73.4l-75.6 75.6C337.1 80.6 298.5 64 256 64c-88.4 0-160 71.6-160 160 0 83 63.1 151.2 144 159.2V416h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32.8c80.9-8 144-76.2 144-159.2 0-34.3-10.8-66.1-29.2-92.2L464 54.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16zm-96 80a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
        }
    ]
};

const FalMarsDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMarsDouble",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 48c0-8.8 7.2-16 16-16h112c8.8 0 16 7.2 16 16v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6L311.3 191.4C336.7 221.9 352 261.2 352 304c0 97.2-78.8 176-176 176S0 401.2 0 304s78.8-176 176-176c42.8 0 82.1 15.3 112.6 40.7L393.4 64H320c-8.8 0-16-7.2-16-16zM176 448a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm293.4-257.9c4.5-5.6 7.8-12.3 9.5-19.6L585.4 64H512c-8.8 0-16-7.2-16-16s7.2-16 16-16h112c8.8 0 16 7.2 16 16v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V86.6l-100 100c22.6 30.6 36 68.4 36 109.4 0 101.6-82.4 184-184 184-20.7 0-40.5-3.4-59.1-9.7 10.1-7.6 19.5-16.2 28.1-25.5 10 2.1 20.3 3.2 30.9 3.2 83.9 0 152-68.1 152-152 0-38.3-14.1-73.3-37.5-100l-5.1-5.9z"
        }
    ]
};

const FalMarsStrokeRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMarsStrokeRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 256a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm319.3-16C375.2 150.3 299.8 80 208 80c-97.2 0-176 78.8-176 176s78.8 176 176 176c91.8 0 167.2-70.3 175.3-160H432v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h89.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7H464v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48.7z"
        }
    ]
};

const FalMarsStrokeUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMarsStrokeUp",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M171.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L144 54.6V128H96c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32.8C63.1 200.8 0 269 0 352c0 88.4 71.6 160 160 160s160-71.6 160-160c0-83-63.1-151.2-144-159.2V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V54.6l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zM160 480a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"
        }
    ]
};

const FalMarsStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMarsStroke",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L384 105.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-40.7 40.7C290.1 143.3 250.8 128 208 128c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6l40.7-40.8 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L406.6 128 480 54.6V144c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368zM64 304a144 144 0 1 1 288 0 144 144 0 1 1-288 0z"
        }
    ]
};

const FalMars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMars",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L288.6 168.7C258.1 143.3 218.8 128 176 128 78.8 128 0 206.8 0 304s78.8 176 176 176 176-78.8 176-176c0-42.8-15.3-82.1-40.7-112.6L416 86.6V176c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16H304zM32 304a144 144 0 1 1 288 0 144 144 0 1 1-288 0z"
        }
    ]
};

const FalMartiniGlassCitrus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMartiniGlassCitrus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 256c-21.7 0-42-6.2-59.2-16.9l-23.1 23.1C373 278.5 401.4 288 432 288c79.5 0 144-64.5 144-144S511.5 0 432 0c-62.7 0-116 40.1-135.8 96h34.6c18-37.8 56.5-64 101.2-64 61.9 0 112 50.1 112 112s-50.1 112-112 112zM16 128c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4L192 342.6V480h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80V342.6l187.3-187.3c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H16zm345.4 32L208 313.4 54.6 160h306.8z"
        }
    ]
};

const FalMartiniGlassEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMartiniGlassEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M33 32c-.5 0-1 .4-1 1 0 .3.1.5.3.7L256 257.4 479.7 33.7c.2-.2.3-.4.3-.7 0-.5-.4-1-1-1H33zm207 254.6L9.7 56.3C3.5 50.1 0 41.7 0 33 0 14.8 14.8 0 33 0h446c18.2 0 33 14.8 33 33 0 8.7-3.5 17.1-9.7 23.3L272 286.6V480h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V286.6z"
        }
    ]
};

const FalMartiniGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMartiniGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 33c0-.5.4-1 1-1h446c.5 0 1 .4 1 1 0 .3-.1.5-.3.7l-94.4 94.4c-.4 0-.9-.1-1.3-.1H128c-.4 0-.9 0-1.3.1L32.3 33.7c-.2-.2-.3-.4-.3-.7zm126.6 127h194.8L256 257.4 158.6 160zM9.7 56.3 240 286.6V480h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96V286.6L502.3 56.3c6.2-6.2 9.7-14.6 9.7-23.3 0-18.2-14.8-33-33-33H33C14.8 0 0 14.8 0 33c0 8.7 3.5 17.1 9.7 23.3z"
        }
    ]
};

const FalMaskFace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMaskFace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96c20.9 0 41.3 6.2 58.6 17.8l37.1 24.8c21 14 45.7 21.5 71 21.5H512v64c0 106-86 192-192 192s-192-86-192-192V160h25.2c25.3 0 50-7.5 71-21.5l37.1-24.8C278.7 102.2 299.1 96 320 96zm-166.8 32H48c-26.5 0-48 21.5-48 48v85c0 51.4 35 96.2 84.8 108.7l71.3 17.8 14.9 3.7c39.6 35.3 91.8 56.8 149 56.8s109.4-21.5 149-56.8l14.9-3.7 71.3-17.8C605 357.2 640 312.4 640 261v-85c0-26.5-21.5-48-48-48H486.8c-19 0-37.5-5.6-53.3-16.1l-37.1-24.8C373.8 72 347.2 64 320 64s-53.8 8-76.4 23.1l-37.1 24.8a96.2 96.2 0 0 1-53.3 16.1zM48 160h48v64c0 46.3 14 89.3 38.1 125l-41.5-10.3C57 329.8 32 297.8 32 261v-85c0-8.8 7.2-16 16-16zm499.4 178.7L505.9 349C530 313.3 544 270.3 544 224v-64h48c8.8 0 16 7.2 16 16v85c0 36.7-25 68.7-60.6 77.6zM208 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zm-16 80c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm48 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"
        }
    ]
};

const FalMaskSnorkel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMaskSnorkel",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 32c8.8 0 16 7.2 16 16v112h-32V48c0-8.8 7.2-16 16-16zM448 480c53 0 96-43 96-96V192h32v192c0 70.7-57.3 128-128 128s-128-57.3-128-128v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 53 43 96 96 96zM64 96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h79.7c14.3 0 26.8-9.5 30.8-23.2l3.4-11.7c13.3-46.4 79-46.4 92.3 0l3.4 11.7c3.9 13.7 16.5 23.2 30.8 23.2H384c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64h-79.7c-28.6 0-53.7-18.9-61.5-46.4l-3.4-11.7c-4.4-15.5-26.3-15.5-30.8 0l-3.4 11.7c-7.9 27.5-33 46.4-61.5 46.4H64c-35.3 0-64-28.7-64-64v-96z"
        }
    ]
};

const FalMaskVentilator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMaskVentilator",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 300.8c0 44.6 21.7 85.6 56.9 112.9-5.7-13.6-8.9-28.6-8.9-44.3 0-30.2 11.8-69.3 30.3-100.8 9.3-15.9 20.8-30.7 34.2-41.7 13.4-11 29.5-18.8 47.5-18.8s34 7.9 47.3 18.8 24.8 25.8 34.2 41.7C420 300 432 339.1 432 369.3c0 15.6-3.1 30.4-8.8 43.9C458.1 386 480 345.4 480 300.8c0-42-19.2-103.3-51.6-154.3C395 93.9 355.3 64 320 64c-35.8 0-75.5 30-108.7 82.4-32.3 51-51.3 112.4-51.3 154.4zm80 68.5c0 26.6 12.5 50.1 32 64.9v40.2c-51.6-12.3-94.5-43.9-119.7-86l-68.8-18.1C34.3 357.4 0 312.9 0 262v-86c0-26.5 21.5-48 48-48h137.1c34.7-54.2 82.3-96 134.9-96 52.1 0 99.7 41.8 134.5 96H592c26.5 0 48 21.5 48 48v86c0 50.9-34.3 95.4-83.5 108.3l-69 18.2C462.1 430.6 419 462 368 474.3V434c19.3-14.7 32-38 32-64.7 0-23.3-9.8-56.8-26.1-84.6-8.1-13.7-17.3-25.3-26.9-33.2S328.3 240 320 240c-8.4 0-17.6 3.6-27.2 11.5-9.6 7.9-18.8 19.4-26.9 33.2-16.2 27.7-25.9 61.3-25.9 84.6zm264.4-18.4 43.9-11.6c35.1-9.2 59.6-41 59.6-77.4V176c0-8.8-7.2-16-16-16h-119c24.5 47.8 39.1 100.3 39.1 140.8 0 17.4-2.7 34.3-7.6 50.1zM166.8 160H48c-8.8 0-16 7.2-16 16v86c0 36.3 24.5 68.1 59.6 77.4l43.9 11.6c-4.9-15.9-7.5-32.7-7.5-50.1 0-40.5 14.4-93 38.8-140.8zM304 320c0-8.8 7.2-16 16-16s16 7.2 16 16v192h-32V320z"
        }
    ]
};

const FalMask = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMask",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80.9 150.2C46 180.3 32 222.2 32 272c0 47.9 16.9 83.2 41.9 106.7C99.2 402.4 135 416 176 416h8.4c12.1 0 23.2-6.8 28.6-17.7l23.2-46.3 28.6 14.3-23.2 46.3c-10.8 21.7-33 35.4-57.2 35.4H176C80 448 0 384 0 272S64 64 288 64s288 96 288 208-80 176-176 176h-8.4c-24.2 0-46.4-13.7-57.2-35.4l-23.2-46.3c-4.4-8.8-13.3-14.3-23.2-14.3s-18.8 5.5-23.2 14.3L236.2 352c9.8-19.6 29.9-32 51.8-32s42 12.4 51.8 32l23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7h8.4c41 0 76.8-13.6 102.1-37.3C527.1 355.3 544 320 544 272c0-49.8-14-91.7-48.9-121.8C459.3 119.3 396.2 96 288 96s-171.3 23.3-207.1 54.2zM160 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm288 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalMasksTheater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMasksTheater",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.6 28c1.7 1.2 3.2 2.5 4.5 4-23 .4-42.7 2.7-59.5 6.3-26.4-6.7-68.1-10.5-131.4-.1C76.9 56.1 41.9 92.8 32.6 105.7v.1c-.1.8-.2 2.4.3 5l27.9 163.7c5.4 31.5 19.5 58.8 41.8 76.9 20.8 16.8 46.9 35.3 74 48.2 16.9 8.1 32.9 13.4 47.4 15.5 6.8 10.4 14.5 21.4 23 32.5-58 4.9-123.3-37.8-165-71.7-29.7-24-46.8-59-53.2-96.2L.8 116.1c-1.7-9.8-1-19.9 4.7-28C20.5 67 63.6 25.9 179.8 6.9S350.5 12.8 371.6 28zM159 286.9c9.4-7.6 22-15.8 37.8-21.8l-1.7 10.2c-1.5 9-2.5 18.2-2.9 27.5-4.7 2.8-8.9 5.8-12.4 8.7-5.7 4.7-11.3 9.9-15.7 15.9-5 7.2-15.1 9.1-22.5 4.2-7.4-4.9-9.4-14.8-4.4-22.1 5.9-8.6 13.8-16 21.8-22.6zm-3.9-122.6c3.1-8.2 12.5-12.4 20.9-9.3s12.7 12.3 9.5 20.5c-5.9 15.4-19.8 27.5-37.6 30.4s-35-4-45.7-16.7c-5.7-6.8-4.7-16.8 2.2-22.4s17.2-4.6 22.9 2.1c7.8 9.3 23.5 6.7 27.8-4.6zm230 346.3c-60-9.8-110.5-74.6-140.1-122-20.1-32.2-24.7-70.7-18.3-107.9L254.6 117c1.7-9.8 5.6-19.1 13.8-24.9 21.1-15.3 75.6-40.3 191.8-21.2s159.3 60.1 174.3 81.2c5.8 8.1 6.4 18.2 4.7 28l-27.9 163.7c-6.4 37.2-23.5 72.2-53.2 96.2-43.7 35.4-113.1 80.5-173 70.7zm-58.5-69.5c21.7 21.3 43.5 34.7 63.8 38s45.4-2.4 73-15.6c27.1-13 53.2-31.4 74-48.2 22.3-18.1 36.4-45.4 41.8-76.9l27.9-163.7c.4-2.5.4-4.2.3-5v-.1c-9.4-12.9-44.3-49.7-152.6-67.5s-153.6 5.9-166.7 15.1v.1c-.4.7-1 2.2-1.4 4.8l-28 163.8c-5.4 31.5-1.1 61.9 14 86.1 14.1 22.6 32.6 48.3 53.9 69.2zm24.7-202.5c-5.7 6.8-16 7.7-22.9 2.1s-7.9-15.6-2.2-22.4c10.7-12.7 27.8-19.6 45.7-16.7s31.7 15 37.6 30.4c3.1 8.2-1.1 17.4-9.5 20.5s-17.8-1.1-20.9-9.3c-2-5.2-6.6-9.2-12.5-10.1s-11.6 1.3-15.2 5.6zm147.8 85.7.6-.2c3.1-1 6.1-2 9.1-3.1 3.7-1.4 7.3-2.9 10.9-4.5 6.2-2.8 13.5 1.6 12.4 8.3-.7 4.2-1.7 8.3-2.8 12.3-1 3.5-2.2 7-3.6 10.4l-.6 1.5c-19.7 47-70.6 76.1-123.9 67.4s-91.7-52.5-94.8-103.3c0-.5-.1-1.1-.1-1.6-.2-3.6-.1-7.3.1-11 .2-4.1.7-8.3 1.4-12.5 1.1-6.6 9.5-8.5 14.5-3.9 2.8 2.6 5.8 5.2 8.8 7.7 2.5 2 5 4 7.6 5.9l.5.4c22 15.9 48 27.2 76.8 31.9s57.1 2.4 83.2-5.6zm-20.7 37.4c-21.9 3.4-44.8 3.4-67.8-.4S366 350.2 346.4 340c10.9 22.9 32.8 40.4 60.2 44.9s53.9-5 71.8-23.2zm1.2-102c-5.7 6.8-16 7.7-22.9 2.1s-7.9-15.6-2.2-22.4c10.7-12.7 27.8-19.6 45.7-16.7s31.7 15 37.6 30.4c3.1 8.2-1.1 17.4-9.5 20.5s-17.8-1.1-20.9-9.3c-2-5.2-6.6-9.2-12.6-10.1s-11.6 1.3-15.2 5.6z"
        }
    ]
};

const FalMattressPillow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMattressPillow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96v320H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h192zm32 0h288c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H288V96zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm112 96c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h64zm-64-32c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-64z"
        }
    ]
};

const FalMaximize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMaximize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m50.2 196.5.6.2c8.2 2 16.8-.4 22.8-6.3l47.1-47.1L233.4 256 120.7 368.7l-47.1-47.1c-6-6-14.6-8.4-22.8-6.3l-.6.2C39.5 318.1 32 327.7 32 338.7V456c0 13.3 10.7 24 24 24h117.3c11 0 20.6-7.5 23.3-18.2l.2-.6c2-8.2-.4-16.8-6.3-22.8l-47.1-47.1L256 278.6l112.7 112.7-47.1 47.1c-6 6-8.4 14.6-6.3 22.8l.2.6c2.7 10.7 12.3 18.2 23.3 18.2H456c13.3 0 24-10.7 24-24V338.7c0-11-7.5-20.6-18.2-23.3l-.6-.2c-8.2-2-16.8.4-22.8 6.3l-47.1 47.1L278.6 256l112.7-112.7 47.1 47.1c6 6 14.6 8.4 22.8 6.3l.6-.2c10.7-2.7 18.2-12.3 18.2-23.3V56c0-13.3-10.7-24-24-24H338.7c-11 0-20.6 7.5-23.3 18.2l-.2.6c-2 8.2.4 16.8 6.3 22.8l47.1 47.1L256 233.4 143.3 120.7l47.1-47.1c6-6 8.4-14.6 6.3-22.8l-.2-.6C193.9 39.5 184.3 32 173.3 32H56c-13.3 0-24 10.7-24 24v117.3c0 11 7.5 20.6 18.2 23.3zM64 154.7V64h90.7L64 154.7zM154.7 448H64v-90.7l90.7 90.7zM448 154.7 357.3 64H448v90.7zM357.3 448l90.7-90.7V448h-90.7z"
        }
    ]
};

const FalMeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMeat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288.9 223.1c30 30 65.3 51.2 99.4 60.2 12.2 3.2 25.2 5 38 4.7L409 305.3c-30 30-70.7 46.8-113.1 46.8H208c-26.5 0-48-21.5-48-48V216c0-42.4 16.9-83.1 46.9-113.1l17.2-17.2c-.3 12.8 1.5 25.8 4.7 38 9 34.1 30.2 69.4 60.2 99.4zm175.8 17.7c-31.2 31.2-99.7 13.1-153.2-40.3S240 78.5 271.2 47.3c9.9-9.9 23.5-14.8 39.2-15.2 8.9.2 18.1 1.6 27.1 3.9 28.9 7.6 59.6 25.9 86.1 52.3s44.7 57.2 52.3 86.1c2.3 8.9 3.7 17.9 3.9 26.8-.4 15.9-5.3 29.6-15.3 39.6zM347.6 4.8c-12-3.2-24.8-5-37.4-4.7-25.7-.3-52.7 6.9-74 28.2l-52 52c-36 36-56.2 84.8-56.2 135.8v90.7c0 4.2-1.7 8.3-4.7 11.3l-2 2h-.1c-.1 0-.5.1-1.2.1-1.5-.1-3.5-.7-5.2-2C102.9 309.3 88.1 304 72 304c-39.8 0-72 32.2-72 72 0 37.2 28.2 67.8 64.4 71.6C68.2 483.8 98.8 512 136 512c39.8 0 72-32.2 72-72 0-16.1-5.3-30.9-14.2-42.9-1.2-1.7-1.9-3.7-2-5.2 0-.7.1-1.1.1-1.2v-.1l2-2c3-3 7.1-4.7 11.3-4.7H296c50.9 0 99.7-20.2 135.7-56.2l52.1-52.1c21.4-21.4 28.6-48.6 28.1-74.5.2-12.5-1.6-25-4.7-36.9-9-34.1-30.2-69.4-60.2-99.4s-65.3-51.2-99.4-60.2zM165.9 372c-10.6 14.6-5.7 33.5 2.2 44.1 4.9 6.7 7.9 14.9 7.9 23.8 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-13.1-10.9-24-24-24-22.1 0-40-17.9-40-40s17.9-40 40-40c9 0 17.2 2.9 23.8 7.9 10.7 7.9 29.5 12.8 44.1 2.2 6.5 10.5 15.4 19.4 25.9 25.9zm186-211.9c15.3 15.3 34.9 20.4 43.8 11.5s3.8-28.5-11.5-43.8-34.9-20.4-43.8-11.5-3.8 28.5 11.5 43.8z"
        }
    ]
};

const FalMedal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMedal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M106.4 191.5c7.5-7.8 15.6-14.9 24.2-21.4L38.5 32h103.4l61.6 102.7c10.9-2.8 22.2-4.8 33.8-5.9l-68-113.3C163.5 5.9 153.1 0 141.9 0H24.6C11 0 0 11 0 24.6c0 4.8 1.4 9.6 4.1 13.6l102.3 153.3zm168.3-62.7c11.6 1 22.9 3 33.8 5.9L370.1 32h103.4l-92 138.1c8.6 6.5 16.7 13.7 24.2 21.4L507.9 38.2c2.7-4 4.1-8.8 4.1-13.6C512 11 501 0 487.4 0H370.1c-11.2 0-21.7 5.9-27.4 15.5l-68 113.3zM256 192a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 320a176 176 0 1 0 0-352 176 176 0 1 0 0 352zm38.8-229.5-17.3-35.1c-8.8-17.8-34.2-17.8-43 0l-17.3 35.1-38.7 5.6c-19.7 2.9-27.5 27.1-13.3 40.9l28 27.3-6.7 38.7c-3.4 19.6 17.2 34.6 34.8 25.3l34.7-18.2 34.6 18.2c17.6 9.3 38.2-5.7 34.8-25.3l-6.6-38.6 28-27.3c14.2-13.9 6.4-38.1-13.3-40.9l-38.7-5.6zm-50.8 18 12-24.3 12 24.3c3.5 7.1 10.3 12 18.1 13.1l26.8 3.9-19.4 18.9c-5.7 5.5-8.2 13.5-6.9 21.2l4.6 26.7-24-12.6c-7-3.7-15.3-3.7-22.3 0l-24 12.6 4.6-26.7c1.3-7.8-1.2-15.7-6.9-21.2l-19.4-18.9 26.8-3.9c7.8-1.1 14.6-6 18.1-13.1z"
        }
    ]
};

const FalMegaphone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMegaphone",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M560 32c-8.8 0-16 7.2-16 16v11.5l-512 128V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-11.5l131.7 32.9c-2.4 8.4-3.7 17.4-3.7 26.6 0 53 43 96 96 96 46.2 0 84.7-32.6 93.9-76L544 452.5V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm-16 387.5-512-128v-71l512-128v327zM192 384c0-6.5 1-12.9 2.8-18.8l124 31c-5.7 29.5-31.6 51.8-62.8 51.8-35.3 0-64-28.7-64-64z"
        }
    ]
};

const FalMelonSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMelonSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M427.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-82.1 82.1c-3.6 3.6-5.2 8.6-4.5 13.6 1.3 9 2 18.2 2 27.6 0 106-86 192-192 192-9.4 0-18.6-.7-27.6-2-5-.7-10 1-13.6 4.5L4.7 404.7c-6.2 6.2-6.2 16.4 0 22.6C58.9 481.5 132.5 512 209.1 512h4C378.2 512 512 378.2 512 213.2v-4c0-76.7-30.5-150.2-84.7-204.5zm-36.3 59L415.6 39C457 85.8 480 146.3 480 209.1v4C480 360.5 360.5 480 213.2 480h-4c-62.9 0-123.4-23-170.2-64.4L63.7 391c40.8 35.5 94 57 152.3 57 128.1 0 232-103.9 232-232 0-58.3-21.5-111.6-57-152.3zm-22.7 22.6C398 121.3 416 166.5 416 216c0 110.5-89.5 200-200 200-49.5 0-94.7-18-129.7-47.7l17.6-17.6c7.9.8 16 1.3 24.1 1.3 123.7 0 224-100.3 224-224 0-8.1-.4-16.2-1.3-24.1l17.6-17.6z"
        }
    ]
};

const FalMelon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMelon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256c0-35.8-8.4-69.7-23.4-99.7-8.4 56.6-47.7 127.6-110.2 190.1S212.9 448.2 156.3 456.6c30 14.9 63.9 23.4 99.7 23.4 123.7 0 224-100.3 224-224zM55.4 355.7c8.4-56.6 47.7-127.6 110.2-190.1S299.1 63.8 355.7 55.4c-30-15-63.9-23.4-99.7-23.4C132.3 32 32 132.3 32 256c0 35.8 8.4 69.7 23.4 99.7zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM414.3 97.7c-11.8-11.8-38.7-18.4-84.2-3.2-43.5 14.5-94.7 46.5-142 93.8s-79.3 98.5-93.8 142c-15.2 45.5-8.6 72.4 3.2 84.2s38.7 18.4 84.2 3.2c43.5-14.5 94.7-46.5 142-93.8s79.3-98.5 93.8-142c15.2-45.5 8.6-72.4-3.2-84.2z"
        }
    ]
};

const FalMemoCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMemoCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h232.2c9.8 11.8 21 22.3 33.5 31.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v134.6c-11.2 3.2-21.9 7.4-32 12.6V64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm352 160a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm44.7 100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7z"
        }
    ]
};

const FalMemoCircleInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMemoCircleInfo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h232.2c9.8 11.8 21 22.3 33.5 31.3-3.2.5-6.4.7-9.7.7H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v134.6c-11.2 3.2-21.9 7.4-32 12.6V64c0-17.7-14.3-32-32-32zM64 144c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm16 80h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm464 48a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-32a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-32 96c0-8.8 7.2-16 16-16v-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16v48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalMemoPad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMemoPad",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 128v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V128H32zm0-32h384V64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v32zm416-32v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64zM112 192h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalMemo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMemo",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 64h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalMemory = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMemory",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 128c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32-19.4 14.6-32 37.8-32 64s12.6 49.5 32 64v32H32v-32c19.4-14.6 32-37.8 32-64s-12.6-49.5-32-64zM0 248.6V416c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V248.6c0-6.8-4.4-12.6-10.1-16.3-13.2-8.6-21.9-23.4-21.9-40.3s8.7-31.7 21.9-40.3c5.7-3.7 10.1-9.5 10.1-16.3V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v7.4c0 6.8 4.4 12.6 10.1 16.3C23.3 160.3 32 175.1 32 192s-8.7 31.7-21.9 40.3C4.4 236 0 241.8 0 248.6zM544 416h-64v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-56v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-56v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-56v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-56v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H32v-96h512v96zM176 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalMenorah = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMenorah",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM32 128c8.8 0 16 7.2 16 16v160c0 26.5 21.5 48 48 48h16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v208h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v208h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v208h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v208h64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v208h16c26.5 0 48-21.5 48-48V144c0-8.8 7.2-16 16-16s16 7.2 16 16v160c0 44.2-35.8 80-80 80H336v96h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h160v-96H96c-44.2 0-80-35.8-80-80V144c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalMercury = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMercury",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M89.2 4.8C83-1.5 72.8-1.6 66.5 4.6s-6.4 16.3-.2 22.6C81.2 42.4 98.9 55 118.6 64 58 91.8 16 153 16 224c0 91.8 70.3 167.2 160 175.3V432h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-32.7c89.7-8.1 160-83.5 160-175.3 0-71-42-132.2-102.6-160 19.6-9 37.3-21.6 52.3-36.8 6.2-6.3 6.1-16.4-.2-22.6s-16.4-6.1-22.6.2C268.7 31.5 232.3 48 192 48S115.3 31.5 89.2 4.8zM192 80a144 144 0 1 1 0 288 144 144 0 1 1 0-288z"
        }
    ]
};

const FalMerge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMerge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-8.8 7.2-16 16-16h127.7c15.4 0 29.8 7.3 38.8 19.8l108.9 149.6c3 4.1 7.8 6.6 12.9 6.6h153.1l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7H304.3c-5.1 0-9.9 2.4-12.9 6.6L182.5 428.2c-9 12.4-23.5 19.8-38.8 19.8H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h127.7c5.1 0 9.9-2.4 12.9-6.6l108.9-149.6c1-1.3 2-2.6 3-3.8-1.1-1.2-2.1-2.5-3-3.8L156.6 102.6c-3-4.1-7.8-6.6-12.9-6.6H16C7.2 96 0 88.8 0 80z"
        }
    ]
};

const FalMessageArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageArrowDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm208 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v153.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 265.4V112z"
        }
    ]
};

const FalMessageArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm128 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h89.4L172.7 268.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L304 182.6V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16H192z"
        }
    ]
};

const FalMessageArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageArrowUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm208 304V150.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7V304c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalMessageBot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageBot",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 384c17.7 0 32 14.3 32 32v48l98.1-73.6c5.5-4.2 12.3-6.4 19.2-6.4H480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h64zM544 64v112h36.3c5.5-9.6 15.9-16 27.7-16 17.7 0 32 14.3 32 32s-14.3 32-32 32c-11.8 0-22.2-6.4-27.7-16H544v144c0 35.3-28.7 64-64 64H373.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80h-64c-35.3 0-64-28.7-64-64V208H59.7c-5.5 9.6-15.9 16-27.7 16-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16H96V64c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64zm-336 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16H208zm-48 16c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48v-96zm56 48a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm176-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FalMessageCaptions = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageCaptions",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm16 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm288 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zM80 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"
        }
    ]
};

const FalMessageCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm299.3 147.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 241.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalMessageCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm155.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 208l52.7-52.7zm96-22.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6l-64-64z"
        }
    ]
};

const FalMessageDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm208 104c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7-13 7.7-23.9 21.1-23.8 40.5.1 18.4 10.8 30.1 22.7 37.3 10.5 6.3 23.8 10.4 34.8 13.7l1.6.5c12.5 3.8 22.2 6.9 29 11.2 5.9 3.7 7.7 7 7.7 11.6.1 6.6-2.7 10.8-7.8 14-5.8 3.6-14.5 5.6-23.7 5.3-11.8-.4-22.7-4.1-36.3-8.7-2.3-.8-4.7-1.6-7.1-2.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1 9.2 3.2 19.7 6.8 30.9 8.9V312c0 8.8 7.2 16 16 16s16-7.2 16-16v-17.1c8.7-1.4 17.4-4.3 25.1-9.1 13.3-8.3 23.2-22.2 22.9-41.6-.2-18.5-10.6-30.6-22.7-38.2-11-6.9-25-11.2-36.3-14.6l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9-6-3.6-7.2-6.4-7.3-10.1 0-5.4 2.4-9.4 8.1-12.8 6.2-3.7 15.1-5.7 23.6-5.5 10.1.2 21 2.3 32.1 5.3 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V104z"
        }
    ]
};

const FalMessageDots = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageDots",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalMessageExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm192 80c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V96c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalMessageHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm112 173.3c0-16.2 13.1-29.3 29.3-29.3 7.8 0 15.2 3.1 20.7 8.6l18.7 18.7c6.2 6.2 16.4 6.2 22.6 0l18.7-18.7c5.5-5.5 12.9-8.6 20.7-8.6 16.2 0 29.3 13.1 29.3 29.3 0 7.8-3.1 15.2-8.6 20.7L256 265.4 184.6 194c-5.5-5.5-8.6-12.9-8.6-20.7zm29.3-61.3c-33.8 0-61.3 27.4-61.3 61.3 0 16.2 6.5 31.8 17.9 43.3l82.7 82.7c6.2 6.2 16.4 6.2 22.6 0l82.7-82.7c11.5-11.5 17.9-27.1 17.9-43.3 0-33.8-27.4-61.3-61.3-61.3-16.2 0-31.8 6.5-43.3 17.9l-7.4 7.4-7.4-7.4c-11.5-11.5-27.1-17.9-43.3-17.9z"
        }
    ]
};

const FalMessageImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageImage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm88 128a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm135.9 32.1L380.3 288H131.5l44.6-63.8 19 25.4c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4l67.1-89.5zm-25.5-19.4L208 213.3l-6.5-8.7c-6-8-15.4-12.7-25.3-12.7-10.3 0-20 5-26 13.5l-49.1 70.2c-3.3 4.7-5.1 10.4-5.1 16.2 0 15.6 12.6 28.2 28.2 28.2h263.7c15.5 0 28.1-12.6 28.1-28.1 0-5.9-1.9-11.7-5.3-16.4l-97-134.3c-6-8.3-15.6-13.2-25.8-13.2-10 0-19.4 4.7-25.5 12.7z"
        }
    ]
};

const FalMessageLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageLines",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"
        }
    ]
};

const FalMessageMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm176 96c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48z"
        }
    ]
};

const FalMessageMiddleTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageMiddleTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.5 128H448c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h104.5c9.5 0 18.5-4.2 24.6-11.5L256 41l62.9 75.5c6.1 7.3 15.1 11.5 24.6 11.5zM268.3 26.3 256 16l12.3 10.2zM168.5 96H64c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H343.5L268.3 5.8c-3-3.7-7.6-5.8-12.3-5.8s-9.3 2.1-12.3 5.8L168.5 96z"
        }
    ]
};

const FalMessageMiddle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageMiddle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M343.5 384H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h104.5c9.5 0 18.5 4.2 24.6 11.5L256 471l62.9-75.5c6.1-7.3 15.1-11.5 24.6-11.5zm-75.2 101.7L256 496l12.3-10.2zM168.5 416H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H343.5l-75.2 90.2c-3 3.6-7.5 5.8-12.3 5.8s-9.3-2.1-12.3-5.8L168.5 416z"
        }
    ]
};

const FalMessageMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm96 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
        }
    ]
};

const FalMessageMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm281.1 82.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V155.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V96c0-5.2-2.6-10.2-6.9-13.2zM320 244c0 4.1-4.5 12-16 12s-16-7.9-16-12 4.5-12 16-12 16 7.9 16 12zm-128 32c0 4.1-4.5 12-16 12s-16-7.9-16-12 4.5-12 16-12 16 7.9 16 12z"
        }
    ]
};

const FalMessagePen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessagePen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm252.3 147.7c4.9 4.9 4.9 12.9 0 17.8l-8.1 8.1-17.8-17.8 8.1-8.1c4.9-4.9 12.9-4.9 17.8 0zm-109.2 91.4 60.7-60.7 17.8 17.8-60.8 60.8c-2.1 2.1-4.6 3.5-7.4 4.2L198 266l4.9-19.5c.7-2.8 2.2-5.4 4.2-7.4zM275.8 125l-91.4 91.5c-6.1 6.2-10.5 13.9-12.6 22.3l-11.3 45.3c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l45.3-11.3c8.4-2.1 16.2-6.5 22.3-12.6l91.4-91.5c17.4-17.4 17.4-45.6 0-63s-45.7-17.4-63.1 0z"
        }
    ]
};

const FalMessagePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessagePlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm176 304c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
        }
    ]
};

const FalMessageQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm104.7 121.8-.2.7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3 0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V240c0 8.8 7.2 16 16 16s16-7.2 16-16v-19.7l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2C344 109 315.5 80 280 80h-57.1c-25.5 0-47.7 17.2-54.2 41.8zM280 304a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalMessageQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageQuote",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm144 144v48h-48v-48h48zm-48 80h48c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C215 290.7 240 258.7 240 222v-78c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32zm144-80h48v48h-48v-48zm48 80c-.9 21.2-15.6 39.4-36.3 44.6l-15.5 3.9c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l15.5-3.9C359 290.7 384 258.7 384 222v-78c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v48c0 17.7 14.3 32 32 32h48z"
        }
    ]
};

const FalMessageSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M378.8 384h-5.5c-6.9 0-13.7 2.2-19.2 6.4L256 464v-48c0-17.7-14.3-32-32-32h-96c-17.7 0-32-14.3-32-32V160.7l-32-25.3V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h46l-40.5-32zM128 0c-8.3 0-16.1 1.6-23.4 4.4l35 27.6H512c17.7 0 32 14.3 32 32v287.3l28.3 22.3c2.4-6.8 3.7-14 3.7-21.6V64c0-35.3-28.7-64-64-64H128zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalMessageSmile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageSmile",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm128 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-164.1 68.1c-6.6 5.9-7.1 16-1.3 22.6C179.5 302.5 215.7 320 256 320s76.5-17.5 101.4-45.3c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3c-19 21.2-46.7 34.6-77.5 34.6s-58.5-13.4-77.5-34.7c-5.9-6.6-16-7.1-22.6-1.3z"
        }
    ]
};

const FalMessageSms = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageSms",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm138.9 144.8c-6.5 2.2-10.9 8.3-10.9 15.2v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-48l19.2 25.6c3 4 7.8 6.4 12.8 6.4s9.8-2.4 12.8-6.4L288 208v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-6.9-4.4-13-10.9-15.2s-13.7.1-17.9 5.6L256 197.3l-35.2-46.9c-4.1-5.5-11.3-7.8-17.9-5.6zm-90.9 38c0-1.1.2-1.6.4-1.9.3-.4.9-1.2 2.4-2 3.1-1.8 8-3 12.9-2.9 6.6.1 16.7 1.6 23.3 3.4 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.8-2.4-21.6-4.3-31.1-4.4-9.3-.1-20.4 1.9-29.7 7.4C88.6 157.3 80 167.8 80 183c.1 14.7 8.8 24 17.7 29.4 7.6 4.6 17.1 7.4 24.3 9.6l1.2.4c8.5 2.6 14.2 4.5 18 6.9 2.7 1.7 2.7 2.4 2.7 3.1v.2c0 1.6-.3 2.3-.6 2.7-.3.5-.9 1.2-2.1 2-2.8 1.7-7.5 2.9-12.8 2.8-7.2-.2-14.2-2.6-23.7-5.8-1.3-.4-2.6-.9-4-1.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.1.4 2.4.8 3.6 1.2 9 3.1 20.9 7.2 33.2 7.6 9.8.3 21.2-1.6 30.7-7.6 10.2-6.4 18-17.3 17.8-32.3-.2-14.7-8.5-24.2-17.6-29.9-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8-1.6-1-2.1-1.6-2.2-1.7v-.4zm256 0c0-1.1.2-1.6.4-1.9.3-.4.9-1.2 2.4-2 3.1-1.8 8-3 12.9-2.9 6.1.1 12.9 1.4 20.1 3.4 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-8.2-2.2-17.9-4.3-27.9-4.4-9.3-.1-20.3 1.9-29.7 7.4-9.9 5.9-18.6 16.4-18.5 31.6.1 14.7 8.8 24 17.7 29.4 7.6 4.6 17.1 7.4 24.3 9.6l1.2.4c8.5 2.6 14.2 4.5 18 6.9 2.7 1.7 2.7 2.4 2.7 3.1v.2c0 1.6-.3 2.3-.6 2.7-.3.5-.9 1.2-2.1 2-2.8 1.7-7.5 2.9-12.8 2.8-7-.2-13.5-2.4-22.6-5.5-1.5-.5-3.2-1.1-4.9-1.6-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c1.2.4 2.6.9 4 1.4 8.8 3 20.4 7 32.6 7.4 9.8.3 21.2-1.6 30.7-7.6 10.2-6.4 18-17.3 17.8-32.3-.2-14.7-8.5-24.2-17.6-29.9-8-5-17.9-8-25.2-10.2l-.6-.2c-8.6-2.6-14.4-4.4-18.3-6.8-1.6-1-2.1-1.6-2.2-1.7v-.4z"
        }
    ]
};

const FalMessageText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageText",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm128 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v112c0 8.8 7.2 16 16 16s16-7.2 16-16V160h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H192z"
        }
    ]
};

const FalMessageXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessageXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464v-48zM64 0C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm116.7 132.7c-6.2 6.2-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 208l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 185.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalMessage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 384c17.7 0 32 14.3 32 32v48l98.1-73.6c5.5-4.2 12.3-6.4 19.2-6.4H448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h96zM0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v288c0 35.3-28.7 64-64 64H309.3l-123.7 92.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3v-80H64c-35.3 0-64-28.7-64-64V64z"
        }
    ]
};

const FalMessagesDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessagesDollar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M183.5 294.4 128 336v-16c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H202.7c-6.9 0-13.7 2.2-19.2 6.4zm19.2 25.6H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v192c0 35.3 28.7 64 64 64h32v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5l81.1-60.8zm53.3 64c0 35.3 28.7 64 64 64h117.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3v-48h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448v32h128c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32 14.3-32 32v16l-55.5-41.6c-5.5-4.2-12.3-6.4-19.2-6.4H320c-17.7 0-32-14.3-32-32v-32h-32v32zM224 79.1c0-8.8-7.2-16-16-16s-16 7.2-16 16v10.5c-6 1.3-12.1 3.4-17.6 6.6-11.1 6.4-20.9 17.8-20.8 34.7.1 16.2 9.8 26.2 19.9 32.2 8.8 5.1 19.7 8.4 28.4 10.9l1.4.4c10.1 3 17.4 5.3 22.5 8.4 4.2 2.5 4.5 4.1 4.5 5.9 0 3.5-1.2 5.7-4.6 7.7-4 2.4-10.4 3.9-17.3 3.7-9-.3-17.3-3-28.2-6.6-1.8-.6-3.8-1.2-5.8-1.9-8.4-2.7-17.4 1.9-20.2 10.3s1.9 17.4 10.3 20.2c1.6.5 3.2 1 4.9 1.6 6.6 2.2 14.3 4.8 22.5 6.5v10.9c0 8.8 7.2 16 16 16s16-7.2 16-16v-10.5c6.4-1.3 12.7-3.5 18.4-7 11.4-6.9 20.2-18.8 20-35.5-.2-16.2-9.6-26.5-19.8-32.8-9.2-5.6-20.7-9-29.6-11.6l-.5-.2c-10.2-3-17.6-5.2-22.7-8.2-4.1-2.4-4.1-3.6-4.1-4.6v-.1c0-2.5.9-4.5 4.8-6.8 4.4-2.5 11-4 17.4-3.9 7.7.1 16.2 1.8 25 4 8.6 2.2 17.3-2.9 19.5-11.5s-2.9-17.3-11.5-19.5c-5.2-1.3-10.9-2.7-16.8-3.6V79.1z"
        }
    ]
};

const FalMessagesQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessagesQuestion",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M202.7 288H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32v16l55.5-41.6c5.5-4.2 12.3-6.4 19.2-6.4zM352 320H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5S96 374.1 96 368v-48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64zm-32 128c-35.3 0-64-28.7-64-64v-32h32v32c0 17.7 14.3 32 32 32h117.3c6.9 0 13.7 2.2 19.2 6.4L512 464v-16c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H448v-32h128c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64h-32v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320zM184.3 70.3c-16.4 0-31 10.3-36.4 25.7l-.3.9c-3 8.3 1.4 17.5 9.7 20.4s17.5-1.4 20.4-9.7l.3-.9c.9-2.7 3.5-4.4 6.3-4.4h41.3c6.5 0 11.7 5.3 11.7 11.7 0 4.2-2.2 8.1-5.9 10.2l-31.4 18c-5 2.9-8 8.1-8 13.9v9.5c0 8.8 7.2 16 16 16s16-7.2 16-16v-.3l23.4-13.3c13.6-7.8 22-22.3 22-37.9 0-24.2-19.6-43.7-43.7-43.7h-41.4zM208 250.7a22.7 22.7 0 1 0 0-45.3 22.7 22.7 0 1 0 0 45.3z"
        }
    ]
};

const FalMessages = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMessages",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M202.7 288H352c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h32c17.7 0 32 14.3 32 32v16l55.5-41.6c5.5-4.2 12.3-6.4 19.2-6.4zM352 320H202.7l-81.1 60.8c-4.8 3.6-11.3 4.2-16.8 1.5S96 374.1 96 368v-48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64zm-32 128c-35.3 0-64-28.7-64-64v-32h32v32c0 17.7 14.3 32 32 32h117.3c6.9 0 13.7 2.2 19.2 6.4L512 464v-16c0-17.7 14.3-32 32-32h32c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H448v-32h128c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64h-32v48c0 6.1-3.4 11.6-8.8 14.3s-11.9 2.1-16.8-1.5L437.3 448H320z"
        }
    ]
};

const FalMeteor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMeteor",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c0-26.4-30.1-41.4-51.2-25.6L81.1 147.2C30 185.5 0 246.1 0 309.8 0 420.9 90 512 201.3 512c64.6 0 125.3-31 163.2-83.4l134.1-185.9c15.3-21.2.2-50.7-25.9-50.7h-26.1L509 50.3c2-4.5 3-9.5 3-14.4C512 16 496 0 476.2 0c-5 0-9.9 1-14.4 3L320 65.4V32zm154.6.3c.5-.2 1-.3 1.5-.3 2.1 0 3.8 1.7 3.8 3.8 0 .5-.1 1.1-.3 1.5l-72.2 164.3c-2.2 4.9-1.7 10.7 1.2 15.2s8 7.3 13.4 7.3h50.6L338.5 409.8c-31.8 44.1-82.9 70.2-137.2 70.2C107.9 480 32 403.4 32 309.8c0-53.8 25.3-104.8 68.3-137L288 32v57.9c0 5.4 2.7 10.4 7.3 13.4s10.2 3.4 15.2 1.2l164.1-72.2zM296 312a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm-96-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm-16 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56 48a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalMeterBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMeterBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256c0 5.7-.2 11.4-.6 17l32.3-30.6C504.6 107.4 392.8 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c69.2 0 132-27.5 178.1-72.1-12.4-.8-23.7-5.8-32.4-13.7C362.5 459.7 311.6 480 256 480 132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224zM176 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64zm95.7 232 85.1-80.6-19.4 41.9c-2.3 5-1.9 10.7 1 15.3s8 7.4 13.5 7.4h48.3l-85.1 80.6 19.4-41.9c2.3-5 1.9-10.7-1-15.3s-8-7.4-13.5-7.4h-48.3zm121.9-152c-5.1 0-10.1 2-13.8 5.5L422.7 370.7c-4.3 4.1-6.7 9.7-6.7 15.7 0 11.9 9.7 21.6 21.6 21.6H487l-34.8 75.5c-6.1 13.3 3.6 28.5 18.2 28.5 5.1 0 10.1-2 13.8-5.5l149.1-141.2c4.3-4.1 6.7-9.7 6.7-15.7 0-11.9-9.7-21.6-21.6-21.6H569l34.8-75.5c6.1-13.3-3.6-28.5-18.2-28.5z"
        }
    ]
};

const FalMeterDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMeterDroplet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 480c49.7 0 95.5-16.2 132.7-43.5 2.8 10.8 6.9 21.1 12 30.7-41.2 28.3-91 44.8-144.7 44.8C114.6 512 0 397.4 0 256S114.6 0 256 0c110.8 0 205.2 70.4 240.8 169-8.5 5.3-15.7 12.9-20.6 22.1l-3.8 7.1C447 102.5 359.7 32 256 32 132.3 32 32 132.3 32 256s100.3 224 224 224zm-80-336v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm89.4 218.4c-6.2 11.6-9.4 24.5-9.4 37.6 0 44.2 35.8 80 80 80s80-35.8 80-80c0-13.1-3.2-26.1-9.4-37.6L528 230l-70.6 132.4zm-28.2-15.1 75.3-141.2c4.6-8.7 13.7-14.1 23.5-14.1s18.9 5.4 23.5 14.1l75.3 141.2c8.7 16.2 13.2 34.3 13.2 52.7 0 61.9-50.1 112-112 112s-112-50.1-112-112c0-18.4 4.5-36.5 13.2-52.7z"
        }
    ]
};

const FalMeterFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMeterFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c76.2 0 143.5 38 183.9 96.1 12.4-1 25.2 3 35 11.9 5.6 5.1 11.1 10.2 16.6 15.5C452.5 64.1 361.7 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c33.6 0 65.7-6.5 95.1-18.3-8.5-7.8-16.3-16.3-23.2-25.5-22.6 7.7-46.8 11.8-71.9 11.8-123.7 0-224-100.3-224-224S132.3 32 256 32zm112 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 4.4 1.8 8.5 4.7 11.4 8.3-11.6 17.4-23.1 27.3-34.4v-41zm-192 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64zm237.4 109.5c9.6-.1 18.7-4.5 24.7-12.1 3.9-4.9 7.8-9.6 11.6-14 16.4 17.8 30.9 39.4 41.8 60.5C601 314 608 339.4 608 352.2c0 70.2-57 127.8-128 127.8-71.8 0-128-57.5-128-127.8 0-17.9 9.4-46.2 27.6-75.8 15.9-25.8 37.9-53.1 64-78.1 14.3 13.7 27.9 28.3 40.8 43.7 6.2 7.4 15.3 11.6 25 11.5zm-21.8-56.4c-10.9-11.6-22.2-22.8-34-33.4-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.7 31.9-32.4 66.2-32.4 92.6 0 87.9 70.3 160 160 160 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-1.8 1.6-3.5 3.3-5.2 5-7.7 7.7-14.8 16.4-21.2 24.5-7-8.4-14.1-16.5-21.5-24.4zM445.1 256c-4.8 0-9.4 2.2-12.5 5.9-14.9 18.4-26.9 33.8-35.1 47.9C389 324.3 384 338.3 384 354c0 28.7 10.7 52.6 28.8 69.2 18 16.5 42.3 24.8 68.2 24.8 21.3 0 40.3-6 57.9-17.7l.3-.2c37.3-26.1 46.3-77.2 25-116.5v-.1c-1.9-3.9-4.5-9-8.3-14.1-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5-12.4 8.2-25.3 12.2-40 12.2-19.1 0-35.3-6.1-46.6-16.4-11.1-10.2-18.4-25.3-18.4-45.6 0-8.3 2.5-16.8 9.1-28.1 4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.4 1.8 2.4.5.6.1.2L507 351l-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"
        }
    ]
};

const FalMeter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMeter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm176-112v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalMicrochipAi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMicrochipAi",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 0c8.8 0 16 7.2 16 16v48h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16v48h16c35.3 0 64 28.7 64 64v16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v16c0 35.3-28.7 64-64 64h-16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-16c-35.3 0-64-28.7-64-64v-16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-16c0-35.3 28.7-64 64-64h16V16c0-8.8 7.2-16 16-16zm-32 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H128zm94.7 89.6 56 128c3.5 8.1-.1 17.5-8.2 21.1s-17.5-.2-21.1-8.2l-9.9-22.5h-63l-9.8 22.4c-3.5 8.1-13 11.8-21.1 8.2s-11.8-13-8.2-21.1l56-128c2.5-5.8 8.3-9.6 14.7-9.6s12.1 3.8 14.7 9.6zM208 231.9 190.5 272h35.1L208 231.9zM352 192v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalMicrochip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMicrochip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-16c-35.3 0-64 28.7-64 64v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v16c0 35.3 28.7 64 64 64h16v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h16c35.3 0 64-28.7 64-64v-16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-64h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-16c0-35.3-28.7-64-64-64h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64V16zm240 112v256c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32zm-256 0c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H160zm192 32v192H160V160h192z"
        }
    ]
};

const FalMicrophoneLinesSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMicrophoneLinesSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm369.6 393.7-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1-70.7 0-128-57.3-128-128v-19.5l-32-25.3V256c0 83 63.1 151.2 144 159.2V480h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-64.8c21.3-2.1 41.4-8.4 59.5-18.1zM256 123.9V96c0-35.3 28.7-64 64-64s64 28.7 64 64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v32h-48c-8.3 0-15.2 6.4-15.9 14.5l22.1 17.5H384v32h-1.2l33.2 26.2V96c0-53-43-96-96-96s-96 43-96 96v2.7l32 25.3zm190.7 150.6 28.1 22.2c3.4-13 5.2-26.6 5.2-40.7v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 6.3-.5 12.4-1.3 18.5z"
        }
    ]
};

const FalMicrophoneLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMicrophoneLines",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 160v-32h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c0-35.3-28.7-64-64-64s-64 28.7-64 64v160c0 35.3 28.7 64 64 64s64-28.7 64-64h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-32h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48zm32 16v80c0 53-43 96-96 96s-96-43-96-96V96c0-53 43-96 96-96s96 43 96 96v80zM48 192c8.8 0 16 7.2 16 16v48c0 70.7 57.3 128 128 128s128-57.3 128-128v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 83-63.1 151.2-144 159.2V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64.8C95.1 407.2 32 339 32 256v-48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalMicrophoneSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMicrophoneSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M474.8 296.7c3.4-13 5.2-26.6 5.2-40.7v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 6.3-.5 12.4-1.3 18.5l28.1 22.2zM416 250.2V96c0-53-43-96-96-96s-96 43-96 96v2.7l32 25.3V96c0-35.3 28.7-64 64-64s64 28.7 64 64v129l32 25.3zm-224-13.7-32-25.3V256c0 83 63.1 151.2 144 159.2V480h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-64.8c21.3-2.1 41.4-8.4 59.5-18.1l-28.1-22.2c-14.7 5.8-30.6 9.1-47.4 9.1-70.7 0-128-57.3-128-128v-19.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalMicrophoneStand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMicrophoneStand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M449.5 186.9 325.1 62.5l4.7-4.7c34.4-34.4 90.1-34.4 124.4 0s34.4 90.1 0 124.5l-4.7 4.7zm-22.6 22.6-4.7 4.7c-17.5 17.5-40.6 26.1-63.6 25.8L272 153.4c-.4-23 8.2-46.1 25.8-63.6l4.7-4.7 124.4 124.4zM358.3 272c31.3.4 62.7-11.3 86.5-35.1l4.7-4.7 11.3-11.3 11.3-11.3 4.7-4.7c46.9-46.9 46.9-122.8 0-169.7S354-11.7 307.1 35.1l-4.7 4.7-11.3 11.3-11.3 11.4-4.7 4.7c-23.8 23.8-35.5 55.2-35.1 86.5l-225 240c-9.6 10.3-15 23.9-15 38 0 14.7 5.8 28.8 16.3 39.3l24.8 24.8C51.5 506.2 65.6 512 80.4 512c14.1 0 27.7-5.4 38-15L256 367.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V337.9l70.3-65.9zM96.5 473.6c-4.4 4.1-10.1 6.4-16.1 6.4-6.2 0-12.2-2.5-16.6-6.9l-24.9-24.8c-4.4-4.4-6.9-10.4-6.9-16.6 0-6 2.3-11.7 6.4-16.1l218-232.6 72.6 72.6-232.5 218z"
        }
    ]
};

const FalMicrophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMicrophone",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 96v160c0 35.3-28.7 64-64 64s-64-28.7-64-64V96c0-35.3 28.7-64 64-64s64 28.7 64 64zM96 96v160c0 53 43 96 96 96s96-43 96-96V96c0-53-43-96-96-96S96 43 96 96zM64 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 83 63.1 151.2 144 159.2V480h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-64.8c80.9-8 144-76.2 144-159.2v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 70.7-57.3 128-128 128S64 326.7 64 256v-48z"
        }
    ]
};

const FalMicroscope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMicroscope",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-17.7 0-32 14.3-32 32-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V160c88.4 0 160 71.6 160 160s-71.6 160-160 160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16H394.2c51.7-34.4 85.8-93.2 85.8-160 0-106-86-192-192-192V64c0-17.7-14.3-32-32-32 0-17.7-14.3-32-32-32h-32zm0 32h32v16c0 8.8 7.2 16 16 16h16v224h-96V64h16c8.8 0 16-7.2 16-16V32zm-32 336c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-64 64c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalMicrowave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMicrowave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h448zm-32 384v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v288c0 35.3 28.7 64 64 64v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h384zm-16-320v224c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zM128 320V160h256v160H128zM96 152v176c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"
        }
    ]
};

const FalMillSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMillSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M287.2 21.1c2.8-8.4-1.7-17.4-10.1-20.2S259.7 2.6 256.9 11l-34.2 102.2c-12.3 8.2-22.8 18.9-30.7 31.4-18.4-29.2-50.9-48.6-88-48.6-27.9 0-53.3 11-72 29v-13c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h.3c-.2 2.6-.3 5.3-.3 8v232c0 8.8 7.2 16 16 16s16-7.2 16-16V200c0-39.8 32.2-72 72-72s72 32.2 72 72v53.4L96.8 490.9c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1L176 354.6V432c0 8.8 7.2 16 16 16s16-7.2 16-16V258.6l41.2-123.7c9.3-4.4 19.8-6.9 30.8-6.9 39.8 0 72 32.2 72 72v232c0 8.8 7.2 16 16 16s16-7.2 16-16V200c0-57.4-46.6-104-104-104-6.3 0-12.4.6-18.3 1.6L287.2 21z"
        }
    ]
};

const FalMinimize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMinimize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m507.3 27.3-108 108 47.1 47.1c6 6 8.4 14.6 6.3 22.8l-.2.6c-2.7 10.7-12.3 18.2-23.3 18.2H312c-13.3 0-24-10.7-24-24V82.7c0-11 7.5-20.6 18.2-23.3l.6-.2c8.2-2 16.8.4 22.8 6.3l47.1 47.1 108-108c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zm-502.6 0c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l108 108 47.1-47.1c6-6 14.6-8.4 22.8-6.3l.6.2c10.7 2.6 18.2 12.2 18.2 23.2V200c0 13.3-10.7 24-24 24H82.7c-11 0-20.6-7.5-23.3-18.2l-.2-.6c-2-8.2.4-16.8 6.3-22.8l47.1-47.1L4.7 27.3zm502.6 480c-6.2 6.2-16.4 6.2-22.6 0l-108-108-47.1 47.1c-6 6-14.6 8.4-22.8 6.3l-.6-.2c-10.7-2.7-18.2-12.3-18.2-23.3V312c0-13.3 10.7-24 24-24h117.3c11 0 20.6 7.5 23.3 18.2l.2.6c2 8.2-.4 16.8-6.3 22.8l-47.1 47.1 108 108c6.2 6.2 6.2 16.4 0 22.6zM4.7 484.7l108-108-47.1-47.1c-6-6-8.4-14.6-6.3-22.8l.2-.6c2.6-10.7 12.2-18.2 23.2-18.2H200c13.3 0 24 10.7 24 24v117.3c0 11-7.5 20.6-18.2 23.3l-.6.2c-8.2 2-16.8-.4-22.8-6.3l-47.1-47.1-108 108c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm406-292.7L320 101.3V192h90.7zM192 101.3 101.3 192H192v-90.7zM410.7 320H320v90.7l90.7-90.7zM192 410.7V320h-90.7l90.7 90.7z"
        }
    ]
};

const FalMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMinus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 256c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16s7.2-16 16-16h384c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalMistletoe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMistletoe",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c8.8 0 16 7.2 16 16v73.4l91.3 91.3c.2.2.4.5.6.7l5.9 1.1 82.9 15.9C537.7 208.6 576 255 576 309c0 41.4-33.6 75-75 75-54 0-100.3-38.3-110.5-91.3l-15.9-82.9-1.1-5.9c-.2-.2-.5-.4-.7-.7L304 134.6v142.7l4 5.3 56.8 75.7C377.3 375 384 395.2 384 416c0 53-43 96-96 96s-96-43-96-96c0-20.8 6.7-41 19.2-57.6l56.8-75.7 4-5.3V134.6l-68.7 68.7c-.2.2-.5.4-.7.7l-1.1 5.9-.4 2.2c-7.9-2.6-16.3-4-25.1-4-18 0-34.6 5.9-48 16L97.3 230C59.4 237.2 32 270.3 32 309c0 23.8 19.3 43 43 43 14.8 0 28.8-4 40.9-11.2 7.5 8.5 16.8 15.4 27.3 20.2-19.1 14.5-42.8 23-68.2 23-41.4 0-75-33.6-75-75 0-54 38.3-100.3 91.3-110.5l82.9-15.9 5.9-1.1c.2-.2.4-.5.7-.7L272 89.4V16c0-8.8 7.2-16 16-16zm190.7 229.9-70.3-13.5 13.5 70.3c7.3 37.9 40.5 65.3 79.1 65.3 23.8 0 43-19.3 43-43 0-38.6-27.4-71.8-65.3-79.1zM236.8 377.6c-8.3 11.1-12.8 24.6-12.8 38.4 0 35.3 28.7 64 64 64s64-28.7 64-64c0-13.8-4.5-27.3-12.8-38.4L288 309.3l-51.2 68.3zM368 64a16 16 0 1 0 32 0 16 16 0 1 0-32 0zm16 48a48 48 0 1 1 0-96 48 48 0 1 1 0 96zM176 272a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm48 16a48 48 0 1 1-96 0 48 48 0 1 1 96 0z"
        }
    ]
};

const FalMitten = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMitten",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 144.2C0 64.6 65.1 0 144.6 0 208 0 264.4 41.5 282.8 102.3l24.6 81.3c15.3-15 36-23.6 57.9-23.6h1.8c44.7 0 80.9 36.2 80.9 80.9 0 18.6-6.4 36.6-18.1 51l-61.8 76H328c.6-1.7 1.5-3.3 2.6-4.7l74.4-91.4c7.1-8.7 11-19.6 11-30.9 0-27-21.9-48.9-48.9-48.9h-1.8c-17.6 0-34 9.1-43.2 24.1l-7 11.4c-3.3 5.4-9.4 8.3-15.7 7.5s-11.4-5.2-13.3-11.2l-33.9-112.2C237.9 64.4 194 32 144.6 32 82.6 32 32 82.4 32 144.2c0 9.2 1.1 18.3 3.3 27.2L84.5 368h-33L4.3 179.2C1.4 167.7 0 156 0 144.2zM64 432v48h288v-48H64zm-32 0c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-48z"
        }
    ]
};

const FalMobileButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMobileButton",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H96zM32 64C32 28.7 60.7 0 96 0h192c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zm160 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalMobileNotch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMobileNotch",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32v16c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V32H96c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32h-32zm-32 0h-64v16h64V32zM32 64C32 28.7 60.7 0 96 0h192c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64z"
        }
    ]
};

const FalMobileRetro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMobileRetro",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h192zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm160 160v64H96v-64h128zM96 128c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H96zM80 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM128 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64z"
        }
    ]
};

const FalMobileScreenButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMobileScreenButton",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c17.7 0 32 14.3 32 32v256H64V64c0-17.7 14.3-32 32-32h192zm32 320v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-96h256zM96 0C60.7 0 32 28.7 32 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm120 416a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalMobileScreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMobileScreen",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c17.7 0 32 14.3 32 32v256H64V64c0-17.7 14.3-32 32-32h192zm32 320v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-96h256zM96 0C60.7 0 32 28.7 32 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm48 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalMobileSignalOut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMobileSignalOut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32h128V0H96C60.7 0 32 28.7 32 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V288h-32v160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm64 368c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zM272 0c-8.8 0-16 7.2-16 16s7.2 16 16 16c114.9 0 208 93.1 208 208 0 8.8 7.2 16 16 16s16-7.2 16-16C512 107.5 404.5 0 272 0zm16 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-32-144c0 8.8 7.2 16 16 16 61.9 0 112 50.1 112 112 0 8.8 7.2 16 16 16s16-7.2 16-16c0-79.5-64.5-144-144-144-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalMobileSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMobileSignal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32h192c17.7 0 32 14.3 32 32v220.3c10.1-8.3 20.8-15.9 32-22.7V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v384c0 35.3 28.7 64 64 64h128v-24c0-2.7 0-5.3.1-8H96c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm128 368h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c2.2 0 4.3-.4 6.2-1.3 1.8-8.2 4-16.4 6.6-24.3-2.9-3.9-7.6-6.4-12.8-6.4zm272-144c-132.5 0-240 107.5-240 240 0 8.8 7.2 16 16 16s16-7.2 16-16c0-114.9 93.1-208 208-208 8.8 0 16-7.2 16-16s-7.2-16-16-16zm-16 256a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32-144c0-8.8-7.2-16-16-16-79.5 0-144 64.5-144 144 0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9 50.1-112 112-112 8.8 0 16-7.2 16-16z"
        }
    ]
};

const FalMobile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMobile",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H96zM32 64C32 28.7 60.7 0 96 0h192c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V64zm128 336h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalMoneyBill1Wave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBill1Wave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 112.5v-.1c.1-.1.4-.6 1.3-1.2 2-1.3 4.7-1.8 6.9-1.2 18.7 5.1 37.3 8.1 55.8 9.5v.5c0 35.3-28.7 64-64 64v-71.5zm0 309.9V376c35.3 0 64 28.7 64 64v6.8c-19.5-1.9-38.7-6-57.8-13.2-2.5-.9-6.2-4.5-6.2-11.3zm96 17.6c0-53-43-96-96-96V216c52.9 0 95.8-42.8 96-95.6 57.8-1 113.9-15.3 165.7-28.6 4.4-1.1 8.7-2.2 13-3.3C356.9 75.8 403.3 65 448 64v8c0 53 43 96 96 96v128c-52.9 0-95.8 42.8-96 95.6-57.8 1-113.9 15.3-165.7 28.6-4.4 1.1-8.7 2.2-13 3.3C219.1 436.2 172.7 447 128 448v-8zm352-47.5v-.5c0-35.3 28.7-64 64-64v71.6c-.1.1-.4.6-1.3 1.2-2 1.3-4.7 1.8-6.9 1.2-18.6-5.1-37.3-8.1-55.8-9.5zm0-327.3c19.5 1.9 38.7 6 57.8 13.2 2.5.9 6.2 4.5 6.2 11.3V136c-35.3 0-64-28.7-64-64v-6.8zM0 112.5v309.8c0 18 10.1 35 27 41.3 87 32.5 174 10.3 261-11.9 79.8-20.3 159.6-40.7 239.3-18.9 23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3-87-32.5-174-10.3-261 11.9-79.8 20.3-159.6 40.6-239.3 18.8C25.6 72.8 0 88.6 0 112.5zM400 256c0-65-44.9-128-112-128s-112 63-112 128 44.9 128 112 128 112-63 112-128zm-112 96c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96zm-16-160c-8.8 0-16 7.2-16 16s7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8v-80c0-8.8-7.2-16-16-16h-16z"
        }
    ]
};

const FalMoneyBill1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBill1",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96c17.7 0 32 14.3 32 32v32c-35.3 0-64-28.7-64-64h32zm-384 0h320c0 53 43 96 96 96v128c-53 0-96 43-96 96H128c0-53-43-96-96-96V192c53 0 96-43 96-96zM32 352c35.3 0 64 28.7 64 64H64c-17.7 0-32-14.3-32-32v-32zm448 64c0-35.3 28.7-64 64-64v32c0 17.7-14.3 32-32 32h-32zM96 96c0 35.3-28.7 64-64 64v-32c0-17.7 14.3-32 32-32h32zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm192 144c0 8.8 7.2 16 16 16v64h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8v-80c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16zm-64 48a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm224 0a128 128 0 1 0-256 0 128 128 0 1 0 256 0z"
        }
    ]
};

const FalMoneyBillSimpleWave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBillSimpleWave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 422.3c0 6.8 3.7 10.4 6.2 11.3 72.8 27.2 146.7 11.3 231.1-10.2 4.3-1.1 8.6-2.2 13-3.3 77.8-19.9 165.3-42.3 253.5-18.2 2.2.6 4.9.2 6.9-1.2.9-.6 1.2-1.1 1.3-1.2s0 0 0-.1V89.7c0-6.8-3.7-10.4-6.2-11.3C465 51.2 391.1 67.1 306.7 88.5c-4.3 1.1-8.6 2.2-13 3.3-77.8 19.9-165.3 42.3-253.5 18.2-2.2-.6-4.9-.2-6.9 1.2-.9.6-1.2 1.1-1.3 1.2v309.9zm-32 0V112.5c0-23.9 25.6-39.7 48.7-33.4 79.8 21.8 159.6 1.5 239.3-18.9C375 38 462 15.8 549 48.3c16.9 6.3 27 23.2 27 41.3v309.9c0 23.9-25.6 39.7-48.7 33.4-79.8-21.8-159.6-1.5-239.3 18.9-87 22.2-174 44.4-261 11.9-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80-31.3-80-64-80-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112-96-53-96-112 40.4-112 96-112z"
        }
    ]
};

const FalMoneyBillSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBillSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm352 128a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0z"
        }
    ]
};

const FalMoneyBillTransfer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBillTransfer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M548.7 27.3 585.4 64H96c-35.3 0-64 28.7-64 64v220.1L46.1 334 64 316.1V192c53 0 96-43 96-96h425.4l-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-64-64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6zM128 96c0 35.3-28.7 64-64 64v-32c0-17.7 14.3-32 32-32h32zM54.6 448H544c35.3 0 64-28.7 64-64V163.9L593.9 178 576 195.9V320c-53 0-96 43-96 96H54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 448zM576 352v32c0 17.7-14.3 32-32 32h-32c0-35.3 28.7-64 64-64zm-320-96a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm160 0a96 96 0 1 0-192 0 96 96 0 1 0 192 0z"
        }
    ]
};

const FalMoneyBillTrendUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBillTrendUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 16c0 8.8 7.2 16 16 16h57.4L287.2 170.2 186.4 83.9c-6-5.1-14.8-5.1-20.8 0l-112 96c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L176 117.1l101.6 87.1c6.3 5.4 15.8 5.1 21.7-.8L448 54.6V112c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm128 288v32c-26.5 0-48-21.5-48-48h32c8.8 0 16 7.2 16 16zm-368-16h288c0 44.2 35.8 80 80 80v32c-44.2 0-80 35.8-80 80H112c0-44.2-35.8-80-80-80v-32c44.2 0 80-35.8 80-80zm320 192c0-26.5 21.5-48 48-48v32c0 8.8-7.2 16-16 16h-32zM32 432c26.5 0 48 21.5 48 48H48c-8.8 0-16-7.2-16-16v-32zm48-144c0 26.5-21.5 48-48 48v-32c0-8.8 7.2-16 16-16h32zm-32-32c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zm176 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FalMoneyBillWave = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBillWave",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 184c35.3 0 64-28.7 64-64v-.5c-18.5-1.4-37.1-4.4-55.8-9.5-2.2-.6-4.9-.2-6.9 1.2-.9.6-1.2 1.1-1.3 1.2V184zm0 192v46.3c0 6.8 3.7 10.4 6.2 11.3 19.1 7.2 38.3 11.4 57.8 13.2V440c0-35.3-28.7-64-64-64zm0-32c53 0 96 43 96 96v8c44.7-1 91.1-11.7 141.3-24.5 4.3-1.1 8.6-2.2 13-3.3 51.8-13.3 108-27.6 165.7-28.6.2-52.8 43.1-95.6 96-95.6V168c-53 0-96-43-96-96v-8c-44.7 1-91.1 11.7-141.3 24.5-4.3 1.1-8.6 2.2-13 3.3-51.8 13.3-108 27.6-165.7 28.6-.2 52.8-43.1 95.6-96 95.6v128zm503.8 58c2.2.6 4.9.2 6.9-1.2.9-.6 1.2-1.1 1.3-1.2s0 0 0-.1V328c-35.3 0-64 28.7-64 64v.5c18.5 1.4 37.1 4.4 55.8 9.5zM480 72c0 35.3 28.7 64 64 64V89.7c0-6.8-3.7-10.4-6.2-11.3-19.1-7.2-38.3-11.4-57.8-13.2V72zM0 422.3V112.5c0-23.9 25.6-39.7 48.7-33.4 79.8 21.8 159.6 1.5 239.3-18.9C375 38 462 15.8 549 48.3c16.9 6.3 27 23.2 27 41.3v309.9c0 23.9-25.6 39.7-48.7 33.4-79.8-21.8-159.6-1.5-239.3 18.9-87 22.2-174 44.4-261 11.9-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80-31.3-80-64-80-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112-96-53-96-112 40.4-112 96-112z"
        }
    ]
};

const FalMoneyBillWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBillWheat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 80v5.3c-18.6-6.6-32-24.4-32-45.3v-5.3c18.6 6.6 32 24.4 32 45.3zm-64-64v24c0 31.7 18.4 59 45.1 72-26.7 13-45.1 40.3-45.1 72v24c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80-8.8 0-16 7.2-16 16zM48 16c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zM16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm16 96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM336 85.3c-18.6-6.6-32-24.4-32-45.3v-5.3c18.6 6.6 32 24.4 32 45.3v5.3zM288 0c-8.8 0-16 7.2-16 16v24c0 31.7 18.4 59 45.1 72-26.7 13-45.1 40.3-45.1 72v24c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80zm160 80v5.3c-18.6-6.6-32-24.4-32-45.3v-5.3c18.6 6.6 32 24.4 32 45.3zm-64-64v24c0 31.7 18.4 59 45.1 72-26.7 13-45.1 40.3-45.1 72v24c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80-8.8 0-16 7.2-16 16zm-80 173.3V184c0-20.9 13.4-38.7 32-45.3v5.3c0 20.9-13.4 38.7-32 45.3zM192 184c0-20.9 13.4-38.7 32-45.3v5.3c0 20.9-13.4 38.7-32 45.3V184zm224 5.3V184c0-20.9 13.4-38.7 32-45.3v5.3c0 20.9-13.4 38.7-32 45.3zM480 304v32c-26.5 0-48-21.5-48-48h32c8.8 0 16 7.2 16 16zM32 368c44.2 0 80-35.8 80-80h288c0 44.2 35.8 80 80 80v32c-44.2 0-80 35.8-80 80H112c0-44.2-35.8-80-80-80v-32zm400 112c0-26.5 21.5-48 48-48v32c0 8.8-7.2 16-16 16h-32zM32 432c26.5 0 48 21.5 48 48H48c-8.8 0-16-7.2-16-16v-32zm48-144c0 26.5-21.5 48-48 48v-32c0-8.8 7.2-16 16-16h32zm-32-32c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48H48zm176 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FalMoneyBill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBill",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 96c0 35.3 28.7 64 64 64v-32c0-17.7-14.3-32-32-32h-32zm-32 0H128c0 53-43 96-96 96v128c53 0 96 43 96 96h320c0-53 43-96 96-96V192c-53 0-96-43-96-96zM32 384c0 17.7 14.3 32 32 32h32c0-35.3-28.7-64-64-64v32zm512-32c-35.3 0-64 28.7-64 64h32c17.7 0 32-14.3 32-32v-32zM64 96c-17.7 0-32 14.3-32 32v32c35.3 0 64-28.7 64-64H64zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm352 128a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0z"
        }
    ]
};

const FalMoneyBillsSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBillsSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h416zM160 32c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm208 240a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0-192 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v256c0 61.9 50.1 112 112 112h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-44.2 0-80-35.8-80-80V112z"
        }
    ]
};

const FalMoneyBills = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyBills",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 64c17.7 0 32 14.3 32 32v32c-35.3 0-64-28.7-64-64h32zm-352 0h288c0 53 43 96 96 96v96c-53 0-96 43-96 96H224c0-53-43-96-96-96v-96c53 0 96-43 96-96zm-96 224c35.3 0 64 28.7 64 64h-32c-17.7 0-32-14.3-32-32v-32zm416 64c0-35.3 28.7-64 64-64v32c0 17.7-14.3 32-32 32h-32zM192 64c0 35.3-28.7 64-64 64V96c0-17.7 14.3-32 32-32h32zm-32-32c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h416c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160zm208 240a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0-192 0zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v256c0 61.9 50.1 112 112 112h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-44.2 0-80-35.8-80-80V112z"
        }
    ]
};

const FalMoneyCheckDollarPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyCheckDollarPen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96H64c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h274.2l-8 32H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v64c-10.9-.3-21.8 1.5-32 5.6V128c0-17.7-14.3-32-32-32zM256 304c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zm16-112h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-128-48c8.8 0 16 7.2 16 16v9.6c5.9 1 19 3.5 24.1 4.9 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-4-1.1-17.7-3.7-22.1-4.4-12.8-2-23.6-.4-30.9 2.9-7.2 3.3-9.9 7.5-10.5 11-.7 4.1-.1 6.2.5 7.4.6 1.4 2 3.1 5 5.1 6.7 4.6 17.1 7.8 31 12l.6.2c12.3 3.7 27.9 8.4 39.5 16.9 6.3 4.5 12 10.6 15.6 18.8 3.6 8.3 4.4 17.4 2.7 27.2-3 17.5-14.6 29.4-29.3 35.7-5.6 2.4-11.6 4-17.9 4.9v8.9c0 8.8-7.2 16-16 16s-16-7.2-16-16v-9.6c-9.4-1.7-23.5-6.6-32.4-9.6-1.8-.6-3.3-1.1-4.6-1.6-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c1.9.6 4 1.3 6.1 2.1 9.5 3.2 20.7 7 27.1 8.1 13.3 2.1 24 .8 31-2.2 6.5-2.8 9.5-6.7 10.3-11.8.8-4.7.2-7.3-.5-9-.7-1.7-2.2-3.6-5.1-5.7-6.5-4.8-16.7-8.1-30.5-12.3l-2-.6c-11.9-3.6-26.6-8-37.7-15.5-6.2-4.2-12.2-10-15.9-17.9-3.8-8.1-4.7-17.1-3.1-26.6 2.9-16.7 14.7-28.4 28.8-34.7 5.6-2.6 11.8-4.4 18.3-5.4V160c0-8.8 7.2-16 16-16zm438.8 120c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6L582.8 264zM406.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l106.3-106.2-40-40-106.2 106.3zm131-176.3c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L469.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3l153.7-153.6z"
        }
    ]
};

const FalMoneyCheckDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyCheckDollar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm272 160h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-80c0-8.8 7.2-16 16-16h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16zm-96-56v17.3c8.5 1.2 16.7 3.1 24.1 5.1 8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3-8.4-.1-17.4 1.8-23.6 5.5-5.7 3.4-8.1 7.3-8.1 12.8 0 3.7 1.3 6.5 7.3 10.1 6.9 4.1 16.6 7.1 29.2 10.9l.5.1c11.3 3.4 25.3 7.6 36.3 14.6 12.1 7.6 22.4 19.7 22.7 38.2.3 19.3-9.6 33.3-22.9 41.6-7.7 4.8-16.4 7.6-25.1 9.1V360c0 8.8-7.2 16-16 16s-16-7.2-16-16v-17.8c-11.2-2.1-21.7-5.7-30.9-8.9-2.1-.7-4.2-1.4-6.2-2.1-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5.8 4.8 1.6 7.1 2.4 13.6 4.6 24.6 8.4 36.3 8.7 9.1.3 17.9-1.7 23.7-5.3 5.1-3.2 7.9-7.3 7.8-14-.1-4.6-1.8-7.8-7.7-11.6-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5c-11-3.3-24.3-7.3-34.8-13.7-12-7.2-22.6-18.9-22.7-37.3-.1-19.4 10.8-32.8 23.8-40.5 7.5-4.4 15.8-7.2 24.1-8.7V152c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalMoneyCheckPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyCheckPen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96h448c17.7 0 32 14.3 32 32v69.6c10.2-4 21.1-5.9 32-5.6v-64c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h266.2l8-32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32zm48 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zm-16-80c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm486.8 56 17.4 17.4c6.2 6.2 6.2 16.4 0 22.6l-24.8 24.8-40-40 24.8-24.8c6.2-6.2 16.4-6.2 22.6 0zM406.5 417.7l106.2-106.2 40 40-106.3 106.2c-2.1 2.1-4.6 3.5-7.4 4.2l-49 12.3 12.3-49c.7-2.8 2.2-5.4 4.2-7.4zm131-176.3L383.8 395.1c-6.2 6.2-10.5 13.9-12.6 22.3l-18.7 74.9c-1.4 5.5.2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l74.9-18.7c8.4-2.1 16.1-6.5 22.3-12.6l153.7-153.8c18.7-18.7 18.7-49.1 0-67.9l-17.4-17.4c-18.7-18.7-49.1-18.7-67.9 0z"
        }
    ]
};

const FalMoneyCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm112 96h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM96 336c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm264-160c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-80zm-40 8c0-22.1 17.9-40 40-40h80c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40h-80c-22.1 0-40-17.9-40-40v-48z"
        }
    ]
};

const FalMoneyFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneyFromBracket",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32c-26.5 0-48 21.5-48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80C0 35.8 35.8 0 80 0h480c44.2 0 80 35.8 80 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-26.5-21.5-48-48-48H80zm416 64c8.8 0 16 7.2 16 16v344c0 30.9-25.1 56-56 56H184c-30.9 0-56-25.1-56-56V112c0-8.8 7.2-16 16-16s16 7.2 16 16v272c53 0 96 43 96 96h128c0-53 43-96 96-96V112c0-8.8 7.2-16 16-16zM224 480c0-35.3-28.7-64-64-64v40c0 13.3 10.7 24 24 24h40zm232 0c13.3 0 24-10.7 24-24v-40c-35.3 0-64 28.7-64 64h40zM320 208c-47 0-80 31.3-80 64s33 64 80 64 80-31.3 80-64-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96 53-96 112-96 112 40.4 112 96z"
        }
    ]
};

const FalMoneySimpleFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoneySimpleFromBracket",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32c-26.5 0-48 21.5-48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80C0 35.8 35.8 0 80 0h480c44.2 0 80 35.8 80 80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-26.5-21.5-48-48-48H80zm416 64c8.8 0 16 7.2 16 16v344c0 30.9-25.1 56-56 56H184c-30.9 0-56-25.1-56-56V112c0-8.8 7.2-16 16-16s16 7.2 16 16v344c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24V112c0-8.8 7.2-16 16-16zM320 208c-47 0-80 31.3-80 64s33 64 80 64 80-31.3 80-64-33-64-80-64zm112 64c0 55.6-53 96-112 96s-112-40.4-112-96 53-96 112-96 112 40.4 112 96z"
        }
    ]
};

const FalMonitorWaveform = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMonitorWaveform",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v160h144c5.3 0 10.3 2.7 13.3 7.1l30.8 46.2 53-139c2.3-5.9 7.8-10 14.2-10.3s12.3 3.1 15.1 8.8l43.5 87.2H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-6.1 0-11.6-3.4-14.3-8.8L290 215.7l-51 134c-2.1 5.6-7.2 9.5-13.2 10.2s-11.8-2-15.1-7L167.4 288H32v128c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalMonkey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMonkey",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 416c0-82.3 44.3-154.2 110.4-193.1 4.7 9.7 10.5 18.7 17.1 27.1-57.1 33.2-95.5 95.1-95.5 166v64h224v-48c0-44.2-35.8-80-80-80h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c31.3 0 59.7 12.9 80 33.6v-50.5c14.7-1.6 28.7-5.5 41.7-11.2l79.2 84.1c25.1 26.7 39.1 62 39.1 98.7V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-21.2c0-28.5-10.9-56-30.4-76.8L448 328.3V480h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H144C64.5 512 0 447.5 0 368V103.3C0 46.2 46.2 0 103.3 0c49 0 88.7 39.7 88.7 88.7V96c0 53-43 96-96 96H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c35.3 0 64-28.7 64-64v-7.3c0-31.3-25.4-56.7-56.7-56.7C63.9 32 32 63.9 32 103.3V368c0 61.9 50.1 112 112 112h16v-64zm320-256v-48c0 20.8-13.2 38.4-31.6 45.1-4.7 1.7-8.4 5.9-8.4 10.9 0 22.1-17.9 40-40 40s-40-17.9-40-40c0-5-3.7-9.2-8.4-10.9-18.4-6.7-31.6-24.3-31.6-45.1v48c0 44.2 35.8 80 80 80s80-35.8 80-80zM336 64h128c-14.6-19.4-37.8-32-64-32s-49.4 12.6-64 32zm64 208c-56.4 0-103.1-41.7-110.9-96H288c-35.3 0-64-28.7-64-64s28.7-64 64-64h20.1C328.3 19 361.9 0 400 0s71.7 19 91.9 48H512c35.3 0 64 28.7 64 64s-28.7 64-64 64h-1.1c-7.8 54.3-54.4 96-110.9 96zm144-160c0-17.7-14.3-32-32-32h-4.6c3 10.1 4.6 20.9 4.6 32v32c17.7 0 32-14.3 32-32zm-256 32v-32c0-11.1 1.6-21.9 4.6-32H288c-17.7 0-32 14.3-32 32s14.3 32 32 32zm80-16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalMonument = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMonument",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M180.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c2.5 2.5 4.2 5.9 4.6 9.4l32 272c1 8.8-5.2 16.7-14 17.8s-16.7-5.2-17.8-14l-31.3-266.5L192 38.6l-64.8 64.8-31.3 266.5c-1 8.8-9 15.1-17.8 14s-15.1-9-14-17.8l32-272c.4-3.6 2-6.9 4.6-9.4l80-80zM144 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16zM40 416h304c22.1 0 40 17.9 40 40v16c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40v-16c0-22.1 17.9-40 40-40zm-8 40v16c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H40c-4.4 0-8 3.6-8 8z"
        }
    ]
};

const FalMoonCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoonCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M446.6 66.8C359 82 291.8 156.8 288.1 248c-9.9-4.1-20.5-6.8-31.6-7.7C264.5 124 361.2 32 479.5 32c6.4 0 12.7.3 19 .8 7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-53.3 30.2-89.3 87.6-89.3 153.3 0 97.2 78.6 176 175.5 176 10.3 0 20.3-.9 30.1-2.6 6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7C595 455.8 540 480 479.5 480c-60.9 0-116.1-24.4-156.4-64 7.5-7.8 13.8-16.8 18.6-26.7 34.8 36.2 83.7 58.7 137.8 58.7 34.2 0 66.3-9 94.1-24.7-106.4-9-189.9-98.4-189.9-207.3 0-58.5 24.1-111.4 62.9-149.2zM144 224c35 0 64.8 22.5 75.6 53.8 8.7-3.7 18.3-5.8 28.4-5.8 39.8 0 72 32.2 72 72s-32.2 72-72 72H64c-35.3 0-64-28.7-64-64s28.7-64 64-64h1.6c7.4-36.5 39.7-64 78.4-64zm0 32c-26.5 0-48 21.5-48 48v2.1c.2 5.3-2.2 10.4-6.5 13.5s-9.8 4-14.9 2.2c-3.3-1.2-6.9-1.8-10.7-1.8-17.7 0-32 14.3-32 32s14.3 32 32 32H248c22.1 0 40-17.9 40-40s-17.9-40-40-40c-11.2 0-21.3 4.6-28.6 12-4.6 4.7-11.5 6.1-17.5 3.6s-9.9-8.4-9.9-14.9v-.8c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FalMoonOverSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoonOverSun",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6l90.4-62.3 90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zm-106 84.6 79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-3.8 5.5-3.8 12.7 0 18.2l54.5 79.1-94.5 17.4c-6.5 1.2-11.6 6.3-12.8 12.8L344.2 469l-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0L167.8 469l-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8l-94.4-17.6L97.7 265c3.8-5.5 3.8-12.7 0-18.2l-54.5-79 94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5L247 97.6c5.5 3.8 12.7 3.8 18.2 0zM174.2 256c0-43.2 33.9-78.7 77-81.6-19.3 15.2-31.7 38.7-31.7 65.1 0 46 37.6 83.2 83.9 83.2h1.2c-13.5 9.5-30 15.1-47.8 15.1-45.7 0-82.6-36.6-82.6-81.8zm82.6-113.8c-63 0-114.6 50.7-114.6 113.8s51.6 113.8 114.6 113.8c31 0 59.1-12.2 79.8-32.1 8.9-8.5 11.1-21.8 5.6-32.8s-17.6-17-29.7-15c-2.9.5-5.9.8-9 .8-28.9 0-51.9-23.2-51.9-51.2 0-18.9 10.5-35.6 26.3-44.5 10.7-6 16.3-18.3 13.7-30.4s-12.8-20.9-25-22c-3.2-.3-6.4-.4-9.7-.4z"
        }
    ]
};

const FalMoonStars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoonStars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 0c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V80h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V16c0-8.8 7.2-16 16-16zM156.6 163.9C85.3 180 32 243.8 32 320.2c0 88.5 71.6 160.2 159.8 160.2 25.7 0 50-6.1 71.5-16.9-87.6-11.3-155.1-86.4-155.1-177.2 0-47.4 18.4-90.4 48.4-122.4zM0 320.2C0 214.1 85.8 128 191.8 128c5.5 0 10.9.2 16.3.7 7 .6 12.8 5.7 14.3 12.5s-1.6 13.9-7.7 17.3c-44.4 25.2-74.4 73-74.4 127.8 0 81 65.5 146.6 146.2 146.6 8.6 0 17-.7 25.1-2.2 6.9-1.2 13.8 2.2 17 8.5s1.9 13.8-3.1 18.7c-34.5 33.6-81.7 54.4-133.6 54.4C85.8 512.4 0 426.3 0 320.2zM432 160v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoon",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.6 66.8c-38.8 37.8-62.9 90.7-62.9 149.2 0 108.9 83.5 198.3 189.9 207.3-27.8 15.7-59.9 24.7-94.1 24.7C117.7 448 32 362.1 32 256c0-94.8 68.5-173.5 158.6-189.2zm66.1-21.5c-1.5-6.9-7.3-11.9-14.3-12.5-6.3-.5-12.6-.8-19-.8C100 32 0 132.3 0 256s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3z"
        }
    ]
};

const FalMoped = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMoped",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 48c0-8.8 7.2-16 16-16h40.9c20.7 0 39 13.2 45.5 32.8l5.2 15.5L500.3 52c5.2-2.6 11-4 16.9-4C532 48 544 60 544 74.9v74.3c0 14.8-12 26.9-26.9 26.9-5.9 0-11.6-1.4-16.9-4L469 156.4l25.5 76.6c5.7-.7 11.6-1 17.5-1 41.5 0 79.1 16.6 106.5 43.5 6.3 6.2 6.4 16.3.2 22.6s-16.3 6.4-22.6.2C574.4 277.1 544.7 264 512 264c-56.5 0-104 39.1-116.7 91.8-1.1 4.6-2 9.3-2.5 14.1-.9 8.1-7.8 14.1-15.9 14.1H256c0 53-43 96-96 96s-96-43-96-96H32c-17.7 0-32-14.3-32-32v-32c0-70.7 57.3-128 128-128h96c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h75.4c.3-1.3.6-2.5.9-3.8 12.2-50.8 50-91.6 98.9-108.2l-55-165.1C406 68.4 399.9 64 393 64h-41c-8.8 0-16-7.2-16-16zm118.7 65.5c.2.1.3.1.5.2l56.8 28.4V81.9l-56.8 28.4c-.4.2-.9.4-1.3.6l.9 2.6zM112 128h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 96h-96c-53 0-96 43-96 96v32h200.5c-5.4-9.4-8.6-20.3-8.6-32v-96zm-64 224c35.3 0 64-28.7 64-64H96c0 35.3 28.7 64 64 64zm352 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"
        }
    ]
};

const FalMortarPestle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMortarPestle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M478.2 35c-1.4-1.7-3.3-2.7-5.4-2.9-1.2-.1-2.4 0-3.5.4-.7.3-1.4.6-2.1 1.1l-.3.2L292.6 160h-54.5L448.2 7.9c3.3-2.4 6.8-4.3 10.5-5.6 5.7-2 11.7-2.7 17.6-2.1 10.2 1.1 20 6.1 26.9 14.7 2.9 3.6 5.1 7.6 6.6 11.8 2 5.7 2.7 11.7 2.1 17.6-1 9.7-5.6 19-13.4 25.8L398.1 160h-48L477 46.3l.3-.3c1.5-1.3 2.4-3.1 2.7-5.2.1-1.2 0-2.4-.4-3.5-.3-.8-.7-1.6-1.3-2.3zM64 224v32c0 69.4 35.3 122.2 102.6 146.1 9.7 3.5 17.2 11.4 20.1 21.4s.7 20.7-5.8 28.7c-6.6 8.3-11.9 17.7-15.4 27.8h181c-3.6-10.1-8.8-19.5-15.4-27.8-6.4-8.1-8.6-18.8-5.8-28.7s10.3-17.9 20.1-21.4C412.7 378.2 448 325.4 448 256v-32H64zm288 256c.1 0 .1 0 0 0zm-192 0c-.1 0-.1 0 0 0zm352-272c0 8.8-7.2 16-16 16h-16v32c0 71.6-32.7 130.1-93.8 163-9.4 5-19.4 9.5-30.1 13.3 6.8 8.5 12.5 17.8 16.9 27.9 2.9 6.5 5.2 13.2 7 20.2 4.4 17.1-10.4 31.7-28.1 31.7H160c-17.7 0-32.4-14.6-28.1-31.7 1.8-7 4.1-13.7 7-20.2 4.5-10 10.2-19.4 16.9-27.9-10.7-3.8-20.7-8.2-30.1-13.3-61-32.9-93.7-91.4-93.7-163v-32H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h480c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalMosque = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMosque",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c5 0 9.8 2.4 12.8 6.4 34.7 46.3 78.1 74.9 133.5 111.5 5.2 3.4 10.5 7 16 10.6 28.9 19.2 45.7 51.7 45.7 86.1 0 28.6-11.4 54.5-29.8 73.5 34.3 1.2 61.8 29.3 61.8 64v96c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64V352c0-34.6 27.5-62.8 61.8-64-18.5-19-29.8-44.9-29.8-73.5 0-34.4 16.7-66.9 45.7-86.1 5.4-3.6 10.8-7.1 16-10.6 55.4-36.5 98.8-65.1 133.5-111.4 3-4 7.8-6.4 12.8-6.4zm32 480v-56c0-10.1-4.7-19.6-12.8-25.6L400 384l-19.2 14.4c-8.1 6-12.8 15.5-12.8 25.6v56h64zm32 0h48v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h32c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h32v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h48v-56c0-20.1 9.5-39.1 25.6-51.2L400 344l38.4 28.8c16.1 12.1 25.6 31.1 25.6 51.2v56zm112-265.4c0-24-11.7-46.3-31.4-59.4-5.6-3.7-11.1-7.3-16.5-10.9-48.6-32.1-92.1-60.7-128-102.7-35.9 41.9-79.4 70.6-128 102.7-5.5 3.6-11 7.2-16.6 10.9-19.7 13.1-31.4 35.4-31.4 59.4 0 40.6 32.9 73.4 73.4 73.4h205.1c40.6 0 73.4-32.9 73.4-73.4zM70.4 5.2a15.9 15.9 0 0 1 19.2 0l16 12C139.8 42.9 160 83.2 160 126v146c0 8.8-7.2 16-16 16s-16-7.2-16-16V160H32v288c0 17.7 14.3 32 32 32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-35.3 0-64-28.7-64-64V126C0 83.2 20.2 42.9 54.4 17.2l16-12zM32 128h96v-2c0-32.7-15.4-63.6-41.6-83.2L80 38l-6.4 4.8C47.4 62.4 32 93.3 32 126v2z"
        }
    ]
};

const FalMosquitoNet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMosquitoNet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M161.7 440.8c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l32-64c1.1-2.2 1.7-4.7 1.7-7.2v-41.4l20-20v38c0 24.3 19.7 44 44 44s44-19.7 44-44v-38l30.9 30.9c3-3.7 6.6-6.9 10.6-9.5-12.9-8.6-21.5-23.3-21.5-40 0-2.1.1-4.2.4-6.2L332 277.4v-24.7l28.2 24.5c6.1-9.1 15.2-15.9 25.9-19.2l.2-.6-51.8-45.1 86.3 12.9c3.6-.9 7.3-1.3 11.2-1.3 8.9 0 17.2 2.4 24.3 6.6l25.8 3.8c8.2-6.5 18.6-10.5 29.9-10.5 16.7 0 31.4 8.5 40 21.5 2.1-3.1 4.5-6 7.3-8.6-12.9-16.9-32.2-28.6-54.7-31.4l-159.9-23.7 49.6-41.3c5.1-4.2 7-11.1 4.9-17.4l-13.9-41.7 29-58.1c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-32 64c-1.9 3.8-2.2 8.2-.9 12.2l12.5 37.6-33.2 27.9v-12.6c0-21.5-15.4-39.4-35.8-43.2v-31c0-4.5-3.7-8.2-8.2-8.2s-8.2 3.7-8.2 8.2v31c-20.4 3.8-35.8 21.7-35.8 43.2v12.6l-33.4-27.8 12.5-37.6c1.3-4 1-8.4-.9-12.2l-32-64c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l29 58.1-13.9 41.7c-2.1 6.2-.1 13.1 4.9 17.4l49.6 41.3-159.7 23.8C30.6 210.6 0 245.2 0 286.3c0 72.6 87.8 109 139.2 57.6L244 252.7v24.7l-47.3 47.3c-3 3-4.7 7.1-4.7 11.3v44.2l-30.3 60.6zm-43.5-121c-.6.5-1.1 1-1.6 1.5-31.2 31.2-84.6 9.1-84.6-35 0-25 18.6-46 43.4-49.1l.8-.1 165.4-24.7-123.4 107.4zM528 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-48v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v48h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v48h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h48v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-48v-16zm0 48h48v48h-48v-48zm0 80h48v48h-48v-48zm-80-32v-48h48v48h-48zm0 80v-48h48v48h-48zm-176-87.4V137.9c0-8.8 7.2-16 16-16s16 7.2 16 16v222.7c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalMosquito = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMosquito",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M182.4 3.4c-6.9 5.5-8.2 15.7-2.8 22.7l41.9 55.7-27.5 54.7c-3.2 6.3-2 14.1 3 19l45.1 45.1-162.8 25.6C34 232.1 0 272.5 0 320.3c0 84.5 97.6 126.9 154.6 67.1l117.4-107v23.9L228 357c-2.5 2.9-3.8 6.7-3.8 10.6v58.3l-44.7 59.5c-5.3 7.1-4.1 17.3 2.8 22.7s16.8 4.2 22.1-2.9l48-63.9c2.1-2.8 3.3-6.3 3.3-9.9v-57.9l16.3-19.4v45.4c0 26.5 21.5 48 48 48s48-21.5 48-48v-45.4l16.2 19.4v57.9c0 3.6 1.2 7.1 3.3 9.9l48 63.9c5.3 7.1 15.2 8.4 22.1 2.9s8.2-15.7 2.8-22.7l-44.7-59.5v-58.4c0-3.9-1.4-7.6-3.8-10.6l-44-52.7v-23.8l117.5 107c57 59.8 154.6 17.5 154.6-67.1 0-47.9-34-88.2-79.4-94.2l-162.7-25.4 45.1-45.1c5-5 6.2-12.7 3-19l-27.4-54.8 41.9-55.7c5.3-7.1 4.1-17.3-2.8-22.7s-16.8-4.2-22.1 2.9l-48 63.9c-3.7 5-4.3 11.7-1.5 17.3l26.7 53.2-44.8 44.7v-9.5c0-23.8-17.3-43.5-40-47.3V63.8c0-4.4-3.6-8-8-8s-8 3.6-8 8v64.8c-22.7 3.8-40 23.6-40 47.3v9.5l-44.6-44.7L254 87.5c2.8-5.6 2.2-12.4-1.5-17.3l-48-63.9c-5.3-7.1-15.2-8.4-22.1-2.9zM272 237.1 133.1 363.8c-.5.5-1.1 1-1.6 1.5-34.9 36.6-99.5 14-99.5-45 0-32.9 23.2-58.7 51.5-62.4.3 0 .5-.1.8-.1l185.8-29.1 1.9 1.9v6.4zm234.9 126.7L368 237v-6.4l1.9-1.9 185.8 29.1c.3 0 .5.1.8.1 28.3 3.7 51.5 29.5 51.5 62.4 0 58.9-64.6 81.6-99.5 45-.5-.5-1-1-1.6-1.5zM304 399.5V175.9c0-8.8 7.2-16 16-16s16 7.2 16 16v223.6c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalMotorcycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMotorcycle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M411.8 96H480V64h-26.6l-41.6 32zm76.2 32h-75.8L467 232.1c14-5.3 29.2-8.1 45-8.1 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-43.4 21.6-81.8 54.7-104.9l-15-28.5C380.5 247.2 352 296.3 352 352v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-8c0-92.8-75.2-168-168-168H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h72c41.4 0 79.9 12.6 111.8 34.1l127.4-98L342.3 64H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h70.3c11.9 0 22.8 6.6 28.3 17.1L385 76.3 436.1 37c4.2-3.2 9.3-5 14.6-5H488c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24zm-230.5 86.7c36.7 34.7 60.2 83.3 62.4 137.3h.2c0-68 35.4-127.8 88.7-161.9l-34.4-65.3-116.9 89.9zm240.3 144.8-44.1-83.8c-23 17.5-37.8 45.2-37.8 76.3 0 53 43 96 96 96s96-43 96-96-43-96-96-96c-10.5 0-20.5 1.7-29.9 4.8l44.1 83.8c4.1 7.8 1.1 17.5-6.7 21.6s-17.5 1.1-21.6-6.7zM128 256c-53 0-96 43-96 96s43 96 96 96c47.6 0 87.1-34.6 94.7-80h-67c-5.5 9.6-15.9 16-27.7 16-17.7 0-32-14.3-32-32s14.3-32 32-32c11.8 0 22.2 6.4 27.7 16h67c-7.6-45.4-47.1-80-94.7-80zM0 352a128 128 0 1 1 256 0 128 128 0 1 1-256 0z"
        }
    ]
};

const FalMound = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMound",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512.7 384H63.3l108.6-188.8C195.8 153.6 240.1 128 288 128s92.2 25.6 116.1 67.2L512.7 384zM288 96c-59.4 0-114.2 31.7-143.9 83.2L35.6 368c-12.3 21.3 3.1 48 27.7 48h449.4c24.6 0 40-26.6 27.7-48L431.9 179.2C402.2 127.7 347.4 96 288 96z"
        }
    ]
};

const FalMountainCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMountainCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 48c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16v160c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-26.5-21.5-48-48-48h-16v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-32V48c0-26.5-21.5-48-48-48H336c-26.5 0-48 21.5-48 48v92.1l32 53V48zm-94 113.2L302.5 288H223c-5 0-9.8 2.4-12.8 6.4l-34.7 46.2-33-47.7L222 161.2c.5-.9 1.3-1.2 2-1.2s1.5.3 2 1.2zM32.5 475.4l92-152.4 37.4 54.1c2.9 4.2 7.7 6.8 12.9 6.9s10-2.3 13.1-6.4L231 320h90.8l93.8 155.4c.6 1 .6 2.2.1 3.3-.5 1-1.4 1.3-2.1 1.3H34.5c-.7 0-1.5-.4-2.1-1.3-.6-1-.5-2.3.1-3.3zm220.9-330.7C247.1 134.3 236 128 224 128s-23.1 6.3-29.4 16.7L5.1 458.9c-6.5 10.8-6.7 24.3-.7 35.3S22 512 34.5 512h379c12.5 0 24-6.8 30.1-17.8s5.8-24.5-.7-35.3L253.4 144.7zM352 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32V96h32zm-32 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-17.7-14.3-32-32-32h-32zm96 96v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v32h-32v-32h32zm-32 96c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v32h-32v-32z"
        }
    ]
};

const FalMountainSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMountainSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M608 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm-23.9 400c13.2 0 23.9-10.7 23.9-23.9 0-4.5-1.3-8.9-3.7-12.7L259.6 98c-.8-1.3-2.2-2-3.6-2s-2.9.8-3.6 2L35.7 443.4a23.8 23.8 0 0 0-3.7 12.7c0 13.2 10.7 23.9 23.9 23.9h400.2zM55.9 512C25 512 0 487 0 456.1c0-10.5 3-20.8 8.6-29.7L225.2 81c6.6-10.6 18.3-17 30.8-17s24.1 6.4 30.8 17l126 200.7 48.2-79c4-6.6 11.2-10.7 19-10.7s15 4.1 19.1 10.7l132 216.3c5.8 9.6 8.9 20.6 8.9 31.8 0 33.8-27.4 61.1-61.1 61.1h-523zm447.5-85.6c5.6 8.9 8.6 19.2 8.6 29.7 0 8.6-1.9 16.7-5.4 23.9h72.2c16.1 0 29.1-13 29.1-29.1 0-5.3-1.5-10.6-4.3-15.2L480 232.9 431.7 312l71.7 114.3z"
        }
    ]
};

const FalMountain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMountain",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 424.1c0 13.2-10.7 23.9-23.9 23.9H55.9C42.7 448 32 437.3 32 424.1c0-4.5 1.3-8.9 3.7-12.7l104.5-166.6 55.3 69.2c3.1 3.9 7.8 6.1 12.7 6s9.6-2.4 12.6-6.4L264 256h114.9l97.5 155.4c2.4 3.8 3.7 8.2 3.7 12.7zM358.8 224H256c-5 0-9.8 2.4-12.8 6.4l-35.6 47.5-49.4-61.8L252.4 66c.8-1.3 2.2-2 3.6-2s2.9.8 3.6 2l99.1 158zM55.9 480h400.2c30.9 0 55.9-25 55.9-55.9 0-10.5-3-20.8-8.6-29.7L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1 0 455 25 480 55.9 480z"
        }
    ]
};

const FalMountains = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMountains",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 424.1c0 13.2-10.7 23.9-23.9 23.9H55.9C42.7 448 32 437.3 32 424.1c0-4.5 1.3-8.9 3.7-12.7L252.4 66c.8-1.3 2.2-2 3.6-2s2.9.8 3.6 2l216.7 345.4c2.4 3.8 3.7 8.2 3.7 12.7zm-480 0C0 455 25 480 55.9 480h523c33.8 0 61.1-27.4 61.1-61.1 0-11.2-3.1-22.2-8.9-31.8l-132-216.3C495 164.1 487.8 160 480 160s-15 4.1-19.1 10.7l-48.2 79L286.8 49c-6.6-10.6-18.3-17-30.8-17s-24.1 6.4-30.8 17L8.6 394.4C3 403.3 0 413.6 0 424.1zM431.7 280l48.3-79.1 123.7 202.8c2.8 4.6 4.3 9.8 4.3 15.2 0 16.1-13 29.1-29.1 29.1h-72.3c3.4-7.3 5.4-15.4 5.4-23.9 0-10.5-3-20.8-8.6-29.7L431.7 280z"
        }
    ]
};

const FalMouseField = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMouseField",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M379.4 36.6c6.2-3 13.2-4.6 20.6-4.6 26.5 0 48 21.5 48 48 0 9.6-2.8 18.6-7.7 26.1-12.5-5.5-26-8.9-40.3-9.8V96c0-22.4-7.7-43-20.6-59.4zm88.2 86.2C475.4 110.4 480 95.7 480 80c0-44.2-35.8-80-80-80-16.9 0-32.7 5.3-45.6 14.3C339.7 5.2 322.5 0 304 0c-53.1 0-96 43.4-96 96.3 0 25.7 10.2 49.8 27.5 67.5C155.8 180.6 96 251.3 96 336c0 18 6 34.6 16 48H64c-35.3 0-64 28.7-64 64s28.7 64 64 64h400c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h292.1c24.2 0 43.9-19.7 43.9-43.9 0-18.9-12.1-35.7-30-41.6l-12.8-4.3 21.6-54.2H464c26.5 0 48-21.5 48-48v-8c0-37.6-17.3-71.2-44.4-93.2zM176 384c-26.5 0-48-21.5-48-48 0-79.5 64.5-144 144-144h16c7.7 0 14.4-5.5 15.7-13.1s-2.9-15.1-10.1-17.8l-12.1-4.5c-24.9-9.3-41.5-33.4-41.5-60.2 0-35.5 28.7-64.4 64-64.4s64 28.7 64 64v16c0 8.8 7.2 16 16 16h8c48.6 0 88 39.4 88 88v8c0 8.8-7.2 16-16 16h-96c-6.5 0-12.4 4-14.9 10.1l-26.4 66-33.7-11.2c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l76.9 25.6c4.9 1.6 8.1 6.2 8.1 11.3 0 6.6-5.3 11.9-11.9 11.9H176zM336 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16V80zm96 108a20 20 0 1 0-40 0 20 20 0 1 0 40 0z"
        }
    ]
};

const FalMp3Player = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMp3Player",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 272a80 80 0 1 0 160 0 80 80 0 1 0-160 0zm80 112a112 112 0 1 1 0-224 112 112 0 1 1 0 224zm-24-112a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM96 96v64h192V96H96zm-32 0c0-17.7 14.3-32 32-32h192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V96z"
        }
    ]
};

const FalMugHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMugHot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0c-8.8 0-16 7.2-16 16 0 24.7 9.8 48.5 27.3 65.9l18.7 18.7c11.5 11.6 18 27.2 18 43.4 0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.7-9.8-48.5-27.3-65.9l-18.8-18.8C102.5 47.8 96 32.2 96 16c0-8.8-7.2-16-16-16zM32 224h320v192c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V224zm352 0h16c44.2 0 80 35.8 80 80s-35.8 80-80 80h-16V224zm0 192h16c61.9 0 112-50.1 112-112s-50.1-112-112-112H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 24.7 9.8 48.5 27.3 65.9l18.7 18.7c11.5 11.6 18 27.2 18 43.4 0 8.8 7.2 16 16 16s16-7.2 16-16c0-24.7-9.8-48.5-27.3-65.9l-18.8-18.8C230.5 47.8 224 32.2 224 16z"
        }
    ]
};

const FalMugMarshmallows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMugMarshmallows",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M357.7 103c6.6 6.6 10.3 15.6 10.3 25h-32c0-.9-.3-1.7-1-2.3l-57.8-57.9c-2.4-2.4-5.7-3.8-9.2-3.8s-6.7 1.4-9.2 3.8L201 125.7c-.6.6-1 1.5-1 2.3h-32c0-9.4 3.7-18.3 10.3-25l57.9-57.9C244.6 36.7 256.1 32 268 32s23.4 4.7 31.8 13.2l57.9 57.8zM64 80v48H32V80c0-26.5 21.5-48 48-48h124.1l-32 32H80c-8.8 0-16 7.2-16 16zM32 384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V192H128v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80H32v192zm0-224h368c61.9 0 112 50.1 112 112s-50.1 112-112 112h-16c0 53-43 96-96 96H96c-53 0-96-43-96-96V192c0-17.7 14.3-32 32-32zm352 192h16c44.2 0 80-35.8 80-80s-35.8-80-80-80h-16v160z"
        }
    ]
};

const FalMugSaucer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMugSaucer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 64h32v224c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V64h288zm64 224v-32h48c61.9 0 112-50.1 112-112S589.9 32 528 32H128c-17.7 0-32 14.3-32 32v224c0 53 43 96 96 96h192c53 0 96-43 96-96zm48-64h-48V64h48c44.2 0 80 35.8 80 80s-35.8 80-80 80zM16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalMugTeaSaucer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMugTeaSaucer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 64h208v224c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64V64h80v40.5l-36.5 30.4C164.2 141 160 150 160 159.5V224c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64.5c0-9.5-4.2-18.5-11.5-24.6L240 104.5V64zm-16-32h-96c-17.7 0-32 14.3-32 32v224c0 53 43 96 96 96h192c53 0 96-43 96-96v-32h48c61.9 0 112-50.1 112-112S589.9 32 528 32H224zm256 192V64h48c44.2 0 80 35.8 80 80s-35.8 80-80 80h-48zM0 464c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm192-240v-64.5l32-26.7 32 26.7V224h-64z"
        }
    ]
};

const FalMugTea = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMugTea",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 96H64v256c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V96H176v40.5l36.5 30.4c7.3 6.1 11.5 15.1 11.5 24.6V256c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64.5c0-9.5 4.2-18.5 11.5-24.6l36.5-30.4V96zm16-32h304c61.9 0 112 50.1 112 112s-50.1 112-112 112h-48v64c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32h96zm304 32h-48v160h48c44.2 0 80-35.8 80-80s-35.8-80-80-80zM128 256h64v-64.5l-32-26.7-32 26.7V256z"
        }
    ]
};

const FalMug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMug",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96v256c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V96H64zm352 0v160h48c44.2 0 80-35.8 80-80s-35.8-80-80-80h-48zm0 192v64c0 53-43 96-96 96H128c-53 0-96-43-96-96V96c0-17.7 14.3-32 32-32h400c61.9 0 112 50.1 112 112s-50.1 112-112 112h-48z"
        }
    ]
};

const FalMushroom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMushroom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M130.8 105c17.5 23.6 45.6 39 77.2 39 46.1 0 84.6-32.5 93.9-75.9 41 8.6 77.3 30.1 104.3 60.2-2-.2-4.1-.3-6.2-.3-35.3 0-64 28.7-64 64s28.7 64 64 64c22.4 0 42.1-11.5 53.5-28.9 1.6 10.1 2.5 20.5 2.5 31 0 16.5-13.4 29.9-29.9 29.9H85.9C69.4 288 56 274.6 56 258.1c0-62.2 29.3-117.6 74.8-153.1zm-14.7-29.1C60.3 117.1 24 183.4 24 258.1c0 34.2 27.7 61.9 61.9 61.9h340.2c34.2 0 61.9-27.7 61.9-61.9C488 133.2 386.8 32 261.9 32h-11.8c-38 0-73.9 9.4-105.3 26-10 5.3-19.6 11.3-28.6 18zm41.5 11.5c27.5-14.9 59-23.4 92.5-23.4h11.8c2.7 0 5.4.1 8 .2-7.1 27.5-32.1 47.8-61.9 47.8-20.5 0-38.7-9.6-50.4-24.6zm169 264.6H294l18 96H200l18-96h-32.6l-16.9 90.1c-1.8 9.4.7 19 6.8 26.3s15.1 11.6 24.6 11.6H312c9.5 0 18.5-4.2 24.6-11.6s8.6-17 6.8-26.3L326.6 352zM128 208a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm208-48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FalMusicNoteSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMusicNoteSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m352 189.1 147.9-37.6c7.1-1.8 12.1-8.2 12.1-15.5V23.1C512 10.3 501.7 0 488.9 0c-2 0-4 .3-5.9.8L331.9 40.5c-7 1.8-11.9 8.2-11.9 15.5v118.5l32 25.3v-10.7zm-32 148.4V376c-20.3-14.8-48.7-24-80-24-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80v-69.2l-32-25.3zm0 94.5c0 9.1-5.1 20.3-19.4 30.5C286.3 472.7 265 480 240 480s-46.3-7.3-60.6-17.5C165.1 452.3 160 441.1 160 432s5.1-20.3 19.4-30.5C193.7 391.3 215 384 240 384s46.3 7.3 60.6 17.5c14.3 10.2 19.4 21.4 19.4 30.5zm160-308.4-128 32.5V68.3l128-33.7v88.9zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalMusicNote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMusicNote",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 23.1C384 10.3 373.7 0 360.9 0c-2 0-4 .3-5.9.8L203.9 40.5c-7 1.8-11.9 8.2-11.9 15.5v320c-20.3-14.8-48.7-24-80-24-61.9 0-112 35.8-112 80s50.1 80 112 80 112-35.8 112-80V189.1l147.9-37.6c7.1-1.8 12.1-8.2 12.1-15.5V23.1zM192 432c0 9.1-5.1 20.3-19.4 30.5C158.3 472.7 137 480 112 480s-46.3-7.3-60.6-17.5C37.1 452.3 32 441.1 32 432s5.1-20.3 19.4-30.5C65.7 391.3 87 384 112 384s46.3 7.3 60.6 17.5c14.3 10.2 19.4 21.4 19.4 30.5zm160-308.4-128 32.5V68.3l128-33.7v88.9z"
        }
    ]
};

const FalMusicSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMusicSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M575.5 376.2c.3-2.7.5-5.4.5-8.2V23c0-12.7-10.3-23-23-23-2.3 0-4.6.3-6.8 1l-311 95.7c-3 .9-5.6 2.7-7.5 5l28.3 22.2v-.1l288-88.6v89l-207 63.7 30.5 24.1L544 157.7v150.7c-17-12.7-39.4-20.4-64-20.4-5.1 0-10.1.3-15 1l48 37.9c9.6 4.5 17.2 10.7 22.4 17.7l40.1 31.7zM256 287l-32-25.3v110.7c-17-12.7-39.4-20.4-64-20.4-53 0-96 35.8-96 80s43 80 96 80 96-35.8 96-80V287zm-96 97c41.1 0 64 26.7 64 48s-22.9 48-64 48-64-26.7-64-48 22.9-48 64-48zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMusic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 23c0-12.7-10.3-23-23-23-2.3 0-4.6.3-6.8 1l-311 95.7C164.6 98.8 160 105 160 112v260.4c-17-12.7-39.4-20.4-64-20.4-53 0-96 35.8-96 80s43 80 96 80 96-35.8 96-80V246.3l288-88.6v150.7c-17-12.7-39.4-20.4-64-20.4-53 0-96 35.8-96 80s43 80 96 80 96-35.8 96-80V23zm-32 345c0 21.3-22.9 48-64 48s-64-26.7-64-48 22.9-48 64-48 64 26.7 64 48zm-320 64c0 21.3-22.9 48-64 48s-64-26.7-64-48 22.9-48 64-48 64 26.7 64 48zm320-307.8-288 88.6v-89l288-88.6v89z"
        }
    ]
};

const FalMustache = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalMustache",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235 112c-31.7 0-62.2 12.6-84.6 35.1-31.6 31.6-81.9 34.4-116.8 6.5l-7.5-6c-5.1-4.1-12-4.5-17.5-1.6-1.4.7-2.7 1.7-3.8 2.8-3 2.8-4.8 6.8-4.8 11.2v44c0 108.2 87.8 196 196 196 42.4 0 83.7-13.8 117.6-39.2l6.4-4.8 6.4 4.8C360.3 386.2 401.6 400 444 400c108.2 0 196-87.8 196-196v-44c0-4.4-1.8-8.4-4.6-11.3-1.1-1.2-2.4-2.1-3.8-2.8-5.5-2.9-12.4-2.5-17.5 1.6l-7.5 6c-34.9 27.9-85.2 25.1-116.8-6.5-22.6-22.4-53-35-84.8-35h-3.3c-25.2 0-49.8 7.5-70.8 21.4l-11 7.3-11-7.3c-21-14-45.6-21.4-70.8-21.4H235zm373 78.7V204c0 90.6-73.4 164-164 164-35.5 0-70-11.5-98.4-32.8l-16-12a15.9 15.9 0 0 0-19.2 0l-16 12C266 356.5 231.5 368 196 368c-90.6 0-164-73.4-164-164v-13.3c45.7 24.4 103.1 16.8 140.9-21 16.4-16.4 38.8-25.7 62-25.7h3.3c18.9 0 37.3 5.6 53 16.1l19.9 13.3c5.4 3.6 12.4 3.6 17.8 0l19.9-13.3a95.23 95.23 0 0 1 53-16.1h3.2c23.3 0 45.6 9.2 62 25.7 37.8 37.8 95.3 45.4 140.9 21z"
        }
    ]
};

const FalN = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalN",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M10.5 33c6.3-2.3 13.4-.4 17.7 4.7L352 420.3V48c0-8.8 7.2-16 16-16s16 7.2 16 16v416c0 6.7-4.2 12.7-10.5 15s-13.4.4-17.7-4.7L32 91.7V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-6.7 4.2-12.7 10.5-15z"
        }
    ]
};

const FalNairaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNairaSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.2 38.9c-4-5.8-11.2-8.3-17.9-6.2S64 41 64 48v208H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v176c0 8.8 7.2 16 16 16s16-7.2 16-16V288h130.7l128.1 185.1c4 5.8 11.2 8.3 17.9 6.2s11.2-8.3 11.2-15.3V288h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v208H243.5L93.2 38.9zM265.6 288H352v124.8L265.6 288zm-61.1-32H96V99.2L204.5 256z"
        }
    ]
};

const FalNarwhal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNarwhal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M630.6 1.4c8 3.7 11.6 13.1 7.9 21.2l-76.3 168C609 222.3 640 275.6 640 336c0 97.2-78.8 176-176 176H240c-88.4 0-160-71.6-160-160v-87.7l-45.9-32.1C12.7 217.2 0 192.8 0 166.7V112c0-6 3.3-11.4 8.6-14.2s11.7-2.3 16.6 1.1L96 148.5l70.8-49.6c4.9-3.4 11.3-3.8 16.6-1.1S192 106 192 112v54.7c0 26.1-12.7 50.6-34.1 65.5L112 264.3v64c0 13.1 10.6 23.7 23.7 23.7 5.4 0 10.6-1.8 14.8-5.2l172.6-138.1c39.4-31.6 89.1-48.7 139.6-48.7 25.4 0 49.6 5.4 71.5 15L609.4 9.4c3.7-8 13.1-11.6 21.2-7.9zM464 480c79.5 0 144-64.5 144-144 0-79.2-65.5-144-145.4-144-43.3 0-85.9 14.8-119.6 41.7L170.5 371.8c-9.9 7.9-22.1 12.2-34.8 12.2-7.3 0-14.2-1.4-20.6-3.9C127.9 437.3 178.9 480 240 480h224zm40-208a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 166.7c0 15.7 7.6 30.3 20.5 39.3L96 236.5l43.5-30.5c12.8-9 20.5-23.7 20.5-39.3v-23.9l-54.8 38.4c-5.5 3.9-12.8 3.9-18.4 0L32 142.7v23.9z"
        }
    ]
};

const FalNestingDolls = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNestingDolls",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c53 0 96 43 96 96v96h32v-96C320 57.3 262.7 0 192 0S64 57.3 64 128v96h32v-96c0-53 43-96 96-96zm64.6 448H74.5c-9.2 0-14-3.5-15.9-6.4C46.9 455.7 32 424.8 32 384c0-32.6 13.6-63.3 30-96h250.2c5.4-11.4 12.1-22.2 19.9-32H51.9c-5.9 0-11.3 3.3-14 8.6C20.2 299.6 0 339.6 0 384c0 48.8 17.9 85.7 31.8 107.1 9.3 14.2 25.7 20.9 42.7 20.9h186.9c-4.8-10.1-6.4-21.3-4.8-32zM148.2 131.8c17.1-5.3 32.2-15.2 43.8-28.3 11.5 13.1 26.6 23 43.8 28.3-2.3 5.1-5.6 9.9-9.8 14.2-18.7 18.7-49.1 18.7-67.9 0-4.2-4.2-7.5-9-9.8-14.2zm65.1-52.7c-5.6-7.3-14.1-10.2-21.3-10.2s-15.7 2.9-21.3 10.2c-9.2 11.9-22.4 20.4-37.5 23.5-10.8 2.3-22.6 13.4-18.8 28.7 3.4 13.6 10.4 26.5 21.1 37.2 31.2 31.2 81.9 31.2 113.1 0 10.6-10.6 17.7-23.5 21.1-37.2 3.8-15.4-8-26.5-18.8-28.7-15.1-3.2-28.3-11.7-37.5-23.5zM464 343.5c11.5 13.1 26.6 23 43.8 28.3-2.3 5.1-5.6 9.9-9.8 14.2-18.7 18.7-49.1 18.7-67.9 0-4.2-4.2-7.5-9-9.8-14.2 17.1-5.3 32.2-15.2 43.8-28.3zm0-34.6c-7.3 0-15.7 2.9-21.3 10.2-9.2 11.9-22.4 20.4-37.5 23.5-10.8 2.3-22.6 13.4-18.8 28.7 3.4 13.6 10.4 26.6 21.1 37.2 31.2 31.2 81.9 31.2 113.1 0 10.6-10.6 17.7-23.5 21.1-37.2 3.8-15.4-8-26.5-18.8-28.7-15.1-3.2-28.3-11.7-37.5-23.5-5.6-7.3-14.1-10.2-21.3-10.2zm124.7 146.4c3.7 8.1 7.8 16.4 12.7 24.7H326.6c4.9-8.3 9-16.6 12.7-24.7 13.8-30.3 20.7-62 20.7-95.3 0-57.4 46.6-104 104-104s104 46.6 104 104c0 33.3 6.9 65 20.7 95.3zm46.8 18.7c-7-10-12.6-20.9-17.7-32-11.9-26.1-17.8-53.3-17.8-82 0-75.1-60.9-136-136-136s-136 60.9-136 136c0 28.7-5.9 55.9-17.8 82.1-5 11.1-10.7 22-17.7 32-5.2 7.3-5.9 16.9-1.8 24.9 4.1 8 12.3 13 21.3 13h304c9 0 17.2-5 21.3-13s3.4-17.6-1.8-24.9z"
        }
    ]
};

const FalNetworkWired = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNetworkWired",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H240c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h160zm-64 160h64c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H240c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h64v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h128v48H80c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-64v-48h288v48h-64c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48h-64v-48h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H336v-48zm160 160h64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h96zm-320 0h64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h96z"
        }
    ]
};

const FalNeuter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNeuter",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 176a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm160 175.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3V496c0 8.8 7.2 16 16 16s16-7.2 16-16V351.3z"
        }
    ]
};

const FalNewspaper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNewspaper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c-17.7 0-32 14.3-32 32v320c0 11.7-3.1 22.6-8.6 32H432c26.5 0 48-21.5 48-48V96c0-17.7-14.3-32-32-32H160zM64 480c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64v32c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-35.3 28.7-64 64-64h288c35.3 0 64 28.7 64 64v304c0 44.2-35.8 80-80 80H64zm320-368c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16zm-224 64c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm32-144h128v-96H192v96zm-32-104c0-13.3 10.7-24 24-24h144c13.3 0 24 10.7 24 24v112c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24V120z"
        }
    ]
};

const FalNfcLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNfcLock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h256v32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v65.1c-11.3 1.6-22.1 4.9-32 9.6V96c0-17.7-14.3-32-32-32zm0 64v65.6c-19.8 20.2-32 47.9-32 78.4V128H240v82.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32h112c17.7 0 32 14.3 32 32zM96 384h224v32H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v256zm128-144a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm240-16c-26.5 0-48 21.5-48 48v48h96v-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H384c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48zm160 80H384v128h160V352z"
        }
    ]
};

const FalNfcMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNfcMagnifyingGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h288c16.6 12.5 35.8 21.8 56.6 27.1-7.6 3.2-15.9 4.9-24.6 4.9H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v64c-11 0-21.7 1.1-32 3.2V96c0-17.7-14.3-32-32-32zm0 64v45.3c-11.4 5-22.2 11.3-32 18.7v-64H240v82.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32h112c17.7 0 32 14.3 32 32zm-64 288H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v256h205.3c5 11.4 11.3 22.2 18.7 32zm-96-176a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm224 176.2a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0 32c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128c0 29.6-10 56.8-26.9 78.5l86.2 86.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-86.2-86.2c-21.7 16.9-48.9 26.9-78.5 26.9z"
        }
    ]
};

const FalNfcPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNfcPen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h202.3l-8 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v124.2l-32 32V96c0-17.7-14.3-32-32-32zm0 64v156.2l-32 32V128H240v82.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32h112c17.7 0 32 14.3 32 32zM276.2 408.3l-1.9 7.7H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v256h190.7c-4.8 7.4-8.4 15.6-10.5 24.3zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm294.8 24c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6L518.8 264zM342.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l106.3-106.2-40-40-106.2 106.3zm131-176.3c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L405.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3l153.7-153.6z"
        }
    ]
};

const FalNfcSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNfcSignal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h163c-1.6 10.5-2.6 21.2-2.9 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v131c-10.9 1.7-21.6 4-32 6.9V96c0-17.7-14.3-32-32-32zm0 64v117.3c-11.1 4.8-21.8 10.2-32 16.4V128H240v82.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3V128c0-17.7 14.3-32 32-32h112c17.7 0 32 14.3 32 32zM233.9 416H96c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v256h149.3c-4.4 10.3-8.2 21-11.3 32zM224 240a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm272 16c8.8 0 16 7.2 16 16s-7.2 16-16 16c-114.9 0-208 93.1-208 208 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-132.5 107.5-240 240-240zm-16 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-80c0 8.8-7.2 16-16 16-61.9 0-112 50.1-112 112 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-79.5 64.5-144 144-144 8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalNfcSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNfcSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM544 351.3V96c0-35.3-28.7-64-64-64H160c-6 0-11.9.8-17.4 2.4L180.1 64H480c17.7 0 32 14.3 32 32v230l32 25.3zm-64-50.5V128c0-17.7-14.3-32-32-32H336c-17.7 0-32 14.3-32 32v33.8l32 25.3V128h112v147.5l32 25.3zM378.8 384H192V236.5l-32-25.3V384c0 17.7 14.3 32 32 32h227.4l-40.5-32zM128 186l-32-25.3V416c0 35.3 28.7 64 64 64h320c6 0 11.9-.8 17.4-2.4L459.9 448H160c-17.7 0-32-14.3-32-32V186z"
        }
    ]
};

const FalNfcSymbol = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNfcSymbol",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M367.2 475.6c5.1 4.9 12.9 5.8 19 2.2 76-43.9 126.9-128 126.9-221.8S462.2 78.1 386.3 34.2c-7.6-4.4-17.4-1.8-21.9 5.8s-1.8 17.4 5.8 21.9c66.2 38.2 110.9 111.9 110.9 194.1 0 78-40.2 148.2-100.8 187.9L203 276.4c-6.4-6.1-16.5-5.8-22.6.6s-5.8 16.5.6 22.6l186.2 176zM145.9 36.4c-5.1-4.9-12.9-5.8-19-2.3C50.9 78.1 0 162.2 0 256s50.9 177.9 126.8 221.8c7.6 4.4 17.4 1.8 21.9-5.8s1.8-17.4-5.8-21.9C76.7 411.9 32 338.2 32 256c0-77.9 40.2-148.2 100.8-187.9L309 235.6c6.4 6.1 16.5 5.8 22.6-.6s5.8-16.5-.6-22.6l-185.1-176z"
        }
    ]
};

const FalNfcTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNfcTrash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h320c17.7 0 32 14.3 32 32v104.2l2.5-7.4c4.8-14.3 15.9-25.2 29.5-30.1V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h317.6l-2.3-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm320 144v-80c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32v82.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V128h112v80h32zm-32 176H96V128h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h256c9.7 0 18.4-4.3 24.3-11.1L369.1 304H352v80zM240 256a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm208.8-53.1L436.5 240H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16h-36.5l-12.4-37.1c-2.1-6.5-8.2-10.9-15.1-10.9h-96c-6.9 0-13 4.4-15.2 10.9zm21.4 37.1 5.3-16h72.9l5.3 16h-83.5zm-69 64.1 12.7 178.2C415.1 499 429 512 445.8 512h132.4c16.8 0 30.7-13 31.9-29.7l12.7-178.2h-32L578.2 480H445.8l-12.6-175.9h-32.1z"
        }
    ]
};

const FalNfc = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNfc",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm0 96v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32v82.7c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V128h112v256H96V128h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-17.7 0-32 14.3-32 32zm160 144a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
        }
    ]
};

const FalNose = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNose",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.2 8.6c-4.1-7.8-13.7-10.9-21.6-6.8s-10.9 13.7-6.8 21.6c74 142.4 171.9 248.6 223.7 299.3 19.1 18.7 30.5 43.7 30.5 69.6 0 48.5-39.3 87.7-87.7 87.7h-34l-2.3-2.6-38.7-43.5c-19.1-21.5-46.5-33.8-75.3-33.8-27.6 0-49.9 22.3-49.9 49.9v6c0 30.9 25.1 56 56 56h144.2c66.1 0 119.7-53.6 119.7-119.7 0-35.3-15.5-68.3-40.1-92.4-50.5-49.5-145.8-153-217.7-291.2zm39.1 446.5 22.2 24.9H184c-13.3 0-24-10.7-24-24v-6.1c0-9.9 8-17.9 17.9-17.9 19.7 0 38.4 8.4 51.4 23.1zm-98-151.4c8.6-1.9 14.1-10.4 12.3-19s-10.4-14.1-19-12.3l-22.8 4.9C42.4 290 0 342.4 0 403.2c0 38.2 17 74.5 46.3 98.9l7.4 6.2c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5l-7.4-6.2c-22-18.5-34.8-45.7-34.8-74.4 0-45.6 31.9-85.1 76.5-94.6l22.8-4.9z"
        }
    ]
};

const FalNotEqual = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNotEqual",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M377.1 34.8c7.3 5 9.1 15 4 22.3L321 144h95c8.8 0 16 7.2 16 16s-7.2 16-16 16H298.8L188.1 336H416c8.8 0 16 7.2 16 16s-7.2 16-16 16H165.9L93.2 473.1c-5 7.3-15 9.1-22.3 4s-9.1-15-4-22.3L127 368H32c-8.8 0-16-7.2-16-16s7.2-16 16-16h117.2l110.7-160H32c-8.8 0-16-7.2-16-16s7.2-16 16-16h250.1l72.7-105.1c5-7.3 15-9.1 22.3-4z"
        }
    ]
};

const FalNotdef = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNotdef",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 452.5 172.3 256 32 59.5v393zM51.7 480h280.6L192 283.5 51.7 480zm160-224L352 452.5v-393L211.7 256zM332.3 32H51.7L192 228.5 332.3 32zM0 48C0 21.5 21.5 0 48 0h288c26.5 0 48 21.5 48 48v416c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48z"
        }
    ]
};

const FalNoteMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNoteMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v213.5c0 3.6-.6 7.2-1.8 10.5H336c-26.5 0-48 21.5-48 48v78.2c-3.3 1.2-6.9 1.8-10.5 1.8H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zm2.7 288L320 418.7V368c0-8.8 7.2-16 16-16h50.7zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h213.5c17 0 33.3-6.7 45.3-18.7l106.5-106.6c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64zm112 112v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48h32z"
        }
    ]
};

const FalNoteSticky = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNoteSticky",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h208v-96c0-26.5 21.5-48 48-48h96V96c0-17.7-14.3-32-32-32H64zm240 370.7 98.7-98.7H320c-8.8 0-16 7.2-16 16v82.7zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v213.5c0 17-6.7 33.3-18.7 45.3L322.7 461.3c-12 12-28.3 18.7-45.3 18.7H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalNote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNote",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v208h-96c-26.5 0-48 21.5-48 48v96H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zm18.7 272L304 434.7V352c0-8.8 7.2-16 16-16h82.7zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h213.5c17 0 33.3-6.7 45.3-18.7l106.5-106.6c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H64zm64 344a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-24-264a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm24 144a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalNotebook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNotebook",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32h-64c-17.7 0-32 14.3-32 32v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v48c0 17.7 14.3 32 32 32h64V32zm32 448h192c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H224v448zm-16 32h-80c-35.3 0-64-28.7-64-64v-48H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-96H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-96H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V64c0-35.3 28.7-64 64-64h288c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H208z"
        }
    ]
};

const FalNotesMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNotesMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v197.5c0 8.5-3.4 16.6-9.4 22.6l-58.5 58.5c-6 6-14.1 9.4-22.6 9.4H160c-17.7 0-32-14.3-32-32V96zm-32 0v256c0 35.3 28.7 64 64 64h197.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm224 400c0-8.8-7.2-16-16-16H128c-53 0-96-43-96-96V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 70.7 57.3 128 128 128h176c8.8 0 16-7.2 16-16zm-48-384c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48z"
        }
    ]
};

const FalNotes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalNotes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v160h-80c-26.5 0-48 21.5-48 48v80H160c-17.7 0-32-14.3-32-32V96zm318.2 192c-1.6 4.5-4.2 8.7-7.6 12.1l-74.5 74.5c-3.4 3.4-7.6 6-12.1 7.6V304c0-8.8 7.2-16 16-16h78.2zM96 96v256c0 35.3 28.7 64 64 64h181.5c17 0 33.3-6.7 45.3-18.7l74.5-74.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm224 400c0-8.8-7.2-16-16-16H128c-53 0-96-43-96-96V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v240c0 70.7 57.3 128 128 128h176c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FalO = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalO",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64a192 192 0 1 0 0 384 192 192 0 1 0 0-384zm224 192a224 224 0 1 1-448 0 224 224 0 1 1 448 0z"
        }
    ]
};

const FalObjectExclude = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectExclude",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h224c17.7 0 32 14.3 32 32v64h32V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h64v-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm96 352v64c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-64v32h64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32v-64h-32zm128-32c35.3 0 64-28.7 64-64h-32c0 17.7-14.3 32-32 32h-32v32h32zm64-160v-32h-64v32h32v64h32v-64zM224 352v-32h-32v-64h-32v96h64zm-64-128h32c0-17.7 14.3-32 32-32h32v-32h-32c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FalObjectGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectGroup",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 125.3c-18.6-6.6-32-24.4-32-45.3 0-26.5 21.5-48 48-48 20.9 0 38.7 13.4 45.3 32h325.4c6.6-18.6 24.4-32 45.3-32 26.5 0 48 21.5 48 48 0 20.9-13.4 38.7-32 45.3v261.4c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48-20.9 0-38.7-13.4-45.3-32H125.3c-6.6 18.6-24.4 32-45.3 32-26.5 0-48-21.5-48-48 0-20.9 13.4-38.7 32-45.3V125.3zM125.3 96c-4.8 13.6-15.6 24.4-29.3 29.3v261.4c13.6 4.8 24.4 15.6 29.3 29.3h325.4c4.8-13.6 15.6-24.4 29.3-29.3V125.3c-13.6-4.8-24.4-15.6-29.3-29.3H125.3zM496 416a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 432a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM496 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zM96 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm80 48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zm-16 48v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm192 64c0-8.8 7.2-16 16-16h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48 0-8.8 7.2-16 16-16s16 7.2 16 16 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalObjectIntersect = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectIntersect",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32H64c-17.7 0-32 14.3-32 32v32H0V64C0 28.7 28.7 0 64 0h32v32zm32 0V0h96v32h-96zM0 128h32v96H0v-96zm288-96h-32V0h32c35.3 0 64 28.7 64 64v64h-32V64c0-17.7-14.3-32-32-32zm32 128h32v128c0 35.3-28.7 64-64 64H160V224c0-35.3 28.7-64 64-64h96zM160 384h32v64c0 17.7 14.3 32 32 32h32v32h-32c-35.3 0-64-28.7-64-64v-64zm-32-32H64c-35.3 0-64-28.7-64-64v-32h32v32c0 17.7 14.3 32 32 32h64v32zm256-160v-32h64c35.3 0 64 28.7 64 64v32h-32v-32c0-17.7-14.3-32-32-32h-64zm-96 320v-32h96v32h-96zm160 0h-32v-32h32c17.7 0 32-14.3 32-32v-32h32v32c0 35.3-28.7 64-64 64zm64-128h-32v-96h32v96zM224 192c-17.7 0-32 14.3-32 32v96h96c17.7 0 32-14.3 32-32v-96h-96z"
        }
    ]
};

const FalObjectSubtract = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectSubtract",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h32V0H64C28.7 0 0 28.7 0 64v32h32V64c0-17.7 14.3-32 32-32zm160 0V0h-96v32h96zM32 128H0v96h32v-96zm0 128H0v32c0 35.3 28.7 64 64 64h32v-32H64c-17.7 0-32-14.3-32-32v-32zm96 96h96v-32h-96v32zm32 32v64c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64h-64v32h64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32v-64h-32zm192-192v-64h-32v96h32v-32zm0-128c0-35.3-28.7-64-64-64h-32v32h32c17.7 0 32 14.3 32 32v32h32V64zm-96 256v32h32c35.3 0 64-28.7 64-64v-32h-32v32c0 17.7-14.3 32-32 32h-32z"
        }
    ]
};

const FalObjectUngroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectUngroup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0 29.8 20.4 54.9 48 62v100c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64 29.8 0 54.9-20.4 62-48h196c7.1 27.6 32.2 48 62 48 35.3 0 64-28.7 64-64 0-29.8-20.4-54.9-48-62V126c27.6-7.1 48-32.2 48-62 0-35.3-28.7-64-64-64-29.8 0-54.9 20.4-62 48H126C118.9 20.4 93.8 0 64 0 28.7 0 0 28.7 0 64zm322 16c5.8 22.5 23.5 40.2 46 46v100c-22.5 5.8-40.2 23.5-46 46H126c-5.8-22.5-23.5-40.2-46-46V126c22.5-5.8 40.2-23.5 46-46h196zm158 128h-16v32h50c5.8 22.5 23.5 40.2 46 46v100c-22.5 5.8-40.2 23.5-46 46H318c-5.8-22.5-23.5-40.2-46-46v-50h-32v50c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64 29.8 0 54.9-20.4 62-48h196c7.1 27.6 32.2 48 62 48 35.3 0 64-28.7 64-64 0-29.8-20.4-54.9-48-62V286c27.6-7.1 48-32.2 48-62 0-35.3-28.7-64-64-64-29.8 0-54.9 20.4-62 48h-34zm96 48a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-32 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-288 32a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm96-192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM64 320a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM352 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zM64 96a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"
        }
    ]
};

const FalObjectUnion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectUnion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 320c17.7 0 32 14.3 32 32v96c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32h-96c-17.7 0-32-14.3-32-32V64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h96zm-32 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h224c35.3 0 64 28.7 64 64v96h96c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H224c-35.3 0-64-28.7-64-64v-96h-32z"
        }
    ]
};

const FalObjectsAlignBottom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectsAlignBottom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16H16zm160-160c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h64zm-64 32c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-64zm288-32c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h64zm-64 32c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-64z"
        }
    ]
};

const FalObjectsAlignCenterHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectsAlignCenterHorizontal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 176c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v64zm-176 48h160c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H272V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H80c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h160v64h-96c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h96v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h96c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-96v-64zm-16 96h112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H144c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h112z"
        }
    ]
};

const FalObjectsAlignCenterVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectsAlignCenterVertical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 64c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h64zm48 176V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v160c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V272h64v96c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-96c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v96h-64zm96 16V144c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V256z"
        }
    ]
};

const FalObjectsAlignLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectsAlignLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0s16 7.2 16 16v480c0 8.8-7.2 16-16 16s-16-7.2-16-16V16zm160 160c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v64zm-32-64c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48v-64zm32 288c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v64zm-32-64c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48v-64z"
        }
    ]
};

const FalObjectsAlignRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectsAlignRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM352 176c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64zm32-64c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v64c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-64zm-32 288c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v64zm32-64c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h160c26.5 0 48-21.5 48-48v-64z"
        }
    ]
};

const FalObjectsAlignTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectsAlignTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm160 160c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h64zm-64-32c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-64zm288 32c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h64zm-64-32c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48h-64z"
        }
    ]
};

const FalObjectsColumn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalObjectsColumn",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 64c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H48zM0 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zm304 176c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16h-96zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V272zm-112 80H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm-96-32h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zM304 64c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-96zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80z"
        }
    ]
};

const FalOctagonCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOctagonCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3l-22.6 22.6A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6 119.4 119.4c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7l119.4-119.4c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zm171.8 171.2-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7 116.7-116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalOctagonDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOctagonDivide",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3l-22.6 22.6A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6 119.4 119.4c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7l119.4-119.4c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM256 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-96 104h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalOctagonExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOctagonExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3l-22.6 22.6A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6 119.4 119.4c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7l119.4-119.4c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM256 128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-24 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalOctagonMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOctagonMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3l-22.6 22.6A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6 119.4 119.4c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7l119.4-119.4c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM160 240h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalOctagonPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOctagonPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3l-22.6 22.6A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6 119.4 119.4c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7l119.4-119.4c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zM240 352v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalOctagonXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOctagonXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.5 32.1c-10.6 0-20.8 4.2-28.3 11.7L43.8 163.2c-7.5 7.5-11.7 17.7-11.7 28.3v129c0 10.6 4.2 20.8 11.7 28.3l-22.6 22.6A71.983 71.983 0 0 1 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4.1 191.5.1h129c19.1 0 37.4 7.6 50.9 21.1l119.4 119.4c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8a71.983 71.983 0 0 1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l22.6-22.6 119.4 119.4c7.5 7.5 17.7 11.7 28.3 11.7h129c10.6 0 20.8-4.2 28.3-11.7l119.4-119.4c7.5-7.5 11.7-17.7 11.7-28.3v-129c0-10.6-4.2-20.8-11.7-28.3L348.8 43.8c-7.5-7.5-17.7-11.7-28.3-11.7h-129zm-10.8 148.6c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalOctagon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOctagon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M163.2 43.8c7.5-7.5 17.7-11.7 28.3-11.7h129c10.6 0 20.8 4.2 28.3 11.7l119.4 119.4c7.5 7.5 11.7 17.7 11.7 28.3v129c0 10.6-4.2 20.8-11.7 28.3L348.8 468.2c-7.5 7.5-17.7 11.7-28.3 11.7h-129c-10.6 0-20.8-4.2-28.3-11.7L43.8 348.8l-22.6 22.6 22.6-22.6c-7.5-7.5-11.7-17.7-11.7-28.3v-129c0-10.6 4.2-20.8 11.7-28.3L163.2 43.8zM.1 320.5c0 19.1 7.6 37.4 21.1 50.9l119.4 119.4c13.5 13.5 31.8 21.1 50.9 21.1h129c19.1 0 37.4-7.6 50.9-21.1l119.4-119.4c13.5-13.5 21.1-31.8 21.1-50.9v-129c0-19.1-7.6-37.4-21.1-50.9L371.4 21.2A71.983 71.983 0 0 0 320.5.1h-129c-19.1 0-37.4 7.6-50.9 21.1L21.2 140.6A71.983 71.983 0 0 0 .1 191.5v129z"
        }
    ]
};

const FalOilCanDrip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOilCanDrip",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 80c0 8.8-7.2 16-16 16h-64v64h96.9c9.9 0 19.7 2.3 28.6 6.8L448 192l167-35.8c18.1-3.9 30.7 17.6 18.4 31.5L451.1 394.3c-12.1 13.8-29.6 21.7-48 21.7H144c-26.5 0-48-21.5-48-48v-28l-64.9-24.3c-18.7-7-31.1-25-31.1-45V208c0-26.5 21.5-48 48-48h192V96h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h160c8.8 0 16 7.2 16 16zm102.7 143.3c-7.1 1.5-14.5.6-21-2.7l-50.5-25.2c-4.4-2.2-9.3-3.4-14.3-3.4H128v176c0 8.8 7.2 16 16 16h259.1c9.2 0 17.9-3.9 24-10.8l156.7-177.6-129.1 27.7zM96 192H48c-8.8 0-16 7.2-16 16v62.7c0 6.7 4.1 12.6 10.4 15L96 305.8V192zm512 208v-.9c-.1-.5-.2-1.2-.3-2.1-.3-1.8-.9-4.2-1.7-7-1.7-5.7-4.2-12.5-7.4-20-2-4.7-4.2-9.5-6.5-14.3-2.3 4.8-4.4 9.6-6.5 14.3-7.1 16.6-9.5 26.7-9.5 29.9 0 8.8 7.2 16 16 16 7 0 10.7-2.1 12.3-3.5 1.2-1.1 3.7-4 3.7-12.5zm32 0c0 32-21.5 48-48 48s-48-21.5-48-48c0-21 20.6-62.6 34.9-88.8 5.8-10.6 20.5-10.6 26.3 0C619.4 337.4 640 379 640 400z"
        }
    ]
};

const FalOilCan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOilCan",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H48c-26.5 0-48 21.5-48 48v62.7c0 20 12.4 37.9 31.1 44.9L96 340v28c0 26.5 21.5 48 48 48h259.1c18.4 0 35.8-7.9 48-21.7l182.4-206.6c12.3-13.9-.3-35.4-18.4-31.5L448 192l-50.5-25.2c-8.9-4.4-18.7-6.8-28.6-6.8H272V96h64zm97.7 124.6c6.5 3.2 13.9 4.2 21 2.7l129.1-27.7-156.7 177.6c-6.1 6.9-14.8 10.8-24 10.8H144c-8.8 0-16-7.2-16-16V192h240.9c5 0 9.9 1.2 14.3 3.4l50.5 25.2zM96 305.8l-53.6-20.1c-6.2-2.3-10.4-8.3-10.4-15V208c0-8.8 7.2-16 16-16h48v113.8z"
        }
    ]
};

const FalOilTemperature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOilTemperature",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 32c0-17.7 14.3-32 32-32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v97.6c36.5 7.4 64 39.7 64 78.4 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-38.7 27.5-71 64-78.4V32zm16 320a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-154.2-37.2c13.5 9.2 29.7 17.5 46.6 20.2 3.4 11.9 8.8 23 15.7 32.9-1.3.1-2.7.1-4 .1-30.3 0-57.6-14.1-76.2-26.8-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 368.1 0 360 0 350.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9zM384 368c-1.3 0-2.7 0-4-.1 6.9-9.9 12.2-21 15.7-32.9 16.8-2.8 33.1-11.1 46.5-20.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7zM192 480c20.9 0 41.6-9.9 58.2-21.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9C150.3 470 171.1 480 192 480z"
        }
    ]
};

const FalOilWell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOilWell",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M497.4 69.6c-6.9-25.6-33.2-40.8-58.8-33.9l-15.5 4.1L489.4 287l15.5-4.1c25.6-6.9 40.8-33.2 33.9-58.8L497.4 69.6zm-67-64.9c42.7-11.4 86.5 13.9 98 56.6l41.4 154.5c11.4 42.7-13.9 86.5-56.6 98l-15.5 4.1c-17.1 4.6-34.6-5.6-39.2-22.6l-29.3-109.5L96 272.2V480h36.5L200 277.3l36.9-9.6-28 84.3h126.2l-33.6-101 31-8 79 237.1H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V176c0-8.8 7.2-16 16-16s16 7.2 16 16v63.2L223.8 206l33-99.1C259 100.4 265.1 96 272 96s13 4.4 15.2 10.9l25.3 76.1 108.4-28.1L392.3 48c-4.6-17.1 5.6-34.6 22.6-39.2l15.5-4.1zM281.5 191.1l-9.5-28.5-11.3 33.9 20.8-5.4zM377.8 480l-32-96H198.2l-32 96h211.6z"
        }
    ]
};

const FalOliveBranch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOliveBranch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96c-38.9 0-68.8-17.9-86.4-32C59.2 49.9 89.1 32 128 32s68.8 17.9 86.4 32c-17.6 14.1-47.5 32-86.4 32zm0-96C59.2 0 14.1 44.2 2.8 56.6.9 58.6 0 61.2 0 64s.9 5.4 2.8 7.4c8.2 8.9 34 34.5 73.8 48C30.6 147.6 0 198.2 0 256v16c0 8.8 7.2 16 16 16h32c88.4 0 160-71.6 160-160v-13.6l122.4-58.8C362.8 40.1 398.3 32 434.3 32H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H434.3c-40.7 0-81 9.2-117.7 26.8l-63 30.2c-.1-.2-.3-.3-.4-.4C241.9 44.2 196.8 0 128 0zm47.7 128h.3c0 70.7-57.3 128-128 128H32c0-70.7 57.3-128 128-128h15.7zm236.5 308.6C390.7 465.2 363.4 480 336 480s-54.7-14.8-76.2-43.4S224 366.8 224 320s14.3-87.9 35.8-116.6c21.5-28.6 48.8-43.4 76.2-43.4s54.7 14.8 76.2 43.4C433.7 232.1 448 273.2 448 320s-14.3 87.9-35.8 116.6zM336 512c79.5 0 144-86 144-192s-64.5-192-144-192-144 86-144 192 64.5 192 144 192zm129.7-40.2c52.9 16.5 105.5 8.4 139.6-27 56.2-58.3 41-168.6-33.9-246.4-42.9-44.5-96.1-68.7-144.2-70.3 13.6 10.4 25.7 22.9 36.2 36.9.5.7 1 1.4 1.5 2 28.3 9 57.7 26.8 83.4 53.5 33.1 34.4 52.4 75.3 57.5 112.6 5.2 37.5-3.9 68.9-23.6 89.3-19.5 20.2-48.9 29.2-84 24-5-.7-10.1-1.8-15.2-3.1-5.2 10-11 19.5-17.4 28.3z"
        }
    ]
};

const FalOlive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOlive",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 448c-70.7 0-128-57.3-128-128 0-84.8 39.8-148.3 91.7-191.4C176.5 84.7 239.5 64 280 64c18.4 0 39.8 9.7 59.3 22.6 9.2 6.1 16.9 12.3 22.3 16.9 2.7 2.3 4.8 4.2 6.1 5.4.7.6 1.2 1.1 1.5 1.4l.3.3.3.3c.3.3.7.8 1.4 1.5 1.3 1.3 3.1 3.4 5.4 6.1 4.6 5.4 10.8 13.1 16.9 22.3 12.8 19.4 22.5 40.8 22.5 59.2 0 40.5-20.7 103.5-64.6 156.3C308.3 408.2 244.8 448 160 448zM0 320c0 88.4 71.6 160 160 160 192 0 288-181.9 288-280 0-56-56-112-56-112s-56-56-112-56C181.9 32 0 128 0 320zm260.4-187.6c3.6-3.6 11.2-6.2 24.2-3 12.6 3.2 27.6 11.5 41 24.9s21.8 28.4 24.9 41c3.2 13 .6 20.6-3 24.2s-11.2 6.2-24.2 3c-12.6-3.2-27.6-11.5-41-24.9s-21.8-28.4-24.9-41c-3.2-13-.6-20.6 3-24.2zm87.8-.7c-16.9-16.9-36.7-28.6-55.9-33.4-18.8-4.7-39.9-3.2-54.5 11.4s-16.1 35.8-11.4 54.5c4.8 19.1 16.5 39 33.4 55.9s36.7 28.6 55.9 33.4c18.8 4.7 39.9 3.2 54.5-11.4s16.1-35.8 11.4-54.5c-4.8-19.1-16.5-39-33.4-55.9z"
        }
    ]
};

const FalOm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOm",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m321.4 33.4 24-24c12.5-12.5 32.8-12.5 45.3 0l24 24c12.5 12.5 12.5 32.8 0 45.3l-24 24c-12.5 12.5-32.8 12.5-45.3 0l-24-24c-12.5-12.5-12.5-32.8 0-45.3zM368 80l1.4-1.4 21.3-21.3L392 56l-1.4-1.4-21.2-21.2L368 32l-1.4 1.4-21.2 21.2L344 56l1.4 1.4 21.3 21.3L368 80zm-224 48c-20.9 0-39.5 10-51.2 25.6-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4C84.7 111.1 112.6 96 144 96c53 0 96 43 96 96 0 24.6-9.2 47-24.4 64h43.5c25.4 0 50.1-8.7 70-24.5l22.2-17.8c17.5-14 39.3-21.7 61.8-21.7 54.6 0 98.9 44.3 98.9 98.9v94c0 52.5-42.6 95.1-95.1 95.1-36 0-69-20.4-85.1-52.6l-10.1-20.3c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l10.1 20.3c10.6 21.4 32.5 34.9 56.4 34.9 34.9 0 63.1-28.3 63.1-63.1v-94c0-37-30-66.9-66.9-66.9-15.2 0-29.9 5.2-41.8 14.7l-22.2 17.8c-25.5 20.4-57.3 31.6-90 31.6h-14.4c26.6 23.5 43.3 57.8 43.3 96 0 70.7-57.3 128-128 128h-16C64.5 512 0 447.5 0 368c0-8.8 7.2-16 16-16s16 7.2 16 16c0 61.9 50.1 112 112 112h16c53 0 96-43 96-96s-43-96-96-96h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64s-28.7-64-64-64zm154.4-12.2c.7.5 1.9 1.3 3.6 2.3 3.2 1.9 8.1 4.6 14.4 7.3 12.6 5.4 30.4 10.7 51.7 10.7s39.1-5.3 51.7-10.7c6.3-2.7 11.1-5.3 14.4-7.3 1.6-1 2.8-1.7 3.6-2.3.4-.3.6-.4.8-.5l.1-.1H297.8h141c7.1-5.2 17.1-3.8 22.3 3.3 5.3 7.1 3.8 17.1-3.2 22.4L448 128l9.6 12.8h-.1l-.1.1-.4.3c-.3.2-.8.6-1.4 1-1.2.8-2.9 1.9-5 3.2-4.3 2.6-10.4 5.9-18.2 9.2-15.6 6.7-37.8 13.4-64.4 13.4s-48.8-6.7-64.2-13.3c-7.8-3.3-13.9-6.7-18.2-9.2-2.1-1.3-3.8-2.4-5-3.2-.6-.4-1.1-.7-1.4-1l-.4-.3-.1-.1h-.1l9.6-12.8-9.6 12.8c-7.1-5.3-8.5-15.3-3.2-22.4 5.3-7.1 15.3-8.5 22.3-3.3l.1.1c.1.1.4.3.8.5z"
        }
    ]
};

const FalOmega = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOmega",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64C118 64 32 150 32 256c0 69.5 36.9 130.4 92.3 164.1 9.4 5.7 15.9 16.1 15.9 27.9 0 17.7-14.3 32-32 32H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h92.2v-.1c-.1-.1-.2-.3-.5-.5C43.1 408.2 0 337.1 0 256 0 132.3 100.3 32 224 32s224 100.3 224 224c0 81.1-43.1 152.1-107.6 191.4-.3.2-.4.3-.5.5v.1H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-92.2c-17.7 0-32-14.3-32-32 0-11.8 6.5-22.2 15.9-27.9C379.1 386.4 416 325.5 416 256c0-106-86-192-192-192z"
        }
    ]
};

const FalOnion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOnion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M195.8 0c2.7 0 5.3.5 7.7 1.5h.1c3.2 1.4 6 3.5 8.1 6.3.7.9 1.3 1.9 1.9 3l3.4 6.8c2.9 5.9 11.4 5.9 14.3 0l3.4-6.8c.5-1.1 1.2-2.1 1.9-3 2.1-2.8 4.9-5 8.1-6.3h.1c2.4-1 5-1.5 7.7-1.5 10.9 0 19.6 9 21.3 19.8 2.1 13.6 6.5 25.6 12.4 36.6h.1l.1.1.2.4.7 1.4 1.2 2.2c15.3 25.7 39.5 45.4 64.5 65.7 46 37.5 95 77.3 95 161.8 0 83.4-62.5 139.3-140.4 163.1l-.1.1-.6.6-.2.2-.1.1-.1-.1c-.1-.1-.2-.2-.3-.4h-.1l13.1 39.4c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-14-42c-11.5 2.1-23.1 3.5-34.8 4.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32.6c-11.7-.8-23.3-2.2-34.8-4.3l-14 42c-2.8 8.4-11.9 12.9-20.2 10.1S126.2 499.3 129 491l13-39.5C63.4 428 0 372 0 288c0-84.5 49-124.3 95.3-162 25.2-20.4 49.5-40.2 64.7-66l1-1.8.7-1.3.2-.3.1-.1h.1c6-11 10.3-23 12.5-36.6C176.2 9 184.9 0 195.8 0zm-76.6 147.9-4.8 3.9c-4.5 3.7-8.9 7.3-13.1 10.7C62 195.3 32 227 32 288c0 43.8 21.5 78.3 56.8 103.3 6 4.3 12.5 8.3 19.2 11.9-14.8-24.5-28-57.9-28-99.2 0-48.4 19.7-108.4 39.2-156.1zm48 277.2c14.6 3.4 29.6 5.5 44.9 6.4-2.2-4.5-4.5-9.4-6.8-14.9C194.6 391.3 184 355.2 184 312c0-61.9 6.1-128.6 12.1-179.6 3-25.6 6-47.3 8.3-62.6 1.1-7.7 2.1-13.8 2.7-17.9l.2-1.3c-2.3-1-4.4-2.3-6.5-3.7-3.4 10.4-7.7 19.9-12.9 28.7l-1.2 2.4c-2.1 4.1-5.2 10.1-8.9 17.6-7.4 15-17.2 35.9-27.1 59.7C130.8 203.4 112 260.8 112 304c0 39.4 14.5 70.3 29.2 91.5 7.3 10.6 14.7 18.7 20.1 24.1 2.4 2.4 4.4 4.2 5.9 5.5zm80.7 5.5c14.7-1.5 29.2-4.2 43.1-8 .8-.8 1.6-1.7 2.6-2.7 5.1-5.6 12-13.8 18.9-24.3 13.8-21 27-49.9 27-83.6 0-44.9-19.7-104.3-40.5-154.1-10.3-24.6-20.5-46.2-28.2-61.6-3.8-7.7-7-13.9-9.3-18.1l-1.2-2.2c-5.2-8.9-9.7-18.6-13.1-29.1-2.3 1.7-4.8 3-7.4 4.1v.1l-.2 1.2c-.2 1-.4 2.6-.7 4.6-.6 4.1-1.6 10-2.7 17.6-2.2 15.1-5.2 36.5-8.2 61.7-6.1 50.4-12 115.7-12 175.8 0 37.9 9.4 69.8 18.8 92.2 4.7 11.2 9.4 19.9 12.8 25.8l.3.5zm81.9-282c20.5 49.6 41.7 112.6 41.7 163.4 0 34.3-10.9 63.9-23.6 86.7 3.9-2.4 7.7-4.9 11.4-7.4 35.3-25 56.8-59.5 56.8-103.3 0-61-30-92.7-69.3-125.5-4.1-3.5-8.5-7-13.1-10.7l-3.9-3.2z"
        }
    ]
};

const FalOption = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOption",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M178 107.7c-6.1-7.4-15.2-11.7-24.8-11.7H16C7.2 96 0 88.8 0 80s7.2-16 16-16h137.3c19.2 0 37.4 8.6 49.5 23.5L462 404.3c6.1 7.4 15.2 11.7 24.8 11.7H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H486.7c-19.2 0-37.4-8.6-49.5-23.5L178 107.7zM624 64c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h192z"
        }
    ]
};

const FalOrnament = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOrnament",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm45.3 32c1.8-5 2.7-10.4 2.7-16 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 5.6 1 11 2.7 16H128c-17.7 0-32 14.3-32 32v57.7C38.6 186.9 0 248.9 0 320c0 106 86 192 192 192s192-86 192-192c0-71.1-38.6-133.1-96-166.3V96c0-17.7-14.3-32-32-32h-18.7zm24.6 112c23 11.2 43 27.7 58.2 48H64c15.2-20.3 35.2-36.8 58.2-48h139.6zM192 96h64v48H128V96h64zM32 320c0-22.8 4.8-44.4 13.3-64h293.4c8.6 19.6 13.3 41.2 13.3 64s-4.7 44.4-13.3 64H45.3C36.8 364.4 32 342.8 32 320zm160 160c-52.3 0-98.8-25.1-128-64h256c-29.2 38.9-75.7 64-128 64z"
        }
    ]
};

const FalOtter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOtter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m145.7 211.4-12.9 6.4c-8.1 4.1-17.1 6.2-26.2 6.2-32.4 0-58.6-26.2-58.6-58.6V144c0-44.2 35.8-80 80-80h64c44.2 0 80 35.8 80 80v21.4c0 32.4-26.2 58.6-58.6 58.6-9.1 0-18.1-2.1-26.2-6.2l-12.9-6.4c-9-4.5-19.6-4.5-28.6 0zM16 144v21.4c0 19.1 5.9 36.8 16 51.4v39.8C32 380 132 480 255.4 480h159.5C539.2 480 640 379.2 640 254.9c0-90.7-64-168.8-153-186.6l-19.9-4c-8.3-1.7-16.4 3.4-18.6 11.6s2.4 16.6 10.4 19.3l21.6 7.2c37.9 12.6 63.4 48.1 63.4 88 0 16.4-6 31.4-16 42.9V192c0-8.8-7.2-16-16-16-44.2 0-80 35.8-80 80h-72 8.1c26.5 0 48-21.5 48-48s-21.5-48-48-48h-8c-20.9 0-40.4 6.2-56.7 16.8.5-3.7.7-7.6.7-11.4V144c0-5.4-.4-10.8-1.1-16h1.1c8.8 0 16-7.2 16-16s-7.2-16-16-16h-10.8c-18-37.8-56.5-64-101.2-64h-64C83.3 32 44.8 58.2 26.8 96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h1.1c-.7 5.2-1.1 10.6-1.1 16zm96 144c-24.6 0-44.9-18.6-47.7-42.5 12.6 6.7 27 10.5 42.3 10.5 14.1 0 27.9-3.3 40.5-9.6L160 240l12.9 6.4c12.6 6.3 26.5 9.6 40.5 9.6 16.7 0 32.3-4.5 45.7-12.3 8.3 25.7 32.4 44.3 60.9 44.3h56.4c-15.2 17-24.4 39.4-24.4 64h-82.7c1.8-5 2.7-10.4 2.7-16 0-26.5-21.5-48-48-48H112zm207.8-32c-11.8-.1-22.2-6.6-27.6-16.2 9.9-27.9 36.6-47.8 67.8-47.8h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8c-19.4 0-35.5 13.7-39.2 32h-1zM528 333.7v-59.2c28.7-17 48-48.3 48-84.1 0-13.3-2.1-26.3-6.1-38.5 23.9 27.9 38.1 64 38.1 103C608 361.5 521.5 448 414.9 448H255.4C167.8 448 94 389.1 71.2 308.8 83.1 315.9 97.1 320 112 320h112c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h208c8.8 0 16-7.2 16-16v-16c0-35.3 28.5-63.9 63.7-64h.3c8.8 0 16-7.2 16-16v-16c0-20.9 13.4-38.7 32-45.3v123c0 16.1-8 31-21.4 39.9l-19.5 13c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l19.5-13c22.3-14.8 35.6-39.8 35.6-66.6zM112 144a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm112 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-72-16c-13.3 0-24 10.7-24 24v8c0 6.1 3.4 11.6 8.8 14.3l16 8c4.5 2.3 9.8 2.3 14.3 0l16-8c5.4-2.7 8.8-8.3 8.8-14.3v-8c0-13.3-10.7-24-24-24H152z"
        }
    ]
};

const FalOutdent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOutdent",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 48 0 55.2 0 64zm192 128c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H208zM0 448c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm96-236.2v88.4L42.3 256 96 211.8zM7 243.6C-.8 250-.8 262 7 268.4l94.8 78.1c10.4 8.6 26.2 1.2 26.2-12.4V177.9c0-13.5-15.7-20.9-26.2-12.4L7 243.6z"
        }
    ]
};

const FalOutlet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOutlet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 160c0 49.2 24.6 79.3 39.5 93.1 1.2 1.1 4.3 2.9 10.9 2.9h155.2c6.6 0 9.7-1.8 10.9-2.9 14.9-13.8 39.5-43.9 39.5-93.1s-24.6-79.3-39.5-93.1c-1.2-1.1-4.3-2.9-10.9-2.9H146.4c-6.6 0-9.7 1.8-10.9 2.9C120.6 176.7 96 206.8 96 256zm-32 0c0-61.1 30.8-99.1 49.7-116.6 8.8-8.2 20.7-11.4 32.6-11.4h155.3c12 0 23.9 3.3 32.6 11.4 19 17.5 49.8 55.5 49.8 116.6s-30.8 99-49.7 116.6c-8.8 8.2-20.7 11.4-32.6 11.4H146.4c-12 0-23.9-3.3-32.6-11.4C94.8 355 64 317.1 64 256zm112-64c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48c0-8.8 7.2-16 16-16zm-48 96c13.3 0 24 10.7 24 24v16c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8v-16c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FalOven = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOven",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32c-35.3 0-64 28.7-64 64v64h384V96c0-35.3-28.7-64-64-64H96zM32 192v256c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V192H32zM0 96C0 43 43 0 96 0h256c53 0 96 43 96 96v352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104-16a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM96 256v160h256V256H96zm-32 0c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 48c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalOverline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalOverline",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm208 96c-88.4 0-160 71.6-160 160v32c0 88.4 71.6 160 160 160s160-71.6 160-160v-32c0-88.4-71.6-160-160-160zM96 288c0-70.7 57.3-128 128-128s128 57.3 128 128v32c0 70.7-57.3 128-128 128S96 390.7 96 320v-32z"
        }
    ]
};

const FalP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalP",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 64h128c61.9 0 112 50.1 112 112s-50.1 112-112 112H32V80c0-8.8 7.2-16 16-16zM32 320h144c79.5 0 144-64.5 144-144S255.5 32 176 32H48C21.5 32 0 53.5 0 80v384c0 8.8 7.2 16 16 16s16-7.2 16-16V320z"
        }
    ]
};

const FalPageCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPageCaretDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h181.5c8.5 0 16.6 3.4 22.6 9.4l74.5 74.5c6 6 9.4 14.1 9.4 22.6V448zM64 512h256c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3l-74.6-74.5C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64zm116.2-165.2c3 3.3 7.3 5.2 11.8 5.2s8.8-1.9 11.8-5.2l75.7-82.6c14.1-15.4 3.2-40.2-17.7-40.2H122.2c-20.9 0-31.8 24.8-17.7 40.2l75.7 82.6zM140.4 256h103.3L192 312.3 140.4 256z"
        }
    ]
};

const FalPageCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPageCaretUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h181.5c8.5 0 16.6 3.4 22.6 9.4l74.5 74.5c6 6 9.4 14.1 9.4 22.6V448zM64 512h256c35.3 0 64-28.7 64-64V138.5c0-17-6.7-33.3-18.7-45.3l-74.6-74.5C278.7 6.7 262.5 0 245.5 0H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64zm139.8-314.8c-3-3.3-7.3-5.2-11.8-5.2s-8.8 1.9-11.8 5.2l-75.7 82.6c-14.1 15.4-3.2 40.2 17.7 40.2h139.6c20.9 0 31.8-24.8 17.7-40.2l-75.7-82.6zM192 231.7l51.6 56.3H140.4l51.6-56.3z"
        }
    ]
};

const FalPage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPage",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 480h256c17.7 0 32-14.3 32-32V138.5c0-8.5-3.4-16.6-9.4-22.6l-74.5-74.5c-6-6-14.1-9.4-22.6-9.4H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm256 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h181.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64z"
        }
    ]
};

const FalPager = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPager",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h384zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm0 272c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zM96 160h320v96H96v-96zm-32 0v96c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalPaintRoller = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaintRoller",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h288zm64 32c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v32c0 35.3 28.7 64 64 64h288c35.3 0 64-28.7 64-64V64zM240 352c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h32zm-32-32c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-96c0-26.5-21.5-48-48-48v-32c0-17.7 14.3-32 32-32h176c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64v32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H272c-35.3 0-64 28.7-64 64v32z"
        }
    ]
};

const FalPaintbrushFine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaintbrushFine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M534.5 41.4c-12.5-12.5-32.8-12.5-45.3 0L324.6 206l45.3 45.3L534.5 86.6c12.5-12.5 12.5-32.8 0-45.3zM302 228.6l-36.6 36.6-40.8 40.8 45.3 45.3 4.6-4.6 36.1-36.1 36.6-36.6-45.2-45.4zm-106.1 93.9c-6.3-1.6-13-2.5-19.9-2.5-44.2 0-80 35.8-80 80 0 2.8.1 5.6.4 8.3 1.7 16.7-3 33.6-12.5 46.7-9.6 13.5-25.9 25-47.1 25H176c44.2 0 80-35.8 80-80 0-6.9-.9-13.5-2.5-19.9l-57.7-57.7zm361.3-213.2L286.3 380.2c1.1 6.4 1.7 13.1 1.7 19.8 0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h4.8c17.6 0 29.6-18.9 27.8-36.4-.4-3.8-.6-7.7-.6-11.6 0-61.9 50.1-112 112-112 6.7 0 13.3.6 19.7 1.7l271-271c25-25 65.5-25 90.5 0s25 65.5 0 90.5z"
        }
    ]
};

const FalPaintbrushPencil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaintbrushPencil",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M534.5 86.6 369.9 251.3 324.6 206 489.3 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3zM347.3 273.9l-36.6 36.6-36.1 36.1-4.6 4.6-45.4-45.2 40.7-40.7 36.7-36.7 45.3 45.3zM176 320c6.9 0 13.5.9 19.9 2.5l57.7 57.7c1.6 6.3 2.5 13 2.5 19.9 0 44.2-35.8 80-80 80H36.8c21.2-.1 37.5-11.6 47.2-25 9.5-13.1 14.2-30 12.5-46.7-.3-2.7-.4-5.5-.4-8.3 0-44.2 35.8-80 80-80zm110.3 60.2 270.9-270.9c25-25 25-65.5 0-90.5s-65.5-25-90.5 0l-271 271c-6.4-1.1-13-1.7-19.7-1.7-61.9 0-112 50.1-112 112 0 3.9.2 7.8.6 11.6 1.8 17.4-10.2 36.3-27.8 36.3H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h144c61.9 0 112-50.1 112-112 0-6.8-.6-13.4-1.7-19.8zM170.8 17c-21.9-21.9-57.3-21.9-79.2 0L49 59.6c-21.9 21.9-21.9 57.3 0 79.2l117.5 117.5c3.1-.2 6.3-.3 9.5-.3 2.7 0 5.3.1 7.9.2l13.9-13.9-48.8-48.7 76.6-76.6 48.8 48.8 22.6-22.6L170.8 17zm239.3 284.6 50.8 50.8c7.6 7.6 13.1 16.9 16.1 27.2l27.3 92.8-92.8-27.3c-10.3-3-19.6-8.6-27.2-16.1l-50.8-50.8-13.8 13.8c.1 2.7.2 5.4.2 8.1 0 3.2-.1 6.4-.3 9.5l42 42c11.4 11.4 25.4 19.7 40.8 24.2l121 35.6c5.6 1.7 11.7.1 15.8-4s5.7-10.2 4-15.8l-35.6-121c-4.5-15.4-12.9-29.4-24.2-40.8L432.6 279 410 301.6zm-295.9-262c9.4-9.4 24.6-9.4 33.9 0L203 94.4 126.4 171l-54.8-54.8c-9.4-9.4-9.4-24.6 0-33.9l42.6-42.6z"
        }
    ]
};

const FalPaintbrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaintbrush",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M295.7 360c-5.4 0-10.6-.5-15.7-1.5v-.1l-3.9-.9-57.7-57.7-.9-3.9h-.1c-1-5.1-1.5-10.3-1.5-15.7 0-25.5 12.2-49.5 32.8-64.5L493.1 38.1c12.7-9.3 30.3-7.9 41.4 3.2S547 70 537.8 82.7L360.2 327.2c-15 20.6-39 32.8-64.5 32.8zm-42.2 20.1c.3 1.3.6 2.6.9 4 1 5.1 1.6 10.4 1.6 15.9 0 44.2-35.8 80-80 80H36.8c21.2 0 37.5-11.5 47.2-24.9 9.5-13.1 14.2-30 12.5-46.7-.3-2.7-.4-5.5-.4-8.3 0-44.2 35.8-80 80-80 5.4 0 10.7.5 15.9 1.6 1.3.3 2.7.6 4 .9l57.7 57.7zm34.2 11.6c2.6.2 5.3.3 8 .3 35.7 0 69.3-17.1 90.4-46l177.6-244.4c18.5-25.5 15.8-60.6-6.5-82.9s-57.4-25-82.9-6.5L230 190c-28.9 21-46 54.6-46 90.3 0 2.7.1 5.4.3 8-2.7-.2-5.5-.3-8.3-.3-61.9 0-112 50.1-112 112 0 3.9.2 7.8.6 11.6 1.8 17.5-10.2 36.4-27.8 36.4H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h144c61.9 0 112-50.1 112-112 0-2.8-.1-5.5-.3-8.3z"
        }
    ]
};

const FalPalette = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPalette",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 258.3c-.1 14.1-13.8 29.7-38.1 29.7H344c-44.2 0-80 35.8-80 80 0 5.6.6 11.2 1.7 16.6 2.9 13.8 8.9 27.3 13.2 37 .8 1.7 1.5 3.3 2.1 4.8 5 11.6 6.9 18.2 6.9 23.5 0 19.2-12.3 29.6-22.7 30-3.1.1-6.2.2-9.3.2C132.3 480 32 379.7 32 256S132.3 32 256 32s224 100.3 224 224v2.3zm32 .3v-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256s114.6 256 256 256c3.5 0 7.1-.1 10.6-.2 31.8-1.3 53.4-30.1 53.4-62 0-14.5-6.1-28.3-12.1-42-4.3-9.8-8.7-19.7-10.8-29.9-.7-3.2-1-6.5-1-9.9 0-26.5 21.5-48 48-48H442c36.5 0 69.7-24.8 70.1-61.3zM152 256a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm8-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalPalletBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPalletBox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 32c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h64v112c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L320 116l54.4 40.8c4.8 3.6 11.3 4.2 16.8 1.5S400 150 400 144V32h64zm-192 0h96v80l-38.4-28.8a15.9 15.9 0 0 0-19.2 0L272 112V32zM176 0c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H176zM0 368c0 8.8 7.2 16 16 16h48v96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm96 112v-96h208v96H96zm240 0v-96h208v96H336z"
        }
    ]
};

const FalPalletBoxes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPalletBoxes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 32H112c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16zM112 0h192c26.5 0 48 21.5 48 48v192c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zm416 128h-96c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm-96-32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zM0 368c0-8.8 7.2-16 16-16h608c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v96h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-96H16c-8.8 0-16-7.2-16-16zm96 112h208v-96H96v96zm240 0h208v-96H336v96z"
        }
    ]
};

const FalPallet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPallet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v96H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm80 32h208v96H96v-96zm240 0h208v96H336v-96z"
        }
    ]
};

const FalPanFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPanFood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M522.4 352c4.5-9.4 8.3-19.3 11.5-29.4.3-.9.5-1.7.8-2.6 6-20.3 9.3-41.8 9.3-64s-3.2-43.7-9.3-64c-3.1-10.6-7-20.8-11.6-30.7l-.6-1.3C486.5 84.3 409.4 32 320 32S153.5 84.3 117.6 160c-4.9 10.2-9 20.9-12.3 32-6 20.3-9.3 41.8-9.3 64s3.2 43.7 9.3 64c3.1 10.6 7 20.8 11.6 30.7l.6 1.3c36 75.7 113.1 128 202.4 128s166.5-52.3 202.4-128zm34.9 0c-38 93.8-130 160-237.4 160S120.5 445.8 82.5 352H40c-22.1 0-40-17.9-40-40V200c0-22.1 17.9-40 40-40h42.6C120.6 66.2 212.6 0 320 0s199.4 66.2 237.4 160H600c22.1 0 40 17.9 40 40v112c0 22.1-17.9 40-40 40h-42.6zm10.5-160c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64H600c4.4 0 8-3.6 8-8V200c0-4.4-3.6-8-8-8h-32.1zm-495.7 0H40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h32.1c-5.3-20.5-8.1-41.9-8.1-64s2.8-43.5 8.1-64zm345.5 144c-21.5 0-42.2-8.6-57.4-23.8-4.5-4.5-4.5-11.9 0-16.4l95.6-95.6c4.5-4.5 11.9-4.5 16.5.1 15.1 15.1 23.7 35.7 23.7 57v2.4c0 27.4-14.7 52.6-38.4 66.2-11.5 6.6-24.6 10-37.8 10h-2.1zm46.4-78.7c0-5.8-1.1-11.5-3.1-17l-60.5 60.5c5.5 2 11.3 3.1 17.3 3.1h2.1c7.7 0 15.3-2 22-5.8 13.8-7.9 22.3-22.5 22.3-38.4v-2.4zm-260.7-54-32 32c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l32-32c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM296 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-180.7-60.7a6.64 6.64 0 0 0 0 9.4l6.6 6.6c3 3 7.1 4.7 11.3 4.7H288c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64v-34.7c0-4.2-1.7-8.3-4.7-11.3l-6.6-6.6a6.64 6.64 0 0 0-9.4 0c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l16-16 16-16c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM320 384c0-17.7-14.3-32-32-32h-16c-8.8 0-16 7.2-16 16v16c0 17.7 14.3 32 32 32s32-14.3 32-32zm0-288c-20.9 0-38.7 13.4-45.3 32h90.5c-6.6-18.6-24.4-32-45.3-32zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalPanFrying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPanFrying",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 416c53 0 101.6-18.4 140-49.1l77 87c14.7 16.6 35.8 26.1 57.9 26.1 42.5 0 77.2-34.5 77.2-77 0-26.7-13.8-51.5-36.6-65.5L433.3 304c9.5-24.8 14.7-51.8 14.7-80C448 100.3 347.7 0 224 0S0 100.3 0 224s100.3 224 224 224zm240.9 16.7-77.5-87.6c12.4-13.3 23.3-28 32.2-44l103 63.5c13.3 8.2 21.4 22.7 21.4 38.3 0 24.8-20.2 45-45.2 45-13 0-25.4-5.6-33.9-15.3zM496 448a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM152.6 102.3c-14.5 13.9-22.6 32.1-24.3 50.7-2.1 23.5-8.7 52.4-19.4 71-26.5 45.9-10.8 104.6 35.1 131.1s104.6 10.8 131.1-35.1c2.9-5.1 8.9-10.9 16.9-15.8 7.9-4.9 16.4-8 23.1-9 12.8-1.8 25.4-6.7 36.5-15 35.5-26.3 42.9-76.4 16.6-111.9-11.4-15.3-27.2-25.5-44.4-29.8-8.7-2.2-20-7.1-31-13.6s-20.9-13.8-27.1-20.3c-30.6-31.9-81.3-32.9-113.1-2.2zm90 24.4c8.9 9.3 21.4 18.4 34.1 25.8s26.7 13.8 39.2 17c10.3 2.6 19.8 8.7 26.6 17.9 15.8 21.3 11.3 51.4-10 67.1-6.7 5-14.2 7.9-21.9 9-11.9 1.7-24.6 6.7-35.4 13.4-10.8 6.7-21.4 15.9-27.8 27.1-17.7 30.6-56.8 41.1-87.4 23.4s-41.1-56.8-23.4-87.4c14-24.3 21.3-58.4 23.6-84.2 1-11.2 5.8-22 14.5-30.4 19.1-18.4 49.5-17.8 67.9 1.3zM200 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0z"
        }
    ]
};

const FalPancakes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPancakes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M73.8 100c8.5-6.2 21.9-12.5 39.9-18 13.7-4.2 29.6-7.9 47.2-10.7-.5 2.8-.8 5.7-.8 8.7 0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48 0-3-.3-5.9-.8-8.7 17.5 2.9 33.4 6.5 47.2 10.7 18 5.5 31.3 11.8 39.9 18 8.9 6.5 9.8 10.7 9.8 12 0 1.1-.6 4.3-6.6 9.5-5.9 5.1-15.5 10.5-29 15.7-26.7 10.2-65.3 18-110.4 21.2-25.2 1.8-46.1 22.4-46.1 48.7V288c0 8.8-7.2 16-16 16s-16-7.2-16-16v-85.7c0-25.1-20.7-43.9-43.1-46.7-28.5-3.5-52.9 18.5-52.9 47V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V166.1c0-19-11.4-33.8-23.4-43-7.9-6-8.6-9.9-8.6-11.1 0-1.3.9-5.5 9.8-12zm125.7-33.5c17.8-1.6 36.8-2.5 56.5-2.5s38.7.9 56.5 2.5c4.5 2.8 7.5 7.8 7.5 13.5 0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16 0-5.7 3-10.7 7.5-13.5zm-95.3-15c-19.7 6-36.7 13.5-49.3 22.6C42.8 83 32 95.6 32 112c0 15.6 9.8 27.8 21.1 36.5 7.4 5.7 10.9 12.1 10.9 17.6V336c0 26.5 21.5 48 48 48s48-21.5 48-48V202.5c0-9.5 7.8-16.3 17-15.2 8.9 1.1 15 8.5 15 14.9V288c0 26.5 21.5 48 48 48s48-21.5 48-48v-80.9c0-8.5 6.9-16.1 16.4-16.8 47-3.4 88.9-11.6 119.5-23.3 15.2-5.8 28.6-12.9 38.4-21.3 9.7-8.3 17.7-19.6 17.7-33.7 0-16.4-10.8-29-22.9-37.9-12.5-9.1-29.6-16.6-49.3-22.7C368.2 39.3 314.6 32 256 32s-112.2 7.3-151.8 19.5zm322.6 159.2c-28.1 9.5-64.7 15.9-106.8 19v32.1c64.8-4.6 119.7-16.7 153.9-37.3 4.6 5.8 6.1 11.2 6.1 15.5 0 10.8-8.9 27.7-53.2 42.7-28.4 9.6-65.4 16-108 19.1-2.1 12.1-7 23.3-13.9 32.9 71.3-3.8 132.1-16.1 169-38.3 4.6 5.8 6.1 11.2 6.1 15.5 0 10.8-8.9 27.7-53.2 42.7C385.2 368.8 325.1 376 256 376c-25.8 0-50.3-1-73.1-3-6.2 11.9-15.3 22-26.3 29.4 30.6 3.8 64.1 5.6 99.4 5.6 92.1 0 172.8-12.4 217.9-39.5 4.6 5.8 6.1 11.2 6.1 15.5 0 10.8-8.9 27.7-53.2 42.7C385.2 440.8 325.1 448 256 448s-129.2-7.2-170.8-21.3C40.9 411.7 32 394.8 32 384c0-4.4 1.4-9.7 6.1-15.5l1.1.6C34.6 359 32 347.8 32 336V172.6c-8.9-7.1-18.9-17.3-25.3-30.9C2.3 149.8 0 158.5 0 168c0 13.5 4.7 25.5 13.4 36C4.7 214.5 0 226.5 0 240s4.7 25.5 13.4 36C4.7 286.5 0 298.5 0 312s4.7 25.5 13.4 36C4.7 358.5 0 370.5 0 384c0 66.7 114.6 96 256 96s256-29.3 256-96c0-13.5-4.7-25.5-13.4-36 8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36s-4.7-25.5-13.4-36c8.7-10.5 13.4-22.5 13.4-36 0-9.5-2.3-18.3-6.7-26.3-5.8 12.1-14.3 21.6-22.2 28.3-1.2 1-2.5 2.1-3.7 3.1-2.7 10.6-14.7 24.8-52.6 37.6z"
        }
    ]
};

const FalPanelEws = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPanelEws",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v225.6c36.5 7.4 64 39.7 64 78.4v16c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h-16c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-16v32c0 35.3-28.7 64-64 64s-64-28.7-64-64v-16c0-20.9-13.4-38.7-32-45.3V448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h384c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-192 64h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm192 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-96 176v-64h-64v64h64zm112-64v160h64V256h-64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v160c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V256z"
        }
    ]
};

const FalPanelFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPanelFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h250.4c6.6 11.4 14.4 22.2 23.2 32H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v32.2c-11.1-1-22.6 1.9-32 8.8V96c0-17.7-14.3-32-32-32zm-56.8 175.5c-2.3.4-4.7.5-7.2.5H128c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h192c26.5 0 48 21.5 48 48v24.9c-15.5 17.9-29.3 36.3-40.8 54.5zM112 280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm96 0a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-96-120v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H128c-8.8 0-16 7.2-16 16zm397.4 93.3c-9.6.1-18.8-4.1-25-11.5-12.9-15.5-26.5-30-40.8-43.7-26.1 25-48 52.3-64 78.1-18.2 29.6-27.6 57.9-27.6 75.8 0 70.3 56.2 127.8 128 127.8 71 0 128-57.6 128-127.8 0-12.8-7-38.2-20.6-64.3-10.9-21.1-25.4-42.6-41.8-60.5-3.8 4.4-7.7 9.1-11.6 14-6 7.5-15.1 12-24.7 12.1zM487.5 197c7.4 7.9 14.5 16 21.5 24.4 6.4-8.1 13.6-16.8 21.2-24.5 1.7-1.7 3.5-3.4 5.2-5 5.6-5.1 14.4-5.1 20 0 24.7 22.7 45.6 52.7 60.4 81.1 14.5 28 24.2 58.8 24.2 79 0 87.8-71.3 159.8-160 159.8-89.7 0-160-72.1-160-159.8 0-26.4 12.7-60.7 32.4-92.6 20-32.4 48.1-66.1 81.4-95.8 2.8-2.5 6.4-3.8 10-3.7 3.5 0 7 1.3 9.8 3.8 11.8 10.6 23.1 21.7 34 33.4zM445 255.9c4.8 0 9.4 2.2 12.4 6 2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1v.1c21.3 39.3 12.3 90.4-25 116.5l-.3.2c-17.5 11.7-36.6 17.7-57.9 17.7-25.9 0-50.2-8.4-68.2-24.8-18.2-16.6-28.8-40.5-28.8-69.2 0-15.7 5-29.7 13.4-44.2 8.2-14.1 20.2-29.5 35.1-47.9 3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1l12.6-9.9-12.6 9.9-.1-.2-.5-.6-1.8-2.4-6.6-8.5-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2-6.6 11.3-9.1 19.8-9.1 28.1 0 20.3 7.3 35.4 18.4 45.6 11.3 10.3 27.5 16.4 46.6 16.4 14.7 0 27.6-4 40-12.2 20.1-14.2 27.8-41.8 18.9-66.5z"
        }
    ]
};

const FalPanorama = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPanorama",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M45.6 64C38.1 64 32 70.1 32 77.6v356.8c0 7.5 6.1 13.6 13.6 13.6 1.6 0 3-.2 4.5-.7 2.5-.8 7.1-2.3 13.6-4.3l3.4-4.6 131.3-174.9c12.8-17.1 38.4-17.1 51.2 0L280 304l78.4-104.5c12.8-17.1 38.4-17.1 51.2 0l179.2 238.9 7.1 9.5c6.8-.8 12.1-6.5 12.1-13.5V77.6c0-7.5-6.1-13.6-13.6-13.6-1.6 0-3 .2-4.5.7C573.6 70.2 467.1 104 320 104S66.4 70.2 50.2 64.7c-1.5-.5-3-.7-4.5-.7zm500.5 370.9L384 218.7l-91.2 121.6-53.3 71.1c25.1-2.1 52-3.4 80.5-3.4 98.6 0 179 15.2 226.1 26.9zm-350.1-19 64-85.3-36-48-110.7 147.7c22.7-5 50.6-10.2 82.8-14.4zM60.4 477.6c-4.7 1.6-9.7 2.4-14.7 2.4C20.4 480 0 459.6 0 434.4V77.6C0 52.4 20.4 32 45.6 32c5.1 0 10 .8 14.7 2.4C74.6 39.2 177.6 72 320 72s245.4-32.8 259.6-37.6c4.7-1.6 9.7-2.4 14.7-2.4 25.3 0 45.7 20.4 45.7 45.6v356.8c0 25.2-20.4 45.6-45.6 45.6-5 0-10-.8-14.7-2.4C565.4 472.8 462.4 440 320 440S74.6 472.8 60.4 477.6zM112 184a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalPaperPlaneTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaperPlaneTop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M3.4 78.3c-6-12-3.9-26.5 5.3-36.3s23.5-12.7 35.9-7.5l448 192c11.8 5 19.4 16.6 19.4 29.4s-7.6 24.4-19.4 29.4l-448 192c-12.3 5.3-26.7 2.3-35.9-7.5s-11.3-24.3-5.3-36.3L92.2 256 3.4 78.3zM120 272 32 448l410.7-176H120zm322.7-32L32 64l88 176h322.7z"
        }
    ]
};

const FalPaperPlane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaperPlane",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M511.6 36.9c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256C5.5 266.3-.7 277.8.1 290s8.4 22.9 19.6 27.6L160 376v93c0 23.8 19.3 43 43 43 13.1 0 25.4-5.9 33.6-16.1l52.8-66h.1l114.2 47.6c9.1 3.8 19.4 3.2 28-1.6s14.5-13.3 16-23l64-416zm-253 380.2-47 58.8c-2.1 2.6-5.3 4.1-8.6 4.1-6.1 0-11-4.9-11-11v-79.7l66.6 27.8zm43.1-16.7-96.6-40.3 269-289.6L416 448l-114.2-47.6zM450.5 48.8 173.6 347 32 288 450.5 48.8z"
        }
    ]
};

const FalPaperclipVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaperclipVertical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c0-53 43-96 96-96s96 43 96 96v256c0 35.3-28.7 64-64 64s-64-28.7-64-64V144c0-8.8 7.2-16 16-16s16 7.2 16 16v208c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-35.3-28.7-64-64-64S96 60.7 96 96v288c0 53 43 96 96 96s96-43 96-96V144c0-8.8 7.2-16 16-16s16 7.2 16 16v240c0 70.7-57.3 128-128 128S64 454.7 64 384V96z"
        }
    ]
};

const FalPaperclip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaperclip",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M380.7 67.3c-29.1-29.1-76.3-29.1-105.4 0l-192 192c-46.8 46.8-46.8 122.6 0 169.4s122.6 46.8 169.4 0l152-152c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-152 152c-59.3 59.3-155.4 59.3-214.6 0S1.4 296 60.7 236.7l192-192c41.6-41.6 109-41.6 150.6 0s41.6 109 0 150.6L219.5 379.1c-28.2 28.2-74.6 25.6-99.6-5.5-21.3-26.6-19.2-65 4.9-89.1l151.9-151.8c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L147.5 307.1c-12.6 12.6-13.7 32.6-2.6 46.5 13 16.2 37.2 17.6 51.9 2.9l183.9-183.8c29.1-29.1 29.1-76.3 0-105.4z"
        }
    ]
};

const FalParachuteBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalParachuteBox",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256.1 0h-.1C86.6 0 8.7 114.4.7 208c-.8 8.8 6.5 16 15.3 16h33.1L165 346.7c-3.2 6.4-5 13.7-5 21.3v96c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48v-96c0-7.7-1.8-14.9-5-21.3L462.9 224H496c8.8 0 16.1-7.2 15.3-16-8-93.6-85.8-208-255.2-208zm162.8 224-94.8 100.4c-6.1-2.8-12.9-4.4-20.1-4.4h-32v-96h146.8zM240 224v96h-32c-7.2 0-14 1.6-20.1 4.4L93.1 224H240zm0 128h64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h32zM35.2 192C46.4 135.7 86.8 73.5 165.5 46.2c-29.9 35-50 87-53.1 145.8H35.2zM180.5 79.1C202.5 47.4 229.7 32 256 32s53.5 15.4 75.5 47.1c19.6 28.3 33.4 67.8 36 112.9h-223c2.7-45.1 16.4-84.5 36-112.9zM476.8 192h-77.2c-3.1-58.8-23.1-110.8-53.1-145.8 78.7 27.3 119.1 89.5 130.3 145.8z"
        }
    ]
};

const FalParagraphLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalParagraphLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H144C82.1 0 32 50.1 32 112s50.1 112 112 112h48v80c0 8.8 7.2 16 16 16s16-7.2 16-16V32h64v272c0 8.8 7.2 16 16 16s16-7.2 16-16V32zm-128 0v160h-48c-44.2 0-80-35.8-80-80s35.8-80 80-80h48zm-69.8 316.3c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2l-96 80C2.1 406.7 0 411.3 0 416s2.1 9.3 5.8 12.3l96 80c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5L60.2 432H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H60.2l62.1-51.7z"
        }
    ]
};

const FalParagraph = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalParagraph",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 192c0-88.4 71.6-160 160-160h240c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v400c0 8.8-7.2 16-16 16s-16-7.2-16-16V64h-64v400c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h-64c-88.4 0-160-71.6-160-160zm224 128V64h-64c-70.7 0-128 57.3-128 128s57.3 128 128 128h64z"
        }
    ]
};

const FalPartyBell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPartyBell",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 224c0-106 86-192 192-192 30.3 0 59 7 84.5 19.6 7.1 3.5 11.5 11 11.5 19.1 0 6-2.4 11.7-6.6 15.9L86.6 313.4c-4.2 4.2-9.9 6.6-15.9 6.6-8.1 0-15.6-4.3-19.1-11.5C39 283 32 254.3 32 224zM224 0C100.3 0 0 100.3 0 224c0 35.3 8.2 68.9 22.8 98.7 9.5 19.2 28.9 29.3 47.9 29.3 14.5 0 28.3-5.7 38.5-16L336 109.2c10.2-10.2 16-24.1 16-38.5 0-19-10.1-38.4-29.3-47.8C292.9 8.2 259.3 0 224 0zm256 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM352 504a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM40 480a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm324.7-307.3c-6.2 6.2-6.2 16.4 0 22.6l8.3 8.3c23.1 23.1 53.4 37.7 85.9 41.3l27.4 3c8.8 1 16.7-5.4 17.7-14.1s-5.4-16.7-14.1-17.7l-27.4-3c-25.3-2.8-48.8-14.1-66.8-32.1l-8.2-8.3c-6.2-6.2-16.4-6.2-22.6 0zm-169.4 192c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l8.3 8.2c18 18 29.3 41.6 32.1 66.8l3 27.4c1 8.8 8.9 15.1 17.7 14.1s15.1-8.9 14.1-17.7l-3-27.4c-3.6-32.5-18.2-62.8-41.3-85.9l-8.3-8.3zm303 135.5c6.7-5.7 7.6-15.8 1.9-22.6l-8.5-10c-6.2-7.3-9.4-16.6-9.2-26.1 1-38.2-28.5-70.4-66.6-72.6l-30-1.8c-20.9-1.2-37.1-18.8-36.5-39.8.5-17.4-5.5-34.4-16.7-47.7l-8.5-10c-5.7-6.7-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5l8.5 10c6.2 7.3 9.4 16.6 9.2 26.1-1 38.2 28.5 70.4 66.6 72.6l30 1.8c20.9 1.2 37.1 18.8 36.5 39.8-.5 17.4 5.5 34.4 16.7 47.7l8.5 10c5.7 6.7 15.8 7.6 22.6 1.9z"
        }
    ]
};

const FalPartyHorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPartyHorn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40 32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm416 128a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM172.7 147.3c-6.2-6.2-6.2-16.4 0-22.6l8.3-8.3c18-18 29.3-41.6 32.1-66.8l3-27.4c1-8.8 8.9-15.1 17.7-14.1s15.1 8.9 14.1 17.7l-3 27.4c-3.6 32.5-18.2 62.8-41.3 85.9l-8.3 8.3c-6.2 6.2-16.4 6.2-22.6 0zm192 169.4 8.3-8.3c23.1-23.1 53.4-37.7 85.9-41.3l27.4-3c8.8-1 16.7 5.4 17.7 14.1s-5.4 16.7-14.1 17.7l-27.4 3c-25.3 2.8-48.8 14.1-66.8 32.1l-8.2 8.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm135.5-303c5.7 6.7 4.9 16.8-1.9 22.5l-10 8.5c-13.3 11.2-30.2 17.2-47.6 16.7-21-.6-38.6 15.6-39.8 36.5l-1.8 30c-2.2 38.2-34.4 67.7-72.6 66.6-9.5-.3-18.8 3-26.1 9.2l-10 8.5c-6.7 5.7-16.8 4.9-22.5-1.9s-4.9-16.8 1.9-22.5l10-8.5c13.3-11.2 30.3-17.2 47.7-16.7 21 .6 38.6-15.6 39.8-36.5l1.8-30c2.2-38.2 34.4-67.7 72.6-66.6 9.5.3 18.8-3 26.1-9.2l10-8.5c6.7-5.7 16.8-4.9 22.6 1.9zM32.1 479.6l.1.1.1.1 76.2-28.6-47.8-47.8-28.6 76.2zm169.6-63.2L95.6 310.3 73 370.7c.8.6 1.6 1.2 2.3 1.9l64 64c.7.7 1.4 1.5 2 2.4l60.5-22.7zm33-12.4 53.3-20c0-.1 0-.1.1-.2s0-.1 0-.2L128.3 224h-.4l-20 53.3L234.7 404zM98.1 212.6c8-21.4 36.4-27.6 52.6-11.4l160.2 160.1c16.2 16.2 10 44.6-11.4 52.6L43.3 510C18 519.4-7.4 494 2 468.8l96.1-256.2z"
        }
    ]
};

const FalPassport = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPassport",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h320zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm32 400c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm33.3-192h39.1c1.6 30.4 7.7 53.8 14.6 70.8-27.9-13.2-48.4-39.4-53.7-70.8zm94.7 80h-.3c-2.4-3.5-5.7-8.9-9.1-16.5-6-13.6-12.4-34.3-14.2-63.5h47.1c-1.8 29.2-8.1 49.9-14.2 63.5-3.4 7.6-6.7 13-9.1 16.5h-.3zm94.7-80c-5.3 31.4-25.8 57.6-53.7 70.8 6.8-17.1 12.9-40.4 14.6-70.8h39.1zm0-32h-39.1c-1.6-30.4-7.7-53.8-14.6-70.8 27.9 13.2 48.4 39.4 53.7 70.8zM224 96h.3c2.4 3.5 5.7 8.9 9.1 16.5 6 13.6 12.4 34.3 14.2 63.5h-47.1c1.8-29.2 8.1-49.9 14.2-63.5 3.4-7.6 6.7-13 9.1-16.5h.3zm-94.7 80c5.3-31.4 25.8-57.6 53.7-70.8-6.8 17.1-12.9 40.4-14.6 70.8h-39.1zM224 320a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
        }
    ]
};

const FalPaste = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaste",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c11.6 0 21.3 8.2 23.5 19.2 1.5 7.4 8.1 12.8 15.7 12.8h8.8c8.8 0 16 7.2 16 16v16H96V80c0-8.8 7.2-16 16-16h8.8c7.6 0 14.2-5.4 15.7-12.8 2.2-11 11.9-19.2 23.5-19.2zM64 64h2.7C65 69 64 74.4 64 80v16c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V80c0-5.6-1-11-2.7-16h2.7c17.7 0 32 14.3 32 32h32c0-35.3-28.7-64-64-64h-45.4c-9-18.9-28.3-32-50.6-32s-41.6 13.1-50.6 32H64C28.7 32 0 60.7 0 96v288c0 35.3 28.7 64 64 64h128v-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm224 416c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h96v56c0 22.1 17.9 40 40 40h56v192c0 17.7-14.3 32-32 32H288zm128-314.7 58.7 58.7H424c-4.4 0-8-3.6-8-8v-50.7zM448 512c35.3 0 64-28.7 64-64V235.9c0-12.7-5.1-24.9-14.1-33.9L438 142.1c-9-9-21.2-14.1-33.9-14.1H288c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h160z"
        }
    ]
};

const FalPause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPause",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 96c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16H48zM0 112c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112zm224-16c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16V112c0-8.8-7.2-16-16-16h-48zm-48 16c0-26.5 21.5-48 48-48h48c26.5 0 48 21.5 48 48v288c0 26.5-21.5 48-48 48h-48c-26.5 0-48-21.5-48-48V112z"
        }
    ]
};

const FalPawClaws = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPawClaws",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M313.7 8.8c-4 7.9-.7 17.5 7.2 21.5 8.5 4.2 21.6 15.4 31.8 34-30-3.5-62.2 21.7-75.2 60.5-14.3 42.9.3 86.2 32.6 96.8s70.1-15.6 84.4-58.5c4-11.9 5.7-23.9 5.5-35.1 0-69.9-37.9-112.8-64.8-126.3-7.9-4-17.5-.7-21.5 7.2zM307.9 135c5.2-15.5 14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1s4 24.7-1.2 40.2-14.2 26.8-23.3 33.1-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1s-4-24.7 1.2-40.2zm-102.5 40.2c-3.5 10.3-9 14.6-13.4 16.1-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1 4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1 4.7 29.9 1.2 40.2zm-3.5 46.5c32.3-10.6 46.9-53.9 32.6-96.8-13-38.8-45.2-64-75.2-60.5 10.2-18.6 23.3-29.8 31.8-34 7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2C149.9 15.2 112 58.1 112 128c-.2 11.3 1.5 23.2 5.5 35.1 14.3 42.9 52.1 69.1 84.4 58.5zm-122.1 54c-.9 7.6-3.9 10.4-5.5 11.3-1.6.9-5.7 2.2-13-.9s-15.7-9.9-22-20.7-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3 1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7 8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1-14.5-25-38.7-39.5-60.2-38.6 10.4-28.1 28.3-44.4 39-49.7 7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2C37.9 127.2 0 170.1 0 240c-.1 13.3 3.7 27.8 11.6 41.4 18.9 32.4 54 47.3 78.5 33.3zM256 288c25.7 0 108.2 25.4 156.8 156.3 2.1 5.7 3.2 12.2 3.2 19.4v4.4c0 6.6-5.3 11.9-11.9 11.9-10.1 0-20.1-1.5-29.7-4.5l-80.2-25.1c-24.9-7.8-51.5-7.8-76.4 0l-80.2 25.1c-9.6 3-19.7 4.5-29.7 4.5-6.6 0-11.9-5.3-11.9-11.9v-4.4c0-7.1 1.1-13.7 3.2-19.4C147.8 313.4 230.3 288 256 288zm0-32c-41.3 0-134.4 35.9-186.8 177.2-3.6 9.7-5.2 20.1-5.2 30.5v4.4c0 24.2 19.7 43.9 43.9 43.9 13.3 0 26.6-2 39.3-6l80.2-25.1c18.6-5.8 38.6-5.8 57.3 0l80.1 25.1c12.7 4 26 6 39.3 6 24.2 0 43.9-19.7 43.9-43.9v-4.4c0-10.4-1.6-20.7-5.2-30.5C390.4 291.9 297.3 256 256 256zm183.3-9.3c6.3-10.8 14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6.9 4.6 3.7 5.5 11.3.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3-.9-7.7.8-18.2 7-29zm-27.7-16.1c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3c7.9-13.6 11.7-28.1 11.6-41.4 0-69.9-37.9-112.8-64.8-126.3-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5c10.7 5.3 28.6 21.6 39 49.7-21.5-1-45.7 13.6-60.2 38.5z"
        }
    ]
};

const FalPawSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPawSimple",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M152 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm31.2 73.2c7.7-15.5 23.5-25.2 40.8-25.2s33.1 9.8 40.8 25.2l33.8 67.5c8.3 16.5 23.1 25.9 36.8 30 28.1 8.4 48.6 34.4 48.6 65.2 0 37.6-30.4 68-68 68-14.4 0-27.7-4.5-38.7-12.1-16-11.1-36.5-14.7-53.3-14.7s-37.3 3.6-53.3 14.7c-11 7.6-24.3 12.1-38.7 12.1-37.6 0-68-30.4-68-68 0-30.8 20.4-56.8 48.6-65.2 13.7-4.1 28.6-13.5 36.8-30l33.8-67.5zm-62.4 53.2c-3.4 6.9-10 11.5-17.3 13.7C62.1 296.4 32 334.7 32 380c0 55.2 44.8 100 100 100 21.2 0 40.8-6.6 56.9-17.8 17.4-12 52.8-12 70.1 0 16.2 11.2 35.8 17.8 57 17.8 55.2 0 100-44.8 100-100 0-45.3-30.1-83.6-71.4-95.9-7.4-2.2-13.9-6.8-17.3-13.7l-33.8-67.5c-13.2-26.3-40-42.9-69.5-42.9s-56.3 16.6-69.5 42.9l-33.8 67.5zM272 88a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm40 88a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM32 200a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0z"
        }
    ]
};

const FalPaw = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPaw",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M197.4 143.2c-3.5 10.3-9 14.6-13.4 16.1-4.5 1.5-11.7 1.2-20.8-5.1s-18.2-17.6-23.3-33.1-4.7-29.9-1.2-40.2c3.5-10.3 9-14.6 13.4-16.1 4.5-1.5 11.7-1.2 20.8 5.1s18.2 17.6 23.3 33.1 4.7 29.9 1.2 40.2zm-3.5 46.5c32.3-10.6 46.9-53.9 32.6-96.8s-52.1-69.1-84.4-58.6-46.9 53.9-32.6 96.8 52.1 69.1 84.4 58.5zm-114.1 54c-.9 7.6-3.9 10.4-5.5 11.3-1.6.9-5.7 2.2-13-.9s-15.7-9.9-22-20.7-8-21.4-7-29c.9-7.6 3.9-10.4 5.5-11.3 1.6-.9 5.7-2.2 13 .9s15.7 9.9 22 20.7 8 21.4 7 29zm10.4 39c24.5-14 29.1-51.7 10.2-84.1s-54-47.3-78.5-33.3-29.1 51.7-10.2 84.1 54 47.3 78.5 33.3zM256 256c25.7 0 108.2 25.4 156.8 156.3 2.1 5.7 3.2 12.2 3.2 19.4v4.4c0 6.6-5.3 11.9-11.9 11.9-10.1 0-20.1-1.5-29.7-4.5l-80.2-25.1c-24.9-7.8-51.5-7.8-76.4 0l-80.2 25.1c-9.6 3-19.7 4.5-29.7 4.5-6.6 0-11.9-5.3-11.9-11.9v-4.4c0-7.1 1.1-13.7 3.2-19.4C147.8 281.4 230.3 256 256 256zm0-32c-41.3 0-134.4 35.9-186.8 177.2-3.6 9.7-5.2 20.1-5.2 30.5v4.4c0 24.2 19.7 43.9 43.9 43.9 13.3 0 26.6-2 39.3-6l80.2-25.1c18.6-5.8 38.6-5.8 57.3 0l80.1 25.1c12.7 4 26 6 39.3 6 24.2 0 43.9-19.7 43.9-43.9v-4.4c0-10.4-1.6-20.8-5.2-30.5C390.4 259.9 297.3 224 256 224zm183.3-9.3c6.3-10.8 14.7-17.6 22-20.7s11.4-1.8 13-.9c1.6.9 4.6 3.7 5.5 11.3.9 7.7-.8 18.2-7 29s-14.7 17.6-22 20.7-11.4 1.8-13 .9c-1.6-.9-4.6-3.7-5.5-11.3-.9-7.7.8-18.2 7-29zm-27.7-16.1c-18.9 32.4-14.3 70.1 10.2 84.1s59.7-.9 78.5-33.3 14.3-70.1-10.2-84.1-59.7.9-78.5 33.3zM307.9 103c5.2-15.5 14.2-26.8 23.3-33.1s16.3-6.6 20.8-5.1c4.4 1.5 9.9 5.8 13.4 16.1s4 24.7-1.2 40.2-14.2 26.8-23.3 33.1-16.3 6.6-20.8 5.1c-4.4-1.5-9.9-5.8-13.4-16.1s-4-24.7 1.2-40.2zm-30.4-10.1c-14.3 42.9.3 86.2 32.6 96.8s70.1-15.6 84.4-58.5-.3-86.2-32.6-96.8-70.1 15.6-84.4 58.5z"
        }
    ]
};

const FalPeace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeace",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 479.4V289.8L93.2 409.9c37.4 39.6 89.1 65.5 146.8 69.6zM72.9 385.1 240 248.4V32.6C123.8 40.8 32 137.7 32 256c0 48.1 15.1 92.6 40.9 129.1zM256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm16-32.6c57.7-4.1 109.4-30 146.8-69.6L272 289.8v189.6zm167.1-94.3c25.8-36.5 40.9-81 40.9-129.1 0-118.3-91.8-215.2-208-223.4v215.8l167.1 136.7z"
        }
    ]
};

const FalPeach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeach",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 0c-26.5 0-48 21.5-48 48 0 17 3.8 33.1 10.6 47.5 9.9-4.1 20.1-7.5 30.7-10.1-5.9-11.1-9.3-23.9-9.3-37.4 0-8.8 7.2-16 16-16h32c37.2 0 68.5 25.4 77.4 59.9 12.1 2.8 25 2.8 37.1 0 9-34.5 40.3-59.9 77.5-59.9h32c8.8 0 16 7.2 16 16 0 13.5-3.4 26.3-9.3 37.5 10.6 2.5 20.9 5.9 30.7 10.1C428.2 81.1 432 65 432 48c0-26.5-21.5-48-48-48h-32c-40.7 0-76.4 21.8-96 54.3C236.4 21.8 200.7 0 160 0h-32zm40 144c69.7 0 127.2 52.4 135.1 120 1 8.8 8.1 16 16.9 16s16.1-7.2 15.2-16c-4-42.8-24.1-80.9-54.1-108.2 6.9-1.2 13.8-2.9 20.5-5.1 13.3-4.4 27.5-6.7 42.4-6.7 75.1 0 136 60.9 136 136 0 51.7-38.2 97-91.1 134-51.5 36.1-108.6 58.2-128.2 65.3-1.1.4-2.6.7-4.7.7s-3.5-.3-4.7-.7c-19.6-7-76.7-29.2-128.2-65.3C70.2 377 32 331.7 32 280c0-75.1 60.9-136 136-136zm123.7-23.7c-23 7.5-48.4 7.5-71.4 0-16.5-5.4-34-8.3-52.3-8.3C75.2 112 0 187.2 0 280c0 136.2 199.3 214.6 240.6 229.4 5 1.8 10.1 2.6 15.4 2.6s10.4-.8 15.4-2.6C312.7 494.6 512 416.2 512 280c0-92.8-75.2-168-168-168-18.3 0-35.9 2.9-52.3 8.3z"
        }
    ]
};

const FalPeanut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeanut",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M127.1 249.9h.4c25.9-5.1 58.5-14.4 83.1-39s33.9-57.2 39-83.1v-.4c1.5-8.2 3.8-16 6.9-23.5 5.5-13.4 13.7-26 24.5-37C302.4 45.2 331.6 32 364 32h68c26.5 0 48 21.5 48 48v68c0 15.8-3.1 30.8-8.8 44.4-5.6 13.6-14 26.4-25.2 37.6-11.2 11.2-24 19.6-37.7 25.2-7.5 3.1-15.3 5.4-23.5 6.9h-.4c-25.9 5.1-58.5 14.4-83.1 39s-33.9 57.2-39 83.1v.4c-1.5 8.2-3.8 16-6.9 23.5-5.5 13.4-13.7 26-24.5 37-21.3 21.7-50.5 34.9-82.9 34.9H80c-26.5 0-48-21.5-48-48v-68c0-15.8 3.1-30.8 8.8-44.4 5.6-13.6 14-26.4 25.2-37.6 11.2-11.2 24-19.6 37.7-25.2 7.5-3.1 15.3-5.4 23.5-6.9zM148 512c41.3 0 78.7-16.9 105.5-44.2 13.8-14 24.2-30.1 31.3-47.2 4-9.5 6.9-19.6 8.8-30 4.8-24.5 12.6-49.1 30.3-66.7s42.2-25.4 66.7-30.3c10.4-1.9 20.5-4.9 30-8.8 17.5-7.2 33.9-17.9 48.1-32.1 14.2-14.2 24.9-30.5 32.1-48C508 187.2 512 168.1 512 148V80c0-44.2-35.8-80-80-80h-68c-41.3 0-78.7 16.9-105.5 44.2-13.8 14-24.2 30.1-31.3 47.2-4 9.5-6.9 19.6-8.8 30-4.8 24.5-12.6 49.1-30.3 66.7s-42.2 25.4-66.7 30.3c-10.4 1.9-20.5 4.9-30 8.8-17.5 7.2-33.9 17.9-48.1 32.1-14.2 14.2-24.9 30.5-32.1 48C4 324.8 0 343.9 0 364v68c0 44.2 35.8 80 80 80h68zm287.2-384a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0zm-64 64a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0zm-224 224a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0zm44.8 19.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4zM435.2 192a19.2 19.2 0 1 0-38.4 0 19.2 19.2 0 1 0 38.4 0zM192 371.2a19.2 19.2 0 1 0 0-38.4 19.2 19.2 0 1 0 0 38.4z"
        }
    ]
};

const FalPeanuts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeanuts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M297.7 160.7c4.7-18.7 3.4-38.9-5.1-57.9l-22.7-50.9c-7.5-16.9-27.4-24.5-44.3-17l-50.9 22.7c-11.1 4.9-20.7 11.8-28.5 20.1-7.8 8.2-14.2 18-18.5 29.3l-.1.4a88.77 88.77 0 0 0-5.8 34.1c.2 6.2 1 12.5 2.5 18.7l.1.2.1.2c4.9 21.3 9.1 50.3-1.8 78.6s-33.4 47-51.3 59.6l-.2.1-.2.1c-5.3 3.6-10.1 7.7-14.3 12.2-7.8 8.2-14.2 18.1-18.6 29.5-4.4 11.4-6.2 23-5.9 34.3.3 11.3 2.8 22.9 7.7 34l22.7 50.9c7.4 16.6 26.5 24.2 43.2 17.5 4.4 10 10.3 19.2 17.3 27.3l-3.2 1.4c-33.1 14.7-71.8-.2-86.6-33.2l-22.8-50.7C3.8 407.2.4 391.5 0 376c-.4-15.5 2.2-31.3 8-46.6 6-15.4 14.7-28.9 25.4-40.1 5.8-6.1 12.3-11.7 19.5-16.6 16.7-11.8 32.5-25.8 39.8-44.9s5-40.1.4-60c-2.1-8.4-3.2-17-3.4-25.4-.4-15.4 2.1-31.1 7.9-46.4l.2-.5c5.9-15.3 14.5-28.7 25.2-39.9s23.6-20.6 38.7-27.3l50.9-22.6c33.1-14.7 71.8.1 86.6 33.2l22.5 50.6c-2.9 8.4-5.1 17.1-6.7 26-3.9 19.7-9.2 34.7-17.3 45.3zm-42.3 89.1h-.2c-8.2 1.5-16 3.8-23.5 6.9-13.7 5.6-26.5 14-37.7 25.2-11.2 11.2-19.5 24-25.2 37.6-5.7 13.6-8.8 28.6-8.8 44.4v68c0 26.5 21.5 48 48 48h68c32.4 0 61.6-13.2 82.7-34.6 10.8-11 19-23.6 24.5-37 3.1-7.5 5.4-15.3 6.9-23.5v-.4c5.1-25.9 14.4-58.5 39-83.1s57.2-33.9 83.1-39h.4c8.2-1.5 16-3.8 23.5-6.9 13.7-5.6 26.5-14 37.7-25.2 11.2-11.2 19.5-24 25.2-37.6 5.7-13.6 8.8-28.6 8.8-44.4V80c0-26.5-21.5-48-48-48H492c-32.4 0-61.6 13.2-82.7 34.6-10.8 11-19 23.6-24.5 37-3.1 7.5-5.4 15.3-6.9 23.5v.2l-.1.2c-5.1 25.9-14.4 58.5-39 83.1s-57.2 33.9-83.1 39h-.2zm126.1 218C354.7 495.1 317.3 512 276 512h-68c-44.2 0-80-35.8-80-80v-68c0-20.1 4-39.2 11.2-56.7 7.2-17.5 17.9-33.8 32.1-48 14.2-14.2 30.6-24.9 48.1-32.1 9.5-4 19.6-6.9 30-8.8 24.5-4.8 49.1-12.6 66.7-30.3s25.4-42.2 30.3-66.7c1.9-10.4 4.9-20.5 8.8-30 7.1-17.1 17.5-33.2 31.3-47.2C413.3 16.9 450.7 0 492 0h68c44.2 0 80 35.8 80 80v68c0 20.1-4 39.2-11.2 56.7-7.2 17.5-17.9 33.8-32.1 48-14.2 14.2-30.6 24.9-48.1 32.1-9.5 4-19.6 6.9-30 8.8-24.5 4.8-49.1 12.6-66.7 30.3s-25.4 42.2-30.3 66.7c-1.9 10.4-4.9 20.5-8.8 30-7.1 17.1-17.5 33.2-31.3 47.2zm162.5-359a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-64 64a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm-224 224a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zm44.8 19.2a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0zM544 172.8a19.2 19.2 0 1 1 0 38.4 19.2 19.2 0 1 1 0-38.4zM300.8 352a19.2 19.2 0 1 1 38.4 0 19.2 19.2 0 1 1-38.4 0z"
        }
    ]
};

const FalPeapod = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeapod",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 32C203.9 32 32 203.9 32 416v48c0 8.8 7.2 16 16 16h48c212.1 0 384-171.9 384-384V48c0-8.8-7.2-16-16-16h-48zm0-32h48c26.5 0 48 21.5 48 48v48c0 229.8-186.2 416-416 416H48c-26.5 0-48-21.5-48-48v-48C0 186.2 186.2 0 416 0zm-48 112a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1-128 0 64 64 0 1 1 128 0zM224 256a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-144 48a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128z"
        }
    ]
};

const FalPear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPear",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-54.2 54.2C470 103.2 480 130.4 480 160c0 30.7-10.8 58.9-28.9 81-29.9 36.5-61.4 81.8-73.3 127.4-8.3 32-25 62.3-50.1 87.3-75 75-196.5 75-271.5 0s-75-196.5 0-271.5c25.1-25.1 55.3-41.8 87.3-50.1 45.7-11.8 90.9-43.4 127.4-73.3 22.1-18 50.3-28.9 81-28.9 29.6 0 56.8 10 78.5 26.9l54.3-54.1c6.2-6.2 16.4-6.2 22.6 0zm-118.6 96 18.9-18.9C391.9 70.6 372.7 64 352 64c-23.1 0-44.2 8.1-60.7 21.6-37.1 30.3-86.9 65.8-139.7 79.5-26.6 6.9-51.8 20.8-72.8 41.7-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c20.9-20.9 34.8-46.1 41.7-72.8 13.7-52.8 49.2-102.6 79.5-139.7 13.6-16.4 21.7-37.5 21.7-60.6 0-20.7-6.6-39.9-17.7-55.6l-18.9 18.9c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM304 336c0 53-43 96-96 96-8.8 0-16-7.2-16-16s7.2-16 16-16c35.3 0 64-28.7 64-64 0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalPedestal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPedestal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32H96c-17.7 0-32 14.3-32 32v384H32V64C32 28.7 60.7 0 96 0h256c35.3 0 64 28.7 64 64v384h-32V64c0-17.7-14.3-32-32-32zM16 480h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96-384a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm208-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalPegasus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPegasus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M333 153.3c1.1-1.5 1.9-3.3 2.5-5.2.4-1.4.6-2.9.5-4.4C336.1 82 386.2 32 448 32h37.8c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1h-32c-8.8 0-16 7.2-16 16v52.8c-.3 1.5-.4 3-.3 4.5.2 2.2.3 4.4.3 6.7 0 24-10.4 45.1-26.7 59.6-3.4 3-5.3 7.4-5.3 11.9V472c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8V334.7c0-7.8-5.6-14.5-13.3-15.8-1.4-.2-2.8-.5-4.3-.8l-116.2-26.2c-5.2-1.2-10.6.3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7 0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1h-33.3c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9 0-4.6-.9-9.3-2.7-13.5l-33.3-80.1c-2.6-6.2-3.9-12.8-3.9-19.5 0-21.8 13.8-40.5 33.2-47.6-4.4-9.4-8.4-19.3-11.8-29.8-20.4 7.7-37 23.3-46 43.1C31.3 180.8 0 214.7 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-20.9 13.4-38.7 32-45.3 0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2.4.2.8.2 1.2 0 .4-.1.9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3h33.2c26.5 0 45.6-25.2 38.5-50.7L197.4 404c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4l88.2 19.9V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V318.4c19.6-20 32-47.5 32-78.4 0-1.9-.1-3.9-.1-5.8.1-.7.1-1.4.1-2.2v-40h7.4l1.7 2.5c19 28.6 57.4 36.8 86.5 18.6 20.4-12.7 31.8-35.9 29.6-59.9l-7.7-80.8c-1.5-15.5-7.3-29.7-16.3-41.3C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16h-96c-70.6 0-129.3 50.8-141.6 117.8L159.9 34.1c-5-2.8-11-2.8-16 .1s-8 8.1-8 13.8c0 77.2 34.4 132.9 68.3 169 16.9 18 33.9 31.2 46.6 40 6.4 4.4 11.7 7.7 15.5 9.9 1.9 1.1 3.4 2 4.5 2.5.5.3 1 .5 1.3.7l.4.2.1.1 7.2-14.3-7.2 14.3c7.9 4 17.5.7 21.5-7.2s.8-17.5-7.1-21.5l-.2-.1-.9-.5c-.8-.4-2-1.1-3.6-2-3.2-1.8-7.8-4.7-13.5-8.6-11.3-7.8-26.4-19.5-41.4-35.5-25.6-27.2-50.8-66.2-57.8-118.4l142.2 81.2c3 1.7 6.4 2.4 9.6 2 2.3-.2 4.5-1 6.4-2.1s3.6-2.6 5-4.5zM480 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalPenCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm331.5-92.7c-6.2-6.2-16.4-6.2-22.6 0l-21.4 21.4 40 40 21.4-21.4c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zm-149 126.4c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l82.3-82.3-40-40-82.3 82.3zm103.8-149c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L245.1 352.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3l126.4-126.3z"
        }
    ]
};

const FalPenClipSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenClipSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm530.8 145.9c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0l-48.5 48.4-13-13.1c-25-25-65.5-25-90.5 0l-47 47 25.3 20 44.3-44.3c12.5-12.5 32.8-12.5 45.3 0l13.1 13.1-62.8 62.7 25.3 20 60-60.1 84.7 84.7-50.1 50.1 25.3 20 118.5-118.5zM321.8 338.9l-50.9 50.9c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4l40.9-40.9-25.3-20-38.3 38.3c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9.9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l53.5-53.6-25.3-20zm127.6-297c12.5-12.5 32.8-12.5 45.3 0l39.4 39.4c12.5 12.5 12.5 32.8 0 45.3L485.7 175 401 90.3l48.4-48.4z"
        }
    ]
};

const FalPenClip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenClip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M385.4 41.9c12.5-12.5 32.8-12.5 45.3 0l39.4 39.4c12.5 12.5 12.5 32.8 0 45.3L421.7 175 337 90.3l48.4-48.4zm-93.7 48.4L99.5 282.5c-48 48-80.8 109.2-94.1 175.8l-5 25c-1.6 7.9.9 16 6.6 21.7s13.8 8.1 21.7 6.6l25-5c66.6-13.3 127.8-46.1 175.8-94.1l263.2-263.2c25-25 25-65.5 0-90.5l-39.4-39.5c-25-25-65.5-25-90.5 0l-48.5 48.4-13-13.1c-25-25-65.5-25-90.5 0L100.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l110.1-110c12.5-12.5 32.8-12.5 45.3 0l13.1 13.1zm22.6 22.7 84.7 84.7-192.1 192.1c-43.6 43.6-99 73.2-159.4 85.3l-13.2 2.6 2.6-13.2c12.1-60.4 41.8-115.9 85.3-159.4L314.3 113z"
        }
    ]
};

const FalPenFancySlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenFancySlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M548.7 143.7c17.4-15.6 27.3-37.9 27.3-61.3C576 36.9 539.1 0 493.6 0c-23.4 0-45.6 9.9-61.3 27.3L308.2 165.2l25.2 19.8L456.1 48.7c9.6-10.6 23.2-16.7 37.5-16.7 27.8 0 50.4 22.6 50.4 50.4 0 14.3-6.1 27.9-16.7 37.5L398.1 236.1l25.5 20.1 125.1-112.5zM304.2 325 280 403.7c-3 9.9-10.7 17.7-20.5 20.9l-128.3 42.8 67.5-67.4h1.3c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24v1.3l-67.4 67.4 42.8-128.3c3.3-9.8 11.1-17.4 20.9-20.5l68.4-20.9-30.5-24.1-47.3 14.6c-19.8 6.1-35.4 21.3-41.9 40.9L66.9 468.6c-8.3 25 15.5 48.8 40.5 40.5L269.6 455c19.6-6.5 34.9-22.1 40.9-41.9l20.6-66.8-26.9-21.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalPenFancy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenFancy",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M392.1 48.7c9.6-10.6 23.2-16.7 37.5-16.7 27.8 0 50.4 22.6 50.4 50.4 0 14.3-6.1 27.9-16.7 37.5L256.6 306 206 255.4 392.1 48.7zM429.6 0c-23.4 0-45.6 9.9-61.3 27.3L175.1 242l-76.2 23.4c-19.8 6.1-35.4 21.3-41.9 40.9L2.9 468.6c-8.3 25 15.5 48.8 40.5 40.5L205.6 455c19.6-6.5 34.9-22.1 40.9-41.9l23.5-76.2 214.7-193.2c17.4-15.6 27.3-37.9 27.3-61.3C512 36.9 475.1 0 429.6 0zM237.9 332.5 216 403.7c-3 9.9-10.7 17.7-20.5 20.9L67.2 467.4l67.5-67.4h1.3c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24v1.3l-67.4 67.5 42.8-128.3c3.3-9.8 11.1-17.4 20.9-20.5l71.2-21.9 58.4 58.4z"
        }
    ]
};

const FalPenField = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenField",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m582.8 45.5 11.9 11.9c12.5 12.5 12.5 32.8 0 45.2L568 129.4l-57-57 26.4-26.8c12.5-12.6 32.8-12.7 45.4-.1zM346.2 239.2 488.5 95.1l56.9 56.9-143.1 143.2c-4.4 4.4-10 7.4-16.1 8.7l-61.5 12.9 12.9-61.7c1.3-6 4.2-11.5 8.6-15.9zM514.7 23.1 323.4 216.7c-8.6 8.7-14.6 19.8-17.1 31.8l-18 85.7c-1.1 5.3.5 10.8 4.3 14.6s9.3 5.5 14.6 4.3l85.5-17.9c12.2-2.6 23.3-8.6 32.1-17.4l192.6-192.5c25-25 25-65.5 0-90.5l-11.9-12c-25.1-25.1-65.8-25-90.8.3zM64 128c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v176c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h240c8.8 0 16-7.2 16-16s-7.2-16-16-16H64zm64 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalPenLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M429.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L341 94.4l76.6 76.6 54.8-54.8c9.4-9.4 9.4-24.6 0-33.9l-42.6-42.7zM83.1 352.4C75.5 360 70 369.3 67 379.6l-27.4 92.8 92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L395 193.6 318.4 117 83.1 352.4zM373.2 17c21.9-21.9 57.3-21.9 79.2 0L495 59.6c21.9 21.9 21.9 57.3 0 79.2L182.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7.1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L373.2 17zM240 480h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalPenNibSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenNibSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm452.4 228.9 75.1-75.1c25-25 25-65.5 0-90.5l-44.1-44.1c-25-25-65.5-25-90.5 0l-75.1 75.1-80.3 21.9 31.2 24.7 52.6-14.4 98.9 98.9-7.9 28.9 27.3 21.5 12.8-46.9zm-99.3 162c-.5.2-1.1.4-1.7.5l-248 74.5 110.2-110.2c9.5 5.6 20.6 8.9 32.5 8.9 18.7 0 35.6-8 47.3-20.8l-25.3-20c-5.7 5.4-13.5 8.8-22 8.8-17.7 0-32-14.3-32-32 0-5.8 1.6-11.3 4.3-16l-25.2-20c-7 10.2-11.1 22.6-11.1 36 0 11.9 3.2 23 8.9 32.5L106.7 446.7l64.8-216.1-27-21.3-76.6 255.3c-3.7 12.3-.3 25.7 8.8 34.7s22.4 12.5 34.7 8.8l275.2-82.5c7.2-2.2 14-5.3 20.2-9.3l-27.8-22zm62.4-349c12.5-12.5 32.8-12.5 45.3 0l44.1 44.1c12.5 12.5 12.5 32.8 0 45.3L464 201.4 374.6 112l66.7-66.7z"
        }
    ]
};

const FalPenNib = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenNib",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M377.4 45.3 310.6 112l89.4 89.4 66.7-66.7c12.5-12.5 12.5-32.8 0-45.3l-44.1-44.1c-12.5-12.5-32.8-12.5-45.3 0zm-97.7 52.4 75.1-75.1c25-25 65.5-25 90.5 0l44.1 44.1c25 25 25 65.5 0 90.5l-75.1 75.1L376.8 370a80.19 80.19 0 0 1-54.2 55.6L47.4 508.1c-12.3 3.7-25.7.3-34.7-8.8S.2 476.9 3.9 464.6l82.6-275.2c7.9-26.4 28.9-46.9 55.6-54.2l137.6-37.5zm3.6 32.2-132.8 36.2c-16 4.4-28.6 16.6-33.3 32.5L42.7 446.7l110.2-110.2c-5.6-9.5-8.9-20.6-8.9-32.5 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64c-11.9 0-23-3.2-32.5-8.9L65.3 469.3l248.1-74.4c15.9-4.8 28.2-17.4 32.5-33.3l36.2-132.8-98.9-98.9zM208 272a32 32 0 1 0 0 64 32 32 0 1 0 0-64z"
        }
    ]
};

const FalPenPaintbrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenPaintbrush",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320.5 410c4.9 39.5 38.6 70 79.4 70h139.2c-21.2 0-37.5-11.5-47.2-24.9-9.5-13.1-14.2-30-12.5-46.7.3-2.7.4-5.5.4-8.3 0-40.8-30.5-74.5-70-79.4l26.5-26.5c43.9 15.1 75.5 56.8 75.5 105.9 0 3.9-.2 7.8-.6 11.6-1.8 17.5 10.2 36.4 27.8 36.4h4.8c17.7 0 32 14.3 32 32s-14.3 32-32 32h-144c-49.1 0-90.8-31.6-105.9-75.5l26.6-26.6zm-187-186L18.7 109.3c-25-25-25-65.5 0-90.5s65.5-25 90.5 0L224 133.5l-22.6 22.6L86.6 41.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l114.8 114.7-22.6 22.6zM461.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L373 94.4l76.6 76.6 54.8-54.8c9.4-9.4 9.4-24.6 0-33.9l-42.6-42.7zM115.1 352.4c-7.6 7.6-13.1 16.9-16.1 27.2l-27.4 92.8 92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L427 193.6 350.4 117 115.1 352.4zM405.2 17c21.9-21.9 57.3-21.9 79.2 0L527 59.6c21.9 21.9 21.9 57.3 0 79.2L214.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7.1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L405.2 17z"
        }
    ]
};

const FalPenRuler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenRuler",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M429.8 39.6c-9.4-9.4-24.6-9.4-33.9 0L341 94.4l76.6 76.6 54.8-54.8c9.4-9.4 9.4-24.6 0-33.9l-42.6-42.7zM83.1 352.4C75.5 360 70 369.3 67 379.6l-27.4 92.8 92.8-27.3c10.3-3 19.6-8.6 27.2-16.1L395 193.6 318.4 117 83.1 352.4zM373.2 17c21.9-21.9 57.3-21.9 79.2 0L495 59.6c21.9 21.9 21.9 57.3 0 79.2L182.3 451.6c-11.4 11.4-25.4 19.7-40.8 24.2l-121 35.6c-5.6 1.7-11.7.1-15.8-4s-5.7-10.2-4-15.8l35.6-121c4.5-15.4 12.9-29.4 24.2-40.8L373.2 17zM82.7 27.3c25-25 65.5-25 90.5 0l70.9 70.9-22.6 22.6L189.7 89l-34.3 34.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L167 66.3l-16.4-16.4c-12.5-12.5-32.8-12.5-45.3 0l-55.4 55.5c-12.5 12.5-12.5 32.8 0 45.3l70.9 70.9-22.6 22.5-70.9-70.8c-25-25-25-65.5 0-90.5l55.4-55.5zm256 457.4-70.9-70.9 22.6-22.6 70.9 70.9c12.5 12.5 32.8 12.5 45.3 0l55.4-55.4c12.5-12.5 12.5-32.8 0-45.3L445.7 345l-34.3 34.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l34.2-34.4-31.8-31.8 22.6-22.6 70.9 70.9c25 25 25 65.5 0 90.5l-55.4 55.4c-25 25-65.5 25-90.5 0z"
        }
    ]
};

const FalPenSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM559 138.8c21.9-21.9 21.9-57.3 0-79.2L516.4 17c-21.9-21.9-57.3-21.9-79.2 0L297.5 156.7l25.3 20 59.6-59.7 76.6 76.6-50.6 50.6 25.3 20L559 138.8zM317.2 335.4 223.6 429c-7.6 7.6-16.9 13.1-27.2 16.1l-92.8 27.3 27.3-92.8c3-10.3 8.6-19.6 16.1-27.2l84.6-84.6-25.3-20-81.9 81.9c-11.4 11.4-19.7 25.4-24.2 40.8l-35.6 121c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2l96.2-96.2-25.3-20zM459.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L481.6 171 405 94.4l54.8-54.8z"
        }
    ]
};

const FalPenSwirl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenSwirl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M454.8 45.5c-12.6-12.6-32.9-12.5-45.4.1L383 72.4l57 57 26.7-26.8c12.5-12.5 12.5-32.8 0-45.2l-11.9-11.9zM218.2 239.2c-4.3 4.4-7.3 9.9-8.6 15.9l-12.9 61.7 61.5-12.9c6.1-1.3 11.7-4.3 16.1-8.7L417.4 152l-56.9-56.9-142.3 144.1zM386.7 23.1c24.9-25.3 65.7-25.4 90.8-.3l11.9 11.9c25 25 25 65.5 0 90.5L296.9 317.8c-8.8 8.8-20 14.8-32.1 17.4l-85.5 17.9c-5.3 1.1-10.8-.5-14.6-4.3s-5.5-9.3-4.3-14.6l18-85.7c2.5-12 8.5-23.1 17.1-31.8L386.7 23.1zm-85.6 29.8C286.5 49.7 271.5 48 256 48 141.1 48 48 141.1 48 256s93.1 208 208 208c8.8 0 16 7.2 16 16s-7.2 16-16 16C123.5 496 16 388.5 16 256S123.5 16 256 16c24.7 0 48.5 3.7 71 10.7l-25.9 26.2zm184.4 132.8c6.8 22.2 10.5 45.8 10.5 70.3 0 79.5-64.5 144-144 144-12.4 0-24.5-1.6-36-4.5-8.6-2.2-13.7-10.9-11.5-19.5s10.9-13.7 19.5-11.5c8.9 2.3 18.3 3.5 28 3.5 61.9 0 112-50.1 112-112 0-15.1-1.6-29.9-4.7-44.1l26.2-26.2z"
        }
    ]
};

const FalPenToSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPenToSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m454.6 45.3 12.1 12.1c12.5 12.5 12.5 32.8 0 45.3L440 129.4 382.6 72l26.7-26.7c12.5-12.5 32.8-12.5 45.3 0zM189 265.6l171-171 57.4 57.4-171 171c-4.2 4.2-9.6 7.2-15.4 8.6l-65.6 15.1 15.1-65.7c1.3-5.8 4.3-11.2 8.6-15.4zm197.7-243L166.4 243c-8.5 8.5-14.4 19.2-17.1 30.9l-20.9 90.6c-1.2 5.4.4 11 4.3 14.9s9.5 5.5 14.9 4.3l90.6-20.9c11.7-2.7 22.4-8.6 30.9-17.1l220.3-220.4c25-25 25-65.5 0-90.5l-12.1-12.2c-25-25-65.5-25-90.5 0zM80 64C35.8 64 0 99.8 0 144v288c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
        }
    ]
};

const FalPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117l76.6 76.6-235.4 235.3c-7.6 7.6-16.9 13.1-27.2 16.1l-92.8 27.4 27.3-92.8c3-10.3 8.6-19.6 16.1-27.2L318.4 117zm134-100c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17z"
        }
    ]
};

const FalPencilMechanical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPencilMechanical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M440 0c-9.4 0-18.3 3.7-25 10.3l-38.6 38.6c-2.7-.6-5.6-.9-8.4-.9-10.2 0-20.1 4.1-27.3 11.3l-29.4 29.4-29.4-29.4c-18.7-18.7-49.1-18.7-67.9 0L108.7 164.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L236.7 81.9c6.2-6.2 16.4-6.2 22.6 0l29.4 29.4L80.4 319.7c-5.5 5.5-9.6 12.2-11.9 19.6L32 456l.7.7-28 28c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l28-28 .7.7 116.7-36.5c7.4-2.3 14.1-6.4 19.6-11.9l260.4-260.3c7.2-7.2 11.3-17.1 11.3-27.3 0-2.9-.3-5.7-.9-8.4L501.7 97c6.6-6.6 10.3-15.6 10.3-25s-3.7-18.3-10.3-25L465 10.3C458.3 3.7 449.4 0 440 0zm4.7 108.7-41.4-41.4L437.7 33c.6-.6 1.5-1 2.3-1s1.7.3 2.3 1L479 69.7c.6.6 1 1.5 1 2.3s-.3 1.7-1 2.3l-34.3 34.3zm-14.6 30.6c1.2 1.2 1.9 2.9 1.9 4.7s-.7 3.4-1.9 4.7L188.7 390.1 122 323.4 363.3 81.9c1.2-1.2 2.9-1.9 4.7-1.9s3.4.7 4.7 1.9l57.4 57.4zM99 348.8c.2-.8.5-1.5.9-2.3l65.5 65.5c-.7.4-1.5.7-2.3.9l-93.2 29.2L99 348.8z"
        }
    ]
};

const FalPencilSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPencilSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM559 138.8c21.9-21.9 21.9-57.3 0-79.2L516.4 17c-21.9-21.9-57.3-21.9-79.2 0L297.5 156.7l25.3 20 59.6-59.7 76.6 76.6-50.6 50.6 25.3 20L559 138.8zM317.2 335.3 240 412.6V400c0-8.8-7.2-16-16-16h-32v-32c0-8.8-7.2-16-16-16h-12.6l68.2-68.2-25.3-20-81.9 81.9c-11.4 11.4-19.7 25.4-24.2 40.8l-35.6 121c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2l96.2-96.2-25.3-20zM493.8 39.6l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L481.6 171 405 94.4l54.8-54.8c9.4-9.4 24.6-9.4 33.9 0zM135.6 368H160v32c0 8.8 7.2 16 16 16h32v24.4c-3.7 1.9-7.5 3.5-11.6 4.7l-92.8 27.3 27.3-92.8c1.2-4 2.7-7.9 4.7-11.6z"
        }
    ]
};

const FalPencil = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPencil",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117l76.6 76.6-219 219V400c0-8.8-7.2-16-16-16h-32v-32c0-8.8-7.2-16-16-16H99.4l219-219zM66.9 379.5c1.2-4 2.7-7.9 4.7-11.5H96v32c0 8.8 7.2 16 16 16h32v24.4c-3.7 1.9-7.5 3.5-11.6 4.7l-92.8 27.3 27.3-92.8zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17zM331.3 202.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalPeopleArrows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeopleArrows",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-22.4 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3C52.1 304 66.8 320 85.6 320h45.2c2.3 6.6 6.1 12.7 11.3 17.9l14 14.1H96v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3C29.3 191.9 64 160 105.6 160h44.8c28.3 0 53.4 14.8 67.7 37.3-4.3 2.2-8.4 5.1-12 8.8l-12.6 12.6c-7.9-15.9-24.3-26.7-43-26.7h-44.9zM160 496V355.9l32 32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16zm288 0V387.9l32-32V496c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96-144h-60.1l14.1-14.1c5.2-5.2 9-11.4 11.3-17.9h45.2c18.7 0 33.4-16 31.9-34.7l-4.2-49.3c-2.1-24.9-22.9-44-47.8-44h-44.8c-18.7 0-35.1 10.8-43 26.7L434 206.1c-3.6-3.6-7.7-6.5-12-8.8 14.2-22.5 39.3-37.3 67.7-37.3h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352zM512 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM251.3 251.3 214.6 288h210.8l-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6l-64 64c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7H214.6l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6l64-64c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalPeopleCarryBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeopleCarryBox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM67.8 343.4l25.9 20.3-63.1 138.9c-3.7 8-13.1 11.6-21.2 7.9s-11.6-13.1-7.9-21.2l66.4-146zM96 193.2v87c0 5 2.3 9.7 6.2 12.7l25.8 19.8V179.4c-4.5-2.2-9.6-3.4-14.8-3.4-9.5 0-17.2 7.7-17.2 17.2zm87.8 82.1L160 227.8v109.5l29 22.3c6.1 4.7 10.4 11.5 11.9 19.1l22.8 114.1c1.7 8.7-3.9 17.1-12.6 18.8s-17.1-3.9-18.8-12.6l-22.8-114-86.8-66.7c-11.8-9.1-18.7-23.1-18.7-38v-87C64 166 86 144 113.2 144c24.9 0 47.7 14.1 58.9 36.4l40.3 80.6 11.6 7.7V160c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v108.8l11.6-7.7 40.3-80.7c11.1-22.3 33.9-36.4 58.9-36.4 27.2 0 49.2 22 49.2 49.2v87c0 14.9-6.9 29-18.7 38L470.5 385l-22.8 114.1c-1.7 8.7-10.2 14.3-18.8 12.6s-14.3-10.2-12.6-18.8l22.8-114.1c1.5-7.6 5.7-14.4 11.9-19.1l29-22.3V227.8l-23.8 47.6c-2.5 5-6.2 9.2-10.9 12.3l-44.5 29.6c-3.7 2.5-8.1 3.2-12.2 2.3-1.5.2-3.1.3-4.7.3H256c-1.6 0-3.2-.1-4.7-.3-4.1.9-8.4.1-12.2-2.3l-44.5-29.6c-4.6-3.1-8.4-7.3-10.9-12.3zM504 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm68.2 343.4 66.4 146c3.7 8 .1 17.5-7.9 21.2s-17.5.1-21.2-7.9l-63.2-139 25.9-20.3zM544 193.2c0-9.5-7.7-17.2-17.2-17.2-5.2 0-10.3 1.2-14.8 3.4v133.3l25.8-19.8c3.9-3 6.2-7.7 6.2-12.7v-87zM256 160v128h128V160H256z"
        }
    ]
};

const FalPeopleDressSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeopleDressSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm17.5 151.2L42.4 352h171.2l-39.1-136.8c-3.9-13.7-16.5-23.2-30.8-23.2h-31.4c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H96v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H42.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8zM416 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm17.5 151.2L298.4 352h171.2l-39.1-136.8c-3.9-13.7-16.5-23.2-30.8-23.2h-31.4c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h-64v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h-21.6c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"
        }
    ]
};

const FalPeopleDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeopleDress",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-89.7 207.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6H96v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6.7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L246.1 368H73.9l52.4-104.8zM160 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9c-17.6-32.9-52-53.5-89.3-53.5s-71.7 20.6-89.3 53.5l-52.8 99c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l52.8-99c12-22.5 35.5-36.6 61-36.6zM456 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-89.7 207.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6.7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368H393.9l52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9c-17.6-32.9-52-53.5-89.3-53.5s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l52.9-98.9c12-22.5 35.5-36.6 61-36.6z"
        }
    ]
};

const FalPeopleGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeopleGroup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM0 280c0 43.3 26.4 80.4 64 96v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-40c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H96V208.4c2.6-.3 5.3-.4 8-.4h48c9.3 0 18.1 1.7 26.2 4.9 8.2 3.2 17.5-.9 20.7-9.1s-.9-17.5-9.1-20.7c-11.7-4.6-24.5-7.1-37.8-7.1h-48C46.6 176 0 222.6 0 280zm64 59.9c-19.3-12.9-32-35-32-59.9 0-25 12.7-47 32-59.9v119.8zM512 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm128 136c0-57.4-46.6-104-104-104h-48c-13.3 0-26.1 2.5-37.8 7.1-8.2 3.2-12.3 12.5-9.1 20.7s12.5 12.3 20.7 9.1c8.1-3.2 16.9-4.9 26.2-4.9h48c2.7 0 5.4.1 8 .4V416h-64v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-48c37.6-15.7 64-52.7 64-96zm-64 59.9V220.1c19.3 12.9 32 34.9 32 59.9 0 24.9-12.7 47-32 59.9zM288 96a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-80 96c-57.4 0-104 46.6-104 104 0 40.1 22.7 74.9 56 92.3V456c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24v-67.7c33.3-17.3 56-52.1 56-92.3 0-57.4-46.6-104-104-104h-32zm-48 50.3v107.4c-14.7-13.2-24-32.4-24-53.7 0-21.3 9.3-40.5 24-53.7zM288 448V225.8c5.1-1.2 10.5-1.8 16-1.8h32c5.5 0 10.9.6 16 1.8V448h-64zm96-98.3V242.3c14.7 13.2 24 32.3 24 53.7 0 21.3-9.3 40.5-24 53.7z"
        }
    ]
};

const FalPeopleLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeopleLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 80a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm24 208h48V177.5c-3.8-1-7.7-1.5-11.8-1.5h-24.4c-4 0-8 .5-11.8 1.5V288zm122.4-15.6L376 203.5V288c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-84.5l-42.4 68.9c-.2.3-.3.5-.5.8 1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 299.5V368c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-68.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 254.4 104 240 131.8 240h24.5c14.6 0 28.7 4 40.8 11.2l42.5-69.1c14.6-23.7 40.4-38.1 68.2-38.1h24.5c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2h24.5c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 299.5V368c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-68.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9-.2-.3-.4-.5-.5-.8zM16 448h608c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128-256a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-24 145.5V368h48v-94.5c-3.8-1-7.7-1.5-11.8-1.5h-24.4c-4 0-8 .5-11.8 1.5zM512 176a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm24 192h48v-94.5c-3.8-1-7.7-1.5-11.8-1.5h-24.4c-4 0-8 .5-11.8 1.5V368z"
        }
    ]
};

const FalPeoplePantsSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeoplePantsSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-6.2 172-4.1 49.3C52.1 304 66.8 320 85.6 320h84.9c18.7 0 33.4-16 31.9-34.7l-4.2-49.3c-2.1-24.9-22.9-44-47.8-44h-44.8c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM416 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-6.2 172-4.1 49.3c-1.6 18.7 13.1 34.7 31.9 34.7h84.9c18.7 0 33.4-16 31.9-34.7l-4.2-49.3c-2.1-24.9-22.9-44-47.8-44h-44.8c-25 0-45.8 19.1-47.8 44zm-31.9-2.7c3.5-41.5 38.1-73.4 79.7-73.4h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h-64v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"
        }
    ]
};

const FalPeoplePants = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeoplePants",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-68.7 104h25.4c6.8 0 13.3 1.4 19.3 4v156h-64V164c6-2.6 12.5-4 19.3-4zM128 496V352h64v144c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-58.9-110.2c-13.9-26-41-42.3-70.6-42.3h-25.4c-29.5 0-56.7 16.3-70.6 42.3L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L96 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16zM456 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-68.7 104h25.4c6.8 0 13.3 1.4 19.3 4v156h-64V164c6-2.6 12.5-4 19.3-4zM448 496V352h64v144c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-58.9-110.2c-13.9-26-41-42.3-70.6-42.3h-25.4c-29.5 0-56.6 16.3-70.6 42.3l-58.8 110.2c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l49.8-93.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalPeoplePulling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeoplePulling",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm9.5 113.3c-.9 2-1.5 4.3-1.5 6.7v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-26.5 21.5-48 48-48h62.6c16.7 0 32.9 5.2 46.5 14.9l121.7 86.8c11.8-33.4 35.5-61.5 66.9-78.6l12.7-6.9c19.4-10.6 41.2-16.2 63.4-16.2 36.9 0 69.7 23.6 81.4 58.7l17.1 51.4c3.4 10.1 10 18.8 18.9 24.8l29.7 19.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-29.7-19.8c-14.8-9.9-25.9-24.4-31.5-41.3l-8.8-26.4L443.3 331l43.6 37.8c4.7 4.1 8.1 9.4 9.8 15.4l30.7 107.4c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11L465.9 393l-100.5-87.2c-14.4-12.5-20.1-32.4-14.4-50.6l26.6-85c-1.3.6-2.6 1.3-3.9 2l-12.7 6.9c-27.5 15-47.4 40.8-55 71.2l-2.3 9.2c-.2 1-.5 1.9-.9 2.8-.8 2-2.1 3.7-3.5 5.1-3.3 3.2-7.8 4.9-12.5 4.5-1.9-.2-3.8-.6-5.5-1.5-1-.5-1.9-1-2.7-1.6l-130.4-92.9 75.3 316.4c2 8.6-3.3 17.2-11.9 19.3s-17.2-3.3-19.3-11.9l-35-147.7h-56.4l26.9 141c1.7 8.7-4 17.1-12.7 18.7s-17.1-4-18.7-12.7L33.5 169.3zm79-5.6c-.3-1.2-.4-2.5-.4-3.7H64.3l30.5 160h54.9l-37.3-156.3zM480 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm-18.5 208.8c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 45-130c-10-11.5-24.7-18.4-40.6-18.4-2.5 0-5 .1-7.5.3l-32.6 104.4zm-6.4 88.9c7.9 4 11.1 13.6 7.2 21.5l-30.8 61.7c-1.5 3.1-3.6 5.9-6 8.3l-62.2 62.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l62.2-62.2 30.8-61.7c4-7.9 13.6-11.1 21.5-7.2z"
        }
    ]
};

const FalPeopleRobbery = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeopleRobbery",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 144c54.3 0 101.9-36.2 116.4-88.5l12.2-43.8C531 3.2 539.8-1.8 548.3.6s13.5 11.2 11.1 19.7l-12.1 43.8c-12.3 44.3-43.4 79.5-83.2 97.9v334c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H368v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V162c-39.8-18.4-70.9-53.6-83.3-97.9l-12.1-43.8C238.2 11.8 243.2 3 251.7.6s17.3 2.6 19.7 11.1l12.2 43.8C298.1 107.8 345.7 144 400 144zm32 28.6c-10.4 2.2-21.1 3.4-32 3.4s-21.6-1.2-32-3.4V320h64V172.6zM85.3 144c21.8 0 42.4 10.3 55.5 27.7L192 240h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-56c-5 0-9.8-2.4-12.8-6.4l-56-74.7c-7.1-9.4-18.1-14.9-29.9-14.9-20.6 0-37.3 16.7-37.3 37.3V320h64v-40c0-8.8 7.2-16 16-16s16 7.2 16 16v216c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H48v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V213.3C16 175 47 144 85.3 144zM80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 80 0zm344 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0z"
        }
    ]
};

const FalPeopleRoof = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeopleRoof",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m328.5 2.5 304 192c7.5 4.7 9.7 14.6 5 22.1s-14.6 9.7-22.1 5L320 34.9 24.5 221.5c-7.5 4.7-17.4 2.5-22.1-5s-2.5-17.4 5-22.1l304-192c5.2-3.3 11.9-3.3 17.1 0zM336 192a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm24 208h48V289.5c-3.8-1-7.7-1.5-11.8-1.5h-24.4c-4 0-8 .5-11.8 1.5V400zm122.4-15.6L376 315.5V400c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-84.5l-42.4 68.9c-.2.3-.3.5-.5.8 1.1 1.6 2.2 3.2 3.3 4.9l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L200 411.5V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-68.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5C78.2 366.4 104 352 131.8 352h24.5c14.6 0 28.7 4 40.8 11.2l42.5-69.1c14.6-23.7 40.4-38.1 68.2-38.1h24.5c27.8 0 53.6 14.4 68.1 38.1l42.6 69.1c12.2-7.2 26.2-11.2 40.8-11.2h24.5c27.8 0 53.6 14.4 68.1 38.1l45.3 73.5c4.6 7.5 2.3 17.4-5.2 22s-17.4 2.3-22-5.2L552 411.5V480c0 17.7-14.3 32-32 32h-48c-17.7 0-32-14.3-32-32v-68.5l-42.4 68.9c-4.6 7.5-14.5 9.9-22 5.2s-9.9-14.5-5.2-22l45.3-73.5c1-1.7 2.1-3.3 3.3-4.9-.2-.3-.4-.5-.5-.8zM144 304a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-24 145.5V480h48v-94.5c-3.8-1-7.7-1.5-11.8-1.5h-24.4c-4 0-8 .5-11.8 1.5zM512 288a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm24 192h48v-94.5c-3.8-1-7.7-1.5-11.8-1.5h-24.4c-4 0-8 .5-11.8 1.5V480z"
        }
    ]
};

const FalPeopleSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeopleSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-6.2 172-4.1 49.3C52.1 304 66.8 320 85.6 320h84.9c18.7 0 33.4-16 31.9-34.7l-4.2-49.3c-2.1-24.9-22.9-44-47.8-44h-44.8c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3zM416 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm17.5 151.2L298.4 352h171.2l-39.1-136.8c-3.9-13.7-16.5-23.2-30.8-23.2h-31.4c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H448v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h-64v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h-21.6c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"
        }
    ]
};

const FalPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeople",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-68.7 104h25.4c6.8 0 13.3 1.4 19.3 4v156h-64V164c6-2.6 12.5-4 19.3-4zM128 496V352h64v144c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-58.9-110.2c-13.9-26-41-42.3-70.6-42.3h-25.4c-29.5 0-56.7 16.3-70.6 42.3L17.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6L96 202.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16zM456 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-89.7 207.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6.7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368H393.9l52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9c-17.6-32.9-52-53.5-89.3-53.5s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l52.9-98.9c12-22.5 35.5-36.6 61-36.6z"
        }
    ]
};

const FalPepperHot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPepperHot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m422.9 133.4 11.2 7.5 9.4 9.6c22.6 23.2 36.5 54.7 36.5 89.5 0 3-.1 5.9-.3 8.8-10.3-15.4-27.7-24.8-46.5-24.8H368v-72c0-15.7-6.4-29.8-16.8-40h.8c26.3 0 50.6 7.9 70.9 21.4zM512 240c0-43.3-17.2-82.6-45.2-111.4l-.4-.4c1.5-3.3 2.9-6.6 4.2-10 9.4-25.6 10.6-53.8 2.7-80.5-1.1-3.8-2.4-7.6-3.9-11.3l-6.5-16.3c-3.3-8.2-12.6-12.2-20.8-8.9s-12.2 12.6-8.9 20.8l6.5 16.3c2.5 6.3 4.3 12.7 5.4 19.2.9 5.1 1.4 10.3 1.4 15.5.1 11.6-1.8 23.1-5.8 34-9-6-18.6-11.1-28.7-15.2-18.5-7.7-38.8-11.8-60-11.8-24.3 0-47.3 5.4-67.9 15.1-19.3 9-10.5 32.9 10.8 32.9H312c13.3 0 24 10.7 24 24v80c0 13.3 10.7 24 24 24h73.2c9.1 0 17.4 5.1 21.5 13.3l11.7 23.4c8.2 16.4 30.7 17.5 36.8.1 5.8-16.5 8.9-34.3 8.9-52.8zm-250.3-80-89.3 145.7c-18.1 29.6-47.5 50.5-81.4 58.1l-35.4 7.9C23.1 378.9 0 407.7 0 441c0 39.2 31.8 71 71 71h32.1c141.1 0 269.1-68.1 348.9-176.2l-16.2-32.5C362.9 411.3 239.6 480 103.2 480H71c-21.6 0-39-17.5-39-39 0-18.3 12.7-34.1 30.6-38.1l35.3-7.9c42.3-9.4 79-35.6 101.7-72.6L299.2 160h-37.5z"
        }
    ]
};

const FalPepper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPepper",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M195.7 5.8c5.7-6.8 15.7-7.7 22.5-2L208 16c10.2-12.3 10.2-12.3 10.3-12.3l.1.1.2.2.6.5c.5.4 1.1 1 1.9 1.7 1.6 1.5 3.7 3.6 6.2 6.3 5 5.5 11.7 13.5 18.3 23.9 10.6 16.8 21.2 40 25 69 19.5-9.3 42.2-12.2 64.7-6.5 10.5 2.6 20.1 6.9 28.7 12.4 21.5-13.8 48.5-19.1 75.3-12.4 51.4 12.9 82.7 65 69.8 116.4l-56 224c-12.9 51.4-65 82.7-116.4 69.8-10.5-2.6-20.1-6.9-28.7-12.4-5.7 3.7-11.8 6.7-18.3 9.2-10.6 4-22 6.1-33.7 6.1-11.7 0-23.1-2.1-33.7-6.1-6.5-2.4-12.6-5.5-18.3-9.2-8.6 5.5-18.3 9.8-28.7 12.4-51.5 12.9-103.6-18.4-116.4-69.8l-56-224C-10 163.8 21.3 111.7 72.7 98.9c26.8-6.7 53.8-1.4 75.3 12.4 7.5-4.9 15.9-8.7 24.9-11.4.8-.2 1.5-.4 2.3-.6.5-.1 1.1-.3 1.6-.4 21.2-5.3 42.6-3.1 61.2 4.9-3.6-20.9-11.5-37.7-19.5-50.3-5.4-8.5-10.8-15-14.7-19.3-2-2.1-3.6-3.7-4.6-4.7-.5-.5-.9-.9-1.2-1.1l-.2-.2c-6.8-5.7-7.7-15.7-2-22.5zm-72.3 128.3c-12.9-6.1-28-8-42.9-4.2-34.3 8.6-55.1 43.3-46.6 77.6l56 224c8.6 34.3 43.3 55.1 77.6 46.6 10-2.5 18.8-7.2 26.1-13.4 6-5.1 14.8-5.1 20.8 0 5.5 4.7 12 8.6 19.1 11.3 7.1 2.7 14.7 4.1 22.5 4.1 7.8 0 15.4-1.4 22.4-4.1 7.1-2.7 13.6-6.5 19.1-11.3 6-5.1 14.8-5.1 20.8 0 7.3 6.2 16.1 10.9 26.1 13.4 34.3 8.6 69-12.3 77.6-46.6l56-224c8.6-34.3-12.3-69-46.6-77.6-20.9-5.2-41.9.4-57.1 13.4-6 5.1-14.8 5.1-20.8 0a64.24 64.24 0 0 0-26.1-13.4c-22.4-5.6-44.9 1.3-60.3 16.4-6.2 6.1-16.2 6.1-22.4 0-15.4-15.1-38-22-60.3-16.4-34.3 8.6-55.1 43.3-46.6 77.6L175.5 358c2.1 8.6-3.1 17.3-11.6 19.4s-17.3-3.1-19.4-11.6l-37.6-150.5c-7.3-29.3-.3-58.8 16.5-81.1zM256 512v-16 16z"
        }
    ]
};

const FalPercent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPercent",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm59.3-356.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-352 352c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l352-352z"
        }
    ]
};

const FalPeriod = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPeriod",
    "viewBox": "0 0 128 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FalPersonArrowDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonArrowDownToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-68.7 104h25.4c6.8 0 13.3 1.4 19.3 4v156h-64V164c6-2.6 12.5-4 19.3-4zM160 480V352h64v128h-64zm-32 0H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-58.9-110.2c-13.9-26-41-42.3-70.6-42.3h-25.4c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l49.8-93.5V480zM480 48v313.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L512 361.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
        }
    ]
};

const FalPersonArrowUpFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonArrowUpFromLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-68.7 104h25.4c6.8 0 13.3 1.4 19.3 4v156h-64V164c6-2.6 12.5-4 19.3-4zM160 480V352h64v128h-64zm-32 0H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16H256V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-58.9-110.2c-13.9-26-41-42.3-70.6-42.3h-25.4c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l49.8-93.5V480zm475.3-347.3-96-96c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 86.6V400c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6z"
        }
    ]
};

const FalPersonBikingMountain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonBikingMountain",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zM130 272c-3.9 0-7.1 2.7-7.8 6.4-1.2 5.8-5.5 10.5-11.2 12.2-6.2 1.8-12.1 4.3-17.7 7.3-5.2 2.9-11.6 2.6-16.5-.7-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1 3.3 5 3.6 11.3.7 16.5-3 5.6-5.5 11.5-7.3 17.7-1.7 5.7-6.4 10-12.2 11.2-3.6.7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8 5.8 1.2 10.5 5.5 12.2 11.2 1.8 6.2 4.3 12.1 7.3 17.7 2.9 5.2 2.6 11.6-.7 16.5-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1 5-3.3 11.3-3.6 16.5-.7 5.6 3 11.5 5.5 17.7 7.3 5.7 1.7 10 6.4 11.2 12.2.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4 1.2-5.8 5.5-10.5 11.2-12.2 6.2-1.8 12.1-4.3 17.7-7.3 5.2-2.9 11.6-2.6 16.5.7 3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1-3.3-5-3.6-11.3-.7-16.5 3-5.6 5.5-11.5 7.3-17.7 1.7-5.7 6.4-10 12.2-11.2 3.6-.7 6.4-4 6.4-7.8v-12c0-3.9-2.7-7.1-6.4-7.8-5.8-1.2-10.5-5.5-12.2-11.2-1.8-6.2-4.3-12.1-7.3-17.7-2.9-5.2-2.6-11.6.7-16.5 2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1-5 3.3-11.3 3.6-16.5.7-5.6-3-11.5-5.5-17.7-7.3-5.7-1.7-10-6.4-11.2-12.2-.7-3.6-4-6.4-7.8-6.4h-12zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5h12c15.8 0 29.5 9.2 36 22.5 2.9 1.1 5.8 2.3 8.6 3.6 14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3 1.3 2.8 2.5 5.7 3.6 8.6 13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36-1.1 2.9-2.3 5.8-3.6 8.6 4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5-2.8 1.3-5.7 2.5-8.6 3.6-6.5 13.3-20.1 22.5-36 22.5h-12c-15.8 0-29.5-9.2-36-22.5-2.9-1.1-5.8-2.3-8.6-3.6-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3-1.3-2.8-2.5-5.7-3.6-8.6C9.2 411.5 0 397.8 0 382v-12c0-15.8 9.2-29.5 22.5-36 1.1-2.9 2.3-5.8 3.6-8.6-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5 2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zm53.5 21.5a53.5 53.5 0 1 1-107 0 53.5 53.5 0 1 1 107 0zM498 272c-3.9 0-7.1 2.7-7.8 6.4-1.2 5.8-5.5 10.5-11.2 12.2-6.2 1.8-12.1 4.3-17.7 7.3-5.2 2.9-11.6 2.6-16.5-.7-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1 3.3 5 3.6 11.3.7 16.5-3 5.6-5.5 11.5-7.3 17.7-1.7 5.7-6.4 10-12.2 11.2-3.6.7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8 5.8 1.2 10.5 5.5 12.2 11.2 1.8 6.2 4.3 12.1 7.3 17.7 2.9 5.2 2.6 11.6-.7 16.5-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1 5-3.3 11.3-3.6 16.5-.7 5.6 3 11.5 5.5 17.7 7.3 5.7 1.7 10 6.4 11.2 12.2.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4 1.2-5.8 5.5-10.5 11.2-12.2 6.2-1.8 12.1-4.3 17.7-7.3 5.2-2.9 11.6-2.6 16.5.7 3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1-3.3-5-3.6-11.3-.7-16.5 3-5.6 5.5-11.5 7.3-17.7 1.7-5.7 6.4-10 12.2-11.2 3.6-.7 6.4-4 6.4-7.8v-12c0-3.9-2.7-7.1-6.4-7.8-5.8-1.2-10.5-5.5-12.2-11.2-1.8-6.2-4.3-12.1-7.3-17.7-2.9-5.2-2.6-11.6.7-16.5 2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1-5 3.3-11.3 3.6-16.5.7-5.6-3-11.5-5.5-17.7-7.3-5.7-1.7-10-6.4-11.2-12.2-.7-3.6-4-6.4-7.8-6.4h-12zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5h12c15.8 0 29.5 9.2 36 22.5 2.9 1.1 5.8 2.3 8.6 3.6 14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3 1.3 2.8 2.5 5.7 3.6 8.6 13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36-1.1 2.9-2.3 5.8-3.6 8.6 4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5-2.8 1.3-5.7 2.5-8.6 3.6-6.5 13.3-20.1 22.5-36 22.5h-12c-15.8 0-29.5-9.2-36-22.5-2.9-1.1-5.8-2.3-8.6-3.6-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3-1.3-2.8-2.5-5.7-3.6-8.6-13.3-6.5-22.5-20.1-22.5-36v-12c0-15.8 9.2-29.5 22.5-36 1.1-2.9 2.3-5.8 3.6-8.6-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5 2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zm53.5 21.5a53.5 53.5 0 1 1-107 0 53.5 53.5 0 1 1 107 0zM330.2 166.7c-6-5.4-15-5.5-21.1-.3L250 217.1c-8 6.8-7.3 19.4 1.3 25.3l93.7 64.4c4.3 3 6.9 7.9 6.9 13.2v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-87.6l-86.8-59.7c-26-17.9-28-55.5-4-76l59.1-50.6c18.3-15.7 45.4-15.4 63.3.8l54.6 49.1H480c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-4 0-7.8-1.5-10.7-4.1l-59.1-53.2zm-160.9-.7 69.9-63.1-3.7-3.5c-11.8-11-29.9-11.6-42.3-1.3l-49.6 41.2 25.7 26.7zm104.3-51-94.4 85.2c-6.4 5.8-16.3 5.4-22.3-.8l-48.3-50.3c-6.4-6.7-5.8-17.5 1.3-23.4l62.8-52.2c24.8-20.6 61.1-19.5 84.7 2.6l16.4 15.4c6.8 6.4 6.7 17.3-.2 23.5z"
        }
    ]
};

const FalPersonBiking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonBiking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M392 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM224 384a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm-96-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm480 128a96 96 0 1 1-192 0 96 96 0 1 1 192 0zm-96-128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm-202.9-89.6c6.1-5.2 15.1-5.1 21.1.3l59.1 53.2c2.9 2.6 6.8 4.1 10.7 4.1h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-73.9l-54.5-49.1c-17.9-16.1-45-16.5-63.3-.8l-59.1 50.6c-23.9 20.5-21.9 58.1 4 76l86.8 59.7V416c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-5.3-2.6-10.2-6.9-13.2l-93.7-64.4c-8.7-6-9.3-18.5-1.3-25.3l59.1-50.6z"
        }
    ]
};

const FalPersonBooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonBooth",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM32 223.4v56.3c.2 5.1 2.7 9.7 6.9 12.6L80 320.6V180.2c-6.2-2.7-13-4.2-20-4.2-15.5 0-28 12.5-28 28v19.4zm0 103V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V204c0-33.1 26.9-60 60-60 27.9 0 53.9 14.2 69 37.6l47.7 74.4H240c8.8 0 16 7.2 16 16s-7.2 16-16 16h-63.3c-10.9 0-21-5.5-26.9-14.7L112 214.5v128.1l34.1 23.4c8.7 6 13.9 15.8 13.9 26.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V392.4l-96-66zM256 32c-8.8 0-16 7.2-16 16v176h-32V48c0-26.5 21.5-48 48-48h272c26.5 0 48 21.5 48 48v448c0 8.8-7.2 16-16 16s-16-7.2-16-16v-56.6c-9.4 5.4-20.3 8.6-32 8.6-15.1 0-29.1-5.3-40-14-10.9 8.8-24.9 14-40 14s-29.1-5.3-40-14c-10.9 8.8-24.9 14-40 14-35.3 0-64-28.7-64-64v-2.9c0-10.8 2.2-21.6 6.5-31.5L335 255 268.1 32H256zm45.5 0 65.8 219.4c1.1 3.6.9 7.5-.6 10.9l-42.8 99.9c-2.6 6-3.9 12.4-3.9 18.9v2.9c0 17.7 14.3 32 32 32 11.1 0 20.9-5.7 26.7-14.3 3-4.5 8-7.1 13.3-7.1s10.4 2.7 13.3 7.1c5.8 8.7 15.6 14.3 26.7 14.3s20.9-5.7 26.7-14.3c3-4.5 8-7.1 13.3-7.1s10.4 2.7 13.3 7.1c5.8 8.7 15.6 14.3 26.7 14.3 17.7 0 32-14.3 32-32V48c0-8.8-7.2-16-16-16H301.5zM240 320v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V320h32z"
        }
    ]
};

const FalPersonBreastfeeding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonBreastfeeding",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM103.3 273.9c20.8-31.2 55.7-49.9 93.2-49.9h68.1c30.9 0 60.5 12.8 81.6 35.3l55.5 59.1c14.6 15.6 14.4 39.9-.4 55.2l-76.8 79.2c-6.2 6.3-6 16.5.3 22.6s16.5 6 22.6-.3l76.8-79.2c26.8-27.6 27.1-71.4.8-99.4l-55.5-59.1c-27.2-29-65.2-45.4-105-45.4h-68c-48.1 0-93.1 24.1-119.8 64.1L23 336.7C-1.5 373.4 12.6 423.4 52.7 442l148.6 68.6c8 3.7 17.5.2 21.2-7.8s.2-17.5-7.8-21.2L66.1 412.9c-22.3-10.3-30.1-38.1-16.5-58.5l53.7-80.5zM192 320c0-8.8-7.2-16-16-16s-16 7.2-16 16v43.4c0 6 1.7 11.9 4.9 17 26.3 42.1 72.4 67.6 122 67.6h1.1c8.8 0 16-7.2 16-16s-7.2-16-16-16h-1.1c-38.6 0-74.4-19.9-94.9-52.6V320zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalPersonBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-68.7 104h25.4c6.8 0 13.3 1.4 19.3 4v156h-64V164c6-2.6 12.5-4 19.3-4zM448 496V352h64v144c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-58.9-110.2c-13.9-26-41-42.3-70.6-42.3h-25.4c-29.5 0-56.6 16.3-70.6 42.3l-58.8 110.2c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l49.8-93.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16zM190.5 17.3C187.9 11.6 182.3 8 176 8s-11.9 3.6-14.5 9.3l-32.1 69.9-74.7-18.5c-6.1-1.5-12.5.7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6-60.9 46.8c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.8 4 11.5 4.8 17.1 2.1s9.2-8.5 9.1-14.7L260 251l75.2-15.8c6.1-1.3 10.9-6 12.3-12.1s-.9-12.4-5.8-16.2l-60.9-46.8 34.6-68.6c2.8-5.6 2.1-12.3-1.8-17.2s-10.3-7.1-16.3-5.6l-74.7 18.5-32.1-69.9zm-37.6 95.2L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l53.7-13.3-24.9 49.4c-3.5 6.9-1.6 15.2 4.5 19.9l43.8 33.7-54.1 11.3c-7.5 1.6-12.9 8.3-12.7 15.9l1 55.3-42.6-35.2c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9l-54.1-11.3 43.8-33.7c6.1-4.7 8-13 4.5-19.9l-24.8-49.4 53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9z"
        }
    ]
};

const FalPersonCane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonCane",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm-24 108v156h64V161.2c-3.4-.8-6.9-1.2-10.5-1.2h-34.2c-6.8 0-13.3 1.4-19.3 4zm-32 38.1-49.9 93.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h34.2c23.5 0 45.7 10.3 60.9 28.2l89.8 105.5c5.7 6.7 4.9 16.8-1.8 22.6s-16.8 4.9-22.6-1.8L240 183.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h-64v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.2zM368 352c-8.8 0-16 7.2-16 16v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-26.5 21.5-48 48-48s48 21.5 48 48v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V368c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalPersonCarryBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonCarryBox",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zM0 496c0 8.8 7.2 16 16 16s16-7.2 16-16V365.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3V496zm60-320c7 0 13.8 1.5 20 4.2v139.2l-40.9-27.2c-4.5-3-7.1-8-7.1-13.3V204c0-15.5 12.5-28 28-28zm52 38.5 37.8 58.8c5.9 9.2 16 14.7 26.9 14.7H352c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H224c-17.7 0-32 14.3-32 32v128h-15.3l-47.8-74.4c-15-23.4-41-37.6-68.9-37.6-33.1 0-60 26.9-60 60v74.9c0 16 8 31 21.4 39.9l100.2 66.8 22.7 113.5c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L153 379.4c-1.7-8.3-6.6-15.6-13.6-20.3L112 340.8V214.5zM224 256V128h128v128H224z"
        }
    ]
};

const FalPersonChalkboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonChalkboard",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M168 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-68.7 104H224v160h-64V164c6-2.6 12.5-4 19.3-4zM160 496V352h64v144c0 8.8 7.2 16 16 16s16-7.2 16-16V160h144c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16v-80h-32v80c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48v80H179.3c-29.5 0-56.7 16.3-70.6 42.3L49.9 280.5c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l49.8-93.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalPersonCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-32 164v156h64V164c-6-2.6-12.5-4-19.3-4h-25.4c-6.8 0-13.3 1.4-19.3 4zm0 188v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1l-49.9 93.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm304 128a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalPersonCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-32 164v156h64V164c-6-2.6-12.5-4-19.3-4h-25.4c-6.8 0-13.3 1.4-19.3 4zm0 188v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1l-49.9 93.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalPersonCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-32 164v156h64V164c-6-2.6-12.5-4-19.3-4h-25.4c-6.8 0-13.3 1.4-19.3 4zm0 188v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1l-49.9 93.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm304 128a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm80 144c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalPersonCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-32 164v156h64V164c-6-2.6-12.5-4-19.3-4h-25.4c-6.8 0-13.3 1.4-19.3 4zm0 188v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1l-49.9 93.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalPersonCircleQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonCircleQuestion",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-32 164v156h64V164c-6-2.6-12.5-4-19.3-4h-25.4c-6.8 0-13.3 1.4-19.3 4zm0 188v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1l-49.9 93.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64-86.4c0-23 18.6-41.6 41.6-41.6h40.5c25.4 0 45.9 20.6 45.9 45.9 0 17.1-9.5 32.7-24.5 40.6L447.8 387c-1.4 7.4-7.9 12.9-15.7 12.9-8.8 0-16-7.2-16-16v-6.8c0-5.9 3.3-11.4 8.6-14.2l32-16.8c4.6-2.4 7.4-7.2 7.4-12.3 0-7.7-6.2-13.9-13.9-13.9h-40.6c-5.3 0-9.6 4.3-9.6 9.6v6.5c0 8.8-7.2 16-16 16s-16-7.2-16-16v-6.4z"
        }
    ]
};

const FalPersonCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-32 164v156h64V164c-6-2.6-12.5-4-19.3-4h-25.4c-6.8 0-13.3 1.4-19.3 4zm0 188v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1l-49.9 93.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l48.7 91.1c-7.5 9.8-14 20.5-19.3 31.8l-48.6-91V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128zm416 16a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm166.6 0 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 368z"
        }
    ]
};

const FalPersonDigging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonDigging",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1-128 0 64 64 0 1 1 128 0zm120.1 258.2-66.2 117.6c-2.8 5-8.2 8.2-13.9 8.2h-46.1l-16 32h235.5l-93.3-157.8zM414 303.3c5.3-9.4 15.2-15.2 26-15.2 10.6 0 20.3 5.6 25.7 14.7L564 468.9c2.6 4.4 4 9.4 4 14.5 0 15.8-12.8 28.6-28.6 28.6H292.9c-16 0-28.9-13-28.9-28.9 0-4.5 1-8.9 3.1-12.9l18.2-36.4c5.4-10.8 16.5-17.7 28.6-17.7h36.8l13.8-24.5L24.3 206c-7.8-4.2-10.6-14-6.4-21.7s14-10.6 21.7-6.4l33.6 18.3 13.1-24c14.9-27.4 44.4-43.6 75.6-41.5l13.9.9c45.9 3.1 85.3 33.9 99.3 77.8l36.2 113.7-3.4 1.1 72.3 39.4 34-60.4zm-142.3 1.3-27.2-85.4c-10-31.3-38.1-53.4-70.9-55.6l-13.9-.9c-18.7-1.2-36.4 8.5-45.3 24.9l-13.1 24 170.4 92.9zM57.6 289.3c4.6-2 9.8-1.7 14.1.7l127.5 70.9c15.2 8.5 24.7 24.5 24.7 42V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-93.2c0-5.8-3.2-11.2-8.2-14L74.5 328.1l-43 171.8c-2.1 8.6-10.8 13.8-19.4 11.6S-1.7 500.7.5 492.1l48-192c1.2-4.8 4.6-8.8 9.2-10.8z"
        }
    ]
};

const FalPersonDollyEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonDollyEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112A56 56 0 1 1 80 0zM0 340.3c.5.4 1.1.9 1.6 1.3L32 365.5V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V340.3zM32 204v74.9c0 5.3 2.7 10.3 7.1 13.3L80 319.4V180.2c-6.2-2.7-13-4.2-20-4.2-15.5 0-28 12.5-28 28zm117.8 69.3L112 214.5v126.3l27.4 18.2c7.1 4.7 12 12 13.6 20.3l22.7 113.5c1.7 8.7-3.9 17.1-12.6 18.8s-17.1-3.9-18.8-12.6l-22.7-113.4-100.2-66.8C8 309.9 0 294.9 0 278.9V204c0-33.1 26.9-60 60-60 27.9 0 53.9 14.2 69 37.6l47.7 74.4h44l-20.3-84.2c-2.1-8.6 3.2-17.2 11.8-19.3s17.2 3.2 19.3 11.8l53.1 219.8c1.1-.1 2.2-.1 3.4-.1 25.7 0 47.9 15.1 58 37l146.1-36.5c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-148 37c-2.3 33.2-30 59.5-63.8 59.5-35.3 0-64-28.7-64-64 0-22.9 12-42.9 30-54.3L228.5 288h-51.8c-10.9 0-21-5.5-26.9-14.7zM288 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalPersonDolly = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonDolly",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zM0 496c0 8.8 7.2 16 16 16s16-7.2 16-16V365.5L1.6 341.6c-.5-.4-1.1-.9-1.6-1.3V496zm60-320c7 0 13.8 1.5 20 4.2v139.2l-40.9-27.2c-4.5-3-7.1-8-7.1-13.3V204c0-15.5 12.5-28 28-28zm52 38.5 37.8 58.8c5.9 9.2 16 14.7 26.9 14.7h51.8L254 393.7c-18 11.3-30 31.4-30 54.3 0 35.3 28.7 64 64 64 33.8 0 61.5-26.2 63.8-59.5l148-37c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6L346 421c-10.2-21.9-32.3-37-58-37-1.1 0-2.3 0-3.4.1l-53-219.9c-2.1-8.6-10.7-13.9-19.3-11.8s-13.9 10.7-11.8 19.3l20.3 84.3h-44L129 181.6C113.9 158.2 87.9 144 60 144c-33.1 0-60 26.9-60 60v74.9c0 16 8 31 21.4 39.9l100.2 66.8 22.7 113.5c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L153 379.4c-1.7-8.3-6.6-15.6-13.6-20.3L112 340.8V214.5zM256 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm185.2-125.7-91.5 22.9-22.9-91.5 91.5-22.9 22.9 91.5zm31-7.8L449.4 223c-4.3-17.1-21.7-27.6-38.8-23.3L319 222.6c-17.1 4.3-27.6 21.7-23.3 38.8l22.9 91.6c4.3 17.1 21.7 27.6 38.8 23.3l91.6-22.9c17.1-4.3 27.6-21.7 23.3-38.8z"
        }
    ]
};

const FalPersonDotsFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonDotsFromLine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344 88a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-144 0a88 88 0 1 1 176 0 88 88 0 1 1-176 0zM80 192a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm96 256V256.6c-21.4 6.5-40.2 14.2-56.3 21.9-20 9.6-35.5 19.2-45.9 26.3-5.2 3.6-9.2 6.5-11.7 8.5-1.3 1-2.2 1.8-2.9 2.3l-.6.5-.1.1c-6.7 5.8-16.8 5-22.6-1.7s-5-16.8 1.7-22.6L48 304l-10.4-12.1.1-.1.3-.2 1-.8c.8-.7 2-1.6 3.5-2.8 3.1-2.4 7.5-5.7 13.3-9.6 11.6-7.9 28.5-18.3 50.1-28.7C149.1 228.8 211.5 208 288 208s138.9 20.8 182.1 41.6c21.6 10.4 38.5 20.8 50.1 28.7 5.8 3.9 10.2 7.3 13.3 9.6 1.5 1.2 2.7 2.1 3.5 2.8l1 .8.3.2.1.1-10.4 12.1 10.4-12.1c6.7 5.8 7.4 15.9 1.7 22.6s-15.9 7.4-22.5 1.7l-.1-.1-.6-.5c-.6-.5-1.6-1.3-2.9-2.3-2.6-2-6.5-4.9-11.7-8.5-10.4-7.1-25.9-16.7-45.9-26.3-16-7.7-34.9-15.4-56.3-21.9V448H368V248.4c-24.3-5.1-51-8.4-80-8.4s-55.7 3.2-80 8.4V448h-32zM0 496c0-8.8 7.2-16 16-16h544c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm304-160a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm160-144a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalPersonDressBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonDressBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M456 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-89.7 207.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h64v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96h48c5.5 0 10.7-2.9 13.6-7.6s3.2-10.6.7-15.6l-64-128c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5L566.1 368H393.9l52.4-104.8zM480 160c25.5 0 49 14.1 61 36.6l52.9 98.9c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-52.9-98.9c-17.6-32.9-52-53.5-89.3-53.5s-71.7 20.6-89.3 53.5l-52.9 98.9c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l52.9-98.9c12-22.5 35.5-36.6 61-36.6zM190.5 17.3C187.9 11.6 182.3 8 176 8s-11.9 3.6-14.5 9.3l-32.1 69.9-74.7-18.5c-6.1-1.5-12.5.7-16.3 5.6s-4.6 11.6-1.8 17.2l34.6 68.6-60.9 46.8c-5 3.8-7.2 10.2-5.8 16.2s6.2 10.8 12.3 12.1L92 251l-1.4 76.8c-.1 6.2 3.4 12 9.1 14.7s12.3 1.9 17.1-2.1l59.2-49 59.2 49c4.8 4 11.5 4.8 17.1 2.1s9.2-8.5 9.1-14.7L260 251l75.2-15.8c6.1-1.3 10.9-6 12.3-12.1s-.9-12.4-5.8-16.2l-60.9-46.8 34.6-68.6c2.8-5.6 2.1-12.3-1.8-17.2s-10.3-7.1-16.3-5.6l-74.7 18.5-32.1-69.9zm-37.6 95.2L176 62.3l23.1 50.2c3.2 7 10.9 10.7 18.4 8.9l53.7-13.3-24.9 49.4c-3.5 6.9-1.6 15.2 4.5 19.9l43.8 33.7-54.1 11.3c-7.5 1.6-12.9 8.3-12.7 15.9l1 55.3-42.6-35.2c-5.9-4.9-14.5-4.9-20.4 0l-42.6 35.2 1-55.3c.1-7.7-5.2-14.4-12.7-15.9l-54.1-11.3 43.8-33.7c6.1-4.7 8-13 4.5-19.9l-24.8-49.4 53.7 13.3c7.5 1.8 15.2-1.9 18.4-8.9z"
        }
    ]
};

const FalPersonDressFairy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonDressFairy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-15.7 192c-14.3 0-26.8 9.5-30.8 23.2L234.4 352h171.2l-39.1-136.8c-3.9-13.7-16.5-23.2-30.8-23.2h-31.4zm0-32h31.5c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H384v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h-64v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h-21.6c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8c7.8-27.5 33-46.4 61.5-46.4zM32 32c91.1 0 172.4 42.3 225.1 108.4-9.3 5.3-17.8 12.1-24.9 20.1C185.4 101.7 113.1 64 32 64v48c0 76.5 35.7 144.6 91.5 188.6l12.1 9.5c6.8 5.3 8.1 15 3 22l-9.1 12.4C108.5 373.6 96 409.3 96 448h16c39.2 0 75.4-12.8 104.7-34.5 2.4.7 4.8 1.2 7.3 1.6v32.1C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32 0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64c0-17.7 14.3-32 32-32zm375.7 128.5c-7.1-8.1-15.5-14.9-24.9-20.1C435.6 74.3 516.9 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32h-16c-41.2 0-79.7-12-112-32.7v-32.1c2.5-.4 5-1 7.3-1.6C452.6 435.2 488.8 448 528 448h16c0-38.7-12.5-74.4-33.6-103.5l-9.1-12.4c-5.1-7-3.7-16.7 3-22l12.1-9.5c55.9-44 91.6-112.1 91.6-188.6V64c-81.1 0-153.4 37.7-200.3 96.5z"
        }
    ]
};

const FalPersonDressSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonDressSimple",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm17.5 151.2L42.4 352h171.2l-39.1-136.8c-3.9-13.7-16.5-23.2-30.8-23.2h-31.4c-14.3 0-26.8 9.5-30.8 23.2zm-30.8-8.8c7.8-27.5 33-46.4 61.5-46.4h31.4c28.6 0 53.7 18.9 61.5 46.4l39.1 136.8c5.8 20.4-9.5 40.8-30.8 40.8H192v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H96v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H42.4c-21.3 0-36.6-20.3-30.8-40.8l39.1-136.8z"
        }
    ]
};

const FalPersonDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonDress",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-40.8 241.7c7.9 4 11.1 13.6 7.2 21.5L73.9 368h172.2l-52.4-104.8c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l64 128c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400h-64v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96H48c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l64-128c4-7.9 13.6-11.1 21.5-7.2zM99 196.6l-52.9 98.9c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l52.9-98.9c17.6-32.9 52-53.5 89.3-53.5s71.7 20.6 89.3 53.5l52.9 98.9c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L221 196.6c-12-22.5-35.5-36.6-61-36.6s-49 14.1-61 36.6z"
        }
    ]
};

const FalPersonDrowning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonDrowning",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32c8.8 0 16 7.2 16 16v41c0 63.4 41.9 119.2 102.7 137 47.9 14 98.7 14 146.5 0l114.2-33.3c8.5-2.5 17.4 2.4 19.8 10.9s-2.4 17.4-10.9 19.8l-114.1 33.3c-16.9 4.9-34.1 8.3-51.5 10.1l-14 111.8c-9.6-3.5-19.1-8.4-28-14.5-.8-.5-1.5-1-2.3-1.5l11.8-94.2c-27.1-.2-54.2-4.1-80.6-11.7-5.6-1.6-11.1-3.5-16.4-5.7l-19 129.3c-8.5 2.6-17.3 4.1-26.2 4.1-2.2 0-4.5-.1-6.7-.3l22-148.8C158.8 203.7 128 149.2 128 89V48c0-8.8 7.2-16 16-16zm176 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM192 448c20.9 0 41.6-9.9 58.2-21.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z"
        }
    ]
};

const FalPersonFairy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonFairy",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-22.4 192c-25 0-45.8 19.1-47.8 44l-4.1 49.3c-1.6 18.7 13.1 34.7 31.9 34.7h84.9c18.7 0 33.4-16 31.9-34.7l-4.2-49.3c-2.1-24.9-22.9-44-47.8-44h-44.8zm0-32h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h-64v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3c3.5-41.5 38.1-73.4 79.7-73.4zM32 32c89.4 0 169.4 40.8 222.2 104.7-10.1 4.2-19.4 9.9-27.7 16.8C179.5 98.7 109.8 64 32 64v48c0 76.5 35.7 144.6 91.5 188.6l12.1 9.5c6.8 5.3 8.1 15 3 22l-9.1 12.4C108.5 373.6 96 409.3 96 448h16c42.5 0 81.6-15.1 112-40.2v39.5C191.7 468 153.2 480 112 480H96c-17.7 0-32-14.3-32-32 0-45.7 14.7-88 39.7-122.3C40.6 275.9 0 198.7 0 112V64c0-17.7 14.3-32 32-32zm381.5 121.5c-8.3-6.9-17.7-12.5-27.7-16.8C438.6 72.8 518.6 32 608 32c17.7 0 32 14.3 32 32v48c0 86.7-40.6 163.9-103.7 213.7C561.3 360 576 402.3 576 448c0 17.7-14.3 32-32 32h-16c-41.2 0-79.7-12-112-32.7v-39.5c30.4 25.1 69.5 40.2 112 40.2h16c0-38.7-12.5-74.4-33.6-103.5l-9.1-12.4c-5.1-7-3.7-16.7 3-22l12.1-9.5c55.9-44 91.6-112.1 91.6-188.6V64c-77.8 0-147.5 34.7-194.5 89.5z"
        }
    ]
};

const FalPersonFallingBurst = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonFallingBurst",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c8.8 0 16 7.2 16 16v10.8c0 55.4-29.2 105.8-75.2 133.7l67.3 102.6 59.4-5.9c13.2-1.3 25.9 5.7 31.8 17.5l43.1 86.1c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2L310.6 289l-64.4 6.4-57.5 44.7 96.6 147.1c4.9 7.4 2.8 17.3-4.6 22.2s-17.3 2.8-22.2-4.6L79.8 232.6C69.6 250.7 64 271.5 64 293.2V368c0 8.8-7.2 16-16 16s-16-7.2-16-16v-74.8c0-67.3 43.1-127.1 106.9-148.4 3.2-1.1 6.2-2.2 9.3-3.5.2-.1.4-.3.6-.4 1.6-1.1 3.4-1.8 5.2-2.2 42.4-20.6 70-63.8 70-111.9V16c0-8.8 7.2-16 16-16zm-68.9 313.3 47.4-36.9-66.9-102.1c-.8.3-1.7.6-2.5.9-18.9 6.3-35.5 16.8-48.9 30.4.4.5.9 1.1 1.3 1.7l69.7 106.1zM56 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm408 259.5-57 47.2-27.6-55.2.6-32.5-21.4-4.5c-13.2-15-32.9-23.2-53.3-21.5l-11.8 1c-.4-.9-.7-1.9-1-2.9-1.4-6.1.9-12.4 5.8-16.2l60.9-46.8-34.6-68.7c-2.8-5.6-2.1-12.3 1.8-17.2s10.3-7.1 16.3-5.6L417.3 87l32.1-69.8c2.7-5.6 8.4-9.2 14.6-9.2s11.9 3.6 14.5 9.3l32.1 69.8 74.6-18.4c6.1-1.5 12.5.7 16.3 5.6s4.6 11.6 1.8 17.2l-34.6 68.6 60.9 46.8c5 3.8 7.2 10.2 5.8 16.2s-6.2 10.8-12.3 12.1L548 251l1.4 76.8c.1 6.2-3.4 12-9.1 14.7s-12.3 1.9-17.1-2.1l-59.2-49zm0-229.2-23.1 50.2c-3.2 7-10.9 10.7-18.4 8.9l-53.7-13.3 24.9 49.4c3.5 6.9 1.6 15.2-4.5 19.9l-43.8 33.7 54.1 11.3c7.5 1.6 12.9 8.3 12.7 15.9l-1 55.3 42.6-35.2c5.9-4.9 14.5-4.9 20.4 0l42.6 35.2-1-55.3c-.1-7.7 5.2-14.4 12.7-15.9l54.1-11.3-43.8-33.7c-6.1-4.7-8-13-4.5-19.9l24.9-49.4-53.7 13.3c-7.5 1.8-15.2-1.9-18.4-8.9L464 62.3z"
        }
    ]
};

const FalPersonFalling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonFalling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v10.8c0 48.1-27.6 91.3-70 111.9-1.8.4-3.6 1.1-5.2 2.2-.2.1-.4.3-.6.4-3 1.3-6.1 2.4-9.3 3.5C139.1 166.1 96 225.9 96 293.2V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-74.8c0-21.7 5.6-42.5 15.8-60.6l178.8 272.2c4.9 7.4 14.8 9.4 22.2 4.6s9.4-14.8 4.6-22.2l-96.7-147.1 57.5-44.7 67-6.7 74.6 89.5c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5l-74.6-89.5c-6.8-8.2-17.2-12.4-27.8-11.4L312 263l-67.2-102.5c46-27.9 75.2-78.2 75.2-133.7V16zm-37.5 260.4-47.4 36.9-69.7-106.1c-.4-.6-.8-1.1-1.3-1.7 13.4-13.5 30-24.1 48.9-30.4.8-.3 1.7-.6 2.5-.9l66.9 102.1zM96 88a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0z"
        }
    ]
};

const FalPersonFromPortal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonFromPortal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 256c0 37.2-1.4 69-3.9 96h32.1c2.5-27.7 3.8-59.6 3.8-96 0-17-.3-33-.8-48 4 .2 8.1-1.1 11.4-3.9l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2-35.5 106.2c-7.3 21.8 2 45.7 22 57l93.3 52.5-43.6 123.3c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L394.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4.4-.9.5-1.3l37.2-111.6 13.7 47.7c5.9 20.6 24.7 34.8 46.2 34.8H496c8.8 0 16-7.2 16-16s-7.2-16-16-16h-55.9c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6c-12.7-3.2-26.1-3.2-38.8 0l-1.5.4c-12.3 3.1-23.7 9-33.3 17.4l-44.6 39C148.1 46.7 117 0 80 0 35.8 0 0 66.6 0 256s35.8 256 80 256c23.3 0 44.3-18.6 59-64h-34c-12.3 32-23.5 32-25 32-1.6 0-13.6 0-26.4-35.8C40.9 409.1 32 349.5 32 256s8.9-153.1 21.5-188.2C66.4 32 78.4 32 80 32c1.6 0 13.6 0 26.4 35.8C119.1 102.9 128 162.5 128 256zM352 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-73.6 114.1-44.1 132.3-27.4-15.4c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM226 314.1 197.3 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4z"
        }
    ]
};

const FalPersonHalfDress = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonHalfDress",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M157.3 32.1c.9-.1 1.8-.1 2.7-.1 13.3 0 24 10.7 24 24 0 10.7-7.1 19.8-16.8 22.9-2.3.7-4.7 1.1-7.2 1.1-1.8 0-3.5-.2-5.2-.6C144 77.1 136 67.5 136 56c0-12.3 9.3-22.5 21.3-23.9zm9.2 79.5C194.4 108.4 216 84.7 216 56c0-26.7-18.7-49.1-43.8-54.7-3.9-.8-8-1.3-12.2-1.3-5.9 0-11.6.9-16.9 2.6C120.4 9.8 104 31 104 56c0 30.9 25.1 56 56 56 1.4 0 2.7 0 4.1-.1.8-.1 1.6-.1 2.4-.2zM192 320v176c0 8.8 7.2 16 16 16 1 0 2-.1 2.9-.3 1.1-.2 2.2-.5 3.3-1 5.7-2.4 9.8-8.1 9.8-14.7V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-58.9-110.2c-10.8-20.2-29.6-34.6-51.3-39.9V320zm-65.7-56.8c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-64 128c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6H96v96c0 8.8 7.2 16 16 16s16-7.2 16-16V400h32v-32H73.9l52.4-104.8zM160 160v-32c-37.3 0-71.7 20.6-89.3 53.5l-52.8 99c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l52.8-99c12-22.5 35.5-36.6 61-36.6z"
        }
    ]
};

const FalPersonHarassing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonHarassing",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm-24 264h64V161.2c-3.4-.8-6.9-1.2-10.5-1.2h-34.2c-6.8 0-13.3 1.4-19.3 4v156zm179.8-37.6L208 183.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h-64v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.2l-49.9 93.3c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h34.2c23.5 0 45.7 10.3 60.9 28.2l89.8 105.5c5.7 6.7 4.9 16.8-1.8 22.6s-16.8 4.9-22.6-1.8zM304 32h56c8.8 0 16 7.2 16 16s-7.2 16-16 16h-56c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 240a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm88 96c30.9 0 56 25.1 56 56v112c0 30.9-25.1 56-56 56-25.1 0-48.8-11.5-64.4-31.3l-53.5-68.2-52.2 91.4c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l64-112c2.6-4.6 7.4-7.6 12.7-8s10.5 1.9 13.8 6.1l51.4 65.4V344c0-30.9 25.1-56 56-56zm0 192c13.3 0 24-10.7 24-24V344c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24zM265.7 104.8c4-7.9 13.6-11.1 21.5-7.2l48 24c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-48-24c-7.9-4-11.1-13.6-7.2-21.5z"
        }
    ]
};

const FalPersonHiking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonHiking",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm-105.1 72.4c-19 2.5-35 16.1-40.1 35l-22.6 82.9 31.9 5.3 30.8-123.2zm-1.5 138.1c-3 12.1-14.9 19.9-27.2 17.9l-47.9-8c-14-2.3-22.9-16.3-19.2-30L31.9 155c9.5-34.8 41.1-59 77.2-59h4.2c15.6 0 27.1 14.7 23.3 29.8l-35.2 140.7zM368 160c8.8 0 16 7.2 16 16v320c0 8.8-7.2 16-16 16s-16-7.2-16-16V256h-39.2c-10.9 0-21.1-5.6-27-14.8l-20.7-32.5-27.9 124.8 36.6 24.4c8.9 5.9 14.2 15.9 14.2 26.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V384.6l-95-63.3c-16.3-10.8-24.3-30.4-20.4-49.6l19.8-96.5c6.1-29.9 35.1-49.3 65-43.7 20.6 3.9 38.7 16.1 50 33.8l37.4 58.7H352v-48c0-8.8 7.2-16 16-16zM123.7 334.8c.5.4 1.1.8 1.6 1.1l26.4 17.6-40.3 146.7c-2.3 8.5-11.1 13.5-19.7 11.2s-13.5-11.2-11.2-19.7l43.2-157zm68.1-153.2L172 278.1c-1.3 6.4 1.4 12.9 6.8 16.5l29.8 19.9L240.3 173c-5.8-5.1-13-8.6-20.7-10-12.8-2.4-25.1 5.9-27.8 18.6z"
        }
    ]
};

const FalPersonMilitaryPointing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonMilitaryPointing",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 59.1V64h128V37.8L256 59.1zm142.2 36.1c1.2 5.4 1.8 11 1.8 16.8 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.8.6-11.4 1.8-16.8C231.5 92.4 224 83.1 224 72V52.3c0-11.7 8.5-21.7 20.1-23.7l144-24c14.6-2.4 27.9 8.9 27.9 23.7V72c0 11.1-7.5 20.4-17.8 23.2zm-33 .8h-90.5c-1.8 5-2.7 10.4-2.7 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1-11-2.7-16zM32 240c0-8.8 7.2-16 16-16h296.3c40.2 0 77.3 21.5 97.2 56.4l100.4 175.7c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6L416 300.2V464c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V256H48c-8.8 0-16-7.2-16-16zm224 224c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-16H256v16zm128-168c0-4.3-.7-8.5-1.9-12.4L273.8 416H384V296zm-40-40h-88v131.2l104.4-127.7c-5-2.3-10.6-3.5-16.4-3.5z"
        }
    ]
};

const FalPersonMilitaryRifle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonMilitaryRifle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64v-4.9l128-21.3V64H192zm160 8V28.3c0-14.8-13.3-26.1-27.9-23.7l-144 24c-11.6 2-20.1 12-20.1 23.7V72c0 11.1 7.5 20.4 17.8 23.2-1.2 5.4-1.8 11-1.8 16.8 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.8-.6-11.4-1.8-16.8C344.5 92.4 352 83.1 352 72zM210.7 96h90.5c1.8 5 2.7 10.4 2.7 16 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-5.6 1-11 2.7-16zM192 296c0-2.3.2-4.6.6-6.7l109 190.7H208c-8.8 0-16-7.2-16-16V296zm128 151.8-106.9-187c5.6-3 12.1-4.7 18.9-4.7h48c22.1 0 40 17.9 40 40v151.7zm32 16.2V300.2l98.1 171.7c4.4 7.7 14.2 10.3 21.8 6s10.3-14.2 6-21.8L384 291.7l46.9-81.2c8.8-15.3 3.6-34.9-11.7-43.7l16-27.7 32-55.4 8-13.9c4.4-7.7 1.8-17.4-5.9-21.9l-13.9-8c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l-16 27.7-16 27.7-16 27.7c-15.3-8.8-34.9-3.6-43.7 11.7L309.9 228c-9.5-2.6-19.5-4-29.6-4h-48.6c-40.2 0-77.3 21.5-97.2 56.4L34.1 456.1c-4.4 7.7-1.7 17.4 6 21.8s17.4 1.7 21.8-6L160 300.2V464c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48zm-12.6-223.1 36-62.3 27.7 16-38.9 67.3c-7.3-8.2-15.6-15.3-24.8-21zM288 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalPersonMilitaryToPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonMilitaryToPerson",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 33.1v13.7H88v-1.9l88-11.7zM180.8.2l-104 13.9C64.9 15.6 56 25.8 56 37.8v17c0 13.3 10.7 24 24 24h104c13.3 0 24-10.7 24-24V24C208 9.5 195.2-1.7 180.8.2zM352 96.6a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM320 256.5c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v31.8H320v-31.8zm-32 0v31.8c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-31.8c0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64zm-171.5-32H160c17.7 0 32 14.3 32 32v13.2l-75.5-45.2zm44.2 63.8H64v-31.8c0-8.2 3.1-15.6 8.1-21.3l88.7 53.1zM96 192.5c-35.3 0-64 28.7-64 64v31.8c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32v-31.8c0-35.3-28.7-64-64-64H96zM64 96.6c0 35.3 28.7 63.9 64 63.9s64-28.6 64-63.9h-32c0 17.6-14.3 31.9-32 31.9s-32-14.3-32-31.9H64zm82.6 259.6c-6.6-5.9-16.7-5.3-22.6 1.3s-5.3 16.7 1.3 22.6l40.5 35.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h149.9l-40.5 35.9c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l72-63.9c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-72-63.9zm218.8 0-72 63.9c-3.4 3-5.4 7.4-5.4 12s2 8.9 5.4 12l72 63.9c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6l-40.5-35.9H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H346.1l40.5-35.9c6.6-5.9 7.2-16 1.3-22.6s-16-7.2-22.6-1.3z"
        }
    ]
};

const FalPersonPinball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonPinball",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm8 168v55.7c.2 5.1 2.7 9.7 6.9 12.6L80 320.6V180.2c-6.2-2.7-13-4.2-20-4.2-15.5 0-28 12.5-28 28v20zm96 168.4-96-66V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V204c0-33.1 26.9-60 60-60 27.9 0 53.9 14.2 69 37.6l47.7 74.4h29.7l316.4-60.8-41.2-123.7c-1.1-3.3-1.6-6.7-1.6-10.1V32c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80H224v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V288h-15.3c-10.9 0-21-5.5-26.9-14.7L112 214.5v128.1l34.1 23.4c8.7 6 13.9 15.8 13.9 26.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V392.4zm480-213.6V32h-96v29.4l42.6 127.7 53.4-10.3zm0 205.2V211.4l-384 73.8V384h384zm-320-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalPersonPraying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonPraying",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM200.5 176h.9c12.4 0 23.7 7.2 29 18.5l3.1 6.7c-.1.2-.2.5-.3.7l-76.1 182.7-26.7-16.8c-13.1-8.2-18.4-24.6-12.7-39l53.1-132.7c4.9-12.1 16.6-20.1 29.7-20.1zm112 306.5-128-80.6 67.3-161.5 12.4 26.5c9.2 19.7 34.9 24.7 50.8 9.9l95.9-89.1c6.5-6 6.9-16.1.8-22.6s-16.1-6.9-22.6-.8l-95.9 89.1-33.8-72.4c-10.5-22.5-33.1-36.9-58-36.9h-.9c-26.2 0-49.7 15.9-59.4 40.2L88 316.9c-11.5 28.7-.8 61.5 25.3 77.9L248.6 480H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h256c7.1 0 13.4-4.7 15.4-11.6s-.8-14.2-6.8-18z"
        }
    ]
};

const FalPersonPregnant = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonPregnant",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 352h128v-32c0-31.1-22.3-57.1-51.7-62.8-12.9-2.5-23-12.6-25.4-25.5l-6.1-32.5c-4.3-22.7-24.1-39.2-47.2-39.2H176c-26.5 0-48 21.5-48 48v144h64zm1.9-223.9c36.6 2 67.5 28.7 74.3 65.1l6.1 32.5c44.3 8.6 77.7 47.5 77.7 94.3v32c0 17.7-14.3 32-32 32h-64v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384h-64v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384c-17.7 0-32-14.3-32-32V232.1l-33.9 63.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l54.4-101.6a95.9 95.9 0 0 1 84.7-50.8H192c.7 0 1.3 0 1.9.1z"
        }
    ]
};

const FalPersonRays = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonRays",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0zm502.6 0c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zm-480 502.6 96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm480 0c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0zM232 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-68.7 104h25.4c6.8 0 13.3 1.4 19.3 4v156h-64V164c6-2.6 12.5-4 19.3-4zM224 496V352h64v144c0 8.8 7.2 16 16 16s16-7.2 16-16V202.2l49.9 93.4c4.2 7.8 13.9 10.7 21.7 6.6s10.7-13.9 6.6-21.7l-58.9-110.2c-13.9-26-41-42.3-70.6-42.3h-25.4c-29.5 0-56.7 16.3-70.6 42.3l-58.8 110.2c-4.2 7.8-1.2 17.5 6.6 21.7s17.5 1.2 21.7-6.6l49.8-93.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalPersonRifle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonRifle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M260.7 192c28.3 0 55.1 10.7 75.3 29.1v275.1c-.1 8.7-7.2 15.8-16 15.8s-16-7.2-16-16V236.7c-12.7-8.2-27.7-12.7-43.3-12.7h-41.4c-15.7 0-30.7 4.6-43.3 12.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V275.8L62.3 439.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5L119.1 254c19-37.9 57.8-61.9 100.2-61.9h41.3zM288 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm320 256v14.2l3.9 17.8H528c8.8 0 16 7.2 16 16s-7.2 16-16 16h-36.9l7.1 32 9.1 41.1 4.3 19.5c1.1 4.7-.1 9.7-3.1 13.5s-7.6 6-12.5 6h-96c-8.8 0-16-7.2-16-16V393.9l-2.7-1.4c-8.1-4.1-13.3-12.4-13.3-21.5V221c0-9.1 5.1-17.4 13.3-21.5l2.7-1.4V160c0-17.7 14.3-32 32-32V32c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c8.8 0 16 7.2 16 16v112c17.7 0 32 14.3 32 32v128l32-8v-72c0-8.8 7.2-16 16-16s16 7.2 16 16v84.5c0 6.9-4.4 13-10.9 15.2l-.9.3-52.2 17.3V336zm-27.3 38.9-1.5-6.9-2.4-10.8-.4-1.7c-.3-1.1-.4-2.3-.4-3.5V160h-32v48c0 6-3.4 11.6-8.8 14.3l-7.2 3.6v140.2l7.2 3.6c5.4 2.7 8.8 8.2 8.8 14.3v96h60.1l-7.1-32-9.1-41.1-1.5-6.9-5.6-25.1z"
        }
    ]
};

const FalPersonRunningFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonRunningFast",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-156.6 60.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5.4c-12.3 3.1-23.7 9-33.3 17.4L149.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2-35.5 106.2c-7.3 21.8 2 45.7 22 57l93.3 52.5-43.6 123.3c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L394.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4.4-.9.5-1.3l37.2-111.6 13.7 47.7c5.9 20.6 24.7 34.8 46.2 34.8H496c8.8 0 16-7.2 16-16s-7.2-16-16-16h-55.9c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7-44.1 132.3-27.4-15.4c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM226 314.1 197.3 384H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM16 95.8c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm-16 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalPersonRunning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonRunning",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM140.6 116.4c12.7-3.2 26.1-3.2 38.8 0L274 140c16.6 4.2 29.8 16.9 34.5 33.4l20.3 71c2 6.9 8.2 11.6 15.4 11.6H400c8.8 0 16 7.2 16 16s-7.2 16-16 16h-55.9c-21.4 0-40.3-14.2-46.2-34.8l-13.6-47.7-37.1 111.6c-.2.5-.3.9-.5 1.3l37.5 21.1c13.6 7.6 19.7 23.9 14.5 38.5l-43.6 123.3c-2.9 8.3-12.1 12.7-20.4 9.8s-12.7-12.1-9.8-20.4l43.5-123.3-93.3-52.5c-20-11.3-29.3-35.2-22-57l35.4-106.2-16.9-4.2c-7.6-1.9-15.6-1.9-23.3 0l-1.5.4c-7.4 1.8-14.2 5.4-20 10.4L74.5 204c-6.7 5.8-16.8 5.1-22.6-1.5s-5.1-16.8 1.5-22.6l52.4-45.8c9.6-8.4 21-14.3 33.3-17.4l1.5-.4zm79.1 43.1L183.5 268c-2.4 7.3.7 15.2 7.3 19l27.5 15.4 44.1-132.3-42.7-10.7zM101.3 384l28.7-69.9c5.9 10 14.1 18.7 24.1 25.4l-23.3 56.6c-4.9 12-16.6 19.8-29.6 19.8H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h85.3z"
        }
    ]
};

const FalPersonSeatReclined = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSeatReclined",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 88a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm24 56a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-120.2-2.6 34.6 207.8c6.4 38.6 39.8 66.8 78.9 66.8H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H177.3c-54.8 0-101.5-39.6-110.5-93.6L32.2 146.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2zm120.4 98.5 11.1 66.7c1.3 7.7 8 13.4 15.8 13.4h42l-12.9-77.2-.1-.4-1.9-11.6c-2.2-13.2-13.6-22.9-27-22.9-16.9 0-29.8 15.2-27 31.9zm27-63.9c28.5 0 52.9 20.2 58.3 48H336c8.8 0 16 7.2 16 16s-7.2 16-16 16h-61.1l10.7 64h33.2c26.7 0 50.6 16.5 59.9 41.5L410 445l50.2-12.5c8.6-2.1 17.3 3.1 19.4 11.6s-3.1 17.3-11.6 19.4l-64 16c-7.9 2-16-2.3-18.9-9.9l-36.3-96.9c-4.7-12.5-16.6-20.8-30-20.8H211.1c-23.5 0-43.5-17-47.3-40.1l-11.1-66.7c-6-36.2 21.9-69.2 58.6-69.2z"
        }
    ]
};

const FalPersonSeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSeat",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 88a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-24-56a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM32 144c0-8.8-7.2-16-16-16s-16 7.2-16 16v192c0 61.9 50.1 112 112 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-44.2 0-80-35.8-80-80V144zm116 64c15.5 0 28 12.5 28 28v92h-40c-8.8 0-16-7.2-16-16v-76c0-15.5 12.5-28 28-28zm58.8 16c-5.6-27.4-29.8-48-58.8-48-33.1 0-60 26.9-60 60v76c0 26.5 21.5 48 48 48h96.6c15.3 0 28.4 10.8 31.4 25.7l16.3 81.4c1.5 7.5 8.1 12.9 15.7 12.9h72c8.8 0 16-7.2 16-16s-7.2-16-16-16h-58.9l-13.7-68.6c-6-29.9-32.2-51.4-62.8-51.4H208v-72h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-65.2z"
        }
    ]
};

const FalPersonShelter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonShelter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264.2 2.3c-5.1-3-11.4-3-16.5 0l-240 144C2.9 149.2 0 154.4 0 160v336c0 8.8 7.2 16 16 16s16-7.2 16-16V169.1L256 34.7l224 134.4V496c0 8.8 7.2 16 16 16s16-7.2 16-16V160c0-5.6-2.9-10.8-7.8-13.7l-240-144zM240 168a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-72 97.5c3.8-1 7.7-1.5 11.8-1.5h24.5c4 0 8 .5 11.8 1.5V368H232V265.5zm0 134.5h48v96c0 8.8 7.2 16 16 16s16-7.2 16-16V291.5l42.4 68.9c4.6 7.5 14.5 9.9 22 5.2s9.9-14.5 5.2-22l-45.3-73.5C321.8 246.4 296 232 268.2 232h-24.4c-27.8 0-53.6 14.4-68.1 38.1l-45.3 73.5c-4.6 7.5-2.3 17.4 5.2 22s17.4 2.3 22-5.2l42.4-68.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalPersonSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M421.5 1c8.3 3.1 12.5 12.3 9.5 20.5l-7.3 19.8L494 66.9c12.5 4.5 18.9 18.3 14.3 30.8l-38.2 105.2c-4.5 12.5-18.3 18.9-30.8 14.3l-70.9-25.8L319 325.5c-3.1 8.3-12.3 12.5-20.5 9.5s-12.5-12.3-9.5-20.5l20.5-55.8-33.9-11.3c-18.9-6.3-35.8-17.5-48.9-32.5L208 193.4v138.2l41.2 68.6c4.5 7.5 6.8 16 6.8 24.7V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-71.1c0-2.9-.8-5.7-2.3-8.2L182.9 352H112v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V211.8l-49.7 99.4c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5L56 188.2c13.6-27.1 41.3-44.2 71.6-44.2H171c23.1 0 45 10 60.2 27.3l19.7 22.5c9.4 10.7 21.4 18.7 34.9 23.2l34.8 11.6 17.7-48.2-64.4-23.4c-12.5-4.5-18.9-18.3-14.3-30.8l38.3-105.1c4.5-12.5 18.3-18.9 30.8-14.3l65 23.7 7.3-20c3-8.3 12.2-12.6 20.5-9.5zM112 178.6V320h64V176.3c-1.7-.2-3.3-.3-5-.3h-43.4c-5.4 0-10.6.9-15.6 2.6zM144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm181.2 39.5-32.8 90.2 150.4 54.7 32.8-90.2-150.4-54.7z"
        }
    ]
};

const FalPersonSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSimple",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm-6.2 172-4.1 49.3C52.1 304 66.8 320 85.6 320h84.9c18.7 0 33.4-16 31.9-34.7l-4.2-49.3c-2.1-24.9-22.9-44-47.8-44h-44.8c-25 0-45.8 19.1-47.8 44zm-31.9-2.7C29.3 191.9 64 160 105.6 160h44.8c41.6 0 76.3 31.9 79.7 73.4l4.1 49.3c2.5 29.8-15.7 56.1-42.2 65.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H96v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V348.3c-26.5-9.5-44.7-35.8-42.2-65.6l4.1-49.3z"
        }
    ]
};

const FalPersonSkating = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSkating",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M392 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM135.2 478.3l-6.2 3.1c-21.6 10.8-47.6 6.6-64.6-10.5L4.7 411.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l59.6 59.6c7.3 7.3 18.5 9.1 27.7 4.5l6.2-3.1c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zm280.4-10.4-.4 1.7c-6.2 24.9-28.6 42.4-54.3 42.4H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h88.8c11 0 20.6-7.5 23.3-18.2l.4-1.7c2.1-8.6 10.8-13.8 19.4-11.6s13.8 10.8 11.6 19.4zM274.7 144H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h204.2c28.6 0 51.8 23.2 51.8 51.8 0 18.2-9.5 35-25.1 44.4l-90.1 54 57.8 57.8c6 6 9.4 14.1 9.4 22.6V432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-89.4l-70.5-70.5a59.787 59.787 0 0 1-17.5-42.3c0-18.8 8.9-36.5 23.9-47.8l50.8-38zm49.9 1.9c-.9 1.1-1.9 2.1-3 2.9l-78.5 58.9c-7 5.2-11.1 13.5-11.1 22.2 0 2.4.3 4.7.9 6.9l93.5-56.1c5.9-3.6 9.6-10 9.6-16.9 0-7.9-4.7-14.8-11.4-17.9zM180.8 276.6c3.9 6.6 8.7 12.8 14.2 18.3l6.4 6.4-94.1 94.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96.1-96.1z"
        }
    ]
};

const FalPersonSkiJumping = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSkiJumping",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm-240 56c0-8.8 7.2-16 16-16h179.2c24.8 0 44.8 20.1 44.8 44.8 0 18.1-10.8 34.3-27.5 41.3L207 231.5c-1.6 2.4-3 4.9-4.2 7.5l-60.2 135.5c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l60.2-135.4c2.6-5.9 6-11.5 9.9-16.6.5-.7 1-1.3 1.5-1.9.3-.4.6-.7.9-1.1l67.3-78.5H128c-8.8 0-16-7.2-16-16zm183.4 16-42.5 49.6 59.3-24.9c4.8-2 7.9-6.7 7.9-11.8 0-7.1-5.7-12.8-12.8-12.8h-11.9zM496 176c8.8 0 16 7.2 16 16v7.3c0 35.9-20 68.8-51.9 85.3L23.3 510.2c-7.9 4.1-17.5 1-21.6-6.9s-1-17.5 6.9-21.6l436.8-225.6c21.3-11 34.6-32.9 34.6-56.9V192c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalPersonSkiLift = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSkiLift",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c8.8 0 16 7.2 16 16v194.8c-1.9.3-3.7.6-5.6 1.1l-26.4 6.6V16c0-8.8 7.2-16 16-16zM104.8 177.7c7.9-4 17.5-.7 21.5 7.2l42.3 84.5L274.2 243c15.1-3.8 29.8 7.7 29.8 23.3v136.5l150.7-59.7c15.3-6 25.3-20.8 25.3-37.2V304c0-8.8 7.2-16 16-16s16 7.2 16 16v1.9c0 29.5-18 56.1-45.5 66.9l-348.6 138c-8.2 3.3-17.5-.8-20.8-9s.8-17.5 9-20.8L272 415.5v-139l-95.7 23.9c-14.6 3.6-29.7-3.3-36.4-16.7l-42.2-84.5c-4-7.9-.7-17.5 7.2-21.5zM9.1 161.6c8-3.8 17.5-.5 21.3 7.5L103.3 321c10 20.9 33.5 31.6 55.9 25.5l36.5-10c8.5-2.3 17.3 2.7 19.6 11.2s-2.7 17.3-11.2 19.6l-36.5 10c-37.3 10.2-76.5-7.7-93.2-42.6L1.6 182.9c-3.8-8-.5-17.5 7.5-21.3zM128 88a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0z"
        }
    ]
};

const FalPersonSkiingNordic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSkiingNordic",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-156.6 60.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5.4c-12.3 3.1-23.7 9-33.3 17.4L117.5 180c-6.7 5.8-7.3 15.9-1.5 22.6 1.5 1.7 3.3 3.1 5.3 4l-57 270.1c-.2 1.1-.3 2.2-.3 3.3H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h496c35.3 0 64-28.7 64-64v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 17.7-14.3 32-32 32h-79.8l29.5-192h2.3c8.8 0 16-7.2 16-16s-7.2-16-16-16h-55.9c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zM96.4 480 158 187l32.9-28.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2-35.4 106.3c-7.3 21.8 2 45.7 22 57l93.3 52.5L292.7 480H167.2l52.9-139.2c-10.2-6.4-18.6-14.9-24.8-24.7L133 480H96.4zm303.8-2.4c-.1.8-.2 1.6-.2 2.4h-73.4l36-102c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4.4-.9.5-1.3l37.2-111.6 13.7 47.7c5.9 20.6 24.7 34.8 46.2 34.8h21.2l-29.2 189.6zm-73.8-307.5-44.1 132.3-27.4-15.4c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7z"
        }
    ]
};

const FalPersonSkiing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSkiing",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M424 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM1.7 280.8c4-7.9 13.6-11.1 21.5-7.1l213.2 107.2 70-83.9-95-95c-8-8-12.5-17.9-13.7-28.1l59 28.1 72.3 72.4c11.7 11.7 12.6 30.4 2 43.1l-65.1 78.2 153.2 77c14 7 30.3 7.9 44.9 2.4l26.5-10c8.3-3.1 17.5 1.1 20.6 9.3s-1.1 17.5-9.3 20.6l-26.5 10c-23 8.7-48.6 7.3-70.6-3.7L8.8 302.3c-7.9-4-11.1-13.6-7.1-21.5zM118.9 65.6l18.1 8.6 8.7-17.3c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5L165.9 88l67.5 32.2L300.2 85c27.6-14.5 61.6.8 69 31.1l18.9 77.6 66.5 31.8.2.1c4.9 2.3 8 6.8 8.9 11.8.5 3.1.1 6.5-1.3 9.6-3.8 8-13.4 11.3-21.3 7.5l-.2-.1-289.3-137.8-9.3 18.6c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l9-18-17.6-8.4c-8-3.8-11.4-13.3-7.6-21.3s13.3-11.4 21.3-7.6zm150.6 71.7 81.4 38.8-12.8-52.4c-2.5-10.1-13.8-15.2-23-10.4l-45.6 24z"
        }
    ]
};

const FalPersonSledding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSledding",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M392 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM1.7 248.8c4-7.9 13.6-11.1 21.5-7.1L419 440.6c14 7 30.3 7.9 44.9 2.4l26.5-10c8.3-3.1 17.5 1.1 20.6 9.3s-1.1 17.5-9.3 20.6l-26.5 10c-23 8.7-48.6 7.3-70.6-3.7L8.8 270.3c-7.9-4-11.1-13.6-7.1-21.5zM160 144h160c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L230.6 272H344c13.3 0 24 10.7 24 24v72c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64H230.6c-28.5 0-42.8-34.5-22.6-54.6l73.4-73.4H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalPersonSnowboarding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSnowboarding",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M221.3 7.1c-4.9-7.4-14.8-9.3-22.2-4.4s-9.3 14.8-4.4 22.2l40.6 61c7.1 10.6 18 17.9 30.5 20.4l37 7.4-83.3 39.2c-16.8 7.9-27.6 24.8-27.6 43.4v83.1L103 338.7c-4.2 2.8-6.6 7.2-7.1 11.8L77 343.1c-7.5-3-14.2-7.8-19.4-14l-29.3-35.3c-5.7-6.8-15.7-7.7-22.5-2s-7.7 15.7-2 22.5l29.5 35.4c8.5 10.3 19.6 18.3 32.2 23.2l341.4 133.6c9.3 3.6 19.2 5.5 29.2 5.5H480c8.8 0 16-7.2 16-16s-7.2-16-16-16h-43.9c-6 0-11.9-1.1-17.5-3.3l-92.9-36.4c.4-.6.7-1.3 1-1.9l41-93.8c11.7-26.8 3.8-58.2-19.3-76.2l-38.8-30.2 96.1-54.1 80 68c6.7 5.7 16.8 4.9 22.6-1.8s4.9-16.8-1.8-22.6l-141-119.9c-3.7-3.1-7.6-6-11.6-8.6-.8-.6-1.6-1.1-2.4-1.5-11.2-6.9-23.6-11.7-36.6-14.3l-42.6-8.5c-4.2-.8-7.8-3.3-10.2-6.8l-40.6-61zm60.8 209.8-46.6-36.2 106.8-50.3c.8.6 1.5 1.2 2.2 1.8l35 29.8-97.5 54.8zm-58.1-4.6 104.7 81.4c11.6 9 15.5 24.7 9.7 38.1l-41 93.8c-.5 1.1-.8 2.2-1 3.3l-170.7-66.8 84-56c8.9-5.9 14.2-15.9 14.2-26.6v-67.2zM424 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
        }
    ]
};

const FalPersonSnowmobiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSnowmobiling",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm159.8 18.3c7.6-4.5 17.4-2.1 21.9 5.5l43.8 73 156.8 78.4c10.8 5.4 17.7 16.5 17.7 28.6v59.1c0 10.7-5.3 20.7-14.2 26.6l-76.1 50.8 63.1 82 1.2 1.8h19.5l43.3-43.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-48 48c-3 3-7.1 4.7-11.3 4.7H432c-8.8 0-16-7.2-16-16s7.2-16 16-16h77.7l-61.5-80H313.3c4.3 9.8 6.7 20.6 6.7 32 0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80 0-26.2 12.6-49.4 32-64l39.2-78.3c5.4-11 16.5-17.8 28.6-17.8H288l36-48h-44c-5 0-9.8-2.4-12.8-6.4l-33.4-44.5c-6.2-8.2-15.9-13.1-26.2-13.1-12.9 0-24.6 7.6-29.9 19.4l-19.1 43.1c-3.6 8.1-13 11.7-21.1 8.1s-11.7-13-8.1-21.1l19.1-43.1c10.4-23.4 33.6-38.4 59.1-38.4 20.4 0 39.5 9.6 51.8 25.9L288 192h60l22.1-29.4-39.8-66.4c-4.5-7.6-2.1-17.4 5.5-22zM470.3 368l73.7-49.1v-59.1l-150.4-75.2-80 106.6c-6 8.1-15.5 12.8-25.6 12.8H99.8l-24.1 48.1c1.4-.1 2.8-.1 4.3-.1h160c18 0 34.6 6 48 16h182.3zM80 384c-26.5 0-48 21.5-48 48s21.5 48 48 48h160c26.5 0 48-21.5 48-48s-21.5-48-48-48H80z"
        }
    ]
};

const FalPersonSwimming = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonSwimming",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm29.8 122.8c-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 384.1 0 390.4 0 398.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 374 404.9 384 384 384s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 374 212.9 384 192 384s-41.7-9.9-58.2-21.2zM258.4 185l153.9 130.5c10.7-3.5 21.4-8.8 30.9-15.4l.2-.2-163-138.3C309.5 140.5 345.3 128 384 128h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80c-114.9 0-208 93.1-208 208v14.8c5.5 1.1 10.9 1.7 16 1.7 5.4 0 10.7-.5 16-1.6V304c0-46.8 18.3-89.4 48.1-121l2.3 2z"
        }
    ]
};

const FalPersonThroughWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonThroughWindow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h80v-70.4c0-70.6 41.2-134.7 105.3-164.1 52.8-24.2 86.7-77 86.7-135.1V32H48zm304 14.4c0 63.8-33.6 122.3-87.4 154.7l63.5 86.9h64.5c9.3 0 18.2 4.1 24.3 11.2l91.2 106.4L517 416h75c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H352v14.4zM367 416h107.9l-82.3-96h-51.3l-54 40.5 93.5 126c5.3 7.1 3.8 17.1-3.3 22.4s-17.1 3.8-22.4-3.3L312.5 448H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h544c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H390.5L367 416zm-98.7-81.2 35.1-26.3-67.6-92.4c-13.2 7.4-25.1 16.7-35.2 27.5l67.7 91.2zm-87.8-64.6c-13.2 22.4-20.6 48.3-20.6 75.4V416h128.8L180.6 270.2zM168 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0z"
        }
    ]
};

const FalPersonToDoor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonToDoor",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-156.6 60.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5.4c-12.3 3.1-23.7 9-33.3 17.4L53.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2-35.5 106.2c-7.3 21.8 2 45.7 22 57l93.3 52.5-43.6 123.3c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L298.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4.4-.9.5-1.3l37.2-111.6 13.7 47.7c5.9 20.6 24.7 34.8 46.2 34.8H400c8.8 0 16-7.2 16-16s-7.2-16-16-16h-55.9c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7-44.1 132.3-27.4-15.4c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM130 314.1 101.3 384H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zM528 32c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16V317.3c-5 1.8-10.4 2.7-16 2.7h-16v144c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v176h16c5.6 0 11 1 16 2.7V48c0-8.8 7.2-16 16-16h96z"
        }
    ]
};

const FalPersonToPortal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonToPortal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zm-156.6 60.4c-12.7-3.2-26.1-3.2-38.8 0l-1.5.4c-12.3 3.1-23.7 9-33.3 17.4L53.5 180c-6.7 5.8-7.3 15.9-1.5 22.6s15.9 7.3 22.6 1.5l52.4-45.8c5.7-5 12.6-8.6 20-10.4l1.5-.4c7.6-1.9 15.6-1.9 23.3 0l16.9 4.2-35.5 106.2c-7.3 21.8 2 45.7 22 57l93.3 52.5-43.6 123.3c-2.9 8.3 1.4 17.5 9.8 20.4s17.5-1.4 20.4-9.8L298.6 378c5.2-14.7-.9-30.9-14.5-38.5l-37.5-21.1c.2-.4.4-.9.5-1.3l37.2-111.6 13.7 47.7c5.9 20.6 24.7 34.8 46.2 34.8H400c8.8 0 16-7.2 16-16s-7.2-16-16-16h-55.9c-7.1 0-13.4-4.7-15.4-11.6l-20.3-71c-4.7-16.5-17.9-29.2-34.5-33.4l-94.5-23.6zm83 53.7-44.1 132.3-27.4-15.4c-6.7-3.8-9.8-11.7-7.3-19l36.2-108.6 42.7 10.7zM130 314.1 101.3 384H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c13 0 24.7-7.8 29.6-19.8l23.3-56.6c-10-6.7-18.2-15.5-24.1-25.4zm328.5 130.1C445.6 480 433.6 480 432 480c-1.6 0-13.6 0-26.4-35.8-9.4-26.3-16.8-66.4-19.9-124.2h-32c7.3 140.7 39.7 192 78.4 192 44.2 0 80-66.6 80-256S476.2 0 432 0c-41.6 0-75.8 59-79.6 224h32c1.8-75.3 10.1-125.3 21.2-156.2C418.4 32 430.4 32 432 32c1.6 0 13.6 0 26.4 35.8C471.1 102.9 480 162.5 480 256s-8.9 153.1-21.5 188.2z"
        }
    ]
};

const FalPersonWalkingArrowLoopLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonWalkingArrowLoopLeft",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8l-30.7-107.4c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5 32.7-104.5c2.5-.2 5-.3 7.5-.3 15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.7 61.6-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9.7-17.5-7.2-21.5zm334.6 90.6c6.8 5.7 16.9 4.7 22.5-2s4.7-16.9-2-22.5l-62-51.8H488c83.9 0 152-68.1 152-152S571.9 64 488 64H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h152c66.3 0 120 53.7 120 120s-53.7 120-120 120h-75.8l62.1-51.7c6.8-5.7 7.7-15.7 2-22.5s-15.7-7.7-22.5-2l-96 80c-3.6 3-5.8 7.5-5.8 12.3s2.1 9.3 5.8 12.3l96 80z"
        }
    ]
};

const FalPersonWalkingArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonWalkingArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8l-30.7-107.4c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5 32.7-104.5c2.5-.2 5-.3 7.5-.3 15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.7 61.6-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9.7-17.5-7.2-21.5zm419.1-190c-6.8-5.7-16.9-4.7-22.5 2s-4.7 16.9 2 22.5l62.1 51.8H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h195.8l-62.1 51.7c-6.8 5.7-7.7 15.7-2 22.5s15.7 7.7 22.5 2l96-80c3.6-3 5.8-7.5 5.8-12.3s-2.1-9.3-5.8-12.3l-96-80z"
        }
    ]
};

const FalPersonWalkingDashedLineArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonWalkingDashedLineArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zM117.6 172.3c1.3-.7 2.6-1.4 3.9-2L95 255.2c-5.7 18.2 0 38.1 14.4 50.6L209.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8l-30.7-107.4c-1.7-6-5.1-11.3-9.8-15.4L187.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5 32.7-104.5c2.5-.2 5-.3 7.5-.3 15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.7 61.6-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9.7-17.5-7.2-21.5zM416 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V16zm122.2 147.7c-6.8-5.7-16.9-4.7-22.5 2s-4.7 16.9 2 22.5l62.1 51.8H384c-8.8 0-16 7.2-16 16s7.2 16 16 16h195.8l-62.1 51.7c-6.8 5.7-7.7 15.7-2 22.5s15.7 7.7 22.5 2l96-80c3.6-3 5.8-7.5 5.8-12.3s-2.1-9.3-5.8-12.3l-96-80zM400 128c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm16 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32zm-16 80c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalPersonWalkingLuggage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonWalkingLuggage",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 56a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm80 0a56 56 0 1 0-112 0 56 56 0 1 0 112 0zM341.6 172.3c1.3-.7 2.6-1.4 3.9-2l-26.6 85c-5.7 18.2 0 38.1 14.4 50.6L433.9 393l30.7 107.4c2.4 8.5 11.3 13.4 19.8 11s13.4-11.3 11-19.8l-30.7-107.4c-1.7-6-5.1-11.3-9.8-15.4L411.3 331l37.8-109.2 8.8 26.4c5.6 16.9 16.7 31.4 31.5 41.3l29.7 19.8c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2l-29.7-19.8c-8.9-5.9-15.5-14.6-18.9-24.8l-17.1-51.4c-11.7-35-44.5-58.7-81.4-58.7-22.1 0-43.9 5.6-63.4 16.2l-12.7 6.9c-35.3 19.3-61 52.4-70.7 91.5l-2.4 9.5c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l2.4-9.6c7.6-30.4 27.5-56.2 55-71.2l12.7-6.9zm7.9 92.5 32.7-104.5c2.5-.2 5-.3 7.5-.3 15.9 0 30.5 7 40.6 18.4l-45 130-30.9-26.8c-4.8-4.2-6.7-10.8-4.8-16.9zm-6.4 88.9c-7.9-4-17.5-.7-21.5 7.2l-30.8 61.7-62.2 62.2c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l62.2-62.2c2.4-2.4 4.5-5.2 6-8.3l30.8-61.7c4-7.9.7-17.5-7.2-21.5zm-94.8-63.4c-7.5-4.6-17.4-2.2-22 5.3L201.1 337c-.6-.4-1.1-.7-1.7-1.1L144 304c-15.3-8.8-34.9-3.6-43.7 11.7l-64 110.9c-8.8 15.3-3.6 34.9 11.7 43.7l55.4 32c15.3 8.8 34.9 3.6 43.7-11.7l36.3-62.9 70.2-115.3c4.6-7.5 2.2-17.4-5.3-22zM118 473.7l-54-31.1 64-110.9 55.4 32-27.5 47.6-38 62.4z"
        }
    ]
};

const FalPersonWalkingWithCane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonWalkingWithCane",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M184 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-30.4 32c-31.6 0-60.3 18.6-73.1 47.5l-47.1 106c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l47.1-106c2.5-5.6 6-10.6 10.3-14.8v96c0 17 9 32.7 23.7 41.4L256 393.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16V393.2c0-11.3-6-21.8-15.8-27.6l-32.2-19V190.4c2.1 2.1 4 4.5 5.7 7l77 115.5c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-77-115.5c-14.8-22.3-39.8-35.6-66.6-35.6h-52.1zM152 285.7V176h53.8c.8 0 1.5 0 2.3.1v151.7L160 299.5c-4.9-2.9-7.9-8.1-7.9-13.8zM96.6 491.8c-2.3 8.5 2.7 17.3 11.2 19.6s17.3-2.7 19.6-11.2l34.2-125.4-28.5-16.8-36.5 133.8zm354.3 13.3c5 7.3 15 9.1 22.3 4s9.1-15 4-22.3L372.3 335.4c-2.8 3.2-6 6.1-9.7 8.5-5.7 3.8-11.9 6.2-18.3 7.3l106.5 153.9z"
        }
    ]
};

const FalPersonWalking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPersonWalking",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-78.5 170.2c-1.3.6-2.6 1.3-3.9 2l-12.7 6.9c-27.5 15-47.4 40.8-55 71.2l-2.4 9.6c-2.1 8.6-10.8 13.8-19.4 11.6s-13.8-10.8-11.6-19.4l2.4-9.5c9.8-39 35.4-72.2 70.7-91.5l12.7-6.9c19.4-10.6 41.2-16.2 63.4-16.2 36.9 0 69.7 23.6 81.4 58.7l17.1 51.4c3.4 10.1 10 18.8 18.9 24.8l29.7 19.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-29.7-19.8c-14.8-9.9-25.9-24.4-31.5-41.3l-8.8-26.4L187.3 331l43.6 37.8c4.7 4.1 8.1 9.4 9.8 15.4l30.7 107.4c2.4 8.5-2.5 17.4-11 19.8s-17.4-2.5-19.8-11L209.9 393l-100.5-87.2c-14.5-12.5-20.1-32.4-14.4-50.6l26.6-85zm36.6-9.9-32.6 104.5c-1.9 6.1 0 12.7 4.8 16.9l30.9 26.8 45-130c-10-11.5-24.7-18.4-40.6-18.4-2.5 0-5 .1-7.5.3zm-31.8 214.9-30.8 61.6c-1.5 3.1-3.6 5.9-6 8.3l-62.2 62.2c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l62.2-62.2 30.8-61.7c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5z"
        }
    ]
};

const FalPerson = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPerson",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-32 164v156h64V164c-6-2.6-12.5-4-19.3-4h-25.4c-6.8 0-13.3 1.4-19.3 4zm0 188v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1l-49.9 93.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l58.8 110.2c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L224 202.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h-64z"
        }
    ]
};

const FalPesetaSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPesetaSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72.7 32C50.2 32 32 50.2 32 72.7V160H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v272c0 8.8 7.2 16 16 16s16-7.2 16-16V320h144c74.1 0 135.2-56 143.1-128H368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16.9c-8-72-69-128-143.1-128H72.7zm246.2 128H64V72.7c0-4.8 3.9-8.7 8.7-8.7H208c56.4 0 103.1 41.7 110.9 96zM64 192h254.9c-7.8 54.3-54.4 96-110.9 96H64v-96z"
        }
    ]
};

const FalPesoSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPesoSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M71.4 32C49.6 32 32 49.6 32 71.4V128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v208c0 8.8 7.2 16 16 16s16-7.2 16-16V352h128c65.6 0 122-39.5 146.7-96H368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-19.2c2.1-10.3 3.2-21 3.2-32s-1.1-21.7-3.2-32H368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-29.3C314 71.5 257.6 32 192 32H71.4zm231.5 96H64V71.4c0-4.1 3.3-7.4 7.4-7.4H192c47.4 0 88.7 25.7 110.9 64zM64 160h252c2.6 10.2 4 21 4 32s-1.4 21.8-4 32H64v-64zm238.9 96c-22.1 38.3-63.5 64-110.9 64H64v-64h238.9z"
        }
    ]
};

const FalPhoneArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneArrowDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 27.3 342.6 192H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v89.4L484.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.3-.4h-.1c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4-50.9-29.5-93.3-71.9-122.7-122.7-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 229.6 186.1 415.8 415.7 416h.3z"
        }
    ]
};

const FalPhoneArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneArrowRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m411.3 4.7 96 96c6.2 6.2 6.2 16.4 0 22.6l-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l68.7-68.7H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h153.4l-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-82.3 282c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.3-.4h-.1c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4-50.9-29.5-93.3-71.9-122.7-122.7-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 229.6 186.1 415.8 415.7 416h.3z"
        }
    ]
};

const FalPhoneArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneArrowUpRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M292.7 196.7 457.4 32H368c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6L315.3 219.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zm36.4 90c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.3-.4h-.1c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4-50.9-29.5-93.3-71.9-122.7-122.7-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 229.6 186.1 415.8 415.7 416h.3z"
        }
    ]
};

const FalPhoneFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136.2 275.2c16.4-7 35.4-2.4 46.7 11.4l33.2 40.6c46-26.7 84.4-65.1 111.1-111.1L286.7 183c-13.8-11.3-18.5-30.3-11.4-46.7l48-112C330.8 6.7 349.7-3.1 368.4.9l112 24C498.8 28.8 512 45.1 512 64c0 236.7-183.5 430.5-416 446.9-4.5.3-9.1.6-13.7.8h-.1c-6.1.2-12.1.4-18.3.4-18.9 0-35.2-13.2-39.1-31.6l-24-112c-4-18.7 5.8-37.6 23.4-45.1l112-48zM64.3 480C293.9 479.8 480 293.7 480 64c0-3.8-2.6-7-6.3-7.8l-112-24c-3.7-.8-7.5 1.2-9 4.7l-48 112c-1.4 3.3-.5 7.1 2.3 9.3l40.6 33.2c12.1 9.9 15.3 27.2 7.4 40.8-29.5 50.9-71.9 93.3-122.7 122.7-13.6 7.9-30.9 4.7-40.8-7.4l-33.2-40.6c-2.3-2.8-6.1-3.7-9.3-2.3l-112 48c-3.5 1.5-5.5 5.3-4.7 9l24 112c.8 3.7 4 6.3 7.8 6.3h.3z"
        }
    ]
};

const FalPhoneHangup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneHangup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128c-134.4 0-234.1 68.7-281.2 117-7.2 7.4-8.9 19.3-3.5 30.5l38.3 78.6c3.3 6.7 10.7 10.3 18 8.6l88-20.5c7.2-1.7 12.4-8.1 12.4-15.6V240c0-7.1 4.7-13.4 11.6-15.4l32.9-9.4a303.81 303.81 0 0 1 167 0l32.9 9.4c6.9 2 11.6 8.2 11.6 15.4v86.6c0 7.4 5.1 13.9 12.4 15.6l88 20.5c7.3 1.7 14.7-1.9 18-8.6l38.3-78.6c5.5-11.2 3.7-23.2-3.5-30.5-47.1-48.3-146.8-117-281.2-117zM15.9 222.6C67.2 170.1 174.6 96 320 96s252.8 74.1 304.1 126.6c18.1 18.5 19.8 45.6 9.3 66.9l-38.3 78.6c-9.8 20.1-32.2 30.8-54 25.7l-88-20.5c-21.7-5.1-37.1-24.4-37.1-46.8v-74.4l-21.3-6.1c-48.8-14-100.6-14-149.4 0l-21.3 6.1v74.5c0 22.3-15.4 41.7-37.1 46.8l-88 20.5c-21.8 5.1-44.2-5.6-54-25.7L6.5 289.5c-10.4-21.3-8.7-48.4 9.3-66.9z"
        }
    ]
};

const FalPhoneIntercom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneIntercom",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 64c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm400 32c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h224zM224 32c-35.3 0-64 28.7-64 64v320c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H224zm32 320a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm32-32c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-96-256h160v96H256v-96zm-32 0v96c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalPhoneMissed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneMissed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 0c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6l98.7 98.7C251.5 178.1 285 192 320 192s68.5-13.9 93.3-38.6l110-110.1c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-110.1 110C371.9 149.5 346.5 160 320 160s-51.9-10.5-70.6-29.3L150.6 32H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM39.1 366.5C86.8 320.1 186.2 255.1 320 255.1s233.2 65 280.9 111.3c7.6 7.4 9.5 19.8 3.7 31.3l-37.4 73.5c-3.3 6.5-10.6 10-17.7 8.4l-88.7-19.8c-7.3-1.6-12.5-8.1-12.5-15.6v-82c0-7.2-4.8-13.5-11.8-15.4l-36.1-9.9c-52.6-14.4-108.1-14.4-160.7 0l-36.1 9.9c-7 1.9-11.8 8.2-11.8 15.4v82.1c0 7.5-5.2 14-12.5 15.6l-88.7 19.8c-7.1 1.6-14.4-1.9-17.7-8.4l-37.4-73.5c-5.8-11.5-3.9-23.9 3.7-31.3zM320 223.1c-144.2 0-251.2 69.9-303.2 120.4-19.3 18.7-21 46.8-9.9 68.7l37.4 73.5c9.9 19.5 31.8 29.9 53.2 25.1l88.7-19.8c21.9-4.9 37.5-24.4 37.5-46.9v-69.7l24.4-6.7a272 272 0 0 1 143.8 0l24.4 6.7v69.8c0 22.5 15.6 42 37.5 46.9l88.7 19.8c21.4 4.8 43.3-5.6 53.2-25.1l37.4-73.5c11.1-21.9 9.4-50-9.9-68.7-52-50.5-159-120.4-303.2-120.4z"
        }
    ]
};

const FalPhoneOffice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneOffice",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32c17.7 0 32 14.3 32 32v304c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h32zM144 0c-23.7 0-44.4 12.9-55.4 32H64C28.7 32 0 60.7 0 96v352c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H231.4c-11-19.1-31.7-32-55.4-32h-32zm144 64v64c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V64c17.7 0 32 14.3 32 32v352c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h16v304c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64V64h48zm192 0v64H320V64h160zM352 240a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 16a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm192-128a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0 160a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 16a48 48 0 1 0 96 0 48 48 0 1 0-96 0z"
        }
    ]
};

const FalPhonePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhonePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 208v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V16c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm-55 78.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.3-.4h-.1c-4.6-.2-9.1-.4-13.7-.8C247.5 494.5 64 300.7 64 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zM512 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4-50.9-29.5-93.3-71.9-122.7-122.7-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C98.6 57 96 60.2 96 64c0 229.6 186.1 415.8 415.7 416h.3z"
        }
    ]
};

const FalPhoneRotary = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneRotary",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 142.4V192h72.9l-18.3 32H32c-17.7 0-32-14.3-32-32v-50.7c0-8.5 3.4-16.6 9.9-22.1C38.2 95.4 125.9 32 256 32s217.8 63.4 246.1 87.2c6.5 5.5 9.9 13.6 9.9 22.1V192c0 17.7-14.3 32-32 32h-54.6l-18.3-32H480v-49.6C453 120.1 373.2 64 256 64S59 120.1 32 142.4zm0-1.1zM32 401c0-11.1 2.9-22.1 8.4-31.8l101.1-177c10.5-18.4 29.5-30.4 50.4-32V128c0-8.8 7.2-16 16-16s16 7.2 16 16v32h64v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32.2c21 1.7 39.9 13.6 50.4 32l101.1 177c5.5 9.7 8.4 20.6 8.4 31.8v31c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-31zm272-209H197.1c-11.5 0-22.1 6.2-27.8 16.1l-101.1 177C65.5 390 64 395.4 64 401v31c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16v-31c0-5.6-1.5-11-4.2-15.9l-101.1-177c-5.7-10-16.3-16.1-27.8-16.1H304zm-96 128a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"
        }
    ]
};

const FalPhoneSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 510.9c-95.4-6.7-182.6-43.3-252.2-100.5l25.7-20.4c70.9 56.3 160.6 89.9 258.1 90h.3c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4-8.7-5-17.1-10.4-25.3-16.2l26.4-20.8c4.9 3.2 9.9 6.3 15 9.3l33.2-40.6c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.2 31.6-39.1 31.6-6.1 0-12.2-.1-18.3-.4h-.1c-4.6-.2-9.1-.4-13.7-.8zM141.2 315.6C92.5 243.9 64 157.3 64 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c1.9 3.3 3.9 6.6 6 9.8l-25.2 19.9c-2.9-4.5-5.7-9.1-8.4-13.7-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24c-3.8.8-6.4 4-6.4 7.8 0 85.8 26 165.5 70.4 231.7l-25.2 19.9zM614.1 3.4c6.9-5.5 17-4.3 22.5 2.6s4.3 17-2.6 22.5l-608 480c-6.9 5.5-17 4.3-22.5-2.6s-4.3-17 2.6-22.5l608-480z"
        }
    ]
};

const FalPhoneVolume = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneVolume",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 0c132.5 0 240 107.5 240 240 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-32-80c0-8.8 7.2-16 16-16 79.5 0 144 64.5 144 144 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112-8.8 0-16-7.2-16-16zm73 174.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.3-.4h-.1c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4-50.9-29.5-93.3-71.9-122.7-122.7-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 229.6 186.1 415.8 415.7 416h.3z"
        }
    ]
};

const FalPhoneXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhoneXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M420.7 4.7c6.2-6.2 16.4-6.2 22.6 0L496 57.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 80l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 102.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L473.4 80l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6zm-27.7 282c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.3-.4h-.1c-4.6-.2-9.1-.4-13.7-.8C247.5 494.5 64 300.7 64 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zM512 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4-50.9-29.5-93.3-71.9-122.7-122.7-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C98.6 57 96 60.2 96 64c0 229.6 186.1 415.8 415.7 416h.3z"
        }
    ]
};

const FalPhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1l40.5-33.1c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6.9l-112 24C13.2 28.8 0 45.1 0 64c0 236.7 183.5 430.5 416 446.9 4.5.3 9.1.6 13.7.8h.1c6.1.2 12.1.4 18.3.4 18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM447.7 480C218.1 479.8 32 293.7 32 64c0-3.8 2.6-7 6.3-7.8l112-24c3.7-.8 7.5 1.2 9 4.7l48 112c1.4 3.3.5 7.1-2.3 9.3l-40.6 33.2c-12.1 9.9-15.3 27.2-7.4 40.8 29.5 50.9 71.9 93.3 122.7 122.7 13.6 7.9 30.9 4.7 40.8-7.4l33.2-40.6c2.3-2.8 6.1-3.7 9.3-2.3l112 48c3.5 1.5 5.5 5.3 4.7 9l-24 112c-.8 3.7-4.1 6.3-7.8 6.3h-.3z"
        }
    ]
};

const FalPhotoFilmMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhotoFilmMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 32H224c-17.7 0-32 14.3-32 32v169.4l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0l41.3 41.4L457.4 96c12.5-12.5 32.8-12.5 45.3 0l53.8 53.8-33.9 11.3-42.6-42.5-116.7 116.7-84.7 84.7H384v32H224c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v72c-6.7 0-13.5 1.1-20.2 3.3l-11.8 3.9V64c0-17.7-14.3-32-32-32zM233.4 320l96-96-41.4-41.4-96 96v9.4c0 17.7 14.3 32 32 32h9.4zM232 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-120 0h16v320h180.6c-8.3 8.8-15 19.6-18.3 32H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h48zm-80 96h64v-64H64c-17.7 0-32 14.3-32 32v32zm0 160v32c0 17.7 14.3 32 32 32h32v-64H32zm64-32v-96H32v96h64zm544-121.8V392c0 1.1-.1 2.2-.3 3.2.2 1.6.3 3.2.3 4.8 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c11.7 0 22.6 2.3 32 6.4v-88.2l-160 53.3V464c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V251.5c0-13.8 8.8-26 21.9-30.4l160-53.3c20.7-6.9 42.1 8.5 42.1 30.4zm-32 38.3v-38.3l-160 53.3v38.3l160-53.3zm-5.9 171.9c5.5-4.1 5.9-7.4 5.9-8.3s-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7zm-192 64c5.5-4.1 5.9-7.4 5.9-8.3s-.4-4.2-5.9-8.3c-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7z"
        }
    ]
};

const FalPhotoFilm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPhotoFilm",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 32H256c-17.7 0-32 14.3-32 32v169.4l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0l41.3 41.4L489.4 96c12.5-12.5 32.8-12.5 45.3 0l73.3 73.4V64c0-17.7-14.3-32-32-32zm64 176v80.1c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v144zm-32 6.7-96-96-116.7 116.6-84.7 84.7H576c17.7 0 32-14.3 32-32v-73.4zM265.4 320l96-96-41.4-41.4-96 96v9.4c0 17.7 14.3 32 32 32h9.4zM296 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-168 80h32v32h-32v288h256v-96h32v96h32c17.7 0 32-14.3 32-32v-64h32v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h64zm-96 96h64v-64H64c-17.7 0-32 14.3-32 32v32zm0 160v32c0 17.7 14.3 32 32 32h32v-64H32zm64-32v-96H32v96h64z"
        }
    ]
};

const FalPi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPi",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16h112v155c0 61.8-21 121.7-59.6 169.9l-.9 1.1c-5.5 6.9-4.4 17 2.5 22.5s17 4.4 22.5-2.5l.9-1.1C136.5 387 160 320 160 251V96h160v286.6c0 36.1 29.3 65.4 65.4 65.4 24.8 0 47.4-14 58.5-36.2l2.3-4.7c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-2.3 4.7c-5.7 11.3-17.2 18.5-29.9 18.5-18.3 0-33.3-15-33.3-33.4V96h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalPianoKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPianoKeyboard",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 224v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h32zm-32 109.3V416H304v-82.7c18.6-6.6 32-24.4 32-45.3v-64h48v64c0 20.9 13.4 38.7 32 45.3zm32 82.7v-82.7c18.6-6.6 32-24.4 32-45.3v-64h64v160c0 17.7-14.3 32-32 32h-64zm-16 32h80c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h368zm-160-32H160v-82.7c18.6-6.6 32-24.4 32-45.3v-64h48v64c0 20.9 13.4 38.7 32 45.3V416zm-144 0H64c-17.7 0-32-14.3-32-32V224h64v64c0 20.9 13.4 38.7 32 45.3V416zm16-112c-8.8 0-16-7.2-16-16v-64h32v64c0 8.8-7.2 16-16 16zm144 0c-8.8 0-16-7.2-16-16v-64h32v64c0 8.8-7.2 16-16 16zm176-112H32v-64c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v64h-80z"
        }
    ]
};

const FalPiano = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPiano",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 384v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-96v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32H32v64c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-64h-48zm-16-32h64v-24.4c0-12.1-6.8-23.2-17.7-28.6l-58.4-29.2c-31.8-15.9-51.9-48.4-51.9-84 0-85-68.8-153.8-153.7-153.8H192c-88.4 0-160 71.6-160 160v160h384zm96-24.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192C0 86 86 0 192 0h6.3C300.8 0 384 83.2 384 185.7c0 23.5 13.2 44.9 34.2 55.4l58.4 29.2c21.7 10.8 35.4 33 35.4 57.2z"
        }
    ]
};

const FalPickaxe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPickaxe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M474.7 321.8c16.1-78.2-7.8-162.5-65.3-219.8-57.2-57-141.1-80.8-218.9-64.8 61.8 30 118.3 73 164.8 119.5 46.9 46.9 89.3 103.4 119.4 165.1zM138.5 49.6c-13.4-5-13.7-24.5-.5-29.8 99.7-40.4 217.6-16.6 294 59.5C508.6 155.7 532.7 274 492.2 374c-5.4 13.3-24.9 13-29.8-.5-27.7-72.3-75.4-139.8-129.7-194.2-54.1-54.1-121.9-102.5-194.2-129.7zM10.1 448.5l261.8-281.2c8 6.6 16.1 13.7 24.1 21.1L33.5 470.3c-1 1.1-1.5 2.5-1.5 3.9 0 3.2 2.6 5.7 5.7 5.7 1.5 0 2.8-.6 3.9-1.5l282-262.4c7.4 8 14.5 16.1 21.1 24.1L63.5 501.9c-7 6.5-16.2 10.1-25.7 10.1C16.9 512 0 495.1 0 474.3c0-9.5 3.6-18.7 10.1-25.7zM443.3 20.7l48 48c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-48-48c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FalPickleball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPickleball",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M363.6 50.7c-25-25-65.6-25-90.6 0L141 182.3l142.5 142c-4.5 11.3-7.8 23.2-9.7 35.5l-155.5-155-3.2 3.2c-13.8 13.7-17.9 34.4-10.4 52.3l24.9 59.8c10 23.9 4.5 51.5-13.9 69.8l-63 62.8c-6.3 6.2-6.3 16.3 0 22.6 6.3 6.2 16.4 6.2 22.7 0l63.3-63c18.3-18.2 45.7-23.7 69.6-13.9l58.5 24c3.4 1.4 6.9 2.4 10.5 3 3 11.4 7.3 22.2 12.6 32.4-11.8.7-23.9-1.2-35.3-5.8l-58.5-24c-12-4.9-25.7-2.2-34.8 7l-63.2 63c-18.8 18.7-49.2 18.7-68 0s-18.8-49.1 0-67.8l63-62.8c9.2-9.2 11.9-22.9 6.9-34.9l-24.9-59.8c-12.5-29.9-5.6-64.3 17.3-87.2L250.3 28.1c37.5-37.4 98.4-37.4 135.9 0l113.6 113.2c29.4 29.3 35.8 72.9 19.1 108.4-8.9-5.8-18.5-10.7-28.5-14.7 10.4-23.5 6-51.9-13.3-71.1L363.6 50.7zM432 480.1a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-224a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-64 128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 64a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm0-48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80 0a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-64-64a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
        }
    ]
};

const FalPie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPie",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 80c-98.6 0-183.4 59.5-220.3 144.6-3.5 8-11.7 15.4-22.9 15.4-8.8 0-16 7.2-16 16s7.2 16 16 16c26 0 46-9.5 59.3-18.9 6.1-4.3 14.1-4.8 20.7-1.2 1.4.8 2.8 1.5 4.3 2.3 17 8.8 41.6 17.8 70.8 17.8s53.8-9 70.8-17.8c10.8-5.6 23.6-5.6 34.4 0 17 8.8 41.6 17.8 70.8 17.8s53.8-9 70.8-17.8c1.5-.8 2.9-1.5 4.3-2.3 6.6-3.7 14.7-3.1 20.7 1.2C485 262.5 505 272 531 272c8.8 0 16-7.2 16-16s-7.2-16-16-16c-11.2 0-19.4-7.4-22.9-15.4C471.4 139.5 386.6 80 288 80zM40 208.2C82.6 113.8 177.6 48 288 48s205.4 65.8 248.1 160.2c24.2 2.4 43.1 22.9 43.1 47.8 0 26.5-21.5 48-48 48-30.2 0-54.2-9.8-71.3-20.5-20 10.1-49 20.5-83.9 20.5-35.8 0-65.4-11-85.5-21.3-1.6-.8-3.5-.8-5 0C265.4 293 235.8 304 200 304c-34.8 0-63.8-10.4-83.9-20.5C99 294.2 75 304 44.8 304c-26.5 0-48-21.5-48-48 0-24.9 18.9-45.3 43.2-47.8zm18.5 127.2c11.4-.9 22-3 31.8-5.8l21.5 64.4c4.4 13.1 16.6 21.9 30.4 21.9h291.7c13.8 0 26-8.8 30.4-21.9l21.5-64.4c9.8 2.8 20.4 4.8 31.8 5.8l-22.9 68.8C486 430.3 461.5 448 434 448H142.1c-27.5 0-52-17.6-60.7-43.8l-22.9-68.8zm147.8-184.2-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5zm192-14.3 16 32c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2l-16-32c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2zM304 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalPig = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPig",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M484.2 32c-4.4 0-8.7.7-12.9 1.9l-54.7 16.9C399.7 56 385.5 66.4 375.5 80H240c-77.4 0-142 55-156.8 128H47.4c-8.5 0-15.4-6.9-15.4-15.4 0-7.1 4.8-13.3 11.7-15l8.2-2c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-8.2 2C14.8 151.8 0 170.8 0 192.6 0 218.8 21.2 240 47.4 240H80v16c0 53.4 29.1 100 72.2 124.8l27.8 78c4.5 12.7 16.6 21.2 30.1 21.2H256c17.7 0 32-14.3 32-32v-32h80v32c0 17.7 14.3 32 32 32h45.9c13.5 0 25.6-8.5 30.1-21.2l18-50.3c25.9-9 48.8-25.5 65.3-47.7.3-.4.6-.6.8-.7H600c22.1 0 40-17.9 40-40V240c0-22.1-17.9-40-40-40h-18.7c-5.2-3.5-9.9-7.7-14.1-12.3 25-13.7 40.9-40 40.9-68.9C608 97.3 590.7 80 569.3 80H528v-4.2c0-24.2-19.6-43.8-43.8-43.8zm40.9 80h44.1c3.7 0 6.7 3 6.7 6.7 0 18.6-11 35.3-28 42.7-9-11.5-19.1-22-30.2-31.2 3.1-5.7 5.6-11.8 7.3-18.2zm-44.4-47.5c1.1-.3 2.3-.5 3.5-.5 6.5 0 11.8 5.3 11.8 11.8v14.3c0 12.5-4.5 24.1-12 33.3-2.8 3.4-4.1 7.8-3.6 12.2s2.9 8.4 6.5 11c17.9 13 33.5 29.3 45.8 48.5 8.2 12.7 18.9 23.5 31.3 31.9 5.4 3.6 11.4 5.1 17.1 5.1H600c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-39.8c-11.1 0-20.7 5.7-26.6 13.7-14 18.8-33.8 32.3-56.3 38.5-5 1.4-9 5.1-10.8 10L445.9 448H400v-48c0-8.8-7.2-16-16-16H272c-8.8 0-16 7.2-16 16v48h-45.9l-29.9-83.7c-1.4-3.8-4.1-7-7.7-8.8-36-18.7-60.5-56.2-60.5-99.5v-16c0-70.7 57.3-128 128-128h143.9c5.9.1 11.4-3 14.3-8.2 5.9-10.6 15.7-18.8 27.9-22.5l54.7-16.8zM468 256a20 20 0 1 0 0-40 20 20 0 1 0 0 40z"
        }
    ]
};

const FalPiggyBank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPiggyBank",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 32c34.8 0 64.5 22.2 75.5 53.3 2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4C362.3 31.2 320.8 0 272 0c-55.5 0-101.6 40.4-110.5 93.4-1.5 8.7 4.4 17 13.1 18.4s17-4.4 18.4-13.1c6.5-37.9 39.4-66.7 79-66.7zM55.2 190.3c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-4.7 2.4C14 175.1 0 197.8 0 222.6c0 35.7 28.5 64.7 64 65.4 0 52.4 25.2 98.8 64 128v48c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-16h64v16c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-29.3c25.5-11.1 47.5-28.7 64-50.7h32c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32h-13.3c-10.7-24.6-27.4-45.9-48.3-62.2l7.2-25c5.8-20.5-9.6-40.8-30.8-40.8H456c-30.5 0-58.2 12.2-78.4 32H224c-77.4 0-142 55-156.8 128h-1.8C47 256 32 241 32 222.6c0-12.7 7.2-24.2 18.5-29.9l4.7-2.3zM424 288a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-27.6-133.3C411 138.3 432.3 128 456 128h2.8l-10.2 35.8c-1.9 6.7.7 13.8 6.5 17.7 22.8 15.2 40.4 37.6 49.7 63.8 2.3 6.4 8.3 10.7 15.1 10.7H544v96h-40.2c-5.3 0-10.3 2.7-13.3 7.1-15.2 22.8-37.6 40.4-63.8 49.6-6.4 2.3-10.7 8.3-10.7 15.1V464c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v32c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-56.2c0-5.3-2.7-10.3-7.1-13.3C118.6 371.5 96 332.4 96 288c0-70.7 57.3-128 128-128h160.4c4.6 0 8.9-1.9 11.9-5.3z"
        }
    ]
};

const FalPills = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPills",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 64c44.2 0 80 35.8 80 80v112H32V144c0-44.2 35.8-80 80-80zM32 368v-80h160v80c0 44.2-35.8 80-80 80s-80-35.8-80-80zM0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112S0 82.1 0 144zm416 304c-70.7 0-128-57.3-128-128 0-29.6 10-56.8 26.9-78.5l179.6 179.6C472.8 438 445.6 448 416 448zm-78.5-229.1C359.2 202 386.4 192 416 192c70.7 0 128 57.3 128 128 0 29.6-10 56.8-26.9 78.5L337.5 218.9zM416 480a160 160 0 1 0 0-320 160 160 0 1 0 0 320z"
        }
    ]
};

const FalPinata = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPinata",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48c0-26.5 21.5-48 48-48s48 21.5 48 48v176h160c53 0 96 43 96 96v144c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-16c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32v16c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V225.9l-57.1-28.6C15.1 185.4 0 161 0 134.4 0 95.5 31.5 64 70.4 64H160V48zm96 336h99.7c10.2 0 20.3 1.9 29.7 5.7l23.1 9.2 36.9-12.3c7.2-2.4 15-2.2 22 .6l12.6 5v-49.7c-4.7-.1-9.3-1.2-13.6-3.4l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6-26.7 10.7c-8.5 3.4-18 3-26.2-1.1l-19.1-9.6L128 342v50.3l12.6-5c7-2.8 14.8-3 22-.6l36.9 12.3 23.1-9.2c9.4-3.8 19.5-5.7 29.7-5.7h3.7zm-128-76.4 19.4-7.8c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l19.1 9.6 26.7-10.7c8.5-3.4 18-3 26.2 1.1l17.6 8.8c-5-30.4-31.4-53.7-63.2-53.7H240c-3.5 0-6.7-1.1-9.4-3l-19.3 7.7c-7 2.8-14.8 3-22 .6L152.5 249l-24.5 9.8v48.7zM224 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8-7.2 16-16 16H70.4C49.2 96 32 113.2 32 134.4c0 14.5 8.2 27.8 21.2 34.3l65.9 33c5.4 2.7 8.8 8.3 8.8 14.3v8.4l12.6-5c7-2.8 14.8-3 22-.6l37 12.2 24.5-9.8V48zm-96 378.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16c0-6 .8-11.9 2.4-17.4-1.7-.3-3.4-.7-5-1.2L152.5 417l-24.5 9.8zm352 0-24.5-9.8-36.9 12.3c-1.6.6-3.3 1-5 1.2 1.6 5.5 2.4 11.4 2.4 17.4v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-37.1zM152 144a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalPinball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPinball",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-232 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm263.9 160L76.2 348.9c-8.1-2.6-15.2-6.7-21.3-11.8-27.1-22.7-30.6-63.2-7.9-90.2s63-30.6 90.1-7.9L383 447.2l.5.4.4.3v.1zm19.8-25.2-246-208.3c-40.6-34.1-101.2-28.8-135.2 11.8S-6.3 327.5 34.3 361.6c9.2 7.7 19.9 13.8 32 17.7l307.8 99.1c14.9 4.8 30.7-1.8 37.9-15 7.4-12.8 4.2-30.8-8.4-40.6z"
        }
    ]
};

const FalPineapple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPineapple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M387.4 2.6c-12 5.2-21.8 13-29.1 22.5-12.5-12.2-32.5-12-44.9.3-17.1 17.1-26.7 38.9-28.8 61.2 11 3.3 21.7 7.9 31.7 13.6-1.2-18.8 5.4-37.9 19.7-52.2l14.7 14.7c3.9 3.9 9.6 5.5 15 4.3s9.7-5.2 11.5-10.4C380.8 46 388.5 36.9 400 32l3.6 14.3c1.2 4.8 4.6 8.9 9.2 10.8s9.8 1.7 14.2-.8c9.5-5.4 20.4-8.3 31.5-8.3h5.5v5.5c0 11.2-2.9 22-8.3 31.5-2.5 4.3-2.8 9.6-.8 14.2s6 8 10.8 9.2L480 112c-4.9 11.5-14 19.2-24.6 22.8-5.2 1.8-9.2 6.1-10.4 11.5s.4 11 4.3 15L464 176c-14.3 14.3-33.4 20.9-52.1 19.8 5.7 10 10.2 20.7 13.6 31.7 22.3-2.1 44.1-11.7 61.2-28.8 12.4-12.4 12.5-32.4.3-44.9 9.4-7.3 17.3-17.1 22.5-29.1 3.7-8.6 3.4-18.4-.7-26.8-3.6-7.2-9.7-12.7-17.1-15.6 2.9-9.2 4.4-18.9 4.4-28.7V48c0-17.7-14.3-32-32-32h-5.5c-9.8 0-19.5 1.5-28.7 4.4-2.9-7.4-8.4-13.5-15.6-17.1-8.4-4.2-18.2-4.4-26.8-.7zm-319.5 404C44.9 383.7 32 352.5 32 320s12.9-63.7 35.9-86.6l85.5-85.5c23-23 54.1-35.9 86.6-35.9s63.7 12.9 86.6 35.9l37.5 37.5c23 23 35.9 54.1 35.9 86.6s-12.9 63.7-35.9 86.6l-85.5 85.5c-23 23-54.1 35.9-86.6 35.9s-63.7-12.9-86.6-35.9l-37.5-37.5zm-22.6 22.7 37.5 37.5c29 29 68.3 45.3 109.3 45.3s80.3-16.3 109.3-45.3l85.5-85.5c29-29 45.3-68.3 45.3-109.3s-16.3-80.3-45.3-109.3l-37.5-37.5C320.3 96.3 281 80 240 80s-80.3 16.3-109.3 45.3l-85.4 85.4C16.3 239.7 0 279 0 320s16.3 80.3 45.3 109.3zm103.4-216.6c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm-64 88c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L128 321.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm128 0c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 321.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0zm-64 88c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 409.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalPipeCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPipeCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 96c8.8 0 16 7.2 16 16v16h416v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v80.7c-11 1-21.7 3-32 5.9V160H32v192h288.7c-.5 5.3-.7 10.6-.7 16s.2 10.7.7 16H32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm480 384a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalPipeCollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPipeCollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M68.3 166.3c5.9-12.2 3.4-26.8-6.2-36.4l-16-16c-18.7-18.7-18.7-49.1 0-67.9s49.1-18.7 67.9 0l16 16c9.6 9.6 24.2 12.1 36.4 6.2C193.5 55.3 223.8 48 256 48s62.5 7.3 89.7 20.3c12.2 5.9 26.8 3.4 36.4-6.2l16-16c18.7-18.7 49.1-18.7 67.9 0s18.7 49.1 0 67.9l-16 16c-9.6 9.6-12.1 24.2-6.2 36.4 13 27.1 20.3 57.5 20.3 89.7s-7.3 62.5-20.3 89.7c-5.9 12.2-3.4 26.8 6.2 36.4l16 16c18.7 18.7 18.7 49.1 0 67.9s-49.1 18.7-67.9 0l-16-16c-9.6-9.6-24.2-12.1-36.4-6.2-27.1 13-57.5 20.3-89.7 20.3s-62.5-7.3-89.7-20.3c-12.2-5.9-26.8-3.4-36.4 6.2l-16 16c-18.7 18.7-49.1 18.7-67.9 0s-18.7-49.1 0-67.9l16-16c9.6-9.6 12.1-24.2 6.2-36.4C55.3 318.5 48 288.2 48 256s7.3-62.5 20.3-89.7zm68.3-142.9c-31.3-31.2-81.9-31.2-113.2 0s-31.2 81.9 0 113.1l16 16C24.4 183.9 16 218.9 16 256s8.4 72.1 23.4 103.5l-16 16c-31.2 31.2-31.2 81.9 0 113.1s81.9 31.2 113.1 0l16-16c31.3 15 66.4 23.4 103.5 23.4s72.1-8.4 103.5-23.4l16 16c31.2 31.2 81.9 31.2 113.1 0s31.2-81.9 0-113.1l-16-16c15-31.3 23.4-66.4 23.4-103.5s-8.4-72.1-23.4-103.5l16-16c31.2-31.2 31.2-81.9 0-113.1s-81.9-31.2-113.1 0l-16 16C328.1 24.4 293.1 16 256 16s-72.1 8.4-103.5 23.4l-16-16zM128 256a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm288 0a160 160 0 1 0-320 0 160 160 0 1 0 320 0zM96 432a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm336 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-368a16 16 0 1 0-32 0 16 16 0 1 0 32 0zM80 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalPipeSection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPipeSection",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v288c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h576v16c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H32v-16zm576 240H32V160h576v192z"
        }
    ]
};

const FalPipeSmoking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPipeSmoking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M586.6 32c-35.2 0-68.4 16.6-89.5 44.7L395 212.5c18.2 15.5 22.4 42.4 8.9 62.8L296 439.8c-29.5 45.1-79.8 72.2-133.7 72.2H160C71.6 512 0 440.4 0 352v-72c0-30.9 25.1-56 56-56h144c28.4 0 51.9 21.2 55.5 48.6l49.5-66c14.9-19.9 42.5-25 63.5-12.1l103-137C498.7 21.3 541.3 0 586.6 0H624c8.8 0 16 7.2 16 16s-7.2 16-16 16h-37.4zm-256 193.8-77.8 103.8c-4.1 5.5-11.3 7.8-17.9 5.6S224 326.9 224 320v-40c0-13.3-10.7-24-24-24H56c-13.3 0-24 10.7-24 24v72c0 70.7 57.3 128 128 128h2.3c43.1 0 83.4-21.7 107-57.8l107.9-164.4c4.8-7.3 2.8-17.2-4.5-22.1l-20.4-13.6c-7.1-4.7-16.6-3.1-21.7 3.7z"
        }
    ]
};

const FalPipeValve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPipeValve",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v80H32v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v288c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h448v16c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H272v-80h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96V32zm-16 192h224v192H32V224h224z"
        }
    ]
};

const FalPipe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPipe",
    "viewBox": "0 0 64 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 0c8.8 0 16 7.2 16 16v480c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalPizzaSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPizzaSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M167.5 32.8c-6.1-.4-12.4 3.7-14.4 11.1l-10 37.6C295 96.1 415.9 217 430.5 368.9l37.6-10c7.4-2 11.5-8.3 11.1-14.4C467.7 177.7 334.3 44.3 167.5 32.8zM38.6 473.4l360.5-96.1c-11-140.9-123.5-253.4-264.4-264.4L38.6 473.4zM4.7 507.3c-4-4-5.6-9.9-4.1-15.4L122.2 35.6C127.7 14.9 146.9-.7 169.7.9c182.8 12.6 328.8 158.6 341.4 341.4 1.6 22.8-14 41.9-34.7 47.5L20.1 511.5c-5.5 1.5-11.4-.1-15.4-4.1zM176 216a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 120a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalPizza = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPizza",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M344.2 389.5C318.9 406.2 288.6 416 256 416c-88.4 0-160-71.6-160-160S167.6 96 256 96c32.6 0 62.9 9.8 88.2 26.5l-99.6 99.6c-18.7 18.7-18.7 49.1 0 67.9l99.6 99.6zm24.9-20.4L267.3 267.3c-6.2-6.2-6.2-16.4 0-22.6l101.8-101.8 22.6-22.6 33.9-33.9c6.4-6.4 6.4-16.5-.2-22.4C380.2 24.2 320.9 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c64.9 0 124.2-24.2 169.4-64 6.6-5.8 6.6-16 .3-22.3l-33.9-33.9-22.6-22.6zm-1.9 43.4 22.9 22.9c-37.4 28-83.8 44.6-134.1 44.6-123.7 0-224-100.3-224-224S132.3 32 256 32c50.3 0 96.7 16.6 134.2 44.6l-23 22.9C335.9 77.1 297.5 64 256 64 150 64 64 150 64 256s86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm132.2-22.4-22.9-22.9C498.9 335.9 512 297.5 512 256s-13.1-79.9-35.5-111.2l22.9-22.9c28 37.4 44.6 83.8 44.6 134.2s-16.6 96.7-44.6 134.2zM480 256c0 32.6-9.8 62.9-26.5 88.2L365.3 256l88.2-88.2c16.7 25.3 26.5 55.6 26.5 88.2zm32 169.4c39.8-45.1 64-104.4 64-169.4s-24.2-124.2-64-169.4c-5.8-6.6-16-6.6-22.3-.3L331.3 244.7c-6.2 6.2-6.2 16.4 0 22.6l101.8 101.8 22.6 22.6 33.9 33.9c6.2 6.2 16.4 6.3 22.3-.3zM160 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-120a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-24 216a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalPlaceOfWorship = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaceOfWorship",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c4.2 0 8.3 1.7 11.3 4.7L406.6 80c6 6 9.4 14.1 9.4 22.6v89.3l41 25.1c14.3 8.7 23 24.2 23 41v222h96c17.7 0 32-14.3 32-32v-69.9c0-10.9-5.5-21-14.6-26.9L512 298.6v-38.1l98.8 63.9c18.2 11.8 29.2 32 29.2 53.7V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-69.9c0-21.7 11-41.9 29.2-53.7l98.8-63.9v38.1l-81.4 52.6c-9.1 5.9-14.6 16-14.6 26.9V448c0 17.7 14.3 32 32 32h96V257.9c0-16.7 8.7-32.2 23-41l41-25.1v-89.2c0-8.5 3.4-16.6 9.4-22.6l75.3-75.3c3-3 7.1-4.7 11.3-4.7zm128 257.9c0-5.6-2.9-10.7-7.7-13.7l-48.7-29.8c-4.8-2.9-7.7-8.1-7.7-13.7v-98.3l-64-64-64 64v98.3c0 5.6-2.9 10.7-7.7 13.7l-48.7 29.8c-4.8 2.9-7.7 8.1-7.7 13.7V480h64v-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96h64V257.9zM352 480v-96c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64z"
        }
    ]
};

const FalPlaneArrival = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneArrival",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M253.3 32c5.8 0 11.1 3.1 13.9 8.2l121.3 215.5c2.1 3.7 5.6 6.4 9.7 7.6l91.5 25.4c15.9 4.4 30.7 12.3 43.2 23.2l26.7 23.1c11.5 9.9 6.7 28.7-8.1 32-27.1 6-55.3 5.1-82-2.5l-299-85c-1.8-.5-3.5-1.3-5-2.4l-94.6-68.4c-4.2-3-6.6-7.8-6.6-12.9L64 100l34.2 7.6c5.7 1.3 10.2 5.5 11.9 11l18.6 62c1.6 5.3 5.7 9.3 11 10.8l101.8 28.3c5.6 1.6 11.6 0 15.6-4.1s5.6-10.1 4-15.7L213.2 32h40.1zm41.8-7.5C286.6 9.4 270.6 0 253.3 0h-40.1c-21.2 0-36.6 20.3-30.8 40.8l40.1 140.4-65.8-18.3-16.1-53.6C135.6 92.7 122 80 105 76.2l-34-7.5C51 64.3 32 79.5 32 100l.2 95.8c0 15.4 7.4 29.8 19.9 38.8l94.7 68.4c4.5 3.3 9.6 5.7 15 7.3l4.4-15.4-4.4 15.4 298.8 84.9c31.8 9 65.4 10 97.7 2.9 40.6-8.9 53.6-60.3 22.1-87.5l-26.7-23.1c-16.1-13.9-35.1-24.1-55.6-29.8L413 234 295.1 24.5zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm160-112a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalPlaneCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-13.4 0-25.2 5.7-34.8 13.3-9.5 7.6-17.6 17.7-24 28.4-12.8 21-21.2 47.3-21.2 68v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9V376l-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30 2.8 0 5.6-.4 8.3-1.2L256 480.6l105.7 30.2c2.7.8 5.5 1.2 8.2 1.2 6.5 0 12.5-2 17.4-5.5-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8v-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8v-56.2c0-5.7 3.1-11 8.1-13.9L200 185.3c5-2.8 8.1-8.2 8.1-13.9v-61.7c0-13.5 6.1-34.1 16.6-51.3 5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3 10.3 17.2 16.2 37.8 16.2 51.4v61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1v-52.4c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zm240 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L480 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalPlaneCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-13.4 0-25.2 5.7-34.8 13.3-9.5 7.6-17.6 17.7-24 28.4-12.8 21-21.2 47.3-21.2 68v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9V376l-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30 2.8 0 5.6-.4 8.3-1.2L256 480.6l105.7 30.2c2.7.8 5.5 1.2 8.2 1.2 6.5 0 12.5-2 17.4-5.5-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8v-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8v-56.2c0-5.7 3.1-11 8.1-13.9L200 185.3c5-2.8 8.1-8.2 8.1-13.9v-61.7c0-13.5 6.1-34.1 16.6-51.3 5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3 10.3 17.2 16.2 37.8 16.2 51.4v61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1v-52.4c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zm128 368a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalPlaneCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-13.4 0-25.2 5.7-34.8 13.3-9.5 7.6-17.6 17.7-24 28.4-12.8 21-21.2 47.3-21.2 68v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9V376l-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30 2.8 0 5.6-.4 8.3-1.2L256 480.6l105.7 30.2c2.7.8 5.5 1.2 8.2 1.2 6.5 0 12.5-2 17.4-5.5-11.2-8.8-21.3-18.9-30.1-30.2l-96.8-27.7c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8v-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8v-56.2c0-5.7 3.1-11 8.1-13.9L200 185.3c5-2.8 8.1-8.2 8.1-13.9v-61.7c0-13.5 6.1-34.1 16.6-51.3 5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3 10.3 17.2 16.2 37.8 16.2 51.4v61.7c0 5.7 3.1 11 8.1 13.9l76.2 43.5c9.6-7.4 19.9-13.9 30.9-19.2L336 162.1v-52.4c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zm128 368a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L518.6 368l36.7-36.7z"
        }
    ]
};

const FalPlaneDeparture = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneDeparture",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M158.7 105.4c11.5-5.2 24.5-5.7 36.4-1.4L375 170c4.2 1.5 8.8 1.3 12.8-.8l88-45c15.8-8.1 33.3-12.3 51-12.3h61c12.7 0 21.1 13.1 15.8 24.6-15.4 33.4-41.7 60.5-74.6 77L255.6 350.3c-2.2 1.1-4.7 1.7-7.2 1.7H109.3c-4.2 0-8.3-1.7-11.3-4.7l-63.9-63.8 23.7-13.6c4.4-2.5 9.8-2.8 14.4-.7l57.2 25.4c4.4 2 9.5 1.8 13.8-.4l115-58.8c5.1-2.6 8.5-7.8 8.7-13.6s-2.6-11.2-7.5-14.3l-137.5-85.3-6.6-14.6 6.6 14.6 36.9-16.8zM206.1 74c-19.7-7.2-41.5-6.4-60.6 2.3l-36.9 16.8c-23.3 10.6-25.4 42.8-3.6 56.3l113.5 70.5-83 42.4L85.3 240l-6.1 13.7 6.1-13.7c-14-6.2-30-5.4-43.3 2.2l-23.8 13.5c-18.3 10.5-21.7 35.5-6.8 50.4l63.8 63.8c9 9 21.2 14.1 33.9 14.1h139.3c7.5 0 14.8-1.7 21.5-5.1l273.4-136.7c39.4-19.7 70.9-52.2 89.3-92.2 15.1-32.7-8.8-70-44.8-70h-61c-22.8 0-45.2 5.4-65.5 15.8l-81.8 41.8L206.1 74zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalPlaneEngines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneEngines",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 256c0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2h-96.9l-11.1-18.7c15-5.8 25.6-20.3 25.6-37.3v-16c0-22.1-17.9-40-40-40H303l-28.6-48.3C268.7 6 258.2 0 246.9 0h-76.2c-16 0-27.6 15.4-23 30.8l15.2-4.5-15.2 4.5 43 145.2H136l-38.4-51.2c-6-8.1-15.5-12.8-25.6-12.8H30c-16.6 0-30 13.4-30 30 0 2.8.4 5.6 1.2 8.3l21.5 75.1C9.5 229.4 0 241.6 0 256s9.5 26.6 22.6 30.6L1.2 361.7C.4 364.4 0 367.2 0 370c0 16.6 13.4 30 30 30h42c10.1 0 19.6-4.7 25.6-12.8L136 336h54.7l-43 145.2c-4.6 15.4 7 30.8 23 30.8h76.2c11.3 0 21.8-6 27.5-15.7L303 448h41c22.1 0 40-17.9 40-40v-16c0-17-10.6-31.6-25.6-37.3l11-18.7h96.9c20.6 0 46.8-8.1 67.9-20.8 20.2-12.1 41.8-32.3 41.8-59.2zM341 384h3c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-22l19-32zm3-256h-3l-19-32h22c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8zm122.3 80c13.5 0 34.1 6.1 51.3 16.6 8.5 5.2 15.4 10.9 20 16.7 4.6 5.8 6.3 10.7 6.3 14.8 0 9.1-8.2 20.9-26.3 31.8-17.2 10.3-37.8 16.2-51.4 16.2h-106c-5.7 0-10.9 3-13.8 7.8L246.9 480h-65.5l46.1-155.5c1.4-4.8.5-10.1-2.5-14.1s-7.8-6.4-12.8-6.4H128c-5 0-9.8 2.4-12.8 6.4L72 368H32.6l30.8-107.6c.8-2.9.8-5.9 0-8.8L32.6 144H72l43.2 57.6c3 4 7.8 6.4 12.8 6.4h84.1c5 0 9.8-2.4 12.8-6.4s4-9.3 2.5-14.1L181.4 32h65.5l99.6 168.2c2.9 4.9 8.1 7.8 13.8 7.8h106z"
        }
    ]
};

const FalPlaneLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-13.4 0-25.2 5.7-34.8 13.3-9.5 7.6-17.6 17.7-24 28.4-12.8 21-21.2 47.3-21.2 68v52.5L24.2 248.9C9.2 257.4 0 273.3 0 290.6v56.2c0 21.3 20.3 36.6 40.8 30.8L176 338.9V376l-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30 2.8 0 5.6-.4 8.3-1.2L256 480.6l105.7 30.2c2.1.6 4.2 1 6.3 1.1v-32.5l-107.6-30.8c-2.9-.8-5.9-.8-8.8 0L144 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8v-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L32 346.8v-56.2c0-5.7 3.1-11 8.1-13.9L200 185.3c5-2.8 8.1-8.2 8.1-13.9v-61.7c0-13.5 6.1-34.1 16.6-51.3 5.2-8.5 10.9-15.4 16.7-20C247 33.7 251.9 32 256 32c9.1 0 20.9 8.2 31.8 26.3 10.3 17.2 16.2 37.8 16.2 51.4v61.7c0 5.7 3.1 11 8.1 13.9L419 246.4c2.5-10.7 6.5-20.8 11.9-30.1L336 162.1v-52.4c0-20.6-8.1-46.8-20.8-67.9C303.1 21.6 282.9 0 256 0zm80 376v-37.1l48 13.7v-.6c0-11 2.8-21.4 7.7-30.4l-67.3-19.2c-4.8-1.4-10-.4-14 2.6s-6.4 7.8-6.4 12.8V384c0 5 2.4 9.8 6.4 12.8L368 440v-40l-32-24zm192-152c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80h160v128H448V352z"
        }
    ]
};

const FalPlaneProp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneProp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M270 0c-16 0-29.6 11.9-31.7 27.8L235.6 48H224c-26.5 0-48 21.5-48 48 0 26.1 20.8 47.3 46.8 48l-4.9 37-67.1 9-3.9-27.6c-2.9-19.8-19.8-34.4-39.7-34.4H84.8c-19.9 0-36.8 14.6-39.6 34.3l-6.1 42.9C16.3 211.2 0 231.9 0 256s16.3 44.8 39.1 50.8l6.1 42.9C48 369.4 64.9 384 84.8 384h22.4c19.9 0 36.8-14.6 39.6-34.3l3.9-27.6 67.1 9 4.9 37c-26 .6-46.8 21.9-46.8 48 0 26.5 21.5 48 48 48h11.6l2.7 20.2C240.4 500.1 254 512 270 512h36c16 0 29.6-11.9 31.7-27.8l7-52.2H368v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c8.8 0 16-7.2 16-16s-7.2-16-16-16v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-19.1l8.5-64h108.8c20.6 0 46.8-8.1 67.9-20.8 20.3-12.1 41.9-32.3 41.9-59.2 0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2H357.5l-8.5-64h19v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c8.8 0 16-7.2 16-16s-7.2-16-16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-23.3l-7-52.2C335.6 11.9 322 0 306 0h-36zm-46 400h3.1l4.3 32H224c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0-320h7.3l-4.3 32h-3c-8.8 0-16-7.2-16-16s7.2-16 16-16zm101.2 96H256c-.7 0-1.4 0-2.1.1l-3.2.4L270 32h36l19.2 144zm0 160L306 480h-36l-19.3-144.6 3.2.4c.7.1 1.4.1 2.1.1h69.2zM76.9 166.9c.6-3.9 3.9-6.9 7.9-6.9h22.4c4 0 7.4 2.9 7.9 6.9l6.2 43.2c1.2 8.7 9.3 14.8 18 13.6L257.1 208h209.2c13.5 0 34.1 6.1 51.3 16.6 8.5 5.2 15.4 10.9 20 16.7 4.6 5.8 6.3 10.7 6.3 14.8 0 9.1-8.2 20.9-26.3 31.8-17.2 10.3-37.8 16.2-51.4 16.2H256.9l-117.7-15.8c-8.7-1.2-16.7 4.9-18 13.6l-6.2 43.2c-.6 3.9-3.9 6.9-7.9 6.9H84.8c-4 0-7.4-2.9-7.9-6.9l-7.8-54.4c-1-7.1-6.6-12.6-13.7-13.6l-5.6-.7C39.6 275 32 266.3 32 256s7.6-19 17.8-20.4l5.6-.7c7.1-.9 12.7-6.5 13.7-13.6l7.8-54.4z"
        }
    ]
};

const FalPlaneSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m347.6 359.4-64.3 112.5c-2.8 5-8.2 8.1-13.9 8.1h-56.2l44.5-155.6c1.4-4.8.4-10-2.6-14s-7.8-6.4-12.8-6.4H160c-5 0-9.8 2.4-12.8 6.4L104 368H64.6l30.8-107.6c.8-2.9.8-5.9 0-8.8L64.6 144h10.2L43 118.8c-6.7 5.5-11 13.9-11 23.2 0 2.8.4 5.6 1.2 8.3L63.4 256 33.2 361.7c-.8 2.7-1.2 5.5-1.2 8.2 0 16.6 13.4 30 30 30h42c10.1 0 19.6-4.7 25.6-12.8L168 336h53.1l-38.7 135.2c-5.8 20.4 9.5 40.8 30.8 40.8h56.2c17.2 0 33.1-9.2 41.7-24.2L373 379.4l-25.4-20.1zM182.4 40.8l9.2 32.4 43 33.9L213.2 32h56.2c5.7 0 11 3.1 13.9 8.1l13.9-7.9-13.9 7.9L374.7 200c2.9 5 8.2 8.1 13.9 8.1h109.7c13.5 0 34.1 6.1 51.3 16.6 8.5 5.2 15.4 10.9 20 16.7 4.6 5.8 6.3 10.7 6.3 14.8 0 9.1-8.2 20.9-26.3 31.8-17.2 10.3-37.8 16.2-51.4 16.2h-14.1l37.1 29.3c15.2-3.4 31.2-9.7 45.1-18 20.1-12.4 41.7-32.6 41.7-59.5 0-13.4-5.7-25.2-13.3-34.8s-17.7-17.6-28.4-24c-21-12.8-47.3-21.2-68-21.2H397.8L311.1 24.2C302.6 9.2 286.7 0 269.4 0h-56.2c-21.2 0-36.6 20.3-30.8 40.8zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalPlaneTail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneTail",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M47.7 32h46.4c12.5 0 24.4 4.8 33.4 13.5L345 256h-80.6c-7 0-13.9.9-20.6 2.7L85.9 300.8 32 51.4C29.9 41.4 37.5 32 47.7 32zM.7 58.1 55 309l-6.7 1.8C19.8 318.4 0 344.2 0 373.7c0 27.3 17 51.7 42.7 61.1l197.1 72.3c8.8 3.2 18.1 4.9 27.5 4.9H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H267.4c-5.6 0-11.2-1-16.5-2.9L53.7 404.8C40.7 400 32 387.6 32 373.7c0-15 10.1-28.1 24.6-32L252 289.6c4-1.1 8.2-1.6 12.4-1.6H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H390.3l.4-.4-11.5-11.1-229.5-222C134.8 8.1 114.9 0 94.1 0H47.7C17.1 0-5.7 28.2.7 58.1zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"
        }
    ]
};

const FalPlaneUpSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneUpSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m464 461.4-32-25.3v43.3l-107.6-30.8c-2.9-.8-5.9-.8-8.8 0L208 479.4V440l57.6-43.2c4-3 6.4-7.8 6.4-12.8v-66.3c0-5-2.4-9.8-6.4-12.8s-9.2-4-14-2.6L96 346.8v-56.2c0-5.7 3.1-11 8.1-13.9l73.1-41.7-27.2-21.4-61.8 35.3c-15 8.5-24.2 24.5-24.2 41.7v56.2c0 21.3 20.3 36.6 40.8 30.8L240 338.9V376l-51.2 38.4c-8.1 6-12.8 15.5-12.8 25.6v42c0 16.6 13.4 30 30 30 2.8 0 5.6-.4 8.3-1.2L320 480.6l105.7 30.2c2.7.8 5.5 1.2 8.2 1.2 16.6 0 30-13.4 30-30v-20.6zm-223.6-360 31.6 25v-16.7c0-13.5 6.1-34.1 16.6-51.3 5.2-8.5 10.9-15.4 16.7-20C311 33.7 315.9 32 320 32c9.1 0 20.9 8.2 31.8 26.3 10.3 17.2 16.2 37.8 16.2 51.4v61.7c0 5.7 3.1 11 8.1 13.9L536 276.7c5 2.8 8.1 8.2 8.1 13.9v50.5l27.6 21.8c2.8-4.7 4.4-10.2 4.4-16.2v-56.1c0-17.2-9.2-33.1-24.2-41.7L400 162.1v-52.4c0-20.6-8.1-46.8-20.8-67.9C367.1 21.6 346.9 0 320 0c-13.4 0-25.2 5.7-34.8 13.3-9.5 7.6-17.6 17.7-24 28.4-11.1 18.3-19 40.6-20.8 59.7zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalPlaneUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlaneUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M221.2 13.3C230.8 5.7 242.6 0 256 0c26.9 0 47.1 21.6 59.2 41.8 12.7 21.1 20.8 47.3 20.8 67.9v52.5L487.8 249c15 8.5 24.2 24.5 24.2 41.7v56.2c0 21.3-20.3 36.6-40.8 30.8L336 338.9V376l51.2 38.4c8.1 6 12.8 15.5 12.8 25.6v42c0 16.6-13.4 30-30 30-2.8 0-5.6-.4-8.2-1.2L256 480.6l-105.7 30.2c-2.7.8-5.5 1.2-8.3 1.2-16.6 0-30-13.4-30-30v-42c0-10.1 4.7-19.6 12.8-25.6L176 376v-37.1L40.8 377.6C20.3 383.4 0 368 0 346.8v-56.2c0-17.2 9.2-33.1 24.2-41.7L176 162.1v-52.4c0-20.7 8.4-46.9 21.2-67.9 6.5-10.7 14.5-20.8 24-28.4zm3.3 45C214.1 75.6 208 96.2 208 109.7v61.7c0 5.7-3.1 11-8.1 13.9L40.1 276.7c-5 2.8-8.1 8.2-8.1 13.9v56.2l155.6-44.5c4.8-1.4 10-.4 14 2.6s6.4 7.8 6.4 12.8V384c0 5-2.4 9.8-6.4 12.8L144 440v39.4l107.6-30.7c2.9-.8 5.9-.8 8.8 0L368 479.4V440l-57.6-43.2c-4-3-6.4-7.8-6.4-12.8v-66.3c0-5 2.4-9.8 6.4-12.8s9.2-4 14-2.6L480 346.8v-56.2c0-5.7-3.1-11-8.1-13.9l-159.8-91.4c-5-2.8-8.1-8.2-8.1-13.9v-61.7c0-13.6-5.9-34.2-16.2-51.4C276.9 40.2 265.1 32 256 32c-4.1 0-9 1.7-14.8 6.3-5.8 4.6-11.5 11.5-16.7 20z"
        }
    ]
};

const FalPlane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlane",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M562.7 221.2c7.6 9.5 13.3 21.3 13.3 34.8 0 26.9-21.6 47.1-41.8 59.2-21.1 12.7-47.3 20.8-67.9 20.8H365.9l-86.8 151.8c-8.5 15-24.5 24.2-41.7 24.2h-56.2c-21.3 0-36.6-20.3-30.8-40.8L189.1 336H136l-38.4 51.2c-6 8.1-15.5 12.8-25.6 12.8H30c-16.6 0-30-13.4-30-30 0-2.8.4-5.6 1.2-8.2L31.4 256 1.2 150.3C.4 147.6 0 144.8 0 142c0-16.6 13.4-30 30-30h42c10.1 0 19.6 4.7 25.6 12.8L136 176h53.1L150.4 40.8C144.6 20.3 160 0 181.2 0h56.2c17.2 0 33.1 9.2 41.7 24.2L365.9 176h100.4c20.7 0 46.9 8.4 68 21.2 10.7 6.5 20.8 14.5 28.4 24zm-45 3.3c-17.3-10.5-37.9-16.6-51.3-16.6H356.6c-5.7 0-11-3.1-13.9-8.1L251.3 40.1l13.9-7.9-13.9 7.9c-2.8-5-8.2-8.1-13.9-8.1h-56.2l44.5 155.6c1.4 4.8.4 10-2.6 14s-7.8 6.4-12.8 6.4H128c-5 0-9.8-2.4-12.8-6.4L72 144H32.6l30.8 107.6c.8 2.9.8 5.9 0 8.8L32.6 368H72l43.2-57.6c3-4 7.8-6.4 12.8-6.4h82.3c5 0 9.8 2.4 12.8 6.4s4 9.2 2.6 14L181.2 480h56.2c5.7 0 11-3.1 13.9-8.1L342.7 312c2.9-5 8.2-8.1 13.9-8.1h109.7c13.6 0 34.2-5.9 51.4-16.2 18.1-10.8 26.3-22.6 26.3-31.7 0-4.1-1.7-9-6.3-14.8-4.6-5.8-11.5-11.5-20-16.7z"
        }
    ]
};

const FalPlanetMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlanetMoon",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM224 480c-106 0-192-86-192-192 0-8.1.5-16.1 1.5-24h58.6c8.5 0 16.6 3.4 22.6 9.4l37.3 37.2v31.5c0 17 9.6 32.6 24.8 40.2 4.4 2.2 7.2 6.7 7.2 11.6v15.3c0 25.8 21 46.8 46.8 46.8 16.2 0 31.3-8.4 39.9-22.3l45.5-73.9c7.8-12.6 11.9-27.1 11.9-41.9V296c0-26.5-21.5-48-48-48h-61.6c-5.2 0-10-3-12.4-7.7-2.2-4.4-1.9-9.7.9-13.9l42.3-63.4c9.8-14.7 14.4-32.1 13.3-49.7l-.9-13.6C349.6 117.2 416 194.8 416 288c0 106-86 192-192 192zM40.3 232c24-78.7 97.1-136 183.7-136 1.8 0 3.5 0 5.3.1l1.3 19.3c.7 10.5-2.1 21-8 29.8l-42.3 63.5c-9.1 13.7-10.2 31.2-2.9 45.9 7.8 15.5 23.6 25.3 41 25.3H280c8.8 0 16 7.2 16 16v21.9c0 8.9-2.5 17.6-7.1 25.2l-45.5 74c-2.7 4.4-7.5 7-12.6 7-8.2 0-14.8-6.6-14.8-14.8v-15.3c0-17-9.6-32.6-24.8-40.2-4.4-2.2-7.2-6.7-7.2-11.6v-44.7l-4.7-4.7-41.9-41.9c-12-12-28.3-18.7-45.3-18.7H40.3zM227.2 64H224C100.3 64 0 164.3 0 288s100.3 224 224 224 224-100.3 224-224c0-111.7-81.7-204.2-188.6-221.2-10.5-1.7-21.3-2.6-32.3-2.8z"
        }
    ]
};

const FalPlanetRinged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlanetRinged",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 32c-2.5 0-6.6.4-12.8 1.9-15.8 3.9-37.7 13.4-64.7 29.3l-2 1.2c-9.5-7.2-19.5-13.6-29.8-19.2C434.5 4.7 484.6-11 503.8 8.2c22.1 22.1-2.3 85.6-57.6 163.7C457.7 197.6 464 226 464 256c0 114.9-93.1 208-208 208-30 0-58.4-6.3-84.2-17.7C93.7 501.6 30.3 526 8.1 503.9c-19.2-19.2-3.4-69.3 37-133.1 5.6 10.3 12 20.2 19.2 29.8l-1.2 2c-15.9 27-25.5 48.9-29.3 64.7-1.4 6.2-1.8 10.2-1.8 12.7 2.5 0 6.6-.4 12.8-1.9 15.8-3.9 37.7-13.4 64.7-29.3 9.9-5.9 20.3-12.5 31.1-19.7C84.7 391.7 48 328.2 48 256c0-114.9 93.1-208 208-208 72.2 0 135.7 36.7 173 92.5 7.3-10.8 13.9-21.1 19.7-31.1 15.9-26.9 25.5-48.9 29.3-64.7 1.5-6.3 1.9-10.3 1.9-12.8zm-71.1 136.8C378.6 115.8 321.5 80 256 80c-97.2 0-176 78.8-176 176 0 65.5 35.8 122.6 88.8 152.9 40.2-29.8 84.2-67.8 128.3-111.8s82-88.1 111.9-128.2zM202.3 423.7c16.9 5.4 34.9 8.3 53.7 8.3 97.2 0 176-78.8 176-176 0-18.7-2.9-36.7-8.3-53.7-29 37.6-64.2 77.6-104 117.3s-79.8 74.9-117.3 104z"
        }
    ]
};

const FalPlantWilt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlantWilt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 96c0-35.3 28.7-64 64-64s64 28.7 64 64v33.1c-38.4 5.7-64 32.2-64 73.9 0 27.9 25.3 74.8 66 111.6 3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6 0-41.7-25.6-68.3-64-73.9V96c0-53-43-96-96-96s-96 43-96 96v65.6c-20.3-20.7-48.7-33.6-80-33.6-61.9 0-112 50.1-112 112v17.1C25.6 262.8 0 289.3 0 331c0 28 25.3 74.9 66 111.7 3.8 3.5 8.9 5.3 14 5.3s10.2-1.8 14-5.3c40.7-36.8 66-83.7 66-111.6 0-41.7-25.6-68.3-64-73.9V240c0-44.2 35.8-80 80-80s80 35.8 80 80v256c0 8.8 7.2 16 16 16s16-7.2 16-16V96zm128 65.7V192c0 8.8 7.2 16 16 16s16-7.2 16-16v-30.3c8.9 2 15.5 5.6 20.1 9.8 6.6 6 11.9 15.8 11.9 31.6 0 5.8-3.3 18.8-13.5 36.5-8.3 14.5-20.1 30-34.5 44.3-14.4-14.3-26.2-29.9-34.5-44.3-10.2-17.7-13.5-30.7-13.5-36.5 0-15.8 5.3-25.6 11.9-31.6 4.6-4.2 11.2-7.8 20.1-9.8zM43.9 299.5c4.6-4.2 11.2-7.8 20.1-9.8v30.6c0 8.8 7.2 16 16 16s16-7.2 16-16v-30.6c8.9 2 15.5 5.6 20.1 9.8 6.6 6 11.9 15.8 11.9 31.6 0 5.8-3.3 18.8-13.5 36.5-8.3 14.5-20.1 30-34.5 44.3-14.4-14.3-26.2-29.9-34.5-44.3C35.3 349.8 32 336.9 32 331.1c0-15.8 5.3-25.6 11.9-31.6z"
        }
    ]
};

const FalPlateUtensils = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlateUtensils",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 16C7.2 16 0 23.2 0 32v144c0 26.5 21.5 48 48 48h16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V224h16c26.5 0 48-21.5 48-48V32c0-8.8-7.2-16-16-16s-16 7.2-16 16v144c0 8.8-7.2 16-16 16H96V32c0-8.8-7.2-16-16-16s-16 7.2-16 16v160H48c-8.8 0-16-7.2-16-16V32c0-8.8-7.2-16-16-16zm482 62.9C455.3 39.8 398.4 16 336 16c-54 0-103.9 17.9-144 48v41.9C229.4 70 280.1 48 336 48c58.9 0 112 24.5 149.9 63.8 3.1-12 7.2-22.9 12.1-32.9zm24.5 269.4C488.5 416.9 417.7 464 336 464c-73.8 0-138.6-38.4-175.5-96.4-8.5 6.5-18.3 11.3-29 14C173.7 450.2 249.5 496 336 496c98.4 0 183-59.2 220-144h-12c-7.6 0-14.8-1.3-21.5-3.7zM480 256a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-256 0a112 112 0 1 1 224 0 112 112 0 1 1-224 0zM608 54.4V288h-64V160c0-61.3 39.4-92.2 64-105.6zM640 288V36.9c0-11.5-9.3-20.9-20.9-20.9-2.1 0-4.1.3-6.1 1-16.8 6.2-101 42.2-101 143v128c0 17.7 14.3 32 32 32h64v160c0 8.8 7.2 16 16 16s16-7.2 16-16V288z"
        }
    ]
};

const FalPlateWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlateWheat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 112v5.3c-18.6-6.6-32-24.4-32-45.3v-5.3c18.6 6.6 32 24.4 32 45.3zm-64-64v24c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16v-24c0-44.2-35.8-80-80-80-8.8 0-16 7.2-16 16zM48 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm-32 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm16 96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm304-122.7c-18.6-6.6-32-24.4-32-45.3v-5.3c18.6 6.6 32 24.4 32 45.3v5.3zM288 32c-8.8 0-16 7.2-16 16v24c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16v-24c0-44.2-35.8-80-80-80zm160 80v5.3c-18.6-6.6-32-24.4-32-45.3v-5.3c18.6 6.6 32 24.4 32 45.3zm-64-64v24c0 44.2 35.8 80 80 80 8.8 0 16-7.2 16-16v-24c0-44.2-35.8-80-80-80-8.8 0-16 7.2-16 16zm-80 205.3V248c0-20.9 13.4-38.7 32-45.3v5.3c0 20.9-13.4 38.7-32 45.3zm48-85.3c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80v-24c0-8.8-7.2-16-16-16zm-160 80c0-20.9 13.4-38.7 32-45.3v5.3c0 20.9-13.4 38.7-32 45.3V248zm64-64c0-8.8-7.2-16-16-16-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80v-24zm160 69.3V248c0-20.9 13.4-38.7 32-45.3v5.3c0 20.9-13.4 38.7-32 45.3zm48-85.3c-44.2 0-80 35.8-80 80v24c0 8.8 7.2 16 16 16 44.2 0 80-35.8 80-80v-24c0-8.8-7.2-16-16-16zM129.8 441.1c-5.5-9.5-15.5-15.6-26.5-16C64 423.6 32.5 391.5 32 352h448c-.5 39.5-32 71.6-71.3 73.1-11 .4-21 6.5-26.5 16a13.7 13.7 0 0 1-11.9 6.9H141.7c-5 0-9.5-2.7-11.9-6.9zM31 320c-17.1 0-31 13.9-31 31 0 57.3 45.3 103.9 102.1 106.1 7.9 13.7 22.7 22.9 39.6 22.9h228.6c17 0 31.8-9.2 39.6-22.9C466.7 454.9 512 408.2 512 351c0-17.1-13.9-31-31-31H31z"
        }
    ]
};

const FalPlayPause = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlayPause",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v352c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v352c0 8.8 7.2 16 16 16s16-7.2 16-16V80zM288 256 96 416V96l192 160zM116.5 71.4c-9.5-7.9-22.8-9.7-34.1-4.4S64 83.6 64 96v320c0 12.4 7.2 23.7 18.4 29s24.5 3.6 34.1-4.4l192-160c7.3-6.1 11.5-15.1 11.5-24.6s-4.2-18.5-11.5-24.6l-192-160z"
        }
    ]
};

const FalPlay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlay",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56.3 66.3c-4.9-3-11.1-3.1-16.2-.3s-8.2 8.2-8.2 14v352c0 5.8 3.1 11.1 8.2 14s11.2 2.7 16.2-.3l288-176c4.8-2.9 7.7-8.1 7.7-13.7s-2.9-10.7-7.7-13.7l-288-176zM24.5 38.1C39.7 29.6 58.2 30 73 39l288 176c14.3 8.7 23 24.2 23 41s-8.7 32.2-23 41L73 473c-14.8 9.1-33.4 9.4-48.5.9S0 449.4 0 432V80c0-17.4 9.4-33.4 24.5-41.9z"
        }
    ]
};

const FalPlugCircleBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlugCircleBolt",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-96.8c17.3-1.7 33.7-6.2 48.9-12.9-.6-6-.9-12.1-.9-18.3 0-6 .3-11.8.9-17.6-19 11.2-41.2 17.6-64.9 17.6-70.7 0-128-57.3-128-128v-64h256v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm304 224a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-96.1-81c-4.3-3.7-10.6-4-15.1-.6l-96 72c-4.1 3.1-5.8 8.5-4.2 13.4s6.2 8.2 11.4 8.2h35.6l-30.1 54.2c-2.8 5-1.7 11.1 2.6 14.9s10.6 4 15.1.6l96-72c4.1-3.1 5.8-8.5 4.2-13.4s-6.2-8.2-11.4-8.2h-35.6l30.1-54.2c2.8-5 1.7-11.1-2.6-14.9z"
        }
    ]
};

const FalPlugCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlugCircleCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-96.8c17.3-1.7 33.7-6.2 48.9-12.9-.6-6-.9-12.1-.9-18.3 0-6 .3-11.8.9-17.6-19 11.2-41.2 17.6-64.9 17.6-70.7 0-128-57.3-128-128v-64h256v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm416 112a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm67.3-187.3c-6.2-6.2-16.4-6.2-22.6 0L416 385.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l40 40c6.2 6.2 16.4 6.2 22.6 0l72-72c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalPlugCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlugCircleExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-96.8c17.3-1.7 33.7-6.2 48.9-12.9-.6-6-.9-12.1-.9-18.3 0-6 .3-11.8.9-17.6-19 11.2-41.2 17.6-64.9 17.6-70.7 0-128-57.3-128-128v-64h256v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm304 224a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalPlugCircleMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlugCircleMinus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-96.8c17.3-1.7 33.7-6.2 48.9-12.9-.6-6-.9-12.1-.9-18.3 0-6 .3-11.8.9-17.6-19 11.2-41.2 17.6-64.9 17.6-70.7 0-128-57.3-128-128v-64h256v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm416 112a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm80-144c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16z"
        }
    ]
};

const FalPlugCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlugCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16zM112 0c8.8 0 16 7.2 16 16v96H96V16c0-8.8 7.2-16 16-16zm160 0c8.8 0 16 7.2 16 16v96h-32V16c0-8.8 7.2-16 16-16zM0 160c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v35.2c-11.4 5.9-22.2 12.9-32 21V176H64v64c0 70.7 57.3 128 128 128 23.7 0 45.8-6.4 64.9-17.6-.6 5.8-.9 11.7-.9 17.6 0 6.2.3 12.3.9 18.3-15.2 6.8-31.7 11.2-48.9 12.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96.8C95.1 391.2 32 323 32 240v-64H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalPlugCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlugCircleXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-96.8c17.3-1.7 33.7-6.2 48.9-12.9-.6-6-.9-12.1-.9-18.3 0-6 .3-11.8.9-17.6-19 11.2-41.2 17.6-64.9 17.6-70.7 0-128-57.3-128-128v-64h256v56.2c9.8-8.1 20.6-15.2 32-21V176h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm304 224a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-84.7-36.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L432 345.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L454.6 368l36.7-36.7z"
        }
    ]
};

const FalPlug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlug",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v96h32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v96h32V16zM16 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64c0 83 63.1 151.2 144 159.2V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-96.8c80.9-8 144-76.2 144-159.2v-64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm176 224c-70.7 0-128-57.3-128-128v-64h256v64c0 70.7-57.3 128-128 128z"
        }
    ]
};

const FalPlusLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlusLarge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v224H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h224v224c0 8.8 7.2 16 16 16s16-7.2 16-16V272h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V16z"
        }
    ]
};

const FalPlusMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlusMinus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 208v144c0 8.8 7.2 16 16 16s16-7.2 16-16V208h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H208V32c0-8.8-7.2-16-16-16s-16 7.2-16 16v144H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h144zM16 464c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v176H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h176v176c0 8.8 7.2 16 16 16s16-7.2 16-16V272h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V64z"
        }
    ]
};

const FalPodcast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPodcast",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 224c0 71.3-38.8 133.5-96.5 166.6-1.4 11.5-3.2 23.4-5 34.8l-.6 3.8C392.8 394.7 448 315.8 448 224 448 100.3 347.7 0 224 0S0 100.3 0 224c0 91.8 55.2 170.6 134.2 205.3l-.6-3.7c-1.9-11.5-3.7-23.5-5.1-35C70.8 357.5 32 295.3 32 224c0-106 86-192 192-192s192 86 192 192zm-48 0c0-79.5-64.5-144-144-144S80 144.5 80 224c0 42.4 18.3 80.5 47.5 106.9 1.6-7.1 4.3-13.9 8.1-20.3 2.1-3.5 4.5-6.7 7-9.7-19-20.1-30.6-47.1-30.6-76.9 0-61.9 50.1-112 112-112s112 50.1 112 112c0 29.8-11.6 56.8-30.6 76.9 2.5 2.9 4.9 6.1 7 9.7 3.8 6.3 6.4 13.1 8.1 20.3C349.7 304.5 368 266.4 368 224zm-144-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-14.5 190.2c-3.6-13.6-8.6-37.7-12.7-63-4.3-26.4-7.3-51.3-7.3-65.7 0-4.3.9-5.8 1.1-6.1.2-.3.7-1.2 2.8-2.3 5.2-2.9 15.3-5.1 30.7-5.1s25.5 2.2 30.7 5.1c2.1 1.1 2.6 2 2.8 2.3.2.3 1.1 1.8 1.1 6.1 0 14.3-2.9 39.2-7.3 65.6-4.1 25.2-9.1 49.4-12.8 63.1-1 .4-2.5.8-4.9 1.2-2.7.4-5.9.6-9.7.6s-7-.2-9.7-.6c-2.3-.4-3.9-.8-4.9-1.2zm-30.6 9.5c5.3 19.8 25.5 24.3 45.1 24.3s39.8-4.6 45.1-24.3c8.1-29.9 21.5-103.9 21.5-138.2 0-36.5-32.4-45.5-66.6-45.5s-66.6 9-66.6 45.5c0 34.4 13.4 108.5 21.5 138.2z"
        }
    ]
};

const FalPodiumStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPodiumStar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c26.5 0 48-21.5 48-48S314.5 0 288 0h-64c-20.9 0-38.7 13.4-45.3 32H168c-44.2 0-80 35.8-80 80v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H120v-48c0-26.5 21.5-48 48-48h10.7c6.6 18.6 24.4 32 45.3 32zM47.3 224l26.2 231.2c3.7 32.3 31 56.8 63.6 56.8h173.8c32.5 0 59.9-24.4 63.6-56.8L400.7 224h-32.2l-25.8 227.6c-1.8 16.2-15.5 28.4-31.8 28.4H137.1c-16.3 0-30-12.2-31.8-28.4L79.5 224H47.3zm214.2 58.8L245.3 246c-8.2-18.6-34.2-18.6-42.4 0l-16.2 36.8-38.2 4.7c-20.5 2.5-26.6 27.4-13.2 40.4l28.7 27.8-7.8 40.3c-3.4 18 15.6 35.9 34.4 24.8l33.4-19.5 33.4 19.6c18.8 11 37.8-6.9 34.4-24.8l-7.6-40.3 28.7-27.8c13.4-13 7.3-37.9-13.2-40.4l-38.2-4.7zM214 300.2l10.1-23 10.1 23c3.2 7.3 10 12.7 18.4 13.8l25.5 3.2-19.4 18.7c-5.8 5.6-8.2 13.8-6.8 21.5l5 26.1-21.3-12.5c-7.2-4.2-16-4.2-23.2 0l-21.2 12.4 5-26.1c1.5-7.7-1-15.9-6.8-21.5L170 317.1l25.5-3.2c8.3-1 15.2-6.5 18.4-13.8z"
        }
    ]
};

const FalPodium = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPodium",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16zM178.7 64H168c-26.5 0-48 21.5-48 48v48h312c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h72v-48c0-44.2 35.8-80 80-80h10.7c6.6-18.6 24.4-32 45.3-32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48h-64c-20.9 0-38.7-13.4-45.3-32zM73.5 455.2 47.3 224h32.2l25.9 227.6c1.8 16.2 15.5 28.4 31.8 28.4h173.7c16.3 0 30-12.2 31.8-28.4L368.5 224h32.2l-26.2 231.2c-3.7 32.3-31 56.8-63.6 56.8H137.1c-32.6 0-59.9-24.4-63.6-56.8z"
        }
    ]
};

const FalPoliceBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPoliceBox",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H96c-17.7 0-32 14.3-32 32v.8C45.7 68.5 32 84.6 32 104v376H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V104c0-19.4-13.7-35.5-32-39.2V64c0-17.7-14.3-32-32-32h-80V16zm112 88v376H64V104c0-4.4 3.6-8 8-8h8c8.8 0 16-7.2 16-16V64h192v16c0 8.8 7.2 16 16 16h8c4.4 0 8 3.6 8 8zM112 328v-48h48v48h-48zm-24-56v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm24-120h20v20h-20v-20zm28 0h20v20h-20v-20zm0 28h20v20h-20v-20zm-8 20h-20v-20h20v20zm-28-72c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64zm120 72v-20h20v20h-20zm28 0v-20h20v20h-20zm0-28v-20h20v20h-20zm-8-20v20h-20v-20h20zm-44-8v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalPollPeople = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPollPeople",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm448 16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-80V64h80zm-320 0h208v96H272c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H272zm320 320c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H384v-96h208zm-320 0h80v96h-80c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H272zM1.1 486.1l-1 7.9c-1.1 8.8 5.1 16.8 13.9 17.9s16.8-5.1 17.9-13.9l1-7.9c3-24 23.4-42 47.6-42h31c24.2 0 44.6 18 47.6 42l1 7.9c1.1 8.8 9.1 15 17.9 13.9s15-9.1 13.9-17.9l-1-7.9c-5-40-39-70.1-79.4-70.1h-31c-40.3 0-74.4 30-79.4 70.1zm0-288-1 7.9c-1.1 8.8 5.1 16.8 13.9 17.9s16.8-5.1 17.9-13.9l1-7.9c3-24 23.4-42 47.6-42h31c24.2 0 44.6 18 47.6 42l1 7.9c1.1 8.8 9.1 15 17.9 13.9s15-9.1 13.9-17.9l-1-7.9c-5-40-39-70.1-79.4-70.1h-31c-40.3 0-74.4 30-79.4 70.1zM80 336a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FalPompebled = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPompebled",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M257.2 22.7c53.3 36.8 58 117.1 21.4 183.5l-.4.7-.5.7c-.6.9-.4 2 .3 2.5.2.2.4.2.4.2h.2s.2 0 .3-.1.3-.2.4-.5l.4-.6.4-.5c47.8-58 123.3-82.4 176.4-44.3 64 45.3 72.1 140.1 25.2 209.7-83.4 123.2-257.1 185-380.5 96.5l9.3-13-9.3 13C-21.9 382.3-27.4 196.3 56.1 73.1L69.3 82l-13.2-9c47-70.1 136.8-95.8 201.1-50.3zm-18.4 26.1C192.6 16.1 122.2 31.9 82.6 90.9v.1C5.7 204.5 15 369.3 120.1 444.4 224.2 519 378.6 469.5 455.5 356c39.6-58.7 29.4-132.7-17.2-165.7l-.1-.1c-33.4-24-90.3-12.8-132.7 38.3-10.7 14.7-31 18.3-46 7.5-14.7-10.6-18.2-30.8-8.5-45.8 32.1-58.8 22.1-117.8-12-141.2l-.2-.1z"
        }
    ]
};

const FalPooStorm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPooStorm",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M173.8 6.7c3-4.2 7.9-6.7 13-6.7C257.3 0 326.2 46 335 119.6c28.9 13.3 49 42.5 49 76.4 0 3.5-.2 7-.6 10.4 37.7 14.3 64.6 50.8 64.6 93.6 0 55.2-44.8 100-100 100h-8.9l12.1-11.5c6.7-6.3 11.5-14.2 14.3-22.8C394.6 358 416 331.5 416 300c0-33-23.5-60.5-54.6-66.7-4.5-.9-8.4-3.7-10.7-7.7s-2.8-8.8-1.3-13.1c1.7-5.2 2.7-10.7 2.7-16.5 0-23.4-15.5-43.2-36.8-49.7-6.5-2-11-7.9-11.3-14.7-2-50.8-42.9-88.8-94.2-97.6.4 1.4.8 2.7 1.3 4.1 2.3 7.8 5 17.8 5 25.4 0 34.8-17.7 55.5-35.3 66.9-8.5 5.5-17 8.8-23.2 10.7-3 .9-5.6 1.6-7.5 2-1.5.6-3.2 1-4.9 1.1C117.7 145.6 96 168.3 96 196c0 5.8.9 11.4 2.7 16.5 1.5 4.4 1 9.1-1.3 13.1s-6.2 6.8-10.7 7.7C55.5 239.5 32 267 32 300c0 32 22.2 58.9 52 66.1-2.6 6.4-4 13.3-4 20.3 0 4.1.5 8 1.3 11.8C35 389.5 0 348.8 0 300c0-42.8 26.9-79.3 64.6-93.6-.4-3.4-.6-6.9-.6-10.4 0-43.7 33.4-79.6 76.1-83.6.5-.1 1.1-.2 1.6-.3h.2c.2 0 .6-.1 1.2-.2 1.1-.2 2.8-.7 5-1.3 4.3-1.3 9.8-3.5 15.3-7 10.4-6.7 20.7-18.2 20.7-40 0-2.2-1.2-7.8-3.7-16.2-2.3-7.6-5.1-15.6-7.1-21.5l-.1-.2c-.6-1.6-1.1-3.1-1.5-4.3-1.7-4.9-.9-10.3 2.1-14.5zM159.7 376H208c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9 85.2-80.6H240c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9-85.2 80.6zm121.9-152c14.7 0 24.4 15.2 18.2 28.5L265 328h49.4c11.9 0 21.6 9.7 21.6 21.6 0 5.9-2.4 11.6-6.7 15.7L180.2 506.5c-3.7 3.5-8.7 5.5-13.8 5.5-14.7 0-24.4-15.2-18.2-28.5L183 408h-49.4c-11.9 0-21.6-9.7-21.6-21.6 0-5.9 2.4-11.6 6.7-15.7l149.1-141.2c3.7-3.5 8.7-5.5 13.8-5.5z"
        }
    ]
};

const FalPoo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPoo",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c-6.5 0-12.3 3.9-14.8 9.9s-1.1 12.9 3.5 17.4l5.8 5.8c8.7 8.7 13.5 20.4 13.5 32.7v8.9c0 20.6-16.7 37.3-37.3 37.3H176c-48.6 0-88 39.4-88 88 0 7.2.9 14.3 2.5 21.1C56.4 233.2 32 265.7 32 304c0 16 4.3 31 11.7 43.9C17.6 363.2 0 391.5 0 424c0 48.6 39.4 88 88 88h336c48.6 0 88-39.4 88-88 0-32.5-17.6-60.8-43.7-76.1C475.7 335 480 320 480 304c0-38.3-24.4-70.8-58.5-82.9 1.7-6.8 2.5-13.8 2.5-21.1 0-35-20.4-65.1-49.9-79.3C363 52.2 303.6 0 232 0h-8zm40 65.8c0-10.7-2.2-21.2-6.3-30.8 46.1 10.8 81.3 50.2 85.8 98.4.6 6.3 4.8 11.6 10.7 13.6 22 7.6 37.8 28.4 37.8 53 0 9.1-2.2 17.7-6 25.2-2.4 4.7-2.3 10.2.2 14.8s7.1 7.7 12.3 8.3c27.9 3.2 49.5 26.9 49.5 55.6 0 15.3-6.2 29.2-16.2 39.4-4 4-5.5 9.9-4.1 15.4s5.7 9.8 11.2 11.3c23.7 6.5 41 28.3 41 54 0 30.9-25.1 56-56 56H88c-30.9 0-56-25.1-56-56 0-25.7 17.4-47.4 41-54 5.5-1.5 9.7-5.8 11.2-11.3s-.1-11.3-4.1-15.4C70.2 333.2 64 319.3 64 304c0-28.7 21.7-52.4 49.5-55.6 5.2-.6 9.8-3.7 12.3-8.3s2.6-10.1.2-14.8c-3.8-7.6-6-16.1-6-25.2 0-30.9 25.1-56 56-56h18.7C233 144 264 113 264 74.7v-8.9zM192 296a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-171.7 80c-15.6 0-28.3 12.7-28.3 28.3 0 5.5 1.6 11.5 5.6 16.6C159 408.8 194.4 448 256 448s97-39.2 106.4-51.1c4-5.1 5.6-11.1 5.6-16.6 0-15.6-12.7-28.3-28.3-28.3H172.3zm83.7 64c-38.2 0-63.3-19.8-75.1-32h150.2c-11.8 12.2-36.9 32-75.1 32z"
        }
    ]
};

const FalPool8Ball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPool8Ball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm368-64a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm37.3 14.2c11.5 10.3 18.7 25.2 18.7 41.8 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-16.6 7.2-31.5 18.7-41.8C212 166 208 155.5 208 144c0-26.5 21.5-48 48-48s48 21.5 48 48c0 11.5-4 22-10.7 30.2zM256 192a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"
        }
    ]
};

const FalPoop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPoop",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M209.2 9.9c2.5-6 8.3-9.9 14.8-9.9h8c71.6 0 131 52.2 142.1 120.7C403.6 134.9 424 165 424 200c0 7.2-.9 14.3-2.5 21.1 34.1 12.1 58.5 44.6 58.5 82.9 0 16-4.3 31-11.7 43.9 26.1 15.3 43.7 43.6 43.7 76.1 0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88 0-32.5 17.6-60.8 43.7-76.1C36.3 335 32 320 32 304c0-38.3 24.4-70.8 58.5-82.9-1.6-6.8-2.5-13.9-2.5-21.1 0-48.6 39.4-88 88-88h18.7c20.6 0 37.3-16.7 37.3-37.3v-8.9c0-12.3-4.9-24-13.5-32.7l-5.8-5.8c-4.6-4.6-5.9-11.5-3.5-17.4zM257.7 35c4.1 9.6 6.3 20.1 6.3 30.8v8.9c0 38.3-31 69.3-69.3 69.3H176c-30.9 0-56 25.1-56 56 0 9.1 2.2 17.7 6 25.2 2.4 4.7 2.3 10.2-.2 14.8s-7.1 7.7-12.3 8.3C85.7 251.6 64 275.3 64 304c0 15.3 6.2 29.2 16.2 39.4 4 4 5.5 9.9 4.1 15.4s-5.7 9.8-11.2 11.3c-23.7 6.5-41 28.3-41 54 0 30.9 25.1 56 56 56H424c30.9 0 56-25.1 56-56 0-25.7-17.4-47.4-41-54-5.5-1.5-9.7-5.8-11.2-11.3s.1-11.3 4.1-15.4c10-10.1 16.2-24 16.2-39.4 0-28.7-21.7-52.4-49.5-55.6-5.2-.6-9.8-3.7-12.3-8.3s-2.6-10.1-.2-14.8c3.8-7.6 6-16.1 6-25.2 0-24.5-15.8-45.4-37.8-53-5.9-2-10.1-7.4-10.7-13.6-4.6-48.4-39.8-87.7-85.9-98.5z"
        }
    ]
};

const FalPopcorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPopcorn",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M178.9 22.9c-8-4.4-17.1-6.9-26.9-6.9-25.5 0-47 17-53.8 40.3C70 59.2 48 83 48 112c0 4.4.5 8.6 1.5 12.7-15 6.6-26.5 19.5-31.2 35.3h35.8c4.4-4.9 10.8-8 17.9-8 6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8c-3-4-4.8-9-4.8-14.4 0-13.3 10.7-24 24-24 1.7 0 3.3.2 4.8.5 4.7 1 9.6-.3 13.4-3.3s5.9-7.7 5.8-12.5v-.7c0-13.2 10.8-23.9 24-23.9 8.1 0 15.2 4 19.6 10.1 3.7 5.3 10.2 7.8 16.5 6.4s11.1-6.4 12.3-12.8c2-11.2 11.8-19.7 23.6-19.7s21.6 8.5 23.6 19.7c1.1 6.3 6 11.4 12.3 12.8s12.8-1.1 16.5-6.4C280.8 52 287.9 48 296 48c13.2 0 24 10.7 24 23.9v.7c0 4.8 2.1 9.4 5.8 12.5s8.6 4.3 13.4 3.3c1.5-.3 3.2-.5 4.8-.5 13.3 0 24 10.7 24 24 0 3.5-.7 6.8-2.1 9.7-2.1 4.7-1.8 10 .7 14.5s7 7.4 12.1 8c9.2 1 16.9 7.4 19.9 15.8h32.8c-2.7-19-14.9-34.9-31.7-42.7.2-1.7.2-3.5.2-5.3 0-29-22-52.8-50.2-55.7C343 33 321.5 16 296 16c-9.7 0-18.9 2.5-26.9 6.9C258.9 9 242.5 0 224 0s-34.9 9-45.1 22.9zM33.2 224h64.9l30 210.3c1.2 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1L130.4 224H208v208c0 8.8 7.2 16 16 16s16-7.2 16-16V224h77.6l-29.4 205.7c-1.2 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6l30-210.3h64.9l-67.9 244.4c-1.9 6.9-8.2 11.7-15.4 11.7h-215c-7.2 0-13.5-4.8-15.4-11.7L33.2 224zM224 192H28.2C12.6 192 0 204.6 0 220.2c0 2.5.3 5.1 1 7.5l69.2 249.1C76 497.6 94.9 512 116.5 512h215c21.6 0 40.5-14.4 46.2-35.2L447 227.7c.7-2.5 1-5 1-7.5 0-15.6-12.6-28.2-28.2-28.2H224z"
        }
    ]
};

const FalPopsicle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPopsicle",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 160c0-70.7-57.3-128-128-128S32 89.3 32 160v176c0 8.8 7.2 16 16 16h96V192c0-8.8 7.2-16 16-16s16 7.2 16 16v160h96c8.8 0 16-7.2 16-16V160zM144 384H48c-26.5 0-48-21.5-48-48V160C0 71.6 71.6 0 160 0s160 71.6 160 160v176c0 26.5-21.5 48-48 48h-96v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384z"
        }
    ]
};

const FalPotFood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPotFood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16c0 25.8 4.3 44.4 11.7 59.2 7.2 14.3 16.7 23.9 24.6 31.7l.4.4c8.1 8.1 14.3 14.4 19 23.8 4.6 9.2 8.3 22.7 8.3 44.8 0 8.8 7.2 16 16 16s16-7.2 16-16c0-25.8-4.3-44.4-11.7-59.2-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8-4.6-9.2-8.3-22.6-8.3-44.8zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 25.8 4.3 44.4 11.7 59.2 7.2 14.3 16.7 23.9 24.6 31.7l.4.4c8.1 8.1 14.3 14.4 19 23.8 4.6 9.2 8.3 22.7 8.3 44.8 0 8.8 7.2 16 16 16s16-7.2 16-16c0-25.8-4.3-44.4-11.7-59.2-7.2-14.3-16.7-23.9-24.6-31.7l-.4-.4c-8.1-8.1-14.3-14.4-19-23.8-4.6-9.2-8.3-22.6-8.3-44.8zM32 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h35.8c5.9 82.9 56.5 152.7 127.3 186.4 7.6 21.9 28.4 37.6 52.9 37.6h144c24.5 0 45.3-15.7 52.9-37.6 70.8-33.7 121.4-103.5 127.3-186.4H608c8.8 0 16-7.2 16-16s-7.2-16-16-16h-37.6c-6.6-18.6-24.3-32-45.3-32H114.9c-21 0-38.7 13.4-45.3 32H32zm507.4-64c-13.8-46.3-56.6-80-107.4-80s-93.6 33.7-107.4 80h34c12.3-28.3 40.5-48 73.3-48s61 19.7 73.3 48h34zM225.3 463.9c-2.8-8.1-8.7-14.7-16.5-18.4-61.4-29.2-105-90.1-109.3-162.2l-.6-10.3c-.5-9.2 6.8-16.9 16-16.9h410.2c9.2 0 16.5 7.7 16 16.9l-.6 10.3c-4.2 72.1-47.8 133-109.3 162.2-7.7 3.7-13.7 10.3-16.5 18.4-3.3 9.4-12.2 16.1-22.7 16.1H248c-10.4 0-19.4-6.7-22.7-16.1z"
        }
    ]
};

const FalPotato = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPotato",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 144c0-61.9-50.1-112-112-112-31 0-59 12.5-79.3 32.9-29.6 29.7-65.7 56.7-102.4 76.8-18.8 10.3-34.3 25.8-44.6 44.6-20.1 36.7-47.1 72.8-76.8 102.4C44.5 309 32 337 32 368c0 61.9 50.1 112 112 112 23.6 0 45.4-7.3 63.4-19.6 30.5-21 65.4-38.4 100.4-50.2 34.4-11.6 62.4-39.6 72.4-77.2 10.7-39.9 34.1-78.9 64.3-107.2 21.9-20.5 35.5-49.5 35.5-81.8zm32 0c0 41.5-17.6 78.9-45.7 105.2-25.8 24.2-46.1 57.9-55.2 92.1-12.9 48.3-49 84.3-93.1 99.2-32.3 10.9-64.4 26.9-92.5 46.2-23.1 16-51.2 25.3-81.5 25.3C64.5 512 0 447.5 0 368c0-39.8 16.2-75.9 42.3-102 27.5-27.4 52.7-61 71.3-95.1 13.2-24.1 33.1-44 57.3-57.3C205 95 238.6 69.8 266 42.3 292.1 16.2 328.2 0 368 0c79.5 0 144 64.5 144 144zM180 264a20 20 0 1 1 0-40 20 20 0 1 1 0 40zm-12 132a20 20 0 1 1-40 0 20 20 0 1 1 40 0zm196-196a20 20 0 1 1 0-40 20 20 0 1 1 0 40z"
        }
    ]
};

const FalPowerOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPowerOff",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM164.3 78.2c7.8-4.1 10.9-13.7 6.9-21.6s-13.7-10.9-21.6-6.9C75 88.3 24 166.2 24 256c0 128.1 103.9 232 232 232s232-103.9 232-232c0-89.8-51-167.7-125.6-206.2-7.8-4.1-17.5-1-21.6 6.9s-1 17.5 6.9 21.6C412.1 111.5 456 178.6 456 256c0 110.5-89.5 200-200 200S56 366.5 56 256c0-77.4 43.9-144.5 108.3-177.8z"
        }
    ]
};

const FalPrescriptionBottleMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPrescriptionBottleMedical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h288zM48 0C21.5 0 0 21.5 0 48v32c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM32 160v288c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160h-32v288c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160H32zm149.3 32c-17.7 0-32 14.3-32 32v21.3H128c-17.7 0-32 14.3-32 32v21.3c0 17.7 14.3 32 32 32h21.3V352c0 17.7 14.3 32 32 32h21.3c17.7 0 32-14.3 32-32v-21.3H256c17.7 0 32-14.3 32-32v-21.4c0-17.7-14.3-32-32-32h-21.3V224c0-17.7-14.3-32-32-32h-21.4zm0 32h21.3v37.3c0 8.8 7.2 16 16 16H256v21.3h-37.3c-8.8 0-16 7.2-16 16V352h-21.4v-37.3c0-8.8-7.2-16-16-16H128v-21.4h37.3c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V224z"
        }
    ]
};

const FalPrescriptionBottlePill = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPrescriptionBottlePill",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h288zM48 0C21.5 0 0 21.5 0 48v32c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM32 160v288c0 35.3 28.7 64 64 64h192c11.6 0 22.4-3.1 31.8-8.4-8.9-7.3-17-15.5-24.3-24.5-2.4.6-4.9.9-7.5.9H96c-17.7 0-32-14.3-32-32v-32h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-32H32zm320 0h-32v72.2c9.8-8.1 20.6-15.2 32-21V160zm80 96a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm36.7-84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96z"
        }
    ]
};

const FalPrescriptionBottle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPrescriptionBottle",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V48c0-8.8 7.2-16 16-16h288zM48 0C21.5 0 0 21.5 0 48v32c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H48zM32 160v288c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160h-32v288c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-32h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-64h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-32H32z"
        }
    ]
};

const FalPrescription = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPrescription",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M31.1 0C13.9 0 0 13.9 0 31.1V304c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h105.4l128 128-132.7 132.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 374.6l132.7 132.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L310.6 352l132.7-132.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L288 329.4 182.4 223.8C241.3 220.5 288 171.7 288 112 288 50.1 237.9 0 176 0H31.1zM144 192H32V32h144c44.2 0 80 35.8 80 80s-35.8 80-80 80h-32z"
        }
    ]
};

const FalPresentationScreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPresentationScreen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm16 64v224c0 35.3 28.7 64 64 64h176v41.4l-91.3 91.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l84.7-84.7 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L304 393.4V352h176c35.3 0 64-28.7 64-64V64h-32v224c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V64H32z"
        }
    ]
};

const FalPretzel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPretzel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M149.4 64C84.6 64 32 116.6 32 181.4c0 64.6 28 122.7 72.7 162.8l27.6-39.9c-32.2-31-52.3-74.6-52.3-122.9 0-38.3 31.1-69.4 69.4-69.4h6.6c42 0 76 34 76 76v3.6c0 16.2-4.9 32-14.2 45.3l-18.2 26.3-33 47.6-45.6 65.8-28.7 41.7c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1l34.5-49.8c4-5.8 11.3-8.3 18-6.1 20.9 6.7 43.2 10.3 66.4 10.3h10.7c15.5 0 30.6-1.6 45.1-4.7l-30.4-44c-4.8.4-9.7.6-14.7.6h-10.8c-8.4 0-16.6-.6-24.7-1.8-5.5-.8-10.2-4.4-12.4-9.4s-1.6-10.9 1.5-15.5l27.8-40.1c3-4.3 7.9-6.9 13.2-6.9s10.2 2.6 13.2 6.9l13 18.8 14.7 21.3 48.9 70.6 34.5 49.8c7.5 10.9 22.5 13.6 33.4 6.1s13.6-22.5 6.1-33.4L391 376.7c-4.9-7-3.4-16.6 3.4-21.8C446.5 315 480 252.1 480 181.4 480 116.6 427.4 64 362.6 64H356c-34.7 0-66 14.2-88.6 37.2-3 3.1-7.1 4.8-11.4 4.8s-8.4-1.7-11.4-4.8C222 78.2 190.7 64 156 64h-6.6zm176.7 359.6c-20.6 5.5-42.3 8.4-64.7 8.4h-10.8c-22.3 0-44-2.9-64.7-8.4L158 463.9c-17.6 25.4-52.5 31.8-77.9 14.2s-31.7-52.5-14.1-78l20.4-29.5C33.5 324.7 0 257 0 181.4 0 98.9 66.9 32 149.4 32h6.6c38 0 72.9 13.6 100 36.3C283.1 45.6 318 32 356 32h6.6C445.1 32 512 98.9 512 181.4c0 75.6-33.5 143.3-86.3 189.3l20.3 29.4c17.6 25.4 11.3 60.3-14.2 77.9s-60.3 11.3-77.9-14.2L326 423.5zM173.3 245l18.2-26.3c5.5-8 8.5-17.4 8.5-27.1V188c0-24.3-19.7-44-44-44h-6.6c-20.7 0-37.4 16.7-37.4 37.4 0 37.3 14.8 71.2 38.8 96.2l22.5-32.6zM356 144c-24.3 0-44 19.7-44 44v3.6c0 9.7 3 19.1 8.5 27.1l40.7 58.8c24-24.9 38.8-58.8 38.8-96.2 0-20.7-16.7-37.4-37.4-37.4H356zm-76 44c0-42 34-76 76-76h6.6c38.3 0 69.4 31.1 69.4 69.4 0 53.7-24.8 101.5-63.5 132.8-3.5 2.8-7.9 4-12.3 3.4s-8.3-3.1-10.9-6.7L294.2 237c-9.2-13.3-14.2-29.1-14.2-45.3V188z"
        }
    ]
};

const FalPrintMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPrintMagnifyingGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 160V64c0-17.7 14.3-32 32-32h229.5c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c6 6 9.4 14.1 9.4 22.6V160h32V90.5c0-17-6.7-33.3-18.7-45.3l-26.6-26.5C454.7 6.7 438.5 0 421.5 0H192c-35.3 0-64 28.7-64 64v96h32zm-32 64h192c9.1-12.1 19.9-22.9 32-32H128c-35.3 0-64 28.7-64 64v128c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32h320c15.8 0 29-11.5 31.6-26.6L498.2 472c-5.9 1.9-12 3.6-18.2 4.8v3.2H160V352h131.2c-2.1-10.3-3.2-21-3.2-32H160c-17.7 0-32 14.3-32 32v32H96V256c0-17.7 14.3-32 32-32zm320 .1a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 377 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128 57.3 128 128 128z"
        }
    ]
};

const FalPrintSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPrintSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 463.9V480H160V352h178.3l-40.5-32H160c-17.7 0-32 14.3-32 32v32H96V256c0-17.7 14.3-32 32-32h48.2l-40.5-32H128c-35.3 0-64 28.7-64 64v128c0 17.7 14.3 32 32 32h32v64c0 17.7 14.3 32 32 32h320c14.8 0 27.3-10.1 30.9-23.7L480 463.9zM137.5 30.4 163 50.5c5.1-10.9 16.2-18.5 29-18.5h229.5c8.5 0 16.6 3.4 22.6 9.4l26.5 26.5c6 6 9.4 14.1 9.4 22.6V160h32V90.5c0-17-6.7-33.3-18.7-45.3l-26.6-26.5C454.7 6.7 438.5 0 421.5 0H192c-23 0-43.2 12.2-54.5 30.4zM512 192H342.2l40.5 32H512c17.7 0 32 14.3 32 32v95.3l32 25.3V256c0-35.3-28.7-64-64-64zm-16 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalPrint = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPrint",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 160H64V64c0-35.3 28.7-64 64-64h229.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160h-32V90.5c0-8.5-3.4-16.6-9.4-22.6l-26.5-26.5c-6-6-14.1-9.4-22.6-9.4H128c-17.7 0-32 14.3-32 32v96zm352 64H64c-17.7 0-32 14.3-32 32v128h32v-32c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v32h32V256c0-17.7-14.3-32-32-32zm0 192v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v128c0 17.7-14.3 32-32 32h-32zM96 352v128h320V352H96zm336-104a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalProjector = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalProjector",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM267.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64zm320 22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zM288 320a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm288 0c0-36-11.9-69.3-32-96h32c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32h-32c20.1-26.7 32-60 32-96zm0 128c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64h-64c-26.7-20.1-60-32-96-32s-69.3 11.9-96 32H64c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h224c26.7 20.1 60 32 96 32 37.3 0 71.6-12.7 98.8-34.1-.9.7-1.8 1.4-2.8 2.1h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48zM80 416H64c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32h224c-20.1 26.7-32 60-32 96s11.9 69.3 32 96H80zm16-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalPumpMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPumpMedical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0h32c26.5 0 48 21.5 48 48h76.1c17 0 33.3 6.7 45.3 18.7l33.9 33.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-34-33.8c-6-6-14.1-9.4-22.6-9.4H256v48h-32V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v80h-32V48c0-26.5 21.5-48 48-48zM85.6 221.3l-18.7 224C65.3 464 80.1 480 98.8 480h186.4c18.7 0 33.4-16 31.9-34.7l-18.7-224c-1.4-16.6-15.2-29.3-31.9-29.3H117.4c-16.6 0-30.5 12.8-31.9 29.3zm-31.9-2.7c2.8-33.2 30.5-58.7 63.8-58.7h149.1c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zM208 288v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalPumpSoap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPumpSoap",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48h76.1c17 0 33.3 6.7 45.3 18.7l33.9 33.9c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-34-33.8c-6-6-14.1-9.4-22.6-9.4H256v48h-32V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v80h-32V48zM85.6 221.3l-18.7 224C65.3 464 80.1 480 98.8 480h186.4c18.7 0 33.4-16 31.9-34.7l-18.7-224c-1.4-16.6-15.2-29.3-31.9-29.3H117.4c-16.6 0-30.5 12.8-31.9 29.3zm-31.9-2.7c2.8-33.2 30.5-58.7 63.8-58.7h149.1c33.3 0 61 25.5 63.8 58.7l18.7 224c3.1 37.3-26.3 69.3-63.8 69.3H98.8c-37.4 0-66.9-32-63.8-69.3l18.7-224zm102.5 126.5c-2.7 5.3-4.2 11.2-4.2 17.2 0 20.8 16.9 37.7 37.7 37.7h4.7c20.8 0 37.7-16.9 37.7-37.7 0-6-1.4-11.9-4.2-17.2L192 275.4l-35.8 69.7zM192 240c10.9 0 20.9 6.1 25.9 15.8l38.4 74.7c5.1 9.9 7.7 20.8 7.7 31.9 0 38.5-31.2 69.7-69.7 69.7h-4.7c-38.5 0-69.7-31.2-69.7-69.7 0-11.1 2.6-22 7.7-31.9l38.4-74.7c5-9.7 15-15.8 25.9-15.8z"
        }
    ]
};

const FalPump = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPump",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M76.9 0c-8.8 0-16 7.2-16 16s7.2 16 16 16H96v176H32v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h288v-32H32V240h80c8.8 0 16-7.2 16-16V32h128v192c0 8.8 7.2 16 16 16h48v-32h-32V32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H76.9zm372.7 133.4c5.3-3.5 11.4-5.4 17.8-5.4H576c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H467.4c-6.3 0-12.5-1.9-17.8-5.4l-51.4-34.3c-8.9-5.9-14.2-15.9-14.2-26.6V194.3c0-10.7 5.3-20.7 14.2-26.6l51.4-34.3zm-17.7 367.9c10.5 7 22.9 10.7 35.5 10.7H576c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H467.4c-12.6 0-25 3.7-35.5 10.7L380.5 141c-17.8 11.9-28.5 31.9-28.5 53.3v219.4c0 21.4 10.7 41.4 28.5 53.3l51.4 34.3zM448 224c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16zm0 80c0 8.8 7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalPumpkin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPumpkin",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m299.1 36.1 20.9 9v53.8c11.1 2 21.8 5.1 32 9.1V35.4c0-6.9-4.1-13.2-10.5-15.9L299.3 1.4c-2.2-.9-4.5-1.4-6.8-1.4h-1.2c-6.9 0-13.1 4.1-15.8 10.4l-41.1 94c12.2-3.9 25-6.5 38.3-7.7l26.5-60.5zM166 145.1c9.5-9.2 20.1-17.3 31.5-24.1-14.3-5.8-29.5-9-45.5-9-43.8 0-82.2 24.1-109 60.4S0 258.1 0 312s16.1 103.3 43 139.6S108.2 512 152 512c24.7 0 47.8-7.7 68-20.9 20.2 13.3 43.3 20.9 68 20.9s47.8-7.7 68-20.9c20.2 13.3 43.3 20.9 68 20.9 43.8 0 82.2-24.1 109-60.4s43-85.7 43-139.6-16.1-103.3-43-139.6S467.8 112 424 112c-15.9 0-31.2 3.2-45.5 9 11.4 6.8 22 14.9 31.5 24.1 4.6-.8 9.3-1.1 14-1.1 31.3 0 60.9 17.1 83.3 47.4S544 264.3 544 312s-14.3 90.3-36.7 120.6-52 47.4-83.3 47.4c-20.7 0-40.6-7.5-58.1-21.2-5.8-4.5-13.9-4.5-19.7 0-17.6 13.7-37.5 21.2-58.2 21.2s-40.6-7.5-58.1-21.2c-5.8-4.5-13.9-4.5-19.7 0-17.6 13.7-37.5 21.2-58.2 21.2-31.3 0-60.9-17.1-83.3-47.4S32 359.7 32 312s14.3-90.3 36.7-120.6 52-47.4 83.3-47.4c4.7 0 9.4.4 14 1.1zM288 160c38.5 0 72.4 19.4 92.6 49 5 7.3 14.9 9.2 22.2 4.2s9.2-14.9 4.2-22.2c-25.9-38-69.6-63-119.1-63s-93.2 25-119.1 63c-5 7.3-3.1 17.3 4.2 22.2s17.3 3.1 22.2-4.2c20.2-29.6 54.1-49 92.6-49z"
        }
    ]
};

const FalPuzzlePieceSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPuzzlePieceSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 96c-8.8 0-16 7.2-16 16v88.8c0 21.6-17.5 39.2-39.2 39.2-16.2 0-28.4-9.9-35.6-19.6C78.8 211.8 71.1 208 64 208s-14.7 3.8-21.1 12.3S32 241.5 32 256s4.4 27.1 10.9 35.7S56.9 304 64 304c7.1 0 14.8-3.8 21.2-12.4 7.2-9.7 19.4-19.6 35.6-19.6 21.6 0 39.2 17.5 39.2 39.2V400c0 8.8 7.2 16 16 16h93.7C252 403.1 240 383.1 240 360c0-41.7 37.9-72 80-72s80 30.3 80 72c0 23.1-12 43.1-29.7 56H464c8.8 0 16-7.2 16-16v-88.8c0-21.6 17.5-39.2 39.2-39.2 16.2 0 28.4 9.9 35.6 19.6 6.4 8.6 14.1 12.4 21.2 12.4s14.7-3.8 21.1-12.3S608 270.6 608 256s-4.4-27.1-10.9-35.7S583 208 576 208c-7.1 0-14.8 3.8-21.2 12.4-7.2 9.7-19.4 19.6-35.6 19.6-21.7 0-39.2-17.5-39.2-39.2V112c0-8.8-7.2-16-16-16h-93.7c17.7 12.8 29.7 32.9 29.7 56 0 41.7-37.9 72-80 72s-80-30.3-80-72c0-23.1 12-43.2 29.7-56H176zm-48 16c0-26.5 21.5-48 48-48h97.5c16.8 0 30.5 13.7 30.5 30.5 0 11.9-6.8 21.3-14.6 26.7-11.2 7.7-17.4 19-17.4 30.8 0 20.2 19.4 40 48 40s48-19.8 48-40c0-11.8-6.3-23.1-17.4-30.8-7.8-5.4-14.6-14.8-14.6-26.7 0-16.8 13.7-30.5 30.6-30.5H464c26.5 0 48 21.5 48 48v88.8c0 4 3.2 7.2 7.2 7.2 2.3 0 6.1-1.6 10-6.7 11-14.7 27.4-25.3 46.8-25.3s35.8 10.5 46.7 25.1S640 235.2 640 256s-6.3 40.2-17.3 54.9S595.4 336 576 336c-19.5 0-35.9-10.6-46.8-25.3-3.8-5.2-7.7-6.7-10-6.7-4 0-7.2 3.2-7.2 7.2V400c0 26.5-21.5 48-48 48h-97.4c-16.9 0-30.6-13.7-30.6-30.6 0-11.9 6.8-21.3 14.6-26.7 11.2-7.7 17.4-19 17.4-30.8 0-20.2-19.4-40-48-40s-48 19.8-48 40c0 11.8 6.3 23.1 17.4 30.8 7.8 5.4 14.6 14.8 14.6 26.7 0 16.9-13.7 30.6-30.5 30.6H176c-26.5 0-48-21.5-48-48v-88.8c0-4-3.2-7.2-7.2-7.2-2.3 0-6.1 1.6-10 6.7C99.9 325.4 83.5 336 64 336c-19.4 0-35.8-10.5-46.7-25.1S0 276.8 0 256s6.3-40.2 17.3-54.9S44.6 176 64 176c19.5 0 35.9 10.6 46.8 25.3 3.8 5.2 7.7 6.7 10 6.7 4 0 7.2-3.2 7.2-7.2V112z"
        }
    ]
};

const FalPuzzlePiece = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPuzzlePiece",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.1 17.3C183.8 6.3 203.2 0 224 0s40.2 6.3 54.9 17.3S304 44.6 304 64c0 19.5-10.6 35.9-25.3 46.8-5.2 3.8-6.7 7.7-6.7 10 0 4 3.2 7.2 7.2 7.2H336c26.5 0 48 21.5 48 48v56.8c0 4 3.2 7.2 7.2 7.2 2.3 0 6.1-1.6 10-6.7 11-14.7 27.4-25.3 46.8-25.3s35.8 10.5 46.7 25.1S512 267.2 512 288s-6.3 40.2-17.3 54.9S467.4 368 448 368c-19.5 0-35.9-10.6-46.8-25.3-3.8-5.2-7.7-6.7-10-6.7-4 0-7.2 3.2-7.2 7.2V464c0 26.5-21.5 48-48 48h-56.8c-21.6 0-39.2-17.5-39.2-39.2 0-16.2 9.9-28.4 19.6-35.6 8.6-6.4 12.4-14.1 12.4-21.2s-3.8-14.7-12.3-21.1S238.6 384 224 384s-27.1 4.4-35.7 10.9S176 409 176 416c0 7.1 3.8 14.8 12.4 21.2 9.7 7.2 19.6 19.4 19.6 35.6 0 21.7-17.5 39.2-39.2 39.2H48c-26.5 0-48-21.5-48-48V343.2C0 321.5 17.5 304 39.2 304c16.2 0 28.4 9.9 35.6 19.6C81.2 332.2 88.9 336 96 336s14.7-3.8 21.1-12.3S128 302.6 128 288s-4.4-27.1-10.9-35.7S103.1 240 96 240c-7.1 0-14.8 3.8-21.2 12.4-7.2 9.7-19.4 19.6-35.6 19.6C17.5 272 0 254.5 0 232.8V176c0-26.5 21.5-48 48-48h120.8c4 0 7.2-3.2 7.2-7.2 0-2.3-1.6-6.1-6.7-10C154.6 99.9 144 83.5 144 64c0-19.4 10.5-35.8 25.1-46.7zm19.2 25.6c-8.5 6.4-12.3 14-12.3 21.1 0 7.1 3.8 14.8 12.4 21.2 9.7 7.2 19.6 19.4 19.6 35.6 0 21.6-17.5 39.2-39.2 39.2H48c-8.8 0-16 7.2-16 16v56.8c0 4 3.2 7.2 7.2 7.2 2.3 0 6.1-1.6 10-6.7C60.1 218.6 76.5 208 96 208c19.4 0 35.8 10.5 46.7 25.1S160 267.2 160 288s-6.3 40.2-17.3 54.9S115.4 368 96 368c-19.5 0-35.9-10.6-46.8-25.3-3.8-5.2-7.7-6.7-10-6.7-4 0-7.2 3.2-7.2 7.2V464c0 8.8 7.2 16 16 16h120.8c4 0 7.2-3.2 7.2-7.2 0-2.3-1.6-6.1-6.7-10-14.7-11-25.3-27.4-25.3-46.8s10.5-35.8 25.1-46.7S203.2 352 224 352s40.2 6.3 54.9 17.3S304 396.6 304 416c0 19.5-10.6 35.9-25.3 46.8-5.2 3.8-6.7 7.7-6.7 10 0 4 3.2 7.2 7.2 7.2H336c8.8 0 16-7.2 16-16V343.2c0-21.7 17.5-39.2 39.2-39.2 16.2 0 28.4 9.9 35.6 19.6 6.4 8.6 14.1 12.4 21.2 12.4s14.7-3.8 21.1-12.3S480 302.6 480 288s-4.4-27.1-10.9-35.7S455 240 448 240c-7.1 0-14.8 3.8-21.2 12.4-7.2 9.7-19.4 19.6-35.6 19.6-21.7 0-39.2-17.5-39.2-39.2V176c0-8.8-7.2-16-16-16h-56.8c-21.6 0-39.2-17.5-39.2-39.2 0-16.2 9.9-28.4 19.6-35.6C268.2 78.8 272 71.1 272 64s-3.8-14.7-12.3-21.1S238.5 32 224 32s-27.1 4.4-35.7 10.9z"
        }
    ]
};

const FalPuzzle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalPuzzle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c-17.7 0-32 14.3-32 32v24c0 17.7 14.3 32 32 32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-17.7 0-32 14.3-32 32v24c0 17.7 14.3 32 32 32h32c0 26.5 21.5 48 48 48s48-21.5 48-48h32c17.7 0 32-14.3 32-32V64c0-35.3-28.7-64-64-64H320zm0 32h128c17.7 0 32 14.3 32 32v112h-48c-8.8 0-16 7.2-16 16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-8.8-7.2-16-16-16h-48v-24h16c26.5 0 48-21.5 48-48s-21.5-48-48-48h-16V32zM64 64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V304c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-17.7-14.3-32-32-32h-32V96c0-17.7-14.3-32-32-32H64zm144 32v176h-32v-16c0-26.5-21.5-48-48-48s-48 21.5-48 48v16H32V128c0-17.7 14.3-32 32-32h144zM80 304c17.7 0 32-14.3 32-32v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 17.7 14.3 32 32 32h32v32h-16c-26.5 0-48 21.5-48 48s21.5 48 48 48h16v48H64c-17.7 0-32-14.3-32-32V304h48zm160 128c0-17.7-14.3-32-32-32h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c17.7 0 32-14.3 32-32v-32h32v16c0 26.5 21.5 48 48 48s48-21.5 48-48v-16h48v144c0 17.7-14.3 32-32 32H240v-48z"
        }
    ]
};

const FalQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalQ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256c0 106 86 192 192 192 42.6 0 81.9-13.9 113.8-37.3L227.9 282.4c-5.8-6.7-5-16.8 1.7-22.6s16.8-5 22.6 1.7l109.7 128C395.4 355 416 307.9 416 256c0-106-86-192-192-192S32 150 32 256zm326.7 179c-37.5 28.2-84.1 45-134.7 45C100.3 480 0 379.7 0 256S100.3 32 224 32s224 100.3 224 224c0 61.7-24.9 117.5-65.2 158l61.4 71.6c5.8 6.7 5 16.8-1.7 22.6s-16.8 5-22.6-1.7L358.7 435z"
        }
    ]
};

const FalQrcode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalQrcode",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 288H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm-96-32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zM304 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16h-96zm-48 16c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80zm0 224c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v68h64v-68c0-8.8 7.2-16 16-16s16 7.2 16 16v84c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-68h-32v152c0 8.8-7.2 16-16 16s-16-7.2-16-16V304zM88 104h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zM72 376c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16v-16zm272-272h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-24 344c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm96-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalQuestion",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64c-53 0-96 43-96 96 0 8.8-7.2 16-16 16s-16-7.2-16-16C16 89.3 73.3 32 144 32h32c70.7 0 128 57.3 128 128 0 35.3-16.6 68.4-44.8 89.6l-60.8 45.6C184.3 305.8 176 322.4 176 340v12c0 8.8-7.2 16-16 16s-16-7.2-16-16v-12c0-27.7 13-53.8 35.2-70.4L240 224c20.1-15.1 32-38.8 32-64 0-53-43-96-96-96h-32zm-8 384a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalQuoteLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalQuoteLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 208C0 146.1 50.1 96 112 96h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-44.2 0-80 35.8-80 80v24.6c9.4-5.4 20.3-8.6 32-8.6h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208zm32 80v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm352-32h-64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32zm-128 64V208c0-61.9 50.1-112 112-112h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-44.2 0-80 35.8-80 80v24.6c9.4-5.4 20.3-8.6 32-8.6h64c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64h-64c-35.3 0-64-28.7-64-64v-32z"
        }
    ]
};

const FalQuoteRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalQuoteRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 304c0 61.9-50.1 112-112 112h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c44.2 0 80-35.8 80-80v-24.6c-9.4 5.4-20.3 8.6-32 8.6h-64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v144zm-32-112v-32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-32zM192 304c0 61.9-50.1 112-112 112H48c-8.8 0-16-7.2-16-16s7.2-16 16-16h32c44.2 0 80-35.8 80-80v-24.6c-9.4 5.4-20.3 8.6-32 8.6H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v144zm-32-112v-32c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-32z"
        }
    ]
};

const FalQuotes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalQuotes",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 88C0 39.4 39.4 0 88 0h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8c-30.9 0-56 25.1-56 56v10.7C37 97 42.4 96 48 96h32c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V88zm32 56v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm128-56c0-48.6 39.4-88 88-88h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-8c-30.9 0-56 25.1-56 56v10.7c5-1.8 10.4-2.7 16-2.7h32c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V88zm32 80v8c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v24zm384 256c0 48.6-39.4 88-88 88h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8c30.9 0 56-25.1 56-56v-10.7c-5 1.8-10.4 2.7-16 2.7h-32c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v88zm-32-56v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm-128 56c0 48.6-39.4 88-88 88h-8c-8.8 0-16-7.2-16-16s7.2-16 16-16h8c30.9 0 56-25.1 56-56v-10.7c-5 1.8-10.4 2.7-16 2.7h-32c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v88zm-32-80v-8c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-24z"
        }
    ]
};

const FalR = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalR",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 32C21.5 32 0 53.5 0 80v384c0 8.8 7.2 16 16 16s16-7.2 16-16V288h135.4l123.3 184.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L205.4 287.3C269.8 280.6 320 226.2 320 160c0-70.7-57.3-128-128-128H48zm128 224H32V80c0-8.8 7.2-16 16-16h144c53 0 96 43 96 96s-43 96-96 96h-16z"
        }
    ]
};

const FalRabbitRunning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRabbitRunning",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 224c7.1 0 13.1 4.6 15.2 10.9l1.3-.4-1.2.6c.5 1.5.8 3.2.8 4.9 0 8.8-7.2 16-16 16s-16-7.2-16-16 7.2-16 16-16zm-31-75.8c14.7 2.1 28.9 6.6 42 13.5-.7-35-15-69-40.8-94.2l-1.4-1.4c-1.9-1.9-4.7-2.7-7.3-2.2l-1.6.3c-2.3.4-4.2 1.9-5.3 3.9-7.5-7.7-15.6-14.7-24.3-21.1 5.8-7.3 14.1-12.4 23.5-14.2l1.6-.3c13-2.5 26.4 1.5 35.8 10.8l1.4 1.4c37.1 36.4 55 87.5 49.4 138.2l23.7 17.7c19 14.2 30.2 36.5 30.2 60.3 0 41.5-33.7 75.2-75.2 75.2h-94.1l-32 32H424c26.5 0 48 21.5 48 48s-21.5 48-48 48H306.5c-21.2 0-41.6-8.4-56.6-23.4l-12.9-13-66.4 44.3c-22.1 14.7-51.9 8.7-66.6-13.3s-8.7-51.9 13.3-66.6l50.4-33.6-55-55c-9.8-9.8-17.6-21.2-23.1-33.7C84 271.2 78.1 272 72 272c-39.8 0-72-32.2-72-72s32.2-72 72-72c16.3 0 31.3 5.4 43.3 14.5 20.1-18.9 47.1-30.5 76.9-30.5h9c17.3 0 34.4 3.7 50.2 10.9l66 30c-2.3-5.4-4.2-11-5.8-16.8l-10.2-37c-5.1-18.5 2.9-38.1 19.5-47.7l7.9 13.7-7.9-13.7 2.1-1.2c9-5.2 19.9-6.3 29.8-3.1 47 15.5 83.1 53.5 96.2 101.1zM81 239c-.7-4.9-1-9.8-1-14.8 0-20.7 5.6-40 15.3-56.7-6.5-4.7-14.6-7.5-23.3-7.5-22.1 0-40 17.9-40 40s17.9 40 40 40c3.1 0 6.1-.4 9-1zm54.1 179.7c-7.4 4.9-9.3 14.8-4.4 22.2s14.8 9.3 22.2 4.4l61.1-40.7-23.1-23.1-55.8 37.2zm201-18.7c-3.7 0-7.2-1.2-10-3.4-.6-.5-1.2-1-1.7-1.6-2.2-2.3-3.8-5.3-4.3-8.7-.1-.4-.1-.9-.1-1.3l-1.7-24.4c-3.3-46.1-34.6-85.5-78.8-99.1l-20.2-6.2c-8.4-2.6-13.2-11.6-10.6-20s11.6-13.2 20-10.6l20.2 6.2c53.6 16.5 92.4 62.4 100.2 117.3l39.6-39.6c3-3 7.1-4.7 11.3-4.7h100.8c23.9 0 43.2-19.3 43.2-43.2 0-13.6-6.4-26.5-17.4-34.6l-37.3-27.9c-15.7-11.7-34.4-18.4-53.8-19.3-7-.3-13-5.2-14.8-12.1l-2-7.8c-9.7-38.5-38.4-69.3-76-81.7-1.2-.4-2.6-.3-3.8.4m0 0-2.1 1.2c-4 2.3-5.9 7-4.7 11.5l10.2 37c5.5 20 16.5 37.9 31.4 51.9 5.7 5.4 6.7 14.1 2.4 20.6s-12.8 8.9-19.9 5.7L238.1 152c-11.6-5.3-24.2-8-36.9-8h-9c-44.3 0-80.2 35.9-80.2 80.2 0 21.3 8.4 41.7 23.5 56.7l137.1 137c9 9 21.2 14.1 33.9 14.1H424c8.8 0 16-7.2 16-16s-7.2-16-16-16h-87.8"
        }
    ]
};

const FalRabbit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRabbit",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M324.1 20.8c6.5 9.4 12.1 19.2 16.9 29.5 3.5-4.4 7.2-8.6 11.2-12.6l3.1-3.1c1.7-1.7 4-2.6 6.4-2.6 4.5 0 8.3 3.3 8.9 7.7l.7 4.9c3.3 22.7 1.2 45.6-5.6 66.8-12.9-4.8-26.7-7.4-40.7-7.5-6.3-33.2-22.5-64.4-47.4-89l-3.1-3.1-11.2 11.5 11.3-11.4C266.9 4.3 256.5 0 245.7 0c-20.4 0-37.7 15-40.6 35.2l-.7 4.9c-7.6 53 8.6 106.2 43.6 145.9v37.6c-62.8 17.5-113.6 63.7-137.4 123.6C99.5 340.1 86.2 336 72 336c-39.8 0-72 32.2-72 72s32.2 72 72 72c12.4 0 24.1-3.1 34.3-8.7 13.7 24.2 39.6 40.5 69.3 40.7H304c26.5 0 48-21.5 48-48 0-25.9-20.5-47-46.2-48l21-22.2 55.9 94.6c13.5 22.8 42.9 30.4 65.7 16.9s30.4-42.9 16.9-65.7L380.5 296h7.3c42.1 0 76.3-34.1 76.3-76.3 0-22.9-10.3-44.6-28.1-59.1l-37-30.1c-1.5-1.2-3.1-2.5-4.7-3.6 9.8-27.4 13-57.1 8.7-86.8l-.7-4.9C399.4 15 382.1 0 361.7 0c-10.8 0-21.2 4.3-28.9 11.9l-3.1 3.1c-1.9 1.9-3.8 3.9-5.6 5.8zM96.4 439.7c-6.8 5.2-15.2 8.3-24.4 8.3-22.1 0-40-17.9-40-40s17.9-40 40-40c11.2 0 21.4 4.6 28.6 12.1-3 14.2-4.6 28.9-4.6 43.9v8c0 2.6.1 5.2.4 7.7zm140.4-400c.6-4.4 4.4-7.7 8.9-7.7 2.4 0 4.7.9 6.3 2.6l3.1 3.1c23.4 23.2 37.3 53.5 40.3 85.2.4 4.6 2.8 8.7 6.5 11.4s8.4 3.7 12.9 2.7c3.1-.7 6.3-1 9.6-1 19.8 0 39 6.8 54.3 19.3l36.9 30.1c10.3 8.4 16.3 21 16.3 34.3 0 24.4-19.8 44.3-44.3 44.3h-35.2c-5.7 0-11 3.1-13.9 8.1s-2.8 11.1.1 16.1l99.1 167.7c4.5 7.6 2 17.4-5.6 21.9s-17.4 2-21.9-5.6l-66.6-112.9c-2.6-4.3-7-7.2-12-7.8s-10 1.3-13.4 4.9L257 421c-4.4 4.6-5.6 11.5-3.1 17.3s8.3 9.7 14.7 9.7H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H175.8c-26.4-.1-47.8-21.6-47.8-48v-8c0-84.6 59.7-155.3 139.3-172.2 7.4-1.6 12.7-8.1 12.7-15.7V180c0-4.1-1.5-8.1-4.4-11.2-31.3-33.1-46-78.8-39.5-124.2l.7-4.9zM352 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalRaccoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRaccoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m283.2 57.1-16.6 20.5c24.6-12.4 53.5-4.7 69.4 15.5 15.9-20.2 44.8-27.9 69.4-15.5l-16.6-20.5C375.9 41.2 356.5 32 336 32s-39.9 9.2-52.8 25.1zM336 162.6c-2.6 3.4-5.7 6.5-9.1 9.2l-36.7 29.4c2.2 1.3 4.4 2.7 6.5 4.1l15.3 10.1c.3-13 10.9-23.4 24-23.4s23.7 10.4 24 23.4l15.3-10.2c2.1-1.4 4.3-2.8 6.6-4.1l-36.7-29.4c-3.4-2.7-6.5-5.8-9.1-9.2zm79.1 24.2 34.4-10.3c8.6-2.6 14.5-10.5 14.5-19.5 0-2.8-.6-5.5-1.7-8.1l-69.6-41.8c-14.4-8.6-32.9-.4-36.2 16-1.8 8.9 1.5 18 8.6 23.7l50 40zm-108.2-40c7.1-5.7 10.4-14.8 8.6-23.7-3.3-16.4-21.9-24.7-36.2-16l-69.6 41.8c-1.1 2.5-1.7 5.3-1.7 8.1 0 9 5.9 16.9 14.5 19.5l34.4 10.3 50-40zM336 0c16 0 31.5 3.8 45.3 10.9l44.1-9.8c3.2-.7 6.5-1.1 9.7-1.1h1.3c24 0 43.5 19.5 43.5 43.5 0 4.7-.8 9.3-2.2 13.8l-13.8 41.5 20.3 25c7.6 9.3 11.7 21 11.7 33 0 23.1-15.2 43.5-37.3 50.2l-35.8 10.7c-10.6 3.2-20.6 7.9-29.8 14l-18.8 12.6C362.9 252 349.6 256 336 256s-26.9-4-38.2-11.6L279 231.9c-9.2-6.1-19.2-10.9-29.8-14l-35.8-10.7c-22.2-6.6-37.3-27-37.3-50.2 0-12 4.1-23.7 11.7-33l20.3-25-13.9-41.7c-1.5-4.4-2.2-9.1-2.2-13.8 0-24 19.5-43.5 43.5-43.5h1.3c3.3 0 6.5.4 9.7 1.1l44.1 9.8C304.5 3.8 320 0 336 0zm-96.4 32.3c-.9-.2-1.8-.3-2.8-.3h-1.3c-6.4 0-11.5 5.2-11.5 11.5 0 1.2.2 2.5.6 3.6l7.4 22.3L258.4 37l.3-.4-19.1-4.2zm174 4.6L440 69.4l7.4-22.2c.4-1.2.6-2.4.6-3.6 0-6.4-5.2-11.5-11.5-11.5h-1.3c-.9 0-1.9.1-2.8.3l-19.1 4.2.3.4zM128 267.1c14-16.8 30.6-31.4 49.1-43.1 7.9 6.1 17 10.8 27 13.8l9.3 2.8C153.5 268.6 112 329.5 112 400c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-16.5 1.9-32.6 5.6-48H32v48c0 44.2 35.8 80 80 80h208c0-17.7-14.3-32-32-32h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48c35.3 0 64 28.7 64 64h96c0-17.7-14.3-32-32-32h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16H112C50.1 512 0 461.9 0 400V96c0-35.3 28.7-64 64-64s64 28.7 64 64v171.1zm320 27.2c0-17-6.9-33.1-18.9-44.8 1-.3 2-.6 2.9-.9l30.4-9.1c11.3 15.9 17.6 35 17.6 54.9 0 31.4-15.6 60.7-41.5 78.4l-10.9 7.2c-18.8 12.7-43.9 10.3-60-5.7-21.1-21.1-17.6-56.2 7.2-72.8l16.3-10.8c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2l-16.3 10.8c-8 5.3-9.1 16.7-2.3 23.5 5.2 5.2 13.3 6 19.4 1.8l10.8-7.3c17.2-11.7 27.5-31.1 27.5-51.9zM95.9 320l.1-.1V256H32v64h63.9zm.1-160H32v64h64v-64zm0-32V96c0-17.7-14.3-32-32-32S32 78.3 32 96v32h64zm208.4 246.2c-16.1 16.1-41.3 18.5-60.2 5.7L199 349.2c-7.3-5-9.2-14.9-4.3-22.2s14.9-9.2 22.2-4.3l45.3 30.7c6.1 4.2 14.3 3.4 19.6-1.9 6.8-6.8 5.8-18.2-2.3-23.7L244.3 304c-7.3-5-9.2-14.9-4.3-22.2s14.9-9.2 22.2-4.3l35.3 23.9c24.6 16.7 28 51.7 6.9 72.8zM272 128a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalRacquet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRacquet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M349 32c35.5 0 69 12.2 93.9 37.1S480 127.5 480 163c0 45.1-19.6 93.4-57.6 131.4-68.1 68.1-168.9 76.9-225.3 20.5C172.2 290 160 256.5 160 221c0-45.1 19.6-93.4 57.6-131.4S303.9 32 349 32zm0-32c-54.2 0-110.5 23.4-154 66.9s-67 99.8-66.9 154c0 28.2 6.4 56 19.7 80.7 7.8 14.4 7.2 32.8-4.4 44.4l-12 12-4.7-4.7c-12.5-12.5-32.8-12.5-45.3 0l-72 72c-12.5 12.5-12.5 32.8 0 45.3l32 32c12.5 12.5 32.8 12.5 45.3 0l72-72c12.5-12.5 12.5-32.8 0-45.3l-4.7-4.7 11.9-11.9c11.6-11.6 30-12.2 44.4-4.3 72.5 39.4 169.9 17.5 234.7-47.4 43.6-43.6 67-99.8 66.9-154 0-42.8-14.8-84.9-46.5-116.6S391.8 0 349 0zM104 376l32 32-72 72-32-32 72-72z"
        }
    ]
};

const FalRadar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRadar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7l-34.1 34.1C338.1 95.3 298.8 80 256 80c-72.2 0-134.2 43.5-161.3 105.6-3.5 8.1.2 17.5 8.3 21.1s17.5-.2 21.1-8.3c22.2-50.9 73-86.4 132-86.4 34 0 65.2 11.8 89.9 31.5l-34.3 34.3c-15.8-11.2-35-17.8-55.7-17.8-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3-28.7 64-64 64s-64-28.7-64-64 28.7-64 64-64c11.9 0 23 3.2 32.5 8.9l-43.8 43.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l224-224c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L425.4 64C380.2 24.2 320.9 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 123.7-100.3 224-224 224S32 379.7 32 256zm384-16c-8.8 0-16 7.2-16 16 0 59-35.5 109.8-86.4 132-8.1 3.5-11.8 13-8.3 21.1s13 11.8 21.1 8.3C388.5 390.2 432 328.2 432 256c0-8.8-7.2-16-16-16zm-313.1 65.3c-8.1 3.5-11.8 13-8.3 21.1 17.7 40.6 50.3 73.2 90.9 90.9 8.1 3.5 17.5-.2 21.1-8.3s-.2-17.5-8.3-21.1c-33.2-14.5-59.9-41.2-74.4-74.4-3.5-8.1-13-11.8-21.1-8.3zM120 256a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm136 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalRadiation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRadiation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m117.4 80 57.2 99c-11.9 12.6-20.9 27.9-26 45H34.3c8.3-58.2 39-109.2 83.2-144zm55.4 384.1L230 365c8.4 2 17.1 3 26 3s17.6-1 26-3l57.2 99.1C313.5 474.3 285.4 480 256 480s-57.5-5.7-83.2-15.9zM394.6 80c44.2 34.8 74.9 85.9 83.2 144H363.4c-5.1-17.1-14.1-32.4-26-45l57.2-99zM160 256c8.8 0 15.8-7.2 17.6-15.9 3.5-17.4 12.7-32.8 25.5-44.1 6.6-5.8 9.4-15.5 5-23.2L144 62c-8.8-15.3-28.6-20.7-42.7-10C47.8 92.7 10.7 154 2 224.1-.2 241.6 14.3 256 32 256h128zm48 83.2-64 110.9c-8.8 15.3-3.7 35.1 12.6 41.9 30.6 12.9 64.2 20 99.4 20s68.9-7.1 99.4-20c16.3-6.9 21.4-26.6 12.6-41.9l-64-110.9c-4.4-7.7-14.2-10.1-22.6-7.3-8 2.7-16.5 4.1-25.4 4.1s-17.4-1.4-25.4-4.1c-8.4-2.8-18.2-.4-22.6 7.3zm126.4-99.1c1.7 8.7 8.7 15.9 17.6 15.9h128c17.7 0 32.2-14.4 30-31.9C501.3 154 464.2 92.7 410.7 52c-14.1-10.7-33.8-5.3-42.7 10l-64 110.9c-4.4 7.6-1.7 17.3 5 23.2 12.8 11.3 22 26.7 25.5 44.1zM240 256a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0z"
        }
    ]
};

const FalRadioTuner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRadioTuner",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500.1 31.5c8.5-2.3 13.6-11 11.3-19.6S500.4-1.7 491.8.6L59.4 115.9c-31.3 8.4-54.1 34.6-58.6 66-.5 3.3-.8 6.6-.8 10.1v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H138.1l362-96.5zM32 193.2c0-2.2.1-4.3.4-6.4C34.9 171.6 48.1 160 64 160h384c17.7 0 32 14.3 32 32v32H32v-30.8zM32 448V256h448v192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zm48-128c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm272 32a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0-160 0z"
        }
    ]
};

const FalRadio = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRadio",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500.1 31.5c8.5-2.3 13.6-11 11.3-19.6S500.4-1.7 491.8.6L59.4 115.9c-31.3 8.4-54.1 34.6-58.6 66-.5 3.3-.8 6.6-.8 10.1v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H138.1l362-96.5zM32 193.2c0-2.2.1-4.3.4-6.4C34.9 171.6 48.1 160 64 160h384c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V193.2zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm-16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zm256 16a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-96-64a96 96 0 1 0 192 0 96 96 0 1 0-192 0z"
        }
    ]
};

const FalRainbow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRainbow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64C160.9 64 32 192.9 32 352v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V352C0 175.3 143.3 32 320 32s320 143.3 320 320v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-159.1-128.9-288-288-288zm0 192c-53 0-96 43-96 96v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-70.7 57.3-128 128-128s128 57.3 128 128v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-53-43-96-96-96zm-192 96v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-123.7 100.3-224 224-224s224 100.3 224 224v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V352c0-106-86-192-192-192s-192 86-192 192z"
        }
    ]
};

const FalRaindrops = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRaindrops",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m160 85.6-27.8 53c-2.7 5.2-4.2 11-4.2 16.9v4.5c0 17.7 14.3 32 32 32s32-14.3 32-32v-4.5c0-5.9-1.4-11.7-4.2-16.9l-27.8-53zm-11.7-46.5c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8v4.5c0 35.3-28.7 64-64 64s-64-28.7-64-64v-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zM64 277.6l-27.8 53c-2.7 5.2-4.2 11-4.2 16.9v4.5c0 17.7 14.3 32 32 32s32-14.3 32-32v-4.5c0-5.9-1.4-11.7-4.2-16.9l-27.8-53zm-11.7-46.5c2.3-4.4 6.8-7.1 11.7-7.1s9.4 2.7 11.7 7.1l44.4 84.6c5.2 9.8 7.8 20.7 7.8 31.8v4.5c0 35.3-28.7 64-64 64s-64-28.7-64-64v-4.5c0-11.1 2.7-22 7.8-31.8l44.4-84.6zM239 301.5c-9.8 15.3-15 33.1-15 51.3 0 52.3 43.2 95.2 96 95.2s96-42.9 96-95.2c0-18.2-5.2-36-15-51.3l-81-126.6-81 126.6zm-27-17.2 95.6-149.5c2.7-4.2 7.3-6.7 12.3-6.7s9.6 2.5 12.3 6.7l95.6 149.5c13.2 20.4 20.2 44.2 20.2 68.5C448 423 390.3 480 320 480s-128-57-128-127.2c0-24.3 7-48.1 20.1-68.6z"
        }
    ]
};

const FalRam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRam",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 56c0-30.9 25.1-56 56-56s56 25.1 56 56v10.8c7.7-1.8 15.7-2.8 24-2.8 14.2 0 27.7 2.8 40 8V56c0-30.9 25.1-56 56-56s56 25.1 56 56v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v37c11 10.5 19.7 23.5 25.2 37.9l47.7 31.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L576 173.9V240c0 53-43 96-96 96h-16c-53 0-96-43-96-96v-60.8l-15.1 10.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l37.3-24.9c7.3-23.9 22.9-44.2 43.5-57.5V56c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8zm-31.8 13.9.2-.2c1.6 11.3 7.9 21 16.9 27.2-13.2 8.3-30.7 6-41.2-6-5.9-6.8-14.5-11-24.1-11s-18.2 4.2-24.1 11c-11.3 12.9-30.6 14.6-44 4-5.5-4.3-12.3-6.9-19.9-6.9-15 0-27.7 10.4-31.1 24.3-3.9 16.1-19.6 26.6-36 24-1.6-.2-3.2-.4-5-.4-17.7 0-32 14.3-32 32 0 2.7.3 5.3.9 7.8 3.5 14.2-3 29-16 36-10.2 5.4-17 16.1-17 28.3s6.8 22.8 17 28.3c12.9 6.9 19.5 21.7 16 36-.6 2.5-.9 5.1-.9 7.8 0 17.7 14.3 32 32 32 1.7 0 3.4-.1 5-.4 16.4-2.5 32 7.9 36 24 3.4 14 16.1 24.3 31.1 24.3 7.6 0 14.4-2.6 19.9-6.9 13.4-10.6 32.8-8.9 44 4 5.9 6.8 14.5 11 24.1 11s18.2-4.2 24.1-11c11.3-12.9 30.6-14.6 44-4 5.5 4.3 12.3 6.9 19.9 6.9 15 0 27.7-10.4 31.1-24.3 1.4-5.8 4.3-10.8 8.2-14.8 6.2 5.2 13 9.9 20.1 14l20.1 5-25.9 103.7C392.2 497 373 512 351 512h-15c-26.5 0-48-21.5-48-48v-40.6c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6V464c0 26.5-21.5 48-48 48h-15c-22 0-41.2-15-46.6-36.4l-25-100C57.2 372.4 32 345.1 32 312c0-5.3.7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5 0-35.3 28.7-64 64-64 3.3 0 6.6.3 9.8.8 6.9-28 32.1-48.8 62.2-48.8 15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9zM344 424c-8.5 0-16.6-1.7-24-4.7V464c0 8.8 7.2 16 16 16h15c7.3 0 13.7-5 15.5-12.1l13.8-55.2C370 419.8 357.5 424 344 424zm-212.3-11.3 13.8 55.2c1.8 7.1 8.2 12.1 15.5 12.1h15c8.8 0 16-7.2 16-16v-44.7c-7.4 3-15.5 4.7-24 4.7-13.5 0-26-4.2-36.3-11.3zM544 168c0-39.8-32.2-72-72-72-36.1 0-66 26.6-71.2 61.2l.1.1-.1.1c-.5 3.5-.8 7-.8 10.6v72c0 35.3 28.7 64 64 64h16c35.3 0 64-28.7 64-64v-72zm-96 8a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalRampLoading = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRampLoading",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32h256c17.7 0 32 14.3 32 32v277.7l32 58.7V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v336.4l32-58.7V64c0-17.7 14.3-32 32-32zm67.1 256c-17.6 0-33.8 9.6-42.2 25.1L38.7 464.8C27.2 486.1 42.6 512 66.9 512h314.2c24.2 0 39.7-25.9 28.1-47.2l-82.1-151.7c-8.4-15.5-24.6-25.1-42.2-25.1H163.1zM149 328.4c2.8-5.2 8.2-8.4 14.1-8.4h121.8c5.9 0 11.3 3.2 14.1 8.4L381.1 480H66.9L149 328.4z"
        }
    ]
};

const FalRankingStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRankingStar",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m300.5 77.2-3.7 7.5-8.3 1.2-43.5 6.3 31.6 30.8 6 5.9-1.4 8.3-7.4 43.3 39-20.6 7.4-3.9 7.5 3.9 38.7 20.3-7.4-43.3-1.4-8.3 6.1-5.9 31.4-30.3-43.4-6.3-8.3-1.2-3.7-7.5L320 37.8l-19.5 39.4zm-5-62c10.3-20.6 39.4-19.9 49.1.1l19.9 40.2 44 6.3h.2c22.1 3.4 31.5 30.6 15.3 46.9l-.2.2-31.9 30.8 7.5 43.7v.3c3.4 22-19.5 39.1-39.8 28.9l-.3-.1-39.1-20.5-39.5 20.9-.3.2c-20.3 10.2-43.2-6.9-39.8-28.9v-.3l7.5-43.8-31.9-31.1-.2-.2c-16.2-16.2-6.7-43.5 15.3-46.9h.2l44-6.3 19.9-40.2zM192 368v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48zm224 64v32c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v128zM256 304v160c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zM32 368v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm448 64v32c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm16-48h96c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FalRaygun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRaygun",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M39.3 2.6c4.5-3 10.3-3.4 15.2-1.2L195.4 64H272c18 0 34.6 6 48 16V48c0-8.8 7.2-16 16-16s16 7.2 16 16v112h32V80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h32c0-6.1 3.4-11.6 8.8-14.3l96-48c5-2.5 10.9-2.2 15.6.7s7.6 8.1 7.6 13.6v128c0 5.5-2.9 10.7-7.6 13.6s-10.6 3.2-15.6.7l-96-48c-5.4-2.7-8.8-8.3-8.8-14.3h-32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80h-32v112c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c-12.4 9.3-27.6 15.1-44.2 15.9v.1L172.6 494.3c-7.9 15.8-27.1 22.2-42.9 14.3l-80-40c-15.8-7.9-22.2-27.1-14.3-42.9l69-137.9C46.1 283.8 0 235.3 0 176c0-30.5 12.2-58.2 32-78.4V16c0-5.4 2.7-10.5 7.3-13.4zM480 176v6.1l64 32v-76.2l-64 32v6.1zM192.3 96H112c-44.2 0-80 35.8-80 80s35.8 80 80 80h160c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-79.7zM64 40.6v34.2C78.5 67.9 94.8 64 112 64h4.6L64 40.6zM140 288 64 440l80 40 96-192H140zm-28-128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalReceipt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalReceipt",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M26.5 4C21.8-.2 15.1-1.2 9.4 1.4S0 9.7 0 16v480c0 6.3 3.7 12 9.4 14.6s12.4 1.6 17.1-2.5L79.2 462l45.4 45.4c6.2 6.2 16.4 6.2 22.6 0l44.8-44.8 44.7 44.7c6.2 6.2 16.4 6.2 22.6 0l45.4-45.4 52.8 46.1c4.7 4.1 11.4 5.1 17.1 2.5s9.4-8.3 9.4-14.6V16c0-6.3-3.7-12-9.4-14.6S362.2-.2 357.5 4l-52.8 46.1-45.4-45.4c-6.2-6.2-16.4-6.2-22.6 0L192 49.4 147.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L79.3 50.1 26.5 4zM32 460.7V51.3L69.5 84c6.3 5.5 15.9 5.2 21.8-.7L136 38.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0L248 38.6l44.7 44.7c6 6 15.5 6.3 21.8.7L352 51.3v409.4L314.5 428c-6.3-5.5-15.9-5.2-21.8.7L248 473.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0L136 473.4l-44.7-44.7c-6-6-15.5-6.3-21.8-.7L32 460.7zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zm16-112c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"
        }
    ]
};

const FalRecordVinyl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRecordVinyl",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm128-256a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-128-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalRectangleAd = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleAd",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm214.6 73.4 72 160c3.6 8.1 0 17.5-8 21.2s-17.5 0-21.2-8L247.3 320h-94.6l-10.2 22.6c-3.6 8.1-13.1 11.7-21.2 8s-11.7-13.1-8-21.2l72-160c2.6-5.7 8.3-9.4 14.6-9.4s12 3.7 14.6 9.4zM200 215l-32.9 73h65.7L200 215zm176 25a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm40-19.9V176c0-8.8 7.2-16 16-16s16 7.2 16 16v160c0 8.8-7.2 16-16 16-7.6 0-14-5.3-15.6-12.4C404.9 347.4 391 352 376 352c-39.8 0-72-32.2-72-72s32.2-72 72-72c14.8 0 28.6 4.5 40 12.1z"
        }
    ]
};

const FalRectangleBarcode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleBarcode",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 48c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm288 0c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm80-16c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-304 16c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm80-16c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm64 16c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144z"
        }
    ]
};

const FalRectangleCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleCode",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h384zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm229.4 140c-6.6 5.9-7.2 16-1.3 22.6l54.5 61.4-54.6 61.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3l64-72c5.4-6.1 5.4-15.2 0-21.3l-64-72c-5.9-6.6-16-7.2-22.6-1.3zM220 194.6c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3l-64 72c-5.4 6.1-5.4 15.2 0 21.3l64 72c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L165.4 256l54.6-61.4z"
        }
    ]
};

const FalRectangleHistoryCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleHistoryCirclePlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 192v.7c5.3-.5 10.6-.7 16-.7s10.7.2 16 .7v-.7c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32zM448 64H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h384c8.8 0 16-7.2 16-16s-7.2-16-16-16zM400 0H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-16 368a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-128-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FalRectangleHistoryCircleUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleHistoryCircleUser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 192v.7c5.3-.5 10.6-.7 16-.7s10.7.2 16 .7v-.7c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h330.8c-12.9-9.1-24.5-19.9-34.6-32H64c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32zM448 64H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h384c8.8 0 16-7.2 16-16s-7.2-16-16-16zM400 0H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16zm156 462.6c-17.3 11-37.9 17.4-60 17.4s-42.7-6.4-60-17.4c7.8-9.1 19.4-14.6 31.8-14.6h56.4c12.4 0 23.9 5.5 31.8 14.6zm24.3-20.8c-13.8-16.1-34.2-25.8-56.1-25.8h-56.4c-21.8 0-42.2 9.6-56.1 25.8-17.2-19.7-27.7-45.6-27.7-73.8 0-61.9 50.1-112 112-112s112 50.1 112 112c0 28.2-10.5 54.1-27.7 73.8zM640 368a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144-48a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"
        }
    ]
};

const FalRectangleHistory = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleHistory",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 192c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192zm-32-64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h384zm0-64c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-8.8 0-16-7.2-16-16s7.2-16 16-16h384zM400 0c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h288z"
        }
    ]
};

const FalRectangleList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleList",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88 0c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm-64-72a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalRectanglePro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectanglePro",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 64h48c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm48 96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v64h32zm96-80c0-8.8 7.2-16 16-16h48c35.3 0 64 28.7 64 64 0 23.2-12.4 43.6-30.9 54.8l35.7 47.6c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L304 288h-32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V176zm32 80h32c17.7 0 32-14.3 32-32s-14.3-32-32-32h-32v64zm208-96c44.2 0 80 35.8 80 80v32c0 44.2-35.8 80-80 80s-80-35.8-80-80v-32c0-44.2 35.8-80 80-80zm-48 80v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
        }
    ]
};

const FalRectangleTerminal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleTerminal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h384zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm35.9 117.6c-5.8 6.7-5 16.8 1.7 22.6l97.8 83.8-97.8 83.9c-6.7 5.8-7.5 15.8-1.7 22.6s15.9 7.5 22.6 1.7l112-96c3.5-3 5.6-7.5 5.6-12.1s-2-9.1-5.6-12.1l-112-96c-6.7-5.8-16.8-5-22.6 1.7zM224 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h176c8.8 0 16-7.2 16-16s-7.2-16-16-16H224z"
        }
    ]
};

const FalRectangleVerticalHistory = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleVerticalHistory",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H256zm-64 32c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H256c-35.3 0-64-28.7-64-64V64zm-96 0c0-8.8 7.2-16 16-16s16 7.2 16 16v384c0 8.8-7.2 16-16 16s-16-7.2-16-16V64zM0 112c0-8.8 7.2-16 16-16s16 7.2 16 16v288c0 8.8-7.2 16-16 16s-16-7.2-16-16V112z"
        }
    ]
};

const FalRectangleVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleVertical",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32v384zm32-384c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64z"
        }
    ]
};

const FalRectangleWide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleWide",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h512zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalRectangleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangleXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm180.7 84.7c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalRectangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectangle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h384zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalRectanglesMixed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRectanglesMixed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 64c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h224zM48 32C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm480 32c8.8 0 16 7.2 16 16v256c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h96zm-96-32c-26.5 0-48 21.5-48 48v256c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-96zM112 336h176c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16v-80c0-8.8 7.2-16 16-16zm-48 16v80c0 26.5 21.5 48 48 48h176c26.5 0 48-21.5 48-48v-80c0-26.5-21.5-48-48-48H112c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalRecycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRecycle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M193.7 35C206.9 13.3 230.5 0 256 0s49.1 13.3 62.3 35l77.8 127.8 11.1-54c1.8-8.7 10.2-14.2 18.9-12.4s14.2 10.2 12.4 18.9l-19.4 94.4c-.9 4.5-3.7 8.3-7.7 10.6s-8.7 2.8-13 1.3L307 191.2c-8.4-2.8-12.9-11.8-10.1-20.2s11.8-12.9 20.2-10.1l50.5 16.8-76.6-126C283.5 39.4 270.3 32 256 32s-27.5 7.4-35 19.7l-31.1 51.2c-4.6 7.5-14.4 9.9-21.9 5.4-7.6-4.6-10-14.5-5.4-22L193.7 35zm241.5 222.8c7.5-4.5 17.3-2.1 21.9 5.4l46 75.6c5.8 9.5 8.8 20.3 8.9 31.4.3 34.1-27.3 61.9-61.4 61.9H266.1l40.5 36c6.6 5.9 7.2 16 1.3 22.6s-16 7.2-22.6 1.3l-72-64c-3.4-3-5.4-7.4-5.4-12s2-8.9 5.4-12l72-64c6.6-5.9 16.7-5.3 22.6 1.3s5.3 16.7-1.3 22.6L266.1 400h184.6c16.3 0 29.5-13.3 29.4-29.6 0-5.3-1.5-10.5-4.3-15l-46-75.6c-4.6-7.6-2.2-17.5 5.4-22zm-300-.2-10-48.4-88.9 146.1c-2.8 4.5-4.2 9.7-4.3 15-.1 16.4 13.1 29.7 29.4 29.7h82.7c8.8 0 16 7.2 16 16s-7.2 16-16 16H61.4C27.3 432-.3 404.2 0 370.1c.1-11.1 3.2-21.9 8.9-31.4l92.4-151.9L45 205.5c-8.4 2.8-17.4-1.8-20.2-10.1S26.6 178 35 175.2l91.4-30.4c4.3-1.4 9.1-1 13 1.3s6.7 6.2 7.7 10.6l19.4 94.4c1.8 8.7-3.8 17.1-12.4 18.9s-17.1-3.8-18.9-12.4z"
        }
    ]
};

const FalReel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalReel",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h416c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V32H16C7.2 32 0 24.8 0 16zm96 16v48h256V32H96zM64 160c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM16 512c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-64c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H16zm80-80v48h256v-48H96z"
        }
    ]
};

const FalRefrigerator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRefrigerator",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 32c35.3 0 64 28.7 64 64v64h-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H32V96c0-35.3 28.7-64 64-64h192zm-32 160v176c0 8.8 7.2 16 16 16s16-7.2 16-16V192h64v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V192h224zM96 0C43 0 0 43 0 96v352c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V96c0-53-43-96-96-96H96z"
        }
    ]
};

const FalRegistered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRegistered",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-96-336v192c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h71.4l59.3 88.9c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2l-50.5-75.7c31-11 53.2-40.6 53.2-75.4 0-44.2-35.8-80-80-80h-64c-26.5 0-48 21.5-48 48zm32 80v-80c0-8.8 7.2-16 16-16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48h-80z"
        }
    ]
};

const FalRepeat1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRepeat1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 255.2c-.4 8.8 6.4 16.3 15.2 16.8s16.3-6.4 16.8-15.2l.4-8C36.2 172.2 99.5 112 176.2 112H320v44.4c0 15.2 12.3 27.6 27.6 27.6 6.8 0 13.4-2.5 18.4-7.1l76.7-69c3.4-3 5.3-7.4 5.3-11.9s-1.9-8.9-5.3-11.9l-76.7-69c-5.1-4.6-11.6-7.1-18.4-7.1C332.3 8 320 20.3 320 35.6V80H176.2C82.4 80 5.1 153.5.4 247.2l-.4 8zM408.1 96 352 146.5V45.6L408.1 96zM512 256.8c.4-8.8-6.4-16.3-15.2-16.8s-16.3 6.4-16.8 15.2l-.4 8C475.8 339.8 412.5 400 335.8 400H192v-44.4c0-15.2-12.3-27.6-27.6-27.6-6.8 0-13.4 2.5-18.4 7.1l-76.7 69c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l76.7 69c5.1 4.6 11.6 7.1 18.4 7.1 15.2 0 27.6-12.3 27.6-27.6V432h143.8c93.8 0 171.1-73.5 175.8-167.2l.4-8zM103.9 416l56.1-50.5v100.9L103.9 416zM288 208c0-6.1-3.4-11.6-8.8-14.3s-11.9-2.1-16.8 1.5l-32 24c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2l6.4-4.8v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalRepeat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRepeat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M15.2 272c-8.8-.5-15.6-8-15.2-16.8l.4-8C5.1 153.5 82.4 80 176.2 80H320V35.6C320 20.3 332.3 8 347.6 8c6.8 0 13.4 2.5 18.4 7.1l76.7 69c3.4 3 5.3 7.4 5.3 11.9s-1.9 8.9-5.3 11.9l-76.7 69c-5.1 4.6-11.6 7.1-18.4 7.1-15.2 0-27.6-12.3-27.6-27.6V112H176.2c-76.7 0-140 60.2-143.8 136.8l-.4 8c-.4 8.8-8 15.6-16.8 15.2zM352 146.5 408.1 96 352 45.5v100.9zM496.8 240c8.8.4 15.6 8 15.2 16.8l-.4 8c-4.7 93.7-82 167.2-175.8 167.2H192v44.4c0 15.2-12.3 27.6-27.6 27.6-6.8 0-13.4-2.5-18.4-7.1l-76.7-69c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l76.7-69c5.1-4.6 11.6-7.1 18.4-7.1 15.2 0 27.6 12.3 27.6 27.6V400h143.8c76.7 0 140-60.2 143.8-136.8l.4-8c.4-8.8 8-15.6 16.8-15.2zM160 365.5 103.9 416l56.1 50.5V365.6z"
        }
    ]
};

const FalReplyAll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalReplyAll",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M202.8 59.8c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1L24.8 178.4c-17.5 15.9-17.5 43.3 0 59.2l156.4 142.2c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L46.3 213.9c-3.5-3.2-3.5-8.7 0-11.8L202.8 59.8zM320 160h80c79.5 0 144 64.5 144 144 0 46.1-15.9 79.7-34 103.2 1.3-7.1 2-14.8 2-23.2 0-70.7-57.3-128-128-128h-72c-13.3 0-24 10.7-24 24v72L128 208 288 64v72c0 13.3 10.7 24 24 24h8zm0 160v-32h64c53 0 96 43 96 96 0 30.4-12.8 47.9-22.2 56.7-5.5 5.1-9.8 12-9.8 19.5 0 10.9 8.8 19.7 19.7 19.7 2.8 0 5.6-.6 8.1-1.9C494.5 467.9 576 417.3 576 304c0-97.2-78.8-176-176-176h-80V64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C99.9 190.3 96 198.9 96 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2v-32z"
        }
    ]
};

const FalReplyClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalReplyClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 32a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V80c0-8.8-7.2-16-16-16zm16 272c0-5.6-.3-11.2-.8-16.6-5 .4-10.1.6-15.2.6-5.7 0-11.4-.3-17-.8.6 5.5 1 11.1 1 16.8 0 46.1-15.9 79.7-34 103.2 1.3-7.1 2-14.8 2-23.2 0-70.7-57.3-128-128-128H216c-13.3 0-24 10.7-24 24v72L32 240 192 96v72c0 13.3 10.7 24 24 24h110.6c-2.9-10.3-4.9-21-5.9-32H224V96c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 222.3 0 230.9 0 240s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2v-64h96c53 0 96 43 96 96 0 30.4-12.8 47.9-22.2 56.7-5.5 5.1-9.8 12-9.8 19.5 0 10.9 8.8 19.7 19.7 19.7 2.8 0 5.6-.6 8.1-1.9C430.5 499.9 512 449.3 512 336z"
        }
    ]
};

const FalReply = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalReply",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 160c-13.3 0-24-10.7-24-24V64L32 208l160 144v-72c0-13.3 10.7-24 24-24h104c70.7 0 128 57.3 128 128 0 8.3-.7 16.1-2 23.2 18.2-23.4 34-57.1 34-103.2 0-79.5-64.5-144-144-144H216zm8 144v48c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2v64h112c97.2 0 176 78.8 176 176 0 113.3-81.5 163.9-100.2 174.1-2.5 1.4-5.3 1.9-8.1 1.9-10.9 0-19.7-8.9-19.7-19.7 0-7.5 4.3-14.4 9.8-19.5 9.4-8.8 22.2-26.4 22.2-56.7 0-53-43-96-96-96h-96v16z"
        }
    ]
};

const FalRepublican = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRepublican",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 176C0 96.5 64.5 32 144 32h224c79.5 0 144 64.5 144 144v192c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-26.5 21.5-48 48-48s48 21.5 48 48v64c0 61.9-50.1 112-112 112-32.2 0-61.2-13.6-81.7-35.4C440.8 465 422.1 480 400 480h-64c-26.5 0-48-21.5-48-48v-48H160v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176zm480 112H32v144c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16c0 44.2 35.8 80 80 80s80-35.8 80-80v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48v-80zm0-32v-80c0-61.9-50.1-112-112-112H144C82.1 64 32 114.1 32 176v80h448zM160 144v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16zm128 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalRestroomSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRestroomSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zM57.8 236c2.1-24.9 22.9-44 47.8-44h44.8c25 0 45.8 19.1 47.8 44l4.1 49.3c1.6 18.7-13.2 34.7-31.9 34.7H85.6c-18.7 0-33.4-16-31.9-34.7l4.1-49.3zm-31.9-2.7-4.1 49.3c-2.5 29.8 15.7 56.1 42.2 65.6V496c0 8.8 7.2 16 16 16s16-7.2 16-16V352h64v144c0 8.8 7.2 16 16 16s16-7.2 16-16V348.3c26.5-9.5 44.7-35.8 42.2-65.6l-4.1-49.3c-3.4-41.5-38.1-73.4-79.7-73.4h-44.8c-41.6 0-76.3 31.9-79.7 73.4zM320 0c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zm192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-15.7 64h31.4c14.3 0 26.8 9.5 30.8 23.2L597.6 352H426.4l39.1-136.8c3.9-13.7 16.5-23.2 30.8-23.2zm0-32c-28.6 0-53.7 18.9-61.5 46.4l-39.1 136.8c-5.8 20.4 9.5 40.8 30.8 40.8H448v112c0 8.8 7.2 16 16 16s16-7.2 16-16V384h64v112c0 8.8 7.2 16 16 16s16-7.2 16-16V384h21.6c21.3 0 36.6-20.3 30.8-40.8l-39.1-136.8c-7.8-27.5-33-46.4-61.5-46.4h-31.5z"
        }
    ]
};

const FalRestroom = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRestroom",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-32 164v156h64V164c-6-2.6-12.5-4-19.3-4h-25.4c-6.8 0-13.3 1.4-19.3 4zm0 188v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V202.1l-49.9 93.4c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l58.9-110.1c13.9-26 41-42.3 70.6-42.3h25.4c29.5 0 56.7 16.3 70.6 42.3l58.8 110.2c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L208 202.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h-64zM496 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm-40.8 241.7c7.9 4 11.1 13.6 7.2 21.5L409.9 368h172.2l-52.4-104.8c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l64 128c2.5 5 2.2 10.9-.7 15.6s-8.1 7.6-13.6 7.6H560v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V400h-64v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96h-48c-5.5 0-10.7-2.9-13.6-7.6s-3.2-10.6-.7-15.6l64-128c4-7.9 13.6-11.1 21.5-7.2zM435 196.6l-52.9 98.9c-4.2 7.8-13.9 10.7-21.7 6.6s-10.7-13.9-6.6-21.7l52.9-98.9c17.6-32.9 52-53.5 89.3-53.5s71.7 20.6 89.3 53.5l52.9 98.9c4.2 7.8 1.2 17.5-6.6 21.7s-17.5 1.2-21.7-6.6L557 196.6c-12-22.5-35.5-36.6-61-36.6s-49 14.1-61 36.6zM336 16v480c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalRetweet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRetweet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m96 103.9 50.5 56.1h-101L96 103.9zm88 60.5c0-6.8-2.5-13.4-7.1-18.4l-69-76.7c-3-3.4-7.4-5.3-11.9-5.3s-8.9 1.9-11.9 5.3l-69 76.7c-4.6 5.1-7.1 11.6-7.1 18.4C8 179.7 20.3 192 35.6 192H80v144c0 44.2 35.8 80 80 80h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-26.5 0-48-21.5-48-48V192h44.4c15.2 0 27.6-12.3 27.6-27.6zm296 243.7L429.5 352h100.9L480 408.1zm-88-60.5c0 6.8 2.5 13.4 7.1 18.4l69 76.7c3 3.4 7.4 5.3 11.9 5.3s8.9-1.9 11.9-5.3l69-76.7c4.6-5.1 7.1-11.6 7.1-18.4 0-15.2-12.3-27.6-27.6-27.6H496V176c0-44.2-35.8-80-80-80H272c-8.8 0-16 7.2-16 16s7.2 16 16 16h144c26.5 0 48 21.5 48 48v144h-44.4c-15.2 0-27.6 12.3-27.6 27.6z"
        }
    ]
};

const FalRhombus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRhombus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m438.5 230.1-184-216C246.8 5.1 235.7 0 224 0s-22.8 5.1-30.4 14.1l-184 216C-3.2 245-3.2 267 9.6 281.9l184 216c7.6 8.9 18.7 14.1 30.4 14.1s22.8-5.1 30.4-14.1l184-216c12.7-14.9 12.7-36.9 0-51.9zM230.1 34.8l184 216c2.5 3 2.5 7.4 0 10.4l-184 216c-1.5 1.8-3.7 2.8-6.1 2.8s-4.6-1-6.1-2.8l-184-216c-2.5-3-2.5-7.4 0-10.4l184-216c1.5-1.8 3.7-2.8 6.1-2.8s4.6 1 6.1 2.8z"
        }
    ]
};

const FalRibbon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRibbon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M228 0h-4v.1c-13.3.2-29.2.7-38.3 1.4s-17 1.7-23.5 2.6c-18.3 2.7-33.3 13.3-43.6 26.7L70.8 92.9C56 112.1 48 135.6 48 159.9c0 27.9 10.6 54.8 29.7 75.1l254.6 271.9c5.4 5.8 14.3 6.7 20.9 2.2l80-56c3.8-2.6 6.2-6.8 6.7-11.3s-1-9.1-4.1-12.5L172.4 139.5c-2.8-3-4.3-7-4.3-11.1 0-9.1 7.4-16.5 16.5-16.5h78.9c9.1 0 16.5 7.4 16.5 16.5 0 4.1-1.5 8-4.3 11.1l-30 33 21.6 23.8 32.1-35.3c8.1-8.9 12.6-20.5 12.6-32.6 0-26.8-21.7-48.5-48.5-48.5h-79c-26.8 0-48.5 21.7-48.5 48.5 0 12.1 4.5 23.7 12.6 32.6l251.3 276.3-53.7 37.6-245.1-261.7c-13.5-14.4-21-33.5-21-53.2 0-17.2 5.7-33.9 16.1-47.5l47.7-62.1c6.3-8.2 14.4-13.3 23-14.6 5.8-.9 12.9-1.7 21.4-2.4 9-.7 26.1-1.3 39.7-1.4 12.1.1 22.8.6 31.9 1.4 8.5.7 15.6 1.6 21.4 2.4 8.6 1.3 16.7 6.4 23 14.6l47.7 62.1c10.5 13.6 16.1 30.3 16.1 47.5 0 19.8-7.5 38.8-21 53.2L314.3 248l21.6 23.8 34.4-36.8c19.1-20.4 29.7-47.2 29.7-75.1 0-24.2-8-47.8-22.8-67l-47.7-62c-10.3-13.4-25.3-24-43.6-26.7-6.5-1-14.3-1.9-23.5-2.6-8.9-.8-19-1.4-30.4-1.5V0h-4zM112.5 319 12.2 429.2c-3.1 3.4-4.6 8-4.1 12.5s3 8.7 6.7 11.3l80 56c6.5 4.6 15.4 3.6 20.9-2.2l86.4-92.2-21.9-23.4-78.3 83.7-53.7-37.6 86.3-94.9-22-23.4z"
        }
    ]
};

const FalRightFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRightFromBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M479.2 254.2c.5.5.8 1.1.8 1.8s-.3 1.4-.8 1.8L347.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8-3.7 0-6.7-3-6.7-6.7V320c0-8.8-7.2-16-16-16H200c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h120c8.8 0 16-7.2 16-16v-57.3c0-3.7 3-6.7 6.7-6.7 1.7 0 3.3.7 4.6 1.8l131.9 124.4zM512 256c0-9.5-3.9-18.6-10.8-25.1l-132-124.4C362 99.8 352.5 96 342.7 96c-21.4 0-38.7 17.3-38.7 38.7V176H200c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h104v41.3c0 21.4 17.3 38.7 38.7 38.7 9.9 0 19.4-3.8 26.5-10.5l132-124.4c6.9-6.5 10.8-15.6 10.8-25.1zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80C35.8 32 0 67.8 0 112v288c0 44.2 35.8 80 80 80h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h96z"
        }
    ]
};

const FalRightFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRightFromLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M415.2 254.2c.5.5.8 1.1.8 1.8s-.3 1.4-.8 1.8L283.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8-3.7 0-6.7-3-6.7-6.7V320c0-8.8-7.2-16-16-16H136c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h120c8.8 0 16-7.2 16-16v-57.3c0-3.7 3-6.7 6.7-6.7 1.7 0 3.3.7 4.6 1.8l131.9 124.4zM448 256c0-9.5-3.9-18.6-10.8-25.1l-132-124.4C298 99.8 288.5 96 278.7 96c-21.4 0-38.7 17.3-38.7 38.7V176H136c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h104v41.3c0 21.4 17.3 38.7 38.7 38.7 9.9 0 19.3-3.8 26.5-10.5l132-124.4c6.9-6.5 10.8-15.6 10.8-25.1zM0 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16S0 71.2 0 80z"
        }
    ]
};

const FalRightLeftLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRightLeftLarge",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M205.2 496c-12.4 0-24.4-4.6-33.7-12.8L49.3 374.6C38.3 364.8 32 350.7 32 336s6.3-28.8 17.3-38.6l122.2-108.6c9.3-8.3 21.3-12.8 33.7-12.8 28 0 50.8 22.7 50.8 50.8V240h144c8.8 0 16 7.2 16 16v29.2c0 10.4 8.4 18.8 18.8 18.8 4.6 0 9-1.7 12.5-4.7l122.1-108.6c4.2-3.7 6.6-9.1 6.6-14.7s-2.4-10.9-6.6-14.7L447.3 52.7c-3.4-3.1-7.9-4.7-12.5-4.7-10.4 0-18.8 8.4-18.8 18.8V96c0 8.8-7.2 16-16 16H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V66.8c0-28 22.7-50.8 50.8-50.8 12.4 0 24.4 4.6 33.7 12.8l122.2 108.6c11 9.8 17.3 23.8 17.3 38.6s-6.3 28.8-17.3 38.6L468.5 323.2c-9.3 8.3-21.3 12.8-33.7 12.8-28 0-50.8-22.7-50.8-50.8V272H240c-8.8 0-16-7.2-16-16v-29.2c0-10.4-8.4-18.8-18.8-18.8-4.6 0-9 1.7-12.5 4.7L70.6 321.3C66.4 325 64 330.4 64 336s2.4 10.9 6.6 14.7l122.1 108.6c3.4 3.1 7.9 4.7 12.5 4.7 10.4 0 18.8-8.4 18.8-18.8V416c0-8.8 7.2-16 16-16h112c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96v13.2c0 28-22.7 50.8-50.8 50.8z"
        }
    ]
};

const FalRightLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRightLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 222.7c0 18.4 14.9 33.3 33.3 33.3 8.4 0 16.4-3.1 22.6-8.8l99-91.4c3.3-3 5.1-7.3 5.1-11.8s-1.9-8.7-5.1-11.8l-99-91.4c-6.1-5.7-14.2-8.8-22.6-8.8-18.4 0-33.3 14.9-33.3 33.3V128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h336v62.7zm33.3 1.3c-.7 0-1.3-.6-1.3-1.3V65.3c0-.7.6-1.3 1.3-1.3.3 0 .6.1.9.3l86.2 79.7-86.3 79.7c-.2.2-.5.3-.9.3zM126.7 480c18.4 0 33.3-14.9 33.3-33.3V384h336c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v-62.7c0-18.4-14.9-33.3-33.3-33.3-8.4 0-16.4 3.1-22.6 8.8l-99 91.4C1.9 359.3 0 363.5 0 368s1.9 8.7 5.1 11.8l99 91.4c6.1 5.7 14.2 8.8 22.6 8.8zm1.3-33.3c0 .7-.6 1.3-1.3 1.3-.3 0-.6-.1-.9-.3L39.6 368l86.3-79.7c.2-.2.5-.3.9-.3.7 0 1.3.6 1.3 1.3v157.4z"
        }
    ]
};

const FalRightLongToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRightLongToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M640 80v352c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16zM320 216H48c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16h272c17.7 0 32 14.3 32 32v49.3c0 3.7 3 6.7 6.7 6.7 1.9 0 3.7-.8 5-2.2L476.2 256 363.7 130.2c-1.3-1.4-3.1-2.2-5-2.2-3.7 0-6.7 3-6.7 6.7V184c0 17.7-14.3 32-32 32zm192 40c0 5.2-1.9 10.1-5.3 14L387.5 403.1c-7.3 8.2-17.8 12.9-28.8 12.9-21.4 0-38.7-17.3-38.7-38.7V328H48c-26.5 0-48-21.5-48-48v-48c0-26.5 21.5-48 48-48h272v-49.3c0-21.4 17.3-38.7 38.7-38.7 11 0 21.5 4.7 28.8 12.9L506.7 242c3.4 3.8 5.3 8.8 5.3 14z"
        }
    ]
};

const FalRightLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRightLong",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 184v-49.3c0-3.7 3-6.7 6.7-6.7 1.9 0 3.7.8 5 2.2L476.2 256 363.7 381.8c-1.3 1.4-3.1 2.2-5 2.2-3.7 0-6.7-3-6.7-6.7V328c0-17.7-14.3-32-32-32H48c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h272c17.7 0 32-14.3 32-32zm154.7 86c3.4-3.8 5.3-8.8 5.3-14s-1.9-10.1-5.3-14L387.5 108.9c-7.3-8.2-17.8-12.9-28.8-12.9-21.4 0-38.7 17.3-38.7 38.7V184H48c-26.5 0-48 21.5-48 48v48c0 26.5 21.5 48 48 48h272v49.3c0 21.4 17.3 38.7 38.7 38.7 11 0 21.5-4.7 28.8-12.9L506.7 270z"
        }
    ]
};

const FalRightToBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRightToBracket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.2 257.8c.5-.5.8-1.1.8-1.8s-.3-1.4-.8-1.8L187.3 129.8c-1.2-1.2-2.9-1.8-4.6-1.8-3.7 0-6.7 3-6.7 6.7V192c0 8.8-7.2 16-16 16H40c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h120c8.8 0 16 7.2 16 16v57.3c0 3.7 3 6.7 6.7 6.7 1.7 0 3.3-.6 4.6-1.8l131.9-124.4zM352 256c0 9.5-3.9 18.6-10.8 25.1l-132 124.4c-7.2 6.8-16.7 10.5-26.5 10.5-21.4 0-38.7-17.3-38.7-38.7V336H40c-22.1 0-40-17.9-40-40v-80c0-22.1 17.9-40 40-40h104v-41.3c0-21.4 17.3-38.7 38.7-38.7 9.9 0 19.3 3.8 26.5 10.5l132 124.4c6.9 6.5 10.8 15.6 10.8 25.1zm-16 192h96c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c44.2 0 80 35.8 80 80v288c0 44.2-35.8 80-80 80h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalRightToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRightToLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 80v352c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16s-16 7.2-16 16zm-96.8 174.2c.5.5.8 1.1.8 1.8s-.3 1.4-.8 1.8L187.3 382.2c-1.2 1.2-2.9 1.8-4.6 1.8-3.7 0-6.7-3-6.7-6.7V320c0-8.8-7.2-16-16-16H40c-4.4 0-8-3.6-8-8v-80c0-4.4 3.6-8 8-8h120c8.8 0 16-7.2 16-16v-57.3c0-3.7 3-6.7 6.7-6.7 1.7 0 3.3.7 4.6 1.8l131.9 124.4zM352 256c0-9.5-3.9-18.6-10.8-25.1l-132-124.4C202 99.8 192.5 96 182.7 96c-21.4 0-38.7 17.3-38.7 38.7V176H40c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h104v41.3c0 21.4 17.3 38.7 38.7 38.7 9.9 0 19.3-3.8 26.5-10.5l132-124.4c6.9-6.5 10.8-15.6 10.8-25.1z"
        }
    ]
};

const FalRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 253.7v4.6c0 4.4-1.8 8.6-5 11.6L261.2 412.5c-2.3 2.2-5.4 3.5-8.7 3.5-6.9 0-12.6-5.6-12.6-12.6V320c0-8.8-7.2-16-16-16H48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16h176c8.8 0 16-7.2 16-16v-83.4c0-6.9 5.6-12.6 12.6-12.6 3.2 0 6.3 1.2 8.7 3.5L411 242.1c3.2 3 5 7.2 5 11.6zM252.6 448c11.4 0 22.5-4.4 30.7-12.3L433.1 293c9.5-9.1 14.9-21.6 14.9-34.8v-4.6c0-13.1-5.4-25.7-14.9-34.8L283.3 76.3C275 68.4 264 64 252.6 64 228 64 208 84 208 108.6V176H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h160v67.4c0 24.6 20 44.6 44.6 44.6z"
        }
    ]
};

const FalRingDiamond = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRingDiamond",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M136 0c-5.7 0-11 3.1-13.9 8.1l-32 56c-3 5.3-2.8 11.8.6 16.8l38.4 57.7C54 164.6 0 236 0 320c0 106 86 192 192 192s192-86 192-192c0-84-54-155.4-129.1-181.5l38.4-57.7c3.4-5 3.6-11.6.6-16.8l-32-56c-2.9-4.9-8.2-8-13.9-8H136zm85.9 130.3c-9.7-1.5-19.7-2.3-29.9-2.3s-20.2.8-29.9 2.3l-39.3-59L145.3 32h93.4l22.5 39.4-39.3 59zM32 320a160 160 0 1 1 320 0 160 160 0 1 1-320 0z"
        }
    ]
};

const FalRing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRing",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.1 127.3C133.9 108.2 191.5 96 256 96s122.1 12.2 162.9 31.3C461.1 147 480 171 480 192c0 14.3-8.7 30-27.6 44.8-6.3-3.7-13-7.2-19.9-10.4-46-21.6-108.4-34.4-176.5-34.4s-130.5 12.8-176.5 34.3c-6.9 3.2-13.6 6.7-19.9 10.4C40.7 222 32 206.3 32 192c0-21 18.9-45 61.1-64.7zm386.9 128V320c0 21-18.9 45-61.1 64.7C378.1 403.8 320.5 416 256 416s-122.1-12.2-162.9-31.3C50.9 365 32 341 32 320v-64.7c13.2 11.8 29.5 22 47.5 30.4 46 21.5 108.4 34.3 176.5 34.3s130.5-12.8 176.5-34.3c18-8.4 34.4-18.6 47.5-30.4zM0 192v128c0 40.8 34.8 72.8 79.5 93.7 46 21.5 108.4 34.3 176.5 34.3s130.5-12.8 176.5-34.3c44.7-20.9 79.5-52.9 79.5-93.7V192c0-40.8-34.8-72.8-79.5-93.7C386.5 76.8 324.1 64 256 64S125.5 76.8 79.5 98.3C34.8 119.2 0 151.2 0 192zm93.1 64.7-1.5-.7 1.5-.7C133.9 236.2 191.5 224 256 224s122.1 12.2 162.9 31.3l1.5.7-1.5.7C378.1 275.8 320.5 288 256 288s-122.1-12.2-162.9-31.3z"
        }
    ]
};

const FalRingsWedding = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRingsWedding",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m137.9 32-8 16 24 48h44.2l24-48-8-16h-76.2zm116.4 23.2-24.6 49.2C300.6 127.1 352 193.5 352 272c0 64.4-34.5 120.7-86.1 151.3-8.6-6.9-16.1-15-22.4-24.1C289 375 320 327.1 320 272c0-27.5-7.7-53.3-21.1-75.2C237.3 213.2 192 269.3 192 336c0 27.5 7.7 53.3 21.1 75.2 6 9.8 13.2 18.8 21.3 26.9C260.5 464 296.4 480 336 480c79.5 0 144-64.5 144-144 0-67.9-47-124.9-110.3-140-4.9-12.4-10.9-24.2-17.9-35.3 89.8 8 160.2 83.4 160.2 175.3 0 97.2-78.8 176-176 176-55.3 0-104.7-25.5-137-65.5-7.5 1-15.2 1.5-23 1.5C78.8 448 0 369.2 0 272c0-78.5 51.4-144.9 122.3-167.7L97.7 55.2c-2.3-4.5-2.3-9.8 0-14.3l16-32C116.4 3.4 121.9 0 128 0h96c6.1 0 11.6 3.4 14.3 8.8l16 32c2.3 4.5 2.3 9.8 0 14.3zM179.2 416c-12.3-24-19.2-51.2-19.2-80 0-76.7 49.1-142 117.6-166.1C251.5 144 215.6 128 176 128c-79.5 0-144 64.5-144 144s64.5 144 144 144h3.2z"
        }
    ]
};

const FalRoadBarrier = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRoadBarrier",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32c8.8 0 16 7.2 16 16v32h576V48c0-8.8 7.2-16 16-16s16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H32v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm592 240V112h-38.1l-80 160H608zm-576 0h38.1l80-160H32v160zm374.1-160h-92.2l-80 160h92.2l80-160zm35.8 0-80 160h92.2l80-160h-92.2zm-256 0-80 160h92.2l80-160h-92.2z"
        }
    ]
};

const FalRoadBridge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRoadBridge",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 32c17.7 0 32 14.3 32 32v384c0 17.7-14.3 32-32 32h-80v-64c0-8.8-7.2-16-16-16s-16 7.2-16 16v64h-80c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h80v64c0 8.8 7.2 16 16 16s16-7.2 16-16V32h80zm0-32H384c-35.3 0-64 28.7-64 64v384c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm-96 192c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zM16 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h272v-32h-48v-64h48V96H16zm248 192c-48.6 0-88 39.4-88 88v88c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-88c0-48.6-39.4-88-88-88h-8c-8.8 0-16 7.2-16 16s7.2 16 16 16h8c30.9 0 56 25.1 56 56v88c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48v-88c0-30.9 25.1-56 56-56h24v-32h-24zm-56-160v64h-96v-64h96z"
        }
    ]
};

const FalRoadCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRoadCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M157.5 74c9.2-25.2 33.2-42 60.1-42h204.8c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7-1.5 0-2.9 0-4.4.1L452.5 85c-4.6-12.6-16.6-21-30.1-21H336v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64h-86.4c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43h238.5c5.9 11.4 12.9 22.2 21 32H100.6c-44.5 0-75.4-44.2-60.1-86l117-320zM336 208v86.6c-3.5 7.6-6.5 15.6-8.9 23.8-2.1 1.1-4.6 1.7-7.1 1.7-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm160 272a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalRoadCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRoadCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M157.5 74c9.2-25.2 33.2-42 60.1-42h204.8c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7-1.5 0-2.9 0-4.4.1L452.5 85c-4.6-12.6-16.6-21-30.1-21H336v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64h-86.4c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43h238.5c5.9 11.4 12.9 22.2 21 32H100.6c-44.5 0-75.4-44.2-60.1-86l117-320zM336 208v86.6c-3.5 7.6-6.5 15.6-8.9 23.8-2.1 1.1-4.6 1.7-7.1 1.7-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm272 160a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalRoadCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRoadCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M157.5 74c9.2-25.2 33.2-42 60.1-42h204.8c26.9 0 50.9 16.8 60.1 42l44.1 120.6c-9.9-1.7-20.2-2.7-30.6-2.7-1.5 0-2.9 0-4.4.1L452.5 85c-4.6-12.6-16.6-21-30.1-21H336v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64h-86.4c-13.4 0-25.4 8.4-30.1 21L70.6 405c-7.6 20.9 7.8 43 30.1 43h238.5c5.9 11.4 12.9 22.2 21 32H100.6c-44.5 0-75.4-44.2-60.1-86l117-320zM336 208v86.6c-3.5 7.6-6.5 15.6-8.9 23.8-2.1 1.1-4.6 1.7-7.1 1.7-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16zm272 160a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm166.6 0 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
        }
    ]
};

const FalRoadLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRoadLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M217.6 32c-26.9 0-50.9 16.8-60.1 42l-117 320c-15.3 41.8 15.7 86 60.1 86H384v-32h-48v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H100.6c-22.2 0-37.7-22.1-30.1-43l117-320c4.6-12.6 16.6-21 30.1-21H304v48c0 8.8 7.2 16 16 16s16-7.2 16-16V64h86.4c13.4 0 25.4 8.4 30.1 21l30.8 84.3c9.7-4.2 20.1-7.1 31-8.4L482.5 74c-9.2-25.2-33.2-42-60.1-42H217.6zM336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm192 16c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80h160v128H448V352z"
        }
    ]
};

const FalRoadSpikes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRoadSpikes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.3 108 160 208l32 48V116.8c0-15.8 20.5-22 29.3-8.9L288 208l32 48V116.8c0-15.8 20.5-22 29.3-8.9L416 208l32 48V116.8c0-15.8 20.5-22 29.3-8.9l129.5 194.3c14.2 21.3-1.1 49.7-26.6 49.7H64V116.8c0-15.8 20.5-22 29.3-8.9zM512 320h68.2L480 169.7V320h32zm-90.6-46.2L352 169.7V320h100.2l-30.8-46.2zm-128 0L224 169.7V320h100.2l-30.8-46.2zm-128 0L96 169.7V320h100.2l-30.8-46.2zM16 416h608c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalRoad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRoad",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M185.6 32c-26.9 0-50.9 16.8-60.1 42L8.5 394c-15.3 41.8 15.7 86 60.1 86h438.8c44.5 0 75.4-44.2 60.1-86l-117-320c-9.2-25.2-33.2-42-60.1-42H185.6zm-30.1 53c4.6-12.6 16.6-21 30.1-21H272v48c0 8.8 7.2 16 16 16s16-7.2 16-16V64h86.4c13.4 0 25.4 8.4 30.1 21l116.9 320c7.6 20.9-7.8 43-30.1 43H304v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H68.6c-22.2 0-37.7-22.1-30.1-43l117-320zM304 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalRobotAstromech = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRobotAstromech",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-79.5 0-144 64.5-144 144v16H96c-35.3 0-64 28.7-64 64v196.2L2.4 479.5C.8 482.6 0 486 0 489.5 0 501.9 10.1 512 22.5 512H128c8.8 0 16-7.2 16-16v-89.4l36.7 36.7c3 3 7.1 4.7 11.3 4.7h128c4.2 0 8.3-1.7 11.3-4.7l36.7-36.7V496c0 8.8 7.2 16 16 16h105.5c12.4 0 22.5-10.1 22.5-22.5 0-3.5-.8-6.9-2.4-10L480 420.2V224c0-35.3-28.7-64-64-64h-16v-16C400 64.5 335.5 0 256 0zm144 192h16c17.7 0 32 14.3 32 32v200c0 2.5.6 4.9 1.7 7.2l24.4 48.8H400V192zm-32 0v169.4L313.4 416H198.6L144 361.4V192h224zm-256 0v288H37.9l24.4-48.8c1.1-2.2 1.7-4.7 1.7-7.2V224c0-17.7 14.3-32 32-32h16zm32-48c0-61.9 50.1-112 112-112s112 50.1 112 112v16H144v-16zm80-16a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM192 240c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalRobot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRobot",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c8.8 0 16 7.2 16 16v80h112c53 0 96 43 96 96v224c0 53-43 96-96 96H192c-53 0-96-43-96-96V192c0-53 43-96 96-96h112V16c0-8.8 7.2-16 16-16zM192 128c-35.3 0-64 28.7-64 64v224c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H192zm16 256h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm96 0h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zM224 224a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm64 32a64 64 0 1 1-128 0 64 64 0 1 1 128 0zm96 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM48 224h16v32H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h16v32H48c-26.5 0-48-21.5-48-48v-96c0-26.5 21.5-48 48-48zm544 160c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-16v-32h16c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48h-16v-32h16z"
        }
    ]
};

const FalRocketLaunch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRocketLaunch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M219.3 292.7c-10-10-21.4-18.1-33.8-24.1C215.6 146.3 269 86.7 321.1 58.1c53.5-29.4 111.4-29.4 154.6-21.8 7.6 43.2 7.7 101.1-21.8 154.6-28.6 52.1-88.2 105.5-210.5 135.6-6-12.4-14.1-23.9-24.1-33.8zm36.7 88.6c0-8.2-.8-16.3-2.4-24.3 37.8-9.5 70.4-21.3 98.4-34.7v80.1c0 12.1-6.8 23.2-17.7 28.6L256 470.1v-88.9zm128 21.1V305c131.7-79.9 136.5-202.5 122.7-276.9-2.2-11.6-11.2-20.7-22.8-22.8-74.4-13.8-197-9-276.9 122.7h-97.4c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.9.7 15.6S10.5 288 16 288h114.7c24.7 0 48.5 9.8 65.9 27.3s27.3 41.2 27.3 65.9V496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6.7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2zm-229-144c-7.9-1.6-16.1-2.4-24.3-2.4H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7h80.1c-13.5 28-25.2 60.5-34.7 98.4zm-11.2 189c-11 11-29.4 19.4-52.6 24.9-20.6 4.9-42.1 6.8-59 7.4.6-17 2.5-38.4 7.4-59 5.5-23.2 13.9-41.6 24.9-52.6 21.9-21.9 57.4-21.9 79.3 0s21.9 57.4 0 79.3zm22.7 22.6c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C7.7 379.7 1 446 .1 483.7c-.4 16 12.2 28.6 28.2 28.2 37.7-.9 104-7.6 138.2-41.9zM392 144a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-24-56a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"
        }
    ]
};

const FalRocket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRocket",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m188.9 372-50.4-50.4c18.6-42.6 61.7-137.7 95.1-187 71-104.5 175.4-110 242.1-98.3 11.7 66.7 6.2 171.1-98.4 242-49.4 33.5-145.5 75.6-188.4 93.7zM109 309.2c-5.2 11.9-2.5 25.7 6.7 34.9l50.7 50.7c9.1 9.1 22.7 11.9 34.5 6.9 6.5-2.7 14.3-6 23-9.8L224 496c0 5.5 2.9 10.7 7.6 13.6s10.6 3.2 15.6.7l101.5-50.7c21.7-10.8 35.4-33 35.4-57.2v-90.3c4-2.5 7.7-4.9 11.3-7.3 120.7-81.9 124.7-203.9 111.3-276.7-2.1-11.6-11.2-20.6-22.8-22.8-72.8-13.4-194.8-9.4-276.7 111.4-2.4 3.6-4.9 7.3-7.3 11.3h-90.2c-24.2 0-46.4 13.7-57.2 35.4L1.7 264.8c-2.5 5-2.2 10.8.7 15.6S10.5 288 16 288h102.5c-3.6 8-6.8 15.2-9.4 21.2zm147 160.9v-92.5c30.3-13.7 65.4-30.3 96-47v71.7c0 12.1-6.8 23.2-17.7 28.6L256 470.1zM109.7 160h71.5c-16.9 30.7-34 65.8-48.1 96H41.9L81 177.7c5.4-10.8 16.5-17.7 28.6-17.7zM392 144a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm-24-56a56 56 0 1 0 0 112 56 56 0 1 0 0-112z"
        }
    ]
};

const FalRollerCoaster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRollerCoaster",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64c-5.4 0-10.8.4-16 1.1V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V74.8c-37.8 18-64 56.5-64 101.2v288c0 8.8-7.2 16-16 16s-16-7.2-16-16V176C0 96.5 64.5 32 144 32h6.6c46.2 0 89.7 22.2 116.7 59.7l125.4 173.7c24.8 34.3 64.5 54.6 106.8 54.6H512c53 0 96-43 96-96v-5c0-40.9-26.9-75.4-64-86.9V272c-6.7 5-15 8-24 8h-8V128.1c-22.5.8-44.4 6.8-64 17.5v117.6c-9.2-6.3-17.3-14.2-23.9-23.4l-8.1-11.3V169l-21.4 19-21.2-24 26.4-23.5C432.1 111.9 473.8 96 517 96c67.9 0 123 55.1 123 123v245c0 8.8-7.2 16-16 16s-16-7.2-16-16V308.7c-23.5 26.6-57.8 43.3-96 43.3v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V350.8c-22.8-2.7-44.6-10.2-64-21.7V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304.3c-6.2-6.2-12-12.9-17.2-20.2L320 219.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V175l-46.7-64.6c-5.1-7-10.9-13.4-17.3-19V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V72c-13-5.2-27.1-8-41.4-8H144z"
        }
    ]
};

const FalRotateExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRotateExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M403.5 133.1C368.3 90.9 315.3 64 256 64c-90.8 0-166.9 63-186.9 147.7-2 8.6-10.6 13.9-19.2 11.9S36 213 38 204.4C61.3 105.5 150.1 32 256 32c69.2 0 131 31.4 172.1 80.6l35.9 42.3V96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h55.9l-36.3-42.8-.1-.1zM272 144v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm-16 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM32 432c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H72.1l36.3 42.8.1.1C143.7 421.1 196.7 448 256 448c90.8 0 166.9-63 186.9-147.7 2-8.6 10.7-13.9 19.3-11.9s13.9 10.6 11.9 19.2C450.7 406.5 361.9 480 256 480c-69.2 0-131-31.4-172.1-80.6L48 357.1V416c0 8.8-7.2 16-16 16z"
        }
    ]
};

const FalRotateLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRotateLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M94.7 360.2c-3.2-5-8.7-8.2-14.7-8.2-12.3 0-20.3 12.8-13.7 23.2C106 438.2 176.1 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7L78.6 56c-5.1-5.1-12.1-8-19.3-8C44.2 48 32 60.2 32 75.3V176c0 8.8 7.2 16 16 16h100.7c15.1 0 27.3-12.2 27.3-27.3 0-7.2-2.9-14.2-8-19.3l-36-36C165.5 81.1 208.7 64 256 64c106 0 192 86 192 192s-86 192-192 192c-67.6 0-127.1-35-161.3-87.8zM64 86.6l73.4 73.4H64V86.6z"
        }
    ]
};

const FalRotateRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRotateRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M417.3 360.2c3.2-5 8.7-8.2 14.7-8.2 12.3 0 20.3 12.8 13.7 23.2C406 438.2 335.9 480 256 480 132.3 480 32 379.7 32 256S132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7L433.4 56c5.1-5.1 12.1-8 19.3-8 15.1 0 27.3 12.2 27.3 27.3V176c0 8.8-7.2 16-16 16H363.3c-15.1 0-27.3-12.2-27.3-27.3 0-7.2 2.9-14.2 8-19.3l36-36C346.5 81.1 303.3 64 256 64 150 64 64 150 64 256s86 192 192 192c67.6 0 127.1-35 161.3-87.8zM448 86.6 374.6 160H448V86.6z"
        }
    ]
};

const FalRotate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRotate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M426.1 301.2C406.2 376.5 337.6 432 256 432c-51 0-96.9-21.7-129-56.3l41-41c5.1-5.1 8-12.1 8-19.3 0-15.1-12.2-27.3-27.3-27.3H48c-8.8 0-16 7.2-16 16v100.6c0 15.1 12.2 27.3 27.3 27.3 7.2 0 14.2-2.9 19.3-8l25.7-25.7c38 40.4 91.9 65.7 151.7 65.7 97.4 0 179.2-67 201.8-157.4 2.4-9.7-5.2-18.6-15.2-18.6-7.8 0-14.5 5.6-16.5 13.2zM385 136.3l-41 41c-5.1 5.1-8 12.1-8 19.3 0 15.1 12.2 27.3 27.3 27.3H464c8.8 0 16-7.2 16-16V107.3c0-15.1-12.2-27.3-27.3-27.3-7.2 0-14.2 2.9-19.3 8l-25.7 25.7C369.7 73.3 315.8 48 256 48c-97.4 0-179.2 67-201.8 157.4-2.4 9.7 5.2 18.6 15.2 18.6 7.8 0 14.5-5.6 16.5-13.2C105.8 135.5 174.4 80 256 80c51 0 96.9 21.7 129.1 56.3zm63 55.7h-73.4l73.4-73.4V192zM64 320h73.4L64 393.4V320z"
        }
    ]
};

const FalRouteHighway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRouteHighway",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M232.2 2.3c-5.1-3-11.4-3-16.5 0L194.6 15c-31.9 19.2-71.5 20.7-104.8 4-17.7-8.9-39.2-3.8-51.1 12.1L14.5 63.3c-10.7 14.2-11.9 33.5-3 49C24.9 135.9 32 162.5 32 189.7V203c0 22.4-4.3 44.6-12.6 65.4L8 296.9c-5.3 13.2-8 27.4-8 41.6 0 43.7 25.4 83.5 65.1 101.8l152.2 70.2c4.3 2 9.2 2 13.4 0l152.2-70.2C422.6 422 448 382.2 448 338.5c0-14.3-2.7-28.4-8-41.6l-11.4-28.5c-8.3-20.8-12.6-43-12.6-65.4v-13.3c0-27.1 7.1-53.8 20.6-77.4 8.8-15.5 7.6-34.7-3-49l-24.3-32.2c-11.9-15.9-33.4-20.9-51.1-12.1-33.3 16.7-72.8 15.1-104.8-4L232.2 2.3zM211 42.4l13-7.8 13 7.8c41.3 24.8 92.4 26.8 135.5 5.2 3.9-1.9 8.6-.8 11.2 2.6l24.2 32.3c3 4 3.4 9.5.9 13.9-11.3 19.7-18.8 41.3-22.4 63.6H61.6c-3.6-22.3-11.1-43.8-22.4-63.6-2.5-4.4-2.2-9.8.9-13.9l24.2-32.2c2.6-3.5 7.3-4.6 11.2-2.6 43.1 21.6 94.2 19.6 135.5-5.2zM64 192h320v11c0 26.5 5 52.7 14.9 77.2l11.4 28.5c3.8 9.5 5.7 19.6 5.7 29.8 0 31.2-18.2 59.6-46.5 72.7L224 478.4 78.5 411.2C50.2 398.1 32 369.8 32 338.5c0-10.2 1.9-20.3 5.7-29.8l11.4-28.5C59 255.7 64 229.5 64 203v-11z"
        }
    ]
};

const FalRouteInterstate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRouteInterstate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M53.7 63.9C113 85.7 195.6 75.8 256 35.6c60.4 40.2 143 50.1 202.3 28.3 3.3 34.5 5.1 66.4 5.1 96.1H48.2c.2-29.8 2.2-61.8 5.5-96.1zm-5 128.1h414c-2.3 44.8-9.9 84.2-24.8 119.4-27.8 66-82.2 119.8-182.3 167.1-101.5-43.3-155.7-96.9-183-163.7-14.8-36.1-22-76.7-23.9-122.8zM270 6.4c-8.4-5.9-19.7-5.9-28.1 0C186.2 45.5 107.2 53 57.4 30.9 43.2 24.6 24.6 33 22.8 50.6 11.9 158.8 11.7 250.5 43 326.9c31.7 77.4 94.5 136.7 203.5 182.5 6.2 2.6 13.4 2.5 19.5-.4 106.7-49.8 169.3-109 201.4-185.2 31.8-75.4 32.7-165 21.8-273.2-1.8-17.6-20.4-26.1-34.6-19.7C404.8 53 325.8 45.5 270 6.4z"
        }
    ]
};

const FalRoute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRoute",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M452.1 164.2c-11.7 18.7-25 36.5-36.1 50.4-11.1-13.9-24.4-31.7-36.1-50.4-17.8-28.5-27.9-53-27.9-68.2 0-35.3 28.7-64 64-64s64 28.7 64 64c0 15.2-10.1 39.7-27.9 68.2zM427.4 251C452.9 221.1 512 146.2 512 96c0-53-43-96-96-96s-96 43-96 96c0 38.7 35 91.9 62.7 128H336c-44.2 0-80 35.8-80 80s35.8 80 80 80h96c26.5 0 48 21.5 48 48s-21.5 48-48 48H166c-9.4 12.3-18.6 23.2-26.4 32H432c44.2 0 80-35.8 80-80s-35.8-80-80-80h-96c-26.5 0-48-21.5-48-48s21.5-48 48-48h76.9c5.1 1.1 10.7-.6 14.5-5zM132.2 417.2c-11.7 17.8-25.1 34.5-36.2 47.4-11.1-12.9-24.5-29.6-36.2-47.4C41.9 390.3 32 367 32 352c0-35.3 28.7-64 64-64s64 28.7 64 64c0 15-9.9 38.3-27.8 65.2zm-7.6 63.1C152.9 446.7 192 392.8 192 352c0-53-43-96-96-96S0 299 0 352c0 50.5 59.8 121 85 148.4 6 6.5 16 6.5 21.9 0 1.6-1.7 3.3-3.6 5.1-5.6 1.8-2 3.8-4.2 5.8-6.6 2.2-2.5 4.4-5.1 6.7-7.9zM440 96a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM96 376a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalRouter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRouter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32c62.9 0 120.4 22.6 165 60.2 6.8 5.7 16.8 4.8 22.5-1.9s4.8-16.8-1.9-22.5C487.5 25.5 422.7 0 352 0S216.5 25.5 166.4 67.8c-6.8 5.7-7.6 15.8-1.9 22.5s15.8 7.6 22.5 1.9C231.6 54.6 289.1 32 352 32zm16 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-64c0-35.3-28.7-64-64-64H368v-80zM64 352h448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm40 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm42.2-251.4C277.9 141.7 313.3 128 352 128s74.1 13.7 101.8 36.6c6.8 5.6 16.9 4.7 22.5-2.1s4.7-16.9-2.1-22.5C441 112.5 398.4 96 352 96s-89 16.5-122.2 43.9c-6.8 5.6-7.8 15.7-2.1 22.5s15.7 7.8 22.5 2.1z"
        }
    ]
};

const FalRss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRss",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16c220.9 0 400 179.1 400 400 0 8.8 7.2 16 16 16s16-7.2 16-16C448 225.4 254.6 32 16 32zm0 144c-8.8 0-16 7.2-16 16s7.2 16 16 16c141.4 0 256 114.6 256 256 0 8.8 7.2 16 16 16s16-7.2 16-16c0-159.1-128.9-288-288-288zm16 240a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FalRubleSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRubleSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M104.7 32C82.2 32 64 50.2 64 72.7V288H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h208c8.8 0 16-7.2 16-16s-7.2-16-16-16H96v-64h144c79.5 0 144-64.5 144-144S319.5 32 240 32H104.7zM96 288V72.7c0-4.8 3.9-8.7 8.7-8.7H240c61.9 0 112 50.1 112 112s-50.1 112-112 112H96z"
        }
    ]
};

const FalRug = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRug",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16h16v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm48 32h64v320H64V96zm448 0h64v320h-64V96zm-32 0v320H160V96h320z"
        }
    ]
};

const FalRugbyBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRugbyBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 16h32c70.7 0 128 57.3 128 128v32c0 176.7-143.3 320-320 320h-32c-70.7 0-128-57.3-128-128v-32C16 159.3 159.3 16 336 16zm27.9 32H336c-77.3 0-147.5 30.4-199.2 80-3 2.9-5.9 5.8-8.8 8.8C78.4 188.5 48 258.7 48 336v31.9c3.5-10.8 8-22.1 13.5-33.6 23.1-48.3 64-104.5 117.2-157.6S288 82.6 336.3 59.5c9.4-4.5 18.7-8.3 27.6-11.5zM143.1 464H176c77.3 0 147.5-30.4 199.2-80 3-2.9 5.9-5.8 8.8-8.8 49.6-51.7 80-121.9 80-199.2v-28.8c-3.2 9.2-7.1 18.6-11.7 28.2-23.1 48.3-64 104.5-117.2 157.6s-109.3 94.2-157.6 117.2c-11.8 5.6-23.3 10.3-34.3 13.8zm-63.9-31.5c4.6 4.6 13.1 7.9 28.2 6.6 15-1.3 34.1-7.1 56.3-17.7 44.3-21.1 97.5-59.7 148.8-110.9S402.3 206 423.4 161.7c10.6-22.2 16.4-41.3 17.7-56.3 1.3-15.1-2-23.6-6.6-28.2s-13.1-7.9-28.2-6.6c-15 1.3-34.1 7.1-56.3 17.7-44.3 21.1-97.5 59.7-148.8 110.9S111.4 303.7 90.3 348c-10.5 22.3-16.3 41.4-17.6 56.4-1.3 15.1 2 23.6 6.6 28.2z"
        }
    ]
};

const FalRulerCombined = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRulerCombined",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 192v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v384c0 1.1.1 2.2.2 3.3C33.8 467.4 47.5 480 64 480h384c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32h-32v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm64 96h192c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64C30.9 512 3.6 486.8.3 454.5c-.2-2.2-.3-4.3-.3-6.5V64C0 28.7 28.7 0 64 0h96c35.3 0 64 28.7 64 64v224h32z"
        }
    ]
};

const FalRulerHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRulerHorizontal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 320c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32h-48v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64H64c-17.7 0-32 14.3-32 32v128zm32 64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v128c0 35.3-28.7 64-64 64H64z"
        }
    ]
};

const FalRulerTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRulerTriangle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 45.3V448c0 17.7 14.3 32 32 32h402.7c7.3 0 13.3-5.9 13.3-13.3 0-3.5-1.4-6.9-3.9-9.4l-39.4-39.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-57.4-57.4-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l25.4-25.4-39.5-39.4c-2.5-2.5-5.9-3.9-9.4-3.9C37.9 32 32 37.9 32 45.3zm45.3-32 421.4 421.4c8.5 8.5 13.3 20 13.3 32 0 25-20.3 45.3-45.3 45.3H64c-35.3 0-64-28.7-64-64V45.3C0 20.3 20.3 0 45.3 0c12 0 23.5 4.8 32 13.3zm44.6 228c6-2.5 12.9-1.1 17.4 3.5l128 128c4.6 4.6 5.9 11.5 3.5 17.4s-8.3 9.9-14.8 9.9H128c-8.8 0-16-7.2-16-16V256c0-6.5 3.9-12.3 9.9-14.8zm22.1 53.3V368h73.4L144 294.6z"
        }
    ]
};

const FalRulerVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRulerVertical",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c17.7 0 32 14.3 32 32v32h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalRuler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRuler",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M51.9 390.6c-12.5-12.5-12.5-32.8 0-45.3l39.4-39.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 41.4-41.4 41.4 41.4c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-41.4-41.4 39.4-39.4c12.5-12.5 32.8-12.5 45.3 0l69.5 69.5c12.5 12.5 12.5 32.8 0 45.3L166.6 460.1c-12.5 12.5-32.8 12.5-45.3 0l-69.4-69.5zm46.9 92.1c25 25 65.5 25 90.5 0l293.4-293.4c25-25 25-65.5 0-90.5l-69.4-69.5c-25-25-65.5-25-90.5 0L29.3 322.7c-25 25-25 65.5 0 90.5l69.5 69.5z"
        }
    ]
};

const FalRupeeSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRupeeSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-26.5 21.5-48 48-48h64c79.5 0 144 64.5 144 144 0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3l-57.1-149.8c-2.6.1-5.3.2-7.9.2H32v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V80zm32 208h80c61.9 0 112-50.1 112-112S173.9 64 112 64H48c-8.8 0-16 7.2-16 16v208zm264.8-27.6c-1.5 9.7-.4 16.5 1.8 21.6 2.2 5.1 5.9 9.7 11.5 14 12.1 9.2 29.9 15.2 51.4 22.6h.1c20 6.8 43.6 14.8 60.7 28.8 8.9 7.3 16.6 16.6 21.2 28.4 4.6 11.9 5.7 25.3 3.4 40.3-3.9 25.5-19 44-40.2 54.2-20.6 9.9-46.3 11.8-72.8 7.2h-.1c-9-1.6-20.6-5.5-31-9.3-7-2.5-14.2-5.3-20.2-7.6-3-1.2-5.8-2.2-8.1-3.1-8.3-3.1-12.5-12.3-9.4-20.6s12.3-12.5 20.6-9.4c2.7 1 5.7 2.2 8.8 3.4 5.8 2.2 12.3 4.7 19.1 7.2 10.5 3.8 19.8 6.8 25.9 7.9 22 3.9 40.4 1.7 53.3-4.5 12.3-5.9 20.2-15.7 22.5-30.3 1.6-10.6.6-18.2-1.6-23.9-2.2-5.7-6-10.7-11.6-15.2-11.8-9.7-29.5-16-50.8-23.3l-2.8-1c-19.2-6.5-41.4-14-57.7-26.5-9-6.8-16.8-15.6-21.6-27-4.8-11.5-6.1-24.4-3.9-38.9 3.7-23.9 19-42 39.7-52.6 20.5-10.4 46.3-13.6 73.3-8.8 7.7 1.4 31 6.4 39.4 8.9 8.5 2.5 13.3 11.4 10.7 19.9s-11.4 13.3-19.9 10.7c-6.7-2-28.7-6.8-35.8-8.1-21.4-3.8-40-.9-53.2 5.8-13 6.6-20.7 16.8-22.6 28.9z"
        }
    ]
};

const FalRupiahSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRupiahSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 80c0-26.5 21.5-48 48-48h64c79.5 0 144 64.5 144 144 0 65.6-43.9 121-103.9 138.3l54.8 144c3.1 8.3-1 17.5-9.3 20.6s-17.5-1-20.6-9.3l-57.1-149.8c-2.6.1-5.3.2-7.9.2H32v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V80zm32 208h80c61.9 0 112-50.1 112-112S173.9 64 112 64H48c-8.8 0-16 7.2-16 16v208zm288-80v144h80c44.2 0 80-35.8 80-80s-35.8-80-80-80h-64c-8.8 0-16 7.2-16 16zm16-48h64c61.9 0 112 50.1 112 112s-50.1 112-112 112h-80v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FalRv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalRv",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 24c0-13.3 10.7-24 24-24h112c13.3 0 24 10.7 24 24v8h112c61.9 0 112 50.1 112 112v8c0 22.1-17.9 40-40 40h-18.4l78.4 62.7c7.6 6.1 12 15.3 12 25V384c0 17.7-14.3 32-32 32h-33.6c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5.6-10.8 1.6-16H254.4c1 5.2 1.6 10.5 1.6 16 0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.2l-80.4-80.4C6.7 317.4 0 301.1 0 284.1V96c0-35.3 28.7-64 64-64h160v-8zM64 64c-17.7 0-32 14.3-32 32v188.1c0 8.5 3.4 16.6 9.4 22.6l73.6 73.6c14.6-17.3 36.5-28.3 61-28.3 26.2 0 49.4 12.6 64 32h144V176c0-8.8 7.2-16 16-16h168c4.4 0 8-3.6 8-8v-8c0-44.2-35.8-80-80-80H352V32h-96v32H64zm112 320a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm320 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm-64 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h48v-96H416v96h16zm-16-192v64h162.4l-80-64H416zm-288 32h160v-64H128v64zm-32-72c0-13.3 10.7-24 24-24h176c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24v-80z"
        }
    ]
};

const FalS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalS",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M83.4 75.8c-27.8 11.5-45.1 30.6-49.8 56.6-3.3 18.2-1.2 31.7 3.6 42.3 4.9 10.7 13.4 19.8 25.5 27.9 25 16.7 61.4 27 101.5 38 .6.2 1.1.3 1.7.5 38 10.5 79.3 21.8 109.1 41.8 15.5 10.4 28.7 23.6 36.8 41.1 8.1 17.5 10.3 37.9 6.1 61.3-7 39-33.3 65.8-69.1 80.6-35.3 14.5-80.2 17.7-127.9 10.5h-.1c-25-3.9-66.1-17.4-94.4-26.7-5.7-1.9-10.9-3.6-15.3-5C2.7 442-1.9 433 .7 424.6s11.7-13 20.1-10.4c5 1.6 10.7 3.5 16.8 5.5 28.5 9.3 65.9 21.6 88 25.1 44 6.6 82.6 3.2 110.9-8.4 27.8-11.5 45.1-30.6 49.8-56.6 3.3-18.2 1.2-31.7-3.6-42.3-4.9-10.7-13.4-19.8-25.5-27.9-25-16.7-61.4-27-101.5-38l-1.7-.5c-38-10.5-79.3-21.8-109.1-41.8-15.5-10.4-28.7-23.6-36.8-41.1-8-17.7-10.2-38-6-61.4 7-39 33.3-65.8 69.1-80.6 35.3-14.5 80.2-17.7 127.9-10.5 14.3 2.2 57.8 10.3 72.9 14.1 8.6 2.2 13.7 10.9 11.5 19.5S272.6 83 264 80.8c-13.6-3.5-55.9-11.4-69.7-13.5l2.4-15.8-2.4 15.8c-44-6.6-82.7-3.3-111 8.4z"
        }
    ]
};

const FalSackDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSackDollar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M201.5 144h109l5.3 3.4C370.6 182.5 480 268.3 480 416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64 0-147.7 109.4-233.5 164.3-268.6l5.3-3.4zm98.4-32h-87.8l-6.7-9.8L156.9 32h198.2l-48.4 70.2-6.7 9.8zm-147.3 26.5C91.2 183.7 0 273.4 0 416c0 53 43 96 96 96h320c53 0 96-43 96-96 0-142.6-91.2-232.3-152.6-277.5-9.7-7.1-18.6-13.2-26.4-18.1L351.2 94l38.9-56.4C401 21.7 389.6 0 370.3 0H141.7c-19.3 0-30.7 21.7-19.8 37.6L160.8 94l18.2 26.4c-7.7 4.9-16.7 11-26.4 18.1zM272 216c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7-13 7.7-23.9 21.1-23.8 40.5.1 18.4 10.8 30.1 22.7 37.3 10.5 6.3 23.8 10.4 34.8 13.7l1.6.5c12.5 3.8 22.2 6.9 29 11.2 5.9 3.7 7.7 7 7.7 11.6.1 6.6-2.7 10.8-7.8 14-5.8 3.6-14.5 5.6-23.7 5.3-11.8-.4-22.7-4.1-36.3-8.7-2.3-.8-4.7-1.6-7.1-2.4-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1 9.2 3.2 19.7 6.8 30.9 8.9V424c0 8.8 7.2 16 16 16s16-7.2 16-16v-17.1c8.7-1.4 17.4-4.3 25.1-9.1 13.3-8.3 23.2-22.2 22.9-41.6-.2-18.5-10.6-30.6-22.7-38.2-11-6.9-25-11.2-36.3-14.6l-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9-6-3.6-7.2-6.4-7.3-10.1 0-5.4 2.4-9.4 8.1-12.8 6.2-3.7 15.1-5.7 23.6-5.5 10.1.2 21 2.3 32.1 5.3 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V216z"
        }
    ]
};

const FalSackXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSackXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M310.5 144h-109l-5.3 3.4C141.4 182.5 32 268.3 32 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64 0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4zm-3.8-41.8L355.1 32H156.9l48.4 70.2 6.7 9.8h87.8l6.7-9.8zM0 416c0-142.6 91.2-232.3 152.6-277.5 9.7-7.1 18.6-13.2 26.4-18.1L160.8 94l-38.9-56.4C111 21.7 122.4 0 141.7 0h228.6c19.3 0 30.7 21.7 19.8 37.6L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96zm256-118.6 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L278.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7z"
        }
    ]
};

const FalSack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSack",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M310.5 144h-109l-5.3 3.4C141.4 182.5 32 268.3 32 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64 0-147.7-109.4-233.5-164.3-268.6l-5.3-3.4zm-3.8-41.8L355.1 32H156.9l48.4 70.2 6.7 9.8h87.8l6.7-9.8zM0 416c0-142.6 91.2-232.3 152.6-277.5 9.7-7.1 18.6-13.2 26.4-18.1L160.8 94l-38.9-56.4C111 21.7 122.4 0 141.7 0h228.6c19.3 0 30.7 21.7 19.8 37.6L351.2 94 333 120.4c7.7 4.9 16.7 11 26.4 18.1C420.8 183.7 512 273.4 512 416c0 53-43 96-96 96H96c-53 0-96-43-96-96z"
        }
    ]
};

const FalSailboat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSailboat",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M285.1 6.8c-4-5.7-11.3-8.2-17.9-6.1S256 9 256 16v320c0 8.8 7.2 16 16 16h224c6 0 11.4-3.3 14.2-8.6s2.3-11.7-1.1-16.6l-224-320zM288 320V66.8L465.3 320H288zM212.1 96.5c-7-1.9-14.4 1.2-18 7.5l-128 224c-2.8 5-2.8 11 .1 16s8.1 8 13.8 8h128c8.8 0 16-7.2 16-16V112c0-7.3-4.9-13.6-11.9-15.5zM107.6 320 192 172.2V320h-84.4zm-65.1 96h491c-13.5 38.1-49.6 64-90.5 64H133c-40.9 0-77-25.9-90.5-64zm-21.4-32c-10.6 0-18.3 10.1-15.4 20.3l4 14.3C25.3 473.9 75.6 512 133 512h310c57.3 0 107.7-38.1 123.2-93.3l4-14.3c2.9-10.2-4.8-20.3-15.4-20.3H21.1z"
        }
    ]
};

const FalSalad = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSalad",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241.1 32c37.1 0 68.9 22.7 82.3 55 2.8 6.6 9.6 10.6 16.7 9.7 3.9-.5 7.8-.7 11.8-.7 7.4 0 14.6.8 21.5 2.4C382.1 96.8 391 96 400 96c15.3 0 30 2.4 43.8 6.8C420.5 78.9 388 64 352 64c-1.3 0-2.7 0-4 .1C327.6 26 287.4 0 241.1 0c-46.3 0-86.5 26-106.9 64.1-2.1-.1-4.1-.1-6.2-.1C57.3 64 0 121.3 0 192c0 23.3 6.2 45.2 17.1 64h39.3C41.2 239 32 216.6 32 192c0-53 43-96 96-96 4.6 0 9.2.3 13.6 1 7.2 1 14.3-3 17-9.7C172 54.8 203.9 32 241.1 32zM400 160c44.2 0 80 35.8 80 80 0 5.5-.6 10.8-1.6 16h32.5c.7-5.2 1.1-10.6 1.1-16 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 5.4.4 10.8 1.1 16h32.5c-1-5.2-1.6-10.5-1.6-16 0-44.2 35.8-80 80-80zM129.3 457.1c-2.7-9-9.2-16.4-17.8-20.2C65.9 417 33.9 372.3 32.1 320h447.8c-1.8 52.3-33.9 97-79.4 116.9-8.6 3.8-15.2 11.2-17.8 20.2-4 13.3-16.2 22.9-30.7 22.9H160c-14.5 0-26.7-9.6-30.7-22.9zM27.4 288C12.3 288 0 300.3 0 315.4c0 67.4 40.6 125.4 98.6 150.8C106.5 492.7 131 512 160 512h192c29 0 53.5-19.3 61.4-45.7 58.1-25.4 98.6-83.4 98.6-150.8 0-15.1-12.3-27.4-27.4-27.4H27.4zM256 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V112zm-148.7 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80z"
        }
    ]
};

const FalSaltShaker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSaltShaker",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 453.2c0-1.6-.1-3.2-.4-4.7L305.8 192H78.2L32.4 448.5c-.3 1.6-.4 3.1-.4 4.7C32 468 44 480 58.8 480h266.4c14.8 0 26.8-12 26.8-26.8zM300.1 160l-7.9-44.1C283.5 67.3 241.3 32 192 32s-91.5 35.3-100.2 83.9L83.9 160h216.2zm25.1 352H58.8C26.3 512 0 485.7 0 453.2c0-3.5.3-6.9.9-10.3l59.4-332.6C71.7 46.5 127.2 0 192 0s120.3 46.5 131.7 110.3l59.4 332.6c.6 3.4.9 6.9.9 10.3 0 32.5-26.3 58.8-58.8 58.8zM176 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-32 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-72.1 146-24 192c-1.1 8.8-9.1 15-17.9 13.9s-15-9.1-13.9-17.9l24-192c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9zm112-4 24 192c1.1 8.8-5.1 16.8-13.9 17.9s-16.8-5.1-17.9-13.9l-24-192c-1.1-8.8 5.1-16.8 13.9-17.9s16.8 5.1 17.9 13.9z"
        }
    ]
};

const FalSandwich = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSandwich",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 96v64H32V96h448zM32 64C14.3 64 0 78.3 0 96v64c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H32zM0 352v64c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-88c-2.2 0-4.5.5-6.5 1.4L320 350.5l-65.5-29.1c-2-.9-4.3-1.4-6.5-1.4H32c-17.7 0-32 14.3-32 32zm244.6 0 68.9 30.6c4.1 1.8 8.9 1.8 13 0l68.9-30.6H480v64H32v-64h212.6zM16 288c10.5 0 20.9-2.6 30.5-5.8 8.5-2.9 17.2-6.6 25.6-10.1l3.2-1.3c19.3-8.2 36.4-14.8 52.7-14.8 20.4 0 36.7 6.7 56.6 14.8 19.5 8 42.2 17.2 71.4 17.2s51.8-9.2 71.4-17.2c19.9-8.1 36.2-14.8 56.6-14.8 16.3 0 33.4 6.6 52.8 14.7l3.2 1.3c8.3 3.5 17.1 7.2 25.6 10.1 9.6 3.2 20 5.8 30.5 5.8 8.8 0 16-7.2 16-16s-7.2-16-16-16c-5.5 0-12.1-1.4-20.3-4.2-7.3-2.5-14.9-5.7-23.4-9.3l-3.2-1.3c-18.6-7.7-41.5-17.1-65.2-17.1-26.8 0-48.2 8.8-67 16.5l-1.8.7c-19.6 8-37 14.8-59.3 14.8s-39.7-6.8-59.3-14.8l-1.8-.7c-18.8-7.7-40.2-16.5-67-16.5-23.7 0-46.6 9.4-65.2 17.3l-3.2 1.3c-8.5 3.6-16.1 6.8-23.4 9.3-7.9 2.7-14.5 4.1-20 4.1-8.8 0-16 7.2-16 16s7.2 16 16 16z"
        }
    ]
};

const FalSatelliteDish = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSatelliteDish",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 0c-8.8 0-16 7.2-16 16s7.2 16 16 16c150.2 0 272 121.8 272 272 0 8.8 7.2 16 16 16s16-7.2 16-16C512 136.1 375.9 0 208 0zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c97.2 0 176 78.8 176 176 0 8.8 7.2 16 16 16s16-7.2 16-16c0-114.9-93.1-208-208-208zM32 304c0-24.5 5-47.7 13.9-68.8l230.9 230.9C255.7 475 232.5 480 208 480c-97.2 0-176-78.8-176-176zm33.5-94.5c-14-14-37.3-12.1-45.7 5.8C7.1 242.2 0 272.3 0 304c0 114.9 93.1 208 208 208 31.7 0 61.8-7.1 88.7-19.8 17.9-8.4 19.8-31.8 5.8-45.7L195.3 339.3l24-24c6.3 3 13.3 4.7 20.7 4.7 26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48c0 7.4 1.7 14.4 4.7 20.7l-24 24L65.5 209.5zM224 272a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalSatellite = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSatellite",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m224 35.3 62.3 62.3-100.6 100.7-62.4-62.3L224 35.3zM309 75 241 7c-9.4-9.4-24.6-9.4-33.9 0L95 119c-9.4 9.4-9.4 24.6 0 33.9l47.6 47.6c-45.3-3.8-92 10.2-128.7 42.3-3.8 3.3-5.9 8-5.9 13v.5c0 4.9 1.9 9.6 5.4 13l103.3 103.4-16 16c-6.3-3-13.3-4.7-20.7-4.7-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48c0-7.4-1.7-14.4-4.7-20.7l16-16 103.3 103.3c3.5 3.5 8.1 5.4 13 5.4h.5c5 0 9.8-2.2 13-5.9 32.1-36.7 46.1-83.3 42.3-128.7L359 417c9.4 9.4 24.6 9.4 33.9 0L505 305c9.4-9.4 9.4-24.6 0-33.9l-68-68 26-26.1c10.9-10.9 17-25.6 17-41s-6.1-30.1-17-41l-46-46c-10.9-10.9-25.6-17-41-17s-30.1 6.1-41 17l-26 26zm105.3 150.7 62.4 62.3L376 388.7l-62.3-62.3 100.6-100.7zm26.1-71.3L292 302.8c-7.9-14.9-18.1-28.9-30.7-41.5l-10.6-10.6c-12.5-12.5-26.5-22.8-41.5-30.7L357.7 71.6c4.9-4.9 11.5-7.6 18.3-7.6s13.5 2.7 18.3 7.6l46.1 46.1c4.9 4.9 7.6 11.5 7.6 18.3s-2.7 13.5-7.6 18.3zM238.7 283.9c49 49 54.8 125.7 15.7 181.2L46.8 257.6c55.5-39.1 132.2-33.3 181.2 15.7l10.6 10.6zM80 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalSausage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSausage",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zM32 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64zm448-240c0 176.7-143.3 320-320 320-35.3 0-64-28.7-64-64s28.7-64 64-64c106 0 192-86 192-192 0-35.3 28.7-64 64-64s64 28.7 64 64zm32 0c0-53-43-96-96-96s-96 43-96 96c0 88.4-71.6 160-160 160-53 0-96 43-96 96s43 96 96 96c194.4 0 352-157.6 352-352zm-112 0c-8.8 0-16 7.2-16 16 0 114.9-93.1 208-208 208-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240-107.5 240-240 0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalSaxophoneFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSaxophoneFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 81.2c9.6-.1 18.7-4.5 24.7-12.1 1.5-1.9 2.9-3.6 4.3-5.4 10.7 12.6 20.2 27.2 27.6 41.5l25.2-13-25.2 13c10.7 20.6 15.8 39.8 15.8 48.5 0 13.6-2.8 26.5-8 38.3h34.1c3.8-12.1 5.9-25 5.9-38.3 0-16.1-7.7-40.7-19.3-63.2-11.8-22.8-28.5-46.8-48.3-64.9-4.3-4-11-4.1-15.5-.4-.2.1-.3.3-.5.4-7.7 7-14.9 15.7-21.2 23.6-7-8.4-14.2-16.4-21.6-24.2-7.3-7.6-14.9-15-22.8-22-2.2-2-5-3-7.8-3-2.9 0-5.7 1-8 3-26.6 23.7-49.1 50.7-65.1 76.6C10.2 105.2 0 132.6 0 153.7 0 167 2 179.9 5.8 192h34.1c-5.1-11.7-7.9-24.7-7.9-38.3 0-12.6 6.8-34.1 21.2-57.3C64.7 77.7 80.4 58 98.9 39.5c9.7 9.5 18.9 19.6 27.7 30.1 6.2 7.4 15.3 11.6 25 11.5zM200 192c10.6-21.7 10.2-48.4-1.8-70.6v-.1c-1.5-3.1-3.7-7.4-7-11.7-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-16.1 18.8-11.6-14.7c-12-15.2-24.4-31.1-26.1-33.2-3-3.8-7.6-6-12.4-6s-9.4 2.2-12.5 5.9c-11.9 14.7-21.7 27.2-28.4 38.7-6.9 11.9-11.2 23.7-11.2 37 0 13.7 2.9 26.1 8.3 36.8H97c-1.2-.9-2.3-1.8-3.3-2.7-8.2-7.6-13.7-18.8-13.7-34.2 0-5.9 1.7-12.1 6.8-20.8 3.2-5.5 7.5-11.6 13.1-18.9l13.5 17.2 16.3 20.8 5.3 6.8 1.5 1.9.4.5.1.1 12.6-9.9-12.6 9.8c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l12.7-14.8c3.8 16.7-2 34.1-15 43.6H200zM521.9 64c-20.8 0-40.8 8.1-55.7 22.6L221.1 324.3c-2.3 2.3-5.4 3.5-8.7 3.5-6.7 0-12.5-5.6-12.5-12.7 0-.9.1-1.9.3-2.8l12.6-56.3H224c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16 0 7.8 5.5 14.2 12.9 15.7L2.7 311.5C.9 321.5 0 331.7 0 341.9v7.6C0 439.2 72.8 512 162.6 512c48.8 0 94.9-21.9 125.8-59.6l234.4-286.5c3-3.7 7.6-5.9 12.4-5.9h77.5c15.1 0 27.3-12.2 27.3-27.3 0-7.2-2.9-14.2-8-19.3l-25.9-26c-15-15-35.4-23.4-56.6-23.4h-27.6zM45.4 256h134.7l-11 49.5c-.7 3.2-1.1 6.5-1.1 9.7 0 24.4 19.8 44.7 44.5 44.7 11.6 0 22.7-4.5 31-12.5l245-237.9c9-8.7 20.9-13.5 33.4-13.5h27.6c12.7 0 24.9 5.1 33.9 14.1l18 17.9h-66.2c-14.4 0-28 6.5-37.2 17.6L263.6 432.1c-24.8 30.3-61.9 47.9-101 47.9C90.5 480 32 421.5 32 349.4v-7.6c0-8.3.7-16.6 2.2-24.7L45.4 256zm74.6 96a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalSaxophone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSaxophone",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M521.9 32c-20.8 0-40.8 8.1-55.7 22.6L221.1 292.3c-2.3 2.3-5.4 3.5-8.7 3.5-6.9 0-12.5-5.6-12.5-12.5v-4.5c0-2.3.5-4.7 1.4-6.8l49-112.1H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h12.3L3.6 277.2c-2.4 11.4-3.6 23-3.6 34.6v5.6C0 407.2 72.8 480 162.6 480c48.8 0 94.9-21.9 125.8-59.6l234.4-286.5c3-3.7 7.6-5.9 12.4-5.9h77.5c15.1 0 27.3-12.2 27.3-27.3 0-7.2-2.9-14.2-8-19.3l-25.9-26c-15-15-35.4-23.4-56.6-23.4h-27.6zM61 160h154.5l-43.4 99.3c-2.7 6.2-4.1 12.9-4.1 19.6v4.5c0 24.6 19.9 44.5 44.5 44.5 11.6 0 22.7-4.5 31-12.5l245-237.9c9-8.7 20.9-13.5 33.4-13.5h27.6c12.7 0 24.9 5.1 33.9 14.1l18 17.9h-66.2c-14.4 0-28 6.5-37.2 17.6L263.6 400.1c-24.8 30.3-61.9 47.9-101 47.9C90.5 448 32 389.5 32 317.4v-5.6c0-9.4 1-18.8 2.9-28L61 160zm43 176a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40-104a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalScaleBalanced = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScaleBalanced",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c0 29.8-20.4 54.9-48 62v354h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h192V126c-27.6-7.1-48-32.2-48-62H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h152.6c11-19.1 31.7-32 55.4-32s44.4 12.9 55.4 32H512c8.8 0 16 7.2 16 16s-7.2 16-16 16H384zm56.7 298.3c17.1 12.8 42.2 21.7 71.3 21.7s54.2-8.9 71.3-21.7c17.1-12.8 24.7-28.1 24.7-42.3H416v-1.6 1.6c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 288h171.4L512 147.3zM384 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6v1.6c0 53-57.3 96-128 96s-128-43-128-96zm-352 0c0 14.2 7.6 29.5 24.7 42.3C73.8 375.1 98.9 384 128 384s54.2-8.9 71.3-21.7c17.1-12.8 24.7-28.1 24.7-42.3H32v-1.6 1.6zm10.3-32h171.4L128 147.3 42.3 288zM128 416C57.3 416 0 373 0 320v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6v1.6c0 53-57.3 96-128 96zM320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalScaleUnbalancedFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScaleUnbalancedFlip",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112.2 10.9c-2.8 8.4 1.7 17.4 10.1 20.2l134.2 44.8c4.6 24.4 23.1 43.9 46.9 50.1v354h-192c-8.8 0-16 7.2-16 16s7.2 16 16 16h208c8.8 0 16-7.2 16-16V126c10.3-2.6 19.6-7.8 27.2-14.7l143.8 47.9c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2L380.3 83.5c2-6.1 3-12.7 3-19.5 0-35.3-28.7-64-64-64-28 0-51.8 18-60.5 43L132.4.8C124-2 115 2.6 112.2 10.9zm87.1 319.3C182.2 343.1 157.1 352 128 352s-54.2-8.9-71.3-21.7C39.6 317.5 32 302.2 32 288h192v-1.6 1.6c0 14.2-7.6 29.5-24.7 42.3zM128 115.3 213.7 256H42.3L128 115.3zM256 288v-1.6c0-14.7-4-29.1-11.7-41.6l-92-151.2C147.2 85.2 137.9 80 128 80s-19.2 5.2-24.3 13.7l-92 151.2C4 257.4 0 271.8 0 286.4v1.6c0 53 57.3 96 128 96s128-43 128-96zm352 128c0 14.2-7.6 29.5-24.7 42.3-17.1 12.8-42.2 21.7-71.3 21.7s-54.2-8.9-71.3-21.7C423.6 445.5 416 430.2 416 416h192v-1.6 1.6zm-10.3-32H426.3L512 243.3 597.7 384zM512 512c70.7 0 128-43 128-96v-1.6c0-14.7-4-29.1-11.7-41.6l-92-151.2c-5.2-8.5-14.4-13.7-24.3-13.7s-19.2 5.2-24.3 13.7l-92 151.2c-7.7 12.6-11.7 27-11.7 41.6v1.6c0 53 57.3 96 128 96zM319.3 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FalScaleUnbalanced = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScaleUnbalanced",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M527.8 10.9c2.8 8.4-1.7 17.4-10.1 20.2L383.5 75.9c-4.6 24.4-23.1 43.9-46.9 50.1v354h192c8.8 0 16 7.2 16 16s-7.2 16-16 16h-208c-8.8 0-16-7.2-16-16V126c-10.3-2.6-19.6-7.8-27.2-14.7l-143.7 47.9c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l136.1-45.4c-2-6.1-3-12.7-3-19.5 0-35.3 28.7-64 64-64 28 0 51.8 18 60.5 43L507.6.8C516-2 525 2.6 527.8 10.9zm-87.1 319.4c17.1 12.8 42.2 21.7 71.3 21.7s54.2-8.9 71.3-21.7c17.1-12.8 24.7-28.1 24.7-42.3H416v-1.6 1.6c0 14.2 7.6 29.5 24.7 42.3zm71.3-215L426.3 256h171.4L512 115.3zM384 288v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2C492.8 85.2 502.1 80 512 80s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6v1.5c0 53-57.3 96-128 96s-128-43-128-96zM32 416c0 14.2 7.6 29.5 24.7 42.3C73.8 471.1 98.9 480 128 480s54.2-8.9 71.3-21.7c17.1-12.8 24.7-28.1 24.7-42.3H32v-1.6 1.6zm10.3-32h171.4L128 243.3 42.3 384zM128 512C57.3 512 0 469 0 416v-1.6c0-14.7 4-29.1 11.7-41.6l92-151.2c5.2-8.5 14.4-13.7 24.3-13.7s19.2 5.2 24.3 13.7l92 151.2c7.6 12.5 11.7 26.9 11.7 41.6v1.6c0 53-57.3 96-128 96zM320.7 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalScalpelLineDashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScalpelLineDashed",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M441.4 32c-11.4 0-22.2 5-29.5 13.7L234.4 256h98.2c4.7 0 9.2-2.1 12.2-5.7L470 102c6.5-7.7 10-17.4 10-27.5v-4c0-21.2-17.3-38.5-38.6-38.5zm-54-6.9C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1zM169.4 320h45.3l-155 154.9c29.2-5 68.3-14.1 106.2-29.7C227.3 419.9 279.2 380.5 287 320h32.2c-8 80.6-76 128-141.1 154.8C108.1 503.6 34 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L169.4 320zM304 480c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm64 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm128 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalScalpel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScalpel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200 288c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L387.4 25.1C400.8 9.2 420.6 0 441.4 0c39 0 70.6 31.6 70.6 70.6v4c0 17.6-6.2 34.6-17.6 48.1L369.3 271c-9.1 10.8-22.5 17-36.7 17H200zM411.9 45.7 234.4 256h98.2c4.7 0 9.2-2.1 12.2-5.7L470 102c6.5-7.7 10-17.4 10-27.5v-4c0-21.2-17.3-38.5-38.6-38.5-11.4 0-22.2 5-29.5 13.7zM4.7 484.7 169.4 320h45.3l-155 154.9c29.2-5 68.3-14.1 106.2-29.7C227.3 419.9 279.2 380.5 287 320h32.2c-8 80.6-76 128-141.1 154.8C108.1 503.6 34 512 16 512c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4z"
        }
    ]
};

const FalScannerGun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScannerGun",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 64c-44.2 0-80 35.8-80 80s35.8 80 80 80h192c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H112zM80 251.4C33.8 237.6 0 194.7 0 144 0 82.1 50.1 32 112 32h192c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48h-42.8L144.3 454.6c-13.4 22.8-42.9 30.5-65.7 17l-53.4-31.4C2.4 426.8-5.2 397.5 8.1 374.7L80 251.4zm34.3 4.6L35.7 390.8c-4.4 7.6-1.9 17.4 5.7 21.9l53.4 31.4c7.6 4.5 17.4 1.9 21.9-5.7L224.1 256H114.4zM432 32h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16zm16 80h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 80c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16zm16 48h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 144c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalScannerImage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScannerImage",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M55.2 33.7c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5L492.2 288H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-72.4c0-30.3-17.1-58-44.2-71.6L55.2 33.7zM544 352v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32zm-440 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalScannerKeyboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScannerKeyboard",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm192 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zm192 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96-16c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM288 128c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h224zM64 96c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 96h144c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h144c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40zm16 120c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm-16 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm-16 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalScannerTouchscreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScannerTouchscreen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm192 0v32c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zM208 0c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zm192 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16zm96-16c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16zM288 128c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h224zM64 96c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64zm40 96h144c4.4 0 8 3.6 8 8v208c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zm-40 8v208c0 22.1 17.9 40 40 40h144c22.1 0 40-17.9 40-40V200c0-22.1-17.9-40-40-40H104c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FalScarecrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScarecrow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 176a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 32c-36.8 0-69.2-19.1-87.7-48H61.9c4 7 2.3 15.9-4.3 20.8L42.7 192l14.9 11.2c6.5 4.9 8.3 13.8 4.3 20.8h62.6c20.2 0 35.3 18.5 31.4 38.3l-21.3 106.4 25.5-14.6c4.9-2.8 11-2.8 15.9 0l48 27.5 48.1-27.5c4.9-2.8 11-2.8 15.9 0l25.5 14.6-21.4-106.4c-4-19.8 11.2-38.3 31.4-38.3h62.6c-4-7-2.3-15.9 4.3-20.8l14.9-11.2-14.9-11.2c-6.5-4.9-8.3-13.8-4.3-20.8h-74.4c-18.5 28.9-50.8 48-87.7 48zm104-104c0 8.3-1 16.3-2.8 24H416c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4l-7.6 11.4 19.9 14.9c4 3 6.4 7.8 6.4 12.8s-2.4 9.8-6.4 12.8l-19.9 14.9 7.6 11.4c3.3 4.9 3.6 11.2.8 16.4s-8.2 8.5-14.1 8.5h-92.5l28.2 140.9c1.2 6.2-1.2 12.5-6.3 16.1s-11.8 4-17.3.9L280 386.4l-48.1 27.5c-4.9 2.8-11 2.8-15.9 0l-48-27.5-48.1 27.5c-5.4 3.1-12.2 2.8-17.3-.9s-7.6-10-6.3-16.1L124.5 256H32c-5.9 0-11.3-3.2-14.1-8.5s-2.5-11.5.8-16.4l7.6-11.4-19.9-14.9c-4-3-6.4-7.8-6.4-12.8s2.4-9.8 6.4-12.8l19.9-14.9-7.6-11.4c-3.3-4.9-3.6-11.2-.8-16.4S26.1 128 32 128h90.8c-1.8-7.7-2.8-15.7-2.8-24C120 46.6 166.6 0 224 0s104 46.6 104 104zM176 88a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-48 408v-50.7c10.3 3.7 21.7 3.7 32 0V496c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalScarf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScarf",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M221.4 32h69.1c17.3 0 33.3 9.4 41.8 24.5l41.5 73.8c6.6 11.8 10.1 25.1 10.1 38.6 0 20.9-8.3 40.9-23 55.6l-9 9L246.6 128H304c8.8 0 16-7.2 16-16s-7.2-16-16-16h-76.7c-21.4 0-32.1 25.9-17 41l130.4 130.3 44.7 44.7-73.4 73.4-161-161c-14.8-14.7-23-34.8-23-55.6 0-13.5 3.5-26.8 10.1-38.6l41.5-73.8c8.5-15 24.5-24.4 41.8-24.4zm153.2 224 9-9c20.8-20.8 32.4-48.9 32.4-78.2 0-19-4.9-37.7-14.2-54.2l-41.5-73.8C346.1 15.6 319.5 0 290.6 0h-69.2c-28.9 0-55.6 15.6-69.7 40.8l-41.5 73.8c-9.3 16.5-14.2 35.2-14.2 54.2 0 29.3 11.7 57.5 32.4 78.2l172.3 172.3 8 8 3.3 3.3 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L334.6 408l25.4-25.4 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L382.6 360l25.4-25.4 76.7 76.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L430.6 312l-3.3-3.3-8-8-44.7-44.7zM233.4 397.3l-22.6-22.6-110.1 110c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l110.1-110zm-48-48-22.6-22.6-110.1 110c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l110.1-110zm-48-48-22.6-22.6-110.1 110c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l110.1-110z"
        }
    ]
};

const FalSchoolCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSchoolCircleCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64v106.8c-9.1-12.9-19.9-24.5-32-34.6V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2l-135.1 90.1c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h192v-96c0-35.3 28.7-64 64-64 2.2 0 4.4.1 6.5.3-2.9 10.2-4.8 20.8-5.8 31.7h-.7c-17.7 0-32 14.3-32 32v96h72.2c10 12.1 21.7 22.9 34.6 32H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h107.2l140-93.3zM416 192c0 7-.7 13.8-2.2 20.3-31.3 16.5-57 42.2-73.5 73.5-6.5 1.4-13.3 2.2-20.3 2.2-53 0-96-43-96-96s43-96 96-96 96 43 96 96zm-288-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm0 32v64h32v-64h-32zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64zm64 0h-32v64h32v-64zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm160 320a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalSchoolCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSchoolCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64v106.8c-9.1-12.9-19.9-24.5-32-34.6V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2l-135.1 90.1c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h192v-96c0-35.3 28.7-64 64-64 2.2 0 4.4.1 6.5.3-2.9 10.2-4.8 20.8-5.8 31.7h-.7c-17.7 0-32 14.3-32 32v96h72.2c10 12.1 21.7 22.9 34.6 32H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h107.2l140-93.3zM416 192c0 7-.7 13.8-2.2 20.3-31.3 16.5-57 42.2-73.5 73.5-6.5 1.4-13.3 2.2-20.3 2.2-53 0-96-43-96-96s43-96 96-96 96 43 96 96zm-288-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm0 32v64h32v-64h-32zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64zm64 0h-32v64h32v-64zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm272 208a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm144 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0-112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalSchoolCircleXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSchoolCircleXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64v106.8c-9.1-12.9-19.9-24.5-32-34.6V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2l-135.1 90.1c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h192v-96c0-35.3 28.7-64 64-64 2.2 0 4.4.1 6.5.3-2.9 10.2-4.8 20.8-5.8 31.7h-.7c-17.7 0-32 14.3-32 32v96h72.2c10 12.1 21.7 22.9 34.6 32H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h107.2l140-93.3zM416 192c0 7-.7 13.8-2.2 20.3-31.3 16.5-57 42.2-73.5 73.5-6.5 1.4-13.3 2.2-20.3 2.2-53 0-96-43-96-96s43-96 96-96 96 43 96 96zm-288-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm0 32v64h32v-64h-32zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64zm64 0h-32v64h32v-64zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm16-96v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm272 208a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm166.6 0 36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L496 390.6l-36.7 36.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l36.7-36.7-36.7-36.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l36.7 36.7 36.7-36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L518.6 368z"
        }
    ]
};

const FalSchoolFlag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSchoolFlag",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 64h80V32h-80v32zm-32-48c0-8.8 7.2-16 16-16h112c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-84.5l89.6 64H512c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h106.9L272 87.8V16zm48 400c0-17.7-14.3-32-32-32s-32 14.3-32 32v64h64v-64zm32 64h160c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H400c-3.3 0-6.6-1-9.3-3L288 115.7 185.3 189c-2.7 1.9-6 3-9.3 3H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h160v-64c0-35.3 28.7-64 64-64s64 28.7 64 64v64zm-96-240a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm32 64a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM64 256c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-32zm64 0H96v32h32v-32zm320-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32zm0 32v32h32v-32h-32zM64 384c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-32zm64 0H96v32h32v-32zm320-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32zm0 32v32h32v-32h-32z"
        }
    ]
};

const FalSchoolLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSchoolLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M311.1 2.7c5.4-3.6 12.4-3.6 17.8 0L468.8 96H576c35.3 0 64 28.7 64 64v112c0-30.5-12.2-58.2-32-78.4V160c0-17.7-14.3-32-32-32H464c-3.2 0-6.2-.9-8.9-2.7L320 35.2l-135.1 90.1c-2.6 1.8-5.7 2.7-8.9 2.7H64c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h192v-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96c0 11.7 3.1 22.6 8.6 32H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h107.2l140-93.3zM352 384c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64v-96zM128 160h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32zm0 32v64h32v-64h-32zM96 352c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-64zm64 0h-32v64h32v-64zm160-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm16 64v16h8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-24c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 64c-26.5 0-48 21.5-48 48v48h96v-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48zm160 80H448v128h160V352z"
        }
    ]
};

const FalSchool = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSchool",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328.9 2.7c-5.4-3.6-12.4-3.6-17.8 0L171.2 96H64c-35.3 0-64 28.7-64 64v288c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H468.8L328.9 2.7zM384 384c0-35.3-28.7-64-64-64s-64 28.7-64 64v96H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h112c3.2 0 6.2-.9 8.9-2.7L320 35.2l135.1 90.1c2.6 1.8 5.7 2.7 8.9 2.7h112c17.7 0 32 14.3 32 32v288c0 17.7-14.3 32-32 32H384v-96zm-32 96h-64v-96c0-17.7 14.3-32 32-32s32 14.3 32 32v96zM96 192v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v64h-32v-64h32zm320-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-32zm0 32h32v64h-32v-64zM96 352v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-32c-17.7 0-32 14.3-32 32zm64 0v64h-32v-64h32zm320-32c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32h-32zm0 32h32v64h-32v-64zM320 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm16-128c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-8v-16z"
        }
    ]
};

const FalScissors = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScissors",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M508.2 442.4c5.7-6.7 4.9-16.8-1.8-22.6l-152-129.3c-6.7-5.7-16.8-4.9-22.6 1.8s-4.9 16.8 1.8 22.6l152 129.3c6.7 5.7 16.8 4.9 22.6-1.8zM287 235.1 208.5 169c9.9-16.7 15.5-36.2 15.5-56.9C224 50.1 173.9 0 112 0S0 50.1 0 112s50.1 112 112 112c29.5 0 56.4-11.4 76.4-30.1l73.8 62.1-73.8 62.1c-20-18.7-46.9-30.1-76.4-30.1C50.1 288 0 338.1 0 400s50.1 112 112 112 112-50.1 112-112c0-20.8-5.7-40.3-15.5-56.9L506.3 92.2c6.8-5.7 7.6-15.8 1.9-22.5s-15.8-7.6-22.5-1.9L287 235.1zM112 192a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm0 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FalScreenUsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScreenUsers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 32H96c-17.7 0-32 14.3-32 32v165.5c-11.9 4.2-22.8 10.7-32 19V64C32 28.7 60.7 0 96 0h448c35.3 0 64 28.7 64 64v184.4c-9.2-8.3-20.1-14.8-32-19V64c0-17.7-14.3-32-32-32zM96 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm224 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM32 480v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm256-32c-17.7 0-32 14.3-32 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-17.7-14.3-32-32-32h-64zm192 32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalScreencast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScreencast",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64H64c-17.7 0-32 14.3-32 32v96.1c-2.7-.1-5.3-.1-8-.1H0V96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H288v-24c0-2.7 0-5.3-.1-8H512c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM16 224c132.5 0 240 107.5 240 240 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-114.9-93.1-208-208-208-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 192a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM0 336c0-8.8 7.2-16 16-16 79.5 0 144 64.5 144 144 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9-50.1-112-112-112-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalScrewdriverWrench = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScrewdriverWrench",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m64.7 34.6 95.3 73.3V160h-52.1L34.6 64.7l30.1-30.1zM192 169.3V104c0-7.5-3.5-14.5-9.4-19L78.6 5c-9.5-7.4-23-6.5-31.6 2L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4h65.3l102 101.9c-19.5 30-16.2 70.5 10.1 96.8l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-26.3-26.3-66.8-29.7-96.8-10.1L192 169.3zM304 304c17.7-17.7 46.3-17.7 64 0l112 112-64 64-112-112c-17.7-17.7-17.7-46.3 0-64zM104 424a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-80.8-47.2a79.09 79.09 0 0 0-23.2 56C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2l103.3-103.3c-5.7-11.2-9.3-23.1-10.9-35.3L112.1 465.7c-8.7 8.7-20.6 13.6-32.9 13.6-25.7 0-46.6-20.8-46.6-46.6 0-12.3 4.9-24.2 13.6-32.9L189.1 257 166 233.9 23.2 376.8zM479.4 160c0 44.8-23.1 84.1-58 106.8l23.5 23.5c40.7-29 67.2-76.6 67.2-130.3 0-24.8-5.7-48.3-15.7-69.3-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7H368c-8.8 0-16-7.2-16-16v-25.4c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0c-55.9 0-105.1 28.6-133.7 72.1l26 20c22.5-35.8 62.4-59.5 107.7-59.5 10.3 0 20.2 1.2 29.7 3.5l-48.1 48.1c-9.1 9.1-14.2 21.5-14.2 34.4V144c0 26.9 21.8 48.6 48.6 48.6h25.4c12.9 0 25.3-5.1 34.4-14.2l48.1-48.1c2.3 9.5 3.5 19.5 3.5 29.7z"
        }
    ]
};

const FalScrewdriver = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScrewdriver",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m447.3 34.6 30.1 30.1-73.3 95.3H352v-52.1l95.3-73.3zM342.7 192H408c7.5 0 14.5-3.5 19-9.4l80-104c7.4-9.6 6.5-23.1-2.1-31.6L465 7c-8.5-8.5-22-9.4-31.6-2.1l-104 80c-5.9 4.5-9.4 11.6-9.4 19v65.3l-78.9 78.9c4.2 3.2 8.3 6.6 12.1 10.5s7.3 7.9 10.5 12.1l79-78.7zM208 304c17.7 17.7 17.7 46.3 0 64L96 480l-64-64 112-112c17.7-17.7 46.3-17.7 64 0zm-86.6-22.6-112 112c-12.5 12.5-12.5 32.8 0 45.3l64 64c12.5 12.5 32.8 12.5 45.3 0l112-112c30.2-30.2 30.2-79.1 0-109.3s-79.1-30.2-109.3 0z"
        }
    ]
};

const FalScribble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScribble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M196.6 19.5C210.2 7 228 0 246.5 0h.9C287.5 0 320 32.5 320 72.6c0 19.2-7.6 37.7-21.3 51.3L75.9 346.7c-7.6 7.7-11.9 18-11.9 28.7 0 22.4 18.2 40.6 40.6 40.6 10.8 0 21.1-4.3 28.7-11.9l254.8-254.8c13.6-13.6 32.1-21.3 51.3-21.3 40.1 0 72.6 32.5 72.6 72.6 0 19.2-7.6 37.7-21.3 51.3L370.5 372.1c-11.8 11.8-18.5 28-18.5 44.8 0 34.8 28.2 63.1 63 63.1 8.7 0 17.3-2 25.1-5.9l48.8-24.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48.8 24.4a88.46 88.46 0 0 1-39.4 9.3c-52.5 0-95-42.7-95-95.1 0-25.2 10-49.5 27.9-67.4l120.2-120.3c7.6-7.6 11.9-17.9 11.9-28.7 0-22.4-18.2-40.6-40.6-40.6-10.8 0-21.1 4.3-28.7 11.9L155.9 426.7c-13.6 13.6-32.1 21.3-51.3 21.3-40.1 0-72.6-32.5-72.6-72.6 0-19.2 7.6-37.7 21.3-51.3l222.8-222.8c7.6-7.6 11.9-17.9 11.9-28.7 0-22.4-18.2-40.6-40.6-40.6h-.9c-10.4 0-20.5 3.9-28.2 11L26.9 219.8c-6.5 6-16.6 5.6-22.6-.9s-5.6-16.6.9-22.6L196.6 19.5z"
        }
    ]
};

const FalScrollOld = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScrollOld",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 64c-26.5 0-48 21.5-48 48v72c0 4.4 3.6 8 8 8h56v32H40c-22.1 0-40-17.9-40-40v-72c0-44.2 35.8-80 80-80h320c44.2 0 80 35.8 80 80v176h-32v-32h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-64h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-16c0-26.5-21.5-48-48-48H144c10 13.4 16 30 16 48v112h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v144c0 26.5 21.5 48 48 48s48-21.5 48-48v-48c0-22.1 18-40 40-40h234.8c22.1 0 40 17.9 40 40v56c0 39.8-32.2 72-72 72H208c-44.2 0-80-35.8-80-80V112c0-26.5-21.5-48-48-48zm192 384h232c22.1 0 40-17.9 40-40v-56c0-4.4-3.6-8-8-8H400v40c0 8.8-7.2 16-16 16s-16-7.2-16-16v-40h-72c-4.4 0-8 3.6-8 8v48c0 18-6 34.6-16 48z"
        }
    ]
};

const FalScrollTorah = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScrollTorah",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 448V64c0-17.7-14.3-32-32-32S32 46.3 32 64v384c0 17.7 14.3 32 32 32s32-14.3 32-32zM64 0c23.7 0 44.4 12.9 55.4 32h401.2c11-19.1 31.7-32 55.4-32 35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0zm512 480c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v384c0 17.7 14.3 32 32 32zm-64-32V64H128v384h384zM172 322.9c0-4.1 1.1-8.2 3.2-11.8l32.3-55-32.3-55c-2.1-3.6-3.2-7.6-3.2-11.8 0-12.9 10.4-23.3 23.3-23.3h65l36-61.3c4.6-7.9 13.1-12.7 22.2-12.7s17.6 4.8 22.2 12.7l36 61.3h65c12.9 0 23.3 10.4 23.3 23.3 0 4.1-1.1 8.2-3.2 11.8l-32.3 55 32.3 55c2.1 3.6 3.2 7.6 3.2 11.8 0 12.9-10.4 23.3-23.3 23.3h-65l-36 61.3c-4.6 7.9-13.1 12.7-22.2 12.7s-17.6-4.8-22.2-12.7l-36-61.3h-65c-12.9 0-23.3-10.4-23.3-23.3zm146.5 59.2 21.1-35.9h-42.2l21.1 35.9zm-39.9-67.9h79.7l34.1-58-34.1-58h-79.7l-34.1 58 34.1 58zm147.9 0L411 287.7l-15.5 26.4h31zm0-116.1h-31l15.5 26.4 15.5-26.5zm-108-67.9L297.4 166h42.2l-21.1-35.9zM226 224.5l15.5-26.5h-31l15.5 26.5zm15.5 89.7L226 287.7l-15.5 26.4h31z"
        }
    ]
};

const FalScroll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScroll",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 112c0-26.5 21.5-48 48-48s48 21.5 48 48v288c0 44.2 35.8 80 80 80h296c39.8 0 72-32.2 72-72v-56c0-22.1-18-40-40-40H296c-22.1 0-40 17.9-40 40v48c0 26.5-21.5 48-48 48s-48-21.5-48-48V112c0-18-6-34.6-16-48h256c26.5 0 48 21.5 48 48v176h32V112c0-44.2-35.8-80-80-80H80C35.8 32 0 67.8 0 112v72c0 22.1 17.9 40 40 40h56v-32H40c-4.4 0-8-3.6-8-8v-72zm472 336H272c10-13.4 16-30 16-48v-48c0-4.4 3.6-8 8-8h234.8c4.4 0 8 3.6 8 8v56c0 22.1-17.9 40-40 40z"
        }
    ]
};

const FalScrubber = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScrubber",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm320 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0z"
        }
    ]
};

const FalScythe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalScythe",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M639.7 19.1c1.7-8.7-3.9-17.1-12.6-18.8S610 4.2 608.3 12.9L550.1 304H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h143.7l-31.4 156.9c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l96-480zM352 0C121.4 0 20.6 155.8 2.9 186.7c-2 3.5-2.9 7.4-2.9 11.4C0 212.4 11.6 224 25.9 224h507.5l6.4-32H37.2C64.7 149.7 158.7 32 352 32h219.8l5.1-25.4c.5-2.3 1.1-4.5 1.8-6.6H352z"
        }
    ]
};

const FalSdCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSdCard",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 64v384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V154.5c0-8.5 3.4-16.6 9.4-22.6l90.5-90.5c6-6 14.1-9.4 22.6-9.4H320c17.7 0 32 14.3 32 32zm32 384V64c0-35.3-28.7-64-64-64H154.5c-17 0-33.3 6.7-45.3 18.7l-90.5 90.6C6.7 121.3 0 137.5 0 154.5V448c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64zM192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80z"
        }
    ]
};

const FalSdCards = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSdCards",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 368c0 17.7-14.3 32-32 32H144c-17.7 0-32-14.3-32-32V154.5c0-8.5 3.4-16.6 9.4-22.6l90.5-90.5c6-6 14.1-9.4 22.6-9.4H384c17.7 0 32 14.3 32 32v304zm32-304c0-35.3-28.7-64-64-64H234.5c-17 0-33.3 6.7-45.3 18.7l-90.5 90.6c-12 12-18.7 28.3-18.7 45.3V368c0 35.3 28.7 64 64 64h240c35.3 0 64-28.7 64-64V64zm-208 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8-7.2-16-16-16zM32 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v272c0 70.7 57.3 128 128 128h240c8.8 0 16-7.2 16-16s-7.2-16-16-16H128c-53 0-96-43-96-96V112z"
        }
    ]
};

const FalSealExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSealExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 96c8.5 0 16.6-3.4 22.6-9.4l46.1-46.1c6.2-6.2 16.4-6.2 22.6 0l46.1 46.1c6 6 14.1 9.4 22.6 9.4h64c8.8 0 16 7.2 16 16v64c0 8.5 3.4 16.6 9.4 22.6l45.6 45.6c6.2 6.2 6.2 16.4 0 22.6l-45.6 45.6c-6 6-9.4 14.1-9.4 22.6v65c0 8.8-7.2 16-16 16h-64.9c-8.5 0-16.6 3.4-22.6 9.4l-45.1 45.1c-6.2 6.2-16.4 6.2-22.6 0l-45.1-45.1c-6-6-14.1-9.4-22.6-9.4H112c-8.8 0-16-7.2-16-16v-64.9c0-8.5-3.4-16.6-9.4-22.6L41 266.8l-22.6 22.7L41 266.8c-6.2-6.2-6.2-16.4 0-22.6l45.6-45.6c6-6 9.4-14.1 9.4-22.6v-64c0-8.8 7.2-16 16-16h64zM18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0l45.2-45.1H400c26.5 0 48-21.5 48-48v-64.9l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176v-64c0-26.5-21.5-48-48-48h-64l-46.1-46.1C271.2-.8 240.8-.8 222 17.9L176 64h-64c-26.5 0-48 21.5-48 48v64l-45.6 45.6zM240 144v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16zm40 208a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalSealQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSealQuestion",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 96c8.5 0 16.6-3.4 22.6-9.4l46.1-46.1c6.2-6.2 16.4-6.2 22.6 0l46.1 46.1c6 6 14.1 9.4 22.6 9.4h64c8.8 0 16 7.2 16 16v64c0 8.5 3.4 16.6 9.4 22.6l45.6 45.6c6.2 6.2 6.2 16.4 0 22.6l-45.6 45.6c-6 6-9.4 14.1-9.4 22.6v65c0 8.8-7.2 16-16 16h-64.9c-8.5 0-16.6 3.4-22.6 9.4l-45.1 45.1c-6.2 6.2-16.4 6.2-22.6 0l-45.1-45.1c-6-6-14.1-9.4-22.6-9.4H112c-8.8 0-16-7.2-16-16v-64.9c0-8.5-3.4-16.6-9.4-22.6L41 266.8l-22.6 22.7L41 266.8c-6.2-6.2-6.2-16.4 0-22.6l45.6-45.6c6-6 9.4-14.1 9.4-22.6v-64c0-8.8 7.2-16 16-16h64zM18.4 221.6c-18.7 18.7-18.7 49.1 0 67.9L64 335.1V400c0 26.5 21.5 48 48 48h64.9l45.1 45.1c18.7 18.7 49.1 18.7 67.9 0l45.2-45.1H400c26.5 0 48-21.5 48-48v-64.9l45.6-45.6c18.7-18.7 18.7-49.1 0-67.9L448 176v-64c0-26.5-21.5-48-48-48h-64l-46.1-46.1C271.2-.8 240.8-.8 222 17.9L176 64h-64c-26.5 0-48 21.5-48 48v64l-45.6 45.6zm150.3-51.8-.2.7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3 0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V288c0 8.8 7.2 16 16 16s16-7.2 16-16v-19.7l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2 0-35.2-28.5-64.3-64-64.3h-57.1c-25.5 0-47.7 17.2-54.2 41.8zM280 352a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalSeal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSeal",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M199.1 86.6c-6 6-14.1 9.4-22.6 9.4H112c-8.8 0-16 7.2-16 16v64.5c0 8.5-3.4 16.6-9.4 22.6L41 244.7c-6.2 6.2-6.2 16.4 0 22.6l-22.6 22.6c-18.7-18.7-18.7-49.1 0-67.9L64 176.5V112c0-26.5 21.5-48 48-48h64.5l45.6-45.6c18.7-18.7 49.1-18.7 67.9 0L335.5 64H400c26.5 0 48 21.5 48 48v64.5l45.6 45.6c18.7 18.7 18.7 49.1 0 67.9L448 335.5V400c0 26.5-21.5 48-48 48h-64.5l-45.6 45.6c-18.7 18.7-49.1 18.7-67.9 0L176.5 448H112c-26.5 0-48-21.5-48-48v-64.5l-45.6-45.6L41 267.3l45.6 45.6c6 6 9.4 14.1 9.4 22.6V400c0 8.8 7.2 16 16 16h64.5c8.5 0 16.6 3.4 22.6 9.4l45.6 45.6c6.2 6.2 16.4 6.2 22.6 0l45.6-45.6c6-6 14.1-9.4 22.6-9.4H400c8.8 0 16-7.2 16-16v-64.5c0-8.5 3.4-16.6 9.4-22.6l45.6-45.6c6.2-6.2 6.2-16.4 0-22.6l-45.6-45.6c-6-6-9.4-14.1-9.4-22.6V112c0-8.8-7.2-16-16-16h-64.5c-8.5 0-16.6-3.4-22.6-9.4L267.3 41c-6.2-6.2-16.4-6.2-22.6 0l-45.6 45.6z"
        }
    ]
};

const FalSeatAirline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSeatAirline",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16v126.3c0 14 3.1 27.9 9 40.6l87.3 187c13.1 28.1 41.4 46.1 72.5 46.1H224v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h256c8.8 0 16-7.2 16-16s-7.2-16-16-16H256v-64h102.2c27 0 51.2-17 60.3-42.5l28.6-80.1c1.8-4.9 1-10.3-2-14.6s-7.9-6.8-13.1-6.8H85.9l-22.4-48H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H48.6L38 169.3c-4-8.5-6-17.7-6-27.1V16zm208 368h-71.2c-18.6 0-35.6-10.8-43.5-27.7L100.9 304h308.4l-21 58.8c-4.6 12.7-16.6 21.2-30.1 21.2H240z"
        }
    ]
};

const FalSection = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSection",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32.5 84.7c3.6-20.1 16.3-34.6 36.9-43.4 21.2-9.1 50.6-11.9 84.4-6.6 10.7 1.7 43.5 8.1 54 10.9 8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-12-3.2-46-9.8-57.3-11.6-37.8-6-73.7-3.4-102.1 8.8C27.8 24.3 6.5 47 .9 79.7c0 .3-.1.6-.1.8-2.2 19 .4 35.7 7.6 50 7.1 14.2 18.1 25 30.7 33.6 4.6 3.1 9.6 6 14.7 8.7-26.7 12-46.7 33-52.1 63.1-.1.3-.1.6-.1.9-2.3 18.3.4 34.3 7.8 48.1 7.2 13.6 18.3 23.9 30.8 32 23.3 15 54.8 24 83.1 32.1l3.3.9c30.8 8.8 57.7 16.8 75.9 29.5 8.7 6.1 14.6 12.7 18 20.3 3.3 7.5 4.8 17.2 2.3 30.6-3.4 18.5-15.7 32.3-36.5 40.8-21.3 8.7-50.7 11.3-84.4 6.3-16.9-2.6-45.6-11.9-67.8-19.1-4.8-1.5-9.2-3-13.2-4.3-8.4-2.7-17.4 2-20.1 10.4s2 17.4 10.4 20.1c3.4 1.1 7.4 2.4 11.8 3.8 21.9 7.2 54.2 17.7 74 20.8h.1c37.5 5.6 73.1 3.2 101.3-8.3 28.6-11.7 50.2-33.2 55.9-64.7 3.4-18.6 1.8-35-4.6-49.4-6.3-14.3-16.8-25.1-28.9-33.6-1.7-1.2-3.5-2.4-5.4-3.5 20-13.1 34.4-32.5 38.9-58.7 3.3-19.4 1.8-36.4-4.5-51.3-6.2-14.8-16.6-26.2-28.8-35.2-23.6-17.4-56.4-27.3-85.9-36.1l-.5-.1c-30.8-9.3-58.3-17.5-77.6-30.6-9.4-6.3-16-13.4-20.1-21.4-4-7.9-6-17.9-4.5-31.5zM178 332.3c-14.1-5.1-28.8-9.3-42.7-13.2l-.5-.1c-30.7-8.7-58.1-16.6-77.4-29-9.3-6-15.9-12.6-19.8-20-3.8-7.2-5.8-16.3-4.3-28.8 3.5-18.3 15.8-32 36.4-40.4 10.1-4.1 22-6.9 35.4-8.1 5.9 1.8 11.8 3.6 17.5 5.3l3.3 1c30.9 9.3 57.9 17.8 76.1 31.2 8.7 6.4 14.8 13.5 18.3 21.8 3.5 8.2 4.9 18.9 2.5 33.4-3.8 22.2-19.1 38.5-44.8 46.8z"
        }
    ]
};

const FalSeedling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSeedling",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 32c0 95.3-69.4 174.4-160.5 189.4 2.7 10.2 4.7 20.7 6.1 31.4C431.4 234.9 512 142.9 512 32c0-17.7-14.3-32-32-32h-32c-81 0-152 43-191.4 107.5 7.8 8.3 15.1 17.2 21.8 26.4C310.7 73.3 374.5 32 448 32h32zM64 96c106 0 192 86 192 192h-32C118 288 32 202 32 96h32zM32 64C14.3 64 0 78.3 0 96c0 123.7 100.3 224 224 224h32v176c0 8.8 7.2 16 16 16s16-7.2 16-16V288C288 164.3 187.7 64 64 64H32z"
        }
    ]
};

const FalSemicolon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSemicolon",
    "viewBox": "0 0 192 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-32 222.4c0 5.6-1.5 11.1-4.5 15.9L55.4 477.9c-.8 1.3-2.3 2.1-3.8 2.1-2.8 0-4.9-2.5-4.4-5.2l23.3-130.9C73 330.1 85 320 99 320c16 0 29 13 29 29v1.5zm32 0V349c0-33.7-27.3-61-61-61-29.5 0-54.8 21.2-60 50.2L15.7 469.1c-4 22.3 13.2 42.9 35.9 42.9 12.7 0 24.5-6.6 31.1-17.4L150.8 383c6-9.8 9.2-21.1 9.2-32.6z"
        }
    ]
};

const FalSendBack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSendBack",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h128zM64 0C28.7 0 0 28.7 0 64v128c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm512 288c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V320c0-17.7 14.3-32 32-32h128zm-128-32c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H448zm-288 32v64c0 35.3 28.7 64 64 64h128v-32H224c-17.7 0-32-14.3-32-32v-64h-32zM416 96H288v32h128c17.7 0 32 14.3 32 32v64h32v-64c0-35.3-28.7-64-64-64zm-264 0c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48zm384 288h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40z"
        }
    ]
};

const FalSendBackward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSendBackward",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h224c17.7 0 32 14.3 32 32v64h32V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v224c0 35.3 28.7 64 64 64h64v-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32zm224 64c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h32v-32H96V96h160v32h32V96zm-64 96h224c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32zm-64 32v224c0 35.3 28.7 64 64 64h224c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64H224c-35.3 0-64 28.7-64 64z"
        }
    ]
};

const FalSensorCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSensorCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h320c17.7 0 32 14.3 32 32v129c11.2 1.4 21.9 4.2 32 8.3V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h173.8c-5.2-9.9-9.1-20.7-11.4-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm144 208c0-35.3 28.7-64 64-64 24.4 0 45.7 13.7 56.5 33.9 2.5 4.6 7 7.7 12.1 8.3s10.3-1.3 13.8-5.1c7.4-8.1 17.9-13.1 29.6-13.1 22.1 0 40 17.9 40 40v1.3c-.2 7.7 5 14.4 12.5 16.1 24.9 5.7 43.6 28 43.6 54.6 0 30.9-25.1 56-56 56H344c-30.9 0-56-25.1-56-56 0-24.4 15.6-45.2 37.4-52.8 6.7-2.4 11-8.8 10.7-15.9-.1-1.1-.1-2.2-.1-3.3zm64-96c-50.8 0-92.4 39.5-95.8 89.5C275.6 360 256 389.7 256 424c0 48.6 39.4 88 88 88h208c48.6 0 88-39.4 88-88 0-37.6-23.6-69.7-56.7-82.3-5-34.9-35-61.7-71.3-61.7-13.9 0-27 4-38 10.8-17.6-21.3-44.2-34.8-74-34.8z"
        }
    ]
};

const FalSensorFire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSensorFire",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h320c17.7 0 32 14.3 32 32v41c9.4-6.9 20.9-9.8 32-8.8V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h273.6c-8.8-9.8-16.5-20.6-23.2-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm317.4 109.3c9.6-.1 18.7-4.5 24.7-12.1 3.9-4.9 7.8-9.6 11.6-14 16.4 17.8 30.9 39.4 41.8 60.5C601 313.8 608 339.3 608 352c0 70.2-57 127.8-128 127.8-71.8 0-128-57.5-128-127.8 0-17.9 9.4-46.2 27.6-75.8 15.9-25.8 37.9-53.1 64-78.1 14.3 13.7 27.9 28.3 40.8 43.7 6.2 7.4 15.3 11.6 25 11.5zM487.5 197c-10.9-11.6-22.2-22.8-34-33.4-2.8-2.5-6.3-3.7-9.8-3.8-3.6 0-7.2 1.2-10 3.7-33.2 29.7-61.4 63.4-81.4 95.8-19.6 32-32.3 66.3-32.3 92.7 0 87.8 70.3 159.8 160 159.8 88.7 0 160-72 160-159.8 0-20.2-9.6-50.9-24.2-79-14.8-28.5-35.7-58.5-60.4-81.1-5.6-5.1-14.4-5.2-20 0-1.8 1.6-3.5 3.3-5.2 5-7.7 7.7-14.8 16.4-21.2 24.5-7-8.4-14.1-16.5-21.5-24.4zM445 255.9c-4.8 0-9.4 2.2-12.5 5.9-14.9 18.4-26.9 33.8-35.1 47.9-8.4 14.4-13.4 28.5-13.4 44.2 0 28.7 10.7 52.6 28.8 69.2 18 16.5 42.3 24.8 68.2 24.8 21.3 0 40.3-6 57.9-17.7l.3-.2c37.3-26.1 46.3-77.2 25-116.5v-.1c-1.9-3.9-4.5-9-8.3-14.1-2.9-3.9-7.4-6.2-12.3-6.4s-9.5 1.9-12.7 5.6l-23.3 27.2-17.5-22.3c-15-19.1-30.5-38.9-32.6-41.5-3-3.8-7.6-6-12.4-6zm94.8 81.3c9 24.7 1.3 52.3-18.9 66.5-12.4 8.2-25.3 12.2-40 12.2-19.1 0-35.3-6.1-46.6-16.4-11.1-10.1-18.4-25.2-18.4-45.6 0-8.3 2.5-16.8 9.1-28.1 4.7-8.1 11.2-17.2 19.8-28.2l20 25.5 20.4 26 6.6 8.5 1.8 2.4.5.6.1.2 12.6-9.9-12.6 9.9c3 3.8 7.4 6 12.2 6.1s9.4-1.9 12.5-5.6l20.7-24.1z"
        }
    ]
};

const FalSensorOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSensorOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 96c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm424.2-34.3c7.6-4.5 10-14.4 5.5-22s-14.4-10-21.9-5.5l-80 48c-7.6 4.5-10 14.4-5.5 22s14.4 10 21.9 5.5l80-48zM528 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96zm-7.8 130.3c-7.6-4.5-17.4-2.1-21.9 5.5s-2.1 17.4 5.5 21.9l80 48c7.6 4.5 17.4 2.1 21.9-5.5s2.1-17.4-5.5-21.9l-80-48z"
        }
    ]
};

const FalSensorTriangleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSensorTriangleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h320c17.7 0 32 14.3 32 32v39.4c9.8-4.8 20.7-7.4 32-7.4V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h161c-.6-4-1-8.1-1-12.3 0-6.7.9-13.3 2.6-19.7H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm64 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm64 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144zm291.8 36.9c-7.3-12.9-21-20.9-35.8-20.9s-28.5 8-35.8 20.9l-150.4 265c-3.8 6.7-5.8 14.2-5.8 21.9 0 24.5 19.8 44.3 44.3 44.3h295.4c24.5 0 44.3-19.8 44.3-44.3 0-7.7-2-15.2-5.8-21.9l-150.4-265zM440 196.7c1.6-2.9 4.7-4.7 8-4.7s6.4 1.8 8 4.7l150.4 265c1 1.9 1.6 3.9 1.6 6.1 0 6.8-5.5 12.3-12.3 12.3H300.3c-6.8 0-12.3-5.5-12.3-12.3 0-2.1.6-4.2 1.6-6.1l150.4-265zM464 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64zm-16 144a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalSensor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSensor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 48v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 0v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalServer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalServer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 224c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H64zM0 352c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64zm304 32a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 280a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24-280a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalShapes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShapes",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M411.4 175.5c5.9 9.9 6.1 22.2.4 32.2s-16.3 16.2-27.8 16.2H192c-11.5 0-22.2-6.2-27.8-16.2s-5.5-22.3.4-32.2l96-160C266.3 5.9 276.8 0 288 0s21.7 5.9 27.4 15.5l96 160zM288 32l-96 160h192L288 32zm184 272H328c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V312c0-4.4-3.6-8-8-8zm-144-32h144c22.1 0 40 17.9 40 40v144c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V312c0-22.1 17.9-40 40-40zM224 384a96 96 0 1 0-192 0 96 96 0 1 0 192 0zM0 384a128 128 0 1 1 256 0 128 128 0 1 1-256 0z"
        }
    ]
};

const FalShareAll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShareAll",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M373.2 59.8c-6.5-5.9-7-16.1-1.1-22.6s16.1-7 22.6-1.1l156.5 142.3c17.5 15.9 17.5 43.3 0 59.2L394.8 379.8c-6.5 5.9-16.7 5.5-22.6-1.1s-5.5-16.7 1.1-22.6l156.4-142.2c3.5-3.2 3.5-8.7 0-11.8L373.2 59.8zM256 160h-80c-79.5 0-144 64.5-144 144 0 46.1 15.9 79.7 34 103.2-1.3-7.1-2-14.8-2-23.2 0-70.7 57.3-128 128-128h72c13.3 0 24 10.7 24 24v72l160-144L288 64v72c0 13.3-10.7 24-24 24h-8zm0 160v-32h-64c-53 0-96 43-96 96 0 30.4 12.8 47.9 22.2 56.7 5.5 5.1 9.8 12 9.8 19.5 0 10.9-8.8 19.7-19.7 19.7-2.8 0-5.6-.6-8.1-1.9C81.5 467.9 0 417.3 0 304c0-97.2 78.8-176 176-176h80V64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2v-32z"
        }
    ]
};

const FalShareFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShareFromSquare",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 280v-56c0-8.8-7.2-16-16-16h-94.5c-53.8 0-97.5 43.6-97.5 97.5 0 5.3.7 10.3 1.9 15C175.5 301.9 160 276 160 240c0-70.7 57.3-128 128-128h96c8.8 0 16-7.2 16-16V40c0-4.4 3.6-8 8-8 2.1 0 4 .8 5.5 2.2l128.8 122c1 1 1.6 2.3 1.6 3.8s-.6 2.8-1.6 3.8l-128.8 122c-1.5 1.4-3.5 2.2-5.5 2.2-4.5 0-8-3.6-8-8zm-32-40v40c0 22.1 18 40 40 40 10.2 0 20.1-3.9 27.5-11l128.9-122c7.4-7 11.6-16.8 11.6-27s-4.2-20-11.6-27L435.6 11c-7.4-7-17.3-11-27.5-11C386 0 368 17.9 368 40v40h-80c-88.4 0-160 71.6-160 160 0 93.4 82.8 134.8 100.6 142.6 2.2 1 4.6 1.4 7.1 1.4 11.2 0 20.3-9.1 20.3-20.3v-.9c0-6.8-3.3-13.1-8.3-17.7-9.5-8.6-23.7-24.1-23.7-39.7 0-36.1 29.3-65.5 65.5-65.5H368zM64 32C28.7 32 0 60.7 0 96v352c0 35.3 28.7 64 64 64h352c35.3 0 64-28.7 64-64v-48c0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H64z"
        }
    ]
};

const FalShareNodes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShareNodes",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 112c0 44.2-35.8 80-80 80-22.9 0-43.6-9.6-58.1-25l-151 75.5c.8 4.4 1.1 8.9 1.1 13.5s-.4 9.1-1.1 13.5l151 75.5c14.6-15.4 35.2-25 58.1-25 44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80c0-9.7 1.7-19 4.9-27.7l-145.7-72.8c-14.3 22-39 36.5-67.2 36.5-44.2 0-80-35.8-80-80s35.8-80 80-80c28.2 0 52.9 14.5 67.2 36.5l145.7-72.9c-3.2-8.6-4.9-17.9-4.9-27.7 0-44.2 35.8-80 80-80s80 35.8 80 80zM80 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-192a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-48 336a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalShare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 160c13.3 0 24-10.7 24-24V64l160 144-160 144v-72c0-13.3-10.7-24-24-24H192c-70.7 0-128 57.3-128 128 0 8.3.7 16.1 2 23.2-18.1-23.5-34-57.1-34-103.2 0-79.5 64.5-144 144-144h120zm-8 144v48c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4S288 51.4 288 64v64H176C78.8 128 0 206.8 0 304c0 113.3 81.5 163.9 100.2 174.1 2.5 1.4 5.3 1.9 8.1 1.9 10.9 0 19.7-8.9 19.7-19.7 0-7.5-4.3-14.4-9.8-19.5-9.4-8.9-22.2-26.4-22.2-56.8 0-53 43-96 96-96h96v16z"
        }
    ]
};

const FalSheep = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSheep",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 136c0-39.8-32.2-72-72-72-36.1 0-66 26.6-71.2 61.2l.1.1-.1.1c-.5 3.5-.8 7-.8 10.6v72c0 35.3 28.7 64 64 64h16c35.3 0 64-28.7 64-64v-72zm-171.5-30.2C385.4 63.1 425.1 32 472 32c44.4 0 82.2 27.8 97.2 66.9l47.7 31.8c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4L576 141.9V208c0 53-43 96-96 96h-16c-53 0-96-43-96-96v-60.8l-15.1 10.1c-7.4 4.9-17.3 2.9-22.2-4.4s-2.9-17.3 4.4-22.2l37.3-24.9zM448 144a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-80 184c9.9 0 18.8-4.5 24.7-11.6 10.1 2.4 20.5 3.6 31.3 3.6h3.4c-8.7 21.5-28.8 37.3-52.8 39.7l-25 100C392.2 497 373 512 351 512h-15c-26.5 0-48-21.5-48-48v-40.6c-9.4 5.4-20.3 8.6-32 8.6s-22.6-3.1-32-8.6V464c0 26.5-21.5 48-48 48h-15c-22 0-41.2-15-46.6-36.4l-25-100C57.2 372.4 32 345.1 32 312c0-5.3.7-10.5 1.9-15.5C13.7 285.7 0 264.5 0 240s13.7-45.7 33.9-56.5c-1.2-5-1.9-10.2-1.9-15.5 0-35.3 28.7-64 64-64 3.3 0 6.6.3 9.8.8 6.9-28 32.1-48.8 62.2-48.8 15 0 28.9 5.2 39.8 13.9C219.5 56.5 236.8 48 256 48s36.5 8.5 48.2 21.9C315.1 61.2 329 56 344 56c5.7 0 11.2.7 16.5 2.1-6.4 9.2-11.7 19.2-15.8 29.9h-.7c-7.6 0-14.4 2.6-19.9 6.9-13.4 10.6-32.8 8.9-44-4-5.9-6.8-14.5-11-24.1-11s-18.2 4.2-24.1 11c-11.3 12.9-30.6 14.6-44 4-5.5-4.3-12.3-6.9-19.9-6.9-15 0-27.7 10.4-31.1 24.3-3.9 16.1-19.6 26.6-36 24-1.6-.2-3.2-.4-5-.4-17.7 0-32 14.3-32 32 0 2.7.3 5.3.9 7.8 3.5 14.2-3 29-16 36-10.2 5.4-17 16.1-17 28.3s6.8 22.8 17 28.3c12.9 6.9 19.5 21.7 16 36-.6 2.5-.9 5.1-.9 7.8 0 17.7 14.3 32 32 32 1.7 0 3.4-.1 5-.4 16.4-2.5 32 7.9 36 24 3.4 14 16.1 24.3 31.1 24.3 7.6 0 14.4-2.6 19.9-6.9 13.4-10.6 32.8-8.9 44 4 5.9 6.8 14.5 11 24.1 11s18.2-4.2 24.1-11c11.3-12.9 30.6-14.6 44-4 5.5 4.3 12.3 6.9 19.9 6.9 15 0 27.7-10.4 31.1-24.3 3.9-16.1 19.6-26.6 36-24 1.6.2 3.2.4 5 .4zm-72 80c-8.5 0-16.6-1.7-24-4.7V464c0 8.8 7.2 16 16 16h15c7.3 0 13.7-5 15.5-12.1l13.8-55.2C370 419.8 357.5 424 344 424zm-212.3-11.3 13.8 55.2c1.8 7.1 8.2 12.1 15.5 12.1h15c8.8 0 16-7.2 16-16v-44.7c-7.4 3-15.5 4.7-24 4.7-13.5 0-26-4.2-36.3-11.3z"
        }
    ]
};

const FalSheetPlastic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSheetPlastic",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 64v256H240c-26.5 0-48 21.5-48 48v112H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32zm-.5 288c-.7 2.8-2.1 5.4-4.2 7.4L231.4 475.3c-2.1 2.1-4.6 3.5-7.4 4.2V368c0-8.8 7.2-16 16-16h111.5zM0 448c0 35.3 28.7 64 64 64h156.1c12.7 0 24.9-5.1 33.9-14.1l115.9-115.8c9-9 14.1-21.2 14.1-33.9V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v384zM187.3 68.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6zm96 54.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160z"
        }
    ]
};

const FalShekelSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShekelSign",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32c-26.5 0-48 21.5-48 48v384c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-8.8 7.2-16 16-16h112c44.2 0 80 35.8 80 80v192c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-61.9-50.1-112-112-112H80zm224 448c61.9 0 112-50.1 112-112V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v320c0 44.2-35.8 80-80 80H192c-8.8 0-16-7.2-16-16V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v256c0 26.5 21.5 48 48 48h112z"
        }
    ]
};

const FalShelvesEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShelvesEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 16c0-8.8-7.2-16-16-16S0 7.2 0 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h576v48c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v144H32V16zm0 176h576v224H32V192z"
        }
    ]
};

const FalShelves = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShelves",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0c8.8 0 16 7.2 16 16v144h576V16c0-8.8 7.2-16 16-16s16 7.2 16 16v480c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V16C0 7.2 7.2 0 16 0zm16 416h576V192H32v224zM448 32h-64v64h64V32zM384 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32V32c0-17.7 14.3-32 32-32zM128 288v64h64v-64h-64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64zm192 0v64h64v-64h-64zm-32 0c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64z"
        }
    ]
};

const FalShieldCat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldCat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM171.3 132.7c-4.6-4.6-11.5-5.9-17.4-3.5s-9.9 8.3-9.9 14.8v128c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-6.5-3.9-12.3-9.9-14.8s-12.9-1.1-17.4 3.5L281.4 192h-50.8l-59.3-59.3zM176 272v-89.4l36.7 36.7c3 3 7.1 4.7 11.3 4.7h64c4.2 0 8.3-1.7 11.3-4.7l36.7-36.7V272c0 44.2-35.8 80-80 80s-80-35.8-80-80zm56 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm64 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalShieldCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm82.3 195.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalShieldCross = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldCross",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v64H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h128v192c0 8.8 7.2 16 16 16s16-7.2 16-16V208h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H272v-64z"
        }
    ]
};

const FalShieldDog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldDog",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM200 128h-21.3c-32.4 0-58.7 26.3-58.7 58.7V216c0 22.6 13.4 42.1 32.7 50.9l-15 29.9c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l20-40.1c26-4.9 45.6-27.7 45.6-55v-56h60.2c6.1 0 11.6 3.4 14.3 8.8l7.2 14.3c2.7 5.4 8.2 8.8 14.3 8.8h56v16c0 35.3-28.7 64-64 64h-48c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V304h32c53 0 96-43 96-96v-16c0-17.7-14.3-32-32-32h-46.1l-2.7-5.5c-8.2-16.2-24.8-26.5-43-26.5H200zm-24.3 112c-13.1-.1-23.7-10.8-23.7-24v-29.3c0-10.9 6.6-20.3 16-24.4 3.3-1.4 6.9-2.2 10.7-2.2H200v56c0 13.2-10.6 23.9-23.7 24h-.5zm96.3-32a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalShieldExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 128c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalShieldHalved = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldHalved",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 38.8v433.8C86.8 397.1 48.5 233.2 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6L240 38.8zm32 433.8V38.8l173.2 73.5c11.3 4.8 18.9 15.5 18.8 27.6-.5 93.3-38.8 257.3-192 332.8zm9-464.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8z"
        }
    ]
};

const FalShieldHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldHeart",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM162.3 214.2c0-19.6 15.9-35.5 35.5-35.5 9.5 0 18.7 3.8 25.4 10.7l21.4 21.9c3 3.1 7.1 4.8 11.4 4.8s8.4-1.7 11.4-4.8l21.4-21.9c6.7-6.8 15.8-10.7 25.4-10.7 19.6 0 35.5 15.9 35.5 35.5v1.5c0 9.7-3.8 19-10.6 25.9L256 326.5l-83.1-84.9c-6.8-6.9-10.6-16.2-10.6-25.9v-1.5zm35.5-67.5c-37.3 0-67.5 30.2-67.5 67.5v1.5c0 18.1 7.1 35.4 19.7 48.3l94.6 96.5c3 3.1 7.1 4.8 11.4 4.8s8.4-1.7 11.4-4.8L362 264c12.6-12.9 19.7-30.2 19.7-48.3v-1.5c0-37.3-30.2-67.5-67.5-67.5-18.1 0-35.5 7.3-48.2 20.3l-10 10.2-10-10.2c-12.7-13-30.1-20.3-48.2-20.3z"
        }
    ]
};

const FalShieldKeyhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldKeyhole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM256 184a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 25.4 16.9 46.8 40 53.7V336c0 8.8 7.2 16 16 16s16-7.2 16-16v-74.3c23.1-6.9 40-28.3 40-53.7z"
        }
    ]
};

const FalShieldMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldMinus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM160 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H160z"
        }
    ]
};

const FalShieldPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldPlus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
        }
    ]
};

const FalShieldQuartered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldQuartered",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M66.8 112.3C55.5 117 47.9 127.7 48 139.8c.1 20 1.9 43.2 6.3 68.2H240V38.8L66.8 112.3zM61.1 240c21.2 84.6 72.2 180.1 178.9 232.6V240H61.1zm210.9 0v232.6c106.7-52.5 157.7-148 179-232.6H272zm185.8-32c4.3-24.9 6.2-48.2 6.3-68.2.1-12.1-7.5-22.8-18.8-27.6L272 38.8V208h185.8zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z"
        }
    ]
};

const FalShieldSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM418 414.9c-23.5 22.9-51.8 43.3-85.4 59.4-7.9 3.8-17.2 3.8-25.1 0-138.3-66.1-184.6-203.6-193.7-299.6l-33.7-26.5c2.6 100.7 45.8 274.7 213.5 355 16.7 8 36.1 8 52.8 0 38.6-18.5 70.6-41.9 97-68.2L418 415zM295 7.8 174 59.2l28.6 22.6 104.9-44.5c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.2 45.8-9.6 108.6-37.1 169.6l25.8 20.4c32.5-68.7 43-139.7 43.3-189.8.1-26.2-16.3-47.9-38.3-57.2L345 7.8c-16-6.8-34-6.8-50 0z"
        }
    ]
};

const FalShieldVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zm76.8 311.4C334.5 295.9 351 256 384 256c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2 6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C311.9 161.5 272 145 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C177.5 184.1 161 224 128 224c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C200.1 318.5 240 335 240 368c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2 6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM339.5 240c-17 14.5-26.3 36.8-24.5 59.1-22.3-1.8-44.6 7.4-59.1 24.5-14.5-17-36.8-26.3-59.1-24.5 1.8-22.3-7.4-44.6-24.5-59.1 17-14.5 26.3-36.8 24.5-59.1 22.3 1.8 44.6-7.4 59.1-24.5 6.6 7.8 14.8 13.9 24 18.1 10.9 5 23 7.3 35.1 6.3-1.8 22.3 7.4 44.6 24.5 59.1zm-99.5 8a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm48 24a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalShieldXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShieldXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.5 37.3c8-3.4 17-3.4 25 0l176.7 75c11.3 4.8 18.9 15.5 18.8 27.6-.5 94-39.4 259.8-195.5 334.5-7.9 3.8-17.2 3.8-25.1 0C87.3 399.6 48.5 233.8 48 139.8c-.1-12.1 7.5-22.8 18.8-27.6l176.7-75zM281 7.8c-16-6.8-34-6.8-50 0l-176.7 75c-22 9.3-38.4 31-38.3 57.2.5 99.2 41.3 280.7 213.6 363.2 16.7 8 36.1 8 52.8 0C454.7 420.7 495.5 239.2 496 140c.1-26.2-16.3-47.9-38.3-57.2L281 7.8zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShield",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M268.5 37.3c-8-3.4-17-3.4-25 0l-176.7 75C55.5 117 47.9 127.7 48 139.8c.5 94 39.3 259.8 195.4 334.5 7.9 3.8 17.2 3.8 25.1 0 156.1-74.7 195-240.4 195.5-334.5.1-12.1-7.5-22.8-18.8-27.6l-176.7-75zM231 7.8c16-6.8 34-6.8 50 0l176.7 75c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0C57.3 420.7 16.5 239.2 16 140c-.1-26.2 16.3-47.9 38.3-57.2L231 7.8z"
        }
    ]
};

const FalShip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShip",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 0c-26.5 0-48 21.5-48 48v16h-48c-26.5 0-48 21.5-48 48v125.3l-33.3 10.8c-34.8 11.2-44.7 55.7-18.1 80.7l88.4 82.9c6.4 6 16.6 5.7 22.6-.7s5.7-16.6-.7-22.6l-88.4-83c-8.9-8.3-5.6-23.1 6-26.9L272 214v170c0 8.8 7.2 16 16 16s16-7.2 16-16V214l199.5 64.5c11.6 3.8 14.9 18.6 6 26.9l-88.4 82.9c-6.4 6-6.8 16.2-.7 22.6s16.2 6.8 22.6.7l88.4-82.9c26.7-25 16.7-69.4-18.1-80.7L480 237.3V112c0-26.5-21.5-48-48-48h-48V48c0-26.5-21.5-48-48-48h-96zm112 64H224V48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v16zM192 96h240c8.8 0 16 7.2 16 16v114.9L302.8 180c-9.6-3.1-19.9-3.1-29.6 0L128 226.9V112c0-8.8 7.2-16 16-16h48zm-58.2 362.8c-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480s-41.7-9.9-58.2-21.2z"
        }
    ]
};

const FalShirtLongSleeve = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShirtLongSleeve",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M110.3 73.4c14-25.5 40.9-41.4 70.1-41.4h43.9c4.1 49.3 45.3 88 95.7 88s91.6-38.7 95.7-88h43.9c29.2 0 56 15.9 70.1 41.4l66.4 120.7c7.8 14.2 11.9 30.1 11.9 46.3V368c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V240.4c0-5.4-1.4-10.7-4-15.4l-58.8-107c-1.4-2.6-3.1-5.1-5-7.3-4.4-5.1-11.4-6.9-17.7-4.5s-10.4 8.3-10.4 15V456c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V121.2c0-6.7-4.2-12.7-10.4-15s-13.3-.5-17.7 4.5c-1.9 2.2-3.6 4.6-5.1 7.3L100 225c-2.6 4.7-4 10-4 15.4V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V240.4c0-16.2 4.1-32.1 11.9-46.3l66.4-120.7zM180.4 0c-40.8 0-78.5 22.2-98.1 58L15.8 178.8C5.5 197.7 0 218.9 0 240.4V368c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V240.4l32-58.2V456c0 30.9 25.1 56 56 56h208c30.9 0 56-25.1 56-56V182.3l32 58.2V368c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V240.4c0-21.6-5.4-42.8-15.8-61.7L557.8 58c-19.7-35.8-57.3-58-98.2-58h-52c-1.5 0-2.9.1-4.2.4-1.1-.2-2.2-.4-3.4-.4H240c-1.2 0-2.3.1-3.4.4-1.3-.2-2.8-.4-4.2-.4h-52zm76.1 32h127c-3.9 31.6-30.9 56-63.5 56s-59.6-24.4-63.5-56z"
        }
    ]
};

const FalShirtRunning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShirtRunning",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0c8.8 0 16 7.2 16 16v48c0 53 43 96 96 96s96-43 96-96V16c0-8.8 7.2-16 16-16s16 7.2 16 16c0 134.3 29.3 192.6 45.6 214.6 8.9 12 18.4 28.6 18.4 47.6V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V278.2c0-19 9.5-35.7 18.4-47.6C34.7 208.6 64 150.3 64 16c0-8.8 7.2-16 16-16zM44.1 249.6c-7.6 10.2-12.1 20-12.1 28.6v118.1L310.6 195l1.4-1c-5.5-15.9-10.5-34.9-14.6-57.5C274.4 170 235.8 192 192 192s-82.4-22-105.5-55.5c-10.7 59.8-28.4 94.1-42.4 113.1zM32 435.7V456c0 13.3 10.7 24 24 24h272c13.3 0 24-10.7 24-24V278.2c0-8.6-4.6-18.4-12.1-28.6-4.8-6.5-10-14.7-15.2-25.2L41.4 429l-9.4 6.7z"
        }
    ]
};

const FalShirtTankTop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShirtTankTop",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 16c0-8.8-7.2-16-16-16S64 7.2 64 16c0 134.3-29.3 192.6-45.6 214.6C9.5 242.5 0 259.2 0 278.2V456c0 30.9 25.1 56 56 56h272c30.9 0 56-25.1 56-56V278.2c0-19-9.5-35.7-18.4-47.6-16.3-22-45.6-80.3-45.6-214.6 0-8.8-7.2-16-16-16s-16 7.2-16 16v48c0 53-43 96-96 96s-96-43-96-96V16zm-9.5 120.5C109.6 170 148.2 192 192 192s82.4-22 105.5-55.5c10.7 59.8 28.4 94.1 42.4 113.1 7.6 10.2 12.1 20 12.1 28.6V456c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V278.2c0-8.6 4.6-18.4 12.1-28.6 14-19 31.7-53.3 42.4-113.1z"
        }
    ]
};

const FalShirt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShirt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M211.4 0c-27.7 0-54.5 9.6-76 27.1L56.3 91.9l-43.4 35.5c-13.7 11.2-15.7 31.4-4.5 45l70.9 86.7c11.2 13.7 31.4 15.7 45 4.5l35.7-29.2V456c0 30.9 25.1 56 56 56h208c30.9 0 56-25.1 56-56V234.4l35.6 29.1c13.7 11.2 33.8 9.2 45-4.5l70.9-86.7c11.2-13.7 9.2-33.8-4.5-45l-10.1 12.4 10.1-12.4-43.3-35.4-79.1-64.8C483.1 9.6 456.3 0 428.6 0h-6.3c-1.3 0-2.5.1-3.7.2-.8-.1-1.7-.2-2.6-.2H224c-.9 0-1.7.1-2.6.2-1.2-.1-2.4-.2-3.7-.2h-6.3zm40.7 32h135.8C378 60 351.3 80 320 80s-58-20-67.9-48zm-96.4 19.9C171.4 39 191.1 32 211.4 32h6.3s.2.1.4.3c.5.4 1 1.2 1.3 2.2C231.1 79.1 271.7 112 320 112s88.9-32.9 100.6-77.5c.3-1 .8-1.8 1.3-2.2.2-.2.4-.2.4-.3h6.3c20.3 0 40 7 55.7 19.9l79.2 64.8 43.3 35.5-70.9 86.7-43.3-35.5-18.4-15.1c-4.8-3.9-11.4-4.7-17-2.1s-9.1 8.3-9.1 14.5V456c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24V200.7c0-6.2-3.6-11.8-9.1-14.5s-12.2-1.8-17 2.1l-18.4 15.1-43.3 35.5-71-86.8 43.3-35.5 79.2-64.8z"
        }
    ]
};

const FalShishKebab = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShishKebab",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 96c0-35.3 28.7-64 64-64s64 28.7 64 64c0 14.4-4.8 27.7-12.8 38.4-5.3 7.1-3.9 17.1 3.2 22.4s17.1 3.9 22.4-3.2c12.1-16 19.2-36 19.2-57.6 0-53-43-96-96-96s-96 43-96 96c0 12.7 2.5 24.9 7 36.1 5.7 14 4.2 26.1-1.5 31.8l-8.8 8.8-30.1-30.1C272.1 128.1 252.5 120 232 120s-40.1 8.1-54.6 22.6l-18.7 18.7C144.1 175.9 136 195.5 136 216c0 6.2.7 12.3 2.2 18.2-5.9-1.4-12-2.2-18.2-2.2-20.5 0-40.1 8.1-54.6 22.6l-18.8 18.8C32.1 287.9 24 307.5 24 328s8.1 40.1 22.6 54.6l30.1 30.1-72 72c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l72-72 30.1 30.1c14.5 14.5 34.1 22.6 54.6 22.6s40.1-8.1 54.6-22.6l18.7-18.7c14.6-14.6 22.7-34.2 22.7-54.7 0-6.2-.7-12.3-2.2-18.2 5.9 1.4 12 2.2 18.2 2.2 20.5 0 40.1-8.1 54.6-22.6l18.7-18.7c14.6-14.6 22.7-34.2 22.7-54.7s-8.1-40.1-22.6-54.6l-30.1-30.1 8.8-8.8c19.3-19.3 16.2-47.7 8.6-66.4-3-7.4-4.7-15.5-4.7-24.1zM181.3 248c-8.5-8.5-13.3-20-13.3-32s4.8-23.5 13.3-32l18.7-18.7c8.5-8.5 20-13.3 32-13.3s23.5 4.8 32 13.3l82.7 82.7c8.5 8.5 13.3 20 13.3 32s-4.8 23.5-13.3 32L328 330.7c-8.5 8.5-20 13.3-32 13.3s-23.5-4.8-32-13.3L181.3 248zm-112 112c-8.5-8.5-13.3-20-13.3-32s4.8-23.5 13.3-32L88 277.3c8.5-8.5 20-13.3 32-13.3s23.5 4.8 32 13.3l82.7 82.7c8.5 8.5 13.3 20 13.3 32s-4.8 23.5-13.3 32L216 442.7c-8.5 8.5-20 13.3-32 13.3s-23.5-4.8-32-13.3L69.3 360z"
        }
    ]
};

const FalShoePrints = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShoePrints",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.9 47c31.6-7.9 68.4-15 96.1-15 43.5 0 94.5 11 133.7 30.6 41 20.5 58.3 44.3 58.3 65.4 0 19.6-13.4 35.6-46.2 48.1-31.9 12.1-71.6 15.9-97.8 15.9-39.2 0-61-12.3-88.1-27.8l-.5-.3c-22.9-13.1-49.1-28.1-87.4-33.7V55.7c8.8-2.6 19.8-5.6 31.9-8.6zM256 160c48 0 76 16 104 32s56 32 104 32c56.4 0 176-16 176-96S512 0 416 0c-63.7 0-160 32-160 32v128zm-64-32c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V32h-32c-35.3 0-64 28.7-64 64s28.7 64 64 64h32v-32h-32zm-.1 337c-12.1-3-23-6-31.9-8.6v-74.7c38.2-5.6 64.5-20.6 87.4-33.7l.5-.3C275 332.3 296.8 320 336 320c26.2 0 65.9 3.8 97.8 15.9 32.8 12.5 46.2 28.5 46.2 48.1 0 21.1-17.4 44.9-58.3 65.4C382.5 469 331.5 480 288 480c-27.7 0-64.5-7.2-96.1-15zM128 352v128s96.3 32 160 32c96 0 224-48 224-128s-119.6-96-176-96c-48 0-76 16-104 32s-56 32-104 32zm-64 32h32v-32H64c-35.3 0-64 28.7-64 64s28.7 64 64 64h32v-32H64c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
        }
    ]
};

const FalShopLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShopLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25c8.4-15.4 24.5-25 42.1-25h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3 0 12.4-5.9 23.3-14.9 30.3-5.4-9.3-12.1-17.8-19.8-25.2 1.6-1.1 2.7-3 2.7-5.2 0-1-.3-2.1-.8-3L529.6 40.3c-2.8-5.1-8.2-8.3-14-8.3h-391c-5.9 0-11.2 3.2-14 8.3L32.8 182.8c-.5.9-.8 1.9-.8 3 0 3.4 2.8 6.2 6.2 6.2h411.4c-9.4 9.2-17.1 20-22.8 32H96v128h256v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v192.3c-.2 26.4-21.6 47.7-48 47.7H112c-26.5 0-48-21.5-48-48V224H38.2C17.1 224 0 206.9 0 185.8zM96 464c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-80H96v80zm432-240c-26.5 0-48 21.5-48 48v48h96v-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48zm0 80v128h160V352H448z"
        }
    ]
};

const FalShopSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShopSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 185.8C0 206.9 17.1 224 38.2 224H64v240c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48v-75.9L338.3 352H96V224h80.2l-40.5-32H38.2c-3.4 0-6.2-2.8-6.2-6.2 0-1 .3-2.1.8-3l27.4-50.3-25.5-20.2-30 55.1c-3.1 5.7-4.7 12-4.7 18.4zM139.6 32h376c5.9 0 11.2 3.2 14 8.3l77.7 142.4c.5.9.8 1.9.8 3 0 3.4-2.8 6.2-6.2 6.2H342.2l40.5 32H544v127.4l32 25.3V224h25.8c21.1 0 38.2-17.1 38.2-38.2 0-6.4-1.6-12.7-4.7-18.3L557.6 25c-8.4-15.4-24.5-25-42.1-25h-391c-7 0-13.8 1.5-20 4.3l35 27.7zM96 464v-80h256v80c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalShop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShop",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 185.8c0-6.4 1.6-12.7 4.7-18.3L82.4 25c8.4-15.4 24.5-25 42.1-25h391c17.6 0 33.7 9.6 42.1 25l77.7 142.4c3.1 5.6 4.7 11.9 4.7 18.3 0 21.1-17.1 38.2-38.2 38.2H576V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H96v128h256v-96h32v208c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V224H38.2C17.1 224 0 206.9 0 185.8zm80 6.2h521.8c3.4 0 6.2-2.8 6.2-6.2 0-1-.3-2.1-.8-3L529.6 40.3c-2.8-5.1-8.2-8.3-14-8.3h-391c-5.9 0-11.2 3.2-14 8.3L32.8 182.8c-.5.9-.8 1.9-.8 3 0 3.4 2.8 6.2 6.2 6.2H80zm16 272c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-80H96v80z"
        }
    ]
};

const FalShovelSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShovelSnow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M419.3 4.7c-6.2-6.2-16.4-6.2-22.6 0l-37.8 37.8C344.2 57.1 336 77 336 97.8c0 15.8 4.7 30.5 12.8 42.8L272 217.4l-41.8-41.8c-16.4-16.4-42.3-18.7-61.4-5.5L20.6 273.3C7.7 282.3 0 297 0 312.7v2c0 12.7 5.1 24.9 14.1 33.9l149.2 149.3c9 9 21.2 14.1 33.9 14.1h2c15.7 0 30.4-7.7 39.4-20.6l103.2-148.3c13.3-19.1 11-44.9-5.5-61.4L294.6 240l76.8-76.8c12.3 8.1 27 12.8 42.8 12.8 20.7 0 40.6-8.2 55.3-22.9l37.8-37.8c6.2-6.2 6.2-16.4 0-22.6l-88-88zm-37.8 60.4L408 38.6l65.4 65.4-26.5 26.5c-8.7 8.7-20.4 13.5-32.7 13.5-25.5 0-46.2-20.7-46.2-46.2 0-12.3 4.9-24 13.5-32.7zM187.2 196.4c6.4-4.4 15-3.7 20.5 1.8l106.1 106.2c5.5 5.5 6.2 14.1 1.8 20.4L212.4 473.1c-3 4.3-7.9 6.9-13.1 6.9h-2c-4.2 0-8.3-1.7-11.3-4.7L36.7 326.1c-3-3-4.7-7.1-4.7-11.3v-2c0-5.2 2.6-10.1 6.9-13.1l148.3-103.3zm16.2 70.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80zm64 64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80z"
        }
    ]
};

const FalShovel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShovel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m396 34.6-43.1 43.2c-10.8 10.8-16.9 25.4-16.9 40.7 0 31.8 25.8 57.5 57.5 57.5 15.3 0 29.9-6.1 40.7-16.9l43.2-43.1L396 34.6zM377.9 7.5C382.7 2.7 389.2 0 396 0s13.3 2.7 18.1 7.5l90.3 90.3c4.8 4.8 7.5 11.3 7.5 18.1s-2.7 13.3-7.5 18.1l-47.6 47.6c-16.8 16.8-39.6 26.2-63.3 26.2-18.9 0-36.5-5.9-51-15.9L235.3 299.3l62.1 62.1c12.5 12.5 12.5 32.8 0 45.3l-58.5 58.5c-30 30-70.7 46.9-113.1 46.9H32c-17.7 0-32-14.3-32-32v-93.8c0-42.4 16.9-83.1 46.9-113.1l58.5-58.5c12.5-12.5 32.8-12.5 45.3 0l62.1 62.1 107.1-107.4c-10-14.5-15.9-32-15.9-51 0-23.7 9.4-46.5 26.2-63.3l47.7-47.6zM32 480h93.7c33.9 0 66.5-13.5 90.5-37.5l58.5-58.5L128 237.3l-58.5 58.5c-24 24-37.5 56.6-37.5 90.5V480z"
        }
    ]
};

const FalShowerDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShowerDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c8.8 0 16 7.2 16 16v16.8c80.9 8 144 76.2 144 159.2h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c0-83 63.1-151.2 144-159.2V16c0-8.8 7.2-16 16-16zm0 64c-70.7 0-128 57.3-128 128h256c0-70.7-57.3-128-128-128zm50.7 388.9c-1.8 2.8-2.7 6.1-2.7 9.4v1.7c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L256 431.6l-13.3 21.3zm-27.1-17 28.2-45.1c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4v1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4zM320 303.6l-13.3 21.3c-1.8 2.8-2.7 6.1-2.7 9.4v1.7c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L320 303.6zm-12.2-40.8c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4v1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4l28.2-45.1zM114.7 452.9c-1.8 2.8-2.7 6.1-2.7 9.4v1.7c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L128 431.6l-13.3 21.3zm-27.1-17 28.2-45.1c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4v1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4zM192 303.6l-13.3 21.3c-1.8 2.8-2.7 6.1-2.7 9.4v1.7c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L192 303.6zm-12.2-40.8c2.6-4.2 7.3-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4v1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4l28.2-45.1zM50.7 324.9c-1.8 2.8-2.7 6.1-2.7 9.4v1.7c0 8.8 7.2 16 16 16s16-7.2 16-16v-1.7c0-3.3-.9-6.6-2.7-9.4L64 303.6l-13.3 21.3zm-27.1-17 28.2-45.1c2.6-4.2 7.2-6.8 12.2-6.8s9.6 2.6 12.2 6.8l28.2 45.1c4.9 7.9 7.6 17 7.6 26.4v1.7c0 26.5-21.5 48-48 48s-48-21.5-48-48v-1.7c0-9.3 2.6-18.5 7.6-26.4z"
        }
    ]
};

const FalShower = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShower",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 115.9C32 87.2 55.2 64 83.9 64c13.8 0 27 5.5 36.7 15.2l28.1 28.1c.5.5 1.1 1 1.7 1.5-33 43.9-29.5 106.5 10.4 146.4l4.7 4.7-16.8 16.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16.8 16.8-4.7-4.7c-39.9-39.9-102.5-43.4-146.4-10.4-.4-.6-.9-1.2-1.5-1.7l-28.1-28.1C127.5 40.8 106.1 32 83.9 32 37.6 32 0 69.6 0 115.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16V115.9zm151.4 3.5c31.2-31.2 81.9-31.2 113.1 0l4.7 4.7-113.1 113.2-4.7-4.7c-31.2-31.2-31.2-81.9 0-113.1zM416 200a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128-128a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-88a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalShredder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShredder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64v128h320V90.5c0-8.5-3.4-16.6-9.4-22.6l-26.5-26.5c-6-6-14.1-9.4-22.6-9.4H128c-17.7 0-32 14.3-32 32zM64 192V64c0-35.3 28.7-64 64-64h229.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V192c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-96c0-35.3 28.7-64 64-64zm0 32c-17.7 0-32 14.3-32 32v96h448v-96c0-17.7-14.3-32-32-32H64zm344 48a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM96 496v-80h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0v-80h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0v-80h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16zm96 0v-80h32v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalShrimp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShrimp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 96c0-35.3 28.7-64 64-64h368c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-17.7 0-32 14.3-32 32s14.3 32 32 32h272c97.2 0 176 78.8 176 176s-78.8 176-176 176h-96c-8.8 0-16-7.2-16-16 0-4.4 1.8-8.4 4.7-11.3l36.7-36.7-36.7-36.7c-5-5-6.1-12.7-2.7-19s10.5-9.5 17.4-8L348.9 375c3.2.7 6.4 1 9.7 1 14 0 25.4-11.4 25.4-25.4V348c0-15.5-12.5-28-28-28H240c-91.8 0-167.2-70.3-175.3-160H64c-35.3 0-64-28.7-64-64zm336 352v-43.1l-46.4-9.9 9.7 9.7c6.2 6.2 6.2 16.4 0 22.6L278.6 448H336zm32-3.6c33-7.5 61.7-26.3 81.7-52.1l-39.8-15.9c-8.1 16.1-23.5 27.8-41.9 30.8v37.2zm98.7-79.8c8.6-18.4 13.3-39 13.3-60.6 0-9.3-.9-18.3-2.5-27.1l-67.4 45c3.3 6.9 5.4 14.4 5.9 22.4l50.8 20.3zm.8-119.5c-20.5-45.5-63.9-78.5-115.5-84.2V288h4c12 0 23.3 3.6 32.7 9.7l78.8-52.5zM320 160H96.9c8 72 69 128 143.1 128h80V160zm-112 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalShuffle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShuffle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M427.3 36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7H344c-20.1 0-39.1 9.5-51.2 25.6L244 202.7l20 26.7 54.4-72.5c6-8.1 15.5-12.8 25.6-12.8h113.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80zM124.8 361.6c-3 4-7.8 6.4-12.8 6.4H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c15.1 0 29.3-7.1 38.4-19.2l53.6-71.5-20-26.7-59.2 78.9zm279.9 113.7c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7H344c-10.1 0-19.6-4.7-25.6-12.8l-168-224c-9.1-12.1-23.3-19.2-38.4-19.2H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c5 0 9.8 2.4 12.8 6.4l168 224c12.1 16.1 31.1 25.6 51.2 25.6h113.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6z"
        }
    ]
};

const FalShutters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShutters",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H32zm0 32h448v32H32V64zM.9 453c-.6 2-.9 4.1-.9 6.1C0 470.7 9.3 480 20.9 480h470.2c11.5 0 20.9-9.3 20.9-20.9 0-2.1-.3-4.1-.9-6.1l-21.2-69h-33.5l19.7 64H35.9l19.7-64H22.2L.9 453zm21.3-197L.9 325c-.6 2-.9 4.1-.9 6.1C0 342.7 9.3 352 20.9 352h470.2c11.5 0 20.9-9.3 20.9-20.9 0-2.1-.3-4.1-.9-6.1l-21.2-69h-33.5l19.7 64H35.9l19.7-64H22.2zm453.9-64H35.9l9.8-32H12.3L.9 197c-.6 2-.9 4.1-.9 6.1C0 214.7 9.3 224 20.9 224h470.2c11.5 0 20.9-9.3 20.9-20.9 0-2.1-.3-4.1-.9-6.1l-11.4-37h-33.5l9.8 32z"
        }
    ]
};

const FalShuttleSpace = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShuttleSpace",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M245.2 448.1 405.3 352H464c64.7 0 123.5-27.4 164.8-76.3 9.6-11.4 9.6-28 0-39.4C587.5 187.4 528.7 160 464 160h-58.7L245.2 63.9C210.4 43 170.6 32 130 32H80c-26.5 0-48 21.5-48 48v48c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32v48c0 26.5 21.5 48 48 48h50c40.6 0 80.4-11 115.2-31.9zM64 384h48c5.5 0 10.8-.6 16-1.6V448H80c-8.8 0-16-7.2-16-16v-48zm164.7 36.6c-21.2 12.7-44.5 21.2-68.7 25V368c5.5-4.2 10.5-9 14.8-14.5.6-.7 1.2-1.2 1.6-1.4.2-.1.3-.1.3-.1h166.4l-114.4 68.6zM64 352H32v-80h144c8.8 0 16-7.2 16-16s-7.2-16-16-16H32v-80h80c15.3 0 28.9 7.1 37.7 18.3 5.8 7.3 15.2 13.7 27 13.7H464c54.9 0 104.4 22.9 139.5 64-35.1 41.1-84.6 64-139.5 64H176.7c-11.8 0-21.2 6.4-27 13.7-8.8 11.2-22.4 18.3-37.7 18.3H64zm0-224V80c0-8.8 7.2-16 16-16h48v65.6c-5.2-1.1-10.5-1.6-16-1.6H64zm110.8 30.5c-4.3-5.4-9.3-10.3-14.8-14.5V66.4c24.2 3.8 47.6 12.3 68.7 25L343.1 160H176.7s-.2 0-.3-.1c-.4-.2-1-.7-1.6-1.4zM464 224c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalShuttlecock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalShuttlecock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M241.9 0c-12.1 0-23.2 6.8-28.6 17.7L92.2 259.8l-18.8 18.8-40.3 40.3c-21.2 21.2-33.1 50-33.1 80C0 461.3 50.7 512 113.1 512c30 0 58.8-11.9 80-33.1l40.2-40.2 18.9-18.9 242.1-121c10.8-5.4 17.7-16.5 17.7-28.6V224c0-17.7-14.3-32-32-32h-56v-72c0-17.7-14.3-32-32-32h-72V32c0-17.7-14.3-32-32-32h-46.1zm67.2 355.6-75.7 37.8-46.1-46.1 77.2-77.2 103-32.5-58.4 118zm47.5-23.7 53.3-107.6.6-.2H480v46.1l-123.5 61.6zM288 101.5l-.2.6-107.6 53.4L241.9 32H288v69.5zm-13.6 43-32.5 103-77.2 77.2-46.1-46.1 37.8-75.7 118-58.4zm6.1 87L315.7 120H392v76.3l-111.5 35.2zM61.9 335.3l34.1-34L210.7 416l-34.1 34.1L61.9 335.3zm89.7 135c-11.7 6.3-24.9 9.7-38.5 9.7-44.8 0-81.1-36.3-81.1-81.1 0-13.6 3.4-26.8 9.7-38.5l109.9 109.9z"
        }
    ]
};

const FalSickle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSickle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0C214 0 128 86 128 192c0 71 38.5 132.9 95.7 166.1 6.3 3.6 14.2 2.6 19.4-2.5l36-36c5.3-5.3 6.2-13.5 2.2-19.9-11-17.2-17.3-37.7-17.3-59.7 0-61.9 50.1-112 112-112 48.1 0 89.1 30.3 105 72.9 2.7 7.2 10.1 11.5 17.7 10.2s13.2-7.8 13.3-15.5V192C512 86 426 0 320 0zM160 192c0-88.4 71.6-160 160-160 65.7 0 122.1 39.6 146.8 96.2C442 108.1 410.4 96 376 96c-79.5 0-144 64.5-144 144 0 23.6 5.7 45.9 15.8 65.6l-18.3 18.3c-42-28.8-69.5-77.2-69.5-131.9zm-44.7 108.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.7 4.7-84.2 84.2C4.7 420.6 0 432.1 0 444s4.7 23.4 13.2 31.8l23 23C44.6 507.3 56.1 512 68 512s23.4-4.7 31.8-13.2l84.2-84.2 4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-16-16-64-64-16-16zM35.8 434.8l84.2-84.2 41.4 41.4-84.2 84.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8l-23-23c-2.4-2.4-3.8-5.7-3.8-9.2s1.4-6.7 3.8-9.2z"
        }
    ]
};

const FalSidebarFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSidebarFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h224V64H64zm384 0H320v384h128c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm0-32c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h384zm-16 64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64zm16 80c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16zm-16 48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64z"
        }
    ]
};

const FalSidebar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSidebar",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H224V64h224zM64 64h128v384H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm0-32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm16 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm-16 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm16 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80z"
        }
    ]
};

const FalSigma = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSigma",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M1.3 41.6C3.9 35.8 9.6 32 16 32h328c22.1 0 40 17.9 40 40v72c0 8.8-7.2 16-16 16s-16-7.2-16-16V72c0-4.4-3.6-8-8-8H52.5l167.3 181.1c5.7 6.1 5.7 15.6 0 21.7L52.5 448H344c4.4 0 8-3.6 8-8v-72c0-8.8 7.2-16 16-16s16 7.2 16 16v72c0 22.1-17.9 40-40 40H16c-6.4 0-12.1-3.8-14.7-9.6s-1.4-12.6 2.9-17.3l182-197.1L4.2 58.9c-4.3-4.7-5.4-11.5-2.9-17.3z"
        }
    ]
};

const FalSignHanging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignHanging",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0c8.8 0 16 7.2 16 16v48h400c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v400c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h48V16c0-8.8 7.2-16 16-16zm80 160v192h288V160H160zm-32 0c0-17.7 14.3-32 32-32h288c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H160c-17.7 0-32-14.3-32-32V160z"
        }
    ]
};

const FalSignalBarsFair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalBarsFair",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 288c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-48 16c0-26.5 21.5-48 48-48s48 21.5 48 48v160c0 26.5-21.5 48-48 48s-48-21.5-48-48V304zM96 432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32z"
        }
    ]
};

const FalSignalBarsGood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalBarsGood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16v288zm-16-336c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48s48-21.5 48-48V176c0-26.5-21.5-48-48-48zM256 464c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16v160zm-16-208c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48s48-21.5 48-48V304c0-26.5-21.5-48-48-48zM96 432v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
        }
    ]
};

const FalSignalBarsSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalBarsSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 176c0-26.5-21.5-48-48-48s-48 21.5-48 48v23.7l32 25.3v-49c0-8.8 7.2-16 16-16s16 7.2 16 16v74.2l32 25.3V176zm-64 288v-75.9l-32-25.3V464c0 26.5 21.5 48 48 48s48-21.5 48-48v-25.4l-32-25.3V464c0 8.8-7.2 16-16 16s-16-7.2-16-16zm-96-151.7-66.6-52.6C204.1 267 192 284.1 192 304v160c0 26.5 21.5 48 48 48s48-21.5 48-48V312.3zm256 39V48c0-8.8 7.2-16 16-16s16 7.2 16 16v328.6l32 25.3V48c0-26.5-21.5-48-48-48s-48 21.5-48 48v278l32 25.3zM256 304v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V304c0-8.8 7.2-16 16-16s16 7.2 16 16zM96 432v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64 0v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalSignalBarsWeak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalBarsWeak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 464c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32zm-16-80c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48s48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
        }
    ]
};

const FalSignalBars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalBars",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 464V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16zM512 48c0-26.5 21.5-48 48-48s48 21.5 48 48v416c0 26.5-21.5 48-48 48s-48-21.5-48-48V48zm-96 128c0-8.8-7.2-16-16-16s-16 7.2-16 16v288c0 8.8 7.2 16 16 16s16-7.2 16-16V176zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v288c0 26.5-21.5 48-48 48s-48-21.5-48-48V176zm-96 288V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16zm-16-208c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48s-48-21.5-48-48V304c0-26.5 21.5-48 48-48zM96 432c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 26.5-21.5 48-48 48s-48-21.5-48-48v-32z"
        }
    ]
};

const FalSignalFair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalFair",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM80 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalSignalGood = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalGood",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v288c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm-144 80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalSignalSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M592 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v347.9l32 25.3V16zM432 496c0 8.8 7.2 16 16 16s16-7.2 16-16v-44.8L432 426v70zm32-384c0-8.8-7.2-16-16-16s-16 7.2-16 16v150.9l32 25.3V112zM304 324.9V496c0 8.8 7.2 16 16 16s16-7.2 16-16V350.2l-32-25.3zM192 288c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalSignalStreamSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalStreamSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 256c0-70.7-25.5-135.5-67.8-185.6-5.7-6.8-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5c37.6 44.6 60.2 102.1 60.2 165 0 29.5-5 57.8-14.1 84.1l26.4 20.9C569 328.5 576 293 576 256zm-96 0c0-46.4-16.5-89-43.9-122.2-5.6-6.8-15.7-7.8-22.5-2.1s-7.8 15.7-2.1 22.5C434.3 181.9 448 217.3 448 256c0 6.3-.4 12.5-1.1 18.7l28.6 22.6c2.9-13.3 4.4-27.1 4.4-41.3zm-340.1-60.7-26-20.5C102.4 199.5 96 227 96 256c0 46.4 16.5 89 43.9 122.2 5.6 6.8 15.7 7.8 22.5 2.1s7.8-15.7 2.1-22.5C141.7 330.1 128 294.7 128 256c0-21.5 4.2-42 11.9-60.7zm-77.2-61-25.5-20C13.5 156.1 0 204.5 0 256c0 70.7 25.5 135.5 67.8 185.6 5.7 6.8 15.8 7.6 22.5 1.9s7.6-15.8 1.9-22.5C54.6 376.4 32 318.9 32 256c0-44 11.1-85.4 30.7-121.6z"
        }
    ]
};

const FalSignalStream = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalStream",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M90.3 68.5c6.8 5.7 7.6 15.8 1.9 22.5C54.6 135.6 32 193.1 32 256s22.6 120.4 60.2 165c5.7 6.8 4.8 16.8-1.9 22.5s-16.8 4.8-22.5-1.9C25.5 391.5 0 326.7 0 256S25.5 120.5 67.8 70.4c5.7-6.8 15.8-7.6 22.5-1.9zm395.4 0c6.8-5.7 16.8-4.8 22.5 1.9C550.5 120.5 576 185.3 576 256s-25.5 135.5-67.8 185.6c-5.7 6.8-15.8 7.6-22.5 1.9s-7.6-15.8-1.9-22.5c37.6-44.6 60.2-102.1 60.2-165s-22.6-120.4-60.2-165c-5.7-6.8-4.8-16.8 1.9-22.5zM224 256a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm64 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM164.6 154.2C141.7 181.9 128 217.3 128 256s13.7 74.1 36.6 101.8c5.6 6.8 4.7 16.9-2.1 22.5s-16.9 4.7-22.5-2.1C112.5 345 96 302.4 96 256s16.5-89 43.9-122.2c5.6-6.8 15.7-7.8 22.5-2.1s7.8 15.7 2.1 22.5zm271.5-20.4C463.5 167 480 209.6 480 256s-16.5 89-43.9 122.2c-5.6 6.8-15.7 7.8-22.5 2.1s-7.8-15.7-2.1-22.5C434.3 330.1 448 294.7 448 256s-13.7-74.1-36.6-101.8c-5.6-6.8-4.7-16.9 2.1-22.5s16.9-4.7 22.5 2.1z"
        }
    ]
};

const FalSignalStrong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalStrong",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v384c0 8.8 7.2 16 16 16s16-7.2 16-16V112zm-144 80c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zM208 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16V304zM80 400c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96z"
        }
    ]
};

const FalSignalWeak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignalWeak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 384c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalSignal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignal",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M592 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v480c0 8.8 7.2 16 16 16s16-7.2 16-16V16zM448 96c-8.8 0-16 7.2-16 16v384c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zM336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16v288c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm-144 80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalSignatureLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignatureLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128c0-35.3 28.7-64 64-64s64 28.7 64 64v3.4c0 26.2-2.4 52.3-7.2 78L59 243.7c-34.8 9.5-59 41.1-59 77.2v92.6C0 450.2 29.8 480 66.5 480c24 0 46.2-13 57.9-33.9l27.1-48.1c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6L337.7 201l-48 96c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6h88.6c5.6-9.7 13.7-17.8 23.4-23.4V288h-86.1l52.4-104.8c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3l-145 39.5c3.4-22.7 5.2-45.7 5.2-68.7V128c0-53-43-96-96-96s-96 43-96 96v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48zm176 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h144v-32H240zM67.4 274.6l109.4-29.8-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4l-27.1 48.1c-6.1 10.9-17.6 17.6-30 17.6-19 0-34.5-15.4-34.5-34.5v-92.6c0-21.6 14.5-40.6 35.4-46.3zM528 224c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm160 80v128H448V352h160z"
        }
    ]
};

const FalSignatureSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignatureSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM378.8 384H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h83.4l-40.5-32zm85-96 40.5 32H560c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96.2zm162 127.9c8-.9 14.2-7.7 14.2-15.9 0-8.8-7.2-16-16-16h-38.6l40.4 31.9zM478.3 183.2c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3l-117 31.9 31.2 24.6 59.7-16.3-22.7 45.5 25.7 20.3 41.7-83.4zM320 131.4V128c0-53-43-96-96-96-22.2 0-42.6 7.5-58.9 20.2l26.3 20.7C201 67.2 212.1 64 224 64c35.3 0 64 28.7 64 64v3.4c0 5.8-.1 11.7-.4 17.5l30.5 24.1c1.3-13.8 1.9-27.7 1.9-41.6zM155 243.7c-34.8 9.5-59 41.1-59 77.2v92.6c0 36.7 29.8 66.5 66.5 66.5 24 0 46.2-13 57.9-33.9l27.1-48.1c15.6-27.7 28.7-56.8 39-86.9L259.8 290c-10.2 32-23.7 63-40.2 92.3l-27.1 48.1c-6.1 10.9-17.6 17.6-30.1 17.6-19 0-34.5-15.4-34.5-34.5v-92.6c0-21.6 14.5-40.6 35.4-46.3l57.2-15.6-31.2-24.7-34.3 9.4zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalSignature = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignature",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 128c0-35.3 28.7-64 64-64s64 28.7 64 64v3.4c0 26.2-2.4 52.3-7.2 78L155 243.7c-34.8 9.5-59 41.1-59 77.2v92.6c0 36.7 29.8 66.5 66.5 66.5 24 0 46.2-13 57.9-33.9l27.1-48.1c20.9-37.1 37.2-76.5 48.5-117.5l7.2-25.7c1.8-6.5 3.5-13 5-19.6L433.7 201l-48 96c-2.5 5-2.2 10.9.7 15.6s8.1 7.6 13.6 7.6h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H425.9l52.4-104.8c2.8-5.6 2.1-12.4-1.9-17.3s-10.5-7-16.6-5.3l-145 39.3c3.4-22.7 5.2-45.7 5.2-68.7V128c0-53-43-96-96-96s-96 43-96 96v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48zm3.4 146.6 109.4-29.8-.4 1.4-7.2 25.7c-10.7 38.5-26 75.6-45.6 110.4l-27.1 48.1c-6.1 10.9-17.6 17.6-30.1 17.6-19 0-34.5-15.4-34.5-34.5v-92.6c0-21.6 14.5-40.6 35.4-46.3zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm320 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H336z"
        }
    ]
};

const FalSignsPost = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSignsPost",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h168.3c4.9 0 9.5 2.2 12.5 6l51.2 64c4.7 5.8 4.7 14.1 0 20l-51.2 64c-3 3.8-7.6 6-12.5 6H272v32h176c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H272v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384H71.7c-4.9 0-9.5-2.2-12.5-6L8 314c-4.7-5.8-4.7-14.1 0-20l51.2-64c3-3.8 7.6-6 12.5-6H240v-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h176V16zm192.6 48H64v96h368.6l38.4-48-38.4-48zM79.4 256 41 304l38.4 48H448v-96H79.4z"
        }
    ]
};

const FalSimCard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSimCard",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V154.5c0-8.5-3.4-16.6-9.4-22.6l-90.5-90.5c-6-6-14.1-9.4-22.6-9.4H64c-17.7 0-32 14.3-32 32zM0 448V64C0 28.7 28.7 0 64 0h165.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64zm64-168v-40c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V280zm32 120c0 8.8 7.2 16 16 16h80v-40H96v24zm176 16c8.8 0 16-7.2 16-16v-24h-64v40h48zm-64-72h80v-48H96v48h112zm80-104c0-8.8-7.2-16-16-16h-80v40h96v-24zm-128-16h-48c-8.8 0-16 7.2-16 16v24h64v-40z"
        }
    ]
};

const FalSimCards = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSimCards",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 368c0 17.7 14.3 32 32 32h240c17.7 0 32-14.3 32-32V154.5c0-8.5-3.4-16.6-9.4-22.6l-90.5-90.5c-6-6-14.1-9.4-22.6-9.4H144c-17.7 0-32 14.3-32 32v304zM80 64c0-35.3 28.7-64 64-64h149.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V368c0 35.3-28.7 64-64 64H144c-35.3 0-64-28.7-64-64V64zM16 96c8.8 0 16 7.2 16 16v272c0 53 43 96 96 96h240c8.8 0 16 7.2 16 16s-7.2 16-16 16H128C57.3 512 0 454.7 0 384V112c0-8.8 7.2-16 16-16zm160 96v16h48v-32h-32c-8.8 0-16 7.2-16 16zm120 16h56v-16c0-8.8-7.2-16-16-16h-80v32h40zm0 32H176v32h176v-32h-56zm-8 64v32h48c8.8 0 16-7.2 16-16v-16h-64zm-56 0h-56v16c0 8.8 7.2 16 16 16h64v-32h-24zm-40-160h144c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48H192c-26.5 0-48-21.5-48-48V192c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FalSink = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSink",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 80c0-26.5 21.5-48 48-48s48 21.5 48 48v32c0 8.8 7.2 16 16 16s16-7.2 16-16V80c0-44.2-35.8-80-80-80s-80 35.8-80 80v208h-80v-16c0-26.5-21.5-48-48-48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16 7.2 16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16H384v-16c0-8.8 7.2-16 16-16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-26.5 0-48 21.5-48 48v16h-80V80zM32 352v48c0 61.9 50.1 112 112 112h224c61.9 0 112-50.1 112-112v-48h-32v48c0 44.2-35.8 80-80 80H144c-44.2 0-80-35.8-80-80v-48H32z"
        }
    ]
};

const FalSirenOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSirenOn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m55.2 33.7 64 32c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2l-64-32c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2zm544 28.6-64 32c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l64-32c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5zM16 192h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm544 0h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-68 128h-32.2l-20.5-164c-2-16-15.6-28-31.8-28h-175c-16.1 0-29.8 12-31.8 28l-20.5 164H148l21-167.9c4-32 31.2-56.1 63.5-56.1h175c32.3 0 59.5 24 63.5 56.1L492 320zm-250.1 0 14.2-114c1.1-8.8 9.1-15 17.9-13.9s15 9.1 13.9 17.9l-13.8 110h-32.2zM496 384H144c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-352-32h352c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FalSiren = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSiren",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M363.8 320H396l-21-167.9C371 120 343.8 96 311.5 96h-175C104.2 96 77 120 73 152.1L52 320h32.2l20.5-164c2-16 15.6-28 31.8-28h175c16.1 0 29.8 12 31.8 28l20.5 164zm-185.6 0L192 210c1.1-8.8-5.1-16.8-13.9-17.9s-16.8 5.1-17.9 13.9l-14.3 114h32.2zM48 384h352c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zM0 400v32c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48H48c-26.5 0-48 21.5-48 48z"
        }
    ]
};

const FalSitemap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSitemap",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h64zm-64 128h16v48H112c-26.5 0-48 21.5-48 48v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48H96v-32c0-8.8 7.2-16 16-16h160v48h-16c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-16v-48h160c8.8 0 16 7.2 16 16v32h-16c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48h-16v-32c0-26.5-21.5-48-48-48H304v-48h16c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48h-64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48zM48 352h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalSkeletonRibs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSkeletonRibs",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-49.9c-29.3 0-56.6 16-69.7 42.9-14.9 30.8-36.9 79.1-55.2 132C111 291.5 96 349.8 96 400v11.2c0 38 30.8 68.8 68.8 68.8 9.6 0 19.1-2 27.9-5.9l81.8-36.3c9.5-4.2 19.4-7 29.5-8.5V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-66.8c10.1 1.5 20 4.3 29.5 8.5l81.8 36.3c8.8 3.9 18.3 5.9 27.9 5.9 38 0 68.8-30.8 68.8-68.8V400c0-50.2-15-108.5-33.2-161.1-18.3-52.8-40.3-101.2-55.2-132C442.5 80 415.2 64 385.9 64H336V16zm-32 80v82.9l-127.8 25.5c13.3-33.2 26.8-62.5 37-83.5 7.4-15.3 23.2-24.9 40.9-24.9H304zM162.8 239.7l.3-.1L304 211.5V284l-168.2 49.1c5.7-27.4 14.1-55.9 23.7-83.7 1.1-3.2 2.3-6.5 3.4-9.7zM130 367.9c.8-.1 1.6-.3 2.4-.5l171.5-50V397c-14.5 1.6-28.9 5.5-42.5 11.5l-81.8 36.3c-4.7 2.1-9.8 3.2-14.9 3.2-20.3 0-36.8-16.5-36.8-36.8V400c0-10.3.7-21 2-32.1zM336 397v-79.7l171.5 50c.8.2 1.6.4 2.5.5 1.3 11.1 2 21.9 2 32.1v11.2c0 20.3-16.5 36.8-36.8 36.8-5.1 0-10.2-1.1-14.9-3.2l-81.8-36.3c-13.6-6.1-28-9.9-42.5-11.5zm168.2-63.9L336 284v-72.5l140.9 28.2.3.1c1.1 3.2 2.3 6.4 3.4 9.7 9.6 27.7 18 56.2 23.7 83.7zm-40.4-128.7L336 178.9V96h49.9c17.7 0 33.5 9.6 40.9 24.9 10.2 21 23.7 50.3 37 83.5zM0 128v368c0 8.8 7.2 16 16 16s16-7.2 16-16V240c0-8.6 4.9-16.6 12.6-20.4l44.5-22.2c23.8-11.9 38.9-36.3 38.9-63V128c0-35.3-28.7-64-64-64S0 92.7 0 128zm32 62.1V128c0-17.7 14.3-32 32-32s32 14.3 32 32v6.4c0 14.5-8.2 27.8-21.2 34.3L32 190.1zM576 64c-35.3 0-64 28.7-64 64v6.4c0 26.7 15.1 51 38.9 63l44.5 22.2c7.7 3.9 12.6 11.8 12.6 20.4v256c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-35.3-28.7-64-64-64zm-10.8 104.7c-13-6.5-21.2-19.8-21.2-34.3V128c0-17.7 14.3-32 32-32s32 14.3 32 32v62.1l-42.8-21.4z"
        }
    ]
};

const FalSkeleton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSkeleton",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c8.8 0 16 7.2 16 16v48h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v64h208c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v64h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H272v75.4l86.6-24.7c6.3-1.8 12.8-2.7 19.3-2.7 38.8 0 70.2 31.4 70.2 70.2v5.2c0 18.5-6.8 36.3-19 50.1l-26.9 30.2c-11.5 12.9-28 20.3-45.3 20.3H155.2c-17.3 0-33.8-7.4-45.3-20.3L83 461.4c-12.3-13.8-19-31.6-19-50.1v-5.2c0-38.8 31.4-70.2 70.2-70.2 6.5 0 13 .9 19.3 2.7l86.5 24.8V288H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h112v-64H32c-8.8 0-16-7.2-16-16s7.2-16 16-16h208V96H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h144V16c0-8.8 7.2-16 16-16zM96 406.2v5.2c0 10.6 3.9 20.9 11 28.8l26.9 30.2c5.4 6.1 13.2 9.6 21.4 9.6h201.5c8.2 0 15.9-3.5 21.4-9.6l26.8-30.2c7.1-7.9 11-18.2 11-28.8v-5.2c0-21.1-17.1-38.2-38.2-38.2-3.5 0-7.1.5-10.5 1.5l-93.8 26.8c-11.5 3.3-23.7 3.3-35.2 0l-93.8-26.8c-3.4-1-6.9-1.5-10.5-1.5-20.9 0-38 17.1-38 38.2zm64 25.8a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm152 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalSkiBootSki = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSkiBootSki",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M415.6 19.4c1.9-8.6-3.7-17.1-12.3-19s-17.1 3.7-19 12.3L380.2 32H168c-7.6 0-14.2 5.3-15.7 12.8L88.2 358.4c-6.1 29.8 16.7 57.6 47 57.6H432c26.5 0 48-21.5 48-48v-52.2c0-18.2-10.3-34.8-26.5-42.9l-83.2-41.6 45.3-211.9zM279.2 64h94.2l-20.6 96H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h41.9l-6.9 32h-51c-8.8 0-16 7.2-16 16s7.2 16 16 16h60.2l90.9 45.5c5.4 2.7 8.8 8.3 8.8 14.3V368c0 8.8-7.2 16-16 16H135.2c-10.1 0-17.7-9.3-15.7-19.2l25.2-123.3c43.6-20 107.6-67.2 134.4-177.5zm-33 0c-20.3 76-60 115.7-93 136.6L181.1 64h65.1zM640 416c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3-28.7 64-64 64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h528c53 0 96-43 96-96z"
        }
    ]
};

const FalSkiBoot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSkiBoot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M383.7 19.1c1.7-8.7-4-17.1-12.7-18.8s-17.1 4-18.8 12.7l-3.6 19H130.3c-22.9 0-42.7 16.2-47.1 38.7l-75.4 384C2 484.4 24.7 512 54.9 512H496c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-76.7c0-17.8-9.9-34.2-25.6-42.5L330 295.4l53.7-276.3zM239.4 64h103l-24.9 128H256c-8.8 0-16 7.2-16 16s7.2 16 16 16h55.3l-12.4 64H224c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c1.2 0 2.3-.1 3.4-.4l132.1 69.5c5.3 2.8 8.5 8.2 8.5 14.2V480H54.9c-10.1 0-17.6-9.2-15.7-19.1l32-163.1c55-23.2 134.1-82.9 168.2-233.8zm-32.9 0C178.6 180.4 122.7 233.7 79 258.4l35.6-181.5c1.5-7.5 8.1-12.9 15.7-12.9h76.2z"
        }
    ]
};

const FalSkullCow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSkullCow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M55.6 1.9c6.8 3.7 10 11.8 7.5 19.1L52 54.5c-2.5 7.5-3.4 15.4-2.6 23.2C52.3 106.3 76.3 128 105 128h79.4c17.6-19.6 43.2-32 71.6-32h128c28.4 0 54 12.4 71.6 32H535c28.7 0 52.7-21.7 55.6-50.3.8-7.8-.1-15.8-2.6-23.2l-11.2-33.4c-2.5-7.4.7-15.4 7.5-19.1s15.3-2 20.1 4.1l7.5 9.3c18.2 22.7 28 50.9 28 80V112c0 70.7-57.3 128-128 128H480v48c0 41.8-26.7 77.3-64 90.5l-26.4 87.9c-8.1 27.1-33 45.6-61.3 45.6h-16.7c-28.3 0-53.2-18.5-61.3-45.6L224 378.5c-37.3-13.2-64-48.7-64-90.5v-48h-32C57.3 240 0 182.7 0 112V95.3c0-29.1 9.9-57.3 28-80L35.5 6c4.8-6 13.3-7.8 20.1-4.1zM480 208h32c49.7 0 90.6-37.8 95.5-86.3C591.6 145 564.9 160 535 160h-60.5c3.5 10 5.5 20.8 5.5 32v16zm-375-48c-29.9 0-56.6-15-72.5-38.3C37.4 170.2 78.3 208 128 208h32v-16c0-11.2 1.9-22 5.5-32H105zm129.6 188.4c9.6 3.4 17 11.2 20 21l26.4 87.8c4.1 13.5 16.5 22.8 30.7 22.8h16.8c14.1 0 26.6-9.3 30.7-22.8l26.4-87.9c2.9-9.8 10.4-17.6 20-21 24.9-8.8 42.6-32.6 42.6-60.4V192c0-35.3-28.7-64-64-64H256c-35.3 0-64 28.7-64 64v96c0 27.8 17.7 51.5 42.6 60.4zM232 256a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalSkullCrossbones = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSkullCrossbones",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M300.1 198.4c-7.6 6.1-12.1 15.3-12.1 25V240c0 8.8-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16v-16.6c0-9.8-4.4-19-12.1-25C125.1 180.2 112 155 112 128c0-49.6 46.5-96 112-96s112 46.4 112 96c0 27-13.1 52.2-35.9 70.4zM320 240v-16.6c29.5-23.4 48-57.5 48-95.4C368 57.3 303.5 0 224 0S80 57.3 80 128c0 37.9 18.5 72 48 95.4V240c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48zm126.5 57.3c-3.7-8-13.2-11.5-21.2-7.8L224 382.4 22.7 289.5c-8-3.7-17.5-.2-21.2 7.8s-.2 17.5 7.8 21.2L185.8 400 9.3 481.5c-8 3.7-11.5 13.2-7.8 21.2s13.2 11.5 21.2 7.8L224 417.6l201.3 92.9c8 3.7 17.5.2 21.2-7.8s.2-17.5-7.8-21.2L262.2 400l176.5-81.5c8-3.7 11.5-13.2 7.8-21.2zM208 136a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalSkull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSkull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 399.6c-.2-10.7 4.9-20.8 13.6-26.9 51.3-36 82.4-89.8 82.4-148.7 0-102.2-96.1-192-224-192S32 121.8 32 224c0 58.8 31.1 112.7 82.4 148.7 8.8 6.1 13.9 16.2 13.6 26.9V464c0 8.8 7.2 16 16 16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h48c8.8 0 16-7.2 16-16v-64.4zm32-.7V464c0 26.5-21.5 48-48 48H144c-26.5 0-48-21.5-48-48v-65.1C37.5 357.8 0 294.7 0 224 0 100.3 114.6 0 256 0s256 100.3 256 224c0 70.7-37.5 133.8-96 174.9zM160 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm224 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalSlashBack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSlashBack",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M7.8 2.3c-7.6 4.5-10 14.4-5.5 22l288 480c4.5 7.6 14.4 10 22 5.5s10-14.4 5.5-22L29.7 7.8c-4.5-7.6-14.4-10-22-5.5z"
        }
    ]
};

const FalSlashForward = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSlashForward",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312.2 2.3c7.6 4.5 10 14.4 5.5 22l-288 480c-4.5 7.6-14.4 10-22 5.5s-10-14.4-5.5-22l288-480c4.5-7.6 14.4-10 22-5.5z"
        }
    ]
};

const FalSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5S621 514 614 508.5L6.1 28.6C-.8 23.1-2 13 3.4 6.1z"
        }
    ]
};

const FalSleigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSleigh",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h16v192c0 59.6 40.8 109.8 96 124v68H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h520c39.8 0 72-32.2 72-72v-24c0-8.8-7.2-16-16-16s-16 7.2-16 16v24c0 22.1-17.9 40-40 40H448v-64c70.7 0 128-57.3 128-128V128h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H488c-22.1 0-40 17.9-40 40v35.8c0 28.8-23.4 52.2-52.2 52.2-72 0-139-37.1-177.1-98.2l-7.2-11.5C179.6 63.4 124 32.4 64 32H16zm400 416H160v-64h256v64zm72-320h56v128c0 53-43 96-96 96H160c-53 0-96-43-96-96V64c48.9.4 94.3 25.7 120.3 67.2l7.2 11.5c44 70.5 121.2 113.3 204.3 113.3 46.5 0 84.2-37.7 84.2-84.2V136c0-4.4 3.6-8 8-8z"
        }
    ]
};

const FalSlider = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSlider",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 128c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h32zm-32-32c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h32c35.3 0 64-28.7 64-64v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-80c0-35.3-28.7-64-64-64h-32zM0 256c0 8.8 7.2 16 16 16h208v-32H16c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalSlidersSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSlidersSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 320a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm78.4 32H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H158.4c-7.4 36.5-39.7 64-78.4 64-44.2 0-80-35.8-80-80s35.8-80 80-80c38.7 0 71 27.5 78.4 64zM384 144a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-30.4-16c7.4-36.5 39.7-64 78.4-64 44.2 0 80 35.8 80 80s-35.8 80-80 80c-38.7 0-71-27.5-78.4-64H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h337.6z"
        }
    ]
};

const FalSlidersUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSlidersUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0c8.8 0 16 7.2 16 16v65.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V238.4C43.5 231 16 198.7 16 160s27.5-71 64-78.4V16c0-8.8 7.2-16 16-16zm0 208a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm160 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80-48c0 38.7-27.5 71-64 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-65.6c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16v257.6c36.5 7.4 64 39.7 64 78.4zm128-160a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-32 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V270.4c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V16c0-8.8 7.2-16 16-16s16 7.2 16 16v97.6c36.5 7.4 64 39.7 64 78.4s-27.5 71-64 78.4z"
        }
    ]
};

const FalSliders = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSliders",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 416c0 8.8 7.2 16 16 16h65.6c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H238.4c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64H16c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm192-160a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm48-80c-38.7 0-71 27.5-78.4 64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h257.6c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H496c8.8 0 16-7.2 16-16s-7.2-16-16-16h-65.6c-7.4-36.5-39.7-64-78.4-64zm-160-32a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64H16C7.2 80 0 87.2 0 96s7.2 16 16 16h97.6c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H270.4z"
        }
    ]
};

const FalSlotMachine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSlotMachine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 416v32c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-32h320zm23.4 64c5.4-9.4 8.6-20.3 8.6-32v-32c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v32c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64v32c0 35.3 28.7 64 64 64h400c44.2 0 80-35.8 80-80V221.3c18.6-6.6 32-24.4 32-45.3 0-26.5-21.5-48-48-48s-48 21.5-48 48c0 20.9 13.4 38.7 32 45.3V432c0 26.5-21.5 48-48 48h-88.6zM576 176a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM416 64v32H96V64c0-17.7 14.3-32 32-32h256c17.7 0 32 14.3 32 32zm32 64c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h384zm-336 48c-8.8 0-16 7.2-16 16s7.2 16 16 16h40.9L113 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9h-64zm120 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h40.9L233 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9h-64zm120 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h40.9L353 314.4c-3.1 8.3 1.1 17.5 9.4 20.6s17.5-1.1 20.6-9.4l48-128c1.8-4.9 1.2-10.4-1.8-14.7s-7.9-6.9-13.2-6.9h-64z"
        }
    ]
};

const FalSmog = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSmog",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0C96.5 0 32 64.5 32 144s64.5 144 144 144h123.3c22.6 19.9 52.2 32 84.7 32s62.1-12.1 84.7-32H496c61.9 0 112-50.1 112-112S557.9 64 496 64c-10.7 0-21 1.5-30.8 4.3C443.8 27.7 401.1 0 352 0c-32.7 0-62.5 12.2-85.1 32.3C242.2 12.1 210.5 0 176 0zM64 144c0-61.9 50.1-112 112-112 31.4 0 59.7 12.9 80.1 33.7 3.1 3.2 7.4 4.9 11.9 4.8s8.7-2.1 11.6-5.5c17.6-20.2 43.5-33 72.4-33 41 0 76.1 25.7 89.8 62 1.6 4.1 4.8 7.4 8.8 9.1s8.7 1.6 12.7-.2c10-4.5 21-7 32.7-7 44.2 0 80 35.8 80 80s-35.8 80-80 80h-33.6c-4.2 0-8.2 1.6-11.2 4.6-17.3 17-41 27.4-67.2 27.4s-49.9-10.4-67.2-27.4c-3-2.9-7-4.6-11.2-4.6H176c-61.9 0-112-50.1-112-112zm16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H272zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"
        }
    ]
};

const FalSmoke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSmoke",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c-53 0-96 43-96 96 0 28.1 12 53.3 31.2 70.8-11.2 3.2-21.9 7.5-32.1 12.8C43.7 189.2 32 160 32 128 32 57.3 89.3 0 160 0c40.1 0 75.9 18.4 99.3 47.3C277.4 37.5 298.1 32 320 32c44.3 0 83.4 22.5 106.4 56.8-9.1 5.8-17.5 12.4-25.3 19.8-17-26.8-47-44.6-81.1-44.6-20.8 0-40 6.6-55.7 17.8-3.6 2.6-8.1 3.5-12.4 2.7s-8.1-3.5-10.4-7.2C224.5 50 194.3 32 160 32zm-16 224c-61.9 0-112 50.1-112 112s50.1 112 112 112h320c44.2 0 80-35.8 80-80s-35.8-80-80-80c-11.7 0-22.7 2.5-32.7 7-4 1.8-8.6 1.9-12.7.2s-7.3-5-8.8-9.1c-13.7-36.3-48.8-62-89.8-62-28.9 0-54.8 12.8-72.4 33-2.9 3.4-7.1 5.4-11.6 5.5s-8.8-1.6-11.9-4.8C203.7 268.9 175.4 256 144 256zM0 368c0-79.5 64.5-144 144-144 34.5 0 66.2 12.1 90.9 32.3 22.6-20.1 52.4-32.3 85.1-32.3 49.1 0 91.8 27.7 113.2 68.3 9.8-2.8 20.1-4.3 30.8-4.3 61.9 0 112 50.1 112 112s-50.1 112-112 112H144C64.5 512 0 447.5 0 368zm608-144c0-53-43-96-96-96-41.3 0-76.6 26.1-90.1 62.8-2 5.4-6.7 9.3-12.4 10.3s-11.4-1.2-15-5.7C376.8 173.8 350 160 320 160c-38.7 0-72.1 22.9-87.3 56-9.2-5.4-18.9-9.9-29-13.6C224 158.5 268.4 128 320 128c31.4 0 60.1 11.3 82.3 30 22.4-37.1 63.1-62 109.7-62 70.7 0 128 57.3 128 128 0 42.2-20.4 79.6-51.9 102.9-5.5-9.2-11.9-17.8-19.2-25.6 23.7-17.4 39.1-45.6 39.1-77.3z"
        }
    ]
};

const FalSmoking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSmoking",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 0c-8.8 0-16 7.2-16 16v27c0 46.7 18.5 91.4 51.5 124.5l21 21c15 15 23.4 35.4 23.4 56.6v27c0 8.8 7.2 16 16 16s16-7.2 16-16V245c0-29.7-11.8-58.2-32.8-79.2l-21-21C495.2 117.8 480 81.2 480 43V16c0-8.8-7.2-16-16-16zm160 288c8.8 0 16-7.2 16-16v-27c0-46.7-18.5-91.4-51.5-124.5l-21-21C552.4 84.5 544 64.2 544 43V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v27c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v27c0 8.8 7.2 16 16 16zM64 384h128v96H64c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32zm160 0h256v96H224v-96zM64 512h432c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H64c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64zm496-160c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-8.8-7.2-16-16-16zm64 0c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalSnake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSnake",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M293.9 88H180c-64.1 0-116 51.9-116 116s51.9 116 116 116h164c30.9 0 56 25.1 56 56s-25.1 56-56 56H115.2c-8.4 0-16.8 1.7-24.6 4.9L44.8 456l45.8 19.1c7.8 3.3 16.2 4.9 24.6 4.9H344c57.4 0 104-46.6 104-104s-46.6-104-104-104H180c-37.6 0-68-30.4-68-68s30.4-68 68-68h109.1l9.5 14.2c14.1 21.1 37.7 33.8 63.1 33.8h4.5c12.3 0 24.5-2.7 35.6-7.9l53.2-24.8c15.3-7.1 25-22.5 25-39.3s-9.8-32.2-25-39.3l-54.5-25.4C390.2 42.5 379 40 367.7 40c-25.8 0-49.9 12.8-64.2 34L294 88zM176 512h-60.8c-12.7 0-25.2-2.5-36.9-7.4l-63.5-26.4C5.8 474.4 0 465.7 0 456s5.8-18.4 14.8-22.2l63.5-26.5c11.7-4.9 24.2-7.4 36.9-7.4H344c13.3 0 24-10.7 24-24s-10.7-24-24-24H180C98.3 352 32 285.7 32 204S98.3 56 180 56h97c20.3-29.9 54.2-48 90.7-48 16 0 31.9 3.5 46.4 10.3l54.4 25.4C495 56.1 512 82.7 512 112s-17 55.9-43.5 68.3l-53.1 24.8c-8.7 4-17.8 7-27.1 8.8-7.2 1.4-14.6 2.1-22 2.1h-4.5c-6 0-11.9-.5-17.7-1.5-8-1.3-15.7-3.5-23.1-6.5-19.7-8-36.8-21.8-48.9-40H180c-19.9 0-36 16.1-36 36s16.1 36 36 36h164c6 0 11.9.4 17.7 1.1 1.5.2 3 .4 4.5.7 6.8 1.1 13.5 2.8 19.9 4.8 54.5 17.8 93.9 69 93.9 129.4 0 75.1-60.9 136-136 136H176zM352 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalSnooze = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSnooze",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4L214.6 128H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4L265.4 32H176zM0 240c0-8.8 7.2-16 16-16h192c6.1 0 11.6 3.4 14.3 8.8s2.1 11.9-1.5 16.8L48 480h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-6.1 0-11.6-3.4-14.3-8.8s-2.1-11.9 1.5-16.8L176 256H16c-8.8 0-16-7.2-16-16zm304-16h128c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9L337.3 384H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H304c-6.2 0-11.8-3.5-14.4-9.1s-1.9-12.1 1.9-16.9l107.2-134H304c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSnowBlowing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSnowBlowing",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v41.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l43.3 43.3v61.7l-53.4-30.8-15.9-59.2c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11.1-11.3 19.6l7.6 28.3-35.8-20.8c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l35.8 20.7-28.3 7.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l59.2-15.9L144 256l-53.4 30.8L31.4 271c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l28.3 7.6-35.8 20.6c-7.7 4.5-10.3 14.2-5.9 21.9s14.2 10.3 21.9 5.9l35.8-20.7-7.6 28.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l15.9-59.2 53.4-30.9v61.7l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l20.7-20.7V432c0 8.8 7.2 16 16 16s16-7.2 16-16v-41.4l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L192 345.4v-61.7l53.4 30.8 15.9 59.2c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-7.6-28.3 35.8 20.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-35.8-20.7 28.3-7.6c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-59.2 15.9L208 256l53.4-30.8 59.2 15.8c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-28.3-7.6 35.8-20.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-35.8 20.7 7.6-28.3c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-15.9 59.2-53.4 31v-61.7l43.3-43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 121.4V80zm288 0c0 8.8 7.2 16 16 16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c44.2 0 80-35.8 80-80s-35.8-80-80-80h-64c-8.8 0-16 7.2-16 16zm0 352c0 8.8 7.2 16 16 16h64c44.2 0 80-35.8 80-80s-35.8-80-80-80H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c26.5 0 48 21.5 48 48s-21.5 48-48 48h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalSnowflakeDroplets = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSnowflakeDroplets",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v73.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l59.3 59.3v93.7l-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11.1-11.3 19.6l13.4 50.1-63.5-36.7c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7-50.1 13.3c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l81-21.7L288 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3s2.7 17.3 11.3 19.6l50.1 13.4-45.1 26 14.6 28.6 46.5-26.8-13.4 50.1c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81 81.1-46.9v93.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-73.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L336 377.4v-93.7l81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1 46.5 26.9 14.7-28.5-45.1-26 50-13.5c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L352 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81-81.1 46.9v-93.7l59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L336 89.4V16zm240 361.5 28.4 55.2c2.3 4.5 3.6 9.7 3.6 14.9 0 17.9-14.5 32.3-32 32.3s-32-14.4-32-32.3c0-5.2 1.2-10.4 3.6-14.9l28.4-55.2zm-18-35-38.9 75.6c-4.7 9.1-7.1 19.3-7.1 29.5 0 35.3 28.7 64.3 64 64.3s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L594 342.5l-.1-.1-1.9-3.7-6.7-13c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7l-6.7 13-1.9 3.7-.1.1zM35.6 432.8 64 377.5l28.4 55.2c2.3 4.5 3.6 9.7 3.6 14.9 0 18-14.5 32.4-32 32.4s-32-14.4-32-32.3c0-5.2 1.2-10.4 3.6-14.9zM7.1 418.1C2.4 427.2 0 437.4 0 447.7 0 483 28.7 512 64 512s64-29 64-64.3c0-10.2-2.4-20.4-7.1-29.5L82 342.5l-.1-.1-1.9-3.7-6.7-13c-1.8-3.5-5.4-5.7-9.3-5.7s-7.5 2.2-9.3 5.7l-6.7 13-1.9 3.7-.1.1-38.9 75.6z"
        }
    ]
};

const FalSnowflake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSnowflake",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v73.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l59.3 59.3v93.7l-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11-11.3 19.5l13.4 50.1-63.5-36.7c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7L21.6 200C13 202.3 8 211 10.3 219.6s11.1 13.6 19.6 11.3l81-21.7L192 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S13 309.7 21.6 312l50.1 13.4-63.5 36.7C.5 366.6-2.1 376.3 2.3 384s14.2 10.3 21.9 5.9l63.5-36.7-13.4 50.1c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81 81.1-46.9v93.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-73.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 377.4v-93.7l81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1 63.5 36.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-63.5-36.7 50.1-13.3c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L256 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81-81.1 46.9v-93.7l59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 89.4V16z"
        }
    ]
};

const FalSnowflakes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSnowflakes",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 4.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L513.4 56l-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L536 78.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L558.6 56l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L536 33.4 507.3 4.7zM240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v73.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l59.3 59.3v93.7l-81.1-46.8-21.7-81c-2.3-8.5-11.1-13.6-19.6-11.3s-13.6 11-11.3 19.5l13.4 50.1-63.6-36.7c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l63.5 36.7-50 13.4C13 202.3 8 211 10.3 219.6s11.1 13.6 19.6 11.3l81-21.7L192 256l-81.1 46.8-81-21.7c-8.5-2.3-17.3 2.8-19.6 11.3S13 309.7 21.6 312l50.1 13.4-63.6 36.7C.5 366.6-2.1 376.3 2.3 384s14.2 10.3 21.9 5.9l63.5-36.7-13.4 50.1c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l21.7-81 81.1-46.9v93.7l-59.3 59.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-73.4l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L240 377.4v-93.7l81.1 46.8 21.7 81c2.3 8.5 11.1 13.6 19.6 11.3s13.6-11.1 11.3-19.6l-13.4-50.1 63.5 36.7c7.7 4.4 17.4 1.8 21.9-5.9s1.8-17.4-5.9-21.9l-63.5-36.7 50.1-13.3c8.5-2.3 13.6-11.1 11.3-19.6s-11.1-13.6-19.6-11.3l-81 21.7L256 256l81.1-46.8 81 21.7c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6l-50.1-13.4 63.5-36.7c7.7-4.4 10.3-14.2 5.9-21.9s-14.2-10.3-21.9-5.9l-63.5 36.7 13.4-50.1c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-21.7 81-81.1 46.9v-93.7l59.3-59.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 89.4V16zm292.7 196.7c-6.2 6.2-6.2 16.4 0 22.6l28.7 28.7-28.7 28.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l28.7-28.7 28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L606.6 264l28.7-28.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L584 241.4l-28.7-28.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalSnowmanHead = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSnowmanHead",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32h192c17.7 0 32 14.3 32 32v96h32V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v96h32V64c0-17.7 14.3-32 32-32zm224 192h.7C382 255.4 400 297.6 400 344c0 52-22.5 98.8-58.5 131-3 2.7-8.3 5-15.8 5H122.2c-7.5 0-12.7-2.2-15.8-5C70.5 442.8 48 396 48 344c0-46.4 17.9-88.6 47.3-120H352zM16 192c-8.8 0-16 7.2-16 16s7.2 16 16 16h38.1C30.1 257.9 16 299.3 16 344c0 61.5 26.7 116.8 69.1 154.8 10.1 9.1 23.6 13.2 37.1 13.2h203.6c13.6 0 27-4.1 37.1-13.2 42.4-38 69.1-93.3 69.1-154.8 0-44.7-14.1-86.1-38.1-120H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm128 136a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-104 16c-26.5 0-48 21.5-48 48v1c0 6.9 1.4 13.6 4.2 19.9l29.2 65.6c2.6 5.8 8.3 9.5 14.6 9.5s12.1-3.7 14.6-9.5l29.2-65.6c2.8-6.3 4.2-13 4.2-19.9v-1c0-26.5-21.5-48-48-48zm-16 48c0-8.8 7.2-16 16-16s16 7.2 16 16v1c0 2.4-.5 4.7-1.5 6.9L224 408.6l-14.5-32.7c-1-2.2-1.5-4.5-1.5-6.9v-1z"
        }
    ]
};

const FalSnowman = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSnowman",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-61.9 0-112 50.1-112 112 0 17.6 4 34.2 11.3 49-5.7 7.3-10.7 15.2-14.7 23.6L96 169.8V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v47.1l-42.9-14.3C12.7 142 3.6 146.6.8 154.9s1.7 17.4 10.1 20.2L130.4 215c-1.6 8.1-2.4 16.4-2.4 25 0 14 2.2 27.4 6.4 40C110.5 308 96 344.3 96 384c0 41.2 15.6 78.8 41.2 107.2 13.7 15.2 33.2 20.8 51 20.8h135.7c17.8 0 37.3-5.7 51-20.8 25.6-28.4 41.2-66 41.2-107.2 0-39.7-14.5-76-38.4-104 4.1-12.6 6.4-26.1 6.4-40 0-8.5-.8-16.9-2.4-25l119.5-39.8c8.4-2.8 12.9-11.9 10.1-20.2s-11.9-12.9-20.2-10.1L448 159.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v57.8l-44.6 14.9c-4.1-8.4-9-16.4-14.7-23.6 7.2-14.8 11.3-31.5 11.3-49C368 50.1 317.9 0 256 0zm-80 112c0-44.2 35.8-80 80-80s80 35.8 80 80c0 15.6-4.5 30.2-12.2 42.5-3.9 6.2-3.1 14.2 1.9 19.5 16.3 17.2 26.3 40.4 26.3 66 0 13.3-2.7 25.9-7.5 37.3-2.5 5.9-1.2 12.8 3.3 17.4 22.4 23.1 36.2 54.6 36.2 89.3 0 33-12.5 63-32.9 85.7-5.9 6.6-15.6 10.3-27.2 10.3H188.1c-11.6 0-21.3-3.7-27.2-10.3C140.5 447 128 417 128 384c0-34.7 13.8-66.2 36.3-89.3 4.5-4.6 5.8-11.5 3.3-17.4-4.8-11.5-7.5-24.1-7.5-37.3 0-25.6 10-48.8 26.3-66 5-5.3 5.8-13.3 1.9-19.5-7.8-12.3-12.3-26.9-12.3-42.5zm96 128a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16 64a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-48-288a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 43.2c0 3.2.8 6.3 2.3 9l9 16.9c.9 1.7 2.7 2.8 4.7 2.8s3.8-1.1 4.7-2.8l9-16.9c1.5-2.8 2.3-5.9 2.3-9V136c0-8.8-7.2-16-16-16s-16 7.2-16 16v3.2z"
        }
    ]
};

const FalSnowplow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSnowplow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c0-17.7 14.3-32 32-32h138.9c19.2 0 36.6 11.4 44.1 29.1l85.1 198.6c2.6 6 3.9 12.4 3.9 18.9V288h96v-48c0-3.7 1.3-7.4 3.7-10.2l80-96c5.7-6.8 15.7-7.7 22.5-2s7.7 15.7 2 22.5L560 245.8v148.4l76.3 91.5c5.7 6.8 4.7 16.9-2 22.5s-16.9 4.7-22.5-2l-80-96c-2.4-2.9-3.7-6.5-3.7-10.2v-80h-81.7c20.7 20.3 33.6 48.7 33.6 80 0 61.9-50.1 112-112 112H112C50.1 512 0 461.9 0 400c0-44.7 26.2-83.2 64-101.2V168c0-22.1 17.9-40 40-40h24V32zm272 224H208c-5.3 0-10.3-2.7-13.3-7.1L135.4 160H104c-4.4 0-8 3.6-8 8v121.1c5.2-.7 10.6-1.1 16-1.1h256c11.1 0 21.9 1.6 32 4.6V256zM160 139.2l56.6 84.8h175.1L313.6 41.7c-2.5-5.9-8.3-9.7-14.7-9.7H160v107.2zM368 320H112c-44.2 0-80 35.8-80 80s35.8 80 80 80h256c44.2 0 80-35.8 80-80s-35.8-80-80-80zm-248 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm104-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalSoap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSoap",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM96 192h129.3c1.9 11.5 5.9 22.3 11.5 32H96c-35.3 0-64 28.7-64 64v128c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V288c0-35.3-28.7-64-64-64h-12.8c5.6-9.7 9.6-20.5 11.5-32h1.3c53 0 96 43 96 96v128c0 53-43 96-96 96H96c-53 0-96-43-96-96V288c0-53 43-96 96-96zm64 80h192c44.2 0 80 35.8 80 80s-35.8 80-80 80H160c-44.2 0-80-35.8-80-80s35.8-80 80-80zm-48 80c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48s-21.5-48-48-48H160c-26.5 0-48 21.5-48 48zM400 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-48 176a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalSocks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSocks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M140.8 465.9C129 475 114.4 480 99.5 480H96c-35.3 0-64-28.7-64-64 0-20.1 9.5-39.1 25.6-51.2l57.6-43.2c28.2-21.2 44.8-54.3 44.8-89.6V128h128V96H160V48c0-8.8 7.2-16 16-16h113.6C292 20.2 297 9.4 303.9.1c-1-.1-2-.1-3-.1H176c-26.5 0-48 21.5-48 48v184c0 25.2-11.9 48.9-32 64l-57.6 43.2C14.2 357.3 0 385.8 0 416c0 53 43 96 96 96h3.5c22 0 43.4-7.3 60.8-20.8l16.1-12.4c-5.4-9.6-9.6-19.9-12.4-30.8l-23.2 17.9zM368 0c-26.5 0-48 21.5-48 48v184c0 25.2-11.9 48.9-32 64l-57.6 43.2C206.2 357.3 192 385.8 192 416c0 53 43 96 96 96h3.5c22 0 43.4-7.3 60.8-20.8l116.1-89.7c27.4-21.2 43.5-53.9 43.5-88.6V48c0-26.5-21.5-48-48-48H368zm-16 48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v48H352V48zm0 80h128v184.9c0 24.8-11.5 48.2-31.1 63.3l-116.1 89.7C321 475 306.4 480 291.5 480H288c-35.3 0-64-28.7-64-64 0-20.1 9.5-39.1 25.6-51.2l57.6-43.2c28.2-21.2 44.8-54.3 44.8-89.6V128z"
        }
    ]
};

const FalSoftServe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSoftServe",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 0c-5.9 0-11.3 3.2-14.1 8.5s-2.5 11.5.8 16.4l10.8 16.3c1.6 2.4 2.5 5.3 2.5 8.2 0 8.1-6.6 14.7-14.7 14.7H116c-37.6 0-68 30.4-68 68 0 11.5 2.8 22.2 7.8 31.7C23.5 174 0 204.2 0 240c0 32.8 19.7 61 48 73.3V352c0 22.2 15.1 41 35.7 46.4l8.9 71.6c3 24 23.4 42 47.6 42h103.6c24.2 0 44.6-18 47.6-42l8.9-71.6C320.9 393 336 374.2 336 352v-38.7c28.3-12.3 48-40.5 48-73.3 0-37.2-25.4-68.5-59.8-77.4 7.5-12.1 11.8-26.3 11.8-41.6C336 54.2 281.8 0 215 0h-23zm112 288H80c-26.5 0-48-21.5-48-48s21.5-48 48-48h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H93.4c-8.2-6.6-13.4-16.7-13.4-28 0-19.9 16.1-36 36-36h61.3c25.8 0 46.7-20.9 46.7-46.7 0-5.9-1.1-11.7-3.2-17.1 46.5 3 83.2 41.6 83.2 88.8 0 16.2-8.2 30.5-20.8 39H240c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48zM80 320h224v32c0 8.8-7.2 16-16 16h-2c-8.1 0-14.9 6-15.9 14l-10.5 84c-1 8-7.8 14-15.9 14H140.2c-8.1 0-14.9-6-15.9-14l-10.5-84c-1-8-7.8-14-15.9-14H96c-8.8 0-16-7.2-16-16v-32z"
        }
    ]
};

const FalSolarPanel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSolarPanel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M221.2 0h312.3c26.9 0 50 19.1 55 45.6L613.2 176l3 16L639 312.6c1 5.1 1 10.2 1 15.4 0 30.9-25.1 56-56 56H336v96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16h96v-96H56c-30.9 0-56-25.1-56-56 0-5.2 0-10.3 1-15.4L23.8 192l3-16L51.5 45.6c5-26.5 28.1-45.6 55-45.6h114.7zM304 352h113.2l-12.5-144H235.3l-12.5 144H304zM250.5 32l-12.4 144h163.8L389.5 32h-139zm186.3 176 12.5 144H584c13.3 0 24-10.7 24-24 0-5.6-.1-7.8-.4-9.5L586.7 208H436.8zm-2.8-32h146.6L557.1 51.5C554.9 40.2 545 32 533.5 32H421.6L434 176zm-230.8 32H53.3L32.4 318.5c-.3 1.7-.4 3.9-.4 9.5 0 13.3 10.7 24 24 24h134.7l12.5-144zm2.8-32 12.4-144H106.5C95 32 85.1 40.2 82.9 51.5L59.4 176H206z"
        }
    ]
};

const FalSolarSystem = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSolarSystem",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256c0 123.7 100.3 224 224 224 31.4 0 61.4-6.5 88.5-18.2 4.2 8.8 9.9 17.1 17.3 24.4.7.7 1.4 1.4 2.1 2C331.1 503.5 294.5 512 256 512 114.6 512 0 397.4 0 256c0-50.9 14.9-98.4 40.5-138.3C35.1 109.1 32 98.9 32 88c0-30.9 25.1-56 56-56 10.9 0 21.1 3.1 29.7 8.5 3.5 2.2 6.8 4.8 9.7 7.7l.2.2L139 64.9c-2.8-6.1-6.6-11.7-11.3-16.4 4.9 4.9 8.6 10.5 11.3 16.4 3.2 7 5 14.8 5 23.1 0 30.9-25.1 56-56 56-8.2 0-16-1.8-23.1-5C44 173.1 32 213.1 32 256zm362.3 215.5c-3.5-2.2-6.8-4.8-9.9-7.9l-.1-.1c-4.9-4.9-8.6-10.5-11.3-16.4-3.2-7-5-14.9-5-23.1 0-30.9 25.1-56 56-56 8.2 0 16 1.8 23.1 5C468 339 480 298.9 480 256c0-123.7-100.3-224-224-224-31.4 0-61.4 6.5-88.5 18.2-4.2-8.8-10-17.1-17.3-24.4-.7-.7-1.4-1.4-2.1-2C180.9 8.5 217.5 0 256 0c141.4 0 256 114.6 256 256 0 50.9-14.9 98.4-40.5 138.3 5.4 8.6 8.5 18.8 8.5 29.7 0 30.9-25.1 56-56 56-10.9 0-21.1-3.1-29.7-8.5zM112 88a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm253.5 101.7c-4.2 1.5-8.8 2.3-13.5 2.3-22.1 0-40-17.9-40-40 0-3.6.5-7.1 1.4-10.4-17.3-8.7-36.8-13.6-57.4-13.6-70.7 0-128 57.3-128 128s57.3 128 128 128 128-57.3 128-128c0-24.3-6.8-47-18.5-66.3zm23.5-22.6c17 25.4 27 56 27 88.9 0 88.4-71.6 160-160 160S96 344.4 96 256 167.6 96 256 96c28.3 0 54.9 7.4 78 20.3 5.4-2.7 11.5-4.3 18-4.3 22.1 0 40 17.9 40 40 0 5.3-1 10.4-3 15.1zM208 256a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160zm168 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalSortDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSortDown",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154.4 445.8c1.4 1.3 3.5 2.2 5.6 2.2s4.2-.8 5.6-2.2l120.2-113.5c1.4-1.3 2.2-3.2 2.2-5.2 0-3.9-3.2-7.1-7.1-7.1H39.1c-3.9 0-7.1 3.2-7.1 7.1 0 2 .8 3.8 2.2 5.2l120.2 113.5zm-22 23.3L12.3 355.6C4.4 348.2 0 337.9 0 327.1 0 305.5 17.5 288 39.1 288h241.8c21.6 0 39.1 17.5 39.1 39.1 0 10.8-4.4 21.1-12.3 28.5L187.6 469.1c-7.4 7-17.3 10.9-27.6 10.9s-20.1-3.9-27.6-10.9z"
        }
    ]
};

const FalSortUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSortUp",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2.8 5.6 2.2l120.2 113.5c1.4 1.3 2.2 3.2 2.2 5.2 0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1 0-2 .8-3.8 2.2-5.2L154.4 66.2zm-22-23.3L12.3 156.4C4.4 163.8 0 174.1 0 184.9 0 206.5 17.5 224 39.1 224h241.8c21.6 0 39.1-17.5 39.1-39.1 0-10.8-4.4-21.1-12.3-28.5L187.6 42.9c-7.5-7-17.4-10.9-27.6-10.9s-20.1 3.9-27.6 10.9z"
        }
    ]
};

const FalSort = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSort",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M34.2 179.7 154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2.8 5.6 2.2l120.2 113.5c1.4 1.3 2.2 3.2 2.2 5.2 0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1 0-2 .8-3.8 2.2-5.2zm-22-23.3C4.4 163.8 0 174.1 0 184.9 0 206.5 17.5 224 39.1 224h241.8c21.6 0 39.1-17.5 39.1-39.1 0-10.8-4.4-21.1-12.3-28.4L187.6 42.9c-7.5-7-17.4-10.9-27.6-10.9s-20.1 3.9-27.6 10.9L12.3 156.4zm22 175.9c-1.4-1.3-2.2-3.2-2.2-5.2 0-3.9 3.2-7.1 7.1-7.1h241.8c3.9 0 7.1 3.2 7.1 7.1 0 2-.8 3.8-2.2 5.2L165.6 445.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 332.3zm-22 23.3 120.2 113.5c7.4 7 17.4 10.9 27.6 10.9s20.1-3.9 27.6-10.9l120.1-113.5c7.8-7.4 12.3-17.7 12.3-28.5 0-21.6-17.5-39.1-39.1-39.1H39.1C17.5 288 0 305.5 0 327.1c0 10.8 4.4 21.1 12.3 28.5z"
        }
    ]
};

const FalSpa = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpa",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.3 219.5c9-6.5 18.5-12.6 28.2-18.1-27.1-93.1-79.8-147.8-97.5-164.1-3.8-3.5-8.8-5.2-13.9-5.2s-10.1 1.7-13.9 5.2c-17.7 16.4-70.4 71.1-97.5 164.1 9.7 5.5 19.1 11.6 28.2 18.1C225.7 140 267.2 89.6 288 68.3c20.8 21.3 62.3 71.7 83.3 151.2zM192 469.1c24.1 7.1 49.5 10.9 75.9 10.9h40.2c26.4 0 51.8-3.8 75.9-10.9 111-32.7 192-135.4 192-257 0-11.1-9.1-20.1-20.2-20.1-64.5 0-124.1 21.6-171.8 57.9-43.6 33.2-77.4 78.7-96 131.2-18.6-52.6-52.4-98.1-96-131.2C144.2 213.6 84.6 192 20.2 192 9.1 192 0 201 0 212.1c0 121.6 81 224.3 192 257zm0-34.4C103.7 403.8 37.3 322.6 32.3 224.3c61.5 2.9 117.4 28 159.7 67.4 43 40.1 72 94.9 78.6 156.3-27.3 0-53.8-4.7-78.6-13.3zm192 0c-24.8 8.6-51.2 13.3-78.6 13.3C312 386.6 341 331.7 384 291.7c42.3-39.4 98.2-64.4 159.7-67.4-5 98.3-71.4 179.5-159.7 210.4z"
        }
    ]
};

const FalSpaceStationMoonConstruction = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpaceStationMoonConstruction",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32c61 0 116.3 24.4 156.7 64H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8C414.1 40.2 339.8 0 256 0 114.6 0 0 114.6 0 256s114.6 256 256 256c91.2 0 171.3-47.7 216.6-119.5 3.1-4.9 3.3-11.2.5-16.3s-8.2-8.3-14-8.3H416c-8.8 0-16 7.2-16 16s7.2 16 16 16h11.6c-41.1 48.9-102.7 80-171.6 80-95.1 0-176.3-59.2-208.8-142.8 39.2 13.6 104 32.3 208.8 32.3 119.5 0 187-24.3 223.8-37.6 5-1.8 9.4-3.4 13.3-4.7 1.7-.6 3.2-1.4 4.6-2.4l1.7-1.3c3-2.3 5.1-5.5 5.9-9.1 4.4-18.7 6.7-38.3 6.7-58.3 0-5.7-.2-11.4-.6-17.1-.6-8.4-7.5-14.9-16-14.9H432c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c0 14.8-1.4 29.3-4.2 43.3-2.1.7-4.2 1.5-6.5 2.3-36.3 13.1-99.4 35.8-213.3 35.8S79 314.7 42.7 301.6c-2.3-.8-4.4-1.6-6.5-2.3-2.7-14-4.2-28.5-4.2-43.3zm104-96a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm144 0a88 88 0 1 0-176 0 88 88 0 1 0 176 0zm-64 0a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm152 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80z"
        }
    ]
};

const FalSpaceStationMoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpaceStationMoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 14.8-1.4 29.3-4.2 43.3-2.1.7-4.2 1.5-6.5 2.3-36.3 13.1-99.4 35.8-213.3 35.8S79 314.7 42.7 301.6c-2.3-.8-4.4-1.6-6.5-2.3-2.7-14-4.2-28.5-4.2-43.3zm224 113.4c104.8 0 169.6-18.7 208.8-32.3C432.3 420.8 351.1 480 256 480S79.7 420.8 47.2 337.2c39.2 13.6 104 32.3 208.8 32.3zM256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM136 160a56 56 0 1 1 112 0 56 56 0 1 1-112 0zm144 0a88 88 0 1 0-176 0 88 88 0 1 0 176 0zm-88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalSpade = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpade",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M449.2 231.8c43.3 44.9 41 119.4-6.8 161.2-41.5 34.7-104.2 29.3-143.7-10.6l-18.5-20.5c-6-6.6-14.4-10.4-23.3-10.5s-17.4 3.5-23.6 9.9l-19.8 20.8c-39.9 40.5-103.5 45.3-142.8 11.1l-.2-.2c-48.7-41.8-51.1-116.3-7.8-161.2L256.4 32.1c.1 0 .2.1.3.2l192.5 199.5zm23-22.2L279.4 9.7c-13-13-34-13-45.9 0L39.7 209.5c-55.9 57.9-52.9 153.8 10 207.8 53.1 46.3 134.4 38.2 184.6-10.8l2.2-2.2 3.5-3.7V480h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-79.4l3.4 3.8 2.7 2.7c50.2 48.6 130.1 56.4 185.1 10.3 61.9-53.9 64.9-149.8 9-207.8z"
        }
    ]
};

const FalSpaghettiMonsterFlying = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpaghettiMonsterFlying",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm42 80.3c13.5-11.7 22-29 22-48.3 0-35.3-28.7-64-64-64s-64 28.7-64 64 28.7 64 64 64c4.6 0 9.1-.5 13.4-1.4l13.6 27.1c-24.9 14.5-43.8 33.5-59.2 52.1-7.6 9.1-14.4 18.2-20.6 26.4l-.5.7c-6.4 8.5-12 15.9-17.4 22.2-11.3 13-18.7 17-25.2 17-5 0-8.7-1.8-12.7-5.5-4.5-4.4-8.5-10.5-13.8-18.9l-.5-.7c-4.7-7.5-10.6-16.9-18.3-24.3C42.3 214.2 31 208 16 208c-8.8 0-16 7.2-16 16s7.2 16 16 16c5 0 8.7 1.8 12.7 5.5 4.5 4.4 8.5 10.5 13.8 18.9l.5.7c4.7 7.5 10.6 16.9 18.3 24.3C69.7 297.8 81 304 96 304c19.4 0 34.1-11.4 45.7-23.9l1 1.5c4.4 6.5 10.2 14.3 17.2 22.6-3 8.5-5.6 17-8 24.9l-1.3 4.3c-3.4 11.2-6.5 20.8-10.2 28.8-3.7 8-7.5 13.3-11.7 16.7-3.8 3-8.8 5.2-16.7 5.2-11 0-21-5.3-36.8-13.8l-.6-.3c-15-8-34.2-17.9-58.5-17.9-8.8 0-16 7.2-16 16s7.2 16 16 16c15.6 0 28.5 6.1 43.5 14.1l3.1 1.7C75.9 407 92.7 416 112 416c14.6 0 26.8-4.2 36.7-12.2 9.6-7.6 16-17.9 20.8-28.2 4.8-10.3 8.4-21.9 11.8-32.9l1.3-4.4c.9-2.8 1.7-5.6 2.6-8.4 19.3 17 44.1 33.4 74.6 43.2l-1 3.4c-5.4 18.4-13 43.8-24.3 65.6-13 25-27.2 37.9-42.4 37.9-8.8 0-16 7.2-16 16s7.2 16 16 16c35.1 0 57.3-29.1 70.8-55.1 12.8-24.7 21.2-53.1 26.6-71.2.5-1.8 1-3.5 1.5-5.1l.1-.3c9.2 1.4 18.9 2.1 29 2.1s19.7-.7 29-2.1l.1.3c.5 1.6 1 3.3 1.5 5.1 5.3 18.1 13.8 46.5 26.6 71.2 13.5 26 35.8 55.1 70.8 55.1 8.8 0 16-7.2 16-16s-7.2-16-16-16c-15.2 0-29.4-12.9-42.4-37.9-11.3-21.8-18.9-47.2-24.3-65.6l-1-3.4c30.5-9.8 55.3-26.2 74.6-43.2.9 2.8 1.7 5.6 2.6 8.4l1.3 4.4c3.4 11 7 22.6 11.8 32.9 4.8 10.3 11.2 20.6 20.8 28.2 9.9 7.9 22.1 12.2 36.7 12.2 19.3 0 36.1-9 49.4-16.2l3.1-1.7c15-8 27.8-14.1 43.5-14.1 8.8 0 16-7.2 16-16s-7.2-16-16-16c-24.4 0-43.5 9.9-58.5 17.9l-.6.3C549 378.7 539 384 528 384c-7.9 0-12.9-2.1-16.7-5.2-4.2-3.3-8-8.6-11.7-16.7-3.7-8.1-6.8-17.7-10.2-28.8l-1.3-4.3c-2.4-7.9-5-16.4-8-24.9 7.1-8.3 12.8-16.1 17.2-22.6l1-1.5c11.6 12.6 26.3 24 45.7 24 15 0 26.3-6.2 34.8-14.5 7.7-7.4 13.6-16.8 18.3-24.3l.5-.7c5.3-8.4 9.2-14.6 13.8-18.9 3.9-3.8 7.6-5.5 12.7-5.5 8.8 0 16-7.2 16-16s-7.2-16-16-16c-15 0-26.3 6.2-34.8 14.5-7.7 7.4-13.6 16.8-18.3 24.3l-.5.7c-5.3 8.4-9.2 14.6-13.8 18.9-3.9 3.8-7.6 5.5-12.7 5.5-6.5 0-13.9-4-25.2-17-5.4-6.2-11-13.6-17.4-22.2l-.5-.7c-6.2-8.2-13-17.3-20.6-26.4-15.5-18.6-34.4-37.5-59.2-52.1l13.5-27.1c4.3.9 8.8 1.4 13.4 1.4 35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64c0 19.3 8.5 36.5 22 48.3L392.1 140c-20.4-7.5-44.2-12-72.1-12s-51.7 4.5-72.1 12L234 112.3zM448 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm4.6 259.8c-.9.8-1.7 1.7-2.5 2.6-2.2 2.4-4.6 4.8-7.1 7.2-27.3 26.3-67.9 52-123 52s-95.7-25.6-123-52c-2.5-2.4-4.8-4.8-7.1-7.2-.7-1-1.5-1.8-2.5-2.6-8.9-9.7-15.9-19-20.9-26.4-2.3-3.4-4.2-6.4-5.7-8.9l3.4-4.5.3-.4c6.3-8.4 12.7-16.9 19.8-25.4C212.5 192.3 250.4 160 320 160s107.5 32.3 135.7 66.2c7.1 8.5 13.5 17 19.8 25.4l.3.4 3.4 4.5c-1.5 2.5-3.4 5.5-5.7 8.9-5 7.4-12 16.7-20.9 26.4z"
        }
    ]
};

const FalSparkle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSparkle",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c6.2 0 11.9 3.6 14.5 9.3l63.2 136.9 136.9 63.2c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5l-136.8 63.4-63.3 136.9c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3l-63.3-136.9L9.3 270.5C3.6 267.9 0 262.2 0 256s3.6-11.9 9.3-14.5l136.9-63.2 63.3-137c2.6-5.7 8.3-9.3 14.5-9.3zm0 54.2L172.8 197c-1.6 3.5-4.4 6.2-7.8 7.8L54.2 256 165 307.2c3.5 1.6 6.2 4.4 7.8 7.8L224 425.8 275.2 315c1.6-3.5 4.4-6.2 7.8-7.8L393.8 256 283 204.8c-3.5-1.6-6.2-4.4-7.8-7.8L224 86.2z"
        }
    ]
};

const FalSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSparkles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 32c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V48c0-8.8 7.2-16 16-16zm0 288c8.8 0 16 7.2 16 16v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16zM136.8 216.4l-82.6 38.2 82.6 38.1c6.9 3.2 12.4 8.7 15.6 15.6l38.1 82.6 38.1-82.6c3.2-6.9 8.7-12.4 15.6-15.6l82.6-38.1-82.6-38.1c-6.9-3.2-12.4-8.7-15.6-15.6l-38.1-82.6-38.1 82.6c-3.2 6.9-8.7 12.4-15.6 15.6zm-13.4 105.4L9.3 269.1c-5.7-2.6-9.3-8.3-9.3-14.5s3.6-11.9 9.3-14.5l114.1-52.7L176 73.3c2.6-5.7 8.3-9.3 14.5-9.3s11.9 3.6 14.5 9.3l52.7 114.1L371.8 240c5.7 2.6 9.3 8.3 9.3 14.5s-3.6 11.9-9.3 14.5l-114 52.8-52.7 114c-2.6 5.7-8.3 9.3-14.5 9.3s-11.9-3.6-14.5-9.3l-52.7-114z"
        }
    ]
};

const FalSpeaker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpeaker",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h256c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm272 272a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm88 0a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm56-208a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalSpeakers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpeakers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 257.6v156.8c-20.3 20.7-48.7 33.6-80 33.6-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6zm0 78.4a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm5.5 144c4.2 11.9 10.7 22.8 19 32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h216.4c-8.3 9.2-14.8 20.1-19 32H64c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h197.5zM176 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-24 272a24 24 0 1 1 48 0 24 24 0 1 1-48 0zM352 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H352zm-64 32c0-35.3 28.7-64 64-64h224c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H352c-35.3 0-64-28.7-64-64V64zm176 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 352a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm-24 112a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalSpellCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpellCheck",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M126.7 9.7C124.2 3.8 118.4 0 112 0S99.8 3.8 97.3 9.7l-96 224c-3.5 8.1.3 17.5 8.4 21s17.5-.3 21-8.4L54 192h116l23.3 54.3c3.5 8.1 12.9 11.9 21 8.4s11.9-12.9 8.4-21l-96-224zM156.3 160H67.7L112 56.6 156.3 160zM256 16v224c0 8.8 7.2 16 16 16h104c39.8 0 72-32.2 72-72 0-31.1-19.7-57.6-47.3-67.6C410.3 104.1 416 88.7 416 72c0-39.8-32.2-72-72-72h-72c-8.8 0-16 7.2-16 16zm88 96h-56V32h56c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-56 32h88c22.1 0 40 17.9 40 40s-17.9 40-40 40h-88v-80zm283.3 155.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L352 473.4 251.3 372.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l112 112c6.2 6.2 16.4 6.2 22.6 0l208-208z"
        }
    ]
};

const FalSpiderBlackWidow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpiderBlackWidow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.2 1.7c7.9 4 11.1 13.6 7.2 21.5l-46.1 92.2c-3 6-2 13.2 2.6 18l61.1 65.9V152c0-32.2 19-59.9 46.3-72.6 7.7-3.6 16.8-.5 20.8 6.9l12.9 24 12.9-23.9c4-7.5 13.2-10.5 20.8-6.9C317 92.1 336 119.8 336 152v47.3l61.2-65.9c4.5-4.9 5.6-12.1 2.6-18l-46.1-92.2c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2l46 92.1c8.9 17.9 5.9 39.5-7.8 54.1l-71.1 76.5 101.6-26.7c5.2-1.4 9.4-5.3 11.1-10.4l18.5-55.6c2.8-8.4 11.9-12.9 20.2-10.1s12.9 11.9 10.1 20.2l-18.5 55.6c-5.1 15.4-17.7 27.1-33.3 31.2L382.9 256l76.5 20.1c15.7 4.1 28.2 15.9 33.3 31.2l18.5 55.6c2.8 8.4-1.7 17.4-10.1 20.2s-17.4-1.7-20.2-10.1l-18.5-55.6c-1.7-5.1-5.9-9-11.1-10.4l-84-22.1 59.7 83.8c9.4 13.1 11.5 30.1 5.7 45.1l-33.8 87.9c-3.2 8.2-12.4 12.4-20.7 9.2s-12.4-12.4-9.2-20.7l33.8-87.9c1.9-5 1.2-10.7-1.9-15l-33-46.3c-2.6 59.5-51.7 107-111.9 107s-109.3-47.5-111.9-107L111 387.3c-3.1 4.4-3.8 10-1.9 15l33.8 87.9c3.2 8.2-.9 17.5-9.2 20.7s-17.5-.9-20.7-9.2l-33.8-87.9c-5.8-15.1-3.6-32 5.7-45.1l59.9-83.7-84 22.1c-5.2 1.4-9.4 5.3-11.1 10.4l-18.5 55.6c-2.8 8.4-11.9 12.9-20.2 10.1S-2 371.3.8 362.9l18.5-55.6c5.2-15.3 17.7-27.1 33.4-31.2l76.4-20.1-76.4-20.1C37 231.8 24.5 220 19.3 204.6L.8 149.1c-2.8-8.4 1.7-17.4 10.1-20.2s17.4 1.7 20.2 10.1l18.5 55.6c1.7 5.1 5.9 9 11.1 10.4l101.6 26.7-70.9-76.6c-13.6-14.7-16.7-36.2-7.8-54.1l46.1-92.2c4-7.9 13.6-11.1 21.5-7.2zm118.9 149.9c-2.8 5.2-8.2 8.4-14.1 8.4s-11.3-3.2-14.1-8.4l-18.7-34.7A47.93 47.93 0 0 0 208 152v104.4c0 4.6-1.9 8.9-5.3 12C186.3 283 176 304.3 176 328v8c0 44.2 35.8 80 80 80s80-35.8 80-80v-8c0-23.7-10.3-45-26.7-59.6-3.4-3-5.3-7.4-5.3-12V152c0-13.8-5.9-26.3-15.2-35.1l-18.7 34.7zm-51.7 155.6c-1.6-2.1-2.4-4.6-2.4-7.2 0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12 0 2.6-.8 5.1-2.4 7.2L272 336l21.6 28.8c1.6 2.1 2.4 4.6 2.4 7.2 0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12 0-2.6.8-5.1 2.4-7.2L240 336l-21.6-28.8z"
        }
    ]
};

const FalSpiderWeb = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpiderWeb",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M141.6 18.4c2.7-7.3 10.3-11.5 17.9-10.1l73.6 13.8c37 6.9 75 6.9 112 0l73.7-13.8c7.6-1.4 15.2 2.8 17.9 10.1l30.7 81.8c12 32 29.3 61.7 51.1 87.9l48.1 57.7c4.9 5.9 4.9 14.6 0 20.5L518.5 324a304.74 304.74 0 0 0-51.1 87.9l-30.7 81.8c-2.7 7.3-10.3 11.5-17.9 10.1L345.2 490c-37-6.9-75-6.9-112 0l-73.6 13.8c-7.6 1.4-15.2-2.8-17.9-10.1L111 411.9c-12-32-29.3-61.7-51.1-87.9l-48.2-57.8c-4.9-5.9-4.9-14.6 0-20.5L59.8 188c21.8-26.2 39.1-55.9 51.1-87.9l30.7-81.8zm17.8 43.7-18.5 49.2c-13.2 35.3-32.3 68.1-56.5 97.1L58.2 240h70.5l2.6-2.9c25.4-29.1 45.1-62.7 57.9-99.1l5.2-14.7-35-61.2zM187 46l34.2 59.9c44.1 12 90.5 12 134.6.2L390 46.2l-39 7.3c-40.9 7.7-82.9 7.7-123.8 0L187 46zm231.5 14.9-35.2 61.7 5.4 15.4c12.8 36.4 32.5 70 57.9 99.1l2.6 2.9h71L494 208.5c-24.1-29-43.2-61.8-56.5-97.1l-19-50.5zM520.1 272H449l-1.1 1.3c-26.2 30-46.3 64.8-59.1 102.5l-5 14.6 34.7 60.7 18.9-50.5c13.2-35.3 32.3-68.1 56.5-97.1l26.2-31.5zM390 465.8l-32.2-56.4c-44.2-14.3-91.6-15.5-136.5-3.4L187 466l40.2-7.5c40.9-7.7 82.9-7.7 123.8 0l39 7.3zm-230.6-15.9 35-61.2-5.2-14.8c-12.8-36.4-32.5-70-57.9-99.1l-2.4-2.8H58.2l26.2 31.5c24.1 29 43.2 61.8 56.5 97.1l18.5 49.3zM170.2 272c18.6 24.5 33.7 51.5 45 80.1L261 272h-90.8zm72.3 96.8c30.9-4.7 62.4-4.1 93.1 1.8l-47.1-82.4-46 80.6zm120.2-15.3c11.1-29.2 26.3-56.6 45-81.6h-91.6l46.6 81.6zm45-113.5c-18.8-24.7-34-51.9-45.3-80.9L316.1 240h91.6zm-73.1-96.8c-30.5 4.9-61.6 4.8-92.1-.1l46.1 80.6 46-80.5zm-119.4 16.6c-11.3 28.7-26.4 55.7-45.1 80.2H261l-45.8-80.2z"
        }
    ]
};

const FalSpider = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpider",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M158.3 23.2c4-7.9.7-17.5-7.2-21.5s-17.5-.7-21.5 7.2l-46 92.1c-8.9 17.9-5.9 39.5 7.8 54.1l71.1 76.5-101.7-26.7c-5.2-1.4-9.4-5.3-11.1-10.4l-18.5-55.6c-2.8-8.4-11.9-12.9-20.2-10.1S-2 140.7.8 149.1l18.5 55.6c5.2 15.3 17.7 27.1 33.4 31.2l76.4 20.1-76.4 20.1C37 280.2 24.5 292 19.3 307.4L.8 362.9c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l18.5-55.6c1.7-5.1 5.9-9 11.1-10.4l84-22.1L85 368.7c-9.4 13.1-11.5 30.1-5.7 45.1l33.8 87.9c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7l-33.8-87.9c-1.9-5-1.2-10.7 1.9-15l33-46.3c2.6 59.5 51.7 107 111.9 107s109.3-47.5 111.9-107l33.1 46.3c3.1 4.4 3.8 10 1.9 15l-33.8 87.9c-3.2 8.2.9 17.5 9.2 20.7s17.5-.9 20.7-9.2l33.8-87.9c5.8-15.1 3.6-32-5.7-45.1L367.2 285l84 22.1c5.2 1.4 9.4 5.3 11.1 10.4l18.5 55.6c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-18.5-55.6c-5.1-15.4-17.7-27.1-33.3-31.2L382.9 256l76.5-20.1c15.7-4.1 28.2-15.9 33.3-31.2l18.5-55.6c2.8-8.4-1.7-17.4-10.1-20.2s-17.4 1.7-20.2 10.1l-18.5 55.6c-1.7 5.1-5.9 9-11.1 10.4l-101.7 26.7 71.1-76.5c13.6-14.7 16.7-36.2 7.8-54.1L382.3 8.8c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l46.1 92.2c3 6 2 13.2-2.6 18l-61.1 66V152c0-32.2-19-59.9-46.3-72.6-7.7-3.6-16.8-.5-20.8 6.9l-12.9 24-12.9-24c-4-7.5-13.2-10.5-20.8-6.9C195 92.1 176 119.8 176 152v47.3l-61.2-65.9c-4.5-4.9-5.6-12.1-2.6-18l46.1-92.2zM288.7 117c9.4 8.8 15.2 21.3 15.2 35.1v104.3c0 4.6 1.9 8.9 5.3 12C325.7 283 336 304.3 336 328v8c0 44.2-35.8 80-80 80s-80-35.8-80-80v-8c0-23.7 10.3-45 26.7-59.6 3.4-3 5.3-7.4 5.3-12V152c0-13.8 5.9-26.3 15.2-35.1l18.7 34.7c2.8 5.2 8.2 8.4 14.1 8.4s11.3-3.2 14.1-8.4l18.7-34.7z"
        }
    ]
};

const FalSpinnerThird = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpinnerThird",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M463.9 376c7.6 4.4 17.5 1.8 21.4-6.1 17.1-34.3 26.7-73 26.7-113.9C512 120 405.9 8.8 272 .5c-8.8-.5-16 6.7-16 15.5s7.2 15.9 16 16.6C388.2 40.8 480 137.7 480 256c0 35.1-8.1 68.3-22.5 97.9-3.9 8-1.3 17.7 6.4 22.2z"
        }
    ]
};

const FalSpinner = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpinner",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8a16 16 0 1 0-22.6 22.6 16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zm22.6-316.8a16 16 0 1 0 22.6-22.6 16 16 0 1 0-22.6 22.6zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zm271.5 339.4a16 16 0 1 0-22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1-67.9-67.9z"
        }
    ]
};

const FalSplit = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSplit",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M404.7 36.7c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7H339.9c-8.5 0-16.6 3.4-22.6 9.4L214.6 256l102.7 102.6c6 6 14.1 9.4 22.6 9.4h117.5l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7H339.9c-17 0-33.3-6.7-45.3-18.7L190.1 276.7c-3-3-7.1-4.7-11.3-4.7H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h162.7c4.2 0 8.3-1.7 11.3-4.7l104.6-104.6c12-12 28.3-18.7 45.3-18.7h117.5l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalSplotch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSplotch",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m189.1 416.1-102.7 9.4C65.8 427.3 48 411.1 48 390.4c0-7.6 2.5-15 7-21.1l18.8-25c14.5-19.4 22.1-43.1 21.6-67.3-.5-20.2-6.6-39.8-17.6-56.6l-40.5-61.9c-3.4-5.2-5.3-11.4-5.3-17.6 0-20.1 18.2-35.2 37.9-31.6l42.8 7.8c47 8.5 94.9-8.8 125.4-45.5l22.3-26.8c6.7-8 16.6-12.7 27.1-12.7 15.2 0 28.7 9.7 33.5 24.1l15 45.1c14.2 42.6 46.9 76.5 88.9 92.3l32.3 12.1c13.7 5.1 22.7 18.2 22.7 32.8 0 11-5.2 21.4-14 28L404 313c-33.4 25-51 65.8-46.4 107.3l2.5 22.7c2.2 19.8-13.3 37.1-33.2 37.1-7.6 0-14.9-2.6-20.9-7.3L269 443c-21.8-17.5-49-27-77-27-1 0-1.9 0-2.9.1zM51 237.8c7.8 11.9 12.1 25.7 12.4 39.8.4 17-4.9 33.7-15.2 47.4l-18.8 25C20.7 361.7 16 375.9 16 390.4c0 39.5 33.9 70.5 73.3 66.9L192 448c20.7 0 40.8 7 57 20l37.1 29.7c11.6 9.3 26 14.3 40.8 14.3 39 0 69.3-33.9 65-72.6l-2.5-22.7c-3.4-30.2 9.5-59.9 33.8-78.1l62-46.5c16.9-12.7 26.8-32.5 26.8-53.6 0-28-17.3-53-43.5-62.8l-32.3-12.1c-33-12.4-58.7-39-69.8-72.4L351.3 46c-9.2-27.5-34.9-46-63.8-46-20 0-38.9 8.9-51.7 24.2L213.5 51c-23.2 27.8-59.5 41-95.1 34.5l-42.8-7.8C36.2 70.6 0 100.8 0 140.9c0 12.5 3.6 24.7 10.5 35.1L51 237.8z"
        }
    ]
};

const FalSpoon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSpoon",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m274.7 205.3 32 32c12.5 12.5 28.7 18.7 45.1 18.7 27.5 0 59.3-17 85.5-48.5 26-31.1 42.7-72 42.7-111.5 0-35.3-28.7-64-64-64-39.5 0-80.4 16.7-111.5 42.6-31.5 26.3-48.5 58.1-48.5 85.5 0 16.4 6.3 32.6 18.7 45.1zm-22.6 22.6c-18.7-18.7-28.1-43.2-28.1-67.7C224 80 320 0 416 0c53 0 96 43 96 96 0 96-80 192-160.2 192-24.5 0-49-9.4-67.7-28.1l-4.7-4.7L27.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l252.1-252.1-4.7-4.7z"
        }
    ]
};

const FalSportsball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSportsball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m436.9 52.4-94.2 94.3c-23.7-27.4-41-60.6-49.2-97.2 41.2-5.3 88.7-4.8 143.5 2.9zm-175 2.6c9.5 43.2 29.8 82.4 58.1 114.4l-64 64-117.6-117.6c22.2-19.9 49.1-36.6 81.6-48.7 13-4.8 27-8.9 41.9-12.2zm-145.8 83.8L233.4 256l-64 64c-31.6-27.9-70.2-48.1-112.7-57.7 7.5-32.2 19.3-63.5 36.7-92 6.7-11 14.3-21.6 22.8-31.6zm-65.5 155c36.1 8.4 68.9 25.4 96 48.9l-94.4 94.5c-6.9-42.8-8.9-93.2-1.5-143.4zM75 459.6l94.3-94.3c23.7 27.4 41 60.6 49.2 97.2-41.2 5.3-88.7 4.8-143.5-2.9zm175-2.5c-9.5-43.2-29.8-82.4-58.1-114.4l64-64 117.7 117.5c-22.2 19.9-49.1 36.6-81.6 48.7-13 4.8-27 8.9-41.9 12.2zm145.8-83.8L278.6 256l64-64c31.6 27.9 70.2 48.1 112.8 57.7-7.5 32.2-19.3 63.5-36.7 92-6.7 11-14.3 21.6-22.8 31.6zm65.5-155c-36.1-8.4-68.9-25.5-96-48.9l94.5-94.5c6.9 42.8 8.9 93.2 1.5 143.4zm.2-194.4c-103.9-17.4-187-11-252.6 13.3-66 24.4-112.2 66.4-142.9 116.4C5.8 251.8 6.9 378.3 24.4 463.1c2.7 12.9 13 22.9 26.1 25.1 103.9 17.4 187 11 252.6-13.3 66-24.5 112.2-66.5 142.9-116.5 60.2-98.2 59.1-224.7 41.6-309.5-2.7-12.9-13-22.9-26.1-25.1z"
        }
    ]
};

const FalSprayCanSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSprayCanSparkles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32v10.1-.1 3.1-.1 5.1-.1 46H96V48.9v.1-5.1.1-3.1.1-9c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v64h-32V32h-64zM96 160c-35.3 0-64 28.7-64 64v224c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V224c0-35.3-28.7-64-64-64H96zM0 224c0-53 43-96 96-96h128c53 0 96 43 96 96v224c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V224zm208 96a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0zM336 0c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V64h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16zm144 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V64h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm0 192v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16zm-64-96v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalSprayCan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSprayCan",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32v64h32V32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v64h32V32h64zm32 128c35.3 0 64 28.7 64 64v216c0 22.1-17.9 40-40 40H72c-22.1 0-40-17.9-40-40V224c0-35.3 28.7-64 64-64h128zm64-72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM96 128c-53 0-96 43-96 96v216c0 39.8 32.2 72 72 72h176c39.8 0 72-32.2 72-72V224c0-53-43-96-96-96H96zm64 144a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM408 64a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-24 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-72-120a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalSprinklerCeiling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSprinklerCeiling",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 0h32v83.8l96 26.2v33.2L11.8 111.4C4.8 109.5 0 103.2 0 96V0zm256 110 96-26.2V0h32v96c0 7.2-4.8 13.5-11.8 15.4L256 143.1V110zm-64-78c8.8 0 16 7.2 16 16v176h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h96V48c0-8.8 7.2-16 16-16zm-48 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144-48a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-32 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-48-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM0 464a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalSprinkler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSprinkler",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 0a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 144a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm128 0a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm192 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm144-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM96 208a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm400 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM32 272a16 16 0 1 1-32 0 16 16 0 1 1 32 0zM96 80a16 16 0 1 1-32 0 16 16 0 1 1 32 0zM32 16a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm224 48c8.8 0 16 7.2 16 16v176h120c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-89 89v86c0 22.1-17.9 40-40 40h-48c-22.1 0-40-17.9-40-40v-86.1l-89-89c-6.9-6.9-8.9-17.2-5.2-26.2s12.5-14.8 22.2-14.8h120V80c0-8.8 7.2-16 16-16zM139.3 288l75.3 75.3c6 6 9.4 14.1 9.4 22.6V472c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-86.1c0-8.5 3.4-16.6 9.4-22.6l75.3-75.3H139.3z"
        }
    ]
};

const FalSquare0 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare0",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c53 0 96 43 96 96v64c0 53-43 96-96 96s-96-43-96-96v-64c0-53 43-96 96-96zm-64 96v64c0 35.3 28.7 64 64 64s64-28.7 64-64v-64c0-35.3-28.7-64-64-64s-64 28.7-64 64z"
        }
    ]
};

const FalSquare1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare1",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm168 98.2c-4.9-2.9-11-2.9-16-.1l-56 32c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l32.2-18.3V352h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V144c0-5.7-3-11-8-13.8z"
        }
    ]
};

const FalSquare2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare2",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm185 78.4-14 13.3c-6.4 6.1-16.6 5.7-22.6-.7s-5.7-16.6.7-22.6l14.1-13.2c15.8-14.9 36.8-23 58.5-22.7 45.6.5 82.3 37.8 82.3 83.5 0 22.2-8.8 43.4-24.5 59.1L198.6 352H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l108.2-108.2c9.7-9.7 15.1-22.8 15.1-36.5 0-28.2-22.7-51.2-50.9-51.6-13.4-.2-26.3 4.8-36.1 14z"
        }
    ]
};

const FalSquare3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare3",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32h144c6.7 0 12.7 4.2 15 10.4s.5 13.3-4.6 17.7l-78.9 67.6 19.9-.1c44.4-.2 80.6 35.7 80.6 80.2 0 44.3-35.9 80.2-80.2 80.2h-36c-27.6 0-53.5-13-70.1-35l-2.5-3.4c-5.3-7.1-3.9-17.1 3.2-22.4s17.1-3.9 22.4 3.2l2.5 3.4c10.5 14 27 22.2 44.5 22.2h36c26.6 0 48.2-21.6 48.2-48.2 0-26.7-21.7-48.3-48.4-48.2l-63.5.3c-6.7 0-12.7-4.1-15.1-10.4s-.5-13.4 4.6-17.7l79.1-67.8H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSquare4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare4",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm133.9 97.1c-8.2-3.3-17.5.7-20.8 8.9l-64 160c-2 4.9-1.4 10.5 1.6 14.9s7.9 7 13.2 7H256v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H151.6l55.2-138.1c3.3-8.2-.7-17.5-8.9-20.8z"
        }
    ]
};

const FalSquare5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare5",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 32h112c8.8 0 16 7.2 16 16s-7.2 16-16 16h-99.5L172 225.9l80.4 8.1c38.4 3.9 67.6 36.2 67.6 74.8 0 41.5-33.7 75.2-75.2 75.2h-44c-27.4 0-53-13.7-68.3-36.4l-1.8-2.7c-4.9-7.3-3-17.3 4.4-22.2s17.3-3 22.2 4.4l1.8 2.7c9.3 13.9 25 22.3 41.8 22.3h44c23.8 0 43.2-19.3 43.2-43.2 0-22.2-16.8-40.7-38.8-42.9l-98.8-10c-4.6-.5-8.8-2.9-11.5-6.7s-3.6-8.6-2.4-13.1l24-96c1.8-7.1 8.2-12.1 15.5-12.1z"
        }
    ]
};

const FalSquare6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare6",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm-96 64c0 53 43 96 96 96s96-43 96-96c0-51.8-41-94-92.3-95.9l39.1-36.3c6.5-6 6.9-16.1.8-22.6s-16.1-6.9-22.6-.8l-82.7 76.8c-22 20.4-34.4 49-34.4 78.9z"
        }
    ]
};

const FalSquare7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare7",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32h160c5.7 0 11 3 13.8 8s2.9 11 .1 16l-128 224c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8L276.4 160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSquare8 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare8",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm172 96h-24c-37.6 0-68 30.4-68 68 0 20.2 8.8 38.4 22.9 50.9-18.8 13.8-30.9 36-30.9 61.1 0 42 34 76 76 76h24c42 0 76-34 76-76 0-25.1-12.1-47.3-30.9-61.1 14-12.5 22.9-30.6 22.9-50.9 0-37.6-30.4-68-68-68zm-24 104c-19.9 0-36-16.1-36-36s16.1-36 36-36h24c19.9 0 36 16.1 36 36s-16.1 36-36 36h-24zm0 32h24c24.3 0 44 19.7 44 44s-19.7 44-44 44h-24c-24.3 0-44-19.7-44-44s19.7-44 44-44z"
        }
    ]
};

const FalSquare9 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare9",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 256a64 64 0 1 1 0-128 64 64 0 1 1 0 128zm-3.7 31.9-39.1 36.3c-6.5 6-6.9 16.1-.8 22.6s16.1 6.9 22.6.8l82.7-76.8c22-20.4 34.4-49 34.4-78.9 0-53-43-96-96-96s-96 43-96 96c0 51.8 41 94 92.3 95.9z"
        }
    ]
};

const FalSquareALock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareALock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64h320c17.7 0 32 14.3 32 32v74.8c9.9-4.7 20.7-8 32-9.6V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.6 0 96v320c0 35.3 28.7 64 64 64h256v-32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm174.3 72.8c-2.7-5.4-8.3-8.8-14.3-8.8s-11.6 3.4-14.3 8.8l-112 224c-4 7.9-.7 17.5 7.2 21.5s17.5.7 21.5-7.2l19.5-39.1h156.2l17.9 35.8V352c0-12.2 3.4-23.5 9.3-33.2l-91-181.9zm-14.3 43L286.1 304H161.9L224 179.8zM464 224c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80h160v128H384V352z"
        }
    ]
};

const FalSquareA = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareA",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c6.1 0 11.6 3.4 14.3 8.8l112 224c4 7.9.7 17.5-7.2 21.5s-17.5.7-21.5-7.2L294.1 320H153.9l-27.6 55.2c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l112-224c2.7-5.4 8.3-8.8 14.3-8.8zm0 51.8L169.9 288h108.2L224 179.8z"
        }
    ]
};

const FalSquareAmpersand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareAmpersand",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 88c0 6.2 2.4 12.1 6.6 16.6l22.1 23.3 21.8-15c8.5-5.9 13.5-15.4 13.5-25.7 0-12.8-10.4-23.2-23.2-23.2H200c-13.3 0-24 10.7-24 24zm68.7 51.2-17.5 12.1 45.4 47.7 34.4-48.3c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3l-38 53.2 36.6 38.5c6.1 6.4 5.8 16.5-.6 22.6s-16.5 5.8-22.6-.6L276 345l-6.3 8.8c-13.5 18.9-35.3 30.2-58.6 30.2h-36c-34.9 0-63.2-28.3-63.2-63.2 0-20.8 10.2-40.3 27.4-52.1l38.7-26.6-18.6-19.5c-9.9-10.4-15.4-24.2-15.4-38.6 0-30.9 25.1-56 56-56h16.8c30.5 0 55.2 24.7 55.2 55.2 0 20.8-10.2 40.2-27.3 52zm-87.1 59.9c-8.5 5.8-13.5 15.4-13.5 25.7 0 17.2 14 31.2 31.2 31.2h36c12.9 0 25-6.2 32.5-16.8l9.8-13.8-53.2-55.8-42.9 29.5z"
        }
    ]
};

const FalSquareArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareArrowDownLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm280-64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-97.4l132.7-132.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L160 297.4V192c0-8.8-7.2-16-16-16s-16 7.2-16 16v144c0 8.8 7.2 16 16 16h136z"
        }
    ]
};

const FalSquareArrowDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareArrowDownRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320zm64-32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zm-280-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h97.4L132.7 187.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L288 297.4V192c0-8.8 7.2-16 16-16s16 7.2 16 16v144c0 8.8-7.2 16-16 16H168z"
        }
    ]
};

const FalSquareArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareArrowDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm235.3-36.7 96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L240 329.4V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v185.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0z"
        }
    ]
};

const FalSquareArrowLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareArrowLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320zm32 64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm36.7-235.3 96-96c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L150.6 240H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H150.6l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalSquareArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareArrowRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96zm-32-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zm-36.7 235.3-96 96c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l68.7-68.7H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h185.4l-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6z"
        }
    ]
};

const FalSquareArrowUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareArrowUpLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm280 64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-97.4l132.7 132.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 214.6V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16h136z"
        }
    ]
};

const FalSquareArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareArrowUpRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zm-280 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h97.4L132.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L288 214.6V320c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H168z"
        }
    ]
};

const FalSquareArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm235.3 36.7 96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 182.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V182.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalSquareB = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareB",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 64c0-17.7 14.3-32 32-32h88c39.8 0 72 32.2 72 72 0 19.3-7.6 36.8-19.9 49.7 21.5 12.5 35.9 35.7 35.9 62.3 0 39.8-32.2 72-72 72H160c-17.7 0-32-14.3-32-32V160zm160 40c0-22.1-17.9-40-40-40h-88v80h88c22.1 0 40-17.9 40-40zM160 352h104c22.1 0 40-17.9 40-40s-17.9-40-40-40H160v80z"
        }
    ]
};

const FalSquareBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareBolt",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm159.7 168H208c5.5 0 10.5 2.8 13.5 7.4s3.3 10.4 1 15.3l-19.4 41.9 85.2-80.6H240c-5.5 0-10.5-2.8-13.5-7.4s-3.3-10.4-1-15.3l19.4-41.9-85.2 80.6zm121.9-152c14.7 0 24.4 15.2 18.2 28.5L265 216h49.4c11.9 0 21.6 9.7 21.6 21.6 0 5.9-2.4 11.6-6.7 15.7L180.2 394.5c-3.7 3.5-8.7 5.5-13.8 5.5-14.7 0-24.4-15.2-18.2-28.5L183 296h-49.4c-11.9 0-21.6-9.7-21.6-21.6 0-5.9 2.4-11.6 6.7-15.7l149.1-141.2c3.7-3.5 8.7-5.5 13.8-5.5z"
        }
    ]
};

const FalSquareC = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareC",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm156.1 92.1c-37.5 37.5-37.5 98.3 0 135.8s98.3 37.5 135.8 0c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6c-50 50-131 50-181 0s-50-131 0-181 131-50 181 0c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0c-37.5-37.5-98.3-37.5-135.8 0z"
        }
    ]
};

const FalSquareCaretDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareCaretDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm224-64c9.6 0 18.7-4 25.2-11l95.5-102.8c4.7-5.1 7.3-11.8 7.3-18.7 0-15.2-12.3-27.5-27.5-27.5h-201c-15.2 0-27.5 12.3-27.5 27.5 0 6.9 2.6 13.6 7.3 18.7L198.8 341c6.5 7 15.6 11 25.2 11zm-1.7-32.7L133.8 224h180.4l-88.4 95.3c-.4.5-1.1.7-1.7.7s-1.3-.3-1.7-.7z"
        }
    ]
};

const FalSquareCaretLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareCaretLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320zm32 64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm64-224c0-9.6 4-18.7 11-25.2l102.8-95.5c5.1-4.7 11.8-7.3 18.7-7.3 15.2 0 27.5 12.3 27.5 27.5v201c0 15.2-12.3 27.5-27.5 27.5-6.9 0-13.6-2.6-18.7-7.3L139 281.2c-7-6.5-11-15.6-11-25.2zm32.7 1.7 95.3 88.5V165.9l-95.3 88.4c-.5.4-.7 1.1-.7 1.7s.3 1.3.7 1.7z"
        }
    ]
};

const FalSquareCaretRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareCaretRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96zm-32-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zm-64 224c0 9.6-4 18.7-11 25.2l-102.8 95.5c-5.1 4.7-11.8 7.3-18.7 7.3-15.2 0-27.5-12.3-27.5-27.5v-201c0-15.2 12.3-27.5 27.5-27.5 6.9 0 13.6 2.6 18.7 7.3L309 230.8c7 6.5 11 15.6 11 25.2zm-32.7-1.7L192 165.8v180.3l95.3-88.4c.5-.4.7-1.1.7-1.7s-.3-1.3-.7-1.7z"
        }
    ]
};

const FalSquareCaretUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareCaretUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 64c9.6 0 18.7 4 25.2 11l95.5 102.8c4.7 5.1 7.3 11.8 7.3 18.7 0 15.2-12.3 27.5-27.5 27.5h-201c-15.2 0-27.5-12.3-27.5-27.5 0-6.9 2.6-13.6 7.3-18.7L198.8 171c6.5-7 15.6-11 25.2-11zm-1.7 32.7L133.8 288h180.4l-88.4-95.3c-.4-.5-1.1-.7-1.7-.7s-1.3.3-1.7.7z"
        }
    ]
};

const FalSquareCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm331.3 107.3-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7 116.7-116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalSquareChevronDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareChevronDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320zm64-32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zm-235.3-68.7-112-112c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 313.4l100.7-100.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-112 112c-6.2 6.2-16.4 6.2-22.6 0z"
        }
    ]
};

const FalSquareChevronLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareChevronLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320zm32 64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm68.7-235.3 112-112c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L166.6 256l100.7 100.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-112-112c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalSquareChevronRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareChevronRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96zm-32-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zm-68.7 235.3-112 112c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L281.4 256 180.7 155.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l112 112c6.2 6.2 6.2 16.4 0 22.6z"
        }
    ]
};

const FalSquareChevronUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareChevronUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm235.3 68.7 112 112c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 198.6 123.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l112-112c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalSquareCode = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareCode",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm197.4 140c-6.6 5.9-7.2 16-1.3 22.6l54.5 61.4-54.6 61.4c-5.9 6.6-5.3 16.7 1.3 22.6s16.7 5.3 22.6-1.3l64-72c5.4-6.1 5.4-15.2 0-21.3l-64-72c-5.9-6.6-16-7.2-22.6-1.3zM188 194.6c5.9-6.6 5.3-16.7-1.3-22.6s-16.7-5.3-22.6 1.3l-64 72c-5.4 6.1-5.4 15.2 0 21.3l64 72c5.9 6.6 16 7.2 22.6 1.3s7.2-16 1.3-22.6L133.4 256l54.6-61.4z"
        }
    ]
};

const FalSquareD = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareD",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 256h64c53 0 96-43 96-96s-43-96-96-96h-64v192zm-1.2-224H224c70.7 0 128 57.3 128 128s-57.3 128-128 128h-65.2c-17 0-30.8-13.8-30.8-30.8V158.8c0-17 13.8-30.8 30.8-30.8z"
        }
    ]
};

const FalSquareDashedCirclePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareDashedCirclePlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 32c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-30.9 0-56 25.1-56 56v24c0 8.8-7.2 16-16 16s-16-7.2-16-16v-24c0-48.6 39.4-88 88-88h24zM0 304v-96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16zm16 48c8.8 0 16 7.2 16 16v24c0 30.9 25.1 56 56 56h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-48.6 0-88-39.4-88-88v-24c0-8.8 7.2-16 16-16zm417.3-159.4c-9.1.8-17.3-6.1-17.3-15.3V120c0-30.9-25.1-56-56-56h-24c-8.8 0-16-7.2-16-16s7.2-16 16-16h24c48.6 0 88 39.4 88 88v57.4c0 8.1-6.7 14.6-14.7 15.2zM160 464c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zM272 64h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16zm272 304a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm160-64v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalSquareDashed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareDashed",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 32h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-30.9 0-56 25.1-56 56v24c0 8.8-7.2 16-16 16s-16-7.2-16-16v-24c0-48.6 39.4-88 88-88zM16 192c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm416 0c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm0-32c-8.8 0-16-7.2-16-16v-24c0-30.9-25.1-56-56-56h-24c-8.8 0-16-7.2-16-16s7.2-16 16-16h24c48.6 0 88 39.4 88 88v24c0 8.8-7.2 16-16 16zm16 208v24c0 48.6-39.4 88-88 88h-24c-8.8 0-16-7.2-16-16s7.2-16 16-16h24c30.9 0 56-25.1 56-56v-24c0-8.8 7.2-16 16-16s16 7.2 16 16zm-416 0v24c0 30.9 25.1 56 56 56h24c8.8 0 16 7.2 16 16s-7.2 16-16 16H88c-48.6 0-88-39.4-88-88v-24c0-8.8 7.2-16 16-16s16 7.2 16 16zm144 112c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96zM160 48c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalSquareDivide = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareDivide",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 40a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-96 104h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16zm72 112a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalSquareDollar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareDollar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm240 24v23c13.5 1 26.6 4.6 39.6 8.3 1.5.4 3.1.9 4.6 1.3 8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2l-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5-19.1-2.8-36.6-.4-49.3 5.1-12.9 5.6-18.6 13.1-19.8 19.5-1.8 9.8 2.1 16.5 10.2 21.7 10.6 6.8 26.5 11.3 45.8 16.8l.3.1c17.7 5 38.9 11.1 54.3 21.7 19 13 27.8 33.8 23.6 56.5-4 21.6-18.9 36-37.8 43.6-9.9 4-21.1 6.3-33.1 6.9V392c0 8.8-7.2 16-16 16s-16-7.2-16-16v-25.9c-8.1-1.3-21.8-5.2-32.4-8.4-6.9-2.1-13.8-4.3-20.7-6.5-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3 11.2 3.4 22.7 6.6 28.1 7.4 19.8 2.9 36.5 1.3 48-3.4 11.2-4.5 16.8-11.3 18.3-19.7 1.9-10.5-1.5-18.4-10.2-24.4-12-8.2-26.8-12.3-40.9-16.2-2.3-.6-4.7-1.3-6.9-1.9-17.1-4.8-37-10.5-51.7-19.9-8.1-5.2-15.7-12.1-20.5-21.7-4.9-9.8-6.2-20.8-4-32.8 3.8-20.7 20-35.1 38.6-43.1 7.4-3.2 15.6-5.6 24.3-7.1V120c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalSquareDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareDownLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm144-88V214.6c0-3.7 3-6.6 6.6-6.6 1.8 0 3.4.7 4.7 1.9l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0l59.1-59.1c3.6-3.6 9-4.9 13.9-3.3 2 .7 3.8 1.8 5.3 3.3l22.1 22.1c1.5 1.5 2.6 3.3 3.3 5.3 1.6 4.9.4 10.3-3.3 13.9l-59.1 59.1c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c1.2 1.2 1.9 2.9 1.9 4.7 0 3.7-3 6.6-6.6 6.6H152c-4.4 0-8-3.6-8-8zm8 40h113.4c21.3 0 38.6-17.3 38.6-38.6 0-10.2-4.1-20.1-11.3-27.3L278.6 288l47.7-47.7c12.2-12.2 16.5-30.3 11-46.7-2.2-6.7-6-12.8-11-17.8l-22.1-22.1c-5-5-11.1-8.8-17.8-11-16.4-5.5-34.5-1.2-46.7 11L192 201.4l-14.1-14.1c-7.2-7.2-17.1-11.3-27.3-11.3-21.3 0-38.6 17.3-38.6 38.6V328c0 22.1 17.9 40 40 40z"
        }
    ]
};

const FalSquareDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareDownRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320zm64-32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zm-144-88V214.6c0-3.7-3-6.6-6.6-6.6-1.8 0-3.4.7-4.7 1.9l-25.4 25.4c-6.2 6.2-16.4 6.2-22.6 0l-59.1-59.1c-3.6-3.6-9-4.9-13.9-3.3-2 .7-3.8 1.8-5.3 3.3l-22.1 22.1c-1.5 1.5-2.6 3.3-3.3 5.3-1.6 4.9-.4 10.3 3.3 13.9l59.1 59.1c6.2 6.2 6.2 16.4 0 22.6L178 324.6c-1.2 1.2-1.9 2.9-1.9 4.7 0 3.7 3 6.6 6.6 6.6H296c4.4 0 8-3.6 8-8zm-8 40H182.6c-21.3 0-38.6-17.3-38.6-38.6 0-10.2 4.1-20.1 11.3-27.3l14.1-14.1-47.7-47.7c-12.2-12.2-16.5-30.3-11-46.7 2.2-6.7 6-12.8 11-17.8l22.1-22.1c5-5 11.1-8.8 17.8-11 16.4-5.5 34.5-1.2 46.7 11l47.7 47.7 14.1-14.1c7.2-7.2 17.1-11.3 27.3-11.3 21.3 0 38.6 17.3 38.6 38.6V328c0 22.1-17.9 40-40 40z"
        }
    ]
};

const FalSquareDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareDown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320zm64-32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320zm-224-16c-9.2 0-18-3.5-24.7-9.7l-91-84A38.29 38.29 0 0 1 96 278.2c0-21.1 17.1-38.3 38.3-38.3H160v-80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v80h25.7c21.1 0 38.3 17.1 38.3 38.3 0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7zm3-33.2 91-84c1.3-1.2 2-2.9 2-4.6 0-3.5-2.8-6.3-6.3-6.3l-41.7.1c-8.8 0-16-7.2-16-16v-96c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v96c0 8.8-7.2 16-16 16h-41.7c-3.5 0-6.3 2.8-6.3 6.3 0 1.7.7 3.4 2 4.6l91 84c.8.8 1.9 1.2 3 1.2s2.2-.4 3-1.2z"
        }
    ]
};

const FalSquareE = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareE",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v80h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v80h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FalSquareEllipsisVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareEllipsisVertical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-24-72a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm24 168a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalSquareEllipsis = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareEllipsis",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320zm32 64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm136-224a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-72 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm168-24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalSquareEnvelope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareEnvelope",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm288 128v29.2l-120.7 66.4c-2.2 1.2-4.7 1.9-7.3 1.9s-5.1-.6-7.3-1.9L96 189.2V160h256zm0 65.7V352H96V225.7l105.3 57.9c7 3.8 14.8 5.8 22.7 5.8s15.8-2 22.7-5.8L352 225.7zM96 128c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32H96z"
        }
    ]
};

const FalSquareExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareExclamation",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 32c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-24 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalSquareF = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareF",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v80h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H160v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FalSquareFragile = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareFragile",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32v80c0 44.2 35.8 80 80 80s80-35.8 80-80v-80h-73.4l20.7 20.7c3.4 3.4 5.1 8.1 4.6 12.9s-3.1 9.1-7 11.7l-30.2 20.1 31.5 26.3c6.8 5.7 7.7 15.7 2 22.5s-15.7 7.7-22.5 2l-48-40c-3.9-3.2-6-8.1-5.7-13.1s2.9-9.7 7.1-12.5l31.8-21.2-29.5-29.4H144zm-1.1-32h162.2c17.1 0 30.9 13.8 30.9 30.9V208c0 56.4-41.7 103.1-96 110.9V384h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-65.1c-54.3-7.8-96-54.4-96-110.9v-81.1c0-17.1 13.8-30.9 30.9-30.9z"
        }
    ]
};

const FalSquareFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareFull",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 32v448H32V32h448zM32 0H0v512h512V0H32z"
        }
    ]
};

const FalSquareG = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareG",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 160c0 53 43 96 96 96 47.6 0 87.1-34.6 94.7-80H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c8.8 0 16 7.2 16 16 0 70.7-57.3 128-128 128S96 326.7 96 256s57.3-128 128-128c32.8 0 62.7 12.3 85.3 32.6 6.6 5.9 7.1 16 1.3 22.6s-16 7.1-22.6 1.3c-17-15.2-39.4-24.4-64-24.4-53 0-96 43-96 96z"
        }
    ]
};

const FalSquareH = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareH",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm336 48v224c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96H144v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96h160v-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalSquareHeart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareHeart",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm99.9 68.9c27.8-28.2 71.9-29.7 101.5-4.6 5.8 4.9 11 10.4 16.3 15.9 2.1 2.2 4.2 4.5 6.4 6.6 2.1-2.2 4.3-4.4 6.4-6.6 5.2-5.5 10.5-11 16.3-15.9 29.6-25.1 73.7-23.6 101.5 4.6 29.4 29.8 29.4 78.2 0 108L246.5 376.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 272.9c-29.4-29.8-29.4-78.2 0-108zm83.6 22.5c-16.8-17.1-44-17.1-60.8 0-17.1 17.4-17.1 45.7 0 63.1L224 353.3l101.3-102.9c17.1-17.4 17.1-45.7 0-63.1-16.8-17.1-44-17.1-60.8 0l-29.1 29.6c-6.3 6.4-16.5 6.4-22.8 0l-29.1-29.6z"
        }
    ]
};

const FalSquareI = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareI",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32h160c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v192h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V160h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSquareInfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareInfo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-16 64h40c8.8 0 16 7.2 16 16v112h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-96h-24c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSquareJ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareJ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm304 48v144c0 53-43 96-96 96s-96-43-96-96v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 35.3 28.7 64 64 64s64-28.7 64-64V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalSquareK = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareK",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm315.1 59.5-87.3 84.3 89 118.6c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2l-86.6-115.4-44.6 43.1V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16v116.8l132.9-128.3c6.4-6.1 16.5-6 22.6.4s6 16.5-.4 22.6z"
        }
    ]
};

const FalSquareKanban = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareKanban",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 448c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64zM0 416c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320zm128-128c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v128c0 8.8 7.2 16 16 16zm176 48c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v192zm-80-80c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16z"
        }
    ]
};

const FalSquareL = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareL",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48v208h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-17.7 0-32-14.3-32-32V144c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalSquareLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320zm32 64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64zm16-224c0-9.2 3.5-18 9.7-24.7l84-91c7.2-7.8 17.4-12.3 28.1-12.3 21.1 0 38.3 17.1 38.3 38.3V192h80c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48h-80v25.7c0 21.1-17.1 38.3-38.3 38.3-10.7 0-20.9-4.5-28.1-12.3l-84-91C83.5 274 80 265.2 80 256zm33.2 3 84 91c1.2 1.3 2.9 2 4.6 2 3.5 0 6.3-2.8 6.3-6.3V304c0-8.8 7.2-16 16-16h96c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-96c-8.8 0-16-7.2-16-16v-41.7c0-3.5-2.8-6.3-6.3-6.3-1.7 0-3.4.7-4.6 2l-84 91c-.8.8-1.2 1.9-1.2 3s.4 2.2 1.2 3z"
        }
    ]
};

const FalSquareList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareList",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm104 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm88 0c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm-64-72a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-24 72a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalSquareM = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareM",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm125.1 38.8L224 276.1l98.9-141.3c4-5.7 11.3-8.2 17.9-6.1S352 137 352 144v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V194.8l-82.9 118.4c-3 4.3-7.9 6.8-13.1 6.8s-10.1-2.5-13.1-6.8L128 194.8V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7 4.5-13.2 11.2-15.3s13.9.4 17.9 6.1z"
        }
    ]
};

const FalSquareMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareMinus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 144h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSquareN = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareN",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm157 38.7 131 183.4V144c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 7-4.5 13.1-11.1 15.2s-13.9-.3-17.9-5.9L160 193.9V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-7 4.5-13.1 11.1-15.2s13.9.3 17.9 5.9z"
        }
    ]
};

const FalSquareNfi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareNfi",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm11.7 128.6C68.8 162.5 64 168.8 64 176v160c0 8.8 7.2 16 16 16s16-7.2 16-16V233.8l66.3 110.5c3.7 6.2 11.1 9.1 18 7.2s11.7-8.2 11.7-15.4V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v102.2L93.7 167.8c-3.7-6.2-11.1-9.1-18-7.2zM224 176v160c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-32h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V176z"
        }
    ]
};

const FalSquareO = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareO",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 160a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm96 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256z"
        }
    ]
};

const FalSquareP = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareP",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32h88c48.6 0 88 39.4 88 88s-39.4 88-88 88h-72v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm88 144c30.9 0 56-25.1 56-56s-25.1-56-56-56h-72v112h72z"
        }
    ]
};

const FalSquareParkingSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareParkingSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm471.5 474.2L459.9 448H160c-17.7 0-32-14.3-32-32V186l-32-25.3V416c0 35.3 28.7 64 64 64h320c6 0 11.9-.8 17.4-2.4zM142.6 34.4 180.1 64H480c17.7 0 32 14.3 32 32v230l32 25.3V96c0-35.3-28.7-64-64-64H160c-6 0-11.9.8-17.4 2.4zm97.4 240V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-68.4l-32-25.3zm197.7-7c6.6-13 10.3-27.8 10.3-43.4 0-53-43-96-96-96h-88c-.9 0-1.8 0-2.7.1l40.4 31.9H352c35.3 0 64 28.7 64 64 0 8.1-1.5 15.8-4.2 22.9l25.9 20.4z"
        }
    ]
};

const FalSquareParking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareParking",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm176 192h80c35.3 0 64-28.7 64-64s-28.7-64-64-64h-80v128zm80 32h-80v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V152c0-13.3 10.7-24 24-24h88c53 0 96 43 96 96s-43 96-96 96z"
        }
    ]
};

const FalSquarePen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquarePen",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm299.5 67.3c-6.2-6.2-16.4-6.2-22.6 0l-21.4 21.4 40 40 21.4-21.4c6.2-6.2 6.2-16.4 0-22.6l-17.4-17.4zm-149 126.4c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l82.3-82.3-40-40-82.3 82.3zm103.8-149c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L213.1 352.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3l126.4-126.3z"
        }
    ]
};

const FalSquarePersonConfined = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquarePersonConfined",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm296 96c30.9 0 56 25.1 56 56v112c0 30.9-25.1 56-56 56-25.1 0-48.8-11.5-64.4-31.3l-53.5-68.2-52.2 91.4c-4.4 7.7-14.2 10.3-21.8 6s-10.3-14.2-6-21.8l64-112c2.6-4.6 7.4-7.6 12.7-8s10.5 1.9 13.8 6.1l51.4 65.4V248c0-30.9 25.1-56 56-56zm24 168V248c0-13.3-10.7-24-24-24s-24 10.7-24 24v112c0 13.3 10.7 24 24 24s24-10.7 24-24zm-88-208a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-80 0a56 56 0 1 1 112 0 56 56 0 1 1-112 0z"
        }
    ]
};

const FalSquarePhoneFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquarePhoneFlip",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zm-171.2 48.1 56 12c1.8.4 3.2 2 3.2 3.9 0 114.9-93.1 208-208 208-1.9 0-3.5-1.3-3.9-3.2l-12-56c-.4-1.9.6-3.8 2.3-4.5l56-24c1.6-.7 3.5-.2 4.7 1.1l16.6 20.3c5 6.1 13.6 7.6 20.4 3.7 25.4-14.7 46.6-35.9 61.4-61.4 3.9-6.8 2.4-15.4-3.7-20.4L249.5 207c-1.4-1.1-1.8-3-1.1-4.7l24-56c.8-1.8 2.6-2.7 4.5-2.3zm-33.9-10.3-24 56c-6.3 14.7-2.1 31.9 10.3 42l9.2 7.5c-8.6 11.9-19.1 22.4-31 31l-7.5-9.2c-10.2-12.4-27.3-16.6-42-10.3l-56 24c-15.8 6.8-24.6 23.8-21 40.6l12 56C96.4 388.1 111 400 128 400c132.5 0 240-107.4 240-240 0-17-11.9-31.6-28.5-35.2l-56-12c-16.8-3.6-33.9 5.2-40.6 21z"
        }
    ]
};

const FalSquarePhoneHangup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquarePhoneHangup",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zM81.1 246.7c78.8-72.9 207-72.9 285.7 0 .8.7 1 1.4 1.1 1.9s0 1.1-.4 1.8l-21.7 35.2c-1 1.7-4.1 3.2-7.4 1.9l-46.2-17.6c-2.4-.9-2.9-2.6-2.9-3.4l2.8-18.1c1.2-7.8-3.4-15.3-10.9-17.7-37-11.9-77.4-11.9-114.3 0-7.5 2.4-12.1 9.9-10.9 17.7l2.8 18.1c0 .9-.5 2.5-2.9 3.4l-46.2 17.6c-3.3 1.2-6.4-.3-7.4-1.9l-21.9-35.2c-.4-.7-.5-1.2-.4-1.8s.3-1.2 1.1-1.9zm307.5-23.5c-91-84.3-238.2-84.3-329.2 0-12.3 11.4-15.1 29.5-6.2 44l21.7 35.2c9.6 15.6 29.4 21.4 46 15l46.2-17.6c14.9-5.7 25.1-20.3 23.3-36.9 0-.2-.1-.5-.1-.7l-.7-4.5c22.5-5.1 46.1-5.1 68.6 0l-.7 4.5c0 .2-.1.5-.1.7-1.8 16.6 8.5 31.3 23.3 36.9l46.3 17.7c16.6 6.3 36.4.6 46-15l21.7-35.2c8.9-14.4 6.1-32.6-6.2-44z"
        }
    ]
};

const FalSquarePhone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquarePhone",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm171.2 48.1-56 12c-1.8.4-3.2 2-3.2 3.9 0 114.9 93.1 208 208 208 1.9 0 3.5-1.3 3.9-3.2l12-56c.4-1.9-.6-3.8-2.3-4.5l-56-24c-1.6-.7-3.5-.2-4.7 1.1l-16.6 20.3c-5 6.1-13.6 7.6-20.4 3.7-25.4-14.7-46.6-35.9-61.4-61.4-3.9-6.8-2.4-15.4 3.7-20.4l20.3-16.6c1.4-1.1 1.8-3 1.1-4.7l-24-56c-.8-1.8-2.6-2.7-4.5-2.3zm33.9-10.3 24 56c6.3 14.7 2.1 31.9-10.3 42l-9.2 7.5c8.6 11.9 19.1 22.4 31 31l7.5-9.2c10.2-12.4 27.3-16.6 42-10.3l56 24c15.8 6.8 24.6 23.8 21 40.6l-12 56C351.6 388.1 337 400 320 400 187.5 400 80 292.6 80 160c0-17 11.9-31.6 28.5-35.2l56-12c16.8-3.6 33.9 5.2 40.6 21z"
        }
    ]
};

const FalSquarePlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquarePlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm208 256v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalSquarePollHorizontal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquarePollHorizontal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96zm-32-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zM256 160c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16zm80 80c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224zM192 352c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16z"
        }
    ]
};

const FalSquarePollVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquarePollVertical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144zm112 144c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalSquareQ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareQ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm128 160c0 53 43 96 96 96 20.7 0 39.9-6.6 55.6-17.7l-50.9-50.9c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l50.9 50.9c11.2-15.8 17.8-35 17.8-55.7 0-53-43-96-96-96s-96 43-96 96zm224 0c0 29.6-10 56.8-26.9 78.5l22.2 22.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.2-22.2C280.8 374 253.6 384 224 384c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128z"
        }
    ]
};

const FalSquareQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareQuarters",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M55.7 65.1 224 233.4 392.3 65.1c-2.6-.7-5.4-1.1-8.3-1.1H64c-2.9 0-5.6.4-8.3 1.1zM33.1 87.7c-.7 2.7-1.1 5.4-1.1 8.3v320c0 2.9.4 5.6 1.1 8.3L201.4 256 33.1 87.7zm22.6 359.2c2.6.7 5.4 1.1 8.3 1.1h320c2.9 0 5.6-.4 8.3-1.1L224 278.6 55.7 446.9zm359.2-22.6c.7-2.6 1.1-5.4 1.1-8.3V96c0-2.9-.4-5.6-1.1-8.3L246.6 256l168.3 168.3zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalSquareQuestion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareQuestion",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm136.7 73.8c6.5-24.6 28.7-41.8 54.2-41.8H248c35.5 0 64 29 64 64.3 0 24-13.4 46.2-34.9 57.2L240 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16v-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7 0-17.8-14.4-32.3-32-32.3h-57.1c-10.9 0-20.5 7.4-23.2 17.9l-.2.7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM200 352a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalSquareQuote = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareQuote",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm144 254.4V200c0-22.1-17.9-40-40-40h-32c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h32c2.7 0 5.4-.3 8-.8v15.2c0 15.9-11.7 29.4-27.5 31.7l-14.8 2.1c-8.7 1.3-14.8 9.4-13.6 18.1s9.4 14.8 18.1 13.6l14.8-2.1c31.5-4.5 54.9-31.5 54.9-63.4zM176 232c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32zm176 0v-32c0-22.1-17.9-40-40-40h-32c-22.1 0-40 17.9-40 40v32c0 22.1 17.9 40 40 40h32c2.7 0 5.4-.3 8-.8v15.2c0 15.9-11.7 29.4-27.5 31.7l-14.8 2.1c-8.7 1.3-14.8 9.4-13.6 18.1s9.4 14.8 18.1 13.6l14.8-2.1c31.5-4.5 54.9-31.5 54.9-63.4V232zm-32-16v16c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v16z"
        }
    ]
};

const FalSquareR = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareR",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 32h80c44.2 0 80 35.8 80 80 0 34.8-22.2 64.4-53.2 75.4l50.5 75.7c4.9 7.4 2.9 17.3-4.4 22.2s-17.3 2.9-22.2-4.4L231.4 288H160v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-17.7 14.3-32 32-32zm80 128c26.5 0 48-21.5 48-48s-21.5-48-48-48h-80v96h80z"
        }
    ]
};

const FalSquareRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96zm-32-64c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64h320zm-16 224c0 9.2-3.5 18-9.7 24.7l-84 91a38.29 38.29 0 0 1-28.1 12.3c-21.1 0-38.3-17.1-38.3-38.3V320h-80c-26.5 0-48-21.5-48-48v-32c0-26.5 21.5-48 48-48h80v-25.7c0-21.1 17.1-38.3 38.3-38.3 10.7 0 20.9 4.5 28.1 12.3l84 91c6.2 6.7 9.7 15.6 9.7 24.7zm-33.2-3-84-91c-1.2-1.3-2.9-2-4.6-2-3.5 0-6.3 2.8-6.3 6.3V208c0 8.8-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16v41.7c0 3.5 2.8 6.3 6.3 6.3 1.7 0 3.4-.7 4.6-2l84-91c.8-.8 1.2-1.9 1.2-3s-.4-2.2-1.2-3z"
        }
    ]
};

const FalSquareRing = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareRing",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm0 288a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm-64-160a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm160 0a96 96 0 1 0-192 0 96 96 0 1 0 192 0z"
        }
    ]
};

const FalSquareRootVariable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareRootVariable",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352.1 64c-7.1 0-13.4 4.7-15.4 11.6L223.4 468.4c-1.8 6.3-7.2 10.8-13.7 11.5s-12.7-2.6-15.8-8.4l-111-207.1c-2.8-5.2-8.2-8.4-14.1-8.4H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h52.8c17.7 0 34 9.7 42.3 25.3l92.4 172.4L306 66.7c5.9-20.6 24.7-34.7 46.1-34.7H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H352.1zm52.6 180.7c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L502.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L480 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalSquareRoot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareRoot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352.1 64c-7.1 0-13.4 4.7-15.4 11.6L223.4 468.4c-1.8 6.3-7.2 10.8-13.7 11.5s-12.7-2.6-15.8-8.4l-111-207.1c-2.8-5.2-8.2-8.4-14.1-8.4H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h52.8c17.7 0 34 9.7 42.3 25.3l92.4 172.4L306 66.7c5.9-20.6 24.7-34.7 46.1-34.7H560c8.8 0 16 7.2 16 16s-7.2 16-16 16H352.1z"
        }
    ]
};

const FalSquareRss = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareRss",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm48 320a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM80 128c-8.8 0-16 7.2-16 16s7.2 16 16 16c132.5 0 240 107.5 240 240 0 8.8 7.2 16 16 16s16-7.2 16-16c0-150.2-121.8-272-272-272zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16c79.5 0 144 64.5 144 144 0 8.8 7.2 16 16 16s16-7.2 16-16c0-97.2-78.8-176-176-176z"
        }
    ]
};

const FalSquareS = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareS",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160.7 94c-1.5 8.5-.5 14.1 1.5 18.2 2 4.2 5.7 8.3 11.7 12.3 12.8 8.4 31.8 13.9 54.4 20.1l1.5.4c20.7 5.7 44.5 12.3 62 23.8 9.3 6.1 17.7 14.3 23 25.2 5.3 11.1 6.6 23.8 4 37.7-4.5 24.3-21.6 40.2-43.1 48.5-21.1 8.1-47.2 9.5-74.1 5.6h-.1c-17-2.6-46.2-11.2-61.2-15.9-8.4-2.6-13.1-11.6-10.5-20.1s11.6-13.1 20.1-10.5c15.2 4.8 42.2 12.6 56.4 14.8 23.4 3.4 43.6 1.8 57.9-3.8 13.9-5.4 21.2-13.8 23.1-24.4 1.5-8.5.5-14.1-1.5-18.2-2-4.2-5.7-8.3-11.7-12.3-12.8-8.4-31.8-13.9-54.4-20.1l-1.5-.4c-20.7-5.7-44.5-12.3-62-23.8-9.3-6.1-17.7-14.3-23-25.2-5.3-11.1-6.6-23.8-4-37.7 4.5-24.3 21.6-40.2 43.1-48.5 21.1-8.1 47.2-9.5 74.1-5.6 8.4 1.2 25.9 5 34.1 7 8.6 2.2 13.8 10.8 11.6 19.4s-10.8 13.8-19.4 11.6c-7.6-1.9-24-5.4-31-6.4-23.4-3.5-43.6-1.8-57.9 3.8-13.9 5.4-21.2 13.8-23.1 24.4z"
        }
    ]
};

const FalSquareShareNodes = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareShareNodes",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm320 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-18.4 0-35.1-7.8-46.7-20.3l-81.7 44.6c.3 2.5.5 5.1.5 7.7s-.2 5.2-.5 7.7l81.7 44.6c11.6-12.5 28.3-20.3 46.7-20.3 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64c0-5.4.7-10.6 1.9-15.6l-78.2-42.7C168.1 309.6 149.2 320 128 320c-35.3 0-64-28.7-64-64s28.7-64 64-64c21.2 0 40.1 10.4 51.7 26.3l78.2-42.7c-1.3-5-1.9-10.2-1.9-15.6 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64zm0 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM160 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FalSquareSlidersVertical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareSlidersVertical",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 96c-8.8 0-16 7.2-16 16v48h-24c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-24v-48c0-8.8-7.2-16-16-16zm0 128c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm160-128c-8.8 0-16 7.2-16 16v112h-24c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-24V144c0-8.8-7.2-16-16-16zm0 192c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalSquareSliders = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareSliders",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 416c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v320zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 80c0-8.8 7.2-16 16-16h48v-24c0-8.8 7.2-16 16-16s16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-24h-48c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16zM96 336c0-8.8 7.2-16 16-16h112v-24c0-8.8 7.2-16 16-16s16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-24H112c-8.8 0-16-7.2-16-16zm192 0c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalSquareSmall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareSmall",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 128c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h192zM64 96c-35.3 0-64 28.7-64 64v192c0 35.3 28.7 64 64 64h192c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalSquareStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareStar",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm238.3 16.9 36.2 73.4 81.1 11.8c6 .9 11 5.1 12.9 10.9s.3 12.2-4 16.4l-58.6 57.2 13.8 80.7c1 6-1.4 12.1-6.4 15.6s-11.5 4.1-16.8 1.2l-72.5-38-72.5 38.1c-5.4 2.8-11.9 2.4-16.8-1.2s-7.4-9.6-6.4-15.6l13.8-80.7-58.6-57.3c-4.4-4.3-5.9-10.6-4-16.4s6.9-10 12.9-10.9l81-11.8 36.2-73.4c2.7-5.5 8.3-8.9 14.3-8.9s11.7 3.5 14.3 8.9zm-40 95.1c-2.3 4.7-6.8 8-12 8.8l-57.3 8.3 41.5 40.4c3.8 3.7 5.5 9 4.6 14.2l-9.8 57.1 51.2-26.9c4.7-2.5 10.2-2.5 14.9 0l51.2 26.9-9.8-57.1c-.9-5.2.8-10.5 4.6-14.2l41.6-40.4-57.3-8.3c-5.2-.8-9.7-4-12-8.8L224 156.2l-25.6 51.9z"
        }
    ]
};

const FalSquareT = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareT",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm112 48h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96v192c0 8.8-7.2 16-16 16s-16-7.2-16-16V176h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSquareTerminal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareTerminal",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm19.9 117.6c-5.8 6.7-5 16.8 1.7 22.6l97.8 83.8-97.8 83.9c-6.7 5.8-7.5 15.8-1.7 22.6s15.9 7.5 22.6 1.7l112-96c3.5-3 5.6-7.5 5.6-12.1s-2-9.1-5.6-12.1l-112-96c-6.7-5.8-16.8-5-22.6 1.7zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H208z"
        }
    ]
};

const FalSquareThisWayUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareThisWayUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm112 272h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm32-256c4.6 0 9 2 12 5.5l56 64c5.8 6.7 5.1 16.8-1.5 22.6s-16.8 5.1-22.6-1.5l-28-32V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V170.6l-28 32c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l56-64c3-3.5 7.4-5.5 12-5.5zm160 0c4.6 0 9 2 12 5.5l56 64c5.8 6.7 5.1 16.8-1.5 22.6s-16.8 5.1-22.6-1.5l-28-32V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V170.6l-28 32c-5.8 6.7-15.9 7.3-22.6 1.5s-7.3-15.9-1.5-22.6l56-64c3-3.5 7.4-5.5 12-5.5z"
        }
    ]
};

const FalSquareU = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareU",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 64v128c0 44.2 35.8 80 80 80s80-35.8 80-80V160c0-8.8 7.2-16 16-16s16 7.2 16 16v128c0 61.9-50.1 112-112 112s-112-50.1-112-112V160c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalSquareUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareUpLeft",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 88v113.4c0 3.7 3 6.6 6.6 6.6 1.8 0 3.4-.7 4.7-1.9l25.4-25.4c6.2-6.2 16.4-6.2 22.6 0l59.1 59.1c3.6 3.6 9 4.9 13.9 3.3 2-.7 3.8-1.8 5.3-3.3l22.1-22.1c1.5-1.5 2.6-3.3 3.3-5.3 1.6-4.9.4-10.3-3.3-13.9l-59.1-59.1c-6.2-6.2-6.2-16.4 0-22.6l25.4-25.4c1.2-1.2 1.9-2.9 1.9-4.7 0-3.7-3-6.6-6.6-6.6H152c-4.4 0-8 3.6-8 8zm8-40h113.4c21.3 0 38.6 17.3 38.6 38.6 0 10.2-4.1 20.1-11.3 27.3L278.6 224l47.7 47.7c12.2 12.2 16.5 30.3 11 46.7-2.2 6.7-6 12.8-11 17.8l-22.1 22.1c-5 5-11.1 8.8-17.8 11-16.4 5.5-34.5 1.2-46.7-11L192 310.6l-14.1 14.1c-7.2 7.2-17.1 11.3-27.3 11.3-21.3 0-38.6-17.3-38.6-38.6V184c0-22.1 17.9-40 40-40z"
        }
    ]
};

const FalSquareUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareUpRight",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96zm-144 88v113.4c0 3.7-3 6.6-6.6 6.6-1.8 0-3.4-.7-4.7-1.9l-25.4-25.4c-6.2-6.2-16.4-6.2-22.6 0l-59.1 59.1c-3.6 3.6-9 4.9-13.9 3.3-2-.7-3.8-1.8-5.3-3.3l-22.1-22.1c-1.5-1.5-2.6-3.3-3.3-5.3-1.6-4.9-.4-10.3 3.3-13.9l59.1-59.1c6.2-6.2 6.2-16.4 0-22.6L178 187.4c-1.2-1.2-1.9-2.9-1.9-4.7 0-3.7 3-6.6 6.6-6.6H296c4.4 0 8 3.6 8 8zm-8-40H182.6c-21.3 0-38.6 17.3-38.6 38.6 0 10.2 4.1 20.1 11.3 27.3l14.1 14.1-47.7 47.7c-12.2 12.2-16.5 30.3-11 46.7 2.2 6.7 6 12.8 11 17.8l22.1 22.1c5 5 11.1 8.8 17.8 11 16.4 5.5 34.5 1.2 46.7-11l47.7-47.7 14.1 14.1c7.2 7.2 17.1 11.3 27.3 11.3 21.3 0 38.6-17.3 38.6-38.6V184c0-22.1-17.9-40-40-40z"
        }
    ]
};

const FalSquareUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 16c9.2 0 18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1 0 21.1-17.1 38.3-38.3 38.3H288v80c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48V272h-25.7c-21.2 0-38.3-17.1-38.3-38.3 0-10.7 4.5-20.9 12.3-28.1l91-84c6.7-6.2 15.6-9.7 24.7-9.7zm-3 33.2-91 84c-1.3 1.2-2 2.9-2 4.6 0 3.5 2.8 6.3 6.3 6.3H176c8.8 0 16 7.2 16 16v96c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V256c0-8.8 7.2-16 16-16h41.7c3.5 0 6.3-2.8 6.3-6.3 0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2s-2.2.4-3 1.2z"
        }
    ]
};

const FalSquareUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32 0-70.7-57.3-128-128-128h-64c-70.7 0-128 57.3-128 128-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zm-32 384H96c0-53 43-96 96-96h64c53 0 96 43 96 96zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 224a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0-160 0z"
        }
    ]
};

const FalSquareV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareV",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm126.3 56.8L224 348.2l97.7-195.4c4-7.9 13.6-11.1 21.5-7.2s11.1 13.6 7.2 21.5l-112 224c-2.7 5.4-8.3 8.8-14.3 8.8s-11.6-3.4-14.3-8.8l-112-224c-4-7.9-.7-17.5 7.2-21.5s17.5-.7 21.5 7.2z"
        }
    ]
};

const FalSquareVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareVirus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm200 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM86.6 230.9c29.3 0 43.9-35.4 23.2-56.1-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0c20.7 20.7 56.1 6 56.1-23.2 0-13.3 10.7-24 24-24s24 10.7 24 24c0 29.3 35.4 43.9 56.1 23.2 9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9c-20.7 20.7-6 56.1 23.2 56.1 13.3 0 24 10.7 24 24s-10.7 24-24 24c-29.3 0-43.9 35.4-23.2 56.1 9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0c-20.7-20.7-56.1-6-56.1 23.2 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-29.3-35.4-43.9-56.1-23.2-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9c20.7-20.7 6-56.1-23.2-56.1-13.3 0-24-10.7-24-24s10.7-24 24-24zm62.6-50.7c8.2 28.6-4.9 60.2-30.9 74.7 26 14.5 39.1 46.1 30.9 74.7 28.6-8.2 60.2 4.9 74.7 30.9 14.5-26 46.1-39.1 74.7-30.9-8.2-28.6 4.9-60.2 30.9-74.7-26-14.5-39.1-46.1-30.9-74.7-16.4 4.7-33.9 2.4-48.5-5.4-10.8-5.7-20.1-14.5-26.2-25.5-14.5 26-46.1 39.1-74.7 30.9z"
        }
    ]
};

const FalSquareW = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareW",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm103.1 58.8 56.3 162.6 49.4-154.2c2.1-6.6 8.3-11.1 15.2-11.1s13.1 4.5 15.2 11.1l49.4 154.2 56.3-162.6c2.9-8.4 12-12.8 20.4-9.9s12.8 12 9.9 20.4l-72 208c-2.3 6.5-8.4 10.8-15.3 10.8s-13-4.6-15.1-11.1L224 220.5l-48.8 152.4c-2.1 6.6-8.2 11-15.1 11.1s-13.1-4.3-15.3-10.8l-72-208c-2.9-8.4 1.5-17.5 9.9-20.4s17.5 1.5 20.4 9.9z"
        }
    ]
};

const FalSquareX = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareX",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm140.1 37.6 83.9 97.8 83.9-97.8c5.8-6.7 15.9-7.5 22.6-1.7s7.5 15.9 1.7 22.6L245.1 256l87.1 101.6c5.8 6.7 5 16.8-1.7 22.6s-16.8 5-22.6-1.7L224 280.6l-83.9 97.8c-5.8 6.7-15.9 7.5-22.6 1.7s-7.5-15.8-1.7-22.6L202.9 256l-87-101.6c-5.8-6.7-5-16.8 1.7-22.6s16.8-5 22.6 1.7z"
        }
    ]
};

const FalSquareXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareXmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm148.7 84.7c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 256l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 278.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalSquareY = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareY",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm124 53.5 100 114.2 100-114.2c5.8-6.7 15.9-7.3 22.6-1.5s7.3 15.9 1.5 22.6L240 294v90c0 8.8-7.2 16-16 16s-16-7.2-16-16v-90L100 170.5c-5.8-6.7-5.1-16.8 1.5-22.6s16.8-5.1 22.6 1.5z"
        }
    ]
};

const FalSquareZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquareZ",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h320c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm144 32h160c6 0 11.5 3.3 14.2 8.7s2.3 11.7-1.2 16.6L175.1 352H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-6 0-11.5-3.4-14.2-8.7s-2.3-11.7 1.2-16.6L272.9 160H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h320zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalSquid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M245.6 4.6c3.5-3.4 8.3-5.1 13.2-4.5l132.3 15.7C419.3 9.3 450.4 4.3 484.9 1c15-1.4 27.6 11.2 26.2 26.2-3.3 34.4-8.4 65.6-14.8 93.7L512.8 254c.6 4.9-1.1 9.8-4.6 13.3s-8.4 5.2-13.3 4.6l-57.9-7.1c-7.3 10.7-14.9 20.4-22.8 29.1-43.9 48.9-94.7 68.2-136.9 72.9l40.1 40.1c6.1 6.1 15.9 6.3 22.2.4l66.8-62c18.9-17.6 48.3-17 66.6 1.2l34.2 34.2c6 6 6.3 15.5.7 21.9l-11 12.5c-30.5 34.8-84.1 36.6-116.8 3.9l-2.9-2.9-15.9 14.7c-18.9 17.6-48.3 17-66.6-1.2l-50.3-50.3-30.1 20.7 38.1 38.1c18.7 18.7 18.7 49.1 0 67.9l-1.4 1.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.4-1.4c6.2-6.2 6.2-16.4 0-22.6l-42.3-42.3-34.2 23.5c-5.8 4-9.1 10.5-9 17.5.2 11.4 9.5 20.5 20.8 20.5h11.7c8.8 0 16 7.2 16 16s-7.2 16-16 16h-11.6c-28.9 0-52.4-23.1-52.8-52-.3-17.7 8.3-34.4 22.9-44.4l29.5-20.3-48.1-48.1-20.8 30.2C86.2 391.6 70.2 400 53 400 24.2 400 .9 376.7.9 347.9V336c0-8.8 7.2-16 16-16s16 7.2 16 16v11.9c0 11.1 9 20.1 20.1 20.1 6.6 0 12.8-3.3 16.6-8.7l24.1-35-42.4-42.4c-6.2-6.2-16.4-6.2-22.6 0l-1.4 1.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.4-1.4c18.7-18.7 49.1-18.7 67.9 0l38.1 38.1 20.7-30.1-50.3-50.2c-18.3-18.3-18.8-47.7-1.2-66.6L96 134.6l-2.9-2.9C60.3 99 62.1 45.4 96.9 14.9L109.5 4c6.3-5.5 15.9-5.2 21.8.7l34.2 34.2c18.3 18.3 18.8 47.7 1.2 66.6l-62 66.8c-5.9 6.3-5.7 16.1.4 22.2l40.1 40.1c4.7-42.2 24-93 72.9-136.9 8.8-7.9 18.5-15.5 29.2-22.8L241 17.8c-.5-4.9 1.2-9.7 4.6-13.1zm31.9 52c11.7-6.2 24.4-12.1 38-17.6L275 34.3l2.5 22.4zM135.1 320.5l56.4 56.4 45.2-31.1c9.5-6.5 20.2-9.5 30.6-10.3 36.3-2.6 82.7-18 123.2-63.1 39.6-44.1 74.6-117.8 87.7-238.7-120.9 13.2-194.6 48.2-238.7 87.8-45.1 40.5-60.5 86.9-63.1 123.2-.7 10.3-3.8 21.1-10.3 30.6L135 320.5zm320.1-85.7 23.3 2.9-5.2-42c-5.6 14.1-11.7 27.1-18.1 39.1zM117.8 111.2l25.5-27.5c5.9-6.3 5.7-16.1-.4-22.2l-23.6-23.6L118 39c-20.9 18.3-22 50.4-2.3 70.1l2.1 2.1zm283 283 2.1 2.1c19.6 19.6 51.8 18.6 70.1-2.3l1.1-1.3-23.6-23.6c-6.1-6.1-15.9-6.3-22.2-.4l-27.5 25.5zM208.9 320a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-16-48a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalSquirrel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSquirrel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32C82.1 32 32 82.1 32 144s50.1 112 112 112c15.7 0 30.2 8.5 37.7 22.3 9.6 17.3 5.2 37-4.3 50.5-11 15.6-17.4 34.6-17.4 55.2 0 53 43 96 96 96h112c35.3 0 64-28.7 64-64s-28.7-64-64-64c-6.7 0-13.2 1-19.2 2.9-8.4 2.6-17.4-2-20.1-10.5s2-17.4 10.5-20.1c9.1-2.9 18.8-4.4 28.8-4.4 11.2 0 22 1.9 32 5.5V240c0-8.8 7.2-16 16-16h11.5c21.2 0 40.6-12 50.1-31l2-4.1-.3-3.4c-3.3-32.6-30.8-57.5-63.7-57.5H400c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16v16c49.1.2 90.2 37.5 95.1 86.4l.8 8c.3 3-.3 6-1.6 8.7l-4.1 8.2c-14.2 28.5-42.7 46.9-74.2 48.5v88.6c19.6 17.6 32 43.1 32 71.6 0 24.6-9.2 47-24.4 64H480c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-70.7 0-128-57.3-128-128 0-27.4 8.6-52.8 23.2-73.6 4.5-6.3 4.6-12.8 2.4-16.7-1.9-3.5-5.7-5.7-9.7-5.7C64.5 288 0 223.5 0 144S64.5 0 144 0s144 64.5 144 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-61.9-50.1-112-112-112zm208 48v76.2c0 39-7.1 66.6-21.2 91.9-11.9 21.2-28.6 40.5-48.2 63-2.8 3.2-5.7 6.5-8.6 9.9l-11.2 13c-14.3 16.4-22.8 42.6-22.8 66 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-29.6 10.4-63.7 30.6-87l11.2-13c3-3.5 5.9-6.8 8.7-10 19.9-22.9 34.3-39.4 44.4-57.5 11-19.7 17.1-41.6 17.1-76.2V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm64 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalStaffSnake = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStaffSnake",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M296 48h-88V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H64C28.7 48 0 76.7 0 112s28.7 64 64 64h8c39.8 0 72-32.2 72-72V80h32v208h-48c-17.7 0-32-14.3-32-32s14.3-32 32-32h16v-32h-16c-35.3 0-64 28.7-64 64s28.7 64 64 64h48v96h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V320h32c26.5 0 48 21.5 48 48s-21.5 48-48 48v32c44.2 0 80-35.8 80-80s-35.8-80-80-80h-32V80h88c30.9 0 56 25.1 56 56s-25.1 56-56 56h-56v32h56c48.6 0 88-39.4 88-88s-39.4-88-88-88zM112 80v24c0 22.1-17.9 40-40 40h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h48zm-40 40a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalStaff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStaff",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M284.2 44.2 277 58.5c-11.9 23.7-2.2 52.5 21.5 64.4s52.5 2.2 64.4-21.5c1.7-3.4 5.1-5.5 8.8-5.5H400c8.8 0 16 7.2 16 16v47.7c0 7.1-4.7 13.4-11.6 15.4l-169.6 48.6c-13.1 3.7-25 10.7-34.6 20.4l-39.4 39.4c-3 3-7.1 4.7-11.3 4.7H112c-8.8 0-16 7.2-16 16v37.5c0 4.2-1.7 8.3-4.7 11.3l-77.2 77.2c-18.7 18.7-18.7 49.1 0 67.9s49.1 18.7 67.9 0l180.2-180.3c1.9-1.9 4.3-3.3 6.9-4.1l85.5-24.4c4.1-1.2 8.5-.7 12.3 1.5l32.8 18.5c7.7 4.3 17.5 1.6 21.8-6.1l19-33.6c2.1-3.7 5.5-6.4 9.5-7.5l3.9-1.1c34.3-9.8 58-41.2 58-76.9V80c0-44.2-35.8-80-80-80h-76.1c-30.3 0-58 17.1-71.6 44.2zM355.8 32H432c26.5 0 48 21.5 48 48v103.9c0 21.4-14.2 40.3-34.8 46.2l-3.9 1.1c-12.1 3.5-22.4 11.6-28.6 22.6l-11.1 19.7-18.9-10.7c-11.2-6.3-24.4-7.9-36.8-4.4l-85.5 24.4c-7.8 2.2-15 6.4-20.8 12.2L59.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l77.3-77.3c9-9 14.1-21.2 14.1-33.9V320h21.5c12.7 0 24.9-5.1 33.9-14.1l39.4-39.4c5.8-5.8 12.9-10 20.8-12.2l169.6-48.5c20.6-5.9 34.8-24.7 34.8-46.2V112c0-26.5-21.5-48-48-48h-28.3c-15.9 0-30.4 9-37.5 23.2-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l7.2-14.3c8.2-16.3 24.8-26.6 43-26.6z"
        }
    ]
};

const FalStairs = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStairs",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 48c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v112c0 8.8-7.2 16-16 16H304v144c0 8.8-7.2 16-16 16H160v112c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h112V336c0-8.8 7.2-16 16-16h128V176c0-8.8 7.2-16 16-16h128V48z"
        }
    ]
};

const FalStamp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStamp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M310.4 129.8c6.1-9.8 9.6-21.3 9.6-33.8 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 12.5 3.5 24 9.6 33.8 9.5 15.2 22.4 37.9 22.4 65.1 0 51.4-41.7 93.1-93.1 93.1H112c-44.2 0-80 35.8-80 80 0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16 0-44.2-35.8-80-80-80h-18.9c-51.4 0-93.1-41.7-93.1-93.1 0-27.1 12.9-49.9 22.4-65.1zm27.2 16.9c-9.2 14.8-17.5 30.8-17.5 48.2 0 33.8 27.4 61.1 61.1 61.1H400c61.9 0 112 50.1 112 112 0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48 0-61.9 50.1-112 112-112h18.9c33.8 0 61.1-27.4 61.1-61.1 0-17.4-8.3-33.4-17.5-48.2C165.3 132 160 114.6 160 96c0-53 43-96 96-96s96 43 96 96c0 18.6-5.3 36-14.5 50.7zM64 456v8c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-8c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalStandardDefinition = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStandardDefinition",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm240 144v160c0 8.8 7.2 16 16 16h64c53 0 96-43 96-96s-43-96-96-96h-64c-8.8 0-16 7.2-16 16zm32 16h48c35.3 0 64 28.7 64 64s-28.7 64-64 64h-48V192zm-176.4 2.4c10.1-3.3 24.9-3.6 43.9-1.1 5.8.8 23.7 3.8 29.2 5 8.6 2 17.2-3.4 19.2-12s-3.4-17.2-12-19.2c-6.8-1.6-25.8-4.7-32-5.5-20.5-2.7-41-3.1-58 2.4-18.2 5.9-32.3 18.7-36.6 40.1-.1.3-.1.6-.1.9-1.6 11.1-.2 21.3 4.6 30.2 4.7 8.8 11.9 15 19.4 19.5 13.9 8.3 32.4 12.6 47.8 16.2l1.4.3c17.3 4 31 7.4 40.1 12.8 4.2 2.5 6.4 4.9 7.6 7.1 1.1 2 2 5.1 1.2 10.6-.7 4.6-2.3 7.5-4.2 9.5-2 2.2-5.2 4.2-10.1 5.8-10.3 3.3-25.6 3.6-44.5 1-8.8-1.2-24-5.7-36.3-9.2-2.7-.8-5.3-1.5-7.6-2.2-8.5-2.4-17.4 2.5-19.8 11s2.5 17.4 11 19.8c1.8.5 3.9 1.1 6.2 1.8 12.1 3.5 30.6 9 42 10.6h.1c20.4 2.7 41.4 3.2 58.5-2.2 8.8-2.8 17.2-7.3 23.8-14.4 6.8-7.2 10.9-16.3 12.5-26.7 1.6-11.1.2-21.3-4.6-30.2-4.7-8.8-11.9-15-19.4-19.5-13.9-8.3-32.4-12.6-47.8-16.2l-1.4-.3c-17.3-4-31-7.4-40.1-12.8-4.2-2.5-6.4-4.9-7.6-7.1-1-1.9-1.9-4.9-1.2-10.1 1.8-8.2 6.3-12.8 15.1-15.6z"
        }
    ]
};

const FalStapler = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStapler",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 352v32H80c-26.5 0-48 21.5-48 48s21.5 48 48 48h512c26.5 0 48-21.5 48-48V299.3c0-36.4-20.5-69.6-53.1-85.9l-326.2-163C236.6 38.3 209.9 32 182.9 32c-54.7 0-106.2 25.8-139.1 69.6l-32.3 43.1C4 154.6 0 166.7 0 179.1c0 26.4 17.9 49.3 43.5 55.7L72 242v78c0 17.7 14.3 32 32 32h344zm-64-32H104v-70l280 70zm224 64H480v-48c0-14.7-10-27.5-24.2-31L51.3 203.8C39.9 201 32 190.8 32 179.1c0-5.5 1.8-10.9 5.1-15.3l32.3-43.1C96.2 85 138.3 64 182.9 64c22 0 43.8 5.1 63.5 15l326.2 163.1c21.7 10.8 35.4 33 35.4 57.2V384zm-128 32h128v16c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h400z"
        }
    ]
};

const FalStarAndCrescent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarAndCrescent",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256c0 118.4 91.9 215.4 208.3 223.5C151.1 444.4 88 357.6 88 256S151.1 67.6 240.3 32.5C123.9 40.6 32 137.6 32 256zM349.6 17.7c7.4 2.9 11.5 10.7 9.8 18.4s-8.8 13-16.7 12.4c-4.8-.3-9.7-.5-14.6-.5-114.9 0-208 93.1-208 208s93.1 208 208 208c4.9 0 9.8-.2 14.6-.5 7.9-.5 15 4.7 16.7 12.4s-2.4 15.5-9.8 18.4C320.6 505.7 289 512 256 512 114.6 512 0 397.4 0 256S114.6 0 256 0c33 0 64.6 6.3 93.6 17.7zm16.6 138.5.3-.5 3.4-6.9 5.5-11.2c3.5-7.1 13.7-7.1 17.2 0l5.5 11.2 3.4 6.9.3.5 22.2 45.1c1.4 2.8 4.1 4.8 7.2 5.3l49.7 7.2.6.1 7.7 1.1 12.4 1.8c7.9 1.1 11 10.8 5.3 16.4l-9 8.7-5.5 5.4-.4.4-36 35.1c-2.3 2.2-3.3 5.4-2.8 8.5l8.5 49.5.1.6 1.3 7.6 2.1 12.3c1.3 7.8-6.9 13.8-13.9 10.1l-11.1-5.8-6.8-3.6-.5-.3-44.5-23.4c-2.8-1.5-6.1-1.5-8.9 0L335 361.7l-.5.3-6.8 3.6-11.1 5.8c-7 3.7-15.3-2.3-13.9-10.1l2.1-12.3 1.3-7.6.1-.6 8.5-49.5c.5-3.1-.5-6.3-2.8-8.5l-36-35.1-.4-.4-5.5-5.4-9-8.7c-5.7-5.6-2.6-15.2 5.3-16.4l12.4-1.8 7.7-1.1.6-.1 49.7-7.2c3.1-.5 5.8-2.4 7.2-5.3l22.2-45.1zm6.5 59.2c-6.1 12.3-17.8 20.8-31.3 22.8l-25.5 3.7 18.4 18c9.8 9.6 14.3 23.3 12 36.8l-4.4 25.3 22.8-12c12.1-6.4 26.6-6.4 38.7 0l22.8 12-4.4-25.4c-2.3-13.5 2.2-27.3 12-36.8l18.4-18-25.5-3.7c-13.5-2-25.3-10.5-31.3-22.8l-11.4-23-11.4 23.1z"
        }
    ]
};

const FalStarChristmas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarChristmas",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216.8 205.4 256 55.1l39.2 150.4c1.4 5.5 5.8 9.9 11.3 11.3L456.9 256l-150.3 39.2c-5.5 1.4-9.9 5.8-11.3 11.3L256 456.9l-39.2-150.3c-1.4-5.5-5.8-9.9-11.3-11.3L55.1 256l150.4-39.2c5.5-1.4 9.9-5.8 11.3-11.3zM256 .2c-10.8 0-20.3 7.3-23.1 17.8l-44.4 170.5L18 232.9C7.5 235.7.2 245.2.2 256s7.3 20.3 17.8 23.1l170.5 44.5L232.9 494c2.7 10.5 12.2 17.8 23.1 17.8s20.3-7.3 23.1-17.8l44.5-170.5L494 279.1c10.5-2.7 17.8-12.2 17.8-23.1s-7.3-20.3-17.8-23.1l-170.5-44.4L279.1 18C276.3 7.5 266.8.2 256 .2zM68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm374.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm-288 310.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm201.4-22.6c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalStarExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarExclamation",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M202.4 186.5 65 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1l-23.6 139.5 122.6-65.5c9.4-5 20.7-5 30.2 0l122.6 65.5-23.5-139.5c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8-137.5-20.3c-10.5-1.5-19.5-8.2-24.1-17.7L287.9 42.3l-61.4 126.5c-4.6 9.5-13.6 16.1-24.1 17.7zm247.8 320.9c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6 68.6-141.3C270.4 5.2 278.7 0 287.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4 459.8 484c1.5 9-2.2 18.1-9.7 23.5zM288 128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-24 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalStarHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarHalfStroke",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M234.4 186.5 97 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1l-23.6 139.5L304 408.1v-333l-45.5 93.7c-4.6 9.5-13.6 16.1-24.1 17.7zM336 408.2l121.6 65-23.5-139.5c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8-137.5-20.3c-10.5-1.5-19.5-8.2-24.1-17.7L336 75.4v332.8zm146.2 99.2c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L183 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L63.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6 68.6-141.3C302.4 5.2 310.7 0 319.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L465.6 328.4 491.8 484c1.5 9-2.2 18.1-9.7 23.5z"
        }
    ]
};

const FalStarHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarHalf",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M226.5 168.8c-4.6 9.5-13.6 16.1-24.1 17.7L65 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1l-23.6 139.5 129.7-69.3V58.8l-53.4 110zM293.3.6c10.9 2.5 18.6 12.2 18.6 23.4v384.7c0 8.9-4.9 17-12.7 21.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6-111.1-110c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6 68.6-141.4c4.9-10.1 16.1-15.4 27-12.9z"
        }
    ]
};

const FalStarOfDavid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarOfDavid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m418.3 286.6-50 81.4h90.2a5.378 5.378 0 0 0 4.6-8.2l-44.9-73.1zM399.5 256l-68.7-112H181.2l-68.7 112 68.7 112h149.6l68.7-112zm37.5 0 53.4 87c3.6 5.9 5.5 12.7 5.5 19.6 0 20.7-16.8 37.4-37.4 37.4H348.7l-56.2 91.5c-7.7 12.8-21.6 20.5-36.5 20.5s-28.8-7.7-36.6-20.5L163.3 400H53.4C32.8 400 16 383.2 16 362.6c0-6.9 1.9-13.7 5.5-19.6l53.4-87-53.4-87c-3.6-5.9-5.5-12.7-5.5-19.6 0-20.6 16.8-37.4 37.4-37.4h109.9l56.2-91.5C227.2 7.7 241.1 0 256 0s28.8 7.7 36.6 20.5l56.1 91.5h109.9c20.7 0 37.4 16.8 37.4 37.4 0 6.9-1.9 13.7-5.5 19.6l-53.4 87zm-68.6-112 50 81.4 44.9-73.1c.5-.9.8-1.8.8-2.8 0-3-2.4-5.4-5.4-5.4h-90.3zm-57.2-32-45.9-74.8c-2-3.2-5.5-5.2-9.3-5.2s-7.3 2-9.3 5.2L200.8 112h110.4zm-167.6 32H53.4a5.378 5.378 0 0 0-4.6 8.2l44.9 73.1 50-81.4zm-50 142.6-44.8 73.1c-.5.9-.8 1.8-.8 2.8 0 3 2.4 5.4 5.4 5.4h90.2l-50-81.4zM200.8 400l45.9 74.8c2 3.2 5.5 5.2 9.3 5.2s7.3-2 9.3-5.2l45.9-74.8H200.8z"
        }
    ]
};

const FalStarOfLife = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarOfLife",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v97.1l84.1-48.6c23-13.3 52.3-5.4 65.6 17.6l16 27.7c13.3 23 5.4 52.3-17.6 65.6L384 256l84.1 48.6c23 13.3 30.8 42.6 17.6 65.6l-16 27.7c-13.3 23-42.6 30.8-65.6 17.6L320 366.9V464c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-97.1l-84.1 48.6c-23 13.3-52.3 5.4-65.6-17.6l-16-27.7c-13.3-23-5.4-52.3 17.6-65.6L128 256l-84.1-48.6 7.7-13.4-7.7 13.4c-23-13.3-30.8-42.6-17.6-65.6l16-27.7c13.3-23 42.6-30.8 65.6-17.6l84.1 48.6V48zm48-16c-8.8 0-16 7.2-16 16v124.9c0 5.7-3 11-8 13.9s-11 2.9-16 0L91.9 124.3c-7.7-4.4-17.4-1.8-21.9 5.9l-16 27.7c-4.4 7.7-1.8 17.4 5.9 21.9L168 242.1c5 2.9 8 8.1 8 13.9s-3 11-8 13.9L59.9 332.3c-7.7 4.4-10.3 14.2-5.9 21.9l16 27.7c4.4 7.7 14.2 10.3 21.9 5.9L200 325.3c5-2.9 11-2.9 16 0s8 8.1 8 13.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V339.1c0-5.7 3-11 8-13.9s11-2.9 16 0l108.1 62.4c7.7 4.4 17.4 1.8 21.9-5.9l16-27.7c4.4-7.7 1.8-17.4-5.9-21.9L344 269.9c-5-2.9-8-8.1-8-13.9s3-11 8-13.9l108.1-62.4c7.7-4.4 10.3-14.2 5.9-21.9l-16-27.7c-4.4-7.7-14.2-10.3-21.9-5.9L312 186.7c-5 2.9-11 2.9-16 0s-8-8.1-8-13.9V48c0-8.8-7.2-16-16-16h-32z"
        }
    ]
};

const FalStarSharpHalfStroke = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarSharpHalfStroke",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 93.9v282.3l-108.5 84.4 43.8-143.9c2-6.5-.4-13.6-5.9-17.6l-126-91H224c7 0 13.1-4.5 15.2-11.1L272 93.9zm32 282.3V93.9l32.8 102.9c2.1 6.6 8.3 11.1 15.2 11.1h148.7l-126 91c-5.5 4-7.9 11.1-5.9 17.6l43.8 143.9L304 376.2zM288 0c-11.7 0-22.1 7.6-25.7 18.8l-50 157.2H58.6C43.9 176 32 187.9 32 202.6c0 8.5 4.1 16.6 11 21.6l130.3 94.1-50.8 167c-4.1 13.3 5.9 26.8 19.8 26.8 4.6 0 9.1-1.5 12.7-4.4l133-103.4 132.9 103.3c3.6 2.8 8.1 4.4 12.7 4.4 13.9 0 23.9-13.4 19.8-26.8l-50.8-167L533 224.1c6.9-5 11-13 11-21.6 0-14.7-11.9-26.6-26.6-26.6H363.7l-50-157.2C310.1 7.6 299.7 0 288 0z"
        }
    ]
};

const FalStarSharpHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarSharpHalf",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m272 93.9-32.8 103c-2.1 6.6-8.2 11.1-15.2 11.1H75.3l126 91c5.5 4 7.9 11.1 5.9 17.6l-43.7 144L272 376.2V93.9zm-8.3-79.5C266.5 5.8 274.4 0 283.4 0 294.8 0 304 9.2 304 20.6V384c0 4.9-2.3 9.6-6.2 12.6l-142.7 111c-3.6 2.8-8.1 4.4-12.7 4.4-13.9 0-23.9-13.4-19.8-26.8l50.8-167L43 224.1c-6.9-5-11-13-11-21.6 0-14.6 11.9-26.5 26.6-26.5h153.7l51.4-161.6z"
        }
    ]
};

const FalStarSharp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarSharp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m288 43.6-48.8 153.3c-2.1 6.6-8.2 11.1-15.2 11.1H75.3l126 91c5.5 4 7.9 11.1 5.9 17.6l-43.7 144 114.7-89.2c5.8-4.5 13.9-4.5 19.6 0l114.7 89.2-43.8-143.9c-2-6.5.4-13.6 5.9-17.6l126-91H352c-7 0-13.1-4.5-15.2-11.1L288 43.6zm-25.7-24.8C265.9 7.6 276.3 0 288 0s22.1 7.6 25.7 18.8l50 157.2h153.7c14.7 0 26.6 11.9 26.6 26.6 0 8.5-4.1 16.6-11 21.6l-130.4 94.1 50.8 167c4.1 13.3-5.9 26.8-19.8 26.8-4.6 0-9.1-1.5-12.7-4.4L288 404.3 155.1 507.6c-3.6 2.8-8.1 4.4-12.7 4.4-13.9 0-23.9-13.4-19.8-26.8l50.8-167L43 224.1c-6.9-5-11-13-11-21.6 0-14.6 11.9-26.5 26.6-26.5h153.7l50-157.2z"
        }
    ]
};

const FalStarShooting = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarShooting",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M315.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm192 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l160-160zm0 192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64zm-378.6 63.8c10.4-1.5 19.4-8.1 24.1-17.5l39.1-79.4 39.1 79.3c4.7 9.5 13.7 16 24.1 17.5l87.5 12.7-63.4 61.9c-7.5 7.3-11 17.9-9.2 28.3l15 87.3-78.2-41.2c-9.3-4.9-20.5-4.9-29.8 0l-78.2 41.3 15-87.3c1.8-10.4-1.7-20.9-9.2-28.3l-63.4-61.9 87.5-12.7zm84.7-125.6c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94-103.5 15C.9 269.3-7 293.5 7.2 307.4l74.9 73.2-17.6 103.3c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3l-17.7-103.3 74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9l-103.5-15.1-46.3-94z"
        }
    ]
};

const FalStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m226.5 168.8 61.4-126.5 61.4 126.5c4.6 9.5 13.6 16.1 24.1 17.7l137.4 20.3-99.8 98.8c-7.4 7.3-10.8 17.8-9 28.1l23.5 139.5L303 407.7c-9.4-5-20.7-5-30.2 0l-122.6 65.5 23.5-139.5c1.7-10.3-1.6-20.7-9-28.1L65 206.8l137.4-20.3c10.5-1.5 19.5-8.2 24.1-17.7zm198.4 340.3c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5l-26.3-155.5 111.2-110.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3l-153.3-22.6-68.6-141.3C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5l-68.6 141.3-153.2 22.7c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5l111.1 110.1L116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z"
        }
    ]
};

const FalStarfighterTwinIonEngineAdvanced = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarfighterTwinIonEngineAdvanced",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M132.7 4.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L36.7 145.9c-3 3-4.7 7.1-4.7 11.3v40.4l148.6-20.3C208.1 128.8 260.2 96 320 96s111.9 32.8 139.4 81.4L608 197.7v-40.4c0-4.2-1.7-8.3-4.7-11.3L484.7 27.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l118.6 118.6c9 9 14.1 21.2 14.1 33.9v197.6c0 12.7-5.1 24.9-14.1 33.9L507.3 507.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l118.6-118.6c3-3 4.7-7.1 4.7-11.3v-40.5l-148.6 20.3C431.9 383.2 379.8 416 320 416s-111.9-32.8-139.4-81.4L32 314.3v40.4c0 4.2 1.7 8.3 4.7 11.3l118.6 118.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L14.1 388.7c-9-9-14.1-21.2-14.1-33.9V157.3c0-12.7 5.1-24.9 14.1-33.9L132.7 4.7zm341.1 207c4.1 14.1 6.2 29 6.2 44.3s-2.2 30.3-6.2 44.3L608 282v-52l-134.2-18.3zM32 282l134.2 18.3c-4.1-14.1-6.2-29-6.2-44.3s2.2-30.3 6.2-44.3L32 230v52zm288 102a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-16-66c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5H224c-8.8 0-16-7.2-16-16s7.2-16 16-16h34c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l24.1 24.1c5.1-3 10.6-5.3 16.5-6.8V160c0-8.8 7.2-16 16-16s16 7.2 16 16v34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L375 223.4c3 5.1 5.3 10.6 6.8 16.5h34c8.8 0 16 7.2 16 16s-7.2 16-16 16H382c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L352.6 311c-5.1 3-10.6 5.3-16.5 6.8v34c0 8.8-7.2 16-16 16s-16-7.2-16-16V318zm16-30a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalStarfighterTwinIonEngine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarfighterTwinIonEngine",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32c8.8 0 16 7.2 16 16v149.1l116.4-19.4C175.8 128.9 228.1 96 288 96s112.2 32.9 139.6 81.7L544 197.1V48c0-8.8 7.2-16 16-16s16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V314.9l-116.4 19.4C400.2 383.1 347.9 416 288 416s-112.2-32.9-139.6-81.7L32 314.9V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm432 224c0 15.1-2.1 29.6-6 43.4l102-17v-52.8l-102-17c3.9 13.8 6 28.4 6 43.4zM32 282.4l102 17c-3.9-13.8-6-28.4-6-43.4s2.1-29.6 6-43.4l-102 17v52.9zM416 256a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-190 16h-34c-8.8 0-16-7.2-16-16s7.2-16 16-16h34c1.5-5.9 3.8-11.4 6.8-16.5l-24.1-24.1c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l24.1 24.1c5.1-3 10.6-5.3 16.5-6.8V160c0-8.8 7.2-16 16-16s16 7.2 16 16v34c5.9 1.5 11.4 3.8 16.5 6.8l24.1-24.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L343 223.4c3 5.1 5.3 10.6 6.8 16.5h34c8.8 0 16 7.2 16 16s-7.2 16-16 16H350c-1.5 5.9-3.8 11.4-6.8 16.5l24.1 24.1c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320.6 311c-5.1 3-10.6 5.3-16.5 6.8v34c0 8.8-7.2 16-16 16s-16-7.2-16-16V318c-5.9-1.5-11.4-3.8-16.5-6.8l-24.1 24.1c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l24.1-24.1c-3-5.1-5.3-10.6-6.8-16.5zm62 16a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalStarfighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarfighter",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m269.6 35.2-29.5 242.9-.1 1V432c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V279l-.1-1-29.5-242.8C368 15.1 351 0 330.7 0h-21.4C289 0 272 15.1 269.6 35.2zm39.7-3.2h21.5c4 0 7.5 3 7.9 7L368 281v151c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V281l29.3-242c.5-4 3.9-7 7.9-7zM64 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v288c0 8.8 7.2 16 16 16s16-7.2 16-16v-19.3l72.1 30c8.6 12.8 23.3 21.3 39.9 21.3h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-32c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-26.5 0-48 21.5-48 48v16H64V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V96zm0 298v-42h64v68.7L64 394zM608 96c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v160h-64v-16c0-26.5-21.5-48-48-48h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16h-32c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c16.6 0 31.3-8.4 39.9-21.3l72.1-30V448c0 8.8 7.2 16 16 16s16-7.2 16-16V160h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V96zm-96 256h64v42l-64 26.7V352zM320 224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalStars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStars",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 16v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM152.8 265.5c-4.7 9.5-13.7 16-24.1 17.5l-87.5 12.8 63.4 61.9c7.5 7.3 11 17.9 9.2 28.3l-15 87.3 78.2-41.2c9.3-4.9 20.5-4.9 29.8 0l78.2 41.2-15-87.3c-1.8-10.4 1.7-20.9 9.2-28.3l63.4-61.9-87.5-12.7c-10.4-1.5-19.4-8.1-24.1-17.5l-39.1-79.4-39.1 79.4zm17.6-108.1c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3L192 460.4l-92.7 48.8c-17.6 9.3-38.2-5.7-34.8-25.3l17.7-103.3-75-73.2C-7 293.5.9 269.3 20.5 266.5L124 251.4l46.3-94zM448 160c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalStarshipFreighter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarshipFreighter",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M377.1 371.9 315.5 285c2.9-9.2 4.5-18.9 4.5-29 0-53-43-96-96-96s-96 43-96 96 43 96 96 96h1.7l60.7 85.7c-19.6 6.7-40.6 10.3-62.4 10.3-106 0-192-86-192-192S118 64 224 64c104.4 0 189.3 83.3 191.9 187 0 1.6.1 3.3.1 5 0 1.7 0 3.5-.1 5.2-1.1 41.5-15.4 79.8-38.9 110.7zm28.3 28.1H397l-.6-.9c22.5-27.1 38.7-59.5 46.5-95.1H544v42.1L405.4 400zm54.6 13.1 95.6-37.2c12.3-4.8 20.4-16.6 20.4-29.8V304c0-17.7-14.3-32-32-32h-96.6c.4-5.3.6-10.6.6-16 0-5.3-.2-10.6-.6-15.8v-.2H544c17.7 0 32-14.3 32-32v-42.1c0-13.2-8.1-25-20.4-29.8l-208-80.9C308.2 39.9 266.3 32 224 32 100.3 32 0 132.3 0 256s100.3 224 224 224c28.7 0 57.1-3.6 84.8-10.7l13.5 19.1c10.5 14.8 27.5 23.6 45.7 23.6h56c30.9 0 56-25.1 56-56 0-17.2-7.8-32.6-20-42.9zM447.4 208h-4.6c-8.4-38.6-26.8-73.5-52.3-101.8L544 165.9V208h-96.6zM80 272a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-16 208a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm48-112a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm188.2 213.6-85.9-125.5c15-6.5 28-16.8 37.9-29.6L380.7 432H424c13.3 0 24 10.7 24 24s-10.7 24-24 24h-56c-7.9 0-15.3-3.9-19.8-10.4z"
        }
    ]
};

const FalStarship = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStarship",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 112c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48s-21.5 48-48 48h-46.8l47.6 34.6 60.1-8.2C296.8 114.8 366.5 64 448 64c106 0 192 86 192 192s-86 192-192 192c-81.5 0-151.2-50.8-179-122.4l-60.1-8.2-47.7 34.6H208c26.5 0 48 21.5 48 48s-21.5 48-48 48H48c-26.5 0-48-21.5-48-48s21.5-48 48-48h58.8l56.2-40.9-21.5-2.9c-26-3.6-45.5-25.9-45.5-52.2s19.5-48.6 45.5-52.2l21.5-2.9-56.2-40.9H48c-26.5 0-48-21.5-48-48zm48-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm97.9 139.5c-10.3 1.4-17.9 10.2-17.9 20.5s7.6 19.1 17.9 20.5L259.4 292c-2.2-11.6-3.4-23.7-3.4-35.9s1.2-24.3 3.4-35.9l-113.5 15.3zM32 400c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm416 16a160 160 0 1 0 0-320 160 160 0 1 0 0 320zm32-160a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm-96 0a64 64 0 1 1 128 0 64 64 0 1 1-128 0z"
        }
    ]
};

const FalSteak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSteak",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 32c-31 0-57 9.9-77.4 28.9l-21.8-23.5C295.7 12.4 329.7 0 368 0c65 0 117.7 39 150.5 80 33.9 42.4 57.5 99.6 57.5 160 0 83.9-55.1 152.8-113.4 196.2-60.5 45-140.9 75.8-222.6 75.8-36.8 0-86.5-4.4-130-19.3C73.4 480.1 0 444.3 0 360c0-38.6 17.8-68.3 42.5-88.1 19.6-15.8 41.4-26.8 63.3-37.8 27.3-13.8 54.6-27.6 77.7-50.7 13.8-13.8 19.7-27.9 30-52.9 3.2-7.7 6.8-16.5 11.2-26.6 7.7-17.6 20.6-44.7 44.1-66.5l21.8 23.4c-18.4 17.1-29.1 39-36.5 55.9-4.3 9.8-7.8 18.3-11 26l-1.1 2.6c-9.5 23-17.5 42.4-35.9 60.7-24.6 24.6-52.8 39.8-77.6 52.4-2.8 1.4-5.5 2.8-8.2 4.2-22.2 11.2-40.9 20.7-57.8 34.3C44.4 311.4 32 332.3 32 360c0 61.4 53 90.2 88.4 102.4C159.3 475.8 205.2 480 240 480c74 0 147.9-28.1 203.5-69.5C497.9 370 544 309.5 544 240c0-52.2-20.6-102.6-50.5-140-29.4-36.7-73.8-68-125.5-68zm-16 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm-230.1 73.7c28.3-11.9 65.5-27.6 106.8-69 23.4-23.4 35.6-52.6 47.2-81.3l.1-.2c2.4-5.9 4.8-11.9 7.3-17.6 7.1-16.3 15.7-32.9 29-45.3 14-13 32-20.3 55.6-20.3 38.6 0 74.7 23.8 100.5 56 26 32.5 43.5 75.9 43.5 120 0 55.2-37.2 107.3-87.6 144.8-50.7 37.8-118 63.2-184.3 63.2-32.9 0-74.9-4.1-109.2-15.9C97.5 420.7 64 399 64 360c0-7.5 1.1-15.6 4.7-23.6 3.7-8.3 9.1-13.9 13.5-17.7 10.2-8.6 24.2-14.6 37.6-20.2l.8-.3 1.2-.5zm12.4 29.5-1.2.5c-15.2 6.4-24.3 10.5-30.2 15.5-4.3 3.6-6.9 7.8-6.9 16.8 0 16.7 14.1 31.2 45.2 41.9C170.9 412.1 209 416 240 416c58.6 0 119.4-22.6 165.3-56.8C451.7 324.6 480 280.8 480 240c0-35.9-14.5-72.5-36.5-100-22.2-27.8-50.1-44-75.5-44-16.3 0-26.3 4.7-33.9 11.7-8.2 7.6-14.6 19-21.5 34.7-2.3 5.3-4.6 11-7.1 17-11.4 28.1-25.6 63.2-54.3 91.9-45.8 45.8-87.7 63.5-117 75.8z"
        }
    ]
};

const FalSteeringWheel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSteeringWheel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 384v95.4C134.4 472 49.1 391.4 34.3 288h106.1c2.2 4.2 5.1 8.1 8.6 11.6l73.1 73.1c5.2 5.2 11.4 9 17.9 11.3zm32 0c6.6-2.3 12.7-6.1 17.9-11.3l73.1-73.1c3.5-3.5 6.3-7.4 8.6-11.6h106.1C462.9 391.4 377.6 472 272 479.4V384zm104.1-128c-.8-4-2.2-8-4.1-11.8l-12.8-25.7c-8.2-16.2-24.8-26.5-43-26.5H195.8c-18.2 0-34.8 10.3-42.9 26.5L140 244.2c-1.9 3.8-3.3 7.8-4.1 11.8H32C32 132.3 132.3 32 256 32s224 100.3 224 224H376.1zM256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-74.5-279.2c2.7-5.4 8.3-8.8 14.3-8.8h120.4c6.1 0 11.6 3.4 14.3 8.8l12.8 25.7c3.1 6.2 1.9 13.6-3 18.5l-73.1 73.1c-6.2 6.2-16.4 6.2-22.6 0l-73-73.1c-4.9-4.9-6.1-12.3-3-18.5l12.8-25.7z"
        }
    ]
};

const FalSterlingSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSterlingSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 152c0-48.6 39.4-88 88-88h7.1c9.5 0 18.9 1.5 27.8 4.5l80 26.7c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2l-80-26.7c-12.2-4.1-25-6.2-37.9-6.2H168C101.7 32 48 85.7 48 152v104H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h31.9C46.3 346.2 31 403.1 3.1 454.3l-1.1 2c-2.7 5-2.6 11 .3 15.8S10.4 480 16 480h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H42.1c23.5-50.1 36.4-104.6 37.8-160H240c8.8 0 16-7.2 16-16s-7.2-16-16-16H80V152z"
        }
    ]
};

const FalStethoscope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStethoscope",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M127 10.4c3.1 8.3-1.1 17.5-9.4 20.6L74.4 47.2c-6.3 2.3-10.4 8.3-10.4 15V192c0 70.7 57.3 128 128 128s128-57.3 128-128V62.2c0-6.7-4.1-12.6-10.4-15L266.4 31c-8.3-3.1-12.5-12.3-9.4-20.6S269.3-2.1 277.6 1l43.2 16.2c18.7 7 31.1 24.9 31.1 44.9V192c0 83-63.1 151.2-144 159.2v.8c0 70.7 57.3 128 128 128s128-57.3 128-128v-98c-27.6-7.1-48-32.2-48-62 0-35.3 28.7-64 64-64s64 28.7 64 64c0 29.8-20.4 54.9-48 62v98c0 88.4-71.6 160-160 160s-160-71.6-160-160v-.8C95.1 343.2 32 275 32 192V62.2c0-20 12.4-37.9 31.1-44.9L106.4 1c8.3-3.1 17.5 1.1 20.6 9.4zM480 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalStocking = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStocking",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 32h256v48H96V32zm-32 0v48c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H96C78.3 0 64 14.3 64 32zm64 206.9V144H96v94.9c0 10.7-5.3 20.7-14.2 26.6l-26.1 17.4C20.9 306.1 0 345.1 0 386.9v2.2C0 457 55 512 122.8 512c24.2 0 48-7.2 68.1-20.6L295 422c35.6-23.7 57-63.7 57-106.5V144h-32v171.5c0 32.1-16 62.1-42.7 79.9l-104.1 69.3c-14.9 9.9-32.4 15.3-50.4 15.3-50.1 0-90.8-40.7-90.8-90.8V387c0-31.1 15.6-60.2 41.4-77.4l26.1-17.4c17.8-11.9 28.5-31.9 28.5-53.3z"
        }
    ]
};

const FalStomach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStomach",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v64c0 61.9 50.1 112 112 112h20c-2.6 10.2-4 21-4 32v48c0 44.2-35.8 80-80 80h-64c-54.5 0-100 39-110 90.6-1.3 6.2-2 12.6-2 19.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-5.2.5-10.2 1.4-15.1 3.8-16.7 14.9-31.2 30.6-39 24.8-12.4 56.5-5.7 78.4 15.2C181.3 462.3 246.5 512 320 512c106 0 192-86 192-192v-96c0-70.7-57.3-128-128-128-47.4 0-88.7 25.7-110.9 64H240c-44.2 0-80-35.8-80-80V16zm4.5 386c-7.4-7.1-15.9-13.2-25-18H176c42.8 0 80-24 98.9-59.4 25.6-11.2 43.6-12.6 57.6-10.2 15.3 2.6 27.6 9.7 42.4 18.4l.5.3c14.1 8.3 30.9 18.1 52.1 20.7 15.2 1.8 31.7-.2 50.4-7.3C465.2 422.2 399.4 480 320 480c-60.3 0-117.5-41.7-155.5-78zM480 310.5c-21.6 11-36.9 12.9-48.7 11.5-13.9-1.7-25.4-8.1-40.2-16.8l-1.2-.7c-13.9-8.2-30.7-18-52.1-21.6-15.1-2.5-31.7-1.8-50.7 3.4.6-4.7.9-9.4.9-14.3v-48c0-53 43-96 96-96s96 43 96 96v86.5z"
        }
    ]
};

const FalStop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStop",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h256zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalStopwatch20 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStopwatch20",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64.6C100.6 104.8 16 194.5 16 304c0 114.9 93.1 208 208 208s208-93.1 208-208c0-47.6-16-91.4-42.9-126.5l38.2-38.2c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-37 37c-33.7-32.3-78.3-53.3-127.7-57V32h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm80 480a176 176 0 1 1 0-352 176 176 0 1 1 0 352zm16-240v128c0 26.5 21.5 48 48 48s48-21.5 48-48V240c0-26.5-21.5-48-48-48s-48 21.5-48 48zm48-16c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm-136.2 11.3c2.3-6.8 8.6-11.3 15.7-11.3 9.1 0 16.5 7.4 16.5 16.5v14.8c0 7.1-2.4 14-6.9 19.6l-32.6 40.7c-15.9 19.9-24.5 44.5-24.5 70V400c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c.4-17.6 6.5-34.6 17.5-48.3l32.6-40.7c9-11.2 13.9-25.2 13.9-39.6v-14.9c0-26.8-21.7-48.5-48.5-48.5-20.9 0-39.4 13.4-46.1 33.2l-.6 1.7c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l.6-1.7z"
        }
    ]
};

const FalStopwatch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStopwatch",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v64.6c49.4 3.8 94 24.8 127.7 57l37-37c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-38.2 38.2C416 212.6 432 256.4 432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-109.5 84.6-199.2 192-207.4V32h-64c-8.8 0-16-7.2-16-16zM48 304a176 176 0 1 0 352 0 176 176 0 1 0-352 0zm192-96v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalStoreLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStoreLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M520.6 120.9c8.1 12.7 9.2 26.8 5.6 39.1h1.8c10.4 0 20.5 1.4 30.1 4.1 4.4-19.8 1.5-41.5-10.4-60.3l-57.4-90.7C485.2 5 476.1 0 466.4 0H109.6c-9.7 0-18.8 5-23.9 13.1l-57.4 90.7c-29.6 46.8-3.4 111.9 51.9 119.4 4 .5 8.1.8 12.1.8 19.6 0 37.5-6.4 52-17 4.8-3.5 9.2-7.6 13.2-11.9 4 4.4 8.4 8.4 13.2 11.9 14.5 10.6 32.4 17 52 17s37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12 4 4.4 8.4 8.4 13.2 11.9 14.5 10.6 32.4 17 52 17 19.8 0 37.8-6.5 52.3-17.3 4.7-3.5 9-7.4 12.9-11.7 3.9 4.3 8.3 8.3 13 11.8 1.2.9 2.5 1.8 3.8 2.7 6.1-9.1 13.5-17.2 22-24.1-5.7-3.1-10.8-7.1-15.1-11.8-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4-16.5 0-31.3-7.2-41.4-18.4-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C254 184.8 239.3 192 222.7 192c-16.5 0-31.3-7.2-41.4-18.4-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C123.6 184.8 109 192 92.4 192c-2.6 0-5.2-.2-7.9-.5-29.3-4-47.7-41-29.1-70.6L111.6 32h352.8l56.2 88.9zM96 352v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v176c0 35.3 28.7 64 64 64h264.6c-5.4-9.4-8.6-20.3-8.6-32H128c-17.7 0-32-14.3-32-32v-64h288v-32H96zm432-128c26.5 0 48 21.5 48 48v48h-96v-48c0-26.5 21.5-48 48-48zm-80 48v48c-17.7 0-32 14.3-32 32v128c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32V352c0-17.7-14.3-32-32-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80zm0 80h160v128H448V352z"
        }
    ]
};

const FalStoreSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStoreSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M544 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v54l32 25.3V272zm-158.9-48c19.8 0 37.8-6.5 52.3-17.3 4.7-3.5 9-7.4 12.9-11.7 3.9 4.3 8.3 8.3 13 11.8 14.5 10.7 32.5 17.2 52.2 17.2 4.1 0 8.1-.3 12.1-.8 55.5-7.4 81.8-72.5 52.1-119.4l-57.4-90.7C517.2 5 508.1 0 498.4 0H141.6c-9.7 0-18.8 5-23.9 13.1l-.7 1.1 25.3 19.9 1.3-2.1h352.8l56.2 88.9c18.7 29.6.3 66.6-29.2 70.6-2.6.3-5.2.5-7.9.5-16.5 0-31.2-7.2-41.5-18.5-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4-16.5 0-31.3-7.2-41.4-18.4a32.05 32.05 0 0 0-23.7-10.5c-4 0-7.9.8-11.6 2.2l74.2 58.8h2.3zm-220.9-9.5-29.7-23.4c-3.3.6-6.7.9-10.1.9-2.6 0-5.2-.2-7.9-.5-20.7-2.8-35.9-22.1-36.6-43.5l-29-22.9c-12 43.2 14 91.7 61.3 98.1 4 .5 8.1.8 12.1.8 14.4 0 27.9-3.5 39.8-9.5zM378.8 384l-40.5-32H128v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v176c0 35.3 28.7 64 64 64h320c15.9 0 30.4-5.8 41.6-15.3L495.4 476c-4.6 2.5-9.8 4-15.4 4H160c-17.7 0-32-14.3-32-32v-64h250.8zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalStore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStore",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M520.6 120.9c18.7 29.6.3 66.6-29.2 70.6-2.6.3-5.2.5-7.9.5-16.5 0-31.2-7.2-41.5-18.5-6.1-6.7-14.7-10.5-23.7-10.5s-17.6 3.8-23.7 10.5c-10.2 11.2-24.8 18.4-41.4 18.4-16.5 0-31.3-7.2-41.4-18.4-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C254 184.8 239.3 192 222.7 192c-16.5 0-31.3-7.2-41.4-18.4-6.1-6.7-14.7-10.5-23.7-10.5s-17.7 3.8-23.7 10.5C123.6 184.8 109 192 92.4 192c-2.6 0-5.2-.2-7.9-.5-29.3-4-47.7-41-29.1-70.6L111.6 32h352.8l56.2 88.9zM483.4 224c4.1 0 8.1-.3 12.1-.8 55.5-7.4 81.8-72.5 52.1-119.4l-57.3-90.7C485.2 5 476.1 0 466.4 0H109.6c-9.7 0-18.8 5-23.9 13.1l-57.4 90.7c-29.6 46.8-3.4 111.9 51.9 119.4 4 .5 8.1.8 12.1.8 19.6 0 37.5-6.4 52-17 4.8-3.5 9.2-7.6 13.2-11.9 4 4.4 8.4 8.4 13.2 11.9 14.5 10.6 32.4 17 52 17s37.5-6.4 52-17c4.8-3.5 9.2-7.6 13.2-12 4 4.4 8.4 8.4 13.2 11.9 14.5 10.6 32.4 17 52 17 19.8 0 37.8-6.5 52.3-17.3 4.7-3.5 9-7.4 12.9-11.7 3.9 4.3 8.3 8.3 13 11.8 14.5 10.7 32.5 17.2 52.2 17.2zM80 256c-8.8 0-16 7.2-16 16v176c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H96v-80c0-8.8-7.2-16-16-16zm16 128h384v64c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-64z"
        }
    ]
};

const FalStrawberry = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStrawberry",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M495.4 20.4c-11.5 40.2-38.5 68.5-66.7 92.3 34.5 3.5 59.9 20.6 71.2 29.6 8.4 6.7 12.1 16.5 12.1 25.8 0 9.2-3.7 19-11.8 25.7-9.2 7.6-29 21.9-54.1 27.8-4-5-8.3-9.9-12.9-14.5l-15-15c1.9.1 3.8.1 5.9.1 23.9 0 45.4-14.5 55.8-23v-.1c.1-.1.2-.4.2-.9 0-.4-.1-.7-.1-.8-10.3-8.3-33.6-23.4-64-23.4-14.7 0-22.9 1.8-26.9 3.2-1.6.6-2.6 1-2.9 1.2-2.4 1.9-5.1 3.1-8 3.5l-18-18c.4-2.9 1.5-5.6 3.5-8 .2-.4.7-1.3 1.2-2.9 1.3-4 3.2-12.2 3.2-26.9 0-30.4-15.1-53.7-23.2-63.9-.1 0-.4-.1-.8-.1-.5 0-.8.1-.9.2h-.1c-8.5 10.4-23 32-23 55.8 0 2 0 4 .1 5.9l-15-15c-4.6-4.6-9.5-8.9-14.5-12.9 5.9-25.2 20.2-44.9 27.8-54.1C325 3.7 334.8 0 344 0s19.1 3.7 25.8 12.1c10 12.5 29.8 42.4 30.2 82.7 29.8-24.3 54.6-48.1 64.6-83.1 2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8zm-206 88 114.2 114.2 6.9 6.9c25 25 37.5 57.8 37.5 90.5 0 96-96 192-272 192C48 512 0 464 0 336 0 160 96.2 64 192.2 64c32.7.1 65.3 12.6 90.3 37.5l6.9 6.9zM32 336c0 61.3 11.8 94.5 30.6 113.4S114.7 480 176 480c166.1 0 240-88.5 240-160 0-24.6-9.4-49.1-28.1-67.9l-128-128C241.2 105.4 216.8 96 192.2 96 120.7 96 32 170 32 336zm157.5-181.5c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7-3.2-22.4 8.7-34.3 28.3-14.6 34.3-8.7zm47.3 98.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3 28.3-14.6 34.3-8.7 3.2 22.4-8.7 34.3zm-32 80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3 28.3-14.6 34.3-8.7 3.2 22.4-8.7 34.3zm-32 80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3 28.3-14.6 34.3-8.7 3.2 22.4-8.7 34.3zm96.7-66.3c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7-3.2-22.4 8.7-34.3 28.3-14.6 34.3-8.7zm24-80c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7-3.2-22.4 8.7-34.3 28.3-14.6 34.3-8.7zm55.3 90.3c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3 28.3-14.6 34.3-8.7 3.2 22.4-8.7 34.3zm-192-80c-11.9 11.9-28.3 14.6-34.3 8.7s-3.2-22.4 8.7-34.3 28.3-14.6 34.3-8.7 3.2 22.4-8.7 34.3zm-23.3 53.7c5.9 5.9 3.2 22.4-8.7 34.3s-28.3 14.6-34.3 8.7-3.2-22.4 8.7-34.3 28.3-14.6 34.3-8.7z"
        }
    ]
};

const FalStreetView = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStreetView",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-64 152v-56c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v56c-14.4 2.1-25.6 13.8-27.2 28.3l-8.9 84.5c-.4 4.1-3.9 7.2-8 7.2H236c-4.1 0-7.5-3.1-8-7.2l-8.9-84.5c-1.5-14.5-12.7-26.2-27.2-28.3zm-32-56v56c0 16.1 11.9 29.4 27.3 31.7l8.9 84.5c2.1 20.4 19.3 35.8 39.8 35.8h40c20.5 0 37.6-15.5 39.8-35.8l8.9-84.5c15.5-2.3 27.3-15.6 27.3-31.7v-56c0-35.3-28.7-64-64-64h-64c-35.3 0-64 28.7-64 64zm-33.4 159.7c8.7-1.7 14.4-10.1 12.7-18.7s-10.1-14.4-18.7-12.7c-33.2 6.4-61.8 15.3-82.6 26.2-10.4 5.5-19.5 11.9-26.2 19.5C4.9 405.6 0 415.1 0 426.2c0 17.6 12.2 31 25.8 40.3 14.1 9.7 33.5 17.8 56 24.4C127.1 504.1 188.7 512 256 512s128.9-7.9 174.2-21.1c22.5-6.6 41.9-14.7 56-24.4 13.6-9.4 25.8-22.7 25.8-40.3 0-11.1-4.9-20.6-11.8-28.3-6.7-7.5-15.9-13.9-26.2-19.4-20.8-11-49.4-19.8-82.6-26.2-8.7-1.7-17.1 4-18.7 12.7s4 17.1 12.7 18.7c31.6 6.1 56.8 14.2 73.6 23.1 8.4 4.5 14 8.7 17.3 12.5 3.2 3.6 3.6 5.9 3.6 6.9 0 1.6-1.3 6.6-11.9 14-10.2 7-25.9 13.9-46.8 20-41.6 12.1-100 19.8-165.2 19.8s-123.6-7.7-165.2-19.8c-20.9-6.1-36.7-13-46.8-20-10.7-7.3-11.9-12.3-11.9-14 0-1.1.4-3.3 3.6-6.9 3.3-3.7 8.9-8 17.3-12.5 16.8-8.9 42-17 73.6-23.1z"
        }
    ]
};

const FalStretcher = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStretcher",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M27.3 68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l141.2 141.3c15 15 35.4 23.4 56.6 23.4H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H202.5c-12.7 0-24.9-5.1-33.9-14.1L27.3 68.7zM224 448a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-8.8-1.8-17.3-5-24.9l53-40.6 53 40.6c-3.2 7.7-5 16.1-5 24.9 0 35.3 28.7 64 64 64s64-28.7 64-64-28.7-64-64-64c-14.9 0-28.6 5.1-39.5 13.6l-46.2-35.3 97.3-74.3h-52.7L368 342.2 297.1 288h-52.7l97.2 74.4-46.2 35.3c-10.8-8.6-24.5-13.7-39.4-13.7-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FalStrikethrough = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStrikethrough",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M129.7 132c4.8-25.9 22-44.8 49.7-56.2 28.3-11.7 67-15 111-8.4 13.8 2.1 56.1 10 69.7 13.5 8.6 2.2 17.3-3 19.5-11.5s-3-17.3-11.5-19.5c-15.1-3.9-58.6-12-72.9-14.1-47.7-7.2-92.7-4.1-127.9 10.5-35.7 14.7-62.1 41.6-69.1 80.6-.1.3-.1.6-.1.9-2.8 22.9.6 42.7 9.5 59.7 8.8 16.8 22.4 29.6 37.9 39.8 18.7 12.2 41.6 21.2 65.2 28.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16H319.4c-18.1-6.6-37-12.1-55.3-17.3l-1.2-.3c-39-11.2-74.8-21.6-100.2-38.1-12.5-8.1-21.5-17.2-27.1-27.8-5.4-10.4-8.1-23.3-6.1-40.5zM379 336.8c4.7 10.8 6.6 24.5 3.4 42.7-4.7 26.1-21.9 45.2-49.8 56.6-28.3 11.7-66.9 15-110.9 8.4-22.1-3.5-59.5-15.7-88-25.1-6.1-2-11.8-3.9-16.8-5.5-8.4-2.7-17.4 1.9-20.1 10.4s1.9 17.4 10.4 20.1c4.4 1.4 9.6 3.1 15.3 5 28.3 9.3 69.3 22.8 94.4 26.7h.1c47.7 7.2 92.7 4.1 127.9-10.5C380.6 450.9 407 424 414 385c4.2-23.3 2.2-43.7-5.6-61.3-.6-1.3-1.2-2.7-1.9-4h-38.8c4.9 5.2 8.6 10.8 11.3 16.8z"
        }
    ]
};

const FalStroopwafel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalStroopwafel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 0 0 448 224 224 0 1 0 0-448zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm142.9-135.8 45.3 45.3 45.3-45.3-22.8-22.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 97.6 278.6 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-22.6 22.6 45.3 45.3 45.3-45.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-45.3 45.3 45.3 45.3 22.6-22.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L414.4 256l22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-22.6-22.6-45.3 45.3 45.3 45.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-45.3-45.3-45.3 45.3 22.6 22.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 414.4 233.4 437c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l22.6-22.6-45.3-45.3-45.3 45.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l45.3-45.3-45.3-45.3-22.6 22.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.6 256 75 233.4c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l22.6 22.6 45.3-45.3-45.3-45.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm45.3 90.5L142.9 256l45.3 45.3 45.2-45.3-45.3-45.3zm181 45.3-45.3-45.3-45.3 45.3 45.3 45.3 45.2-45.3zm-67.9 67.9L256 278.6l-45.3 45.3 45.3 45.2 45.3-45.3zm-90.6-135.8 45.3 45.3 45.3-45.3-45.3-45.2-45.3 45.3z"
        }
    ]
};

const FalSubscript = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSubscript",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64C7.2 64 0 71.2 0 80s7.2 16 16 16h39.2L157 256 55.2 416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c5.5 0 10.6-2.8 13.5-7.4L176 285.8l98.5 154.8c2.9 4.6 8 7.4 13.5 7.4h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-39.2L195 256 296.8 96H336c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-5.5 0-10.6 2.8-13.5 7.4L176 226.2 77.5 71.4c-2.9-4.6-8-7.4-13.5-7.4H16zm448 272c0-5.1-2.5-10-6.6-13s-9.5-3.8-14.4-2.2l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V480h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V336z"
        }
    ]
};

const FalSubtitlesSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSubtitlesSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm434 444.6H96c-17.7 0-32-14.3-32-32V135.4l-32-25.2V416c0 35.3 28.7 64 64 64h404.4l-40.5-32zM544 32H139.6l40.5 32H544c17.7 0 32 14.3 32 32v280.6l32 25.3V96c0-35.3-28.7-64-64-64zM423.3 256l40.5 32H496c8.8 0 16-7.2 16-16s-7.2-16-16-16h-72.7zM144 256c-8.8 0-16 7.2-16 16s7.2 16 16 16h113.2l-40.5-32H144zm160 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h74.8l-40.5-32H304zm-160 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96z"
        }
    ]
};

const FalSubtitles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSubtitles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm112 160h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm256 0h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-256 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm160 0h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H272c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSuitcaseMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSuitcaseMedical",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32h160c8.8 0 16 7.2 16 16v48H160V48c0-8.8 7.2-16 16-16zm-48 16v48H64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64h-64V48c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm256 80v320H128V128h256zm-288 0v320H64c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h32zm320 320V128h32c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32h-32zM240 176c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32v-32c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3v-48z"
        }
    ]
};

const FalSuitcaseRolling = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSuitcaseRolling",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48v80h128V48c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm-32 80V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v80h32c35.3 0 64 28.7 64 64v224c0 35.3-28.7 64-64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h32zM80 448h240c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h16zm16-192c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalSuitcase = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSuitcase",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 48v48h192V48c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 48V48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v48h64c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64zm240 32H128v320h256V128h-16zm-304 0c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h32V128H64zm384 320c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-32v320h32z"
        }
    ]
};

const FalSunBright = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSunBright",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zM0 256c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm400 0c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80c-8.8 0-16-7.2-16-16zM256 400c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80c0-8.8 7.2-16 16-16zM75 75c6.2-6.2 16.4-6.2 22.6 0l56.6 56.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L75 97.6c-6.2-6.2-6.2-16.4 0-22.6zm0 362c-6.2-6.2-6.2-16.4 0-22.6l56.6-56.6c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L97.6 437c-6.2 6.2-16.4 6.2-22.6 0zm282.8-282.8c-6.2-6.2-6.2-16.4 0-22.6L414.4 75c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-56.6 56.6c-6.2 6.2-16.4 6.2-22.6 0zm0 203.6c6.2-6.2 16.4-6.2 22.6 0l56.6 56.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-56.6-56.6c-6.2-6.2-6.2-16.4 0-22.6zM336 256a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm-192 0a112 112 0 1 1 224 0 112 112 0 1 1-224 0z"
        }
    ]
};

const FalSunCloud = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSunCloud",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.9c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6l90.4-62.3 90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9l9.4-50.9c-11-.4-21.6-2.6-31.4-6.5l-5 27.3-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0l-79.1 54.5-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8l-94.3-17.4L97.7 265c3.8-5.5 3.8-12.7 0-18.2l-54.5-78.9 94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5L247 97.7c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-17.1 24.8c4-.4 8.2-.7 12.3-.7 8.6 0 17 1 25.1 2.8l20.1-29.2c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zM256 128c-70.7 0-128 57.3-128 128s57.3 128 128 128c12.4 0 24.5-1.8 35.8-5.1-2.5-8.5-3.8-17.6-3.8-26.9 0-1.9.1-3.7.2-5.5-10.1 3.6-20.9 5.5-32.2 5.5-53 0-96-43-96-96s43-96 96-96 96 43 96 96c0 1.9-.1 3.7-.2 5.5 3.2-1.1 6.4-2.1 9.7-2.9 4.9-11 11.5-21.1 19.5-29.9C368.6 171.1 317.3 128 256 128zm208 96c-38.7 0-71 27.5-78.4 64H384c-35.3 0-64 28.7-64 64s28.7 64 64 64h184c39.8 0 72-32.2 72-72s-32.2-72-72-72c-10.1 0-19.7 2.1-28.4 5.8C528.8 246.5 499 224 464 224zm0 32c26.5 0 48 21.5 48 48v.8c0 6.5 3.9 12.4 9.9 14.9s13 1.1 17.5-3.6c7.3-7.4 17.4-12 28.6-12 22.1 0 40 17.9 40 40s-17.9 40-40 40H384c-17.7 0-32-14.3-32-32s14.3-32 32-32c3.8 0 7.4.6 10.7 1.8 5 1.8 10.6 1 14.9-2.2s6.7-8.2 6.5-13.5v-2.1c0-26.5 21.5-48 48-48z"
        }
    ]
};

const FalSunDust = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSunDust",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l25.1-25.1c-2.2-2.2-5.2-3.8-8.4-4.4l-94.5-17.4L97.7 265c3.8-5.5 3.8-12.7 0-18.2l-54.5-79 94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5L247 97.6c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c.6 3.3 2.2 6.2 4.4 8.4l24.9-25-19.9-107.9zM256 128c-70.7 0-128 57.3-128 128 0 35.3 14.3 67.3 37.5 90.5l22.6-22.6C170.7 306.5 160 282.5 160 256c0-53 43-96 96-96 26.5 0 50.5 10.7 67.9 28.1l22.6-22.6C323.4 142.3 291.3 128 256 128zm248 32a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM400 264a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zM400 424a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-240 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm160 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm184-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-264-56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-104a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalSunHaze = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSunHaze",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M435.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L320 65.1 229.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L185 121 77.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2l62.3 90.4h35.4c0-3.2-.9-6.4-2.8-9.1l-54.5-79.1 94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5L311 97.6c5.5 3.8 12.7 3.8 18.2 0l79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-1.9 2.7-2.8 5.9-2.8 9.1h35.4l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L455 121 435.1 13.1zM448 256c0-70.7-57.3-128-128-128s-128 57.3-128 128h32c0-53 43-96 96-96s96 43 96 96h32zM80 288c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm416 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H496zM16 384c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm64 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm224 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c8.8 0 16-7.2 16-16s-7.2-16-16-16H304z"
        }
    ]
};

const FalSunPlantWilt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSunPlantWilt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160.5 0c-5.9 0-11.3 3.2-14.1 8.4l-27.5 51-55.5-16.7c-5.6-1.7-11.7-.1-15.9 4s-5.7 10.3-4 15.9L60.1 118l-51 27.5c-5.2 2.8-8.4 8.2-8.4 14.1s3.2 11.3 8.4 14.1l51 27.5-16.6 55.5c-1.7 5.6-.2 11.7 4 15.9s10.3 5.7 15.9 4l55.5-16.6 27.5 51c2.8 5.2 8.2 8.4 14.1 8.4s11.3-3.2 14.1-8.4l27.5-51 55.6 16.6c5.6 1.7 11.7.1 15.9-4s5.7-10.3 4-15.9L261 201.3l51-27.5c5.2-2.8 8.4-8.2 8.4-14.1s-3.2-11.3-8.4-14.1l-51-27.5 16.6-55.4c1.7-5.6.2-11.7-4-15.9s-10.3-5.7-15.9-4l-55.6 16.6-27.5-51c-2.8-5.2-8.2-8.4-14.1-8.4zm0 49.7L180.1 86c3.6 6.7 11.4 9.9 18.7 7.7l39.6-11.8-11.9 39.5c-2.2 7.3 1.1 15.1 7.7 18.7l36.3 19.6-36.3 19.6c-6.7 3.6-9.9 11.4-7.7 18.7l11.9 39.5-39.6-11.8c-7.3-2.2-15.1 1.1-18.7 7.7l-19.6 36.3-19.6-36.3c-3.6-6.7-11.4-9.9-18.7-7.7l-39.6 11.7 11.9-39.5c2.2-7.3-1.1-15.1-7.7-18.7l-36.4-19.5 36.3-19.6c6.7-3.6 9.9-11.4 7.7-18.7L82.6 81.9l39.6 11.8c7.3 2.2 15.1-1.1 18.7-7.7l19.6-36.3zm32.6 111.2a32 32 0 1 0-63.9 0 32 32 0 1 0 63.9 0zm303.7.1c0-17.6 14.3-32 32-32s32 14.3 32 32v49.5c-11.4 2.5-21.7 7.9-29.9 16.2-11.9 12.1-18 28.9-18 48 0 14.4 7.5 30.9 16.5 45.3 9.4 15.1 22.3 30.7 36.5 44.1 6.2 5.8 15.8 5.8 22 0 14.2-13.4 27.1-29.1 36.5-44.2 9-14.4 16.5-30.9 16.5-45.2 0-19.1-6.1-35.9-18-48-8.2-8.3-18.5-13.7-29.9-16.2v-49.6c0-35.3-28.6-64-64-64s-64 28.6-64 64v43.9c-11.4-7.6-25.2-12.1-39.9-12.1-39.7 0-71.9 32.2-71.9 71.9v9.6c-11.4 2.5-21.7 7.9-29.9 16.2-11.9 12.1-18 28.9-18 48 0 14.4 7.5 30.9 16.5 45.3 9.5 15.1 22.3 30.7 36.5 44.1 6.2 5.8 15.8 5.8 22 0 14.2-13.4 27.1-29.1 36.5-44.2 9-14.4 16.5-30.9 16.5-45.2 0-19.1-6.1-35.9-18-48-8.2-8.3-18.5-13.7-29.9-16.2v-9.6c0-22.1 17.9-39.9 39.9-39.9s39.9 17.9 39.9 39.9v215.5H17.3c-8.8 0-16 7.2-16 16s7.2 16 16 16h607.4c8.8 0 16-7.2 16-16s-7.2-16-16-16H496.8V160.9zM368.9 304.6c10.6 0 18.2 3.4 23.2 8.4s8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3-5.5 8.8-12.5 18-20.3 26.7-7.9-8.7-14.9-17.8-20.3-26.6-8.3-13.3-11.6-23.3-11.6-28.3 0-12.3 3.8-20.5 8.8-25.5 5-5 12.6-8.4 23.2-8.4zm228.1-1.7c-5.5 8.8-12.5 18-20.3 26.7-7.9-8.7-14.9-17.8-20.3-26.6-8.3-13.3-11.6-23.3-11.6-28.3 0-12.3 3.8-20.5 8.8-25.5 5-5 12.6-8.4 23.2-8.4s18.2 3.4 23.2 8.4 8.8 13.2 8.8 25.5c0 4.9-3.3 14.9-11.6 28.3z"
        }
    ]
};

const FalSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSun",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M371.1 13.1c-1-5.3-4.6-9.8-9.6-11.9s-10.7-1.5-15.2 1.6L256 65.1 165.7 2.8c-4.5-3.1-10.2-3.7-15.2-1.6s-8.6 6.6-9.6 11.9L121 121 13.1 140.8c-5.3 1-9.8 4.6-11.9 9.6s-1.5 10.7 1.6 15.2L65.1 256 2.8 346.3c-3.1 4.5-3.7 10.2-1.6 15.2s6.6 8.6 11.9 9.6L121 391l19.8 107.9c1 5.3 4.6 9.8 9.6 11.9s10.7 1.5 15.2-1.6l90.4-62.3 90.3 62.3c4.5 3.1 10.2 3.7 15.2 1.6s8.6-6.6 9.6-11.9L391 391l107.9-19.8c5.3-1 9.8-4.6 11.9-9.6s1.5-10.7-1.6-15.2L446.9 256l62.3-90.3c3.1-4.5 3.7-10.2 1.6-15.2s-6.6-8.6-11.9-9.6L391 121 371.1 13.1zm-106 84.6 79.1-54.5 17.4 94.5c1.2 6.5 6.3 11.6 12.8 12.8l94.5 17.4-54.5 79.1c-3.8 5.5-3.8 12.7 0 18.2l54.5 79.1-94.5 17.4c-6.5 1.2-11.6 6.3-12.8 12.8L344.2 469l-79.1-54.5c-5.5-3.8-12.7-3.8-18.2 0L167.8 469l-17.4-94.5c-1.2-6.5-6.3-11.6-12.8-12.8l-94.4-17.6L97.7 265c3.8-5.5 3.8-12.7 0-18.2l-54.5-79 94.5-17.4c6.5-1.2 11.6-6.3 12.8-12.8l17.4-94.5L247 97.6c5.5 3.8 12.7 3.8 18.2 0zM256 384a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-96-128a96 96 0 1 1 192 0 96 96 0 1 1-192 0z"
        }
    ]
};

const FalSunglasses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSunglasses",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M86.3 87.6C89.9 73.7 102.4 64 116.8 64c4.9 0 9.7 1.1 14.1 3.3l22 11c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-22-11c-8.8-4.4-18.5-6.7-28.4-6.7-29 0-54.2 19.6-61.5 47.6L4.6 276.3c-3 11.6-4.6 23.5-4.6 35.5V368c0 61.9 50.1 112 112 112h44.3c59.4 0 108.5-46.4 111.8-105.8l3.4-54.2h32.9l3.4 54.2c3.3 59.4 52.4 105.8 111.9 105.8H464c61.9 0 112-50.1 112-112v-55.8c0-12.1-1.5-24.2-4.6-36L520.7 79.6c-7.2-28-32.5-47.6-61.5-47.6-9.9 0-19.6 2.3-28.4 6.7l-22 11c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l22-11c4.4-2.2 9.2-3.3 14.1-3.3 14.4 0 26.9 9.7 30.5 23.6l48.2 186.8c-31-12-65-18.4-97.6-18.4-40.1 0-82.2 9.6-118.5 27.3-2.6 1.3-4.9 2.9-7 4.7h-53.7c-2.1-1.8-4.4-3.4-7-4.7-36.2-17.8-78.3-27.4-118.4-27.4-32.6 0-66.6 6.3-97.6 18.4L86.3 87.6zM32 312.2v-.2c31.4-15.6 68.6-24 103.7-24 35.3 0 72.5 8.5 104.3 24v.1l-3.8 60.2v.2c-2.4 42.4-37.4 75.6-79.9 75.6H112c-7.7 0-15.1-1.1-22.1-3.1l9.2-4.6 12-6 24-12 48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-48 24-24 12-12 6-12 6-12 6c-1.4.7-2.6 1.6-3.7 2.5-8.1-7.7-14.6-17-19-27.5.3-.1.7-.3 1-.5l96-48c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L32 366.1v-53.9zM544 368c0 44.2-35.8 80-80 80h-44.3c-8.5 0-16.7-1.3-24.3-3.8l91.8-45.9c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-96 48-12 6c-.6.3-1.1.6-1.7 1-7.7-7.7-13.9-17-18-27.4l93.9-47c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-85.6 42.8L336 312v-.1c31.8-15.5 69-24 104.3-24 35.1 0 72.2 8.4 103.7 24v56z"
        }
    ]
};

const FalSunrise = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSunrise",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M276.7 4.7c6.2-6.2 16.4-6.2 22.6 0l96 96c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L304 54.6V208c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96zm116.8 220.5c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L500.9 448h-38.8l38.7-56.2-94.5-17.4c-6.5-1.2-11.6-6.3-12.8-12.8l-17.4-94.5-79.1 54.5c-5.5 3.8-12.7 3.8-18.2 0l-79.1-54.5-17.4 94.5c-1.2 6.5-6.3 11.6-12.8 12.8l-94.3 17.4 38.7 56.2H75.1l-40.3-58.3c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6l90.4 62.3 90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM412 448h-33.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H164c14.2-55.2 64.3-96 124-96s109.8 40.8 124 96zM16 480h544c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSunset = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSunset",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M299.3 219.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V16c0-8.8 7.2-16 16-16s16 7.2 16 16v153.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm94.2 5.9c5 2.1 8.6 6.6 9.6 11.9L423 345l107.9 19.8c5.3 1 9.8 4.6 11.9 9.6s1.5 10.7-1.6 15.2L500.9 448h-38.8l38.7-56.2-94.5-17.4c-6.5-1.2-11.6-6.3-12.8-12.8l-17.4-94.5-79.1 54.5c-5.5 3.8-12.7 3.8-18.2 0l-79.1-54.5-17.4 94.5c-1.2 6.5-6.3 11.6-12.8 12.8l-94.3 17.4 38.7 56.2H75.1l-40.3-58.3c-3.1-4.5-3.7-10.2-1.6-15.2s6.6-8.6 11.9-9.6L153 345l19.8-107.9c1-5.3 4.6-9.8 9.6-11.9s10.7-1.5 15.2 1.6l90.4 62.3 90.3-62.3c4.5-3.1 10.2-3.7 15.2-1.6zM412 448h-33.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H164c14.2-55.2 64.3-96 124-96s109.8 40.8 124 96zM16 480h544c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalSuperscript = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSuperscript",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 16c0-5.1-2.5-10-6.6-13S447.9-.8 443 .8l-48 16c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l26.9-9V160h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V16zM16 64C7.2 64 0 71.2 0 80s7.2 16 16 16h39.2L157 256 55.2 416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c5.5 0 10.6-2.8 13.5-7.4L176 285.8l98.5 154.8c2.9 4.6 8 7.4 13.5 7.4h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-39.2L195 256 296.8 96H336c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48c-5.5 0-10.6 2.8-13.5 7.4L176 226.2 77.5 71.4c-2.9-4.6-8-7.4-13.5-7.4H16z"
        }
    ]
};

const FalSushiRoll = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSushiRoll",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 136c0-22.4-12.2-39.9-25.9-52-13.6-12.1-31.6-21.6-51.1-28.9C331.8 40.4 279.8 32 224 32S116.2 40.4 77 55.1C57.5 62.4 39.5 71.9 25.9 84 12.2 96.1 0 113.6 0 136v216c0 45.2 35.8 77.4 73.9 96.5C114 468.5 167.1 480 224 480s110-11.5 150.1-31.5c38.1-19.1 73.9-51.3 73.9-96.5V136zm-32 0c0 14.8-11.9 28.6-32.3 40-89.2-.1-143.5-58.9-143.7-111.8 98.6 3 176 34 176 71.8zm-384 0c0-37.7 77.4-68.7 176-71.8 0 12.5 2.1 24.9 6 36.7-17.9 4.6-39.3 11.9-60.8 22.7-26.7 13.4-54.4 32.6-75.2 59.1-28.7-12.5-46-28.8-46-46.7zm78.4 58.1c16.1-17.5 36.3-31.3 57.2-41.8 22-11 43.8-18 60.5-21.8 19.3 30.3 51.4 55 92 67.8-28.3 6.2-61.1 9.7-96.1 9.7-42.5 0-81.8-5.2-113.6-13.9zM32 193c12.7 9.7 28.3 17.6 45 23.8 39.2 14.7 91.2 23.1 147 23.1s107.8-8.4 147-23.1c16.7-6.3 32.3-14.1 45-23.8v159c0 53-86 96-192 96S32 405 32 352V193z"
        }
    ]
};

const FalSushi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSushi",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m535.2 288.7-104.7-34.8 59.3-100.4c17.4 20.9 29.7 46.3 34.7 74.7l10.7 60.5zM375.6 96.2c33.9 1.8 65.3 14.3 90.6 34.3l-66.8 113.1-66.2-22c-9.1-3-18.4-5.2-27.8-6.5l70.2-118.9zM268.8 214.1c-13 1.1-25.9 3.9-38.5 8.2L133.2 256l94.5-160h110.9l-69.8 118.1zM86.5 272.2 41 287.9l10.5-59.7c12.4-70.1 69.2-122.7 138.4-131l-103.4 175zM209.1 64C115.9 64 36.2 130.9 20 222.6L9.5 282.4c-4.2 24 18.9 43.8 42 35.8l189.4-65.6c26.6-9.2 55.5-9.4 82.3-.5l202 67.1c23 7.6 45.8-12.1 41.6-35.9L556 222.6C539.8 130.9 460.1 64 366.9 64H209.1zM32 352.9c.5 52.6 43.3 95.1 96 95.1 17.3 0 33.6-4.6 47.6-12.6 2.7-1.6 6.1-1.6 8.8 0 14 8 30.3 12.6 47.6 12.6 18.8 0 36.4-5.4 51.2-14.8 2.9-1.8 6.6-1.8 9.5 0 14.8 9.4 32.4 14.8 51.2 14.8 17.3 0 33.6-4.6 47.6-12.6 2.7-1.6 6.1-1.6 8.8 0 14 8 30.3 12.6 47.6 12.6 52.5 0 95.1-42.1 96-94.4-8.4.7-17.1-.2-25.8-3.1l-6.2-2v3.5c0 35.3-28.7 64-64 64-11.6 0-22.4-3.1-31.7-8.4-12.6-7.2-28-7.2-40.6 0-9.3 5.3-20.1 8.4-31.7 8.4-12.6 0-24.3-3.6-34.1-9.8-13.4-8.4-30.4-8.4-43.7 0-9.9 6.2-21.5 9.8-34.1 9.8-11.6 0-22.4-3.1-31.7-8.4-12.6-7.2-28-7.2-40.6 0-9.3 5.3-20.1 8.4-31.7 8.4-35.3 0-64-28.7-64-64v-4.3l-5.3 1.8c-9 3.1-18 4.1-26.7 3.4z"
        }
    ]
};

const FalSwapArrows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSwapArrows",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M100.7 20.7c6.2-6.2 16.4-6.2 22.6 0l88 88c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L128 70.6V360c0 48.6 39.4 88 88 88s88-39.4 88-88V152c0-66.3 53.7-120 120-120s120 53.7 120 120v289.4l60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-6.2 6.2-16.4 6.2-22.6 0l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l60.7 60.7V152c0-48.6-39.4-88-88-88s-88 39.4-88 88v208c0 66.3-53.7 120-120 120S96 426.3 96 360V70.6l-60.7 60.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l88-88z"
        }
    ]
};

const FalSwap = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSwap",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 126.7c0 18.4-14.9 33.3-33.3 33.3H128v200c0 48.6 39.4 88 88 88s88-39.4 88-88V152c0-66.3 53.7-120 120-120s120 53.7 120 120v200h46.7c18.4 0 33.3 14.9 33.3 33.3 0 8.3-3.1 16.3-8.7 22.4l-75.5 83c-3 3.3-7.3 5.2-11.8 5.2s-8.8-1.9-11.8-5.2l-75.5-83c-5.6-6.1-8.7-14.1-8.7-22.4 0-18.4 14.9-33.3 33.3-33.3H512V152c0-48.6-39.4-88-88-88s-88 39.4-88 88v208c0 66.3-53.7 120-120 120S96 426.3 96 360V160H49.3C30.9 160 16 145.1 16 126.7c0-8.3 3.1-16.3 8.7-22.4l75.5-83c3-3.3 7.3-5.2 11.8-5.2s8.8 1.9 11.8 5.2l75.5 83c5.6 6.1 8.7 14.1 8.7 22.4zm-96 1.3h62.7c.7 0 1.3-.6 1.3-1.3 0-.3-.1-.6-.3-.9l-63.7-70-63.7 70c-.2.2-.3.6-.3.9 0 .7.6 1.3 1.3 1.3H112zm416 256h-62.7c-.7 0-1.3.6-1.3 1.3 0 .3.1.6.3.9l63.7 70 63.7-70c.2-.2.3-.6.3-.9 0-.7-.6-1.3-1.3-1.3H528z"
        }
    ]
};

const FalSwatchbook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSwatchbook",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 416c0 53 43 96 96 96h360c30.9 0 56-25.1 56-56v-80c0-30.9-25.1-56-56-56H331.7l87.3-87.3c21.9-21.9 21.9-57.3 0-79.2L362.4 97c-21.9-21.9-57.3-21.9-79.2 0L192 188.2V56c0-30.9-25.1-56-56-56H56C25.1 0 0 25.1 0 56v360zm456 64H171.7l128-128H456c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24zm-59.6-269.9L192 414.5v-181l113.9-113.9c9.4-9.4 24.6-9.4 33.9 0l56.6 56.6c9.4 9.4 9.4 24.6 0 33.9zM96 480c-35.3 0-64-28.7-64-64V288h128v128c0 35.3-28.7 64-64 64zM32 256v-96h128v96H32zm0-128V56c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v72H32zm64 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalSwordLaserAlt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSwordLaserAlt",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M353.2 224 503.8 57.1c5.3-5.9 8.2-13.5 8.2-21.4V32c0-17.7-14.3-32-32-32h-3.7c-7.9 0-15.6 2.9-21.4 8.2L215.8 224h47.8L476.3 32h3.7v3.7L310.1 224h43.1zm-213.9 46.1L13.2 396.2C4.7 404.6 0 416.1 0 428s4.7 23.4 13.2 31.8l39 39C60.6 507.3 72.1 512 84 512s23.4-4.7 31.8-13.2l215.5-215.5c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9H173.3c-12.7 0-24.9 5.1-33.9 14.1zM281.4 288 184 385.4l-28.7-28.7-28.7-28.7 35.3-35.3c3-3 7.1-4.7 11.3-4.7h108.2zM144 390.6l17.4 17.4-68.2 68.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8l-8.2-8.2 77.4-77.4zM121.4 368 44 445.4l-8.2-8.2c-2.4-2.4-3.8-5.7-3.8-9.2s1.4-6.7 3.8-9.2l68.2-68.2 17.4 17.4z"
        }
    ]
};

const FalSwordLaser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSwordLaser",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m503.8 57.1-210 232.7-22.7-22.7L480 35.7V32h-3.7L244.8 240.9l-22.7-22.7 232.8-210c5.8-5.3 13.5-8.2 21.4-8.2h3.7c17.7 0 32 14.3 32 32v3.7c0 7.9-2.9 15.6-8.2 21.4zM187.3 228.7l16 16 64 64 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-4.7-4.7-57.9 57.9c1.2 2.3 1.9 4.9 1.9 7.5 0 4.2-1.7 8.3-4.7 11.3L118.6 496c-10.2 10.2-24.1 16-38.6 16s-28.4-5.8-38.6-16L16 470.6C5.8 460.4 0 446.5 0 432s5.8-28.4 16-38.6l76.7-76.7c5.1-5.1 12.8-6 18.8-2.8l57.9-57.9-4.7-4.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM152 318.6 134.6 336l41.4 41.4 17.4-17.4-41.4-41.4zm22.6-22.6 41.4 41.4 17.4-17.4-41.4-41.4-17.4 17.4zm-136 120c-4.2 4.2-6.6 10-6.6 16s2.4 11.8 6.6 16L64 473.4c4.2 4.2 10 6.6 16 6.6s11.8-2.4 16-6.6l65.4-65.4-57.4-57.4L38.6 416z"
        }
    ]
};

const FalSword = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSword",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M507.3 4.7C503.7 1 498.5-.6 493.4.2l-75.8 12.6c-16.4 2.7-31.6 10.6-43.4 22.3L174.6 234.7l22.6 22.6L396.8 57.8c7.1-7.1 16.2-11.8 26.1-13.4l53.7-8.9-8.9 53.7c-1.6 9.9-6.3 19-13.4 26L254.6 314.7l22.6 22.6 199.6-199.5c11.8-11.8 19.6-27 22.3-43.4l12.6-75.8c.8-5.1-.8-10.3-4.5-13.9zm-392 216c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-5.3 5.3-6.2 13.6-2.2 19.9l49.1 77.2-32.9 32.8-31.6-6.3c-5.2-1-10.7.6-14.5 4.4l-24 24c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l24-24c3.8-3.8 5.4-9.2 4.4-14.5l-6.3-31.6 32.9-32.9 77.2 49.1c6.3 4 14.6 3.1 19.9-2.2l32-32c6.2-6.2 6.2-16.4 0-22.6l-176-176zm26.2 122.7-49.1-77.2 11.6-11.6L257.4 408l-11.6 11.6-77.2-49.1c-6.3-4-14.6-3.1-19.9 2.2l-48 48c-3.8 3.8-5.4 9.2-4.4 14.5l6.3 31.6-6.6 6.6L38.6 416l6.6-6.6 31.6 6.3c5.2 1 10.7-.6 14.5-4.4l48-48c5.3-5.3 6.2-13.6 2.2-19.9z"
        }
    ]
};

const FalSwordsLaser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSwordsLaser",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M393.9 177.2c-4.8 2-8.2 6.1-9.4 10.9L185.1 8.2C179.3 2.9 171.6 0 163.7 0H160c-17.7 0-32 14.3-32 32v3.7c0 7.9 2.9 15.6 8.2 21.4L384 331.7v7.1c0 12.7 5.1 24.9 14.1 33.9l126.1 126.1c8.4 8.4 19.9 13.2 31.8 13.2s23.4-4.7 31.8-13.2l39-39c8.4-8.4 13.2-19.9 13.2-31.8s-4.7-23.4-13.2-31.8L411.3 180.7c-4.6-4.6-11.5-5.9-17.4-3.5zM160 35.7V32h3.7L384 230.8v53.1L160 35.7zM513.4 328l-28.7 28.7-28.7 28.7-35.3-35.3c-3-3-4.7-7.1-4.7-11.3V230.6l97.4 97.4zm22.6 22.6 68.2 68.2c2.4 2.4 3.8 5.7 3.8 9.2s-1.4 6.7-3.8 9.2l-8.2 8.2-77.4-77.4 17.4-17.4zM573.4 468l-8.2 8.2c-2.4 2.4-5.7 3.8-9.2 3.8s-6.7-1.4-9.2-3.8L478.6 408l17.4-17.4 77.4 77.4zm-375-228.3-11-11c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l4.7 4.7-57.9 57.9c-6-3.2-13.7-2.3-18.8 2.8L16 393.4C5.8 403.6 0 417.5 0 432s5.8 28.4 16 38.6L41.4 496c10.2 10.2 24.1 16 38.6 16s28.4-5.8 38.6-16l76.7-76.7c3-3 4.7-7.1 4.7-11.3 0-2.6-.7-5.2-1.9-7.5l57.9-57.9 4.7 4.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-11-11 26.2-29-21.6-23.9-27.3 30.2-28.6-28.6 31.6-28.5-21.4-23.8-32.8 29.6zM480 35.7l-97.3 107.8 3 2.7c11.8-3.7 24.4-2.6 35.3 2.7l82.8-91.7c5.3-5.9 8.2-13.5 8.2-21.4V32c0-17.7-14.3-32-32-32h-3.7c-7.9 0-15.6 2.9-21.4 8.2l-111 100.2 23.9 21.6 108.5-98h3.7v3.7zM152 318.6l41.4 41.4-17.4 17.4-41.4-41.4 17.4-17.4zm22.6-22.6 17.4-17.4 41.4 41.4-17.4 17.4-41.4-41.4zm-136 120 65.4-65.4 57.4 57.4L96 473.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6L38.6 448c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16z"
        }
    ]
};

const FalSwords = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSwords",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M130.7 278.6 115.3 294l-12.7-12.7c-12.5-12.5-32.8-12.5-45.3 0l-16 16c-9.4 9.4-12 23.5-6.6 35.6l23.1 51.9-48.4 48.6c-12.5 12.5-12.5 32.8 0 45.3l24 24c12.5 12.5 32.8 12.5 45.3 0l48.5-48.5 51.8 23c12.1 5.4 26.3 2.7 35.6-6.6l16-16c12.5-12.5 12.5-32.8 0-45.3l-12.7-12.7 15.4-15.4-22.6-22.6-15.4 15.4-57.4-57.4 15.4-15.4-22.6-22.6zm227.9-67.9 22.6 22.6 109.9-109.8c7.9-7.9 12.8-18.4 13.9-29.6l7-76.5c.4-4.7-1.3-9.4-4.6-12.8s-8-5.1-12.8-4.6l-76.5 7c-11.2 1-21.7 5.9-29.6 13.9L278.6 130.7l22.6 22.6L411.1 43.5c2.6-2.6 6.1-4.3 9.9-4.6l57.3-5.2-5.2 57.3c-.3 3.7-2 7.2-4.6 9.9L358.6 210.7zM64 320l16-16 128 128-16 16-62-27.5c-6-2.7-13.1-1.4-17.8 3.3L56 480l-24-24 56.2-56.2c4.7-4.7 6-11.8 3.3-17.8L64 320zM38.9 91l-5.2-57.3L91 38.9c3.7.3 7.2 2 9.9 4.6l253.8 253.9 22.6-22.6L123.5 20.9C115.6 12.9 105.1 8 93.9 7L17.4.1C12.7-.4 8 1.3 4.7 4.7s-5.1 8-4.6 12.7L7 93.9c1 11.2 5.9 21.7 13.9 29.6l253.8 253.9 22.6-22.6L43.5 100.9c-2.6-2.6-4.3-6.1-4.6-9.9zm370.5 190.4-128 128c-12.5 12.5-12.5 32.8 0 45.3l16 16c9.4 9.4 23.5 12 35.6 6.6l51.9-23.1 48.5 48.5c12.5 12.5 32.8 12.5 45.3 0l24-24c12.5-12.5 12.5-32.8 0-45.3l-48.5-48.5 23-51.9c5.4-12.1 2.7-26.3-6.6-35.6l-16-16c-12.5-12.5-32.8-12.5-45.3 0zM432 304l16 16-27.5 62c-2.7 6.1-1.4 13.1 3.3 17.8L480 456l-24 24-56.2-56.2c-4.7-4.7-11.8-6-17.8-3.3L320 448l-16-16 128-128z"
        }
    ]
};

const FalSymbols = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSymbols",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16S7.2 0 16 0zm0 64h192c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16zM473.7 4.1C493.5.2 512 15.3 512 35.5V168h-.2c.1 1.3.2 2.7.2 4 0 28.7-28.7 52-64 52s-64-23.3-64-52 28.7-52 64-52c11.7 0 22.6 2.5 32 7V35.5L352 61.1V200h-.2c.1 1.3.2 2.7.2 4 0 28.7-28.7 52-64 52s-64-23.3-64-52 28.7-52 64-52c11.7 0 22.6 2.5 32 7V61.1c0-15.3 10.8-28.4 25.7-31.4l128-25.6zM480 172c0-3.1-1.5-7.5-6.9-11.9-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zm-160 32c0-3.1-1.5-7.5-6.9-11.9-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zm16 148a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm171.3 4.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0zM480 464a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1-96 0zM76.4 256H85c32.6 0 59.1 26.4 59.1 59.1 0 18.1-8.3 35.2-22.6 46.4l-20.2 15.8 49.8 45.3 47.3-35.5c7.1-5.3 17.1-3.9 22.4 3.2s3.9 17.1-3.2 22.4l-42.4 31.8 43.5 39.6c6.5 5.9 7 16.1 1.1 22.6s-16.1 7-22.6 1.1l-48.1-43.7-46.8 35.1C91.3 507.5 77.8 512 64 512c-35.5 0-64-29.1-64-64.3 0-19.7 9-38.6 24.6-50.8l27.1-21.3L35.8 361A60.15 60.15 0 0 1 16 316.4C16 283 43 256 76.4 256zm25.3 80.4c6.5-5.1 10.3-13 10.3-21.3 0-14.9-12.1-27.1-27.1-27.1h-8.5C60.7 288 48 300.7 48 316.4c0 8 3.4 15.6 9.3 21l20 18.2 24.4-19.2zM44.4 422A32.91 32.91 0 0 0 32 447.7c0 17.8 14.5 32.3 32 32.3 6.9 0 13.7-2.2 19.2-6.4l41.8-31.4-49.2-44.8L44.4 422z"
        }
    ]
};

const FalSynagogue = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSynagogue",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M309.8 3.7c5.9-4.9 14.6-4.9 20.5 0l121 100.8c18.2 15.2 28.7 37.7 28.7 61.5v78.1l53.3-48c6.1-5.5 15.3-5.5 21.4 0l69.4 62.5c10.1 9.1 15.9 22.1 15.9 35.7V464c0 26.5-21.5 48-48 48H64c-35.3 0-64-28.7-64-64V294.3c0-13.6 5.8-26.6 15.9-35.7l69.4-62.5c6.1-5.5 15.3-5.5 21.4 0l53.3 48V166c0-23.7 10.5-46.3 28.8-61.5l121-100.8zM480 480h112c8.8 0 16-7.2 16-16V294.3c0-4.5-1.9-8.9-5.3-11.9L544 229.5l-58.7 52.8c-3.4 3-5.3 7.4-5.3 11.9V480zm-32-314c0-14.2-6.3-27.8-17.3-36.9L320 36.8l-110.7 92.3c-11 9.1-17.3 22.6-17.3 36.9v314h64v-96c0-35.3 28.7-64 64-64s64 28.7 64 64v96h64V166zm-96 218c0-17.7-14.3-32-32-32s-32 14.3-32 32v96h64v-96zm-192-89.7c0-4.5-1.9-8.9-5.3-11.9L96 229.5l-58.7 52.9c-3.4 3-5.3 7.4-5.3 11.9V448c0 17.7 14.3 32 32 32h96V294.3zm191.5-155.5 26-.2c17-.2 27.5 18.4 18.6 32.9L383.4 192l12.6 20.6c8.9 14.5-1.6 33-18.6 32.9l-26-.2-12.9 21.9c-8.3 14.2-28.9 14.2-37.3 0l-12.9-21.9-26 .2c-17 .2-27.5-18.4-18.6-32.9l12.9-20.6-12.6-20.6c-8.9-14.5 1.6-33 18.6-32.9l26 .2 12.9-21.9c8.3-14.2 28.9-14.2 37.3 0l12.9 21.9zM308 159.3c-2.5 4.2-7 6.8-11.9 6.7l-23.7-.2 11.7 19.1c2.7 4.4 2.7 9.9 0 14.2l-11.7 19.1 23.7-.2c4.9 0 9.4 2.5 11.9 6.7l12 20.5 12-20.5c2.5-4.2 7-6.8 11.9-6.7l23.7.2-11.7-19.1c-2.7-4.4-2.7-9.9 0-14.2l11.7-19.1-23.7.2c-4.9 0-9.4-2.5-11.9-6.7l-12-20.5-12 20.5z"
        }
    ]
};

const FalSyringe = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalSyringe",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M404.7 4.7c-6.2 6.2-6.2 16.4 0 22.6L433.4 56 384 105.4l-68.7-68.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80 80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L406.6 128 456 78.6l28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-40-40-40-40c-6.2-6.2-16.4-6.2-22.6 0zm-272 224-50 49.9c-12 12-18.7 28.3-18.7 45.3v101.5L4.7 484.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L86.6 448h101.5c17 0 33.3-6.7 45.3-18.7l192-192-22.6-22.6-192 192c-6 6-14.1 9.4-22.6 9.4H96v-92.2c0-8.5 3.4-16.6 9.4-22.6l38.6-38.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L166.6 240l41.4-41.4 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L230.6 176l66.7-66.7-22.6-22.7-78.1 78.1-64 64z"
        }
    ]
};

const FalT = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalT",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h160v400c0 8.8 7.2 16 16 16s16-7.2 16-16V64h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalTableCellsLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTableCellsLarge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 64v176h208V96c0-17.7-14.3-32-32-32H272zm-32 0H64c-17.7 0-32 14.3-32 32v144h208V64zM32 272v144c0 17.7 14.3 32 32 32h176V272H32zm240 176h176c17.7 0 32-14.3 32-32V272H272v176zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalTableCells = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTableCells",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 64v96h128V96c0-17.7-14.3-32-32-32h-96zm-32 0H192v96h128V64zm-160 0H64c-17.7 0-32 14.3-32 32v64h128V64zM32 192v128h128V192H32zm0 160v64c0 17.7 14.3 32 32 32h96v-96H32zm160 96h128v-96H192v96zm160 0h96c17.7 0 32-14.3 32-32v-64H352v96zm128-128V192H352v128h128zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm192 224h128V192H192v128z"
        }
    ]
};

const FalTableColumns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTableColumns",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c17.7 0 32 14.3 32 32v64H32V96c0-17.7 14.3-32 32-32h384zM32 416V192h208v256H64c-17.7 0-32-14.3-32-32zm240 32V192h208v224c0 17.7-14.3 32-32 32H272zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalTableLayout = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTableLayout",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c17.7 0 32 14.3 32 32v64H32V96c0-17.7 14.3-32 32-32h384zM32 416V192h128v256H64c-17.7 0-32-14.3-32-32zm160 32V192h288v224c0 17.7-14.3 32-32 32H192zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64z"
        }
    ]
};

const FalTableList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTableList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64v96h288V96c0-17.7-14.3-32-32-32H192zm-32 0H64c-17.7 0-32 14.3-32 32v64h128V64zM32 192v128h128V192H32zm0 160v64c0 17.7 14.3 32 32 32h96v-96H32zm160 96h256c17.7 0 32-14.3 32-32v-64H192v96zm288-128V192H192v128h288zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalTablePicnic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTablePicnic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M191.6 64H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h88.2l-52.4 128H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16h-99.8L343.8 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H191.7zm117.7 32 52.4 128H150.4l52.3-128h106.6zM89.6 288 33.2 425.9c-3.3 8.2.6 17.5 8.8 20.9s17.5-.6 20.9-8.8l61.3-150H89.6zm332.8 0h-34.6l61.4 150.1c3.3 8.2 12.7 12.1 20.9 8.8s12.1-12.7 8.8-20.9l-56.5-138z"
        }
    ]
};

const FalTablePivot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTablePivot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64v96h320V96c0-17.7-14.3-32-32-32H160zm0 128v256h288c17.7 0 32-14.3 32-32V192H160zM128 64H64c-17.7 0-32 14.3-32 32v64h96V64zM32 416c0 17.7 14.3 32 32 32h64V192H32v224zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm446.8 182.1c-2.5 6-8.3 9.9-14.8 9.9h-16v48c0 26.5-21.5 48-48 48h-48v16c0 6.5-3.9 12.3-9.9 14.8s-12.9 1.1-17.4-3.5l-32-32c-6.2-6.2-6.2-16.4 0-22.6l32-32c4.6-4.6 11.5-5.9 17.4-3.5s9.9 8.3 9.9 14.8v16h48c8.8 0 16-7.2 16-16v-48h-16c-6.5 0-12.3-3.9-14.8-9.9s-1.1-12.9 3.5-17.4l32-32c6.2-6.2 16.4-6.2 22.6 0l32 32c4.6 4.6 5.9 11.5 3.5 17.4z"
        }
    ]
};

const FalTableRows = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTableRows",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 96c0-17.7 14.3-32 32-32h64v384H64c-17.7 0-32-14.3-32-32V96zm128 176h320v144c0 17.7-14.3 32-32 32H160V272zm320-32H160V64h288c17.7 0 32 14.3 32 32v144zM0 416c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320z"
        }
    ]
};

const FalTableTennisPaddleBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTableTennisPaddleBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M423.8 88.2c56.7 56.7 70.5 139.9 41.5 209.6 10 4.2 19.4 9.6 27.9 16.1 35.9-82 20.3-181.2-46.8-248.3-87.5-87.5-229.3-87.5-316.8 0l-60.1 60.1c-24 24-37.5 56.6-37.5 90.5v2.8c0 33.9 13.5 66.5 37.5 90.5l9.8 9.8c13.1 13.1 12.4 34.6-1.7 46.8L11 423.8C4.3 429.6.3 438 0 446.9s3.1 17.5 9.4 23.8l32 32c6.3 6.3 14.9 9.7 23.8 9.4s17.2-4.3 23-11l57.7-66.6c12.2-14 33.7-14.8 46.8-1.7l9.8 9.8c24 24 56.6 37.5 90.5 37.5h2.7c3.1 0 6.1-.1 9.2-.3-5.6-9.8-10-20.4-12.9-31.7-25.1-.3-49.1-10.3-66.9-28.1l-9.8-9.8c-26.3-26.3-69.3-24.7-93.6 3.3L64 480l-32-32 66.6-57.7c28.1-24.3 29.6-67.4 3.3-93.6l-9.8-9.8c-18-18-28.1-42.5-28.1-67.9v-2.7c0-18.2 5.2-35.8 14.6-51l214.6 214.5c3.3-11.1 8-21.6 14-31.3L99.5 140.9l52.7-52.7c75-75 196.5-75 271.5 0zM352 416a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm160 0a96 96 0 1 0-192 0 96 96 0 1 0 192 0z"
        }
    ]
};

const FalTableTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTableTree",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v64h448V96c0-17.7-14.3-32-32-32H64zm64 128v48c0 8.8 7.2 16 16 16h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-5.6 0-11-1-16-2.7V336c0 8.8 7.2 16 16 16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-26.5 0-48-21.5-48-48V192H32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V192H128zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm224 176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16zm80 80h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalTable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTable",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v64h448V96c0-17.7-14.3-32-32-32H64zM32 192v112h208V192H32zm240 0v112h208V192H272zm-32 144H32v80c0 17.7 14.3 32 32 32h176V336zm32 112h176c17.7 0 32-14.3 32-32v-80H272v112zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalTabletButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTabletButton",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm224 328a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalTabletRugged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTabletRugged",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64.5 58.4C67.1 43.4 80.2 32 96 32h256c15.8 0 28.9 11.4 31.5 26.4.9 5 4.1 9.3 8.6 11.5l23.9 12v60.2l-23.2 11.6c-5.4 2.7-8.8 8.3-8.8 14.3v32c0 6.1 3.4 11.6 8.8 14.3l23.2 11.6v60.2l-23.2 11.6c-5.4 2.7-8.8 8.3-8.8 14.3v32c0 6.1 3.4 11.6 8.8 14.3l23.2 11.6v60.2L392.1 442c-4.5 2.3-7.7 6.6-8.6 11.5-2.6 15-15.8 26.4-31.5 26.4H96c-15.8 0-28.9-11.4-31.5-26.4-.9-5-4.1-9.3-8.6-11.5L32 430.1v-60.2l23.2-11.6c5.4-2.7 8.8-8.2 8.8-14.3v-32c0-6.1-3.4-11.6-8.8-14.3L32 286.1v-60.2l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3v-32c0-6.1-3.4-11.6-8.8-14.3L32 142.1V81.9l23.9-12c4.5-2.3 7.7-6.5 8.6-11.5zM96 0C67.4 0 43.2 18.7 35 44.6L8.8 57.7C3.4 60.4 0 65.9 0 72v80c0 6.1 3.4 11.6 8.8 14.3L32 177.9v12.2L8.8 201.7C3.4 204.4 0 209.9 0 216v80c0 6.1 3.4 11.6 8.8 14.3L32 321.9v12.2L8.8 345.7C3.4 348.4 0 353.9 0 360v80c0 6.1 3.4 11.6 8.8 14.3L35 467.4c8.2 25.9 32.4 44.6 61 44.6h256c28.6 0 52.8-18.7 61-44.6l26.1-13.1c5.4-2.7 8.8-8.2 8.8-14.3v-80c0-6.1-3.4-11.6-8.8-14.3L416 334.1v-12.2l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3v-80c0-6.1-3.4-11.6-8.8-14.3L416 190.1v-12.2l23.2-11.6c5.4-2.7 8.8-8.3 8.8-14.3V72c0-6.1-3.4-11.6-8.8-14.3L413 44.6C404.8 18.7 380.6 0 352 0H96zm32 96h192v320H128V96zm-32 0v320c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalTabletScreenButton = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTabletScreenButton",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c17.7 0 32 14.3 32 32v256H32V64c0-17.7 14.3-32 32-32h320zm32 320v96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-96h384zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm184 416a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalTabletScreen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTabletScreen",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c17.7 0 32 14.3 32 32v256H32V64c0-17.7 14.3-32 32-32h320zm32 320v96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-96h384zM64 0C28.7 0 0 28.7 0 64v384c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm112 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalTablet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTablet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm192 336h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalTablets = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTablets",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M603.9 261.3c-3.4 4.1-6.9 8.1-10.8 11.9s-7.8 7.4-11.9 10.8c-62.8 51.5-155.7 47.9-214.4-10.8S304.5 121.6 356 58.8c3.4-4.1 6.9-8.1 10.8-11.9s7.8-7.4 11.9-10.8c62.8-51.5 155.7-47.9 214.4 10.8s62.3 151.6 10.8 214.4zM570.5 69.5c-46.2-46.2-118.8-49.7-169-10.6l179.6 179.6c39.1-50.2 35.5-122.8-10.6-169zm-12 191.6L378.9 81.5c-39.1 50.2-35.5 122.8 10.6 169s118.8 49.7 169 10.6zM319.2 336c.5 5.3.8 10.6.8 16s-.3 10.7-.8 16c-8 80.9-76.2 144-159.2 144S8.8 448.9.8 368c-.5-5.3-.8-10.6-.8-16s.3-10.7.8-16C8.8 255.1 77 192 160 192s151.2 63.1 159.2 144zM160 224c-65.3 0-119.1 48.9-127 112h254c-7.9-63.1-61.7-112-127-112zm0 256c65.3 0 119.1-48.9 127-112H33c7.9 63.1 61.7 112 127 112z"
        }
    ]
};

const FalTachographDigital = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTachographDigital",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm96 32v64h224v-64H96zm-32 0c0-17.7 14.3-32 32-32h224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32v-64zm0 208c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm320 0c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16zM80 288a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalTaco = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTaco",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m257.1 61.2 44.1 34.2 17-22-17 22c10.9 8.5 24.4 12.8 38.2 12.4l55.8-1.7c.8 0 1.6.5 1.8 1.3l15.6 53.6c3.9 13.3 12.2 24.8 23.6 32.5l46.1 31.4c.7.5 1 1.4.7 2.1-1.4 3.8-3.4 8.3-6.3 14.8-1.9 4.2-4.1 9.1-6.2 14.2 7.6 8.5 14.6 17.4 21.2 26.7 2.7-10 7.3-20.3 11.5-29.7 2.6-5.8 5.1-11.3 6.8-16.2 4.7-13.1 0-27.8-11.6-35.7l-46.1-31.4c-5.9-4-10.2-9.9-12.2-16.8l-15.4-53.6c-3.9-13.4-16.4-22.5-30.4-22.1L338.6 79c-7.1.2-14.1-2-19.7-6.4l-44.1-34.2c-11-8.6-26.5-8.6-37.5 0l-44.2 34.2c-5.6 4.4-12.6 6.6-19.7 6.4l-55.8-1.7c-14-.4-26.5 8.6-30.4 22.1l-15.5 53.5c-2 6.8-6.3 12.8-12.2 16.8L13.4 201c-11.5 7.9-16.3 22.6-11.6 35.7 1.8 4.9 4.2 10.4 6.9 16.3 4.2 9.4 8.8 19.6 11.5 29.7 6.5-9.3 13.6-18.2 21.2-26.7-2.1-5.1-4.3-10-6.2-14.2-2.9-6.5-4.9-11-6.3-14.8-.3-.8 0-1.7.7-2.1l46.1-31.4c11.4-7.8 19.8-19.3 23.6-32.5l15.7-53.6c.2-.8 1-1.3 1.8-1.3l55.8 1.7c13.8.4 27.3-4 38.2-12.4l44.1-34.2c.7-.5 1.6-.5 2.2 0zM256 224c123.7 0 224 100.3 224 224H32c0-123.7 100.3-224 224-224zM32 480h448c17.7 0 32-14.3 32-32 0-141.4-114.6-256-256-256S0 306.6 0 448c0 17.7 14.3 32 32 32zm80-96a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalTag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTag",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 229.5V80c0-8.8 7.2-16 16-16h149.5c8.5 0 16.6 3.4 22.6 9.4l176 176c12.5 12.5 12.5 32.8 0 45.3L262.6 428.1c-12.5 12.5-32.8 12.5-45.3 0l-176-176-22.6 22.6 22.6-22.6c-6-6-9.4-14.1-9.4-22.6zm-32 0c0 17 6.7 33.3 18.7 45.3l176 176c25 25 65.5 25 90.5 0l133.5-133.5c25-25 25-65.5 0-90.5l-176-176c-12-12-28.3-18.7-45.3-18.7H48C21.5 32 0 53.5 0 80v149.5zM112 168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalTags = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTags",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M204.1 32c12.7 0 24.9 5.1 33.9 14.1l172.7 172.6c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0L14.1 270.1c-9-9-14.1-21.2-14.1-33.9V80c0-26.5 21.5-48 48-48h156.1zM36.7 247.4l172.7 172.7c12.5 12.5 32.8 12.5 45.3 0l133.4-133.5c12.5-12.5 12.5-32.8 0-45.3L215.4 68.7c-3-3-7.1-4.7-11.3-4.7H48c-8.8 0-16 7.2-16 16v156.1c0 4.2 1.7 8.3 4.7 11.3zM308.4 36.9c6.1-6.4 16.2-6.6 22.6-.5l141.3 135c52.8 50.4 52.8 134.7 0 185.1l-124.6 119c-6.4 6.1-16.5 5.9-22.6-.5s-5.9-16.5.5-22.6l124.6-119c39.6-37.8 39.6-101 0-138.8l-141.3-135c-6.4-6.1-6.6-16.2-.5-22.6zM104 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalTally1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTally1",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalTally2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTally2",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48z"
        }
    ]
};

const FalTally3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTally3",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm128 0c8.8 0 16 7.2 16 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16zm144 16v416c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalTally4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTally4",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm128 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48zm112-16c-8.8 0-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm144 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48z"
        }
    ]
};

const FalTally = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTally",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c8.8 0 16 7.2 16 16v249.8l96-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16v207.1l96-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16v164.5l96-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16v121.8l74.9-25c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2l-85 28.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V214.2l-96 32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V256.9l-96 32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V299.5l-96 32V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.2l-74.9 25c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l85-28.4V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalTamale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTamale",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m296.4 304 23.1 138.7c1.7 10.2-1.7 20.6-9 27.9C274 507 207.7 512 160 512S46 507 9.4 470.7c-7.3-7.3-10.7-17.7-9-27.9L23.6 304h29.2l-24 143.5c-.2 1 .2 2 .9 2.8 12.8 12.6 32.4 21.3 56.8 26.5 24.2 5.2 50.4 6.4 73.4 6.4s49.2-1.2 73.4-6.4c24.5-5.2 44.1-13.9 56.8-26.5.7-.8 1.1-1.8.9-2.8L267.2 304h29.2zm23.2-234.7L296.4 208h-29.2l24-143.5c.2-1-.2-2-.9-2.8-12.8-12.6-32.4-21.3-56.8-26.5-24.2-5.2-50.4-6.4-73.4-6.4s-49.2 1.2-73.4 6.4c-24.5 5.2-44 13.9-56.8 26.5-.7.8-1.1 1.8-.9 2.8L52.8 208H23.6L.4 69.3c-1.7-10.2 1.7-20.6 9-27.9C46 5 112.3 0 160 0s114 5 150.6 41.3c7.3 7.3 10.7 17.7 9 27.9zM8 256c0-8.8 7.2-16 16-16h272c8.8 0 16 7.2 16 16s-7.2 16-16 16H192l28.8 38.4c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2L160 282.7l-35.2 46.9c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4L128 272H24c-8.8 0-16-7.2-16-16zM160 56c8.8 0 16 7.2 16 16v136h-32V72c0-8.8 7.2-16 16-16zm9.6 292.8c1.9 2.6 4.1 4.9 6.4 7V440c0 8.8-7.2 16-16 16s-16-7.2-16-16v-84.2c2.3-2.1 4.5-4.4 6.4-7L160 336l9.6 12.8zM95.9 78.6 107.7 208H75.6L64.1 81.4c-.8-8.8 5.7-16.6 14.5-17.4S95.2 69.7 96 78.5zM83.2 358.4c5.8 4.3 12.2 7.1 18.8 8.6l-6 66.5c-.8 8.8-8.6 15.3-17.4 14.5s-15.3-8.6-14.5-17.4l7.7-84.4c3 4.6 6.8 8.8 11.5 12.2zm153.6 0c4.6-3.5 8.5-7.6 11.5-12.2l7.7 84.4c.8 8.8-5.7 16.6-14.5 17.4s-16.6-5.7-17.4-14.5L218 367c6.6-1.4 13-4.2 18.8-8.6zM212.3 208l11.8-129.4c.8-8.8 8.6-15.3 17.4-14.5s15.3 8.6 14.5 17.4L244.4 208h-32.1z"
        }
    ]
};

const FalTankWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTankWater",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M269.6 64H384c17.7 0 32 14.3 32 32v256c-20.9 0-41.7-10-58.2-21.2-7.3-5-13.7-10.3-19.8-15.9-10.2-9.5-25.9-9.5-36.1 0-6.1 5.6-12.5 11-19.8 15.9-16.5 11.3-37.2 21.2-58.1 21.2s-41.7-9.9-58.2-21.2c-7.3-5-13.7-10.3-19.8-15.9-10.2-9.5-25.9-9.5-36.1 0-6.1 5.6-12.5 11-19.8 15.9C73.6 342.1 52.9 352 32 352V96c0-17.7 14.3-32 32-32h114.4l6.1-10 13.6-22H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H249.9l13.6 22 6.1 10zM32 384c30.3 0 57.5-14.1 76.2-26.8 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.7 12.7 45.9 26.8 76.2 26.8v32c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-32zM236.4 70.7C233.7 66.5 229 64 224 64s-9.7 2.5-12.4 6.7l-47.2 70.8c-8.1 12.1-12.4 26.3-12.4 40.9v1.6c0 39.8 32.2 72 72 72s72-32.2 72-72v-1.7c0-14.5-4.3-28.8-12.4-40.9l-47.2-70.7zm-12.4 39 33 49.5c4.6 6.8 7 14.9 7 23.1v1.7c0 22.1-17.9 40-40 40s-40-17.9-40-40v-1.7c0-8.2 2.4-16.3 7-23.1l33-49.5z"
        }
    ]
};

const FalTape = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTape",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm115.4 384C404.5 408.8 448 337.5 448 256c0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h336c8.8 0 16-7.2 16-16s-7.2-16-16-16H339.4zM224 192a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
        }
    ]
};

const FalTarpDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTarpDroplet",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M328 113.5c0-.1-.1-1.1-.6-3.1-.6-2.3-1.7-5.3-3.2-8.9-3.2-7.4-7.9-16-13.7-25.3-7-11.3-15-22.6-22.4-32.6-7.4 10-15.4 21.3-22.4 32.6-5.8 9.3-10.5 17.9-13.7 25.3-1.6 3.6-2.6 6.6-3.2 8.9-.5 2-.6 3-.6 3.1 0 17.7 15.9 35.5 40 35.5s40-17.8 40-35.5zm32 0c0 37.3-32.2 67.5-72 67.5s-72-30.2-72-67.5c0-27.7 39.7-81.3 60.2-107 6.1-7.7 17.5-7.7 23.7 0 20.4 25.7 60.2 79.3 60.2 107zM64 128h129.3c1.9 11.5 5.9 22.3 11.5 32H64c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h320V368c0-26.5 21.5-48 48-48h112V192c0-17.7-14.3-32-32-32H371.2c5.6-9.7 9.6-20.5 11.5-32H512c35.3 0 64 28.7 64 64v156.1c0 12.7-5.1 24.9-14.1 33.9L446.1 497.9c-9 9-21.2 14.1-33.9 14.1H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64zm359.4 347.3 115.9-115.9c2.1-2.1 3.5-4.6 4.2-7.4H432c-8.8 0-16 7.2-16 16v111.5c2.8-.7 5.4-2.1 7.4-4.2zM96 200a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalTarp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTarp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 384V128c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v128H432c-26.5 0-48 21.5-48 48v112H64c-17.7 0-32-14.3-32-32zm391.4 27.3c-2.1 2.1-4.6 3.5-7.4 4.2V304c0-8.8 7.2-16 16-16h111.5c-.7 2.8-2.1 5.4-4.2 7.4L423.4 411.3zM576 128c0-35.3-28.7-64-64-64H64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h348.1c12.7 0 24.9-5.1 33.9-14.1l115.9-115.8c9-9 14.1-21.2 14.1-33.9V128zM96 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalTaxiBus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTaxiBus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 32c79 0 124.2 20.8 146.2 38.1 7 5.5 11.1 14.4 12.9 25.9H33c1.7-11.5 5.9-20.3 12.9-25.9C67.8 52.8 113 32 192 32zM32 224v-96h144v96H32zm0 128v-96h243.8l9.1-32H208v-96h136.6c8.4-14.5 22.3-25.4 38.9-29.8C381.8 79.5 375.6 59 358 45 329.2 22.2 276.5 0 192 0S54.8 22.2 26 45C4.5 62.1 0 88.9 0 110.2V352c0 23.7 12.9 44.4 32 55.4V464c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h160v-32H64c-17.7 0-32-14.3-32-32zm96-40a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360-152c4.4 0 8 3.6 8 8v8h-96v-8c0-4.4 3.6-8 8-8h80zm-120 8v9.2c-23.3 4.5-42.6 21.8-49.3 45.2L297 298.1c-24.5 13.7-41 39.9-41 69.9v128c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h320v32c0 8.8 7.2 16 16 16s16-7.2 16-16V368c0-30-16.6-56.2-41-69.9l-21.6-75.7c-6.7-23.5-26-40.7-49.3-45.2V168c0-22.1-17.9-40-40-40H408c-22.1 0-40 17.9-40 40zm16 40h131.8c14.3 0 26.8 9.5 30.8 23.2l16.2 56.8H333.2l16.2-56.8c3.9-13.7 16.5-23.2 30.8-23.2h3.8zm224 224H288v-64c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48v64zm-248-56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm200 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalTaxi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTaxi",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 48v16h128V48c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zm-32 16V48c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v16h.4c35.3 0 66.5 23.2 76.6 57l34.3 114.4.4 1.3c28.9 16.5 48.3 47.6 48.3 83.3v176c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-35.7 19.4-66.8 48.3-83.3l.4-1.3L83 121c10.2-33.8 41.3-57 76.6-57h.4zm-.4 32c-21.2 0-39.9 13.9-46 34.2l-28.3 94.4c3.5-.4 7.1-.6 10.7-.6h320c3.6 0 7.2.2 10.7.6l-28.3-94.4c-6.1-20.3-24.8-34.2-46-34.2H159.6zM74.7 259.9l-.5-.1C49.6 268.7 32 292.3 32 320v96h448v-96c0-27.7-17.6-51.3-42.3-60.2l-.5.1-.1-.3c-6.6-2.3-13.8-3.6-21.2-3.6H96c-7.4 0-14.5 1.3-21.2 3.6l-.1.3zM80 328a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalTeddyBear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTeddyBear",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 64c0 12.5 7.2 23.4 17.8 28.7 6.9 3.4 10.3 11.2 8.3 18.6-1.3 4.8-2.1 10.4-2.1 16.7 0 51.3 44.7 96 104 96s104-44.7 104-96c0-6.4-.8-11.9-2.1-16.7-2-7.4 1.5-15.2 8.3-18.6C408.8 87.4 416 76.5 416 64c0-17.7-14.3-32-32-32-15.1 0-27.8 10.5-31.2 24.7-2 8.6-10.5 13.9-19.1 12C319 65.3 303 64 288 64s-31 1.3-45.7 4.6c-8.6 1.9-17.1-3.4-19.1-12C219.8 42.5 207.1 32 192 32c-17.7 0-32 14.3-32 32zm32-64c24.8 0 46.4 14.2 57 34.8 13.3-2 26.6-2.8 39-2.8s25.7.8 39 2.8C337.6 14.2 359.2 0 384 0c35.3 0 64 28.7 64 64 0 20.6-9.8 38.9-24.9 50.6.6 4.3.9 8.8.9 13.4 0 70.7-60.9 128-136 128s-136-57.3-136-128c0-4.6.3-9.1.9-13.4-15.1-11.7-24.9-30-24.9-50.6 0-35.3 28.7-64 64-64zm96 184c-17.7 0-32-10.7-32-24s14.3-24 32-24 32 10.7 32 24-14.3 24-32 24zm-232 6c27.6-22.1 67.9-17.6 90 10l10.8 13.5c67.3 84.1 195.1 84.1 262.4 0L430 200c22.1-27.6 62.4-32.1 90-10s32.1 62.4 10 90l-10.8 13.5c-27 33.7-59.5 59.8-95.1 78.2V384h26c7.1-27.6 32.2-48 62-48 35.3 0 64 28.7 64 64 0 35.7-15.5 70.2-25.3 88.7-8.1 15.3-24 23.3-39.9 23.3H65.1c-15.9 0-31.8-8-39.9-23.3C15.5 470.2 0 435.7 0 400c0-35.3 28.7-64 64-64 29.8 0 54.9 20.4 62 48h26v-12.3c-35.6-18.4-68.2-44.5-95.1-78.2L46 280c-22.1-27.6-17.6-67.9 10-90zm55.9 290H208v-16c0-26.5-21.5-48-48-48h-48c-8.8 0-16-7.2-16-16 0-17.7-14.3-32-32-32s-32 14.3-32 32c0 27.6 12.4 56.4 21.5 73.7 1.9 3.6 6.1 6.3 11.6 6.3h46.8zm72.1-92.3c4 1.3 7.9 2.8 11.6 4.7 10.1-32.7 40.5-56.4 76.4-56.4h32c35.9 0 66.3 23.7 76.4 56.3 3.7-1.8 7.6-3.4 11.6-4.7v-25.8c0-6.2 3.6-11.8 9.2-14.5 34.9-16.5 66.8-41.1 93-73.8L505 260c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5l-10.8 13.5c-80.1 100.1-232.3 100.1-312.3 0L121 220c-11-13.8-31.2-16-45-5s-16 31.2-5 45l10.8 13.5c26.2 32.7 58.1 57.3 93 73.8 5.6 2.6 9.2 8.3 9.2 14.5v25.9zm40 28.3c10 13.4 16 30 16 48v16h96v-16c0-18 6-34.6 16-48 0-26.5-21.5-48-48-48h-32c-26.5 0-48 21.5-48 48zm192 0c-26.5 0-48 21.5-48 48v16h142.9c5.5 0 9.7-2.7 11.6-6.3 9.2-17.3 21.5-46.1 21.5-73.7 0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16h-48zM240 96a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalTeethOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTeethOpen",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64h384c35.3 0 64 28.7 64 64v64c0 17.7-14.3 32-32 32v-32c0-35.3-28.7-64-64-64-14 0-27 4.5-37.6 12.2-10.9-26-36.5-44.2-66.4-44.2-22.6 0-42.8 10.4-56 26.7-13.2-16.3-33.4-26.7-56-26.7-29.9 0-55.5 18.2-66.4 44.2C155 132.5 142 128 128 128c-35.3 0-64 28.7-64 64v32c-17.7 0-32-14.3-32-32v-64c0-35.3 28.7-64 64-64zm320 160v-32c0-17.7 14.3-32 32-32s32 14.3 32 32v32h-64zm-112 0v-56c0-22.1 17.9-40 40-40s40 17.9 40 40v56h-80zm-72-96c22.1 0 40 17.9 40 40v56h-80v-56c0-22.1 17.9-40 40-40zm-56 128h336c35.3 0 64-28.7 64-64v-64c0-53-43-96-96-96H96C43 32 0 75 0 128v64c0 35.3 28.7 64 64 64h112zm-16-64v32H96v-32c0-17.7 14.3-32 32-32s32 14.3 32 32zm320 256H96c-35.3 0-64-28.7-64-64v-32c0-17.7 14.3-32 32-32v32c0 35.3 28.7 64 64 64 16.8 0 32-6.5 43.5-17 12.8 19.9 35.1 33 60.5 33 22.6 0 42.8-10.4 56-26.7 13.2 16.3 33.4 26.7 56 26.7 25.4 0 47.7-13.2 60.5-33 11.4 10.6 26.7 17 43.5 17 35.3 0 64-28.7 64-64v-32c17.7 0 32 14.3 32 32v32c0 35.3-28.7 64-64 64zm-208-88c0 22.1-17.9 40-40 40s-40-17.9-40-40v-40h80v40zm16-72H64c-35.3 0-64 28.7-64 64v32c0 53 43 96 96 96h384c53 0 96-43 96-96v-32c0-35.3-28.7-64-64-64H288zm128 32h64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32zm-32 32v8c0 22.1-17.9 40-40 40s-40-17.9-40-40v-40h80v32zm-224 0c0 17.7-14.3 32-32 32s-32-14.3-32-32v-32h64v32z"
        }
    ]
};

const FalTeeth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTeeth",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c-35.3 0-64 28.7-64 64v256c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H96zM0 128c0-53 43-96 96-96h384c53 0 96 43 96 96v256c0 53-43 96-96 96H96c-53 0-96-43-96-96V128zm160 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v32h64v-32zm-64 64v32c0 17.7 14.3 32 32 32s32-14.3 32-32v-32H96zm75.5 79c-11.4 10.6-26.7 17-43.5 17-35.3 0-64-28.7-64-64v-96c0-35.3 28.7-64 64-64 14 0 27 4.5 37.6 12.2 10.9-26 36.5-44.2 66.4-44.2 22.6 0 42.8 10.4 56 26.7 13.2-16.3 33.4-26.7 56-26.7 29.9 0 55.5 18.2 66.4 44.2C421 164.5 434 160 448 160c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64-16.8 0-32-6.5-43.5-17-12.8 19.9-35.1 33-60.5 33-22.6 0-42.8-10.4-56-26.7-13.2 16.3-33.4 26.7-56 26.7-25.4 0-47.7-13.2-60.5-33zM232 160c-22.1 0-40 17.9-40 40v56h80v-56c0-22.1-17.9-40-40-40zm-40 160v8c0 22.1 17.9 40 40 40s40-17.9 40-40v-40h-80v32zm224-64h64v-32c0-17.7-14.3-32-32-32s-32 14.3-32 32v32zm0 64c0 17.7 14.3 32 32 32s32-14.3 32-32v-32h-64v32zm-72 48c22.1 0 40-17.9 40-40v-40h-80v40c0 22.1 17.9 40 40 40zm40-112v-56c0-22.1-17.9-40-40-40s-40 17.9-40 40v56h80z"
        }
    ]
};

const FalTelescope = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTelescope",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m447.1 35.7-89.2 51.5 96 166.3 89.2-51.5-96-166.3zM344 127.2l-264.4 168-.1.1s0 .1-.1.1 0 .1 0 .1v.1L134 390v.1s.1 0 .1.1h.3l97-52.5c-4.7-10.2-7.4-21.7-7.4-33.7 0-44.2 35.8-80 80-80s80 35.8 80 80-35.8 80-80 80c-10 0-19.6-1.8-28.4-5.2l-52.9 123.5c-3.5 8.1-12.9 11.9-21 8.4s-11.9-12.9-8.4-21l53.2-124.1-97 52.4c-15.2 8.2-34.3 2.9-42.9-12.1L52 311.4c-8.6-14.9-3.9-33.8 10.6-43L328.4 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.1 8c15.3-8.8 34.9-3.6 43.7 11.7l96 166.3c8.8 15.3 3.6 34.9-11.7 43.7l-89.2 51.5c-15.3 8.8-34.9 3.6-43.7-11.7l-.5-.8-42.6 23.1c-1.7-10.9-5.5-21-11.1-30l37.9-20.5L344 127.2zM304 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm55.7 9.4c-7.8 7.5-17 13.5-27.3 17.4l52.9 123.5c3.5 8.1 12.9 11.9 21 8.4s11.9-12.9 8.4-21l-55-128.3zm-329.8-9.3 32 56c4.4 7.7 1.7 17.4-6 21.8s-17.4 1.7-21.8-6l-32-56c-4.4-7.7-1.7-17.4 6-21.8s17.4-1.7 21.8 6z"
        }
    ]
};

const FalTemperatureArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 96c0-35.3 28.7-64 64-64s64 28.7 64 64v156.7c0 14.9 7 27.7 16 36.9 19.8 20.2 32 47.9 32 78.4 0 61.9-50.1 112-112 112S64 429.9 64 368c0-30.5 12.2-58.2 32-78.4 9-9.2 16-22 16-36.9V96zm64-96c-53 0-96 43-96 96v156.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zm-32 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-29.8-20.4-54.9-48-62v-34c0-8.8-7.2-16-16-16s-16 7.2-16 16v34c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64zm116.7 43.3 64 64c6.2 6.2 16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L448 425.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v377.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6z"
        }
    ]
};

const FalTemperatureArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 96c0-35.3 28.7-64 64-64s64 28.7 64 64v156.7c0 14.9 7 27.7 16 36.9 19.8 20.2 32 47.9 32 78.4 0 61.9-50.1 112-112 112S64 429.9 64 368c0-30.5 12.2-58.2 32-78.4 9-9.2 16-22 16-36.9V96zm64-96c-53 0-96 43-96 96v156.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zm-32 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v210c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64zM420.7 36.7l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L416 86.6V464c0 8.8 7.2 16 16 16s16-7.2 16-16V86.6l68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalTemperatureEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureEmpty",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 96c0-35.3 28.7-64 64-64s64 28.7 64 64v156.7c0 14.9 7 27.7 16 36.9 19.8 20.2 32 47.9 32 78.4 0 61.9-50.1 112-112 112S48 429.9 48 368c0-30.5 12.2-58.2 32-78.4 9-9.2 16-22 16-36.9V96zm64-96c-53 0-96 43-96 96v156.7c0 4.6-2.2 9.8-6.8 14.5C31.7 293.1 16 328.8 16 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zm-32 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FalTemperatureFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureFull",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c-35.3 0-64 28.7-64 64v156.7c0 14.9-7 27.7-16 36.9-19.8 20.2-32 47.9-32 78.4 0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96v156.7c0 4.6 2.2 9.8 6.8 14.5 25.5 26 41.2 61.6 41.2 100.8 0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8 4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62V96c0-8.8 7.2-16 16-16s16 7.2 16 16v210c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64z"
        }
    ]
};

const FalTemperatureHalf = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureHalf",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c-35.3 0-64 28.7-64 64v156.7c0 14.9-7 27.7-16 36.9-19.8 20.2-32 47.9-32 78.4 0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96v156.7c0 4.6 2.2 9.8 6.8 14.5 25.5 26 41.2 61.6 41.2 100.8 0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8 4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62v-98c0-8.8 7.2-16 16-16s16 7.2 16 16v98c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64z"
        }
    ]
};

const FalTemperatureHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureHigh",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM112 96c0-35.3 28.7-64 64-64s64 28.7 64 64v156.7c0 14.9 7 27.7 16 36.9 19.8 20.2 32 47.9 32 78.4 0 61.9-50.1 112-112 112S64 429.9 64 368c0-30.5 12.2-58.2 32-78.4 9-9.2 16-22 16-36.9V96zm64-96c-53 0-96 43-96 96v156.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zm-32 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v210c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FalTemperatureList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureList",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 96c0-35.3 28.7-64 64-64s64 28.7 64 64v156.7c0 14.9 7 27.7 16 36.9 19.8 20.2 32 47.9 32 78.4 0 61.9-50.1 112-112 112S32 429.9 32 368c0-30.5 12.2-58.2 32-78.4 9-9.2 16-22 16-36.9V96zm64-96C91 0 48 43 48 96v156.7c0 4.6-2.2 9.8-6.8 14.5C15.7 293.1 0 328.8 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zm-32 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-29.8-20.4-54.9-48-62V144c0-8.8-7.2-16-16-16s-16 7.2-16 16v162c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64zM320 48c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zm32 128c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H368c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalTemperatureLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureLow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM112 96c0-35.3 28.7-64 64-64s64 28.7 64 64v156.7c0 14.9 7 27.7 16 36.9 19.8 20.2 32 47.9 32 78.4 0 61.9-50.1 112-112 112S64 429.9 64 368c0-30.5 12.2-58.2 32-78.4 9-9.2 16-22 16-36.9V96zm64-96c-53 0-96 43-96 96v156.7c0 4.6-2.2 9.8-6.8 14.5C47.7 293.1 32 328.8 32 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zm-32 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-29.8-20.4-54.9-48-62v-34c0-8.8-7.2-16-16-16s-16 7.2-16 16v34c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FalTemperatureQuarter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureQuarter",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c-35.3 0-64 28.7-64 64v156.7c0 14.9-7 27.7-16 36.9-19.8 20.2-32 47.9-32 78.4 0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96v156.7c0 4.6 2.2 9.8 6.8 14.5 25.5 26 41.2 61.6 41.2 100.8 0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8 4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62v-34c0-8.8 7.2-16 16-16s16 7.2 16 16v34c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64z"
        }
    ]
};

const FalTemperatureSnow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureSnow",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 96c0-35.3 28.7-64 64-64s64 28.7 64 64v156.7c0 14.9 7 27.7 16 36.9 19.8 20.2 32 47.9 32 78.4 0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4 9-9.2 16-22 16-36.9V96zm64-96c-53 0-96 43-96 96v156.7c0 4.6-2.2 9.8-6.8 14.5C303.7 293.1 288 328.8 288 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zm-32 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-29.8-20.4-54.9-48-62v-34c0-8.8-7.2-16-16-16s-16 7.2-16 16v34c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64zM284.6 142.8l7.6-28.3c2.3-8.5-2.8-17.3-11.3-19.6s-17.3 2.8-19.6 11.3l-15.9 59.2-53.4 30.9v-61.7l43.3-43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 89.4V48c0-8.8-7.2-16-16-16s-16 7.2-16 16v41.4l-20.7-20.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l43.3 43.3v61.7l-53.4-30.8-15.9-59.2c-2.2-8.5-11-13.6-19.5-11.3s-13.6 11.1-11.3 19.6l7.6 28.3-35.9-20.8c-7.7-4.4-17.4-1.8-21.9 5.9s-1.8 17.4 5.9 21.9l35.8 20.7-28.3 7.6c-8.5 2.3-13.6 11.1-11.3 19.6s11.1 13.6 19.6 11.3l59.2-15.9L144 224l-53.4 30.8L31.4 239c-8.5-2.3-17.3 2.8-19.6 11.3s2.8 17.3 11.3 19.6l28.3 7.6-35.8 20.6c-7.7 4.5-10.3 14.2-5.9 21.9s14.2 10.3 21.9 5.9l35.8-20.7-7.6 28.3c-2.3 8.5 2.8 17.3 11.3 19.6s17.3-2.8 19.6-11.3l15.9-59.2 53.4-30.9v61.7l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l20.7-20.7V400c0 8.8 7.2 16 16 16s16-7.2 16-16v-41.4l20.7 20.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L192 313.4v-61.7l53.4 30.8 13.8 51.7c6.5-33.3 22.4-63.3 44.8-87v-3.8l-42.6 11.4L208 224l53.4-30.8 42.6 11.4v-33.1l-3.4-.9 3.4-2v-37l-19.4 11.2z"
        }
    ]
};

const FalTemperatureSun = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureSun",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m336 101.1-18.1-3-14.1-84.7c-.9-5.4-4.5-10-9.6-12.1s-10.9-1.5-15.4 1.6L208 52.5 137.2 2.9c-4.5-3.2-10.3-3.8-15.4-1.6s-8.7 6.7-9.6 12.1L98.1 98.1l-84.7 14.1c-5.4.9-10 4.5-12.1 9.6s-1.5 10.9 1.6 15.4L52.5 208 2.9 278.8c-3.2 4.5-3.8 10.3-1.6 15.4s6.7 8.7 12.1 9.6l84.7 14.1 14.1 84.7c.9 5.4 4.5 10 9.6 12.1s10.9 1.5 15.4-1.6l70.8-49.6 69 48.3c-3.2-13.7-4.9-27.9-5-42.6l-54.8-38.4c-5.5-3.9-12.8-3.9-18.4 0l-59.2 41.4-11.8-71c-1.1-6.7-6.4-12-13.2-13.2l-71-11.8L85 217c3.9-5.5 3.9-12.8 0-18.4l-41.3-59 71-11.8c6.7-1.1 12-6.4 13.2-13.2l11.8-71L198.9 85c5.5 3.9 12.8 3.9 18.4 0l59.2-41.4 11.8 71c1.1 6.7 6.4 12 13.2 13.2l34.6 5.8v-32.5zM208 264a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-88-56a88 88 0 1 0 176 0 88 88 0 1 0-176 0zM400 96c0-35.3 28.7-64 64-64s64 28.7 64 64v156.7c0 14.9 7 27.7 16 36.9 19.8 20.2 32 47.9 32 78.4 0 61.9-50.1 112-112 112s-112-50.1-112-112c0-30.5 12.2-58.2 32-78.4 9-9.2 16-22 16-36.9V96zm64-96c-53 0-96 43-96 96v156.7c0 4.6-2.2 9.8-6.8 14.5C335.7 293.1 320 328.8 320 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-39.3-15.7-74.9-41.2-100.8-4.6-4.7-6.8-9.9-6.8-14.5V96c0-53-43-96-96-96zm-32 368a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0c0-29.8-20.4-54.9-48-62V96c0-8.8-7.2-16-16-16s-16 7.2-16 16v210c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64z"
        }
    ]
};

const FalTemperatureThreeQuarters = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTemperatureThreeQuarters",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 32c-35.3 0-64 28.7-64 64v156.7c0 14.9-7 27.7-16 36.9-19.8 20.2-32 47.9-32 78.4 0 61.9 50.1 112 112 112s112-50.1 112-112c0-30.5-12.2-58.2-32-78.4-9-9.2-16-22-16-36.9V96c0-35.3-28.7-64-64-64zM64 96c0-53 43-96 96-96s96 43 96 96v156.7c0 4.6 2.2 9.8 6.8 14.5 25.5 26 41.2 61.6 41.2 100.8 0 79.5-64.5 144-144 144S16 447.5 16 368c0-39.3 15.7-74.9 41.2-100.8 4.6-4.7 6.8-9.9 6.8-14.5V96zm96 304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0 32c-35.3 0-64-28.7-64-64 0-29.8 20.4-54.9 48-62V144c0-8.8 7.2-16 16-16s16 7.2 16 16v162c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64z"
        }
    ]
};

const FalTengeSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTengeSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48zm0 128c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v272c0 8.8-7.2 16-16 16s-16-7.2-16-16V192H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalTennisBall = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTennisBall",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256.6 480c-4.5-58.4 15.6-118.4 60.3-163.1s104.6-64.8 163.1-60.3v-.6c0-123.7-100.3-224-224-224h-.6c4.5 58.4-15.6 118.4-60.3 163.1S90.4 259.9 32 255.4v.6c0 123.7 100.3 224 224 224h.6zm31.9-2.3c97.7-14.2 174.9-91.4 189.1-189.1-49.5-3.8-100.3 13.2-138.1 51s-54.8 88.6-51 138.1zm-65-443.4C125.8 48.6 48.6 125.8 34.3 223.5c49.5 3.8 100.3-13.2 138.1-51s54.8-88.6 51-138.1zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FalTentArrowDownToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTentArrowDownToLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M243.8 117.2c-5.9-6.5-16.1-7-22.6-1.1L160 171.8V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v155.8l-61.2-55.6c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6l88 80c6.1 5.5 15.4 5.5 21.5 0l88-80c6.5-5.9 7-16.1 1.1-22.6zM0 496c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm393.5-364.9c-5.7-4.2-13.4-4.2-19 0L201 259.3c-10.1 7.5-16.9 18.7-18.9 31.1l-22 139c-1.4 8.7 4.6 16.9 13.3 18.3s16.9-4.6 18.3-13.3l22-139.1c.7-4.1 2.9-7.9 6.3-10.4l148-109.2V432c0 8.8 7.2 16 16 16s16-7.2 16-16v-91.2l66.7 100c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L400 283.2V175.7l147.9 109.4c3.4 2.5 5.6 6.2 6.3 10.4l22 139.1c1.4 8.7 9.6 14.7 18.3 13.3s14.7-9.6 13.3-18.3l-22-139c-2-12.4-8.7-23.6-18.9-31.1L393.5 131.1z"
        }
    ]
};

const FalTentArrowLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTentArrowLeftRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M482.8 4.2c-6.5-5.9-16.7-5.5-22.6 1.1s-5.5 16.7 1.1 22.6L518.6 80H57.4l57.4-52.2c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80C1.9 87.2 0 91.5 0 96s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L57.4 112h461.2l-57.4 52.2c-6.5 5.9-7 16.1-1.1 22.6s16.1 7 22.6 1.1l88-80c3.3-3 5.2-7.3 5.2-11.8s-1.9-8.8-5.2-11.8l-88-80zm-185.3 159c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8c-3.7 28.7 18.7 54.2 47.6 54.2h343.2c29 0 51.3-25.5 47.6-54.2l-17.6-134.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM272 207.7V480H116.4c-9.7 0-17.1-8.5-15.9-18.1L118 327.5c.6-4.3 2.9-8.2 6.4-10.8l147.6-109zm32 168.5L368.2 480H304V376.2zm0-60.8V207.7l147.5 109.1c3.5 2.6 5.8 6.5 6.4 10.8L475.4 462c1.2 9.6-6.2 18.1-15.9 18.1h-53.6l-.3-.4L304 315.4z"
        }
    ]
};

const FalTentArrowTurnLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTentArrowTurnLeft",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M114.8 27.8c6.5-5.9 7-16.1 1.1-22.6s-16.1-7-22.6-1.1l-88 80C1.9 87.2 0 91.5 0 96s1.9 8.8 5.2 11.8l88 80c6.5 5.9 16.7 5.5 22.6-1.1s5.5-16.7-1.1-22.6L57.4 112H464c44.2 0 80 35.8 80 80v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-61.9-50.1-112-112-112H57.4l57.4-52.2zm182.7 135.3c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8c-3.7 28.7 18.7 54.2 47.6 54.2h343.2c29 0 51.3-25.5 47.6-54.2l-17.6-134.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zM272 207.7V480H116.4c-9.7 0-17.1-8.5-15.9-18.1L118 327.5c.6-4.3 2.9-8.2 6.4-10.8l147.6-109zm32 168.5L368.2 480H304V376.2zm0-60.8V207.7l147.5 109.1c3.5 2.6 5.8 6.5 6.4 10.8L475.4 462c1.2 9.6-6.2 18.1-15.9 18.1h-53.6l-.3-.4L304 315.4z"
        }
    ]
};

const FalTentArrowsDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTentArrowsDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.9 117.3c-5.9-6.6-16-7.1-22.6-1.2l-53.3 48V16c0-8.8-7.2-16-16-16S96 7.2 96 16v148.1l-53.3-48c-6.6-5.9-16.7-5.4-22.6 1.2s-5.4 16.7 1.2 22.6l80 72c6.1 5.5 15.3 5.5 21.4 0l80-72c6.6-5.9 7.1-16 1.2-22.6zm352 0c-5.9-6.6-16-7.1-22.6-1.2l-53.3 48V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v148.1l-53.3-48c-6.6-5.9-16.7-5.4-22.6 1.2s-5.4 16.7 1.2 22.6l80 72c6.1 5.5 15.3 5.5 21.4 0l80-72c6.6-5.9 7.1-16 1.2-22.6zm-258.4 45.8c-5.7-4.2-13.4-4.2-19 0L105.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L68.8 457.8c-3.7 28.7 18.7 54.2 47.6 54.2h343.2c29 0 51.3-25.5 47.6-54.2l-17.6-134.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zm-173 153.7L272 207.7V480H116.4c-9.7 0-17.1-8.5-15.9-18.1L118 327.5c.6-4.3 2.9-8.2 6.4-10.8zm179.5-1.4V207.7l147.5 109.1c3.5 2.6 5.8 6.5 6.4 10.8L475.4 462c1.2 9.6-6.2 18.1-15.9 18.1h-53.6l-.3-.4L304 315.4zm0 164.6V376.2L368.2 480H304z"
        }
    ]
};

const FalTent = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTent",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M278.9 2.8c5.5-3.8 12.7-3.8 18.2 0l220.2 151.9c11.3 7.8 18.7 20 20.4 33.6L571.4 458c3.6 28.6-18.8 54-47.6 54H52.2C23.4 512 1 486.7 4.6 458l33.7-269.8c1.7-13.6 9.1-25.8 20.4-33.6L278.9 2.8zM76.9 181c-3.8 2.6-6.2 6.7-6.8 11.2L36.4 462c-1.2 9.5 6.3 18 15.9 18H272V46.5L76.9 181zm328.5 299L304 288.4V480h101.4zm36.2 0h82.1c9.6 0 17.1-8.4 15.9-18l-33.7-269.8c-.6-4.5-3-8.6-6.8-11.2L304 46.5V220l137.6 260z"
        }
    ]
};

const FalTents = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTents",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M425.5 3.1c-5.7-4.2-13.4-4.2-19 0L236 129.1c9.5 1.8 18.7 5.8 26.8 12l5.4 4.1L416 35.9l163.5 120.9c3.5 2.6 5.8 6.5 6.4 10.8L603.4 302c1.2 9.6-6.2 18.1-15.9 18.1H456.7l4.8 32h126c29 0 51.3-25.5 47.6-54.2l-17.5-134.5c-1.7-12.9-8.6-24.6-19.1-32.4L425.5 3.1zm-192 160c-5.7-4.2-13.4-4.2-19 0L41.4 291c-10.5 7.8-17.4 19.5-19.1 32.4L4.8 457.8C1.1 486.5 23.5 512 52.4 512h343.2c29 0 51.3-25.5 47.6-54.2l-17.6-134.4c-1.7-12.9-8.6-24.6-19.1-32.4l-173-127.9zm-173 153.7L208 207.7V480H52.4c-9.7 0-17.1-8.5-15.9-18.1l17.6-134.3c.6-4.3 2.9-8.2 6.4-10.8zm179.5-6.9V207.7l147.5 109.1c3.5 2.6 5.8 6.5 6.4 10.8L411.4 462c1.2 9.6-6.2 18.1-15.9 18.1h-50.1l-.2-.4-104-168c-.4-.6-.7-1.1-1.2-1.6zm0 170.1V370.5L307.8 480H240z"
        }
    ]
};

const FalTerminal = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTerminal",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M5.1 59.7c-6.5-6-6.9-16.1-.8-22.6s16.1-6.9 22.6-.8l224 208c3.3 3 5.1 7.3 5.1 11.7s-1.9 8.7-5.1 11.7l-224 208c-6.5 6-16.6 5.6-22.6-.8s-5.6-16.6.8-22.6L216.5 256 5.1 59.7zM240 448h320c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalTextHeight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTextHeight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M491.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L464 86.6v338.8l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 425.4V86.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80zM32 32C14.3 32 0 46.3 0 64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64h112v384H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64V64h112v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7-14.3-32-32-32H32z"
        }
    ]
};

const FalTextSize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTextSize",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64h144v384h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64V64h144v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7-14.3-32-32-32H32zm320 192c-17.7 0-32 14.3-32 32v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h112v192h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V256h112v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-17.7-14.3-32-32-32H352z"
        }
    ]
};

const FalTextSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTextSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM390.4 64h149.1l-11 44.1c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l11-44.1c5-20.2-10.2-39.8-31-39.8h-383c-4.7 0-9.2 1-13.3 2.9L180.1 64h177.1l-32.1 114.5 27.2 21.5 38.1-136zM287.7 312l-38.1 136H176c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-53.1L315 333.5 287.7 312z"
        }
    ]
};

const FalTextWidth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTextWidth",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32C14.3 32 0 46.3 0 64v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64h176v192h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V64h176v64c0 8.8 7.2 16 16 16s16-7.2 16-16V64c0-17.7-14.3-32-32-32H32zM4.7 372.7c-6.2 6.2-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 400h338.8l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7H54.6l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-80 80z"
        }
    ]
};

const FalText = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalText",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 64c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H240v384h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V64H32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V64z"
        }
    ]
};

const FalThermometer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalThermometer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352.8 53.8 310.6 96l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L288 118.6 246.6 160l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 182.6 224l36.7 36.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L160 246.6l-22.6 22.6c-6 6-9.4 14.1-9.4 22.6V384h92.1c8.5 0 16.6-3.4 22.6-9.4l215.5-215.4c14-14 21.8-32.9 21.8-52.7 0-41.1-33.4-74.5-74.5-74.5-19.8 0-38.7 7.8-52.7 21.8zm-76.1 30.9 53.5-53.5c20-20 47.1-31.2 75.3-31.2C464.3 0 512 47.7 512 106.5c0 28.2-11.2 55.3-31.2 75.3L265.4 397.3c-12 12-28.3 18.7-45.3 18.7H118.6l-91.3 91.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L96 393.4V291.9c0-17 6.7-33.3 18.7-45.3l33.9-33.9 64-64 64-64z"
        }
    ]
};

const FalTheta = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTheta",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 256c0-58.9 17.1-111.6 43.9-149.1C118.7 69.4 154.3 48 192 48s73.3 21.4 100.1 58.9C318.9 144.4 336 197.1 336 256s-17.1 111.6-43.9 149.1C265.3 442.6 229.7 464 192 464s-73.3-21.4-100.1-58.9C65.1 367.6 48 314.9 48 256zM192 16c-50.7 0-95.1 28.8-126.2 72.3C34.7 131.9 16 191.2 16 256s18.7 124.1 49.8 167.7C96.9 467.2 141.3 496 192 496s95.1-28.8 126.2-72.3C349.3 380.1 368 320.8 368 256s-18.7-124.1-49.8-167.7C287.1 44.8 242.7 16 192 16zm-80 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"
        }
    ]
};

const FalThoughtBubble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalThoughtBubble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-50.7 0-94.4 29.4-115.2 72.1-1.6-.1-3.2-.1-4.8-.1C60.9 72 0 132.9 0 208s60.9 136 136 136c10.8 0 21.2-1.3 31.3-3.6 20.5 26.5 52.6 43.6 88.7 43.6s68.2-17.1 88.7-43.6c10.1 2.4 20.5 3.6 31.3 3.6 75.1 0 136-60.9 136-136S451.1 72 376 72c-1.6 0-3.2 0-4.8.1C350.4 29.4 306.7 0 256 0zm-90 94.5C179.6 58 214.8 32 256 32s76.4 26 90 62.5c2.6 7 9.6 11.2 17 10.3 4.3-.5 8.6-.8 13-.8 57.4 0 104 46.6 104 104s-46.6 104-104 104c-11.5 0-22.6-1.9-32.9-5.3-7.1-2.4-14.8.5-18.7 6.9-14.1 23-39.5 38.4-68.4 38.4s-54.3-15.4-68.4-38.5c-3.9-6.4-11.6-9.2-18.7-6.9-10.3 3.4-21.4 5.3-32.9 5.3C78.6 312 32 265.4 32 208s46.6-104 104-104c4.4 0 8.8.3 13 .8 7.4.9 14.4-3.3 17-10.3zM144 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FalThumbsDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalThumbsDown",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288.8 430.3c3.5 12.8 16.7 20.3 29.5 16.8s20.3-16.7 16.8-29.5l-4.5-16.4c-5.5-20.2-13.9-39.3-24.7-56.9-3.1-4.9-3.2-11.1-.4-16.2s8.2-8.2 14-8.2H448c17.7 0 32-14.3 32-32 0-11.3-5.9-21.3-14.8-27-7.2-4.6-9.5-13.9-5.3-21.3 2.6-4.6 4.1-10 4.1-15.7 0-12.4-7-23.1-17.3-28.5-4.2-2.2-7.3-6.1-8.3-10.8s.1-9.5 3-13.2c4.2-5.4 6.7-12.2 6.7-19.5 0-14.2-9.2-26.3-22.1-30.4-7.8-2.5-12.4-10.6-10.7-18.6.5-2.2.7-4.5.7-6.9 0-17.7-14.3-32-32-32h-89.5c-15.8 0-31.2 4.7-44.4 13.4l-38.5 25.7c-9 6-16.6 13.7-22.4 22.6-4.9 7.4-14.8 9.4-22.2 4.6s-9.4-14.8-4.6-22.2c8.1-12.3 18.7-23.1 31.4-31.6l38.5-25.7c18.4-12.3 40-18.8 62.1-18.8H384c35.3 0 64 28.7 64 64v.6c19.1 11.1 32 31.7 32 55.4 0 8.7-1.8 17.1-4.9 24.7 12.8 11.7 20.9 28.5 20.9 47.3 0 6.5-1 12.8-2.8 18.7 11.6 11.6 18.8 27.6 18.8 45.3 0 35.3-28.7 64-64 64H346.4c6.2 13.1 11.3 26.7 15.1 40.9l4.5 16.4c8.1 29.8-9.5 60.6-39.3 68.8s-60.6-9.5-68.8-39.3l-4.5-16.4c-8.9-32.6-29.6-60.8-58.2-79l-3.1-2 8.2-12.9-8.2 12.9c-11.8-7.5-21.7-17.1-29.5-28.2-5.1-7.2-3.3-17.2 4-22.3s17.2-3.3 22.3 4c5.4 7.7 12.2 14.4 20.4 19.5l3.1 2c35.3 22.4 60.9 57.2 71.9 97.5l4.5 16.4zM32 352h64V128H32v224zm-32 0V128c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"
        }
    ]
};

const FalThumbsUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalThumbsUp",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288.8 81.7c3.5-12.8 16.7-20.3 29.5-16.8s20.3 16.7 16.8 29.5l-4.5 16.4c-5.5 20.2-13.9 39.3-24.7 56.9-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2H448c17.7 0 32 14.3 32 32 0 11.3-5.9 21.3-14.8 27-7.2 4.6-9.5 13.9-5.3 21.3 2.6 4.6 4.1 10 4.1 15.7 0 12.4-7 23.1-17.3 28.5-4.2 2.2-7.3 6.1-8.3 10.8s.1 9.5 3 13.2c4.2 5.4 6.7 12.2 6.7 19.5 0 14.2-9.2 26.3-22.1 30.4-7.8 2.6-12.4 10.6-10.7 18.6.5 2.2.7 4.5.7 6.9 0 17.7-14.3 32-32 32h-89.5c-15.8 0-31.2-4.7-44.4-13.4l-38.5-25.7c-9-6-16.6-13.7-22.4-22.6-4.9-7.4-14.8-9.4-22.2-4.6s-9.4 14.8-4.6 22.2c8.1 12.3 18.7 23.1 31.4 31.6l38.5 25.7c18.4 12.3 40 18.8 62.1 18.8H384c35.3 0 64-28.7 64-64v-.6c19.1-11.1 32-31.7 32-55.4 0-8.7-1.8-17.1-4.9-24.7 12.8-11.7 20.9-28.5 20.9-47.3 0-6.5-1-12.8-2.8-18.7 11.6-11.6 18.8-27.6 18.8-45.3 0-35.3-28.7-64-64-64H346.4c6.2-13.1 11.3-26.7 15.1-40.9l4.5-16.4c8.1-29.8-9.5-60.6-39.3-68.8s-60.6 9.5-68.8 39.3l-4.5 16.4c-8.9 32.6-29.6 60.8-58.2 79l-3.1 2c-11.8 7.5-21.7 17.1-29.5 28.2-5.1 7.2-3.3 17.2 4 22.3s17.2 3.3 22.3-4c5.4-7.7 12.2-14.4 20.4-19.5l3.1-2c35.3-22.4 60.9-57.2 71.9-97.5l4.5-16.4zM32 224h64v224H32V224zm-32 0v224c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalThumbtack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalThumbtack",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m119.9 34.5-12.1 156.9c-.7 9.7-5.9 18.6-13.9 24-27 18.3-47.3 46.2-55.6 79.6L32 320h144v-96c0-8.8 7.2-16 16-16s16 7.2 16 16v96h144l-6.2-25c-8.3-33.4-28.6-61.3-55.6-79.6-8.1-5.5-13.2-14.3-13.9-24L264.1 34.5c-.1-.8-.1-1.6-.1-2.5H120c0 .8 0 1.6-.1 2.5zM176 352H32c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l6.2-25c10.3-41.3 35.4-75.7 68.7-98.3L85.5 64 88 32H64c-2.9 0-5.6-.8-7.9-2.1-4.9-2.8-8.1-8-8.1-13.9 0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16 0 5.9-3.2 11.1-8.1 13.9-2.3 1.3-5 2.1-7.9 2.1h-24l2.5 32 9.6 124.9c33.3 22.6 58.4 57.1 68.7 98.3l6.2 25c2.4 9.6.2 19.7-5.8 27.5S361.8 352 352 352H208v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V352z"
        }
    ]
};

const FalTick = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTick",
    "viewBox": "0 0 128 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M24.6 256.9C28.9 275.1 45.2 288 64 288s35.1-12.9 39.4-31.1L133.9 129c1.4-6 2.1-12.1 2.1-18.2V104c0-39.8-32.2-72-72-72S-8 64.2-8 104v6.8c0 6.1.7 12.3 2.1 18.2l30.5 127.9zM24 104c0-22.1 17.9-40 40-40s40 17.9 40 40v6.8c0 3.6-.4 7.3-1.3 10.8L72.3 249.5c-.9 3.8-4.3 6.5-8.3 6.5s-7.4-2.7-8.3-6.5L25.3 121.6c-.8-3.5-1.3-7.2-1.3-10.8V104z"
        }
    ]
};

const FalTicketAirline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTicketAirline",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-49.6c-36.5-7.4-64-39.7-64-78.4s27.5-71 64-78.4V128c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h512c35.3 0 64 28.7 64 64v66.4c0 8-8 13.6-16 13.6-26.5 0-48 21.5-48 48s21.5 48 48 48c8 0 16 5.6 16 13.6V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm464 16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM217.8 218.9c1.6 4.9.8 10.2-2.2 14.4s-7.8 6.6-13 6.6H160c-5 0-9.8-2.4-12.8-6.4L128 208h-3.5l10.1 40.2c1.3 5.1 1.3 10.4 0 15.5L124.5 304h3.5l19.2-25.6c3-4 7.8-6.4 12.8-6.4h42.7c5.1 0 10 2.5 13 6.6s3.8 9.5 2.2 14.4l-19.7 59h20c2.8 0 5.5-1.5 6.9-4l39.7-68.1c2.9-4.9 8.1-7.9 13.8-7.9h40.3c11.8 0 23.1-4.7 31.5-13 1.6-1.6 1.6-4.3 0-5.9-8.4-8.4-19.7-13-31.5-13h-40.2c-5.7 0-11-3-13.8-7.9L225.1 164c-1.4-2.5-4.1-4-6.9-4h-20l19.6 58.9zM187.1 128h31.1c14.2 0 27.4 7.6 34.6 19.8l35.1 60.2H319c20.3 0 39.8 8.1 54.1 22.4 14.1 14.1 14.1 37 0 51.2C358.7 296 339.3 304 319 304h-31.1l-35.1 60.2c-7.2 12.3-20.3 19.8-34.6 19.8h-31.1c-16.4 0-27.9-16-22.8-31.6l16.2-48.4H168l-14.4 19.2c-6 8.1-15.5 12.8-25.6 12.8h-13.8c-15.6 0-27.1-14.7-23.3-29.8l12.6-50.2L91 205.8c-3.8-15.1 7.7-29.8 23.3-29.8H128c10.1 0 19.6 4.7 25.6 12.8L168 208h12.5l-16.1-48.4c-5.2-15.5 6.4-31.6 22.8-31.6z"
        }
    ]
};

const FalTicketSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTicketSimple",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 128c0-35.3 28.7-64 64-64h448c35.3 0 64 28.7 64 64v66c0 7.3-4.9 13.7-12 15.5-20.7 5.3-36 24.1-36 46.5s15.3 41.2 36 46.5c7.1 1.8 12 8.2 12 15.5v66c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-66c0-7.3 4.9-13.7 12-15.5 20.7-5.3 36-24.1 36-46.5s-15.3-41.2-36-46.5c-7.1-1.8-12-8.2-12-15.5v-66zm64-32c-17.7 0-32 14.3-32 32v54.7C60.2 195 80 223.2 80 256s-19.8 61-48 73.3V384c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-54.7c-28.2-12.3-48-40.5-48-73.3s19.8-61 48-73.3V128c0-17.7-14.3-32-32-32H64z"
        }
    ]
};

const FalTicket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTicket",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64C28.7 64 0 92.7 0 128v66c0 7.3 4.9 13.7 12 15.5 20.7 5.3 36 24.1 36 46.5s-15.3 41.2-36 46.5c-7.1 1.8-12 8.2-12 15.5v66c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64v-66c0-7.3-4.9-13.7-12-15.5-20.7-5.3-36-24.1-36-46.5s15.3-41.2 36-46.5c7.1-1.8 12-8.2 12-15.5v-66c0-35.3-28.7-64-64-64H64zm-32 64c0-17.7 14.3-32 32-32h448c17.7 0 32 14.3 32 32v54.7c-28.2 12.3-48 40.5-48 73.3s19.8 61 48 73.3V384c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-54.7C60.2 317 80 288.8 80 256s-19.8-61-48-73.3V128zm128 64h256v128H160V192zm-32 0v128c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalTicketsAirline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTicketsAirline",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 96v224c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32v-47.5c-23.7-11.8-40-36.2-40-64.5s16.3-52.8 40-64.5V96c0-17.7-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zm484.1 45.6h.1-.1zm.1 132.9h-.1.1zM160 32h416c35.3 0 64 28.7 64 64v56c0 8.8-7.4 15.7-15.6 19.1-14.3 6.1-24.4 20.3-24.4 36.9s10.1 30.8 24.4 36.9c8.1 3.4 15.6 10.3 15.6 19.1v56c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64V96c0-35.3 28.7-64 64-64zm320 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm0 64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm16 48a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm-16 80a16 16 0 1 1 32 0 16 16 0 1 1-32 0zM16 96c8.8 0 16 7.2 16 16v256c0 44.2 35.8 80 80 80h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H112C50.1 480 0 429.9 0 368V112c0-8.8 7.2-16 16-16zm274.3 74.9c1.6 4.9.8 10.2-2.2 14.4s-7.8 6.6-13 6.6h-45.3c-4.2 0-8.3-1.7-11.3-4.7L207.1 176H196l7.3 21.9c2.2 6.6 2.2 13.7 0 20.2L196 240h11.2l11.3-11.3c3-3 7.1-4.7 11.3-4.7h45.3c5.1 0 10 2.5 13 6.6s3.8 9.5 2.2 14.4L276 288h20c2.8 0 5.5-1.5 6.9-4l30.4-52.1c2.9-4.9 8.1-7.9 13.8-7.9h41.6c11.8 0 23.1-4.7 31.5-13 1.6-1.6 1.6-4.3 0-5.9-8.4-8.4-19.7-13-31.5-13h-41.6c-5.7 0-11-3-13.8-7.9L302.9 132c-1.4-2.5-4.1-4-6.9-4h-20l14.3 42.9zM264.9 96H296c14.2 0 27.4 7.6 34.6 19.8l-13.8 8.1 13.8-8.1 25.7 44.2h32.4c20.3 0 39.8 8.1 54.1 22.4 14.1 14.1 14.1 37 0 51.2-14.4 14.3-33.8 22.4-54.1 22.4h-32.4l-25.8 44.2c-7.1 12.2-20.3 19.8-34.5 19.8h-31.1c-16.4 0-27.9-16-22.8-31.6l10.8-32.4h-16.5l-6.6 6.6c-6 6-14.1 9.4-22.6 9.4h-22.3c-16.4 0-27.9-16-22.8-31.6l10.8-32.4-10.8-32.4c-5.2-15.5 6.4-31.6 22.8-31.6h22.3c8.5 0 16.6 3.4 22.6 9.4l6.6 6.6h16.5l-10.8-32.4C236.9 112 248.5 96 264.9 96z"
        }
    ]
};

const FalTilde = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTilde",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96.8 160C61.2 160 32 188.8 32 224v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-53.2 43.9-96 96.8-96 29.4 0 57.6 13.5 75.9 36.7l128 162.8c12.1 15.4 31 24.5 50.7 24.5 35.5 0 64.8-28.8 64.8-64v-96c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 53.2-43.9 96-96.8 96-29.4 0-57.6-13.5-75.9-36.7l-128-162.9c-12.1-15.4-31-24.5-50.7-24.5z"
        }
    ]
};

const FalTimelineArrow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTimelineArrow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0zm32 0c0 29.8-20.4 54.9-48 62v114h224V142c-27.6-7.1-48-32.2-48-62 0-35.3 28.7-64 64-64s64 28.7 64 64c0 29.8-20.4 54.9-48 62v114h195.8l-62.1-51.7c-6.8-5.7-7.7-15.7-2-22.5s15.7-7.7 22.5-2l95.9 79.9c.6.5 1.1 1 1.6 1.5 2.6 2.8 4.2 6.7 4.2 10.8v1c-.2 3.5-1.5 6.7-3.6 9.2-.6.8-1.3 1.5-2.1 2.1l-.1.1-95.9 79.9c-6.8 5.7-16.9 4.7-22.5-2s-4.7-16.9 2-22.5l62.1-51.8H256v82c27.6 7.1 48 32.2 48 62 0 35.3-28.7 64-64 64s-64-28.7-64-64c0-29.8 20.4-54.9 48-62v-82H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V142c-27.6-7.1-48-32.2-48-62 0-35.3 28.7-64 64-64s64 28.7 64 64zm32 352a32 32 0 1 0 64 0 32 32 0 1 0-64 0zM400 80a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FalTimeline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTimeline",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm16 94c27.6-7.1 48-32.2 48-62 0-35.3-28.7-64-64-64S80 44.7 80 80c0 29.8 20.4 54.9 48 62v114H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h304v82c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62v-82h272c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V142c27.6-7.1 48-32.2 48-62 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62v114H160V142zm176 322a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM496 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FalTimer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTimer",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 0c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V32.6C388.2 40.8 480 137.7 480 256c0 123.7-100.3 224-224 224S32 379.7 32 256c0-46.6 14.2-89.9 38.6-125.8 5-7.3 3.1-17.3-4.2-22.2s-17.3-3.1-22.2 4.2C16.3 153.2 0 202.7 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zm-84.7 148.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z"
        }
    ]
};

const FalTireFlat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTireFlat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 460.2c0 10.9 8.9 19.8 19.8 19.8h408.4c10.9 0 19.8-8.9 19.8-19.8 0-3.1-.7-6.1-2.1-8.8L460.2 416c-5.6-11.1-5.5-23.9-.6-34.7 13-28.4 20.3-60 20.3-93.3C480 164.3 379.7 64 256 64S32 164.3 32 288c0 33.4 7.3 65 20.3 93.3 5 10.8 5 23.6-.6 34.7l-17.6 35.4-28.3-14.1 28.3 14.1c-1.4 2.7-2.1 5.8-2.1 8.8zM512 288c0 38.1-8.3 74.2-23.2 106.7-1 2.2-1 4.8.1 7l17.7 35.3c3.6 7.2 5.5 15.1 5.5 23.2 0 28.6-23.2 51.8-51.8 51.8H51.8C23.2 512 0 488.8 0 460.2c0-8 1.9-16 5.5-23.2l17.7-35.3c1.1-2.2 1.1-4.8.1-7C8.3 362.2 0 326.1 0 288 0 146.6 114.6 32 256 32s256 114.6 256 256zm-128 0c0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6 0 1.4 0 2.7-.1 4l61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2zm-74.1 34.4c-8.6 13.5-22.1 23.5-38 27.6v65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1zm-70 27.5c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4v-65zM128 288c0 8.3.8 16.3 2.3 24.2l61.8-20.2c-.1-1.3-.1-2.7-.1-4 0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 218.1 128 251.2 128 288zm128-64c8.3 0 16.3 1.6 23.6 4.5l38.2-52.6C299.5 165.8 278.4 160 256 160s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8c7.3-2.9 15.3-4.5 23.6-4.5zM96 288a160 160 0 1 1 320 0 160 160 0 1 1-320 0zm192 0a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FalTirePressureWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTirePressureWarning",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 0c-8.8 0-16 7.2-16 16v11.6c0 42.2 9.8 83.9 28.7 121.6l5 9.9c.2.3.3.6.5.9 18 30.9 36.4 73.1 35.8 120.5-.6 45.5-18.7 97.9-76.2 151.4H118.2C60.7 378.5 42.6 326.1 42 280.6c-.6-47.4 17.8-89.7 35.8-120.5.2-.3.3-.6.5-.9l5-9.9C102.2 111.4 112 69.8 112 27.6V16c0-8.8-7.2-16-16-16S80 7.2 80 16v11.6c0 37.3-8.7 74-25.3 107.3l-4.7 9.5C30.7 177.5 9.3 225.5 10 281c.7 55 23.1 115.3 86 174.1V496c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h64v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-40.9c63-58.8 85.3-119.1 86-174.1.7-55.5-20.7-103.5-39.9-136.6l-4.7-9.5C440.7 101.6 432 64.8 432 27.6V16c0-8.8-7.2-16-16-16zM256 96c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalTireRugged = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTireRugged",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M229.8 32c-8.2 0-15.1 6.3-15.9 14.5l-.3 3.1c-.6 6.6-5.2 12.1-11.6 13.9-15.5 4.3-30.2 10.5-43.9 18.2-5.8 3.2-12.9 2.6-18-1.6l-2.4-2c-6.4-5.2-15.7-4.8-21.5 1l-37.1 37c-5.8 5.8-6.3 15.1-1 21.5l2 2.4c4.2 5.1 4.8 12.3 1.6 18-7.7 13.7-13.9 28.4-18.2 43.9-1.8 6.4-7.3 11-13.9 11.6l-3.1.3c-8.2.8-14.5 7.7-14.5 15.9v52.4c0 8.2 6.3 15.1 14.5 15.9l3.1.3c6.6.6 12.1 5.2 13.9 11.6 4.3 15.5 10.5 30.2 18.2 43.9 3.2 5.8 2.6 12.9-1.6 18l-2 2.4c-5.2 6.4-4.8 15.7 1 21.5l37.1 37.1c5.8 5.8 15.1 6.3 21.5 1l2.4-2c5.1-4.2 12.3-4.8 18-1.6 13.7 7.7 28.4 13.9 43.9 18.2 6.4 1.8 11 7.3 11.6 13.9l.3 3.1c.8 8.2 7.7 14.5 15.9 14.5h52.4c8.2 0 15.1-6.3 15.9-14.5l.3-3.1c.6-6.6 5.2-12.1 11.6-13.9 15.5-4.3 30.2-10.5 43.9-18.2 5.8-3.2 12.9-2.6 18 1.6l2.4 2c6.4 5.2 15.7 4.8 21.5-1l37.1-37.1c5.8-5.8 6.3-15.1 1-21.5l-2-2.4c-4.2-5.1-4.8-12.3-1.6-18 7.7-13.7 13.9-28.4 18.2-43.9 1.8-6.4 7.3-11 13.9-11.6l3.1-.3c8.2-.8 14.5-7.7 14.5-15.9v-52.3c0-8.2-6.3-15.1-14.5-15.9l-3.1-.3c-6.6-.6-12.1-5.2-13.9-11.6-4.3-15.5-10.5-30.2-18.2-43.9-3.2-5.8-2.6-12.9 1.6-18l2-2.4c5.2-6.4 4.8-15.7-1-21.5l-37.1-37.1c-5.8-5.8-15.1-6.3-21.5-1L372 80c-5.1 4.2-12.3 4.8-18 1.6-13.7-7.7-28.4-13.9-43.9-18.2-6.4-1.8-11-7.3-11.6-13.9l-.3-3.1c-.8-8.2-7.7-14.5-15.9-14.5h-52.5zm-46.4 3.6C188.9 14.9 207.7 0 229.8 0h52.4c22 0 40.9 14.9 46.4 35.6 11 3.6 21.7 8.1 31.9 13.2 18.5-10.7 42.4-8 58 7.6l37.1 37.1c15.6 15.6 18.3 39.4 7.6 58 5.2 10.2 9.6 20.9 13.2 31.9 20.7 5.5 35.6 24.3 35.6 46.4v52.4c0 22-14.9 40.9-35.6 46.4-3.6 11-8.1 21.7-13.2 31.9 10.7 18.5 8 42.4-7.6 58l-37.1 37.1c-15.6 15.6-39.4 18.3-58 7.6-10.2 5.2-20.9 9.6-31.9 13.2-5.5 20.7-24.3 35.6-46.4 35.6h-52.4c-22 0-40.9-14.9-46.4-35.6-11-3.6-21.7-8.1-31.9-13.2-18.5 10.7-42.4 8-58-7.6l-37.1-37.1c-15.6-15.6-18.3-39.5-7.6-58-5.2-10.2-9.6-20.9-13.2-31.9C14.9 323.1 0 304.3 0 282.2v-52.4c0-22 14.9-40.9 35.6-46.4 3.6-11 8.1-21.7 13.2-31.9-10.7-18.5-8-42.4 7.6-58l37.1-37.1c15.6-15.6 39.5-18.3 58-7.6 10.2-5.2 20.9-9.6 31.9-13.2zM96 256a160 160 0 1 1 320 0 160 160 0 1 1-320 0zm160 128a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm0-224a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-75.9 96.6a24 24 0 1 1 14.8-45.7 24 24 0 1 1-14.8 45.7zm167.2-30.2a24 24 0 1 1-45.7 14.8 24 24 0 1 1 45.7-14.8zm-29.6 73.8a24 24 0 1 1-38.8 28.2 24 24 0 1 1 38.8-28.2zm-118.1 33.5a24 24 0 1 1 28.2-38.8 24 24 0 1 1-28.2 38.8z"
        }
    ]
};

const FalTire = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTire",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm319.9 4 61.8 20.1c1.5-7.8 2.3-15.9 2.3-24.2 0-36.8-15.5-69.9-40.3-93.3l-38.2 52.6c9.1 11 14.5 25.2 14.5 40.6 0 1.4 0 2.7-.1 4zm-9.9 30.4c-8.6 13.5-22.1 23.5-38 27.6v65c44.3-5.5 81.5-33.6 99.8-72.4l-61.9-20.1zM240 383v-65c-15.8-4.1-29.3-14.1-37.9-27.5l-61.9 20.1c18.3 38.8 55.5 66.9 99.8 72.4zM130.3 280.2l61.8-20.2c-.1-1.3-.1-2.7-.1-4 0-15.4 5.5-29.6 14.5-40.6l-10.1-13.9-28.1-38.7C143.5 186.1 128 219.2 128 256c0 8.3.8 16.3 2.3 24.2zm102.1-83.7c7.3-2.9 15.3-4.5 23.6-4.5s16.3 1.6 23.6 4.5l38.2-52.6C299.5 133.8 278.4 128 256 128s-43.5 5.8-61.8 15.9l28.1 38.8 10 13.8zM288 256a32 32 0 1 0-64 0 32 32 0 1 0 64 0zM256 96a160 160 0 1 1 0 320 160 160 0 1 1 0-320z"
        }
    ]
};

const FalToggleLargeOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToggleLargeOff",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 384a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm0 32h256c88.4 0 160-71.6 160-160S504.4 96 416 96H160C71.6 96 0 167.6 0 256s71.6 160 160 160zm96-32c38.9-29.2 64-75.7 64-128s-25.1-98.8-64-128h160c70.7 0 128 57.3 128 128s-57.3 128-128 128H256z"
        }
    ]
};

const FalToggleLargeOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToggleLargeOn",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 128a128 128 0 1 0 0 256 128 128 0 1 0 0-256zm0 288H160C71.6 416 0 344.4 0 256S71.6 96 160 96h256c88.4 0 160 71.6 160 160s-71.6 160-160 160zm-96-32c-38.9-29.2-64-75.7-64-128s25.1-98.8 64-128H160c-70.7 0-128 57.3-128 128s57.3 128 128 128h160z"
        }
    ]
};

const FalToggleOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToggleOff",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M416 128c70.7 0 128 57.3 128 128s-57.3 128-128 128H160c-70.7 0-128-57.3-128-128s57.3-128 128-128h256zm160 128c0-88.4-71.6-160-160-160H160C71.6 96 0 167.6 0 256s71.6 160 160 160h256c88.4 0 160-71.6 160-160zm-352 0a64 64 0 1 1-128 0 64 64 0 1 1 128 0zm-160 0a96 96 0 1 0 192 0 96 96 0 1 0-192 0z"
        }
    ]
};

const FalToggleOn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToggleOn",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 128c-70.7 0-128 57.3-128 128s57.3 128 128 128h256c70.7 0 128-57.3 128-128s-57.3-128-128-128H160zM0 256C0 167.6 71.6 96 160 96h256c88.4 0 160 71.6 160 160s-71.6 160-160 160H160C71.6 416 0 344.4 0 256zm480 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0z"
        }
    ]
};

const FalToiletPaperBlankUnder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletPaperBlankUnder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M58.2 75.2C42.3 104.3 32 145.5 32 192s10.3 87.7 26.2 116.8C74.4 338.5 94.1 352 112 352h225.3c-7.2-8.2-13.6-17.7-19.2-27.9C299.2 289.5 288 242.8 288 192s11.2-97.5 30.1-132.1c5.6-10.2 12-19.6 19.2-27.9H112c-17.9 0-37.6 13.5-53.8 43.2zM400 32c-17.9 0-37.6 13.5-53.8 43.2C330.3 104.3 320 145.5 320 192s10.3 87.7 26.2 116.8c16.2 29.7 35.9 43.2 53.8 43.2s37.6-13.5 53.8-43.2C469.7 279.7 480 238.5 480 192s-10.3-87.7-26.2-116.8C437.6 45.5 417.9 32 400 32zm80 432V327.6c-18.6 32.3-46.1 56.4-80 56.4H112c-35.1 0-63.4-25.9-81.9-59.9C11.2 289.5 0 242.8 0 192S11.2 94.5 30.1 59.9C48.6 25.9 76.9 0 112 0h288c35.1 0 63.4 25.9 81.9 59.9C500.8 94.5 512 141.2 512 192v272c0 26.5-21.5 48-48 48H176c-26.5 0-48-21.5-48-48v-48h32v48c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16zm-80-224c6.4 0 11.9-11.3 14.5-27.6 1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16-5.1-6.4-8.2-13.8-10.3-20-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20 4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20 4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20-4.8 6.1-15.1 16-31.4 16z"
        }
    ]
};

const FalToiletPaperBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletPaperBlank",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M20.5 463.6c-2.8 4.7-4.3 10-4.5 15.4-.2 5.8 1.2 11.6 4.2 16.8 5.6 10 16.3 16.2 27.8 16.2h269.9c22.3 0 45.4-12.1 55.4-36.1 10.7-25.8 27.3-76.6 36.3-158.9.3-2.4.5-4.9.8-7.4 3.4-33.9 5.6-73 5.6-117.7 0-88.4 35.8-160 80-160s80 71.6 80 160-35.8 160-80 160c-20.6 0-39.4-15.6-53.6-41.2-1.6 16.4-3.6 31.8-5.7 46 15.5 16 35.2 27.3 59.3 27.3 40.7 0 69-32.2 85.2-64.6C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0H160c-53 0-96 86-96 192 0 80.2-.4 180.8-36.2 257.3-2.3 4.9-4.7 9.6-7.3 14.3v.1zM432.3 32c-8.6 9.9-15.8 21.2-21.5 32.6C393.7 98.8 384 143.9 384 192c0 155.1-26.7 239-40.2 271.7-4.3 10.3-14.5 16.3-25.9 16.3H48c.2-.3.4-.6.5-.9 24.4-44.1 35.9-95.4 41.6-144.8C95.9 284.6 96 234.4 96 192c0-49.1 10-92 24.7-121.5C136.4 39.2 152.1 32 160 32h272.3zm49.2 180.4c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zm45.9 43.6c5.1-6.4 8.2-13.8 10.3-20 4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20 4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16z"
        }
    ]
};

const FalToiletPaperCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletPaperCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 479c.2-5.3 1.7-10.6 4.5-15.4v-.1c2.6-4.6 5-9.4 7.3-14.3C63.6 372.8 64 272.2 64 192 64 86 107 0 160 0h336c40.7 0 69 32.2 85.2 64.6C598.3 98.8 608 143.9 608 192s-9.7 93.2-26.8 127.4C565 351.8 536.7 384 496 384c-24.1 0-43.8-11.3-59.3-27.2 2.1-14.2 4.1-29.6 5.7-46 14.2 25.6 33 41.2 53.6 41.2 44.2 0 80-71.6 80-160S540.2 32 496 32s-80 71.6-80 160c0 44.7-2.2 83.7-5.6 117.7-.3 2.5-.5 4.9-.8 7.4-9 82.3-25.6 133.1-36.3 158.9-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2-2.9-5.2-4.3-11-4.2-16.8zM160 32c-7.9 0-23.6 7.2-39.3 38.5C106 100 96 142.9 96 192c0 42.4-.1 92.6-5.8 142.2-5.7 49.5-17.3 100.7-41.6 144.8-.2.3-.4.6-.5.9h269.8c11.4 0 21.6-6.1 25.9-16.3C357.3 431 384 347.1 384 192c0-48.1 9.7-93.2 26.8-127.4 5.7-11.3 12.8-22.6 21.5-32.6H160zm336 208c6.4 0 11.9-11.3 14.5-27.6 1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16-5.1-6.4-8.2-13.8-10.3-20-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20 4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20 4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20-4.8 6.1-15.1 16-31.4 16zm-188.7-84.7-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalToiletPaperSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletPaperSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M581.2 319.4C598.3 285.2 608 240.1 608 192s-9.7-93.2-26.8-127.4C565 32.2 536.7 0 496 0H160c-14.1 0-27.5 6.1-39.5 17l25.7 20.3c5.6-4 10.4-5.3 13.8-5.3h272.3c-8.6 9.9-15.8 21.2-21.5 32.6C393.7 98.8 384 143.9 384 192c0 11.3-.1 22.1-.4 32.7l31.2 24.6c.8-18 1.2-37 1.2-57.3 0-88.4 35.8-160 80-160s80 71.6 80 160c0 65.6-19.7 122-48 146.7l25.4 20c11.5-11.3 20.8-25.3 27.8-39.3zm-212.6 56.5c-8.3 43.2-18.1 71.7-24.8 87.8-4.3 10.3-14.5 16.3-25.9 16.3H48c.2-.3.4-.6.5-.9 24.4-44.1 35.9-95.4 41.6-144.8C95.9 284.6 96 234.4 96 192c0-10.4.4-20.5 1.3-30.3l-29.5-23.3c-2.5 17-3.8 35-3.8 53.6 0 80.2-.4 180.8-36.2 257.3-2.3 4.9-4.7 9.6-7.3 14.3v.1c-2.8 4.7-4.3 10-4.5 15.4-.2 5.8 1.2 11.6 4.2 16.8C25.8 505.8 36.5 512 48 512h269.9c22.3 0 45.4-12.1 55.4-36.1 6.6-15.9 15.5-41.4 23.4-77.9l-28.1-22.2zm112.9-163.5c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zm45.9 43.6c5.1-6.4 8.2-13.8 10.3-20 4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20 4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalToiletPaperUnderSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletPaperUnderSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M500.4 480H240c-8.8 0-16-7.2-16-16v-48h-32v48c0 26.5 21.5 48 48 48h288c3.9 0 7.7-.5 11.3-1.3L500.4 480zM544 327.6v23.7l32 25.3V192c0-50.8-11.2-97.5-30.1-132.1C527.4 25.9 499.1 0 464 0H176c-19.3 0-36.5 7.8-51.1 20.4l25.8 20.4c8.5-6 17.1-8.8 25.3-8.8h225.3c-7.2 8.2-13.6 17.7-19.2 27.9C363.2 94.5 352 141.2 352 192c0 2.6 0 5.2.1 7.8l33.9 26.7c-1.3-11.1-1.9-22.6-1.9-34.5 0-46.5 10.3-87.7 26.2-116.8C426.4 45.5 446.1 32 464 32s37.6 13.5 53.8 43.2C533.7 104.3 544 145.5 544 192s-10.3 87.7-26.2 116.8c-3 5.4-6 10.3-9.2 14.6l25.1 19.8c3.7-4.9 7.1-10.2 10.2-15.7zM64 192c0 50.8 11.2 97.5 30.1 132.1 18.6 34 46.8 59.9 81.9 59.9h202.8l-40.5-32H176c-17.9 0-37.6-13.5-53.8-43.2C106.3 279.7 96 238.5 96 192c0-10.3.5-20.4 1.5-30.1l-29.3-23.1c-2.8 17-4.2 34.8-4.2 53.2zm400 48c-6.4 0-11.9-11.3-14.5-27.6-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6zm0 32c16.2 0 26.6-9.9 31.4-16 5.1-6.4 8.2-13.8 10.3-20 4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20 4.8 6.1 15.1 16 31.4 16zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalToiletPaperUnder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletPaperUnder",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32h225.3c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9H112c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6V464c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-48h-32v48c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V192c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0H112C76.9 0 48.6 25.9 30.1 59.9 11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1c18.5 34 46.8 59.9 81.9 59.9h288c33.9 0 61.4-24.1 80-56.4zm-94.5-115.2c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zm45.9 43.6c5.1-6.4 8.2-13.8 10.3-20 4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20 4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM96 224a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm64 0a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-16a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalToiletPaperXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletPaperXmark",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 192c0-46.5 10.3-87.7 26.2-116.8C74.4 45.5 94.1 32 112 32h225.3c-7.2 8.2-13.6 17.7-19.2 27.9C299.2 94.5 288 141.2 288 192s11.2 97.5 30.1 132.1c5.6 10.2 12 19.6 19.2 27.9H112c-17.9 0-37.6-13.5-53.8-43.2C42.3 279.7 32 238.5 32 192zM346.2 75.2C362.4 45.5 382.1 32 400 32s37.6 13.5 53.8 43.2C469.7 104.3 480 145.5 480 192s-10.3 87.7-26.2 116.8C437.6 338.5 417.9 352 400 352s-37.6-13.5-53.8-43.2C330.3 279.7 320 238.5 320 192s10.3-87.7 26.2-116.8zM480 327.6V464c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16v-48h-32v48c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V192c0-50.8-11.2-97.5-30.1-132.1C463.4 25.9 435.1 0 400 0H112C76.9 0 48.6 25.9 30.1 59.9 11.2 94.5 0 141.2 0 192s11.2 97.5 30.1 132.1c18.5 34 46.8 59.9 81.9 59.9h288c33.9 0 61.4-24.1 80-56.4zm-94.5-115.2c-1-6.2-1.5-13.1-1.5-20.4s.5-14.2 1.5-20.4c2.6-16.3 8.1-27.6 14.5-27.6s11.9 11.3 14.5 27.6c1 6.2 1.5 13.1 1.5 20.4s-.5 14.2-1.5 20.4c-2.6 16.3-8.1 27.6-14.5 27.6s-11.9-11.3-14.5-27.6zm45.9 43.6c5.1-6.4 8.2-13.8 10.3-20 4.2-12.7 6.3-28.3 6.3-44.1s-2.1-31.3-6.3-44.1c-2.1-6.2-5.2-13.5-10.3-20-4.8-6.1-15.1-16-31.4-16s-26.6 9.9-31.4 16c-5.1 6.4-8.2 13.8-10.3 20-4.2 12.7-6.3 28.3-6.3 44.1s2.1 31.3 6.3 44.1c2.1 6.2 5.2 13.5 10.3 20 4.8 6.1 15.1 16 31.4 16s26.6-9.9 31.4-16zM227.3 132.7c-6.2-6.2-16.4-6.2-22.6 0L168 169.4l-36.7-36.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l36.7 36.7-36.7 36.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l36.7-36.7 36.7 36.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L190.6 192l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6z"
        }
    ]
};

const FalToiletPaper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletPaper",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 479c.2-5.3 1.7-10.6 4.5-15.4v-.1c2.6-4.6 5-9.4 7.3-14.3C63.6 372.8 64 272.2 64 192 64 86 107 0 160 0h336c40.7 0 69 32.2 85.2 64.6C598.3 98.8 608 143.9 608 192s-9.7 93.2-26.8 127.4C565 351.8 536.7 384 496 384c-24.1 0-43.8-11.3-59.3-27.2 2.1-14.2 4.1-29.6 5.7-46 14.2 25.6 33 41.2 53.6 41.2 44.2 0 80-71.6 80-160S540.2 32 496 32s-80 71.6-80 160c0 44.7-2.2 83.7-5.6 117.7-.3 2.5-.5 4.9-.8 7.4-9 82.3-25.6 133.1-36.3 158.9-10 24-33.2 36.1-55.4 36.1H48c-11.5 0-22.2-6.2-27.8-16.2-2.9-5.2-4.3-11-4.2-16.8zM160 32c-7.9 0-23.6 7.2-39.3 38.5C106 100 96 142.9 96 192c0 42.4-.1 92.6-5.8 142.2-5.7 49.5-17.3 100.7-41.6 144.8-.2.3-.4.6-.5.9h269.8c11.4 0 21.6-6.1 25.9-16.3C357.3 431 384 347.1 384 192c0-48.1 9.7-93.2 26.8-127.4 5.7-11.3 12.8-22.6 21.5-32.6H160zm336 208c6.4 0 11.9-11.3 14.5-27.6 1-6.2 1.5-13.1 1.5-20.4s-.5-14.2-1.5-20.4c-2.6-16.3-8.1-27.6-14.5-27.6s-11.9 11.3-14.5 27.6c-1 6.2-1.5 13.1-1.5 20.4s.5 14.2 1.5 20.4c2.6 16.3 8.1 27.6 14.5 27.6zm0 32c-16.2 0-26.6-9.9-31.4-16-5.1-6.4-8.2-13.8-10.3-20-4.2-12.7-6.3-28.3-6.3-44.1s2.1-31.3 6.3-44.1c2.1-6.2 5.2-13.5 10.3-20 4.8-6.1 15.1-16 31.4-16s26.6 9.9 31.4 16c5.1 6.4 8.2 13.8 10.3 20 4.2 12.7 6.3 28.3 6.3 44.1s-2.1 31.3-6.3 44.1c-2.1 6.2-5.2 13.5-10.3 20-4.8 6.1-15.1 16-31.4 16zm-368-64a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm80-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalToiletPortable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletPortable",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 64v32h256V64c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32zm0 64v320h256V336h-24c-22.1 0-40-17.9-40-40v-48c0-22.1 17.9-40 40-40h24v-80H32zm288-64v432c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H32v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64zm-56 176c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v-64h-24z"
        }
    ]
};

const FalToilet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToilet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zm64 180.8c5-1.6 10.2-3.2 15.4-4.6C121 181.2 174.5 176 224 176s103 5.2 144.6 16.3c5.3 1.4 10.4 2.9 15.4 4.6V64h32v146.6c2.1 1.2 4.2 2.5 6.1 3.8 13.9 9.4 25.9 23 25.9 41.6 0 69.8-35.8 118.1-81 148.5l15.2 51c1.2 4.1 1.8 8.3 1.8 12.5 0 24.3-19.7 43.9-43.9 43.9H107.9C83.7 512 64 492.3 64 468.1c0-4.2.6-8.5 1.8-12.5l15.2-51C35.8 374.1 0 325.8 0 256c0-18.5 12-32.2 25.9-41.6 1.9-1.3 4-2.6 6.1-3.8V64h32v132.8zM40.3 305.7c11.3 31.6 33.2 55.4 59.7 72.9 39.4 26.1 88.2 37.4 124 37.4s84.6-11.3 124.1-37.3c26.5-17.5 48.4-41.3 59.7-72.9-11.5 5.6-24.9 10.2-39.2 14C327 330.8 273.5 336 224 336s-103-5.2-144.6-16.3c-14.3-3.8-27.6-8.4-39.2-14zM416 256c0-3.1-1.8-8.3-11.8-15-9.8-6.6-24.7-12.7-43.9-17.8C322.2 213.1 271.7 208 224 208s-98.2 5.1-136.3 15.2c-19.2 5.1-34.1 11.2-43.9 17.8-10 6.7-11.8 11.9-11.8 15s1.8 8.3 11.8 15c9.8 6.6 24.7 12.7 43.9 17.8C125.8 298.9 176.3 304 224 304s98.2-5.1 136.3-15.2c19.2-5.1 34.1-11.2 43.9-17.8 9.9-6.7 11.8-11.9 11.8-15zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16zm239.5 400.7-13.1-43.8C299.6 439.7 257.3 448 224 448s-75.6-8.3-114.4-27.2l-13.1 43.9c-.3 1.1-.5 2.3-.5 3.4 0 6.6 5.3 11.9 11.9 11.9h232.2c6.6 0 11.9-5.3 11.9-11.9 0-1.2-.2-2.3-.5-3.4z"
        }
    ]
};

const FalToiletsPortable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToiletsPortable",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h128c17.7 0 32 14.3 32 32v32H32V64c0-17.7 14.3-32 32-32zM32 448V128h192v80h-24c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h24v112H32zm224-240V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v432c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h192v16c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm-32 32v64h-24c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h24zM384 32h128c17.7 0 32 14.3 32 32v32H352V64c0-17.7 14.3-32 32-32zm-32 416V128h192v80h-24c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h24v112H352zm224-240V64c0-35.3-28.7-64-64-64H384c-35.3 0-64 28.7-64 64v432c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h192v16c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm-32 32v64h-24c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h24z"
        }
    ]
};

const FalTomato = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTomato",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 4.7 224 16l11.3-11.3.1.1.2.2.4.5c.4.4.8.9 1.4 1.5 1.1 1.3 2.6 3.1 4.4 5.4 3.5 4.7 8 11.5 12.5 20.4 6 12 11.9 27.8 15.1 47.4 52.9 1.7 102.9 13.6 145.6 35.3 13.2 6.7 20.1 21.6 16.6 36S415.3 176 400.5 176h-4.8c6.7 11.5 5.5 26.1-3.1 36.5-9.1 10.9-24.2 14.5-37.2 8.9L256 178.8l-99.4 42.6c-13 5.6-28.2 1.9-37.2-8.9-8.7-10.5-9.8-25.2-2.9-36.8h-.2c-13.3 2-26.9-4.5-33.4-17.1-8-15.8-1.7-35 14-43l.8-.4c41-20.6 88.6-32.3 139.1-34.6-2.8-13.8-7.1-24.9-11.3-33.3-3.5-7-7-12.2-9.5-15.6-1.2-1.7-2.2-2.8-2.9-3.6-.3-.4-.5-.6-.6-.7l-.1-.1c-6.2-6.3-6.1-16.3.1-22.5 6.2-6.2 16.4-6.2 22.6 0zm4.7 107.6c-47.2 2-90.9 12.7-127.7 31.3l-.8.4c1.2-.3 2.4-.4 3.6-.4l31.3.2c5.9 0 11.3 3.3 14 8.5s2.4 11.5-.8 16.4L144 192l105.7-45.3c4-1.7 8.6-1.7 12.6 0L368 192l-15.4-23.1c-3.3-4.9-3.6-11.2-.8-16.4s8.2-8.5 14.1-8.5h34.6c-37-18.8-81-29.7-128.5-31.7-.2 8.7-7.3 15.7-16 15.7s-15.8-7-16-15.7zM73.4 195.4C47.3 223.5 32 259.8 32 304c0 55 23.6 97.8 62.5 127.7C134.1 462.2 190.8 480 256 480s121.9-17.8 161.5-48.3C456.4 401.8 480 359 480 304c0-44.2-15.3-80.5-41.4-108.6 8.7-6.4 15.7-15 20.3-25.1C492.2 204.5 512 249.6 512 304c0 130.9-114.6 208-256 208S0 434.9 0 304c0-54.4 19.8-99.6 53.1-133.7.4.9.8 1.8 1.3 2.7 4.7 9.2 11.2 16.7 18.9 22.4z"
        }
    ]
};

const FalTombstoneBlank = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTombstoneBlank",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 192v256h32V192C416 86 330 0 224 0S32 86 32 192v256h32V192c0-88.4 71.6-160 160-160s160 71.6 160 160zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalTombstone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTombstone",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 448V192c0-88.4-71.6-160-160-160S64 103.6 64 192v256H32V192C32 86 118 0 224 0s192 86 192 192v256h-32zM0 496c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm240-352v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V240h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalToolbox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToolbox",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 64h160c8.8 0 16 7.2 16 16v48H160V80c0-8.8 7.2-16 16-16zm-48 16v48h-21.5c-17 0-33.3 6.7-45.3 18.7l-42.5 42.6C6.7 201.3 0 217.5 0 234.5V416c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V234.5c0-17-6.7-33.3-18.7-45.3l-42.5-42.5c-12-12-28.3-18.7-45.3-18.7H384V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48zm16 80h261.5c8.5 0 16.6 3.4 22.6 9.4l42.5 42.5c6 6 9.4 14.1 9.4 22.6V304H352v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H192v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H32v-69.5c0-8.5 3.4-16.6 9.4-22.6l42.5-42.5c6-6 14.1-9.4 22.6-9.4H144zM32 336h128v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h128v32c0 8.8 7.2 16 16 16s16-7.2 16-16v-32h128v80c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32v-80z"
        }
    ]
};

const FalTooth = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTooth",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M132 64c14.7 0 29 4.8 40.8 13.6l41.6 31.2 21.3 16c7.1 5.3 17.1 3.9 22.4-3.2s3.9-17.1-3.2-22.4l-5.4-4 16.3-13.9c13-11.1 29.5-17.2 46.6-17.2 39.5 0 71.6 32.1 71.6 71.6v3c0 11.6-2.7 23-7.9 33.4L354 216.3c-6.2 12.3-10.5 25.5-13 39.1l-33.6 188.2-28.1-112.4c-6.4-25.4-29.2-43.2-55.3-43.2s-48.9 17.8-55.3 43.2l-28.1 112.4L107 255.4c-2.4-13.6-6.8-26.7-13-39.1L71.9 172c-5.2-10.4-7.9-21.8-7.9-33.4V132c0-37.6 30.4-68 68-68zm91.3 11.5L192 52c-17.3-13-38.4-20-60-20C76.8 32 32 76.8 32 132v6.6c0 16.6 3.9 32.9 11.3 47.7l22.2 44.3c4.8 9.6 8.2 19.8 10.1 30.4l34.6 193.6c2.6 14.7 15.4 25.4 30.4 25.4 14.1 0 26.5-9.6 29.9-23.4l29.4-117.7c2.8-11.1 12.8-18.9 24.2-18.9s21.5 7.8 24.2 18.9l29.4 117.7c3.4 13.7 15.8 23.4 29.9 23.4 14.9 0 27.7-10.7 30.4-25.4L372.5 261c1.9-10.6 5.3-20.8 10.1-30.4l22.2-44.3c7.4-14.8 11.3-31.1 11.3-47.7v-3C416 78.4 369.6 32 312.4 32c-24.7 0-48.6 8.8-67.4 24.9l-21.7 18.6z"
        }
    ]
};

const FalToothbrush = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToothbrush",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 192c-17.7 0-32-14.3-32-32s14.3-32 32-32h224c24.8 0 45.1-9.9 57.7-28.9 6.6-10.1 10.1-21.2 11.9-31.6 14.8 3.6 27.9 9.7 37.9 17.8C408.3 95.7 416 109.4 416 128c0 35.3-28.7 64-64 64H64zM0 160c0 35.3 28.7 64 64 64h288c53 0 96-43 96-96 0-58.5-51.6-89.9-104-95.2-8.8-.9-15.8 6.4-16.4 15.2-1.5 25.3-8.4 48-39.6 48H64c-35.3 0-64 28.7-64 64zm64 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v176H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H384V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v176h-32V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v176h-32V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v176h-32V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v176h-32V272c0-8.8-7.2-16-16-16s-16 7.2-16 16v176H64V272z"
        }
    ]
};

const FalToriiGate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalToriiGate",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 112c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V40.9l-23.5 9.4c-22.7 9-46.9 13.7-71.3 13.7H126.8c-24.4 0-48.6-4.7-71.3-13.7L32 40.9V112zm208 64H96v80h144v-80zm-176 0c-35.3 0-64-28.7-64-64V13.4C0 6 6 0 13.4 0c1.7 0 3.4.3 5 1l49 19.6C86.3 28.1 106.5 32 126.8 32h258.4c20.4 0 40.5-3.9 59.4-11.4l49-19.6c1.6-.6 3.3-1 5-1C506 0 512 6 512 13.4V112c0 35.3-28.7 64-64 64v80h48c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H96v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h48v-80zm352 0H272v80h144v-80z"
        }
    ]
};

const FalTornado = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTornado",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 122.6c0 13.9 4.5 27.4 12.8 38.5L418 232c19.4 25.9 30 57.5 30 89.9 0 39.7-15.8 77.8-43.9 105.9L325.9 506c-3.8 3.8-8.9 5.9-14.2 5.9-12.4 0-21.8-11.1-19.8-23.4l5.9-35.7c4-24 .3-48.7-10.6-70.5-10-19.9-25.5-36.5-44.6-47.8l-116.4-68.3C48 220.2 0 136.3 0 45.6V32C0 14.3 14.3 0 32 0h361.4C405.9 0 416 10.1 416 22.6c0 6-2.4 11.8-6.6 16l-38.6 38.6c-12 12-18.8 28.4-18.8 45.4zm-320-77c0 28.7 5.5 56.6 15.7 82.4h272.5c-.1-1.8-.2-3.6-.2-5.4 0-25.5 10.1-50 28.2-68L370.7 32H32v13.6zm110.4 193.1 57.6 33.8v-.5h204.9c-3.4-7.3-7.6-14.2-12.5-20.8l-53.2-70.9c-4.7-6.3-8.6-13.1-11.7-20.3H63.4c19 31.9 45.9 59.2 79 78.7zM253.5 304l5.3 3.1c24.5 14.4 44.3 35.6 57 61 13.8 27.5 18.5 58.6 13.7 89l51.9-51.9c22.1-22.1 34.5-52.1 34.5-83.3 0-6-.5-12-1.4-17.9h-161z"
        }
    ]
};

const FalTowerBroadcast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTowerBroadcast",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M46.7 1.4c-8.1-3.6-17.5-.1-21.2 8C9.1 45.6 0 85.8 0 128s9.1 82.4 25.5 118.6c3.6 8.1 13.1 11.6 21.2 8s11.6-13.1 8-21.2C40.1 201.3 32 165.6 32 128s8.1-73.3 22.6-105.4c3.6-8.1.1-17.5-8-21.2zm482.7 0c-8.1 3.6-11.6 13.1-8 21.2C535.9 54.7 544 90.4 544 128s-8.1 73.3-22.6 105.4c-3.6 8.1-.1 17.5 8 21.2s17.5.1 21.2-8C566.9 210.4 576 170.2 576 128s-9.1-82.4-25.5-118.6c-3.6-8.1-13.1-11.6-21.2-8zM256 128a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm48 62c27.6-7.1 48-32.2 48-62 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 29.8 20.4 54.9 48 62v306c0 8.8 7.2 16 16 16s16-7.2 16-16V190zM138.9 69.8c3.2-8.2-.9-17.5-9.1-20.7s-17.5.9-20.7 9.1C100.6 79.8 96 103.4 96 128s4.6 48.2 13.1 69.8c3.2 8.2 12.5 12.3 20.7 9.1s12.3-12.5 9.1-20.7c-7-18-10.9-37.6-10.9-58.2s3.9-40.2 10.9-58.2zm328-11.6c-3.2-8.2-12.5-12.3-20.7-9.1s-12.3 12.5-9.1 20.7c7 18 10.9 37.6 10.9 58.2s-3.9 40.2-10.9 58.2c-3.2 8.2.9 17.5 9.1 20.7s17.5-.9 20.7-9.1c8.5-21.7 13.1-45.2 13.1-69.8s-4.6-48.2-13.1-69.8z"
        }
    ]
};

const FalTowerCell = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTowerCell",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M40.9 9.1c-8.2-3.2-17.5.9-20.7 9.2C7.2 52.2 0 89.2 0 128s7.2 75.8 20.3 109.8c3.2 8.2 12.4 12.4 20.7 9.2s12.4-12.4 9.2-20.7C38.4 196 32 162.8 32 128s6.4-67.9 18.1-98.2c3.2-8.2-.9-17.5-9.2-20.7zm494.1 0c-8.2 3.2-12.4 12.4-9.2 20.7C537.6 60.1 544 93.2 544 128s-6.4 67.9-18.1 98.2c-3.2 8.2.9 17.5 9.2 20.7s17.5-.9 20.7-9.2c13.1-33.9 20.3-71 20.3-109.8s-7.2-75.8-20.3-109.8c-3.2-8.2-12.4-12.4-20.7-9.2zM288 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm47.3 75.1c10.4-11.4 16.7-26.5 16.7-43.1 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 16.6 6.3 31.7 16.7 43.1L97.4 489.4c-3.6 8.1 0 17.5 8 21.2s17.5 0 21.2-8l39-86.6h244.9l39 86.6c3.6 8.1 13.1 11.7 21.2 8s11.7-13.1 8-21.2L335.3 171.1zM396.1 384H179.9l28.8-64h158.6l28.8 64zm-87.9-195.2 44.7 99.2H223.1l44.7-99.2c6.3 2.1 13.1 3.3 20.2 3.3s13.8-1.1 20.2-3.3zM140 70.4c3.5-8.1-.2-17.5-8.3-21.1s-17.5.2-21.1 8.3C101.2 79.2 96 103 96 128s5.2 48.8 14.7 70.4c3.5 8.1 13 11.8 21.1 8.3s11.8-13 8.3-21.1c-7.7-17.6-12-37.1-12-57.6s4.3-40 12-57.6zm325.3-12.8c-3.5-8.1-13-11.8-21.1-8.3s-11.8 13-8.3 21.1c7.7 17.6 12 37.1 12 57.6s-4.3 40-12 57.6c-3.5 8.1.2 17.5 8.3 21.1s17.5-.2 21.1-8.3C474.8 176.8 480 153 480 128s-5.2-48.8-14.7-70.4z"
        }
    ]
};

const FalTowerControl = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTowerControl",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 16c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32h48c17.7 0 32 14.3 32 32v32h80.9c26.2 0 45.3 24.8 38.7 50.1l-37 142.1c7.6 1.2 13.4 7.8 13.4 15.8 0 8.8-7.2 16-16 16h-48v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H128v144c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H48c-8.8 0-16-7.2-16-16 0-8 5.8-14.6 13.4-15.8l-37-142.1C1.8 152.8 20.9 128 47.1 128H128V96c0-17.7 14.3-32 32-32h48V32h-32c-8.8 0-16-7.2-16-16zm-32 144.2v-.2H47.1c-5.2 0-9.1 5-7.7 10l39.1 150H128V160.2zM160 320h128V160H160v160zm160-160v160h49.6l39.1-150c1.3-5.1-2.5-10-7.7-10h-81zm-32-32V96H160v32h128z"
        }
    ]
};

const FalTowerObservation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTowerObservation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248.8 1.7c4.5-2.3 9.8-2.3 14.3 0l176 88c7.9 4 11.1 13.6 7.2 21.5s-13.6 11.1-21.5 7.2L416 114v78c0 26.5-21.5 48-48 48h-7.8l39.6 237.4c.1.9.2 1.8.2 2.6h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c0-.9.1-1.7.2-2.6L151.8 240H144c-26.5 0-48-21.5-48-48v-78.1l-8.8 4.4c-7.9 4-17.5.7-21.5-7.2s-.7-17.5 7.2-21.5l176-88zm7.2 32.2-128 64V128h256V97.9l-128-64zM128 160v32c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16v-32H128zm231.4 320L256 391.4 152.6 480h206.8zM184 240c0 .9-.1 1.7-.2 2.6l-6.5 39.1 78.7 67.5 78.7-67.5-6.5-39.1c-.1-.9-.2-1.8-.2-2.6H184zm-12.9 78.6L151 439.2l80.4-68.9-60.3-51.7zm109.5 51.7 80.4 68.9-20.1-120.6-60.3 51.7z"
        }
    ]
};

const FalTractor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTractor",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 48v111.2c6.9-18.3 24.5-31.2 45-31.2h38c21.7 0 40.3 14.5 46.1 34.7 12.6-7 27.6-7.8 40.7-2.7h42.8L289.9 41.4c-2.6-5.7-8.3-9.4-14.6-9.4H144c-8.8 0-16 7.2-16 16zM96 157.3V48c0-26.5 21.5-48 48-48h131.3c18.9 0 36 11.1 43.8 28.3L378.3 160H480v-40.2c0-29.7 11.8-58.2 32.8-79.2l3.9-3.9c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-3.9 3.9c-15 15-23.4 35.4-23.4 56.6V160h88c22.2 0 39.9 18 39.9 40v60.5c0 12.2-5.5 23.6-15 31.2L567.1 338c-11.3 9.1-25.4 14-40 14H382.2c-4.4 15.9-16.9 28.5-32.9 33.2 10.2 18.4 7.3 41.8-8.1 57.1l-26.9 26.9c-15.3 15.4-38.7 18.3-57.1 8.1-5.9 20.2-24.5 34.7-46.2 34.7h-38c-21.7 0-40.3-14.5-46.1-34.7-18.4 10.2-41.8 7.3-57.1-8.1l-27-26.9 11-11-11 11c-15.3-15.4-18.3-38.7-8.1-57.1C14.5 379.3 0 360.7 0 339v-38c0-21.7 14.5-40.3 34.7-46.1-10.2-18.4-7.3-41.8 8.1-57.1l26.9-26.9c7.4-7.4 16.6-11.9 26.3-13.4zM384 320h143.2c7.3 0 14.3-2.5 20-7l57.8-46.3c1.9-1.5 3-3.8 3-6.2V200c0-4.5-3.6-8-7.9-8H431.4h.6-96l5.7 5.7c15.4 15.4 18.3 38.7 8.1 57.1 20.2 5.8 34.7 24.4 34.7 46.1v19zm128 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM157 174.4l-1.3 12.9c-.6 6-4.5 11.1-10.1 13.3-1.8.7-3.5 1.4-5.2 2.2-5.5 2.4-11.9 1.6-16.6-2.3l-10.1-8.2c-6.4-5.2-15.6-4.7-21.4 1.1l-26.9 26.9c-5.8 5.8-6.3 15.1-1.1 21.4l8.2 10.1c3.8 4.7 4.7 11.1 2.3 16.6-.8 1.7-1.5 3.5-2.2 5.2-2.2 5.6-7.3 9.5-13.3 10.1L46.4 285c-8.2.9-14.4 7.7-14.4 16v38c0 8.2 6.2 15.1 14.4 15.9l12.9 1.3c6 .6 11.1 4.5 13.3 10.1.7 1.8 1.4 3.5 2.2 5.2 2.4 5.5 1.6 11.9-2.3 16.6l-8.2 10.1c-5.2 6.4-4.7 15.6 1.1 21.4l26.9 26.9c5.8 5.8 15.1 6.3 21.4 1.1l10.1-8.2c4.7-3.8 11.1-4.7 16.6-2.3 1.7.8 3.5 1.5 5.2 2.2 5.6 2.2 9.5 7.3 10.1 13.3l1.3 12.9c.8 8.2 7.7 14.4 15.9 14.4H211c8.2 0 15.1-6.2 15.9-14.4l1.3-12.9c.6-6 4.5-11.1 10.1-13.3 1.8-.7 3.5-1.4 5.2-2.2 5.5-2.4 11.9-1.6 16.6 2.3l10.1 8.2c6.4 5.2 15.6 4.7 21.4-1.1l26.9-26.9c5.8-5.8 6.3-15.1 1.1-21.4l-8.2-10.1c-3.8-4.7-4.7-11.1-2.3-16.6.8-1.7 1.5-3.4 2.2-5.2 2.2-5.6 7.3-9.5 13.3-10.1l12.9-1.3c8.2-.8 14.4-7.7 14.4-15.9v-38c0-8.2-6.2-15.1-14.4-15.9l-12.9-1.3c-6-.6-11.1-4.5-13.3-10.1-.7-1.8-1.4-3.5-2.2-5.2-2.4-5.5-1.6-11.9 2.3-16.6l8.2-10.1c5.2-6.4 4.7-15.6-1.1-21.4l-26.9-26.9c-5.8-5.8-15.1-6.3-21.4-1.1l-10.1 8.2c-4.7 3.8-11.1 4.7-16.6 2.3-1.7-.8-3.5-1.5-5.2-2.2-5.6-2.2-9.5-7.3-10.1-13.3l-1.2-13c-.8-8.2-7.7-14.4-15.9-14.4H173c-8.2 0-15.1 6.2-15.9 14.4zM137.6 320a54.4 54.4 0 1 0 108.8 0 54.4 54.4 0 1 0-108.8 0zm54.4 86.4a86.4 86.4 0 1 1 0-172.8 86.4 86.4 0 1 1 0 172.8z"
        }
    ]
};

const FalTrademark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrademark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 112c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zm112 288c0 8.8 7.2 16 16 16s16-7.2 16-16V128h-32v272zm204.3-298.2c-4.3-5.2-11.4-7.1-17.7-4.8s-10.6 8.3-10.6 15v288c0 8.8 7.2 16 16 16s16-7.2 16-16V156.2l131.7 158c3 3.6 7.5 5.8 12.3 5.8s9.3-2.1 12.3-5.8l131.7-158V400c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-6.7-4.2-12.8-10.6-15s-13.4-.4-17.7 4.8L464 279 316.3 101.8z"
        }
    ]
};

const FalTrafficCone = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrafficCone",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M248.2 32h15.5c3.3 0 6.2 2 7.4 5l49.2 123H191.6l49.2-123c1.2-3 4.2-5 7.4-5zm84.9 160 51.2 128H127.6l51.2-128h154.4zm64 160 51.2 128H63.6l51.2-128h282.4zm-186-326.9L29.2 480H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16h-13.2L300.9 25.1C294.8 10 280.1 0 263.8 0h-15.6c-16.4 0-31.1 10-37.1 25.1z"
        }
    ]
};

const FalTrafficLightGo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrafficLightGo",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v288c0 88.4-71.6 160-160 160S0 440.4 0 352V64zm160 384a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-216a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-24-192a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm80 0a56 56 0 1 1-112 0 56 56 0 1 1 112 0z"
        }
    ]
};

const FalTrafficLightSlow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrafficLightSlow",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v288c0 88.4-71.6 160-160 160S0 440.4 0 352V64zm136 328a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm80 0a56 56 0 1 1-112 0 56 56 0 1 1 112 0zm0-136a56 56 0 1 1-112 0 56 56 0 1 1 112 0zm-80-136a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm80 0a56 56 0 1 1-112 0 56 56 0 1 1 112 0z"
        }
    ]
};

const FalTrafficLightStop = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrafficLightStop",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v288c0 88.4-71.6 160-160 160S0 440.4 0 352V64zm136 328a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm80 0a56 56 0 1 1-112 0 56 56 0 1 1 112 0zm-56-160a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm0-136a56 56 0 1 1 0-112 56 56 0 1 1 0 112z"
        }
    ]
};

const FalTrafficLight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrafficLight",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v288c0 70.7 57.3 128 128 128s128-57.3 128-128V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h192c35.3 0 64 28.7 64 64v288c0 88.4-71.6 160-160 160S0 440.4 0 352V64zm136 328a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm80 0a56 56 0 1 1-112 0 56 56 0 1 1 112 0zm-56-160a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm0 80a56 56 0 1 1 0-112 56 56 0 1 1 0 112zm-24-192a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm80 0a56 56 0 1 1-112 0 56 56 0 1 1 112 0z"
        }
    ]
};

const FalTrailer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrailer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M56 64h400c13.3 0 24 10.7 24 24v264H282.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H56c-13.3 0-24-10.7-24-24V88c0-13.3 10.7-24 24-24zm232 320h328c8.8 0 16-7.2 16-16s-7.2-16-16-16H512V88c0-30.9-25.1-56-56-56H56C25.1 32 0 57.1 0 88v240c0 30.9 25.1 56 56 56h40c0 53 43 96 96 96s96-43 96-96zm-32 0a64 64 0 1 1-128 0 64 64 0 1 1 128 0zM112 96c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16s16-7.2 16-16V112c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalTrainSubwayTunnel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrainSubwayTunnel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224v240c0 8.8 7.2 16 16 16s16-7.2 16-16V256C512 114.6 397.4 0 256 0S0 114.6 0 256v240c0 8.8 7.2 16 16 16s16-7.2 16-16V256zm336-48v48h-96v-96h48c26.5 0 48 21.5 48 48zm-128 80h128v80c0 26.5-21.5 48-48 48H192c-26.5 0-48-21.5-48-48v-80h96zm0-128v96h-96v-48c0-26.5 21.5-48 48-48h48zm-48-32c-44.2 0-80 35.8-80 80v160c0 32.8 19.8 61 48 73.4l-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l59.3-59.3h114.8l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L352 441.4c28.3-12.3 48-40.5 48-73.4V208c0-44.2-35.8-80-80-80H192zm8 256a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm136-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalTrainSubway = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrainSubway",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32v192H32V96c0-35.3 28.7-64 64-64h112zm32 0h112c35.3 0 64 28.7 64 64v128H240V32zM32 352v-96h384v96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zM96 0C43 0 0 43 0 96v256c0 46 32.4 84.4 75.6 93.8l-38.9 38.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l59.3-59.3h210.8l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-38.9-38.9C415.6 436.4 448 398 448 352V96c0-53-43-96-96-96H96zm24 352a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm232-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalTrainTrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrainTrack",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M207.1 53.2c2.9-8.4-1.5-17.5-9.9-20.4s-17.5 1.5-20.4 9.9L158.5 96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h35.4l-33.2 96H72c-8.8 0-16 7.2-16 16s7.2 16 16 16h31.1l-33.3 96H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h26.8l-25.9 74.8c-2.9 8.3 1.5 17.5 9.9 20.4s17.5-1.5 20.4-9.9L92.6 384h390.8l29.5 85.2c2.9 8.3 12 12.8 20.4 9.9s12.8-12 9.9-20.4l-26-74.7H544c8.8 0 16-7.2 16-16s-7.2-16-16-16h-37.8L473 256h31c8.8 0 16-7.2 16-16s-7.2-16-16-16h-42.1l-33.2-96H464c8.8 0 16-7.2 16-16s-7.2-16-16-16h-46.5l-18.4-53.2c-2.9-8.4-12-12.8-20.4-9.9s-12.8 12-9.9 20.4L383.7 96H192.3l14.8-42.8zM181.2 128h213.6l33.2 96H148l33.2-96zm291.1 224H103.7l33.2-96h302.2l33.2 96z"
        }
    ]
};

const FalTrainTram = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrainTram",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M41.3 50c9.1-11.4 22.9-18 37.5-18H208v64h-48c-53 0-96 43-96 96v160c0 28.9 12.8 54.8 33 72.4l-60.3 60.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l65.8-65.8c10.8 4.2 22.6 6.5 34.9 6.5h128c12.3 0 24-2.3 34.9-6.5l65.8 65.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L351 424.4c20.2-17.6 33-43.5 33-72.4V192c0-53-43-96-96-96h-48V32h129.2c14.6 0 28.4 6.6 37.5 18l12.8 16c5.5 6.9 15.6 8 22.5 2.5s8-15.6 2.5-22.5l-12.8-16c-15.2-19-38.2-30-62.5-30H78.8C54.5 0 31.5 11 16.3 30L3.5 46C-2 52.9-.9 63 6 68.5s17 4.4 22.5-2.5l12.8-16zM160 128h128c35.3 0 64 28.7 64 64v64H96v-64c0-35.3 28.7-64 64-64zM96 288h256v64c0 35.3-28.7 64-64 64H160c-35.3 0-64-28.7-64-64v-64zm96 56a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm88 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalTrainTunnel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrainTunnel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224v240c0 8.8 7.2 16 16 16s16-7.2 16-16V256C512 114.6 397.4 0 256 0S0 114.6 0 256v240c0 8.8 7.2 16 16 16s16-7.2 16-16V256zm336-48v48H144v-48c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48zM144 368v-80h224v80c0 26.5-21.5 48-48 48H192c-26.5 0-48-21.5-48-48zm16 73.4-43.3 43.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l59.3-59.3h114.8l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L352 441.4c28.3-12.3 48-40.5 48-73.4V208c0-44.2-35.8-80-80-80H192c-44.2 0-80 35.8-80 80v160c0 32.8 19.8 61 48 73.4zM280 352a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalTrain = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrain",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32c35.3 0 64 28.7 64 64v128H32V96c0-35.3 28.7-64 64-64h256zM32 352v-96h384v96c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64zM96 0C43 0 0 43 0 96v256c0 46 32.4 84.4 75.6 93.8l-38.9 38.9c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l59.3-59.3h210.8l59.3 59.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-38.9-38.9C415.6 436.4 448 398 448 352V96c0-53-43-96-96-96H96zm128 368a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"
        }
    ]
};

const FalTransformerBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransformerBolt",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 16c0-8.8-7.2-16-16-16S96 7.2 96 16v16H64c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V16zm160 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V16zM48 112c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H64c-8.8 0-16 7.2-16 16zm160 0c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v288H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V192h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm48 320V192h256v288H64zm78.6-144 61.9-61.9-4.4 44.3c-.4 4.5 1 9 4.1 12.3s7.3 5.3 11.9 5.3h25.4l-61.9 61.9 4.4-44.3c.4-4.5-1-9-4.1-12.3s-7.3-5.3-11.9-5.3h-25.4zm75.6-112c-5.6 0-11 2.2-15 6.2L102.3 331c-4.1 4.1-6.3 9.6-6.3 15.3 0 12 9.7 21.7 21.7 21.7h32.7l-5.7 56.6c-1.3 12.5 8.6 23.4 21.2 23.4 5.6 0 11-2.2 15-6.2L281.7 341c4.1-4.1 6.3-9.6 6.3-15.3 0-12-9.7-21.7-21.7-21.7h-32.6l5.7-56.6c1.3-12.5-8.6-23.4-21.2-23.4z"
        }
    ]
};

const FalTransgender = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransgender",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32c8.8 0 16-7.2 16-16s-7.2-16-16-16H32c-8.8 0-16 7.2-16 16v112c0 8.8 7.2 16 16 16s16-7.2 16-16V54.6L89.4 96l-4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l4.7-4.7 13.2 13.2C106.8 157.9 96 189.7 96 224c0 83 63.1 151.2 144 159.2V416h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-32.8c80.9-8 144-76.2 144-159.2 0-34.3-10.8-66.1-29.2-92.2L464 54.6V128c0 8.8 7.2 16 16 16s16-7.2 16-16V16c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16s7.2 16 16 16h73.4l-75.6 75.6C337.1 80.6 298.5 64 256 64s-81.1 16.6-109.8 43.6L134.6 96l4.7-4.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-4.7 4.7L70.6 32H144zm112 64a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"
        }
    ]
};

const FalTransporter1 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransporter1",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm208 128c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16zM48 320c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16zm80 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm192-302.9V288h-32V176.2c-1.6-.2-3.1-.2-4.7-.2h-54.6c-1.6 0-3.2.1-4.7.2V288h-32v-94.9c-.5.6-1 1.3-1.5 1.9l-65.7 86.7c-5.3 7-15.4 8.4-22.4 3.1s-8.4-15.4-3.1-22.4l65.7-86.7c15.1-19.9 38.7-31.7 63.7-31.7h54.6c25 0 48.6 11.7 63.7 31.7l65.7 86.7c5.3 7 4 17.1-3.1 22.4s-17.1 4-22.4-3.1L321.5 195c-.5-.7-1-1.3-1.5-1.9zM176 320h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalTransporter2 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransporter2",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V64H16C7.2 64 0 56.8 0 48s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16s16 7.2 16 16zm416 320v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-16c0-8.8 7.2-16 16-16s16 7.2 16 16zM256 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM144 480c-8.8 0-16 7.2-16 16s-7.2 16-16 16-16-7.2-16-16c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16-7.2-16-16-16H144zm239.7-256h-40.2l-22-29c-.5-.7-1-1.3-1.5-1.9V224h-32v-47.8c-1.6-.2-3.1-.2-4.7-.2h-54.6c-1.6 0-3.2.1-4.7.2V224h-32v-30.9c-.5.6-1 1.3-1.5 1.9l-22 29h-40.2l36.7-48.3c15.1-19.9 38.7-31.7 63.7-31.7h54.6c25 0 48.6 11.7 63.7 31.7l36.7 48.3zM96 272c0-8.8 7.2-16 16-16h288c8.8 0 16 7.1 16 15.9v.2c0 8.8-7.2 15.9-16 15.9H112c-8.8 0-16-7.2-16-16zm64 64c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalTransporter3 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransporter3",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V16zM64 112c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-16zm192-80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM144 448c-26.5 0-48 21.5-48 48 0 8.8 7.2 16 16 16s16-7.2 16-16 7.2-16 16-16h224c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48H144zm16-304c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16h288c8.8 0 16-7.1 16-15.9v-.2c0-8.8-7.2-15.9-16-15.9H112c-8.8 0-16 7.2-16 16zm64 64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalTransporter4 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransporter4",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-48 64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm-32 64c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm64 64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm304-272c-8.8 0-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16zM48 352c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-16c0-8.8-7.2-16-16-16zm80 144c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalTransporter5 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransporter5",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 0c-8.8 0-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16zM48 128c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-16c0-8.8-7.2-16-16-16zM208 16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zm-48 128c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm64 128c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-32 96c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalTransporter6 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransporter6",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 0c-8.8 0-16 7.2-16 16v16H16C7.2 32 0 39.2 0 48s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H64V16c0-8.8-7.2-16-16-16zm416 352c-8.8 0-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16zM208 16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16zM96 272c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm32 224c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalTransporter7 = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransporter7",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V48zM64 272c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16c0 8.8 7.2 16 16 16s16-7.2 16-16v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H64v-16zm64 224c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s7.2 16 16 16 16-7.2 16-16c0-26.5-21.5-48-48-48H144c-26.5 0-48 21.5-48 48 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        }
    ]
};

const FalTransporterEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransporterEmpty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 480c-8.8 0-16 7.2-16 16s-7.2 16-16 16-16-7.2-16-16c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16-7.2-16-16-16H144z"
        }
    ]
};

const FalTransporter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTransporter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M464 0c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v16c0 8.8-7.2 16-16 16s-16-7.2-16-16V64h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V16c0-8.8 7.2-16 16-16zM48 64c8.8 0 16 7.2 16 16v16h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V80c0-8.8 7.2-16 16-16zm208 16a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM128 496c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.5 21.5-48 48-48h224c26.5 0 48 21.5 48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zm64-302.9c-.5.6-1 1.3-1.5 1.9l-65.7 86.7c-5.3 7-15.4 8.4-22.4 3.1s-8.4-15.4-3.1-22.4l65.7-86.7c15.1-19.9 38.7-31.7 63.7-31.7h54.6c25 0 48.6 11.7 63.7 31.7l65.7 86.7c5.3 7 4 17.1-3.1 22.4s-17.1 4-22.4-3.1L321.5 195c-.5-.7-1-1.3-1.5-1.9V416h-32v-96h-64v96h-32V193.1zm32-16.8V288h64V176.2c-1.6-.2-3.1-.2-4.7-.2h-54.6c-1.6 0-3.2.1-4.7.2z"
        }
    ]
};

const FalTrashArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-18.3l-25.5 356.6c-2.3 33.5-30.2 59.4-63.8 59.4H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.2L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96l25.3 354.3c1.2 16.7 15.1 29.7 31.9 29.7h200.8c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zM224 176c4.2 0 8.3 1.7 11.3 4.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 230.6V392c0 8.8-7.2 16-16 16s-16-7.2-16-16V230.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7z"
        }
    ]
};

const FalTrashCanArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCanArrowUp",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v336c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.1L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96v336c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V96H64zm160 80c4.2 0 8.3 1.7 11.3 4.7l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L240 230.6V392c0 8.8-7.2 16-16 16s-16-7.2-16-16V230.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l80-80c3-3 7.1-4.7 11.3-4.7z"
        }
    ]
};

const FalTrashCanCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCanCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v336c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.1L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96v336c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V96H64zm267.3 139.3-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7 116.7-116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalTrashCanClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCanClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v96.7c-11 1-21.7 3-32 5.9V96H64v336c0 26.5 21.5 48 48 48h184.2c10 12.1 21.7 22.9 34.6 32H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.1L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM336 176v44.5c-11.7 7.6-22.4 16.6-32 26.7V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm-192 0v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm192 304a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 64c8.8 0 16 7.2 16 16v48h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16v-64c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalTrashCanList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCanList",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.7 32h76.5c5.5 0 10.6 2.8 13.6 7.5L275.1 64H140.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zm143.2 32L287 22.6A47.98 47.98 0 0 0 246.3 0h-76.6c-16.5 0-31.9 8.5-40.7 22.6L103.1 64H16C7.2 64 0 71.2 0 80s7.2 16 16 16h16v336c0 44.2 35.8 80 80 80h192c44.2 0 80-35.8 80-80V96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-87.1zM352 96v336c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48V96h288zm-192 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16zm208-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H464zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16h128c8.8 0 16-7.2 16-16s-7.2-16-16-16H464zm-16 144c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalTrashCanPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCanPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v336c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.1L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96v336c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V96H64zm144 288v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalTrashCanSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCanSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-95.1L407 22.6A47.98 47.98 0 0 0 366.3 0h-92.6c-16.5 0-31.9 8.5-40.7 22.6L207.1 64h-27l40.5 32H480v204.8l32 25.2V96zm-39.6 361.9C463.9 471.2 449 480 432 480H208c-26.5 0-48-21.5-48-48V211.2L128 186v246c0 44.2 35.8 80 80 80h224c27.2 0 51.2-13.5 65.6-34.2l-25.2-19.9zM208 400c0 8.8 7.2 16 16 16s16-7.2 16-16V274.4l-32-25.3V400zm96 0c0 8.8 7.2 16 16 16s16-7.2 16-16v-49.8l-32-25.3V400zm96-162.4 32 25.3V176c0-8.8-7.2-16-16-16s-16 7.2-16 16v61.6zM260.2 39.5c2.9-4.7 8.1-7.5 13.6-7.5h92.5c5.5 0 10.6 2.8 13.6 7.5L395.1 64H244.9l15.3-24.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalTrashCanUndo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCanUndo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v336c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.1L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96v336c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V96H64zm155.9 93.3c5.9 6.6 5.4 16.7-1.2 22.6l-49 44.1H240c44.2 0 80 35.8 80 80v40c0 8.8-7.2 16-16 16s-16-7.2-16-16v-40c0-26.5-21.5-48-48-48h-70.3l49 44.1c6.6 5.9 7.1 16 1.2 22.6s-16 7.1-22.6 1.2l-80-72c-3.4-3-5.3-7.4-5.3-11.9s1.9-8.9 5.3-11.9l80-72c6.6-5.9 16.7-5.4 22.6 1.2z"
        }
    ]
};

const FalTrashCanXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCanXmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v336c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.1L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96v336c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V96H64zm84.7 116.7c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalTrashCan = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCan",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v336c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.1L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96v336c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V96H64zm80 80v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalTrashCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashCheck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-18.3l-25.5 356.6c-2.3 33.5-30.2 59.4-63.8 59.4H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.2L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96l25.3 354.3c1.2 16.7 15.1 29.7 31.9 29.7h200.8c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zm264.9 139.3-128 128c-6.2 6.2-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7 116.7-116.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"
        }
    ]
};

const FalTrashClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashClock",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zm159.2 32L311 22.6A47.98 47.98 0 0 0 270.3 0h-92.6c-16.5 0-31.9 8.5-40.7 22.6L111.1 64H16C7.2 64 0 71.2 0 80s7.2 16 16 16h18.3l25.5 356.6C62.1 486.1 90 512 123.6 512h200.8c2 0 4-.1 6-.3-12.7-9-24.2-19.7-34.2-31.7H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96h315.2L374 201.8c10.5-3.6 21.4-6.3 32.6-8l7-97.8H432c8.8 0 16-7.2 16-16s-7.2-16-16-16h-95.1zM432 256a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalTrashList = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashList",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h118.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-60.5c-5.5 0-10.6 2.8-13.6 7.5zM279 22.6 304.9 64H400c8.8 0 16 7.2 16 16s-7.2 16-16 16h-18.3l-25.5 356.6c-2.3 33.5-30.2 59.4-63.8 59.4H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.2L137 22.6A47.98 47.98 0 0 1 177.7 0h60.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96l25.3 354.3c1.2 16.7 15.1 29.7 31.9 29.7h168.8c16.8 0 30.7-13 31.9-29.7L349.6 96H66.4zM464 128h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 128h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H464c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16 144c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalTrashPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashPlus",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-18.3l-25.5 356.6c-2.3 33.5-30.2 59.4-63.8 59.4H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.2L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96l25.3 354.3c1.2 16.7 15.1 29.7 31.9 29.7h200.8c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zM208 384v-80h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-80v80c0 8.8-7.2 16-16 16s-16-7.2-16-16z"
        }
    ]
};

const FalTrashSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M509.7 96H528c8.8 0 16-7.2 16-16s-7.2-16-16-16h-95.1L407 22.6A47.98 47.98 0 0 0 366.3 0h-92.6c-16.5 0-31.9 8.5-40.7 22.6L207.1 64h-27l40.5 32h257l-13.7 192.1 30.4 24L509.7 96zm-56.8 346.5-.6 7.8c-1.2 16.7-15.1 29.7-31.9 29.7H219.6c-16.8 0-30.7-13-31.9-29.7l-16.5-230.2-34-26.8 18.5 259.3c2.4 33.5 30.3 59.4 63.8 59.4h200.9c29.1 0 54-19.5 61.6-46.6l-29.1-23zM273.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L395.1 64H244.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalTrashUndo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashUndo",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zm159.2 32L311 22.6A47.98 47.98 0 0 0 270.3 0h-92.6c-16.5 0-31.9 8.5-40.7 22.6L111.1 64H16C7.2 64 0 71.2 0 80s7.2 16 16 16h18.3l25.5 356.6C62.1 486.1 90 512 123.6 512h200.8c33.6 0 61.4-25.9 63.8-59.4L413.7 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16h-95.1zm44.8 32-25.4 354.3c-1.2 16.7-15.1 29.7-31.9 29.7H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96h315.2zm-161.8 93.3c-5.9-6.6-16-7.1-22.6-1.2l-80 72c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l80 72c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6l-49-44.1H240c26.5 0 48 21.5 48 48v40c0 8.8 7.2 16 16 16s16-7.2 16-16v-40c0-44.2-35.8-80-80-80h-70.3l49-44.1c6.6-5.9 7.1-16 1.2-22.6z"
        }
    ]
};

const FalTrashXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrashXmark",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.2 39.5 148.9 64h150.2l-15.3-24.5c-2.9-4.7-8.1-7.5-13.6-7.5h-92.5c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6 336.9 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16h-18.3l-25.5 356.6c-2.3 33.5-30.2 59.4-63.8 59.4H123.6c-33.6 0-61.4-25.9-63.8-59.4L34.3 96H16C7.2 96 0 88.8 0 80s7.2-16 16-16h95.2L137 22.6A47.98 47.98 0 0 1 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM66.4 96l25.3 354.3c1.2 16.7 15.1 29.7 31.9 29.7h200.8c16.8 0 30.7-13 31.9-29.7L381.6 96H66.4zm82.3 116.7c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 288l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 310.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalTrash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrash",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zm159.2 32L311 22.6A47.98 47.98 0 0 0 270.3 0h-92.6c-16.5 0-31.9 8.5-40.7 22.6L111.1 64H16C7.2 64 0 71.2 0 80s7.2 16 16 16h18.3l25.5 356.6C62.1 486.1 90 512 123.6 512h200.8c33.6 0 61.4-25.9 63.8-59.4L413.7 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16h-95.1zm44.8 32-25.4 354.3c-1.2 16.7-15.1 29.7-31.9 29.7H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96h315.2z"
        }
    ]
};

const FalTreasureChest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTreasureChest",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 64v192h64v-32c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32h64V64H128zm192 320h-64c-35.3 0-64-28.7-64-64v-32h-64v160h320V288h-64v32c0 35.3-28.7 64-64 64zM96 69.5C58.7 82.6 32 118.2 32 160v96h64V69.5zM32 288v144c0 8.8 7.2 16 16 16h48V288H32zm448 160h48c8.8 0 16-7.2 16-16V288h-64v160zm64-192v-96c0-41.8-26.7-77.4-64-90.5V256h64zM0 160C0 89.3 57.3 32 128 32h320c70.7 0 128 57.3 128 128v272c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V160zm320 32h-64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-16 48v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalTreeChristmas = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTreeChristmas",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M212.3 75c-1.6 4.3-5 7.7-9.4 9.4L171.8 96l31.2 11.7c4.3 1.6 7.7 5 9.4 9.4l11.6 31.1 11.7-31.2c1.6-4.3 5-7.7 9.4-9.4L276.2 96 245 84.3c-4.3-1.6-7.7-5-9.4-9.4L224 43.8 212.3 75zM224 0c10.7 0 20.2 6.6 24 16.6l15.1 40.3L303.4 72c10 3.7 16.6 13.3 16.6 24s-6.6 20.2-16.6 24l-40.3 15.1-15.1 40.3c-3.7 10-13.3 16.6-24 16.6s-20.2-6.6-24-16.6l-15.1-40.3-40.3-15.1c-10-3.7-16.6-13.3-16.6-24s6.6-20.2 16.6-24l40.3-15.1L200 16.6C203.8 6.6 213.3 0 224 0zM27.9 307.9l107-157.4 25.1 9.4 2.5 6.8L58.4 320h49.8c5.8 0 11.2 3.2 14 8.3s2.6 11.4-.6 16.3L35 480h378l-86.6-135.4c-3.2-4.9-3.4-11.2-.6-16.3s8.2-8.3 14-8.3h48.8L285.3 167.1l2.7-7.2 24.8-9.3 106.6 157.7c2.8 4.2 4.5 9 4.8 14 1 16.1-11.8 29.7-28 29.7h-27.1l74.4 116.3c2.9 4.6 4.5 9.9 4.5 15.3 0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6c0-5.4 1.6-10.7 4.5-15.3L78.9 352H51.3C35.7 352 23 339.4 23 323.8c0-5.7 1.7-11.2 4.9-15.9zM160 288a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm128 104a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalTreeCity = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTreeCity",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 32c-8.8 0-16 7.2-16 16v448c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-26.5 21.5-48 48-48h128c26.5 0 48 21.5 48 48v144h32v-80c0-8.8 7.2-16 16-16s16 7.2 16 16v80h16c26.5 0 48 21.5 48 48v256c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8-7.2-16-16-16h-96c-8.8 0-16-7.2-16-16V48c0-8.8-7.2-16-16-16H336zm48 32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32zm0 32v32h32V96h-32zm96 192c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32zm64 0h-32v32h32v-32zm-32 96h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32zm0 32v32h32v-32h-32zM352 224c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32zm64 0h-32v32h32v-32zm-32 96h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32zm0 32v32h32v-32h-32zM128 224c8.8 0 16 7.2 16 16v48h32c26.5 0 48-21.5 48-48 0-16-7.8-30.2-19.9-38.9l-8-5.8c-4.9-3.5-7.4-9.5-6.4-15.5l.4-2.6c1.1-6.7 1.9-11.9 1.9-17.2 0-35.3-28.7-64-64-64s-64 28.7-64 64c0 5.3.8 10.5 1.9 17.2l.4 2.6c.9 6-1.5 11.9-6.4 15.5l-8 5.8C39.8 209.8 32 224 32 240c0 26.5 21.5 48 48 48h32v-48c0-8.8 7.2-16 16-16zm-16 96H80c-44.2 0-80-35.8-80-80 0-26.7 13.1-50.3 33.2-64.9-.7-4.7-1.2-9.9-1.2-15.1 0-53 43-96 96-96s96 43 96 96c0 5.2-.5 10.4-1.2 15.1 20.1 14.6 33.2 38.2 33.2 64.9 0 44.2-35.8 80-80 80h-32v176c0 8.8-7.2 16-16 16s-16-7.2-16-16V320z"
        }
    ]
};

const FalTreeDeciduous = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTreeDeciduous",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M177.7 95.6c-.9 4.5-3.8 8.4-7.8 10.6s-8.8 2.7-13.1 1.2c-6.5-2.2-13.5-3.5-20.8-3.5-35.3 0-64 28.7-64 64 0 13.2 4 25.4 10.8 35.6 2.8 4.1 3.5 9.3 1.9 14s-5.2 8.4-9.9 10C49.9 236.3 32 260.1 32 288c0 35.3 28.7 64 64 64h144V144c0-8.8 7.2-16 16-16s16 7.2 16 16v208h144c35.3 0 64-28.7 64-64 0-27.9-17.9-51.7-42.8-60.4-4.7-1.6-8.3-5.3-9.9-10s-.9-9.9 1.9-14C436 193.4 440 181.2 440 168c0-35.3-28.7-64-64-64-7.3 0-14.3 1.2-20.8 3.5-4.3 1.5-9.1 1-13.1-1.2s-6.8-6.1-7.8-10.6C326.8 59.3 294.5 32 256 32s-70.8 27.3-78.3 63.6zM240 384H96c-53 0-96-43-96-96 0-35.3 19.1-66.2 47.5-82.8-4.8-11.4-7.5-24-7.5-37.2 0-53 43-96 96-96 5.1 0 10.1.4 14.9 1.2C166.7 30.4 207.8 0 256 0s89.3 30.4 105.1 73.2C366 72.4 371 72 376 72c53 0 96 43 96 96 0 13.2-2.7 25.7-7.5 37.2 28.4 16.6 47.5 47.5 47.5 82.8 0 53-43 96-96 96H272v112c0 8.8-7.2 16-16 16s-16-7.2-16-16V384z"
        }
    ]
};

const FalTreeDecorated = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTreeDecorated",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M236.4 5.9C233.3 2.2 228.8 0 224 0s-9.3 2.2-12.4 5.9L70.3 178.6c-4.1 5-6.3 11.2-6.3 17.6 0 15.4 12.4 27.8 27.8 27.8h18.9l-72.6 90.8c-3.9 4.9-6.1 11.1-6.1 17.4 0 15.3 12.5 27.8 27.8 27.8h21.3L5.2 467.6C1.8 472.4 0 478 0 483.9 0 499.4 12.6 512 28.1 512h391.8c15.5 0 28.1-12.6 28.1-28.1 0-5.8-1.8-11.5-5.2-16.2L366.9 360h21.3c15.4 0 27.8-12.5 27.8-27.8 0-6.3-2.2-12.5-6.1-17.4L337.3 224h18.9c15.4 0 27.8-12.4 27.8-27.8 0-6.4-2.2-12.6-6.3-17.6L236.4 5.9zm176 474.1H35.6l89.5-126.8c3.4-4.9 3.9-11.3 1.1-16.6S118 328 112 328H68.5l88-110c3.8-4.8 4.6-11.4 1.9-16.9s-8.3-9.1-14.4-9.1h-43.3L224 41.3 347.3 192H304c-6.2 0-11.8 3.5-14.4 9.1s-1.9 12.1 1.9 16.9l88 110H336c-6 0-11.5 3.3-14.2 8.6s-2.3 11.7 1.1 16.6L412.4 480zM184 312a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm80-152a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm24 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalTreeLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTreeLarge",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c4.8 0 9.3 2.2 12.4 5.9l141.3 172.7c4.1 5 6.3 11.2 6.3 17.6 0 15.3-12.4 27.8-27.8 27.8h-18.9l72.6 90.8c4 4.9 6.1 11.1 6.1 17.4 0 15.4-12.5 27.8-27.8 27.8h-21.3l76 107.6c3.4 4.7 5.2 10.4 5.2 16.2 0 15.5-12.6 28.1-28.1 28.1H28.1C12.6 512 0 499.4 0 483.9c0-5.8 1.8-11.5 5.2-16.2L81.1 360H59.8C44.5 360 32 347.5 32 332.2c0-6.3 2.2-12.5 6.1-17.4l72.6-90.8H91.8C76.4 224 64 211.6 64 196.2c0-6.4 2.2-12.6 6.3-17.6L211.6 5.9c3-3.7 7.6-5.9 12.4-5.9zm-64 480h252.4l-89.5-126.8c-3.4-4.9-3.9-11.3-1.1-16.6S330 328 336 328h43.5l-88-110c-3.8-4.8-4.6-11.4-1.9-16.9s8.3-9.1 14.4-9.1h43.3L224 41.3 100.7 192H144c6.2 0 11.8 3.5 14.4 9.1s1.9 12.1-1.9 16.9l-88 110H112c6 0 11.5 3.3 14.2 8.6s2.3 11.7-1.1 16.6L35.6 480H160z"
        }
    ]
};

const FalTreePalm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTreePalm",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M115.7 128c.7-.7 1.4-1.5 2.2-2.2 20.7-20.7 42.4-35.1 64.1-44.5 8.1-3.5 17.5.2 21 8.3s-.2 17.5-8.3 21c-17.7 7.7-36.1 19.7-54.1 37.8-3.6 3.6-6.9 7.1-10 10.7l-1.3 1.5c-51.1 60.1-42 123.1-21.3 156.1l136-136c3.2-3.2 7.5-4.9 12-4.7h176v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h78.1C532.8 135.5 490 80 400 80c-31.6 0-57.2 6.8-77.4 17.2-7.2 3.7-16 1.4-20.6-5.3-20.8-31-61-59.9-126-59.9-90 0-132.8 55.5-142.1 96h81.7zM544 208H341.1c8 23.6 15.1 49.1 21 75.4 14.3 64.4 21.4 135.3 15.4 200.1-1.6 16.5-15.6 28.5-31.6 28.5H245.8c-21.7 0-36.7-21-30.8-41.3 27.4-94.3 34-166.1 30.8-216.1-.6-10-1.7-19.1-3-27.4L129.1 340.8c-11.8 11.8-34.2 13.9-46-3.3-26.8-39.6-38.5-110 6.5-177.5H32c-16.7 0-34-14.3-30.1-34.9C12.3 70.1 67.6 0 176 0c68.6 0 116.2 28.1 144.4 63 22.6-9.4 49.1-15 79.6-15 108.4 0 163.7 70.1 174.1 125.1C578 193.7 560.7 208 544 208zm-272.3 0c2.8 13 4.9 27.8 5.9 44.5 3.5 54.5-3.8 130-32 227.1v.2s0 .1.1.2h99.9c5.5-60.6-1.1-127.9-14.8-189.7-6.5-29.4-14.6-57.2-23.7-82.3h-35.4z"
        }
    ]
};

const FalTree = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTree",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L72 145.4c-5.1 5.1-8 12.1-8 19.3 0 15.1 12.2 27.3 27.3 27.3h17.9l-70.5 82.3c-4.3 5-6.7 11.4-6.7 18 0 15.3 12.4 27.7 27.7 27.7h17.5L6.7 402.3c-4.3 5-6.7 11.4-6.7 18C0 435.6 12.4 448 27.7 448H208v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h180.3c15.3 0 27.7-12.4 27.7-27.7 0-6.6-2.4-13-6.7-18L370.8 320h17.5c15.3 0 27.7-12.4 27.7-27.7 0-6.6-2.4-13-6.7-18L338.8 192h17.9c15.1 0 27.3-12.2 27.3-27.3 0-7.2-2.9-14.2-8-19.3L235.3 4.7zM240 416V208c0-8.8-7.2-16-16-16s-16 7.2-16 16v208H37.1l87.1-101.6c4.1-4.7 5-11.4 2.4-17.1s-8.3-9.3-14.5-9.3h-43l87.1-101.6c4.1-4.7 5-11.4 2.4-17.1s-8.3-9.3-14.5-9.3h-41.5L224 38.6 345.4 160H304c-6.2 0-11.9 3.6-14.5 9.3s-1.7 12.4 2.4 17.1l87 101.6H336c-6.2 0-11.9 3.6-14.5 9.3s-1.7 12.4 2.4 17.1l87 101.6H240z"
        }
    ]
};

const FalTrees = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrees",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M167.6 11.9c12.8-15 35.9-15 48.7 0l102.2 119.9c4.1 4.8 6.4 11 6.4 17.4 0 14.8-12 26.8-26.8 26.8h-12l61.4 67.4c4.5 4.9 7 11.3 7 17.9 0 14.7-11.9 26.6-26.6 26.6h-15.2l65.6 84.4c3.7 4.9 5.7 10.7 5.7 16.7 0 14.9-12.1 27-27 27H208v80c0 8.8-7.2 16-16 16s-16-7.2-16-16v-80H27c-14.9 0-27-12.1-27-27 0-6 2-11.8 5.7-16.6L71.3 288H56.2c-14.7 0-26.6-11.9-26.6-26.6 0-6.6 2.5-13 7-17.9L97.9 176h-12c-14.8 0-26.8-12-26.8-26.8 0-6.4 2.3-12.5 6.4-17.4L167.6 11.9zM235.1 384h111.7l-79.4-102.2c-3.7-4.8-4.4-11.4-1.7-16.9s8.3-9 14.4-9h35.7L238 170.8c-4.3-4.7-5.4-11.4-2.8-17.2s8.3-9.5 14.6-9.5h37L192 32.7 97.1 144h37c6.3 0 12.1 3.7 14.6 9.5s1.5 12.6-2.8 17.2L68.3 256H104c6.1 0 11.7 3.5 14.4 9s2 12-1.7 16.9L37.2 384H176V208c0-8.8 7.2-16 16-16s16 7.2 16 16v176h27.1zM423.5 12.6c12.7-15.4 36.2-15.6 49.1-.4l102 119.7c4.1 4.8 6.4 11 6.4 17.4 0 14.8-12 26.8-26.8 26.8h-12.1l61.4 67.4c4.5 4.9 7 11.3 7 17.9 0 14.7-11.9 26.6-26.6 26.6h-15.2l65.6 84.4c3.7 4.8 5.7 10.6 5.7 16.6 0 14.9-12.1 27-27 27H464v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16s16 7.2 16 16v176h138.8l-79.4-102.2c-3.8-4.8-4.4-11.4-1.7-16.9s8.3-9 14.4-9h35.7L494 170.8c-4.3-4.7-5.4-11.4-2.8-17.2s8.3-9.5 14.6-9.5h37L448.2 32.9 388 106.2c-5.6 6.8-15.7 7.8-22.5 2.2s-7.8-15.7-2.2-22.5l60.2-73.2z"
        }
    ]
};

const FalTriangleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTriangleExclamation",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M34.5 420.4c-1.6 2.8-2.5 6-2.5 9.3 0 10.2 8.2 18.4 18.4 18.4h411.2c10.2 0 18.4-8.2 18.4-18.4 0-3.3-.9-6.4-2.5-9.3l-201-344.6C272.2 68.5 264.4 64 256 64s-16.2 4.5-20.5 11.8l-201 344.6zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4 0 27.8-22.6 50.4-50.4 50.4H50.4C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zm-24 224a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalTriangleInstrument = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTriangleInstrument",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v49.4c-24.6 4.4-46.5 19-60.1 40.5L46.5 367.7C37 382.8 32 400.2 32 418c0 51.9 42.1 94 94 94h324c51.9 0 94-42.1 94-94 0-17.8-5-35.2-14.5-50.2l-85.7-135.7-23.2 23.2 81.8 129.5c6.3 9.9 9.6 21.4 9.6 33.1 0 34.3-27.8 62-62 62H126c-34.3 0-62-27.8-62-62 0-11.7 3.3-23.2 9.6-33.1l165.3-261.7C249.5 106.2 268.1 96 288 96s38.5 10.2 49.1 27.1l48.5 76.8-65.1 65.1c-9.5-5.6-20.6-8.9-32.5-8.9-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64c0-11.9-3.2-23-8.9-32.5l59.9-59.9 23.2-23.2 113-113c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L408.8 176.6 364.1 106c-13.6-21.6-35.5-36.1-60.1-40.6V16zm16 304a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FalTrianglePersonDigging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrianglePersonDigging",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 32c2.8 0 5.4 1.4 6.8 3.8l264.5 432c1.5 2.5 1.6 5.6.2 8.1s-4.1 4.1-7 4.1H56c-2.9 0-5.6-1.6-7-4.1s-1.4-5.6.2-8.1l264-432c1.5-2.4 4-3.8 6.8-3.8zm34.1-12.9C346.8 7.2 333.9 0 320 0s-26.9 7.3-34.1 19.1l-264 432c-7.5 12.3-7.8 27.8-.8 40.4S41.5 512 56 512h528.5c14.5 0 27.8-7.8 34.9-20.4s6.8-28.1-.8-40.4L354.1 19.1zM312 224a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-37 48c9.9 0 18.6 6.6 21.2 16.2l5.9 21.8-46.5-26.8 1.8-2.4c4.2-5.5 10.7-8.8 17.6-8.8zm66.5 60.7-14.4-52.9c-6.4-23.5-27.8-39.8-52.1-39.8-17 0-33 8-43.2 21.6l-12.6 16.8c-2.7 3.7-3.8 8.3-2.9 12.8s3.7 8.4 7.7 10.6l155.9 89.9-9.6 16c-3 4.9-3 11.1-.2 16.1s8.2 8.1 13.9 8.1h96c5.8 0 11.1-3.1 13.9-8.1s2.8-11.2-.2-16.1l-48-80c-2.9-4.8-8.1-7.8-13.7-7.8s-10.8 2.9-13.7 7.8l-21.9 36.6-54.8-31.6zm-124.6-12-7.5 16.8-32 72c-3.6 8.1 0 17.5 8.1 21.1s17.5 0 21.1-8.1l24.5-55.2 40.9 25.6V416c0 8.8 7.2 16 16 16s16-7.2 16-16v-32c0-5.5-2.8-10.6-7.5-13.6l-64-40-15.6-9.8zM451.7 400h-39.4l19.7-32.9 19.7 32.9z"
        }
    ]
};

const FalTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTriangle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M235.5 75.8c4.2-7.3 12-11.8 20.5-11.8s16.2 4.5 20.5 11.8l201 344.6c1.6 2.8 2.5 6 2.5 9.3 0 10.2-8.2 18.4-18.4 18.4H50.4C40.2 448 32 439.8 32 429.6c0-3.3.9-6.4 2.5-9.3l201-344.6zm-27.6-16.2L6.9 404.2C2.4 411.9 0 420.7 0 429.6 0 457.4 22.6 480 50.4 480h411.2c27.8 0 50.4-22.6 50.4-50.4 0-8.9-2.4-17.7-6.9-25.4l-201-344.6C294.1 42.5 275.8 32 256 32s-38.1 10.5-48.1 27.6z"
        }
    ]
};

const FalTricycleAdult = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTricycleAdult",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h39c5.3 0 10.3 2.6 13.3 7L440 226.7l-53.2 70.9c-6.8 9-17.4 14.3-28.7 14.3-2.8 0-5.6-.3-8.3-1L19.7 232.4c-8.6-2-17.2 3.3-19.3 11.9s3.3 17.2 11.9 19.3l31.9 7.6C17.6 288.2 0 318.1 0 352c0 53 43 96 96 96 18 0 34.8-4.9 49.1-13.5-.4.2-.8.5-1.1.7 14.1 8.2 30.5 12.8 48 12.8 53 0 96-43 96-96 0-8.1-1-16-2.9-23.5l57.3 13.6c5.1 1.2 10.4 1.8 15.7 1.8 21.4 0 41.5-10.1 54.3-27.1l46.6-62.1 18.8 27.8C459.4 300 448 324.7 448 352c0 53 43 96 96 96s96-43 96-96-43-96-96-96c-14.2 0-27.7 3.1-39.8 8.6L382.8 85.1C373.8 71.9 359 64 343 64h-39zm176 288c0-16.2 6.1-31.1 16-42.4l34.8 51.4c5 7.3 14.9 9.2 22.2 4.3s9.2-14.9 4.3-22.2l-34.7-51.3c6.7-2.4 13.9-3.7 21.5-3.7 35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64zm-232.9-32.5c5.6 9.5 8.9 20.6 8.9 32.5 0 35.3-28.7 64-64 64-7.5 0-14.7-1.3-21.3-3.6C184 395.9 192 374.9 192 352c0-17.8-4.9-34.5-13.3-48.8l68.5 16.3zM62.9 106.1c-3.3-8.2-12.6-12.2-20.8-8.9s-12.2 12.6-8.9 20.8l23.3 58.3c7.3 18.3 22.6 32.1 41.4 37.7l89.6 26.2c8.5 2.5 17.4-2.4 19.9-10.9s-2.4-17.4-10.9-19.8l-89.6-26.2c-9.4-2.8-17.1-9.7-20.7-18.8l-23.3-58.4zM94.4 416c-34.6-.9-62.4-29.2-62.4-64 0-35.3 28.7-64 64-64s64 28.7 64 64-28.7 64-64 64"
        }
    ]
};

const FalTricycle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTricycle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.3c14.8 0 26.7 11.9 26.7 26.7 0 8.4-4 16.3-10.7 21.3l-42.7 32h-27.2c-58.4 0-113.2 24.5-152.1 66.1L117.9 160H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h31.4l51 76.5c-2.7 4-5.2 8.1-7.6 12.3l-4.2 7.4c-2.2-.1-4.4-.2-6.6-.2C50.1 256 0 306.1 0 368s50.1 112 112 112 112-50.1 112-112c0-48-30.1-88.9-72.5-104.8 31.5-54 89.3-87.2 151.9-87.2h20.1l14.2 56.6c-47.8 18.6-81.7 65-81.7 119.4 0 70.7 57.3 128 128 128s128-57.3 128-128-57.3-128-128-128c-5.2 0-10.3.3-15.3.9l-14.6-58.5 38.4-28.8c14.8-11.1 23.5-28.5 23.5-46.9 0-32.4-26.3-58.7-58.7-58.7H272zm73.5 232 23 91.9c2.1 8.6 10.8 13.8 19.4 11.6s13.8-10.8 11.6-19.4l-23-91.8c2.5-.2 4.9-.3 7.4-.3 53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-39.3 23.7-73.1 57.5-88zM112 288a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FalTrillium = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrillium",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M203.3 8.2c11.8-11 29.8-11 41.5 0C256.9 19.5 277.9 40.7 296 67c17.9 26 34.2 58.9 34.2 93.4 0 9.3-1.2 18.4-3.5 27 10.5 2.3 20.8 6.1 30.5 11.7 29.9 17.2 50.4 47.6 64.2 75.9 13.9 28.7 21.9 57.3 25.7 73.5 3.8 15.8-5.4 31.5-20.9 36.1-16 4.8-44.9 12.2-76.8 14.6-31.5 2.3-68.3-.1-98.2-17.2-10.5-6-19.6-13.6-27.1-22.2-7.5 8.7-16.6 16.2-27.1 22.2-29.9 17.2-66.7 19.6-98.2 17.2-31.9-2.4-60.9-9.8-76.8-14.6C6.3 380-2.9 364.4.8 348.5c3.8-16.2 11.8-44.8 25.7-73.5 13.7-28.3 34.2-58.8 64.2-75.9 9.8-5.6 20.1-9.5 30.6-11.7-2.3-8.6-3.5-17.7-3.5-27C117.8 126 134.2 93 152 67c18.1-26.3 39.1-47.5 51.2-58.8zM224 32.6c-11.4 10.7-29.8 29.6-45.6 52.5-16.5 24-28.6 50.4-28.6 75.2 0 12 2.9 23.3 8.1 33.3 2.6 5 2.4 10.9-.6 15.7s-8.1 7.7-13.7 7.7c-12.6 0-25.4 3.2-37 9.9C84.9 239.4 68 263 55.3 289c-12 25-19.3 50.2-23 65.4 15.1 4.4 40.8 10.9 68.7 12.9 29.1 2.2 58.2-.6 79.9-13.1 12.8-7.3 22.6-17.9 28.8-30.1 2.7-5.3 8.2-8.7 14.2-8.7s11.5 3.3 14.2 8.7c6.3 12.2 16 22.7 28.8 30.1 21.7 12.5 50.8 15.2 79.9 13.1 27.8-2.1 53.6-8.5 68.7-12.9-3.7-15.2-10.9-40.5-23-65.4-12.6-26.1-29.6-49.7-51.3-62.1-11.6-6.7-24.4-9.8-36.9-9.9-5.6 0-10.8-2.9-13.7-7.7s-3.1-10.7-.6-15.7c5.2-10 8.1-21.3 8.1-33.3 0-24.9-12.1-51.3-28.6-75.2-15.6-22.8-34.1-41.7-45.5-52.5zm0 183.4a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm56 24a56 56 0 1 1-112 0 56 56 0 1 1 112 0zm-6.2 183.2c-8.2 35.9-22.6 61.3-30.9 73.9-9.1 13.7-28.8 13.7-37.9 0-8.3-12.5-22.7-38-30.9-73.9 10.3-3.1 20.4-7.2 30-12.5 4.8 24 12.9 42.9 19.8 55.7 6.9-12.9 15-31.7 19.8-55.7 9.7 5.3 19.8 9.4 30 12.5zM9.9 105.4c14.7-1.9 44.2-2.8 82.7 10-2.6 10.4-4.2 21.2-4.5 32.3-25.6-9.3-46.4-11.4-60.4-11.3 6.4 11.1 17.2 26.4 35 42.3-9.1 6.1-17.4 13.1-24.9 20.6-27.4-25.7-40.3-50-45.8-63-5.8-13.8 3-29.1 17.9-31zm375.4 73.3c17.8-16 28.7-31.2 35.1-42.4-14 0-34.9 2.1-60.4 11.3-.3-11.1-2-21.9-4.5-32.3 38.5-12.8 68-11.8 82.7-10 14.9 1.9 23.7 17.1 17.9 31-5.5 13-18.4 37.4-45.9 63-7.5-7.6-15.7-14.6-24.9-20.6z"
        }
    ]
};

const FalTrophyStar = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrophyStar",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M400 32H176c-9 0-15.4 7.3-15.1 15 6.2 163.9 44.9 239.2 76.1 273.5 15.5 17.1 29.9 24.8 39.3 28.3 4.8 1.8 8.5 2.6 10.6 3 .5.1.9.1 1.2.2.3 0 .7-.1 1.2-.2 2.1-.3 5.8-1.1 10.6-3 9.4-3.5 23.8-11.3 39.3-28.3C370.4 286.3 409 210.9 415.3 47c.3-7.8-6.2-15-15.1-15zM176 0h224c26.5 0 48.1 21.8 47.1 48.2-.2 5.3-.4 10.6-.7 15.8H528c26 0 49.3 21.6 46.2 49.7-10.1 94-61.9 158.2-118.1 199.9-55.9 41.4-117.1 61.3-149.3 66.9l-.1-.3c-.9.3-1.8.6-2.7.8v99h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h96v-98.9c-.9-.3-1.8-.5-2.7-.8l-.1.3c-32.2-5.7-93.4-25.5-149.3-66.9-56.2-41.7-108-106-118.1-200C-1.3 85.6 22 64 48 64h81.6c-.3-5.2-.5-10.4-.7-15.8C127.9 21.8 149.5 0 176 0zm201.8 323.2c19.2-9.1 39.6-20.7 59.2-35.3 51.1-37.9 96.4-94.8 105.4-177.6.8-7-5.1-14.3-14.4-14.3h-83.8c-9.8 116.5-37.2 185.9-66.4 227.2zM131.8 96H48c-9.3 0-15.2 7.3-14.4 14.3 8.9 82.9 54.3 139.8 105.4 177.6 19.6 14.6 40 26.2 59.2 35.3C169 281.9 141.5 212.5 131.8 96zm177.8-.5 12.5 25.5 28.2 4.1c19.7 2.9 27.5 27.1 13.3 40.9l-20.4 19.9L348 214c3.4 19.6-17.2 34.6-34.8 25.3L288 226.1l-25.2 13.3c-17.6 9.3-38.2-5.7-34.8-25.3l4.8-28.1-20.4-19.9c-14.2-13.9-6.4-38.1 13.3-40.9l28.2-4.1 12.6-25.6c8.8-17.8 34.2-17.8 43 0zM280.8 139c-3.5 7.1-10.3 12-18.1 13.1l-16.3 2.4 11.7 11.5c5.7 5.5 8.2 13.5 6.9 21.2l-2.8 16.3 14.6-7.7c7-3.7 15.3-3.7 22.3 0l14.6 7.7-2.7-16.3c-1.3-7.8 1.2-15.7 6.9-21.2l11.8-11.5-16.3-2.4c-7.8-1.1-14.6-6-18.1-13.1l-7.3-14.8-7.3 14.8z"
        }
    ]
};

const FalTrophy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrophy",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32h224c9 0 15.4 7.3 15.1 15-6.2 163.9-44.9 239.2-76.1 273.5-15.5 17.1-29.9 24.8-39.3 28.3-4.8 1.8-8.5 2.6-10.6 3-.5.1-.9.1-1.2.2-.3 0-.7-.1-1.2-.2-2.1-.3-5.8-1.1-10.6-3-9.4-3.5-23.8-11.3-39.3-28.3-31-34.3-69.7-109.6-75.9-273.5-.3-7.8 6.2-15 15.1-15zM400 0H176c-26.5 0-48.1 21.8-47.1 48.2.2 5.3.4 10.6.7 15.8H48C22 64-1.3 85.6 1.8 113.7c10.1 94 61.9 158.2 118.1 199.9 55.9 41.4 117.1 61.3 149.3 66.9l.1-.3c.9.3 1.8.6 2.7.8v99h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96v-98.9c.9-.3 1.8-.5 2.7-.8l.1.3c32.2-5.7 93.4-25.5 149.3-66.9 56.2-41.7 108-105.9 118.1-199.9C577.3 85.6 554 64 528 64h-81.6c.3-5.2.5-10.4.7-15.8C448.1 21.8 426.5 0 400 0zm44.2 96H528c9.3 0 15.2 7.3 14.4 14.3-8.9 82.9-54.3 139.8-105.4 177.6-19.6 14.6-40 26.2-59.2 35.3C407 281.9 434.5 212.5 444.2 96zm-246 227.2c-19.2-9.1-39.6-20.7-59.2-35.3-51.1-37.8-96.5-94.7-105.4-177.6-.8-7 5.1-14.3 14.4-14.3h83.8c9.8 116.5 37.2 185.9 66.4 227.2z"
        }
    ]
};

const FalTrowelBricks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrowelBricks",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m32 128 192-96v192L32 128zm224-96c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-192 96C6.8 104.8 0 115.9 0 128s6.8 23.2 17.7 28.6l192 96c9.9 5 21.7 4.4 31.1-1.4S256 235.1 256 224v-80h88c0 17.7 14.3 32 32 32h88c26.5 0 48-21.5 48-48s-21.5-48-48-48h-88c-17.7 0-32 14.3-32 32h-88V32zm208 80c8.8 0 16 7.2 16 16s-7.2 16-16 16h-88v-32h88zM288 384h192v96H256v-96h32zm-64 0v96H32v-96h192zm256-32H320v-96h160v96zm-192-96v96H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32z"
        }
    ]
};

const FalTrowel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrowel",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M491.8 20.2c26.9 26.9 26.9 70.5 0 97.5l-95.4 95.4c-14.6 14.6-38.2 14.6-52.8 0l-11-11-102 102 75.5 75.5c12.6 12.6 7.5 34.1-9.4 39.7L36.2 506.1c-18.7 6.3-36.6-11.6-30.3-30.3l86.8-260.6c5.6-16.9 27.1-22 39.7-9.4l75.6 75.6 102-102-11-11c-14.6-14.6-14.6-38.2 0-52.8l95.4-95.4c26.9-26.9 70.5-26.9 97.5 0zm-170.2 118c-2.1 2.1-2.1 5.5 0 7.5l44.7 44.7c2.1 2.1 5.5 2.1 7.5 0L469.2 95c14.4-14.4 14.4-37.8 0-52.2s-37.8-14.4-52.2 0l-95.4 95.4zM41.3 470.7 274.4 393 119 237.6 41.3 470.7z"
        }
    ]
};

const FalTruckArrowRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckArrowRight",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32c17.7 0 32 14.3 32 32v320H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h288zM0 352c0 35.3 28.7 64 64 64 0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8c-9.1-10.7-22.4-16.8-36.4-16.8H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288zm481.3-224c4.7 0 9.1 2 12.1 5.6l77.5 90.4H416v-96h65.3zM416 344.4V256h160v128h-5.5c-13.2-37.3-48.7-64-90.5-64-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM235.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l52.7 52.7H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h153.4l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6l-80-80z"
        }
    ]
};

const FalTruckBolt = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckBolt",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32c17.7 0 32 14.3 32 32v320H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h288zM0 352c0 35.3 28.7 64 64 64 0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8c-9.1-10.7-22.4-16.8-36.4-16.8H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288zm416-224h65.3c4.7 0 9.1 2 12.1 5.6l77.5 90.4H416v-96zm0 216.4V256h160v128h-5.5c-13.2-37.3-48.7-64-90.5-64-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM251.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-4.6 4.6-5.9 11.5-3.5 17.4s8.3 9.9 14.8 9.9h89.4l-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96c4.6-4.6 5.9-11.5 3.5-17.4s-8.3-9.9-14.8-9.9h-89.4l68.7-68.7z"
        }
    ]
};

const FalTruckClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H384V64c0-17.7-14.3-32-32-32H64zm0 384c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v32h65.3c14 0 27.3 6.1 36.4 16.8l78.7 91.8c7.5 8.7 11.6 19.8 11.6 31.2V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96zm352-288v96h154.9l-77.5-90.4c-3-3.5-7.5-5.6-12.1-5.6H416zm0 128v88.4c17-15.2 39.4-24.4 64-24.4 41.8 0 77.4 26.7 90.5 64h5.5V256H416zM224 416a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM208 256a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm0-192a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm16 64v32h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalTruckContainerEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckContainerEmpty",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 160c0-17.7 14.3-32 32-32h56c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8V360c0 19.4-13.7 35.5-32 39.2v.8c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32 32.8 0 61 19.7 73.3 48H448V160zm144 64-43.2-57.6c-3-4-7.8-6.4-12.8-6.4h-56v64h112zm16 32H480v80c13.4-10 30-16 48-16 32.8 0 60.9 19.7 73.3 47.9 3.8-.6 6.7-3.9 6.7-7.9V256zm-80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-272-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalTruckContainer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckContainer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32h288c35.3 0 64 28.7 64 64v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-17.7-14.3-32-32-32H64c-17.7 0-32 14.3-32 32v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-35.3 28.7-64 64-64zm384 128c0-17.7 14.3-32 32-32h56c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8V360c0 19.4-13.7 35.5-32 39.2v.8c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80s35.8-80 80-80c26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32 32.8 0 61 19.7 73.3 48H448V160zm144 64-43.2-57.6c-3-4-7.8-6.4-12.8-6.4h-56v64h112zm16 32H480v80c13.4-10 30-16 48-16 32.8 0 60.9 19.7 73.3 47.9 3.8-.6 6.7-3.9 6.7-7.9V256zM112 96c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm96 0c8.8 0 16 7.2 16 16v160c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm224 352a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-272-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalTruckDroplet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckDroplet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32c17.7 0 32 14.3 32 32v320H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h288zM0 352c0 35.3 28.7 64 64 64 0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8c-9.1-10.7-22.4-16.8-36.4-16.8H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288zm416-224h65.3c4.7 0 9.1 2 12.1 5.6l77.5 90.4H416v-96zm0 216.4V256h160v128h-5.5c-13.2-37.3-48.7-64-90.5-64-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM256 211c0 23.7-20.3 45-48 45s-48-21.3-48-45c0-1.7.9-7.2 5-17.4 3.9-9.5 9.5-20.4 16.1-32.1 8.5-14.8 18.1-29.7 26.8-42.6 8.7 12.8 18.4 27.8 26.8 42.6 6.7 11.6 12.3 22.6 16.1 32.1 4.1 10.2 5 15.7 5 17.4zm32 0c0-32-45.2-98.9-67.6-130.2-6.1-8.6-18.6-8.6-24.8 0C173.2 112.1 128 179 128 211c0 42.5 35.8 77 80 77s80-34.5 80-77z"
        }
    ]
};

const FalTruckFast = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckFast",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32h224c17.7 0 32 14.3 32 32v320H250.5c-13.2-37.3-48.7-64-90.5-64-24.6 0-47 9.2-64 24.4V288H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8c-9.1-10.7-22.4-16.8-36.4-16.8H416V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v32H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V64c0-17.7 14.3-32 32-32zm442.9 192H416v-96h65.3c4.7 0 9.1 2 12.1 5.6l77.5 90.4zM416 256h160v128h-5.5c-13.2-37.3-48.7-64-90.5-64-24.6 0-47 9.2-64 24.4V256zM96 416a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM48 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H48zm-32 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalTruckFieldUn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckFieldUn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c-17.7 0-32 14.3-32 32v256h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H352V96c0-17.7-14.3-32-32-32H96zM0 160c0-17.7 14.3-32 32-32V96c0-35.3 28.7-64 64-64h224c32.6 0 59.6 24.4 63.5 56h53.4c17.7 0 33.9 9.7 42.3 25.2l42.4 78.8H544c35.3 0 64 28.7 64 64v96h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16v-64c-17.7 0-32-14.3-32-32v-96zm384-40v72h101.2L451 128.4c-2.8-5.2-8.2-8.4-14.1-8.4H384zm0 232h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64h5.5v-96c0-17.7-14.3-32-32-32H384v128zM253.3 135.1l34.7 52V144c0-8.8 7.2-16 16-16s16 7.2 16 16v96c0 7.1-4.6 13.3-11.4 15.3s-14-.6-17.9-6.4l-34.7-52V240c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-7.1 4.6-13.3 11.4-15.3s14 .6 17.9 6.4zM128 144v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 26.5-21.5 48-48 48s-48-21.5-48-48v-64c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 240a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FalTruckField = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckField",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 64c17.7 0 32 14.3 32 32v256H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64V96c0-17.7 14.3-32 32-32h224zM32 128c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32v64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-96c0-35.3-28.7-64-64-64h-22.4l-42.4-78.8C470.8 97.7 454.5 88 436.9 88h-53.4c-3.9-31.6-30.9-56-63.5-56H96c-35.3 0-64 28.7-64 64v32zm352 64v-72h52.9c5.9 0 11.3 3.2 14.1 8.4l34.2 63.6H384zm5.5 160H384V224h160c17.7 0 32 14.3 32 32v96h-5.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64zM96 384a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FalTruckFlatbed = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckFlatbed",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 96c-13.3 0-24 10.7-24 24v264H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8c-9.1-10.7-22.4-16.8-36.4-16.8H408zm8 160h160v128h-5.5c-13.2-37.3-48.7-64-90.5-64-24.6 0-47 9.2-64 24.4V256zm154.9-32H416v-96h65.3c4.7 0 9.1 2 12.1 5.6l77.5 90.4zM96 416a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm384-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FalTruckFront = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckFront",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32c-26.5 0-48 21.5-48 48v168.4c10.8-9.7 23.9-17 38.3-21l31.3-88.8c9-25.6 33.2-42.7 60.4-42.7h188c27.1 0 51.3 17.1 60.4 42.7l31.3 88.8c14.4 4 27.4 11.3 38.3 21V80c0-26.5-21.5-48-48-48H80zM32 320v48c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-48c0-35.3-28.7-64-64-64H96c-35.3 0-64 28.7-64 64zm-32 0V80C0 35.8 35.8 0 80 0h352c44.2 0 80 35.8 80 80v288c0 26.2-12.6 49.4-32 64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-49.6c-5.2 1-10.5 1.6-16 1.6H80c-5.5 0-10.8-.6-16-1.6V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c-19.4-14.6-32-37.8-32-64v-48zm105.4-96h301.2l-26.3-74.7c-4.6-12.7-16.7-21.3-30.3-21.3H162c-13.6 0-25.7 8.6-30.2 21.3L105.4 224zM80 328a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm328-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalTruckMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckMedical",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 32c17.7 0 32 14.3 32 32v320H250.5c-13.2-37.3-48.7-64-90.5-64s-77.4 26.7-90.5 64H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h288zM0 352c0 35.3 28.7 64 64 64 0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V235.8c0-11.5-4.1-22.5-11.6-31.2l-78.7-91.8c-9.1-10.7-22.4-16.8-36.4-16.8H416V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v288zm416-224h65.3c4.7 0 9.1 2 12.1 5.6l77.5 90.4H416v-96zm0 216.4V256h160v128h-5.5c-13.2-37.3-48.7-64-90.5-64-24.6 0-47 9.2-64 24.4zM160 352a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zM192 64c-17.7 0-32 14.3-32 32v32h-32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32h32v32c0 17.7 14.3 32 32 32h32c17.7 0 32-14.3 32-32v-32h32c17.7 0 32-14.3 32-32v-32c0-17.7-14.3-32-32-32h-32V96c0-17.7-14.3-32-32-32h-32zm0 32h32v48c0 8.8 7.2 16 16 16h48v32h-48c-8.8 0-16 7.2-16 16v48h-32v-48c0-8.8-7.2-16-16-16h-48v-32h48c4.2 0 8.3-1.7 11.3-4.7s4.7-7.1 4.7-11.3V96z"
        }
    ]
};

const FalTruckMonster = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckMonster",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M264 32c-4.4 0-8 3.6-8 8v88h206.4l-73.2-90.1c-3-3.7-7.6-5.9-12.4-5.9H264zM96 128h128V40c0-22.1 17.9-40 40-40h112.8c14.5 0 28.1 6.5 37.3 17.7L503.6 128H544c35.3 0 64 28.7 64 64v48h-1c4.4 3.9 8.6 8 12.6 12.2 6.1 6.4 5.8 16.6-.7 22.6s-16.6 5.8-22.6-.7C567.2 243.3 525.8 224 480 224c-56.2 0-105.6 28.9-134.1 72.7-3 4.5-8 7.3-13.4 7.3h-25c-5.4 0-10.4-2.7-13.4-7.3C265.6 252.9 216.2 224 160 224c-45.8 0-87.2 19.3-116.4 50.2-6.1 6.4-16.2 6.7-22.6.7s-6.7-16.2-.7-22.6c3.7-3.9 7.6-7.7 11.6-11.3v-49c0-35.3 28.7-64 64-64zm-32 89.7c28.2-16.3 61-25.7 96-25.7 64.3 0 121.1 31.6 156 80h8c34.8-48.4 91.7-80 156-80 35 0 67.8 9.4 96 25.7V192c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v25.7zm90 54.3c-3.9 0-7.1 2.7-7.8 6.4-1.2 5.8-5.5 10.5-11.2 12.2-6.2 1.8-12.1 4.3-17.7 7.3-5.2 2.9-11.6 2.6-16.5-.7-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1 3.3 5 3.6 11.3.7 16.5-3 5.6-5.5 11.5-7.3 17.7-1.7 5.7-6.4 10-12.2 11.2-3.6.7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8 5.8 1.2 10.5 5.5 12.2 11.2 1.8 6.2 4.3 12.1 7.3 17.7 2.9 5.2 2.6 11.6-.7 16.5-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1 5-3.3 11.3-3.6 16.5-.7 5.6 3 11.5 5.5 17.7 7.3 5.7 1.7 10 6.4 11.2 12.2.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4 1.2-5.8 5.5-10.5 11.2-12.2 6.2-1.8 12.1-4.3 17.7-7.3 5.2-2.9 11.6-2.6 16.5.7 3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1-3.3-5-3.6-11.3-.7-16.5 3-5.6 5.5-11.5 7.3-17.7 1.7-5.7 6.4-10 12.2-11.2 3.6-.7 6.4-4 6.4-7.8v-12c0-3.9-2.7-7.1-6.4-7.8-5.8-1.2-10.5-5.5-12.2-11.2-1.8-6.2-4.3-12.1-7.3-17.7-2.9-5.2-2.6-11.6.7-16.5 2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1-5 3.3-11.3 3.6-16.5.7-5.6-3-11.5-5.5-17.7-7.3-5.7-1.7-10-6.4-11.2-12.2-.7-3.6-4-6.4-7.8-6.4h-12zm-36-9.5c6.5-13.3 20.1-22.5 36-22.5h12c15.8 0 29.5 9.2 36 22.5 2.9 1.1 5.8 2.3 8.6 3.6 14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3 1.3 2.8 2.5 5.7 3.6 8.6 13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36-1.1 2.9-2.3 5.8-3.6 8.6 4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5-2.8 1.3-5.7 2.5-8.6 3.6-6.5 13.3-20.1 22.5-36 22.5h-12c-15.8 0-29.5-9.2-36-22.5-2.9-1.1-5.8-2.3-8.6-3.6-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3-1.3-2.8-2.5-5.7-3.6-8.6-13.3-6.5-22.5-20.2-22.5-36v-12c0-15.8 9.2-29.5 22.5-36 1.1-2.9 2.3-5.8 3.6-8.6-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5 2.8-1.3 5.7-2.5 8.6-3.6zm42 92a21.5 21.5 0 1 0 0 43 21.5 21.5 0 1 0 0-43zm53.5 21.5a53.5 53.5 0 1 1-107 0 53.5 53.5 0 1 1 107 0zm252.7-97.6c-1.2 5.8-5.5 10.5-11.2 12.2-6.2 1.8-12.1 4.3-17.7 7.3-5.2 2.9-11.6 2.6-16.5-.7-3.1-2.1-7.3-1.7-10.1 1l-8.5 8.5c-2.7 2.7-3.1 7-1 10.1 3.3 5 3.6 11.3.7 16.5-3 5.6-5.5 11.5-7.3 17.7-1.7 5.7-6.4 10-12.2 11.2-3.6.7-6.4 4-6.4 7.8v12c0 3.9 2.7 7.1 6.4 7.8 5.8 1.2 10.5 5.5 12.2 11.2 1.8 6.2 4.3 12.1 7.3 17.7 2.9 5.2 2.6 11.6-.7 16.5-2.1 3.1-1.7 7.3 1 10.1l8.5 8.5c2.7 2.7 7 3.1 10.1 1 5-3.3 11.3-3.6 16.5-.7 5.6 3 11.5 5.5 17.7 7.3 5.7 1.7 10 6.4 11.2 12.2.7 3.6 4 6.4 7.8 6.4h12c3.9 0 7.1-2.7 7.8-6.4 1.2-5.8 5.5-10.5 11.2-12.2 6.2-1.8 12.1-4.3 17.7-7.3 5.2-2.9 11.6-2.6 16.5.7 3.1 2.1 7.3 1.7 10.1-1l8.5-8.5c2.7-2.7 3.1-7 1-10.1-3.3-5-3.6-11.3-.7-16.5 3-5.6 5.5-11.5 7.3-17.7 1.7-5.7 6.4-10 12.2-11.2 3.6-.7 6.4-4 6.4-7.8v-12c0-3.9-2.7-7.1-6.4-7.8-5.8-1.2-10.5-5.5-12.2-11.2-1.8-6.2-4.3-12.1-7.3-17.7-2.9-5.2-2.6-11.6.7-16.5 2.1-3.1 1.7-7.3-1-10.1l-8.5-8.5c-2.7-2.7-7-3.1-10.1-1-5 3.3-11.3 3.6-16.5.7-5.6-3-11.5-5.5-17.7-7.3-5.7-1.7-10-6.4-11.2-12.2-.7-3.6-4-6.4-7.8-6.4h-12c-3.9 0-7.1 2.7-7.8 6.4zM474 240h12c15.8 0 29.5 9.2 36 22.5 2.9 1.1 5.8 2.3 8.6 3.6 14-4.8 30.1-1.7 41.3 9.5l8.5 8.5c11.2 11.2 14.4 27.3 9.5 41.3 1.3 2.8 2.5 5.7 3.6 8.6 13.3 6.5 22.5 20.1 22.5 36v12c0 15.8-9.2 29.5-22.5 36-1.1 2.9-2.3 5.8-3.6 8.6 4.8 14 1.7 30.1-9.5 41.3l-8.5 8.5c-11.2 11.2-27.3 14.4-41.3 9.5-2.8 1.3-5.7 2.5-8.6 3.6-6.5 13.3-20.1 22.5-36 22.5h-12c-15.8 0-29.5-9.2-36-22.5-2.9-1.1-5.8-2.3-8.6-3.6-14 4.8-30.1 1.7-41.3-9.5l-8.5-8.5c-11.2-11.2-14.4-27.3-9.5-41.3-1.3-2.8-2.5-5.7-3.6-8.6-13.3-6.5-22.5-20.1-22.5-36v-12c0-15.8 9.2-29.5 22.5-36 1.1-2.9 2.3-5.8 3.6-8.6-4.8-14-1.7-30.1 9.5-41.3l8.5-8.5c11.2-11.2 27.3-14.4 41.3-9.5 2.8-1.3 5.7-2.5 8.6-3.6 6.5-13.3 20.1-22.5 36-22.5zm-15.5 136a21.5 21.5 0 1 0 43 0 21.5 21.5 0 1 0-43 0zm21.5 53.5a53.5 53.5 0 1 1 0-107 53.5 53.5 0 1 1 0 107z"
        }
    ]
};

const FalTruckMoving = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckMoving",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 64c-22.1 0-40 17.9-40 40v232c13.4-10 30-16 48-16 26.2 0 49.4 12.6 64 32 14.6-19.4 37.8-32 64-32 32.8 0 61 19.7 73.3 48H448V104c0-22.1-17.9-40-40-40H72zm408 272c13.4-10 30-16 48-16 32.8 0 60.9 19.7 73.3 47.9 3.8-.6 6.7-3.9 6.7-7.9V256H480v80zm0-176v64h112l-43.2-57.6c-3-4-7.8-6.4-12.8-6.4h-56zm160 90.7V360c0 19.4-13.7 35.5-32 39.2v.8c0 44.2-35.8 80-80 80s-80-35.8-80-80H288c0 44.2-35.8 80-80 80-26.2 0-49.4-12.6-64-32-14.6 19.4-37.8 32-64 32-44.2 0-80-35.8-80-80V104c0-39.8 32.2-72 72-72h336c39.8 0 72 32.2 72 72v24h56c15.1 0 29.3 7.1 38.4 19.2l56 74.7c6.2 8.3 9.6 18.4 9.6 28.8zM528 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-272-48a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM80 448a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalTruckPickup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckPickup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 80v112h229.3L389 70.1c-3-3.8-7.7-6.1-12.6-6.1H272c-8.8 0-16 7.2-16 16zm268.6 110.1 1.5 1.9H552c30.9 0 56 25.1 56 56v104h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64c0 53-43 96-96 96s-96-43-96-96h-96c0 53-43 96-96 96s-96-43-96-96H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V248c0-30.9 25.1-56 56-56h136V80c0-26.5 21.5-48 48-48h104.5c14.7 0 28.6 6.7 37.7 18.3l110.4 139.8zM64 352h21.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64h107c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H576V248c0-13.3-10.7-24-24-24H88c-13.3 0-24 10.7-24 24v104zm176 32a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm224 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FalTruckPlane = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckPlane",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M189.2 13.3C198.8 5.7 210.6 0 224 0c26.9 0 47.1 21.6 59.2 41.8 10.4 17.3 17.7 38 20 56.3-12.3 3.3-23.1 10.2-31.2 19.4v-7.8c0-13.6-5.9-34.2-16.2-51.4C244.9 40.2 233.1 32 224 32c-4.1 0-9 1.7-14.8 6.3-5.8 4.6-11.5 11.5-16.7 20-10.4 17.3-16.5 37.9-16.5 51.4v80c0 5.7-3.1 11-8.1 13.9L40.1 276.7c-5 2.8-8.1 8.2-8.1 13.9v56.2l123.6-35.3c4.8-1.4 10-.4 14 2.6s6.4 7.8 6.4 12.8V384c0 5-2.4 9.8-6.4 12.8L112 440v39.4l107.6-30.7c2.9-.8 5.9-.8 8.8 0l38.8 11.1c5.4 7.8 12.5 14.4 20.8 19.2v20l-64-18.3-105.7 30.1c-2.7.8-5.5 1.2-8.3 1.2-16.6 0-30-13.4-30-30v-42c0-10.1 4.7-19.6 12.8-25.6L144 376v-27.9L40.8 377.6C20.3 383.4 0 368 0 346.8v-56.2c0-17.2 9.2-33.1 24.2-41.7L144 180.4v-70.7c0-20.7 8.4-46.9 21.2-67.9 6.5-10.7 14.5-20.8 24-28.4zM592 160H336c-8.8 0-16 7.2-16 16v136.6c4.3-2.5 8.9-4.5 13.8-5.9l3.5-11.8 12.4-41.2c8.1-27.1 33-45.6 61.3-45.6h106c28.3 0 53.2 18.5 61.3 45.6l12.4 41.2 3.5 11.8c4.9 1.4 9.5 3.4 13.8 5.9V176c0-8.8-7.2-16-16-16zm48 208v48c0 20.9-13.4 38.7-32 45.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32H352v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-34.7c-18.6-6.6-32-24.4-32-45.3V176c0-26.5 21.5-48 48-48h256c26.5 0 48 21.5 48 48v192zm-32 48v-48c0-17.7-14.3-32-32-32H352c-17.7 0-32 14.3-32 32v48c0 8.8 7.2 16 16 16h256c8.8 0 16-7.2 16-16zm-48-112-9.6-32-2.8-9.2c-4-13.5-16.5-22.8-30.6-22.8H411c-14.1 0-26.6 9.3-30.6 22.8l-2.8 9.2-9.6 32h192zm-184 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm152 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalTruckPlow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckPlow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 64h94.1c5.6 0 10.7 2.9 13.7 7.7L357.2 192H160V80c0-8.8 7.2-16 16-16zm218.8 128-5.1-8.3L311 55c-8.7-14.3-24.2-23-41-23h-94c-26.5 0-48 21.5-48 48v112H56c-30.9 0-56 25.1-56 56v96c0 19.4 13.7 35.5 32 39.2v.8c0 53 43 96 96 96s96-43 96-96h48c0 53 43 96 96 96s96-43 96-96h56.5l75.2 90.2c5.7 6.8 15.7 7.7 22.5 2s7.7-15.7 2-22.5L544 362.2V213.8l76.3-91.6c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2l-80 96c-2.4 2.9-3.7 6.5-3.7 10.2V352h-32.9c.5-2.6.8-5.3.8-8v-96c0-30.9-25.1-56-56-56h-29.2zM448 330.9C430.8 305 401.4 288 368 288c-41.8 0-77.4 26.7-90.5 64h-59c-13.2-37.3-48.7-64-90.5-64-41.7 0-77.1 26.5-90.4 63.6-3.2-1-5.6-4.1-5.6-7.6v-96c0-13.3 10.7-24 24-24h368c13.3 0 24 10.7 24 24v82.9zM64 384a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm304-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FalTruckRampBox = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckRampBox",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 0c-44.2 0-80 35.8-80 80v304c0 1.3.2 2.5.4 3.7L11.8 480.6C3.3 482.9-1.8 491.7.6 500.2s11.1 13.6 19.6 11.2l395.9-107.8C417.9 463.8 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.5.1-35.8 9.7V80c0-26.5 21.5-48 48-48h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zm96 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM84.9 191.2l14.5 54.1c3.4 12.8 16.6 20.4 29.4 17l46.4-12.4c12.8-3.4 20.4-16.6 17-29.4l-14.5-54.1 30.9-8.3L250 312.6 95.4 354 54 199.4l30.9-8.3zm30.9-8.3 30.9-8.3 12.5 46.4-30.9 8.3-12.4-46.4zm-70.1-14.4c-17.1 4.6-27.2 22.1-22.6 39.2l41.4 154.6c4.6 17.1 22.1 27.2 39.2 22.6l154.5-41.4c17.1-4.6 27.2-22.1 22.6-39.2l-41.3-154.6c-4.6-17.1-22.1-27.2-39.2-22.6L45.7 168.5z"
        }
    ]
};

const FalTruckRampCouch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckRampCouch",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 80c0-44.2 35.8-80 80-80h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H432c-26.5 0-48 21.5-48 48v299.1l35.8-9.8.5-.1C433.6 322.4 476.8 288 528 288c61.9 0 112 50.1 112 112s-50.1 112-112 112c-60.7 0-110.1-48.2-111.9-108.4L20.2 511.4c-8.5 2.3-17.3-2.7-19.6-11.2s2.7-17.3 11.2-19.6l340.6-92.8c-.3-1.2-.4-2.5-.4-3.7V80zm256 320a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM225.7 128.2c36.4-9.8 73.6 4.8 94.3 33.7v75.5c-3.1-.4-6.3-.3-9.5.6-11.1 3-18.3 13.3-17.8 24.3.8 15.1-9.1 28.6-23.7 32.5l-141.4 38c-14.6 3.9-29.9-2.9-36.8-16.3-5-9.9-16.5-15.2-27.6-12.2-12.8 3.4-20.4 16.6-17 29.4L59.7 384c1.1 4.3 5.5 6.8 9.8 5.7l24.8-6.6c1.2-.3 2.4-.6 3.6-.8L278.2 334c.7-.2 1.5-.4 2.2-.5l39.6-10.8v33.1l-2.6.7-30.9 8.3v-.1l-30.9 8.3-122.1 32.8-30.9 8.2-.1-.2-24.8 6.6c-21.3 5.7-43.3-6.9-49-28.3l-13.4-50.2c-3.9-14.7-1.6-29.7 5.3-42l-6.4-24C1.7 229 29.5 180.8 76.5 168.2l149.2-40zm8.3 30.9-149.2 40c-29.9 8-47.6 38.7-39.6 68.6l2.2 8.3c2.4-1 5-1.9 7.6-2.6 26-7 52.6 5.5 64.3 28.5L260.8 264c-1.3-25.8 15.5-49.9 41.4-56.9l2.4-.6-2.1-7.8c-8-29.9-38.7-47.6-68.6-39.6z"
        }
    ]
};

const FalTruckRamp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckRamp",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 0c-44.2 0-80 35.8-80 80v304c0 1.3.2 2.5.4 3.7L11.8 480.6C3.3 482.9-1.8 491.7.6 500.2s11.1 13.6 19.6 11.2l395.9-107.8C417.9 463.8 467.3 512 528 512c61.9 0 112-50.1 112-112s-50.1-112-112-112c-51.2 0-94.4 34.4-107.7 81.3l-.5.1-35.8 9.7V80c0-26.5 21.5-48 48-48h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H432zm96 320a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"
        }
    ]
};

const FalTruckTow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruckTow",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64v112c0 26.5-21.5 48-48 48S0 202.5 0 176v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16c0 8.8 7.2 16 16 16s16-7.2 16-16V32c0-11.8 6.4-22.2 16-27.7C84.7 1.6 90.2 0 96 0h49.7c9.1 0 17.8 3.9 23.9 10.7L384 252V144c0-26.5 21.5-48 48-48h56.5c19.8 0 38.4 9.1 50.5 24.7l90.8 116.8c6.6 8.4 10.1 18.8 10.1 29.5v101c0 26.5-21.5 48-48 48H576c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48h144L96 64zm154.5 320h139c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H592c8.8 0 16-7.2 16-16v-80H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h21.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zM416 416a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm97.8-275.6c-6.1-7.8-15.4-12.4-25.3-12.4H432c-8.8 0-16 7.2-16 16v112h187.7l-89.9-115.6zM145.6 32h-29.9l112 224h117L145.6 32zM224 416a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FalTruck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTruck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v288c0 17.7 14.3 32 32 32h5.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H384V64c0-17.7-14.3-32-32-32H64zm0 384c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0h288c35.3 0 64 28.7 64 64v32h65.3c14 0 27.3 6.1 36.4 16.8l78.7 91.8c7.5 8.7 11.6 19.8 11.6 31.2V384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96zm352-192h154.9l-77.5-90.4c-3-3.5-7.5-5.6-12.1-5.6H416v96zm0 32v88.4c17-15.2 39.4-24.4 64-24.4 41.8 0 77.4 26.7 90.5 64h5.5V256H416zM224 416a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm256 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FalTrumpet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTrumpet",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M608 96.8v286.4c-10-14.3-33.6-45.3-67.1-73.1C507 282.1 461.3 256 408 256H32v-32h376c53.3 0 99-26.1 132.9-54.1C574.4 142.1 598 111 608 96.8zM352 288v128h-48V288h48zm32 128V288h24c42.8 0 81.4 21 112.5 46.8 30.9 25.6 52.8 54.6 61.7 67.4 5.9 8.5 15.6 13.9 26.4 13.9 17.4 0 31.4-14.1 31.4-31.4V95.4c0-17.3-14.1-31.4-31.4-31.4-10.8 0-20.5 5.4-26.4 13.9-8.9 12.8-30.8 41.8-61.7 67.4C489.4 171 450.8 192 408 192h-24v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-48v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-48v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16H32c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16h56.4C73.2 305 64 327.4 64 352c0 53 43 96 96 96h256c47.4 0 86.7-34.3 94.6-79.4-3.4-3.1-6.9-6.2-10.5-9.2-6.7-5.5-13.5-10.6-20.5-15.2.3 2.6.5 5.2.5 7.8 0 35.3-28.7 64-64 64H384zm-112 0h-48V288h48v128zm-80 0h-32c-35.3 0-64-28.7-64-64s28.7-64 64-64h32v128z"
        }
    ]
};

const FalTtyAnswer = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTtyAnswer",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M329 286.7c11.3-13.8 30.3-18.5 46.7-11.4l112 48c17.6 7.5 27.4 26.5 23.4 45.1l-24 112c-4 18.4-20.3 31.6-39.1 31.6-6.1 0-12.2-.1-18.3-.4h-.1c-4.6-.2-9.1-.4-13.7-.8C183.5 494.5 0 300.7 0 64c0-18.9 13.2-35.2 31.6-39.1l112-24c18.7-4 37.6 5.8 45.1 23.4l48 112c7 16.4 2.4 35.4-11.4 46.7l-40.6 33.2c26.7 46 65.1 84.4 111.1 111.1l33.2-40.6zM448 480c3.8 0 7-2.6 7.8-6.3l24-112c.8-3.7-1.2-7.5-4.7-9l-112-48c-3.3-1.4-7.1-.5-9.3 2.3l-33.2 40.6c-9.9 12.1-27.2 15.3-40.8 7.4-50.9-29.5-93.3-71.9-122.7-122.7-7.9-13.6-4.7-30.9 7.4-40.8l40.6-33.2c2.8-2.3 3.7-6.1 2.3-9.3l-48-112c-1.5-3.5-5.3-5.5-9-4.7l-112 24C34.6 57 32 60.2 32 64c0 229.6 186.1 415.8 415.7 416h.3zM312 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm0 96h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm80-80c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V80zm112-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16V80zm16 80h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-200 0h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H400c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalTty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTty",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M354 164.8v29.8c0 8.1 6.1 14.9 14.1 15.9l78.7 9.4c7.3.9 14.2-3.3 16.8-10.1l10.3-26.8c6.4-16.6 2.5-31.1-6.1-38.7C426.2 107.6 352.1 64 256 64S85.8 107.6 44.1 144.3c-8.6 7.6-12.5 22.1-6.1 38.7l10.3 26.7c2.6 6.8 9.6 11 16.8 10.1l78.7-9.4c8-1 14.1-7.8 14.1-15.9v-29.7c0-13 7.9-24.7 20-29.6 50-20.3 106-20.3 156.1 0 12.1 4.9 20 16.6 20 29.6zm-32 29.8v-29.8c-42.3-17.2-89.7-17.2-132 0v29.8c0 24.3-18.2 44.8-42.3 47.7L69 251.6c-21.8 2.6-42.5-9.9-50.4-30.3L8.2 194.5c-10.1-26-6.2-55.8 14.8-74.2C68.7 79.9 150 32 256 32s187.3 47.9 233 88.3c20.9 18.4 24.8 48.2 14.8 74.2l-10.3 26.7c-7.9 20.4-28.7 32.9-50.4 30.3l-78.7-9.4c-24.1-2.9-42.3-23.3-42.3-47.7zM72 291.2h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H72c-15.9 0-28.8-12.9-28.8-28.8v-32c0-15.9 12.9-28.8 28.8-28.8zM68.8 320v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2v-32c0-1.8-1.4-3.2-3.2-3.2H72c-1.8 0-3.2 1.4-3.2 3.2zm3.2 83.2h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H72c-15.9 0-28.8-12.9-28.8-28.8v-32c0-15.9 12.9-28.8 28.8-28.8zM68.8 432v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2v-32c0-1.8-1.4-3.2-3.2-3.2H72c-1.8 0-3.2 1.4-3.2 3.2zM408 403.2h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8h-32c-15.9 0-28.8-12.9-28.8-28.8v-32c0-15.9 12.9-28.8 28.8-28.8zm-3.2 28.8v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2v-32c0-1.8-1.4-3.2-3.2-3.2h-32c-1.8 0-3.2 1.4-3.2 3.2zm-249.6 0c0-15.9 12.9-28.8 28.8-28.8h144c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8H184c-15.9 0-28.8-12.9-28.8-28.8v-32zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2v32c0 1.8 1.4 3.2 3.2 3.2h144c1.8 0 3.2-1.4 3.2-3.2v-32c0-1.8-1.4-3.2-3.2-3.2H184zM155.2 320c0-15.9 12.9-28.8 28.8-28.8h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8h-32c-15.9 0-28.8-12.9-28.8-28.8v-32zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2v-32c0-1.8-1.4-3.2-3.2-3.2h-32zm112-25.6h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8h-32c-15.9 0-28.8-12.9-28.8-28.8v-32c0-15.9 12.9-28.8 28.8-28.8zm-3.2 28.8v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2v-32c0-1.8-1.4-3.2-3.2-3.2h-32c-1.8 0-3.2 1.4-3.2 3.2zm86.4 0c0-15.9 12.9-28.8 28.8-28.8h32c15.9 0 28.8 12.9 28.8 28.8v32c0 15.9-12.9 28.8-28.8 28.8h-32c-15.9 0-28.8-12.9-28.8-28.8v-32zm28.8-3.2c-1.8 0-3.2 1.4-3.2 3.2v32c0 1.8 1.4 3.2 3.2 3.2h32c1.8 0 3.2-1.4 3.2-3.2v-32c0-1.8-1.4-3.2-3.2-3.2h-32z"
        }
    ]
};

const FalTugrikSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTugrikSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h160v147.5l-115.9 29c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l108.1-27v63l-115.9 29c-8.6 2.1-13.8 10.8-11.6 19.4s10.8 13.8 19.4 11.6l108.1-27V456c0 8.8 7.2 16 16 16s16-7.2 16-16V332.5l115.9-29c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-108.1 27v-63l115.9-29c8.6-2.1 13.8-10.8 11.6-19.4s-10.8-13.8-19.4-11.6l-108.1 27V64h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalTurkey = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTurkey",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M496 64c0-17.7 14.3-32 32-32s32 14.3 32 32c0 2.7-.3 5.4-1 7.9-1.3 5.2-.5 11.1 2.9 16 3.7 5.2 9.4 8 15.2 8.2 17.1.6 30.9 14.7 30.9 32 0 17.7-14.3 32-32 32-6 0-12.6-.6-20.3-1.5l-3.9-.5c-6.3-.7-13.2-1.5-19.9-2-15.9-1-35.4-.4-51.5 11l-41.6 29.3c-18.8 13.2-30.5 32-39.1 50.6-5.3 11.3-10 24.3-14.4 36.2-2.5 6.7-4.8 13.1-7.1 18.8-4.9 12.2-12.9 23.3-23.9 32.2-34.3 27.8-84.7 22.5-112.5-11.9s-22.5-84.7 11.9-112.5c17.2-13.9 38.3-19.5 58.7-17.4 14.5 1.5 31.2 3.1 47.6 2 16.5-1.2 33.7-5.3 48.9-16l63.6-44.9c12.8-9 18.4-22.7 20.9-34.8 2.5-12 2.6-24.9 2.6-34.7zm32-64c-35.3 0-64 28.7-64 64 0 10.1-.2 19.7-1.9 28.1-1.8 8.3-4.6 12.9-8.1 15.3l-40.3 28.4C370.6 110.5 325.7 96 288 96 176 96 0 224 0 384c0 128 160 128 288 128s288 0 288-128c0-60.3-25-116.1-62.2-162.2l-26.2 18.5C522 282.3 544 332 544 384c0 24.6-7.4 40.5-18.3 52-11.6 12.3-29.6 22.1-54.5 29.2C420.4 479.7 353.4 480 288 480s-132.4-.3-183.2-14.8c-24.9-7.1-42.9-16.9-54.5-29.2C39.4 424.5 32 408.6 32 384c0-68 37.6-132 91.4-180.2C177.6 155.2 242.3 128 288 128c27.3 0 61.5 9.7 96.1 28-7.6 3.8-16.4 5.8-26.5 6.5-13.1.9-27.2-.3-41.9-1.9-28.5-3-58.2 4.9-82.2 24.3-48.1 38.9-55.5 109.4-16.6 157.5s109.4 55.5 157.5 16.6c15.3-12.4 26.5-28 33.4-45.1 3.1-7.7 5.7-14.9 8.3-21.9 4-10.8 7.7-21.1 12.6-31.6 7.6-16.4 16.3-29.3 28.5-37.9l41.6-29.3c6.7-4.7 16.5-6.2 31-5.2 5.8.4 11.7 1.1 18 1.8l4.3.5c7.6.9 15.9 1.7 23.9 1.7 35.3 0 64-28.7 64-64 0-29.8-20.4-54.9-48-62v-2c0-35.3-28.7-64-64-64z"
        }
    ]
};

const FalTurkishLiraSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTurkishLiraSign",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32c8.8 0 16 7.2 16 16v77.1l155.6-44.5c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8L96 158.4v62.7l155.6-44.5c8.5-2.4 17.4 2.5 19.8 11s-2.5 17.4-11 19.8L96 254.4V448h95.2c85.8 0 156.3-67.6 159.8-153.3l1-23.3c.4-8.8 7.8-15.7 16.7-15.3s15.7 7.8 15.3 16.7l-1 23.2c-4.3 102.8-88.9 184-191.8 184H80c-8.8 0-16-7.2-16-16V263.5l-27.6 7.9c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8L64 230.2v-62.7l-27.6 7.9c-8.5 2.4-17.4-2.5-19.8-11s2.5-17.4 11-19.8L64 134.2V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalTurnDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTurnDownLeft",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M160 208v-57.3c0-3.7-3-6.7-6.7-6.7-1.9 0-3.7.8-5 2.2L35.8 272l112.5 125.8c1.3 1.4 3.1 2.2 5 2.2 3.7 0 6.7-3 6.7-6.7V336c0-17.7 14.3-32 32-32h176c61.9 0 112-50.1 112-112V80c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v112c0 26.5-21.5 48-48 48H192c-17.7 0-32-14.3-32-32zM5.3 286c-3.4-3.9-5.3-8.8-5.3-14s1.9-10.1 5.3-14l119.2-133.1c7.3-8.2 17.8-12.9 28.8-12.9 21.4 0 38.7 17.3 38.7 38.7V208h176c8.8 0 16-7.2 16-16V80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48v112c0 79.5-64.5 144-144 144H192v57.3c0 21.4-17.3 38.7-38.7 38.7-11 0-21.5-4.7-28.8-12.9L5.3 286z"
        }
    ]
};

const FalTurnDownRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTurnDownRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M352 208v-57.3c0-3.7 3-6.7 6.7-6.7 1.9 0 3.7.8 5 2.2L476.2 272 363.7 397.8c-1.3 1.4-3.1 2.2-5 2.2-3.7 0-6.7-3-6.7-6.7V336c0-17.7-14.3-32-32-32H144c-61.9 0-112-50.1-112-112V80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v112c0 26.5 21.5 48 48 48h176c17.7 0 32-14.3 32-32zm154.7 78c3.4-3.8 5.3-8.8 5.3-14s-1.9-10.1-5.3-14L387.5 124.9c-7.3-8.2-17.8-12.9-28.8-12.9-21.4 0-38.7 17.3-38.7 38.7V208H144c-8.8 0-16-7.2-16-16V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v112c0 79.5 64.5 144 144 144h176v57.3c0 21.4 17.3 38.7 38.7 38.7 11 0 21.5-4.7 28.8-12.9L506.7 286z"
        }
    ]
};

const FalTurnDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTurnDown",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 352H70.7c-3.7 0-6.7 3-6.7 6.7 0 1.9.8 3.7 2.2 5L192 476.2l125.8-112.5c1.4-1.3 2.2-3.1 2.2-5 0-3.7-3-6.7-6.7-6.7H256c-17.7 0-32-14.3-32-32V144c0-61.9-50.1-112-112-112H48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64c26.5 0 48 21.5 48 48v176c0 17.7-14.3 32-32 32zm78 154.7c-3.8 3.4-8.8 5.3-14 5.3s-10.1-1.9-14-5.3L44.9 387.5c-8.2-7.3-12.9-17.8-12.9-28.8 0-21.4 17.3-38.7 38.7-38.7H128V144c0-8.8-7.2-16-16-16H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h64c79.5 0 144 64.5 144 144v176h57.3c21.4 0 38.7 17.3 38.7 38.7 0 11-4.7 21.5-12.9 28.8L206 506.7z"
        }
    ]
};

const FalTurnUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTurnUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 160H70.7c-3.7 0-6.7-3-6.7-6.7 0-1.9.8-3.7 2.2-5L192 35.8l125.8 112.5c1.4 1.3 2.2 3.1 2.2 5 0 3.7-3 6.7-6.7 6.7H256c-17.7 0-32 14.3-32 32v176c0 61.9-50.1 112-112 112H48c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h64c26.5 0 48-21.5 48-48V192c0-17.7-14.3-32-32-32zM206 5.3c-3.9-3.4-8.8-5.3-14-5.3s-10.1 1.9-14 5.3L44.9 124.5c-8.2 7.3-12.9 17.8-12.9 28.8 0 21.4 17.3 38.7 38.7 38.7H128v176c0 8.8-7.2 16-16 16H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h64c79.5 0 144-64.5 144-144V192h57.3c21.4 0 38.7-17.3 38.7-38.7 0-11-4.7-21.5-12.9-28.8L206 5.3z"
        }
    ]
};

const FalTurntable = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTurntable",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h448zM64 32C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm160 352a128 128 0 1 1 0-256 128 128 0 1 1 0 256zM64 256a160 160 0 1 0 320 0 160 160 0 1 0-320 0zm160 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm256 17.4V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v176.5c-16 1.4-30.9 10.8-38.6 26.2l-16 32c-11.8 23.6-2.2 52.2 21.3 64s52.2 2.2 64-21.3l16-32c10.6-21.2 3.9-46.5-14.6-59.9zM452.3 320c2.3 0 4.6.6 6.8 1.7 7.9 4 11.1 13.6 7.2 21.5l-16 32c-4 7.9-13.6 11.1-21.5 7.2s-11.1-13.6-7.2-21.5l16-32c2.7-5.5 8.2-8.7 14-8.8h.7z"
        }
    ]
};

const FalTurtle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTurtle",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M200 64c-75.1 0-136 60.9-136 136v40c0 8.8-7.2 16-16 16s-16-7.2-16-16v-40c0-92.8 75.2-168 168-168s168 75.2 168 168v40c0 8.8-7.2 16-16 16s-16-7.2-16-16v-40c0-75.1-60.9-136-136-136zm200 124.6c0-42.3 34.3-76.6 76.6-76.6 54.9 0 99.4 44.5 99.4 99.4V224c0 35.3-28.7 64-64 64h-20.5c-20.3 57.4-74.7 96-135.8 96H352v48c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-48h-32v48c0 26.5-21.5 48-48 48h-32c-26.5 0-48-21.5-48-48v-48H48c-26.5 0-48-21.5-48-48s21.5-48 48-48h312c22.1 0 40-17.9 40-40v-59.4zM256 416v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-80h35.7c48.2 0 91-30.8 106.3-76.6l2.8-8.5c2.2-6.5 8.3-10.9 15.2-10.9h32c17.7 0 32-14.3 32-32v-12.6c0-37.2-30.2-67.4-67.4-67.4-24.6 0-44.6 20-44.6 44.6V248c0 39.8-32.2 72-72 72H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v80c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-80h96v64zm224-224a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalTvMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTvMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 32c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32h512zM64 0C28.7 0 0 28.7 0 64v320c0 35.3 28.7 64 64 64h512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm32 496c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM409.1 98.8c-4.3-3-9.8-3.7-14.7-1.8l-128 48c-6.2 2.3-10.4 8.3-10.4 15v90.5c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V171.1l96-36v83.4c-5-1.6-10.4-2.5-16-2.5-26.5 0-48 19.7-48 44s21.5 44 48 44 48-19.7 48-44c0-.8 0-1.6-.1-2.5 0-.5.1-1 .1-1.5V112c0-5.2-2.6-10.2-6.9-13.2zM384 260c0 4.1-4.5 12-16 12s-16-7.9-16-12 4.5-12 16-12 16 7.9 16 12zm-128 32c0 4.1-4.5 12-16 12s-16-7.9-16-12 4.5-12 16-12 16 7.9 16 12z"
        }
    ]
};

const FalTvRetro = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTvRetro",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M154.4 3.9c-6.7-5.8-16.8-5-22.6 1.7s-5 16.8 1.7 22.6L212.7 96H80c-44.2 0-80 35.8-80 80v256c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H299.3l79.2-67.9c6.7-5.8 7.5-15.9 1.7-22.6S364.4-2 357.6 3.8L256 90.9l-101.6-87zM256 128h176c26.5 0 48 21.5 48 48v256c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h176zm80 64c8.8 0 16 7.2 16 16v192c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V208c0-8.8 7.2-16 16-16h224zm-224-32c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48H112zm320 72a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm24 40a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalTv = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTv",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h512c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 416h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalTypewriter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalTypewriter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32c-17.7 0-32 14.3-32 32v96H64V64c0-35.3 28.7-64 64-64h228.1c17 0 33.3 6.7 45.3 18.7l27.9 27.9c12 12 18.7 28.3 18.7 45.3V160h-32V91.9c0-8.5-3.4-16.6-9.4-22.6l-27.9-27.9c-6-6-14.1-9.4-22.6-9.4H128zM32 224v64h448v-64H365.3L352 237.3c-12 12-28.3 18.7-45.3 18.7H205.3c-17 0-33.3-6.7-45.3-18.7l22.6-22.6c6 6 14.1 9.4 22.6 9.4h101.5c8.5 0 16.6-3.4 22.6-9.4l13.3-13.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32v128c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V320c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h114.7c8.5 0 16.6 3.4 22.6 9.4l13.3 13.3-22.6 22.6-13.3-13.3H32zm32 96v128c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V320H64zm96 96h192c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16zm-16-48a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm48 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm48 16a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm80-16a16 16 0 1 1-32 0 16 16 0 1 1 32 0z"
        }
    ]
};

const FalU = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalU",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32c8.8 0 16 7.2 16 16v240c0 88.4 71.6 160 160 160s160-71.6 160-160V48c0-8.8 7.2-16 16-16s16 7.2 16 16v240c0 106-86 192-192 192S0 394 0 288V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalUfoBeam = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUfoBeam",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m141.3 166.7 11.3-11.4-11.3 11.4.1.1.2.2.6.5c.5.4 1.1 1 1.9 1.6 1.6 1.3 3.8 3 6.7 5.1 5.8 4 14.5 9.1 26.3 14.1C200.7 198.4 236.7 208 288 208s87.3-9.6 110.9-19.6c11.8-5 20.4-10.1 26.3-14.1 2.9-2 5.1-3.7 6.7-5.1.8-.7 1.4-1.2 1.9-1.6l.6-.5.2-.2.1-.1-11.3-11.4 11.3 11.4c2.7-2.7 4.3-6.2 4.7-9.9.7-8.1.8-16 .2-23.7 30.2 8 55.1 18.1 73.1 29.4 23.1 14.4 31.2 28.3 31.2 39.1 0 7.9-4.2 17.4-16 27.9s-29.7 20.7-53.3 29.5c-47 17.7-113 29-186.7 29s-139.7-11.3-186.7-29c-23.6-8.9-41.5-19-53.3-29.5-11.8-10.5-16-20-16-27.9 0-10.9 8.2-24.7 31.2-39.1 18-11.3 42.9-21.4 73.1-29.4-.6 7.7-.5 15.6.2 23.7.3 3.7 2 7.3 4.7 9.9zm2.3-68.3c-38.9 8.9-72.5 21.4-97.3 36.9C20.1 151.7 0 173.9 0 201.6c0 20.3 11 37.8 26.7 51.8S64.3 279.3 90 289c51.4 19.4 121.4 31 198 31s146.5-11.7 198-31c25.7-9.7 47.5-21.6 63.3-35.6 15.7-14 26.7-31.5 26.7-51.8 0-27.7-20.1-49.9-46.3-66.3-24.8-15.5-58.4-28-97.3-36.9C412.1 39.7 353.1 0 288 0S163.9 39.7 143.5 98.4zM288 32c66.9 0 122 50.8 119.9 115.3l-.8.6c-4.2 2.9-10.9 6.9-20.7 11.1-19.5 8.2-51.2 17-98.4 17s-78.9-8.8-98.4-17.1c-9.8-4.2-16.5-8.2-20.7-11.1l-.8-.6C166 82.8 221.1 32 288 32zM103.8 338c-7.7-4.3-17.5-1.5-21.8 6.2l-80 144C-2.3 496 .5 505.7 8.2 510s17.5 1.5 21.8-6.2l80-144c4.3-7.7 1.5-17.5-6.2-21.8zm368.5 0c-7.7 4.3-10.5 14-6.2 21.8l80 144c4.3 7.7 14 10.5 21.8 6.2s10.5-14 6.2-21.8l-80-144c-4.3-7.7-14-10.5-21.8-6.2zM288 272a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-168-72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm360 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalUfo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUfo",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176.6 238.3c-11.7 11-11.7 11-11.6 11l.1.1.2.2.6.6c.5.5 1.1 1.1 1.9 1.8 1.6 1.5 4 3.4 7 5.7 6.1 4.5 15.2 10.3 27.7 16 25 11.4 63.1 22.3 117.5 22.3s92.5-10.9 117.5-22.3c12.5-5.7 21.6-11.5 27.7-16 3.1-2.3 5.4-4.2 7-5.7.8-.7 1.5-1.3 1.9-1.8l.6-.6.2-.2.1-.1-11.6-11 11.7 11c2.5-2.6 4-6 4.3-9.6.8-9.6.8-19 .1-28.1 38.3 10.3 69.8 24.1 92.1 39.7 25.5 17.8 36.4 36.2 36.4 52.7 0 12.2-5.8 25.2-19.2 38.5-13.5 13.4-33.7 26.2-60.1 37.3C476.1 401.9 402.3 416 320 416s-156.1-14.1-208.8-36.2c-26.3-11.1-46.6-23.9-60.1-37.3C37.8 329.2 32 316.2 32 304c0-16.5 10.9-34.9 36.5-52.8 22.3-15.6 53.7-29.3 92.1-39.7-.7 9.1-.7 18.5.1 28.1.3 3.6 1.8 7 4.3 9.6l11.7-11zm296.3-61.5C452.3 110.2 390.3 64 320 64s-132.3 46.2-152.8 112.9C120 188.1 79.5 204.5 50.1 225 20.7 245.6 0 272.3 0 304c0 23.2 11.2 43.9 28.6 61.2 17.3 17.2 41.6 32 70.2 44.1C156.2 433.4 234.4 448 320 448s163.8-14.6 221.2-38.7c28.7-12.1 52.9-26.9 70.2-44.1 17.4-17.3 28.6-38 28.6-61.2 0-31.7-20.7-58.4-50.1-79-29.3-20.5-69.9-36.9-117-48.1zm-21.1 50.5.1-.1zm-3.9 3.3c-.5.4-1.1.8-1.7 1.3-4.5 3.3-11.7 7.9-22 12.6C403.5 254 370 264 320 264s-83.5-10-104.2-19.4c-10.4-4.7-17.6-9.4-22-12.6-.6-.5-1.2-.9-1.7-1.3C189.1 154.3 249.4 96 320 96s130.9 58.3 127.9 134.7zM152 312a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm192 48a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm168-24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalUmbrellaBeach = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUmbrellaBeach",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M471.6 99.4c46.8 45.1 72.2 109 68.3 174.7l-86.3-31.4c15.2-43.2 21.6-89 18.9-134.8-.2-2.9-.5-5.7-.9-8.5zm-68.8-45.1c21.7 10.1 36.3 31.4 37.7 55.6 2.5 41.4-3.3 82.8-17 121.9l-167.6-61c14.6-38.8 36.9-74.2 65.3-104.3 17.5-18.5 44.1-25.2 68.2-17.3l3.3 1.2c3.4 1.2 6.7 2.5 10 3.9zm-3.1-35.4c-109.8-38-228.4 3.2-292.6 94-11.1 15.7-2.8 36.8 15.3 43.4l92.4 33.6 30.2 11 167.6 61 30.1 10.9 89.1 32.4c18.1 6.6 38-4.2 39.6-23.4 9-108.1-52-213.2-155.6-256.9-2.4-1.1-4.9-2.1-7.4-3l-5.9-2.1-2.7-.9zM305.9 37c-2.7 2.3-5.4 4.8-7.9 7.5-31.5 33.3-56 72.5-72.2 115.4l-89.6-32.6C176.5 73 239.2 40.1 305.9 37zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16h544c8.8 0 16-7.2 16-16s-7.2-16-16-16H253.4l77.8-213.7-30.1-10.9L219.4 480H16z"
        }
    ]
};

const FalUmbrellaSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUmbrellaSimple",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16.5C116.7 40.1 17 134.9 2 256.1-.2 273.6 14.3 288 32 288h448c17.7 0 32.2-14.4 30-31.9-15-121.2-114.7-216-238-223.6V16zm0 430.6V320h-32v126.6c0 18.5-15 33.4-33.4 33.4-12.7 0-24.2-7.2-29.9-18.5l-2.3-4.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l2.3 4.7c11.1 22.2 33.8 36.2 58.6 36.2 36.1 0 65.4-29.3 65.4-65.4zM256 64c112.8 0 206.2 83.5 221.7 192H34.3C49.8 147.5 143.2 64 256 64z"
        }
    ]
};

const FalUmbrella = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUmbrella",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v32.4C132.8 55.6 18.9 156 2.1 285.9c-2 15.6 17.3 24.4 27.8 12.7C43.9 283 71.2 272 96 272c38.7 0 71 27.5 78.4 64.1 1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C217 299.5 249.3 272 288 272s71 27.5 78.4 64.1c1.7 8.7 8.7 15.9 17.6 15.9s15.8-7.2 17.6-15.9C409 299.5 441.3 272 480 272c24.8 0 52.1 11 66.1 26.7 10.5 11.7 29.8 2.9 27.8-12.7C557.1 156 443.2 55.6 304 48.4V16zm80 278.3c-19.6-32.5-55.2-54.3-96-54.3s-76.4 21.8-96 54.3c-19.6-32.5-55.2-54.3-96-54.3-17.6 0-36.7 4.1-53.7 11.8C73.3 153 171 80 288 80s214.7 73 245.7 171.8c-17-7.7-36.1-11.8-53.7-11.8-40.8 0-76.4 21.8-96 54.3zm-112 12.4v139.9c0 18.5-15 33.4-33.4 33.4-12.7 0-24.2-7.2-29.9-18.5l-2.3-4.7c-4-7.9-13.6-11.1-21.5-7.2s-11.1 13.6-7.2 21.5l2.3 4.7c11.1 22.2 33.8 36.2 58.6 36.2 36.1 0 65.4-29.3 65.4-65.4V306.7c-5-1.8-10.4-2.7-16-2.7s-11 1-16 2.7z"
        }
    ]
};

const FalUnderline = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUnderline",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16H96v160c0 70.7 57.3 128 128 128s128-57.3 128-128V64h-48c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48v160c0 88.4-71.6 160-160 160S64 312.4 64 224V64H16C7.2 64 0 56.8 0 48zm0 416c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"
        }
    ]
};

const FalUnicorn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUnicorn",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 32h37.8c24.7 0 45.4 18.8 47.8 43.4l7.7 80.8c1.1 11.9-4.5 23.4-14.7 29.7-14.4 9-33.4 4.9-42.9-9.2l-6.4-9.6c-3-4.5-8-7.1-13.3-7.1h-32c-8.8 0-16 7.2-16 16v52.8c-.3 1.5-.4 3-.3 4.5.2 2.2.3 4.4.3 6.7 0 24-10.4 45.1-26.7 59.6-3.4 3-5.3 7.4-5.3 11.9V472c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8V334.7c0-7.8-5.6-14.5-13.3-15.8-1.4-.2-2.8-.5-4.3-.8l-116.2-26.2c-5.2-1.2-10.6.3-14.5 4s-5.7 9-4.8 14.3c.8 4.5 1.1 9.1 1.1 13.7 0 11.3-2.3 22.4-6.7 32.8l-8.1 19c-5 11.7-5.9 24.8-2.5 37l15.9 57.2c1.4 5.1-2.4 10.1-7.7 10.1h-33.3c-3.6 0-6.7-2.4-7.7-5.9l-13.5-48.6c-6.3-22.8-4.7-47.1 4.6-68.8l8.1-19c1.9-4.4 2.8-9.1 2.8-13.9 0-4.6-.9-9.3-2.7-13.5l-33.3-80.1c-2.6-6.2-3.9-12.8-3.9-19.5 0-28 22.7-50.7 50.7-50.7H320c8.8 0 16-7.2 16-16 0-61.9 50.1-112 112-112zm116.2 32c-2.5-12.2-7.7-23.4-15-32.9C555.5 29 560 23 560 16c0-8.8-7.2-16-16-16h-96c-74.1 0-135.2 56-143.1 128H146.7c-33.5 0-62.3 19.9-75.3 48.5C31.3 180.8 0 214.7 0 256v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48c0-20.9 13.4-38.7 32-45.3 0 10.9 2.2 21.7 6.4 31.7l33.4 80.1c.2.4.2.8.2 1.2 0 .4-.1.9-.3 1.3l-8.1 19c-12.2 28.4-14.3 60.2-6 90l13.5 48.6c4.8 17.3 20.6 29.3 38.5 29.3h33.2c26.5 0 45.6-25.2 38.5-50.7L197.4 404c-1.5-5.3-1.1-10.9 1.1-15.9l8.1-19c5.6-13.1 8.8-27.2 9.2-41.4l88.2 19.9V472c0 22.1 17.9 40 40 40h32c22.1 0 40-17.9 40-40V318.4c19.6-20 32-47.5 32-78.4 0-1.9-.1-3.9-.1-5.8.1-.7.1-1.4.1-2.2v-40h7.4l1.7 2.5c19 28.6 57.4 36.8 86.5 18.6 20.4-12.7 31.8-35.9 29.6-59.9l-4.7-49.4 65.2-21.7c3.8-1.3 6.4-4.8 6.4-8.8 0-5.1-4.2-9.3-9.3-9.3h-66.6zM480 112a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"
        }
    ]
};

const FalUniformMartialArts = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUniformMartialArts",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 0c-.9 0-1.8.1-2.7.2-38.1 2.4-72.5 24.1-91.1 57.8L15.8 178.8C5.5 197.7 0 218.9 0 240.4V368c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V240.4l32-58.2V288h32V121.2c0-6.7-4.2-12.7-10.4-15s-13.3-.5-17.7 4.5c-1.9 2.2-3.6 4.6-5.1 7.3L100 225c-2.6 4.7-4 10-4 15.4V368c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V240.4c0-16.2 4.1-32.1 11.9-46.3l66.4-120.7C123.8 49 149 33.3 176.7 32.1c.4 0 .7 0 1.1-.1h52.3l72 144-56 112h35.8l52.4-104.8L409.9 32h52.3c.4 0 .7.1 1.1.1 27.7 1.3 53 16.9 66.4 41.4l66.4 120.7c7.8 14.2 11.9 30.1 11.9 46.3V368c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V240.4c0-5.4-1.4-10.7-4-15.4l-58.8-107c-1.4-2.6-3.1-5.1-5-7.3-4.4-5.1-11.4-6.9-17.7-4.5s-10.4 8.3-10.4 15V288h32V182.3l32 58.2V368c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V240.4c0-21.6-5.4-42.8-15.8-61.7L557.8 58c-18.5-33.7-53-55.4-91.1-57.8-.9-.1-1.8-.2-2.7-.2H176zm89.9 32h108.2L320 140.2 265.9 32zM448 384v72c0 13.3-10.7 24-24 24H216c-13.3 0-24-10.7-24-24v-72h-32v72c0 30.9 25.1 56 56 56h208c30.9 0 56-25.1 56-56v-72h-32zm-304-48c0 8.8 7.2 16 16 16h130.1l-47.4 71.1c-4.9 7.4-2.9 17.3 4.4 22.2s17.3 2.9 22.2-4.4l50.7-76 50.7 76c4.9 7.4 14.8 9.3 22.2 4.4s9.3-14.8 4.4-22.2L349.9 352H480c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalUnion = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUnion",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32c8.8 0 16 7.2 16 16v240c0 88.4 71.6 160 160 160s160-71.6 160-160V48c0-8.8 7.2-16 16-16s16 7.2 16 16v240c0 106-86 192-192 192S0 394 0 288V48c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalUniversalAccess = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUniversalAccess",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm-16-368a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-174.3 56.8c-4 7.9-.7 17.5 7.2 21.5l21.1 10.5c16 8 32.8 14 50.1 17.8v67.7l-15.7 78.4c-1.7 8.7 3.9 17.1 12.6 18.8s17.1-3.9 18.8-12.6l13.3-66.9h37.8l13.4 67.1c1.7 8.7 10.2 14.3 18.8 12.6s14.3-10.2 12.6-18.8L304 318.4v-67.7c17.3-3.9 34.1-9.9 50.1-17.8l21.1-10.5c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-21.1 10.5c-26 13-54.7 19.8-83.8 19.8s-57.8-6.8-83.8-19.8l-21.1-10.5c-7.9-4-17.5-.7-21.5 7.2zM240 255.4a213.858 213.858 0 0 0 32 0V304h-32v-48.6z"
        }
    ]
};

const FalUnlockKeyhole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUnlockKeyhole",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c-53 0-96 43-96 96v64h240c44.2 0 80 35.8 80 80v160c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80h16v-64C96 57.3 153.3 0 224 0c58 0 107 38.6 122.7 91.4 2.5 8.5-2.3 17.4-10.8 19.9s-17.4-2.3-19.9-10.8C304.2 60.9 267.5 32 224 32zM80 224c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80zm184 144h-80c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16z"
        }
    ]
};

const FalUnlock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUnlock",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128c0-53 43-96 96-96 43.5 0 80.2 28.9 92 68.6 2.5 8.5 11.4 13.3 19.9 10.8s13.3-11.4 10.8-19.9C331 38.6 282 0 224 0 153.3 0 96 57.3 96 128v64H80c-44.2 0-80 35.8-80 80v160c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H128v-64zM32 272c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272z"
        }
    ]
};

const FalUpDownLeftRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpDownLeftRight",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M252.9 33.4 196 96h120l-56.9-62.6c-.8-.9-1.9-1.4-3.1-1.4s-2.3.5-3.1 1.4zm29.8-21.5 61.7 67.9c4.8 5.3 7.5 12.2 7.5 19.4 0 15.9-12.9 28.8-28.8 28.8H272v112h112v32H272v112h51.2c15.9 0 28.8 12.9 28.8 28.8 0 7.2-2.7 14.1-7.5 19.4l-61.7 67.9c-6.9 7.5-16.6 11.8-26.8 11.8s-19.9-4.3-26.8-11.8l-61.7-67.9c-4.8-5.3-7.5-12.2-7.5-19.4 0-15.9 12.9-28.8 28.8-28.8H240V272H128v51.2c0 15.9-12.9 28.8-28.8 28.8-7.2 0-14.1-2.7-19.4-7.5l-68-61.7C4.3 275.9 0 266.2 0 256s4.3-19.9 11.8-26.8l67.9-61.7c5.3-4.8 12.2-7.5 19.4-7.5 15.9 0 28.8 12.9 28.8 28.8V240H240V128h-51.2c-15.9 0-28.8-12.9-28.8-28.8 0-7.2 2.7-14.1 7.5-19.4l61.7-67.9C236.1 4.3 245.8 0 256 0s19.9 4.3 26.8 11.8zM316 416H196l56.9 62.6c.8.9 1.9 1.4 3.1 1.4s2.3-.5 3.1-1.4L316 416zm162.6-156.9c.9-.8 1.4-1.9 1.4-3.1s-.5-2.3-1.4-3.1L416 196v120l62.6-56.9zm-46.4 85.4c-5.3 4.8-12.2 7.5-19.4 7.5-15.9 0-28.8-12.9-28.8-28.8V188.8c0-15.9 12.9-28.8 28.8-28.8 7.2 0 14.1 2.7 19.4 7.5l67.9 61.7c7.5 6.9 11.8 16.6 11.8 26.8s-4.3 19.9-11.8 26.8l-67.9 61.7zM33.4 252.9c-.9.8-1.4 1.9-1.4 3.1s.5 2.3 1.4 3.1L96 316V196l-62.6 56.9z"
        }
    ]
};

const FalUpDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpDown",
    "viewBox": "0 0 256 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M103.3 9.7C110 3.5 118.8 0 128 0s18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1 0 21.1-17.1 38.3-38.3 38.3H192V352h25.7c21.1 0 38.3 17.1 38.3 38.3 0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7s-18-3.5-24.7-9.7l-91-84C4.5 411.1 0 400.9 0 390.3 0 369.1 17.1 352 38.3 352H64V160H38.3C17.1 160 0 142.9 0 121.7c0-10.7 4.5-20.9 12.3-28.1l91-84zM128 32c-1.1 0-2.2.4-3 1.2l-91 84c-1.3 1.2-2 2.9-2 4.6 0 3.5 2.8 6.3 6.3 6.3H80c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16H38.3c-3.5 0-6.3 2.8-6.3 6.3 0 1.7.7 3.4 2 4.6l91 84c.8.8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.8 2-4.6 0-3.5-2.8-6.3-6.3-6.3H176c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h41.7c3.5 0 6.3-2.8 6.3-6.3 0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2z"
        }
    ]
};

const FalUpFromBracket = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpFromBracket",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.2 32.8c.5-.5 1.1-.8 1.8-.8s1.4.3 1.8.8l124.4 131.9c1.2 1.2 1.8 2.9 1.8 4.6 0 3.7-3 6.7-6.7 6.7H288c-8.8 0-16 7.2-16 16v120c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V192c0-8.8-7.2-16-16-16h-57.3c-3.7 0-6.7-3-6.7-6.7 0-1.7.7-3.3 1.8-4.6L222.2 32.8zM224 0c-9.5 0-18.6 3.9-25.1 10.8l-124.4 132C67.8 150 64 159.5 64 169.3c0 21.4 17.3 38.7 38.7 38.7H144v104c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V208h41.3c21.4 0 38.7-17.3 38.7-38.7 0-9.9-3.8-19.3-10.5-26.5l-124.4-132C242.6 3.9 233.5 0 224 0zM32 336c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 44.2 35.8 80 80 80h288c44.2 0 80-35.8 80-80v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48v-96z"
        }
    ]
};

const FalUpFromDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpFromDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.2 64.8c.5-.5 1.1-.8 1.8-.8s1.4.3 1.8.8l124.4 131.9c1.2 1.2 1.8 2.9 1.8 4.6 0 3.7-3 6.7-6.7 6.7H288c-8.8 0-16 7.2-16 16v120c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V224c0-8.8-7.2-16-16-16h-57.3c-3.7 0-6.7-3-6.7-6.7 0-1.7.7-3.3 1.8-4.6L222.2 64.8zM224 32c-9.5 0-18.6 3.9-25.1 10.8l-124.4 132C67.8 182 64 191.5 64 201.3c0 21.4 17.3 38.7 38.7 38.7H144v104c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V240h41.3c21.4 0 38.7-17.3 38.7-38.7 0-9.9-3.8-19.3-10.5-26.5l-124.4-132C242.6 35.9 233.5 32 224 32zM32 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm384 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-264-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120-24a24 24 0 1 0-48 0 24 24 0 1 0 48 0z"
        }
    ]
};

const FalUpFromLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpFromLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M190.2 64.8c.5-.5 1.1-.8 1.8-.8s1.4.3 1.8.8l124.4 131.9c1.2 1.2 1.8 2.9 1.8 4.6 0 3.7-3 6.7-6.7 6.7H256c-8.8 0-16 7.2-16 16v120c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V224c0-8.8-7.2-16-16-16H70.7c-3.7 0-6.7-3-6.7-6.7 0-1.7.7-3.3 1.8-4.6L190.2 64.8zM192 32c-9.5 0-18.6 3.9-25.1 10.8l-124.4 132C35.8 182 32 191.5 32 201.3c0 21.4 17.3 38.7 38.7 38.7H112v104c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V240h41.3c21.4 0 38.7-17.3 38.7-38.7 0-9.9-3.8-19.3-10.5-26.5l-124.4-132C210.6 35.9 201.5 32 192 32zM16 480h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16s7.2 16 16 16z"
        }
    ]
};

const FalUpLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpLeft",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M72 128c-4.4 0-8 3.6-8 8v201.4c0 3.7 3 6.6 6.6 6.6 1.8 0 3.4-.7 4.7-1.9l61.4-61.4c6.2-6.2 16.4-6.2 22.6 0L272 393.4c4.2 4.2 10 6.6 16 6.6s11.8-2.4 16-6.6l25.4-25.4c4.2-4.2 6.6-10 6.6-16s-2.4-11.8-6.6-16L216.7 223.3c-3-3-4.7-7.1-4.7-11.3s1.7-8.3 4.7-11.3l61.4-61.4c1.2-1.2 1.9-2.9 1.9-4.7 0-3.7-3-6.6-6.6-6.6H72zm-40 8c0-22.1 17.9-40 40-40h201.4c21.3 0 38.6 17.3 38.6 38.6 0 10.2-4.1 20.1-11.3 27.3L250.6 212 352 313.4c10.2 10.2 16 24.1 16 38.6s-5.8 28.4-16 38.6L326.6 416c-10.2 10.2-24.1 16-38.6 16s-28.4-5.8-38.6-16L148 314.6l-50.1 50.1c-7.2 7.2-17 11.3-27.3 11.3-21.3 0-38.6-17.3-38.6-38.6V136z"
        }
    ]
};

const FalUpLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpLong",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 160H38.7c-3.7 0-6.7-3-6.7-6.7 0-1.9.8-3.7 2.2-5L160 35.8l125.8 112.5c1.4 1.3 2.2 3.1 2.2 5 0 3.7-3 6.7-6.7 6.7H232c-17.7 0-32 14.3-32 32v272c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V192c0-17.7-14.3-32-32-32zM174 5.3c-3.9-3.4-8.8-5.3-14-5.3s-10.1 1.9-14 5.3L12.9 124.5C4.7 131.8 0 142.3 0 153.3 0 174.7 17.3 192 38.7 192H88v272c0 26.5 21.5 48 48 48h48c26.5 0 48-21.5 48-48V192h49.3c21.4 0 38.7-17.3 38.7-38.7 0-11-4.7-21.5-12.9-28.8L174 5.3z"
        }
    ]
};

const FalUpRightAndDownLeftFromCenter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpRightAndDownLeftFromCenter",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M321 0c-18.2 0-33 14.8-33 33 0 8.7 3.5 17.1 9.7 23.3L325.4 84l-71.7 71.7c-15.6 15.6-15.6 40.9 0 56.6l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0l71.6-71.8 27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7 18.2 0 33-14.8 33-33V32c0-17.7-14.3-32-32-32H321zm-1 33c0-.5.4-1 1-1h159v159c0 .5-.4 1-1 1-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-83 83c-3.1 3.1-8.2 3.1-11.3 0l-46.1-46.1c-3.1-3.1-3.1-8.2 0-11.3l83-83c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7zM32 512h159c18.2 0 33-14.8 33-33 0-8.7-3.5-17.1-9.7-23.3L186.6 428l71.7-71.7c15.6-15.6 15.6-40.9 0-56.6l-46.1-46.1c-15.6-15.6-40.9-15.6-56.6 0L84 325.4l-27.7-27.7c-6.2-6.2-14.6-9.7-23.3-9.7-18.2 0-33 14.8-33 33v159c0 17.7 14.3 32 32 32zm160-33c0 .5-.4 1-1 1H32V321c0-.5.4-1 1-1 .3 0 .5.1.7.3l39 39c6.2 6.2 16.4 6.2 22.6 0l83-83c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-83 83c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39c.2.2.3.4.3.7z"
        }
    ]
};

const FalUpRightFromSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpRightFromSquare",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 33c0-18.2 14.8-33 33-33h127c17.7 0 32 14.3 32 32v127c0 18.2-14.8 33-33 33-8.7 0-17.1-3.5-23.3-9.7L404 130.6 235.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L381.4 108l-51.7-51.7c-6.2-6.2-9.7-14.6-9.7-23.3zm33-1c-.5 0-1 .4-1 1 0 .3.1.5.3.7l126 126c.2.2.4.3.7.3.5 0 1-.4 1-1V32H353zM0 96c0-35.3 28.7-64 64-64h144c8.8 0 16 7.2 16 16s-7.2 16-16 16H64c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h352c17.7 0 32-14.3 32-32V304c0-8.8 7.2-16 16-16s16 7.2 16 16v144c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpRight",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M312 128c4.4 0 8 3.6 8 8v201.4c0 3.7-3 6.6-6.6 6.6-1.8 0-3.4-.7-4.7-1.9l-61.4-61.4c-6.2-6.2-16.4-6.2-22.6 0L112 393.4c-4.2 4.2-10 6.6-16 6.6s-11.8-2.4-16-6.6L54.6 368c-4.2-4.2-6.6-10-6.6-16s2.4-11.8 6.6-16l112.7-112.7c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-61.4-61.4c-1.2-1.2-1.9-2.9-1.9-4.7 0-3.7 3-6.6 6.6-6.6H312zm40 8c0-22.1-17.9-40-40-40H110.6C89.3 96 72 113.3 72 134.6c0 10.2 4.1 20.1 11.3 27.3l50.1 50.1L32 313.4c-10.2 10.2-16 24.1-16 38.6s5.8 28.4 16 38.6L57.4 416c10.2 10.2 24.1 16 38.6 16s28.4-5.8 38.6-16L236 314.6l50.1 50.1c7.2 7.2 17.1 11.3 27.3 11.3 21.3 0 38.6-17.3 38.6-38.6V136z"
        }
    ]
};

const FalUpToDottedLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpToDottedLine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M222.2 160.8c.5-.5 1.1-.8 1.8-.8s1.4.3 1.8.8l124.4 131.9c1.2 1.2 1.8 2.9 1.8 4.6 0 3.7-3 6.7-6.7 6.7H288c-8.8 0-16 7.2-16 16v120c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V320c0-8.8-7.2-16-16-16h-57.3c-3.7 0-6.7-3-6.7-6.7 0-1.7.7-3.3 1.8-4.6l124.4-131.9zM224 128c-9.5 0-18.6 3.9-25.1 10.8l-124.4 132C67.8 278 64 287.5 64 297.3c0 21.4 17.3 38.7 38.7 38.7H144v104c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V336h41.3c21.4 0 38.7-17.3 38.7-38.7 0-9.9-3.8-19.3-10.5-26.5l-124.4-132c-6.5-6.9-15.6-10.8-25.1-10.8zm192-92a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM32 36a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm264 24a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-72-24a24 24 0 1 0 0 48 24 24 0 1 0 0-48zM104 60a24 24 0 1 0 48 0 24 24 0 1 0-48 0z"
        }
    ]
};

const FalUpToLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpToLine",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 64h352c8.8 0 16-7.2 16-16s-7.2-16-16-16H16C7.2 32 0 39.2 0 48s7.2 16 16 16zm174.2 96.8c.5-.5 1.1-.8 1.8-.8s1.4.3 1.8.8l124.4 131.9c1.2 1.2 1.8 2.9 1.8 4.6 0 3.7-3 6.7-6.7 6.7H256c-8.8 0-16 7.2-16 16v120c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V320c0-8.8-7.2-16-16-16H70.7c-3.7 0-6.7-3-6.7-6.7 0-1.7.7-3.3 1.8-4.6l124.4-131.9zM192 128c-9.5 0-18.6 3.9-25.1 10.8l-124.4 132C35.8 278 32 287.5 32 297.3c0 21.4 17.3 38.7 38.7 38.7H112v104c0 22.1 17.9 40 40 40h80c22.1 0 40-17.9 40-40V336h41.3c21.4 0 38.7-17.3 38.7-38.7 0-9.9-3.8-19.3-10.5-26.5l-124.4-132c-6.5-6.9-15.6-10.8-25.1-10.8z"
        }
    ]
};

const FalUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUp",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M189.7 64h4.6c4.4 0 8.6 1.8 11.6 5l142.6 149.8c2.2 2.3 3.5 5.4 3.5 8.7 0 6.9-5.6 12.6-12.6 12.6H256c-8.8 0-16 7.2-16 16V432c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16V256c0-8.8-7.2-16-16-16H44.6c-6.9 0-12.6-5.6-12.6-12.6 0-3.2 1.2-6.3 3.5-8.7L178.1 69c3-3.2 7.2-5 11.6-5zM384 227.4c0-11.4-4.4-22.5-12.3-30.7L229 46.9c-9-9.5-21.6-14.9-34.7-14.9h-4.6c-13.1 0-25.7 5.4-34.7 14.9L12.3 196.7C4.4 205 0 216 0 227.4 0 252 20 272 44.6 272H112v160c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V272h67.4c24.6 0 44.6-20 44.6-44.6z"
        }
    ]
};

const FalUpload = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUpload",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 54.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6L139.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 54.6zM208 352H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-64c0-17.7-14.3-32-32-32H304v-32h144c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v-64c0-35.3 28.7-64 64-64h144v32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1-48 0z"
        }
    ]
};

const FalUsbDrive = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsbDrive",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 128c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h352V128H64zM0 160c0-35.3 28.7-64 64-64h352c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-35.3 0-64-28.7-64-64V160zm480 224v-32h128V160H480v-32h128c17.7 0 32 14.3 32 32v192c0 17.7-14.3 32-32 32H480zm96-176a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16 112a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
        }
    ]
};

const FalUserAlien = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserAlien",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32C154.6 32 96 91.1 96 167c0 39.5 21.1 78.5 49.8 112.7 28.3 33.6 60.7 58.7 76 69.6.1.1.8.5 2.2.5s2.1-.4 2.2-.5c15.2-10.9 47.7-35.9 76-69.6C330.9 245.5 352 206.5 352 167c0-75.9-58.6-135-128-135zM64 167C64 74.8 135.6 0 224 0s160 74.8 160 167c0 101-106.6 185-139.2 208.3-6.1 4.3-13.4 6.5-20.8 6.5s-14.7-2.1-20.8-6.5C170.6 352 64 268.1 64 167zm62.1 185.2c12.8 12.5 25.1 23.2 35.8 31.7h-27.5C80 384 35.5 426.4 32.2 480h383.6c-3.3-53.6-47.8-96-102.2-96h-27.4c10.6-8.6 23-19.3 35.8-31.7 70.3 4.3 126 62.7 126 134.1 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 415 55.7 356.6 126.1 352.3zm23-175.4 48 16c8.4 2.8 12.9 11.9 10.1 20.2s-11.9 12.9-20.2 10.1l-48-16c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1zm160 30.4-48 16c-8.4 2.8-17.4-1.7-20.2-10.1s1.7-17.4 10.1-20.2l48-16c8.4-2.8 17.4 1.7 20.2 10.1s-1.7 17.4-10.1 20.2z"
        }
    ]
};

const FalUserAstronaut = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserAstronaut",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 176a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-320 0a176 176 0 1 1 352 0 176 176 0 1 1-352 0zm-32-64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm432 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16s16 7.2 16 16zM0 482.3c0-64.2 33.9-120.4 84.7-151.8 8.6 7.8 17.9 14.8 27.7 21.1-47 23.8-79.5 72.2-80.4 128.4h64v-32c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v32h64c-.9-56.2-33.4-104.6-80.5-128.4 9.8-6.3 19.1-13.3 27.7-21.1 50.8 31.4 84.7 87.6 84.7 151.8 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zm288-2.3h32v-32c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v32h32v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16h64v-16c0-8.8 7.2-16 16-16s16 7.2 16 16v16zm-82.7-317.3 21.2 6c3.3.9 5.5 3.9 5.5 7.3s-2.2 6.4-5.5 7.3l-21.2 6-6 21.2c-.9 3.3-3.9 5.5-7.3 5.5s-6.4-2.2-7.3-5.5l-6-21.2-21.2-6c-3.3-.9-5.5-3.9-5.5-7.3s2.2-6.4 5.5-7.3l21.2-6 6-21.2c.9-3.3 3.9-5.5 7.3-5.5s6.4 2.2 7.3 5.5l6 21.2zM160 128c-17.7 0-32 14.3-32 32v16c0 44.2 35.8 80 80 80h32c44.2 0 80-35.8 80-80v-16c0-17.7-14.3-32-32-32H160zm-64 32c0-35.3 28.7-64 64-64h128c35.3 0 64 28.7 64 64v16c0 61.9-50.1 112-112 112h-32c-61.9 0-112-50.1-112-112v-16z"
        }
    ]
};

const FalUserBountyHunter = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserBountyHunter",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0c-8.8 0-16 7.2-16 16v248c0 1 .1 2 .3 3l-.2 3.5c-.8 12 7.5 22.7 19.2 25.1l114.6 22.9c16.2 3.2 36.1 3.2 52.3 0l114.6-22.9c11.8-2.4 20-13.1 19.2-25.1l-8.3-128.2C370.5 62.2 304.1 0 224 0 170.5 0 123.1 27.7 96 70V32c8.8 0 16-7.2 16-16S104.8 0 96 0H80zm21.1 193.1c7.3 4.5 15.8 10.5 24.4 17.9 18.8 16.4 36.3 39.1 41.2 68.5l-70.2-14 4.7-72.4zm98.5 93.1c-3.3-45.3-28.9-78.1-53.1-99.2-13-11.4-25.9-19.7-35.6-25.2-1.1-.6-2.1-1.2-3.1-1.7H208v127.6c-1.3-.2-2.6-.4-3.9-.7l-4.5-.9zm40.4 1.6V160h100.2c-1 .5-2 1.1-3.1 1.7-9.7 5.5-22.6 13.9-35.6 25.2-24.2 21.1-49.8 53.9-53.1 99.2l-4.5.9c-1.3.3-2.5.5-3.9.7zm41.3-8.2c4.9-29.5 22.4-52.1 41.2-68.5 8.5-7.4 17.1-13.4 24.4-17.9l4.7 72.4-70.2 14zM341.6 128H106.4c11.2-55.1 59.9-96 117.6-96s106.4 40.9 117.6 96zM134.4 384h179.2c54.4 0 98.9 42.4 102.2 96H310.6L241 410.3c-9.4-9.4-24.6-9.4-33.9 0L137.4 480H32.2c3.3-53.6 47.8-96 102.2-96zm89.6 54.6 41.4 41.4h-82.8l41.4-41.4zM25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-74.2-60.2-134.4-134.4-134.4H134.4C60.2 352 0 412.2 0 486.4 0 500.5 11.5 512 25.6 512z"
        }
    ]
};

const FalUserCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserCheck",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm141.7 208c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4zm457-116.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L496 281.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"
        }
    ]
};

const FalUserChef = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserChef",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 64c0 13.9 8.9 25.8 21.3 30.2 6.4 2.3 10.7 8.3 10.7 15.1V144h192v-34.7c0-6.8 4.3-12.8 10.7-15.1C343.1 89.8 352 77.9 352 64c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-17.7-14.3-32-32-32S96 46.3 96 64zm32-64c19.1 0 36.3 8.4 48 21.7C187.7 8.4 204.9 0 224 0s36.3 8.4 48 21.7C283.7 8.4 300.9 0 320 0c35.3 0 64 28.7 64 64 0 23.7-12.9 44.4-32 55.4V176c0 70.7-57.3 128-128 128S96 246.7 96 176v-56.6c-19.1-11-32-31.7-32-55.4 0-35.3 28.7-64 64-64zm96 272c53 0 96-43 96-96H128c0 53 43 96 96 96zM112 372.6c0 7.1-4.7 13.3-11.4 15.3C60.9 399.8 32 436.5 32 480h96v-43.5c0-18.7 10.9-35.7 27.9-43.6l33.4-15.4-77.3-36.1v31.2zM160 480h256c0-43.5-28.9-80.2-68.6-92-6.8-2-11.4-8.3-11.4-15.3V345l-166.7 76.9c-5.7 2.6-9.3 8.3-9.3 14.5V480zm177.3-170.9-1.4-3c3-1.4 6.2-2.1 9.5-2.1 12.5 0 22.5 10.1 22.5 22.5v34.8c46.9 19 80 65 80 118.7 0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32 0-53.7 33.1-99.7 80-118.7v-34.8C80 314 90.1 304 102.5 304c3.3 0 6.5.7 9.5 2.1l112 52.2 111.9-52.2 1.4 3zM240 416a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm48 16a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalUserClock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserClock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM32 480c1.2-79.7 66.2-144 146.3-144h91.4c18.2 0 35.6 3.3 51.7 9.4 1.4-10.8 3.8-21.4 7-31.5-18.4-6.4-38.2-9.9-58.8-9.9h-91.3C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h365.1c-12.9-9.1-24.5-19.9-34.6-32H32zm320-352a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm144 128a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm0 256a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm0-224c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32v-48c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalUserCowboy = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserCowboy",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176.1 32c4.8 0 7.3.6 8.5 1 1 .3 1.9.8 3.6 1.8.1.1.4.3.7.5C192.3 37.9 205.8 48 224 48s31.7-10.1 35.1-12.7c.3-.3.6-.4.7-.5 1.6-1.1 2.5-1.5 3.6-1.8 1.1-.4 3.6-1 8.5-1 .6.2 3 1.2 7 5.7 5.8 6.6 12 17.3 18.1 31.9 6.5 15.4 11.9 33 16.3 50.1-25 5-54.6 8.3-89.3 8.3s-64.4-3.2-89.3-8.3c4.4-17.1 9.8-34.7 16.3-50.1 6.1-14.6 12.4-25.3 18.1-31.9 4-4.6 6.3-5.6 7-5.7zm168.3 80C330.8 59.3 307.6 0 272 0c-18 0-25.9 5.4-32.5 9.9-4.8 3.3-8.8 6.1-15.5 6.1s-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-35.6 0-58.8 59.3-72.4 112-7.1-2.2-13.7-4.5-19.8-6.9-32.4-12.7-49.4-27.2-55-34.7-4.7-6.3-13.3-8.2-20.2-4.6S-1.7 77.6.8 85.1c9.3 27.9 35 62.4 72.5 89.9 38 27.7 89.2 49.1 150.6 49.1s112.7-21.4 150.6-49.1c37.6-27.4 63.2-62 72.5-89.9 2.5-7.4-.8-15.6-7.8-19.2s-15.5-1.7-20.2 4.6c-5.6 7.5-22.6 22-55 34.7-6.1 2.4-12.7 4.7-19.8 6.9zm-72.7-80a.1.1 0 1 0 .1.1.1.1 0 1 0-.1-.1zm-95.6 0a.1.1 0 1 0 .3.1.1.1 0 1 0-.3-.1zM92.2 149.1c-5.5-4-10.7-8.2-15.5-12.4C112.4 149.9 160.9 160 224 160s111.6-10.1 147.3-23.4c-4.8 4.2-10 8.4-15.5 12.4-33.3 24.4-78 43-131.8 43s-98.5-18.6-131.8-42.9zm8.5 266.9h246.6c32.3 0 59.5 24 63.5 56.1l1 7.9H36.2l1-7.9c4-32 31.2-56.1 63.5-56.1zm0-32c-48.4 0-89.3 36.1-95.3 84.1l-1 7.9c-2.3 19.1 12.6 36 31.8 36h375.6c19.2 0 34.1-16.9 31.8-36l-1-7.9c-6-48-46.8-84.1-95.3-84.1H100.7zM224 352c70 0 126.9-56.2 128-126-10.5 5.2-21.6 10-33.3 14.1C311 285.4 271.5 320 224 320s-87-34.6-94.7-79.9c-11.6-4.1-22.8-8.8-33.3-14.1 1.1 69.8 58 126 128 126z"
        }
    ]
};

const FalUserCrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserCrown",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M238.7 4.4C234.3 1.5 229.2 0 224 0s-10.3 1.5-14.7 4.4l-32.4 21.7c-5.4 3.6-12.4 3.6-17.8 0L124 2.7C121.4.9 118.3 0 115.2 0H112c-8.8 0-16 7.2-16 16v128c0 70.7 57.3 128 128 128s128-57.3 128-128V16c0-8.8-7.2-16-16-16h-3.2c-3.2 0-6.2.9-8.9 2.7l-35 23.4c-5.4 3.6-12.4 3.6-17.8 0L238.7 4.4zM320 112H128V43.8l13.4 8.9c16.1 10.7 37.1 10.7 53.3 0L224 33.1l29.4 19.6c16.1 10.7 37.1 10.7 53.3 0l13.3-8.9V112zm-192 32h192c0 53-43 96-96 96s-96-43-96-96zm40 192h112c75.1 0 136 60.9 136 136v8H32v-8c0-75.1 60.9-136 136-136zm0-32C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168z"
        }
    ]
};

const FalUserDoctorHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserDoctorHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 144c0 53-43 96-96 96s-96-43-96-96v-16h34.3c31.7 0 61.1-14.5 80.4-38.7l6.3 6.3c10.5 10.5 24.7 16.4 39.6 16.4h30.1c.9 5.2 1.3 10.5 1.3 16v16zm32-16C352 57.3 294.7 0 224 0S96 57.3 96 128c0 35.3-16.6 68.4-44.8 89.6l-4.3 3.2c-9.4 7.1-14.9 18.1-14.9 29.9 0 20.6 16.7 37.3 37.3 37.3H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H69.3c-2.9 0-5.3-2.4-5.3-5.3 0-1.7.8-3.3 2.1-4.3l4.3-3.2c15.8-11.9 28.8-26.7 38.4-43.4C129.5 242.6 173.3 272 224 272s94.5-29.4 115.2-72.2c9.6 16.7 22.6 31.5 38.4 43.4l4.3 3.2c1.3 1 2.1 2.6 2.1 4.3 0 2.9-2.4 5.3-5.3 5.3H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h58.7c20.6 0 37.3-16.7 37.3-37.3 0-11.8-5.5-22.8-14.9-29.9l-4.3-3.2C368.6 196.4 352 163.3 352 128zM225.5 57.1C213.5 81 189.1 96 162.3 96h-28.8c13.2-37.3 48.7-64 90.5-64 35.5 0 66.6 19.3 83.2 48h-18.6c-6.4 0-12.5-2.5-17-7l-20.3-20.3c-6.2-6.2-16.4-6.2-22.6 0-1.3 1.3-2.4 2.8-3.1 4.5zM270.8 336c5.8 0 11.5.3 17.2 1v33.3c-23.1 6.9-40 28.3-40 53.7v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16v-24c0-25.4-16.9-46.8-40-53.7v-25.8c55.6 20 95.5 73 96 135.5H32c.5-68.2 48.2-125.3 112-140.2v30.9c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3V336h94.8zM176 416a16 16 0 1 1-32 0 16 16 0 1 1 32 0zM0 481.2c0 17 13.8 30.8 30.8 30.8h386.4c17 0 30.8-13.8 30.8-30.8 0-97.9-79.3-177.2-177.2-177.2h-93.6C79.3 304 0 383.3 0 481.2z"
        }
    ]
};

const FalUserDoctorHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserDoctorHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128c0-5.5-.5-10.8-1.3-16h-30.1c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128H128v16c0 53 43 96 96 96s96-43 96-96v-16zm-91.3-75.3c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6c-16.6-28.7-47.7-48-83.2-48-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9.8-1.6 1.8-3.1 3.1-4.5zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 214.7 96 144v-16zm80 208v34.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3v-30.9C80.2 354.7 32.6 411.8 32 480h384c-.5-62.4-40.4-115.4-96-135.5v25.8c23.1 6.9 40 28.3 40 53.7v24c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-24c0-25.4 16.9-46.8 40-53.7V337c-5.6-.7-11.4-1-17.2-1H176zm-32 80a16 16 0 1 0 32 0 16 16 0 1 0-32 0zM0 481.2C0 383.3 79.3 304 177.2 304h93.6c97.9 0 177.2 79.3 177.2 177.2 0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2z"
        }
    ]
};

const FalUserDoctorMessage = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserDoctorMessage",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm96 128a128 128 0 1 1 0-256 128 128 0 1 1 0 256zm-64 176a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm16-96v34.7c18.6 6.6 32 24.4 32 45.3 0 26.5-21.5 48-48 48s-48-21.5-48-48c0-20.9 13.4-38.7 32-45.3v-30.9C80.2 354.7 32.6 411.8 32 480h384c-.5-62.4-40.4-115.4-96-135.5v25.8c23.1 6.9 40 28.3 40 53.7v24c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16s7.2-16 16-16v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-24c0-25.4 16.9-46.8 40-53.7V337c-5.6-.7-11.4-1-17.2-1H176zM0 481.2C0 383.3 79.3 304 177.2 304h93.6c97.9 0 177.2 79.3 177.2 177.2 0 17-13.8 30.8-30.8 30.8H30.8C13.8 512 0 498.2 0 481.2zM544 192h48c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H432c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h16c17.7 0 32 14.3 32 32v8l44.8-33.6c5.5-4.2 12.3-6.4 19.2-6.4zm-65.1 80.8-9.6 7.2-8.5 6.4c-2.4 1.8-5.7 2.1-8.4.8s-4.4-4.1-4.4-7.2v-56h-16c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v128c0 26.5-21.5 48-48 48h-48l-64 48-1.1.8z"
        }
    ]
};

const FalUserDoctor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserDoctor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0 128 128 0 1 0-256 0zm48 288a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm32-45.3V336h94.8c5.8 0 11.5.3 17.2 1v33.3c-23.1 6.9-40 28.3-40 53.7v24c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16v-8c0-13.3 10.7-24 24-24s24 10.7 24 24v8c-8.8 0-16 7.2-16 16s7.2 16 16 16h16c8.8 0 16-7.2 16-16v-24c0-25.4-16.9-46.8-40-53.7v-25.8c55.6 20 95.5 73 96 135.5H32c.5-68.2 48.2-125.3 112-140.2v30.9c-18.6 6.6-32 24.4-32 45.3 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.7-32-45.3zm1.2-66.7C79.3 304 0 383.3 0 481.2c0 17 13.8 30.8 30.8 30.8h386.4c17 0 30.8-13.8 30.8-30.8 0-97.9-79.3-177.2-177.2-177.2h-93.6z"
        }
    ]
};

const FalUserGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserGear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480h319c15.6 13.1 36.9 13.7 53 4.8v.9c0 9.2 2.7 18.5 7.9 26.3H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c11.8 0 23.4 1.2 34.5 3.3-1.6 13.7 3.2 26.6 11.6 36.1-14.5-4.8-30-7.4-46.2-7.4h-91.3c-80 0-145 64.3-146.3 144zm64-352a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm277.5 266.1 17.2 30.5c15.9-6.3 33-3.7 46 3.7 12.6 7.2 23.6 20.1 26.6 36.7H497c3-16.6 13.9-29.5 26.5-36.7 12.9-7.4 30-9.9 45.9-3.6l17.2-30.5c-12.8-11.4-18.5-27.7-18.5-42.4s5.7-31 18.5-42.4l-17.2-30.5c-15.9 6.3-32.9 3.7-45.9-3.6-12.7-7.3-23.6-20.3-26.5-36.9h-33.7c-3.1 16.6-14 29.5-26.6 36.7-13 7.4-30 9.9-46 3.7l-17.2 30.5c12.8 11.4 18.5 27.7 18.5 42.4s-5.7 31-18.5 42.4zm26.1 61.7-1.6 1c-10.7 6.3-24.4 2.6-30.5-8.2L341 401.7c-5.7-10.2-2.3-23.1 7.8-29 7.3-4.3 11.2-12.5 11.2-21s-3.9-16.7-11.2-21c-10-5.9-13.5-18.8-7.8-29l26.4-46.9c6.1-10.8 19.9-14.5 30.5-8.2l1.6 1c6.5 3.9 14.6 3.4 21.2-.3 6.6-3.8 11.3-10.6 11.3-18.2v-1.4c0-11.7 9.5-21.3 21.3-21.3h53.4c11.8 0 21.4 9.6 21.4 21.4v1.6c0 7.5 4.6 14.2 11.1 18 6.5 3.7 14.5 4.2 21 .3l1.8-1c10.7-6.3 24.4-2.6 30.5 8.2l26.5 46.8c5.7 10.2 2.3 23-7.8 29-7.3 4.3-11.2 12.6-11.2 21s3.9 16.7 11.2 21c10 5.9 13.5 18.8 7.8 29l-26.4 46.9c-6.1 10.8-19.9 14.5-30.5 8.2l-1.8-1c-6.5-3.8-14.5-3.4-21 .3-6.5 3.7-11.1 10.4-11.1 18v1.6c0 11.8-9.6 21.4-21.4 21.4h-53.4c-11.7 0-21.3-9.5-21.3-21.3v-1.4c0-7.6-4.6-14.4-11.3-18.2-6.6-3.7-14.7-4.2-21.2-.3zm80.5-160.1a56 56 0 1 1 0 112 56 56 0 1 1 0-112zm0 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalUserGraduate = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserGraduate",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M228.7.7c-3.1-.9-6.3-.9-9.4 0l-208 64C4.6 66.8 0 73 0 80s4.6 13.2 11.3 15.3l20.7 6.4v71.7L.8 266.9c-1.6 4.9-.8 10.3 2.2 14.5s7.8 6.6 13 6.6h64c5.1 0 10-2.5 13-6.6s3.8-9.5 2.2-14.4L64 173.4v-61.9l155.3 47.8c3.1.9 6.3.9 9.4 0l208-64C443.4 93.2 448 87 448 80s-4.6-13.2-11.3-15.3l-208-64zM224 127.3 70.4 80 224 32.7 377.6 80 224 127.3zm-35.9 312.5c19.1 21.5 52.7 21.5 71.8 0l71.1-80c49.2 18 84.4 65 85 120.2H32c.5-55.2 35.7-102.3 85-120.2l71.1 80zm-78.5-111.4C45.9 350 0 410.3 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-71-45.9-131.3-109.6-152.8-10.9-3.7-22.7.4-30.3 9l-72.1 81c-6.4 7.2-17.6 7.2-23.9 0L140 337.4c-7.6-8.6-19.4-12.7-30.3-9zM48 226.6l9.8 29.4H38.2l9.8-29.4zm48-71.8V176c0 70.7 57.3 128 128 128s128-57.3 128-128v-21.2l-32 9.8V176c0 53-43 96-96 96s-96-43-96-96v-11.3l-32-9.8z"
        }
    ]
};

const FalUserGroupCrown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserGroupCrown",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 0c5.2 0 10.3 1.5 14.7 4.4L271.2 26c5.4 3.6 12.4 3.6 17.8 0l35-23.3c2.6-1.8 5.7-2.7 8.9-2.7h3.1c8.8 0 16 7.2 16 16v128c0 70.7-57.3 128-128 128S96 214.7 96 144V16c0-8.8 7.2-16 16-16h3.2c3.2 0 6.2.9 8.9 2.7l35.1 23.4c5.4 3.6 12.4 3.6 17.8 0l32.3-21.7C213.7 1.5 218.8 0 224 0zm96 43.8-13.4 8.9c-16.1 10.7-37.1 10.7-53.3 0L224 33.1l-29.4 19.6c-16.1 10.7-37.1 10.7-53.3 0L128 43.8V112h192V43.8zM224 240c53 0 96-43 96-96H128c0 53 43 96 96 96zM32 472v8h384v-8c0-75.1-60.9-136-136-136H168c-75.1 0-136 60.9-136 136zm-32 0c0-92.8 75.2-168 168-168h112c92.8 0 168 75.2 168 168v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8zm432-216c-27.7 0-53-10.1-72.6-26.7 1.9-2.9 3.6-6 5.3-9 3.6-6.7 6.8-13.7 9.5-21 14.6 15.2 35.1 24.7 57.8 24.7 44.2 0 80-35.8 80-80s-35.8-80-80-80c-18 0-34.6 6-48 16V42.8c14.5-6.9 30.8-10.8 48-10.8 61.9 0 112 50.1 112 112s-50.1 112-112 112zm177.3 256H471.4c5.4-9.4 8.6-20.3 8.6-32h128c-.7-70.8-58.3-128-129.3-128H440c-8.8-11.7-18.8-22.4-29.8-31.8 2.4-.1 4.7-.2 7.1-.2h61.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7z"
        }
    ]
};

const FalUserGroupSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserGroupSimple",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M88 136a72 72 0 1 1 144 0 72 72 0 1 1-144 0zm176 0a104 104 0 1 0-208 0 104 104 0 1 0 208 0zm144 0a72 72 0 1 1 144 0 72 72 0 1 1-144 0zm176 0a104 104 0 1 0-208 0 104 104 0 1 0 208 0zM208 320c53 0 96 43 96 96v16c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16v-16c0-53 43-96 96-96h80zm-80-32C57.3 288 0 345.3 0 416v16c0 26.5 21.5 48 48 48h240c26.5 0 48-21.5 48-48v-16c0-32.4-12-61.9-31.8-84.4-23.5-26.7-57.9-43.6-96.2-43.6h-80zm304 192h80c70.7 0 128-57.3 128-128v-16c0-26.5-21.5-48-48-48H352c-12.7 0-24.2 4.9-32.8 13 7.7 7.4 14.7 15.7 20.8 24.5 2.9-3.4 7.2-5.5 12.1-5.5H592c8.8 0 16 7.2 16 16v16c0 53-43 96-96 96h-80c-24.6 0-47-9.2-64-24.4v8.4c0 9.8-1.8 19.2-5 27.8 19.9 12.8 43.6 20.2 69 20.2z"
        }
    ]
};

const FalUserGroup = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserGroup",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm141.7 208c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4zm431 208c17 0 30.7-13.8 30.7-30.7 0-89.1-72.2-161.3-161.3-161.3h-61.4c-4.4 0-8.8.2-13.2.5 11.3 9.4 21.6 19.9 30.7 31.5h43.9c71 0 128.6 57.2 129.3 128H480v2.3c0 10.8-2.8 20.9-7.6 29.7h136.9zM432 256c61.9 0 112-50.1 112-112S493.9 32 432 32c-24.8 0-47.7 8.1-66.3 21.7 5.2 9.8 9.3 20.3 12.4 31.2C392.3 71.9 411.2 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-25.2 0-47.6-11.6-62.3-29.8-4.7 10.3-10.4 19.9-17 28.9C373 243.4 401 256 432 256z"
        }
    ]
};

const FalUserHairBuns = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserHairBuns",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M314.5 96h-32c-12.7 0-24.9-5.1-33.9-14.1l-13.3-13.2c-6.2-6.2-16.4-6.2-22.6 0l-13.3 13.2c-9 9-21.2 14.1-33.9 14.1h-32c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64zm5.5 32v16c0 53-43 96-96 96s-96-43-96-96v-16h37.5c21.2 0 41.6-8.4 56.6-23.4l1.9-1.9 1.9 1.9c15 15 35.4 23.4 56.6 23.4H320zm-96 144c46.7 0 87.5-25 109.9-62.3 8.7 8.8 20.8 14.3 34.1 14.3 26.5 0 48-21.5 48-48v-64c0-26.5-21.5-48-48-48-10.6 0-20.4 3.4-28.3 9.2C319.2 29.9 275.1 0 224 0s-95.2 29.9-115.7 73.2C100.4 67.4 90.6 64 80 64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48 13.4 0 25.4-5.5 34.1-14.3C136.5 247 177.3 272 224 272zm128-96v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16zM168 336h112c75.1 0 136 60.9 136 136v8H32v-8c0-75.1 60.9-136 136-136zm0-32C75.2 304 0 379.2 0 472v8c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32v-8c0-92.8-75.2-168-168-168H168zM96 144v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64c0-8.8 7.2-16 16-16s16 7.2 16 16v32z"
        }
    ]
};

const FalUserHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128c0-5.5-.5-10.8-1.3-16h-30.1c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128H128v16c0 53 43 96 96 96s96-43 96-96v-16zM224 0c70.7 0 128 57.3 128 128 0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9 0 20.6-16.7 37.3-37.3 37.3H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.7c2.9 0 5.3-2.4 5.3-5.3 0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3 0 2.9 2.4 5.3 5.3 5.3H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H69.3C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128 96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6c-16.6-28.7-47.7-48-83.2-48-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9.8-1.6 1.8-3.1 3.1-4.5zM32 480h384c-1.9-71-60-128-131.5-128H163.6C92.1 352 33.9 409 32 480zm-32 3.6C0 393.2 73.2 320 163.6 320h120.8c90.4 0 163.6 73.2 163.6 163.6 0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"
        }
    ]
};

const FalUserHairMullet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserHairMullet",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 144c0 53-43 96-96 96s-96-43-96-96v-16c0-5.5.5-10.8 1.3-16h11.3c32.1 0 62.3-13.7 83.4-37.2 21.1 23.5 51.3 37.2 83.4 37.2h11.3c.9 5.2 1.3 10.5 1.3 16v16zM97.2 110.5c-.8 5.7-1.2 11.6-1.2 17.5v16c0 15.6 2.8 30.6 7.9 44.5-.7 26.5-7.7 46.3-21.3 66.6-2.5 3.8-3.3 8.5-2.2 13s4.2 8.2 8.3 10.2l16 8c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-.6-.3c4.6-8.7 8.3-17.6 11.1-26.9 5.7 6.3 12.1 12 19 17l-11.8 35.5c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l10-29.9c14.5 5.7 30.3 8.8 46.9 8.8s32.3-3.1 46.9-8.8l10 29.9c2.8 8.4 11.9 12.9 20.2 10.1s12.9-11.9 10.1-20.2l-11.8-35.5c6.9-5 13.2-10.7 19-17 2.8 9.3 6.5 18.2 11.1 26.9l-.6.3c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l16-8c4.1-2.1 7.1-5.8 8.3-10.2s.4-9.2-2.2-13c-13.5-20.3-20.6-40.2-21.3-66.6 5.1-13.9 7.9-28.8 7.9-44.5v-16c0-5.9-.4-11.8-1.2-17.5 5.4-2.6 9.2-8.1 9.2-14.5 0-8.8-7.2-16-16-16h-1.3c-19-46.9-65-80-118.7-80s-99.7 33.1-118.7 80H104c-8.8 0-16 7.2-16 16 0 6.4 3.8 11.9 9.2 14.5zM140.8 80c16.6-28.7 47.6-48 83.2-48s66.6 19.3 83.2 48c-26.7-.1-51.5-13.4-66.3-35.6l-3.5-5.3c-3-4.5-8-7.1-13.3-7.1s-10.3 2.7-13.3 7.1l-3.5 5.3A80.399 80.399 0 0 1 140.8 80zm22.7 272h120.9c71.5 0 129.6 57 131.5 128H32c1.9-71 60-128 131.5-128zm0-32C73.2 320 0 393.2 0 483.6 0 499.3 12.7 512 28.4 512h391.2c15.7 0 28.4-12.7 28.4-28.4 0-90.4-73.2-163.6-163.6-163.6H163.6z"
        }
    ]
};

const FalUserHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128c0-5.5-.5-10.8-1.3-16h-30.1c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128H128v16c0 53 43 96 96 96s96-43 96-96v-16zm-12.8-48c-16.6-28.7-47.7-48-83.2-48-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9.8-1.6 1.8-3.1 3.1-4.5 6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 214.7 96 144v-16zM32 480h384c-1.9-71-60-128-131.5-128H163.6C92.1 352 33.9 409 32 480zm-32 3.6C0 393.2 73.2 320 163.6 320h120.8c90.4 0 163.6 73.2 163.6 163.6 0 15.7-12.7 28.4-28.4 28.4H28.4C12.7 512 0 499.3 0 483.6z"
        }
    ]
};

const FalUserHeadset = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserHeadset",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32c-88.4 0-160 71.6-160 160v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16C32 86 118 0 224 0s192 86 192 192v16c0 61.9-50.1 112-112 112h-96c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32h32c44.2 0 80-35.8 80-80v-16c0-88.4-71.6-160-160-160zm0 32c70.7 0 128 57.3 128 128 0 13.9-2.2 27.3-6.3 39.8-8.3 14.5-23.9 24.2-41.7 24.2h-8.4c15.2-17 24.4-39.4 24.4-64 0-53-43-96-96-96s-96 43-96 96c0 24.6 9.3 47.1 24.5 64.1-5.4 9.4-8.5 20.3-8.5 31.9 0 1.4 0 2.7.1 4C114.8 268.6 96 232.5 96 192c0-70.7 57.3-128 128-128zm-16 288h105.6c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4 0 412.2 60.2 352 134.4 352H208zm105.6 32H134.4c-54.4 0-98.9 42.4-102.2 96h383.6c-3.3-53.6-47.8-96-102.2-96z"
        }
    ]
};

const FalUserHelmetSafety = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserHelmetSafety",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 60.8c-28.7 16.6-48 47.6-48 83.2h192c0-35.5-19.3-66.6-48-83.2V80c0 8.8-7.2 16-16 16s-16-7.2-16-16V32h-32v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V60.8zM271.2 25C318.5 43.8 352 90 352 144h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h16c0-54 33.5-100.2 80.8-119C180 10.7 192.7 0 208 0h32c15.3 0 28 10.7 31.2 25zM224 320c-65.3 0-119.1-48.9-127-112h32.3c7.6 45.4 47.1 80 94.7 80s87.1-34.6 94.7-80H351c-7.9 63.1-61.7 112-127 112zm191.8 160c-3.3-53.6-47.8-96-102.2-96H134.4c-54.4 0-98.9 42.4-102.2 96h383.6zM0 486.4C0 412.2 60.2 352 134.4 352h179.2c74.2 0 134.4 60.2 134.4 134.4 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4z"
        }
    ]
};

const FalUserInjured = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserInjured",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128c0 53-43 96-96 96s-96-43-96-96c0-5.5.5-10.8 1.3-16h189.4c.9 5.2 1.3 10.5 1.3 16zm-12.8-48h-69.6l39.8-31.8c12.2 8.2 22.4 19.1 29.8 31.8zm-63.4-46-57.4 46h-45.6c16.6-28.7 47.6-48 83.2-48 6.8 0 13.4.7 19.8 2zM352 128a128 128 0 1 0-256 0 128 128 0 1 0 256 0zM32 480c.5-33.7 12.4-64.6 32-89v89H32zm64 0V361.3c12.9-8.8 27.3-15.6 42.7-19.9L226.9 480H96zm224-32c0 17.7-14.3 32-32 32h-23.2l-40.7-64H288c17.7 0 32 14.3 32 32zM80 512h338.3c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512H80zm336-32h-72.6c5.4-9.4 8.6-20.3 8.6-32 0-35.3-28.7-64-64-64h-84.3l-30.5-47.9c1.7-.1 3.4-.1 5.1-.1h91.4c80 0 145 64.3 146.3 144z"
        }
    ]
};

const FalUserLargeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserLargeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m541 512-40.5-32H96c.7-70.8 58.3-128 129.3-128h113l-40.5-32h-72.5C136.2 320 64 392.2 64 481.3c0 17 13.8 30.7 30.7 30.7H541zm-77-368C464 64.5 399.5 0 320 0c-54.4 0-101.8 30.2-126.3 74.8L219.3 95c18.2-37.3 56.4-63 100.7-63 61.9 0 112 50.1 112 112 0 34.9-15.9 66-40.9 86.6l25.6 20.2c29-26.4 47.3-64.5 47.3-106.8zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalUserLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserLarge",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 144a112 112 0 1 0-224 0 112 112 0 1 0 224 0zm-256 0a144 144 0 1 1 288 0 144 144 0 1 1-288 0zM32 480h448c-.7-70.8-58.3-128-129.3-128H161.3c-71 0-128.6 57.2-129.3 128zm-32 1.3C0 392.2 72.2 320 161.3 320h189.4c89.1 0 161.3 72.2 161.3 161.3 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3z"
        }
    ]
};

const FalUserLock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserLock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480h352c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7-.2 2.1-.3 4.2-.3 6.3v39c-26.8-33.5-68-55-114.3-55h-91.4c-80 0-145 64.3-146.3 144zm64-352a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm432 96c-26.5 0-48 21.5-48 48v48h96v-48c0-26.5-21.5-48-48-48zm-80 48c0-44.2 35.8-80 80-80s80 35.8 80 80v48c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48zm0 80v128h160V352H448z"
        }
    ]
};

const FalUserMagnifyingGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserMagnifyingGlass",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a96 96 0 1 1 192 0 96 96 0 1 1-192 0zM32 480c1.2-79.7 66.2-144 146.3-144h91.4c6.5 0 12.9.4 19.2 1.2-.6-5.7-.9-11.4-.9-17.2 0-5.1.2-10.1.7-15-6.2-.7-12.6-1-19-1h-91.4C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7V480H32zm192-224a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm224-31.9a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 224c29.6 0 56.8-10 78.5-26.9l86.2 86.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-86.2-86.2C566 377 576 349.7 576 320.2c0-70.7-57.3-128-128-128s-128 57.3-128 128 57.3 128 128 128z"
        }
    ]
};

const FalUserMinus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserMinus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm141.7 208c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4zM432 224c-8.8 0-16 7.2-16 16s7.2 16 16 16h192c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"
        }
    ]
};

const FalUserMusic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserMusic",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480h257.4c2.5 12.2 8.2 23 16.1 32H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c43.5 0 83.3 15.6 114.3 41.4v40.2c-1.5 0-2.9 0-4.4.1-26.8-30.4-66.1-49.7-109.9-49.7h-91.4c-80 0-145 64.3-146.3 144zm64-352a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm501.9 39.8c20.7-6.9 42.1 8.5 42.1 30.4V392c0 1.1-.1 2.2-.3 3.2.2 1.6.3 3.2.3 4.8 0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c11.7 0 22.6 2.3 32 6.4v-88.2l-160 53.3V464c0 26.5-28.7 48-64 48s-64-21.5-64-48 28.7-48 64-48c11.7 0 22.6 2.3 32 6.4V251.5c0-13.8 8.8-26 21.9-30.4l160-53.3zM448 289.8l160-53.3v-38.3l-160 53.3v38.3zM608 400c0-.9-.4-4.2-5.9-8.3-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3zm-192 64c0-.9-.4-4.2-5.9-8.3-5.5-4.1-14.6-7.7-26.1-7.7s-20.5 3.5-26.1 7.7c-5.5 4.1-5.9 7.4-5.9 8.3s.4 4.2 5.9 8.3c5.5 4.1 14.6 7.7 26.1 7.7s20.5-3.5 26.1-7.7c5.5-4.1 5.9-7.4 5.9-8.3z"
        }
    ]
};

const FalUserNinja = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserNinja",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm32 0c0 70.7-57.3 128-128 128-63.6 0-116.3-46.3-126.3-107.1l-38.4 38.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L89.4 112 36.7 59.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l45.2 45.2C123 34 169.6 0 224 0c70.7 0 128 57.3 128 128zM211.1 452.9l-82.5-108.2C72.9 364.8 33 417.7 32 480h199.7l-20.2-26.5c-.1-.2-.3-.4-.4-.6zm33.1-9.4 27.7 36.5H416c-1-62.3-40.9-115.2-96.6-135.3l-75.3 98.8zM418.3 512H29.7C13.3 512 0 498.7 0 482.3 0 399.5 56.4 330 132.8 309.9c6-1.6 12.2.9 15.9 5.8l62.5 83.3c6.4 8.5 19.2 8.5 25.6 0l62.5-83.3c3.7-4.9 9.9-7.4 15.9-5.8C391.6 330 448 399.5 448 482.3c0 16.4-13.3 29.7-29.7 29.7zM176 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalUserNurseHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserNurseHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 144V76.9l96-42 96 42V144H128zM96 76.9V160c0 35.3-16.6 68.4-44.8 89.6l-4.3 3.2c-9.4 7.1-14.9 18.1-14.9 29.9 0 20.6 16.7 37.3 37.3 37.3H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H69.3c-2.9 0-5.3-2.4-5.3-5.3 0-1.7.8-3.3 2.1-4.3l4.3-3.2c15.8-11.9 28.8-26.7 38.4-43.3C129.5 274.6 173.3 304 224 304s94.5-29.4 115.2-72.2c9.6 16.7 22.6 31.5 38.4 43.3l4.3 3.2c1.3 1 2.1 2.6 2.1 4.3 0 2.9-2.4 5.3-5.3 5.3H320c-8.8 0-16 7.2-16 16s7.2 16 16 16h58.7c20.6 0 37.3-16.7 37.3-37.3 0-11.8-5.5-22.8-14.9-29.9l-4.3-3.2C368.6 228.4 352 195.3 352 160V76.9c0-12.7-7.5-24.2-19.2-29.3l-96-42c-8.2-3.6-17.5-3.6-25.7 0l-96 42C103.5 52.7 96 64.2 96 76.9zM320 176c0 53-43 96-96 96-35.5 0-66.6-19.3-83.2-48h21.5c35.5 0 68.3-18.3 87-48H320zm-112.8 0c-12.4 10.2-28.2 16-44.8 16h-33c-.9-5.2-1.3-10.5-1.3-16h79.2zm-76.4 206 59.3 59.3c18.7 18.7 49.1 18.7 67.9 0l59.2-59.3c52.8 1.8 95.4 43.5 98.6 95.9H32.2c3.2-52.4 45.9-94.1 98.6-95.9zm20-25.3c-4.3-4.3-10.2-6.8-16.4-6.8C60.2 349.9 0 410.1 0 484.3c0 14.1 11.5 25.6 25.6 25.6h396.8c14.1 0 25.6-11.5 25.6-25.6 0-74.2-60.2-134.4-134.4-134.4-6.1 0-12 2.4-16.4 6.8l-61.9 61.9c-6.2 6.2-16.4 6.2-22.6 0l-61.9-61.9zM208 56v16h-16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16h16c4.4 0 8-3.6 8-8V80c0-4.4-3.6-8-8-8h-16V56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8z"
        }
    ]
};

const FalUserNurseHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserNurseHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 144V76.9l96-42 96 42V144H128zM96 76.9V176c0 70.7 57.3 128 128 128s128-57.3 128-128V76.9c0-12.7-7.5-24.2-19.2-29.3l-96-42c-8.2-3.6-17.5-3.6-25.7 0l-96 42C103.5 52.7 96 64.2 96 76.9zM320 176c0 53-43 96-96 96-35.5 0-66.6-19.3-83.2-48h21.5c35.5 0 68.3-18.3 87-48H320zm-112.8 0c-12.4 10.2-28.2 16-44.8 16h-33c-.9-5.2-1.3-10.5-1.3-16h79.2zm-86.1 180.3 69 69c18.7 18.7 49.1 18.7 67.9 0l69-69c51.4 16.8 88.5 64.9 89.1 121.6H32c.6-56.8 37.7-104.9 89.1-121.6zm21.7-23.5c-7.5-7.5-18.3-11-28.4-7.9C48.2 344.9 0 406.4 0 479.2c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-72.8-48.2-134.3-114.4-154.4-10.1-3.1-20.9.4-28.4 7.9l-69.8 69.8c-6.2 6.2-16.4 6.2-22.6 0L143 332.7zM208 56v16h-16c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h16v16c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-16h16c4.4 0 8-3.6 8-8V80c0-4.4-3.6-8-8-8h-16V56c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8z"
        }
    ]
};

const FalUserNurse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserNurse",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128v16h192V70.2l-96-36-96 36V128zm-32 32V70.2c0-13.3 8.3-25.3 20.8-30l96-36c7.2-2.7 15.2-2.7 22.5 0l96 36c12.5 4.7 20.8 16.6 20.8 30V176c0 70.7-57.3 128-128 128s-128-57.3-128-128v-16zm224 16H128c0 53 43 96 96 96s96-43 96-96zM119 359.1C68.7 376.5 32.5 424 32 480h384c-.5-56-36.7-103.5-86.9-120.9L259 433.6c-19 20.1-51 20.1-69.9 0L119 359.1zm22.4-22.9 71 75.5c6.3 6.7 17 6.7 23.3 0l71-75.5c7.6-8.1 18.9-11.9 29.4-8.5C401 348.6 448 409.4 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-71.9 47-132.7 111.9-153.6 10.5-3.4 21.8.4 29.4 8.5zM216 48h16c4.4 0 8 3.6 8 8v16h16c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-16v16c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-16h-16c-4.4 0-8-3.6-8-8V80c0-4.4 3.6-8 8-8h16V56c0-4.4 3.6-8 8-8z"
        }
    ]
};

const FalUserPen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserPen",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480h290.2l-1 3.8c-2.4 9.5-1.8 19.3 1.4 28.2H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c44.2 0 84.6 16.1 115.8 42.7l-22.7 22.7c-25.3-20.9-57.7-33.4-93.1-33.4h-91.4c-80 0-145 64.3-146.3 144zm64-352a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm486.8 136c-6.2-6.2-16.4-6.2-22.6 0l-24.8 24.8 40 40 24.8-24.8c6.2-6.2 6.2-16.4 0-22.6L582.8 264zM406.5 417.7c-2.1 2.1-3.5 4.6-4.2 7.4l-12.3 49 49-12.3c2.8-.7 5.4-2.2 7.4-4.2l106.3-106.2-40-40-106.2 106.3zm131-176.3c18.7-18.7 49.1-18.7 67.9 0l17.4 17.4c18.7 18.7 18.7 49.1 0 67.9L469.1 480.3c-6.2 6.2-13.9 10.5-22.3 12.6l-74.9 18.7c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.7-4.2-15.2l18.7-74.9c2.1-8.4 6.5-16.1 12.6-22.3l153.7-153.6z"
        }
    ]
};

const FalUserPilotTie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserPilotTie",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m230.9.8 144 32c11.4 2.5 20.5 11.1 23.8 22.3s.2 23.3-8.1 31.6l-6.2-6.2 6.2 6.2-22.6 22.6v1.6c0 15.6-7.6 31.8-23.2 40.1-22.5 12-59.5 25-120.8 25s-98.3-13.1-120.8-25C87.6 142.7 80 126.5 80 110.9v-1.6L57.4 86.6c-8.3-8.2-11.4-20.3-8.1-31.5s12.4-19.8 23.8-22.3l144-32c4.6-1 9.3-1 13.9 0zM80 64l27.3 27.3c3 3 4.7 7.1 4.7 11.3v8.2c0 5.8 2.8 10 6.2 11.8C135.8 132 167.6 144 224 144s88.2-12 105.8-21.3c3.4-1.8 6.2-6 6.2-11.8v-8.2c0-4.2 1.7-8.3 4.7-11.3L368 64 224 32 80 64zm96 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-6.1l18.4 36.9 51.6-68.7c71.3 3.2 128.1 62.1 128.1 134.2 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3l51.6 68.7 18.4-36.8H192c-8.8 0-16-7.2-16-16zm48 35.8-22.9 45.7 2.9 3.8 20 26.7 20-26.7 2.9-3.8-22.9-45.7zM184 480l-70.4-93.9C69 395.3 35.1 433.4 32.2 480H184zm80 0h151.8c-2.9-46.6-36.8-84.7-81.4-93.9L264 480zM96 192c0-2.9.1-5.8.3-8.7 9.1 4.3 19.6 8.5 31.8 12.1 1.8 51.4 44.1 92.6 95.9 92.6s94.1-41.1 95.9-92.6c12.2-3.6 22.7-7.8 31.8-12.1.2 2.9.3 5.8.3 8.7 0 70.7-57.3 128-128 128S96 262.7 96 192zm87.2-126.3L224 86.1l40.8-20.4c7.9-4 17.5-.7 21.5 7.2s.7 17.5-7.2 21.5l-48 24c-4.5 2.3-9.8 2.3-14.3 0l-48-24c-7.9-4-11.1-13.6-7.2-21.5s13.6-11.1 21.5-7.2z"
        }
    ]
};

const FalUserPilot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserPilot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M230.9.8c-4.6-1-9.3-1-13.9 0l-144 32c-11.3 2.5-20.5 11-23.7 22.3s-.2 23.3 8.1 31.6L80 109.3v1.6c0 15.6 7.6 31.8 23.2 40.1 22.5 12 59.5 25 120.8 25s98.3-13.1 120.8-25c15.5-8.2 23.2-24.5 23.2-40.1v-1.6l22.6-22.6-6.2-6.2 6.2 6.2c8.3-8.3 11.4-20.4 8.1-31.6s-12.4-19.8-23.8-22.3l-144-32zM80 64l144-32 144 32-27.3 27.3c-3 3-4.7 7.1-4.7 11.3v8.2c0 5.8-2.8 10-6.2 11.8C312.2 132 280.4 144 224 144s-88.2-12-105.8-21.3c-3.4-1.8-6.2-6-6.2-11.8v-8.2c0-4.2-1.7-8.3-4.7-11.3L80 64zm41.5 320.8 70.9 62.1c18.1 15.8 45.1 15.8 63.2 0l70.9-62.1c48.4 6.1 86.2 45.9 89.3 95.2H32.2c3-49.3 40.9-89.1 89.3-95.2zm15.7-28.8c-3-2.6-6.8-4.1-10.7-3.8C55.9 356.3 0 414.8 0 486.4 0 500.5 11.5 512 25.6 512h396.8c14.1 0 25.6-11.5 25.6-25.6 0-71.6-55.9-130.1-126.5-134.2-3.9-.2-7.8 1.2-10.7 3.8l-76.3 66.7c-6 5.3-15 5.3-21.1 0L137.1 356zM304 432c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7-9.1 4.3-19.6 8.5-31.8 12.1-1.8 51.5-44 92.6-95.9 92.6s-94.1-41.1-95.9-92.6c-12.2-3.6-22.7-7.8-31.8-12.1-.2 2.9-.3 5.8-.3 8.7zm87.2-126.3c-7.9-4-17.5-.7-21.5 7.2s-.7 17.5 7.2 21.5l48 24c4.5 2.3 9.8 2.3 14.3 0l48-24c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2L224 86.1l-40.8-20.4z"
        }
    ]
};

const FalUserPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserPlus",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm141.7 208c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4zm333.7 0c0 8.8 7.2 16 16 16s16-7.2 16-16v-80h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"
        }
    ]
};

const FalUserPoliceTie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserPoliceTie",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m230.9.8 144 32c11.4 2.5 20.5 11.1 23.8 22.3s.2 23.3-8.1 31.6l-6.2-6.2 6.2 6.2-22.6 22.6v1.6c0 15.6-7.6 31.8-23.2 40.1-22.5 12-59.5 25-120.8 25s-98.3-13.1-120.8-25C87.6 142.7 80 126.5 80 110.9v-1.6L57.4 86.6c-8.3-8.2-11.4-20.3-8.1-31.5s12.4-19.8 23.8-22.3l144-32c4.6-1 9.3-1 13.9 0zM80 64l27.3 27.3c3 3 4.7 7.1 4.7 11.3v8.2c0 5.8 2.8 10 6.2 11.8 11.9 6.3 30.3 13.8 58.4 18-12.8-19.5-16.6-41.7-16.6-57.4 0-6.5 4-12.4 10.1-14.9l48-19.2c3.8-1.5 8.1-1.5 11.9 0l48 19.2c6 2.5 10 8.4 10 14.9 0 15.7-3.8 37.9-16.5 57.5 28.1-4.2 46.5-11.7 58.4-18 3.4-1.8 6.2-6 6.2-11.8v-8.2c0-4.2 1.7-8.3 4.7-11.3L368 64 224 32 80 64zm96 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-6.1l18.4 36.9 51.6-68.7c71.3 3.2 128.1 62.1 128.1 134.2 0 14.1-11.5 25.6-25.6 25.6H25.6C11.5 512 0 500.5 0 486.4c0-72.1 56.8-131 128.1-134.3l51.6 68.7 18.4-36.8H192c-8.8 0-16-7.2-16-16zm48 35.8-22.9 45.7 2.9 3.8 20 26.7 20-26.7 2.9-3.8-22.9-45.7zM184 480l-70.4-93.9C69 395.3 35.1 433.4 32.2 480H184zm80 0h151.8c-2.9-46.5-36.8-84.7-81.4-93.9L264 480zM96 192c0-2.9.1-5.8.3-8.7 9.1 4.3 19.6 8.5 31.8 12.1 1.8 51.4 44.1 92.6 95.9 92.6s94.1-41.1 95.9-92.6c12.2-3.6 22.7-7.8 31.8-12.1.2 2.9.3 5.8.3 8.7 0 70.7-57.3 128-128 128S96 262.7 96 192zm128-49.7c20.5-11.3 28.9-31.3 31.3-48.5L224 81.2l-31.3 12.5C195 111 203.5 131 224 142.2z"
        }
    ]
};

const FalUserPolice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserPolice",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m217.1.8-144 32c-11.4 2.5-20.6 11-23.8 22.3s-.2 23.3 8.1 31.6L80 109.3v1.6c0 15.6 7.6 31.8 23.2 40.1 22.5 12 59.5 25 120.8 25s98.3-13.1 120.8-25c15.5-8.2 23.2-24.5 23.2-40.1v-1.6l22.6-22.6-6.2-6.2 6.2 6.2c8.3-8.3 11.4-20.4 8.1-31.6s-12.4-19.8-23.8-22.3l-144-32c-4.6-1-9.3-1-13.9 0zM224 32l144 32-27.3 27.3c-3 3-4.7 7.1-4.7 11.3v8.2c0 5.8-2.8 10-6.2 11.8-11.9 6.3-30.3 13.8-58.4 18 12.8-19.5 16.6-41.7 16.6-57.4 0-6.5-4-12.4-10.1-14.9l-48-19.2c-3.8-1.5-8.1-1.5-11.9 0l-48 19.2c-6 2.5-10 8.4-10 14.9 0 15.7 3.8 37.9 16.5 57.5-28.1-4.2-46.5-11.7-58.4-18-3.4-1.8-6.2-6-6.2-11.8v-8.2c0-4.2-1.7-8.3-4.7-11.3L80 64l144-32zM96 192c0 70.7 57.3 128 128 128s128-57.3 128-128c0-2.9-.1-5.8-.3-8.7-9.1 4.3-19.6 8.5-31.8 12.1-1.8 51.5-44 92.6-95.9 92.6s-94.1-41.1-95.9-92.6c-12.2-3.6-22.7-7.8-31.8-12.1-.2 2.9-.3 5.8-.3 8.7zm128-49.7c-20.5-11.3-28.9-31.3-31.3-48.6L224 81.2l31.3 12.5c-2.4 17.3-10.8 37.3-31.3 48.6zm-32.6 287.2c18.4 17 46.7 17 65.1 0l49.3-45.5h7.8c54.4 0 98.9 42.4 102.2 96H336v-16h16c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16v-16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v16H32.2c3.3-53.6 47.8-96 102.2-96h7.8l49.3 45.5zM320.3 512h102.1c14.1 0 25.6-11.5 25.6-25.6 0-74.2-60.2-134.4-134.4-134.4h-7.8c-8 0-15.8 3-21.7 8.5L234.9 406c-6.1 5.7-15.6 5.7-21.7 0l-49.3-45.5c-5.9-5.5-13.7-8.5-21.7-8.5h-7.8C60.2 352 0 412.2 0 486.4 0 500.5 11.5 512 25.6 512h294.7z"
        }
    ]
};

const FalUserRobotXmarks = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserRobotXmarks",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80h160c44.2 0 80-35.8 80-80v-96c0-44.2-35.8-80-80-80h-64V16zM96 144c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c-26.5 0-48-21.5-48-48v-96zm-80-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zM96 384h256c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16h-32v-32c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v32H48c-8.8 0-16-7.2-16-16v-16c0-35.3 28.7-64 64-64zm16 64h32v32h-32v-32zm96 0v32h-32v-32h32zm16 64h176c26.5 0 48-21.5 48-48v-16c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48h176zm16-64h32v32h-32v-32zm96 0v32h-32v-32h32zM137.3 118.7c-5.2-5.2-13.5-5.2-18.7 0s-5.2 13.5 0 18.7l22.7 22.6-22.7 22.7c-5.2 5.2-5.2 13.5 0 18.7s13.5 5.2 18.7 0l22.7-22.7 22.7 22.7c5.2 5.2 13.5 5.2 18.7 0s5.2-13.5 0-18.7L178.7 160l22.7-22.7c5.2-5.2 5.2-13.5 0-18.7s-13.5-5.2-18.7 0L160 141.3l-22.7-22.7zm109.3 0c-5.2 5.2-5.2 13.5 0 18.7l22.7 22.6-22.7 22.7c-5.2 5.2-5.2 13.5 0 18.7s13.5 5.2 18.7 0l22.7-22.7 22.7 22.7c5.2 5.2 13.5 5.2 18.7 0s5.2-13.5 0-18.7L306.7 160l22.7-22.7c5.2-5.2 5.2-13.5 0-18.7s-13.5-5.2-18.7 0L288 141.3l-22.7-22.7c-5.2-5.2-13.5-5.2-18.7 0z"
        }
    ]
};

const FalUserRobot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserRobot",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-64c-44.2 0-80 35.8-80 80v96c0 44.2 35.8 80 80 80h160c44.2 0 80-35.8 80-80v-96c0-44.2-35.8-80-80-80h-64V16zM96 144c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32v-32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32c-26.5 0-48-21.5-48-48v-96zm-80-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96c0-8.8-7.2-16-16-16zm432 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16v-96zm-288 32a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-48-16a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm192 0a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16-48a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM96 384h256c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16h-32v-32c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v32H48c-8.8 0-16-7.2-16-16v-16c0-35.3 28.7-64 64-64zm112 64v32h-32v-32h32zm-96 0h32v32h-32v-32zm112 64h176c26.5 0 48-21.5 48-48v-16c0-53-43-96-96-96H96c-53 0-96 43-96 96v16c0 26.5 21.5 48 48 48h176zm16-64h32v32h-32v-32zm96 0v32h-32v-32h32z"
        }
    ]
};

const FalUserSecret = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserSecret",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M169.1 37.7c-5.8 6.6-12 17.3-18.1 31.9-6.1 14.5-11.3 31-15.5 47.2 24.4 6.4 54 11.2 88.6 11.2 33.4 0 63.3-5.2 88.3-12.1-4.2-15.9-9.3-32-15.3-46.3C291 55 284.7 44.3 279 37.7c-4-4.6-6.3-5.6-7-5.7-4.8 0-7.3.6-8.5 1-1 .3-1.9.8-3.6 1.8-.1.1-.4.3-.7.5-3.5 2.6-17 12.7-35.2 12.7s-31.7-10.1-35.1-12.7c-.3-.3-.6-.4-.7-.5-1.6-1.1-2.5-1.5-3.6-1.8-1.1-.4-3.6-1-8.5-1-.6.2-3 1.2-7 5.7zM272 0c34.2 0 57 54.9 70.8 106l2.4-.9c14.8-5.7 26.5-11.4 34.3-15.7 3.9-2.1 6.9-3.9 8.9-5 1-.6 1.7-1 2.2-1.3l.5-.3h.1c7.4-4.9 17.3-2.9 22.2 4.4s2.9 17.3-4.4 22.2L400 96l8.9 13.3h-.1l-.2.1-.8.5c-.7.4-1.6 1-2.8 1.7-2.4 1.4-5.8 3.5-10.3 5.8-8.9 4.8-21.7 11.1-37.9 17.3C324.4 147.4 278.4 160 224 160c-58.3 0-104.3-12.5-135.9-25.1-15.8-6.3-28-12.7-36.3-17.5-4.2-2.4-7.4-4.5-9.6-6-1.1-.7-2-1.3-2.6-1.8l-.7-.5-.2-.2-.1-.1L48.2 96l-9.6 12.8c-7.1-5.3-8.5-15.3-3.2-22.4 5.3-7.1 15.3-8.5 22.4-3.2h.1l.4.3c.4.3 1 .7 1.8 1.3 1.7 1.1 4.4 2.8 7.9 4.9 7.2 4.2 18 9.8 32.2 15.5 1.6.6 3.3 1.3 5 1.9C118.7 55.7 141.5 0 176 0c18 0 25.9 5.4 32.5 9.9 4.7 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0zm-.3 32a.1.1 0 1 0 .1.1.1.1 0 1 0-.1-.1zm-95.6 0a.1.1 0 1 0 .3.1.1.1 0 1 0-.3-.1zM100 224c-2.6-10.2-4-21-4-32 0-6.7.5-13.3 1.5-19.7 9.6 3.1 19.9 6.1 31.1 8.8-.4 3.6-.6 7.2-.6 10.9 0 53 43 96 96 96s96-43 96-96c0-4-.2-7.9-.7-11.7 11.1-2.8 21.5-5.8 31-9 1.1 6.8 1.7 13.7 1.7 20.8 0 11-1.4 21.8-4 32h71.2c7.1 0 12.8 5.7 12.8 12.8 0 2.1-.5 4.1-1.5 6l-45.7 86.8C423.6 364.8 448 415.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-56.5 24.4-107.2 63.2-142.4l-45.7-86.8c-1-1.8-1.5-3.9-1.5-6 0-7.1 5.7-12.8 12.8-12.8H100zm234.8 32c-22.1 38.3-63.5 64-110.9 64s-88.7-25.7-110.9-64H60.6l30.9 58.7c6.8 12.9 4 28.8-6.8 38.6C52.3 382.7 32 424.9 32 472v8h122.8l-26.2-91.6c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l20.3 70.9 22.1-66.5H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-9.8l22.2 66.5 20.3-70.9c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8L293.2 480H416v-8c0-47.1-20.3-89.3-52.7-118.6-10.8-9.8-13.6-25.7-6.8-38.6l30.9-58.8h-52.5zM203.5 480h40.9L224 418.6 203.5 480zM144 184.4c10.1 2 20.8 3.6 32 4.9v8.7c0 7 5.7 12.7 12.7 12.7 5.5 0 10.3-3.5 12-8.7l3.5-10.5c6.5.3 13.1.5 19.8.5 6.7 0 13.3-.2 19.8-.5l3.5 10.5c1.7 5.2 6.6 8.7 12 8.7 7 0 12.7-5.7 12.7-12.7v-9c11.2-1.4 21.8-3.2 32-5.3V198c0 24.7-20 44.7-44.7 44.7-14.1 0-27-6.6-35.3-17.3-8.3 10.7-21.2 17.3-35.3 17.3-24.7 0-44.7-20-44.7-44.7v-13.6z"
        }
    ]
};

const FalUserShakespeare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserShakespeare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M304 160v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80v48c0 40.1 29.5 73.3 68 79.1V224c0-6.6 5.4-12 12-12s12 5.4 12 12v15.1c38.5-5.8 68-39 68-79.1zM114.1 90.5C124.1 38.9 169.5 0 224 0s99.9 38.9 109.9 90.5c11 8.8 18.1 22.3 18.1 37.5v9.5c0 9.5 2.8 18.7 8.1 26.6l16.7 25.1c4.7 7.1 7.2 15.4 7.2 23.8 0 23.7-19.2 43-43 43h-59.3c-16.9 10.2-36.6 16-57.7 16s-40.9-5.8-57.7-16H107c-23.7 0-43-19.2-43-43 0-8.5 2.5-16.8 7.2-23.8l16.7-25.1c5.3-7.9 8.1-17.1 8.1-26.6V128c0-15.2 7.1-28.7 18.1-37.5zm219.7 91.9c-3.1 15.2-9.3 29.3-17.8 41.7h25c6.1 0 11-4.9 11-11 0-2.2-.6-4.3-1.8-6.1l-16.4-24.6zM132.1 224c-8.6-12.3-14.8-26.4-17.8-41.7l-16.5 24.6c-1.2 1.8-1.8 3.9-1.8 6.1 0 6.1 4.9 11 11 11h25.1zm43.9-96a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm-7.5 39.5c2 2 6 5.3 10.7 8.1 4.9 2.9 9.4 4.4 12.8 4.4 6.6 0 12 5.4 12 12s-5.4 12-12 12c-9.5 0-18.3-3.8-24.8-7.6-2.5-1.5-4.9-3.1-7.1-4.6C211.6 201 199 204 192 204c-6.6 0-12-5.4-12-12s5.4-12 12-12c2.1 0 12.9-1.9 23.5-12.5 4.7-4.7 12.3-4.7 17 0zM0 481.3c0-69.5 44-128.8 105.7-151.4 13.6-24.9 40-41.8 70.3-41.8h96c30.4 0 56.8 16.9 70.3 41.8C404 352.5 448 411.8 448 481.3c0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3zM176 320c-26.5 0-48 21.5-48 48v3.6c1.6-.8 3.3-1.5 5.1-2.3 17.6-7.6 42.5-15 74.9-16.9V320h-32zm64 32.5c32.5 1.9 57.3 9.3 74.9 16.9 1.8.8 3.5 1.5 5.1 2.3V368c0-26.5-21.5-48-48-48h-32v32.5zM224 384c-35.8 0-61.6 7.5-78.2 14.7-8.3 3.6-14.4 7.1-18.2 9.7-1.9 1.3-3.3 2.3-4.1 2.9-.4.3-.7.5-.8.7l-.1.1c-4.7 4.1-11.4 5.2-17.1 2.6-5.8-2.7-9.5-8.4-9.5-14.7v-30.3C58.1 391.9 32.5 432.9 32 480h176c0-8.8 7.2-16 16-16s16 7.2 16 16h176c-.5-47.1-26-88.1-64-110.3V400c0 6.3-3.7 12-9.5 14.6-5.7 2.6-12.4 1.5-17.1-2.6l-.1-.1-.3-.2-.6-.4c-.8-.6-2.2-1.6-4.1-2.9-3.8-2.5-9.9-6.1-18.2-9.7-16.5-7.2-42.3-14.7-78.1-14.7zm-16 32a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalUserShield = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserShield",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM32 480h356.1c10.3 11.3 22.1 21.9 35.5 31.5-1.7.3-3.5.5-5.3.5H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c17.6 0 34.6 2.6 50.7 7.3.6 11 1.9 22.9 4.1 35.3-16.9-6.9-35.5-10.6-54.9-10.6h-91.3c-80 0-145 64.3-146.3 144zm64-352a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm288.1 173.4c1.3 53 22.6 129.5 95.9 170V263l-95.9 38.4zm223.9 0L512 263v208.4c73.4-40.5 94.6-117.1 95.9-170zm-103-75.7 120 48c9 3.7 15 12.5 15 22.3 0 63.3-25.9 168.8-134.8 214.2-5.9 2.5-12.6 2.5-18.5 0C377.9 464.8 352 359.3 352 296c0-9.8 6-18.6 15.1-22.3l120-48c5.7-2.3 12.1-2.3 17.8 0z"
        }
    ]
};

const FalUserSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 128C448 57.3 390.7 0 320 0c-53.9 0-100.1 33.4-118.9 80.6l26.6 21C239.2 61.4 276.1 32 320 32c53 0 96 43 96 96 0 35.9-19.7 67.2-48.9 83.7l26.6 21C426.6 209.5 448 171.2 448 128zm52.4 352H128c1.2-79.7 66.2-144 146.3-144H318l-40.5-32h-3.2C175.8 304 96 383.8 96 482.3c0 16.4 13.3 29.7 29.7 29.7h388.6c7 0 13.4-2.4 18.5-6.5L500.4 480zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalUserTag = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserTag",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm192 256c0-2.4-.1-4.8-.3-7.2l26.8 26.8c-5.4 7.5-14.2 12.5-24.2 12.5H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c17.5 0 34.3 2.5 50.3 7.2v33.7c-15.7-5.7-32.6-8.9-50.3-8.9h-91.4c-80 0-145 64.3-146.3 144h384zM96 128a128 128 0 1 1 256 0 128 128 0 1 1-256 0zm449.9 363.3c-18.7 18.7-49.1 18.7-67.9 0L370.7 384c-12-12-18.7-28.3-18.7-45.3V256c0-17.7 14.3-32 32-32h82.7c17 0 33.3 6.7 45.3 18.7l107.3 107.4c18.7 18.7 18.7 49.1 0 67.9l-73.4 73.4zM384 256v82.7c0 8.5 3.4 16.6 9.4 22.6l107.3 107.4c6.2 6.2 16.4 6.2 22.6 0l73.4-73.4c6.2-6.2 6.2-16.4 0-22.6L489.4 265.4c-6-6-14.1-9.4-22.6-9.4H384zm24 40a16 16 0 1 1 32 0 16 16 0 1 1-32 0z"
        }
    ]
};

const FalUserTieHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserTieHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128c0-5.5-.5-10.8-1.3-16h-30.1c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128H128v16c0 53 43 96 96 96s96-43 96-96v-16zM224 0c70.7 0 128 57.3 128 128 0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9 0 20.6-16.7 37.3-37.3 37.3H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.7c2.9 0 5.3-2.4 5.3-5.3 0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3 0 2.9 2.4 5.3 5.3 5.3H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H69.3C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128 96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6c-16.6-28.7-47.7-48-83.2-48-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9.8-1.6 1.8-3.1 3.1-4.5zm-48.3 425.2-55.7-120.7C71.5 372.9 32.6 421.9 32 480h149.4c-.3-.7-.7-1.4-1-2.1zM416 480c-.6-58.1-39.5-107.1-92.7-122.8l-55.7 120.7c-.3.7-.7 1.4-1 2.1H416zM131.8 322.7c6.8-1.3 13.4 2.5 16.3 8.8l32 69.5 21.7-65H192c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-9.8l21.7 65 32.1-69.5c2.9-6.3 9.5-10 16.3-8.8 75 13.8 131.8 79.6 131.8 158.6 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3c0-79 56.8-144.7 131.8-158.6zm116.5 120.7L224 370.6l-24.3 72.8 9.7 21.1c5.7 12.4 23.3 12.4 29.1 0l9.7-21.1z"
        }
    ]
};

const FalUserTieHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserTieHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128v16c0 53-43 96-96 96s-96-43-96-96v-16h34.3c31.7 0 61.1-14.5 80.4-38.7l6.3 6.3c10.5 10.5 24.7 16.4 39.6 16.4h30.1c.9 5.2 1.3 10.5 1.3 16zm-91.3-75.3c-1.3 1.3-2.4 2.8-3.1 4.5A70.93 70.93 0 0 1 162.3 96h-28.8c13.2-37.3 48.7-64 90.5-64 35.5 0 66.6 19.3 83.2 48h-18.6c-6.4 0-12.5-2.5-17-7l-20.3-20.3c-6.2-6.2-16.4-6.2-22.6 0zM96 128v16c0 70.7 57.3 128 128 128s128-57.3 128-128v-16C352 57.3 294.7 0 224 0S96 57.3 96 128zm96 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h9.8l-21.7 65-32.1-69.5c-2.9-6.3-9.5-10-16.3-8.8C56.8 336.5 0 402.3 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-79-56.8-144.7-131.8-158.6-6.8-1.3-13.4 2.5-16.3 8.8l-32 69.5-21.7-65h9.8c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm17.5 160.5-9.7-21.1 24.2-72.8 24.3 72.8-9.7 21.1c-5.7 12.4-23.3 12.4-29.1 0zm-29.1 13.4c.3.7.7 1.4 1 2.1H32c.6-58.1 39.5-107.1 92.7-122.8l55.7 120.7zM416 480H266.6c.3-.7.7-1.4 1-2.1l55.7-120.7c53.2 15.7 92.1 64.6 92.7 122.8z"
        }
    ]
};

const FalUserTie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserTie",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192zM96 128a128 128 0 1 0 256 0 128 128 0 1 0-256 0zm96 176c-8.8 0-16 7.2-16 16s7.2 16 16 16h9.8l-21.7 65-32.1-69.5c-2.9-6.3-9.5-10-16.3-8.8C56.8 336.5 0 402.3 0 481.3c0 17 13.8 30.7 30.7 30.7h386.6c17 0 30.7-13.8 30.7-30.7 0-79-56.8-144.7-131.8-158.6-6.8-1.3-13.4 2.5-16.3 8.8l-32 69.5-21.7-65h9.8c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64zm17.5 160.5-9.7-21.1 24.2-72.8 24.3 72.8-9.7 21.1c-5.7 12.4-23.3 12.4-29.1 0zm-29.1 13.4c.3.7.7 1.4 1 2.1H32c.6-58.1 39.5-107.1 92.7-122.8l55.7 120.7zM416 480H266.6c.3-.7.7-1.4 1-2.1l55.7-120.7c53.2 15.7 92.1 64.6 92.7 122.8z"
        }
    ]
};

const FalUserUnlock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserUnlock",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm0-224a128 128 0 1 1 0 256 128 128 0 1 1 0-256zm-45.7 336c-80 0-145 64.3-146.3 144h352c0 11.7 3.1 22.6 8.6 32H29.7C13.3 512 0 498.7 0 482.3 0 383.8 79.8 304 178.3 304h91.4c43.6 0 83.6 15.7 114.6 41.7-.2 2.1-.3 4.2-.3 6.3v39c-26.8-33.5-68-55-114.3-55h-91.4zM480 272v48h128c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H448c-17.7 0-32-14.3-32-32V352c0-17.7 14.3-32 32-32v-48c0-44.2 35.8-80 80-80s80 35.8 80 80h-32c0-26.5-21.5-48-48-48s-48 21.5-48 48zm-32 208h160V352H448v128z"
        }
    ]
};

const FalUserVisor = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserVisor",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224c41.8 0 77.4-26.7 90.5-64h-181c13.2 37.3 48.7 64 90.5 64zm0 32c-60.6 0-111.3-42.1-124.6-98.6C88 152.5 80 141.2 80 128V96c0-17.7 14.3-32 32-32h1.1C135.3 25.7 176.6 0 224 0s88.7 25.7 110.9 64h1.1c17.7 0 32 14.3 32 32v32c0 13.2-8 24.5-19.4 29.4-13.3 56.5-64 98.6-124.6 98.6zM152.4 64h143.2C278 44.4 252.4 32 224 32s-54 12.4-71.6 32zm25.8 272c-80 0-145 64.3-146.3 144H416c-1.2-79.7-66.2-144-146.3-144h-91.4zM0 482.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM336 96H112v32h224V96zm-7.1 341.4c-9.5 0-22.5 11.4-31.7 19.5-2.6 2.2-4.8 4.2-6.6 5.6-2.8 2-6.8.1-6.5-3.5 3.9-36.5 15.9-66.5 35.7-89.5 1.5-1.8 4.9-1.9 6.1.1 18.9 24.6 29 55 30.1 90.2 0 3.9-4.9 5.7-7.3 2.5-12.2-17.3-17.6-23-19.9-25z"
        }
    ]
};

const FalUserVneckHairLong = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserVneckHairLong",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128c0-5.5-.5-10.8-1.3-16h-30.1c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128H128v16c0 53 43 96 96 96s96-43 96-96v-16zM224 0c70.7 0 128 57.3 128 128 0 35.3 16.6 68.4 44.8 89.6l4.3 3.2c9.4 7.1 14.9 18.1 14.9 29.9 0 20.6-16.7 37.3-37.3 37.3H320c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.7c2.9 0 5.3-2.4 5.3-5.3 0-1.7-.8-3.3-2.1-4.3l-4.3-3.2c-15.8-11.9-28.8-26.7-38.4-43.4C318.5 242.6 274.7 272 224 272s-94.5-29.4-115.2-72.2c-9.6 16.7-22.6 31.5-38.4 43.4l-4.3 3.2c-1.3 1-2.1 2.6-2.1 4.3 0 2.9 2.4 5.3 5.3 5.3H128c8.8 0 16 7.2 16 16s-7.2 16-16 16H69.3C48.7 288 32 271.3 32 250.7c0-11.8 5.5-22.8 14.9-29.9l4.3-3.2C79.4 196.4 96 163.3 96 128 96 57.3 153.3 0 224 0zm4.7 52.7c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6c-16.6-28.7-47.7-48-83.2-48-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9.8-1.6 1.8-3.1 3.1-4.5zm-43.1 365.4-48-64C77.9 365.2 32.6 417.3 32 480h384c-.6-62.7-45.9-114.8-105.6-125.8l-48 64c-19.2 25.6-57.6 25.6-76.8 0zM143.7 321c5.3-.6 10.5 1.9 13.7 6.2l53.9 71.8c6.4 8.5 19.2 8.5 25.6 0l53.9-71.8c3.2-4.3 8.4-6.7 13.7-6.2 80.6 8.7 143.5 77.2 143.5 160.3 0 17-13.8 30.7-30.7 30.7H30.7C13.8 512 0 498.2 0 481.3 0 398.2 62.9 329.7 143.7 321z"
        }
    ]
};

const FalUserVneckHair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserVneckHair",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128c0-5.5-.5-10.8-1.3-16h-30.1c-14.9 0-29.1-5.9-39.6-16.4l-6.3-6.3C223.4 113.5 194 128 162.3 128H128v16c0 53 43 96 96 96s96-43 96-96v-16zm-91.3-75.3c6.2-6.2 16.4-6.2 22.6 0L271.6 73c4.5 4.5 10.6 7 17 7h18.6c-16.6-28.7-47.7-48-83.2-48-41.8 0-77.4 26.7-90.5 64h28.9c26.7 0 51.2-15 63.2-38.9.8-1.6 1.8-3.1 3.1-4.5zM96 128C96 57.3 153.3 0 224 0s128 57.3 128 128v16c0 70.7-57.3 128-128 128S96 214.7 96 144v-16zm89.6 290.1-57.2-76.3C72.6 358.8 32 410.7 32 472v8h384v-8c0-61.3-40.6-113.2-96.4-130.2l-57.2 76.3c-19.2 25.6-57.6 25.6-76.8 0zm-53.5-110.3c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.2z"
        }
    ]
};

const FalUserVneck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserVneck",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M224 224a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm128-96a128 128 0 1 1-256 0 128 128 0 1 1 256 0zM185.6 418.1l-57.2-76.3C72.6 358.8 32 410.7 32 472v8h384v-8c0-61.3-40.6-113.2-96.4-130.1l-57.2 76.3c-19.2 25.6-57.6 25.6-76.8 0zm-53.5-110.3c5.8-1.3 11.7 1.2 15.3 5.9l63.9 85.2c6.4 8.5 19.2 8.5 25.6 0l63.9-85.2c3.6-4.7 9.5-7.2 15.3-5.9C391.4 324.3 448 391.5 448 472v8c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32v-8c0-80.5 56.6-147.7 132.1-164.1z"
        }
    ]
};

const FalUserXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUserXmark",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 128a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm141.7 208c80 0 145 64.3 146.3 144H32c1.2-79.7 66.2-144 146.3-144h91.4zM224 256a128 128 0 1 0 0-256 128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7 0-98.5-79.8-178.3-178.3-178.3h-91.4zm290.4-155.3c-6.2 6.2-6.2 16.4 0 22.6l52.7 52.7-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l52.7-52.7 52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L566.6 224l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L544 201.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"
        }
    ]
};

const FalUser = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUser",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 128a96 96 0 1 0-192 0 96 96 0 1 0 192 0zm-224 0a128 128 0 1 1 256 0 128 128 0 1 1-256 0zM32 480h384c-1.2-79.7-66.2-144-146.3-144h-91.4c-80 0-145 64.3-146.3 144zm-32 2.3C0 383.8 79.8 304 178.3 304h91.4c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z"
        }
    ]
};

const FalUsersBetweenLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsersBetweenLines",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 16C0 7.2 7.2 0 16 0h608c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zm0 480c0-8.8 7.2-16 16-16h608c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zm147.2-304a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM369.6 320h-96c-35.3 0-64 28.7-64 64h224c0-35.3-28.7-64-64-64zm-192 64c0-53 43-96 96-96h96c53 0 96 43 96 96 0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32zm144-160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 320v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-35.3 28.7-64 64-64h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-17.7 0-32 14.3-32 32zm480-32h-88c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-17.7-14.3-32-32-32z"
        }
    ]
};

const FalUsersGear = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsersGear",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm112 64a64 64 0 1 1 128 0 64 64 0 1 1-128 0zm119.2 78.5c12-8.4 21.9-19.5 29-32.5 7.5-13.7 11.8-29.4 11.8-46.1 0-53-43-96-96-96s-96 43-96 96 43 96 96 96c20.6 0 39.6-6.5 55.2-17.5zM360.1 352h-98.8C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h290.9c-1.1-2-2.1-4-3-6-19.6 2.1-40.8-4.6-55.4-23.1-.7-.9-1.5-1.9-2.2-2.8H160.1c2.8-53.5 47-96 101.2-96h110.8c-6.7-9.1-11.1-20.1-12-32zm278.2-67.4C629.1 232 583.2 192 528 192h-84c2.6 10.2 4 21 4 32h80c28.7 0 53.9 15.2 68 37.9 15.5 1.4 30.9 8.5 42.3 22.7zM464 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM196 192h-84C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80c0-11 1.4-21.8 4-32zm305 97.3v-.6c3.9-.5 7.9-.7 12-.7s8.1.3 12 .7v.6c0 16.5 10.6 29.2 22 35.8 11.5 6.7 27.7 9.4 41.9 1.2l.5-.3c2.1 2.7 4 5.6 5.8 8.5l1.9 3.2c1.6 2.9 3.1 5.9 4.4 9l-.5.3c-14.3 8.2-20 23.7-20 36.9s5.7 28.7 20 36.9l.5.3c-1.3 3.1-2.7 6.1-4.3 9l-1.9 3.4c-1.8 2.9-3.7 5.7-5.7 8.4l-.5-.3c-14.2-8.2-30.4-5.5-41.9 1.2-11.4 6.6-22 19.2-22 35.8v.6c-3.9.5-7.9.7-12 .7s-8.1-.3-12-.7v-.6c0-16.5-10.6-29.2-22-35.8-11.5-6.7-27.7-9.4-41.9-1.2l-.5.3c-2.1-2.7-4-5.5-5.7-8.4l-1.9-3.3c-1.6-2.9-3.1-5.9-4.4-9l.5-.3c14.3-8.2 20-23.7 20-36.9s-5.7-28.7-20-36.9l-.5-.3c1.3-3.1 2.8-6.1 4.4-9.1l1.8-3.2c1.8-2.9 3.7-5.8 5.8-8.5l.5.3c14.2 8.2 30.4 5.5 41.9-1.2 11.4-6.6 22-19.2 22-35.8zm12-33.3c-6.1 0-12.2.4-18.1 1.3-16.2 2.3-25.9 16.5-25.9 30.7v1.4c0 2-1.5 5.4-6.1 8.1-4.5 2.6-8.1 2.2-9.9 1.1l-1.2-.7c-12.2-7.1-29.4-5.8-39.5 7.1-3.3 4.2-6.3 8.6-9.1 13.2l-.1.2-2 3.4-.1.2c-2.5 4.6-4.8 9.4-6.8 14.3-6.1 15.2 1.4 30.7 13.6 37.7l1.2.7c1.8 1 4 4 4 9.2s-2.2 8.2-4 9.2l-1.2.7c-12.2 7.1-19.7 22.6-13.6 37.7 2 4.9 4.2 9.6 6.7 14.2l.1.3 2.1 3.6.2.3c2.7 4.6 5.8 8.9 9 13.1 10.1 12.8 27.3 14.1 39.5 7.1l1.2-.7c1.8-1 5.4-1.5 9.9 1.1 4.6 2.7 6.1 6.1 6.1 8.1v1.4c0 14.1 9.7 28.4 25.9 30.7 5.9.8 12 1.3 18.1 1.3s12.2-.4 18.1-1.3c16.2-2.3 25.9-16.5 25.9-30.7v-1.4c0-2 1.5-5.4 6.1-8.1 4.5-2.6 8.1-2.2 9.9-1.1l1.2.7c12.2 7.1 29.4 5.8 39.5-7.1 3.3-4.2 6.3-8.5 9-13.1l.2-.3 2.1-3.6.1-.3c2.5-4.6 4.8-9.3 6.7-14.1 6.1-15.2-1.4-30.7-13.6-37.7l-1.2-.7c-1.8-1-4-4-4-9.2s2.2-8.2 4-9.2l1.2-.7c12.2-7.1 19.7-22.6 13.6-37.7-2-4.9-4.2-9.7-6.8-14.2l-.1-.2-2-3.5-.1-.2c-2.8-4.6-5.8-9-9.1-13.2-10.1-12.8-27.3-14.1-39.5-7.1l-1.2.7c-1.8 1-5.4 1.5-9.9-1.1-4.6-2.7-6.1-6.1-6.1-8.1v-1.4c0-14.1-9.7-28.4-25.9-30.7-5.9-.8-12-1.3-18.1-1.3zm15 128a16 16 0 1 1-32 0 16 16 0 1 1 32 0zm-16 48a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"
        }
    ]
};

const FalUsersLine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsersLine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M147.2 160a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm352 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM369.6 288h-96c-35.3 0-64 28.7-64 64h224c0-35.3-28.7-64-64-64zm-192 64c0-53 43-96 96-96h96c53 0 96 43 96 96 0 17.7-14.3 32-32 32h-224c-17.7 0-32-14.3-32-32zm144-160a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zM64 288v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-35.3 28.7-64 64-64h88c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-17.7 0-32 14.3-32 32zm480-32h-88c-8.8 0-16-7.2-16-16s7.2-16 16-16h88c35.3 0 64 28.7 64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c0-17.7-14.3-32-32-32zM16 448h608c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalUsersMedical = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsersMedical",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM64 80a80 80 0 1 1 160 0 80 80 0 1 1-160 0zm256 208a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0-160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm-58.7 256c-54.2 0-98.4 42.5-101.2 96H448c0 11.7 3.1 22.6 8.6 32H154.7c-14.7 0-26.7-11.9-26.7-26.7 0-73.6 59.7-133.3 133.3-133.3h117.4c4.6 0 9.1.2 13.5.7-5.2 9.3-8.2 19.9-8.2 31.3v.1c-1.8-.1-3.5-.1-5.3-.1H261.3zM512 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm16 224h-80c0-11-1.4-21.8-4-32h84c61.9 0 112 50.1 112 112 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2-35.8-80-80-80zm-336 0h-80c-44.2 0-80 35.8-80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112h84c-2.6 10.2-4 21-4 32zm320 64h32c17.7 0 32 14.3 32 32v32h32c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-32v32c0 17.7-14.3 32-32 32h-32c-17.7 0-32-14.3-32-32v-32h-32c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h32v-32c0-17.7 14.3-32 32-32zm0 80c0 8.8-7.2 16-16 16h-48v32h48c8.8 0 16 7.2 16 16v48h32v-48c0-8.8 7.2-16 16-16h48v-32h-48c-8.8 0-16-7.2-16-16v-48h-32v48z"
        }
    ]
};

const FalUsersRays = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsersRays",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M4.7 4.7c-6.2 6.2-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0zm630.6 0c-6.2-6.2-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l64-64c6.2-6.2 6.2-16.4 0-22.6zm-608 502.6 64-64c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-64 64c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0zm608 0c6.2-6.2 6.2-16.4 0-22.6l-64-64c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0zM288 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-24 128c19.4 0 35.5 13.7 39.2 32H240.8c3.7-18.3 19.8-32 39.2-32h80zm-80-32c-39.8 0-72 32.2-72 72 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-39.8-32.2-72-72-72h-80zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24h56c8.8 0 16-7.2 16-16s-7.2-16-16-16h-56c-30.9 0-56 25.1-56 56v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8zm336.2-152a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm23.8 64c13.3 0 24 10.7 24 24v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-30.9-25.1-56-56-56h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56z"
        }
    ]
};

const FalUsersRectangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsersRectangle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 0C35.8 0 0 35.8 0 80v352c0 44.2 35.8 80 80 80h480c44.2 0 80-35.8 80-80V80c0-44.2-35.8-80-80-80H80zM32 80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zm256 112a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-24 128c19.4 0 35.5 13.7 39.2 32H240.8c3.7-18.3 19.8-32 39.2-32h80zm-80-32c-39.8 0-72 32.2-72 72 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-39.8-32.2-72-72-72h-80zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24h56c8.8 0 16-7.2 16-16s-7.2-16-16-16h-56c-30.9 0-56 25.1-56 56v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8zm336.2-152a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm23.8 64c13.3 0 24 10.7 24 24v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-30.9-25.1-56-56-56h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56z"
        }
    ]
};

const FalUsersSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsersSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m191.5 73 30.7 24.2c1.2-5.5 1.9-11.3 1.9-17.2 0-44.2-35.8-80-80-80-12.5 0-24.3 2.9-34.9 8l30.7 24.2c1.4-.1 2.8-.2 4.2-.2 24.1 0 44.1 17.8 47.5 41zm-55.9 119H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h64.2l-40.5-32zM413 247.9c2-7.6 3-15.6 3-23.9 0-53-43-96-96-96-16.2 0-31.4 4-44.8 11.1l29 22.9c5.1-1.3 10.4-2 15.8-2 35.3 0 64 28.7 64 64v1l29 22.9zM338.3 352h-77C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h330.6c13.5 0 24.7-10 26.4-23.1l-34.5-27.3c1.4 5.9 2.3 12.1 2.6 18.3H160.1c2.8-53.5 47-96 101.2-96h117.6l-40.5-32zM464 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zM448 224h80c44.2 0 80 35.8 80 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112h-84c2.6 10.2 4 21 4 32zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalUsersViewfinder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsersViewfinder",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 32h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H24C10.7 0 0 10.7 0 24v104c0 8.8 7.2 16 16 16s16-7.2 16-16V32zm576 0v96c0 8.8 7.2 16 16 16s16-7.2 16-16V24c0-13.3-10.7-24-24-24H512c-8.8 0-16 7.2-16 16s7.2 16 16 16h96zM128 480H32v-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v104c0 13.3 10.7 24 24 24h104c8.8 0 16-7.2 16-16s-7.2-16-16-16zm480 0h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h104c13.3 0 24-10.7 24-24V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v96zM288 192a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-24 128c19.4 0 35.5 13.7 39.2 32H240.8c3.7-18.3 19.8-32 39.2-32h80zm-80-32c-39.8 0-72 32.2-72 72 0 13.3 10.7 24 24 24h176c13.3 0 24-10.7 24-24 0-39.8-32.2-72-72-72h-80zM159.8 176a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm64 0a48 48 0 1 0-96 0 48 48 0 1 0 96 0zM128 312c0-13.3 10.7-24 24-24h56c8.8 0 16-7.2 16-16s-7.2-16-16-16h-56c-30.9 0-56 25.1-56 56v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8zm336.2-152a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm23.8 64c13.3 0 24 10.7 24 24v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-30.9-25.1-56-56-56h-56c-8.8 0-16 7.2-16 16s7.2 16 16 16h56z"
        }
    ]
};

const FalUsers = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUsers",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm128 0a80 80 0 1 0-160 0 80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64h117.4c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7h330.6c14.7 0 26.7-11.9 26.7-26.7 0-73.6-59.7-133.3-133.3-133.3H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128a80 80 0 1 0 0-160 80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80 0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112h-84c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32h-84C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z"
        }
    ]
};

const FalUtensilsSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUtensilsSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.8 18.6c1.5-8.7-4.4-17-13.2-18.4s-17 4.4-18.4 13.2l-.5 3L148.4 39l3.4-20.3zM197 77.3l3-60.5C200.4 8 193.6.5 184.8 0S168.5 6.4 168 15.2L166.1 53 197 77.3zm56.4 44.5L248 15.2c-.5-8.8-8-15.6-16.8-15.2S215.6 8 216 16.8l4 78.7 33.4 26.3zM129.3 187l-33.2-26.2c-.1 1.5-.1 3-.1 4.5V176c0 44.2 35.8 80 80 80h16v240c0 8.8 7.2 16 16 16s16-7.2 16-16V261.8L176.2 224h-.2c-22.7 0-41.8-15.8-46.7-37zM320 174.5v-9.2c0-4.4-.4-8.8-1.1-13.2L295.8 13.4c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l21.5 128.7 34.3 27.2zm224 176.8V32c0-17.7-14.3-32-32-32-16 0-128 32-128 176v49l32 25.3V176c0-62.5 23.8-97.7 47-117.8 12-10.4 24.4-17.2 34.5-21.3 7.6-3.1 12.6-4.2 14.3-4.6l.2-.1V320h-7.6l39.6 31.3zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalUtensils = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUtensils",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M42.6.2c8.7 1.5 14.6 9.7 13.2 18.4L32.7 157.4c-.4 2.6-.7 5.2-.7 7.9V176c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48v-10.7c0-2.6-.2-5.3-.7-7.9L168.2 18.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2l23.1 138.8c.7 4.3 1.1 8.7 1.1 13.2V176c0 44.2-35.8 80-80 80h-16v240c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H80c-44.2 0-80-35.8-80-80v-10.7c0-4.4.4-8.8 1.1-13.2L24.2 13.4C25.7 4.7 33.9-1.2 42.6.2zM88.8 0c8.8.4 15.6 8 15.2 16.8l-8 160c-.4 8.8-8 15.6-16.8 15.2s-15.6-8-15.2-16.8l8-160C72.5 6.4 80-.4 88.8 0zm46.4 0c8.8-.4 16.3 6.4 16.8 15.2l8 160c.4 8.8-6.4 16.3-15.2 16.8s-16.3-6.4-16.8-15.2l-8-160C119.6 8 126.4.5 135.2 0zM320 176v112c0 17.7 14.3 32 32 32h64V32.2l-.2.1c-1.7.4-6.7 1.5-14.3 4.6C391.4 41 379 47.8 367 58.2c-23.2 20.1-47 55.3-47 117.8zM416 0c17.7 0 32 14.3 32 32v464c0 8.8-7.2 16-16 16s-16-7.2-16-16V352h-64c-35.3 0-64-28.7-64-64V176C288 32 400 0 416 0z"
        }
    ]
};

const FalUtilityPoleDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUtilityPoleDouble",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64h80V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 17.7-14.3 32-32 32h-42.5L304 231.8V288h80v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 17.7-14.3 32-32 32h-42.5L304 423.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V320h-32v176c0 8.8-7.2 16-16 16s-16-7.2-16-16v-72.2L74.5 320H32c-17.7 0-32-14.3-32-32v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64v-48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h80v-56.2L74.5 128H32c-17.7 0-32-14.3-32-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h80V32zm-81.4 96 81.4 63.3V128h-81.4zM240 224.2V288h32V128h-32v96.2zm64-32.9 81.4-63.3H304v63.3zM126.6 320l81.4 63.3V320h-81.4zM304 383.3l81.4-63.3H304v63.3zM272 32h-32v64h32V32z"
        }
    ]
};

const FalUtilityPole = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalUtilityPole",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 32c0-17.7 14.3-32 32-32h32c17.7 0 32 14.3 32 32v64h80V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48c0 17.7-14.3 32-32 32h-42.5L304 231.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V128h-32v368c0 8.8-7.2 16-16 16s-16-7.2-16-16V231.8L74.5 128H32c-17.7 0-32-14.3-32-32V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h64V48c0-8.8 7.2-16 16-16s16 7.2 16 16v48h80V32zm-81.4 96 81.4 63.3V128h-81.4zM304 191.3l81.4-63.3H304v63.3zM272 32h-32v64h32V32z"
        }
    ]
};

const FalV = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalV",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M9.8 33.3c8.1-3.4 17.5.4 21 8.5L192 422.9 353.3 41.8c3.4-8.1 12.8-11.9 21-8.5s11.9 12.8 8.5 21l-176 416c-2.5 5.9-8.3 9.8-14.7 9.8s-12.2-3.8-14.7-9.8L1.3 54.2c-3.4-8.1.4-17.5 8.5-21z"
        }
    ]
};

const FalVacuumRobot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVacuumRobot",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zm356.7-100.7c-55.6-55.6-145.8-55.6-201.4 0-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c68.1-68.1 178.5-68.1 246.6 0s68.1 178.5 0 246.6c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c55.6-55.6 55.6-145.8 0-201.4zm-144 57.4c6.2-6.2 16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-6.2-6.2-6.2-16.4 0-22.6zm-80 16c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6zm-16 102.6c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l64 64c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64z"
        }
    ]
};

const FalVacuum = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVacuum",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192.4 89.2C203.2 37.2 249 0 302.1 0H528c61.9 0 112 50.1 112 112 0 44.8-26.3 83.5-64.3 101.4C596.1 243.9 608 280.5 608 320v128c0 35.3-28.7 64-64 64h-75.3c10.4-9.2 19.2-20 26.2-32H544c17.7 0 32-14.3 32-32V320c0-88.4-71.6-160-160-160-17.7 0-32 14.3-32 32v96c-11 0-21.8 1.4-32 4V192c0-35.3 28.7-64 64-64 54.6 0 103.9 22.8 138.8 59.4 31-11 53.2-40.6 53.2-75.4 0-44.2-35.8-80-80-80H302.1c-37.9 0-70.6 26.6-78.3 63.7L197 224h-32.7l28.1-134.8zM157.7 256h32.7l-26.7 128.1C197.3 386 224 413.9 224 448c0 35.3-28.7 64-64 64H24.2C10.8 512 0 501.2 0 487.8c0-5.2.8-10.4 2.5-15.3l7.6-22.9c13.1-39.2 49.8-65.6 91.1-65.6H131l26.7-128zm-13.4 160h-43.1c-27.5 0-52 17.6-60.7 43.8L33.7 480H160c17.7 0 32-14.3 32-32s-14.3-32-32-32h-15.7zm303.7 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1-192 0zm96-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalValueAbsolute = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalValueAbsolute",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm155.3 116.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l84.7 84.7-84.7 84.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l84.7-84.7 84.7 84.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l84.7-84.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-84.7-84.7zM512 48c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16s16-7.2 16-16V48z"
        }
    ]
};

const FalVanShuttle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVanShuttle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M32 88v104h128V64H56c-13.3 0-24 10.7-24 24zm0 136v104c0 13.3 10.7 24 24 24h13.5c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64h139c13.2-37.3 48.7-64 90.5-64s77.4 26.7 90.5 64H584c13.3 0 24-10.7 24-24V224H32zm160-32h160V64H192v128zm192 0h204.1L477.6 69.3c-3-3.4-7.4-5.3-11.9-5.3H384v128zm200 192h-8c0 53-43 96-96 96s-96-43-96-96H256c0 53-43 96-96 96s-96-43-96-96h-8c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h409.7c13.6 0 26.6 5.8 35.7 15.9l126.3 140.3c7.9 8.8 12.3 20.3 12.3 32.1V328c0 30.9-25.1 56-56 56zm-40 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0zm-384 64a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FalVault = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVault",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h448c35.3 0 64 28.7 64 64v352c0 35.3-28.7 64-64 64v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16c-35.3 0-64-28.7-64-64V64zm352 176a128 128 0 1 0-256 0 128 128 0 1 0 256 0zm-288 0a160 160 0 1 1 320 0 160 160 0 1 1-320 0zm160 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm256 0a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm32 0c0 20.9-13.4 38.7-32 45.3V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V221.3c-18.6-6.6-32-24.4-32-45.3 0-26.5 21.5-48 48-48s48 21.5 48 48z"
        }
    ]
};

const FalVectorCircle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVectorCircle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M280 32c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V40c0-4.4 3.6-8 8-8h48zm40 26V40c0-22.1-17.9-40-40-40h-48c-22.1 0-40 17.9-40 40v18C128.6 78.5 78.5 128.6 58 192H40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h18c20.5 63.4 70.6 113.5 134 134v18c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-18c63.4-20.5 113.5-70.6 134-134h18c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-18c-20.5-63.4-70.6-113.5-134-134zm-.2 33.9c45.9 17.9 82.4 54.4 100.3 100.3-20.2 2-36.1 19-36.1 39.8v48c0 20.8 15.8 37.8 36.1 39.8-17.9 45.9-54.4 82.4-100.3 100.3-2-20.2-19-36.1-39.8-36.1h-48c-20.8 0-37.8 15.8-39.8 36.1-45.9-17.9-82.4-54.4-100.3-100.3 20.2-2 36.1-19 36.1-39.8v-48c0-20.8-15.8-37.8-36.1-39.8 17.9-45.9 54.4-82.4 100.3-100.3 2 20.2 19 36.1 39.8 36.1h48c20.8 0 37.8-15.8 39.8-36.1zM429.1 224H472c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h5.1zM288 429.1V472c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v5.1zM50.4 224H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h10.4z"
        }
    ]
};

const FalVectorPolygon = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVectorPolygon",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v8H128v-8c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40h8v192h-8c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-8h192v8c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-43.7l-25.4-42.3c8.1-7.3 13.2-17.9 13.2-29.7v-48c0-11.8-5.1-22.3-13.2-29.7l25.4-42.3H408c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-48zm-52.3 288 25.4 42.3c-8.1 7.3-13.2 17.9-13.2 29.7v8H128v-8c0-22.1-17.9-40-40-40h-8V160h8c22.1 0 40-17.9 40-40v-8h192v8c0 11.8 5.1 22.3 13.2 29.7L307.7 192H264c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h43.7zM40 384h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm320 0h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm-96-160h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zM88 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48z"
        }
    ]
};

const FalVectorSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVectorSquare",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M408 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v8H128v-8c0-22.1-17.9-40-40-40H40C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40h8v192h-8c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-8h192v8c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40v-48c0-22.1-17.9-40-40-40h-8V160h8c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40h-48zM80 352V160h8c22.1 0 40-17.9 40-40v-8h192v8c0 22.1 17.9 40 40 40h8v192h-8c-22.1 0-40 17.9-40 40v8H128v-8c0-22.1-17.9-40-40-40h-8zm-40 32h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zm320 0h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8zM40 64h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8z"
        }
    ]
};

const FalVentDamper = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVentDamper",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M512 96H128c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM48 128h16c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64h16c26.5 0 48 21.5 48 48v160c0 26.5-21.5 48-48 48h-16c0 35.3-28.7 64-64 64H128c-35.3 0-64-28.7-64-64H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48zm544 224c8.8 0 16-7.2 16-16V176c0-8.8-7.2-16-16-16h-16v192h16zm-544 0h16V160H48c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16zm128-192h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 80h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 80h288c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"
        }
    ]
};

const FalVenusDouble = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVenusDouble",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm176-144c0 91.8-70.3 167.2-160 175.3V416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64.7C86.3 343.2 16 267.8 16 176 16 78.8 94.8 0 192 0s176 78.8 176 176zm-24 142c7.3-7.8 14-16.2 20-25 23.6 17 52.6 27 84 27 79.5 0 144-64.5 144-144S527.5 32 448 32c-31.3 0-60.3 10-84 27-6-8.9-12.7-17.2-20-25 29.1-21.4 65.1-34 104-34 97.2 0 176 78.8 176 176 0 91.8-70.3 167.2-160 175.3V416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64.7c-32.7-3-62.9-14.9-88-33.3z"
        }
    ]
};

const FalVenusMars = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVenusMars",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 320a144 144 0 1 0 0-288 144 144 0 1 0 0 288zm176-144c0 91.8-70.3 167.2-160 175.3V416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v48c0 8.8-7.2 16-16 16s-16-7.2-16-16v-48H96c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64.7C70.3 343.2 0 267.8 0 176 0 78.8 78.8 0 176 0s176 78.8 176 176zm-80.1 184.6c9.7-5.1 19-10.9 27.8-17.4C325.6 368.5 361 384 400 384c79.5 0 144-64.5 144-144S479.5 96 400 96c-10.5 0-20.7 1.1-30.6 3.3-4.1-10.2-8.9-20.1-14.5-29.4C369.3 66 384.4 64 400 64c42.8 0 82.1 15.3 112.6 40.7L585.4 32H496c-8.8 0-16-7.2-16-16s7.2-16 16-16h128c8.8 0 16 7.2 16 16v128c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6l-72.7 72.7C560.7 157.9 576 197.2 576 240c0 97.2-78.8 176-176 176-50.5 0-96-21.3-128.1-55.4z"
        }
    ]
};

const FalVenus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVenus",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M48 176a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm160 175.3c89.7-8.1 160-83.5 160-175.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 91.8 70.3 167.2 160 175.3V416h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-64.7z"
        }
    ]
};

const FalVestPatches = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVestPatches",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m173.4 69.1 33.4 87.4-17.1 44.8-64.4-168.5c-1.7-.5-3.3-.8-4.9-.8H96c-8.8 0-16 7.2-16 16v138.7c0 11.6-3.2 23-9.1 32.9l-34.3 57.2c-3 5-4.6 10.7-4.6 16.5V464c0 8.8 7.2 16 16 16h113.6c2.4 11.8 7.4 22.7 14.4 32H48c-26.5 0-48-21.5-48-48V293.3c0-11.6 3.2-23 9.1-32.9l34.3-57.2c3-5 4.6-10.7 4.6-16.5v-139C48.2 21.3 69.6 0 96 0h29c6.3 0 12.3 1.8 17.4 5.1 10.2 4.9 18.6 12.5 24.7 19.6C176 35 192.9 48 224 48s48-13 56.9-23.3c6.1-7.1 14.5-14.7 24.7-19.6C310.7 1.8 316.7 0 323 0h29c26.5 0 48 21.5 48 48v138.7c0 5.8 1.6 11.5 4.6 16.5l34.3 57.2c6 9.9 9.1 21.3 9.1 32.9V464c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V296.9c0-7.8 1.4-15.6 4.2-22.9l78.4-204.9C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9zm149.3-36.3-96.6 252.6c-1.4 3.6-2.1 7.5-2.1 11.4V464c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16V293.3c0-5.8-1.6-11.5-4.6-16.5l-34.3-57.2c-6-9.9-9.1-21.3-9.1-32.9V48c0-7.7-5.5-14.2-12.8-15.7-1-.2-2.1-.3-3.2-.3h-24.4c-1.6 0-3.2.3-4.9.8zM112 416a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm-4.7-107.3 12.7 12.7 12.7-12.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L142.6 280l12.7 12.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L120 302.6l-12.7 12.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L97.4 280l-12.7-12.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zM312 240c19.6 0 35.9 14.1 39.3 32.7 18.6 3.4 32.7 19.7 32.7 39.3 0 22.1-17.9 40-40 40h-56c-8.8 0-16-7.2-16-16v-56c0-22.1 17.9-40 40-40zm-8 40v40h40c4.4 0 8-3.6 8-8s-3.6-8-8-8h-8c-8.8 0-16-7.2-16-16v-8c0-4.4-3.6-8-8-8s-8 3.6-8 8z"
        }
    ]
};

const FalVest = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVest",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 0h24.4c20.5 0 36.7 13 46.7 24.7C176 35 192.9 48 224 48s48-13 56.9-23.3C290.9 13 307.1 0 327.6 0H352c26.5 0 48 21.5 48 48v138.7c0 5.8 1.6 11.5 4.6 16.5l34.3 57.2c6 9.9 9.1 21.3 9.1 32.9V464c0 26.5-21.5 48-48 48H240c-26.5 0-48-21.5-48-48V296.9c0-7.8 1.4-15.6 4.2-22.9l78.4-204.9C261.3 75.6 244.6 80 224 80s-37.3-4.4-50.6-10.9l33.4 87.4-17.1 44.8-60.8-159C126.6 36.1 120.6 32 114 32H96c-8.8 0-16 7.2-16 16v138.7c0 11.6-3.2 23-9.1 32.9l-34.3 57.2c-3 5-4.6 10.7-4.6 16.5v132.1l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-88 88c-.8.8-1.6 1.4-2.4 2C35.1 475.5 41 480 48 480h113.6c2.4 11.8 7.4 22.7 14.4 32H48c-26.5 0-48-21.5-48-48V293.3c0-11.6 3.2-23 9.1-32.9l34.3-57.2c3-5 4.6-10.7 4.6-16.5V48C48 21.5 69.5 0 96 0zm272 48c0-8.8-7.2-16-16-16h-18c-6.6 0-12.6 4.1-14.9 10.3l-93 243.1c-1.4 3.6-2.1 7.5-2.1 11.4V464c0 8.8 7.2 16 16 16h160c7 0 12.9-4.5 15.1-10.7-.9-.6-1.7-1.2-2.4-2l-88-88c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l68.7 68.7V293.3c0-5.8-1.6-11.5-4.6-16.5l-34.3-57.2c-6-9.9-9.1-21.3-9.1-32.9V48z"
        }
    ]
};

const FalVialCircleCheck = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVialCircleCheck",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v202.8c-20.2 28.6-32 63.5-32 101.2V224H64v160c0 35.3 28.7 64 64 64s64-28.7 64-64v-16c0 25.2 5.3 49.1 14.8 70.8-17.3 24.9-46.2 41.2-78.8 41.2-53 0-96-43-96-96V64H16C7.2 64 0 56.8 0 48zm64 16v128h128V64H64zm304 416a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm0-256a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm67.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-72 72c-6.2 6.2-16.4 6.2-22.6 0l-40-40c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l28.7 28.7 60.7-60.7c6.2-6.2 16.4-6.2 22.6 0z"
        }
    ]
};

const FalVialVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVialVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h16v320c0 53 43 96 96 96 31.4 0 59.3-15.1 76.8-38.4 5.3-7.1 3.9-17.1-3.2-22.4s-17.1-3.9-22.4 3.2C167.5 438 148.9 448 128 448c-35.3 0-64-28.7-64-64V224h144c8.8 0 16-7.2 16-16V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm176 160H64V64h128v128zm128 152a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-169.4-81.1c-13.3 0-24 10.7-24 24s10.7 24 24 24c29.3 0 43.9 35.4 23.2 56.1-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0c20.7-20.7 56.1-6 56.1 23.2 0 13.3 10.7 24 24 24s24-10.7 24-24c0-29.3 35.4-43.9 56.1-23.2 9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9c-20.7-20.7-6-56.1 23.2-56.1 13.3 0 24-10.7 24-24s-10.7-24-24-24c-29.3 0-43.9-35.4-23.2-56.1 9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0c-20.7 20.7-56.1 6-56.1-23.2 0-13.3-10.7-24-24-24s-24 10.7-24 24c0 29.3-35.4 43.9-56.1 23.2-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9c20.7 20.7 6 56.1-23.2 56.1zm62.6-50.7c28.6 8.2 60.2-4.9 74.7-30.9 7.2 13 18.8 22.8 32.2 28.3 13.3 5.5 28.3 6.7 42.5 2.6-8.2 28.6 4.9 60.2 30.9 74.7-26 14.5-39.1 46.1-30.9 74.7-28.6-8.2-60.2 4.9-74.7 30.9-14.5-26-46.1-39.1-74.7-30.9 8.2-28.6-4.9-60.2-30.9-74.7 26-14.5 39.1-46.1 30.9-74.7z"
        }
    ]
};

const FalVial = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVial",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M292.7 4.7c6.2-6.2 16.4-6.2 22.6 0l32 32 128 128 32 32c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L464 198.6l-84.7 84.7-197.5 197.5c-20 20-47.1 31.2-75.3 31.2C47.7 512 0 464.3 0 405.5c0-28.2 11.2-55.3 31.2-75.3l69.5-69.5L313.4 48l-20.7-20.7c-6.2-6.2-6.2-16.4 0-22.6zM336 70.6 150.6 256h210.8l80-80L336 70.6zM329.4 288H118.6l-64.8 64.8c-14 14-21.8 32.9-21.8 52.7 0 41.1 33.4 74.5 74.5 74.5 19.8 0 38.7-7.8 52.7-21.8L329.4 288z"
        }
    ]
};

const FalVials = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVials",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32C7.2 32 0 39.2 0 48s7.2 16 16 16h16v336c0 44.2 35.8 80 80 80s80-35.8 80-80V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm48 224V64h96v192H64zm0 32h96v112c0 26.5-21.5 48-48 48s-48-21.5-48-48V288zM304 32c-8.8 0-16 7.2-16 16s7.2 16 16 16h16v336c0 44.2 35.8 80 80 80s80-35.8 80-80V64h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H304zm48 224V64h96v192h-96zm0 32h96v112c0 26.5-21.5 48-48 48s-48-21.5-48-48V288z"
        }
    ]
};

const FalVideoArrowDownLeft = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVideoArrowDownLeft",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h256zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm352 290.4 103.4 56.9c5.6 3.1 12 4.7 18.4 4.7 21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8 3.4 0 6.2 2.8 6.2 6.2v243.7c0 3.4-2.8 6.2-6.2 6.2-1 0-2.1-.3-3-.8L416 317.9v36.5zM224 352c8.8 0 16-7.2 16-16s-7.2-16-16-16h-73.4l132.7-132.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L128 297.4V224c0-8.8-7.2-16-16-16s-16 7.2-16 16v112c0 8.8 7.2 16 16 16h112z"
        }
    ]
};

const FalVideoArrowUpRight = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVideoArrowUpRight",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h256zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm352 290.4 103.4 56.9c5.6 3.1 12 4.7 18.4 4.7 21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8 3.4 0 6.2 2.8 6.2 6.2v243.7c0 3.4-2.8 6.2-6.2 6.2-1 0-2.1-.3-3-.8L416 317.9v36.5zM160 160c-8.8 0-16 7.2-16 16s7.2 16 16 16h73.4L100.7 324.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 214.6V288c0 8.8 7.2 16 16 16s16-7.2 16-16V176c0-8.8-7.2-16-16-16H160z"
        }
    ]
};

const FalVideoPlus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVideoPlus",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 96c17.7 0 32 14.3 32 32v256c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h256zM64 64C28.7 64 0 92.7 0 128v256c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm352 290.4 103.4 56.9c5.6 3.1 12 4.7 18.4 4.7 21.1 0 38.2-17.1 38.2-38.2V134.2c0-21.1-17.1-38.2-38.2-38.2-6.4 0-12.8 1.6-18.4 4.7L416 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8 3.4 0 6.2 2.8 6.2 6.2v243.7c0 3.4-2.8 6.2-6.2 6.2-1 0-2.1-.3-3-.8L416 317.9v36.5zM208 176c0-8.8-7.2-16-16-16s-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16h64v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64v-64z"
        }
    ]
};

const FalVideoSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVideoSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM416 175.2V128c0-35.3-28.7-64-64-64H180.1l40.5 32H352c17.7 0 32 14.3 32 32v97l32 25.3v-75zM64 384V135.4l-29.9-23.6C32.7 117 32 122.4 32 128v256c0 35.3 28.7 64 64 64h256c26.4 0 49-16 58.8-38.8l-27.1-21.4c-1.9 15.9-15.3 28.2-31.7 28.2H96c-17.7 0-32-14.3-32-32zm512-249.8v242.4l26.5 20.9c3.5-5.8 5.5-12.5 5.5-19.7V134.2c0-21.1-17.1-38.2-38.2-38.2-6.4 0-12.8 1.6-18.4 4.7L448 157.6v36.5l118.8-65.4c.9-.5 1.9-.8 3-.8 3.4 0 6.2 2.8 6.2 6.2z"
        }
    ]
};

const FalVideo = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVideo",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 96c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H64zM0 128c0-35.3 28.7-64 64-64h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm519.4 283.3L416 354.4v-36.5l118.8 65.4c.9.5 1.9.8 3 .8 3.4 0 6.2-2.8 6.2-6.2V134.2c0-3.4-2.8-6.2-6.2-6.2-1 0-2.1.3-3 .8L416 194.1v-36.5l103.4-56.9c5.6-3.1 12-4.7 18.4-4.7 21.1 0 38.2 17.1 38.2 38.2v243.6c0 21.1-17.1 38.2-38.2 38.2-6.4 0-12.8-1.6-18.4-4.7z"
        }
    ]
};

const FalVihara = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVihara",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m309.8 3.7-26.3 21c-33.9 27.1-72.3 48-113.5 61.8l-31 10.3c-8.4 2.8-12.9 11.9-10.1 20.2s11.9 12.9 20.2 10.1l10.9-3.6v47.2c-28.9 33.7-67.6 57.6-110.7 68.4l-4.8 1.2c-1.3.3-2.5.7-3.6 1.3-2.1 1.1-4 2.6-5.4 4.4s-2.5 4-3 6.3c-.4 1.8-.5 3.6-.3 5.5s.8 3.6 1.6 5.2c1.1 2.1 2.6 4 4.4 5.4s4 2.5 6.3 3c1.2.3 2.5.4 3.9.4H96v61.6c-14.7 31.3-38.9 57.3-69.2 74.1L8.5 417.9c-.6.3-1.2.7-1.7 1.1-1.9 1.3-3.5 3-4.6 5s-1.9 4.1-2.1 6.4c-.2 1.9-.1 3.8.4 5.7s1.3 3.6 2.4 5.2c1.3 1.9 3 3.5 5 4.6s4.1 1.9 6.4 2.1c.7.1 1.3.1 2 .1H64v48c0 8.8 7.2 16 16 16s16-7.2 16-16V448h128v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h47.7c.7 0 1.4 0 2-.1 2.3-.2 4.5-1 6.4-2.1s3.6-2.7 5-4.6c1.1-1.6 1.9-3.3 2.4-5.2s.6-3.8.4-5.7c-.2-2.3-1-4.5-2.1-6.4s-2.7-3.6-4.6-5c-.6-.4-1.1-.7-1.7-1.1l-18.3-10.2c-30.3-16.8-54.5-42.8-69.2-74.1V272h47.7c1.3 0 2.6-.1 3.9-.4 2.3-.5 4.5-1.6 6.3-3s3.4-3.3 4.4-5.4c.8-1.6 1.4-3.4 1.6-5.2s.1-3.7-.3-5.5c-.5-2.3-1.6-4.5-3-6.3s-3.3-3.4-5.4-4.4c-1.1-.6-2.4-1-3.6-1.3l-4.8-1.2c-43.2-10.8-81.8-34.7-110.7-68.4v-47.4l10.9 3.6c8.4 2.8 17.4-1.7 20.2-10.1s-1.7-17.4-10.1-20.2L470 86.5c-41.2-13.7-79.6-34.6-113.5-61.8l-26.3-21c-1.1-.9-2.2-1.6-3.4-2.2-2.1-1-4.5-1.5-6.8-1.5s-4.7.5-6.8 1.5c-1.2.6-2.4 1.3-3.4 2.2zM128 352h389.4c12.5 24.8 30 46.6 51.3 64H71.3c21.3-17.4 38.8-39.2 51.3-64h5.4zm0-32v-48h384v48H128zm64-160v-47.3c40.3-14.9 77.9-36.1 111.5-62.9L320 36.5l16.5 13.2c33.6 26.8 71.2 48.1 111.5 62.9V160H192zm128 80H128.1c20.8-13 39.7-29.2 55.9-48h272c16.2 18.8 35.1 35 55.9 48H320z"
        }
    ]
};

const FalViolin = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalViolin",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M347.3 27.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-320 320c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l320-320zm288 0c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L452.5 164.9c-53.3-45.5-111.2-44.7-152-19-9.9 6.1-12.5 18.5-12.5 30.1 0 35.3-28.7 64-64 64-5.2 0-10.2-.6-15.1-1.8-14.1-3.4-30.2-4-39.8 6.7C143.5 273.3 128 310.8 128 352c0 22.4 4.6 43.7 12.9 63.1l-1.4.9c-7.2 4.4-11.5 12.2-11.5 20.6 0 6.4 2.6 12.6 7.1 17.1l51.2 51.2c4.5 4.5 10.7 7.1 17.1 7.1 8.4 0 16.2-4.4 20.6-11.5l.9-1.4c19.4 8.3 40.7 12.9 63.1 12.9 41.2 0 78.7-15.5 107-41.1 10.7-9.7 10.1-25.8 6.7-39.8-1.2-4.8-1.8-9.9-1.8-15.1 0-35.3 28.7-64 64-64 11.6 0 24-2.6 30.1-12.4 25.7-40.9 26.5-98.7-19-152L635.3 27.3zM429.8 187.6 324.7 292.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l105.1-105.1c34.2 41.3 32.2 81.8 16.4 109.4l-.4.1c-1.2.2-2.6.3-4.4.3-53 0-96 43-96 96 0 7.7.9 15.3 2.7 22.6.6 2.4 1 4.6 1.2 6.5.2 1.6.2 2.7.1 3.6-22.5 19.5-51.9 31.3-84 31.3-16.3 0-31.8-3-46.1-8.6l40.4-65.7c5.8-9.5 4.4-21.7-3.5-29.5l-15.1-15.1c-7.9-7.9-20.1-9.3-29.5-3.5L168.5 398c-5.5-14.2-8.5-29.7-8.5-46 0-32.1 11.8-61.5 31.4-83.9.8-.1 2 0 3.6.1 1.9.2 4.1.6 6.5 1.2 7.3 1.8 14.8 2.7 22.6 2.7 53 0 96-43 96-96 0-1.7.1-3.2.3-4.4l.1-.4c27.6-15.8 68.1-17.9 109.4 16.4zM496 72a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM544 24a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm72 120a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM245.6 388.2l6.1 6.1-49.8 80.9-37.3-37.3 80.9-49.8z"
        }
    ]
};

const FalVirusCovidSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVirusCovidSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M503.3 272H544v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v24h-40.7c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8 17 17c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17 17-28.8 28.8C410.1 91.4 374.8 76 336 72.7V32h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v40.7c-29 2.5-56.2 11.7-79.8 26.2l27.2 21.5C272 109.9 295.3 104 320 104c83.9 0 152 68.1 152 152 0 12.1-1.4 23.9-4.1 35.2l27.2 21.5c4.2-13 7-26.6 8.2-40.7zM168 256c0-12.1 1.4-23.9 4.1-35.2l-27.2-21.5c-4.2 13-7 26.6-8.2 40.7H96v-24c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-24h40.7c3.3 38.8 18.7 74.1 42.4 102.3l-28.8 28.8-17-17c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17-17 28.8-28.8c28.2 23.7 63.5 39 102.3 42.4V480h-24c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-24v-40.7c29-2.5 56.2-11.8 79.8-26.2l-27.2-21.5C368 402.1 344.7 408 320 408c-83.9 0-152-68.1-152-152zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalVirusCovid = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVirusCovid",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M216 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v40.7c-38.8 3.3-74.1 18.7-102.3 42.4l-28.8-28.8 17-17c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-56.6 56.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l17-17 28.8 28.8C91.4 165.9 76 201.2 72.7 240H32v-24c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16v-24h40.7c3.3 38.8 18.7 74.1 42.4 102.3l-28.8 28.8-17-17c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l56.6 56.6c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-17-17 28.8-28.8c28.2 23.7 63.5 39 102.3 42.4V480h-24c-8.8 0-16 7.2-16 16s7.2 16 16 16h80c8.8 0 16-7.2 16-16s-7.2-16-16-16h-24v-40.7c38.8-3.3 74.1-18.7 102.3-42.4l28.8 28.8-17 17c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l56.6-56.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-17 17-28.8-28.8c23.7-28.2 39-63.5 42.4-102.3H480v24c0 8.8 7.2 16 16 16s16-7.2 16-16v-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v24h-40.7c-3.3-38.8-18.7-74.1-42.4-102.3l28.8-28.8 17 17c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56.6-56.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l17 17-28.8 28.8C346.1 91.4 310.8 76 272 72.7V32h24c8.8 0 16-7.2 16-16s-7.2-16-16-16h-80zm40 104a152 152 0 1 1 0 304 152 152 0 1 1 0-304zm-64 104a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm112 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalVirusSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVirusSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M532.5 288H544c17.7 0 32-14.3 32-32s-14.3-32-32-32h-11.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C412.3 118.4 352 93.4 352 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11.5c0 36.4-32.2 59.6-63.3 55.7l35.2 27.8c33.4-11.2 60.1-41.8 60.1-83.5 0 78.4 94.8 117.7 150.2 62.2-55.4 55.5-16.1 150.3 62.3 150.3-29.1 0-52.8 13-68.3 32.3l25.1 19.9c9.9-12 24.8-20.1 43.1-20.1zm-425-32c29.1 0 52.8-13 68.3-32.3l-25.1-19.9c-9.9 12-24.8 20.1-43.1 20.1H96c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.2 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-11.5c0-36.4 32.2-59.6 63.3-55.7L380.1 385c-33.4 11.2-60.1 41.8-60.1 83.4 0-78.4-94.8-117.6-150.2-62.2 55.4-55.4 16.1-150.2-62.3-150.2zM25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4z"
        }
    ]
};

const FalVirus = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVirus",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M75 75c-12.5 12.5-12.5 32.8 0 45.3l8.2 8.2c35.2 35.2 10.2 95.5-39.7 95.5H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h11.5c49.9 0 74.9 60.3 39.6 95.6l-8.1 8.2c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l8.2-8.2c35.3-35.3 95.6-10.3 95.6 39.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32v-11.5c0-49.9 60.3-74.9 95.6-39.6l8.2 8.2c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-8.2-8.2c-35.3-35.3-10.3-95.6 39.6-95.6H480c17.7 0 32-14.3 32-32s-14.3-32-32-32h-11.5c-49.9 0-74.9-60.3-39.6-95.6l8.2-8.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-8.2 8.2C348.3 118.4 288 93.4 288 43.5V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11.5c0 49.9-60.3 74.9-95.6 39.6l-8.2-8.1C107.7 62.5 87.5 62.5 75 75zm331.2 30.8C350.8 161.2 390.1 256 468.5 256c-78.4 0-117.7 94.8-62.2 150.2C350.8 350.8 256 390 256 468.4c0-78.4-94.8-117.6-150.2-62.2C161.2 350.8 121.9 256 43.5 256c78.4 0 117.7-94.8 62.2-150.2C161.2 161.2 256 121.9 256 43.5c0 78.4 94.8 117.7 150.2 62.2zM224 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 64a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm80 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalViruses = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalViruses",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m78.9 327.8 15.2-15.2c30.2-30.2 81.9-8.8 81.9 33.9V368c0 8.8 7.2 16 16 16s16-7.2 16-16v-21.5c0-42.8 51.7-64.2 81.9-33.9l15.2 15.2c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L312.5 290c-30.2-30.2-8.8-81.9 33.9-81.9H368c8.8 0 16-7.2 16-16s-7.2-16-16-16h-21.5c-42.8 0-64.2-51.7-33.9-81.9L327.8 79c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-15.3 15c-30.2 30.3-81.9 8.9-81.9-33.9V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v21.5c0 42.8-51.7 64.2-81.9 33.9L78.9 56.2c-6.2-6.2-16.4-6.3-22.6 0s-6.2 16.4 0 22.6l15.1 15.3c30.2 30.2 8.8 81.9-33.9 81.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h21.5c42.8 0 64.2 51.7 33.9 81.9l-15.2 15.2c-6.2 6.2-6.3 16.4 0 22.6s16.4 6.2 22.6 0zm7-135.8c22.8-17.4 34.9-46.6 31.1-75 28.5 3.8 57.6-8.3 75-31.1 8.4 11 19.5 19.5 32 24.9 13.4 5.8 28.3 8.1 43 6.1-3.8 28.5 8.3 57.6 31.1 75-22.8 17.4-34.9 46.6-31.1 75-28.5-3.8-57.6 8.3-75 31.1-17.4-22.8-46.6-34.9-75-31.1 3.8-28.5-8.3-57.6-31.1-75zm82.1 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm72 32a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm256 128a16 16 0 1 0-32 0 16 16 0 1 0 32 0zm101.8 95.2C574.5 423.9 591 384 624 384c8.8 0 16-7.2 16-16s-7.2-16-16-16c-33 0-49.5-39.9-26.2-63.2 6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0C551.9 289.5 512 273 512 240c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 33-39.9 49.5-63.2 26.2-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6C417.5 312.1 401 352 368 352c-8.8 0-16 7.2-16 16s7.2 16 16 16c33 0 49.5 39.9 26.2 63.2-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0C440.1 446.5 480 463 480 496c0 8.8 7.2 16 16 16s16-7.2 16-16c0-33 39.9-49.5 63.2-26.2 6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6zM579.5 368c-17 14.5-26.3 36.8-24.5 59.1-22.3-1.8-44.6 7.4-59.1 24.5-14.5-17-36.8-26.3-59.1-24.5 1.8-22.3-7.4-44.6-24.5-59.1 17-14.5 26.3-36.8 24.5-59.1 22.3 1.8 44.6-7.4 59.1-24.5 8.5 10 19.7 17.3 32 21.3 8.7 2.8 17.9 3.9 27.1 3.2-1.8 22.3 7.4 44.6 24.5 59.1z"
        }
    ]
};

const FalVoicemail = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVoicemail",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 352a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm144-112c0 45.2-20.9 85.6-53.5 112h171c-32.6-26.4-53.5-66.8-53.5-112 0-79.5 64.5-144 144-144s144 64.5 144 144-64.5 144-144 144H144C64.5 384 0 319.5 0 240S64.5 96 144 96s144 64.5 144 144zm208 112a112 112 0 1 0 0-224 112 112 0 1 0 0 224z"
        }
    ]
};

const FalVolcano = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVolcano",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M213 58.7c-2.5 5-7.4 8.3-12.9 8.8s-11-2-14.3-6.4c-5.9-7.9-15.2-13-25.8-13-17.7 0-32 14.3-32 32s14.3 32 32 32c9.7 0 18.3-4.3 24.2-11.1 3.1-3.6 7.7-5.6 12.4-5.5s9.2 2.3 12.2 6l46.7 58.4c.1.2.3.2.5.2s.4-.1.5-.2l46.7-58.4c3-3.7 7.4-5.9 12.2-6s9.3 1.9 12.4 5.5c5.9 6.8 14.5 11.1 24.2 11.1 17.7 0 32-14.3 32-32s-14.3-32-32-32c-10.6 0-19.9 5.1-25.8 13-3.3 4.5-8.7 6.9-14.3 6.4s-10.5-3.8-12.9-8.8C291.1 42.8 274.8 32 256 32s-35.1 10.8-43 26.7zM256 0c23.9 0 45.3 10.5 60 27.1 10.3-7 22.6-11.1 36-11.1 35.3 0 64 28.7 64 64s-28.7 64-64 64c-12.5 0-24.2-3.6-34.1-9.8l-36.4 45.6c-6.2 7.7-15.6 12.3-25.5 12.3s-19.3-4.5-25.5-12.3l-36.4-45.6c-9.9 6.2-21.5 9.8-34.1 9.8-35.3 0-64-28.7-64-64s28.7-64 64-64c13.4 0 25.8 4.1 36 11.1C210.7 10.5 232.1 0 256 0zM32 459.8C32 471 41 480 52.2 480h407.6c11.1 0 20.2-9 20.2-20.2 0-4.9-1.8-9.7-5.1-13.4L387 347.5 362 385c-6.3 9.4-16.8 15-28 15-8.9 0-17.5-3.6-23.8-9.9l-34.5-34.5C263.1 343.1 246 336 228.3 336c-13.2 0-26.1 3.9-37.1 11.2l-17.8 11.9c-8.7 5.8-18.9 8.9-29.3 8.9s-20.6-3.1-29.3-8.9l-77.7 87.3c-3.3 3.7-5.1 8.5-5.1 13.4zm303.4-92.6 29.6-44.4-40.3-45.3c-12.1-13.7-29.6-21.5-47.8-21.5h-41.8c-18.3 0-35.7 7.8-47.8 21.5l-50.8 57.1c2.4.9 4.9 1.4 7.5 1.4 4.1 0 8.1-1.2 11.6-3.5l17.8-11.9c16.3-10.8 35.4-16.6 54.9-16.6 26.2 0 51.4 10.4 70 29l34.5 34.5c.3.3.8.5 1.2.5.6 0 1.1-.3 1.4-.8zm13.3-111 34.7 39.1 22 24.7 93.5 105.2c8.5 9.5 13.2 21.9 13.2 34.7 0 28.8-23.4 52.2-52.2 52.2H52.2C23.4 512 0 488.6 0 459.8c0-12.8 4.7-25.1 13.2-34.7l74.6-84 21.5-24.1 54.1-60.8c18.2-20.5 44.3-32.2 71.8-32.2H277c27.4 0 53.5 11.7 71.8 32.2z"
        }
    ]
};

const FalVolleyball = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVolleyball",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M415.1 413.7c-85.3 20-177.8 6.8-256.2-42.8-13.5 21.4-24.2 44.4-31.9 68.2 36.5 25.8 81 40.9 129.1 40.9 62.2 0 118.5-25.4 159.1-66.3zm34-44c10.9-18.4 19.2-38.5 24.4-59.8-72 12.5-148.4 1.8-217.2-35.5-31 19.1-57.5 43.1-78.9 70.2 83.6 52.2 184.6 59.1 271.7 25zm30.1-93.4c.6-6.7.9-13.4.9-20.3 0-99.3-64.6-183.5-154.1-212.9 52.5 65.3 80.6 150 72.9 239.3 27.1 1.5 54.1-.6 80.3-6.2zM272.8 32.6c-5.5-.4-11.1-.6-16.8-.6-21.5 0-42.3 3-62 8.7 46.8 56.1 75.7 127.6 77.9 205.8 30.5 16.5 62.6 27.2 95.1 32.5 8-95.3-29.1-184.8-94.2-246.4zM162 52.6C85.2 88.2 32 165.9 32 256c0 7.5.4 14.9 1.1 22.1 34.4-69.3 92.8-127.1 169.6-159.7l3.7-1.6c-12-23.3-27-44.9-44.4-64.2zM45.3 332.3c11.8 32.5 30.9 61.5 55.3 85C125.7 348.8 173.2 288 239.9 247c-1-35.5-8.2-69.5-20.4-100.9l-4.4 1.9C131.4 183.5 71.8 252.2 45.3 332.3zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0z"
        }
    ]
};

const FalVolumeHigh = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVolumeHigh",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 188 288 66.7v378.6L151.6 324c-2.9-2.6-6.7-4-10.6-4H56c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h85c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9l135.5 120.5 10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5 16.5 0 29.8-13.3 29.8-29.8V61.8c0-16.5-13.3-29.8-29.8-29.8zm119.4 147.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C406 216.5 416 235.1 416 256s-10 39.5-25.6 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2c23.3-17.5 38.4-45.4 38.4-76.8s-15.1-59.3-38.4-76.8zm42-69.2c-5.6 6.8-4.7 16.9 2.1 22.5C489.4 161.9 512 206.3 512 256s-22.6 94.1-58.2 123.4c-6.8 5.6-7.8 15.7-2.1 22.5s15.7 7.8 22.5 2.1c42.6-35.1 69.8-88.4 69.8-148s-27.2-112.9-69.8-148.1c-6.8-5.6-16.9-4.7-22.5 2.1zm86.7-73.6c-6.7-5.7-16.8-4.9-22.6 1.8s-4.9 16.8 1.8 22.6c55.3 47 90.4 117 90.4 195.2s-35.1 148.2-90.4 195.2c-6.7 5.7-7.6 15.8-1.8 22.6s15.8 7.6 22.6 1.8C600.5 422.8 640 344 640 256S600.5 89.2 538.4 36.4z"
        }
    ]
};

const FalVolumeLow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVolumeLow",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 188 288 66.7v378.6L151.6 324c-2.9-2.6-6.7-4-10.6-4H56c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h85c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9l135.5 120.5 10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5 16.5 0 29.8-13.3 29.8-29.8V61.8c0-16.5-13.3-29.8-29.8-29.8zm119.4 147.2c-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C406 216.5 416 235.1 416 256s-10 39.5-25.6 51.2c-7.1 5.3-8.5 15.3-3.2 22.4s15.3 8.5 22.4 3.2c23.3-17.5 38.4-45.4 38.4-76.8s-15.1-59.3-38.4-76.8z"
        }
    ]
};

const FalVolumeOff = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVolumeOff",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 66.7 151.6 188c-2.9 2.6-6.7 4-10.6 4H56c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h85c3.9 0 7.7 1.4 10.6 4L288 445.3V66.7zm-17.6-27.2c5.5-4.8 12.5-7.5 19.8-7.5 16.5 0 29.8 13.3 29.8 29.8v388.4c0 16.5-13.3 29.8-29.8 29.8-7.3 0-14.3-2.7-19.8-7.5l10.6-12-10.6 12L134.9 352H56c-30.9 0-56-25.1-56-56v-80c0-30.9 25.1-56 56-56h78.9L270.4 39.5z"
        }
    ]
};

const FalVolumeSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVolumeSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM576 256c0-59.6-27.2-112.9-69.8-148.1-6.8-5.6-16.9-4.7-22.5 2.1s-4.7 16.9 2.1 22.5C521.4 161.9 544 206.3 544 256c0 28.7-7.5 55.6-20.8 78.9l25.4 20C566 326 576 292.2 576 256zm-104 38.4c5.2-11.8 8-24.8 8-38.4 0-31.4-15.1-59.3-38.4-76.8-7.1-5.3-17.1-3.9-22.4 3.2s-3.9 17.1 3.2 22.4C438 216.5 448 235.1 448 256c0 6.1-.9 12-2.4 17.6l26.4 20.8zM352 61.8c0-16.5-13.3-29.8-29.8-29.8-7.3 0-14.3 2.7-19.8 7.5l-72.1 64.1 25.5 20.1 64.2-57v107.8l32 25.3v-138zM88 192h47.6l-40.5-32H88c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9l135.5 120.5 10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5 16.5 0 29.8-13.3 29.8-29.8v-87.4l-32-25.3v107.8L183.6 324c-2.9-2.6-6.7-4-10.6-4H88c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24z"
        }
    ]
};

const FalVolumeXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVolumeXmark",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M151.6 188 288 66.7v378.6L151.6 324c-2.9-2.6-6.7-4-10.6-4H56c-13.3 0-24-10.7-24-24v-80c0-13.3 10.7-24 24-24h85c3.9 0 7.7-1.4 10.6-4zM290.2 32c-7.3 0-14.3 2.7-19.8 7.5L134.9 160H56c-30.9 0-56 25.1-56 56v80c0 30.9 25.1 56 56 56h78.9l135.5 120.5 10.6-12-10.6 12c5.5 4.8 12.5 7.5 19.8 7.5 16.5 0 29.8-13.3 29.8-29.8V61.8c0-16.5-13.3-29.8-29.8-29.8zm121.1 132.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l68.7 68.7-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l68.7-68.7 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L502.6 256l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L480 233.4l-68.7-68.7z"
        }
    ]
};

const FalVolume = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVolume",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 66.7 183.6 188c-2.9 2.6-6.7 4-10.6 4H88c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24h85c3.9 0 7.7 1.4 10.6 4L320 445.3V66.7zm-17.6-27.2c5.5-4.8 12.5-7.5 19.8-7.5 16.5 0 29.8 13.3 29.8 29.8v388.4c0 16.5-13.3 29.8-29.8 29.8-7.3 0-14.3-2.7-19.8-7.5l10.6-12-10.6 12L166.9 352H88c-30.9 0-56-25.1-56-56v-80c0-30.9 25.1-56 56-56h78.9L302.4 39.5zm116.8 142.9c5.3-7.1 15.3-8.5 22.4-3.2 23.3 17.5 38.4 45.4 38.4 76.8s-15.1 59.3-38.4 76.8c-7.1 5.3-17.1 3.9-22.4-3.2s-3.9-17.1 3.2-22.4C438 295.5 448 276.9 448 256s-10-39.5-25.6-51.2c-7.1-5.3-8.5-15.3-3.2-22.4zm87-74.5C548.8 143.1 576 196.4 576 256s-27.2 112.9-69.8 148.1c-6.8 5.6-16.9 4.7-22.5-2.1s-4.7-16.9 2.1-22.5C521.4 350.1 544 305.7 544 256s-22.6-94.1-58.2-123.4c-6.8-5.6-7.8-15.7-2.1-22.5s15.7-7.8 22.5-2.1z"
        }
    ]
};

const FalVrCardboard = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalVrCardboard",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M576 96H64c-17.7 0-32 14.3-32 32v256c0 17.7 14.3 32 32 32h136.4c12.1 0 23.2-6.8 28.6-17.7l39.2-78.3c9.8-19.6 29.9-32 51.8-32s42 12.4 51.8 32l-21.5 10.7 21.5-10.7 39.2 78.3c5.4 10.8 16.5 17.7 28.6 17.7H576c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32zM64 64h512c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H439.6c-24.2 0-46.4-13.7-57.2-35.4l-39.2-78.3c-4.4-8.8-13.4-14.3-23.2-14.3s-18.8 5.5-23.2 14.3l-39.2 78.3c-10.8 21.7-33 35.4-57.2 35.4H64c-35.3 0-64-28.7-64-64V128c0-35.3 28.7-64 64-64zm112 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm0-128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm336 80a48 48 0 1 0-96 0 48 48 0 1 0 96 0zm-128 0a80 80 0 1 1 160 0 80 80 0 1 1-160 0z"
        }
    ]
};

const FalW = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalW",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M10.5 33c8.3-3 17.5 1.2 20.5 9.5l135.2 370L272.6 43.6c2-6.8 8.2-11.6 15.4-11.6s13.4 4.7 15.4 11.6l106.4 368.9L545 42.5c3-8.3 12.2-12.6 20.5-9.5s12.6 12.2 9.5 20.5l-152 416c-2.4 6.5-8.7 10.7-15.6 10.5s-12.9-4.9-14.8-11.6L288 105.7 183.4 468.4c-1.9 6.7-7.9 11.3-14.8 11.6s-13.2-4-15.6-10.5L1 53.5C-2.1 45.2 2.2 36 10.5 33z"
        }
    ]
};

const FalWaffle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWaffle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256a224 224 0 1 0-448 0 224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0 256 256 0 1 1-512 0zM272 80v64h64v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16h-32v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-64v64c0 8.8-7.2 16-16 16s-16-7.2-16-16v-64h-64v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-64h-32c-8.8 0-16-7.2-16-16s7.2-16 16-16h32v-32c0-8.8 7.2-16 16-16s16 7.2 16 16v32h64V80c0-8.8 7.2-16 16-16s16 7.2 16 16zm-96 96v64h64v-64h-64zm0 96v64h64v-64h-64zm96 0v64h64v-64h-64zm0-32h64v-64h-64v64z"
        }
    ]
};

const FalWagonCovered = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWagonCovered",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M239.4 34.1C250.1 13.8 271.4 0 296 0h48c24.6 0 45.9 13.8 56.6 34.1 13.1-12.6 30.6-20.8 50.1-22.1l115.1-7.6c41.7-2.8 71.7 39.5 55.2 77.9L560.3 224c8.7.1 15.7 7.2 15.7 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-16H96v16c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.7 7-15.9 15.7-16L19 82.3C2.5 43.9 32.5 1.6 74.2 4.4l115.1 7.7c19.5 1.3 36.9 9.5 50.1 22.1zM114.6 224H232V91.9c0-25.3-19.6-46.2-44.8-47.9L72.1 36.3c-17.9-1.2-30.7 16.9-23.7 33.4L114.6 224zm293.4 0h117.4l66.2-154.3c7.1-16.5-5.8-34.6-23.7-33.4L452.8 44C427.6 45.7 408 66.6 408 91.9V224zM264 91.9V224h112V64c0-17.7-14.3-32-32-32h-48c-17.7 0-32 14.3-32 32v27.9zM176 512c-61.9 0-112-50.1-112-112s50.1-112 112-112c56.4 0 103.1 41.7 110.9 96h66.3c7.8-54.3 54.4-96 110.9-96 61.9 0 112 50.1 112 112s-50.1 112-112 112c-56.4 0-103.1-41.7-110.9-96h-66.3c-7.8 54.3-54.4 96-110.9 96zm16-33.6c31.3-6.4 56-31.1 62.4-62.4H192v62.4zm-32 0V416H97.6c6.4 31.3 31.1 56 62.4 62.4zm-64-78.8v.8-.8zm1.6-15.6H160v-62.4c-31.3 6.4-56 31.1-62.4 62.4zm94.4-62.4V384h62.4c-6.4-31.3-31.1-56-62.4-62.4zM542.4 416H480v62.4c31.3-6.4 56-31.1 62.4-62.4zm-94.4 0h-62.4c6.4 31.3 31.1 56 62.4 62.4V416zm-64-16v-.4.8-.4zm64-16v-62.4c-31.3 6.4-56 31.1-62.4 62.4H448zm32 0h62.4c-6.4-31.3-31.1-56-62.4-62.4V384z"
        }
    ]
};

const FalWalker = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWalker",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M178.8 32H320c26.5 0 48 21.5 48 48v112H103.4L132 69.1c5.1-21.7 24.5-37.1 46.8-37.1zM368 224v162c-27.6 7.1-48 32.2-48 62 0 35.3 28.7 64 64 64s64-28.7 64-64c0-29.8-20.4-54.9-48-62V80c0-44.2-35.8-80-80-80H178.8c-37.2 0-69.5 25.6-77.9 61.8L.4 492.4c-2 8.6 3.3 17.2 11.9 19.2s17.2-3.3 19.2-11.9L96 223.6v.4h272zm48 224a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FalWalkieTalkie = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWalkieTalkie",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 16c0-8.8-7.2-16-16-16S64 7.2 64 16v80h-8c-30.9 0-56 25.1-56 56v150.1c0 10.6 4.2 20.8 11.7 28.3l17.9 17.9c1.5 1.5 2.3 3.5 2.3 5.7v102c0 30.9 25.1 56 56 56H296c30.9 0 56-25.1 56-56V353.9c0-2.1.8-4.2 2.3-5.7l17.9-17.9c7.5-7.5 11.7-17.7 11.7-28.3V152c0-30.9-25.1-56-56-56H96V16zM80 128h248c13.3 0 24 10.7 24 24v150.1c0 2.1-.8 4.2-2.3 5.7l-17.9 17.9c-7.5 7.5-11.7 17.7-11.7 28.3v102c0 13.3-10.7 24-24 24H88c-13.3 0-24-10.7-24-24V353.9c0-10.6-4.2-20.8-11.7-28.3l-18-17.9c-1.5-1.5-2.3-3.5-2.3-5.7V152c0-13.3 10.7-24 24-24h24zm96-80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zm96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32zM96 192c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z"
        }
    ]
};

const FalWallet = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWallet",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M80 32C35.8 32 0 67.8 0 112v288c0 44.2 35.8 80 80 80h352c44.2 0 80-35.8 80-80V176c0-44.2-35.8-80-80-80H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h320c26.5 0 48 21.5 48 48v224c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h384c8.8 0 16-7.2 16-16s-7.2-16-16-16H80zm304 280a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalWandMagicSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWandMagicSparkles",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M458.3 34.9c3.1-3.1 8.2-3.1 11.3 0L509 74.3c3.1 3.1 3.1 8.2 0 11.3L388.7 206.1 338 155.4 458.3 34.9zM66.9 426.3l248.4-248.4 50.7 50.7-248.3 248.5c-3.1 3.1-8.2 3.1-11.3 0l-39.5-39.4c-3.1-3.1-3.1-8.2 0-11.3zm368.8-414L44.3 403.7c-15.6 15.6-15.6 40.9 0 56.6l39.4 39.4c15.6 15.6 40.9 15.6 56.6 0l391.4-391.4c15.6-15.6 15.6-40.9 0-56.6l-39.4-39.4c-15.6-15.6-40.9-15.6-56.6 0zM128 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48V80zm336 240c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16zM252.2 16c0-6.7-5.4-12.2-12.2-12.2S227.8 9.2 227.8 16v19.8H208c-6.7 0-12.2 5.4-12.2 12.2s5.4 12.2 12.2 12.2h19.8V80c0 6.7 5.4 12.2 12.2 12.2s12.2-5.4 12.2-12.2V60.2H272c6.7 0 12.2-5.4 12.2-12.2s-5.4-12.2-12.2-12.2h-19.8V16z"
        }
    ]
};

const FalWandMagic = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWandMagic",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m305.9 155.3 50.7 50.7L477.1 85.7c3.1-3.1 3.1-8.2 0-11.3l-39.4-39.5c-3.1-3.1-8.2-3.1-11.3 0L305.9 155.3zm-22.6 22.6L34.9 426.3c-3.1 3.1-3.1 8.2 0 11.3L74.3 477c3.1 3.1 8.2 3.1 11.3 0l248.5-248.3-50.7-50.7zm-271 225.8L403.7 12.3c15.6-15.6 40.9-15.6 56.6 0l39.4 39.4c15.6 15.6 15.6 40.9 0 56.6L108.3 499.7c-15.6 15.6-40.9 15.6-56.6 0l-39.4-39.4c-15.6-15.6-15.6-40.9 0-56.6z"
        }
    ]
};

const FalWandSparkles = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWandSparkles",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M472.8 0c-9.6 0-18.9 3.5-26 9.9L169.9 256H136c-22.1 0-40 17.9-40 40v27.1L17.7 393C6.5 403.1 0 417.5 0 432.6c0 14.1 5.6 27.6 15.6 37.6l26.2 26.2c10 10 23.5 15.6 37.6 15.6 15.1 0 29.5-6.4 39.6-17.6L391.1 192H416c17.7 0 32-14.3 32-32v-26.4l55.3-69.1c5.6-7 8.7-15.8 8.7-24.8v-.5C512 17.5 494.5 0 472.8 0zM468 33.8c1.3-1.2 3-1.8 4.8-1.8 4 0 7.2 3.2 7.2 7.2v.5c0 1.7-.6 3.4-1.7 4.8L419.5 118c-2.3 2.8-3.5 6.4-3.5 10v32h-32c-4.5 0-8.9 1.9-11.9 5.3L95.2 473c-4 4.5-9.8 7-15.8 7-5.6 0-11-2.2-15-6.2l-26.2-26.2c-4-4-6.2-9.3-6.2-14.9 0-6 2.6-11.7 7.1-15.8l83.6-74.6c3.4-3 5.3-7.4 5.3-11.9V296c0-4.4 3.6-8 8-8h40c3.9 0 7.7-1.4 10.6-4L468 33.8zM256 32c0-8.8-7.2-16-16-16s-16 7.2-16 16v32h-32c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v32c0 8.8 7.2 16 16 16s16-7.2 16-16V96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16h-32V32zM96 80c0-8.8-7.2-16-16-16s-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V80zm352 224c0-8.8-7.2-16-16-16s-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48v48c0 8.8 7.2 16 16 16s16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48v-48z"
        }
    ]
};

const FalWand = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWand",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M446.8 9.9c7.2-6.4 16.4-9.9 26-9.9C494.5 0 512 17.5 512 39.2v.5c0 9-3.1 17.8-8.7 24.8L448 133.6V160c0 17.7-14.3 32-32 32h-24.9L119 494.4A53.336 53.336 0 0 1 79.4 512c-14.1 0-27.7-5.6-37.6-15.6l-26.2-26.2C5.6 460.2 0 446.7 0 432.6c0-15.1 6.5-29.5 17.7-39.6L96 323.1V296c0-22.1 17.9-40 40-40h33.9L446.8 9.9zm26 22.1c-1.8 0-3.5.6-4.8 1.8L186.6 284c-2.9 2.6-6.7 4-10.6 4h-40c-4.4 0-8 3.6-8 8v34.3c0 4.6-1.9 8.9-5.3 11.9l-83.6 74.7c-4.5 4-7.1 9.7-7.1 15.8 0 5.6 2.2 11 6.2 14.9l26.2 26.2c4 4 9.4 6.2 15 6.2 6 0 11.8-2.6 15.8-7l276.9-307.7c3-3.4 7.4-5.3 11.9-5.3h32v-32c0-3.6 1.2-7.2 3.5-10l58.8-73.5c1.1-1.4 1.7-3.1 1.7-4.8v-.5c0-4-3.2-7.2-7.2-7.2z"
        }
    ]
};

const FalWarehouseFull = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWarehouseFull",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0l262.1 110.4c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v272c0 8.8-7.2 16-16 16s-16-7.2-16-16V224H128v272c0 8.8-7.2 16-16 16s-16-7.2-16-16V224zm256 176v80h80c8.8 0 16-7.2 16-16v-48c0-8.8-7.2-16-16-16h-80zm-32 80v-80H192v64c0 8.8 7.2 16 16 16h112zm0-176c0-8.8-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16v64h128v-64zm112 64c26.5 0 48 21.5 48 48v48c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V304c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v64h80z"
        }
    ]
};

const FalWarehouse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWarehouse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M326.2 36c-4-1.7-8.4-1.7-12.4 0L51.6 146.4C39.7 151.4 32 163 32 175.9V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-25.8 15.4-49 39.2-59L301.4 6.5c11.9-5 25.3-5 37.3 0l262.1 110.4c23.7 10 39.2 33.2 39.2 59V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V175.9c0-12.9-7.7-24.5-19.6-29.5L326.2 36zM96 224c0-17.7 14.3-32 32-32h384c17.7 0 32 14.3 32 32v272c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V224zm32 256h384v-64H128v64zm384-160H128v64h384v-64zm-384-32h384v-64H128v64z"
        }
    ]
};

const FalWashingMachine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWashingMachine",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 32c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0h320c35.3 0 64 28.7 64 64v384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm165.7 255c-7 .7-14.3 1-21.7 1-41.8 0-72.9-20.8-95.7-36l-2.1-1.4c-25-16.7-41.3-26.6-62.2-26.6-9.8 0-20.6 1.6-31.4 4-.4 3.9-.6 7.9-.6 12 0 61.9 50.1 112 112 112 45.1 0 84-26.6 101.7-65zm9.5-33.4c.5-4.4.8-8.9.8-13.5 0-61.9-50.1-112-112-112-45.3 0-84.4 27-102 65.7 7.4-1.1 14.8-1.7 22-1.7 32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5zM80 304a144 144 0 1 1 288 0 144 144 0 1 1-288 0z"
        }
    ]
};

const FalWatchApple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWatchApple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 48v16h192V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v17.6c36.5 7.4 64 39.7 64 78.4v224c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48v-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-16H96v16zM80 96c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm112 136a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56-120a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-56-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm-56 96a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm168-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalWatchCalculator = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWatchCalculator",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 48v16h192V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v17.6c36.5 7.4 64 39.7 64 78.4v224c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48v-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-16H96v16zM80 96c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm16 96h192v-32H96v32zm-32-48c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zm64 136a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm64 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm112-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zM104 384a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm112-24a24 24 0 1 1-48 0 24 24 0 1 1 48 0zm64 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48z"
        }
    ]
};

const FalWatchFitness = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWatchFitness",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 48v16h192V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v17.6c36.5 7.4 64 39.7 64 78.4v224c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48v-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-16H96v16zM80 96c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm32 125.3c0 7.8 3.1 15.2 8.6 20.7l71.4 71.4 71.4-71.4c5.5-5.5 8.6-12.9 8.6-20.7 0-16.2-13.1-29.3-29.3-29.3-7.8 0-15.2 3.1-20.7 8.6l-18.7 18.7c-6.2 6.2-16.4 6.2-22.6 0L162 200.6c-5.5-5.5-12.9-8.6-20.7-8.6-16.2 0-29.3 13.1-29.3 29.3zm29.3-61.3c16.2 0 31.8 6.5 43.3 17.9l7.4 7.4 7.4-7.4c11.5-11.5 27.1-17.9 43.3-17.9 33.8 0 61.3 27.4 61.3 61.3 0 16.2-6.5 31.8-17.9 43.3l-82.7 82.7c-6.2 6.2-16.4 6.2-22.6 0l-82.9-82.7C86.5 253.1 80 237.5 80 221.3c0-33.8 27.4-61.3 61.3-61.3z"
        }
    ]
};

const FalWatchSmart = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWatchSmart",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M96 48v16h192V48c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM64 65.6V48c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v17.6c36.5 7.4 64 39.7 64 78.4v224c0 38.7-27.5 71-64 78.4V464c0 26.5-21.5 48-48 48H112c-26.5 0-48-21.5-48-48v-17.6C27.5 439 0 406.7 0 368V144c0-38.7 27.5-71 64-78.4zM96 464c0 8.8 7.2 16 16 16h160c8.8 0 16-7.2 16-16v-16H96v16zM80 96c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H80zm128 80v71.4l40.9 27.2c7.4 4.9 9.3 14.8 4.4 22.2s-14.8 9.3-22.2 4.4l-48-32c-4.5-3-7.1-8-7.1-13.3V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"
        }
    ]
};

const FalWatch = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWatch",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 32h128c17.7 0 32 14.3 32 32v25.7C259.8 73.3 227 64 192 64s-67.8 9.3-96 25.7V64c0-17.7 14.3-32 32-32zm-64 80h1C25.1 147.2 0 198.7 0 256s25.1 108.8 65 144h-1v48c0 35.3 28.7 64 64 64h128c35.3 0 64-28.7 64-64v-48h-1c39.9-35.2 65-86.7 65-144s-25.1-108.8-65-144h1V64c0-35.3-28.7-64-64-64H128C92.7 0 64 28.7 64 64v48zm224 310.3V448c0 17.7-14.3 32-32 32H128c-17.7 0-32-14.3-32-32v-25.7c28.2 16.3 61 25.7 96 25.7s67.8-9.4 96-25.7zM32 256a160 160 0 1 1 320 0 160 160 0 1 1-320 0zm176-80c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 5.3 2.7 10.3 7.1 13.3l48 32c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L208 247.4V176z"
        }
    ]
};

const FalWaterArrowDown = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWaterArrowDown",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 0c8.8 0 16 7.2 16 16v169.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-80 80c-6.2 6.2-16.4 6.2-22.6 0l-80-80c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l52.7 52.7V16c0-8.8 7.2-16 16-16zM133.8 458.8C150.3 470 171.1 480 192 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 470 363.1 480 384 480s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 512.1 0 504 0 494.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9zM192 352c20.9 0 41.6-9.9 58.2-21.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 342 363.1 352 384 352s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 384.1 0 376 0 366.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9C150.3 342 171.1 352 192 352z"
        }
    ]
};

const FalWaterArrowUp = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWaterArrowUp",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 240c8.8 0 16-7.2 16-16V54.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L272 54.6V224c0 8.8 7.2 16 16 16zM133.8 458.8c-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 480.1 0 486.4 0 494.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 470 404.9 480 384 480s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 470 212.9 480 192 480s-41.7-9.9-58.2-21.2zM192 352c-20.9 0-41.7-9.9-58.2-21.2-9.7-6.6-18-14-25.9-21.9-6.6-6.5-17.2-6.5-23.8 0-7.9 7.9-16.1 15.2-25.9 21.9-12.8 8.7-28.1 16.6-44 19.8C6.4 352.1 0 358.4 0 366.2c0 9.8 8 17.9 17.7 16.2 23.1-4 43.6-15 58.5-25.2 7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 18.6 12.7 45.9 26.8 76.2 26.8s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3 5.1 4.5 11.9 9.9 19.8 15.3 15 10.2 35.4 21.2 58.5 25.2 9.7 1.7 17.7-6.4 17.7-16.2 0-7.9-6.4-14.1-14.1-15.7-16-3.1-31.3-11.1-44.1-19.8-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C425.6 342 404.9 352 384 352s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9-6.6-6.5-17.2-6.5-23.7 0-7.9 7.9-16.1 15.2-25.9 21.9C233.6 342 212.9 352 192 352z"
        }
    ]
};

const FalWaterLadder = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWaterLadder",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M128 112c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48v112.2h224V112c0-44.2 35.8-80 80-80s80 35.8 80 80v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-26.5-21.5-48-48-48s-48 21.5-48 48v266.2c-10.8 4-21.8 6.2-32 6.2V256.2H160v122c-9.5-3.5-18.8-8.3-27.1-14.1-1.6-1.1-3.2-2.2-4.9-3.1V112zm64 336c20.9 0 41.6-9.9 58.2-21.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 438 363.1 448 384 448s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 480.1 0 472 0 462.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9C150.3 438 171.1 448 192 448z"
        }
    ]
};

const FalWater = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWater",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M133.8 106.8C150.3 118 171.1 128 192 128s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 118 363.1 128 384 128s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 160.1 0 152 0 142.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9zm0 288C150.3 406 171.1 416 192 416s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 406 363.1 416 384 416s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 448.1 0 440 0 430.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9zM192 272c20.9 0 41.6-9.9 58.2-21.2 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9C342.3 262 363.1 272 384 272s41.6-9.9 58.2-21.2c9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.5 23.7 0 7.9 7.9 16.2 15.2 26 21.9 12.8 8.7 28.1 16.6 44.1 19.8 7.7 1.5 14.1 7.8 14.1 15.7 0 9.8-8 17.9-17.7 16.2-23.1-4-43.6-15-58.5-25.2-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.6-45.9 26.7-76.2 26.7s-57.6-14.1-76.2-26.8c-7.9-5.4-14.7-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-18.7 12.7-45.9 26.8-76.2 26.8s-57.6-14.1-76.2-26.8c-7.9-5.4-14.6-10.8-19.8-15.3-5.1 4.5-11.8 9.9-19.8 15.3-14.9 10.2-35.4 21.2-58.5 25.2C8 304.1 0 296 0 286.2c0-7.9 6.4-14.1 14.1-15.7 15.9-3.1 31.3-11.1 44-19.8 9.8-6.7 18-14 25.9-21.9 6.6-6.5 17.2-6.6 23.8 0 7.9 7.9 16.2 15.2 25.9 21.9C150.3 262 171.1 272 192 272z"
        }
    ]
};

const FalWatermelonSlice = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWatermelonSlice",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M404.7 4.7c6.2-6.2 16.4-6.2 22.6 0C481.5 58.9 512 132.5 512 209.1v4C512 378.2 378.2 512 213.2 512h-4C132.5 512 59 481.5 4.7 427.3c-6.2-6.2-6.2-16.4 0-22.6l400-400zm11 34.3L391 63.7c35.5 40.8 57 94 57 152.3 0 128.1-103.9 232-232 232-58.3 0-111.6-21.5-152.3-57L39 415.6C85.8 457 146.3 480 209.1 480h4C360.5 480 480 360.5 480 213.2v-4c0-62.8-23-123.3-64.4-170.2zM86.3 368.3C121.3 398 166.5 416 216 416c110.5 0 200-89.5 200-200 0-49.5-18-94.7-47.7-129.7l-282 282zm261-203.6 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-80 80 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm88 8 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm-168 72 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0zm88 8 16 16c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-16-16c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z"
        }
    ]
};

const FalWavePulse = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWavePulse",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M319.6 0c7.5-.2 14.1 4.9 15.9 12.1l84 336 37.6-93.9C464.4 236 482 224 501.7 224H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H501.7c-6.5 0-12.4 4-14.9 10.1l-56 139.9c-2.6 6.4-9 10.5-15.9 10s-12.8-5.4-14.4-12.1l-78.7-315-82 410.2c-1.5 7.3-7.8 12.7-15.3 12.9s-14.1-4.9-15.9-12.1l-58.1-231.8c-1.7-7.1-8.1-12.1-15.5-12.1H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h119c22 0 41.2 15 46.6 36.4l40.7 162.7 82-410.2C305.8 5.5 312.1.2 319.6 0z"
        }
    ]
};

const FalWaveSine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWaveSine",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M31.4 244.2v-.1l.1-.3.4-1.3c.3-1.2.9-3 1.6-5.2 1.5-4.6 3.7-11.2 6.7-19.1 6-15.9 15.2-37 27.6-58C93.2 117 129.1 80 176 80c36.5 0 61.1 19.2 80.8 52.2 20.2 33.9 33.7 79.7 47.9 128.3l.4 1.3c13.7 47 28.2 96.6 50.7 134.4 23.3 39 56.8 67.8 108.2 67.8 65.1 0 109.2-51 135.8-95.9 13.6-23 23.5-45.9 29.9-63 3.2-8.6 5.6-15.7 7.3-20.8.8-2.5 1.4-4.5 1.8-5.9.2-.7.4-1.2.5-1.6l.1-.5v-.1L624 272l15.4 4.2c2.3-8.5-2.7-17.3-11.2-19.6s-17.3 2.7-19.6 11.2v.1l-.1.3-.4 1.3c-.3 1.2-.9 3-1.6 5.2-1.5 4.6-3.7 11.2-6.7 19.1-6 15.9-15.2 37-27.6 58C546.8 395 510.9 432 464 432c-36.5 0-61.1-19.2-80.8-52.2-20.2-33.9-33.7-79.7-47.9-128.3l-.4-1.3c-13.7-47-28.2-96.6-50.7-134.4C260.9 76.8 227.5 48 176 48c-65.1 0-109.2 51-135.8 95.9-13.6 23-23.5 45.9-29.9 63-3.3 8.5-5.7 15.6-7.3 20.7-.8 2.5-1.4 4.5-1.8 5.9-.2.7-.4 1.2-.5 1.6l-.1.5v.1l15.4 4.2-15.4-4.1c-2.3 8.5 2.7 17.3 11.2 19.6s17.3-2.7 19.6-11.2z"
        }
    ]
};

const FalWaveSquare = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWaveSquare",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 64c-8.8 0-16 7.2-16 16v144c0 26.5-21.5 48-48 48H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h112c8.8 0 16-7.2 16-16V80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V288c0-26.5 21.5-48 48-48h112c8.8 0 16 7.2 16 16s-7.2 16-16 16H512c-8.8 0-16 7.2-16 16v144c0 26.5-21.5 48-48 48h-96c-26.5 0-48-21.5-48-48V80c0-8.8-7.2-16-16-16h-96z"
        }
    ]
};

const FalWaveTriangle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWaveTriangle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176.1 32c5.2 0 10.1 2.6 13 6.9l275 397.3L611 230.7c5.1-7.2 15.1-8.9 22.3-3.7s8.9 15.1 3.7 22.3l-160 224c-3 4.2-7.9 6.7-13.1 6.7s-10.1-2.6-13-6.9L175.8 75.8 29 281.3c-5.1 7.2-15.1 8.9-22.3 3.7s-8.9-15.1-3.7-22.3l160-224c3-4.2 7.9-6.7 13.1-6.7z"
        }
    ]
};

const FalWaveformLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWaveformLines",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c8.8 0 16 7.2 16 16v480c0 8.8-7.2 16-16 16s-16-7.2-16-16V16c0-8.8 7.2-16 16-16zm192 64c8.8 0 16 7.2 16 16v352c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM224 96c8.8 0 16 7.2 16 16v288c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm192 32c8.8 0 16 7.2 16 16v224c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-288 64c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16v-96c0-8.8 7.2-16 16-16zm-96 32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16zm576 0c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16s-16-7.2-16-16v-32c0-8.8 7.2-16 16-16z"
        }
    ]
};

const FalWaveform = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWaveform",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 0c8 0 14.8 5.9 15.9 13.9l49.3 369.5 47-305.8c1.2-7.9 8-13.6 16-13.6s14.6 6 15.7 13.8l34.6 254L528.3 173c1.4-7.3 7.6-12.7 15-13s14.1 4.5 16.1 11.6L588.1 272H624c8.8 0 16 7.2 16 16s-7.2 16-16 16h-48c-7.1 0-13.4-4.7-15.4-11.6l-13.4-46.8-35.5 189.3c-1.4 7.7-8.3 13.2-16.1 13s-14.4-6.1-15.5-13.8L447 191.4l-47.2 307c-1.2 7.9-8 13.6-16 13.6s-14.6-6-15.7-13.9l-48.1-361-48.1 361c-1.1 7.9-7.7 13.8-15.7 13.9s-14.8-5.7-16-13.6l-47.2-307-33.1 242.8c-1.1 7.8-7.6 13.6-15.5 13.8s-14.7-5.3-16.1-13L92.8 245.6l-13.4 46.8c-2 6.9-8.2 11.6-15.4 11.6H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h35.9l28.7-100.4c2-7.1 8.7-11.9 16.1-11.6s13.6 5.7 15 13l29.8 158.8 34.6-254c1.1-7.9 7.8-13.8 15.7-13.8s14.7 5.7 16 13.6l47.1 305.9 49.2-369.6C305.2 5.9 312 0 320 0z"
        }
    ]
};

const FalWebhook = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWebhook",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M192 128c0-53 43-96 96-96s96 43 96 96c0 8.8 7.2 16 16 16s16-7.2 16-16C416 57.3 358.7 0 288 0S160 57.3 160 128c0 40 18.4 75.8 47.1 99.2L147.3 323c-6.1-1.9-12.6-3-19.3-3-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64c0-17.1-6.7-32.6-17.6-44.1L238 238.2c7.2-11.5 3.2-25.5-6.5-32.7-24-17.4-39.5-45.6-39.5-77.5zm-32 256a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm128-224a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm-64-32c0 35.3 28.7 64 64 64 6.7 0 13.2-1 19.3-3l63.5 101.7c7.2 11.5 21.6 14.1 32.2 8.4 13.5-7.1 28.7-11.1 45-11.1 53 0 96 43 96 96s-43 96-96 96c-18.7 0-36.1-5.3-50.9-14.6-7.5-4.7-17.4-2.4-22.1 5.1s-2.4 17.4 5.1 22.1c19.7 12.3 43 19.5 67.9 19.5 70.7 0 128-57.3 128-128s-57.3-128-128-128c-19.2 0-37.4 4.2-53.8 11.8l-59.8-95.7c10.9-11.5 17.6-27 17.6-44.1 0-35.3-28.7-64-64-64s-64 28.7-64 64zM73.2 305.2c7.2-5.1 9-15 4-22.3s-15-9-22.3-4C21.7 302.1 0 340.5 0 384c0 70.7 57.3 128 128 128 65.3 0 119.1-48.9 127-112h131c7.1 27.6 32.2 48 62 48 35.3 0 64-28.7 64-64s-28.7-64-64-64c-29.8 0-54.9 20.4-62 48H248c-13.5 0-23.4 10.8-24.2 22.9-3.6 49.8-45.1 89.1-95.8 89.1-53 0-96-43-96-96 0-32.6 16.2-61.4 41.2-78.8zM480 384a32 32 0 1 1-64 0 32 32 0 1 1 64 0z"
        }
    ]
};

const FalWeightHanging = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWeightHanging",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M208 80a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm112 48c10-13.4 16-30 16-48 0-44.2-35.8-80-80-80s-80 35.8-80 80c0 18 6 34.6 16 48h-72c-22 0-41.2 15-46.6 36.4l-72 288c-3.6 14.3-.4 29.5 8.7 41.2S33.2 512 48 512h416c14.8 0 28.7-6.8 37.8-18.5s12.3-26.8 8.7-41.2l-72-288C433.2 143 414 128 392 128h-72zm-64 32h136c7.3 0 13.7 5 15.5 12.1l72 288c1.2 4.8.1 9.8-2.9 13.7s-7.7 6.2-12.6 6.2H48c-4.9 0-9.6-2.3-12.6-6.2s-4.1-8.9-2.9-13.7l72-288c1.8-7.1 8.2-12.1 15.5-12.1h136z"
        }
    ]
};

const FalWeightScale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWeightScale",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M112 176a144 144 0 1 1 288 0 144 144 0 1 1-288 0zm320 0c0-28.8-6.9-56-19.2-80H448c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32h35.2C86.9 120 80 147.2 80 176c0 97.2 78.8 176 176 176s176-78.8 176-176zM391.8 64C359.5 24.9 310.7 0 256 0S152.5 24.9 120.2 64H64C28.7 64 0 92.7 0 128v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64h-56.2zM320 224c0-20.6-9.7-39-24.9-50.7l23.6-55c3.5-8.1-.3-17.5-8.4-21s-17.5.3-21 8.4l-23.6 55c-3.2-.5-6.4-.7-9.7-.7-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64zm-64-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"
        }
    ]
};

const FalWhale = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWhale",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M164.9.8c5.7 1.8 9.9 6.7 10.9 12.6l14.1 84.7 84.7 14.1c5.9 1 10.8 5.2 12.6 10.9s.3 12-3.9 16.2L242.6 180c-18.3 18.3-44.2 26.6-69.7 22.3L111 192l-40.2 58.4c-9.2 13.3-10.4 30.6-3.1 45 7.5 15.1 22.9 24.6 39.7 24.6h3.2c11.3 0 22.2-3.8 31-10.9l129.3-103.4c62.9-50.3 140.9-77.7 221.4-77.7 81.6 0 147.7 66.1 147.7 147.7V384c0 53-43 96-96 96H162.4C72.7 480 0 407.3 0 317.6c0-39.5 15.7-77.3 43.6-105.2l46.5-46.5 3.4-3.4-7.9-47.4c-4.2-25.5 4.1-51.4 22.4-69.7l40.7-40.7c4.2-4.2 10.5-5.8 16.2-3.9zm-15.6 48.5L130.6 68c-11 11-16 26.5-13.4 41.8l8.7 52.2 52.2 8.7c15.3 2.5 30.9-2.4 41.8-13.4l18.7-18.7-65.3-10.9c-6.7-1.1-12-6.4-13.2-13.2l-10.8-65.2zM368 296a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm-334.1.5c-1.3 6.9-1.9 14-1.9 21.2C32 389.6 90.4 448 162.4 448H544c35.3 0 64-28.7 64-64V275.7c0-63.9-51.8-115.7-115.7-115.7-73.2 0-144.2 24.9-201.4 70.7L161.6 334.1c-14.5 11.6-32.4 17.9-50.9 17.9h-3.2c-28.9 0-55.4-16.4-68.4-42.2-2.2-4.3-3.9-8.8-5.2-13.3z"
        }
    ]
};

const FalWheatAwnCircleExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWheatAwnCircleExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M491.2 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L341.8 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-46.9 46.8c-4.5-6.5-9.6-12.8-15.4-18.6l-22.6-22.5c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9C7 278.8 7 339.6 44.4 377.1l34 33.9-73.6 73.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l73.6-73.5 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c8.3-.5 16.5-2 24.4-4.6-2-10.5-3-21.4-3-32.4v-.7c-23.6 10.9-52.5 6.6-72-12.9l-33.9-33.9c31.8-31.8 80.3-36.6 117.1-14.5 4.5-12 10.3-23.4 17.2-33.9-3.5-2.3-6.9-5-9.9-8.1l-33.9-34c29.9-29.8 74.5-35.9 110.3-18.2 11.6-6.1 24.1-10.9 37-14.2-2.5-2-5-3.8-7.6-5.6l46.8-46.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L414.2 177c-16.1-5.5-33-7.8-49.8-6.7l126.8-127zM191.8 297.5l-.3.3-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.4 37.4 37.5 97.9.4 135.4zM248 82.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7L248 173.4c-25-25-25-65.5 0-90.5zM89.7 241.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6zm181 181L248 444.9c-25 25-65.5 25-90.5 0L123.6 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zM384 368a112 112 0 1 1 224 0 112 112 0 1 1-224 0zm256 0a144 144 0 1 0-288 0 144 144 0 1 0 288 0zm-144 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-160c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16s16-7.2 16-16v-64c0-8.8-7.2-16-16-16z"
        }
    ]
};

const FalWheatAwnSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWheatAwnSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm235.7 288-37 37c1.9-31.2-7.5-62.9-28.2-88.5L149.7 203c-2.8.7-5.4 2.1-7.6 4.2l-33.9 33.9c-37.5 37.5-37.5 98.3 0 135.8l34 34.1-73.5 73.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l73.5-73.5 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-27-27-63.2-39.4-98.5-37.2l39.7-39.8-25.3-20zm27.6-231.1c-18.7 18.7-28 43.2-28.1 67.7l40.4 31.9c-13.9-24.4-10.5-56.1 10.4-76.9l22.6-22.6 11.3 11.3c35.1 35.1 37.3 90.7 6.6 128.4l26.5 20.9c37.6-28.1 91.1-25.1 125.3 9.1l11.3 11.3-22.6 22.6c-10.3 10.3-23.2 16.3-36.6 18.2l30.6 24.2c10.3-4.6 20-11.2 28.5-19.7l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-5.8-5.8-12-10.9-18.6-15.4l46.9-47.1c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L478 176.9c-16.1-5.5-33-7.8-49.8-6.7L555 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L405.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-46.8 46.8c-4.5-6.5-9.6-12.8-15.4-18.6l-22.6-22.5c-6.2-6.2-16.4-6.2-22.6 0l-34 33.9zM130.9 263.9l22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5zm181 181c-25 25-65.5 25-90.5 0L187.5 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3-22.6 22.6z"
        }
    ]
};

const FalWheatAwn = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWheatAwn",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M491 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L341.6 147.5c1-16.8-1.2-33.7-6.7-49.8l54.3-54.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-46.8 46.8c-4.5-6.5-9.6-12.8-15.4-18.6l-22.6-22.5c-6.2-6.2-16.4-6.2-22.6 0l-34 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.9 33.9c-17.4 17.4-26.7 39.8-28 62.6l-6-6c-6.2-6.2-16.4-6.2-22.6 0l-33.8 33.9c-37.5 37.5-37.5 98.3 0 135.8L78.2 411 4.7 484.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l73.5-73.5 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c22.8-1.3 45.2-10.6 62.5-28l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-6-6c22.8-1.3 45.2-10.6 62.5-28l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-5.8-5.8-12-10.9-18.6-15.4l47-46.9c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L414 176.9c-16.1-5.5-33-7.8-49.8-6.7L491 43.3zM191.6 297.5l-.3.3-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.4 37.4 37.5 97.9.4 135.4zm56.3-214.6 22.6-22.6 11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5zM89.5 241.3l11.3 11.3c37.5 37.5 37.5 98.2 0 135.7l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6zm181 181-22.6 22.6c-25 25-65.5 25-90.5 0L123.5 411c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zm90.5-90.5-22.6 22.6c-25 25-65.5 25-90.5 0L214 320.5c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3zm90.5-90.5-22.6 22.6c-25 25-65.5 25-90.5 0l-34-33.9c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3z"
        }
    ]
};

const FalWheatSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWheatSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M25.9 3.4C19-2 8.9-.8 3.4 6.1s-4.2 17 2.7 22.5l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zm497.6 275.1 33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-18-18-40-29.5-63.2-34.6l16.9-.8c45.1-2.3 81.2-38.4 83.5-83.5l2.7-54c.7-14.2-11-25.9-25.2-25.2l-54 2.7c-45.1 2.3-81.2 38.4-83.5 83.5l-.9 17.7c-4.9-23.5-16.5-46-34.8-64.2l-22.5-22.6c-6.2-6.2-16.4-6.2-22.6 0l-34 33.9c-18.7 18.7-28 43.2-28.1 67.7l40.4 31.9C295.6 127.5 299 95.8 319.9 75l22.6-22.6 11.3 11.3c35.1 35.1 37.3 90.7 6.6 128.4l26.5 20.9c37.6-28.1 91.1-25.1 125.3 9.1l11.3 11.3-22.6 22.6c-10.3 10.3-23.2 16.3-36.5 18.2l30.6 24.2c10.3-4.6 20-11.2 28.5-19.7zm-236.6 32.9-25.3-20-29 29c1.3-20.6-2.4-41.5-11-60.6l-73.7-58.2-31.6 31.6c-37.5 37.5-37.5 98.3 0 135.8l33.9 34-81.5 81.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l81.5-81.5 33.9 33.9c37.5 37.5 98.3 37.5 135.8 0l33.9-33.9c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-27-27-63.2-39.4-98.6-37.2l31.7-31.7zM542.3 33.7 540 78.9c-1.4 28.7-24.4 51.7-53.1 53.1l-45.2 2.3 2.3-45.2c1.4-28.7 24.4-51.7 53.1-53.1l45.2-2.3zM172.8 380.3l-33.9-33.9c-25-25-25-65.5 0-90.5l22.6-22.6 11.3 11.3c37.2 37.2 37.5 97.4.8 135l-.8.8zm147.1 56.5c-25 25-65.5 25-90.5 0L195.5 403c37.5-37.5 98.2-37.5 135.7 0l11.3 11.3-22.6 22.6z"
        }
    ]
};

const FalWheat = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWheat",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M433.1 36c-28.7 1.4-51.7 24.4-53.1 53.1l-2.3 45.2 45.2-2.3c28.7-1.4 51.7-24.4 53.1-53.1l2.3-45.2-45.2 2.3zM348 87.5c2.3-45.1 38.4-81.2 83.5-83.5l54-2.7c14.2-.7 25.9 11 25.2 25.2l-2.7 54c-2.3 45.1-38.3 81.2-83.5 83.5l-16.9.8c23.1 5 45.2 16.6 63.2 34.6l22.6 22.6c6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-17.4 17.4-39.8 26.7-62.6 28l6 6c6.2 6.2 6.2 16.4 0 22.6L369 369c-17.4 17.4-39.8 26.7-62.5 28l6 6c6.2 6.2 6.2 16.4 0 22.6l-33.9 33.9c-37.5 37.5-98.3 37.5-135.8 0l-33.9-33.9-81.6 81.5c-6.2 6.2-16.4 6.3-22.6 0s-6.2-16.4 0-22.6L86.2 403l-33.9-33.9c-37.5-37.5-37.5-98.3 0-135.8l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0l6 6c1.3-22.8 10.6-45.2 28-62.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0l6 6c1.3-22.8 10.6-45.2 28-62.6l33.9-33.9c6.2-6.2 16.4-6.2 22.6 0L312.4 41c18.3 18.3 29.9 40.7 34.8 64.2l.9-17.7zm88.8 168.4 22.6-22.6-11.3-11.3c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0zm-181-90.5 33.9 33.9 1.5-1.5c36-37.6 35.5-97.3-1.5-134.3l-11.2-11.2-22.6 22.6c-25 25-25 65.5 0 90.5zm-56.6-11.3L188 142.8l-22.6 22.6c-25 25-25 65.5 0 90.5l33.9 33.9 1.3-1.3c36.2-37.6 35.8-97.4-1.3-134.5zm-90.4 226.2.8-.8c36.7-37.6 36.4-97.7-.8-135l-11.3-11.2-22.6 22.6c-25 25-25 65.5 0 90.5l33.9 33.9zm147.1 56.5 22.6-22.6-11.3-11.2c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0zm90.5-90.5 22.6-22.6-11.3-11.3c-37.5-37.5-98.2-37.5-135.7 0l33.9 33.9c25 25 65.5 25 90.5 0z"
        }
    ]
};

const FalWheelchairMove = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWheelchairMove",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M368 80a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm0-80a56 56 0 1 1 0 112 56 56 0 1 1 0-112zM199.5 106.9c-11.9-4.9-25.6-2.1-34.7 7l-41.4 41.4c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l41.4-41.4c18.2-18.2 45.6-23.7 69.5-14L313.5 119c31.7 13 40 54.1 15.8 78.4l-49.1 49.1c6.9 7.9 13.1 16.4 18.4 25.6h113.5c20.5 0 35.7 19 31.2 38.9l-27.7 124.5c-1.9 8.6-10.5 14.1-19.1 12.1s-14.1-10.5-12.1-19.1L412.1 304h-99.4c4.8 15.2 7.3 31.3 7.3 48 0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c5.6 0 11.1.3 16.5.8l67.7-67.7-44.7-18.3zm107.2 67.8c8.1-8.1 5.3-21.8-5.3-26.1l-25.1-10.3-62.8 62.8c15.7 5.6 30.3 13.5 43.3 23.4l49.9-49.9zM160 480a128 128 0 1 0 0-256 128 128 0 1 0 0 256z"
        }
    ]
};

const FalWheelchair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWheelchair",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M176 32a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-32.4 96c-2-8.6-10.5-14-19.1-12.1C53.2 212.1 0 275.8 0 352c0 88.4 71.6 160 160 160 69.7 0 128.9-44.5 150.9-106.7 2.9-8.3-1.4-17.5-9.8-20.4s-17.5 1.4-20.4 9.8c-17.6 49.7-65 85.3-120.7 85.3-70.7 0-128-57.3-128-128 0-60.9 42.5-111.9 99.5-124.8 8.6-2 14-10.5 12.1-19.1zm56-51.6c-2-8.6-10.5-14-19.1-12.1s-14 10.5-12.1 19.1l34.3 151.1c5 21.9 24.4 37.4 46.8 37.4h108.6l59.6 119.2c1.9 3.8 5.2 6.7 9.3 8s8.4 1 12.2-.9l64-32c7.9-4 11.1-13.6 7.2-21.5s-13.6-11.1-21.5-7.2l-49.7 24.8-52.5-104.6c-5.4-10.8-16.5-17.7-28.6-17.7H249.5c-7.5 0-13.9-5.2-15.6-12.5L215 224h137c8.8 0 16-7.2 16-16s-7.2-16-16-16H207.7l-8.1-35.5z"
        }
    ]
};

const FalWhiskeyGlassIce = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWhiskeyGlassIce",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m480 64-50 342.9c-3.4 23.6-23.7 41.1-47.5 41.1h-253c-23.8 0-44.1-17.5-47.5-41.1L32 64h448zM32 32c-9.3 0-18.1 4-24.2 11.1S-1 59.4.3 68.6l50 342.9C56 450.8 89.7 480 129.5 480h253c39.7 0 73.4-29.1 79.2-68.5l50-342.9c1.3-9.2-1.4-18.5-7.5-25.5S489.3 32 480 32H32zm223.4 163.3.6-.6c-5-1.8-10.4-2.7-16-2.7h-96c-26.5 0-48 21.5-48 48v96c0 26.5 21.5 48 48 48h73.8l-19-19c-4-4-7.6-8.4-10.6-13H144c-8.8 0-16-7.2-16-16v-96c0-8.8 7.2-16 16-16h82.7l28.7-28.7zm67.9 45.3 56.6 56.6c6.2 6.2 6.2 16.4 0 22.6l-56.6 56.6c-6.2 6.2-16.4 6.2-22.6 0l-56.6-56.6c-6.2-6.2-6.2-16.4 0-22.6l56.6-56.6c6.2-6.2 16.4-6.2 22.6 0zM278 218l-56.6 56.6c-18.7 18.7-18.7 49.1 0 67.9l56.7 56.5c18.7 18.7 49.1 18.7 67.9 0l56.6-56.6c18.7-18.7 18.7-49.1 0-67.9L346 217.9c-18.7-18.7-49.1-18.7-67.9 0z"
        }
    ]
};

const FalWhiskeyGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWhiskeyGlass",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "m32 64 28 192h392l28-192H32zm32.7 224L82 406.9c3.4 23.6 23.7 41.1 47.5 41.1h253c23.8 0 44.1-17.5 47.5-41.1L447.3 288H64.7zM7.8 43.1C13.9 36 22.7 32 32 32h448c9.3 0 18.1 4 24.2 11.1s8.8 16.4 7.5 25.5l-50 342.9c-5.7 39.3-39.4 68.5-79.2 68.5h-253c-39.7 0-73.4-29.1-79.2-68.5L.3 68.6C-1 59.4 1.7 50.1 7.8 43.1z"
        }
    ]
};

const FalWhistle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWhistle",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M93.4 115.3C79.5 128.1 67.6 143 58 159.4c-14.8-2.8-26-15.8-26-31.4 0-17.7 14.3-32 32-32 13.2 0 24.5 7.9 29.4 19.3zM0 128c0 28.4 18.5 52.5 44.1 60.8C36.3 209.7 32 232.4 32 256c0 106 86 192 192 192 64.7 0 121.9-32 156.7-81L529 444.4c4.6 2.4 9.6 3.6 14.8 3.6h2c9 0 17.6-3.8 23.7-10.5l63.4-69.7c4.6-5 7.1-11.6 7.1-18.4 0-8.5-3.9-16.5-10.6-21.6l-128.6-99.6c-5.2-4-12.4-4.5-18-1.1l-17.7 10.6c-10.3 6.2-23.4 5.5-33-1.7-9.7-7.3-14-19.8-10.8-31.5l5.7-21c1.7-6.2-.5-12.9-5.6-16.9l-62.6-48.4c-.9-.7-1.8-1.3-2.7-1.7C321.6 84 275.2 64 224 64c-38.8 0-74.8 11.5-105 31.2C107.8 76.5 87.4 64 64 64 28.7 64 0 92.7 0 128zm569.5 309.5-23.4-21.3c-.1.1-.1.1-.2.1h-2.1l-148.4-77.4c-14-7.3-31.3-3.2-40.5 9.8-29.1 41-76.9 67.7-130.9 67.7-88.5 0-160.3-71.8-160.3-160.3S135.5 95.8 224 95.8c42.7 0 81.5 16.7 110.3 43.9 1.8 1.7 3.9 3.3 6.1 4.5l53.3 41.3-3 10.9c-6.6 24.2 2.2 50.1 22.3 65.1 19.9 14.9 46.9 16.3 68.3 3.5l8.5-5.1L606.3 350l-60.2 66.2 23.4 21.3zM256 256a32 32 0 1 1-64 0 32 32 0 1 1 64 0zm-32-64a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"
        }
    ]
};

const FalWifiExclamation = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWifiExclamation",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M336 48v240c0 8.8-7.2 16-16 16s-16-7.2-16-16V48c0-8.8 7.2-16 16-16s16 7.2 16 16zM4.7 161.7C75.4 91.7 169.4 45 274 34.3c-1.3 4.3-2 8.9-2 13.7v18.7c-95 11-180.2 53.9-244.7 117.7-6.3 6.2-16.4 6.2-22.6-.1s-6.2-16.4.1-22.6zm112 114.3c41.3-41.2 95.2-69.9 155.3-80v32.5c-51.3 9.7-97.2 34.8-132.7 70.2-6.3 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6zM368 196c60.1 10.1 114 38.8 155.3 80 6.3 6.2 6.3 16.4 0 22.6s-16.4 6.3-22.6 0c-35.5-35.4-81.4-60.5-132.7-70.2V196zm0-148c0-4.7-.7-9.3-2-13.7C470.6 45 564.6 91.7 635.3 161.7c6.3 6.2 6.3 16.3.1 22.6s-16.3 6.3-22.6.1C548.2 120.6 463 77.7 368 66.7V48zm-48 400a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-96a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"
        }
    ]
};

const FalWifiFair = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWifiFair",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M139.3 298.7C185.6 252.5 249.5 224 320 224s134.4 28.5 180.7 74.7c6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0zM288 416a32 32 0 1 1 64 0 32 32 0 1 1-64 0zm96 0a64 64 0 1 0-128 0 64 64 0 1 0 128 0z"
        }
    ]
};

const FalWifiSlash = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWifiSlash",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M3.4 6.1C8.9-.8 19-2 25.9 3.4l608 480c6.9 5.5 8.1 15.5 2.6 22.5S621 514 614 508.5L6.1 28.6C-.8 23.1-2 13 3.4 6.1zm394.7 230-54.7-43.2c70 5.6 133 36.3 179.9 83.1 6.3 6.2 6.3 16.4 0 22.6s-16.4 6.3-22.6 0c-28.4-28.3-63.5-50-102.6-62.5zm-189.6 13.4c-25.8 12.5-49.1 29.2-69.2 49.2-6.3 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6c19-18.9 40.6-35.2 64.2-48.3l27.6 21.8zm-6.8-168.4-30.2-23.9C218 40.9 267.9 32 320 32c122.9 0 234.3 49.5 315.3 129.7 6.3 6.2 6.3 16.3.1 22.6s-16.3 6.3-22.6.1C537.6 110 434.2 64 320 64c-41.1 0-80.8 6-118.3 17.1zM48.8 123.4l26 20.5c-16.9 12.3-32.8 25.9-47.5 40.5-6.3 6.2-16.4 6.2-22.6-.1s-6.2-16.4.1-22.6c13.8-13.7 28.5-26.5 44-38.3zm219.3 330.1a64 64 0 1 1 103.7-75 64 64 0 1 1-103.7 75zM352 416a32 32 0 1 0-64 0 32 32 0 1 0 64 0z"
        }
    ]
};

const FalWifiWeak = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWifiWeak",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M320 384a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FalWifi = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWifi",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M27.3 184.4C102.4 110 205.8 64 320 64s217.6 46 292.7 120.4c6.3 6.2 16.4 6.2 22.6-.1s6.2-16.4-.1-22.6C554.3 81.5 442.9 32 320 32S85.7 81.5 4.7 161.7c-6.3 6.2-6.3 16.3-.1 22.6s16.3 6.3 22.6.1zM320 224c70.5 0 134.4 28.5 180.7 74.7 6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0C185.6 252.5 249.5 224 320 224zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"
        }
    ]
};

const FalWindTurbine = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindTurbine",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M302.1 431.2c18.2 29.6 64 13 58.9-21.4l-28.3-192.2L425 46.8c16.5-30.6-20.8-61.9-48-40.3L224.8 127.1l-194.1 5.5c-34.8 1-43.2 48.9-10.9 61.7l180.6 71.5 39.6 64.5V480h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h224c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96v-97.7l30.1 49zM301 222.3l28.4 192.1L227.6 249c-3.6-5.9-9-10.4-15.5-13L31.5 164.5l194.1-5.4c6.9-.2 13.6-2.6 19-6.9L396.9 31.6l-92.4 170.8c-3.3 6.1-4.5 13.1-3.5 19.9zM272 208a16 16 0 1 0-32 0 16 16 0 1 0 32 0z"
        }
    ]
};

const FalWindWarning = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindWarning",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M390.3 352c-33.2 57.4-95.2 96-166.3 96-106 0-192-86-192-192S118 64 224 64s192 86 192 192h32c0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224c89.4 0 166.5-52.3 202.4-128h-36.1zM224 128c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm248 128h48c53 0 96-43 96-96s-43-96-96-96H336c-8.8 0-16 7.2-16 16s7.2 16 16 16h208c35.3 0 64 28.7 64 64s-28.7 64-64 64h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48-256c53 0 96-43 96-96s-43-96-96-96h-48c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c35.3 0 64 28.7 64 64s-28.7 64-64 64h-72.1c2.7 10.4 4.7 21.1 6.1 32h66z"
        }
    ]
};

const FalWind = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWind",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M288 16c0 8.8 7.2 16 16 16h64c26.5 0 48 21.5 48 48s-21.5 48-48 48H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h352c44.2 0 80-35.8 80-80S412.2 0 368 0h-64c-8.8 0-16 7.2-16 16zm64 384c0 8.8 7.2 16 16 16h56c48.6 0 88-39.4 88-88s-39.4-88-88-88H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h408c30.9 0 56 25.1 56 56s-25.1 56-56 56h-56c-8.8 0-16 7.2-16 16zM112 512h64c44.2 0 80-35.8 80-80s-35.8-80-80-80H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c26.5 0 48 21.5 48 48s-21.5 48-48 48h-64c-8.8 0-16 7.2-16 16s7.2 16 16 16z"
        }
    ]
};

const FalWindowFlip = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindowFlip",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M448 64c17.7 0 32 14.3 32 32v320c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h384zm64 32c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96v320c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96zm-96 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-120-24a24 24 0 1 0 48 0 24 24 0 1 0-48 0zm-72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalWindowFrameOpen = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindowFrameOpen",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M272 32h144c17.7 0 32 14.3 32 32v192H272V32zm208 256V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v224h448zm-240-32H64V64c0-17.7 14.3-32 32-32h144v224zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16V320h-32v160H64V320H32v160H16z"
        }
    ]
};

const FalWindowFrame = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindowFrame",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M240 288v192H64V288h176zm32 192V288h176v192H272zm208 0V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v416H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16h-16zm-32-224H272V32h144c17.7 0 32 14.3 32 32v192zM96 32h144v224H64V64c0-17.7 14.3-32 32-32z"
        }
    ]
};

const FalWindowMaximize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindowMaximize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v96h448V96c0-17.7-14.3-32-32-32H64zM32 224v192c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V224H32zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"
        }
    ]
};

const FalWindowMinimize = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindowMinimize",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16h480c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"
        }
    ]
};

const FalWindowRestore = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindowRestore",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 32H208c-26.5 0-48 21.5-48 48v16h-32V80c0-44.2 35.8-80 80-80h224c44.2 0 80 35.8 80 80v224c0 44.2-35.8 80-80 80h-16v-32h16c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM320 160H64c-17.7 0-32 14.3-32 32v64h320v-64c0-17.7-14.3-32-32-32zM32 448c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V288H32v160zm32-320h256c35.3 0 64 28.7 64 64v256c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64z"
        }
    ]
};

const FalWindow = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindow",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M64 64c-17.7 0-32 14.3-32 32v320c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32H64zM0 96c0-35.3 28.7-64 64-64h384c35.3 0 64 28.7 64 64v320c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm96 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1-48 0zm120-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"
        }
    ]
};

const FalWindsock = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWindsock",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 0c8.8 0 16 7.2 16 16v112h64V86.7c0-20.1 18.3-35.2 38-31.4L486 123c15.1 2.9 26 16.1 26 31.4v107.2c0 15.3-10.9 28.5-26 31.4l-352 67.7c-19.7 3.8-38-11.3-38-31.4V288H32v208c0 8.8-7.2 16-16 16s-16-7.2-16-16V16C0 7.2 7.2 0 16 0zm16 160v96h64v-96H32zm96-73.3v242.6l96-18.5V105.2l-96-18.5zm128 24.6v193.3L384 280V136l-128-24.6zm160 30.8v131.8l64-12.3V154.5l-64-12.3z"
        }
    ]
};

const FalWineBottle = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWineBottle",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M404.7 4.7c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6-4.4 4.4-10.6 5.7-16.1 4l-86.6 86.6c-8 8-10.9 19.6-9.6 30.9 4 36.7-8.1 74.8-36.2 103L197.3 493.3c-25 25-65.5 25-90.5 0l-88-88c-25-25-25-65.5 0-90.5l22.6 22.6c-12.5 12.5-12.5 32.8 0 45.3l88 88c12.5 12.5 32.8 12.5 45.3 0l24.7-24.7L66.1 312.7l-24.7 24.7-22.7-22.7 161.5-161.4c28.1-28.1 66.3-40.2 103-36.2 11.3 1.2 22.9-1.6 30.9-9.6l86.6-86.6c-1.7-5.5-.4-11.7 4-16.1zm-316 285.4 133.2 133.2 89.4-89.4-133.2-133.2-89.4 89.4zm112-112 133.2 133.2 2.2-2.2c21-21 30-49.4 27-76.9-2-18.3 2.3-40.5 18.8-57l13.3-13.3-45.3-45.3-13.2 13.4c-16.5 16.5-38.7 20.8-57 18.8-27.5-3-55.9 6-76.9 27l-2.2 2.2zm172-84 45.3 45.3L467.4 90l-45.3-45.3-49.4 49.4z"
        }
    ]
};

const FalWineGlassCrack = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWineGlassCrack",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M149.2 32h-88L46.4 195.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L258.8 32h-75.1l23.2 58.1c3.1 7.7-.3 16.5-7.7 20.3l-44.2 22 48.3 48.3c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-64-64c-3.6-3.6-5.3-8.8-4.5-13.9s4-9.4 8.6-11.7l50.8-25.4L149.2 32zm11.1-32h98.4c16.6 0 30.4 12.6 31.9 29.1l14.9 163.6c7.3 80.2-51.4 150-129.5 158.5V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.1C65.9 342.7 7.2 272.8 14.5 192.7L29.4 29.1C30.9 12.6 44.7 0 61.2 0h99.1z"
        }
    ]
};

const FalWineGlassEmpty = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWineGlassEmpty",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M46.4 195.6C40.3 262.4 92.9 320 160 320s119.7-57.6 113.6-124.4L258.8 32H61.2L46.4 195.6zm-31.9-2.9L29.4 29.1C30.9 12.6 44.7 0 61.2 0h197.6c16.6 0 30.4 12.6 31.9 29.1l14.9 163.6c7.3 80.2-51.4 150-129.5 158.5V480h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V351.1C65.9 342.7 7.2 272.8 14.5 192.7z"
        }
    ]
};

const FalWineGlass = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWineGlass",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M49.6 160h220.8l3.2 35.6C279.7 262.4 227.1 320 160 320S40.3 262.4 46.4 195.6l3.2-35.6zm2.9-32 8.7-96h197.6l8.7 96h-215zM29.4 29.1 14.5 192.7c-7.3 80.1 51.4 150 129.5 158.4V480H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-64V351.1c78.1-8.5 136.8-78.3 129.5-158.5L290.6 29.1C289.1 12.6 275.3 0 258.8 0H61.2C44.7 0 30.9 12.6 29.4 29.1z"
        }
    ]
};

const FalWonSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWonSign",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M31.3 43.3c-2.6-8.4-11.6-13.2-20-10.6S-1.9 44.3.7 52.7L63.3 256H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h57.1l55.6 180.7c2.1 6.8 8.4 11.4 15.6 11.3s13.3-5 15.2-11.8L208 288h96l48.5 180.2c1.9 6.9 8 11.7 15.2 11.8s13.5-4.5 15.6-11.3L438.9 288H496c8.8 0 16-7.2 16-16s-7.2-16-16-16h-47.3l62.6-203.3c2.6-8.4-2.1-17.4-10.6-20s-17.4 2.1-20 10.6L415.3 256h-86.7L271.5 43.8c-1.9-7-8.2-11.8-15.4-11.8s-13.6 4.9-15.4 11.8L183.4 256H96.7L31.3 43.3zM106.6 288h68.2L143 406.3 106.6 288zm110-32L256 109.5 295.4 256h-78.8zm120.6 32h68.2L369 406.3 337.2 288z"
        }
    ]
};

const FalWorm = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWorm",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M432 192v-27.8l-27.5-3.9-31.1-4.4c-30.7-4.4-53.4-30.6-53.4-61.6 0-34.4 27.9-62.3 62.3-62.3h40.1c31.8 0 57.6 25.8 57.6 57.6V356c0 68.5-55.5 124-124 124s-124-55.5-124-124v-36c0-44.2-35.8-80-80-80-39.8 0-72 32.2-72 72v144c0 13.3-10.7 24-24 24s-24-10.7-24-24V312c0-66.3 53.7-120 120-120 70.7 0 128 57.3 128 128v36c0 42 34 76 76 76s76-34 76-76V192zM382.3 0C330.2 0 288 42.2 288 94.3c0 46.9 34.5 86.7 80.9 93.3L400 192v164c0 24.3-19.7 44-44 44s-44-19.7-44-44v-36c0-88.4-71.6-160-160-160C68.1 160 0 228.1 0 312v144c0 30.9 25.1 56 56 56s56-25.1 56-56V312c0-22.1 17.9-40 40-40 26.5 0 48 21.5 48 48v36c0 86.2 69.8 156 156 156s156-69.8 156-156V89.6C512 40.1 471.9 0 422.4 0h-40.1zM408 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalWreathLaurel = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWreathLaurel",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M384 32c44.2 0 80 35.8 80 80-44.2 0-80-35.8-80-80zm110.6 62C486 40.7 439.7 0 384 0h-16c-8.8 0-16 7.2-16 16v16c0 61.9 50.1 112 112 112h8.1c25.7 31.5 39.9 71 39.9 112 0 72.8-40.5 136.1-100.2 168.7 9.4 2.3 18.7 5 27.8 8.2 12.3 4.3 24.3 9.3 36 15.2l4.6 2.3c51.5 9 105.4-14.2 133-62.1L630 359c3.9-6.8 1.6-15.5-5.2-19.4-11.4-6.6-23.6-11-35.9-13.3 31-23.4 51-60.5 51-102.3v-33.8c0-7.9-6.4-14.2-14.2-14.2-13.2 0-25.9 2.3-37.7 6.4 15.2-35.7 14-77.9-6.9-114.1L564.2 39c-3.9-6.8-12.6-9.1-19.4-5.2-24.3 14-41.5 35.7-50.2 60.2zM319.8 480h19.8c37.3 0 74 8.7 107.3 25.3l9.9 5c7.9 4 17.5.7 21.5-7.2s.7-17.5-7.2-21.5l-9.9-5c-37.8-18.8-79.4-28.6-121.6-28.6H320c-106 0-192-86-192-192 0-41 14.2-80.5 39.9-112h8.1c61.9 0 112-50.1 112-112V16c0-8.8-7.2-16-16-16h-16c-55.7 0-102 40.7-110.6 94-8.8-24.5-25.9-46.2-50.2-60.2-6.8-3.9-15.5-1.6-19.4 5.2L58.9 68.3c-20.9 36.2-22.1 78.4-7 114.1-11.8-4.1-24.5-6.4-37.7-6.4C6.4 176 0 182.4 0 190.2V224c0 41.8 20 78.9 51 102.3-12.3 2.3-24.4 6.7-35.9 13.3-6.7 3.9-9 12.6-5.1 19.4l16.9 29.3C56.7 440 117.1 463 172 447.7c6.9-1.9 13.7-4.4 20.3-7.6 10.2 7.1 21 13.4 32.4 18.7-15.8 4.6-31.1 10.6-45.9 18l-9.9 5c-7.9 4-11.1 13.6-7.2 21.5s13.6 11.1 21.5 7.2l9.9-5c33.3-16.7 70.1-25.3 107.3-25.3h19.3zM176 112c0-21.6 8.5-41.2 22.4-55.5C213 41.4 233.4 32 256 32c0 44.2-35.8 80-80 80zM96 289.8v24.8c-37.3-13.2-64-48.8-64-90.6v-14.1c36.6 8.1 64 40.8 64 79.8zm448 24.8v-24.8c0-39.1 27.4-71.7 64-79.8v14c0 41.8-26.7 77.4-64 90.5zm-401.1 82.7 12.4 21.4c-38.9 7.2-79.8-10.2-100.7-46.4l-7-12.2c35.8-11.3 75.8 3.3 95.3 37.1zM96.7 194.7c-25.7-30.1-31-74.2-10.1-110.4l7-12.2c27.7 25.3 35 67.3 15.5 101.1l-12.4 21.5zm434.1-21.4c-19.5-33.8-12.1-75.8 15.5-101.1l7 12.2c20.9 36.2 15.5 80.4-10.2 110.4l-12.4-21.4zm-33.8 224c19.5-33.8 59.6-48.4 95.3-37.1l-7 12.2c-20.9 36.2-61.8 53.6-100.7 46.4l12.4-21.4z"
        }
    ]
};

const FalWreath = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWreath",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M334.9 73.3c-16.3 4.8-33.6-3.9-39.3-20-4.4-12.4-16.3-21.3-30.2-21.3-7.9 0-15.1 2.8-20.7 7.6-11.9 10.1-29.5 10.1-41.4 0-5.6-4.8-12.8-7.6-20.7-7.6-13.9 0-25.8 8.9-30.2 21.3-5.7 16.1-22.9 24.8-39.3 20-2.9-.8-5.9-1.3-9.1-1.3-17.7 0-32 14.3-32 32 0 3.2.5 6.3 1.3 9.1 4.8 16.3-3.9 33.6-20 39.3-12.4 4.4-21.3 16.3-21.3 30.2 0 7.9 2.8 15.1 7.6 20.7 10.1 11.9 10.1 29.5 0 41.4-4.8 5.6-7.6 12.8-7.6 20.7 0 13.9 8.9 25.8 21.3 30.2 16.1 5.7 24.8 22.9 20 39.3-.8 2.9-1.3 5.9-1.3 9.1 0 17.7 14.3 32 32 32h.5c-5.4 8.2-8.5 18.1-8.5 28.7v2.9c-31.6-3.9-56-30.9-56-63.5 0-6.3.9-12.5 2.6-18.2C17.8 317 0 293.3 0 265.4c0-15.8 5.7-30.2 15.2-41.4C5.7 212.8 0 198.4 0 182.6c0-27.9 17.8-51.6 42.6-60.3-1.7-5.8-2.6-12-2.6-18.3 0-35.3 28.7-64 64-64 6.3 0 12.5.9 18.2 2.6C131 17.8 154.7 0 182.6 0c15.8 0 30.2 5.7 41.4 15.2C235.2 5.7 249.6 0 265.4 0c27.9 0 51.6 17.8 60.3 42.6 5.8-1.7 11.9-2.6 18.2-2.6 35.3 0 64 28.7 64 64 0 6.3-.9 12.5-2.6 18.2 24.8 8.8 42.6 32.5 42.6 60.3 0 15.8-5.7 30.2-15.2 41.4 9.5 11.2 15.2 25.6 15.2 41.4 0 27.9-17.8 51.6-42.6 60.3 1.7 5.8 2.6 11.9 2.6 18.2 0 32.6-24.4 59.6-56 63.5v-2.9c0-10.6-3.1-20.4-8.5-28.7h.5c17.7 0 32-14.3 32-32 0-3.2-.5-6.3-1.3-9.1-4.8-16.3 3.9-33.6 20-39.3 12.5-4.4 21.3-16.3 21.3-30.2 0-7.9-2.8-15.1-7.6-20.7-10.1-11.9-10.1-29.5 0-41.4 4.8-5.6 7.6-12.8 7.6-20.7 0-13.9-8.9-25.8-21.3-30.2-16.1-5.7-24.8-22.9-20-39.3.8-2.9 1.3-5.9 1.3-9.1 0-17.7-14.3-32-32-32-3.2 0-6.3.5-9.1 1.3zM235.2 458l52.8 19.8v-59.6L235.2 438c-7.2 2.7-15.2 2.7-22.5 0L160 418.2v59.6l52.8-19.8c7.2-2.7 15.2-2.7 22.5 0zM128 411.1c0-15 12.1-27.1 27.1-27.1 3.2 0 6.5.6 9.5 1.7L224 408l59.4-22.3c3-1.1 6.3-1.7 9.5-1.7 15 0 27.1 12.1 27.1 27.1v73.8c0 15-12.1 27.1-27.1 27.1-3.2 0-6.5-.6-9.5-1.7L224 488l-59.4 22.3c-3 1.1-6.3 1.7-9.5 1.7-15 0-27.1-12.1-27.1-27.1v-73.8zm55.5-227.6c-.3 15.1-6.3 29.6-16.8 40.5 10.4 10.9 16.4 25.4 16.8 40.5 15.1.3 29.6 6.3 40.5 16.8 10.9-10.4 25.4-16.4 40.5-16.8.3-15.1 6.3-29.6 16.8-40.5-10.4-10.9-16.4-25.4-16.8-40.5-8.1-.2-16-2-23.3-5.2-6.3-2.8-12.2-6.7-17.2-11.6-10.9 10.4-25.4 16.4-40.5 16.8zm19.5-41.1c11.3-12.1 30.6-12.1 41.9 0 5.7 6 13.6 9.4 21.9 9.1 16.6-.6 30.2 13 29.6 29.6-.3 8.3 3 16.3 9.1 21.9 12.1 11.3 12.1 30.6 0 41.9-6 5.7-9.4 13.6-9.1 21.9.6 16.6-13 30.2-29.6 29.6-8.3-.3-16.3 3-21.9 9.1-11.3 12.1-30.6 12.1-41.9 0-5.7-6-13.6-9.4-21.9-9.1-16.6.6-30.2-13-29.6-29.6.3-8.3-3-16.3-9.1-21.9-12.1-11.3-12.1-30.6 0-41.9 6-5.7 9.4-13.6 9.1-21.9-.6-16.6 13-30.2 29.6-29.6 8.3.3 16.3-3 21.9-9.1z"
        }
    ]
};

const FalWrenchSimple = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWrenchSimple",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M137 2.8c4.4 3 7 7.9 7 13.2v152l48 36 48-36V16c0-5.3 2.6-10.2 7-13.2s9.9-3.6 14.8-1.7C332.9 28.9 384 94.1 384 176c0 71.1-38.6 133.1-96 166.3V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V332.8c0-6 3.4-11.5 8.7-14.2C316.6 292.1 352 238.2 352 176c0-58.9-31.9-107.7-80-134.8V176c0 5-2.4 9.8-6.4 12.8l-64 48a15.9 15.9 0 0 1-19.2 0l-64-48c-4-3-6.4-7.8-6.4-12.8V41.2C63.9 68.3 32 117.1 32 176c0 62.2 35.4 116.1 87.3 142.6 5.4 2.7 8.7 8.2 8.7 14.2V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V342.3C38.6 309.1 0 247.1 0 176 0 94.1 51.1 28.9 122.2 1.1c4.9-1.9 10.5-1.3 14.8 1.7z"
        }
    ]
};

const FalWrench = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalWrench",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 160c0-10.7-1.3-21.1-3.8-31l-48.9 48.9c-9 9-21.2 14.1-33.9 14.1H368c-26.5 0-48-21.5-48-48v-25.4c0-12.7 5.1-24.9 14.1-33.9L383 35.8c-9.9-2.5-20.3-3.8-31-3.8-70.7 0-128 57.3-128 128 0 9.2 1 18.1 2.8 26.7 3.2 15.2-.6 32.4-13.1 44.9L45.8 399.4C37 408.3 32 420.3 32 432.8c0 26.1 21.1 47.2 47.2 47.2 12.5 0 24.5-5 33.4-13.8l167.9-167.9c12.4-12.4 29.7-16.3 44.9-13.1 8.6 1.8 17.5 2.8 26.7 2.8 70.7 0 128-57.3 128-128zm32 0c0 88.4-71.6 160-160 160-11.4 0-22.6-1.2-33.3-3.5-5.6-1.2-11.5.3-15.6 4.4L135.2 488.8a79.09 79.09 0 0 1-56 23.2C35.5 512 0 476.5 0 432.8c0-21 8.3-41.1 23.2-56l167.9-167.9c4.1-4.1 5.6-10 4.4-15.6-2.3-10.7-3.5-21.9-3.5-33.3C192 71.6 263.6 0 352 0c24.8 0 48.3 5.7 69.3 15.7 9.2 4.4 10.5 16.5 3.3 23.7l-67.9 67.9c-3 3-4.7 7.1-4.7 11.3V144c0 8.8 7.2 16 16 16h25.4c4.2 0 8.3-1.7 11.3-4.7l67.9-67.9c7.2-7.2 19.3-5.9 23.7 3.3 10.1 21 15.7 44.5 15.7 69.3zM88 408a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalXRay = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalXRay",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h480c8.8 0 16 7.2 16 16s-7.2 16-16 16h-16v384h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V64H16C7.2 64 0 56.8 0 48zm64 16v384h384V64H64zm192 32c8.8 0 16 7.2 16 16v32h64c8.8 0 16 7.2 16 16s-7.2 16-16 16h-64v32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96v53.5l45.1-17.4c7-2.7 14.4-4.1 21.9-4.1h2.2c32.5 0 58.8 26.3 58.8 58.8 0 13.2-4.4 25.9-12.5 36.3l-18.2 23.2c-12.7 16.2-32.2 25.7-52.9 25.7H195.6c-20.6 0-40.1-9.5-52.9-25.7l-18.2-23.2c-8.1-10.3-12.5-23.1-12.5-36.3 0-32.5 26.3-58.8 58.8-58.8h2.2c7.5 0 14.9 1.4 21.9 4.1l45.1 17.4V240h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16h96v-32h-64c-8.8 0-16-7.2-16-16s7.2-16 16-16h64v-32c0-8.8 7.2-16 16-16zM144 330.8c0 6 2 11.8 5.7 16.5l18.2 23.2c6.7 8.5 16.9 13.5 27.7 13.5h120.8c10.8 0 21-5 27.7-13.5l18.2-23.2c3.7-4.7 5.7-10.5 5.7-16.5 0-14.8-12-26.8-26.8-26.8H339c-3.6 0-7.1.7-10.4 1.9l-55.3 21.3c-11.1 4.3-23.4 4.3-34.5 0l-55.3-21.3c-3.3-1.3-6.9-1.9-10.4-1.9H171c-15 0-27 12-27 26.8zm48 21.2a16 16 0 1 1 32 0 16 16 0 1 1-32 0zm112-16a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"
        }
    ]
};

const FalX = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalX",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M380.2 58.3c5.7-6.7 4.9-16.8-1.9-22.5s-16.8-4.9-22.6 1.9L192 231.2 28.2 37.7c-5.7-6.7-15.8-7.6-22.5-1.9s-7.6 15.8-1.9 22.5L171 256 3.8 453.7c-5.7 6.7-4.9 16.8 1.9 22.6s16.8 4.9 22.5-1.9L192 280.8l163.8 193.5c5.7 6.7 15.8 7.6 22.6 1.9s7.6-15.8 1.9-22.6L213 256 380.2 58.3z"
        }
    ]
};

const FalXmarkLarge = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalXmarkLarge",
    "viewBox": "0 0 448 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M420.7 36.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L246.6 256l196.7 196.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 278.6 27.3 475.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L201.4 256 4.7 59.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 233.4 420.7 36.7z"
        }
    ]
};

const FalXmarkToSlot = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalXmarkToSlot",
    "viewBox": "0 0 576 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M144 64c-8.8 0-16 7.2-16 16v304h320V80c0-8.8-7.2-16-16-16H144zm336 16v304h16c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16h16V80c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM48 320h16v32H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16h-16v-32h16c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48v-64c0-26.5 21.5-48 48-48zm164.7-171.3c6.2-6.2 16.4-6.2 22.6 0l52.7 52.7 52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L310.6 224l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L288 246.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l52.7-52.7-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalXmark = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalXmark",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256l132.5-132.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6l132.5 132.5z"
        }
    ]
};

const FalXmarksLines = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalXmarksLines",
    "viewBox": "0 0 640 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M16 32h608c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 64 0 56.8 0 48s7.2-16 16-16zm0 416h608c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16zm212.7-283.3c6.2-6.2 16.4-6.2 22.6 0l68.7 68.7 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L342.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L320 278.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l68.7-68.7-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6zM118.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L96 278.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L73.4 256 4.7 187.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L96 233.4l68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L118.6 256zm334.1-91.3c6.2-6.2 16.4-6.2 22.6 0l68.7 68.7 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L566.6 256l68.7 68.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L544 278.6l-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l68.7-68.7-68.7-68.7c-6.2-6.2-6.2-16.4 0-22.6z"
        }
    ]
};

const FalY = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalY",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M28.9 38.5c-5.2-7.1-15.2-8.7-22.4-3.4s-8.6 15.2-3.4 22.4L176 293.2V464c0 8.8 7.2 16 16 16s16-7.2 16-16V293.2L380.9 57.5c5.2-7.1 3.7-17.1-3.4-22.4s-17.1-3.7-22.4 3.4L192 260.9 28.9 38.5z"
        }
    ]
};

const FalYenSign = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalYenSign",
    "viewBox": "0 0 320 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M29 38.7c-5.2-7.2-15.2-8.8-22.3-3.7S-2.1 50.2 3 57.4L123 224H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v64H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h96v112c0 8.8 7.2 16 16 16s16-7.2 16-16V352h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96v-64h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-75L317 57.4c5.2-7.2 3.5-17.2-3.6-22.3s-17.2-3.5-22.3 3.6l-131 182L29 38.7z"
        }
    ]
};

const FalYinYang = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalYinYang",
    "viewBox": "0 0 512 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M480 256c0 123.7-100.3 224-224 224-57.4 0-104-46.6-104-104s46.6-104 104-104c75.1 0 136-60.9 136-136 0-26.5-7.6-51.2-20.6-72C436.5 103.1 480 174.5 480 256zM256 32c57.4 0 104 46.6 104 104s-46.6 104-104 104c-75.1 0-136 60.9-136 136 0 26.5 7.6 51.2 20.6 72C75.5 408.9 32 337.5 32 256 32 132.3 132.3 32 256 32zm0 480a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm24-136a24 24 0 1 0-48 0 24 24 0 1 0 48 0zm-24-216a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"
        }
    ]
};

const FalZ = {
    "element": "svg",
    "data-testid": "icon",
    "data-name": "FalZ",
    "viewBox": "0 0 384 512",
    "xmlns": "http://www.w3.org/2000/svg",
    "children": [
        {
            "element": "path",
            "d": "M0 48c0-8.8 7.2-16 16-16h352c6.2 0 11.9 3.6 14.5 9.3s1.7 12.3-2.3 17.1L50.5 448H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-6.2 0-11.9-3.6-14.5-9.3s-1.7-12.3 2.3-17.1L333.5 64H16C7.2 64 0 56.8 0 48z"
        }
    ]
};

/**
 * Generated bundle index. Do not edit.
 */

export { Fal0, Fal00, Fal1, Fal2, Fal3, Fal360Degrees, Fal4, Fal5, Fal6, Fal7, Fal8, Fal9, FalA, FalAbacus, FalAccentGrave, FalAcorn, FalAddressBook, FalAddressCard, FalAirConditioner, FalAirplay, FalAlarmClock, FalAlarmExclamation, FalAlarmPlus, FalAlarmSnooze, FalAlbum, FalAlbumCirclePlus, FalAlbumCircleUser, FalAlbumCollection, FalAlbumCollectionCirclePlus, FalAlbumCollectionCircleUser, FalAlicorn, FalAlien, FalAlien8bit, FalAlignCenter, FalAlignJustify, FalAlignLeft, FalAlignRight, FalAlignSlash, FalAlt, FalAmpGuitar, FalAmpersand, FalAnchor, FalAnchorCircleCheck, FalAnchorCircleExclamation, FalAnchorCircleXmark, FalAnchorLock, FalAngel, FalAngle, FalAngle90, FalAngleDown, FalAngleLeft, FalAngleRight, FalAngleUp, FalAnglesDown, FalAnglesLeft, FalAnglesRight, FalAnglesUp, FalAnglesUpDown, FalAnkh, FalApartment, FalAperture, FalApostrophe, FalAppleCore, FalAppleWhole, FalArchway, FalArrowDown, FalArrowDown19, FalArrowDown91, FalArrowDownAZ, FalArrowDownArrowUp, FalArrowDownBigSmall, FalArrowDownFromArc, FalArrowDownFromDottedLine, FalArrowDownFromLine, FalArrowDownLeft, FalArrowDownLeftAndArrowUpRightToCenter, FalArrowDownLong, FalArrowDownRight, FalArrowDownShortWide, FalArrowDownSmallBig, FalArrowDownSquareTriangle, FalArrowDownToArc, FalArrowDownToBracket, FalArrowDownToDottedLine, FalArrowDownToLine, FalArrowDownToSquare, FalArrowDownTriangleSquare, FalArrowDownUpAcrossLine, FalArrowDownUpLock, FalArrowDownWideShort, FalArrowDownZA, FalArrowLeft, FalArrowLeftFromArc, FalArrowLeftFromLine, FalArrowLeftLong, FalArrowLeftLongToLine, FalArrowLeftToArc, FalArrowLeftToLine, FalArrowPointer, FalArrowProgress, FalArrowRight, FalArrowRightArrowLeft, FalArrowRightFromArc, FalArrowRightFromBracket, FalArrowRightFromLine, FalArrowRightLong, FalArrowRightLongToLine, FalArrowRightToArc, FalArrowRightToBracket, FalArrowRightToCity, FalArrowRightToLine, FalArrowRotateLeft, FalArrowRotateRight, FalArrowTrendDown, FalArrowTrendUp, FalArrowTurnDown, FalArrowTurnDownLeft, FalArrowTurnDownRight, FalArrowTurnUp, FalArrowUp, FalArrowUp19, FalArrowUp91, FalArrowUpAZ, FalArrowUpArrowDown, FalArrowUpBigSmall, FalArrowUpFromArc, FalArrowUpFromBracket, FalArrowUpFromDottedLine, FalArrowUpFromGroundWater, FalArrowUpFromLine, FalArrowUpFromSquare, FalArrowUpFromWaterPump, FalArrowUpLeft, FalArrowUpLeftFromCircle, FalArrowUpLong, FalArrowUpRight, FalArrowUpRightAndArrowDownLeftFromCenter, FalArrowUpRightDots, FalArrowUpRightFromSquare, FalArrowUpShortWide, FalArrowUpSmallBig, FalArrowUpSquareTriangle, FalArrowUpToArc, FalArrowUpToDottedLine, FalArrowUpToLine, FalArrowUpTriangleSquare, FalArrowUpWideShort, FalArrowUpZA, FalArrowsCross, FalArrowsDownToLine, FalArrowsDownToPeople, FalArrowsFromDottedLine, FalArrowsFromLine, FalArrowsLeftRight, FalArrowsLeftRightToLine, FalArrowsMaximize, FalArrowsMinimize, FalArrowsRepeat, FalArrowsRepeat1, FalArrowsRetweet, FalArrowsRotate, FalArrowsSpin, FalArrowsSplitUpAndLeft, FalArrowsToCircle, FalArrowsToDot, FalArrowsToDottedLine, FalArrowsToEye, FalArrowsToLine, FalArrowsTurnRight, FalArrowsTurnToDots, FalArrowsUpDown, FalArrowsUpDownLeftRight, FalArrowsUpToLine, FalAsterisk, FalAt, FalAtom, FalAtomSimple, FalAudioDescription, FalAudioDescriptionSlash, FalAustralSign, FalAvocado, FalAward, FalAwardSimple, FalAxe, FalAxeBattle, FalB, FalBaby, FalBabyCarriage, FalBackpack, FalBackward, FalBackwardFast, FalBackwardStep, FalBacon, FalBacteria, FalBacterium, FalBadge, FalBadgeCheck, FalBadgeDollar, FalBadgePercent, FalBadgeSheriff, FalBadgerHoney, FalBadminton, FalBagSeedling, FalBagShopping, FalBagel, FalBagsShopping, FalBaguette, FalBahai, FalBahtSign, FalBallPile, FalBalloon, FalBalloons, FalBallot, FalBallotCheck, FalBan, FalBanBug, FalBanParking, FalBanSmoking, FalBanana, FalBandage, FalBangladeshiTakaSign, FalBanjo, FalBarcode, FalBarcodeRead, FalBarcodeScan, FalBars, FalBarsFilter, FalBarsProgress, FalBarsSort, FalBarsStaggered, FalBaseball, FalBaseballBatBall, FalBasketShopping, FalBasketShoppingSimple, FalBasketball, FalBasketballHoop, FalBat, FalBath, FalBatteryBolt, FalBatteryEmpty, FalBatteryExclamation, FalBatteryFull, FalBatteryHalf, FalBatteryLow, FalBatteryQuarter, FalBatterySlash, FalBatteryThreeQuarters, FalBed, FalBedBunk, FalBedEmpty, FalBedFront, FalBedPulse, FalBee, FalBeerMug, FalBeerMugEmpty, FalBell, FalBellConcierge, FalBellExclamation, FalBellOn, FalBellPlus, FalBellSchool, FalBellSchoolSlash, FalBellSlash, FalBells, FalBenchTree, FalBezierCurve, FalBicycle, FalBillboard, FalBinBottles, FalBinBottlesRecycle, FalBinRecycle, FalBinary, FalBinaryCircleCheck, FalBinaryLock, FalBinarySlash, FalBinoculars, FalBiohazard, FalBird, FalBitcoinSign, FalBlanket, FalBlanketFire, FalBlender, FalBlenderPhone, FalBlinds, FalBlindsOpen, FalBlindsRaised, FalBlock, FalBlockBrick, FalBlockBrickFire, FalBlockQuestion, FalBlockQuote, FalBlog, FalBlueberries, FalBluetooth, FalBold, FalBolt, FalBoltAuto, FalBoltLightning, FalBoltSlash, FalBomb, FalBone, FalBoneBreak, FalBong, FalBook, FalBookArrowRight, FalBookArrowUp, FalBookAtlas, FalBookBible, FalBookBlank, FalBookBookmark, FalBookCircleArrowRight, FalBookCircleArrowUp, FalBookCopy, FalBookFont, FalBookHeart, FalBookJournalWhills, FalBookMedical, FalBookOpen, FalBookOpenCover, FalBookOpenReader, FalBookQuran, FalBookSection, FalBookSkull, FalBookSparkles, FalBookTanakh, FalBookUser, FalBookmark, FalBookmarkSlash, FalBooks, FalBooksMedical, FalBoombox, FalBoot, FalBootHeeled, FalBoothCurtain, FalBorderAll, FalBorderBottom, FalBorderBottomRight, FalBorderCenterH, FalBorderCenterV, FalBorderInner, FalBorderLeft, FalBorderNone, FalBorderOuter, FalBorderRight, FalBorderTop, FalBorderTopLeft, FalBoreHole, FalBottleDroplet, FalBottleWater, FalBowArrow, FalBowlChopsticks, FalBowlChopsticksNoodles, FalBowlFood, FalBowlHot, FalBowlRice, FalBowlScoop, FalBowlScoops, FalBowlSoftServe, FalBowlSpoon, FalBowlingBall, FalBowlingBallPin, FalBowlingPins, FalBox, FalBoxArchive, FalBoxBallot, FalBoxCheck, FalBoxCircleCheck, FalBoxDollar, FalBoxHeart, FalBoxOpen, FalBoxOpenFull, FalBoxTaped, FalBoxTissue, FalBoxesPacking, FalBoxesStacked, FalBoxingGlove, FalBracketCurly, FalBracketCurlyRight, FalBracketRound, FalBracketRoundRight, FalBracketSquare, FalBracketSquareRight, FalBracketsCurly, FalBracketsRound, FalBracketsSquare, FalBraille, FalBrain, FalBrainArrowCurvedRight, FalBrainCircuit, FalBrakeWarning, FalBrazilianRealSign, FalBreadLoaf, FalBreadSlice, FalBreadSliceButter, FalBridge, FalBridgeCircleCheck, FalBridgeCircleExclamation, FalBridgeCircleXmark, FalBridgeLock, FalBridgeSuspension, FalBridgeWater, FalBriefcase, FalBriefcaseArrowRight, FalBriefcaseBlank, FalBriefcaseMedical, FalBrightness, FalBrightnessLow, FalBringForward, FalBringFront, FalBroccoli, FalBroom, FalBroomBall, FalBroomWide, FalBrowser, FalBrowsers, FalBrush, FalBucket, FalBug, FalBugSlash, FalBugs, FalBuilding, FalBuildingCircleArrowRight, FalBuildingCircleCheck, FalBuildingCircleExclamation, FalBuildingCircleXmark, FalBuildingColumns, FalBuildingFlag, FalBuildingLock, FalBuildingNgo, FalBuildingShield, FalBuildingUn, FalBuildingUser, FalBuildingWheat, FalBuildings, FalBullhorn, FalBullseye, FalBullseyeArrow, FalBullseyePointer, FalBuoy, FalBuoyMooring, FalBurger, FalBurgerCheese, FalBurgerFries, FalBurgerGlass, FalBurgerLettuce, FalBurgerSoda, FalBurrito, FalBurst, FalBus, FalBusSchool, FalBusSimple, FalBusinessTime, FalButter, FalC, FalCabin, FalCabinetFiling, FalCableCar, FalCactus, FalCakeCandles, FalCakeSlice, FalCalculator, FalCalculatorSimple, FalCalendar, FalCalendarArrowDown, FalCalendarArrowUp, FalCalendarCheck, FalCalendarCircleExclamation, FalCalendarCircleMinus, FalCalendarCirclePlus, FalCalendarCircleUser, FalCalendarClock, FalCalendarDay, FalCalendarDays, FalCalendarExclamation, FalCalendarHeart, FalCalendarImage, FalCalendarLines, FalCalendarLinesPen, FalCalendarMinus, FalCalendarPen, FalCalendarPlus, FalCalendarRange, FalCalendarStar, FalCalendarUsers, FalCalendarWeek, FalCalendarXmark, FalCalendars, FalCamcorder, FalCamera, FalCameraCctv, FalCameraMovie, FalCameraPolaroid, FalCameraRetro, FalCameraRotate, FalCameraSecurity, FalCameraSlash, FalCameraViewfinder, FalCameraWeb, FalCameraWebSlash, FalCampfire, FalCampground, FalCanFood, FalCandleHolder, FalCandy, FalCandyBar, FalCandyCane, FalCandyCorn, FalCannabis, FalCapsules, FalCar, FalCarBattery, FalCarBolt, FalCarBuilding, FalCarBump, FalCarBurst, FalCarBus, FalCarCircleBolt, FalCarGarage, FalCarMirrors, FalCarOn, FalCarRear, FalCarSide, FalCarSideBolt, FalCarTilt, FalCarTunnel, FalCarWash, FalCarWrench, FalCaravan, FalCaravanSimple, FalCardClub, FalCardDiamond, FalCardHeart, FalCardSpade, FalCards, FalCardsBlank, FalCaretDown, FalCaretLeft, FalCaretRight, FalCaretUp, FalCarrot, FalCars, FalCartArrowDown, FalCartArrowUp, FalCartCircleArrowDown, FalCartCircleArrowUp, FalCartCircleCheck, FalCartCircleExclamation, FalCartCirclePlus, FalCartCircleXmark, FalCartFlatbed, FalCartFlatbedBoxes, FalCartFlatbedEmpty, FalCartFlatbedSuitcase, FalCartMinus, FalCartPlus, FalCartShopping, FalCartShoppingFast, FalCartXmark, FalCashRegister, FalCassetteBetamax, FalCassetteTape, FalCassetteVhs, FalCastle, FalCat, FalCatSpace, FalCauldron, FalCediSign, FalCentSign, FalCertificate, FalChair, FalChairOffice, FalChalkboard, FalChalkboardUser, FalChampagneGlass, FalChampagneGlasses, FalChargingStation, FalChartArea, FalChartBar, FalChartBullet, FalChartCandlestick, FalChartColumn, FalChartGantt, FalChartLine, FalChartLineDown, FalChartLineUp, FalChartLineUpDown, FalChartMixed, FalChartMixedUpCircleCurrency, FalChartMixedUpCircleDollar, FalChartNetwork, FalChartPie, FalChartPieSimple, FalChartPieSimpleCircleCurrency, FalChartPieSimpleCircleDollar, FalChartPyramid, FalChartRadar, FalChartScatter, FalChartScatter3d, FalChartScatterBubble, FalChartSimple, FalChartSimpleHorizontal, FalChartTreeMap, FalChartUser, FalChartWaterfall, FalCheck, FalCheckDouble, FalCheckToSlot, FalCheese, FalCheeseSwiss, FalCherries, FalChess, FalChessBishop, FalChessBishopPiece, FalChessBoard, FalChessClock, FalChessClockFlip, FalChessKing, FalChessKingPiece, FalChessKnight, FalChessKnightPiece, FalChessPawn, FalChessPawnPiece, FalChessQueen, FalChessQueenPiece, FalChessRook, FalChessRookPiece, FalChestnut, FalChevronDown, FalChevronLeft, FalChevronRight, FalChevronUp, FalChevronsDown, FalChevronsLeft, FalChevronsRight, FalChevronsUp, FalChfSign, FalChild, FalChildCombatant, FalChildDress, FalChildReaching, FalChildren, FalChimney, FalChopsticks, FalChurch, FalCircle, FalCircle0, FalCircle1, FalCircle2, FalCircle3, FalCircle4, FalCircle5, FalCircle6, FalCircle7, FalCircle8, FalCircle9, FalCircleA, FalCircleAmpersand, FalCircleArrowDown, FalCircleArrowDownLeft, FalCircleArrowDownRight, FalCircleArrowLeft, FalCircleArrowRight, FalCircleArrowUp, FalCircleArrowUpLeft, FalCircleArrowUpRight, FalCircleB, FalCircleBolt, FalCircleBookOpen, FalCircleBookmark, FalCircleC, FalCircleCalendar, FalCircleCamera, FalCircleCaretDown, FalCircleCaretLeft, FalCircleCaretRight, FalCircleCaretUp, FalCircleCheck, FalCircleChevronDown, FalCircleChevronLeft, FalCircleChevronRight, FalCircleChevronUp, FalCircleD, FalCircleDashed, FalCircleDivide, FalCircleDollar, FalCircleDollarToSlot, FalCircleDot, FalCircleDown, FalCircleDownLeft, FalCircleDownRight, FalCircleE, FalCircleEllipsis, FalCircleEllipsisVertical, FalCircleEnvelope, FalCircleEuro, FalCircleExclamation, FalCircleExclamationCheck, FalCircleF, FalCircleG, FalCircleH, FalCircleHalf, FalCircleHalfStroke, FalCircleHeart, FalCircleI, FalCircleInfo, FalCircleJ, FalCircleK, FalCircleL, FalCircleLeft, FalCircleLocationArrow, FalCircleM, FalCircleMicrophone, FalCircleMicrophoneLines, FalCircleMinus, FalCircleN, FalCircleNodes, FalCircleNotch, FalCircleO, FalCircleP, FalCircleParking, FalCirclePause, FalCirclePhone, FalCirclePhoneFlip, FalCirclePhoneHangup, FalCirclePlay, FalCirclePlus, FalCircleQ, FalCircleQuarter, FalCircleQuarterStroke, FalCircleQuarters, FalCircleQuestion, FalCircleR, FalCircleRadiation, FalCircleRight, FalCircleS, FalCircleSmall, FalCircleSort, FalCircleSortDown, FalCircleSortUp, FalCircleStar, FalCircleSterling, FalCircleStop, FalCircleT, FalCircleThreeQuarters, FalCircleThreeQuartersStroke, FalCircleTrash, FalCircleU, FalCircleUp, FalCircleUpLeft, FalCircleUpRight, FalCircleUser, FalCircleV, FalCircleVideo, FalCircleW, FalCircleWaveformLines, FalCircleX, FalCircleXmark, FalCircleY, FalCircleYen, FalCircleZ, FalCirclesOverlap, FalCitrus, FalCitrusSlice, FalCity, FalClapperboard, FalClapperboardPlay, FalClarinet, FalClawMarks, FalClipboard, FalClipboardCheck, FalClipboardList, FalClipboardListCheck, FalClipboardMedical, FalClipboardPrescription, FalClipboardQuestion, FalClipboardUser, FalClock, FalClockDesk, FalClockEight, FalClockEightThirty, FalClockEleven, FalClockElevenThirty, FalClockFive, FalClockFiveThirty, FalClockFourThirty, FalClockNine, FalClockNineThirty, FalClockOne, FalClockOneThirty, FalClockRotateLeft, FalClockSeven, FalClockSevenThirty, FalClockSix, FalClockSixThirty, FalClockTen, FalClockTenThirty, FalClockThree, FalClockThreeThirty, FalClockTwelve, FalClockTwelveThirty, FalClockTwo, FalClockTwoThirty, FalClone, FalClosedCaptioning, FalClosedCaptioningSlash, FalClothesHanger, FalCloud, FalCloudArrowDown, FalCloudArrowUp, FalCloudBinary, FalCloudBolt, FalCloudBoltMoon, FalCloudBoltSun, FalCloudCheck, FalCloudDrizzle, FalCloudExclamation, FalCloudFog, FalCloudHail, FalCloudHailMixed, FalCloudMeatball, FalCloudMinus, FalCloudMoon, FalCloudMoonRain, FalCloudMusic, FalCloudPlus, FalCloudQuestion, FalCloudRain, FalCloudRainbow, FalCloudShowers, FalCloudShowersHeavy, FalCloudShowersWater, FalCloudSlash, FalCloudSleet, FalCloudSnow, FalCloudSun, FalCloudSunRain, FalCloudWord, FalCloudXmark, FalClouds, FalCloudsMoon, FalCloudsSun, FalClover, FalClub, FalCoconut, FalCode, FalCodeBranch, FalCodeCommit, FalCodeCompare, FalCodeFork, FalCodeMerge, FalCodePullRequest, FalCodePullRequestClosed, FalCodePullRequestDraft, FalCodeSimple, FalCoffeeBean, FalCoffeeBeans, FalCoffeePot, FalCoffin, FalCoffinCross, FalCoin, FalCoinBlank, FalCoinFront, FalCoinVertical, FalCoins, FalColon, FalColonSign, FalColumns3, FalComet, FalComma, FalCommand, FalComment, FalCommentArrowDown, FalCommentArrowUp, FalCommentArrowUpRight, FalCommentCaptions, FalCommentCheck, FalCommentCode, FalCommentDollar, FalCommentDots, FalCommentExclamation, FalCommentHeart, FalCommentImage, FalCommentLines, FalCommentMedical, FalCommentMiddle, FalCommentMiddleTop, FalCommentMinus, FalCommentMusic, FalCommentPen, FalCommentPlus, FalCommentQuestion, FalCommentQuote, FalCommentSlash, FalCommentSmile, FalCommentSms, FalCommentText, FalCommentXmark, FalComments, FalCommentsDollar, FalCommentsQuestion, FalCommentsQuestionCheck, FalCompactDisc, FalCompass, FalCompassDrafting, FalCompassSlash, FalCompress, FalCompressWide, FalComputer, FalComputerClassic, FalComputerMouse, FalComputerMouseScrollwheel, FalComputerSpeaker, FalContainerStorage, FalConveyorBelt, FalConveyorBeltArm, FalConveyorBeltBoxes, FalConveyorBeltEmpty, FalCookie, FalCookieBite, FalCopy, FalCopyright, FalCorn, FalCorner, FalCouch, FalCow, FalCowbell, FalCowbellCirclePlus, FalCrab, FalCrateApple, FalCrateEmpty, FalCreditCard, FalCreditCardBlank, FalCreditCardFront, FalCricketBatBall, FalCroissant, FalCrop, FalCropSimple, FalCross, FalCrosshairs, FalCrosshairsSimple, FalCrow, FalCrown, FalCrutch, FalCrutches, FalCruzeiroSign, FalCrystalBall, FalCube, FalCubes, FalCubesStacked, FalCucumber, FalCupStraw, FalCupStrawSwoosh, FalCupTogo, FalCupcake, FalCurlingStone, FalCustard, FalD, FalDagger, FalDash, FalDatabase, FalDeer, FalDeerRudolph, FalDeleteLeft, FalDeleteRight, FalDemocrat, FalDesktop, FalDesktopArrowDown, FalDharmachakra, FalDiagramCells, FalDiagramLeanCanvas, FalDiagramNested, FalDiagramNext, FalDiagramPredecessor, FalDiagramPrevious, FalDiagramProject, FalDiagramSankey, FalDiagramSubtask, FalDiagramSuccessor, FalDiagramVenn, FalDial, FalDialHigh, FalDialLow, FalDialMax, FalDialMed, FalDialMedLow, FalDialMin, FalDialOff, FalDiamond, FalDiamondExclamation, FalDiamondHalf, FalDiamondHalfStroke, FalDiamondTurnRight, FalDice, FalDiceD10, FalDiceD12, FalDiceD20, FalDiceD4, FalDiceD6, FalDiceD8, FalDiceFive, FalDiceFour, FalDiceOne, FalDiceSix, FalDiceThree, FalDiceTwo, FalDinosaur, FalDiploma, FalDiscDrive, FalDisease, FalDisplay, FalDisplayArrowDown, FalDisplayChartUp, FalDisplayChartUpCircleCurrency, FalDisplayChartUpCircleDollar, FalDisplayCode, FalDisplayMedical, FalDisplaySlash, FalDistributeSpacingHorizontal, FalDistributeSpacingVertical, FalDitto, FalDivide, FalDna, FalDoNotEnter, FalDog, FalDogLeashed, FalDollarSign, FalDolly, FalDollyEmpty, FalDolphin, FalDongSign, FalDonut, FalDoorClosed, FalDoorOpen, FalDove, FalDown, FalDownFromDottedLine, FalDownFromLine, FalDownLeft, FalDownLeftAndUpRightToCenter, FalDownLong, FalDownRight, FalDownToBracket, FalDownToDottedLine, FalDownToLine, FalDownload, FalDragon, FalDrawCircle, FalDrawPolygon, FalDrawSquare, FalDreidel, FalDrone, FalDroneFront, FalDroplet, FalDropletDegree, FalDropletPercent, FalDropletSlash, FalDrum, FalDrumSteelpan, FalDrumstick, FalDrumstickBite, FalDryer, FalDryerHeat, FalDuck, FalDumbbell, FalDumpster, FalDumpsterFire, FalDungeon, FalE, FalEar, FalEarDeaf, FalEarListen, FalEarMuffs, FalEarthAfrica, FalEarthAmericas, FalEarthAsia, FalEarthEurope, FalEarthOceania, FalEclipse, FalEgg, FalEggFried, FalEggplant, FalEject, FalElephant, FalElevator, FalEllipsis, FalEllipsisStroke, FalEllipsisStrokeVertical, FalEllipsisVertical, FalEmptySet, FalEngine, FalEngineWarning, FalEnvelope, FalEnvelopeCircleCheck, FalEnvelopeDot, FalEnvelopeOpen, FalEnvelopeOpenDollar, FalEnvelopeOpenText, FalEnvelopes, FalEnvelopesBulk, FalEquals, FalEraser, FalEscalator, FalEthernet, FalEuroSign, FalExclamation, FalExpand, FalExpandWide, FalExplosion, FalEye, FalEyeDropper, FalEyeDropperFull, FalEyeDropperHalf, FalEyeEvil, FalEyeLowVision, FalEyeSlash, FalEyes, FalF, FalFaceAngry, FalFaceAngryHorns, FalFaceAnguished, FalFaceAnxiousSweat, FalFaceAstonished, FalFaceAwesome, FalFaceBeamHandOverMouth, FalFaceClouds, FalFaceConfounded, FalFaceConfused, FalFaceCowboyHat, FalFaceDiagonalMouth, FalFaceDisappointed, FalFaceDisguise, FalFaceDizzy, FalFaceDotted, FalFaceDowncastSweat, FalFaceDrooling, FalFaceExhaling, FalFaceExplode, FalFaceExpressionless, FalFaceEyesXmarks, FalFaceFearful, FalFaceFlushed, FalFaceFrown, FalFaceFrownOpen, FalFaceFrownSlight, FalFaceGlasses, FalFaceGrimace, FalFaceGrin, FalFaceGrinBeam, FalFaceGrinBeamSweat, FalFaceGrinHearts, FalFaceGrinSquint, FalFaceGrinSquintTears, FalFaceGrinStars, FalFaceGrinTears, FalFaceGrinTongue, FalFaceGrinTongueSquint, FalFaceGrinTongueWink, FalFaceGrinWide, FalFaceGrinWink, FalFaceHandOverMouth, FalFaceHandPeeking, FalFaceHandYawn, FalFaceHeadBandage, FalFaceHoldingBackTears, FalFaceHushed, FalFaceIcicles, FalFaceKiss, FalFaceKissBeam, FalFaceKissClosedEyes, FalFaceKissWinkHeart, FalFaceLaugh, FalFaceLaughBeam, FalFaceLaughSquint, FalFaceLaughWink, FalFaceLying, FalFaceMask, FalFaceMeh, FalFaceMehBlank, FalFaceMelting, FalFaceMonocle, FalFaceNauseated, FalFaceNoseSteam, FalFaceParty, FalFacePensive, FalFacePersevering, FalFacePleading, FalFacePouting, FalFaceRaisedEyebrow, FalFaceRelieved, FalFaceRollingEyes, FalFaceSadCry, FalFaceSadSweat, FalFaceSadTear, FalFaceSaluting, FalFaceScream, FalFaceShush, FalFaceSleeping, FalFaceSleepy, FalFaceSmile, FalFaceSmileBeam, FalFaceSmileHalo, FalFaceSmileHearts, FalFaceSmileHorns, FalFaceSmilePlus, FalFaceSmileRelaxed, FalFaceSmileTear, FalFaceSmileTongue, FalFaceSmileUpsideDown, FalFaceSmileWink, FalFaceSmilingHands, FalFaceSmirking, FalFaceSpiralEyes, FalFaceSunglasses, FalFaceSurprise, FalFaceSwear, FalFaceThermometer, FalFaceThinking, FalFaceTired, FalFaceTissue, FalFaceTongueMoney, FalFaceTongueSweat, FalFaceUnamused, FalFaceViewfinder, FalFaceVomit, FalFaceWeary, FalFaceWoozy, FalFaceWorried, FalFaceZany, FalFaceZipper, FalFalafel, FalFamily, FalFamilyDress, FalFamilyPants, FalFan, FalFanTable, FalFarm, FalFaucet, FalFaucetDrip, FalFax, FalFeather, FalFeatherPointed, FalFence, FalFerrisWheel, FalFerry, FalFieldHockeyStickBall, FalFile, FalFileArrowDown, FalFileArrowUp, FalFileAudio, FalFileBinary, FalFileCertificate, FalFileChartColumn, FalFileChartPie, FalFileCheck, FalFileCircleCheck, FalFileCircleExclamation, FalFileCircleInfo, FalFileCircleMinus, FalFileCirclePlus, FalFileCircleQuestion, FalFileCircleXmark, FalFileCode, FalFileContract, FalFileCsv, FalFileDashedLine, FalFileDoc, FalFileExcel, FalFileExclamation, FalFileExport, FalFileHeart, FalFileImage, FalFileImport, FalFileInvoice, FalFileInvoiceDollar, FalFileLines, FalFileLock, FalFileMagnifyingGlass, FalFileMedical, FalFileMinus, FalFileMusic, FalFilePdf, FalFilePen, FalFilePlus, FalFilePlusMinus, FalFilePowerpoint, FalFilePrescription, FalFileShield, FalFileSignature, FalFileSlash, FalFileSpreadsheet, FalFileUser, FalFileVideo, FalFileWaveform, FalFileWord, FalFileXmark, FalFileZip, FalFileZipper, FalFiles, FalFilesMedical, FalFill, FalFillDrip, FalFilm, FalFilmCanister, FalFilmSimple, FalFilmSlash, FalFilms, FalFilter, FalFilterCircleDollar, FalFilterCircleXmark, FalFilterList, FalFilterSlash, FalFilters, FalFingerprint, FalFire, FalFireBurner, FalFireExtinguisher, FalFireFlame, FalFireFlameCurved, FalFireFlameSimple, FalFireHydrant, FalFireSmoke, FalFireplace, FalFish, FalFishBones, FalFishCooked, FalFishFins, FalFishingRod, FalFlag, FalFlagCheckered, FalFlagPennant, FalFlagSwallowtail, FalFlagUsa, FalFlashlight, FalFlask, FalFlaskGear, FalFlaskRoundPoison, FalFlaskRoundPotion, FalFlaskVial, FalFlatbread, FalFlatbreadStuffed, FalFloppyDisk, FalFloppyDiskCircleArrowRight, FalFloppyDiskCircleXmark, FalFloppyDiskPen, FalFloppyDisks, FalFlorinSign, FalFlower, FalFlowerDaffodil, FalFlowerTulip, FalFlute, FalFluxCapacitor, FalFlyingDisc, FalFolder, FalFolderArrowDown, FalFolderArrowUp, FalFolderBookmark, FalFolderClosed, FalFolderGear, FalFolderGrid, FalFolderHeart, FalFolderImage, FalFolderMagnifyingGlass, FalFolderMedical, FalFolderMinus, FalFolderMusic, FalFolderOpen, FalFolderPlus, FalFolderTree, FalFolderUser, FalFolderXmark, FalFolders, FalFonduePot, FalFont, FalFontAwesome, FalFontCase, FalFootball, FalFootballHelmet, FalFork, FalForkKnife, FalForklift, FalFort, FalForward, FalForwardFast, FalForwardStep, FalFrame, FalFrancSign, FalFrenchFries, FalFrog, FalFunction, FalFutbol, FalG, FalGalaxy, FalGalleryThumbnails, FalGameBoard, FalGameBoardSimple, FalGameConsoleHandheld, FalGameConsoleHandheldCrank, FalGamepad, FalGamepadModern, FalGarage, FalGarageCar, FalGarageOpen, FalGarlic, FalGasPump, FalGasPumpSlash, FalGauge, FalGaugeCircleBolt, FalGaugeCircleMinus, FalGaugeCirclePlus, FalGaugeHigh, FalGaugeLow, FalGaugeMax, FalGaugeMin, FalGaugeSimple, FalGaugeSimpleHigh, FalGaugeSimpleLow, FalGaugeSimpleMax, FalGaugeSimpleMin, FalGavel, FalGear, FalGearCode, FalGearComplex, FalGearComplexCode, FalGears, FalGem, FalGenderless, FalGhost, FalGif, FalGift, FalGiftCard, FalGifts, FalGingerbreadMan, FalGlass, FalGlassCitrus, FalGlassEmpty, FalGlassHalf, FalGlassWater, FalGlassWaterDroplet, FalGlasses, FalGlassesRound, FalGlobe, FalGlobePointer, FalGlobeSnow, FalGlobeStand, FalGoalNet, FalGolfBallTee, FalGolfClub, FalGolfFlagHole, FalGopuram, FalGraduationCap, FalGramophone, FalGrapes, FalGrate, FalGrateDroplet, FalGreaterThan, FalGreaterThanEqual, FalGrid, FalGrid2, FalGrid2Plus, FalGrid4, FalGrid5, FalGridDividers, FalGridHorizontal, FalGridRound, FalGridRound2, FalGridRound2Plus, FalGridRound4, FalGridRound5, FalGrill, FalGrillFire, FalGrillHot, FalGrip, FalGripDots, FalGripDotsVertical, FalGripLines, FalGripLinesVertical, FalGripVertical, FalGroupArrowsRotate, FalGuaraniSign, FalGuitar, FalGuitarElectric, FalGuitars, FalGun, FalGunSlash, FalGunSquirt, FalH, FalH1, FalH2, FalH3, FalH4, FalH5, FalH6, FalHammer, FalHammerCrash, FalHammerWar, FalHamsa, FalHand, FalHandBackFist, FalHandBackPointDown, FalHandBackPointLeft, FalHandBackPointRibbon, FalHandBackPointRight, FalHandBackPointUp, FalHandDots, FalHandFingersCrossed, FalHandFist, FalHandHeart, FalHandHolding, FalHandHoldingBox, FalHandHoldingDollar, FalHandHoldingDroplet, FalHandHoldingHand, FalHandHoldingHeart, FalHandHoldingMagic, FalHandHoldingMedical, FalHandHoldingSeedling, FalHandHoldingSkull, FalHandHorns, FalHandLizard, FalHandLove, FalHandMiddleFinger, FalHandPeace, FalHandPointDown, FalHandPointLeft, FalHandPointRibbon, FalHandPointRight, FalHandPointUp, FalHandPointer, FalHandScissors, FalHandSparkles, FalHandSpock, FalHandWave, FalHandcuffs, FalHands, FalHandsAslInterpreting, FalHandsBound, FalHandsBubbles, FalHandsClapping, FalHandsHolding, FalHandsHoldingChild, FalHandsHoldingCircle, FalHandsHoldingDiamond, FalHandsHoldingDollar, FalHandsHoldingHeart, FalHandsPraying, FalHandshake, FalHandshakeAngle, FalHandshakeSimple, FalHandshakeSimpleSlash, FalHandshakeSlash, FalHanukiah, FalHardDrive, FalHashtag, FalHashtagLock, FalHatBeach, FalHatChef, FalHatCowboy, FalHatCowboySide, FalHatSanta, FalHatWinter, FalHatWitch, FalHatWizard, FalHeadSide, FalHeadSideBrain, FalHeadSideCough, FalHeadSideCoughSlash, FalHeadSideGear, FalHeadSideGoggles, FalHeadSideHeadphones, FalHeadSideHeart, FalHeadSideMask, FalHeadSideMedical, FalHeadSideVirus, FalHeading, FalHeadphones, FalHeadphonesSimple, FalHeadset, FalHeart, FalHeartCircleBolt, FalHeartCircleCheck, FalHeartCircleExclamation, FalHeartCircleMinus, FalHeartCirclePlus, FalHeartCircleXmark, FalHeartCrack, FalHeartHalf, FalHeartHalfStroke, FalHeartPulse, FalHeat, FalHelicopter, FalHelicopterSymbol, FalHelmetBattle, FalHelmetSafety, FalHelmetUn, FalHexagon, FalHexagonCheck, FalHexagonDivide, FalHexagonExclamation, FalHexagonImage, FalHexagonMinus, FalHexagonPlus, FalHexagonVerticalNft, FalHexagonVerticalNftSlanted, FalHexagonXmark, FalHighDefinition, FalHighlighter, FalHighlighterLine, FalHillAvalanche, FalHillRockslide, FalHippo, FalHockeyMask, FalHockeyPuck, FalHockeyStickPuck, FalHockeySticks, FalHollyBerry, FalHoneyPot, FalHoodCloak, FalHorizontalRule, FalHorse, FalHorseHead, FalHorseSaddle, FalHose, FalHoseReel, FalHospital, FalHospitalUser, FalHospitals, FalHotTubPerson, FalHotdog, FalHotel, FalHourglass, FalHourglassClock, FalHourglassEnd, FalHourglassHalf, FalHourglassStart, FalHouse, FalHouseBlank, FalHouseBuilding, FalHouseChimney, FalHouseChimneyBlank, FalHouseChimneyCrack, FalHouseChimneyHeart, FalHouseChimneyMedical, FalHouseChimneyUser, FalHouseChimneyWindow, FalHouseCircleCheck, FalHouseCircleExclamation, FalHouseCircleXmark, FalHouseCrack, FalHouseDay, FalHouseFire, FalHouseFlag, FalHouseFloodWater, FalHouseFloodWaterCircleArrowRight, FalHouseHeart, FalHouseLaptop, FalHouseLock, FalHouseMedical, FalHouseMedicalCircleCheck, FalHouseMedicalCircleExclamation, FalHouseMedicalCircleXmark, FalHouseMedicalFlag, FalHouseNight, FalHousePersonLeave, FalHousePersonReturn, FalHouseSignal, FalHouseTree, FalHouseTsunami, FalHouseTurret, FalHouseUser, FalHouseWater, FalHouseWindow, FalHryvniaSign, FalHundredPoints, FalHurricane, FalHyphen, FalI, FalICursor, FalIceCream, FalIceSkate, FalIcicles, FalIcons, FalIdBadge, FalIdCard, FalIdCardClip, FalIgloo, FalImage, FalImageLandscape, FalImagePolaroid, FalImagePolaroidUser, FalImagePortrait, FalImageSlash, FalImageUser, FalImages, FalImagesUser, FalInbox, FalInboxFull, FalInboxIn, FalInboxOut, FalInboxes, FalIndent, FalIndianRupeeSign, FalIndustry, FalIndustryWindows, FalInfinity, FalInfo, FalInhaler, FalInputNumeric, FalInputPipe, FalInputText, FalIntegral, FalInterrobang, FalIntersection, FalIslandTropical, FalItalic, FalJ, FalJackOLantern, FalJar, FalJarWheat, FalJedi, FalJetFighter, FalJetFighterUp, FalJoint, FalJoystick, FalJug, FalJugBottle, FalJugDetergent, FalK, FalKaaba, FalKazoo, FalKerning, FalKey, FalKeySkeleton, FalKeySkeletonLeftRight, FalKeyboard, FalKeyboardBrightness, FalKeyboardBrightnessLow, FalKeyboardDown, FalKeyboardLeft, FalKeynote, FalKhanda, FalKidneys, FalKipSign, FalKitMedical, FalKitchenSet, FalKite, FalKiwiBird, FalKiwiFruit, FalKnife, FalKnifeKitchen, FalL, FalLacrosseStick, FalLacrosseStickBall, FalLambda, FalLamp, FalLampDesk, FalLampFloor, FalLampStreet, FalLandMineOn, FalLandmark, FalLandmarkDome, FalLandmarkFlag, FalLanguage, FalLaptop, FalLaptopArrowDown, FalLaptopBinary, FalLaptopCode, FalLaptopFile, FalLaptopMedical, FalLaptopMobile, FalLaptopSlash, FalLariSign, FalLasso, FalLassoSparkles, FalLayerGroup, FalLayerMinus, FalLayerPlus, FalLeaf, FalLeafHeart, FalLeafMaple, FalLeafOak, FalLeafyGreen, FalLeft, FalLeftFromLine, FalLeftLong, FalLeftLongToLine, FalLeftRight, FalLeftToLine, FalLemon, FalLessThan, FalLessThanEqual, FalLifeRing, FalLightCeiling, FalLightEmergency, FalLightEmergencyOn, FalLightSwitch, FalLightSwitchOff, FalLightSwitchOn, FalLightbulb, FalLightbulbCfl, FalLightbulbCflOn, FalLightbulbDollar, FalLightbulbExclamation, FalLightbulbExclamationOn, FalLightbulbGear, FalLightbulbOn, FalLightbulbSlash, FalLighthouse, FalLightsHoliday, FalLineColumns, FalLineHeight, FalLinesLeaning, FalLink, FalLinkHorizontal, FalLinkHorizontalSlash, FalLinkSimple, FalLinkSimpleSlash, FalLinkSlash, FalLips, FalLiraSign, FalList, FalListCheck, FalListDropdown, FalListMusic, FalListOl, FalListRadio, FalListTimeline, FalListTree, FalListUl, FalLitecoinSign, FalLoader, FalLobster, FalLocationArrow, FalLocationCheck, FalLocationCrosshairs, FalLocationCrosshairsSlash, FalLocationDot, FalLocationDotSlash, FalLocationExclamation, FalLocationMinus, FalLocationPen, FalLocationPin, FalLocationPinLock, FalLocationPinSlash, FalLocationPlus, FalLocationQuestion, FalLocationSmile, FalLocationXmark, FalLock, FalLockA, FalLockHashtag, FalLockKeyhole, FalLockKeyholeOpen, FalLockOpen, FalLocust, FalLollipop, FalLoveseat, FalLuchadorMask, FalLungs, FalLungsVirus, FalM, FalMace, FalMagnet, FalMagnifyingGlass, FalMagnifyingGlassArrowRight, FalMagnifyingGlassChart, FalMagnifyingGlassDollar, FalMagnifyingGlassLocation, FalMagnifyingGlassMinus, FalMagnifyingGlassPlus, FalMailbox, FalMailboxFlagUp, FalManatSign, FalMandolin, FalMango, FalManhole, FalMap, FalMapLocation, FalMapLocationDot, FalMapPin, FalMarker, FalMars, FalMarsAndVenus, FalMarsAndVenusBurst, FalMarsDouble, FalMarsStroke, FalMarsStrokeRight, FalMarsStrokeUp, FalMartiniGlass, FalMartiniGlassCitrus, FalMartiniGlassEmpty, FalMask, FalMaskFace, FalMaskSnorkel, FalMaskVentilator, FalMasksTheater, FalMattressPillow, FalMaximize, FalMeat, FalMedal, FalMegaphone, FalMelon, FalMelonSlice, FalMemo, FalMemoCircleCheck, FalMemoCircleInfo, FalMemoPad, FalMemory, FalMenorah, FalMercury, FalMerge, FalMessage, FalMessageArrowDown, FalMessageArrowUp, FalMessageArrowUpRight, FalMessageBot, FalMessageCaptions, FalMessageCheck, FalMessageCode, FalMessageDollar, FalMessageDots, FalMessageExclamation, FalMessageHeart, FalMessageImage, FalMessageLines, FalMessageMedical, FalMessageMiddle, FalMessageMiddleTop, FalMessageMinus, FalMessageMusic, FalMessagePen, FalMessagePlus, FalMessageQuestion, FalMessageQuote, FalMessageSlash, FalMessageSmile, FalMessageSms, FalMessageText, FalMessageXmark, FalMessages, FalMessagesDollar, FalMessagesQuestion, FalMeteor, FalMeter, FalMeterBolt, FalMeterDroplet, FalMeterFire, FalMicrochip, FalMicrochipAi, FalMicrophone, FalMicrophoneLines, FalMicrophoneLinesSlash, FalMicrophoneSlash, FalMicrophoneStand, FalMicroscope, FalMicrowave, FalMillSign, FalMinimize, FalMinus, FalMistletoe, FalMitten, FalMobile, FalMobileButton, FalMobileNotch, FalMobileRetro, FalMobileScreen, FalMobileScreenButton, FalMobileSignal, FalMobileSignalOut, FalMoneyBill, FalMoneyBill1, FalMoneyBill1Wave, FalMoneyBillSimple, FalMoneyBillSimpleWave, FalMoneyBillTransfer, FalMoneyBillTrendUp, FalMoneyBillWave, FalMoneyBillWheat, FalMoneyBills, FalMoneyBillsSimple, FalMoneyCheck, FalMoneyCheckDollar, FalMoneyCheckDollarPen, FalMoneyCheckPen, FalMoneyFromBracket, FalMoneySimpleFromBracket, FalMonitorWaveform, FalMonkey, FalMonument, FalMoon, FalMoonCloud, FalMoonOverSun, FalMoonStars, FalMoped, FalMortarPestle, FalMosque, FalMosquito, FalMosquitoNet, FalMotorcycle, FalMound, FalMountain, FalMountainCity, FalMountainSun, FalMountains, FalMouseField, FalMp3Player, FalMug, FalMugHot, FalMugMarshmallows, FalMugSaucer, FalMugTea, FalMugTeaSaucer, FalMushroom, FalMusic, FalMusicNote, FalMusicNoteSlash, FalMusicSlash, FalMustache, FalN, FalNairaSign, FalNarwhal, FalNestingDolls, FalNetworkWired, FalNeuter, FalNewspaper, FalNfc, FalNfcLock, FalNfcMagnifyingGlass, FalNfcPen, FalNfcSignal, FalNfcSlash, FalNfcSymbol, FalNfcTrash, FalNose, FalNotEqual, FalNotdef, FalNote, FalNoteMedical, FalNoteSticky, FalNotebook, FalNotes, FalNotesMedical, FalO, FalObjectExclude, FalObjectGroup, FalObjectIntersect, FalObjectSubtract, FalObjectUngroup, FalObjectUnion, FalObjectsAlignBottom, FalObjectsAlignCenterHorizontal, FalObjectsAlignCenterVertical, FalObjectsAlignLeft, FalObjectsAlignRight, FalObjectsAlignTop, FalObjectsColumn, FalOctagon, FalOctagonCheck, FalOctagonDivide, FalOctagonExclamation, FalOctagonMinus, FalOctagonPlus, FalOctagonXmark, FalOilCan, FalOilCanDrip, FalOilTemperature, FalOilWell, FalOlive, FalOliveBranch, FalOm, FalOmega, FalOnion, FalOption, FalOrnament, FalOtter, FalOutdent, FalOutlet, FalOven, FalOverline, FalP, FalPage, FalPageCaretDown, FalPageCaretUp, FalPager, FalPaintRoller, FalPaintbrush, FalPaintbrushFine, FalPaintbrushPencil, FalPalette, FalPallet, FalPalletBox, FalPalletBoxes, FalPanFood, FalPanFrying, FalPancakes, FalPanelEws, FalPanelFire, FalPanorama, FalPaperPlane, FalPaperPlaneTop, FalPaperclip, FalPaperclipVertical, FalParachuteBox, FalParagraph, FalParagraphLeft, FalPartyBell, FalPartyHorn, FalPassport, FalPaste, FalPause, FalPaw, FalPawClaws, FalPawSimple, FalPeace, FalPeach, FalPeanut, FalPeanuts, FalPeapod, FalPear, FalPedestal, FalPegasus, FalPen, FalPenCircle, FalPenClip, FalPenClipSlash, FalPenFancy, FalPenFancySlash, FalPenField, FalPenLine, FalPenNib, FalPenNibSlash, FalPenPaintbrush, FalPenRuler, FalPenSlash, FalPenSwirl, FalPenToSquare, FalPencil, FalPencilMechanical, FalPencilSlash, FalPeople, FalPeopleArrows, FalPeopleCarryBox, FalPeopleDress, FalPeopleDressSimple, FalPeopleGroup, FalPeopleLine, FalPeoplePants, FalPeoplePantsSimple, FalPeoplePulling, FalPeopleRobbery, FalPeopleRoof, FalPeopleSimple, FalPepper, FalPepperHot, FalPercent, FalPeriod, FalPerson, FalPersonArrowDownToLine, FalPersonArrowUpFromLine, FalPersonBiking, FalPersonBikingMountain, FalPersonBooth, FalPersonBreastfeeding, FalPersonBurst, FalPersonCane, FalPersonCarryBox, FalPersonChalkboard, FalPersonCircleCheck, FalPersonCircleExclamation, FalPersonCircleMinus, FalPersonCirclePlus, FalPersonCircleQuestion, FalPersonCircleXmark, FalPersonDigging, FalPersonDolly, FalPersonDollyEmpty, FalPersonDotsFromLine, FalPersonDress, FalPersonDressBurst, FalPersonDressFairy, FalPersonDressSimple, FalPersonDrowning, FalPersonFairy, FalPersonFalling, FalPersonFallingBurst, FalPersonFromPortal, FalPersonHalfDress, FalPersonHarassing, FalPersonHiking, FalPersonMilitaryPointing, FalPersonMilitaryRifle, FalPersonMilitaryToPerson, FalPersonPinball, FalPersonPraying, FalPersonPregnant, FalPersonRays, FalPersonRifle, FalPersonRunning, FalPersonRunningFast, FalPersonSeat, FalPersonSeatReclined, FalPersonShelter, FalPersonSign, FalPersonSimple, FalPersonSkating, FalPersonSkiJumping, FalPersonSkiLift, FalPersonSkiing, FalPersonSkiingNordic, FalPersonSledding, FalPersonSnowboarding, FalPersonSnowmobiling, FalPersonSwimming, FalPersonThroughWindow, FalPersonToDoor, FalPersonToPortal, FalPersonWalking, FalPersonWalkingArrowLoopLeft, FalPersonWalkingArrowRight, FalPersonWalkingDashedLineArrowRight, FalPersonWalkingLuggage, FalPersonWalkingWithCane, FalPesetaSign, FalPesoSign, FalPhone, FalPhoneArrowDownLeft, FalPhoneArrowRight, FalPhoneArrowUpRight, FalPhoneFlip, FalPhoneHangup, FalPhoneIntercom, FalPhoneMissed, FalPhoneOffice, FalPhonePlus, FalPhoneRotary, FalPhoneSlash, FalPhoneVolume, FalPhoneXmark, FalPhotoFilm, FalPhotoFilmMusic, FalPi, FalPiano, FalPianoKeyboard, FalPickaxe, FalPickleball, FalPie, FalPig, FalPiggyBank, FalPills, FalPinata, FalPinball, FalPineapple, FalPipe, FalPipeCircleCheck, FalPipeCollar, FalPipeSection, FalPipeSmoking, FalPipeValve, FalPizza, FalPizzaSlice, FalPlaceOfWorship, FalPlane, FalPlaneArrival, FalPlaneCircleCheck, FalPlaneCircleExclamation, FalPlaneCircleXmark, FalPlaneDeparture, FalPlaneEngines, FalPlaneLock, FalPlaneProp, FalPlaneSlash, FalPlaneTail, FalPlaneUp, FalPlaneUpSlash, FalPlanetMoon, FalPlanetRinged, FalPlantWilt, FalPlateUtensils, FalPlateWheat, FalPlay, FalPlayPause, FalPlug, FalPlugCircleBolt, FalPlugCircleCheck, FalPlugCircleExclamation, FalPlugCircleMinus, FalPlugCirclePlus, FalPlugCircleXmark, FalPlus, FalPlusLarge, FalPlusMinus, FalPodcast, FalPodium, FalPodiumStar, FalPoliceBox, FalPollPeople, FalPompebled, FalPoo, FalPooStorm, FalPool8Ball, FalPoop, FalPopcorn, FalPopsicle, FalPotFood, FalPotato, FalPowerOff, FalPrescription, FalPrescriptionBottle, FalPrescriptionBottleMedical, FalPrescriptionBottlePill, FalPresentationScreen, FalPretzel, FalPrint, FalPrintMagnifyingGlass, FalPrintSlash, FalProjector, FalPump, FalPumpMedical, FalPumpSoap, FalPumpkin, FalPuzzle, FalPuzzlePiece, FalPuzzlePieceSimple, FalQ, FalQrcode, FalQuestion, FalQuoteLeft, FalQuoteRight, FalQuotes, FalR, FalRabbit, FalRabbitRunning, FalRaccoon, FalRacquet, FalRadar, FalRadiation, FalRadio, FalRadioTuner, FalRainbow, FalRaindrops, FalRam, FalRampLoading, FalRankingStar, FalRaygun, FalReceipt, FalRecordVinyl, FalRectangle, FalRectangleAd, FalRectangleBarcode, FalRectangleCode, FalRectangleHistory, FalRectangleHistoryCirclePlus, FalRectangleHistoryCircleUser, FalRectangleList, FalRectanglePro, FalRectangleTerminal, FalRectangleVertical, FalRectangleVerticalHistory, FalRectangleWide, FalRectangleXmark, FalRectanglesMixed, FalRecycle, FalReel, FalRefrigerator, FalRegistered, FalRepeat, FalRepeat1, FalReply, FalReplyAll, FalReplyClock, FalRepublican, FalRestroom, FalRestroomSimple, FalRetweet, FalRhombus, FalRibbon, FalRight, FalRightFromBracket, FalRightFromLine, FalRightLeft, FalRightLeftLarge, FalRightLong, FalRightLongToLine, FalRightToBracket, FalRightToLine, FalRing, FalRingDiamond, FalRingsWedding, FalRoad, FalRoadBarrier, FalRoadBridge, FalRoadCircleCheck, FalRoadCircleExclamation, FalRoadCircleXmark, FalRoadLock, FalRoadSpikes, FalRobot, FalRobotAstromech, FalRocket, FalRocketLaunch, FalRollerCoaster, FalRotate, FalRotateExclamation, FalRotateLeft, FalRotateRight, FalRoute, FalRouteHighway, FalRouteInterstate, FalRouter, FalRss, FalRubleSign, FalRug, FalRugbyBall, FalRuler, FalRulerCombined, FalRulerHorizontal, FalRulerTriangle, FalRulerVertical, FalRupeeSign, FalRupiahSign, FalRv, FalS, FalSack, FalSackDollar, FalSackXmark, FalSailboat, FalSalad, FalSaltShaker, FalSandwich, FalSatellite, FalSatelliteDish, FalSausage, FalSaxophone, FalSaxophoneFire, FalScaleBalanced, FalScaleUnbalanced, FalScaleUnbalancedFlip, FalScalpel, FalScalpelLineDashed, FalScannerGun, FalScannerImage, FalScannerKeyboard, FalScannerTouchscreen, FalScarecrow, FalScarf, FalSchool, FalSchoolCircleCheck, FalSchoolCircleExclamation, FalSchoolCircleXmark, FalSchoolFlag, FalSchoolLock, FalScissors, FalScreenUsers, FalScreencast, FalScrewdriver, FalScrewdriverWrench, FalScribble, FalScroll, FalScrollOld, FalScrollTorah, FalScrubber, FalScythe, FalSdCard, FalSdCards, FalSeal, FalSealExclamation, FalSealQuestion, FalSeatAirline, FalSection, FalSeedling, FalSemicolon, FalSendBack, FalSendBackward, FalSensor, FalSensorCloud, FalSensorFire, FalSensorOn, FalSensorTriangleExclamation, FalServer, FalShapes, FalShare, FalShareAll, FalShareFromSquare, FalShareNodes, FalSheep, FalSheetPlastic, FalShekelSign, FalShelves, FalShelvesEmpty, FalShield, FalShieldCat, FalShieldCheck, FalShieldCross, FalShieldDog, FalShieldExclamation, FalShieldHalved, FalShieldHeart, FalShieldKeyhole, FalShieldMinus, FalShieldPlus, FalShieldQuartered, FalShieldSlash, FalShieldVirus, FalShieldXmark, FalShip, FalShirt, FalShirtLongSleeve, FalShirtRunning, FalShirtTankTop, FalShishKebab, FalShoePrints, FalShop, FalShopLock, FalShopSlash, FalShovel, FalShovelSnow, FalShower, FalShowerDown, FalShredder, FalShrimp, FalShuffle, FalShutters, FalShuttleSpace, FalShuttlecock, FalSickle, FalSidebar, FalSidebarFlip, FalSigma, FalSignHanging, FalSignal, FalSignalBars, FalSignalBarsFair, FalSignalBarsGood, FalSignalBarsSlash, FalSignalBarsWeak, FalSignalFair, FalSignalGood, FalSignalSlash, FalSignalStream, FalSignalStreamSlash, FalSignalStrong, FalSignalWeak, FalSignature, FalSignatureLock, FalSignatureSlash, FalSignsPost, FalSimCard, FalSimCards, FalSink, FalSiren, FalSirenOn, FalSitemap, FalSkeleton, FalSkeletonRibs, FalSkiBoot, FalSkiBootSki, FalSkull, FalSkullCow, FalSkullCrossbones, FalSlash, FalSlashBack, FalSlashForward, FalSleigh, FalSlider, FalSliders, FalSlidersSimple, FalSlidersUp, FalSlotMachine, FalSmog, FalSmoke, FalSmoking, FalSnake, FalSnooze, FalSnowBlowing, FalSnowflake, FalSnowflakeDroplets, FalSnowflakes, FalSnowman, FalSnowmanHead, FalSnowplow, FalSoap, FalSocks, FalSoftServe, FalSolarPanel, FalSolarSystem, FalSort, FalSortDown, FalSortUp, FalSpa, FalSpaceStationMoon, FalSpaceStationMoonConstruction, FalSpade, FalSpaghettiMonsterFlying, FalSparkle, FalSparkles, FalSpeaker, FalSpeakers, FalSpellCheck, FalSpider, FalSpiderBlackWidow, FalSpiderWeb, FalSpinner, FalSpinnerThird, FalSplit, FalSplotch, FalSpoon, FalSportsball, FalSprayCan, FalSprayCanSparkles, FalSprinkler, FalSprinklerCeiling, FalSquare, FalSquare0, FalSquare1, FalSquare2, FalSquare3, FalSquare4, FalSquare5, FalSquare6, FalSquare7, FalSquare8, FalSquare9, FalSquareA, FalSquareALock, FalSquareAmpersand, FalSquareArrowDown, FalSquareArrowDownLeft, FalSquareArrowDownRight, FalSquareArrowLeft, FalSquareArrowRight, FalSquareArrowUp, FalSquareArrowUpLeft, FalSquareArrowUpRight, FalSquareB, FalSquareBolt, FalSquareC, FalSquareCaretDown, FalSquareCaretLeft, FalSquareCaretRight, FalSquareCaretUp, FalSquareCheck, FalSquareChevronDown, FalSquareChevronLeft, FalSquareChevronRight, FalSquareChevronUp, FalSquareCode, FalSquareD, FalSquareDashed, FalSquareDashedCirclePlus, FalSquareDivide, FalSquareDollar, FalSquareDown, FalSquareDownLeft, FalSquareDownRight, FalSquareE, FalSquareEllipsis, FalSquareEllipsisVertical, FalSquareEnvelope, FalSquareExclamation, FalSquareF, FalSquareFragile, FalSquareFull, FalSquareG, FalSquareH, FalSquareHeart, FalSquareI, FalSquareInfo, FalSquareJ, FalSquareK, FalSquareKanban, FalSquareL, FalSquareLeft, FalSquareList, FalSquareM, FalSquareMinus, FalSquareN, FalSquareNfi, FalSquareO, FalSquareP, FalSquareParking, FalSquareParkingSlash, FalSquarePen, FalSquarePersonConfined, FalSquarePhone, FalSquarePhoneFlip, FalSquarePhoneHangup, FalSquarePlus, FalSquarePollHorizontal, FalSquarePollVertical, FalSquareQ, FalSquareQuarters, FalSquareQuestion, FalSquareQuote, FalSquareR, FalSquareRight, FalSquareRing, FalSquareRoot, FalSquareRootVariable, FalSquareRss, FalSquareS, FalSquareShareNodes, FalSquareSliders, FalSquareSlidersVertical, FalSquareSmall, FalSquareStar, FalSquareT, FalSquareTerminal, FalSquareThisWayUp, FalSquareU, FalSquareUp, FalSquareUpLeft, FalSquareUpRight, FalSquareUser, FalSquareV, FalSquareVirus, FalSquareW, FalSquareX, FalSquareXmark, FalSquareY, FalSquareZ, FalSquid, FalSquirrel, FalStaff, FalStaffSnake, FalStairs, FalStamp, FalStandardDefinition, FalStapler, FalStar, FalStarAndCrescent, FalStarChristmas, FalStarExclamation, FalStarHalf, FalStarHalfStroke, FalStarOfDavid, FalStarOfLife, FalStarSharp, FalStarSharpHalf, FalStarSharpHalfStroke, FalStarShooting, FalStarfighter, FalStarfighterTwinIonEngine, FalStarfighterTwinIonEngineAdvanced, FalStars, FalStarship, FalStarshipFreighter, FalSteak, FalSteeringWheel, FalSterlingSign, FalStethoscope, FalStocking, FalStomach, FalStop, FalStopwatch, FalStopwatch20, FalStore, FalStoreLock, FalStoreSlash, FalStrawberry, FalStreetView, FalStretcher, FalStrikethrough, FalStroopwafel, FalSubscript, FalSubtitles, FalSubtitlesSlash, FalSuitcase, FalSuitcaseMedical, FalSuitcaseRolling, FalSun, FalSunBright, FalSunCloud, FalSunDust, FalSunHaze, FalSunPlantWilt, FalSunglasses, FalSunrise, FalSunset, FalSuperscript, FalSushi, FalSushiRoll, FalSwap, FalSwapArrows, FalSwatchbook, FalSword, FalSwordLaser, FalSwordLaserAlt, FalSwords, FalSwordsLaser, FalSymbols, FalSynagogue, FalSyringe, FalT, FalTable, FalTableCells, FalTableCellsLarge, FalTableColumns, FalTableLayout, FalTableList, FalTablePicnic, FalTablePivot, FalTableRows, FalTableTennisPaddleBall, FalTableTree, FalTablet, FalTabletButton, FalTabletRugged, FalTabletScreen, FalTabletScreenButton, FalTablets, FalTachographDigital, FalTaco, FalTag, FalTags, FalTally, FalTally1, FalTally2, FalTally3, FalTally4, FalTamale, FalTankWater, FalTape, FalTarp, FalTarpDroplet, FalTaxi, FalTaxiBus, FalTeddyBear, FalTeeth, FalTeethOpen, FalTelescope, FalTemperatureArrowDown, FalTemperatureArrowUp, FalTemperatureEmpty, FalTemperatureFull, FalTemperatureHalf, FalTemperatureHigh, FalTemperatureList, FalTemperatureLow, FalTemperatureQuarter, FalTemperatureSnow, FalTemperatureSun, FalTemperatureThreeQuarters, FalTengeSign, FalTennisBall, FalTent, FalTentArrowDownToLine, FalTentArrowLeftRight, FalTentArrowTurnLeft, FalTentArrowsDown, FalTents, FalTerminal, FalText, FalTextHeight, FalTextSize, FalTextSlash, FalTextWidth, FalThermometer, FalTheta, FalThoughtBubble, FalThumbsDown, FalThumbsUp, FalThumbtack, FalTick, FalTicket, FalTicketAirline, FalTicketSimple, FalTicketsAirline, FalTilde, FalTimeline, FalTimelineArrow, FalTimer, FalTire, FalTireFlat, FalTirePressureWarning, FalTireRugged, FalToggleLargeOff, FalToggleLargeOn, FalToggleOff, FalToggleOn, FalToilet, FalToiletPaper, FalToiletPaperBlank, FalToiletPaperBlankUnder, FalToiletPaperCheck, FalToiletPaperSlash, FalToiletPaperUnder, FalToiletPaperUnderSlash, FalToiletPaperXmark, FalToiletPortable, FalToiletsPortable, FalTomato, FalTombstone, FalTombstoneBlank, FalToolbox, FalTooth, FalToothbrush, FalToriiGate, FalTornado, FalTowerBroadcast, FalTowerCell, FalTowerControl, FalTowerObservation, FalTractor, FalTrademark, FalTrafficCone, FalTrafficLight, FalTrafficLightGo, FalTrafficLightSlow, FalTrafficLightStop, FalTrailer, FalTrain, FalTrainSubway, FalTrainSubwayTunnel, FalTrainTrack, FalTrainTram, FalTrainTunnel, FalTransformerBolt, FalTransgender, FalTransporter, FalTransporter1, FalTransporter2, FalTransporter3, FalTransporter4, FalTransporter5, FalTransporter6, FalTransporter7, FalTransporterEmpty, FalTrash, FalTrashArrowUp, FalTrashCan, FalTrashCanArrowUp, FalTrashCanCheck, FalTrashCanClock, FalTrashCanList, FalTrashCanPlus, FalTrashCanSlash, FalTrashCanUndo, FalTrashCanXmark, FalTrashCheck, FalTrashClock, FalTrashList, FalTrashPlus, FalTrashSlash, FalTrashUndo, FalTrashXmark, FalTreasureChest, FalTree, FalTreeChristmas, FalTreeCity, FalTreeDeciduous, FalTreeDecorated, FalTreeLarge, FalTreePalm, FalTrees, FalTriangle, FalTriangleExclamation, FalTriangleInstrument, FalTrianglePersonDigging, FalTricycle, FalTricycleAdult, FalTrillium, FalTrophy, FalTrophyStar, FalTrowel, FalTrowelBricks, FalTruck, FalTruckArrowRight, FalTruckBolt, FalTruckClock, FalTruckContainer, FalTruckContainerEmpty, FalTruckDroplet, FalTruckFast, FalTruckField, FalTruckFieldUn, FalTruckFlatbed, FalTruckFront, FalTruckMedical, FalTruckMonster, FalTruckMoving, FalTruckPickup, FalTruckPlane, FalTruckPlow, FalTruckRamp, FalTruckRampBox, FalTruckRampCouch, FalTruckTow, FalTrumpet, FalTty, FalTtyAnswer, FalTugrikSign, FalTurkey, FalTurkishLiraSign, FalTurnDown, FalTurnDownLeft, FalTurnDownRight, FalTurnUp, FalTurntable, FalTurtle, FalTv, FalTvMusic, FalTvRetro, FalTypewriter, FalU, FalUfo, FalUfoBeam, FalUmbrella, FalUmbrellaBeach, FalUmbrellaSimple, FalUnderline, FalUnicorn, FalUniformMartialArts, FalUnion, FalUniversalAccess, FalUnlock, FalUnlockKeyhole, FalUp, FalUpDown, FalUpDownLeftRight, FalUpFromBracket, FalUpFromDottedLine, FalUpFromLine, FalUpLeft, FalUpLong, FalUpRight, FalUpRightAndDownLeftFromCenter, FalUpRightFromSquare, FalUpToDottedLine, FalUpToLine, FalUpload, FalUsbDrive, FalUser, FalUserAlien, FalUserAstronaut, FalUserBountyHunter, FalUserCheck, FalUserChef, FalUserClock, FalUserCowboy, FalUserCrown, FalUserDoctor, FalUserDoctorHair, FalUserDoctorHairLong, FalUserDoctorMessage, FalUserGear, FalUserGraduate, FalUserGroup, FalUserGroupCrown, FalUserGroupSimple, FalUserHair, FalUserHairBuns, FalUserHairLong, FalUserHairMullet, FalUserHeadset, FalUserHelmetSafety, FalUserInjured, FalUserLarge, FalUserLargeSlash, FalUserLock, FalUserMagnifyingGlass, FalUserMinus, FalUserMusic, FalUserNinja, FalUserNurse, FalUserNurseHair, FalUserNurseHairLong, FalUserPen, FalUserPilot, FalUserPilotTie, FalUserPlus, FalUserPolice, FalUserPoliceTie, FalUserRobot, FalUserRobotXmarks, FalUserSecret, FalUserShakespeare, FalUserShield, FalUserSlash, FalUserTag, FalUserTie, FalUserTieHair, FalUserTieHairLong, FalUserUnlock, FalUserVisor, FalUserVneck, FalUserVneckHair, FalUserVneckHairLong, FalUserXmark, FalUsers, FalUsersBetweenLines, FalUsersGear, FalUsersLine, FalUsersMedical, FalUsersRays, FalUsersRectangle, FalUsersSlash, FalUsersViewfinder, FalUtensils, FalUtensilsSlash, FalUtilityPole, FalUtilityPoleDouble, FalV, FalVacuum, FalVacuumRobot, FalValueAbsolute, FalVanShuttle, FalVault, FalVectorCircle, FalVectorPolygon, FalVectorSquare, FalVentDamper, FalVenus, FalVenusDouble, FalVenusMars, FalVest, FalVestPatches, FalVial, FalVialCircleCheck, FalVialVirus, FalVials, FalVideo, FalVideoArrowDownLeft, FalVideoArrowUpRight, FalVideoPlus, FalVideoSlash, FalVihara, FalViolin, FalVirus, FalVirusCovid, FalVirusCovidSlash, FalVirusSlash, FalViruses, FalVoicemail, FalVolcano, FalVolleyball, FalVolume, FalVolumeHigh, FalVolumeLow, FalVolumeOff, FalVolumeSlash, FalVolumeXmark, FalVrCardboard, FalW, FalWaffle, FalWagonCovered, FalWalker, FalWalkieTalkie, FalWallet, FalWand, FalWandMagic, FalWandMagicSparkles, FalWandSparkles, FalWarehouse, FalWarehouseFull, FalWashingMachine, FalWatch, FalWatchApple, FalWatchCalculator, FalWatchFitness, FalWatchSmart, FalWater, FalWaterArrowDown, FalWaterArrowUp, FalWaterLadder, FalWatermelonSlice, FalWavePulse, FalWaveSine, FalWaveSquare, FalWaveTriangle, FalWaveform, FalWaveformLines, FalWebhook, FalWeightHanging, FalWeightScale, FalWhale, FalWheat, FalWheatAwn, FalWheatAwnCircleExclamation, FalWheatAwnSlash, FalWheatSlash, FalWheelchair, FalWheelchairMove, FalWhiskeyGlass, FalWhiskeyGlassIce, FalWhistle, FalWifi, FalWifiExclamation, FalWifiFair, FalWifiSlash, FalWifiWeak, FalWind, FalWindTurbine, FalWindWarning, FalWindow, FalWindowFlip, FalWindowFrame, FalWindowFrameOpen, FalWindowMaximize, FalWindowMinimize, FalWindowRestore, FalWindsock, FalWineBottle, FalWineGlass, FalWineGlassCrack, FalWineGlassEmpty, FalWonSign, FalWorm, FalWreath, FalWreathLaurel, FalWrench, FalWrenchSimple, FalX, FalXRay, FalXmark, FalXmarkLarge, FalXmarkToSlot, FalXmarksLines, FalY, FalYenSign, FalYinYang, FalZ };
//# sourceMappingURL=virginmediao2-momentum-icons-icons-fal.mjs.map
